(function() {
    'use strict';

    var app = angular
        .module('app.sites', ['app.doclibraryForms', 'textAngular'])
         .run(run)
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider, $mdThemingProvider, $controllerProvider, $compileProvider, $filterProvider, $provide) {
        app.controller = $controllerProvider.register;
        app.directive = $compileProvider.directive;
        app.filter = $filterProvider.register;
        app.factory = $provide.factory;
        app.service = $provide.service;
        app.constant = $provide.constant;
        app.value = $provide.value;
        
        // State
        $stateProvider
            .state('app.sites', {
                url: '/sites',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/sites/sites.html',
                        controller: 'SitesController as siteCtrl'
                    }
                },
                resolve: {
                    Icons: function(msApi) {
                        return msApi.resolve('icons@get');
                    },
                    RestAPIService: 'RestAPIService',
                    Sites: function(RestAPIService) {
                        return RestAPIService.getSites();
                    }
                }
            })
            .state('app.sites.site', {
                url: '/:siteId',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/sites/site/site.html',
                        controller: 'SitesController as siteCtrl'
                    },
                    'sitehome@app.sites.site':{
                    	 templateUrl: 'app/main/sites/site/home/site.home.html',
                         controller: 'SitesHomeController as siteHomeCtrl'                    	
                    },                    
                    'dashboard@app.sites.site': {
                        templateUrl: 'app/main/sites/site/dashboard/site.dashboard.html',
                        controller: 'SitesDashboardController as siteDashCtrl'
                    },
                    'doclibrary@app.sites.site': {
                        templateUrl: 'app/main/sites/site/doclibrary/site.doclibrary.html',
                        controller: 'SitesDocLibraryController as siteDocLibCtrl'
                    },
                    'members@app.sites.site': {
                        templateUrl: 'app/main/sites/site/members/site.members.html',
                        controller: 'SitesMembersController as siteMembersCtrl'
                    },
                    'wiki@app.sites.site': {
                        templateUrl: 'app/main/sites/site/wiki/site.wiki.html',
                        controller: 'SitesWikiController as siteWikiCtrl'
                    },
                    /*'todolist@app.sites.site': {
                        templateUrl: 'app/main/sites/site/todolist/site.todolist.html',
                        controller: 'SitesTodoController as siteTodoCtrl'
                    },*/
                    'sitesettings@app.sites.site': {
                        templateUrl: 'app/main/sites/site/sitesettings/sitesettings.html',
                        controller: 'SiteSettingsController as sitesettingCtrl'
                    },
                    'discussionforum@app.sites.site': {
                        templateUrl: 'app/main/sites/site/discussionforum/site.forum.html',
                        controller: 'SitesForumController as siteForumCtrl'
                    }
                },
                params: {
                	showsettings:null,
                	hideLibrary:null
                  },
                resolve: {
                    RestAPIService: 'RestAPIService',
                    Members: function(RestAPIService, $stateParams) {
                        return RestAPIService.getMembers("site-3");
                    },
                    SiteDashboard: function(RestAPIService,$stateParams){
                    	return RestAPIService.getSiteHome("site-3");                    	
                    }
                }
            });
        msApiProvider.register('icons', ['assets/icons/selection.json']);
    }
    function run(msNavigationService, $localStorage, $rootScope, $state) {
        // Navigation
    	 $rootScope.$state = $state;
    	/* if($localStorage.sitesettingdata !=undefined){
				var sitedisplayname = $localStorage.sitesettingdata.sitedisplayname;
			}else{
				var sitedisplayname = "Home";
			}*/
//         msNavigationService.saveItem('sites', {
//             title: 'Home',
//             icon: 'icon-tile-four',
//             state: 'app.sites.site',
//             weight: 1,
//             hidden: function() {                 
//             	//  if ($localStorage.menubarsetting != undefined) {
//                 //      var show = $localStorage.menubarsetting.site;
//                 //      return !(show);
//                 //  }
// //            	 hide this menu if auditor logs in
//             	 if ($rootScope.currentLogedInUser != undefined) {
//                      var roles = $rootScope.currentLogedInUser.authorities;
//                      return (roles.indexOf("ROLE_AUDITOR") > -1);
//                  }
//            }
//         });
    }
    
})();
(function ()
{
    'use strict';

    angular
        .module('app.sites')
        .controller('msNoteItemController', msNoteItemController)
        .directive('msNoteItem', msNoteItemDirective);

    /** @ngInject */
    function msNoteItemController($document)
    {
        var vm = this;
        vm.element = [];
               }

    /** @ngInject */
    function msNoteItemDirective()
    {
        return {
            restrict        : 'A',
            controller      : 'msNoteItemController as MsNoteItem',
            templateUrl     : 'app/main/sites/site/todolist/directives/ms-note-item/ms-note-item.html',
            require         : ['msNoteItem', '^msMasonry'],
            bindToController: {
                msNoteItem: '='
            },
            link            : function (scope, element, attributes, controllers)
            {

                var MsNoteItem = controllers[0];
                var msMasonry = controllers[1];

                MsNoteItem.element = element;
                MsNoteItem.note = MsNoteItem.msNoteItem;


                scope.$watch('MsNoteItem.msNoteItem', function (newVal, oldVal)
                {
                    if ( newVal !== oldVal )
                    {
                        MsNoteItem.note = newVal;
                    }
                });

                scope.$on('msMasonryItem:startReLayout', function ()
                {
                    if (  MsNoteItem.columnWidth === msMasonry.columnWidth )
                    {
                        return;
                    }

                    MsNoteItem.columnWidth = msMasonry.columnWidth;

                    });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.sites')
        .controller('msNoteFormController', msNoteFormController)
        .directive('msNoteForm', msNoteFormDirective);

        /** @ngInject */
        function msNoteFormController($state, $scope,  msUtils, $mdDialog, $rootScope, $timeout, $http, RestAPIService,$q, $stateParams)
                {
            var MsNoteForm = this;
            var siteId = $stateParams.siteId;
            var notes=[];            
           /* RestAPIService.getToDoList(siteId).then(
                function(success){                 
                   notes  = success.data;
                   init();                 
                },
                function(error){
                RestAPIService.showErrorDialog(error);
                }
            );     */

            var config = {
                headers : {                     
                     'Authorization':'Bearer eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJhZG1pbiIsImF1dGgiOiJST0xFX0FETUlOLFJPTEVfVVNFUiIsImV4cCI6MTQ5MDE4NTcyMX0.1aXGwOdifQjxLTYQXnf8BPE0qRwDh70NE8flGvHx8mHR0fjLhEjQKyjlyOa6Okkv5Uab_9WNU3Kv_a3aaECx8A'
                    }
                }       
        //Data
        MsNoteForm.type = '';
        MsNoteForm.defaultNote = {
            'todolistId'  :'',
            'name'        : '',
            'description' : '',
            'actions'  : []
            };
        MsNoteForm.noteId = '';
        MsNoteForm.editNode = {};
        MsNoteForm.newCheckListItem = '';
        MsNoteForm.checkListForm = false;
        MsNoteForm.ngFlowOptions = {
            singleFile: true
            };
        MsNoteForm.ngFlow = {
            // ng-flow will be injected into here through its directive
            flow: {}
            };
        //Methods
        MsNoteForm.init = init;
        MsNoteForm.submit = submit;
        MsNoteForm.isNotValid = isNotValid;
        MsNoteForm.deleteNote = deleteNote;
        MsNoteForm.addChecklistItem = addChecklistItem;
        MsNoteForm.checklistFormToggle = checklistFormToggle;
        MsNoteForm.deleteCheckItem = deleteCheckItem;
        MsNoteForm.toggleArchive = toggleArchive;
        MsNoteForm.toggleInArray = msUtils.toggleInArray;
        MsNoteForm.exists = msUtils.exists;
         /**
         * Initialize
         */
        function init()
            {
            // If form type edit
            if ( MsNoteForm.type === 'edit' )
                {
                MsNoteForm.editNode = notes.getById(MsNoteForm.noteId);
                MsNoteForm.note = angular.copy(MsNoteForm.editNode);
                
            }        
            // If form type new
            else
                {
                resetForm();
            }
        }
        /**
         * Watch New Note Form, reset form if it is closed
         */
        $scope.$on('MsNewNote:closed', function ()
            {
            resetForm();
        });
        /**
         * Reset Form
         */
        function resetForm()
        {
            $scope.$evalAsync(function ()
            {
               MsNoteForm.note = angular.copy(MsNoteForm.defaultNote);
               MsNoteForm.checkListForm = false;
            });
        }
        /**
         * Submit Form
         */
        function submit()
            {
            if ( MsNoteForm.type === 'new' )
                {
                add();
                }
            else if ( MsNoteForm.type === 'edit' )
                {
                save();
                }
            }
        /**
         * Add new note
         */
        function add()
            {
            if ( isNotValid() )
                {
                return;
                }
        //MsNoteForm.todolistId = msUtils.guidGenerator();
         MsNoteForm.note.todolistId = 'Todo-124';
      /*   RestAPIService.addToDoList(MsNoteForm.note, siteId).then(
             function(success){
                MsNoteForm.addToDo=success.data;
                // add is success.Need to refresh the page
                $state.reload();
                },
             function(error){
                RestAPIService.showErrorDialog(error);
                    });*/
         MsNoteForm.note = angular.copy(MsNoteForm.defaultNote);
         $scope.$emit('MsNewNote:close');

         $mdDialog.cancel();
        }
        /**
         * Save Note
         */
        function save()
            {
        if ( isNotValid() )
            {
            return;
            }

       /* RestAPIService.updateTodo(MsNoteForm.note, siteId).then(
            function(success){
            // alert(JSON.stringify(success.data));
            // Update is success.Need to refresh  the page
            $state.reload();
            },
            function(error){
                RestAPIService.showErrorDialog(error);
            });*/
            $mdDialog.hide();
        }
        function toggleArchive()
        {
            if ( MsNoteForm.type === 'new' )
            {
                MsNoteForm.note.archive = true;
                submit();
            }
            else if ( MsNoteForm.type === 'edit' )
            {
                MsNoteForm.note.archive = !MsNoteForm.note.archive;
                save();
            }
        }
          /**
         * One of the title, description, checklist inputs are should be exist.
         * @returns {boolean}
         */
        function isNotValid()
        {
        // return  MsNoteForm.note.todolistId === '' && MsNoteForm.note.description === '' && MsNoteForm.note.actions.length === 0;
        }
        /**
         * Delete Note
         * @param ev
         */
        function deleteNote(ev)
        {
                var confirm = $mdDialog.confirm()
                .title('Remove')
                .htmlContent('the note will be deleted permanently for this site?')
                .ariaLabel('delete note')
                .targetEvent(ev)
                .ok('OK')
                .cancel('CANCEL');

        $mdDialog.show(confirm).then(function ()
            {               
       /*     RestAPIService.deleteTodo(MsNoteForm.noteId).then(
                function(success){
                    // delete is success.Need to refresh the page
                    $state.reload();
                    },
                    function(error){
                        RestAPIService.showErrorDialog(error);
                });*/
          });
        }
        /**
         * Add Checklist Item
         */
        function addChecklistItem()
        {
            if ( MsNoteForm.newCheckListItem === '' )
            {
                return;
            }
            MsNoteForm.note.actions.push({
                completed: false,
                description   : MsNoteForm.newCheckListItem
            });
            MsNoteForm.newCheckListItem = '';
            focusChecklistInput();
            }
        /**
         * Checklist form toggle
         */
        function checklistFormToggle()
        {
            $scope.$evalAsync(function ()
            {
                MsNoteForm.checkListForm = !MsNoteForm.checkListForm;

                $timeout(function ()
                {
                    focusChecklistInput();

                });
            });
        }
        /**
         * Delete check item
         * @param item
         */
        function deleteCheckItem(item)
        {
            MsNoteForm.note.actions.splice(MsNoteForm.note.actions.indexOf(item), 1);
            focusChecklistInput();
        }
        /**
         * Focus checklist input
         */
        function focusChecklistInput()
        {
            angular.element('#new-checklist-item-input').focus();
        }

        function getById(value)
        {
            console.log('getById',value)
         return notes.filter(function (x)
            {
                if(x.todolistId === value){
                    return x;
                }
            });

        };

    }
    /** @ngInject */
    function msNoteFormDirective()
    {
        return {
            restrict    : 'EA',
            controller  : 'msNoteFormController',
            controllerAs: 'MsNoteForm',
            scope       : {
                noteType: '=',
                noteId  : '='
            },
            templateUrl : 'app/main/sites/site/todolist/directives/ms-note-form/ms-note-form.html',
            link        : function (scope, element, attributes, MsNoteForm)
            {
                // Type
                MsNoteForm.type = scope.noteType;
                // Note id
                if ( angular.isDefined(scope.noteId) )
                {
                    MsNoteForm.noteId = scope.noteId;
                 }

             // MsNoteForm.init();

            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.sites')
        .controller('msNewNoteController', msNewNoteController)
        .directive('msNewNoteButton', msNewNoteButtonDirective)
        .directive('msNewNote', msNewNoteDirective);

    /** @ngInject */
    function msNewNoteController($scope, $document)
    {
        var MsNewNote = this;

        //Data
        MsNewNote.form = {
            name      : '',
            description: ''
        };

        //Methods
        MsNewNote.open = open;
        MsNewNote.close = close;
        MsNewNote.element = [];
        /**
         * Close Trigger
         */
        $scope.$on('MsNewNote:close', function ()
        {
            close();
        });

        /**
         * Open new note form
         */
        function open()
        {
            MsNewNote.element.find('textarea');
            $document.on('click', outSideClick);
        }

        /**
         * Close new note form
         */
        function close()
        {
           $scope.$broadcast('MsNewNote:closed');

            $document.off('click', outSideClick);
        }

        /**
         * Click Outside Event Handler
         * @param event
         */
        function outSideClick(event)
        {
            var isChild = MsNewNote.element.has(event.target).length > 0;
            var isSelf = MsNewNote.element[0] === event.target;
            var isMenu = angular.element(event.target).closest('md-menu-content').length > 0;
           

            var isInside = isChild || isSelf || isMenu;

            if ( !isInside )
            {
                close();
            }
        }
    }

    /** @ngInject */
    function msNewNoteDirective()
    {
        return {
            restrict    : 'E',
            controller  : 'msNewNoteController',
            controllerAs: 'MsNewNote',
            templateUrl : 'app/main/sites/site/todolist/directives/ms-new-note/ms-new-note.html',
            link        : function (scope, element, attributes, MsNewNote)
            {
                MsNewNote.element = element;
            }
        };
    }

    /** @ngInject */
    function msNewNoteButtonDirective()
    {
        return {
            restrict: 'EA',
            require : '^msNewNote',
            link    : function (scope, element, attributes, msNewNote)
            {
                element.on('click', function ()
                {
                    msNewNote.open();

                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.sites')
        .controller('SitesWikiController', SitesWikiController);

    /** @ngInject */
    function SitesWikiController()
    {
        var siteWikiCtrl = this;


        siteWikiCtrl.test = 'Wiki HTML content should be in here';
        
    }
})();


(function() {
    'use strict';

    angular
        .module('app.sites')
        .controller('SitesTodoController', SitesTodoController);

    /** @ngInject */
    function SitesTodoController($document, $scope, $timeout, $mdDialog, $http, RestAPIService, CurrentSiteId, CurrentSiteName, CurrentSiteUrl) {
        var siteTodoCtrl = this;
        siteTodoCtrl.value = CurrentSiteName.value;

        siteTodoCtrl.getAnotherColor = function(index) {
            siteTodoCtrl.colors = ['red', 'pink', 'purple', 'deep-purple', 'indigo', 'blue', 'light-blue', 'cyan', 'teal', 'green',
                'light-green', 'lime', 'yellow', 'amber', 'deep-orange', 'brown', 'grey', 'blue-grey'
            ];
            var totalNoOfColors = siteTodoCtrl.colors.length;
            return 'md-' + siteTodoCtrl.colors[index % totalNoOfColors] + '-50-bg';
        }
        
        siteTodoCtrl.filters = {
            archive: false
        };
        siteTodoCtrl.noteListType = 'notes';
        // Methods
        siteTodoCtrl.editNote = editNote;

        /**
         * Edit Note
         * @param ev
         * @param noteId
         */
        function editNote(ev, noteId) {
            $mdDialog.show({
                template: '<md-dialog ms-scroll><ms-note-form note-type="\'edit\'" note-id="\'' + noteId + '\'"></ms-note-form></md-dialog>',
                parent: $document.find('#notes'),
                targetEvent: ev,
                clickOutsideToClose: true,
                escapeToClose: true,
            });
        }

        siteTodoCtrl.showConfirm = function(ev) {
            $mdDialog.show({
                template: '<md-dialog ms-scroll><ms-note-form note-type="\'new\' "></ms-note-form></md-dialog>',
                parent: $document.find('#notes'),
                targetEvent: ev,
                clickOutsideToClose: true,
                escapeToClose: true
            });
        }


        /**
         * Escape key event
         */
        function escKeyEvent(e) {
            if (e.keyCode === 27) {
                editNote(ev);
            }
        }
        
        $scope.goSites = function(hash) {
            $scope.$parent.todolistview = false;
        }

        Array.prototype.getById = function(value) {
            return this.filter(function(x) {
                return x.todolistId === value;
            })[0];
        };

    }
})();
(function() {
    'use strict';

    angular
        .module('app.sites')
        .controller('SiteSettingsController', SiteSettingsController);

    /** @ngInject */
    function SiteSettingsController($state, $scope, RestAPIService, $stateParams, $mdDialog, $location,Icons, $localStorage) {
        var sitesettingCtrl = this;
        var siteId = "site-2";
        $scope.siteSettingsLabels = {};
        $scope.Edit = true;
        $scope.setting = {};
        $scope.siteSettingsValue = {};
        sitesettingCtrl.editMode = function() {
            $scope.Edit = !$scope.Edit;
            $scope.editButton = true;
        };

        if ($localStorage.sitesettingdata != null && $localStorage.sitesettingdata != undefined) {
            $scope.sitedisplayname = $localStorage.sitesettingdata.sitedisplayname;
        } else {
            $scope.sitedisplayname = "site";
        }

        $scope.getSite = function() {
            RestAPIService.getSiteDetails(siteId).then(
                function(success) {
                    $scope.site = success.data;
                    sitesettingCtrl.site = success.data;
                    $scope.getPermission();
                    $scope.getFileById();
                },
                function(error) {
                });
        };
       
        $scope.getFileById = function() {
            RestAPIService.getFileById(siteId,$scope.site.documentLibrary).then(
                function(success) {
                    $scope.file = success.data; 
                },
                function(error) {
                });
        };
        
        /*$scope.getFoldersOnly = function() {
            RestAPIService.getFoldersOnly(siteId,$scope.file).then(
                function(success) {
                    $scope.filepermission = success.data;   
                },
                function(error) {
                });
        };*/
        
         $scope.updateFolderSettings =function(){
        RestAPIService.FoldersOnly(siteId,$scope.file).then(
            function(success) {
           	  RestAPIService.successTostDialog("Folder Settings Updated successfully ");
            	$scope.getFileById();
            	 $state.reload();
            },
            function(error) {
                RestAPIService.showErrorDialog(error);
            }
        );
        $mdDialog.hide();
    
       }


         $scope.openIconList = function(ev) {
             $mdDialog.show({
                 controller: CreateSiteDialogController,
                 templateUrl: 'app/main/sites/site/dashboard/site.logo.html',
                 parent: angular.element(document.body),
                 targetEvent: ev,
                 clickOutsideToClose:true,
                 preserveScope: true,
                 autoWrap: true,
                 
                 skipHide: true, // this line does the trick for nested dialogs

                 fullscreen: $scope.customFullscreen // Only for -xs, -sm breakpoints.
               })
               .then(function(answer) {
                 $scope.status = 'You said the information was "' + answer + '".';
               }, function() {
                 $scope.status = 'You cancelled the dialog.';
               });
           };
       
         
           function CreateSiteDialogController($scope, $mdDialog, RestAPIService){
           	
           	$scope.icons = Icons.icons;
           	  $scope.noOfIconsForDisplay = 50;
                 $scope.iconsPerColumn = 5;

                 $scope.range = function(min, max, step){
                   step = step || 1;
                   var input = [];
                   for (var i = min; i <= max; i += step) input.push(i);
                   return input;
                 };

                 $scope.loadMoreIcons = function() {
                     $scope.noOfIconsForDisplay += 10;
                    
                 };
                 $scope.hide = function() {

                     $mdDialog.hide();
                   };

                   $scope.cancel = function() {                
                       $mdDialog.cancel();
                   };
                   $scope.saveLogo = function(siteIcon) {
                   	sitesettingCtrl.value = siteIcon;
                       $mdDialog.hide();
                   };
           	
           }
           
           
           $scope.Updatesite =function(site){        	
           	site['siteId'] =siteId; 
           	site['icon'] = sitesettingCtrl.value;
           	RestAPIService.updateSite(site).then(
           			function(success){
           				 RestAPIService.successTostDialog('Updated Successfully');   
           				 $state.go('app.sites', null, { reload: true });
           				/* $state.reload();*/
            				RestAPIService.getSites();
           			},
           			function(error){
           				
           			});

           };
        sitesettingCtrl.smartstoreSave = function(siteId, setting) {
            $scope.setting['siteSettingsName'] = "smartstore";
            $scope.setting['siteSettingsValue'] = $scope.siteSettingsValue;
            RestAPIService.siteSettings(siteId, $scope.setting).then(
                function(success) {
                    RestAPIService.successTostDialog(success.headers('X-smartportalApp-alert'));
                    $scope.siteSettingsValue = success.data.settings['smartstore'];
                    sitesettingCtrl.Cancel();
                },
                function(error) {

                    RestAPIService.showErrorDialog(error);
                }
            );

        };
        $scope.save = function(siteId, setting) {
            $scope.setting['siteSettingsName'] = "ganeralsettings";
            $scope.setting['siteSettingsValue'] = $scope.home;
            RestAPIService.siteSettings(siteId, $scope.setting).then(
                function(success) {
                    RestAPIService.successTostDialog(' Updated Successfully');
                    $scope.siteSettingsValue = success.data.settings['general'];
                    $state.reload();
                },
                function(error) {
                    RestAPIService.showErrorDialog(error);
                }
            );
        };
        $scope.clear = function() {
            $scope.home = null;
        }
        sitesettingCtrl.Cancel = function() {
            $scope.editButton = false;
            $scope.Edit = !$scope.Edit;
        };
        sitesettingCtrl.solrSave = function(siteId, setting) {
            $scope.setting['siteSettingsName'] = "solr";
            $scope.setting['siteSettingsValue'] = $scope.siteSettingsValue;
            RestAPIService.siteSettings(siteId, $scope.setting).then(
                function(success) {
                    RestAPIService.successTostDialog(success.headers('X-smartportalApp-alert'));
                    $scope.siteSettingsValue = success.data.settings['solr'];
                    sitesettingCtrl.Cancel();
                },
                function(error) {
                    RestAPIService.showErrorDialog(error);
                });
        };

        $scope.addDocumentTypeDialog = function(ev) {
            $mdDialog.show({
                controller: AddDocumentDialogController,
                templateUrl: 'app/main/sites/site/sitesettings/site.addDocumentDialog.html',
                parent: angular.element(document.body),
                preserveScope: true,
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: $scope.customFullscreen
            })
        }

        function AddDocumentDialogController($scope, $mdDialog) {
            $scope.getDocumentTypes = function() {
                RestAPIService.getDocumentTypes().then(
                    function(success) {
                        $scope.documentsList = success.data;
                    },
                    function(error) {
                        RestAPIService.showErrorDialog(error);
                    });
            }
            $scope.cancel = function() {
                $mdDialog.cancel();
            };
        }

        sitesettingCtrl.getSites = function() {
            RestAPIService.getSites().then(
                function(success) {
                    sitesettingCtrl.sites = success.data;
                },
                function(error) {
                    RestAPIService.showErrorDialog(error);
                }
            );
        }
        sitesettingCtrl.deleteSite = function(ev) {
            var confirm = $mdDialog.confirm()
                .title('Remove')
                .textContent('Site will be permanently deleted. Continue ?')
                .ariaLabel('Delete Site')
                .targetEvent(ev)
                .ok('Ok')
                .cancel('Cancel');
            $mdDialog.show(confirm).then(function() {
                RestAPIService.deleteSite(siteId).then(
                    function(success) {
                        RestAPIService.successTostDialog("Site deleted successfully ");
                        $location.url('/smartportal/sites');
                        sitesettingCtrl.getSites();

                    },
                    function(error) {
                        $mdDialog.show(
                            $mdDialog.alert()
                            .clickOutsideToClose(true)
                            .title('Error')
                            .textContent(error.headers('X-smartportalApp-params'))
                            .ok('Ok')
                        );
                    });
            });
        };
        $scope.allUsersForPermission = [];

        $scope.getPermission = function() {
            RestAPIService.getFilePermissions(siteId, $scope.site.documentLibrary).then(
                function(response) {
                    $scope.allUsersForPermission = response.data;
                },
                function(error) {
                    RestAPIService.showErrorDialog(error);
                });
        }
        
        $scope.searchElements = {
            type: 'User'
        };

        $scope.searchUsersForManagePermission = function(elements) {
            $scope.searchedUsers = {};
            RestAPIService.searchUsers(elements).then(
                function(response) {
                    if (response.data[0].length > 0) {
                        $scope.searchedUsers.data = response.data[0];
                        $scope.searchedUsers.type = elements.type;
                    }
                },
                function(error) {
                    RestAPIService.showErrorDialog(error);
                });
        }

        $scope.addUserForManagePermission = function(memberData, status, type) {
            var json = {};
            json.type = type;
            if (status != undefined) {
                var keys = Object.keys(status);
                var filtered = keys.filter(function(key) {
                    return status[key]
                });
                json.permissions = filtered;
            } else {
                json.permissions = [];
            }
            if (type == 'User' || type == 'Group') {
            	json.fileId = $scope.site.documentLibrary;
                if (type == 'User') {
                	json.email = memberData.email;
                    json.lastName = memberData.lastName;
                    json.firstName = memberData.firstName;
                    json.id = memberData.login;
                } else {
                    json.id = memberData.id;
                    json.firstName = memberData.name;
                }
            } else if (type == 'Owner' || type == 'SiteAdmin') {
                json.id = type;
                json.fileId = $scope.site.documentLibrary;
                json.firstName = type;
            }
            if ($scope.allUsersForPermission.length > 0) {
                if (type == 'User' || type == 'Group') {
                    var temp = false;
                    for (var i = 0; i < $scope.allUsersForPermission.length; i++) {
                        if ($scope.allUsersForPermission[i].id === json.id) {
                            $scope.allUsersForPermission.splice(i, 1)
                            $scope.allUsersForPermission.splice(i, 0, json);
                            temp = true;
                            break;
                        }
                    }
                    if (!temp) {
                        $scope.allUsersForPermission.push(json);
                    }
                } else if (type == 'Owner' || type == 'SiteAdmin') {
                    var temp = false;
                    for (var i = 0; i < $scope.allUsersForPermission.length; i++) {
                        if ($scope.allUsersForPermission[i].type === type) {
                            $scope.allUsersForPermission.splice(i, 1)
                            $scope.allUsersForPermission.splice(i, 0, json);
                            temp = true;
                            break;
                        }
                    }
                    if (!temp) {
                        $scope.allUsersForPermission.push(json);
                    }
                }
            } else {
                $scope.allUsersForPermission.push(json);
            }
        }

        $scope.removePermission = function(user) {
            if (user.type == 'User' || user.type == 'Group') {
                for (var i = 0; i < $scope.allUsersForPermission.length; i++) {
                    if ($scope.allUsersForPermission[i].id === user.id) {
                        $scope.allUsersForPermission.splice(i, 1)
                        break;
                    }
                }
            }
        }
        
        $scope.onChangePermissionType = function(type) {
        	if (type == 'Owner' || type == 'SiteAdmin') {
        		$scope.ownerStatus = {};    		
                 for (var i = 0; i < $scope.allUsersForPermission.length; i++) {
                     if ($scope.allUsersForPermission[i].type === type) {
                    	 for (var key in $scope.allUsersForPermission[i].permissions) {
                    		 $scope.ownerStatus[$scope.allUsersForPermission[i].permissions[key]] = true;
                    	 }
                         break;
                     }
                 }
        	}       
        	$scope.searchedUsers = {};            	  
        	$scope.searchElements.text = null;
        	
        }
        
        $scope.saveUserManagePermission = function() {
            RestAPIService.updateFilePermission(siteId, $scope.site.documentLibrary, $scope.allUsersForPermission).then(
                function(response) {
                    RestAPIService.successTostDialog("Permissions updated successfully");
                    $state.reload();
                },
                function(error) {
                    RestAPIService.showErrorDialog(error);
                });
        }
        
       
    }
})();
(function ()
{
    'use strict';
    angular
        .module('app.sites')
        .controller('SitesMembersController', SitesMembersController);
        
        /** @ngInject */
        function SitesMembersController($http, $scope, $mdDialog, LoggedInUserId, RestAPIService,Members,$stateParams,$localStorage)
        {
            var siteMembersCtrl = this; 
            $scope.x=true;
           // var siteId = $stateParams.siteId;
            var siteId ="site-2";
            $scope.roles = ["Administrators","Members"];
            siteMembersCtrl.members = Members.data; 
            /*if(siteMembersCtrl.members.roleId == "Administrators"){
          	   $scope.x = false;
          }     */    
            $scope.hide= true;
            siteMembersCtrl.members.forEach(function(member) {
        	  if(member.roleId == "Administrators"){
        		  if(member.login == $localStorage.currentUser.username)
        		  $scope.hide= false;
        		  }
          	});
         
            
            siteMembersCtrl.getMembers = function(){ 
                RestAPIService.getMembers(siteId).then(
                    function(success){
                        siteMembersCtrl.members = success.data;
                        
                    },
                    function(error){
                        RestAPIService.showErrorDialog(error);
                    }
                );  
            }      

            siteMembersCtrl.deleteMember = function( ev, member, memberData){               
                var confirm = $mdDialog.confirm() 
                .title('Remove')               
                .textContent(member +' privilege of '+ memberData.firstName+" "+memberData.lastName + ' will be removed for this site , continue ?')            
                .targetEvent(ev)
                .ok('Ok')
                .cancel('Cancel');
                
                $mdDialog.show(confirm).then(function() {
                        //Deleting the member
                        RestAPIService.deleteMember(siteId,memberData.login).then(
                            function(success){
                            	//alert(JSON.stringify(siteId));
                                //Member Successfully deleted. Need to refresh through GET call  
                                siteMembersCtrl.getMembers(siteId); 
                            },
                            function(error){
                               RestAPIService.showErrorDialog(error);
                            }
                        );    
                }, function() {
                   //User clicked Cancel. Close the popup
                });
            };


            siteMembersCtrl.addMemberDialog = addMemberDialog;
            siteMembersCtrl.memberRole='';

            function addMemberDialog(ev,roleId){  
                siteMembersCtrl.memberRole = roleId;                 
                $mdDialog.show({
                    controller: AddMemberDialogController ,
                    templateUrl: 'app/main/sites/site/members/site.addMemberDialog.html',
                    parent: angular.element(document.body),
                    preserveScope: true,
                    targetEvent: ev,
                    clickOutsideToClose:true,
                    fullscreen: $scope.customFullscreen // Only for -xs, -sm breakpoints.
                })  
            }    

            function AddMemberDialogController($scope, $mdDialog){
                $scope.memberRole = siteMembersCtrl.memberRole;
                $scope.tableVisibility=false;
                $scope.searchedMembers=[];
                $scope.width=25; 
                
                $scope.addMember = function(memberData){
                    var member ={};
                    member.email = memberData.email;
                    member.firstName = memberData.firstName;
                    member.lastName = memberData.lastName;
                    member.login = memberData.login;
                    member.roleId = siteMembersCtrl.memberRole;
                    //alert(JSON.stringify(member));
                    
                    RestAPIService.addMember(siteId,member).then(
                        function(success){
                        	 RestAPIService.successTostDialog('Member'+' '+ member.login +' '+'added Successfully');	 	
                        	//alert(JSON.stringify(siteId));
                            //Member Successfully added. Need to refresh through GET call  
                            siteMembersCtrl.getMembers(siteId); 
                        },
                        function(error){
                            RestAPIService.showErrorDialog(error);
                        }
                    );               
                }  

                $scope.close=function(){
                    $mdDialog.cancel();
                }      

                $scope.cancel= function(memberData){
                    $scope.member = {};
                    $scope.tableVisibility=false;        
                    $scope.searchedMembers=[];
                    $scope.width=25;
                    $scope.msgVisibility=false;                    
                    $mdDialog.cancel();
                }       
                $scope.searchMember = function(memberdata){ 
                     var q = "";
                    if(memberdata == undefined || angular.equals(memberdata, {}) ){
                        $scope.msgVisibility=true;
                        $scope.tableVisibility=false;
                        $scope.member = {}; 
                    }else{ 
                        if((memberdata.name !=""&&memberdata.name !=undefined) && (memberdata.email !="" && memberdata.email !=undefined)){
                          q = memberdata.name;
                        }else if((memberdata.name ==""|| memberdata.name==undefined) && (memberdata.email !="" && memberdata.email != undefined)){
                            q = memberdata.email;
                        }else if(memberdata.name !="" && (memberdata.email ==""||memberdata.email==undefined)){
                            q = memberdata.name;
                        }
                        $scope.searchedMembers= [];                     
                        RestAPIService.searchMember(siteId,q).then(
                        function(success){
                            $scope.searchedMembers = success.data;
                            $scope.msgVisibility=false;
                            $scope.tableVisibility=true;
                            $scope.member = {};                        
                        },function(error){
                            RestAPIService.showErrorDialog(error);
                        }
                        );
                    }                       
                }
                // $scope.addMemberInHardCodedStag = function(memberData){
                //     siteMembersCtrl.hardcodedMembers.push(memberData);
                // }       
                $scope.ok= function(){
                    $mdDialog.cancel();
                } 
            }               
        }
    }
)();
(function ()
{
    'use strict';

    angular
        .module('app.sites')
        .controller('SitesHomeController', SitesHomeController);

    /** @ngInject */
    function SitesHomeController(CurrentSitePage, $localStorage, $http, $scope, RestAPIService,SiteDashboard,$stateParams, $rootScope, $state)
    {
        var siteHomeCtrl = this;
        CurrentSitePage.value = 'Home';
        var siteId = $stateParams.siteId;
          $scope.Home = SiteDashboard.data;
            $scope.getSiteDetails = function() {  
                RestAPIService.getSiteDetails(siteId).then(
                    function(success){
                     $scope.siteData = success.data;
                     $rootScope.documentLibraryId = success.data.documentLibrary;
                     
                    },
                    function(error){
                       RestAPIService.showErrorDialog(error);
                    }
                );
                RestAPIService.getPayablesDashboard(siteId).then(
                        function(success){
                         $scope.payablesDashboard = success.data;
//                         Processing data for Process time Analysis.
                        var ptaDataMonths = success.data.ptaVM.ptaMonths;
                        var ptaDataInvoicesProcessd = success.data.ptaVM.ptaProcessedInvoices;
                         var ptaDataAverageProcessingTimes = success.data.ptaVM.ptaAverageProcessingTimes;                         
//                         Processing data for Channel analysis.
                         $scope.channelAnalysisNoOfItemsProcessed = success.data.caVM.noOfItemsProcessed[0];
                         $scope.caKeys =  Object.keys($scope.channelAnalysisNoOfItemsProcessed);
                     $scope.cavalues = Object.values($scope.channelAnalysisNoOfItemsProcessed);
                     $scope.caMainArray = [];
                     for(var i=0; i<$scope.caKeys.length; i++){
                       $scope.singleArray = [];
                       $scope.singleArray.push($scope.caKeys[i]);
                       $scope.singleArray.push($scope.cavalues[i]);
                       $scope.caMainArray.push($scope.singleArray);
                     }
                    var caNoOfItemsProcessed = $scope.caMainArray;
//                     Processing data for Status Analysis.
                     $scope.statusAnalysisNoOfItemsProcessed = success.data.statusVM.noOfItemsProcessed[0];
                     $scope.saKeys =  Object.keys($scope.statusAnalysisNoOfItemsProcessed);
                     $scope.savalues = Object.values($scope.statusAnalysisNoOfItemsProcessed);
                     $scope.saMainArray = [];
                     $scope.saMainArray[0] = ['ocr',$scope.statusAnalysisNoOfItemsProcessed.ocr];
                         $scope.saMainArray[1] = ['revised',$scope.statusAnalysisNoOfItemsProcessed.revised];
                         $scope.saMainArray[2] = ['posted',$scope.statusAnalysisNoOfItemsProcessed.posted];
                         $scope.saMainArray[3] = ['paid',$scope.statusAnalysisNoOfItemsProcessed.paid];
                    var saNoOfItemsProcessed = $scope.saMainArray;
//                     Processing data for key pint indexes.
                     $scope.keyPointIndexes = success.data.kpiVM.keyPointIndexs;
//                     Processing data for Invoice Volume Analysis.
                     $scope.IVAMonthsData= success.data.invoiceVm.months;
//                     Making month number (01) as Strings (Jan) to display in chart.
                     for(var i=0; i<$scope.IVAMonthsData.length; i++){
                       var monthNumber = $scope.IVAMonthsData[i].substring(4,6);
//                       Call a function which converts Month number to String.
                       var month = $scope.setMonth(monthNumber);
                       $scope.IVAMonthsData[i] = $scope.IVAMonthsData[i].substring(6,8)+'-'+month+'-'+$scope.IVAMonthsData[i].substring(0,4);
                     }
                    var IVAMonths = $scope.IVAMonthsData;
                     $scope.IVAItemsData = success.data.invoiceVm.data;
                     $scope.IVAItemsFinalArray = [];
                     for(var i=0; i<$scope.IVAItemsData.length; i++){
                       $scope.IVATempAObj = {};
                       var keys = Object.keys($scope.IVAItemsData[i]);
                       var values = Object.values($scope.IVAItemsData[i]);
                       $scope.IVATempAObj['name'] =  keys[0];
                       $scope.IVATempAObj['data'] =  values[0];
                       $scope.IVAItemsFinalArray.push($scope.IVATempAObj);
                     }
                   var  IVAItemsFinalArray = $scope.IVAItemsFinalArray;
                     console.log(IVAItemsFinalArray);
                     console.log(IVAMonths);
                        },
                        function(error){
                           RestAPIService.showErrorDialog(error);
                        }
                    );
                
            }
            $scope.setMonth = function(month){
              if(month == '01'){
                return 'Jan';
              }
              else if(month == '02'){
                return 'Feb';
              }
              else if(month == '03'){
                return 'Mar';
              }
              else if(month == '04'){
                return 'Apr';
              }
              else if(month == '05'){
                return 'May';
              }
              else if(month == '06'){
                return 'Jun';
              }
              else if(month == '07'){
                return 'Jul';
              }
              else if(month == '08'){
                return 'Aug';
              }
              else if(month == '09'){
                return 'Sep';
              }
              else if(month == '10'){
                return 'Oct';
              }
              else if(month == '11'){
                return 'Nov';
              }
              else if(month == '12'){
                return 'Dec';
              }
              
            }

              if($localStorage.sitesettingdata !=null && $localStorage.sitesettingdata !=undefined){
                $scope.sitedisplayname = $localStorage.sitesettingdata.sitedisplayname;
                siteHomeCtrl.sitedisname = $scope.sitedisplayname;
              }else{
                $scope.sitedisplayname = "site";
                siteHomeCtrl.sitedisname = "site";
              }
        
    }
})();


(function() {
    'use strict';

    var app = angular
        .module('app.doclibraryForms', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $controllerProvider, $compileProvider, $filterProvider, $provide) {
        app.controller = $controllerProvider.register;
        app.directive = $compileProvider.directive;
        app.filter = $filterProvider.register;
        app.factory = $provide.factory;
        app.service = $provide.service;
        
        $stateProvider
            .state('app.doclibraryForm', {
                url: '/smartportal/docLibraryForm/:siteId/:fileId/:businessObject',
                params: {
                    'siteId': null,
                    'fileId': null,
                    'businessObject': null
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/main/sites/site/doclibraryForm/doclibraryForm.html',
                        controller: 'DoclibraryFormController as docLibraryFormCtrl'
                    }
                },
                resolve: {
                    deps: ['$ocLazyLoad', function($ocLazyLoad) {
                        return $ocLazyLoad.load(['app/main/sites/site/doclibraryForm/doclibraryForm.controller.js']);
                    }]
                }
            });

    }
})();
(function() {
    'use strict';

    angular
        .module('app.doclibraryForms')
        .controller('DoclibraryFormController', DoclibraryFormController);

    /** @ngInject */
    function DoclibraryFormController($state, $scope, $stateParams, $window, RestAPIService, $sce) {
        var docLibraryFormCtrl = this;
        $scope.isReadOnlyHeaderCurrency = true;        
        $scope.header = {};
        $scope.lineItems = [{
    		temp : null    		 
        }]; 
        docLibraryFormCtrl.gotoBack = function() {
            $window.history.back();
        }

        function viewForm(data){
            $scope.currentFormName = data.name;
            $scope.currentFormHeader = $sce.trustAsHtml(data.content.replace(/&quot;/g,'"'));
            $scope.currentFormLineitem = $sce.trustAsHtml(data.lineItemContent.replace(/&quot;/g,'"'));
        }

        
        // Initial load
        init();

        function init() {
            if ($stateParams.fileId != undefined && $stateParams.siteId != undefined) {
                RestAPIService.buildForm($stateParams.siteId, $stateParams.fileId).then(
                    function(success) {
                        $scope.header = success.data.header;
                        $scope.lineItems = success.data.lineItems;
                    },
                    function(error) {
                        RestAPIService.showErrorDialog(error);
                    });
            }
            if($stateParams.businessObject != undefined){
            	RestAPIService.findBusinessObjectAttributes($stateParams.businessObject).then(
                        function(success) {
                        	if(success.data != undefined){
                        		if(undefined != success.data.formId){
                        			RestAPIService.getRequestFormById(success.data.formId).then(
                                            function(response) {
                                            	console.log("response :: ",response)
                                                viewForm(response.data);
                                            },
                                            function(error) {
                                                RestAPIService.showErrorDialog(error);
                                        });
                        		}
                        	}
                        },
                        function(error) {
                            RestAPIService.showErrorDialog(error);
                    });
            	
            }
            
            
        }

    }
})();
(function() {
    'use strict';

    angular
        .module('app.sites')
        .controller('SitesDocLibraryController', SitesDocLibraryController);


    /** @ngInject */
    function SitesDocLibraryController($scope, $mdDialog, $mdSidenav, $state, RestAPIService, CommonUtil, FileIdForLegacyForm, $stateParams, $rootScope) {
        var siteDocLibCtrl = this;
        siteDocLibCtrl.currentFolderId = '';
        $scope.detailsVisibility = false;
        $scope.versionsVisibility = false;
        $scope.buttonVisibility = false;
        $scope.filebuttonVisibility = false;
        $scope.hide =false;

        $scope.filePath = [{
            "id": "",
            "name": "Home"
        }];
        $scope.filePathVisibility = false;
        var siteId = "site-2";
        $stateParams.siteId ="site-2";

        $scope.orderByField = 'name';
        $scope.reverseSort = false;

        siteDocLibCtrl.pageNumber = 0;
        siteDocLibCtrl.pageSize = 10;
        siteDocLibCtrl.next = function() {
            siteDocLibCtrl.pageNumber = siteDocLibCtrl.pageNumber + 1;
            siteDocLibCtrl.getFiles();
        }
        siteDocLibCtrl.previous = function() {
            siteDocLibCtrl.pageNumber = siteDocLibCtrl.pageNumber - 1;
            siteDocLibCtrl.getFiles();
        }
        $scope.sendPageNumber = function(pageNumber) {
            siteDocLibCtrl.pageNumber = pageNumber;
            siteDocLibCtrl.getFiles();
        }
        
       
        siteDocLibCtrl.getFiles = function() {
         $scope.selectedRow = 0;
             $scope.detailsVisibility = false;
            RestAPIService.getFiles(siteDocLibCtrl.currentFolderId, siteId, siteDocLibCtrl.pageNumber, siteDocLibCtrl.pageSize).then(
                function(success) {
                    siteDocLibCtrl.files = success.data;                   
                    siteDocLibCtrl.numberOfElements = success.headers('x-total-count');
                      $scope.noOfPages = siteDocLibCtrl.numberOfElements / siteDocLibCtrl.pageSize;
                    $scope.pageNumbers = [];
                    if ($scope.noOfPages > 0) {
                        for (var i = 0; i < $scope.noOfPages; i++) {
                            $scope.pageNumbers.push(i);
                        }
                    }
                       },
                function(error) {
                    RestAPIService.showErrorDialog(error);
                });
        };
        $scope.getSite = function() {
            RestAPIService.getSiteDetails(siteId).then(
                function(success) {
                    $scope.site = success.data;
                   //$scope.getFileById();
                   //$scope.getSiteSettingPermission();
                },
                function(error) {
                });
        };
        // $scope.getFileById = function() {
        //     RestAPIService.getFileById(siteId,$scope.site.documentLibrary).then(
        //         function(success) {
        //          siteDocLibCtrl.filepermission = success.data;
                    
        //         },
        //         function(error) {
        //         });
        // };
       
        // $scope.getSiteSettingPermission = function() {
        //  siteDocLibCtrl.settingsResponseEdit = true;
        // RestAPIService.getMyFilePermissions(siteId,$scope.site.documentLibrary).then(
        //         function(response){
        //          siteDocLibCtrl.mySiteSettingPermissions = response.data;
        //           if(siteDocLibCtrl.mySiteSettingPermissions.permissions != undefined) {
        //                  var settingsResponse = siteDocLibCtrl.mySiteSettingPermissions.permissions.indexOf("Edit");
        //                  if(settingsResponse >= 0) {
        //                      siteDocLibCtrl.settingsResponseEdit = false;
        //                  }   
        //              }
        //         },
                
        //          function(error){
        //             RestAPIService.showErrorDialog(error);
        //         }); 
     
        // }
        $scope.renewalFile = function(file) {
            RestAPIService.renewalFile(siteId, file).then(
                function(success) {
                    RestAPIService.successTostDialog("File renamed successfully ");
                    siteDocLibCtrl.getFiles();
                },
                function(error) {
                    RestAPIService.showErrorDialog(error);
                });
        }

        siteDocLibCtrl.getAttributes = function(fileId) {
            RestAPIService.getAttributes(siteId, fileId).then(
                function(response) {
                    $scope.file = response.data;
                    siteDocLibCtrl.selectedFile = response.data;

                    siteDocLibCtrl.fileAttributes = [];
                    for (var attributeName in response.data.attributes) {
                        var attribute = {
                            name: attributeName,
                            value: response.data.attributes[attributeName]
                        }
                        siteDocLibCtrl.fileAttributes.push(attribute);
                    }

                    siteDocLibCtrl.allSharedUsers = response.data.users;
                     },
                function(error) {
                    RestAPIService.showErrorDialog(error);
                }
            );
        };

        $scope.editorEnabled = false;
        $scope.enableEditor = function() {
            $scope.editorEnabled = true;
        };
        $scope.disableEditor = function() {
            $scope.editorEnabled = false;
        };

        $scope.saveAllAttributes = function() {
            $scope.disableEditor();
            $scope.fileAttributesObject = {};
            $scope.fileAttributesObject.id = siteDocLibCtrl.selectedFile.id;
             var attributes = {};
            for (var i = 0; i < siteDocLibCtrl.fileAttributes.length; i++) {
                  attributes[siteDocLibCtrl.fileAttributes[i].name] = siteDocLibCtrl.fileAttributes[i].value;
            }
            $scope.fileAttributesObject.attributes = attributes;
            $scope.fileAttributesObject.versions = siteDocLibCtrl.selectedFile.versions;
            $scope.fileAttributesObject.activities = siteDocLibCtrl.selectedFile.activities;
            $scope.fileAttributesObject.users = siteDocLibCtrl.selectedFile.users;
            RestAPIService.updateFileAttrAndSharing(siteId, $scope.fileAttributesObject).then(
                function(response) {
                    siteDocLibCtrl.getAttributes(siteDocLibCtrl.selectedFile.id);
                    $mdDialog.hide();
                },
                function(error) {
                    RestAPIService.showErrorDialog(error);
                }
            );
        };


        siteDocLibCtrl.fileIcon = function(file) {
            return CommonUtil.getIconForFile(file);
        }

        siteDocLibCtrl.toggleDetails = function(fileItem, i) {
            siteDocLibCtrl.selectFile(fileItem, i);
            $scope.showsidenav = true;
            toggleSidenav('details-sidenav');
        }

        function toggleSidenav(sidenavId) {
            $mdSidenav(sidenavId).toggle();
        }

        siteDocLibCtrl.folderClick = function(file) {
        
            if (file.type == 'file') return;
            siteDocLibCtrl.pageNumber = 0;
            siteDocLibCtrl.currentFolderId = file.id;
            $scope.filePath.push(file);
            siteDocLibCtrl.getFiles();
            if ($scope.filePath.length > 1) {
                $scope.filePathVisibility = true;
            }
        }

        siteDocLibCtrl.selectFile = function(fileItem, i) {
           // alert(JSON.stringify(fileItem));
            /*$scope.hide =false;*/
            siteDocLibCtrl.edit =false;
            siteDocLibCtrl.permission=false;
            siteDocLibCtrl.deleteFilepermission=false;
            siteDocLibCtrl.downloadFile=false;
            siteDocLibCtrl.viewFile =false;
            if (fileItem.status == 'CheckedOut') {
                $scope.checkout = true;
            } else {
                $scope.checkout = false;
            }
            // RestAPIService.getMyFilePermissions(siteId,fileItem.id).then(
            //         function(response){
            //           $scope.myPermissions = response.data;
            //          siteDocLibCtrl.filePermissions = $scope.myPermissions;
            //         if($scope.myPermissions.permissions != undefined) {
            //          var responseEdit = $scope.myPermissions.permissions.indexOf("Edit");
            //          var responsePermission = $scope.myPermissions.permissions.indexOf("Permission");
            //          var responseDelete = $scope.myPermissions.permissions.indexOf("Delete");
            //          var responseDownload = $scope.myPermissions.permissions.indexOf("Download");
            //          var responseView = $scope.myPermissions.permissions.indexOf("View");
                    
            //          if(responseEdit >= 0) {
            //              siteDocLibCtrl.edit = true;
            //          }
            //          if(responsePermission >=0){
            //              siteDocLibCtrl.permission = true;
            //          }if(responseDelete >=0){
            //              siteDocLibCtrl.deleteFilepermission = true;
            //          }
            //          if(responseDownload >=0){
            //              siteDocLibCtrl.downloadFile = true;
            //          }
            //          if(responseView >=0){
            //              siteDocLibCtrl.viewFile = true;
            //          }
                        
            //      }
            //                         },
            //         function(error){
            //             RestAPIService.showErrorDialog(error);
            //         }
            //     );  
             $scope.selectedRow = i;
            siteDocLibCtrl.receivedFile = fileItem;
            $scope.iconsVisibility = i;
            $scope.detailsVisibility = true;

            if (fileItem.type === "folder") {
                $scope.versionsVisibility = false;
            } else {
                $scope.versionsVisibility = true;
            }

            if (fileItem.mimeType == "") {
                $scope.buttonVisibility = false;
                $scope.filebuttonVisibility = false;
            } else if (fileItem.mimeType === "application/pdf" || fileItem.mimeType === "text/plain" || fileItem.mimeType === "multipart/form-data" || fileItem.mimeType === "application/octet-stream" || "application/jpg" || "application/PNG") {
                $scope.buttonVisibility = false;
                $scope.filebuttonVisibility = true;
            } else {
                $scope.buttonVisibility = true;
                $scope.filebuttonVisibility = false;
            }

            siteDocLibCtrl.selectedFileName = fileItem.name;
            $scope.selectedFileIcon = CommonUtil.getIconForFile(fileItem);
            $scope.businessObjectName = fileItem.businessObjectName;
            // Call API service to get attributes, versions and activities of this file.
            var fileId = fileItem.id;
            siteDocLibCtrl.getAttributes(fileId);

        }


        $scope.toggleDetails = function(fileItem, i) {
            /*siteDocLibCtrl.selectFile(fileItem, i);*/
            $scope.showsidenav = true;
            toggleSidenav('details-sidenav');
        }

        function toggleSidenav(sidenavId) {
            $mdSidenav(sidenavId).toggle();
        }


        $scope.previewFile = function(ev) {
            $mdDialog.show({
                controller: DialogController,
                templateUrl: 'app/main/sites/site/doclibrary/previewFiles.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true
            });
        }

        function DialogController($scope, $mdDialog, $sce, $sessionStorage) {
            var selectedFile = siteDocLibCtrl.receivedFile;
            var jwtToken = $sessionStorage.currentUser.token.trim();
            if (jwtToken != undefined && selectedFile != undefined) {
                var encodedURI = encodeURIComponent(baseUrl + '/api/sites/' + $stateParams.siteId + '/files/file?fileId=' + selectedFile.id + '&checkingOut=false&attachment=false&jwtToken=' + jwtToken);

                $scope.fileURL = $sce.trustAsResourceUrl('https://docs.google.com/gview?url=' + encodedURI + '&embedded=true');

            }
        }

        $scope.noOfNewAttributes = 0;
        $scope.addNewAttribute = function() {
            var newAttribute = {
                name: 'Enter name',
                value: 'Enter value'
            }
            //Replacing all spaces with underscore in "label" and use it as "name"
            //newAttribute.name = newAttribute.label.replace(/ /g,"_");
            //siteDocLibCtrl.fileAttributes[newAttribute.key] = newAttribute.value;
            siteDocLibCtrl.fileAttributes.push(newAttribute);
            $scope.noOfNewAttributes++;
        };
        siteDocLibCtrl.folderSettingDialog = function(ev){            $mdDialog.show({
                controller: folderSettingDialogController,
                templateUrl: 'app/main/sites/site/doclibrary/folderSettingDialog.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: $scope.customFullscreen
            })

        }

        function folderSettingDialogController($scope) {            
             $scope.currentFile = angular.copy(siteDocLibCtrl.receivedFile);
              $scope.folder=$scope.currentFile;
              $scope.cancel = function() {
                $mdDialog.cancel();                     
                }
            $scope.FolderUpdate =function(folder){
             RestAPIService.FoldersOnly(siteId,$scope.currentFile).then(
                 function(success) {
                      RestAPIService.successTostDialog("Folder Settings Updated successfully ");
                     siteDocLibCtrl.getFiles();
                 },
                 function(error) {
                     RestAPIService.showErrorDialog(error);
                 }
             );
             $mdDialog.hide();
         
            }

        }



        siteDocLibCtrl.allUsers = [];

        siteDocLibCtrl.managePermissionsDialog = function(ev) {
            $mdDialog.show({
                controller: managePermissionsDialogController,
                templateUrl: 'app/main/sites/site/doclibrary/managePermissionsDialog.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: $scope.customFullscreen
            })
        }

        function managePermissionsDialogController($scope) {
             $scope.currentFile = angular.copy(siteDocLibCtrl.receivedFile);
            var siteId = "site-2";
           $scope.permissionType = $scope.currentFile.permissionType;
           if($scope.permissionType == "Inherited"){
               $scope.filePermissionType = true;
           }
            $scope.allUsersForPermission = [];

            // $scope.getPermission = function() {
            //     RestAPIService.getFilePermissions(siteId, "1000223").then(
            //         function(response) {
            //             $scope.allUsersForPermission = response.data;
            //         },
            //         function(error) {
            //             RestAPIService.showErrorDialog(error);
            //         });
            // }

            $scope.selectedFileName = siteDocLibCtrl.selectedFileName;

            $scope.searchElements = {
                type: 'User'
            };

            $scope.searchUsersForManagePermission = function(elements) {
                $scope.searchedUsers = {};
                RestAPIService.searchUsers(elements).then(
                    function(response) {
                        if (response.data[0].length > 0) {
                            $scope.searchedUsers.data = response.data[0];
                            $scope.searchedUsers.type = elements.type;
                        }
                    },
                    function(error) {
                        RestAPIService.showErrorDialog(error);
                    });
            }

            $scope.addUserForManagePermission = function(memberData, status, type) {
                var json = {};
                json.type = type;
                
                if (status != undefined) {
                    var keys = Object.keys(status);
                    var filtered = keys.filter(function(key) {
                        return status[key]
                    });
                    json.permissions = filtered;
                } else {
                    json.permissions = [];
                }
                if (type == 'User' || type == 'Group') {
                    json.fileId = siteDocLibCtrl.selectedFile.id;
                    if (type == 'User') {
                        json.email = memberData.email;
                        json.lastName = memberData.lastName;
                        json.firstName = memberData.firstName;
                        json.id = memberData.login;
                    } else {
                        json.id = memberData.id;
                        json.firstName = memberData.name;
                    }
                } else if (type == 'Owner' || type == 'SiteAdmin') {
                    json.id = type;
                    json.fileId = siteDocLibCtrl.selectedFile.id;
                    json.firstName = type;
                }
                if ($scope.allUsersForPermission.length > 0) {
                    if (type == 'User' || type == 'Group') {
                        var temp = false;
                        for (var i = 0; i < $scope.allUsersForPermission.length; i++) {
                            if ($scope.allUsersForPermission[i].id === json.id) {
                                $scope.allUsersForPermission.splice(i, 1)
                                $scope.allUsersForPermission.splice(i, 0, json);
                                temp = true;
                                break;
                            }
                        }
                        if (!temp) {
                            $scope.allUsersForPermission.push(json);
                        }
                    } else if (type == 'Owner' || type == 'SiteAdmin') {
                        var temp = false;
                        for (var i = 0; i < $scope.allUsersForPermission.length; i++) {
                            if ($scope.allUsersForPermission[i].type === type) {
                                $scope.allUsersForPermission.splice(i, 1)
                                $scope.allUsersForPermission.splice(i, 0, json);
                                temp = true;
                                break;
                            }
                        }
                        if (!temp) {
                            $scope.allUsersForPermission.push(json);
                        }
                    }
                } else {
                    $scope.allUsersForPermission.push(json);
                }
            }

            $scope.removePermission = function(user) {
                if (user.type == 'User' || user.type == 'Group') {
                    for (var i = 0; i < $scope.allUsersForPermission.length; i++) {
                        if ($scope.allUsersForPermission[i].id === user.id) {
                            $scope.allUsersForPermission.splice(i, 1)
                            break;
                        }
                    }
                } else if (user.type == 'Owner' || user.type == 'SiteAdmin') {
                    for (var i = 0; i < $scope.allUsersForPermission.length; i++) {
                        if ($scope.allUsersForPermission[i].type === user.type) {
                            $scope.allUsersForPermission.splice(i, 1)
                            break;
                        }
                    }
                }
            }
            
            $scope.onChangePermissionType = function(type) {
                if (type == 'Owner' || type == 'SiteAdmin') {
                    $scope.ownerStatus = {};            
                     for (var i = 0; i < $scope.allUsersForPermission.length; i++) {
                         if ($scope.allUsersForPermission[i].type === type) {
                             for (var key in $scope.allUsersForPermission[i].permissions) {
                                 $scope.ownerStatus[$scope.allUsersForPermission[i].permissions[key]] = true;
                             }
                             break;
                         }
                     }
                }    
                $scope.searchedUsers = {};                
                $scope.searchElements.text = null;
            }

            $scope.cancel = function() {
                $mdDialog.cancel();
            }

            $scope.saveUserManagePermission = function(filePermissionType) {
                    if($scope.filePermissionType == true){
                    RestAPIService.setInherited(siteId, siteDocLibCtrl.selectedFile.id).then(
                            function(response) {
                                RestAPIService.successTostDialog("Permissions Inherited successfully");
                                $mdDialog.cancel();
                            },
                            function(error) {
                                RestAPIService.showErrorDialog(error);
                            });
                    
                }else{
                    RestAPIService.updateFilePermission(siteId, siteDocLibCtrl.selectedFile.id, $scope.allUsersForPermission).then(
                            function(response) {
                                RestAPIService.successTostDialog("Permissions updated successfully");
                                $mdDialog.cancel();
                            },
                            function(error) {
                                RestAPIService.showErrorDialog(error);
                            });
                    
                }
                
            }
        }

        siteDocLibCtrl.allSharedUsers = [];
        siteDocLibCtrl.sharedUsersDialog = function(ev) {
            $mdDialog.show({
                controller: sharedUsersDialogController,
                templateUrl: 'app/main/sites/site/doclibrary/sharedUsersDialog.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: $scope.customFullscreen
            })

        }

        function sharedUsersDialogController($scope) {

            $scope.getPermission = function() {
                RestAPIService.getPermission(siteDocLibCtrl.selectedFile.id).then(
                    function(response) {
                        $scope.allSharedUsers = response.data;

                    },
                    function(error) {
                        RestAPIService.showErrorDialog(error);
                    }
                );

            }
            //$scope.allSharedUsers = siteDocLibCtrl.allSharedUsers;
            $scope.selectedFileName = siteDocLibCtrl.selectedFileName;

            $scope.myDate = new Date('9999-12-31T03:24:00');
            $scope.isOpen = false;

            $scope.searchElements = {
                type: 'user'
            };

            $scope.searchUsers = function(elements) {
                $scope.searchedUsers = {};
                RestAPIService.searchUsers(elements).then(
                    function(response) {
                        if (response.data[0].length > 0) {
                            $scope.searchedUsers.data = response.data[0];
                            $scope.searchedUsers.type = elements.type;
                        }
                    },
                    function(error) {
                        RestAPIService.showErrorDialog(error);
                    });
            }
            siteDocLibCtrl.permission = {};

            $scope.shareFile = function(memberData, status, myDate, type) {
                var keys = Object.keys(status);
                var filtered = keys.filter(function(key) {
                    return status[key]
                });
                siteDocLibCtrl.permission.fileId = siteDocLibCtrl.selectedFile.id;
                if (type == 'user') {
                    siteDocLibCtrl.permission.userId = memberData.login;
                } else {
                    siteDocLibCtrl.permission.groupId = memberData.id;
                }

                siteDocLibCtrl.permission.permissions = filtered;
                siteDocLibCtrl.permission.expirydate = myDate;

                RestAPIService.Filepermission(siteDocLibCtrl.permission).then(
                    function(response) {
                        $scope.getPermission();
                    },
                    function(error) {
                        RestAPIService.showErrorDialog(error);
                    });

                $scope.allSharedUsers.push(memberData);
            }

            $scope.removeSharing = function(userId) {

                RestAPIService.Removepermission(userId).then(
                    function(response) {
                        $scope.getPermission();
                    },
                    function(error) {
                        RestAPIService.showErrorDialog(error);
                    }
                );
            }

            $scope.cancel = function() {
                $mdDialog.cancel();
            }
            $scope.updateFileSharing = function() {
                RestAPIService.successTostDialog("Shared Document Sent For Approval ");
                $mdDialog.cancel();
            }
            $scope.fileAttributes = siteDocLibCtrl.fileAttributes;
            $scope.selectedFileName = siteDocLibCtrl.selectedFileName;
            /* $scope.updateFileSharing = function(){
                 //building the PUT object manually,i.e.JSON structure
                 //because only share and attributes are editable 
                 $scope.fileSharingObject = {};
                 $scope.fileSharingObject.id = siteDocLibCtrl.selectedFile.id;
                 //Appending dynamic file attributes
                 $scope.fileSharingObject.attributes = $scope.fileAttributes;

                 //Appending the versions and activities AS IT IS-without any change
                 $scope.fileSharingObject.versions = siteDocLibCtrl.selectedFile.versions;
                 $scope.fileSharingObject.activities = siteDocLibCtrl.selectedFile.activities;
                 //Updating the shared user object
                 $scope.fileSharingObject.users = $scope.allSharedUsers; 

                 //alert(JSON.stringify($scope.fileAttributesObject));
                 RestAPIService.updateFileAttrAndSharing(siteId,$scope.fileSharingObject).then(
                     function(response){
                        //$state.reload();
                        //reloading is a bad UI experience.Hence calling GET again
                        RestAPIService.successTostDialog("Fie shared successfully ");
                        siteDocLibCtrl.getAttributes(siteDocLibCtrl.selectedFile.id);
                        $mdDialog.hide();
                     },
                     function(error){
                         RestAPIService.showErrorDialog(error);
                     });

             }*/
        }



        siteDocLibCtrl.doubleClick = function(file) {           
            $scope.permissions= [];
           // $scope.permissions =siteDocLibCtrl.filePermissions.permissions;
           /* if($scope.permissions.length>0){
            if($scope.permissions.indexOf("Edit") >= -1){
                    $scope.hide =false;
                    }
            }
            else{
                $scope.hide =true;
            }*/

            
            if (file.type == 'file') return;
            $scope.detailsVisibility = false;
            siteDocLibCtrl.pageNumber = 0;
            siteDocLibCtrl.currentFolderId = file.id;
            $scope.filePath.push(file);
            siteDocLibCtrl.getFiles();
            if ($scope.filePath.length > 1) {
                $scope.filePathVisibility = true;
            }

        };
        siteDocLibCtrl.gotoFolder = function(folder) {
            //Get the content of that specific folderz
            siteDocLibCtrl.doubleClick(folder);

            //Delete the intermediate folder links that come after selected folder
            var currentPath = $scope.filePath;
            var i;
            for (i = 0; i < currentPath.length; i++) {
                if (currentPath[i].id == folder.id) {
                    $scope.filePath.splice(i + 1, (currentPath.length - i + 1));
                    break;
                }
            }
            if ($scope.filePath.length == 1) {
                $scope.filePathVisibility = false;
            }
        }

        siteDocLibCtrl.currentFile = {};
        $scope.UpdateFile = function(ev) {
            siteDocLibCtrl.currentFile = angular.copy(siteDocLibCtrl.receivedFile);
            siteDocLibCtrl.name = siteDocLibCtrl.currentFile.name;
            siteDocLibCtrl.id = siteDocLibCtrl.currentFile.id;
            $mdDialog.show({
                controller: UpdateFileDialogController,
                templateUrl: 'app/main/sites/site/doclibrary/editFiledialog.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: $scope.customFullscreen,

            })


        };

        function UpdateFileDialogController($scope, $mdDialog) {

            $scope.currentFile = siteDocLibCtrl.currentFile;

            $scope.hide = function() {
                $mdDialog.hide();
            };
            $scope.cancel = function() {
                $mdDialog.cancel();
            };
            $scope.updateFile = function(file) {
                RestAPIService.updateFile(siteId, file).then(
                    function(success) {
                        //Update successful. Need to refresh
                        //$state.reload();
                        //Reload is bad UI experience, hence executing GET again
                        RestAPIService.successTostDialog("File renamed successfully ");
                        siteDocLibCtrl.getFiles();
                    },
                    function(error) {
                        RestAPIService.showErrorDialog(error);
                    }
                );
                $mdDialog.hide(file);
            };
        }



        siteDocLibCtrl.VersionFile = {};
        $scope.VersionFileDialog = function(ev, file) {
            siteDocLibCtrl.VersionFile = angular.copy(file);
            $mdDialog.show({
                controller: VersionFileDialogController,
                templateUrl: 'app/main/sites/site/doclibrary/VersionFiledialog.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: $scope.customFullscreen,

            })

        };

        function VersionFileDialogController($scope, $mdDialog) {
            $scope.VersionFile = siteDocLibCtrl.VersionFile;
            $scope.selectedFileName = siteDocLibCtrl.selectedFileName;
            var formData = new FormData();
            $scope.setFile = function(element) {
                $scope.$apply(function() {
                    $scope.files = [];
                    for (var i = 0; i < element.files.length; i++) {
                        formData.append('file', element.files[i]);
                        $scope.files.push(element.files[i]);
                    }
                });
            };
            $scope.hide = function() {
                $mdDialog.hide();
            };
            $scope.cancel = function() {
                $mdDialog.cancel();
            };
            $scope.NewVersionFile = function() {
                //alert(JSON.stringify(checkInfile));
                RestAPIService.NewVersionFile(siteId, $scope.files[0], siteDocLibCtrl.VersionFile).then(
                    function(success) {

                        //        //Update successful. Need to refresh
                        //$state.reload();
                        //Update the file attribute section. Calling get again
                        //reloading is a bad UI experience.Hence calling GET again
                        RestAPIService.successTostDialog("New version added successfully");
                        siteDocLibCtrl.getAttributes(siteDocLibCtrl.selectedFile.id);
                    },
                    function(error) {
                        // RestAPIService.showErrorDialog(error);
                        $mdDialog.show(
                            $mdDialog.alert()
                            .clickOutsideToClose(true)
                            .title('Error')
                            .textContent(error.data.description)
                            .ok('Ok')
                        );
                    }
                );
                $mdDialog.hide();
            };
        }
        siteDocLibCtrl.checkInFile = {};
        $scope.checkInFileDialog = function(ev) {
            siteDocLibCtrl.checkInFile = angular.copy(siteDocLibCtrl.receivedFile);
            $mdDialog.show({
                controller: CheckInFileDialogController,
                templateUrl: 'app/main/sites/site/doclibrary/checkInFiledialog.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: $scope.customFullscreen,
            })
        };

        function CheckInFileDialogController($scope, $mdDialog) {
            $scope.checkInFile = siteDocLibCtrl.checkInFile;
            var formData = new FormData();
            $scope.setFile = function(element) {
                $scope.$apply(function() {
                    $scope.files = [];
                    for (var i = 0; i < element.files.length; i++) {
                        formData.append('file', element.files[i]);
                        $scope.files.push(element.files[i]);
                    }
                });
            };
            $scope.hide = function() {
                $mdDialog.hide();
            };
            $scope.cancel = function() {
                $mdDialog.cancel();
            };
            $scope.checkIn = function() {
                 $rootScope.loadingProgress = true;
                //alert(JSON.stringify(checkInfile));
                RestAPIService.checkIn(siteId, $scope.files[0], siteDocLibCtrl.checkInFile, siteDocLibCtrl.currentFolderId).then(
                    function(success) {
                         $rootScope.loadingProgress = false;
                        /*  alert("checkIn Success");*/
                        siteDocLibCtrl.getFiles();
                        RestAPIService.successTostDialog("CheckIn Document Sent  For Approval ");
                        // $mdDialog.show(
                        //         $mdDialog.alert()
                        //         .clickOutsideToClose(true)
                        //         .title('Success!')
                        //         .textContent('File checked in successfully')
                        //         .ok('Ok')
                        //     );
                    },
                    function(error) {
                        $mdDialog.show(
                            $mdDialog.alert()
                            .clickOutsideToClose(true)
                            .title('Error')
                            .textContent(error.data.description)
                            .ok('Ok')
                        );
                    }
                );
                $mdDialog.hide();
            };
        }
        siteDocLibCtrl.deleteFile = function(ev, file) {
            var fileId = siteDocLibCtrl.receivedFile.id;
            var confirm = $mdDialog.confirm()
                .title('Remove')
                .textContent('File ' + siteDocLibCtrl.receivedFile.name + ' will be permanently deleted. Continue ?')
                .targetEvent(ev)
                .ok('Ok')
                .cancel('Cancel');
            $mdDialog.show(confirm).then(function() {
                RestAPIService.deleteFile(siteId, fileId).then(
                    function(success) {
                        //delete successful. Need to refresh
                        RestAPIService.successTostDialog("File deleted successfully");
                        // Making the Attributes, versions, activities and shared users as  empty when a file was deleted.
                        $scope.file = {};
                        siteDocLibCtrl.fileAttributes = {};
                        siteDocLibCtrl.allSharedUsers = {};
                        // Show the <div> consisting of " Select a file or folder to view its details."
                        $scope.detailsVisibility = false;
                        //$state.reload();
                        //Reload is bad UI experience, hence executing GET again
                        siteDocLibCtrl.getFiles();
                    },
                    function(error) {
                        RestAPIService.showErrorDialog(error);
                    }
                );
            }, function() {
                $mdDialog.cancel();
            });
        }

        $scope.buildForm = function(fileId) {

            console.log("$scope.businessObjectName : ", $scope.businessObjectName)

            $state.go('app.doclibraryForm', {
                'siteId': siteId,
                'fileId': fileId,
                'businessObject': $scope.businessObjectName
            });
        };

        $scope.downloadFile = function() {
            var fileId = siteDocLibCtrl.receivedFile.id;
            RestAPIService.downloadFile(siteId, fileId).then(
                function(success) {
                    var headers = success.headers();
                    //alert(JSON.stringify(headers));
                    var data = success.data;
                    //alert(data);
                    //var filename = headers['x-filename'];
                    var filename = siteDocLibCtrl.selectedFileName;
                    var contentType = headers['content-type'];
                    var linkElement = document.createElement('a');
                    try {
                        var blob = new Blob([data], {
                            type: contentType
                        });
                        var url = window.URL.createObjectURL(blob);
                        linkElement.setAttribute('href', url);
                        linkElement.setAttribute("download", filename);
                        var clickEvent = new MouseEvent("click", {
                            "view": window,
                            "bubbles": true,
                            "cancelable": false
                        });
                        linkElement.dispatchEvent(clickEvent);
                    } catch (ex) {
                        console.log(ex);
                    }
                    RestAPIService.successTostDialog("File downloaded successfully");
                },
                function(error) {
                    console.log('ERROR Downloading the file ********');
                    RestAPIService.showErrorDialog(error);
                }
            );
        }
        $scope.downloadVersionedFile = function(fileId, versionNo) {
            RestAPIService.downloadVersionedFile(siteId, fileId, versionNo).then(
                function(success) {
                    var headers = success.headers();
                    var data = success.data;
                    var filename = siteDocLibCtrl.selectedFileName;
                    var contentType = headers['content-type'];
                    var linkElement = document.createElement('a');
                    try {
                        var blob = new Blob([data], {
                            type: contentType
                        });
                        var url = window.URL.createObjectURL(blob);
                        linkElement.setAttribute('href', url);
                        linkElement.setAttribute("download", filename);
                        var clickEvent = new MouseEvent("click", {
                            "view": window,
                            "bubbles": true,
                            "cancelable": false
                        });
                        linkElement.dispatchEvent(clickEvent);
                    } catch (ex) {
                        console.log(ex);
                    }
                },
                function(error) {
                    console.log('ERROR Downloading the file ********');
                    RestAPIService.showErrorDialog(error);
                }
            );
        }
        $scope.fileCheckout = function() {
            var fileId = siteDocLibCtrl.receivedFile.id;
            RestAPIService.fileCheckout(siteId, fileId).then(
                function(success) {
                    console.log(success);
                    siteDocLibCtrl.getFiles();
                    var headers = success.headers();
                    var data = success.data;
                    var filename = siteDocLibCtrl.selectedFileName;
                    var contentType = headers['content-type'];
                    var linkElement = document.createElement('a');
                    try {
                        var blob = new Blob([data], {
                            type: contentType
                        });
                        var url = window.URL.createObjectURL(blob);
                        linkElement.setAttribute('href', url);
                        linkElement.setAttribute("download", filename);
                        var clickEvent = new MouseEvent("click", {
                            "view": window,
                            "bubbles": true,
                            "cancelable": false
                        });
                        linkElement.dispatchEvent(clickEvent);
                    } catch (ex) {
                        console.log(ex);
                    }
                    RestAPIService.successTostDialog("File checked out successfully ");
                },
                function(error) {
                    console.log('ERROR Downloading the file ********');
                    //RestAPIService.showErrorDialog(error);  
                    $mdDialog.show(
                        $mdDialog.alert()
                        .clickOutsideToClose(true)
                        .title('Error')
                        .textContent('The file has been already checked out')
                        .ok('Ok')
                    );

                }
            );
        }
        $scope.createFile = function(ev) {
            $mdDialog.show({
                controller: CreateFileDialogController,
                templateUrl: 'app/main/sites/site/doclibrary/upload.doclibrary.dialog.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: $scope.customFullscreen
            })
        };

        function CreateFileDialogController($scope, $http, RestAPIService, $mdDialog, $state, $window) {            
            
                
            //$scope.filepermission = siteDocLibCtrl.filepermission.foldersOnly;
            if(siteDocLibCtrl.currentFolderId != ''){
                $scope.filepermission = false;
            }
            /*if(siteDocLibCtrl.receivedFile){
            $scope.foldersOnly =siteDocLibCtrl.receivedFile.foldersOnly;            
            }*/
            var formData = new FormData();
            $scope.setFile = function(element) {
                $scope.$apply(function() {
                    $scope.files = [];
                    for (var i = 0; i < element.files.length; i++) {
                        formData.append('file', element.files[i]);
                        $scope.files.push(element.files[i]);
                    }
                });
            };

            $scope.hide = function() {
                $mdDialog.hide();
            };

            $scope.template = {};
            $scope.create = {};
            $scope.create['documentType'] = ""
            $scope.createFiledocTypeJson = {};
            $scope.documentType = {};
            $scope.documentTypeName = "";
            $scope.documentTypeCreate = {};
            $scope.attributeObjects = [];
            $scope.selectDocumentType = function(documentType) {
                RestAPIService.getDocumentTypeAttributes(documentType.id).then(function(responce) {
                        $scope.attributeObjects = responce.data.attributes;
                        $scope.documentTypeName = documentType.name

                        if (responce.data.attributes == null) {
                            alert("No Attributes for selected DocumentType");
                        }
                    },
                    function(error) {
                        RestAPIService.showErrorDialog(error);
                    })
            }

            $scope.selectDocumentTemplate = function(documentTemplate) {
                $scope.createDocumenttype = "";
                $scope.templateList.forEach(function(template) {
                    if (template.name == documentTemplate) {
                        $scope.createDocumenttype = template.documentType;
                        $scope.create.documentType = template.documentType;
                    }
                });

                $scope.documentsList.forEach(function(documentType) {
                    if (documentType.name == $scope.createDocumenttype) {
                        $scope.DocTypeattributeObjects = documentType.attributes;
                    }
                })
            }

            $scope.getDocumentTypes = function() {
                RestAPIService.getDocumentTypes().then(
                    function(success) {
                        $scope.newDocumentType = [];

                        $scope.documentsList = success.data;
                        $scope.documentsList.forEach(function(documentType) {
                            if (documentType.approvalRequired == true && documentType.docuemntApprovalConfig !== null) {
                                //if(documentType.docuemntApprovalConfig !==null){
                                if (documentType.docuemntApprovalConfig.agents)
                                    $scope.newDocumentType.push(documentType);
                            }
                            //}
                            else if (documentType.approvalRequired == false) {
                                $scope.newDocumentType.push(documentType);
                            } else {
                                return;
                            }

                        })
                    },
                    function(error) {
                        RestAPIService.showErrorDialog(error);
                    }
                );
            }

            $scope.getDocumentTemplate = function() {
                RestAPIService.getDocumentTemplate().then(
                    function(success) {
                        $scope.templateList = success.data;
                    },
                    function(error) {
                        RestAPIService.showErrorDialog(error);
                    }
                );
            }

            $scope.cancel = function() {
                $mdDialog.cancel();
            };

            $scope.attributeObject = {};
            $scope.documentTypeJson = {};
            $scope.uploadFile = function(ev, folderName, description, documentTypeName, documentTypeJson) {            
                $rootScope.loadingProgress = true;
                $scope.documentTypeJson['documentType'] = documentTypeName;
                $scope.documentTypeJson['attributes'] = {};
                $scope.attributeObjects.forEach(function(attribute) {
                    $scope.documentTypeJson.attributes[attribute.name] = attribute.Value;
                });
                var files = $scope.files;
                if (files == undefined && folderName == undefined) {
                    $scope.ErrorMsg = "Please upload a file or create new folder"
                }
                if (undefined != files) {
                    /*  var file = files[Object.keys(files)[0]];
                      if (file.size > 100 * 1024 * 1024) {
                          alert("Too large File. Only File smaller than 100MB can be uploaded.");
                          return false;
                      }*/
                    RestAPIService.uploadFile(siteId, description, $scope.files[0], siteDocLibCtrl.currentFolderId, $scope.documentTypeJson).then(
                        function(success) {
                            //alert(JSON.stringify($scope.documentTypeJson));
                            $rootScope.loadingProgress = false;
                            RestAPIService.successTostDialog("Document Sent For Approval ");
                            siteDocLibCtrl.getFiles();
                        },
                        function(error) {
                            RestAPIService.showErrorDialog(error);
                        }
                    );
                    $mdDialog.hide(ev);
                }
                if (undefined != folderName) {
                    RestAPIService.createFolder(siteId,description, folderName, siteDocLibCtrl.currentFolderId).then(
                        function(success) {
                            $rootScope.loadingProgress = false;
                            RestAPIService.successTostDialog("Folder created successfully ");
                            siteDocLibCtrl.getFiles();
                            $mdDialog.hide(ev);
                        },
                        function(error) {
                            if (error) {
                                RestAPIService.successTostDialog(error.data.description);
                                return;
                            }
                        }
                    );

                }
            }

            $scope.createTemplateFile = function(ev, name, description, documentType, template) {
                $scope.templateName = template;
                $scope.createFiledocTypeJson['documentType'] = documentType;
                $scope.createFiledocTypeJson['attributes'] = {};
                $scope.DocTypeattributeObjects.forEach(function(attribute) {
                    $scope.createFiledocTypeJson.attributes[attribute.name] = attribute.Value;
                });
                RestAPIService.createTemplateFile(siteId, siteDocLibCtrl.currentFolderId, $scope.createFiledocTypeJson, $scope.templateName, name).then(
                    function(success) {
                        RestAPIService.successTostDialog("Created successfully ");
                        siteDocLibCtrl.getFiles();
                    },
                    function(error) {
                        RestAPIService.showErrorDialog(error);
                    }
                );
                $mdDialog.hide(ev);
            }
        }
    }
})();
(function ()
{
    'use strict';
    angular
        .module('app.sites')
        .controller('SitesForumController', SitesForumController);
          function SitesForumController( $http, $scope,$mdDialog)
    {
      var siteForumCtrl =this;
      var imagePath = 'img/list/60.jpeg';
      $scope.openthread = function(threadData){
        $scope.selectedThread = threadData;
        $scope.commentsVisibility = true;
      }
      $scope.userComment = 'Enter comment here ...';
      $scope.opencategory = function(searchCategory){
        $scope.searchCategory = searchCategory;
        $scope.commentsVisibility = false;
      }
      $scope.createThreadDialog = function(ev) {
              $mdDialog.show({
                  controller: CreateThreadDialogController,
                  templateUrl: 'app/main/sites/site/discussionforum/create.thread.html',
                  parent: angular.element(document.body),
                  targetEvent: ev,
                  clickOutsideToClose:true,
                  fullscreen: $scope.customFullscreen 
              })

              $scope.cancel = function(){    
              };   
        };
        function CreateThreadDialogController($scope, $mdDialog) {
           
            $scope.hide = function() {
              $mdDialog.hide();
            };
            $scope.cancel = function() {     
              $mdDialog.cancel();
            };
          };

      siteForumCtrl.getAnotherColor =  function(index){
          siteForumCtrl.colors = ['red','pink','purple','deep-purple','indigo','blue', 'light-blue','cyan', 'teal','green',
                      'light-green','lime','yellow','amber','deep-orange','brown','grey','blue-grey'];
          var totalNoOfColors = siteForumCtrl.colors.length;                        
          return siteForumCtrl.colors[index%totalNoOfColors];
      }

  
       $scope.Searchcategory={};
       $scope.Threads = [
          {
            face:imagePath,
            Threadid : "1",
            Threadname : "Need to add user in the threaddd with namee",
            Creator : "James",
            Category: "Music",
            Comments :[
            {
              Commenter:"james",
              Commentedon:"April 2017",
              Comment:"dhhhasjkjjjjhkhabbvbcvjhdghbbbbbbbbbbbgdhfkgkggjggghhhhhhhhjgehduwjiejfeifhuefhoehfuehfue",
            },
            {
              Commenter:"john",
              Commentedon:"April 2017",
              Comment:"dhhhasjfffffffffffsddsssssskjjjjhkhabbvbcvjhdghehduwjiejfeifhuefhoehfuehfue"
            },
            {
              Commenter:"john",
              Commentedon:"March 2017",
              Comment:"dhhhasjfffffffffffsddsssssskjjjjhkhabbvbcvjhdghehduwjiejfeifhuefhoehfuehfue"
            },
            {
              Commenter:"smit",
              Commentedon:"March 2017",
              Comment:"dhhhasjkjjjjhkhabbvfdddddddddddbcvjhdghehduwjiejfeifhuefhoehfuehfue"
            }],
          },
          {
           Threadid: "2",
           Threadname : "Need to change user need to chnage",
           Creator : "John",
           Category: "web design",
           Comments :[
            {
              Commenter:"james",
              Commentedon:"April 2017",
              Comment:"dhhhasjkjjjjhkhabbvbcvjhdghehduwjiejfeifhuefhoehfuehfue"
            },
            {
              Commenter:"john",
              Commentedon:"April 2017",
              Comment:"dhhhasjfffffffffffsddsssssskjjjjhkhabbvbcvjhdghehduwjiejfeifhuefhoehfuehfue"
            },
            {
              Commenter:"john",
              Commentedon:"April 2017",
              Comment:"dhhhasjfffffffffffsddsssssskjjjjhkhabbvbcvjhdghehduwjiejfeifhuefhoehfuehfue"
            },
            {
              Commenter:"johnhh",
              Commentedon:"April 2017",
              Comment:"dhhhasjfffffffffffsddsssssskjjjjhkhabbvbcvjhdghehduwjiejfeifhuefhoehfuehfue"
            },
            {
              Commenter:"smit",
              Commentedon:"April 2017",
              Comment:"dhhhasjkjjjjhkhabbvfdddddddddddbcvjhdghehduwjiejfeifhuefhoehfuehfue"
            }],
          },
          {
           Threadid: "3",
           Threadname : "security changes security changes  security",
           Creator : "smit",
           Category: "Great designs",
           Comments :[
            {
              Commenter:"james",
              Commentedon:"March 2017",
              Comment:"dhhhasjkjjjjhkhabbvbcvjhdghehduwjiejfeifhuefhoehfuehfue"
            },
            {
              Commenter:"john",
              Commentedon:"March 2017",
              Comment:"dhhhasjfffffffffffsddsssssskjjjjhkhabbvbcvjhdghehduwjiejfeifhuefhoehfuehfue"
            },
            {
              Commenter:"john",
              Commentedon:"March 2017",
              Comment:"dhhhasjfffffffffffsddsssssskjjjjhkhabbvbcvjhdghehduwjiejfeifhuefhoehfuehfue"
            },
            {
              Commenter:"smit",
              Commentedon:"March 2017",
              Comment:"dhhhasjkjjjjhkhabbvfdddddddddddbcvjhdghehduwjiejfeifhuefhoehfuehfue"
            }],
          },
          {
           Threadid: "4",
           Threadname : "security vendors new security  addddding",
           Creator : "sss",
           Category: "General Discussions",
           Comments :[
            {
              Commenter:"james",
              Commentedon:"March 2017",
              Comment:"dhhhasjkjjjjhkhabbvbcvjhdghehduwjiejfeifhuefhoehfuehfue"
            },
            {
              Commenter:"john",
              Commentedon:"March 2017",
              Comment:"dhhhasjfffffffffffsddsssssskjjjjhkhabbvbcvjhdghehduwjiejfeifhuefhoehfuehfue"
            },
            {
              Commenter:"john",
              Commentedon:"March 2017",
              Comment:"dhhhasjfffffffffffsddsssssskjjjjhkhabbvbcvjhdghehduwjiejfeifhuefhoehfuehfue"
            },
            {
              Commenter:"smit",
              Commentedon:"March 2017",
              Comment:"dhhhasjkjjjjhkhabbvfdddddddddddbcvjhdghehduwjiejfeifhuefhoehfuehfue"
            }],
          },
          {
           Threadid: "5",
           Threadname : "security vendors ddddd security vendors new security vendors",
           Creator : "new user",
           Category: "Graphic design",
           Comments :[
            {
              Commenter:"james",
              Commentedon:"April 2017",
              Comment:"dhhhasjkjjjjhkhabbvbcvjhdghehduwjiejfeifhuefhoehfuehfue"
            },
            {
              Commenter:"john",
              Commentedon:"April 2017",
              Comment:"dhhhasjfffffffffffsddsssssskjjjjhkhabbvbcvjhdghehduwjiejfeifhuefhoehfuehfue"
            },
            {
              Commenter:"john",
              Commentedon:"April 2017",
              Comment:"dhhhasjfffffffffffsddsssssskjjjjhkhabbvbcvjhdghehduwjiejfeifhuefhoehfuehfue"
            },
            {
              Commenter:"smit",
              Commentedon:"April 2017",
              Comment:"dhhhasjkjjjjhkhabbvfdddddddddddbcvjhdghehduwjiejfeifhuefhoehfuehfue"
            }], 
          },
          {
           Threadid: "6",
           Threadname : "security vendors ddddd security vendors new security",
           Creator : "gggg",
           Category: "General forum designs",
           Comments :[
            {
              Commenter:"james",
              Commentedon:"April 2017",
              Comment:"dhhhasjkjjjjhkhabbvbcvjhdghehduwjiejfeifhuefhoehfuehfue"
            },
            {
              Commenter:"john",
              Commentedon:"April 2017",
              Comment:"dhhhasjfffffffffffsddsssssskjjjjhkhabbvbcvjhdghehduwjiejfeifhuefhoehfuehfue"
            },
            {
              Commenter:"john",
              Commentedon:"April 2017",
              Comment:"dhhhasjfffffffffffsddsssssskjjjjhkhabbvbcvjhdghehduwjiejfeifhuefhoehfuehfue"
            },
            {
              Commenter:"smit",
              Commentedon:"April 2017",
              Comment:"dhhhasjkjjjjhkhabbvfdddddddddddbcvjhdghehduwjiejfeifhuefhoehfuehfue"
            }],
          },
          {
           Threadid: "7",
           Threadname : "securicty vendors ddddd security",
           Creator : "gggcg",
           Category: "Event designs",
           Comments :[
            {
              Commenter:"james",
              Commentedon:"April 2017",
              Comment:"dhhhasjkjjjjhkhabbvbcvjhdghehduwjiejfeifhuefhoehfuehfue"
            },
            {
              Commenter:"john",
              Commentedon:"April 2017",
              Comment:"dhhhasjfffffffffffsddsssssskjjjjhkhabbvbcvjhdghehduwjiejfeifhuefhoehfuehfue"
            },
            {
              Commenter:"john",
              Commentedon:"April 2017",
              Comment:"dhhhasjfffffffffffsddsssssskjjjjhkhabbvbcvjhdghehduwjiejfeifhuefhoehfuehfue"
            },
            {
              Commenter:"smit",
              Commentedon:"April 2017",
              Comment:"dhhhasjkjjjjhkhabbvfdddddddddddbcvjhdghehduwjiejfeifhuefhoehfuehfue"
            }],
          },
          {
           Threadid: "8",
           Threadname : "securicty vendors security",
           Creator : "gdg",
           Category: "Tech designs",
           Comments :[
            {
              Commenter:"james",
              Commentedon:"April 2017",
              Comment:"dhhhasjkjjjjhkhabbvbcvjhdghehduwjiejfeifhuefhoehfuehfue"
            },
            {
              Commenter:"john",
              Commentedon:"April 2017",
              Comment:"dhhhasjfffffffffffsddsssssskjjjjhkhabbvbcvjhdghehduwjiejfeifhuefhoehfuehfue"
            },
            {
              Commenter:"john",
              Commentedon:"April 2017",
              Comment:"dhhhasjfffffffffffsddsssssskjjjjhkhabbvbcvjhdghehduwjiejfeifhuefhoehfuehfue"
            },
            {
              Commenter:"johnb",
              Commentedon:"April 2017",
              Comment:"dhhhasjfffffffffffsddsssssskjjjjhkhabbvbcvjhdghehduwjiejfeifhuefhoehfuehfue"
            },
            {
              Commenter:"smit",
              Commentedon:"April 2017",
              Comment:"dhhhasjkjjjjhkhabbvfdddddddddddbcvjhdghehduwjiejfeifhuefhoehfuehfue"
            }],
          }
        ];
    }         
})();



      
        

    
 
(function ()
{
    'use strict';

    angular
        .module('app.sites')
        .controller('SitesDashboardController', SitesDashboardController);

    /** @ngInject */
    function SitesDashboardController($scope, Members,Sites,CurrentSiteId, $stateParams, CurrentSiteName, CurrentSitePage)
    {
        var siteDashCtrl = this;
        var siteId = $stateParams.siteId;
        siteDashCtrl.sites = Sites.data;

        Sites.data.forEach(function(attribute){
            if(attribute.id == siteId){
                siteDashCtrl.siteHomeText = attribute.siteHomeText;
                siteDashCtrl.title = attribute.title;
                CurrentSiteName.value = attribute.name;
            }
        });

        $scope.allMembers = Members.data;
        var imagePath = 'img/list/60.jpeg';

        siteDashCtrl.test = 'Dshboard HTML content should be in here';
        $scope.messages = [{
          face : imagePath,
          what: 'Admin',
          who: 'Min Li Chan',
          when: '3:08PM',
          notes: "Last seen 30 mins ago"
        }, {
          face : imagePath,
          what: 'Admin',
          who: 'Min Li Chan',
          when: '3:08PM',
          notes: "Last seen 30 mins ago"
        }, {
          face : imagePath,
          what: 'Admin',
          who: 'Min Li Chan',
          when: '3:08PM',
          notes: "Last seen 30 mins ago"
        }, {
          face : imagePath,
          what: 'Admin',
          who: 'Min Li Chan',
          when: '3:08PM',
          notes: "Last seen 30 mins ago"
        }, {
          face : imagePath,
          what: 'Admin',
          who: 'Min Li Chan',
          when: '3:08PM',
          notes: "Last seen 30 mins ago"
        }, {
          face : imagePath,
          what: 'Admin',
          who: 'Min Li Chan',
          when: '3:08PM',
          notes: "Last seen 30 mins ago"
        }, {
          face : imagePath,
          what: 'Admin',
          who: 'Min Li Chan',
          when: '3:08PM',
          notes: "Last seen 30 mins ago"
        }, {
          face : imagePath,
          what: 'Admin',
          who: 'Min Li Chan',
          when: '3:08PM',
          notes: "Last seen 30 mins ago"
        }, {
          face : imagePath,
          what: 'Admin',
          who: 'Min Li Chan',
          when: '3:08PM',
          notes: "Last seen 30 mins ago"
        }];

        siteDashCtrl.tiles = buildGridModel(
          [{
            icon : "icon-calendar-today",
            title: "Updated today: 15 files ",
            background: ""
          },
          {
            icon : "icon-file-word-box",
            title: "DOC: 12 files",
            background: ""
          },
          {
            icon : "icon-file-excel",
            title: "Excel: 3 files",
            background: ""
          },
          {
            icon : "icon-account",
            title: "Knuth kyle: 3 files",
            
            background: ""
          },
          {
            icon : "icon-file-pdf",
            title: "PDF: 7 files",
            background: ""
          },
          {
            icon : "icon-account",
            title: "Morris Johnson: 4 files",
            
            background: ""
          },
          {
            icon : "icon-account",
            title: "Admin: 2 files",
            background: ""
          },
          {
            
            icon : "icon-calendar-clock",
            title: "Yesterday: 10 files",
            background: ""
          },
          {
            icon : "icon-timer-sand",
            title: "Last week: 23 files ",
            
            background: ""
          },
          {
            icon : "icon-account",
            title: "Prat Deushe: 5 files ",
            background: ""
          },
          {
            icon : "icon-account",
            title: "Laplace singh: 2 files",
            background: ""
          }
      ]);

    


        
    }

    function buildGridModel(tileTmpl){
      var it, results = [ ];

      for (var j=0; j<tileTmpl.length; j++) {

        it = tileTmpl[j];
        //it = angular.extend({},tileTmpl);
        //it.icon  = it.icon + (j+1);
        //it.title = it.title + (j+1);
        it.span  = { row : 1, col : 1 };

        switch(j+1) {
          case 1:
            it.background = "#ff8a80"; 
            it.span.row = it.span.col = 2;
            break;

          case 2: it.background = "#b9f6ca";         break; 
          case 3: it.background = "#80d8ff";      break;
          case 4:
            it.background = "#84ffff";
            it.span.col = 2;
            break;

          case 5:
            it.background = "#ffff8d";
            it.span.row = it.span.col = 2;
            break;

          case 6: it.background = "#ff80ab";          break;
          case 7: it.background = "#80d8ff";      break;
          case 8: it.background = "#b388ff";        break;
          case 9: it.background = "#448aff";      break;
          case 10: it.background = "#8c9eff";  break;
          case 11: it.background = "#ffff8d";       break;
        }

        results.push(it);
      }
      return results;
    }
})();


(function ()
{
    'use strict';

    angular
        .module('app.pages.error-500', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.pages_errors_error-500', {
            url      : '/pages/errors/error-500',
            views    : {
                'main@'                             : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.pages_errors_error-500': {
                    templateUrl: 'app/main/pages/errors/500/error-500.html',
                    controller : 'Error500Controller as vm'
                }
            },
            bodyClass: 'error-500'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/errors/500');

        // Navigation
        msNavigationServiceProvider.saveItem('pages.errors.error-500', {
            title : '500',
            state : 'app.pages_errors_error-500',
            weight: 2
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.error-500')
        .controller('Error500Controller', Error500Controller);

    /** @ngInject */
    function Error500Controller()
    {
        // Data

        // Methods

        //////////
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.error-404', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.pages_errors_error-404', {
            url      : '/pages/errors/error-404',
            views    : {
                'main@'                             : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.pages_errors_error-404': {
                    templateUrl: 'app/main/pages/errors/404/error-404.html',
                    controller : 'Error404Controller as vm'
                }
            },
            bodyClass: 'error-404'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/errors/404');

        // Navigation
        // msNavigationServiceProvider.saveItem('pages.errors', {
        //     title : 'Errors',
        //     icon  : 'icon-alert',
        //     weight: 3
        // });

        // msNavigationServiceProvider.saveItem('pages.errors.error-404', {
        //     title : '404',
        //     state : 'app.pages_errors_error-404',
        //     weight: 1
        // });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.error-404')
        .controller('Error404Controller', Error404Controller);

    /** @ngInject */
    function Error404Controller($scope,$location)
    {
        $scope.goHome = function (hash) { 
            console.log('going home');
            $location.path('/');
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('app.overview', [
            'app.core',
            'app.pages.error-404',
            'ngMaterial', 'ngMessages', 'ngStorage',
            'app.createform', 'login',
            'app.sites','app.docbuffer','app.requests','app.maininbox', 'app.verification','app.sharedwithme','app.mycontent', 'app.toolbarsearch',
            'app.initiateReports'
        ])
        .config(config)

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
        $stateProvider
            .state('app.overview', {
                url: '/smartportal/sites/',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/dashboard/overview.html',
                        controller: 'OverviewController as overCtrl'
                    }
                },
                resolve: {
                    Icons: function(msApi) {
                        return msApi.resolve('icons@get');
                    },
                    RestAPIService: 'RestAPIService',
                    Homepage: function(RestAPIService) {
                        return RestAPIService.getHomePage();
                    }
                }
            });

        // msNavigationServiceProvider.saveItem('smartportal', {
        //     title: 'Home',
        //     icon: 'icon-tile-four',
        //     state: 'app.overview',
        //     translate: 'Home',
        //     weight: 4
        // });
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.overview')
        .controller('CustomCreateformController', ['$scope','$http','RestAPIService','SubmitURLService','$mdDialog','$state',function($scope,$http,RestAPIService,SubmitURLService,$mdDialog,$state){
        	var customCtrl = this;
			var formData = new FormData();

        	customCtrl.custom = {
			  formName : '',
			  formDesc : '',
			  formUrl:''
			}

			customCtrl.submitUrl = function(ev){
				var inputUrl = customCtrl.custom.formUrl;
				SubmitURLService.submitFormUrl(inputUrl).then(
					function(success){
						//alert('***'+success.data.length);
					   $scope.openPreviewDialog(success.data,ev);
					},
					function(error){
						var errorStatus = error.status;
				    	var errorStatusText = error.statusText;
				    	if(errorStatus == -1){
				    		errorStatusText = 'The server application is not running';
				    	}
				    	$mdDialog.show(
					      $mdDialog.alert()
					        .clickOutsideToClose(true)
					        .title('Server error occurred while processing')
					        .htmlContent('<hr><br><strong>Error code : </strong>'+errorStatus+
					        	'<br><strong>Error message : </strong>'+errorStatusText)
					        .ariaLabel('Alert Dialog Demo')
					        .ok('Ok')
					    );
					}
				);
	    	}

	    	customCtrl.uploadFile = function(ev){
				var noOfFiles = $scope.files.length;
				// for (var i = 0; i < noOfFiles; i++) {
			 //        var file = $scope.files[i];
				// 	var uploadUrl = 'http://localhost:8085/createform/custom/fileupload';
				// 	//fileUpload.uploadFileToUrl($scope.files[0],uploadUrl);
			 //   	}


			    RestAPIService.uploadFileToUrl($scope.files[0]).then(
				    function(success){
				       //$state.go('app.createform.custom.preview');
				      $scope.openPreviewDialog(success.data,ev);
				   		// $mdDialog.show(
					    //   $mdDialog.alert()
					    //     .clickOutsideToClose(true)
					    //     .title('Length of result')
					    //     .htmlContent('<hr><br><strong>length : </strong>'+success.data.length)
					    //     .ariaLabel('Alert Dialog Demo')
					    //     .ok('Ok')
					    // );

				    },
				    function(error){
				    	var errorStatus = error.status;
				    	var errorStatusText = error.statusText;
				    	if(errorStatus == -1){
				    		errorStatusText = 'The server application is not running';
				    	}
				    	$mdDialog.show(
					      $mdDialog.alert()
					        .clickOutsideToClose(true)
					        .title('Server error occurred while processing')
					        .htmlContent('<hr><br><strong>Error code : </strong>'+errorStatus+
					        	'<br><strong>Error message : </strong>'+errorStatusText)
					        .ariaLabel('Alert Dialog Demo')
					        .ok('Ok')
					    );
				    	
  						//alert("Server error occurred while processing");
				    }
				);
			  
			  
	    	}

	    	$scope.openPreviewDialog = function(data,ev){
	    		customCtrl.inputElemAll = data;

	    		    $mdDialog.show({
				      controller: DialogController,
				      templateUrl: 'app/main/createform/views/custom/preview.html',
				      parent: angular.element(document.body),
				      targetEvent: ev,
				      clickOutsideToClose:false,
				      escapeToClose: false
				    })
			        .then(function(answer) {
			          //$scope.status = 'You said the information was "' + answer + '".';
			        }, function() {
			          //$scope.status = 'You cancelled the dialog.';
			        });


			         function DialogController($scope, $mdDialog,$filter) {
			   			//Setting the input element lists
			   			$scope.inputElemAll = customCtrl.inputElemAll;
			   			$scope.fieldTypes = ["text","password","checkbox","url","email","date",
			   						"number","range","radio"];
			   			
						$scope.removeElem = function(index) {
					      $scope.inputElemAll.splice(index,1);
					      //Removing item from parent list
					    };

					    $scope.addElem = function(){
							//Initializing new row
					    	var newElem ={};
					    	newElem.id = $scope.inputElemAll.length +1;
					    	newElem.name = "elem-"+parseInt($scope.inputElemAll.length +1);
					    	newElem.type = "text";
					    	newElem.value = "";
					    	newElem.style = "";
					    	newElem.required = false;
							
							newElem.position={};
							newElem.position.row = $scope.inputElemAll.length +1;
							newElem.position.column = 1;
							newElem.position.parent = " ";

							//Adding new row
						    $scope.inputElemAll.push(newElem);
						  
						    
						};
						$scope.setParent = function() {
							//List of potential parent = All elements present in the form
					   		$scope.parentAll = [];
					   		$scope.parentAll.push(" "); //For root

					   		for(var i=0;i<$scope.inputElemAll.length;i++){
					   			var eachInput = $scope.inputElemAll[i];
					   			//Dont allow duplicate element names
					   			if($scope.parentAll.indexOf(eachInput.name) == -1)		$scope.parentAll.push(eachInput.name);
					   		}
					    	

					    };
   						$scope.hide = function() {
					      $mdDialog.hide();
					    };

					    
					    $scope.preview = function() {
							//PRE-Processing the data
							
							var invalidElemName = [];
							for(var i=0;i<$scope.inputElemAll.length;i++){
								// (1) Removing elements that has no name :1st part
								var elem = $scope.inputElemAll[i];
								if(elem.name.trim()==''){
									invalidElemName.push(i);
									
								}
								// (2) Assume type="text" for any unknown type
								var elemType = elem.type.trim();
								if(elemType=='' || $scope.fieldTypes.indexOf(elemType)==-1){
									$scope.inputElemAll[i].type = 'text';
								}
								// (3) Accomodate blank row at the end
								var elemRow = elem.position.row;
								if( elemRow== null || elemRow == undefined || elemRow==''){
									$scope.inputElemAll[i].position.row = $scope.inputElemAll.length+1;
								}
								// (4) Assign column=1 as default value
								var elemCol = elem.position.column;
								if( elemCol== null || elemCol == undefined || elemCol==''){
									$scope.inputElemAll[i].position.column = 1;
								}

							}
							// (1) Removing elements that has no name :2nd part
							for(var j=invalidElemName.length-1;j>=0;j--){
								$scope.removeElem(invalidElemName[j]);
							}
							
					    	//Sorting the elements based on their row number
					    	$scope.inputElemAll.sort(function(a, b){
					    		//If row is same, sort by column number
					    		if(a.position.row == b.position.row)	return a.position.column - b.position.column;
					    		else 	return a.position.row - b.position.row;

					    	});

					    	//POST-Processing the data
					    	var currRow='';
					    	var currCol ='';
							for(var i=0;i<$scope.inputElemAll.length;i++){
								/*
								 * (5) Every element should have unique row, column combination
								 *     Otherwise force the uniqueness, by incrementing column number */
								var elem = $scope.inputElemAll[i];
								if(elem.position.row == currRow){
									if(elem.position.column == currCol){
										$scope.inputElemAll[i].position.column = parseInt(currCol+(elem.id)); //Make column unique
									} 
								}
								else{
									currRow = elem.position.row;
									currCol = elem.position.column;	   
								}

							}

					    	//Counting no of columns for each row
					    	$scope.rowColMap = {};
							for(var i=0;i<$scope.inputElemAll.length;i++){
								if(!$scope.rowColMap[$scope.inputElemAll[i].position.row]){
							      $scope.rowColMap[$scope.inputElemAll[i].position.row] = {};
						      	}
						    	$scope.rowColMap[$scope.inputElemAll[i].position.row][$scope.inputElemAll[i].position.column] = $scope.inputElemAll[i];
						    }

						    


		   					//alert('***'+JSON.stringify($scope.rowColMap));
					    };

					    $scope.answer = function(answer) {
					      $mdDialog.hide(answer);
					    };

					    $scope.isNumeric = function(n){
						  return !isNaN(parseFloat(n)) && isFinite(n);
						}

						$scope.getChildren = function(elemName){
						  	var children = new Array();
						  	angular.forEach($scope.inputElemAll, function(eachInput){
						  		if(eachInput.position.parent == elemName){
						  			children.push(eachInput);
						  		}
					      	})
						  	return children;
						}
						$scope.checkParent = function(elem){
							//if(elem == undefined)	return;
							if(elem.name == elem.position.parent){
								$scope.parentError = 'No element can be it\'s own parent';
								return true;
							}
							var child = elem;
							var parent = elem.position.parent;
							
							var result = $filter('filter')($scope.inputElemAll, {name:parent})[0];
							if(result){
								//console.log('grandparent= '+result.position.parent);
								if(result.position.parent != ' '){
									$scope.parentError = 'The field \"'+result.name+'\" itself is a child of \"'+result.position.parent+
												'\". Grandchildren are not allowed.';
							  			return true;
								}

							}	
					      	return false;
						}
						$scope.getElemId= function(elemName) {
							for(var i=0;i<$scope.inputElemAll.length;i++){
								var elem = $scope.inputElemAll[i];
								if(elem.name == elemName)		return elem.id;
							}
					    };
					    $scope.dynamicElemLabel= function(elemName,isRequired) {
					    	if(isRequired)		return elemName+' (Required)';
					    	else 	return elemName;
					    };
					    

					 
				  }
	   
	    	}

    		$scope.setFile = function(element) {    			
    			$scope.$apply(function() {
		         	$scope.files = [];
			        for (var i = 0; i < element.files.length; i++) {
			          formData.append('file', element.files[i]);
			          $scope.files.push(element.files[i]);
			        }
				    //If user did not specify any form name, suggest one
				    if($scope.files.length){
					   	var formName = customCtrl.custom.formName;
					   	if(!formName){
					   		customCtrl.custom.formName = 'LogInUser 001 - '+element.files[0].name;
					   	}
					}
					else{
					   	return;
					   }

		       	});

		    };


			$scope.reset = function() {
				customCtrl.custom={};
				$scope.files={};
				$scope.customForm.$setPristine();
		        $scope.customForm.$setUntouched();
		    };



  

        }])
        .directive('httpPrefix', function() {
			    return {
			        restrict: 'A',
			        require: 'ngModel',
			        link: function(scope, element, attrs, controller) {
			            function ensureHttpPrefix(value) {
			                // Need to add prefix if we don't have http:// prefix already AND we don't have part of it
			                if(value && !/^(https?):\/\//i.test(value)
			                   && 'http://'.indexOf(value) !== 0 && 'https://'.indexOf(value) !== 0 ) {
			                    controller.$setViewValue('http://' + value);
			                    controller.$render();
			                    return 'http://' + value;
			                }
			                else
			                    return value;
			            }
			            controller.$formatters.push(ensureHttpPrefix);
			            controller.$parsers.splice(0, 0, ensureHttpPrefix);
			        }
			    };
		   })

    	//.service('RestAPIService', ['$http','$q', function ($http,$q) {

    		// var uploadUrl = 'http://localhost:8085/rest/createform/custom/file';
    		//var uploadUrl = 'http://1-dot-clock-asit.appspot.com/rest/createform/custom/file';
		  	// this.uploadFileToUrl = function(file){
		   //      var fd = new FormData();
		   //      fd.append('file', file);
		   //      return $http.post(uploadUrl, fd, {
		   //          transformRequest: angular.identity,
		   //          headers: {'Content-Type': undefined}
		   //      });
		      
		  	// };
		//}])
		.service('SubmitURLService', ['$http','$q', function ($http,$q) {
			
			//var uploadUrl = 'http://localhost:8085/rest/createform/custom/url';
			var uploadUrl = 'http://1-dot-clock-asit.appspot.com/rest/createform/custom/url';
		  	this.submitFormUrl = function(inputUrl){
		  		var data = 'formUrl='+inputUrl;
		       // return $http.post(uploadUrl, data);
		       return $http.post(uploadUrl, data, {
		            headers: {'Content-Type': 'application/x-www-form-urlencoded'}
		        });
		    };
		}]);

      
})();
(function() {
    'use strict';

    var app = angular
        .module('app.businessadmin', [])
       // .run(run)
        .config(config);

    /** @ngInject */
    function config($stateProvider,  $controllerProvider, $compileProvider, $filterProvider, $provide) {
        app.controller = $controllerProvider.register;
        app.directive = $compileProvider.directive;
        app.filter = $filterProvider.register;
        app.factory = $provide.factory;
        app.service = $provide.service;

        $stateProvider
            .state('app.businessadmin', {
                url: '/smartportal/businessadmin',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/business-admin/business.admin.html',
                        controller: 'AdminController as adminCtrl'
                    }
                }
            })
            .state('app.businessadmin.users', {
                url: '/users',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/business-admin/business-usermanagement/businessUsers.html',
                        controller: 'BusinessUserController as businessUserCtrl'
                    }
                }
            })
           .state('app.businessadmin.finishReset', {
                url: '/reset/finish?key',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/business-admin/business-usermanagement/resetpassword.html',
                        controller: 'BusinessUserController as businessUserCtrl'
                    }
                }
              
            })
            .state('app.businessadmin.groups', {
                url: '/groups',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/business-admin/business-usermanagement/groups/businessgroups.html',
                        controller: 'BusinessGroupController as businessgroupsCtrl'
                    }
                },
                resolve: {
                    RestAPIService: 'RestAPIService',
                    Groups: function(RestAPIService) {
                        return RestAPIService.getAllGroups();
                    }
                }
            })
             .state('app.businessadmin.content', {
                url: '/admincontent',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/business-admin/busines.admin.content.html',
                        controller: 'AdminController as adminCtrl'
                    }
                }
            })
                     
             .state('app.businessadmin.template', {
            url: '/template',
            views: {
                'content@app': {
                    templateUrl: 'app/main/business-admin/business-templates/businesstemplate.content.html',
                    controller: 'BusinessTemplateController as businessTemplateCtrl'
                }
            },
            resolve: {
            	DocumentTypes: function(RestAPIService) {
                    return RestAPIService.getDocumentTypes();
                },
                 Templates: function(RestAPIService) {
                     return RestAPIService.getTemplates();
                 }
            }
           
        })
        .state('app.businessadmin.attributes', {
            url: '/attibutes',
            views: {
                'content@app': {
                    templateUrl: 'app/main/business-admin/business-attributes/attributes.html',
                    controller: 'BusinessAttributesController as CACtrl'
                }
            },
            resolve: {
            	RestAPIService: 'RestAPIService',
                Attributes: function(RestAPIService) {
                    return RestAPIService.getContractAttributes();
                }
            }
           
        })
         .state('app.businessadmin.Vendor', {
            url: '/vendorList',
            views: {
                'content@app': {
                    templateUrl: 'app/main/business-admin/business-Vendor/vendor.list.html',
                    controller: 'BusinessVendorController as VendorCtrl'
                }
            }
           
        }) 
        .state('app.businessadmin.PRTypes', {
            url: '/PRTypes',
            views: {
                'content@app': {
                    templateUrl: 'app/main/business-admin/business-PRTypes/PRTypes.html',
                    controller: 'BusinessCustomerController as customerCtrl'
                }
            }
           
        }) 
         .state('app.businessadmin.POTypes', {
            url: '/POTypes',
            views: {
                'content@app': {
                    templateUrl: 'app/main/business-admin/business-POTypes/POTypes.html',
                    controller: 'BusinessPOTypesController as POTypeCtrl'
                }
            }
           
        }) 
         .state('app.businessadmin.Company', {
            url: '/Companies',
            views: {
                'content@app': {
                    templateUrl: 'app/main/business-admin/business-companies/company.html',
                    controller: 'BusinessCompanyController as companyCtrl'
                }
            }
           
        }) 
         .state('app.businessadmin.GLAccount', {
            url: '/GLAccounts',
            views: {
                'content@app': {
                    templateUrl: 'app/main/business-admin/business-GLAccounts/GLAccount.html',
                    controller: 'BusinessGLAccountController as GLACtrl'
                }
            }
           
        }) 
        .state('app.businessadmin.ExpenseType', {
            url: '/ExpenseTypes',
            views: {
                'content@app': {
                    templateUrl: 'app/main/business-admin/business-ExpenseTypes/ExpenseTypes.html',
                    controller: 'BusinessExpenseTypeController as expenseCtrl'
                }
            }
           
        }) 
        .state('app.businessadmin.InvoiceType', {
            url: '/InvoiceTypes',
            views: {
                'content@app': {
                    templateUrl: 'app/main/business-admin/business-invoicetypes/invoicetypes.html',
                    controller: 'BusinessEmployeeController as employeeCtrl'
                }
            }
           
        }) 
         .state('app.businessadmin.Plants', {
            url: '/plants',
            views: {
                'content@app': {
                    templateUrl: 'app/main/business-admin/business-plants/plants.html',
                    controller: 'BusinessPlantController as plantCtrl'
                }
            }
           
        }) 
        .state('app.businessadmin.Costcenter', {
            url: '/Costcenter',
            views: {
                'content@app': {
                    templateUrl: 'app/main/business-admin/business-costcenters/costcenter.html',
                    controller: 'BusinessCostcenterController as costcenterCtrl'
                }
            }
           
        }) 
        .state('app.businessadmin.PurchaseOrg', {
            url: '/purchaseOrg',
            views: {
                'content@app': {
                    templateUrl: 'app/main/business-admin/business-purchaseorg/purchase.html',
                    controller: 'BusinessPurchaseController as PurchaseCtrl'
                }
            }
           
        })
         .state('app.businessadmin.CategoryList', {
            url: '/categoryList',
            views: {
                'content@app': {
                    templateUrl: 'app/main/business-admin/business-categories/categorylist.html',
                    controller: 'BusinessCategoryController as CategoryCtrl'
                }
            }
           
        })
        .state('app.businessadmin.contractTypes', {
            url: '/contractTypes',
            views: {
                'content@app': {
                    templateUrl: 'app/main/business-admin/business-contracttypes/contracttypes.html',
                    controller: 'BusinessContractController as contractCtrl'
                }
            }
           
        })
        .state('app.businessadmin.portlets', {
            url: '/portlets',
            views: {
                'content@app': {
                    templateUrl: 'app/main/business-admin/business-portlets/preview.portlets.html',
                    controller: 'BusinessPortletController as portletCtrl'
                }
            },
            resolve: {
            	RestAPIService: 'RestAPIService',
                AllPortlets: function(RestAPIService) {
                    return RestAPIService.getAllPortlets();
                }
            }
        });
    }
        // function run(msNavigationService, $localStorage, $rootScope) {        	
        // 	msNavigationService.saveItem('BusinessAdmin', {
        //         title: 'BAdmin',
        //         icon: 'icon-account-key',
        //         state: 'app.businessadmin',
        //         weight: 11,
        //         hidden: function() {                                     	
        //                 if ($rootScope.currentLogedInUser != undefined) {                        
        //                     var roles = $rootScope.currentLogedInUser.authorities;
        //                     return !(roles.indexOf("ROLE_ADMIN") > -1);
        //                 }
                  
        //         }
        //     });
        // }
     
    
})();
(function() {
    'use strict';

    angular
        .module('app.businessadmin')
        .controller('BusinessGroupController', BusinessGroupController);

    /** @ngInject */
    
    var groupObj = {};
    function BusinessGroupController($state, $http, $scope, RestAPIService, $mdDialog, Groups) {
        var businessgroupsCtrl = this;
        businessgroupsCtrl.hidden = false;
        businessgroupsCtrl.isOpen = false;
        businessgroupsCtrl.hover = false;
        $scope.viewGroupMember = false;
        businessgroupsCtrl.allGroups = Groups.data;
        $scope.totalGroups = Groups.data.length;
        businessgroupsCtrl.allGroups.forEach(function(group) {
            // Calling Service for getting every group data based on groupId.
            RestAPIService.getGroupMembers(group.id).then(
                function(responce) {
                    group['members'] = responce.data;
                }
            )
            group['hidden'] = false;
            group['isOpen'] = false;
            group['hover'] = false;
        })
        businessgroupsCtrl.goToadmin =function(){
       	 $state.go('app.businessadmin.content');
        }
         
        if(groupObj !={} ||groupObj != undefined){
        	$scope.groupObj = groupObj;
        } 
        
        
        $scope.getAnotherColor = function(index) {
            $scope.colors = ['green-bg white-fg', 'orange-bg white-fg', 'pink-bg white-fg', 'blue-grey-bg white-fg', 'yellow-bg white-fg'];
            var totalNoOfColors = $scope.colors.length;
            return $scope.colors[index % totalNoOfColors];
        }      
        $scope.dtOptions = {
            dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            columnDefs: [{ // Target the actions column
                targets: 3,
                responsivePriority: 1,
                filterable: false,
                sortable: false
            }],
            pagingType: 'simple',
            lengthMenu: [10, 20, 30, 50, 100],
            pageLength: 20
        };

        businessgroupsCtrl.getAllGroups = function() {
            RestAPIService.getAllGroups().then(
                function(responce) {
                    businessgroupsCtrl.allGroups = responce.data;
                    $scope.totalGroups = responce.data.length;
                    businessgroupsCtrl.allGroups.forEach(function(group) {
                        // Calling Service for getting every group data based on groupId.
                        RestAPIService.getGroupMembers(group.id).then(
                            function(responce) {
                                group['members'] = responce.data;
                            }
                        )
                        group['hidden'] = false;
                        group['isOpen'] = false;
                        group['hover'] = false;
                    })
                },
                function(error) {
                    RestAPIService.showErrorDialog(error);
                }
            );
        }

        businessgroupsCtrl.selectGroup = function(eachGroup) {
            $scope.viewGroupMember = true;
            $scope.groupObj = eachGroup;
            groupObj =  $scope.groupObj;
        }

        $scope.goBackToGroup = function() {
            $scope.viewGroupMember = false;
        }


        $scope.$watch('eachGroup.isOpen', function(isOpen) {
            if (isOpen) {
                $timeout(function() {
                    $scope.tooltipVisible = isOpen;
                }, 600);
            } else {
                $scope.tooltipVisible = isOpen;
            }
        });

        businessgroupsCtrl.getAnotherColor = function(index) {
            // md-hue's are written for lighten the colors.
            businessgroupsCtrl.colors = ['md-blue-grey-bg', 'md-warn md-hue-3', 'md-accent md-hue-3', 'md-primary md-hue-3', 'md-light-green-bg'];
            var totalNoOfColors = businessgroupsCtrl.colors.length;
            return businessgroupsCtrl.colors[index % totalNoOfColors];
        }

        businessgroupsCtrl.currentGroup = {};
        businessgroupsCtrl.editGroup = function(ev, group) {
        	businessgroupsCtrl.currentGroup = angular.copy(group);
            $mdDialog.show({
                controller: EditGroupDialogController,
                templateUrl: 'app/main/business-admin/business-usermanagement/groups/editGroupDialog.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: $scope.customFullscreen
            })
        };

        function EditGroupDialogController($scope, $mdDialog) {
        	 $scope.close = function() {
                 $mdDialog.cancel();
             }
        
            $scope.currentGroup = businessgroupsCtrl.currentGroup;

            $scope.hide = function() {
                $mdDialog.hide();
            };
            $scope.cancel = function() {
                $mdDialog.cancel();
            };
            $scope.EditGroup = function(group) {
            RestAPIService.editGroup(group).then(
                    function(success) {
                   	 RestAPIService.successTostDialog("Group Updated Successfully");
                        $state.reload();
                    },
                    function(error) {
                        RestAPIService.showErrorDialog(error);
                    }
                );
                $mdDialog.hide(group);
            };
        }
        
        businessgroupsCtrl.deleteGroupMember = function(groupData, i) {
            var groupData = groupData;
            var groupId = groupData.id;
            var login = groupData.members[i].login;
            var name = groupData.members[i].firstName + " " + groupData.members[i].lastName;
            var groupName = groupData.name;
            var confirm = $mdDialog.confirm()
                .title('Remove')
                .textContent(name + ' will be removed from ' + groupName + ' , continue ?')
                //.targetEvent(ev)
                .ok('Ok')
                .cancel('Cancel');
            $mdDialog.show(confirm).then(function() {
                RestAPIService.deleteGroupMember(groupId, login).then(
                    function(responce) {
                        // Refresh the data after deleting.                        
                        //$state.reload();
                    	RestAPIService.successTostDialog("Member Deleted Successfully");
                        RestAPIService.getGroupMembers(groupId).then(
                            function(responce) {
                                groupData['members'] = responce.data;
                            }
                        )
                    },
                    function(error) {
                        RestAPIService.showErrorDialog(error);
                    }
                );
            }, function() {
                //User clicked Cancel. Close the popup
            });
        }

        businessgroupsCtrl.deleteGroup = function(groupData) {
            var groupId = groupData.id;
            var confirm = $mdDialog.confirm()
                .title('Remove')
                .textContent(groupData.name + ' group will be removed, continue ?')
                //.targetEvent(ev)
                .ok('Ok')
                .cancel('Cancel');
            $mdDialog.show(confirm).then(function() {
                //Deleting the group
                RestAPIService.deleteGroup(groupId).then(
                    function(success) {
                    	RestAPIService.successTostDialog("Group Deleted Successfully");
                        //Group Successfully deleted. Need to refresh through GET call                           
                        //$state.reload();
                        businessgroupsCtrl.getAllGroups();
                    },
                    function(error) {
                        RestAPIService.showErrorDialog(error);
                    }
                );
            }, function() {
                //User clicked Cancel. Close the popup
            });
        }
                businessgroupsCtrl.createGroupDialog = function(ev) {
            $mdDialog.show({
                    controller: CreateGroupDialogController,
                    templateUrl: 'app/main/business-admin/business-usermanagement/groups/createbusinessGroupDialog.html',
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    fullscreen: $scope.customFullscreen // Only for -xs, -sm breakpoints.
                })
                .then(function(answer) {

                }, function() {

                });
        }

        function CreateGroupDialogController($scope, $mdDialog) {
            $scope.close = function() {
                $mdDialog.cancel();
            }

            $scope.cancel = function() {
                $scope.group = {};
                $mdDialog.cancel();
            }

            $scope.createGroup = function(groupData) {
                RestAPIService.createGroup(groupData).then(
                    function(success) {
                    	RestAPIService.successTostDialog("Group Created Successfully");
                       /* $mdDialog.show(
                            $mdDialog.alert()
                            .parent(angular.element(document.querySelector('#popupContainer')))
                            .clickOutsideToClose(true)
                            .textContent('You have successfully created a ' + groupData.name + ' Group .')
                            .ok('Ok')
                        );*/

                        //                        $state.reload();
                        businessgroupsCtrl.getAllGroups();
                    },
                    function(error) {
                    	if (error.status == 400) {
                            RestAPIService.successTostDialog(error.headers('X-smartportalApp-defaultMessage'));

                            return false;

                        }
                      //  RestAPIService.showErrorDialog(error);
                    }
                );
                $mdDialog.hide(groupData);
            };
        }

        businessgroupsCtrl.addMemberDialog = function(ev, groupData) {
            businessgroupsCtrl.groupId = groupData.id;
            //alert(businessgroupsCtrl.groupId);
            $mdDialog.show({
                    controller: addGroupMemberController,
                    templateUrl: 'app/main/business-admin/business-usermanagement/groups/addbusinessGroupMemberDialog.html',
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    fullscreen: $scope.customFullscreen // Only for -xs, -sm breakpoints.
                })
                .then(function(answer) {

                }, function() {

                });
        }

        function addGroupMemberController($scope, $mdDialog,$location,$window) {
        	
        	
        	
            $scope.searchMember = function(memberdata) {
                var q = "";
                var type="user"
                if (memberdata == undefined || angular.equals(memberdata, {})) {
                    $scope.msgVisibility = true;
                    $scope.tableVisibility = false;
                    $scope.member = {};
                } else {
                    if ((memberdata.name != "" && memberdata.name != undefined) && (memberdata.email != "" && memberdata.email != undefined)) {
                        q = memberdata.name;
                    } else if ((memberdata.name == "" || memberdata.name == undefined) && (memberdata.email != "" && memberdata.email != undefined)) {
                        q = memberdata.email;
                    } else if (memberdata.name != "" && (memberdata.email == "" || memberdata.email == undefined)) {
                        q = memberdata.name;
                    }
                    $scope.searchedMembers = [];
                    RestAPIService.searchMemberForGroups(q,type).then(
                        function(success) {
                        	$scope.searchedMembers = success.data;
                            
                            $scope.msgVisibility = false;
                            $scope.tableVisibility = true;
                            $scope.member = {};
                        },
                        function(error) {
                            RestAPIService.showErrorDialog(error);
                        }
                    );
                }
            }

            $scope.addGroupMember = function(memberdata) {
                var groupId = businessgroupsCtrl.groupId;
                RestAPIService.addGroupMember(memberdata, groupId).then(
                    function(responce) {
                    	 //$mdDialog.cancel();
                              //  $state.reload();
                                RestAPIService.getGroupMembers(groupId).then(
                                        function(responce) {
                                        	groupObj.members =responce.data;
                                        },
                                        function(error) {
                                            RestAPIService.showErrorDialog(error);
                                        }
                                    );
                    	 
                    },
                    function(error) {
                        RestAPIService.showErrorDialog(error);
                    }
                );
            }

            $scope.cancel = function(memberdata) {
                $scope.member = {};
                $scope.tableVisibility = false;
                $scope.searchedMembers = [];
                //$scope.width=25;
                $scope.msgVisibility = false;
                $mdDialog.cancel();
            }
            $scope.ok = function() {

                $mdDialog.cancel();
            }

        }

    }


})();
(function() {
    'use strict';

    var app = angular
        .module('app.administration', ['datatables', 'ngResource','nvd3','angular-loading-bar','daterangepicker'])
        .run(run)
        .config(config);

    /** @ngInject */
    function config($stateProvider, $controllerProvider, $compileProvider,msNavigationServiceProvider, cfpLoadingBarProvider,$filterProvider, $provide,msApiProvider) {
        app.controller = $controllerProvider.register;
        app.directive = $compileProvider.directive;
        app.filter = $filterProvider.register;
        app.factory = $provide.factory;
        app.service = $provide.service;

        cfpLoadingBarProvider.includeSpinner = false;
        cfpLoadingBarProvider.parentSelector = '#loading-bar-container';
        cfpLoadingBarProvider.spinnerTemplate = '<div><span class="fa fa-spinner">Loading...Please wait</div>';

        $stateProvider
	        .state('app.administration', {
	            url: '/um',
	            views: {
	                'content@app': {
	                	 controller: function($state){
	                		 $state.go('app.administration.users');
	                     }
	                }
	            },
	        data: {accessRole: ['admin']}
	        }).state('app.administration.users', {
                url: '/users',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/administration/user-management/users/users.html',
                        controller: 'UMController as userCtrl'
                    }
                },
                resolve: {
                    RestAPIService: 'RestAPIService',
                    Users: function(RestAPIService) {
                        return RestAPIService.getUsers();
                    }
                },
                data: {accessRole: ['admin']}
            })
           .state('app.finishReset', {
                url: '/reset/finish?key',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/administration/user-management/users/resetpassword.html',
                        controller: 'UMController as userCtrl'
                    }
                },
            data: {accessRole: ['Admin']}

            })
            .state('app.administration.groups', {
                url: '/groups',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/administration/user-management/groups/groups.html',
                        controller: 'GMController as groupsCtrl'
                    }
                },
                resolve: {
                    RestAPIService: 'RestAPIService',
                    Groups: function(RestAPIService) {
                        return RestAPIService.getAllGroups();
                    }
                },
                data: {accessRole: ['admin']}
            })
           .state('app.administration.userupload', {
                url: '/userupload',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/administration/user-management/user-upload/userupload.html',
                        controller: 'UserUploadController as useruploadCtrl'
                    }
                },
                resolve: {
                    RestAPIService: 'RestAPIService',
                    Users: function(RestAPIService) {
                        return RestAPIService.getUsers();
                    }
                },
                data: {accessRole: ['admin']}
            })
            .state('app.administration.forms', {
                url: '/forms',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/administration/forms-management/overviewPage.html',
                        controller: 'FMController as requestCtrl'
                    }
                },

                data: {accessRole: ['admin']}
            })
            .state('app.administration.doaReports', {
                url: '/doaReports',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/administration/doa-reports/doa-reports.html',
                        controller: 'DOAController as doCtrl'
                    }
                },

                data: {accessRole: ['admin']}
            })
            .state('app.administration.forms.content', {
                url: '/:requestId',
                params: {
                    'requestId': null,
                    'currentForm': null
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/main/administration/forms-management/form.content.html',
                        controller: 'FMController as requestCtrl'
                    }
                },
                data: {accessRole: ['admin']}
            }).state('app.administration.createform', {
                url: '/createform',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/administration/forms-management/createForm.html',
                        controller: 'FMController as requestCtrl'
                    }
                },

                data: {accessRole: ['admin']}
            })
             .state('app.administration.lists', {
                url: '/lists',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/administration/list-management/listOverview.html',
                        controller: 'LMController as listCtrl'
                    }
                },

                data: {accessRole: ['admin']}
            }).state('app.administration.list-maintenance', {
                url: '/lists',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/administration/list-management/list-maintenance/list-maintenance.html',
                        controller: 'LMAINController as listmainCtrl'
                    }
                },

                data: {accessRole: ['admin']}
            }).state('app.administration.workflow-management', {
                url: '/workflow-management',
                views: {
	                'content@app': {
	                	 controller: function($state){
	                		 $state.go('app.administration.workflow-management.content');
	                     }
	                }
	            },
                resolve: {
                    RestAPIService: 'RestAPIService',
                    Actvitys: function(RestAPIService) {
                        return RestAPIService.getActvitys();
                    }

                },
                data: {accessRole: ['admin']}
            })
            .state('app.administration.workflow-management.defination', {
                url: '/defination',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/administration/workflow-management/workflow.defination.html',
                        controller: 'WMController as workflowCtrl'
                    }
                },
                data: {accessRole: ['admin']}
            })
            .state('app.administration.workflow-management.content', {
                url: '/content',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/administration/workflow-management/workflow.content.html',
                        controller: 'WMController as workflowCtrl'
                    }
                },
                data: {accessRole: ['admin']}
            })
            .state('app.administration.bussiness-object', {
                url: '/bussiness-object',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/administration/business-object/bussiness.html',
                        controller: 'BussinessController as bsCrtl'
                    }
                },
                resolve: {
                    RestAPIService: 'RestAPIService',
                    Objects: function(RestAPIService) {
                        return RestAPIService.getObjects();
                    }
                },
                data: {accessRole: ['admin']}
            })
            .state('app.administration.requestType', {
                url: '/request-type',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/administration/request-management/createrequestType.html',
                        controller: 'ReqtypeController as reqtypeCtrl'
                    }
                },
                resolve: {
                    Icons: function(msApi) {
                          return msApi.resolve('icons@get');
                      },
                    RestAPIService: 'RestAPIService',
                    Requests: function(RestAPIService) {
                        return RestAPIService.getRequests();
                    }
                },

                data: {accessRole: ['admin']}
            })
            .state('app.administration.settings', {
                url: '/settings',
                views: {
	                'content@app': {
	                	 controller: function($state){
	                		 $state.go('app.administration.settings.brand');
	                     }
	                }
	            },

                data: {accessRole: ['admin']}
            })
            // .state('app.administration.settings.account', {
            //     url: '/account',
            //     views: {
            //         'content@app': {
            //             templateUrl: 'app/main/administration/settings/accountSettings.html',
            //             controller: 'SettingsController as settingCtrl'
            //         }
            //     },
            //     data: {accessRole: ['admin']}
            // })
            .state('app.administration.settings.emailConfig', {
                url: '/account',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/administration/settings/emailConfiguration.html',
                        controller: 'SettingsController as settingCtrl'
                    }
                },
                data: {accessRole: ['admin']}
            })
            .state('app.administration.settings.technical', {
                url: '/technical',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/administration/settings/technicalSettings.html',
                        controller: 'SettingsController as settingCtrl'
                    }
                },
                data: {accessRole: ['admin']}
            }).state('app.administration.settings.help', {
                url: '/help',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/administration/settings/helpSettings.html',
                        controller: 'SettingsController as settingCtrl'
                    }
                },
                data: {accessRole: ['admin']}
            })
      
           
            .state('app.administration.settings.brand', {
                url: '/brand',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/administration/settings/brandsettings.html',
                        controller: 'SettingsController as settingCtrl'
                    }
                },
                data: {accessRole: ['admin']}
            })
            .state('app.administration.settings.site', {
                url: '/site',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/administration/settings/siteSettings.html',
                        controller: 'SettingsController as settingCtrl'
                    }
                },
                data: {accessRole: ['admin']}
            }).state('app.administration.settings.menubar', {
                url: '/menubar',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/administration/settings/menubarSettings.html',
                        controller: 'SettingsController as settingCtrl'
                    }
                },
                data: {accessRole: ['admin']}
            })
           .state('app.administration.binder', {
                url: '/binder',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/administration/binder-management/binder.html',
                        controller: 'BinderController as binderCrtl'
                    }
                },
                resolve: {
                    RestAPIService: 'RestAPIService',
                    Binders: function(RestAPIService) {
                        return RestAPIService.getBinders();
                    }
                },
                data: {accessRole: ['admin']}
            })
             .state('app.administration.documentType', {
                url: '/documentType',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/administration/document-type/documenttype.html',
                        controller: 'DocumentTypeController as doctypeCrtl'
                    }
                },
                resolve: {
                	 RestAPIService: 'RestAPIService',
                	 DocumentTypes: function(RestAPIService) {
                         return RestAPIService.getDocumentTypes();
                     }
                },
                data: {accessRole: ['admin']}

            })
            .state('app.administration.documentType.siteConfig', {
                url: '/documentTypeSiteConfig',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/administration/document-type/siteConfigureDialog.html',
                        controller: 'DocumentTypeController as doctypeCrtl'
                    }
                },
                params: {
                    obj: {
                    	"docType": null
                    }
         	     },
                resolve: {
                	 RestAPIService: 'RestAPIService',
                	 DocumentTypes: function(RestAPIService) {
                         return RestAPIService.getDocumentTypes();
                     }
                },
                data: {accessRole: ['admin']}

            })
        .state('app.administration.template', {
            url: '/template',
            views: {
                'content@app': {
                    templateUrl: 'app/main/administration/Template/template.content.html',
                    controller: 'TemplateController as templateCtrl'
                }
            },
            resolve: {
            	 RestAPIService: 'RestAPIService',
            	 DocumentTypes: function(RestAPIService) {
                     return RestAPIService.getDocumentTypes();
                 },
                 Templates: function(RestAPIService) {
                     return RestAPIService.getTemplates();
                 }
            },
            data: {accessRole: ['admin']}

        })
        .state('app.administration.reports', {
            url: '/reports',
            views: {
                'content@app': {
                    templateUrl: 'app/main/administration/reports/reportDefinition.html',
                    controller: 'Reportscontoller as repCtrl'
                }
            },
            resolve: {
          	  Icons: function(msApi) {
                  return msApi.resolve('icons@get');
              }
            },
            data: {accessRole: ['admin']}
        }).state('app.administration.reports.maintenance', {
            url: '/maintenance',
            views: {
                'content@app': {
                    templateUrl: 'app/main/administration/reports/reportMaintenance.html',
                    controller: 'Reportscontoller as repCtrl'
                }
            },
            resolve: {
          	  Icons: function(msApi) {
                  return msApi.resolve('icons@get');
              }
            },
            data: {accessRole: ['admin']}
        })
        .state('app.administration.zohoReports', {
                url: '/maintenance',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/administration/zohoReports/preview.zohoReports.html',
                        controller: 'ZohoReportsController as zohoCtrl'
                    }
                },
                resolve: {
                    RestAPIService: 'RestAPIService',
                    ZohoReports: function(RestAPIService) {
                        return RestAPIService.getAllZohoReports();
                    }
                }
            }).state('app.administration.requestTypeDetails', {
                url: '/requestTypeDetails',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/administration/requestTypeDetails/requestTypeDeatils.html',
                        controller: 'requestTypeDetailsController as reqTypeCtrl'
                    }
                },
                resolve: {
                      RequestsData: function(RestAPIService) {
                          return RestAPIService.getRequests();
                      },
                      RequestTypeDetails: function(RestAPIService) {
                          return RestAPIService.getAllRequestTypeDetails();
                      }
                }
            })
            .state('app.administration.substitution', {
                url: '/substitution',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/administration/admin-substitution/admin.preview.substitution.html',
                        controller: 'AdminSubstitutionController as subCtrl'
                    }
                }

            })
            .state('app.administration.parReports', {
                url: '/initiatereports',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/administration/admin-reports/admin-reports.html',
                        controller: 'AdminReportsController as reportsCtrl'
                    }
                },
                resolve: {
                    RestAPIService: 'RestAPIService',
                       Users: function(RestAPIService) {
                           return RestAPIService.getUsers();
                       }
                   }
            })
            .state('app.administration.invoiceTypeList', {
                url : '/invoiceTypes',
                views : {
                    'content@app' : {
                        templateUrl : 'app/main/administration/invoiceTypes/invoiceType.html',
                        controller : 'InvoicetypeListController as invoiceCtrl'
                    }
                }

            })
            .state('app.administration.pr_request', {
                url : 'invoiceTypes/:type',
                views : {
                    'content@app' : {
                        templateUrl : 'app/main/administration/invoiceTypes/pr_request/pr_request.html',
                        controller : 'PRController as prCtrl'
                    }
                }
            })
            .state('app.administration.vendor_request', {
                url : '/invoiceTypes/:type',
                views : {
                    'content@app' : {
                        templateUrl : 'app/main/administration/invoiceTypes/vendor_cr_request/vendor_cr.html',
                        controller : 'VendorController as vrCtrl'
                    }
                }
            })
  .state('app.administration.approvematrix', {
            url: '/approvematrix',
            views: {
                'content@app': {
                    templateUrl: 'app/main/administration/approve-matrix/approvematrix.html',
                    controller: 'ApprovematrixController as approveCtrl'
                }
            }

        })
        .state('app.administration.approveLevel', {
            url: '/approvelevel',
            views: {
                'content@app': {
                    templateUrl: 'app/main/administration/approver-Level/approveLevel.html',
                    controller: 'ApprovelevelController as approverCtrl'
                }
            }

        })
        .state('app.administration.emailBuffer', {
            url: '/emailBuffer',
            views: {
                'content@app': {
                    templateUrl: 'app/main/administration/email-buffer/emailBuffer.html',
                    controller: 'emailBufferConfigController as emailBufCnfgCtrl'
                }
            }
        })

        .state('app.administration.mtrInboxConfg', {
            url: '/mtrInboxConfg',
            views: {
                'content@app': {
                    templateUrl: 'app/main/administration/mtrInbox-Confg/mtrInbox.html',
                    controller: 'MtrInboxConfgController as MtrInCtrl'
                }
            }

        })



         .state('app.administration.approvematrix.createDetails', {
            url: '/createDetails',

            views: {
                'content@app': {
                    templateUrl: 'app/main/administration/approve-matrix/approvematrix.details.html',
                    controller: 'ApprovematrixController as approveCtrl'
                }
            },
            params: {
                    matrixDetails: null

                },

        })
             .state('app.administration.reAssign', {
                url: '/reassign',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/administration/admin-reAssign/preview.reAssign.html',
                        controller: 'ReAssignController as reassignCtrl'
                    }
                }
            })
            .state('app.administration.systemLogs', {
                url: '/systemlogs',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/administration/system-logs/system_logs.html',
                        controller: 'SystemController as systemCtrl'
                    }
                }
            })
         msApiProvider.register('icons', ['assets/icons/selection.json']);

         }



    function run(msNavigationService, $localStorage, $rootScope, $state) {

    	 $rootScope.$state = $state;
        msNavigationService.saveItem('admin', {
            title: 'Admin',
            icon: 'icon-account',
            state: 'app.administration',
            weight: 6,
            hidden: function() {
                    if ($rootScope.currentLogedInUser != undefined) {
                        var roles = $rootScope.currentLogedInUser.authorities;
                        return !(roles.indexOf("ROLE_ADMIN") > -1);
                    }
                   }
        });
        /*msNavigationServiceProvider.saveItem('admin', {
            title : 'Admin',
            icon  : 'icon-account',
            state : 'app.administration',
            weight:6
        });*/
    }

})();

 (function() {
     'use strict';
     angular
         .module('app.administration')
         .controller('UMController', UMController);

     function UMController($state, $http, $scope, $mdDialog, RestAPIService, Users,$localStorage) {
         var userCtrl = this;

         $scope.usersList = Users.data;
         $scope.count = Users.data.length;
         $("#vertical-navigation").hide();
         $("#content-container").css({ "margin-left": "0px" });
         userCtrl.user = {};
         //userCtrl.dtInstance = {};
         userCtrl.dtOptions = {
                 dom       : '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
                pagingType: 'simple',
                autoWidth : false,
                responsive: true

               };
                  if ($localStorage.menubarsetting != undefined) {
                     $scope.showsForms = $localStorage.menubarsetting.formsmanagement;
                      $scope.showWorkflow = $localStorage.menubarsetting.adminWorkflow;
                     $scope.showrequestManagement = $localStorage.menubarsetting.requestManagement;
                     $scope.showListManagement = $localStorage.menubarsetting.listManagement;
                     $scope.showBusinessObject = $localStorage.menubarsetting.businessObject;
                     $scope.showBinder = $localStorage.menubarsetting.binder;
                     $scope.showTemplates = $localStorage.menubarsetting.templates;
                     $scope.showReports1 = $localStorage.menubarsetting.adminReports;


                     $scope.showSubstitution = $localStorage.menubarsetting.substitution;
                     $scope.showZohoReports = $localStorage.menubarsetting.zohoReports;

                      $scope.showDocumentType  = $localStorage.menubarsetting.documentTypes;
                       $scope.showReqTypeDetails  = $localStorage.menubarsetting.reqTypeDetails;
                          $scope.showInvoiceTypes  = $localStorage.menubarsetting.invoiceTypes;

            }
            $scope.sizeselect=function(size){
                $scope.size = size
                userCtrl.getUsers();                
            }
            $scope.pageNumber = 0;
            $scope.size =100;

            $scope.next = function(){	
                $scope.pageNumber = $scope.pageNumber + 1; 
                userCtrl.getUsers();    	
              }
              $scope.previous = function(){
                  $scope.pageNumber = $scope.pageNumber - 1; 
                  userCtrl.getUsers();    	
              }  	 
              $scope.sendPageNumber = function(page) {
               $scope.pageNumber = page;
               userCtrl.getUsers();
           }
         $scope.goToPreviousState = function() {
            $state.go("app.mycontent_inbox");
            $("#vertical-navigation").show();
            $("#content-container").css({ "margin-left": "60px" });
         }
         userCtrl.getUsers = function() {
             RestAPIService.getUsers($scope.pageNumber,$scope.size).then(
                 function(success) {
                    $scope.pageNumbers = [];
                     $scope.usersList = success.data;
                     $scope.totalRecords = success.headers('x-total-count');
                    $scope.totalPages = Math.ceil($scope.totalRecords/$scope.size);
                   if ($scope.totalPages  > 0) {
                    for (var i = 0; i < $scope.totalPages; i++) {
                        $scope.pageNumbers.push(i);
                        }
                   } 

                 },
                 function(error) {
                     RestAPIService.showErrorDialog(error);
                 }
             );
             //return userCtrl.usersList;
         }


         //$scope.allUsers = Users.data;

         $scope.createUserDialog = function(ev) {
             $mdDialog.show({
                 controller: CreateUserDialogController,
                 templateUrl: 'app/main/administration/user-management/users/create.user.dialog.html',
                 parent: angular.element(document.body),
                 targetEvent: ev,
                 clickOutsideToClose: true,
                 fullscreen: $scope.customFullscreen
             })
             $scope.cancel = function() {
                 $scope.user = {};
             };
         };


         function CreateUserDialogController($scope, $mdDialog) {
             $scope.status = ["True", "False"];
             $scope.roles = ["ROLE_USER", "ROLE_ADMIN","ROLE_TICKETMANAGER","ROLE_AUDITOR","ROLE_BUSINESS_ADMIN"];
             $scope.user={};
             $scope.user.activated=false;
            // $scope.re = /^[a-z0-9._%+-]+@(yahoo\.com|gmail\.com|msn\.com|hotmail\.com|actiprocess\.com|smartdocsnow\.com|live\.com)/
           //  $scope.re = /^[a-z]+[a-z0-9._]+@[a-z]+\.[a-z.]{2,5}$/;
             $scope.hide = function() {
                 $mdDialog.hide();
             };
             $scope.cancel = function() {
                 $mdDialog.cancel();
             };
             $scope.passwordLength = 12;
             $scope.addUpper = true;
             $scope.addNumbers = true;
             $scope.addSymbols = true;

             function getRandomInt(min, max) {
               return Math.floor(Math.random() * (max - min + 1)) + min;
             }

             function shuffleArray(array) {
               for (var i = array.length - 1; i > 0; i--) {
                 var j = Math.floor(Math.random() * (i + 1));
                 var temp = array[i];
                 array[i] = array[j];
                 array[j] = temp;
               }
               return array;
             }
             $scope.createPassword = function() {
               var lowerCharacters = ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z'];
               var upperCharacters = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];
               var numbers = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
               var symbols = ['!', '#', '$', '%', '&', '\'', '(', ')', '*', '+', ',', '-', '.', '/', ':', ';', '<', '=', '>', '?', '@', '[', '\\', ']', '^', '_', '`', '{', '|', '}', '~'];
               var noOfLowerCharacters = 0,
                 noOfUpperCharacters = 0,
                 noOfNumbers = 0,
                 noOfSymbols = 0;
               var noOfneededTypes = $scope.addUpper + $scope.addNumbers + $scope.addSymbols;
               var noOfLowerCharacters = getRandomInt(1, $scope.passwordLength - noOfneededTypes);
               var usedTypeCounter = 1;
               if ($scope.addUpper) {
                 noOfUpperCharacters = getRandomInt(1, $scope.passwordLength - noOfneededTypes + usedTypeCounter - noOfLowerCharacters);
                 usedTypeCounter++;
               }
               if ($scope.addNumbers) {
                 noOfNumbers = getRandomInt(1, $scope.passwordLength - noOfneededTypes + usedTypeCounter - noOfLowerCharacters - noOfUpperCharacters);
                 usedTypeCounter++;
               }
               if ($scope.addSymbols) {
                 noOfSymbols = $scope.passwordLength - noOfLowerCharacters - noOfUpperCharacters - noOfNumbers;
               }
               var passwordArray = [];
               for (var i = 0; i < noOfLowerCharacters; i++) {
                 passwordArray.push(lowerCharacters[getRandomInt(1, lowerCharacters.length - 1)]);
               }
               for (var i = 0; i < noOfUpperCharacters; i++) {
                 passwordArray.push(upperCharacters[getRandomInt(1, upperCharacters.length - 1)]);
               }
               for (var i = 0; i < noOfNumbers; i++) {
                 passwordArray.push(numbers[getRandomInt(1, numbers.length - 1)]);
               }
               for (var i = 0; i < noOfSymbols; i++) {
                 passwordArray.push(symbols[getRandomInt(1, symbols.length - 1)]);
               }
               passwordArray = shuffleArray(passwordArray);
               return passwordArray.join("");
             };
             $scope.password=$scope.createPassword();
             $scope.mypassword = "";
             $scope.showPassword = function(){
               $scope.mypassword = $scope.password;
             };



          // Set the default value of inputType
             $scope.inputType = 'password';

             // Hide & show password function
             $scope.hideShowPassword = function(){
               if ($scope.inputType == 'password')
                 $scope.inputType = 'text';
               else
                 $scope.inputType = 'password';
             };

             $scope.save = function(user) {
                 RestAPIService.createUser(user).then(
                     function(success) {
                         $mdDialog.hide();
                         RestAPIService.successTostDialog('User Created Successfully');
                        $state.reload();
                     },
                     function(error) {
                         if(error.status == 400){
                             RestAPIService.successTostDialog(error.headers('X-smartportalApp-defaultMessage'));

                             return false;

                         }
                      }

                 );


             };

         }
         userCtrl.ChangePassword=function(ev,user) {
            userCtrl.currentLogin =user;
           $mdDialog.show({
               controller: ChangePasswordController,
               templateUrl: 'app/main/finishReset/finishReset.html',
               parent: angular.element(document.body),
               targetEvent: ev,
               clickOutsideToClose: true,
               fullscreen: $scope.customFullscreen
           })
       }

       function ChangePasswordController($scope) {
           $scope.cancel = function() {
               $mdDialog.cancel();
           }
           $scope.save = function(password) {
               $scope.profileUser = userCtrl.currentLogin;
                 RestAPIService.ResetPassword($scope.profileUser,password).then(
                         function(success){
                                 RestAPIService.successTostDialog("Password Changed successfully ");
                             $mdDialog.hide(password);
                         },
                          function(error) {
                       RestAPIService.showErrorDialog(error);
                       });


           }
       }


         userCtrl.resetPassword = function(email) {
             // $scope.mailId=email;
            // alert(email);
             RestAPIService.resetPassword(email).then(
                 function(success) {
                     //RestAPIService.successTostDialog("Reset link sent to emailId successfully");
                     alert("Reset link sent to emailId successfully");
                     $state.reload();

                 },
                 function(error) {
                     RestAPIService.showErrorDialog(error);
                 }
             );
             $mdDialog.hide();

     }
         userCtrl.currentUser = {};
         $scope.updateUserDialog = function(ev, user) {
             userCtrl.currentUser = angular.copy(user);
             $mdDialog.show({
                 controller: UpdateUserDialogController,
                 templateUrl: 'app/main/administration/user-management/users/update.user.dialog.html',
                 parent: angular.element(document.body),
                 targetEvent: ev,
                 clickOutsideToClose: true,
                 fullscreen: $scope.customFullscreen
             })
         };

         function UpdateUserDialogController($scope, $mdDialog) {
             $scope.status = ["true", "false"];
             $scope.roles = ["ROLE_USER", "ROLE_ADMIN","ROLE_TICKETMANAGER","ROLE_AUDITOR","ROLE_BUSINESS_ADMIN"];
             $scope.currentUser = userCtrl.currentUser;

             $scope.hide = function() {
                 $mdDialog.hide();
             };
             $scope.cancel = function() {
                 $mdDialog.cancel();
             };
             $scope.update = function(user) {
                 RestAPIService.updateUser(user).then(
                     function(success) {
                         RestAPIService.successTostDialog('User Updated Successfully');
                         $state.reload();
                     },
                     function(error) {
                         RestAPIService.showErrorDialog(error);
                     }
                 );
                 $mdDialog.hide(user);
             };
         }
        
         userCtrl.deleteUser = function(ev, user) {
             var confirm = $mdDialog.confirm()
                 .title('Remove')
                 .textContent('User ' + user.firstName + ' ' + user.lastName + ' will be permanently deleted. Continue ?')
                 .targetEvent(ev)
                 .ok('Ok')
                 .cancel('Cancel');
             $mdDialog.show(confirm).then(function() {

                 RestAPIService.deleteUser(user.login).then(
                     function(success) {
                         RestAPIService.successTostDialog('User Deleted Successfully');
                         $state.reload();
                     },
                     function(error) {
                         RestAPIService.showErrorDialog(error);
                     }
                 );
             }, function() {
                 $mdDialog.cancel();
             });
         }


         init();

         function init() {
             userCtrl.getUsers();
         }

     }

   

 })();

(function() {
    'use strict';

    angular
        .module('app.administration')
        .controller('GMController', GMController);

    /** @ngInject */
    var groupObj = {};
    function GMController($state, $http, $scope, RestAPIService, $mdDialog, Groups,$localStorage) {
        var groupsCtrl = this;
        groupsCtrl.hidden = false;
        groupsCtrl.isOpen = false;
        groupsCtrl.hover = false;
        $scope.viewGroupMember = false;
        groupsCtrl.allGroups = Groups.data;
        $scope.totalGroups = Groups.data.length;       
        $("#vertical-navigation").hide();
        $("#content-container").css({ "margin-left": "0px" });
        groupsCtrl.allGroups.forEach(function(group) {
            // Calling Service for getting every group data based on groupId.
            RestAPIService.getGroupMembers(group.id).then(
                function(responce) {
                    group['members'] = responce.data;
                }
            )
            group['hidden'] = false;
            group['isOpen'] = false;
            group['hover'] = false;
        })
       if ($localStorage.menubarsetting != undefined) {
                     $scope.showsForms = $localStorage.menubarsetting.formsmanagement;
                      $scope.showWorkflow = $localStorage.menubarsetting.adminWorkflow; 
                     $scope.showrequestManagement = $localStorage.menubarsetting.requestManagement;
                     $scope.showListManagement = $localStorage.menubarsetting.listManagement;
                     $scope.showBusinessObject = $localStorage.menubarsetting.businessObject;
                     $scope.showBinder = $localStorage.menubarsetting.binder;
                     $scope.showTemplates = $localStorage.menubarsetting.templates;
                     $scope.showReports1 = $localStorage.menubarsetting.adminReports;
                  
                    
                     $scope.showSubstitution = $localStorage.menubarsetting.substitution;
                     $scope.showZohoReports = $localStorage.menubarsetting.zohoReports;
                     
                      $scope.showDocumentType  = $localStorage.menubarsetting.documentTypes;   
                       $scope.showReqTypeDetails  = $localStorage.menubarsetting.reqTypeDetails; 
                          $scope.showInvoiceTypes  = $localStorage.menubarsetting.invoiceTypes;     
                     
            }
        if(groupObj !={} ||groupObj != undefined){
        	$scope.groupObj = groupObj;
        } 
        
    
        $scope.getAnotherColor = function(index) {
            /*$scope.colors = ['green-bg white-fg', 'orange-bg white-fg', 'pink-bg white-fg', 'blue-grey-bg white-fg', 'back-bg white-fg'];*/
        	$scope.colors = ['#4CAF50 !important','#FF9800 !important','#E91E63 !important','#607D8B !important','#FFFFFF !important']
            var totalNoOfColors = $scope.colors.length;
            return $scope.colors[index % totalNoOfColors];
        }
        $scope.goToPreviousState = function() {
        	$state.go("app.mycontent_inbox");
         	$("#vertical-navigation").show();
         	$("#content-container").css({ "margin-left": "60px" });
         }
        $scope.dtOptions = {
            dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            columnDefs: [{ // Target the actions column
                targets: 3,
                responsivePriority: 1,
                filterable: false,
                sortable: false
            }],
            pagingType: 'simple',
            lengthMenu: [10, 20, 30, 50, 100],
            pageLength: 20
        };
        	
        
     
         
        groupsCtrl.getAllGroups = function() {
            RestAPIService.getAllGroups().then(
                function(responce) {
                    groupsCtrl.allGroups = responce.data;
                    $scope.totalGroups = responce.data.length;
                    groupsCtrl.allGroups.forEach(function(group) {
                        // Calling Service for getting every group data based on groupId.
                        RestAPIService.getGroupMembers(group.id).then(
                            function(responce) {
                                group['members'] = responce.data;
                            }
                        )
                        group['hidden'] = false;
                        group['isOpen'] = false;
                        group['hover'] = false;
                    })
                },
                function(error) {
                    RestAPIService.showErrorDialog(error);
                }
            );
        }

        groupsCtrl.selectGroup = function(eachGroup) {
            $scope.viewGroupMember = true;
            $scope.groupObj = eachGroup;
        }

        $scope.goBackToGroup = function() {
            $scope.viewGroupMember = false;
        }


        $scope.$watch('eachGroup.isOpen', function(isOpen) {
            if (isOpen) {
                $timeout(function() {
                    $scope.tooltipVisible = isOpen;
                }, 600);
            } else {
                $scope.tooltipVisible = isOpen;
            }
        });

        groupsCtrl.getAnotherColor = function(index) {
            // md-hue's are written for lighten the colors.
            groupsCtrl.colors = ['md-blue-grey-bg', 'md-warn md-hue-3', 'md-accent md-hue-3', 'md-primary md-hue-3', 'md-light-green-bg'];
            var totalNoOfColors = groupsCtrl.colors.length;
            return groupsCtrl.colors[index % totalNoOfColors];
        }

        groupsCtrl.deleteGroupMember = function(groupData, i) {
            var groupData = groupData;
            var groupId = groupData.id;
            var login = groupData.members[i].login;
            var name = groupData.members[i].firstName + " " + groupData.members[i].lastName;
            var groupName = groupData.name;
            var confirm = $mdDialog.confirm()
                .title('Remove')
                .textContent(name + ' will be removed from ' + groupName + ' , continue ?')
                //.targetEvent(ev)
                .ok('Ok')
                .cancel('Cancel');
            $mdDialog.show(confirm).then(function() {
                RestAPIService.deleteGroupMember(groupId, login).then(
                    function(responce) {
                        // Refresh the data after deleting.                        
                        //$state.reload();
                    	 RestAPIService.successTostDialog('Member Deleted Successfully');
                        RestAPIService.getGroupMembers(groupId).then(
                            function(responce) {
                                groupData['members'] = responce.data;
                            }
                        )
                    },
                    function(error) {
                        RestAPIService.showErrorDialog(error);
                    }
                );
            }, function() {
                //User clicked Cancel. Close the popup
            });
        }

        groupsCtrl.deleteGroup = function(groupData) {
            var groupId = groupData.id;
            var confirm = $mdDialog.confirm()
                .title('Remove')
                .textContent(groupData.name + ' group will be removed, continue ?')
                //.targetEvent(ev)
                .ok('Ok')
                .cancel('Cancel');
            $mdDialog.show(confirm).then(function() {
                //Deleting the group
                RestAPIService.deleteGroup(groupId).then(
                    function(success) {
                        //Group Successfully deleted. Need to refresh through GET call                           
                        //$state.reload();
                    	RestAPIService.successTostDialog('Group Deleted Successfully');
                        groupsCtrl.getAllGroups();
                    },
                    function(error) {
                        RestAPIService.showErrorDialog(error);
                    }
                );
            }, function() {
                //User clicked Cancel. Close the popup
            });
        }

        groupsCtrl.createGroupDialog = function(ev) {
            $mdDialog.show({
                    controller: CreateGroupDialogController,
                    templateUrl: 'app/main/administration/user-management/groups/createGroupDialog.html',
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    fullscreen: $scope.customFullscreen // Only for -xs, -sm breakpoints.
                })
                .then(function(answer) {

                }, function() {

                });
        }

        function CreateGroupDialogController($scope, $mdDialog) {
            $scope.close = function() {
                $mdDialog.cancel();
            }

            $scope.cancel = function() {
                $scope.group = {};
                $mdDialog.cancel();
            }

            $scope.createGroup = function(groupData) {
                RestAPIService.createGroup(groupData).then(
                    function(success) {
                        $mdDialog.show(
                            $mdDialog.alert()
                            .parent(angular.element(document.querySelector('#popupContainer')))
                            .clickOutsideToClose(true)
                            .textContent('You have successfully created a ' + groupData.name + ' Group .')
                            .ok('Ok')
                        );

                        //                        $state.reload();
                        groupsCtrl.getAllGroups();
                    },
                    function(error) {
                    	$mdDialog.show(
                                $mdDialog.alert()
                                .clickOutsideToClose(true)
                                .title('Error')
                                .textContent(error.data.description)
                                .ok('Ok')
                            );
                       /* RestAPIService.showErrorDialog(error);*/
                    }
                );
                $mdDialog.hide(groupData);
            };
        }
        
        groupsCtrl.currentGroup = {};
        groupsCtrl.editGroup = function(ev, group) {
            groupsCtrl.currentGroup = angular.copy(group);
            $mdDialog.show({
                controller: EditGroupDialogController,
                templateUrl: 'app/main/administration/user-management/groups/editGroupDialog.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: $scope.customFullscreen
            })
        };

        function EditGroupDialogController($scope, $mdDialog) {
        	 $scope.close = function() {
                 $mdDialog.cancel();
             }
        
            $scope.currentGroup = groupsCtrl.currentGroup;

            $scope.hide = function() {
                $mdDialog.hide();
            };
            $scope.cancel = function() {
                $mdDialog.cancel();
            };
            $scope.EditGroup = function(group) {
            RestAPIService.editGroup(group).then(
                    function(success) {
                   	 RestAPIService.successTostDialog("Group Updated Successfully");
                        $state.reload();
                    },
                    function(error) {
                        RestAPIService.showErrorDialog(error);
                    }
                );
                $mdDialog.hide(group);
            };
        }

        groupsCtrl.addMemberDialog = function(ev, groupData) {
            groupsCtrl.groupId = groupData.id;
            //alert(groupsCtrl.groupId);
            $mdDialog.show({
                    controller: addGroupMemberController,
                    templateUrl: 'app/main/administration/user-management/groups/addGroupMemberDialog.html',
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    fullscreen: $scope.customFullscreen // Only for -xs, -sm breakpoints.
                })
                .then(function(answer) {

                }, function() {

                });
        }

        function addGroupMemberController($scope, $mdDialog,$location,$window) {
        	
            $scope.searchMember = function(memberdata) {
                var q = "";
                var type="user"
                if (memberdata == undefined || angular.equals(memberdata, {})) {
                    $scope.msgVisibility = true;
                    $scope.tableVisibility = false;
                    $scope.member = {};
                } else {
                    if ((memberdata.name != "" && memberdata.name != undefined) && (memberdata.email != "" && memberdata.email != undefined)) {
                        q = memberdata.name;
                    } else if ((memberdata.name == "" || memberdata.name == undefined) && (memberdata.email != "" && memberdata.email != undefined)) {
                        q = memberdata.email;
                    } else if (memberdata.name != "" && (memberdata.email == "" || memberdata.email == undefined)) {
                        q = memberdata.name;
                    }
                    $scope.searchedMembers = [];
                    RestAPIService.searchMemberForGroups(q,type).then(
                        function(success) {
                        	$scope.searchedMembers = success.data;
                            
                            $scope.msgVisibility = false;
                            $scope.tableVisibility = true;
                            $scope.member = {};
                        },
                        function(error) {
                            RestAPIService.showErrorDialog(error);
                        }
                    );
                }
            }

            $scope.addGroupMember = function(memberdata) {
                var groupId = groupsCtrl.groupId;
                RestAPIService.addGroupMember(memberdata, groupId).then(
                    function(responce) {
                    	 RestAPIService.successTostDialog('User'+' '+ memberdata.login +' '+'added Successfully');
                                RestAPIService.getGroupMembers(groupId).then(
                                        function(responce) {
                                        	groupObj.members =responce.data;
                                        	
                                        },
                                        function(error) {
                                            RestAPIService.showErrorDialog(error);
                                        }
                                    );
                    	 
                    },
                    function(error) {
                        RestAPIService.showErrorDialog(error);
                    }
                );
            }

            $scope.cancel = function(memberdata) {
                $scope.member = {};
                $scope.tableVisibility = false;
                $scope.searchedMembers = [];
                //$scope.width=25;
                $scope.msgVisibility = false;
                $mdDialog.cancel();
            }
            $scope.ok = function() {           
                $mdDialog.cancel();
                $state.reload();               
                
            }

        }

    }


})();
(function () {
   'use strict';
   angular
      .module('app.administration')
      .controller('UserUploadController', UserUploadController);

   function UserUploadController($scope, $http,$mdToast, RestAPIService, $mdDialog, $state, $timeout, $window, $localStorage) {
      $("#vertical-navigation").hide();
      $("#content-container").css({ "margin-left": "0px" });
      $scope.goToPreviousState = function () {
         $state.go("app.overview");
         $("#vertical-navigation").show();
         $("#content-container").css({ "margin-left": "60px" });
      }
      if ($localStorage.menubarsetting != undefined) {
         $scope.showsForms = $localStorage.menubarsetting.formsmanagement;
         $scope.showWorkflow = $localStorage.menubarsetting.adminWorkflow;
         $scope.showrequestManagement = $localStorage.menubarsetting.requestManagement;
         $scope.showListManagement = $localStorage.menubarsetting.listManagement;
         $scope.showBusinessObject = $localStorage.menubarsetting.businessObject;
         $scope.showBinder = $localStorage.menubarsetting.binder;
         $scope.showTemplates = $localStorage.menubarsetting.templates;
         $scope.showReports1 = $localStorage.menubarsetting.adminReports;
         $scope.showSubstitution = $localStorage.menubarsetting.substitution;
         $scope.showZohoReports = $localStorage.menubarsetting.zohoReports;
         $scope.showDocumentType = $localStorage.menubarsetting.documentTypes;
         $scope.showReqTypeDetails = $localStorage.menubarsetting.reqTypeDetails;
         $scope.showInvoiceTypes = $localStorage.menubarsetting.invoiceTypes;

      }
      $scope.Upload = function () {
         // function Upload() {
            $scope.save=true;
         var fileUpload = document.getElementById("fileUpload");
         var regex = /^([a-zA-Z0-9\s_\\.\-:])+(.csv|.txt)$/;
         if (regex.test(fileUpload.value.toLowerCase())) {
            if (typeof (FileReader) != "undefined") {
               var reader = new FileReader();
               reader.onload = function (e) {
                  var table = document.createElement("table");
                  var rows = e.target.result.split("\n");
                  for (var i = 0; i < rows.length; i++) {

                     var cells = rows[i].split(",");
                     if (cells.length > 1) {
                        var row = table.insertRow(-1);
                        for (var j = 0; j < cells.length; j++) {
                           var cell = row.insertCell(-1);
                           cell.innerHTML = cells[j];

                           // console.log(cell)
                        }
                     }
                  }
                  $timeout(function () {
                     var dvCSV = document.getElementById("dvCSV");
                     dvCSV.innerHTML = "";
                     dvCSV.appendChild(table);
                  }, 2000);
                
               }
               reader.readAsText(fileUpload.files[0]);
            } else {
               $scope.save=false;
               alert("This browser does not support HTML5.");
            }
         } else {
            $scope.save=false;
            alert("Please upload a valid CSV file.");
         }
         // }
      }

      $scope.clear = function () {
         $("#dvCSV").remove();
         $scope.save=false;
      }
     
      $scope.setAttachmentFile = function (element) {
         $scope.attachmentfiles = [];
         var formData = new FormData();
         $scope.$apply(function () {
            for (var i = 0; i < element.files.length; i++) {
               formData.append('file', element.files[i]);
               $scope.attachmentfiles.push(element.files[i]);
            }
         });
      };

      $scope.Save = function () {
        RestAPIService.getUploadCsv($scope.attachmentfiles).then(
            function(success) {
               $mdToast.show(
                  $mdToast.simple()
                  .textContent('Users Uploaded Successfully')
                  // .position(pinTo)
                  .hideDelay(1000)
              );
              $state.reload();
           },
            function(error) {
                RestAPIService.showErrorDialog(error);
            }
        );
        
      }
  $scope.cancel = function () {
         $state.reload();
      }


   }
})();
(function ()
{
    'use strict';

    angular
        .module('app.administration')
        .controller('LMAINController', LMAINController);

    /** @ngInject */
    function LMAINController($state, $scope,$mdDialog,RestAPIService,$stateParams,$window,$localStorage)
    {
        var listmainCtrl = this;
        listmainCtrl.pageNumber = 0;
        listmainCtrl.pageSize = 100;
        $scope.showrowdata = true;
        $scope.attributes ={};
        $scope.dataflag = true;
        $("#vertical-navigation").hide();
        $("#content-container").css({ "margin-left": "0px" });
        $scope.searchObj = {};
        $scope.goToPreviousState = function() {
        	$state.go("app.overview");
         	$("#vertical-navigation").show();
         	$("#content-container").css({ "margin-left": "60px" });
         }

          if ($localStorage.menubarsetting != undefined) {
                     $scope.showsForms = $localStorage.menubarsetting.formsmanagement;
                     $scope.showrequestManagement = $localStorage.menubarsetting.requestManagement;
                     $scope.showListManagement = $localStorage.menubarsetting.listManagement;
                     $scope.showBusinessObject = $localStorage.menubarsetting.businessObject;
                     $scope.showBinder = $localStorage.menubarsetting.binder;
                     $scope.showTemplates = $localStorage.menubarsetting.templates;
                     $scope.showReports1 = $localStorage.menubarsetting.adminReports;
                     $scope.showsReports2 = $localStorage.menubarsetting.adminReports2;
                     $scope.showILM = $localStorage.menubarsetting.ILM;
                     $scope.showSystemLandscape = $localStorage.menubarsetting.systemLandscape;
                     $scope.showAnnouncements = $localStorage.menubarsetting.announcements;
                     $scope.showSubstitution = $localStorage.menubarsetting.substitution;
                     $scope.showZohoReports = $localStorage.menubarsetting.zohoReports;
                     $scope.showWorkspacetype = $localStorage.menubarsetting.workspaceType;
                     $scope.showApprovalMatrix = $localStorage.menubarsetting.approvalMatrix;
                     $scope.showEmailTemplates = $localStorage.menubarsetting.emailTemplates;
                     $scope.showContractApprovals = $localStorage.menubarsetting.contractApprovals;
                      $scope.showWorkflow = $localStorage.menubarsetting.adminWorkflow; 
                       $scope.showDocumentType  = $localStorage.menubarsetting.documentTypes;         
                     
            }

        
        listmainCtrl.next = function() {
        	listmainCtrl.pageNumber = listmainCtrl.pageNumber + 1;
        	listmainCtrl.getlistdata()
          // alert("hi")
        }
        listmainCtrl.previous = function() {
        	listmainCtrl.pageNumber = listmainCtrl.pageNumber - 1;
        	listmainCtrl.getlistdata()
        }
        $scope.sendPageNumber = function(pageNumber) {
        	listmainCtrl.pageNumber = pageNumber;
        	listmainCtrl.getlistdata()
        }
        
        $scope.goback = function(){
        	$state.transitionTo($state.current, $stateParams, {
        	    reload: true,
        	    inherit: false,
        	    notify: true
        	});
        }
        
       /* listmainCtrl.dtOptions = {
                dom: '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
                pagingType: 'simple',
                autoWidth: false,
                responsive: true,
            };*/
        

        
            RestAPIService.getlistdata().then(
                function(success) {
                    $scope.listdata = success.data;

                },
                function(error) {
                    RestAPIService.showErrorDialog(error);
                }
            );
          
          listmainCtrl.getlistdata = function(){
        	   RestAPIService.getdetaildata($scope.listname, listmainCtrl.pageNumber, listmainCtrl.pageSize).then(
                       function(success) {
                     	  if((success.data !=null || success.data !=undefined) && success.data.length > 0)
                     		  {
                               $scope.tdata = success.data;
                               listmainCtrl.tdata= success.data;
                     		  for(var obj in success.data){
                     			    if(success.data.hasOwnProperty(obj)){
                     			    for(var prop in success.data[obj]){
                     			        if(success.data[obj].hasOwnProperty(prop)){
                     			         if ($.inArray(prop, $scope.dynamicdata1) === -1) {
                     			        	 $scope.dynamicdata1.push(prop);
                     			         }
                     			        } 
                     			    }
                     			}
                     			}
                     		 listmainCtrl.numberOfElements = success.headers('x-total-count');
                                $scope.noOfPages = listmainCtrl.numberOfElements / listmainCtrl.pageSize;
                                $scope.pageNumbers = [];
                                if ($scope.noOfPages > 0) {
                                    for (var i = 0; i < $scope.noOfPages; i++) {
                                        $scope.pageNumbers.push(i);
                                    }
                                }
                     		  }else
                     			  {
                     			  $scope.dynamicdata1 = undefined;
                     			  }

                       },
                       function(error) {
                           RestAPIService.showErrorDialog(error);
                       }
                   );
           }
           
           $scope.searchListData = function(searchObj){
            RestAPIService.getDynamicInstanceDataByMultipleValues(listmainCtrl.listname,[searchObj.selectedAttribute], [searchObj.attributeValue]).then(function(success){
                    if((success.data !=null || success.data !=undefined) && success.data.length > 0)
                              {
                               $scope.tdata = success.data;
                               listmainCtrl.tdata= success.data;
                              for(var obj in success.data){
                                    if(success.data.hasOwnProperty(obj)){
                                    for(var prop in success.data[obj]){
                                        if(success.data[obj].hasOwnProperty(prop)){
                                         if ($.inArray(prop, $scope.dynamicdata1) === -1) {
                                             $scope.dynamicdata1.push(prop);
                                         }
                                        } 
                                    }
                                }
                                }
                             listmainCtrl.numberOfElements = success.headers('x-total-count');
                                $scope.noOfPages = listmainCtrl.numberOfElements / listmainCtrl.pageSize;
                                $scope.pageNumbers = [];
                                if ($scope.noOfPages > 0) {
                                    for (var i = 0; i < $scope.noOfPages; i++) {
                                        $scope.pageNumbers.push(i);
                                    }
                                }
                              }else
                                  {
                                  $scope.dynamicdata1 = undefined;
                                  } 
                }, function(error){
                    RestAPIService.showErrorDialog(error);
                })
           }
           
            $scope.showdetail = function(list){
                $scope.listdatause = list;
                listmainCtrl.listname =list.name;
            	$scope.dynamicdata1 = [];
            	 $scope.showrowdata = false;
                
               $scope.listname = list.name;
              listmainCtrl.getlistdata();
               $scope.formatHeaders = function(headers) {
                    for(var i=0,len=headers.length,formattedHeaders=[]; i<len; i++){
                        formattedHeaders.push({ "title" : headers[i] });
                    };
                    return formattedHeaders;
                };
                
                $scope.dtoption2 = {
              		  dom: '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
                        pagingType: 'simple',
                        lengthChange: false,
                        autoWidth: false,
                        responsive: false,
              }
                
            }
            
            $scope.createlistmaintenanace = function(ev,list) {
            	listmainCtrl.listdatadata = $scope.listdatause;
                $mdDialog.show({
                    controller: ListMaincontroller,
                    templateUrl: 'app/main/administration/list-management/list-maintenance/createlist-maintenanace-dialog.html', 
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    fullscreen: $scope.customFullscreen
                })
            };
            $scope.deletedata = function(ev, data){
         	   RestAPIService.deletedata(data._id,$scope.listdatause.name).then(
                        function(success) {
                            RestAPIService.successTostDialog("List Deleted Successfully");
                            listmainCtrl.getlistdata();
                        },
                        function(error) {
                            RestAPIService.showErrorDialog(error);
                        }
                    );
         	   $mdDialog.hide(data);
           }
            $scope.updatedataDialog = function(ev, detaildata) {
            	listmainCtrl.updatedata = detaildata;
                  $mdDialog.show({
                      controller: UpdatelistMaincontroller,
                      templateUrl: 'app/main/administration/list-management/list-maintenance/updatelistmaintenance-dialog.html',
                      parent: angular.element(document.body),
                      targetEvent: ev,
                      fullscreen: $scope.customFullscreen
                  })
              };
              
              function UpdatelistMaincontroller($scope, $mdDialog){
            	  $scope.currentdata = listmainCtrl.updatedata;
            	  $scope.updateddata = [];
           	   var udata =[];
           	   var pmap = {};
                  $scope.hide = function() {
                      $mdDialog.hide();
                  };
                  $scope.cancel = function() {
                      $mdDialog.cancel();
                  };

            	   var valarr = [];
                  $scope.updatedata = function() {
                   angular.forEach($scope.currentdata, function(value, key){
          	      valarr.push(key);
          	      });
         		  for(var i=0; i<$scope.updateddata.length; i++){
          			  if(valarr[i] !="_id"){
          				pmap[valarr[i]] = $scope.updateddata[i];
          			  }
            		} 
                   udata.push({"productMap":pmap});
                   $scope.arrsend = udata[0];
                   $scope.arrsend.id = $scope.updateddata[0];
                   $scope.arrsend.name = listmainCtrl.listname;
                      RestAPIService.updatedyData($scope.arrsend).then(
                          function(success) {
                              RestAPIService.successTostDialog("List Updated Successfully");
                            //   $state.reload();
                            listmainCtrl.getlistdata();
                          },
                          function(error) {
                              RestAPIService.showErrorDialog(error);
                          }
                      );
                      $mdDialog.hide(udata);
                  };
                  
              }
              
              
              
            function ListMaincontroller($scope, $mdDialog){
            	$scope.attrdata = 	listmainCtrl.listdatadata.attributes;
                $scope.crlist=[];
                $scope.save = false;
                $scope.hide = function() {
                    $mdDialog.hide();
                };
                $scope.cancel = function() {
                    $mdDialog.cancel();
                };
                //smapletemplateDownload
                $scope.downloadlistMaintainanceTemplate=function ()
                {
                   
                  var t = listmainCtrl.listdatadata.attributes;
                  var createXLSLFormatObj = [];
                  var tempArray=[];   
                for(var m=0;m<t.length;m++){
                    tempArray.push(t[m].fieldname);
                   } 
               createXLSLFormatObj.push(tempArray);
                 var currentdata=[];
                  $.each(currentdata, function(index, value) {
                        var innerRowData = [];
                  $.each(value, function(ind, val) {
                            console.log(val);
                
                            innerRowData.push(val);
                        });
                        createXLSLFormatObj.push(innerRowData);
                       console.log("innerrowdata",innerRowData);
                       
                    });
                
                     /* File Name */
                     var filename = listmainCtrl.listname+".xlsx";
                
                     /* Sheet Name */
                     var ws_name = listmainCtrl.listname;
                
                     if (typeof console !== 'undefined') console.log(new Date());
                     var wb = XLSX.utils.book_new(),
                         ws = XLSX.utils.aoa_to_sheet(createXLSLFormatObj);
                
                     /* Add worksheet to workbook */
                     XLSX.utils.book_append_sheet(wb, ws, ws_name);
                
                     /* Write workbook and Download */
                     if (typeof console !== 'undefined') console.log(new Date());
                     XLSX.writeFile(wb, filename);
                     if (typeof console !== 'undefined') console.log(new Date());
                 }
                 //smapletemplateDownload
               //fileUpload//
               $scope.Upload = function() {
                $scope.save = true;
                var fileUpload = document.getElementById("fileUpload");
                var regex = /^([a-zA-Z()0-9\s_\\.\-:])+(.xls|.xlsx)$/;
                if (regex.test(fileUpload.value.toLowerCase())) {
                 if (typeof(FileReader) != "undefined") {
                  var reader = new FileReader();
                  reader.onload = function(e) {
                   $scope.ProcessExcel(e.target.result);
                  }
             
                  reader.readAsBinaryString(fileUpload.files[0]);
                 } else {
                  $window.alert("This browser does not support HTML5.");
                 }
                } else {
                 $window.alert("Please upload a valid Excel file.");
                }
               };
               $scope.ProcessExcel = function(data) {
                //Read the Excel File data.
                var workbook = XLSX.read(data, {
                 type: 'binary'
                });
             
                  var colValues =[];
                //Fetch the name of First Sheet.
                var firstSheet = workbook.SheetNames[0];
             //Read all rows from First Sheet into an JSON array.
                var excelRows = XLSX.utils.sheet_to_row_object_array(workbook.Sheets[firstSheet]);
                console.log(excelRows)
                $scope.$apply(function() {
                    $scope.arrayOfObjectsdata = excelRows;
                    // $scope.headerdata=[];
                    // for(var j=0;j< $scope.arrayOfObjectsdata.length;j++){
                    //     $scope.headerdata.push($scope.arrayOfObjectsdata[j].key);
                    // }
                  
                    console.log( $scope.headerdata );
                
                
                
    
                });
              
           };
           $scope.clear = function() {
            $scope.arrayOfObjectsdata = [];
            $scope.save = false;
            document.getElementById("fileUpload").value = '';
           }
           $scope.uploadSave=function(){
            $scope.arr1= $scope.arrayOfObjectsdata;
          console.log($scope.arr1)
          $scope.array1=[]
          for(var j=0;j<$scope.arrayOfObjectsdata.length;j++){
            $scope.array1.push({"name":listmainCtrl.listdatadata.name,"productMap":$scope.arrayOfObjectsdata[j]})
          }
          RestAPIService.createuploadExceldetail( $scope.array1).then(
                function(success) {
                  $mdDialog.hide();
            $mdDialog.show(
                $mdDialog.alert()
                .clickOutsideToClose(true)
                .title('Success!')
                .textContent('Data of ' + listmainCtrl.listdatadata.name + ' has been successfully updated')
                .ok('Ok')
            );
            listmainCtrl.getlistdata();   
                },
                function(error) {
                    RestAPIService.showErrorDialog(error);
                }
            );

           }
               //endupload//  
                $scope.save =function(){
              	  var t = $scope.attrdata;
              	  var uniqueNames=[];
              	  var uniqueNames1 = [];
              	  var obj ={};
              	  var ary=[];
              	  for(var i=0; i<t.length; i++){
              		  obj[t[i].fieldname] = $scope.crlist[i].list;
              		}
                    
              	  ary.push({"productMap":obj});
              	  ary.name = $scope.attrdata.name;
                     $scope.arr1 = ary[0];
                     $scope.arr1.name = listmainCtrl.listdatadata.name;
                    RestAPIService.createdetail($scope.arr1).then(
                            function(success) {
                                // $state.reload();  
                                // listmainCtrl.tdata.push( success.data)
                                $mdDialog.hide();
                        $mdDialog.show(
                            $mdDialog.alert()
                            .clickOutsideToClose(true)
                            .title('Success!')
                            .textContent('Data of ' + $scope.arr1.name + ' has been successfully updated')
                            .ok('Ok')
                        );
                        listmainCtrl.setSuccessData(success.data);   
                            },
                            function(error) {
                                RestAPIService.showErrorDialog(error);
                            }
                        );
                       
                }
            }
            listmainCtrl.setSuccessData=function(data){
                $scope.tdata=data;
            }
        }
 })();
(function () {
	'use strict';
	angular
		.module('app.administration')
		.controller('VendorController', VendorController);

	function VendorController($scope, $mdDialog, $state,$localStorage) {
        var vrCtrl = this;
        $scope.gotoPR_Types =function(){
            $state.go('app.administration.invoiceTypeList');
        }
          if ($localStorage.menubarsetting != undefined) {
                     $scope.showsForms = $localStorage.menubarsetting.formsmanagement;
                      $scope.showWorkflow = $localStorage.menubarsetting.adminWorkflow; 
                     $scope.showrequestManagement = $localStorage.menubarsetting.requestManagement;
                     $scope.showListManagement = $localStorage.menubarsetting.listManagement;
                     $scope.showBusinessObject = $localStorage.menubarsetting.businessObject;
                     $scope.showBinder = $localStorage.menubarsetting.binder;
                     $scope.showTemplates = $localStorage.menubarsetting.templates;
                     $scope.showReports1 = $localStorage.menubarsetting.adminReports;
                  
                    
                     $scope.showSubstitution = $localStorage.menubarsetting.substitution;
                     $scope.showZohoReports = $localStorage.menubarsetting.zohoReports;
                     
                      $scope.showDocumentType  = $localStorage.menubarsetting.documentTypes;
                       $scope.showReqTypeDetails  = $localStorage.menubarsetting.reqTypeDetails; 
                          $scope.showInvoiceTypes  = $localStorage.menubarsetting.invoiceTypes;        
                     
            }

        $("#vertical-navigation").hide();
        $("#content-container").css({ "margin-left": "0px" });
        $scope.goToPreviousState = function() {
            $state.go("app.mycontent_inbox");
            $("#vertical-navigation").show();
            $("#content-container").css({ "margin-left": "60px" });
         }

    }

})();
(function () {
	'use strict';
	angular
		.module('app.administration')
		.controller('PRController', PRController);

	function PRController($scope, $mdDialog, $state,$localStorage) {
        var invoiceCtrl = this;
        $scope.gotoPR_Types =function(){
            $state.go('app.administration.invoiceTypeList');
        }
          if ($localStorage.menubarsetting != undefined) {
                     $scope.showsForms = $localStorage.menubarsetting.formsmanagement;
                      $scope.showWorkflow = $localStorage.menubarsetting.adminWorkflow; 
                     $scope.showrequestManagement = $localStorage.menubarsetting.requestManagement;
                     $scope.showListManagement = $localStorage.menubarsetting.listManagement;
                     $scope.showBusinessObject = $localStorage.menubarsetting.businessObject;
                     $scope.showBinder = $localStorage.menubarsetting.binder;
                     $scope.showTemplates = $localStorage.menubarsetting.templates;
                     $scope.showReports1 = $localStorage.menubarsetting.adminReports;
                  
                    
                     $scope.showSubstitution = $localStorage.menubarsetting.substitution;
                     $scope.showZohoReports = $localStorage.menubarsetting.zohoReports;
                     
                      $scope.showDocumentType  = $localStorage.menubarsetting.documentTypes;  
                       $scope.showReqTypeDetails  = $localStorage.menubarsetting.reqTypeDetails; 
                          $scope.showInvoiceTypes  = $localStorage.menubarsetting.invoiceTypes;      
                     
            }

        $("#vertical-navigation").hide();
        $("#content-container").css({ "margin-left": "0px" });
        $scope.goToPreviousState = function() {
            $state.go("app.mycontent_inbox");
            $("#vertical-navigation").show();
            $("#content-container").css({ "margin-left": "60px" });
         }

    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core',
            [
                'ngAnimate',
                'ngAria',
                'ngCookies',
                'ngMessages',
                'ngResource',
                'ngSanitize',
                'ngMaterial',
                'pascalprecht.translate',
                'textAngular',
                'ui.router'
                
            ]);
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsWidgetController', MsWidgetController)
        .directive('msWidget', msWidgetDirective)
        .directive('msWidgetFront', msWidgetFrontDirective)
        .directive('msWidgetBack', msWidgetBackDirective);

    /** @ngInject */
    function MsWidgetController($scope, $element)
    {
        var vm = this;

        // Data
        vm.flipped = false;

        // Methods
        vm.flip = flip;

        //////////

        /**
         * Flip the widget
         */
        function flip()
        {
            if ( !isFlippable() )
            {
                return;
            }

            // Toggle flipped status
            vm.flipped = !vm.flipped;

            // Toggle the 'flipped' class
            $element.toggleClass('flipped', vm.flipped);
        }

        /**
         * Check if widget is flippable
         *
         * @returns {boolean}
         */
        function isFlippable()
        {
            return (angular.isDefined($scope.flippable) && $scope.flippable === true);
        }
    }

    /** @ngInject */
    function msWidgetDirective()
    {
        return {
            restrict  : 'E',
            scope     : {
                flippable: '=?'
            },
            controller: 'MsWidgetController',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    //////////
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetFrontDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-front');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetBackDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-back');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsTimelineController', MsTimelineController)
        .directive('msTimeline', msTimelineDirective)
        .directive('msTimelineItem', msTimelineItemDirective);

    /** @ngInject */
    function MsTimelineController()
    {
        var vm = this;

        // Data
        vm.scrollEl = undefined;

        // Methods
        vm.setScrollEl = setScrollEl;
        vm.getScrollEl = getScrollEl;

        //////////

        /**
         * Set scroll element
         *
         * @param scrollEl
         */
        function setScrollEl(scrollEl)
        {
            vm.scrollEl = scrollEl;
        }

        /**
         * Get scroll element
         *
         * @returns {undefined|*}
         */
        function getScrollEl()
        {
            return vm.scrollEl;
        }
    }

    /** @ngInject */
    function msTimelineDirective()
    {
        return {
            scope     : {
                msTimeline: '=?',
                loadMore  : '&?msTimelineLoadMore'
            },
            controller: 'MsTimelineController',
            compile   : function (tElement)
            {
                tElement.addClass('ms-timeline');

                return function postLink(scope, iElement, iAttrs, MsTimelineCtrl)
                {
                    // Create an element for triggering the load more action and append it
                    var loadMoreEl = angular.element('<div class="ms-timeline-loader md-accent-bg md-whiteframe-4dp"><span class="spinner animate-rotate"></span></div>');
                    iElement.append(loadMoreEl);

                    // Default config
                    var config = {
                        scrollEl: '#content'
                    };

                    // Extend the configuration
                    config = angular.extend(config, scope.msTimeline, {});
                    
                    // Grab the scrollable element and store it in the controller for general use
                    var scrollEl = angular.element(config.scrollEl);
                    MsTimelineCtrl.setScrollEl(scrollEl);

                    // Threshold
                    var threshold = 144;

                    // Register onScroll event for the first time
                    registerOnScroll();

                    /**
                     * onScroll Event
                     */
                    function onScroll()
                    {
                        if ( scrollEl.scrollTop() + scrollEl.height() + threshold > loadMoreEl.position().top )
                        {
                            // Show the loader
                            loadMoreEl.addClass('show');

                            // Unregister scroll event to prevent triggering the function over and over again
                            unregisterOnScroll();

                            // Trigger load more event
                            scope.loadMore().then(
                                // Success
                                function ()
                                {
                                    // Hide the loader
                                    loadMoreEl.removeClass('show');

                                    // Register the onScroll event again
                                    registerOnScroll();
                                },

                                // Error
                                function ()
                                {
                                    // Remove the loader completely
                                    loadMoreEl.remove();
                                }
                            );
                        }
                    }

                    /**
                     * onScroll event registerer
                     */
                    function registerOnScroll()
                    {
                        scrollEl.on('scroll', onScroll);
                    }

                    /**
                     * onScroll event unregisterer
                     */
                    function unregisterOnScroll()
                    {
                        scrollEl.off('scroll', onScroll);
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        unregisterOnScroll();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msTimelineItemDirective($timeout, $q)
    {
        return {
            scope  : true,
            require: '^msTimeline',
            compile: function (tElement)
            {
                tElement.addClass('ms-timeline-item').addClass('hidden');

                return function postLink(scope, iElement, iAttrs, MsTimelineCtrl)
                {
                    var threshold = 72,
                        itemLoaded = false,
                        itemInViewport = false,
                        scrollEl = MsTimelineCtrl.getScrollEl();

                    //////////

                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Check if the timeline item has ms-card
                        if ( iElement.find('ms-card') )
                        {
                            // If the ms-card template loaded...
                            scope.$on('msCard::cardTemplateLoaded', function (event, args)
                            {
                                var cardEl = angular.element(args[0]);

                                // Test the card to see if there is any image on it
                                testForImage(cardEl).then(function ()
                                {
                                    $timeout(function ()
                                    {
                                        itemLoaded = true;
                                    });
                                });
                            });
                        }
                        else
                        {
                            // Test the element to see if there is any image on it
                            testForImage(iElement).then(function ()
                            {
                                $timeout(function ()
                                {
                                    itemLoaded = true;
                                });
                            });
                        }

                        // Check if the loaded element also in the viewport
                        scrollEl.on('scroll', testForVisibility);

                        // Test for visibility for the first time without waiting for the scroll event
                        testForVisibility();
                    }

                    // Item ready watcher
                    var itemReadyWatcher = scope.$watch(
                        function ()
                        {
                            return itemLoaded && itemInViewport;
                        },
                        function (current, old)
                        {
                            if ( angular.equals(current, old) )
                            {
                                return;
                            }

                            if ( current )
                            {
                                iElement.removeClass('hidden').addClass('animate');

                                // Unbind itemReadyWatcher
                                itemReadyWatcher();
                            }
                        }, true);

                    /**
                     * Test the given element for image
                     *
                     * @param element
                     * @returns promise
                     */
                    function testForImage(element)
                    {
                        var deferred = $q.defer(),
                            imgEl = element.find('img');

                        if ( imgEl.length > 0 )
                        {
                            imgEl.on('load', function ()
                            {
                                deferred.resolve('Image is loaded');
                            });
                        }
                        else
                        {
                            deferred.resolve('No images');
                        }

                        return deferred.promise;
                    }

                    /**
                     * Test the element for visibility
                     */
                    function testForVisibility()
                    {
                        if ( scrollEl.scrollTop() + scrollEl.height() > iElement.position().top + threshold )
                        {
                            $timeout(function ()
                            {
                                itemInViewport = true;
                            });

                            // Unbind the scroll event
                            scrollEl.off('scroll', testForVisibility);
                        }
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsStepperController', MsStepperController)
        .directive('msHorizontalStepper', msHorizontalStepperDirective)
        .directive('msHorizontalStepperStep', msHorizontalStepperStepDirective)
        .directive('msVerticalStepper', msVerticalStepperDirective)
        .directive('msVerticalStepperStep', msVerticalStepperStepDirective);

    /** @ngInject */
    function MsStepperController($timeout)
    {
        var vm = this;

        // Data
        vm.mainForm = undefined;

        vm.orientation = 'horizontal';
        vm.steps = [];
        vm.currentStep = undefined;
        vm.currentStepNumber = 1;

        // Methods
        vm.setOrientation = setOrientation;
        vm.registerMainForm = registerMainForm;
        vm.registerStep = registerStep;
        vm.setupSteps = setupSteps;
        vm.resetForm = resetForm;

        vm.setCurrentStep = setCurrentStep;

        vm.gotoStep = gotoStep;
        vm.gotoPreviousStep = gotoPreviousStep;
        vm.gotoNextStep = gotoNextStep;
        vm.gotoFirstStep = gotoFirstStep;
        vm.gotoLastStep = gotoLastStep;

        vm.isFirstStep = isFirstStep;
        vm.isLastStep = isLastStep;

        vm.isStepCurrent = isStepCurrent;
        vm.isStepDisabled = isStepDisabled;
        vm.isStepOptional = isStepOptional;
        vm.isStepHidden = isStepHidden;
        vm.filterHiddenStep = filterHiddenStep;
        vm.isStepValid = isStepValid;
        vm.isStepNumberValid = isStepNumberValid;

        vm.isFormValid = isFormValid;

        //////////

        /**
         * Set the orientation of the stepper
         *
         * @param orientation
         */
        function setOrientation(orientation)
        {
            vm.orientation = orientation || 'horizontal';
        }

        /**
         * Register the main form
         *
         * @param form
         */
        function registerMainForm(form)
        {
            vm.mainForm = form;
        }

        /**
         * Register a step
         *
         * @param element
         * @param scope
         * @param form
         */
        function registerStep(element, scope, form)
        {
            var step = {
                element   : element,
                scope     : scope,
                form      : form,
                stepNumber: scope.step || (vm.steps.length + 1),
                stepTitle : scope.stepTitle
            };

            // Push the step into steps array
            vm.steps.push(step);

            // Sort steps by stepNumber
            vm.steps.sort(function (a, b)
            {
                return a.stepNumber - b.stepNumber;
            });
            
            return step;
        }

        /**
         * Setup steps for the first time
         */
        function setupSteps()
        {
            vm.setCurrentStep(vm.currentStepNumber);
        }

        /**
         * Reset steps and the main form
         */
        function resetForm()
        {
            // Timeout is required here because we need to
            // let form model to reset before setting the
            // statuses
            $timeout(function ()
            {
                // Reset all the steps
                for ( var x = 0; x < vm.steps.length; x++ )
                {
                    vm.steps[x].form.$setPristine();
                    vm.steps[x].form.$setUntouched();
                }

                // Reset the main form
                vm.mainForm.$setPristine();
                vm.mainForm.$setUntouched();

                // Go to first step
                gotoFirstStep();
            });
        }

        /**
         * Set current step
         *
         * @param stepNumber
         */
        function setCurrentStep(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return;
            }

            // Update the current step number
            vm.currentStepNumber = stepNumber;

            if ( vm.orientation === 'horizontal' )
            {
                // Hide all steps
                for ( var i = 0; i < vm.steps.length; i++ )
                {
                    vm.steps[i].element.hide();
                }

                // Show the current step
                vm.steps[vm.currentStepNumber - 1].element.show();
            }
            else if ( vm.orientation === 'vertical' )
            {
                // Hide all step content
                for ( var j = 0; j < vm.steps.length; j++ )
                {
                    vm.steps[j].element.find('.ms-stepper-step-content').hide();
                }

                // Show the current step content
                vm.steps[vm.currentStepNumber - 1].element.find('.ms-stepper-step-content').show();
            }
        }

        /**
         * Go to a step
         *
         * @param stepNumber
         */
        function gotoStep(stepNumber)
        {
            // If the step we are about to go
            // is hidden, bail...
            if ( isStepHidden(stepNumber) )
            {
                return;
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the previous step
         */
        function gotoPreviousStep()
        {
            var stepNumber = vm.currentStepNumber - 1;

            // Test the previous steps and make sure we
            // will land to the one that is not hidden
            for ( var s = stepNumber; s >= 1; s-- )
            {
                if ( !isStepHidden(s) )
                {
                    stepNumber = s;
                    break;
                }
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the next step
         */
        function gotoNextStep()
        {
            var stepNumber = vm.currentStepNumber + 1;

            // Test the following steps and make sure we
            // will land to the one that is not hidden
            for ( var s = stepNumber; s <= vm.steps.length; s++ )
            {
                if ( !isStepHidden(s) )
                {
                    stepNumber = s;
                    break;
                }
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the first step
         */
        function gotoFirstStep()
        {
            vm.setCurrentStep(1);
        }

        /**
         * Go to the last step
         */
        function gotoLastStep()
        {
            vm.setCurrentStep(vm.steps.length);
        }

        /**
         * Check if the current step is the first step
         *
         * @returns {boolean}
         */
        function isFirstStep()
        {
            return vm.currentStepNumber === 1;
        }

        /**
         * Check if the current step is the last step
         *
         * @returns {boolean}
         */
        function isLastStep()
        {
            return vm.currentStepNumber === vm.steps.length;
        }

        /**
         * Check if the given step is the current one
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepCurrent(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return vm.currentStepNumber === stepNumber;
        }

        /**
         * Check if the given step should be disabled
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepDisabled(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            var disabled = false;

            for ( var i = 1; i < stepNumber; i++ )
            {
                if ( !isStepValid(i) )
                {
                    disabled = true;
                    break;
                }
            }

            return disabled;
        }

        /**
         * Check if the given step is optional
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepOptional(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return vm.steps[stepNumber - 1].scope.optionalStep;
        }

        /**
         * Check if the given step is hidden
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepHidden(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return !!vm.steps[stepNumber - 1].scope.hideStep;
        }

        /**
         * Check if the given step is hidden as a filter
         *
         * @param step
         * @returns {boolean}
         */
        function filterHiddenStep(step)
        {
            return !isStepHidden(step.stepNumber);
        }

        /**
         * Check if the given step is valid
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepValid(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            // If the step is optional, always return true
            if ( isStepOptional(stepNumber) )
            {
                return true;
            }

            return vm.steps[stepNumber - 1].form.$valid;
        }

        /**
         * Check if the given step number is a valid step number
         *
         * @param stepNumber
         * @returns {boolean}
         */
        function isStepNumberValid(stepNumber)
        {
            return !(angular.isUndefined(stepNumber) || stepNumber < 1 || stepNumber > vm.steps.length);
        }

        /**
         * Check if the entire form is valid
         *
         * @returns {boolean}
         */
        function isFormValid()
        {
            return vm.mainForm.$valid;
        }
    }

    /** @ngInject */
    function msHorizontalStepperDirective()
    {
        return {
            restrict        : 'A',
            scope           : {},
            require         : ['form', 'msHorizontalStepper'],
            priority        : 1001,
            controller      : 'MsStepperController as MsStepper',
            bindToController: {
                model: '=ngModel'
            },
            transclude      : true,
            templateUrl     : 'app/core/directives/ms-stepper/templates/horizontal/horizontal.html',
            compile         : function (tElement)
            {
                tElement.addClass('ms-stepper');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Register the main form and setup
                    // the steps for the first time
                    MsStepperCtrl.setOrientation('horizontal');
                    MsStepperCtrl.registerMainForm(FormCtrl);
                    MsStepperCtrl.setupSteps();
                };
            }
        };
    }

    /** @ngInject */
    function msHorizontalStepperStepDirective()
    {
        return {
            restrict: 'E',
            require : ['form', '^msHorizontalStepper'],
            priority: 1000,
            scope   : {
                step        : '=?',
                stepTitle   : '=?',
                optionalStep: '=?',
                hideStep    : '=?'
            },
            compile : function (tElement)
            {
                tElement.addClass('ms-stepper-step');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Is it an optional step?
                    scope.optionalStep = angular.isDefined(iAttrs.optionalStep);

                    // Register the step
                    MsStepperCtrl.registerStep(iElement, scope, FormCtrl);

                    // Hide the step by default
                    iElement.hide();
                };
            }
        };
    }

    /** @ngInject */
    function msVerticalStepperDirective($timeout)
    {
        return {
            restrict        : 'A',
            scope           : {},
            require         : ['form', 'msVerticalStepper'],
            priority        : 1001,
            controller      : 'MsStepperController as MsStepper',
            bindToController: {
                model: '=ngModel'
            },
            transclude      : true,
            templateUrl     : 'app/core/directives/ms-stepper/templates/vertical/vertical.html',
            compile         : function (tElement)
            {
                tElement.addClass('ms-stepper');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Register the main form and setup
                    // the steps for the first time

                    // Timeout is required in vertical stepper
                    // as we are using transclusion in steps.
                    // We have to wait for them to be transcluded
                    // and registered to the controller
                    $timeout(function ()
                    {
                        MsStepperCtrl.setOrientation('vertical');
                        MsStepperCtrl.registerMainForm(FormCtrl);
                        MsStepperCtrl.setupSteps();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msVerticalStepperStepDirective()
    {
        return {
            restrict   : 'E',
            require    : ['form', '^msVerticalStepper'],
            priority   : 1000,
            scope      : {
                step        : '=?',
                stepTitle   : '=?',
                optionalStep: '=?',
                hideStep    : '=?'
            },
            transclude : true,
            templateUrl: 'app/core/directives/ms-stepper/templates/vertical/step/vertical-step.html',
            compile    : function (tElement)
            {
                tElement.addClass('ms-stepper-step');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Is it an optional step?
                    scope.optionalStep = angular.isDefined(iAttrs.optionalStep);
                    
                    // Register the step
                    scope.stepInfo = MsStepperCtrl.registerStep(iElement, scope, FormCtrl);

                    // Expose the controller to the scope
                    scope.MsStepper = MsStepperCtrl;

                    // Hide the step content by default
                    iElement.find('.ms-stepper-step-content').hide();
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSplashScreen', msSplashScreenDirective);

    /** @ngInject */
    function msSplashScreenDirective($animate)
    {
        return {
            restrict: 'E',
            link    : function (scope, iElement)
            {
                var splashScreenRemoveEvent = scope.$on('msSplashScreen::remove', function ()
                {
                    $animate.leave(iElement).then(function ()
                    {
                        // De-register scope event
                        splashScreenRemoveEvent();

                        // Null-ify everything else
                        scope = iElement = null;
                    });
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSidenavHelper', msSidenavHelperDirective);

    /** @ngInject */
    function msSidenavHelperDirective()
    {
        return {
            restrict: 'A',
            require : '^mdSidenav',
            link    : function (scope, iElement, iAttrs, MdSidenavCtrl)
            {
                // Watch md-sidenav open & locked open statuses
                // and add class to the ".page-layout" if only
                // the sidenav open and NOT locked open
                scope.$watch(function ()
                {
                    return MdSidenavCtrl.isOpen() && !MdSidenavCtrl.isLockedOpen();
                }, function (current)
                {
                    if ( angular.isUndefined(current) )
                    {
                        return;
                    }

                    iElement.parent().toggleClass('full-height', current);
                    angular.element('html').toggleClass('sidenav-open', current);
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsShortcutsController', MsShortcutsController)
        .directive('msShortcuts', msShortcutsDirective);

    /** @ngInject */
    function MsShortcutsController($scope, $cookies, $document, $timeout, $q, msNavigationService)
    {
        var vm = this;

        // Data
        vm.query = '';
        vm.queryOptions = {
            debounce: 300
        };
        vm.resultsLoading = false;
        vm.selectedResultIndex = 0;
        vm.ignoreMouseEvents = false;
        vm.mobileBarActive = false;

        vm.results = null;
        vm.shortcuts = [];

        vm.sortableOptions = {
            ghostClass   : 'ghost',
            forceFallback: true,
            fallbackClass: 'dragging',
            onSort       : function ()
            {
                vm.saveShortcuts();
            }
        };

        // Methods
        vm.populateResults = populateResults;
        vm.loadShortcuts = loadShortcuts;
        vm.saveShortcuts = saveShortcuts;
        vm.addShortcut = addShortcut;
        vm.removeShortcut = removeShortcut;
        vm.handleResultClick = handleResultClick;

        vm.absorbEvent = absorbEvent;
        vm.handleKeydown = handleKeydown;
        vm.handleMouseenter = handleMouseenter;
        vm.temporarilyIgnoreMouseEvents = temporarilyIgnoreMouseEvents;
        vm.ensureSelectedResultIsVisible = ensureSelectedResultIsVisible;
        vm.toggleMobileBar = toggleMobileBar;

        //////////

        init();

        function init()
        {
            // Load the shortcuts
            vm.loadShortcuts().then(
                // Success
                function (response)
                {
                    vm.shortcuts = response;

                    // Add shortcuts as results by default
                    if ( vm.shortcuts.length > 0 )
                    {
                        vm.results = response;
                    }
                }
            );

            // Watch the model changes to trigger the search
            $scope.$watch('MsShortcuts.query', function (current, old)
            {
                if ( angular.isUndefined(current) )
                {
                    return;
                }

                if ( angular.equals(current, old) )
                {
                    return;
                }

                // Show the loader
                vm.resultsLoading = true;

                // Populate the results
                vm.populateResults().then(
                    // Success
                    function (response)
                    {
                        vm.results = response;
                    },
                    // Error
                    function ()
                    {
                        vm.results = [];
                    }
                ).finally(
                    function ()
                    {
                        // Hide the loader
                        vm.resultsLoading = false;
                    }
                );
            });
        }

        /**
         * Populate the results
         */
        function populateResults()
        {
            var results = [],
                flatNavigation = msNavigationService.getFlatNavigation(),
                deferred = $q.defer();

            // Iterate through the navigation array and
            // make sure it doesn't have any groups or
            // none ui-sref items
            for ( var x = 0; x < flatNavigation.length; x++ )
            {
                if ( flatNavigation[x].uisref )
                {
                    results.push(flatNavigation[x]);
                }
            }

            // If there is a query, filter the results
            if ( vm.query )
            {
                results = results.filter(function (item)
                {
                    if ( angular.lowercase(item.title).search(angular.lowercase(vm.query)) > -1 )
                    {
                        return true;
                    }
                });

                // Iterate through one last time and
                // add required properties to items
                for ( var i = 0; i < results.length; i++ )
                {
                    // Add false to hasShortcut by default
                    results[i].hasShortcut = false;

                    // Test if the item is in the shortcuts list
                    for ( var y = 0; y < vm.shortcuts.length; y++ )
                    {
                        if ( vm.shortcuts[y]._id === results[i]._id )
                        {
                            results[i].hasShortcut = true;
                            break;
                        }
                    }
                }
            }
            else
            {
                // If the query is empty, that means
                // there is nothing to search for so
                // we will populate the results with
                // current shortcuts if there is any
                if ( vm.shortcuts.length > 0 )
                {
                    results = vm.shortcuts;
                }
            }

            // Reset the selected result
            vm.selectedResultIndex = 0;

            // Fake the service delay
            $timeout(function ()
            {
                // Resolve the promise
                deferred.resolve(results);
            }, 250);

            // Return a promise
            return deferred.promise;
        }

        /**
         * Load shortcuts
         */
        function loadShortcuts()
        {
            var deferred = $q.defer();

            // For the demo purposes, we will
            // load the shortcuts from the cookies.
            // But here you can make an API call
            // to load them from the DB.
            var shortcuts = angular.fromJson($cookies.get('FUSE.shortcuts'));

            // No cookie available. Generate one
            // for the demo purposes...
            if ( angular.isUndefined(shortcuts) )
            {
                shortcuts = [
                    // {
                    //     'title'      : 'Sample',
                    //     'icon'       : 'icon-tile-four',
                    //     'state'      : 'app.sample',
                    //     'weight'     : 1,
                    //     'children'   : [],
                    //     '_id'        : 'sample',
                    //     '_path'      : 'apps.sample',
                    //     'uisref'     : 'app.sample',
                    //     'hasShortcut': true
                    // }
                ];

                $cookies.put('FUSE.shortcuts', angular.toJson(shortcuts));
            }

            // Resolve the promise
            deferred.resolve(shortcuts);

            return deferred.promise;
        }

        /**
         * Save the shortcuts
         */
        function saveShortcuts()
        {
            var deferred = $q.defer();

            // For the demo purposes, we will
            // keep the shortcuts in the cookies.
            // But here you can make an API call
            // to save them to the DB.
            $cookies.put('FUSE.shortcuts', angular.toJson(vm.shortcuts));

            // Fake the service delay
            $timeout(function ()
            {
                deferred.resolve({'success': true});
            }, 250);

            return deferred.promise;
        }

        /**
         * Add item as shortcut
         *
         * @param item
         */
        function addShortcut(item)
        {
            // Update the hasShortcut status
            item.hasShortcut = true;

            // Add as a shortcut
            vm.shortcuts.push(item);

            // Save the shortcuts
            vm.saveShortcuts();
        }

        /**
         * Remove item from shortcuts
         *
         * @param item
         */
        function removeShortcut(item)
        {
            // Update the hasShortcut status
            item.hasShortcut = false;

            // Remove the shortcut
            for ( var x = 0; x < vm.shortcuts.length; x++ )
            {
                if ( vm.shortcuts[x]._id === item._id )
                {
                    // Remove the x-th item from the array
                    vm.shortcuts.splice(x, 1);

                    // If we aren't searching for anything...
                    if ( !vm.query )
                    {
                        // If all the shortcuts have been removed,
                        // null-ify the results
                        if ( vm.shortcuts.length === 0 )
                        {
                            vm.results = null;
                        }
                        // Otherwise update the selected index
                        else
                        {
                            if ( x >= vm.shortcuts.length )
                            {
                                vm.selectedResultIndex = vm.shortcuts.length - 1;
                            }
                        }
                    }
                }
            }

            // Save the shortcuts
            vm.saveShortcuts();
        }

        /**
         * Handle the result click
         *
         * @param item
         */
        function handleResultClick(item)
        {
            // Add or remove the shortcut
            if ( item.hasShortcut )
            {
                vm.removeShortcut(item);
            }
            else
            {
                vm.addShortcut(item);
            }
        }

        /**
         * Absorb the given event
         *
         * @param event
         */
        function absorbEvent(event)
        {
            event.preventDefault();
        }

        /**
         * Handle keydown
         *
         * @param event
         */
        function handleKeydown(event)
        {
            var keyCode = event.keyCode,
                keys = [38, 40];

            // Prevent the default action if
            // one of the keys are pressed that
            // we are listening
            if ( keys.indexOf(keyCode) > -1 )
            {
                event.preventDefault();
            }

            switch ( keyCode )
            {
                // Enter
                case 13:

                    // Trigger result click
                    vm.handleResultClick(vm.results[vm.selectedResultIndex]);

                    break;

                // Up Arrow
                case 38:

                    // Decrease the selected result index
                    if ( vm.selectedResultIndex - 1 >= 0 )
                    {
                        // Decrease the selected index
                        vm.selectedResultIndex--;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                // Down Arrow
                case 40:

                    // Increase the selected result index
                    if ( vm.selectedResultIndex + 1 < vm.results.length )
                    {
                        // Increase the selected index
                        vm.selectedResultIndex++;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                default:
                    break;
            }
        }

        /**
         * Handle mouseenter
         *
         * @param index
         */
        function handleMouseenter(index)
        {
            if ( vm.ignoreMouseEvents )
            {
                return;
            }

            // Update the selected result index
            // with the given index
            vm.selectedResultIndex = index;
        }

        /**
         * Set a variable for a limited time
         * to make other functions to ignore
         * the mouse events
         */
        function temporarilyIgnoreMouseEvents()
        {
            // Set the variable
            vm.ignoreMouseEvents = true;

            // Cancel the previous timeout
            $timeout.cancel(vm.mouseEventIgnoreTimeout);

            // Set the timeout
            vm.mouseEventIgnoreTimeout = $timeout(function ()
            {
                vm.ignoreMouseEvents = false;
            }, 250);
        }

        /**
         * Ensure the selected result will
         * always be visible on the results
         * area
         */
        function ensureSelectedResultIsVisible()
        {
            var resultsEl = $document.find('#ms-shortcut-add-menu').find('.results'),
                selectedItemEl = angular.element(resultsEl.find('.result')[vm.selectedResultIndex]);

            if ( resultsEl && selectedItemEl )
            {
                var top = selectedItemEl.position().top - 8,
                    bottom = selectedItemEl.position().top + selectedItemEl.outerHeight() + 8;

                // Start ignoring mouse events
                vm.temporarilyIgnoreMouseEvents();

                if ( resultsEl.scrollTop() > top )
                {
                    resultsEl.scrollTop(top);
                }

                if ( bottom > (resultsEl.height() + resultsEl.scrollTop()) )
                {
                    resultsEl.scrollTop(bottom - resultsEl.height());
                }
            }
        }

        /**
         * Toggle mobile bar
         */
        function toggleMobileBar()
        {
            vm.mobileBarActive = !vm.mobileBarActive;
        }
    }

    /** @ngInject */
    function msShortcutsDirective()
    {
        return {
            restrict        : 'E',
            scope           : {},
            require         : 'msShortcuts',
            controller      : 'MsShortcutsController as MsShortcuts',
            bindToController: {},
            templateUrl     : 'app/core/directives/ms-shortcuts/ms-shortcuts.html',
            compile         : function (tElement)
            {
                // Add class
                tElement.addClass('ms-shortcuts');

                return function postLink(scope, iElement)
                {
                    // Data

                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsSearchBarController', MsSearchBarController)
        .directive('msSearchBar', msSearchBarDirective);

    /** @ngInject */
    function MsSearchBarController($scope, $element, $timeout)
    {
        var vm = this;

        // Data
        vm.collapsed = true;
        vm.query = '';
        vm.queryOptions = {
            debounce: vm.debounce || 0
        };
        vm.resultsLoading = false;
        vm.results = null;
        vm.selectedResultIndex = 0;
        vm.ignoreMouseEvents = false;

        // Methods
        vm.populateResults = populateResults;

        vm.expand = expand;
        vm.collapse = collapse;

        vm.absorbEvent = absorbEvent;
        vm.handleKeydown = handleKeydown;
        vm.handleMouseenter = handleMouseenter;
        vm.temporarilyIgnoreMouseEvents = temporarilyIgnoreMouseEvents;
        vm.handleResultClick = handleResultClick;
        vm.ensureSelectedResultIsVisible = ensureSelectedResultIsVisible;

        //////////

        init();

        function init()
        {
            // Watch the model changes to trigger the search
            $scope.$watch('MsSearchBar.query', function (current, old)
            {
                if ( angular.isUndefined(current) )
                {
                    return;
                }

                if ( angular.equals(current, old) )
                {
                    return;
                }

                if ( vm.collapsed )
                {
                    return;
                }

                // Evaluate the onSearch function to access the
                // function itself
                var onSearchEvaluated = $scope.$parent.$eval(vm.onSearch, {query: current}),
                    isArray = angular.isArray(onSearchEvaluated),
                    isPromise = (onSearchEvaluated && !!onSearchEvaluated.then);

                if ( isArray )
                {
                    // Populate the results
                    vm.populateResults(onSearchEvaluated);
                }

                if ( isPromise )
                {
                    // Show the loader
                    vm.resultsLoading = true;

                    onSearchEvaluated.then(
                        // Success
                        function (response)
                        {
                            // Populate the results
                            vm.populateResults(response);
                        },
                        // Error
                        function ()
                        {
                            // Assign an empty array to show
                            // the no-results screen
                            vm.populateResults([]);
                        }
                    ).finally(function ()
                        {
                            // Hide the loader
                            vm.resultsLoading = false;
                        }
                    );
                }
            });
        }

        /**
         * Populate the results
         *
         * @param results
         */
        function populateResults(results)
        {
            // Before doing anything,
            // make sure the search bar is expanded
            if ( vm.collapsed )
            {
                return;
            }

            var isArray = angular.isArray(results),
                isNull = results === null;

            // Only accept arrays and null values
            if ( !isArray && !isNull )
            {
                return;
            }

            // Reset the selected result
            vm.selectedResultIndex = 0;

            // Populate the results
            vm.results = results;
        }

        /**
         * Expand
         */
        function expand()
        {
            // Set collapsed status
            vm.collapsed = false;

            // Call expand on scope
            $scope.expand();

            // Callback
            if ( vm.onExpand && angular.isFunction(vm.onExpand) )
            {
                vm.onExpand();
            }
        }

        /**
         * Collapse
         */
        function collapse()
        {
            // Empty the query
            vm.query = '';

            // Empty results to hide the results view
            vm.populateResults(null);

            // Set collapsed status
            vm.collapsed = true;

            // Call collapse on scope
            $scope.collapse();

            // Callback
            if ( vm.onCollapse && angular.isFunction(vm.onCollapse) )
            {
                vm.onCollapse();
            }
        }

        /**
         * Absorb the given event
         *
         * @param event
         */
        function absorbEvent(event)
        {
            event.preventDefault();
        }

        /**
         * Handle keydown
         *
         * @param event
         */
        function handleKeydown(event)
        {
            var keyCode = event.keyCode,
                keys = [27, 38, 40];

            // Prevent the default action if
            // one of the keys are pressed that
            // we are listening
            if ( keys.indexOf(keyCode) > -1 )
            {
                event.preventDefault();
            }

            switch ( keyCode )
            {
                // Enter
                case 13:

                    // Trigger result click
                    vm.handleResultClick(vm.results[vm.selectedResultIndex]);

                    break;

                // Escape
                case 27:

                    // Collapse the search bar
                    vm.collapse();

                    break;

                // Up Arrow
                case 38:

                    // Decrease the selected result index
                    if ( vm.selectedResultIndex - 1 >= 0 )
                    {
                        // Decrease the selected index
                        vm.selectedResultIndex--;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                // Down Arrow
                case 40:

                    if ( !vm.results )
                    {
                        return;
                    }

                    // Increase the selected result index
                    if ( vm.selectedResultIndex + 1 < vm.results.length )
                    {
                        // Increase the selected index
                        vm.selectedResultIndex++;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                default:
                    break;
            }
        }

        /**
         * Handle mouseenter
         *
         * @param index
         */
        function handleMouseenter(index)
        {
            if ( vm.ignoreMouseEvents )
            {
                return;
            }

            // Update the selected result index
            // with the given index
            vm.selectedResultIndex = index;
        }

        /**
         * Set a variable for a limited time
         * to make other functions to ignore
         * the mouse events
         */
        function temporarilyIgnoreMouseEvents()
        {
            // Set the variable
            vm.ignoreMouseEvents = true;

            // Cancel the previous timeout
            $timeout.cancel(vm.mouseEventIgnoreTimeout);

            // Set the timeout
            vm.mouseEventIgnoreTimeout = $timeout(function ()
            {
                vm.ignoreMouseEvents = false;
            }, 250);
        }

        /**
         * Handle the result click
         *
         * @param item
         */
        function handleResultClick(item)
        {
            if ( vm.onResultClick )
            {
                vm.onResultClick({item: item});
            }

            // Collapse the search bar
            vm.collapse();
        }

        /**
         * Ensure the selected result will
         * always be visible on the results
         * area
         */
        function ensureSelectedResultIsVisible()
        {
            var resultsEl = $element.find('.ms-search-bar-results'),
                selectedItemEl = angular.element(resultsEl.find('.result')[vm.selectedResultIndex]);

            if ( resultsEl && selectedItemEl )
            {
                var top = selectedItemEl.position().top - 8,
                    bottom = selectedItemEl.position().top + selectedItemEl.outerHeight() + 8;

                // Start ignoring mouse events
                vm.temporarilyIgnoreMouseEvents();

                if ( resultsEl.scrollTop() > top )
                {
                    resultsEl.scrollTop(top);
                }

                if ( bottom > (resultsEl.height() + resultsEl.scrollTop()) )
                {
                    resultsEl.scrollTop(bottom - resultsEl.height());
                }
            }
        }
    }

    /** @ngInject */
    function msSearchBarDirective($document)
    {
        return {
            restrict        : 'E',
            scope           : {},
            require         : 'msSearchBar',
            controller      : 'MsSearchBarController as MsSearchBar',
            bindToController: {
                debounce     : '=?',
                onSearch     : '@',
                onResultClick: '&?',
                onExpand     : '&?',
                onCollapse   : '&?'
            },
            templateUrl     : 'app/core/directives/ms-search-bar/ms-search-bar.html',
            compile         : function (tElement)
            {
                // Add class
                tElement.addClass('ms-search-bar');

                return function postLink(scope, iElement)
                {
                    // Data
                    var inputEl,
                        bodyEl = $document.find('body');

                    // Methods
                    scope.collapse = collapse;
                    scope.expand = expand;

                    //////////

                    // Initialize
                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Grab the input element
                        inputEl = iElement.find('#ms-search-bar-input');
                    }

                    /**
                     * Expand action
                     */
                    function expand()
                    {
                        // Add expanded class
                        iElement.addClass('expanded');

                        // Add helper class to the body
                        bodyEl.addClass('ms-search-bar-expanded');

                        // Focus on the input
                        inputEl.focus();
                    }

                    /**
                     * Collapse action
                     */
                    function collapse()
                    {
                        // Remove expanded class
                        iElement.removeClass('expanded');

                        // Remove helper class from the body
                        bodyEl.removeClass('ms-search-bar-expanded');
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msScrollConfig', msScrollConfigProvider)
        .directive('msScroll', msScrollDirective);

    /** @ngInject */
    function msScrollConfigProvider()
    {
        // Default configuration
        var defaultConfiguration = {
            wheelSpeed            : 1,
            wheelPropagation      : false,
            swipePropagation      : true,
            minScrollbarLength    : null,
            maxScrollbarLength    : null,
            useBothWheelAxes      : false,
            useKeyboard           : true,
            suppressScrollX       : false,
            suppressScrollY       : false,
            scrollXMarginOffset   : 0,
            scrollYMarginOffset   : 0,
            stopPropagationOnClick: true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            defaultConfiguration = angular.extend({}, defaultConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig
            };

            return service;

            //////////

            /**
             * Return the config
             */
            function getConfig()
            {
                return defaultConfiguration;
            }
        };
    }

    /** @ngInject */
    function msScrollDirective($timeout, msScrollConfig, msUtils, fuseConfig)
    {
        return {
            restrict: 'AE',
            compile : function (tElement)
            {
                // Do not replace scrollbars if
                // 'disableCustomScrollbars' config enabled
                if ( fuseConfig.getConfig('disableCustomScrollbars') )
                {
                    return;
                }

                // Do not replace scrollbars on mobile devices
                // if 'disableCustomScrollbarsOnMobile' config enabled
                if ( fuseConfig.getConfig('disableCustomScrollbarsOnMobile') && msUtils.isMobile() )
                {
                    return;
                }

                // Add class
                tElement.addClass('ms-scroll');

                return function postLink(scope, iElement, iAttrs)
                {
                    var options = {};

                    // If options supplied, evaluate the given
                    // value. This is because we don't want to
                    // have an isolated scope but still be able
                    // to use scope variables.
                    // We don't want an isolated scope because
                    // we should be able to use this everywhere
                    // especially with other directives
                    if ( iAttrs.msScroll )
                    {
                        options = scope.$eval(iAttrs.msScroll);
                    }

                    // Extend the given config with the ones from provider
                    options = angular.extend({}, msScrollConfig.getConfig(), options);

                    // Initialize the scrollbar
                    $timeout(function ()
                    {
                        PerfectScrollbar.initialize(iElement[0], options);
                    }, 0);

                    // Update the scrollbar on element mouseenter
                    iElement.on('mouseenter', updateScrollbar);

                    // Watch scrollHeight and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollHeight');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    // Watch scrollWidth and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollWidth');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    /**
                     * Update the scrollbar
                     */
                    function updateScrollbar()
                    {
                        PerfectScrollbar.update(iElement[0]);
                    }

                    // Cleanup on destroy
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('mouseenter');
                        PerfectScrollbar.destroy(iElement[0]);
                    });
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msResponsiveTable', msResponsiveTableDirective);

    /** @ngInject */
    function msResponsiveTableDirective()
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement)
            {
                // Wrap the table
                var wrapper = angular.element('<div class="ms-responsive-table-wrapper"></div>');
                iElement.after(wrapper);
                wrapper.append(iElement);

                //////////
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msRandomClass', msRandomClassDirective);

    /** @ngInject */
    function msRandomClassDirective()
    {
        return {
            restrict: 'A',
            scope   : {
                msRandomClass: '='
            },
            link    : function (scope, iElement)
            {
                var randomClass = scope.msRandomClass[Math.floor(Math.random() * (scope.msRandomClass.length))];
                iElement.addClass(randomClass);
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msNavigationService', msNavigationServiceProvider)
        .controller('MsNavigationController', MsNavigationController)
        // Vertical
        .directive('msNavigation', msNavigationDirective)
        .controller('MsNavigationNodeController', MsNavigationNodeController)
        .directive('msNavigationNode', msNavigationNodeDirective)
        .directive('msNavigationItem', msNavigationItemDirective)
        //Horizontal
        .directive('msNavigationHorizontal', msNavigationHorizontalDirective)
        .controller('MsNavigationHorizontalNodeController', MsNavigationHorizontalNodeController)
        .directive('msNavigationHorizontalNode', msNavigationHorizontalNodeDirective)
        .directive('msNavigationHorizontalItem', msNavigationHorizontalItemDirective);

    /** @ngInject */
    function msNavigationServiceProvider()
    {
        // Inject $log service
        var $log = angular.injector(['ng']).get('$log');

        // Navigation array
        var navigation = [];

        var service = this;

        // Methods
        service.saveItem = saveItem;
        service.deleteItem = deleteItem;
        service.sortByWeight = sortByWeight;

        //////////

        /**
         * Create or update the navigation item
         *
         * @param path
         * @param item
         */
        function saveItem(path, item)
        {
            if ( !angular.isString(path) )
            {
                $log.error('path must be a string (eg. `dashboard.project`)');
                return;
            }

            var parts = path.split('.');

            // Generate the object id from the parts
            var id = parts[parts.length - 1];

            // Get the parent item from the parts
            var parent = _findOrCreateParent(parts);

            // Decide if we are going to update or create
            var updateItem = false;

            for ( var i = 0; i < parent.length; i++ )
            {
                if ( parent[i]._id === id )
                {
                    updateItem = parent[i];

                    break;
                }
            }

            // Update
            if ( updateItem )
            {
                angular.extend(updateItem, item);

                // Add proper ui-sref
                updateItem.uisref = _getUiSref(updateItem);
            }
            // Create
            else
            {
                // Create an empty children array in the item
                item.children = [];

                // Add the default weight if not provided or if it's not a number
                if ( angular.isUndefined(item.weight) || !angular.isNumber(item.weight) )
                {
                    item.weight = 1;
                }

                // Add the item id
                item._id = id;

                // Add the item path
                item._path = path;

                // Add proper ui-sref
                item.uisref = _getUiSref(item);

                // Push the item into the array
                parent.push(item);
            }
        }

        /**
         * Delete navigation item
         *
         * @param path
         */
        function deleteItem(path)
        {
            if ( !angular.isString(path) )
            {
                $log.error('path must be a string (eg. `dashboard.project`)');
                return;
            }

            // Locate the item by using given path
            var item = navigation,
                parts = path.split('.');

            for ( var p = 0; p < parts.length; p++ )
            {
                var id = parts[p];

                for ( var i = 0; i < item.length; i++ )
                {
                    if ( item[i]._id === id )
                    {
                        // If we have a matching path,
                        // we have found our object:
                        // remove it.
                        if ( item[i]._path === path )
                        {
                            item.splice(i, 1);
                            return true;
                        }

                        // Otherwise grab the children of
                        // the current item and continue
                        item = item[i].children;
                        break;
                    }
                }
            }

            return false;
        }

        /**
         * Sort the navigation items by their weights
         *
         * @param parent
         */
        function sortByWeight(parent)
        {
            // If parent not provided, sort the root items
            if ( !parent )
            {
                parent = navigation;
                parent.sort(_byWeight);
            }

            // Sort the children
            for ( var i = 0; i < parent.length; i++ )
            {
                var children = parent[i].children;

                if ( children.length > 1 )
                {
                    children.sort(_byWeight);
                }

                if ( children.length > 0 )
                {
                    sortByWeight(children);
                }
            }
        }

        /* ----------------- */
        /* Private Functions */
        /* ----------------- */

        /**
         * Find or create parent
         *
         * @param parts
         * @returns {Array|Boolean}
         * @private
         */
        function _findOrCreateParent(parts)
        {
            // Store the main navigation
            var parent = navigation;

            // If it's going to be a root item
            // return the navigation itself
            if ( parts.length === 1 )
            {
                return parent;
            }

            // Remove the last element from the parts as
            // we don't need that to figure out the parent
            parts.pop();

            // Find and return the parent
            for ( var i = 0; i < parts.length; i++ )
            {
                var _id = parts[i],
                    createParent = true;

                for ( var p = 0; p < parent.length; p++ )
                {
                    if ( parent[p]._id === _id )
                    {
                        parent = parent[p].children;
                        createParent = false;

                        break;
                    }
                }

                // If there is no parent found, create one, push
                // it into the current parent and assign it as a
                // new parent
                if ( createParent )
                {
                    var item = {
                        _id     : _id,
                        _path   : parts.join('.'),
                        title   : _id,
                        weight  : 1,
                        children: []
                    };

                    parent.push(item);
                    parent = item.children;
                }
            }

            return parent;
        }

        /**
         * Sort by weight
         *
         * @param x
         * @param y
         * @returns {number}
         * @private
         */
        function _byWeight(x, y)
        {
            return parseInt(x.weight) - parseInt(y.weight);
        }

        /**
         * Setup the ui-sref using state & state parameters
         *
         * @param item
         * @returns {string}
         * @private
         */
        function _getUiSref(item)
        {
            var uisref = '';

            if ( angular.isDefined(item.state) )
            {
                uisref = item.state;

                if ( angular.isDefined(item.stateParams) && angular.isObject(item.stateParams) )
                {
                    uisref = uisref + '(' + angular.toJson(item.stateParams) + ')';
                }
            }

            return uisref;
        }

        /* ----------------- */
        /* Service           */
        /* ----------------- */

        this.$get = function ()
        {
            var activeItem = null,
                navigationScope = null,
                folded = null,
                foldedOpen = null;

            var service = {
                saveItem          : saveItem,
                deleteItem        : deleteItem,
                sort              : sortByWeight,
                clearNavigation   : clearNavigation,
                setActiveItem     : setActiveItem,
                getActiveItem     : getActiveItem,
                getNavigation     : getNavigation,
                getFlatNavigation : getFlatNavigation,
                setNavigationScope: setNavigationScope,
                setFolded         : setFolded,
                getFolded         : getFolded,
                setFoldedOpen     : setFoldedOpen,
                getFoldedOpen     : getFoldedOpen,
                toggleFolded      : toggleFolded
            };

            return service;

            //////////

            /**
             * Clear the entire navigation
             */
            function clearNavigation()
            {
                // Clear the navigation array
                navigation = [];

                // Clear the vm.navigation from main controller
                if ( navigationScope )
                {
                    navigationScope.vm.navigation = navigation;
                }
            }

            /**
             * Set active item
             *
             * @param node
             * @param scope
             */
            function setActiveItem(node, scope)
            {
                activeItem = {
                    node : node,
                    scope: scope
                };
            }

            /**
             * Return active item
             */
            function getActiveItem()
            {
                return activeItem;
            }

            /**
             * Return navigation array
             *
             * @param root
             * @returns Array
             */
            function getNavigation(root)
            {
                if ( root )
                {
                    for ( var i = 0; i < navigation.length; i++ )
                    {
                        if ( navigation[i]._id === root )
                        {
                            return [navigation[i]];
                        }
                    }

                    return null;
                }

                return navigation;
            }

            /**
             * Return flat navigation array
             *
             * @param root
             * @returns Array
             */
            function getFlatNavigation(root)
            {
                // Get the correct navigation array
                var navigation = getNavigation(root);

                // Flatten the navigation object
                return _flattenNavigation(navigation);
            }

            /**
             * Store navigation's scope for later use
             *
             * @param scope
             */
            function setNavigationScope(scope)
            {
                navigationScope = scope;
            }

            /**
             * Set folded status
             *
             * @param status
             */
            function setFolded(status)
            {
                folded = status;
            }

            /**
             * Return folded status
             *
             * @returns {*}
             */
            function getFolded()
            {
                return folded;
            }

            /**
             * Set folded open status
             *
             * @param status
             */
            function setFoldedOpen(status)
            {
                foldedOpen = status;
            }

            /**
             * Return folded open status
             *
             * @returns {*}
             */
            function getFoldedOpen()
            {
                return foldedOpen;
            }


            /**
             * Toggle fold on stored navigation's scope
             */
            function toggleFolded()
            {
                navigationScope.toggleFolded();
            }

            /**
             * Flatten the given navigation
             *
             * @param navigation
             * @private
             */
            function _flattenNavigation(navigation)
            {
                var flatNav = [];

                for ( var x = 0; x < navigation.length; x++ )
                {
                    // Copy and clear the children of the
                    // navigation that we want to push
                    var navToPush = angular.copy(navigation[x]);
                    navToPush.children = [];

                    // Push the item
                    flatNav.push(navToPush);

                    // If there are child items in this navigation,
                    // do some nested function magic
                    if ( navigation[x].children.length > 0 )
                    {
                        flatNav = flatNav.concat(_flattenNavigation(navigation[x].children));
                    }
                }

                return flatNav;
            }
        };
    }

    /** @ngInject */
    function MsNavigationController($scope, msNavigationService)
    {
        var vm = this;

        // Data
        if ( $scope.root )
        {
            vm.navigation = msNavigationService.getNavigation($scope.root);
        }
        else
        {
            vm.navigation = msNavigationService.getNavigation();
        }

        // Methods
        vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Sort the navigation before doing anything else
            msNavigationService.sort();
        }

        /**
         * Toggle horizontal mobile menu
         */
        function toggleHorizontalMobileMenu()
        {
            angular.element('body').toggleClass('ms-navigation-horizontal-mobile-menu-active');
        }
    }

    /** @ngInject */
    function msNavigationDirective($rootScope, $timeout, $mdSidenav, msNavigationService)
    {
        return {
            restrict   : 'E',
            scope      : {
                folded: '=',
                root  : '@'
            },
            controller : 'MsNavigationController as vm',
            templateUrl: 'app/core/directives/ms-navigation/templates/vertical.html',
            transclude : true,
            compile    : function (tElement)
            {
                tElement.addClass('ms-navigation');

                return function postLink(scope, iElement)
                {
                    var bodyEl = angular.element('body'),
                        foldExpanderEl = angular.element('<div id="ms-navigation-fold-expander"></div>'),
                        foldCollapserEl = angular.element('<div id="ms-navigation-fold-collapser"></div>'),
                        sidenav = $mdSidenav('navigation');

                    // Store the navigation in the service for public access
                    msNavigationService.setNavigationScope(scope);

                    // Initialize
                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Set the folded status for the first time.
                        // First, we have to check if we have a folded
                        // status available in the service already. This
                        // will prevent navigation to act weird if we already
                        // set the fold status, remove the navigation and
                        // then re-initialize it, which happens if we
                        // change to a view without a navigation and then
                        // come back with history.back() function.

                        // If the service didn't initialize before, set
                        // the folded status from scope, otherwise we
                        // won't touch anything because the folded status
                        // already set in the service...
                        if ( msNavigationService.getFolded() === null )
                        {
                            msNavigationService.setFolded(scope.folded);
                        }

                        if ( msNavigationService.getFolded() )
                        {
                            // Collapse everything.
                            // This must be inside a $timeout because by the
                            // time we call this, the 'msNavigation::collapse'
                            // event listener is not registered yet. $timeout
                            // will ensure that it will be called after it is
                            // registered.
                            $timeout(function ()
                            {
                                $rootScope.$broadcast('msNavigation::collapse');
                            });

                            // Add class to the body
                            bodyEl.addClass('ms-navigation-folded');

                            // Set fold expander
                            setFoldExpander();
                        }
                    }

                    // Sidenav locked open status watcher
                    scope.$watch(function ()
                    {
                        return sidenav.isLockedOpen();
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        var folded = msNavigationService.getFolded();

                        if ( folded )
                        {
                            if ( current )
                            {
                                // Collapse everything
                                $rootScope.$broadcast('msNavigation::collapse');
                            }
                            else
                            {
                                // Expand the active one and its parents
                                var activeItem = msNavigationService.getActiveItem();
                                if ( activeItem )
                                {
                                    activeItem.scope.$emit('msNavigation::stateMatched');
                                }
                            }
                        }
                    });

                    // Folded status watcher
                    scope.$watch('folded', function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        setFolded(current);
                    });

                    /**
                     * Set folded status
                     *
                     * @param folded
                     */
                    function setFolded(folded)
                    {
                        // Store folded status on the service for global access
                        msNavigationService.setFolded(folded);

                        if ( folded )
                        {
                            // Collapse everything
                            $rootScope.$broadcast('msNavigation::collapse');

                            // Add class to the body
                            bodyEl.addClass('ms-navigation-folded');

                            // Set fold expander
                            setFoldExpander();
                        }
                        else
                        {
                            // Expand the active one and its parents
                            var activeItem = msNavigationService.getActiveItem();
                            if ( activeItem )
                            {
                                activeItem.scope.$emit('msNavigation::stateMatched');
                            }

                            // Remove body class
                            bodyEl.removeClass('ms-navigation-folded ms-navigation-folded-open');

                            // Remove fold collapser
                            removeFoldCollapser();
                        }
                    }

                    /**
                     * Set fold expander
                     */
                    function setFoldExpander()
                    {
                        iElement.parent().append(foldExpanderEl);

                        // Let everything settle for a moment
                        // before registering the event listener
                        $timeout(function ()
                        {
                            foldExpanderEl.on('mouseenter touchstart', onFoldExpanderHover);
                        });
                    }

                    /**
                     * Set fold collapser
                     */
                    function setFoldCollapser()
                    {
                        bodyEl.find('#main').append(foldCollapserEl);
                        foldCollapserEl.on('mouseenter touchstart', onFoldCollapserHover);
                    }

                    /**
                     * Remove fold collapser
                     */
                    function removeFoldCollapser()
                    {
                        foldCollapserEl.remove();
                    }

                    /**
                     * onHover event of foldExpander
                     */
                    function onFoldExpanderHover(event)
                    {
                        if ( event )
                        {
                            event.preventDefault();
                        }

                        // Set folded open status
                        msNavigationService.setFoldedOpen(true);

                        // Expand the active one and its parents
                        var activeItem = msNavigationService.getActiveItem();
                        if ( activeItem )
                        {
                            activeItem.scope.$emit('msNavigation::stateMatched');
                        }

                        // Add class to the body
                      //  bodyEl.addClass('ms-navigation-folded-open');

                        // Remove the fold opener
                        foldExpanderEl.remove();

                        // Set fold collapser
                        setFoldCollapser();
                    }

                    /**
                     * onHover event of foldCollapser
                     */
                    function onFoldCollapserHover(event)
                    {
                        if ( event )
                        {
                            event.preventDefault();
                        }

                        // Set folded open status
                        msNavigationService.setFoldedOpen(false);

                        // Collapse everything
                        $rootScope.$broadcast('msNavigation::collapse');

                        // Remove body class
                        bodyEl.removeClass('ms-navigation-folded-open');

                        // Remove the fold collapser
                        foldCollapserEl.remove();

                        // Set fold expander
                        setFoldExpander();
                    }

                    /**
                     * Public access for toggling folded status externally
                     */
                    scope.toggleFolded = function ()
                    {
                        var folded = msNavigationService.getFolded();

                        setFolded(!folded);
                    };

                    /**
                     * On $stateChangeStart
                     */
                    scope.$on('$stateChangeStart', function ()
                    {
                        // Close the sidenav
                        sidenav.close();
                    });

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        foldCollapserEl.off('mouseenter touchstart');
                        foldExpanderEl.off('mouseenter touchstart');
                    });
                };
            }
        };
    }

    /** @ngInject */
    function MsNavigationNodeController($scope, $element, $rootScope, $animate, $state, msNavigationService)
    {
        var vm = this;

        // Data
        vm.element = $element;
        vm.node = $scope.node;
        vm.hasChildren = undefined;
        vm.collapsed = undefined;
        vm.collapsable = undefined;
        vm.group = undefined;
        vm.animateHeightClass = 'animate-height';

        // Methods
        vm.toggleCollapsed = toggleCollapsed;
        vm.collapse = collapse;
        vm.expand = expand;
        vm.getClass = getClass;
        vm.isHidden = isHidden;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Setup the initial values

            // Has children?
            vm.hasChildren = vm.node.children.length > 0;

            // Is group?
            vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

            // Is collapsable?
            if ( !vm.hasChildren || vm.group )
            {
                vm.collapsable = false;
            }
            else
            {
                vm.collapsable = !!(angular.isUndefined(vm.node.collapsable) || typeof vm.node.collapsable !== 'boolean' || vm.node.collapsable === true);
            }

            // Is collapsed?
            if ( !vm.collapsable )
            {
                vm.collapsed = false;
            }
            else
            {
                vm.collapsed = !!(angular.isUndefined(vm.node.collapsed) || typeof vm.node.collapsed !== 'boolean' || vm.node.collapsed === true);
            }

            // Expand all parents if we have a matching state or
            // the current state is a child of the node's state
            if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
            {
                // If state params are defined, make sure they are
                // equal, otherwise do not set the active item
                if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                {
                    return;
                }

                $scope.$emit('msNavigation::stateMatched');

                // Also store the current active menu item
                msNavigationService.setActiveItem(vm.node, $scope);
            }

            $scope.$on('msNavigation::stateMatched', function ()
            {
                // Expand if the current scope is collapsable and is collapsed
                if ( vm.collapsable && vm.collapsed )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.collapsed = false;
                    });
                }
            });

            // Listen for collapse event
            $scope.$on('msNavigation::collapse', function (event, path)
            {
                if ( vm.collapsed || !vm.collapsable )
                {
                    return;
                }

                // If there is no path defined, collapse
                if ( angular.isUndefined(path) )
                {
                    vm.collapse();
                }
                // If there is a path defined, do not collapse
                // the items that are inside that path. This will
                // prevent parent items from collapsing
                else
                {
                    var givenPathParts = path.split('.'),
                        activePathParts = [];

                    var activeItem = msNavigationService.getActiveItem();
                    if ( activeItem )
                    {
                        activePathParts = activeItem.node._path.split('.');
                    }

                    // Test for given path
                    if ( givenPathParts.indexOf(vm.node._id) > -1 )
                    {
                        return;
                    }

                    // Test for active path
                    if ( activePathParts.indexOf(vm.node._id) > -1 )
                    {
                        return;
                    }

                    vm.collapse();
                }
            });

            // Listen for $stateChangeSuccess event
            $scope.$on('$stateChangeSuccess', function ()
            {
                if ( vm.node.state === $state.current.name )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Update active item on state change
                    msNavigationService.setActiveItem(vm.node, $scope);

                    // Collapse everything except the one we're using
                    $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
                }

                // Expand the parents if we the current
                // state is a child of the node's state
                if ( $state.includes(vm.node.state) )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Emit the stateMatched
                    $scope.$emit('msNavigation::stateMatched');
                }
            });
        }

        /**
         * Toggle collapsed
         */
        function toggleCollapsed()
        {
            if ( vm.collapsed )
            {
                vm.expand();
            }
            else
            {
                vm.collapse();
            }
        }

        /**
         * Collapse
         */
        function collapse()
        {
            // Grab the element that we are going to collapse
            var collapseEl = vm.element.children('ul');

            // Grab the height
            var height = collapseEl[0].offsetHeight;

            $scope.$evalAsync(function ()
            {
                // Set collapsed status
                vm.collapsed = true;

                // Add collapsing class to the node
                vm.element.addClass('collapsing');

                // Animate the height
                $animate.animate(collapseEl,
                    {
                        'display': 'block',
                        'height' : height + 'px'
                    },
                    {
                        'height': '0px'
                    },
                    vm.animateHeightClass
                ).then(
                    function ()
                    {
                        // Clear the inline styles after animation done
                        collapseEl.css({
                            'display': '',
                            'height' : ''
                        });

                        // Clear collapsing class from the node
                        vm.element.removeClass('collapsing');
                    }
                );

                // Broadcast the collapse event so child items can also be collapsed
                $scope.$broadcast('msNavigation::collapse');
            });
        }

        /**
         * Expand
         */
        function expand()
        {
            // Grab the element that we are going to expand
            var expandEl = vm.element.children('ul');

            // Move the element out of the dom flow and
            // make it block so we can get its height
            expandEl.css({
                'position'  : 'absolute',
                'visibility': 'hidden',
                'display'   : 'block',
                'height'    : 'auto'
            });

            // Grab the height
            var height = expandEl[0].offsetHeight;

            // Reset the style modifications
            expandEl.css({
                'position'  : '',
                'visibility': '',
                'display'   : '',
                'height'    : ''
            });

            $scope.$evalAsync(function ()
            {
                // Set collapsed status
                vm.collapsed = false;

                // Add expanding class to the node
                vm.element.addClass('expanding');

                // Animate the height
                $animate.animate(expandEl,
                    {
                        'display': 'block',
                        'height' : '0px'
                    },
                    {
                        'height': height + 'px'
                    },
                    vm.animateHeightClass
                ).then(
                    function ()
                    {
                        // Clear the inline styles after animation done
                        expandEl.css({
                            'height': ''
                        });

                        // Clear expanding class from the node
                        vm.element.removeClass('expanding');
                    }
                );

                // If item expanded, broadcast the collapse event from rootScope so that the other expanded items
                // can be collapsed. This is necessary for keeping only one parent expanded at any time
                $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
            });
        }

        /**
         * Return the class
         *
         * @returns {*}
         */
        function getClass()
        {
            return vm.node.class;
        }

        /**
         * Check if node should be hidden
         *
         * @returns {boolean}
         */
        function isHidden()
        {
            if ( angular.isDefined(vm.node.hidden) && angular.isFunction(vm.node.hidden) )
            {
                return vm.node.hidden();
            }

            return false;
        }
    }

    /** @ngInject */
    function msNavigationNodeDirective()
    {
        return {
            restrict        : 'A',
            bindToController: {
                node: '=msNavigationNode'
            },
            controller      : 'MsNavigationNodeController as vm',
            compile         : function (tElement)
            {
                tElement.addClass('ms-navigation-node');

                return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl)
                {
                    // Add custom classes
                    iElement.addClass(MsNavigationNodeCtrl.getClass());

                    // Add group class if it's a group
                    if ( MsNavigationNodeCtrl.group )
                    {
                        iElement.addClass('group');
                    }
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationItemDirective()
    {
        return {
            restrict: 'A',
            require : '^msNavigationNode',
            compile : function (tElement)
            {
                tElement.addClass('ms-navigation-item');

                return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl)
                {
                    // If the item is collapsable...
                    if ( MsNavigationNodeCtrl.collapsable )
                    {
                        iElement.on('click', MsNavigationNodeCtrl.toggleCollapsed);
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('click');
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationHorizontalDirective(msNavigationService)
    {
        return {
            restrict   : 'E',
            scope      : {
                root: '@'
            },
            controller : 'MsNavigationController as vm',
            templateUrl: 'app/core/directives/ms-navigation/templates/horizontal.html',
            transclude : true,
            compile    : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal');

                return function postLink(scope)
                {
                    // Store the navigation in the service for public access
                    msNavigationService.setNavigationScope(scope);
                };
            }
        };
    }

    /** @ngInject */
    function MsNavigationHorizontalNodeController($scope, $element, $rootScope, $state, msNavigationService)
    {
        var vm = this;

        // Data
        vm.element = $element;
        vm.node = $scope.node;
        vm.hasChildren = undefined;
        vm.group = undefined;

        // Methods
        vm.getClass = getClass;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Setup the initial values

            // Is active
            vm.isActive = false;

            // Has children?
            vm.hasChildren = vm.node.children.length > 0;

            // Is group?
            vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

            // Mark all parents as active if we have a matching state
            // or the current state is a child of the node's state
            if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
            {
                // If state params are defined, make sure they are
                // equal, otherwise do not set the active item
                if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                {
                    return;
                }

                $scope.$emit('msNavigation::stateMatched');

                // Also store the current active menu item
                msNavigationService.setActiveItem(vm.node, $scope);
            }

            $scope.$on('msNavigation::stateMatched', function ()
            {
                // Mark as active if has children
                if ( vm.hasChildren )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = true;
                    });
                }
            });

            // Listen for clearActive event
            $scope.$on('msNavigation::clearActive', function ()
            {
                if ( !vm.hasChildren )
                {
                    return;
                }

                var activePathParts = [];

                var activeItem = msNavigationService.getActiveItem();
                if ( activeItem )
                {
                    activePathParts = activeItem.node._path.split('.');
                }

                // Test for active path
                if ( activePathParts.indexOf(vm.node._id) > -1 )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = true;
                    });
                }
                else
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = false;
                    });
                }

            });

            // Listen for $stateChangeSuccess event
            $scope.$on('$stateChangeSuccess', function ()
            {
                if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Update active item on state change
                    msNavigationService.setActiveItem(vm.node, $scope);

                    // Clear all active states except the one we're using
                    $rootScope.$broadcast('msNavigation::clearActive');
                }
            });
        }

        /**
         * Return the class
         *
         * @returns {*}
         */
        function getClass()
        {
            return vm.node.class;
        }
    }

    /** @ngInject */
    function msNavigationHorizontalNodeDirective()
    {
        return {
            restrict        : 'A',
            bindToController: {
                node: '=msNavigationHorizontalNode'
            },
            controller      : 'MsNavigationHorizontalNodeController as vm',
            compile         : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal-node');

                return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl)
                {
                    // Add custom classes
                    iElement.addClass(MsNavigationHorizontalNodeCtrl.getClass());

                    // Add group class if it's a group
                    if ( MsNavigationHorizontalNodeCtrl.group )
                    {
                        iElement.addClass('group');
                    }
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationHorizontalItemDirective($mdMedia)
    {
        return {
            restrict: 'A',
            require : '^msNavigationHorizontalNode',
            compile : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal-item');

                return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl)
                {
                    iElement.on('click', onClick);

                    function onClick()
                    {
                        if ( !MsNavigationHorizontalNodeCtrl.hasChildren || $mdMedia('gt-md') )
                        {
                            return;
                        }

                        iElement.toggleClass('expanded');
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('click');
                    });
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('msNavFoldService', msNavFoldService)
        .directive('msNavIsFolded', msNavIsFoldedDirective)
        .controller('MsNavController', MsNavController)
        .directive('msNav', msNavDirective)
        .directive('msNavTitle', msNavTitleDirective)
        .directive('msNavButton', msNavButtonDirective)
        .directive('msNavToggle', msNavToggleDirective);

    /** @ngInject */
    function msNavFoldService()
    {
        var foldable = {};

        var service = {
            setFoldable    : setFoldable,
            isNavFoldedOpen: isNavFoldedOpen,
            toggleFold     : toggleFold,
            openFolded     : openFolded,
            closeFolded    : closeFolded
        };

        return service;

        //////////

        /**
         * Set the foldable
         *
         * @param scope
         * @param element
         */
        function setFoldable(scope, element)
        {
            foldable = {
                'scope'  : scope,
                'element': element
            };
        }

        /**
         * Is folded open
         */
        function isNavFoldedOpen()
        {
          /*  return foldable.scope.isNavFoldedOpen();*/
        }

        /**
         * Toggle fold
         */
        function toggleFold()
        {
            foldable.scope.toggleFold();
        }

        /**
         * Open folded navigation
         */
        function openFolded()
        {
            foldable.scope.openFolded();
        }

        /**
         * Close folded navigation
         */
        function closeFolded()
        {
            foldable.scope.closeFolded();
        }
    }

    /** @ngInject */
    function msNavIsFoldedDirective($document, $rootScope, msNavFoldService)
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement, iAttrs)
            {
                var isFolded = (iAttrs.msNavIsFolded === 'true'),
                    isFoldedOpen = false,
                    body = angular.element($document[0].body),
                    openOverlay = angular.element('<div id="ms-nav-fold-open-overlay"></div>'),
                    closeOverlay = angular.element('<div id="ms-nav-fold-close-overlay"></div>'),
                    sidenavEl = iElement.parent();

                // Initialize the service
                msNavFoldService.setFoldable(scope, iElement, isFolded);

                // Set the fold status for the first time
                if ( isFolded )
                {
                    fold();
                }
                else
                {
                    unfold();
                }

                /**
                 * Is nav folded open
                 */
                function isNavFoldedOpen()
                {
                    return isFoldedOpen;
                }

                /**
                 * Toggle fold
                 */
                function toggleFold()
                {
                    isFolded = !isFolded;

                    if ( isFolded )
                    {
                        fold();
                    }
                    else
                    {
                        unfold();
                    }
                }

                /**
                 * Fold the navigation
                 */
                function fold()
                {
                    // Add classes
                    body.addClass('ms-nav-folded');

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    // Append the openOverlay to the element
                    sidenavEl.append(openOverlay);

                    // Event listeners
                    openOverlay.on('mouseenter touchstart', function (event)
                    {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Open folded navigation
                 */
                function openFolded(event)
                {
                    if ( angular.isDefined(event) )
                    {
                        event.preventDefault();
                    }

                    body.addClass('ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Remove open overlay
                    sidenavEl.find(openOverlay).remove();

                    // Append close overlay and bind its events
                    sidenavEl.parent().append(closeOverlay);
                    closeOverlay.on('mouseenter touchstart', function (event)
                    {
                        closeFolded(event);
                        isFoldedOpen = false;
                    });
                }

                /**
                 * Close folded navigation
                 */
                function closeFolded(event)
                {
                    if ( angular.isDefined(event) )
                    {
                        event.preventDefault();
                    }

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    body.removeClass('ms-nav-folded-open');

                    // Remove close overlay
                    sidenavEl.parent().find(closeOverlay).remove();

                    // Append open overlay and bind its events
                    sidenavEl.append(openOverlay);
                    openOverlay.on('mouseenter touchstart', function (event)
                    {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Unfold the navigation
                 */
                function unfold()
                {
                    body.removeClass('ms-nav-folded ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    iElement.off('mouseenter mouseleave');
                }

                // Expose functions to the scope
                scope.toggleFold = toggleFold;
                scope.openFolded = openFolded;
                scope.closeFolded = closeFolded;
                scope.isNavFoldedOpen = isNavFoldedOpen;

                // Cleanup
                scope.$on('$destroy', function ()
                {
                    openOverlay.off('mouseenter touchstart');
                    closeOverlay.off('mouseenter touchstart');
                    iElement.off('mouseenter mouseleave');
                });
            }
        };
    }


    /** @ngInject */
    function MsNavController()
    {
        var vm = this,
            disabled = false,
            toggleItems = [],
            lockedItems = [];

        // Data

        // Methods
        vm.isDisabled = isDisabled;
        vm.enable = enable;
        vm.disable = disable;
        vm.setToggleItem = setToggleItem;
        vm.getLockedItems = getLockedItems;
        vm.setLockedItem = setLockedItem;
        vm.clearLockedItems = clearLockedItems;

        //////////

        /**
         * Is navigation disabled
         *
         * @returns {boolean}
         */
        function isDisabled()
        {
            return disabled;
        }

        /**
         * Disable the navigation
         */
        function disable()
        {
            disabled = true;
        }

        /**
         * Enable the navigation
         */
        function enable()
        {
            disabled = false;
        }

        /**
         * Set toggle item
         *
         * @param element
         * @param scope
         */
        function setToggleItem(element, scope)
        {
            toggleItems.push({
                'element': element,
                'scope'  : scope
            });
        }

        /**
         * Get locked items
         *
         * @returns {Array}
         */
        function getLockedItems()
        {
            return lockedItems;
        }

        /**
         * Set locked item
         *
         * @param element
         * @param scope
         */
        function setLockedItem(element, scope)
        {
            lockedItems.push({
                'element': element,
                'scope'  : scope
            });
        }

        /**
         * Clear locked items list
         */
        function clearLockedItems()
        {
            lockedItems = [];
        }
    }

    /** @ngInject */
    function msNavDirective($rootScope, $mdComponentRegistry, msNavFoldService)
    {
        return {
            restrict  : 'E',
            scope     : {},
            controller: 'MsNavController',
            compile   : function (tElement)
            {
                tElement.addClass('ms-nav');

                return function postLink(scope)
                {
                    // Update toggle status according to the ui-router current state
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Update toggles on state changes
                    var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', function ()
                    {
                        $rootScope.$broadcast('msNav::expandMatchingToggles');

                        // Close navigation sidenav on stateChangeSuccess
                        $mdComponentRegistry.when('navigation').then(function (navigation)
                        {
                            navigation.close();

                            if ( msNavFoldService.isNavFoldedOpen() )
                            {
                                msNavFoldService.closeFolded();
                            }
                        });
                    });

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        stateChangeSuccessEvent();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msNavTitleDirective()
    {
        return {
            restrict: 'A',
            compile : function (tElement)
            {
                tElement.addClass('ms-nav-title');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msNavButtonDirective()
    {
        return {
            restrict: 'AE',
            compile : function (tElement)
            {
                tElement.addClass('ms-nav-button');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msNavToggleDirective($rootScope, $q, $animate, $state)
    {
        return {
            restrict: 'A',
            require : '^msNav',
            scope   : true,
            compile : function (tElement, tAttrs)
            {
                tElement.addClass('ms-nav-toggle');

                // Add collapsed attr
                if ( angular.isUndefined(tAttrs.collapsed) )
                {
                    tAttrs.collapsed = true;
                }

                tElement.attr('collapsed', tAttrs.collapsed);

                return function postLink(scope, iElement, iAttrs, MsNavCtrl)
                {
                    var classes = {
                        expanded         : 'expanded',
                        expandAnimation  : 'expand-animation',
                        collapseAnimation: 'collapse-animation'
                    };

                    // Store all related states
                    var links = iElement.find('a');
                    var states = [];
                    var regExp = /\(.*\)/g;

                    angular.forEach(links, function (link)
                    {
                        var state = angular.element(link).attr('ui-sref');

                        if ( angular.isUndefined(state) )
                        {
                            return;
                        }

                        // Remove any parameter definition from the state name before storing it
                        state = state.replace(regExp, '');

                        states.push(state);
                    });

                    // Store toggle-able element and its scope in the main nav controller
                    MsNavCtrl.setToggleItem(iElement, scope);

                    // Click handler
                    iElement.children('.ms-nav-button').on('click', toggle);

                    // Toggle function
                    function toggle()
                    {
                        // If navigation is disabled, do nothing...
                        if ( MsNavCtrl.isDisabled() )
                        {
                            return;
                        }

                        // Disable the entire navigation to prevent spamming
                        MsNavCtrl.disable();

                        if ( isCollapsed() )
                        {
                            // Clear the locked items list
                            MsNavCtrl.clearLockedItems();

                            // Emit pushToLockedList event
                            scope.$emit('msNav::pushToLockedList');

                            // Collapse everything but locked items
                            $rootScope.$broadcast('msNav::collapse');

                            // Expand and then...
                            expand().then(function ()
                            {
                                // Enable the entire navigation after animations completed
                                MsNavCtrl.enable();
                            });
                        }
                        else
                        {
                            // Collapse with all children
                            scope.$broadcast('msNav::forceCollapse');
                        }
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.children('.ms-nav-button').off('click');
                    });

                    /*---------------------*/
                    /* Scope Events        */
                    /*---------------------*/

                    /**
                     * Collapse everything but locked items
                     */
                    scope.$on('msNav::collapse', function ()
                    {
                        // Only collapse toggles that are not locked
                        var lockedItems = MsNavCtrl.getLockedItems();
                        var locked = false;

                        angular.forEach(lockedItems, function (lockedItem)
                        {
                            if ( angular.equals(lockedItem.scope, scope) )
                            {
                                locked = true;
                            }
                        });

                        if ( locked )
                        {
                            return;
                        }

                        // Collapse and then...
                        collapse().then(function ()
                        {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Collapse everything
                     */
                    scope.$on('msNav::forceCollapse', function ()
                    {
                        // Collapse and then...
                        collapse().then(function ()
                        {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Expand toggles that match with the current states
                     */
                    scope.$on('msNav::expandMatchingToggles', function ()
                    {
                        var currentState = $state.current.name;
                        var shouldExpand = false;

                        angular.forEach(states, function (state)
                        {
                            if ( currentState === state )
                            {
                                shouldExpand = true;
                            }
                        });

                        if ( shouldExpand )
                        {
                            expand();
                        }
                        else
                        {
                            collapse();
                        }
                    });

                    /**
                     * Add toggle to the locked list
                     */
                    scope.$on('msNav::pushToLockedList', function ()
                    {
                        // Set expanded item on main nav controller
                        MsNavCtrl.setLockedItem(iElement, scope);
                    });

                    /*---------------------*/
                    /* Internal functions  */
                    /*---------------------*/

                    /**
                     * Is element collapsed
                     *
                     * @returns {bool}
                     */
                    function isCollapsed()
                    {
                        return iElement.attr('collapsed') === 'true';
                    }

                    /**
                     * Is element expanded
                     *
                     * @returns {bool}
                     */
                    function isExpanded()
                    {
                        return !isCollapsed();
                    }

                    /**
                     * Expand the toggle
                     *
                     * @returns $promise
                     */
                    function expand()
                    {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already expanded, do nothing..
                        if ( isExpanded() )
                        {
                            // Reject the deferred object
                            deferred.reject({'error': true});

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', false);

                        // Grab the element to expand
                        var elementToExpand = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Move the element out of the dom flow and
                        // make it block so we can get its height
                        elementToExpand.css({
                            'position'  : 'absolute',
                            'visibility': 'hidden',
                            'display'   : 'block',
                            'height'    : 'auto'
                        });

                        // Grab the height
                        var height = elementToExpand[0].offsetHeight;

                        // Reset the style modifications
                        elementToExpand.css({
                            'position'  : '',
                            'visibility': '',
                            'display'   : '',
                            'height'    : ''
                        });

                        // Animate the height
                        scope.$evalAsync(function ()
                        {
                            $animate.animate(elementToExpand,
                                {
                                    'display': 'block',
                                    'height' : '0px'
                                },
                                {
                                    'height': height + 'px'
                                },
                                classes.expandAnimation
                            ).then(
                                function ()
                                {
                                    // Add expanded class
                                    elementToExpand.addClass(classes.expanded);

                                    // Clear the inline styles after animation done
                                    elementToExpand.css({'height': ''});

                                    // Resolve the deferred object
                                    deferred.resolve({'success': true});
                                }
                            );
                        });

                        // Return the promise
                        return deferred.promise;
                    }

                    /**
                     * Collapse the toggle
                     *
                     * @returns $promise
                     */
                    function collapse()
                    {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already collapsed, do nothing..
                        if ( isCollapsed() )
                        {
                            // Reject the deferred object
                            deferred.reject({'error': true});

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', true);

                        // Grab the element to collapse
                        var elementToCollapse = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Grab the height
                        var height = elementToCollapse[0].offsetHeight;

                        // Animate the height
                        scope.$evalAsync(function ()
                        {
                            $animate.animate(elementToCollapse,
                                {
                                    'height': height + 'px'
                                },
                                {
                                    'height': '0px'
                                },
                                classes.collapseAnimation
                            ).then(
                                function ()
                                {
                                    // Remove expanded class
                                    elementToCollapse.removeClass(classes.expanded);

                                    // Clear the inline styles after animation done
                                    elementToCollapse.css({
                                        'display': '',
                                        'height' : ''
                                    });

                                    // Resolve the deferred object
                                    deferred.resolve({'success': true});
                                }
                            );
                        });

                        // Return the promise
                        return deferred.promise;
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('msMaterialColorPickerController', msMaterialColorPickerController)
        .directive('msMaterialColorPicker', msMaterialColorPicker);

    /** @ngInject */
    function msMaterialColorPickerController($scope, $mdColorPalette, $mdMenu, fuseGenerator)
    {
        var vm = this;
        vm.palettes = $mdColorPalette; // Material Color Palette
        vm.selectedPalette = false;
        vm.selectedHues = false;
        $scope.$selectedColor = {};

        // Methods
        vm.activateHueSelection = activateHueSelection;
        vm.selectColor = selectColor;
        vm.removeColor = removeColor;

        /**
         * Initialize / Watch model changes
         */
        $scope.$watch('ngModel', setSelectedColor);

        /**
         * Activate Hue Selection
         * @param palette
         * @param hues
         */
        function activateHueSelection(palette, hues)
        {
            vm.selectedPalette = palette;
            vm.selectedHues = hues;
        }

        /**
         * Select Color
         * @type {selectColor}
         */
        function selectColor(palette, hue)
        {
            // Update Selected Color
            updateSelectedColor(palette, hue);

            // Update Model Value
            updateModel();

            // Hide The picker
            $mdMenu.hide();
        }

        function removeColor()
        {
            vm.selectedColor = {
                palette: '',
                hue    : '',
                class  : ''
            };

            activateHueSelection(false, false);

            updateModel();
        }

        /**
         * Set SelectedColor by model type
         */
        function setSelectedColor()
        {
            if ( !vm.modelCtrl.$viewValue || vm.modelCtrl.$viewValue === '' )
            {
                removeColor();
                return;
            }

            var palette, hue;

            // If ModelType Class
            if ( vm.msModelType === 'class' )
            {
                var color = vm.modelCtrl.$viewValue.split('-');
                if ( color.length >= 5 )
                {
                    palette = color[1] + '-' + color[2];
                    hue = color[3];
                }
                else
                {
                    palette = color[1];
                    hue = color[2];
                }
            }

            // If ModelType Object
            else if ( vm.msModelType === 'obj' )
            {
                palette = vm.modelCtrl.$viewValue.palette;
                hue = vm.modelCtrl.$viewValue.hue || 500;
            }

            // Update Selected Color
            updateSelectedColor(palette, hue);
        }

        /**
         * Update Selected Color
         * @param palette
         * @param hue
         */
        function updateSelectedColor(palette, hue)
        {
            vm.selectedColor = {
                palette     : palette,
                hue         : hue,
                class       : 'md-' + palette + '-' + hue + '-bg',
                bgColorValue: fuseGenerator.rgba(vm.palettes[palette][hue].value),
                fgColorValue: fuseGenerator.rgba(vm.palettes[palette][hue].contrast)
            };

            // If Model object not Equals the selectedColor update it
            // it can be happen when the model only have pallete and hue values
            if ( vm.msModelType === 'obj' && !angular.equals(vm.selectedColor, vm.modelCtrl.$viewValue) )
            {
                // Update Model Value
                updateModel();
            }

            activateHueSelection(palette, vm.palettes[palette]);

            $scope.$selectedColor = vm.selectedColor;
        }

        /**
         * Update Model Value by model type
         */
        function updateModel()
        {
            if ( vm.msModelType === 'class' )
            {
                vm.modelCtrl.$setViewValue(vm.selectedColor.class);
            }
            else if ( vm.msModelType === 'obj' )
            {
                vm.modelCtrl.$setViewValue(vm.selectedColor);
            }
        }
    }

    /** @ngInject */
    function msMaterialColorPicker()
    {
        return {
            require    : ['msMaterialColorPicker', 'ngModel'],
            restrict   : 'E',
            scope      : {
                ngModel    : '=',
                msModelType: '@?'
            },
            controller : 'msMaterialColorPickerController as vm',
            transclude : true,
            templateUrl: 'app/core/directives/ms-material-color-picker/ms-material-color-picker.html',
            link       : function (scope, element, attrs, controllers, transclude)
            {
                var ctrl = controllers[0];

                /**
                 *  Pass model controller to directive controller
                 */
                ctrl.modelCtrl = controllers[1];

                /**
                 * ModelType: 'obj', 'class'(default)
                 * @type {string|string}
                 */
                ctrl.msModelType = scope.msModelType || 'class';

                transclude(scope, function (clone)
                {
                    clone = clone.filter(function (i, el)
                    {
                        return ( el.nodeType === 1 ) ? true : false;
                    });

                    if ( clone.length )
                    {
                        element.find('ms-color-picker-button').replaceWith(clone);
                    }
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('msMasonryController', msMasonryController)
        .directive('msMasonry', msMasonry)
        .directive('msMasonryItem', msMasonryItem);

    /** @ngInject */
    function msMasonryController($scope, $window, $mdMedia, $timeout)
    {
        var vm = this,
            defaultOpts = {
                columnCount     : 5,
                respectItemOrder: false,
                reLayoutDebounce: 400,
                responsive      : {
                    md: 3,
                    sm: 2,
                    xs: 1
                }
            },
            reLayoutTimeout = true;

        vm.options = null;
        vm.container = [];
        vm.containerPos = '';
        vm.columnWidth = '';
        vm.items = [];

        // Methods
        vm.reLayout = reLayout;
        vm.initialize = initialize;
        vm.waitImagesLoaded = waitImagesLoaded;

        function initialize()
        {
            vm.options = !vm.options ? defaultOpts : angular.extend(defaultOpts, vm.options);


            watchContainerResize();
        }

        $scope.$on('msMasonry:relayout', function ()
        {
            reLayout();
        });

        function waitImagesLoaded(element, callback)
        {
            if ( typeof imagesLoaded !== 'undefined' )
            {
                var imgLoad = $window.imagesLoaded(element);

                imgLoad.on('done', function ()
                {
                    callback();
                });
            }
            else
            {
                callback();
            }
        }

        function watchContainerResize()
        {
            $scope.$watch(
                function ()
                {
                    return vm.container.width();
                },
                function (newValue, oldValue)
                {
                    if ( newValue !== oldValue )
                    {
                        reLayout();
                    }
                }
            );
        }

        function reLayout()
        {
            // Debounce for relayout
            if ( reLayoutTimeout )
            {
                $timeout.cancel(reLayoutTimeout);
            }

            reLayoutTimeout = $timeout(function ()
            {
                start();

                $scope.$broadcast('msMasonry:relayoutFinished');

            }, vm.options.reLayoutDebounce);

            // Start relayout
            function start()
            {
                vm.containerPos = vm.container[0].getBoundingClientRect();

                updateColumnOptions();

                $scope.$broadcast('msMasonry:relayoutStarted');

                vm.items = vm.container.find('ms-masonry-item');

                //initialize lastRowBottomArr
                var referenceArr = Array.apply(null, new Array(vm.columnCount)).map(function ()
                {
                    return 0;
                });

                // set item positions
                for ( var i = 0; i < vm.items.length; i++ )
                {
                    var item = vm.items[i],
                        xPos, yPos, column, refTop;

                    item = angular.element(item);

                    if ( item.scope() )
                    {
                        item.scope().$broadcast('msMasonryItem:startReLayout');
                    }

                    item.css({'width': vm.columnWidth});

                    if ( vm.options.respectItemOrder )
                    {
                        column = i % vm.columnCount;
                        refTop = referenceArr[column];
                    }
                    else
                    {
                        refTop = Math.min.apply(Math, referenceArr);
                        column = referenceArr.indexOf(refTop);
                    }

                    referenceArr[column] = refTop + item[0].getBoundingClientRect().height;

                    xPos = Math.round(column * vm.columnWidth);
                    yPos = refTop;

                    item.css({'transform': 'translate3d(' + xPos + 'px,' + yPos + 'px,0px)'});
                    item.addClass('placed');

                    if ( item.scope() )
                    {
                        item.scope().$broadcast('msMasonryItem:finishReLayout');
                    }
                }
            }
        }

        function updateColumnOptions()
        {
            vm.columnCount = vm.options.columnCount;

            if ( $mdMedia('gt-md') )
            {
                vm.columnCount = vm.options.columnCount;
            }
            else if ( $mdMedia('md') )
            {
                vm.columnCount = (vm.columnCount > vm.options.responsive.md ? vm.options.responsive.md : vm.columnCount);
            }
            else if ( $mdMedia('sm') )
            {
                vm.columnCount = (vm.columnCount > vm.options.responsive.sm ? vm.options.responsive.sm : vm.columnCount);
            }
            else
            {
                vm.columnCount = vm.options.responsive.xs;
            }

            vm.columnWidth = vm.containerPos.width / vm.columnCount;

        }
    }

    /** @ngInject */
    function msMasonry($timeout)
    {
        return {
            restrict  : 'AEC',
            controller: 'msMasonryController',
            compile   : compile
        };
        function compile(element, attributes)
        {
            return {
                pre : function preLink(scope, iElement, iAttrs, controller)
                {
                    controller.options = angular.fromJson(attributes.options || '{}');
                    controller.container = element;
                },
                post: function postLink(scope, iElement, iAttrs, controller)
                {
                    $timeout(function ()
                    {
                        controller.initialize();
                    });
                }
            };
        }
    }

    /** @ngInject */
    function msMasonryItem()
    {
        return {
            restrict: 'AEC',
            require : '^msMasonry',
            priority: 1,
            link    : link
        };

        function link(scope, element, attributes, controller)
        {
            controller.waitImagesLoaded(element, function ()
            {
                controller.reLayout();

            });

            scope.$on('msMasonryItem:finishReLayout', function ()
            {
                scope.$watch(function ()
                {
                    return element.height();
                }, function (newVal, oldVal)
                {
                    if ( newVal !== oldVal )
                    {
                        controller.reLayout();
                    }
                });
            });

            element.on('$destroy', function ()
            {
                controller.reLayout();
            });
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msInfoBar', msInfoBarDirective);

    /** @ngInject */
    function msInfoBarDirective($document)
    {
        return {
            restrict   : 'E',
            scope      : {},
            transclude : true,
            templateUrl: 'app/core/directives/ms-info-bar/ms-info-bar.html',
            link       : function (scope, iElement)
            {
                var body = $document.find('body'),
                    bodyClass = 'ms-info-bar-active';

                // Add body class
                body.addClass(bodyClass);

                /**
                 * Remove the info bar
                 */
                function removeInfoBar()
                {
                    body.removeClass(bodyClass);
                    iElement.remove();
                    scope.$destroy();
                }

                // Expose functions
                scope.removeInfoBar = removeInfoBar;
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsFormWizardController', MsFormWizardController)
        .directive('msFormWizard', msFormWizardDirective)
        .directive('msFormWizardForm', msFormWizardFormDirective);

    /** @ngInject */
    function MsFormWizardController()
    {
        var vm = this;

        // Data
        vm.forms = [];
        vm.selectedIndex = 0;

        // Methods
        vm.registerForm = registerForm;

        vm.previousStep = previousStep;
        vm.nextStep = nextStep;
        vm.firstStep = firstStep;
        vm.lastStep = lastStep;

        vm.totalSteps = totalSteps;
        vm.isFirstStep = isFirstStep;
        vm.isLastStep = isLastStep;

        vm.currentStepInvalid = currentStepInvalid;
        vm.previousStepInvalid = previousStepInvalid;
        vm.formsIncomplete = formsIncomplete;
        vm.resetForm = resetForm;

        //////////

        /**
         * Register form
         *
         * @param form
         */
        function registerForm(form)
        {
            vm.forms.push(form);
        }

        /**
         * Go to previous step
         */
        function previousStep()
        {
            if ( isFirstStep() )
            {
                return;
            }

            vm.selectedIndex--;
        }

        /**
         * Go to next step
         */
        function nextStep()
        {
            if ( isLastStep() )
            {
                return;
            }

            vm.selectedIndex++;
        }

        /**
         * Go to first step
         */
        function firstStep()
        {
            vm.selectedIndex = 0;
        }

        /**
         * Go to last step
         */
        function lastStep()
        {
            vm.selectedIndex = totalSteps() - 1;
        }

        /**
         * Return total steps
         *
         * @returns {int}
         */
        function totalSteps()
        {
            return vm.forms.length;
        }

        /**
         * Is first step?
         *
         * @returns {boolean}
         */
        function isFirstStep()
        {
            return vm.selectedIndex === 0;
        }

        /**
         * Is last step?
         *
         * @returns {boolean}
         */
        function isLastStep()
        {
            return vm.selectedIndex === totalSteps() - 1;
        }

        /**
         * Is current step invalid?
         *
         * @returns {boolean}
         */
        function currentStepInvalid()
        {
            return angular.isDefined(vm.forms[vm.selectedIndex]) && vm.forms[vm.selectedIndex].$invalid;
        }

        /**
         * Is previous step invalid?
         *
         * @returns {boolean}
         */
        function previousStepInvalid()
        {
            return vm.selectedIndex > 0 && angular.isDefined(vm.forms[vm.selectedIndex - 1]) && vm.forms[vm.selectedIndex - 1].$invalid;
        }

        /**
         * Check if there is any incomplete forms
         *
         * @returns {boolean}
         */
        function formsIncomplete()
        {
            for ( var x = 0; x < vm.forms.length; x++ )
            {
                if ( vm.forms[x].$invalid )
                {
                    return true;
                }
            }

            return false;
        }

        /**
         * Reset form
         */
        function resetForm()
        {
            // Go back to the first step
            vm.selectedIndex = 0;

            // Make sure all the forms are back in the $pristine & $untouched status
            for ( var x = 0; x < vm.forms.length; x++ )
            {
                vm.forms[x].$setPristine();
                vm.forms[x].$setUntouched();
            }
        }
    }

    /** @ngInject */
    function msFormWizardDirective()
    {
        return {
            restrict  : 'E',
            scope     : true,
            controller: 'MsFormWizardController as msWizard',
            compile   : function (tElement)
            {
                tElement.addClass('ms-form-wizard');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msFormWizardFormDirective()
    {
        return {
            restrict: 'A',
            require : ['form', '^msFormWizard'],
            compile : function (tElement)
            {
                tElement.addClass('ms-form-wizard-form');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var formCtrl = ctrls[0],
                        MsFormWizardCtrl = ctrls[1];

                    MsFormWizardCtrl.registerForm(formCtrl);
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msDatepickerFixConfig', msDatepickerFixConfigProvider)
        .directive('msDatepickerFix', msDatepickerFix);

    /** @ngInject */
    function msDatepickerFixConfigProvider()
    {

        // Default configuration
        var defaultConfiguration = {
            // To view
            formatter: function (val)
            {
                if ( !val )
                {
                    return '';
                }

                return val === '' ? val : new Date(val);
            },
            // To model
            parser   : function (val)
            {
                if ( !val )
                {
                    return '';
                }
                var offset = moment(val).utcOffset();
                var date = new Date(moment(val).add(offset, 'm'));
                return date;
            }
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            defaultConfiguration = angular.extend({}, defaultConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            return defaultConfiguration;
        };
    }

    /** @ngInject */
    function msDatepickerFix(msDatepickerFixConfig)
    {
        return {
            require: 'ngModel',
            link   : function (scope, elem, attrs, ngModel)
            {
                ngModel.$formatters.unshift(msDatepickerFixConfig.formatter); // to view
                ngModel.$parsers.unshift(msDatepickerFixConfig.parser); // to model
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msCard', msCardDirective);

    /** @ngInject */
    function msCardDirective()
    {
        return {
            restrict: 'E',
            scope   : {
                templatePath: '=template',
                card        : '=ngModel',
                vm          : '=viewModel'
            },
            template: '<div class="ms-card-content-wrapper" ng-include="templatePath" onload="cardTemplateLoaded()"></div>',
            compile : function (tElement)
            {
                // Add class
                tElement.addClass('ms-card');

                return function postLink(scope, iElement)
                {
                    // Methods
                    scope.cardTemplateLoaded = cardTemplateLoaded;

                    //////////

                    /**
                     * Emit cardTemplateLoaded event
                     */
                    function cardTemplateLoaded()
                    {
                        scope.$emit('msCard::cardTemplateLoaded', iElement);
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.quick-panel', [])
        .config(config);

    /** @ngInject */
    function config($translatePartialLoaderProvider, msApiProvider)
    {
        // Translation
        $translatePartialLoaderProvider.addPart('app/quick-panel');

        // Api
        msApiProvider.register('quickPanel.activities', ['app/data/quick-panel/activities.json']);
        msApiProvider.register('quickPanel.contacts', ['app/data/quick-panel/contacts.json']);
        msApiProvider.register('quickPanel.events', ['app/data/quick-panel/events.json']);
        msApiProvider.register('quickPanel.notes', ['app/data/quick-panel/notes.json']);
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.quick-panel')
        .controller('ChatTabController', ChatTabController);

    /** @ngInject */
    function ChatTabController(msApi, $timeout)
    {
        var vm = this;

        // Data
        vm.chat = {};
        vm.chatActive = false;
        vm.replyMessage = '';

        msApi.request('quickPanel.contacts@get', {},
            // Success
            function (response)
            {
                vm.contacts = response.data;
            }
        );

        // Methods
        vm.toggleChat = toggleChat;
        vm.reply = reply;

        //////////

        function toggleChat(contact)
        {
            vm.chatActive = !vm.chatActive;

            if ( vm.chatActive )
            {
                vm.replyMessage = '';
                vm.chat.contact = contact;
                scrollToBottomOfChat(0);
            }
        }

        function reply()
        {
            if ( vm.replyMessage === '' )
            {
                return;
            }

            if ( !vm.chat.contact.dialog )
            {
                vm.chat.contact.dialog = [];
            }

            vm.chat.contact.dialog.push({
                who    : 'user',
                message: vm.replyMessage,
                time   : 'Just now'
            });

            vm.replyMessage = '';

            scrollToBottomOfChat(400);
        }

        function scrollToBottomOfChat(speed)
        {
            var chatDialog = angular.element('#chat-dialog');

            $timeout(function ()
            {
                chatDialog.animate({
                    scrollTop: chatDialog[0].scrollHeight
                }, speed);
            }, 0);

        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.user-management', ['datatables', 'ngResource','nvd3'])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
       //$scope.updateUser = {};
        $stateProvider
            .state('app.user-management', {
                abstract: true
                //url     : '/user-management'
            })
            
            // .state('app.user-management.create-user',{
                
            //     url: '/create-user',
            //     views: {
            //         'content@app': {
            //             templateUrl: 'app/main/user-management/create-user/create-user.html',
            //             controller: 'UserController as createUserCtrl'
            //         }
            //     }

            // })
            // .state('app.user-management.update-user',{
                
            //     url: '/update-user:id',
            //     views: {
            //         'content@app': {
            //             templateUrl: 'app/main/user-management/update-user/update-user.html',
            //             controller: 'UpdateUserController'
            //         }
            //     }

            // })          
            
            .state('app.user-management.usersDetails',{
                
                url: '/users',
                views: {
                    'content@app': {
                        templateUrl: '/app/main/user-management/users/users.html',
                        controller: 'UserController as userCtrl'
                    }
                }

                ,
                resolve : {
                    RestAPIService: 'RestAPIService',
                    Users:  function(RestAPIService){
                        return RestAPIService.getUsers();
                    }
                }
                


            }) 
            .state('app.user-management.groups',{
                
                url: '/groups',
                views: {
                    'content@app': {
                        templateUrl: '/app/main/user-management/groups/groups.html',
                        controller: 'GroupsController as groupsCtrl'
                    }
                },
                resolve : {
                    RestAPIService : 'RestAPIService',
                    Groups: function(RestAPIService){
                        return RestAPIService.getAllGroups();
                    }
                }
                

            }) 
             /*.state('app.lists-management',{
                
                url: '/lists-management',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/pages/errors/404/error-404.html',
                        controller: 'Error404Controller as cf'
                    }
                }
                 }); */
          
          
      /*  msNavigationServiceProvider.saveItem('admin.user-management', {
            title : 'User Management',
            icon  : 'icon-account-circle',
            weight: 1
        });   
        
        msNavigationServiceProvider.saveItem('admin.user-management.usersDetails', {
            title: 'Users',
            state: 'app.user-management.usersDetails'
        });
        msNavigationServiceProvider.saveItem('admin.user-management.groups', {
            title: 'Groups',
            state: 'app.user-management.groups'
        });*/
       /* msNavigationServiceProvider.saveItem('admin.lists-management', {
            title: 'Lists-management',
            icon:'icon-view-list'
            state: 'app.lists-management',
            weight: 3
            });*/


    }
})();
 (function() {
     'use strict';
     angular
         .module('app.user-management')
         .controller('UserController', UserController);

     function UserController($state, $http, $scope, $mdDialog, RestAPIService, Users,$localStorage) {
         var userCtrl = this;

         $scope.usersList = Users.data;
         $scope.count = Users.data.length;
          userCtrl.goToAdmin = function(){
            $state.go('app.admin');
        }
        userCtrl.goToAdminuser = function(){
            $state.go('app.adminuser');
        }


         userCtrl.user = {};
         //userCtrl.dtInstance = {};
         userCtrl.dtOptions = {
             dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
             columnDefs: [
                 { // Target the actions column
                     targets: 6,
                     responsivePriority: 1,
                     filterable: false,
                     sortable: false
                 }
             ],

             pagingType: 'simple',
             lengthMenu: [10, 20, 30, 50, 100],
             pageLength: 20
                 // scrollY     : 'auto',
                 //responsive  : true
         };

         userCtrl.getUsers = function() {
             RestAPIService.getUsers().then(
                 function(success) {
                     $scope.usersList = success.data;
                     $scope.count = $scope.usersList.length;
                 },
                 function(error) {
                     RestAPIService.showErrorDialog(error);
                 }
             );
             //return userCtrl.usersList;
         }


         //$scope.allUsers = Users.data;

         $scope.createUserDialog = function(ev) {
             $mdDialog.show({
                 controller: CreateUserDialogController,
                 templateUrl: 'app/main/user-management/users/create.user.dialog.html',
                 parent: angular.element(document.body),
                 targetEvent: ev,
                 clickOutsideToClose: true,
                 fullscreen: $scope.customFullscreen
             })
             $scope.cancel = function() {
                 $scope.user = {};
             };
         };


         function CreateUserDialogController($scope, $mdDialog) {
             $scope.status = ["True", "False"];
             $scope.roles = ["ROLE_USER", "ROLE_ADMIN"];

             $scope.hide = function() {
                 $mdDialog.hide();
             };
             $scope.cancel = function() {
                 $mdDialog.cancel();
             };

             $scope.save = function(user) {
                 RestAPIService.createUser(user).then(
                     function(success) {
                         //Create successful. Need to refresh
                         $state.reload();
                     },
                     function(error) {
                         RestAPIService.showErrorDialog(error);
                     }
                 );
                 $mdDialog.hide(user);
             };

         }

         userCtrl.currentUser = {};
         $scope.updateUserDialog = function(ev, user) {
             userCtrl.currentUser = angular.copy(user);
             $mdDialog.show({
                 controller: UpdateUserDialogController,
                 templateUrl: 'app/main/user-management/users/update.user.dialog.html',
                 parent: angular.element(document.body),
                 targetEvent: ev,
                 clickOutsideToClose: true,
                 fullscreen: $scope.customFullscreen
             })
         };

         function UpdateUserDialogController($scope, $mdDialog) {
             $scope.status = ["true", "false"];
             $scope.roles = ["ROLE_USER", "ROLE_ADMIN"];
             $scope.currentUser = userCtrl.currentUser;

             $scope.hide = function() {
                 $mdDialog.hide();
             };
             $scope.cancel = function() {
                 $mdDialog.cancel();
             };
             $scope.update = function(user) {
                 RestAPIService.updateUser(user).then(
                     function(success) {
                         //Update successful. Need to refresh
                         $state.reload();
                     },
                     function(error) {
                         RestAPIService.showErrorDialog(error);
                     }
                 );
                 $mdDialog.hide(user);
             };
         }

         userCtrl.deleteUser = function(ev, user) {
             var confirm = $mdDialog.confirm()
                 .title('Remove')
                 .textContent('User ' + user.firstName + ' ' + user.lastName + ' will be permanently deleted. Continue ?')
                 .targetEvent(ev)
                 .ok('Ok')
                 .cancel('Cancel');
             $mdDialog.show(confirm).then(function() {

                 RestAPIService.deleteUser(user.login).then(
                     function(success) {
                         //delete successful. Need to refresh
                         $state.reload();
                     },
                     function(error) {
                         RestAPIService.showErrorDialog(error);
                     }
                 );
             }, function() {
                 $mdDialog.cancel();
             });
         }

     }
 })();

(function() {
    'use strict';

    angular
        .module('app.user-management')
        .controller('GroupsController', GroupsController);

    /** @ngInject */
    function GroupsController($state, $http, $scope, RestAPIService, $mdDialog, Groups,$localStorage) {
        var groupsCtrl = this;
        groupsCtrl.hidden = false;
        groupsCtrl.isOpen = false;
        groupsCtrl.hover = false;

        groupsCtrl.allGroups = Groups.data;
        $scope.totalGroups = Groups.data.length;

        groupsCtrl.allGroups.forEach(function(group) {
            // Calling Service for getting every group data based on groupId.
            RestAPIService.getGroupMembers(group.id).then(
                function(responce) {
                    group['members'] = responce.data;
                }
            )
            group['hidden'] = false;
            group['isOpen'] = false;
            group['hover'] = false;
        })

        groupsCtrl.goToAdmin = function(){
            $state.go('app.admin');
        }
        groupsCtrl.goToAdminuser = function(){
            $state.go('app.adminuser');
        }

        groupsCtrl.getAllGroups = function() {
            RestAPIService.getAllGroups().then(
                function(responce) {
                    groupsCtrl.allGroups = responce.data;
                    $scope.totalGroups = responce.data.length;
                    groupsCtrl.allGroups.forEach(function(group) {
                        // Calling Service for getting every group data based on groupId.
                        RestAPIService.getGroupMembers(group.id).then(
                            function(responce) {
                                group['members'] = responce.data;
                            }
                        )
                        group['hidden'] = false;
                        group['isOpen'] = false;
                        group['hover'] = false;
                    })
                },
                function(error) {
                    RestAPIService.showErrorDialog(error);
                }
            );
        }

        

        $scope.$watch('eachGroup.isOpen', function(isOpen) {
            if (isOpen) {
                $timeout(function() {
                    $scope.tooltipVisible = isOpen;
                }, 600);
            } else {
                $scope.tooltipVisible = isOpen;
            }
        });

        groupsCtrl.getAnotherColor = function(index) {
            // md-hue's are written for lighten the colors.
            groupsCtrl.colors = ['md-blue-grey-bg', 'md-warn md-hue-3', 'md-accent md-hue-3', 'md-primary md-hue-3', 'md-light-green-bg'];
            var totalNoOfColors = groupsCtrl.colors.length;
            return groupsCtrl.colors[index % totalNoOfColors];
        }

        groupsCtrl.deleteGroupMember = function(groupData, i) {
            var groupData = groupData;
            var groupId = groupData.id;
            var login = groupData.members[i].login;
            var name = groupData.members[i].firstName + " " + groupData.members[i].lastName;
            var groupName = groupData.name;
            var confirm = $mdDialog.confirm()
                .title('Remove')
                .textContent(name + ' will be removed from '+groupName+' , continue ?')
                //.targetEvent(ev)
                .ok('Ok')
                .cancel('Cancel');
            $mdDialog.show(confirm).then(function() {
                RestAPIService.deleteGroupMember(groupId, login).then(
                    function(responce) {
                        // Refresh the data after deleting.                        
                        //$state.reload();
                        RestAPIService.getGroupMembers(groupId).then(
                            function(responce) {                               
                                groupData['members'] = responce.data;
                            }
                        )
                    },
                    function(error) {
                        RestAPIService.showErrorDialog(error);
                    }
                );
            }, function() {
                //User clicked Cancel. Close the popup
            });
        }

        groupsCtrl.deleteGroup = function(groupData) {
            var groupId = groupData.id;
            var confirm = $mdDialog.confirm()
                .title('Remove')
                .textContent(groupData.name + ' group will be removed, continue ?')
                //.targetEvent(ev)
                .ok('Ok')
                .cancel('Cancel');
            $mdDialog.show(confirm).then(function() {
                //Deleting the group
                RestAPIService.deleteGroup(groupId).then(
                    function(success) {
                        //Group Successfully deleted. Need to refresh through GET call                           
                        //$state.reload();
                        groupsCtrl.getAllGroups();
                    },
                    function(error) {
                        RestAPIService.showErrorDialog(error);
                    }
                );
            }, function() {
                //User clicked Cancel. Close the popup
            });
        }

        groupsCtrl.createGroupDialog = function(ev) {
            $mdDialog.show({
                    controller: CreateGroupDialogController,
                    templateUrl: 'app/main/user-management/groups/createGroupDialog.html',
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    fullscreen: $scope.customFullscreen // Only for -xs, -sm breakpoints.
                })
                .then(function(answer) {
                    
                }, function() {
                    
                });
        }

        function CreateGroupDialogController($scope, $mdDialog) {
            $scope.close = function() {
                $mdDialog.cancel();
            }

            $scope.cancel = function() {
                $scope.group = {};
                $mdDialog.cancel();
            }

            $scope.createGroup = function(groupData) {
                RestAPIService.createGroup(groupData).then(
                    function(success) {
                        $mdDialog.show(
                            $mdDialog.alert()
                            .parent(angular.element(document.querySelector('#popupContainer')))
                            .clickOutsideToClose(true)
                            .textContent('You have successfully created a ' + groupData.name + ' Group .')
                            .ok('Ok')
                        );
                        
                        //$state.reload();
                        groupsCtrl.getAllGroups();
                    },
                    function(error) {
                        RestAPIService.showErrorDialog(error);
                    }
                );
                $mdDialog.hide(groupData);
            };
        }

        groupsCtrl.addMemberDialog = function(ev, groupData) {
            groupsCtrl.groupId = groupData.id;
            //alert(groupsCtrl.groupId);
            $mdDialog.show({
                    controller: addGroupMemberController,
                    templateUrl: 'app/main/user-management/groups/addGroupMemberDialog.html',
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    fullscreen: $scope.customFullscreen // Only for -xs, -sm breakpoints.
                })
                .then(function(answer) {
                    
                }, function() {
                   
                });
        }

        function addGroupMemberController($scope, $mdDialog) {
            $scope.searchMember = function(memberdata) {
                var q = "";
                if (memberdata == undefined || angular.equals(memberdata, {})) {
                    $scope.msgVisibility = true;
                    $scope.tableVisibility = false;
                    $scope.member = {};
                } else {
                    if ((memberdata.name != "" && memberdata.name != undefined) && (memberdata.email != "" && memberdata.email != undefined)) {
                        q = memberdata.name;
                    } else if ((memberdata.name == "" || memberdata.name == undefined) && (memberdata.email != "" && memberdata.email != undefined)) {
                        q = memberdata.email;
                    } else if (memberdata.name != "" && (memberdata.email == "" || memberdata.email == undefined)) {
                        q = memberdata.name;
                    }
                    $scope.searchedMembers = [];
                    RestAPIService.searchMemberForGroups(q).then(
                        function(success) {
                            $scope.searchedMembers = success.data;
                            $scope.msgVisibility = false;
                            $scope.tableVisibility = true;
                            $scope.member = {};
                        },
                        function(error) {
                            RestAPIService.showErrorDialog(error);
                        }
                    );
                }
            }

            $scope.addGroupMember = function(memberdata) {
                var groupId = groupsCtrl.groupId;                
                RestAPIService.addGroupMember(memberdata, groupId).then(
                    function(responce) {                        
                        //$state.reload();
                        groupsCtrl.getAllGroups();
                    },
                    function(error) {
                        RestAPIService.showErrorDialog(error);
                    }
                );
            }

            $scope.cancel = function(memberdata) {
                $scope.member = {};
                $scope.tableVisibility = false;
                $scope.searchedMembers = [];
                //$scope.width=25;
                $scope.msgVisibility = false;
                $mdDialog.cancel();
            }

            $scope.ok = function() {
                
                $mdDialog.cancel();
            }

        }



        groupsCtrl.groupStatGraphData = {
        "title": "Group Statistics",
        "ranges": {
            "TW": "This Week",
            "LW": "Last Week",
            "2W": "2 Weeks Ago"
        },
        "mainChart": [
            {
                "key": "Portal Admin",
                "values": {
                    "2W": [
                        {"x": "Group1", "y": 9},
                        {"x": "Group2", "y": 12},
                        {"x": "Group3", "y": 9},
                        {"x": "Group4", "y": 12},
                        {"x": "Group5", "y": 7},
                        {"x": "Group6", "y": 8},
                        {"x": "Group7", "y": 16}
                    ],
                    "LW": [
                        {"x": "Group1", "y": 12},
                        {"x": "Group2", "y": 8},
                        {"x": "Group3", "y": 7},
                        {"x": "Group4", "y": 13},
                        {"x": "Group5", "y": 7},
                        {"x": "Group6", "y": 6},
                        {"x": "Group7", "y": 10}
                    ],
                    "TW": [
                        {"x": "Group1", "y": 11},
                        {"x": "Group2", "y": 10},
                        {"x": "Group3", "y": 8},
                        {"x": "Group4", "y": 11},
                        {"x": "Group5", "y": 8},
                        {"x": "Group6", "y": 10},
                        {"x": "Group7", "y": 17}
                    ]
                }
            },
            {
                "key": "Portal User",
                "values": {
                    "2W": [
                        {"x": "Group1", "y": 37},
                        {"x": "Group2", "y": 32},
                        {"x": "Group3", "y": 39},
                        {"x": "Group4", "y": 27},
                        {"x": "Group5", "y": 18},
                        {"x": "Group6", "y": 24},
                        {"x": "Group7", "y": 20}
                    ],
                    "LW": [
                        {"x": "Group1", "y": 37},
                        {"x": "Group2", "y": 24},
                        {"x": "Group3", "y": 51},
                        {"x": "Group4", "y": 31},
                        {"x": "Group5", "y": 29},
                        {"x": "Group6", "y": 17},
                        {"x": "Group7", "y": 31}
                    ],
                    "TW": [
                        {"x": "Group1", "y": 42},
                        {"x": "Group2", "y": 28},
                        {"x": "Group3", "y": 43},
                        {"x": "Group4", "y": 34},
                        {"x": "Group5", "y": 20},
                        {"x": "Group6", "y": 25},
                        {"x": "Group7", "y": 22}
                    ]
                }
            }
        ]
    };



       
        groupsCtrl.groupStatGraph = {
            title       : groupsCtrl.groupStatGraphData.title,
            mainChart   : {
                config : {
                    refreshDataOnly: true,
                    deepWatchData  : true
                },
                options: {
                    chart: {
                        type        : 'multiBarChart',
                        //color       : ['#03a9f4', '#b3e5fc'],
                        color       : ['#78909c', '#cfd8dc'],
                        
                        height      : 320,
                        margin      : {
                            top   : 8,
                            right : 16,
                            bottom: 32,
                            left  : 32
                        },
                        clipEdge    : true,
                        groupSpacing: 0.3,
                        reduceXTicks: false,
                        stacked     : false,
                        duration    : 250,
                        x           : function (d)
                        {
                            return d.x;
                        },
                        y           : function (d)
                        {
                            return d.y;
                        },
                        yAxis       : {
                            tickFormat: function (d)
                            {
                                return d;
                            }
                        },
                        legend      : {
                            margin: {
                                top   : 8,
                                bottom: 32
                            }
                        },
                        controls    : {
                            margin: {
                                top   : 8,
                                bottom: 32
                            }
                        },
                        tooltip     : {
                            gravity: 's',
                            classes: 'gravity-s'
                        }
                    }
                },
                data   : []
            },
            ranges      : groupsCtrl.groupStatGraphData.ranges,
            currentRange: '',

            days        : ['Group1', 'Group2', 'Group3', 'Group4', 'Group5', 'Group6', 'Group7'],
            changeRange : function (range)
            {
                
                 /**
                 * Update main chart data by iterating through the
                 * chart dataset and separately adding every single
                 * dataset by hand.
                 *
                 * You MUST NOT swap the entire data object by doing
                 * something similar to this:
                 * vm.widget.mainChart.data = chartData
                 *
                 * It would be easier but it won't work with the
                 * live updating / animated charts due to how d3
                 * works.
                 *
                 * If you don't need animated / live updating charts,
                 * you can simplify these greatly.
                 */
                angular.forEach(groupsCtrl.groupStatGraphData.mainChart, function (chartData, index)
                {
                    groupsCtrl.groupStatGraph.mainChart.data[index] = {
                        key   : chartData.key,
                        values: chartData.values[range]
                    };
                });

                //alert(groupsCtrl.groupStatGraph.mainChart.data.length);
                
            },
            init        : function ()
            {
                
                groupsCtrl.groupStatGraph.changeRange('TW');
            }
        };

        groupsCtrl.groupStatGraph.init();
    }


})();
(function() {
	'use strict';

	angular.module('app.reset.password', []).config(config);

	function config($stateProvider) {
		$stateProvider.state('app.reset_password', {
			url : '/smartportal/reset/finish/:key',
			params: {
				key: null
            },
			views : {
				'main@' : {
					templateUrl : 'app/core/layouts/content-only.html',
					controller : 'MainController as vm'
				},
				'content@app.reset_password' : {
					templateUrl : 'app/main/reset/view/reset.html',
					controller : 'RPController as vm'
				}
			},
			bodyClass : 'RS',
			data : {
				accessRole : [ 'ALL' ]
			}
		});
	}
})();
(function() {
    'use strict';

    angular
        .module('app.reset.password')
        .controller('RPController', RPController);

    function RPController($scope, $state, $location, $stateParams,RestAPIService) {
        var vm = this;
        var key = $stateParams.key;
        $scope.finishPassword = {};

        $scope.cancel =function(){
            $location.path('/login');
        }
        $scope.resetPasswordfinish = function(finishPassword) { 
        	 $scope.finishPassword['key'] = key;
        	 $scope.finishPassword['newPassword'] = $scope.password;
        	
             RestAPIService.resetPasswordfinish($scope.finishPassword).then(
                   function(success) {
                	   RestAPIService.successTostDialog("Successfully Updated");
                   	$location.path('/smartportal/login');
                   },
                   function(error) {
                	   alert("Invalid Key");
                       //RestAPIService.showErrorDialog(error);
                   }
               );        
        }
    };

})();
(function() {
    'use strict';

    var app = angular
        .module('app.profile', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider, $controllerProvider, $compileProvider, $filterProvider, $provide) {
    	 app.controller = $controllerProvider.register;
         app.directive = $compileProvider.directive;
         app.filter = $filterProvider.register;
         app.factory = $provide.factory;
         app.service = $provide.service;
       

        $stateProvider
            .state('app.profile', {
                url: '/smartportal/profile',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/profile/myprofile.html',
                        controller: 'ProfileController as profileCtrl'
                    },
                    'about@app.profile': {
                        templateUrl: 'app/main/profile/about/about.html',
                        controller : 'AboutController as abtCtrl'
                    },
                    'substitution@app.profile': {
                        templateUrl: 'app/main/profile/substitution/substitution.html',
                        controller : 'SubstitutionController as substitutionCtrl'
                    }
                }
            });

        
       
     
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.profile')
        .controller('SubstitutionController', SubstitutionController);

    /** @ngInject */
    function SubstitutionController($scope,$location, $mdDialog, RestAPIService,$sessionStorage)
    {
        var substitutionCtrl = this;
        substitutionCtrl.getAllSubstitutes = function(){
        	RestAPIService.getAllSubstitutes().then(
                    function(success) {
                        $scope.allSubstitutes = success.data;                        
                    },
                    function(error) {
                        RestAPIService.showErrorDialog(error);
                    }
                );        	
        }
        $scope.createSubstitutor = function(ev){
        	$mdDialog.show({
        		templateUrl: 'app/main/profile/substitution/substitution.create.html',
                controller: CreateSubstitutorDialogController,                
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: $scope.customFullscreen
            })
        }
        function CreateSubstitutorDialogController($scope, $mdDialog, $sessionStorage){
        	$scope.getAllUsers = function(){
            	RestAPIService.getUsers().then(
                        function(success) {
                            $scope.usersList = success.data;                       
                        },
                        function(error) {
                            RestAPIService.showErrorDialog(error);
                        }
                    );
            }
        	$scope.cancel = function() {
               $mdDialog.cancel();
        	};
        	$scope.save = function(data){
                data['user_id'] = $sessionStorage.currentUser.username;
                data['createdBy'] = $sessionStorage.currentUser.username;
        		RestAPIService.createSubstitutor(data).then(
                        function(success) {
//                            $scope.usersList = success.data;
                        	$mdDialog.cancel();
                        	substitutionCtrl.getAllSubstitutes();
                        },
                        function(error) {
                            RestAPIService.showErrorDialog(error);
                        }
                    );
        		
        	}
        }
        
        $scope.update = function(ev,item){        	
        	substitutionCtrl.substitutionItem = angular.copy(item);
        	$mdDialog.show({
        		templateUrl: 'app/main/profile/substitution/substitution.update.html',
                controller: UpdateUserDialogController,                
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: $scope.customFullscreen
            })
        }
        function UpdateUserDialogController($mdDialog, $scope, RestAPIService){        	
        	$scope.substitutionItem = substitutionCtrl.substitutionItem;
            $scope.substitutionItem.from_date = new Date($scope.substitutionItem.from_date);
            $scope.substitutionItem.to_date = new Date($scope.substitutionItem.to_date);         		
        	$scope.cancel = function() {
                $mdDialog.cancel();
         	};
         	$scope.getAllUsers = function(){
            	RestAPIService.getUsers().then(
                        function(success) {
                            $scope.usersList = success.data;                       
                        },
                        function(error) {
                            RestAPIService.showErrorDialog(error);
                        }
                    );
            }
         	$scope.update = function(ev, data){
          		RestAPIService.updateSubstitutor(data).then(
                        function(success) {
                        	$mdDialog.cancel();
                        	substitutionCtrl.getAllSubstitutes();
                        },
                        function(error) {
                            RestAPIService.showErrorDialog(error);
                        });
         	}
        }
        $scope.delete = function(ev, data){
        	var confirm = $mdDialog.confirm()
            .title('Remove')
            .textContent('Substitution will be permanently deleted. Continue ?')
            .targetEvent(ev)
            .ok('Ok')
            .cancel('Cancel');
        $mdDialog.show(confirm).then(function() {
        	RestAPIService.deleteSubstitutor(data).then(
                    function(success) {                   
                    	RestAPIService.successTostDialog("Successfully Deleted.");
                    	substitutionCtrl.getAllSubstitutes();
                    },
                    function(error) {
                        RestAPIService.showErrorDialog(error);
                    }
                );
            
        }, function() {
            $mdDialog.cancel();
        });
        	
        }
        
        
        
        
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.profile')
        .controller('MyDossierDocumentsController', MyDossierDocumentsController);

    /** @ngInject */
    function MyDossierDocumentsController($scope, $mdDialog, RestAPIService,$sessionStorage,$sce)
    {
        var docCtrl = this;        
        $scope.init = function init(){
            RestAPIService.getPerticularBinder('binder5').then(function(responce){
                $scope.binderData = responce.data;
                console.log($scope.binderData);
            },function(error){
                RestAPIService.showErrorDialog(error);
            });
        }     
        $scope.init();       
        $scope.selectFolder = function(folderData){
            $scope.docTypeAndFormDetailsFinalArray = [];
            $scope.selectedFolder = folderData;           
            $scope.docTypesAndFormsDetailsList = {};
            RestAPIService.getdocTypesAndFormDetails($scope.selectedFolder.documentTypes.join('%2C')).then(function(success){
                $scope.docTypesAndFormsDetails = success.data;
                // Find the corresponding form content that is mapped to docType.               
                $scope.docTypesAndFormsDetails.documentTypes.forEach(function(h){
                    if(h.formId != null || h.formId != undefined){
                        $scope.docTypeAndFormDetailsFinalArray.push({
                            'docTypeDetails': h,
                            'formDetails': $scope.docTypesAndFormsDetails.documentTypesForms[h.formId],
                            'formContent': $scope.getFormContent($scope.docTypesAndFormsDetails.documentTypesForms[h.formId])
                        })
                    }else{
                        $scope.docTypeAndFormDetailsFinalArray.push({
                            'docTypeDetails': h,
                            'formDetails': '',
                            'formContent': ''
                        })
                    }                    
                })
                console.log("Final objects are",$scope.docTypeAndFormDetailsFinalArray);
            },function(error){
                RestAPIService.showErrorDialog(error);
            })
        }
        $scope.getFormContent = function(data){
            return $sce.trustAsHtml(data.content.replace(/&quot;/g,'"'));             
        }
         $scope.createFile = function(ev) {
            $mdDialog.show({
                controller: UploadDocumentDialogController,
                templateUrl: 'app/main/profile/documents/documentUploadDialog.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: $scope.customFullscreen
            })
        };
        function UploadDocumentDialogController($scope, $http, RestAPIService, $mdDialog, $state, $window) {
            // $scope.filepermission = siteDocLibCtrl.filepermission.foldersOnly;
            // if(siteDocLibCtrl.currentFolderId != ''){
            //     $scope.filepermission = false;
            // }
            // if(siteDocLibCtrl.receivedFile){
            // $scope.foldersOnly =siteDocLibCtrl.receivedFile.foldersOnly;            
            // }
            var formData = new FormData();
            $scope.files = [];
            $scope.setFile = function(element) {
                $scope.$apply(function() {                    
                    for (var i = 0; i < element.files.length; i++) {
                        formData.append('file', element.files[i]);
                        $scope.files.push(element.files[i]);
                    }
                });
            };

            $scope.hide = function() {
                $mdDialog.hide();
            };

            $scope.template = {};
            $scope.create = {};
            $scope.create['documentType'] = ""
            $scope.createFiledocTypeJson = {};
            $scope.documentType = {};
            $scope.documentTypeName = "";
            $scope.documentTypeCreate = {};
            $scope.attributeObjects = [];
            $scope.selectDocumentType = function(documentType) {
                RestAPIService.getDocumentTypeAttributes(documentType.id).then(function(responce) {
                        $scope.attributeObjects = responce.data.attributes;
                        $scope.documentTypeName = documentType.name

                        if (responce.data.attributes == null) {
                            alert("No Attributes for selected DocumentType");
                        }
                    },
                    function(error) {
                        RestAPIService.showErrorDialog(error);
                    })
            }

            $scope.selectDocumentTemplate = function(documentTemplate) {
                $scope.createDocumenttype = "";
                $scope.templateList.forEach(function(template) {
                    if (template.name == documentTemplate) {
                        $scope.createDocumenttype = template.documentType;
                        $scope.create.documentType = template.documentType;
                    }
                });

                $scope.documentsList.forEach(function(documentType) {
                    if (documentType.name == $scope.createDocumenttype) {
                        $scope.DocTypeattributeObjects = documentType.attributes;
                    }
                })
            }

            $scope.getDocumentTypes = function() {
                RestAPIService.getDocumentTypesforSite('site-2').then(
                    function(success) {
                        $scope.newDocumentType = [];

                        $scope.documentsList = success.data;
                        $scope.documentsList.forEach(function(documentType) {
                            if (documentType.approvalRequired == true && documentType.docuemntApprovalConfig !== null) {
                                //if(documentType.docuemntApprovalConfig !==null){
                                if (documentType.docuemntApprovalConfig.agents)
                                    $scope.newDocumentType.push(documentType);
                            }
                            //}
                            else if (documentType.approvalRequired == false) {
                                $scope.newDocumentType.push(documentType);
                            } else {
                                return;
                            }

                        })
                    },
                    function(error) {
                        RestAPIService.showErrorDialog(error);
                    }
                );
            }

            $scope.getDocumentTemplate = function() {
                RestAPIService.getDocumentTemplate().then(
                    function(success) {
                        $scope.templateList = success.data;
                    },
                    function(error) {
                        RestAPIService.showErrorDialog(error);
                    }
                );
            }

            $scope.cancel = function() {
                $mdDialog.cancel();
            };

            $scope.attributeObject = {};
            $scope.documentTypeJson = {};
            $scope.uploadFile = function(ev, folderName, description, documentTypeName, documentTypeJson) {            
                $rootScope.loadingProgress = true;
                $scope.documentTypeJson['documentType'] = documentTypeName;
                $scope.documentTypeJson['attributes'] = {};
                $scope.attributeObjects.forEach(function(attribute) {
                    $scope.documentTypeJson.attributes[attribute.name] = attribute.Value;
                });
                var files = $scope.files;
                if (files == undefined && folderName == undefined) {
                    $scope.ErrorMsg = "Please upload a file or create new folder"
                }
                if (undefined != files) {
                    /*  var file = files[Object.keys(files)[0]];
                      if (file.size > 100 * 1024 * 1024) {
                          alert("Too large File. Only File smaller than 100MB can be uploaded.");
                          return false;
                      }*/
                    RestAPIService.uploadFile(siteId, description, $scope.files[0], siteDocLibCtrl.currentFolderId, $scope.documentTypeJson).then(
                        function(success) {
                            //alert(JSON.stringify($scope.documentTypeJson));
                            $rootScope.loadingProgress = false;
                            RestAPIService.successTostDialog("Document Sent For Approval ");
                            siteDocLibCtrl.getFiles();
                        },
                        function(error) {
                            RestAPIService.showErrorDialog(error);
                        }
                    );
                    $mdDialog.hide(ev);
                }
                if (undefined != folderName) {
                    RestAPIService.createFolder(siteId,description, folderName, siteDocLibCtrl.currentFolderId).then(
                        function(success) {
                            $rootScope.loadingProgress = false;
                            RestAPIService.successTostDialog("Folder created successfully ");
                            siteDocLibCtrl.getFiles();
                            $mdDialog.hide(ev);
                        },
                        function(error) {
                            if (error) {
                                RestAPIService.successTostDialog(error.data.description);
                                return;
                            }
                        }
                    );

                }
            }

            $scope.createTemplateFile = function(ev, name, description, documentType, template) {
                $scope.templateName = template;
                $scope.createFiledocTypeJson['documentType'] = documentType;
                $scope.createFiledocTypeJson['attributes'] = {};
                $scope.DocTypeattributeObjects.forEach(function(attribute) {
                    $scope.createFiledocTypeJson.attributes[attribute.name] = attribute.Value;
                });
                RestAPIService.createTemplateFile(siteId, siteDocLibCtrl.currentFolderId, $scope.createFiledocTypeJson, $scope.templateName, name).then(
                    function(success) {
                        RestAPIService.successTostDialog("Created successfully ");
                        siteDocLibCtrl.getFiles();
                    },
                    function(error) {
                        RestAPIService.showErrorDialog(error);
                    }
                );
                $mdDialog.hide(ev);
            }
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.profile')
        .controller('AboutController', AboutController);

    /** @ngInject */
    function AboutController($scope, $location, $mdDialog, $localStorage)
    {
     var abtCtrl = this; 
     var json = $localStorage.logedInuserdetail;
     
     $scope.currentLogedInUser = json['currentLogedInUser'];
     $scope.loggedInUserName = json['loggedInUserName'];
     var LoggedInUserName = $scope.loggedInUserName;
     abtCtrl.editprofile =function(ev,user){
    	 abtCtrl.currentUser = angular.copy(user);
//    	 abtCtrl.currentUser = angular.copy(user);
         $mdDialog.show({
             controller: UpdateUserDialogController,
             templateUrl: 'app/main/profile/edit.profile.dialog.html',
             parent: angular.element(document.body),
             targetEvent: ev,
             clickOutsideToClose: true,
             fullscreen: $scope.customFullscreen
         })
     }
     function UpdateUserDialogController($scope, RestAPIService,$mdDialog, $state){    	 
    	 $scope.currentUser = abtCtrl.currentUser;
    	 $scope.roles = ["ROLE_USER", "ROLE_ADMIN"];
    	 $scope.status = ["true", "false"];
    	 $scope.currencyFormats = ["Dot(.)" , "Comma(,)"];
         $scope.dateFormats = ["YYYY-MM-DD", "DD.MM.YYYY", "YYYYMMDD", "DD-MM-YYYY", "MM-DD-YYYY", "MM/DD/YYYY"];
         $scope.currency= ["INR", "USD", "GBP", "EUR"];
         $scope.languages= ["English", "German", "French", "Spanish", "Hindi"];
         $scope.timeZones= ["BRT(Brasilia Time)", "CST(China Standard Time)", "ART(Argentina Time)", "BTT(Bhutan Time)", "CT(China Time)","IST(Indian Standard Time)"];
         $scope.updateUserProfile = function(user) {
             RestAPIService.updateUserProfile(user).then(
                 function(success) {
                 	RestAPIService.successTostDialog("Profile updated successfully");
                 
                     $mdDialog.hide(user);
                     $state.reload();
                 },
                 function(error) {
                     RestAPIService.showErrorDialog(error);
                 });
         }
        
          $scope.hide = function() {
              $mdDialog.hide();
          };
          $scope.cancel = function() {
              $mdDialog.cancel();
          };
    	 
     }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.mycontent.outbox',[])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider)
    {
        // State
        $stateProvider.state('app.mycontent_outbox', {
            url      : '/outbox',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/mycontent/outbox/outbox.html',
                    controller : 'OutboxController as outboxCtrl'
                }
            },
            resolve: {
                RestAPIService: 'RestAPIService',
                ReqOutbox: function(RestAPIService) {
                    return RestAPIService.getRequestOutbox();
                }
                  },
            bodyClass: 'mycontent-outbox'
        })
        .state('app.mycontent_outbox.details', {
            url: '/details/:requestType',
            params: {
                requestType: null
            },
            views: {
                'content@app': {
                    templateUrl: 'app/main/mycontent/outbox/outbox.workitems.html',
                    controller: 'OutboxController as outboxCtrl'
                }
            }
        });     
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.mycontent.outbox')
        .controller('OutboxController', OutboxController);

    /** @ngInject */
    function OutboxController($state, $stateParams, $scope, $http, RestAPIService, CommonUtil, ReqOutbox, $sce, $mdDialog,$sessionStorage ) {
        var contentCtrl = this;
        $scope.docTypes = [];
        $scope.docTypes = ReqOutbox.data;
        $scope.isUpdatable = true;  
        $scope.inbox =true; 
        $scope.openInWindow=function(fileData,reqId){
           ReqId = reqId; 
          var jwtToken = $sessionStorage.currentUser.token.trim();
          $scope.fileURL = fileData.url;
          //$scope.fileURL = baseUrl+ '/api/requests/inbox/filedownload?archiveId='+ fileData.archiveId + '&requestId=' + ReqId + '&archiveDocId='+ fileData.archiveDocId + '&attachment=false&jwtToken='+ jwtToken;
      window.open($scope.fileURL);
        return false;

    }
        $scope.goToOutbox = function() {
            $state.go('app.mycontent_outbox');
        }
        $scope.goBackToItems = function() {
            $scope.itemsVisibility = !$scope.itemsVisibility;
        }
        // $scope.goToWorkitems = function(requestType) {
        //     $state.go('app.mycontent_outbox.details', { 'requestType': requestType });
        // }
        $scope.goToWorkitems = function(requestType, displayName) {
          angular.forEach($scope.InboxConfig,function(item){
            // if(item.requestType == requestType){
            //      if(item.screenType == 'split_screen') $scope.stateName ="app.mtrInbox";
            //      else $scope.stateName ="app.mycontent_inbox.details" }
          })
            if(!$scope.stateName) $scope.stateName ='app.coromandeloutbox';
           $state.go($scope.stateName,{
            'requestType' : requestType,
              'displayName' : displayName
            });

          }
        resetRequest();
        function resetRequest() {
          $scope.header = {};
           // $scope.lineItems = [{}];          
            $scope.formHeader = false;
            $scope.formLineitem = false;
            contentCtrl.inboxComment = {};
            $scope.isReadOnlyHeaderCurrency = false;
            $scope.workitemInfo = {};
        }        
        $scope.selectWorkitem = function(workitem) {
          $scope.selectedWorkitem = workitem.docId;
            RestAPIService.getOutboxWorkitemInfo($stateParams.requestType, workitem.docId).then(function(responce) {
              viewForm(responce.data);
                $scope.workitemInfo = responce.data;
                $scope.header = responce.data.header;
                
                if($scope.header.BLDAT!=undefined || $scope.header.BLDAT!= null || $scope.header.BUDAT!=undefined || $scope.header.BUDAT!=null){
                 if($scope.header.BLDAT){
                    contentCtrl.InvoiceDate = $scope.header.BLDAT;                  
                    $scope.header.BLDAT = contentCtrl.InvoiceDate.substring(0,4)+'-'+contentCtrl.InvoiceDate.substring(4,6)+'-'+contentCtrl.InvoiceDate.substring(6,8);
                    $scope.header.BLDAT =  new Date($scope.header.BLDAT);
                  }
                  if($scope.header.BUDAT){
                    contentCtrl.PostingDate = $scope.header.BUDAT;
                    $scope.header.BUDAT = contentCtrl.PostingDate.substring(0,4)+'-'+contentCtrl.PostingDate.substring(4,6)+'-'+contentCtrl.PostingDate.substring(6,8);
                    $scope.header.BUDAT =  new Date($scope.header.BUDAT);
                  }
                  if($scope.header.RECEIPT_DATE){
                    contentCtrl.ReceiptDate = $scope.header.RECEIPT_DATE;
                    $scope.header.RECEIPT_DATE = contentCtrl.ReceiptDate.substring(0,4)+'-'+contentCtrl.ReceiptDate.substring(4,6)+'-'+contentCtrl.ReceiptDate.substring(6,8);
                    $scope.header.RECEIPT_DATE =new Date($scope.header.RECEIPT_DATE);
                  }
                  if($scope.header.WRBTR){
                        contentCtrl.Amount =$scope.header.WRBTR;
                        $scope.header.WRBTR = parseInt(contentCtrl.Amount);
                      }               
                }        
                // contentCtrl.lineItems = $scope.workitemInfo.lineItems;
                $scope.lineItems =[];
                angular.forEach($scope.workitemInfo.lineItems,function(key,value){
                    $scope.lineItems.push(key.lineItems);
                    if($scope.workitemInfo.lineItems.length == $scope.lineItems.length)
                    return;
                })   
                angular.forEach($scope.lineItems,function(key,value){
                  if(key.WRBTR !=undefined || key.WRBTR !=null){
                   contentCtrl.LineItemAmount =key.WRBTR;
                      key.WRBTR= parseInt(key.WRBTR);
                  }
                  if(key.WERKS){
                      var plant ={}
                      plant.listname ="plant_unit",
                      plant.listvar ="WERKS",
                      plant.value =key.WERKS;
                   RestAPIService.getItemDetails(plant).then(
                       function(success){
                           $scope.plantDescription =success.data;
                       },
                       function(error){
                       });                                       
                  }
                  if(key.WBS_ELEMENT){
                   var plant ={}
                   plant.listname ="wbs_element",
                   plant.listvar ="PSPNR",
                   plant.value =key.WBS_ELEMENT;
                RestAPIService.getItemDetails(plant).then(
                    function(success){
                        $scope.WBS_Description =success.data;
                    },
                    function(error){
                    });                                       
               }
                  if(key.KOSTL){
                   var plant ={}
                   plant.listname ="cost_center",
                   plant.listvar ="KOSTL",
                   plant.value =key.KOSTL;
                RestAPIService.getItemDetails(plant).then(
                    function(success){
                        $scope.CostDescription =success.data;
                        },
                    function(error){
                    });    

                  }
                  if(key.EKGRP){
                   var plant ={}
                   plant.listname ="purchasegroup",
                   plant.listvar ="EKGRP",
                   plant.value =key.EKGRP;
                RestAPIService.getItemDetails(plant).then(
                    function(success){
                        $scope.purchaseDescription =success.data;
                        },
                    function(error){
                    });    

                  }
                  if(key.SAKNR){
                   var plant ={}
                   plant.listname ="gl_account",
                   plant.listvar ="SAKNR",
                   plant.value =key.SAKNR;
                RestAPIService.getItemDetails(plant).then(
                    function(success){
                        $scope.glAccountDescription =success.data;
                        },
                    function(error){
                    });
                }
                if(key.ANLN1){
                   var plant ={}
                   plant.listname ="asset_code",
                   plant.listvar ="ANLN1",
                   plant.value =key.ANLN1;
                RestAPIService.getItemDetails(plant).then(
                    function(success){
                        $scope.AssetDescription =success.data;
                        },
                    function(error){
                    });
                }
                if(key.KNTTP){
                   var plant ={}
                   plant.listname ="account_assigning",
                   plant.listvar ="KNTTP",
                   plant.value =key.KNTTP;
                RestAPIService.getItemDetails(plant).then(
                    function(success){
                        $scope.AccountDescription =success.data;
                        },
                    function(error){
                    });
                }
                if(key.EPSTP){
                   var plant ={}
                   plant.listname ="item_category",
                   plant.listvar ="PSTYP",
                   plant.value =key.EPSTP;
                RestAPIService.getItemDetails(plant).then(
                    function(success){
                        $scope.ItemDescription =success.data;
                        },
                    function(error){
                    });
                }
                if(key.ORDER_NO){
                   var plant ={}
                   plant.listname ="order_number",
                   plant.listvar ="AUFNR",
                   plant.value =key.ORDER_NO;
                RestAPIService.getItemDetails(plant).then(
                    function(success){
                        $scope.OrderDescription =success.data;
                        },
                    function(error){
                    });
                }
               })       
                
             
                $scope.formHeader = true;
                $scope.formLineitem = true;                
                if(responce.data.dataChange == 'D'){
                  $scope.isUpdatable = false;
                  $scope.isReadOnlyHeaderCurrency = true;
                }
                
                $scope.workitemInfo.logs.forEach(function(h) {
          if (h.activityText == "Initiated") {
            h['icon'] = "icon-star-outline";
          }else if (h.activityText == "Confirm") {
            h['icon'] = "icon-check";
          }
          else if (h.activityText == "Approve") {
            h['icon'] = "icon-check";
          } else if (h.activityText == "Reject") {
            h['icon'] = "icon-cancel";
          }
          else if (h.activityText != "Initiated" && h.activityText != "Confirm" && h.activityText != "Approve" && h.activityText != "Reject") {
            h['icon'] = "icon-content-save";
          }

        })
            }, function(error) {
                RestAPIService.showErrorDialog(error);
            })
        };
       
        
        $scope.itemsVisibility = true;
        $scope.mobileselectWorkitem = function(workitem) {
          $scope.workitemInfo={};
            $scope.itemsVisibility = !$scope.itemsVisibility;            
      $scope.selectedWorkitem = workitem.docId;
      RestAPIService
          .getInboxWorkitemInfo($stateParams.requestType,
              workitem.docId)
          .then(
              function(responce) {
                resetRequest();
                viewForm(responce.data);
                $scope.displayName = $stateParams.displayName;
                $scope.workitemInfo = responce.data;
                $scope.workitemInfo.logs
                    .forEach(function(h) {
                      if (h.activityText == "Initiated") {
                        h['icon'] = "icon-star-outline";
                      }else if (h.activityText == "Confirm") {
                        h['icon'] = "icon-check";
                      }
                      else if (h.activityText == "Approve") {
                        h['icon'] = "icon-check";
                      } else if (h.activityText == "Reject") {
                        h['icon'] = "icon-cancel";
                      }else if (h.activityText != "Initiated" && h.activityText != "Confirm" && h.activityText != "Approve" && h.activityText != "Reject") {
                        h['icon'] = "icon-content-save";
                      }

                    })                
                $scope.header = responce.data.header;
                if($scope.header.BLDAT!=undefined || $scope.header.BLDAT!= null || $scope.header.BUDAT!=undefined || $scope.header.BUDAT!=null){
                  
                          if($scope.header.BLDAT){
                            contentCtrl.InvoiceDate = $scope.header.BLDAT;                  
                            $scope.header.BLDAT = contentCtrl.InvoiceDate.substring(6,8)+'-'+contentCtrl.InvoiceDate.substring(4,6)+'-'+contentCtrl.InvoiceDate.substring(0,4);
                          $scope.header.BLDAT =  new Date($scope.header.BLDAT);
                          }
                          if($scope.header.BUDAT){
                            contentCtrl.PostingDate = $scope.header.BUDAT;
                            $scope.header.BUDAT = contentCtrl.PostingDate.substring(6,8)+'-'+contentCtrl.PostingDate.substring(4,6)+'-'+contentCtrl.PostingDate.substring(0,4);
                            $scope.header.BUDAT =  new Date($scope.header.BUDAT);
                          }
                          if($scope.header.RECEIPT_DATE){
                            contentCtrl.ReceiptDate = $scope.header.RECEIPT_DATE;
                            $scope.header.RECEIPT_DATE = contentCtrl.ReceiptDate.substring(6,8)+'-'+contentCtrl.ReceiptDate.substring(4,6)+'-'+contentCtrl.ReceiptDate.substring(0,4);
                            $scope.header.BUDAT =  new Date($scope.header.BUDAT);
                          }
                           
                        if($scope.header.WRBTR){
                          contentCtrl.Amount =$scope.header.WRBTR;
                          $scope.header.WRBTR = parseInt(contentCtrl.Amount);
                      }
                    }
//                var d = new Date();
//                if ($scope.header.BLDAT != undefined
//                    || $scope.header.BLDAT != null) {
//                  contentCtrl.SAPDate = $scope.header.BLDAT;
//                  d.setYear($scope.header.BLDAT.substring(0,
//                      4));
//                  d.setMonth($scope.header.BLDAT.substring(4,
//                      6) - 1);
//                  d.setDate($scope.header.BLDAT.substring(6,
//                      8));
//                  $scope.header.BLDAT = d;
//                }

                  // contentCtrl.lineItems = responce.data.lineItems;
                  // angular.forEach(contentCtrl.lineItems,function(key,value){
                  //     $scope.lineItems.push(key.lineItems);
                  // })
                angular.forEach($scope.lineItems,function(key,value){
                  if(key.WRBTR !=undefined || key.WRBTR !=null){
                   key.WRBTR= contentCtrl.LineItemAmount;
                  }
               }) 
                // Object                   .values($scope.lineItems)
                //     .forEach(
                //         function(date) {
                //           date.Trans = new Date();
                //           $scope.lineItems.Trans = date.Trans;
                //         });
                // delete $scope.lineItems.Trans;
                // delete $scope.lineItems.curr;
                $scope.formHeader = true;
                $scope.formLineitem = true;
                if (responce.data.dataChange == 'D') {
                  $scope.isUpdatable = false;
                  $scope.isReadOnlyHeaderCurrency = true;
                }

              }, function(error) {
                RestAPIService.showErrorDialog(error);
              })
    
            
        }

          $scope.fileIcon = function(fileType){
          var icon ={};
            if(fileType == "folder"){
                  icon = "icon-folder";
              }                        
              else if(fileType.indexOf("jpg")!= -1){
                  icon = "icon-file-image";
              }
              else if(fileType.indexOf("jpeg")!= -1){
                  icon = "icon-file-image";
              }
              else if(fileType.indexOf("png")!= -1){
                  icon = "icon-file-image";
              }
              else if(fileType.indexOf("pdf")!= -1){
                  icon = "icon-file-pdf-box";
              }
              else if(fileType.indexOf("txt")!= -1){
                  icon = "icon-clipboard-text";
              }
              else if(fileType.indexOf("html")!= -1){
                  icon = "icon-language-html5";
              }
              else if(fileType.indexOf("xl")!= -1){
                  icon = "icon-file-excel";
              }
              else if(fileType.indexOf("word")!= -1){
                  icon = "icon-file-word";
              }
              else if(fileType.indexOf("xml")!= -1){
                  icon = "icon-file-xml";
              }
              else if(fileType.indexOf("doc")!= -1){
                  icon = "icon-file-document";
              }  
              else if(fileType.indexOf("docx")!= -1){
                  icon = "icon-file-document";
              }
              else if(fileType.indexOf("json")!= -1){
                  icon = "icon-clipboard-text";
              }                      

              else{
                  icon = "icon-file-document";
              }
              return icon;
              console.log(icon);
        }
          var ReqId;
          var archiveId;
          var archiveDocId;
          $scope.previewFile = function(ev, file, reqId) {
           ReqId = reqId;     
           archiveId = file.archiveId;
           archiveDocId = file.archiveDocId;
           contentCtrl.file = file;
          console.log(ReqId, archiveId, archiveDocId);
          if(file.fileType.toLowerCase() == 'pdf' ){
            window.open(file.url);
          }
          else{
          $mdDialog.show({
            controller : DialogController,
            templateUrl : 'app/main/mycontent/inbox/previewFiles.html',
            parent : angular.element(document.body),
            targetEvent : ev,
            clickOutsideToClose : true
          });
          }
        }
        function DialogController($scope, $mdDialog, $sce, $sessionStorage, $rootScope) {
          $scope.fileVis = false;
                $scope.imgVis= false;
          var jwtToken = $sessionStorage.currentUser.token.trim();
          if(jwtToken != undefined && ReqId != undefined) {
                //var encodedURI = encodeURIComponent(baseUrl+'/api/requests/inbox/filedownload?archiveId='+archiveId+'&requestId='+ReqId+'&archiveDocId='+archiveDocId+'&attachment=false&jwtToken='+jwtToken);
             var encodedURI =encodeURIComponent(contentCtrl.file.url);
            $scope.fileURL = $sce.trustAsResourceUrl('https://docs.google.com/gview?url='+encodedURI+'&embedded=true');
                if(contentCtrl.file.fileType =="jpg" || contentCtrl.file.fileType =="JPG" || contentCtrl.file.fileType =="jpeg" || contentCtrl.file.fileType =="JPEG" || contentCtrl.file.fileType =="PNG" || contentCtrl.file.fileType =="png"){
                      $scope.imgVis= true;
                      $scope.fileURL =contentCtrl.file.url;
                      }else{
                      $scope.fileVis= true;
                      $scope.fileURL = $sce.trustAsResourceUrl('https://docs.google.com/gview?url='+encodedURI+'&embedded=true');
                      }
                
              }
//              if(jwtToken != undefined && ReqId != undefined) {
//                var encodedURI = encodeURIComponent(baseUrl+'/api/requests/inbox/filedownload?archiveId='+archiveId+'&requestId='+ReqId+'&archiveDocId='+archiveDocId+'&attachment=false&jwtToken='+jwtToken);
//                  if($rootScope.online){                
//                    $scope.fileURL = $sce.trustAsResourceUrl('https://docs.google.com/gview?url='+encodedURI+'&embedded=true');
//                  }else {
//                    $scope.fileURL = baseUrl+ '/api/requests/inbox/filedownload?archiveId='+ archiveId + '&requestId=' + ReqId + '&archiveDocId='+ archiveDocId + '&attachment=true&jwtToken='+ jwtToken;
//                  }             
//                
//              }
          
//          if(contentCtrl.file.fileType =="jpg" || contentCtrl.file.fileType =="JPG" || contentCtrl.file.fileType =="jpeg" || contentCtrl.file.fileType =="JPEG" || contentCtrl.file.fileType =="PNG" || contentCtrl.file.fileType =="png"){
//                 $scope.imgVis= true;
//                 $scope.fileURL =contentCtrl.file.url;
//                }else{
//                 $scope.fileVis= true;
//                $scope.fileURL =contentCtrl.file.url;
//                }
//          $scope.cancel = function() {
//            $mdDialog.cancel();
//          }
        }
          $scope.download = function(file, reqId) {
          archiveId = file.archiveId;
          ReqId = reqId;
          archiveDocId = file.archiveDocId;
          // console.log(file);

          RestAPIService.downloadAttachment(ReqId, archiveId, archiveDocId)
              .then(function(success) {
                var headers = success.headers();
                // alert(JSON.stringify(headers));
                var data = success.data;
                // alert(data);
                // var filename = headers['x-filename'];
                var filename = file.fileName;
                var contentType = headers['content-type'];
                var linkElement = document.createElement('a');
                try {
                  var blob = new Blob([ data ], {
                    type : contentType
                  });
                  var url = window.URL.createObjectURL(blob);
                  linkElement.setAttribute('href', url);
                  linkElement.setAttribute("download", filename);
                  var clickEvent = new MouseEvent("click", {
                    "view" : window,
                    "bubbles" : true,
                    "cancelable" : false
                  });
                  linkElement.dispatchEvent(clickEvent);
                } catch (ex) {
                  console.log(ex);
                }
              }, function(error) {
                console.log('ERROR Downloading the file ********');
                RestAPIService.showErrorDialog(error);
              });
        }
        $scope.myView = true;
        $scope.changeView = function() {
            $scope.myView = !$scope.myView;
        };

        $scope.search = function(query) {
            $scope.searchString = query;
        };
        $scope.selectedTab = 0;
        $scope.changeTab = function() {
            if ( $scope.selectedTab > 0 ) {
                $scope.selectedTab = 0;
            }
            else {
                $scope.selectedTab--;
            }
            
        }
        function viewForm(data){
          RestAPIService.getFormData(data).then(function(success){
            $scope.formData=success.data;
            $scope.currentFormHeader = $sce.trustAsHtml($scope.formData.content.replace(/&quot;/g, '"'));
         $scope.currentFormLineitem = $sce.trustAsHtml($scope.formData.lineItemContent.replace(/&quot;/g, '"'));
         $scope.currentFormInboxHeader = $sce.trustAsHtml($scope.formData.inboxHeaderContent.replace(/&quot;/g, '"'));
         $scope.currentFormInboxLineitem = $sce.trustAsHtml($scope.formData.inboxLineItemContent.replace(/&quot;/g, '"'));
        },function(error){

        })
            // $scope.currentFormHeader = $sce.trustAsHtml(data.mainLayout.replace(/&quot;/g,'"'));
            // $scope.currentFormLineitem = $sce.trustAsHtml(data.detailsLayout.replace(/&quot;/g,'"'));
        }
        $scope.getAnotherColor = function(index) {
            $scope.colors = ['blue-bg white-fg','pink-bg white-fg','green-bg white-fg'];
            var totalNoOfColors = $scope.colors.length;
            return $scope.colors[index % totalNoOfColors];
        }
        $scope.currencies = ["INR","USD","EUR","PLN"];
        $scope.getInvoiceTypes = function() {
          var list = "InvoiceTypes";
            RestAPIService.getdetaildata(list).then(
                function(success) {
                    $scope.invoiceList = success.data;
                   // alert(JSON.stringify($scope.invoiceList));
                   
                },
                function(error) {
                    RestAPIService.showErrorDialog(error);
                }
            );
           
        }

        $scope.getCompanies = function() {
          var list = "Company";
            RestAPIService.getdetaildata(list).then(
                function(success) {
                    $scope.companyList = success.data;
//                   alert(JSON.stringify($scope.companyList));
                   
                },
                function(error) {
                    RestAPIService.showErrorDialog(error);
                }
            );
           
        }

        $scope.getVendors = function() {
          var list = "Vendor";
            RestAPIService.getdetaildata(list).then(
                function(success) {
                    $scope.vendorList = success.data;
                   // alert(JSON.stringify($scope.vendorList));
                   
                },
                function(error) {
                    RestAPIService.showErrorDialog(error);
                }
            );
           
        }
        
        $scope.getDocTypes = function() {
          var list = "DocTypes";
            RestAPIService.getdetaildata(list).then(
                function(success) {
                    $scope.doctypeList = success.data;
                  //  alert(JSON.stringify($scope.doctypeList));
                   
                },
                function(error) {
                    RestAPIService.showErrorDialog(error);
                }
            );
           
        }
        $scope.getAllWorkitems = function() {
          RestAPIService.getAllOutboxWorkitems($stateParams.requestType,$scope.pageNumber, $scope.size).then(
                    function(success) {
                        $scope.allWorkitems = success.data;
                    },
                    function(error) {
                        RestAPIService.showErrorDialog(error);
                    });
//          These are for Payables Build. Dont delete these.
//            $scope.getInvoiceTypes();
//          $scope.getCompanies();
//          $scope.getVendors();
//          $scope.getDocTypes();
        };
        $scope.pageNumber = 0;
        $scope.size = 200;
        $scope.nextInboxItems = function() {      
//      Preventing the request call for next items when items in present page are zero.
      if($scope.allWorkitems.length != 0){
        $scope.pageNumber = $scope.pageNumber + 1;
        $scope.getAllWorkitems();
      }
      else{
        return;
      }
    }
    $scope.previousInboxItems = function() {
//      Make the previous items call when the page number is greater than or equal to zero.
      if ($scope.pageNumber - 1 >= 0) {
        $scope.pageNumber = $scope.pageNumber - 1;
        $scope.getAllWorkitems();
      } else {
        alert("This is First page.");
      }
    }
        
        // Initial load
        init();

        function init() {
            if ($stateParams.requestType != undefined) {
              $scope.getAllWorkitems();             
            }
        }
    }

         
})();
(function ()
{
    'use strict';

    angular
        .module('app.mycontent.inbox', ['app.mtrInbox'])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider)
    {
        // State
        $stateProvider.state('app.mycontent_inbox', {
            url      : '/inbox',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/mycontent/inbox/inbox.html',
                    controller : 'InboxController as inboxCtrl'
                }
            },
            resolve: {
                RestAPIService: 'RestAPIService',
                ReqInbox: function(RestAPIService) {
                    return RestAPIService.getRequestGroupDoctypes();
                },
                Plants: function(RestAPIService) {
                    return RestAPIService.GetPlants();
                },
                PRDoctypes: function(RestAPIService){
                    return RestAPIService.getDocTypes("pr_doctype");
                },
                MaterialTypes: function(RestAPIService) {
                    return RestAPIService.GetMaterialTypes();
                },
                BlockList:function(RestAPIService){
                    return RestAPIService.getBlockList("block_text");
                }
                         
            },
            bodyClass: 'mycontent-inbox'
        })
        .state('app.mycontent_inbox.details', {
            url: '/details/:requestType',
            params: {
                requestType: null,
                displayName:null
            },
            views: {
                'content@app': {
                    templateUrl: 'app/main/mycontent/inbox/inbox.workitems.html',
                    controller: 'InboxController as inboxCtrl'
                }
            }
        });     
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.mycontent.inbox')
        .controller('InboxController', InboxController);
    /** @ngInject */
    var ReqId = "";
    var archiveId = "";
    var archiveDocId ="";
   function InboxController($state, $stateParams, $scope, $http,$anchorScroll,
            RestAPIService, CommonUtil, ReqInbox, $sce, $mdDialog, $window,$sessionStorage,$localStorage,AuthenticationService,
            $rootScope,Plants,PRDoctypes,MaterialTypes,BlockList) {

        if($localStorage.currentUser == undefined || $localStorage.currentUser ==null ){
            AuthenticationService.Logout();
        }
        else{
        var jwtToken = $localStorage.currentUser.token.trim();
        RestAPIService.getAllCodingTemplates($stateParams.requestType, 0,1000).then(
            function(success) {
                contentCtrl.AllcodingTemplates = success.data;
                $scope.totalRecords = success.headers('x-total-count');
                $scope.pages = $scope.totalRecords/$scope.size;
                var index= $scope.pages.toString().indexOf('.');
                    var x= $scope.pages.toString().substring(0,index);
                    $scope.totalPages = parseInt(x)+1;
            },
            function(error) {
                RestAPIService.showErrorDialog(error);
            });
        }
        var contentCtrl = this;
        $scope.CodingTemplate = true;

        $scope.docTypes = [];
         $scope.toggle = [];
         $scope.arrow =[];
        $scope.toggleFilter = function(inx) {
            $scope.arrow[inx]=$scope.arrow[inx] === true ? false :true;
            $scope.toggle[inx] = $scope.toggle[inx] === true ? false : true;
        };
        $scope.Total =function(price,Quantity,index){
            if(Quantity == undefined || Quantity ==null || price == undefined || price == null){
                $scope.lineItems[index].GSWRT = 0;
                return;
            }
            $scope.lineItems[index].GSWRT = parseFloat(Quantity) * parseFloat(price);
            parseFloat( $scope.lineItems[index].GSWRT).toFixed(2);
          }


        $scope.Allplants=Plants.data;
        $scope.prDoctypes =PRDoctypes.data;
        $scope.docTypes = ReqInbox.data;
        $scope.BlockLists =BlockList.data;
        $scope.isUpdatable = true;
        $scope.inbox =true;
        $rootScope.inboxButtons = false;


        //Code For Alkem only

        if(!FinalLineItems){
            var FinalLineItems = [];
         }
         if(!UpdatedLinItems){
            var UpdatedLinItems = [];
         }
        $scope.searchCodingTemplates =function(ev,index){
          $mdDialog.show({
               controllerAs: 'searchCodingTemplateDialogCtrl',
               controller: searchCodingTemplateDialogCtrl,
               preserveScope: true,
               autoWrap: true,
               templateUrl: 'app/main/Requests/coadingTemplates.html'
           });
       }
       function searchCodingTemplateDialogCtrl($scope,$mdDialog,RestAPIService){
       // var FinalLineItems = [];
        $scope.searchResult =contentCtrl.AllcodingTemplates;
        $scope. searchResultRowClick =function(order){
            angular.forEach(order.lineItems,function(key,value){
                if(key.WRBTR){
                    key.WRBTR =parseInt(key.WRBTR);
                }
              UpdatedLinItems.push(key);

            })
            if(contentCtrl.lineItems){
               var codingtemplates =contentCtrl.InsideLineItems.concat(UpdatedLinItems);
               contentCtrl.setCodingtemplates(codingtemplates);
            }
            if(UpdatedLinItems.length>0 && contentCtrl.lineItems == 0){
                codingtemplates = UpdatedLinItems;
                contentCtrl.setCodingtemplates(codingtemplates);
              }
            // else{
            //     UpdatedLinItems =FinalLineItems;
            //     contentCtrl.setCodingtemplates(UpdatedLinItems);
            // }
        }
       $scope.pageNumber = 0;
        $scope.page =100;
        $scope.size=100;
        $scope.cancel = function() {
        $mdDialog.cancel();
      };
    }
    contentCtrl.setCodingtemplates =function(FinallineItems){
        $scope.lineItems =FinallineItems;
        $mdDialog.cancel();

    }

        contentCtrl.setorderCode =function(data){
            $scope.lineItems[contentCtrl.selectedIndex].ORDER_NO =data.AUFNR;
        }
        contentCtrl.setCostCenter=function(data){
            $scope.lineItems[contentCtrl.selectedIndex].KOSTL =data.KOSTL;
        }
        contentCtrl.setGLAccount =function(data){
            $scope.lineItems[contentCtrl.selectedIndex].SAKNR =data.SAKNR;
        }
        contentCtrl.setFunctionalArea =function(data){
          $scope.lineItems[contentCtrl.selectedIndex].FKBER =data.FKBER;
        }
        $scope.searchOrder =function(ev,index){
            contentCtrl.selectedIndex = index;
            $mdDialog.show({
                controllerAs: 'searchOrderDialogCtrl',
                controller: searchOrderDialogCtrl,
                preserveScope: true,
                autoWrap: true,
                templateUrl: 'app/main/Requests/orderdialog.html'
            });
        }
        function searchOrderDialogCtrl($scope, RestAPIService, $mdDialog) {
            $scope.searchAssetCode ={};
            $scope.pageNumber = 0;
            $scope.page =100;
            $scope.size=100;
            $scope.cancel = function() {
                $mdDialog.cancel();
            };
            $scope.searchAssetCode =function(search){
                RestAPIService.getorderDataBySearch(search,$scope.pageNumber, $scope.size).then(
                    function(success) {
                      $scope.searchResult =success.data;
                      $scope.totalRecords = success.headers('x-total-count');
                      $scope.pages = $scope.totalRecords/$scope.size;
                      var index= $scope.pages.toString().indexOf('.');
                          var x= $scope.pages.toString().substring(0,index);
                          $scope.totalPages = parseInt(x)+1;
                    },
                    function(error) {
                        RestAPIService.showErrorDialog(error);
                    });
                    $scope.searchResultRowClick = function(order) {
                        contentCtrl.searchData =order;
                       contentCtrl.setorderCode(order);

                        $mdDialog.cancel();
                    };
                    $scope.next = function(){
                        $scope.pageNumber = $scope.pageNumber + 1;
                        RestAPIService.getorderDataBySearch(search,$scope.pageNumber, $scope.size).then(
                            function(success) {
                                $scope.searchResult = success.data;
                            },
                            function(error) {
                                RestAPIService.showErrorDialog(error);
                            });
                    }
                    $scope.previous = function(){
                        $scope.pageNumber = $scope.pageNumber - 1;
                        RestAPIService.getorderDataBySearch(search,$scope.pageNumber, $scope.size).then(
                            function(success) {
                                $scope.searchResult = success.data;
                            },
                            function(error) {
                                RestAPIService.showErrorDialog(error);
                            });

                    }
            }
        }

        $scope.searchCostCenter =function(ev,index){
            contentCtrl.selectedIndex = index;
            $mdDialog.show({
                controllerAs: 'searchCostCenterDialogCtrl',
                controller: searchCostCenterDialogCtrl,
                preserveScope: true,
                autoWrap: true,
                templateUrl: 'app/main/Requests/costcenterdialog.html'
            });
        }
        function searchCostCenterDialogCtrl($scope, RestAPIService, $mdDialog) {
            $scope.searchAssetCode ={};
            $scope.pageNumber = 0;
            $scope.page =100;
            $scope.size=100;
            $scope.cancel = function() {
                $mdDialog.cancel();
            };

            $scope.searchCostCenter =function(search){
                RestAPIService.getCostCenterData(search,$scope.pageNumber, $scope.size).then(
                    function(success) {
                      $scope.searchResult =success.data;
                      $scope.totalRecords = success.headers('x-total-count');
                      $scope.pages = $scope.totalRecords/$scope.size;
                      var index= $scope.pages.toString().indexOf('.');
                          var x= $scope.pages.toString().substring(0,index);
                          $scope.totalPages = parseInt(x)+1;
                    },
                    function(error) {
                        RestAPIService.showErrorDialog(error);
                    });
                    $scope.searchResultRowClick = function(order) {
                        contentCtrl.searchData =order;
                       contentCtrl.setCostCenter(order);

                        $mdDialog.cancel();
                    };
                    $scope.next = function(){
                        $scope.pageNumber = $scope.pageNumber + 1;
                        RestAPIService.getCostCenterData(search,$scope.pageNumber, $scope.size).then(
                            function(success) {
                                $scope.searchResult = success.data;
                            },
                            function(error) {
                                RestAPIService.showErrorDialog(error);
                            });
                    }
                    $scope.previous = function(){
                        $scope.pageNumber = $scope.pageNumber - 1;
                        RestAPIService.getCostCenterData(search,$scope.pageNumber, $scope.size).then(
                            function(success) {
                                $scope.searchResult = success.data;
                            },
                            function(error) {
                                RestAPIService.showErrorDialog(error);
                            });

                    }
            }
        }
        $scope.searchGLAccount =function(ev,index){
            // contentCtrl.selectedIndex = index;
             contentCtrl.selectedIndex =index;
             $mdDialog.show({
                 controllerAs: 'searchGLAccountDialogCtrl',
                 controller: searchGLAccountDialogCtrl,
                 preserveScope: true,
                 autoWrap: true,
                 templateUrl: 'app/main/Requests/glAccountdialog.html'
             });
         }
         function searchGLAccountDialogCtrl($scope, RestAPIService, $mdDialog) {
             $scope.searchGlAccount ={};
             $scope.pageNumber = 0;
             $scope.page =100;
             $scope.size=100;
             $scope.cancel = function() {
                 $mdDialog.cancel();
             };
             $scope.searchGLValues =function(search){
               RestAPIService.getGLDataBySearch(search,$scope.pageNumber, $scope.size).then(
                     function(success) {
                         $scope.searchResult = success.data;
                         $scope.totalRecords = success.headers('x-total-count');
                         $scope.pages = $scope.totalRecords/$scope.size;
                         var index= $scope.pages.toString().indexOf('.');
                             var x= $scope.pages.toString().substring(0,index);
                             $scope.totalPages = parseInt(x)+1;
                     },
                     function(error) {
                         RestAPIService.showErrorDialog(error);
                     });

                     $scope.next = function(){
                         $scope.pageNumber = $scope.pageNumber + 1;
                         RestAPIService.getGLDataBySearch(search,$scope.pageNumber, $scope.size).then(
                             function(success) {
                                 $scope.searchResult = success.data;
                             },
                             function(error) {
                                 RestAPIService.showErrorDialog(error);
                             });
                     }
                     $scope.previous = function(){
                         $scope.pageNumber = $scope.pageNumber - 1;
                         RestAPIService.getGLDataBySearch(search,$scope.pageNumber, $scope.size).then(
                             function(success) {
                                 $scope.searchResult = success.data;
                             },
                             function(error) {
                                 RestAPIService.showErrorDialog(error);
                             });

                     }
                     $scope.searchResultRowClick = function(order) {
                         contentCtrl.searchData =order;
                        contentCtrl.setGLAccount(order);

                         $mdDialog.cancel();
                     };
                 }
         }

         $scope.searchFunctionalArea =function(ev,index){
          // contentCtrl.selectedIndex = index;
           contentCtrl.selectedIndex =index;
           $mdDialog.show({
               controllerAs: 'searchFunctionalAreaDialogCtrl',
               controller: searchFunctionalAreaDialogCtrl,
               preserveScope: true,
               autoWrap: true,
               templateUrl: 'app/main/Requests/FunctionalAreaDialog.html'
           });
       }
       function searchFunctionalAreaDialogCtrl($scope, RestAPIService, $mdDialog) {
           $scope.searchGlAccount ={};
           $scope.pageNumber = 0;
           $scope.page =100;
           $scope.size=100;
           $scope.cancel = function() {
               $mdDialog.cancel();
           };
           $scope.searchFuncationlArea =function(search){
             RestAPIService.getFuncationalDataBySearch(search,$scope.pageNumber, $scope.size).then(
                   function(success) {
                       $scope.searchResult = success.data;
                       $scope.totalRecords = success.headers('x-total-count');
                       $scope.pages = $scope.totalRecords/$scope.size;
                       var index= $scope.pages.toString().indexOf('.');
                           var x= $scope.pages.toString().substring(0,index);
                           $scope.totalPages = parseInt(x)+1;
                   },
                   function(error) {
                       RestAPIService.showErrorDialog(error);
                   });

                   $scope.next = function(){
                       $scope.pageNumber = $scope.pageNumber + 1;
                       RestAPIService.getFuncationalDataBySearch(search,$scope.pageNumber, $scope.size).then(
                           function(success) {
                               $scope.searchResult = success.data;
                           },
                           function(error) {
                               RestAPIService.showErrorDialog(error);
                           });
                   }
                   $scope.previous = function(){
                       $scope.pageNumber = $scope.pageNumber - 1;
                       RestAPIService.getFuncationalDataBySearch(search,$scope.pageNumber, $scope.size).then(
                           function(success) {
                               $scope.searchResult = success.data;
                           },
                           function(error) {
                               RestAPIService.showErrorDialog(error);
                           });

                   }
                   $scope.searchResultRowClick = function(order) {
                       contentCtrl.searchData =order;
                      contentCtrl.setFunctionalArea(order);

                       $mdDialog.cancel();
                   };
               }
       }



        $scope.searchPurchaseOrder = function(ev, index) {
            contentCtrl.selectedIndex = index;
                $mdDialog.show({
                    controllerAs: 'searchPurchaseOrderDialogCtrl',
                    controller: SearchPurchaseOrderController,
                    preserveScope: true,
                    autoWrap: true,
                    templateUrl: 'app/main/mycontent/inbox/searchDataDialog.html'
                });
            };
            function SearchPurchaseOrderController($scope, RestAPIService, $mdDialog) {
                $scope.SearchObject ={};
                $scope.pageNumber = 0;
                $scope.page =100;
                $scope.size=100;
                $scope.cancel = function() {
                    $mdDialog.cancel();
                };
                $scope.materialTypes =MaterialTypes.data;
               // $scope.plants =Plants.data;
                $scope.searchValues = function(search) {
                    $scope.pageNumber = 0;
                    if(search == null || search ==undefined){
                        var search ={};
                        search['_id']='';
                    }
                  $scope.SearchObject =search;
                    RestAPIService.getLisBySearch(search,$scope.pageNumber, $scope.size).then(
                        function(success) {
                            $scope.searchResult = success.data;
                            $scope.totalRecords = success.headers('x-total-count');
                            $scope.pages = $scope.totalRecords/$scope.size;
                            var index= $scope.pages.toString().indexOf('.');
                                var x= $scope.pages.toString().substring(0,index);
                                $scope.totalPages = parseInt(x)+1;
                        },
                        function(error) {
                            RestAPIService.showErrorDialog(error);
                        });

                        $scope.next = function(){
                            $scope.pageNumber = $scope.pageNumber + 1;
                            RestAPIService.getLisBySearch($scope.SearchObject,$scope.pageNumber, $scope.size).then(
                                function(success) {
                                    $scope.searchResult = success.data;
                                },
                                function(error) {
                                    RestAPIService.showErrorDialog(error);
                                });
                        }
                        $scope.previous = function(){
                            $scope.pageNumber = $scope.pageNumber - 1;
                            RestAPIService.getLisBySearch($scope.SearchObject,$scope.pageNumber, $scope.size).then(
                                function(success) {
                                    $scope.searchResult = success.data;
                                },
                                function(error) {
                                    RestAPIService.showErrorDialog(error);
                                });
                        }
                        $scope.searchResultRowClick = function(order) {
                            contentCtrl.searchData =order;
                           contentCtrl.setLineItemFields(order);

                            $mdDialog.cancel();
                        };
                };
            }


        $scope.searchList =function(ev,index,material){
            contentCtrl  .type =material;
            if(material == 'glAccount'){
                contentCtrl.url ="gl_account",
           contentCtrl.searchtypes =[{"name":"GL Account","value":"SAKNR"},{"name":"Description","value":"TXT20"}]
          }
          if(material == 'Asset'){
           contentCtrl.url ="asset_code",
           contentCtrl.searchtypes =[{"name":"AssetCode","value":"ANLN1"},{"name":"Description","value":"TXT50"}]
          }
          if(material == 'MaterialGroupDesc'){
            contentCtrl.url ="material_group",
            contentCtrl.searchtypes =[{"name":"MaterialGroup","value":"MATKL"},{"name":"Description","value":"WGBEZ "}]
          }
           $mdDialog.show({
               controllerAs: 'searchTestDialogCtrl',
               controller: searchTestDialogCtrl,
               preserveScope: true,
               autoWrap: true,
               templateUrl: 'app/main/mycontent/inbox/Inbox_PR_Edit.html'
           });
       }



       function searchTestDialogCtrl($scope,$mdDialog,RestAPIService){
           $scope.Type =contentCtrl  .type;
           $scope.searchMaterial =contentCtrl.searchtypes;
           $scope.url =contentCtrl.url;
           $scope.pageNumber = 0;
           $scope.page =100;
           $scope.size=100;
           $scope.searchList =function(search){
               RestAPIService.getAllList(search,$scope.url,$scope.pageNumber, $scope.size).then(
                   function(success) {
                       $scope.searchResult = success.data;
                       $scope.totalRecords = success.headers('x-total-count');
                       $scope.pages = $scope.totalRecords/$scope.size;
                       var index= $scope.pages.toString().indexOf('.');
                           var x= $scope.pages.toString().substring(0,index);
                           $scope.totalPages = parseInt(x)+1;
                   },
                   function(error) {
                       RestAPIService.showErrorDialog(error);
                   });
           }


           $scope.cancel = function() {
           $mdDialog.cancel();


       };
       }

        $scope.events = [ {
            badgeClass : 'info',
            badgeIconClass : 'glyphicon-check',
            title : 'First heading',
            content : 'Some awesome content.'
        }, {
            badgeClass : 'warning',
            badgeIconClass : 'glyphicon-credit-card',
            title : 'Second heading',
            content : 'More awesome content.'
        } ];
        $scope.openInWindow=function(fileData){
            window.open(fileData);
            return false;
        }
        $scope.getinboxConfig =function(){
          RestAPIService.getInboxConfgData().then(
            function(success){
              $scope.InboxConfig= success.data},
              function(error){}
          )
        }


        $scope.goToWorkitems = function(requestType, displayName) {
            // $scope.stateName ='app.coromandelinbox';
            //   $scope.stateName ="app.mtrInbox";
        //   angular.forEach($scope.InboxConfig,function(item){
        //     if(item.requestType == requestType){
        //          if(item.screenType == 'split_screen') $scope.stateName ="app.mtrInbox";
        //          else $scope.stateName ="app.mycontent_inbox.details" }
        //   })
        //     if(!$scope.stateName) $scope.stateName ='app.coromandelinbox';


        //coromandel Inbox
           $state.go('app.coromandelinbox',{
            'requestType' : requestType,
              'displayName' : displayName
            });


        //alkem inbox 
        // $state.go('app.mycontent_inbox.details', {
        //     'requestType' : requestType,
        //     'displayName' : displayName
        // });

        
        //Mtr inbox
        // $state.go('app.mtrInbox', {
        //         'requestType' : requestType,
        //         'displayName' : displayName
        //     });

          }

        resetRequest();
        function resetRequest() {
            $scope.header = {};
            $scope.lineItems = [ ];
            $scope.formHeader = false;
            $scope.formLineitem = false;
            contentCtrl.inboxComment = {};
            $scope.isReadOnlyHeaderCurrency = false;
            $scope.workitemInfo = {};
            $scope.attachmentfiles = [];
        }
        contentCtrl.pageNo=0;
        contentCtrl.size =50;
        $scope.loadMore =function(){
            contentCtrl.pageNo ++;
            $scope.MoreLineItems =[];
            RestAPIService.getInboxWorkitemInfo($stateParams.requestType,contentCtrl.docId,contentCtrl.pageNo,contentCtrl.size).then(
                function(responce){
                    $scope.MoreItems =responce.data.lineItems;
                    angular.forEach($scope.MoreItems,function(key,value){
                        $scope.MoreLineItems.push(key.lineItems);
                    })
                    $scope.lineItems =$scope.lineItems.concat($scope.MoreLineItems);
                },
                function(error){

                }
            )}

        $scope.selectWorkitem = function(workitem) {
           contentCtrl.docId =workitem.docId;
            $scope.selectedWorkitem = workitem.docId;
            $scope.selectWorkitemDescription =workitem.description;
             RestAPIService.getInboxWorkitemInfo($stateParams.requestType,workitem.docId,"0","100").then(
                            function(responce) {
                                resetRequest();
                                viewForm(responce.data);
                                $scope.disabled =true
                                $scope.displayName = $stateParams.displayName;
                                $scope.workitemInfo = responce.data;
                               // $scope.totalLineItems = responce.headers('x-total-count');
                                $scope.workitemInfo.logs.forEach(function(h) {
                                            if (h.activityText == "Initiated") {
                                                h['icon'] = "icon-star-outline";
                                            }else if (h.activityText == "Confirm") {
                                                h['icon'] = "icon-check";
                                            }else if (h.activityText == "Approve") {
                                                h['icon'] = "icon-check";

                                            }else if (h.activityText == "Reject") {
                                                h['icon'] = "icon-cancel";
                                            }else if (h.activityText != "Initiated" && h.activityText != "Confirm" && h.activityText != "Approve" && h.activityText != "Reject") {
                                                h['icon'] = "icon-content-save";
                                            }
                                        })
                                $scope.header = responce.data.header;
                                if($scope.header.BLDAT!=undefined || $scope.header.BLDAT!= null || $scope.header.BUDAT!=undefined || $scope.header.BUDAT!=null){
                                    if($scope.header.BLDAT){
                                    contentCtrl.InvoiceDate = $scope.header.BLDAT;
                                    $scope.header.BLDAT = CommonUtil.generatePortalDate($scope.header.BLDAT);
                                    }
                                    if($scope.header.BUDAT){
                                    contentCtrl.PostingDate = $scope.header.BUDAT;
                                    $scope.header.BUDAT =  CommonUtil.generatePortalDate($scope.header.BUDAT);
                                    }
                                    if($scope.header.RECEIPT_DATE){
                                        contentCtrl.ReceiptDate = $scope.header.RECEIPT_DATE;
                                        $scope.header.RECEIPT_DATE = CommonUtil.generatePortalDate($scope.header.RECEIPT_DATE);
                                    }
                                    if($scope.header.NEXT_PMT_DATE){
                                        contentCtrl.NextPaymentDate = $scope.header.NEXT_PMT_DATE;
                                        $scope.header.NextPaymentDate = CommonUtil.generatePortalDate($scope.header.NEXT_PMT_DATE);
                                    }
                                    if($scope.header.WRBTR){
                                        contentCtrl.Amount =$scope.header.WRBTR;
                                        $scope.header.WRBTR = parseInt(contentCtrl.Amount);
                                    }
                                }
                                 if($scope.header.VALID_DATE ){
                                    $scope.header.VALID_DATE = CommonUtil.generatePortalDate($scope.header.VALID_DATE);
                                    }
                                    if($scope.header.PODATE ){
                                    $scope.header.PODATE = CommonUtil.generatePortalDate($scope.header.PODATE);
                                    }

                                contentCtrl.lineItems = responce.data.lineItems;
                                angular.forEach(contentCtrl.lineItems,function(key,value){
                                    $scope.lineItems.push(key.lineItems);
                                    contentCtrl.InsideLineItems =$scope.lineItems;
                                })
                                // angular.forEach($scope.lineItems,function(key,value){
                                //    if(key.WRBTR !=undefined || key.WRBTR !=null){
                                //     contentCtrl.LineItemAmount =key.WRBTR;
                                //        key.WRBTR= parseInt(key.WRBTR);
                                //    } })
                                $scope.addLineItem = function() {
                                    $scope.lineItems.push({});
                                }
                                $scope.removeLineItem = function(index) {
                                    $scope.lineItems.splice(index, 1);
                                }
                               $scope.formHeader = true;
                                $scope.formLineitem = true;
                                if (responce.data.dataChange == 'D') {
                                    $scope.isUpdatable = true;
                                    $scope.isReadOnlyHeaderCurrency = true;
                                }

                            }, function(error) {
                                RestAPIService.showErrorDialog(error);
                            })
        };

        $scope.updateHeader = function() {
            // console.log("Update Header call ---",$scope.header)
        }

        $scope.updateLineItems = function() {
            // console.log("Update Line Items call ---",$scope.lineItems)
        }
        $scope.selectedTab = 0;
        $scope.changeTab = function() {
            if ($scope.selectedTab > 0) {
                $scope.selectedTab = 0;
            } else {
                $scope.selectedTab--;
            }
        }
//      Display Primary Document.
        $scope.displayPrimaryDocument = function(){
            $scope.workitemInfo.attachments.forEach(function(h){
                if(h.primaryDocumnet === 'X'){
                    $scope.mainDocument = h;
                    return false;
                }
            })
//          Call the preview function iff document exists.
            if($scope.mainDocument != undefined || $scope.mainDocument != null ){
                $scope.openInWindow($scope.mainDocument.url);
                }
            else
                $mdDialog.show($mdDialog
                        .alert().parent(angular.element(document.querySelector('#popupContainer')))
                        .clickOutsideToClose(true)
                        .title('Not Found.')
                        .htmlContent("No Primary Document for this Workitem.")
                        .ariaLabel('Alert Dialog Demo')
                        .ok('Ok')
                // .targetEvent(ev)
                );

        }
        $scope.download = function(file, reqId) {
            archiveId = file.archiveId;
            ReqId = reqId;
            archiveDocId = file.archiveDocId;
         RestAPIService.downloadAttachment(ReqId, archiveId, archiveDocId)
                    .then(function(success) {
                        var headers = success.headers();
                        // alert(JSON.stringify(headers));
                        var data = success.data;
                        // alert(data);
                        // var filename = headers['x-filename'];
                        var filename = file.fileName;
                        var contentType = headers['content-type'];
                        var linkElement = document.createElement('a');
                        try {
                            var blob = new Blob([ data ], {
                                type : contentType
                            });
                            var url = window.URL.createObjectURL(blob);
                            linkElement.setAttribute('href', url);
                            linkElement.setAttribute("download", filename);
                            var clickEvent = new MouseEvent("click", {
                                "view" : window,
                                "bubbles" : true,
                                "cancelable" : false
                            });
                            linkElement.dispatchEvent(clickEvent);
                        } catch (ex) {
                            console.log(ex);
                        }
                    }, function(error) {
                        console.log('ERROR Downloading the file ********');
                        RestAPIService.showErrorDialog(error);
                    });
        }
        $scope.fileIcon = function(fileType) {

            var icon = {};
            if (fileType == "folder") {
                icon = "icon-folder";
            } else if (fileType.indexOf("jpg") != -1) {
                icon = "icon-file-image";
            } else if (fileType.indexOf("jpeg") != -1) {
                icon = "icon-file-image";
            } else if (fileType.indexOf("png") != -1) {
                icon = "icon-file-image";
            } else if (fileType.indexOf("pdf") != -1) {
                icon = "icon-file-pdf-box";
            } else if (fileType.indexOf("txt") != -1) {
                icon = "icon-clipboard-text";
            } else if (fileType.indexOf("html") != -1) {
                icon = "icon-language-html5";
            } else if (fileType.indexOf("xl") != -1) {
                icon = "icon-file-excel";
            } else if (fileType.indexOf("word") != -1) {
                icon = "icon-file-word";
            } else if (fileType.indexOf("xml") != -1) {
                icon = "icon-file-xml";
            } else if (fileType.indexOf("doc") != -1) {
                icon = "icon-file-document";
            } else if (fileType.indexOf("docx") != -1) {
                icon = "icon-file-document";
            } else if (fileType.indexOf("json") != -1) {
                icon = "icon-clipboard-text";
            }

            else {
                icon = "icon-file-document";
            }
            return icon;

        }

        contentCtrl.fileIcon = function(file) {
            return CommonUtil.getIconForFile(file);
        }
        var jwtToken = $localStorage.currentUser.token.trim();
        $scope.previewFile = function(ev, file, reqId) {
            ReqId = reqId;
            archiveId = file.archiveId;
            archiveDocId = file.archiveDocId;
            contentCtrl.file = file;
            console.log(ReqId, archiveId, archiveDocId);
            if(file.fileType.toLowerCase() == 'pdf' ){
                window.open(contentCtrl.file.url);
            }
            else{
            $mdDialog.show({
                controller : DialogController,
                templateUrl : 'app/main/mycontent/inbox/previewFiles.html',
                parent : angular.element(document.body),
                targetEvent : ev,
                clickOutsideToClose : true
            });
            }
        }
        function DialogController($scope, $mdDialog, $sce, $sessionStorage) {

            $scope.toggle = [];
            $scope.arrow =[];
    $scope.toggleFilter = function(inx) {
       $scope.arrow[inx]=$scope.arrow[inx] === true ? false :true;
     $scope.toggle[inx] = $scope.toggle[inx] === true ? false : true;
    };

            $scope.fileVis = false;
            $scope.imgVis= false;

            if(jwtToken != undefined && ReqId != undefined) {
            var encodedURI = encodeURIComponent(baseUrl+'/api/requests/inbox/filedownload?archiveId='+archiveId+'&requestId='+ReqId+'&archiveDocId='+archiveDocId+'&attachment=false&jwtToken='+jwtToken);
                  var encodedURI =contentCtrl.file.url;
                //$scope.fileURL = $sce.trustAsResourceUrl('https://docs.google.com/gview?url='+encodedURI+'&embedded=true');
                if(contentCtrl.file.fileType =="jpg" || contentCtrl.file.fileType =="JPG" || contentCtrl.file.fileType =="jpeg" || contentCtrl.file.fileType =="JPEG" || contentCtrl.file.fileType =="PNG" || contentCtrl.file.fileType =="png"){
                    $scope.imgVis= true;
                    $scope.fileURL =contentCtrl.file.url;
                  }else{
                    $scope.fileVis= true;

                    //$scope.fileURL = $sce.trustAsResourceUrl('https://docs.google.com/gview?url='+encodedURI+'&embedded=true');
                  }

            }
//          if(contentCtrl.file.fileType =="jpg" || contentCtrl.file.fileType =="JPG" || contentCtrl.file.fileType =="jpeg" || contentCtrl.file.fileType =="JPEG" || contentCtrl.file.fileType =="PNG" || contentCtrl.file.fileType =="png"){
//                   $scope.imgVis= true;
//                  contentCtrl.fileURL =contentCtrl.file.url;
//               }else{
//                   $scope.fileVis= true;
//                  contentCtrl.fileURL =contentCtrl.file.url;
//               }
            $scope.cancel = function() {
                $mdDialog.cancel();
            }
        }
        $scope.goToInbox = function() {
            $state.go('app.mycontent_inbox');
        }

        contentCtrl.fileIcon = function(file) {
            return CommonUtil.getIconForFile(file);
        }

        $scope.myView = true;
        $scope.changeView = function() {
            $scope.myView = !$scope.myView;
        };

        $scope.search = function(query) {
            $scope.searchString = query;
        };

        $scope.processActvity = function(actvity, ev) {
            contentCtrl.newAttachments = $scope.attachmentfiles;
            contentCtrl.actvity = actvity;
            contentCtrl.selectedWorkitemInfo = $scope.workitemInfo;
            console.log("hii", contentCtrl.selectedWorkitemInfo);
            $mdDialog.show({
                controller : ProcessController,
                templateUrl : 'app/main/mycontent/inbox/add.comment.html',
                parent : angular.element(document.body),
                targetEvent : ev,
                clickOutsideToClose : true,
                fullscreen : $scope.customFullscreen
            });
        }
        $scope.workitemInfo.attachments = [];
        function ProcessController($scope, $mdDialog) {
            $scope.popupHeading = contentCtrl.actvity.buttonText;
            $scope.process = function(ev, comment) {
                $mdDialog.cancel();
                $rootScope.inboxButtons = true;
                delete contentCtrl.actvity.$$hashKey;
                var json = {
                    activities : []
                };
                json.comment = comment;
                json.activities.push(contentCtrl.actvity);
                json.header = contentCtrl.selectedWorkitemInfo.header;
                if(json.header.BLDAT){
                    json.header.BLDAT =contentCtrl.InvoiceDate;
                }
                if(json.header.BUDAT){
                    json.header.BUDAT =contentCtrl.PostingDate;
                }
                if(json.header.RECEIPT_DATE){
                    json.header.RECEIPT_DATE=contentCtrl.ReceiptDate;
                }
                if(json.header.WRBTR){
                    json.header.WRBTR =contentCtrl.Amount;
                }
                if(json.header.NEXT_PMT_DATE){
                    json.header.NEXT_PMT_DATE=contentCtrl.NextPaymentDate;
                }
                json.lineItems = contentCtrl.selectedWorkitemInfo.lineItems;
                angular.forEach(json.lineItems,function(key,value){
                    if(key.WRBTR !=undefined || key.WRBTR !=null){
                     key.WRBTR= contentCtrl.LineItemAmount;
                    }
                 })
                 json.lineItems = contentCtrl.selectedWorkitemInfo.lineItems;
                angular.forEach(json.lineItems,function(key,value){
                    if( key.lineItems.$$hashKey){
                        delete  key.lineItems.$$hashKey;
                    }

                    // if(key.WRBTR !=undefined || key.WRBTR !=null){
                    //  key.WRBTR= contentCtrl.LineItemAmount;
                    // }
                 })
                if (contentCtrl.newAttachments.length > 0) {
                    $scope.allAttachments = contentCtrl.selectedWorkitemInfo.attachments
                            .concat(contentCtrl.newAttachments);
                }
                console.log(json);
                RestAPIService.submitRequestResource(
                                contentCtrl.selectedWorkitemInfo.requestId,
                                contentCtrl.selectedWorkitemInfo.requestType,
                                json, $scope.allAttachments)
                        .then(
                                function(success) {
                                    if (success.status == 200) {
                                        resetRequest();
                                        if (contentCtrl.actvity.buttonText == "Approve") {
                                            $mdDialog
                                                    .show($mdDialog
                                                            .alert()
                                                            .parent(
                                                                    angular
                                                                            .element(document
                                                                                    .querySelector('#popupContainer')))
                                                            .clickOutsideToClose(
                                                                    true)
                                                            .title('Success.')
                                                            .htmlContent(
                                                                    "<h4><b>"
                                                                            + contentCtrl.selectedWorkitemInfo.requestId
                                                                            + "</b> was Approved successfully.</h4>")
                                                            .ariaLabel(
                                                                    'Alert Dialog Demo')
                                                            .ok('Ok')
                                                    // .targetEvent(ev)
                                                    );
                                            $state.reload();
                                        } else {
                                            $mdDialog
                                                    .show($mdDialog
                                                            .alert()
                                                            .parent(
                                                                    angular
                                                                            .element(document
                                                                                    .querySelector('#popupContainer')))
                                                            .clickOutsideToClose(
                                                                    true)
                                                            .title('Success.')
                                                            .htmlContent(
                                                                    "<h4><b>"
                                                                            + contentCtrl.selectedWorkitemInfo.requestId
                                                                            + "</b> was Rejected successfully.</h4>")
                                                            .ariaLabel(
                                                                    'Alert Dialog Demo')
                                                            .ok('Ok')
                                                    // .targetEvent(ev)
                                                    );
                                            $state.reload();
                                        }
                                    }
                                }, function(error) {
                                    RestAPIService.showErrorDialog(error);
                                });
            }
            $scope.hide = function() {
                $mdDialog.hide();
            };

            $scope.cancel = function() {
                $mdDialog.cancel();
            };

        }

        // Collaborte call.
         $scope.collaborate = function(ev,activity){
            contentCtrl.selectedWorkitemInfo = $scope.workitemInfo;
            contentCtrl.attachmentfiles = $scope.attachmentfiles;
            contentCtrl.CollaborateActivity = activity;
            $mdDialog.show({
                controller: CollaborateDialogController,
                templateUrl: 'app/main/mycontent/inbox/collaborateDialog.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: $scope.customFullscreen
            });
        }
        function CollaborateDialogController($scope,RestAPIService, $mdDialog, $rootScope ){
            var dataCtrl = this;
            dataCtrl.dtOptions = {
                dom: '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
                pagingType: 'simple',
                responsive: true
            };
            $scope.getAllUsers = function(){
                RestAPIService.getUsers().then(function(success){
                    $scope.agents = success.data;
                },function(error){
                       RestAPIService.showErrorDialog(error);
                });
            }
            $scope.searchedMembers = [];
            $scope.searchText = null;
            $scope.selectedAgents = null;
            $scope.agentsSearch = function(query) {
                var results = query ? $scope.agents.filter(createFilterForAgents(query)) : [];
                return results;
            }
            function createFilterForAgents(query) {
                var lowercaseQuery = angular.lowercase(query);
                return function filterFn(text) {
                  return (((text.firstName != undefined) ? ((text.firstName).toLowerCase().indexOf(lowercaseQuery) === 0 ) : false) || ((text.lastName != undefined) ? ((text.lastName).toLowerCase().indexOf(lowercaseQuery) === 0 ) : false) || ((text.name != undefined) ? ((text.name).toLowerCase().indexOf(lowercaseQuery) === 0 ) : false));
                };
            }
            $scope.cancel = function() {
                $mdDialog.cancel();
            };


        $scope.collaborateActivity =function(ev, user, comment){
            $rootScope.inboxButtons = true;
            contentCtrl.inboxComment[requestId] = comment;
            var workItem = contentCtrl.selectedWorkitemInfo;
            var requestId = workItem.requestId;

            if(user.sapUserId){
                contentCtrl.CollaborateActivity.actvity ="550"
            }

            var activity = contentCtrl.CollaborateActivity;
            delete activity.$$hashKey;

            var json = {
                       activities: []
                   };
                   json.comment = comment;
                   json.activities.push(activity);
                  // workItem.header.PROJECT = contentCtrl.projectNumber;
                   json.header = workItem.header;
                   // json.header.FIELD52 =contentCtrl.Date;
                   json.lineItems = workItem.lineItems;
                   var form = new FormData();
                   if (contentCtrl.attachmentfiles.length > 0) {
                      $scope.newAttachments =  workItem.attachments.concat(contentCtrl.attachmentfiles);
                       for (var prop in $scope.newAttachments) {
                           form.append('files', $scope.newAttachments[prop]);
                       }
                   }

             RestAPIService.sendCollaboration(requestId,workItem.requestType,user.login,json,form).then(
                            function(response){
                                 $mdDialog.show(
                                      $mdDialog.alert()
                                        .parent(angular.element(document.querySelector('#popupContainer')))
                                        .clickOutsideToClose(true)
                                        .title('Success.')
                                        .htmlContent("<h4>Collaboration sent successfully for <b>"+workItem.requestId+"</b>.</h4>")
                                        .ariaLabel('Alert Dialog Demo')
                                        .ok('Ok'));
                              $state.reload();
                            },function(error){
                                RestAPIService.showErrorDialog(error);
                            });  }}
             $scope.collaborateBack = function(ev, activity){
            contentCtrl.attachmentfiles = $scope.attachmentfiles;
            contentCtrl.selectedWorkitemInfo = $scope.workitemInfo;
            contentCtrl.collabratebackactivity = activity;
            $mdDialog.show({
                controller: CollaborateBackDialogController,
                templateUrl: 'app/main/mycontent/inbox/collaborateBackDialog.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: $scope.customFullscreen
            });
        }
        function CollaborateBackDialogController($scope, $mdDialog, RestAPIService){
            $scope.cancel = function() {
                $mdDialog.cancel();
            };
            $scope.collaborateBackComment = function(ev, comment){
                $rootScope.inboxButtons = true;
                var workItem = contentCtrl.selectedWorkitemInfo;
                var requestId = workItem.requestId;
                if(workItem.status == "7"){
                    contentCtrl.collabratebackactivity.actvity = "551"
                }
                var actvity = contentCtrl.collabratebackactivity;
                delete actvity.$$hashKey;
                 var json = {
                        activities: []
                    };
                json.comment = comment;
                json.activities.push(actvity);
                json.header = workItem.header;
                json.lineItems = workItem.lineItems;
                var form = new FormData();
                if (contentCtrl.attachmentfiles.length > 0) {
                  $scope.newAttachments =  workItem.attachments.concat(contentCtrl.attachmentfiles);
                    for (var prop in  $scope.newAttachments) {
                        form.append('files',  $scope.newAttachments[prop]);
                    }
                }

                    var user = null;
                    RestAPIService.sendCollaboration(requestId,workItem.requestType,user,json,form).then(
                            function(response){

                                $mdDialog.show(
                                          $mdDialog.alert()
                                            .parent(angular.element(document.querySelector('#popupContainer')))
                                            .clickOutsideToClose(true)
                                            .title('Success.')
//                                          .textContent("Collaboration sent successfully.")
                                            .htmlContent("<h4>Collaboration back is successfull for <b>"+workItem.requestId+"</b>.</h4>")
                                            .ariaLabel('Alert Dialog Demo')
                                            .ok('Ok')
//                                          .targetEvent(ev)
                                        );
                                $state.reload();
                            },function(error){
                                RestAPIService.showErrorDialog(error);
                            });
                    $mdDialog.cancel();

            }
        }
        $scope.itemsVisibility = true;
        $scope.mobileselectWorkitem = function(workitem) {
            $scope.plants=Plants.data;
            $scope.prDoctypes =PRDoctypes.data;
            $scope.workitemInfo={};
            $scope.itemsVisibility = !$scope.itemsVisibility;
            $scope.selectedWorkitem = workitem.docId;
             $anchorScroll();
            RestAPIService
                    .getInboxWorkitemInfo($stateParams.requestType,
                            workitem.docId)
                    .then(
                            function(responce) {
                                resetRequest();
                                viewForm(responce.data);
                                $scope.displayName = $stateParams.displayName;
                                $scope.workitemInfo = responce.data;
                                console.log(responce.data)
                                $scope.workitemInfo.logs
                                        .forEach(function(h) {
                                            if (h.activityText == "Initiated") {
                                                h['icon'] = "icon-star-outline";
                                            }else if (h.activityText == "Confirm") {
                                                h['icon'] = "icon-check";
                                            }
                                            else if (h.activityText == "Approve") {
                                                h['icon'] = "icon-check";
                                            } else if (h.activityText == "Reject") {
                                                h['icon'] = "icon-cancel";
                                            }
                                            else if (h.activityText != "Initiated" && h.activityText != "Confirm" && h.activityText != "Approve" && h.activityText != "Reject") {
                                                h['icon'] = "icon-content-save";
                                            }

                                        })
                                  $scope.header = responce.data.header;
                                if($scope.header.BLDAT!=undefined || $scope.header.BLDAT!= null || $scope.header.BUDAT!=undefined || $scope.header.BUDAT!=null){

                                    if($scope.header.BLDAT){
                                    contentCtrl.InvoiceDate = $scope.header.BLDAT;
                                    $scope.header.BLDAT = CommonUtil.generatePortalDate($scope.header.BLDAT);
                                    }
                                    if($scope.header.BUDAT){
                                    contentCtrl.PostingDate = $scope.header.BUDAT;
                                    $scope.header.BUDAT =  CommonUtil.generatePortalDate($scope.header.BUDAT);
                                    }
                                    if($scope.header.RECEIPT_DATE){
                                        contentCtrl.ReceiptDate = $scope.header.RECEIPT_DATE;
                                        $scope.header.RECEIPT_DATE = CommonUtil.generatePortalDate($scope.header.RECEIPT_DATE);
                                    }
                                    if($scope.header.NEXT_PMT_DATE){
                                        contentCtrl.NextPaymentDate = $scope.header.NEXT_PMT_DATE;
                                        $scope.header.NextPaymentDate = CommonUtil.generatePortalDate($scope.header.NEXT_PMT_DATE);
                                    }
                                }
                                if($scope.header.TAX_AMOUNT){
                                    contentCtrl.Amount =$scope.header.TAX_AMOUNT;
                                    $scope.header.TAX_AMOUNT = parseInt(contentCtrl.Amount);
                                }
                                if($scope.header.WRBTR){
                                    contentCtrl.GrossAmount =$scope.header.WRBTR;
                                    $scope.header.WRBTR = parseInt(contentCtrl.GrossAmount);
                                }
                                if($scope.header.FRIEGHT_AMT){
                                    contentCtrl.FrightAmount =$scope.header.FRIEGHT_AMT;
                                    $scope.header.WRBTR = parseInt(contentCtrl.FrightAmount);
                                }




                                contentCtrl.lineItems = responce.data.lineItems;
                                angular.forEach(contentCtrl.lineItems,function(key,value){
                                    $scope.lineItems.push(key.lineItems);
                                })
                                angular.forEach($scope.lineItems,function(key,value){
                                    if(key.WRBTR !=undefined || key.WRBTR !=null){
                                     contentCtrl.LineItemAmount =key.WRBTR;
                                        key.WRBTR= parseInt(key.WRBTR);
                                    }
                                 })

                                $scope.formHeader = true;
                                $scope.formLineitem = true;
                                if (responce.data.dataChange == 'D') {
                                    $scope.isUpdatable = true;
                                    $scope.isReadOnlyHeaderCurrency = true;
                                }

                            }, function(error) {
                                RestAPIService.showErrorDialog(error);
                            })


        }
        $scope.goBackToItems = function() {
            $scope.itemsVisibility = !$scope.itemsVisibility;
        }
        $scope.getAnotherColor = function(index) {
            $scope.colors = ['blue-bg white-fg','pink-bg white-fg', 'green-bg white-fg'];
            var totalNoOfColors = $scope.colors.length;
            return $scope.colors[index % totalNoOfColors];
        }
        $scope.attachmentfiles = [];
        $scope.setAttachmentFile = function(element) {
            var formData = new FormData();
            $scope.$apply(function() {

                for (var i = 0; i < element.files.length; i++) {
                    formData.append('file', element.files[i]);
                    $scope.attachmentfiles.push(element.files[i]);
                }
            });
        };
        function viewForm(data) {
            RestAPIService.getFormData(data).then(function(success){
                $scope.formData=success.data;
                $scope.currentFormHeader = $sce.trustAsHtml($scope.formData.content.replace(/&quot;/g, '"'));
                if($scope.formData.lineItemContent){
             $scope.currentFormLineitem = $sce.trustAsHtml($scope.formData.lineItemContent.replace(/&quot;/g, '"'));
                }
             if($scope.formData.inboxHeaderContent){
                $scope.currentFormInboxHeader = $sce.trustAsHtml($scope.formData.inboxHeaderContent.replace(/&quot;/g, '"'));
             }
             if($scope.formData.inboxLineItemContent){
                $scope.currentFormInboxLineitem = $sce.trustAsHtml($scope.formData.inboxLineItemContent.replace(/&quot;/g, '"'));
             }
            },function(error){

            })
        }
        $scope.currencies = [ "INR", "USD", "EUR", "PLN" ];

        $scope.getAllWorkitems = function() {
            RestAPIService.getAllInboxWorkitems($stateParams.requestType,
                    $scope.pageNumber, $scope.size).then(function(success) {
                $scope.allWorkitems = success.data;
                console.log( $scope.allWorkitems )
            }, function(error) {
                RestAPIService.showErrorDialog(error);
            });

        };
        $scope.pageNumber = 0;
        $scope.size = 200;
        $scope.nextInboxItems = function() {
//          Preventing the request call for next items when items in present page are zero.
            if($scope.allWorkitems.length != 0){
                $scope.pageNumber = $scope.pageNumber + 1;
                $scope.getAllWorkitems();
            }
            else{
                return;
            }
        }
        $scope.previousInboxItems = function() {
//          Make the previous items call when the page number is greater than or equal to zero.
            if ($scope.pageNumber - 1 >= 0) {
                $scope.pageNumber = $scope.pageNumber - 1;
                $scope.getAllWorkitems();
            } else {
                alert("This is First page.");
            }
        }





    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.mycontent.emailApprovals', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider)
    {
        // State
        $stateProvider.state('app.emailApproval', {
            url      : '/emailApproval/:requestType/:docId',
            params: {                   
                requestType: null,
                docId:null                   
            },
            views    : {
                'content@app': {
                    templateUrl: 'app/main/mycontent/emailApprovals/workitemDetails.html',
                    controller : 'EmailApprovalController as eaCtrl'
                }
            },
            resolve: {
                RestAPIService: 'RestAPIService',
                ReqInbox: function(RestAPIService) {
                    return RestAPIService.getRequestGroupDoctypes();
                },
                Plants: function(RestAPIService) {
                    return RestAPIService.GetPlants();
                },
                PRDoctypes: function(RestAPIService){
                    return RestAPIService.getDocTypes("pr_doctype");
                },
                MaterialTypes: function(RestAPIService) {
                    return RestAPIService.GetMaterialTypes();
                },
                BlockList:function(RestAPIService){
                    return RestAPIService.getBlockList("block_text");
                }
                         
            },
            bodyClass: 'mycontent-inbox'
        });     
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.mycontent.emailApprovals')
        .controller('EmailApprovalController', EmailApprovalController);
        /** @ngInject */
        var ReqId = ""; 
        var archiveId = ""; 
        var archiveDocId ="";
       function EmailApprovalController($state, $stateParams, $scope, $http,$anchorScroll,
            RestAPIService, CommonUtil, ReqInbox, $sce, $mdDialog, $window,$sessionStorage,$localStorage,AuthenticationService,
            $rootScope,Plants,PRDoctypes,MaterialTypes,BlockList) {        
        if($localStorage.currentUser == undefined || $localStorage.currentUser ==null ){
            AuthenticationService.Logout();
        }
        else{
        var jwtToken = $localStorage.currentUser.token.trim();
        RestAPIService.getAllCodingTemplates($stateParams.requestType, 0,1000).then(
            function(success) {
                eaCtrl.AllcodingTemplates = success.data;
                $scope.totalRecords = success.headers('x-total-count');
                $scope.pages = $scope.totalRecords/$scope.size;                           
                var index= $scope.pages.toString().indexOf('.');
                    var x= $scope.pages.toString().substring(0,index);
                    $scope.totalPages = parseInt(x)+1;            
            },
            function(error) {
                RestAPIService.showErrorDialog(error);
            }); 
        }
        var eaCtrl = this;  
            
        $scope.docTypes = [];
         $scope.toggle = [];
         $scope.arrow =[];
        $scope.toggleFilter = function(inx) {
            $scope.arrow[inx]=$scope.arrow[inx] === true ? false :true;
            $scope.toggle[inx] = $scope.toggle[inx] === true ? false : true;
        }; 
        $scope.Total =function(price,Quantity,index){ 
            if(Quantity == undefined || Quantity ==null || price == undefined || price == null){
                $scope.lineItems[index].GSWRT = 0;
                return;
            }   
            $scope.lineItems[index].GSWRT = parseFloat(Quantity) * parseFloat(price);
            parseFloat( $scope.lineItems[index].GSWRT).toFixed(2);
          }

        $scope.Allplants=Plants.data;
        $scope.prDoctypes =PRDoctypes.data;   
        $scope.docTypes = ReqInbox.data;
        $scope.BlockLists =BlockList.data;       
        $scope.isUpdatable = true;
        $scope.inbox =true;
        $rootScope.inboxButtons = false;   
       
       
        //Code For Alkem only
       
        if(!FinalLineItems){
            var FinalLineItems = [];
         }
         if(!UpdatedLinItems){
            var UpdatedLinItems = [];
         }
        $scope.searchCodingTemplates =function(ev,index){                                                  
          $mdDialog.show({
               controllerAs: 'searchCodingTemplateDialogCtrl',
               controller: searchCodingTemplateDialogCtrl,
               preserveScope: true,
               autoWrap: true,
               templateUrl: 'app/main/Requests/coadingTemplates.html'
           });
       }  
       function searchCodingTemplateDialogCtrl($scope,$mdDialog,RestAPIService){ 
       // var FinalLineItems = [];         
        $scope.searchResult =eaCtrl.AllcodingTemplates;                                                 
        $scope. searchResultRowClick =function(order){                                                       
            angular.forEach(order.lineItems,function(key,value){
                if(key.WRBTR){
                    key.WRBTR =parseInt(key.WRBTR);
                }
              UpdatedLinItems.push(key);
             
            })
            if(eaCtrl.lineItems){
               var codingtemplates =eaCtrl.InsideLineItems.concat(UpdatedLinItems);
               eaCtrl.setCodingtemplates(codingtemplates); 
            }
            if(UpdatedLinItems.length>0 && eaCtrl.lineItems == 0){
                codingtemplates = UpdatedLinItems;
                eaCtrl.setCodingtemplates(codingtemplates);   
              }
            // else{
            //     UpdatedLinItems =FinalLineItems;
            //     eaCtrl.setCodingtemplates(UpdatedLinItems);   
            // }                                                                                                
        }
       $scope.pageNumber = 0;
        $scope.page =100;
        $scope.size=100;  
        $scope.cancel = function() {
        $mdDialog.cancel();
      }; 
    } 
    eaCtrl.setCodingtemplates =function(FinallineItems){                                             
        $scope.lineItems =FinallineItems;
        $mdDialog.cancel();
       
    } 
   
        eaCtrl.setorderCode =function(data){
            $scope.lineItems[eaCtrl.selectedIndex].ORDER_NO =data.AUFNR;
        }
        eaCtrl.setCostCenter=function(data){
            $scope.lineItems[eaCtrl.selectedIndex].KOSTL =data.KOSTL;
        }
        eaCtrl.setGLAccount =function(data){
            $scope.lineItems[eaCtrl.selectedIndex].SAKNR =data.SAKNR;
        }
        $scope.searchOrder =function(ev,index){
            eaCtrl.selectedIndex = index;
            $mdDialog.show({
                controllerAs: 'searchOrderDialogCtrl',
                controller: searchOrderDialogCtrl,
                preserveScope: true,
                autoWrap: true,
                templateUrl: 'app/main/Requests/orderdialog.html'
            });
        }
        function searchOrderDialogCtrl($scope, RestAPIService, $mdDialog) {
            $scope.searchAssetCode ={};
            $scope.pageNumber = 0;
            $scope.page =100;
            $scope.size=100;
            $scope.cancel = function() {
                $mdDialog.cancel();
            }; 
            $scope.searchAssetCode =function(search){
                RestAPIService.getorderDataBySearch(search,$scope.pageNumber, $scope.size).then(
                    function(success) {
                      $scope.searchResult =success.data;
                      $scope.totalRecords = success.headers('x-total-count');
                      $scope.pages = $scope.totalRecords/$scope.size;                           
                      var index= $scope.pages.toString().indexOf('.');
                          var x= $scope.pages.toString().substring(0,index);
                          $scope.totalPages = parseInt(x)+1;                             
                    },
                    function(error) {
                        RestAPIService.showErrorDialog(error);
                    });
                    $scope.searchResultRowClick = function(order) {
                        eaCtrl.searchData =order;
                       eaCtrl.setorderCode(order);
                        
                        $mdDialog.cancel();
                    }; 
                    $scope.next = function(){               	
                        $scope.pageNumber = $scope.pageNumber + 1; 
                        RestAPIService.getorderDataBySearch(search,$scope.pageNumber, $scope.size).then(
                            function(success) {
                                $scope.searchResult = success.data;                                                  
                            },
                            function(error) {
                                RestAPIService.showErrorDialog(error);
                            });
                    }
                    $scope.previous = function(){
                        $scope.pageNumber = $scope.pageNumber - 1; 
                        RestAPIService.getorderDataBySearch(search,$scope.pageNumber, $scope.size).then(
                            function(success) {
                                $scope.searchResult = success.data;                                                  
                            },
                            function(error) {
                                RestAPIService.showErrorDialog(error);
                            });

                    }
            }
        }

        $scope.searchCostCenter =function(ev,index){
            eaCtrl.selectedIndex = index;
            $mdDialog.show({
                controllerAs: 'searchCostCenterDialogCtrl',
                controller: searchCostCenterDialogCtrl,
                preserveScope: true,
                autoWrap: true,
                templateUrl: 'app/main/Requests/costcenterdialog.html'
            });
        }
        function searchCostCenterDialogCtrl($scope, RestAPIService, $mdDialog) {
            $scope.searchAssetCode ={};
            $scope.pageNumber = 0;
            $scope.page =100;
            $scope.size=100;
            $scope.cancel = function() {
                $mdDialog.cancel();
            }; 

            $scope.searchCostCenter =function(search){
                RestAPIService.getCostCenterData(search,$scope.pageNumber, $scope.size).then(
                    function(success) {
                      $scope.searchResult =success.data;
                      $scope.totalRecords = success.headers('x-total-count');
                      $scope.pages = $scope.totalRecords/$scope.size;                           
                      var index= $scope.pages.toString().indexOf('.');
                          var x= $scope.pages.toString().substring(0,index);
                          $scope.totalPages = parseInt(x)+1;                             
                    },
                    function(error) {
                        RestAPIService.showErrorDialog(error);
                    });
                    $scope.searchResultRowClick = function(order) {
                        eaCtrl.searchData =order;
                       eaCtrl.setCostCenter(order);
                        
                        $mdDialog.cancel();
                    }; 
                    $scope.next = function(){               	
                        $scope.pageNumber = $scope.pageNumber + 1; 
                        RestAPIService.getCostCenterData(search,$scope.pageNumber, $scope.size).then(
                            function(success) {
                                $scope.searchResult = success.data;                                                  
                            },
                            function(error) {
                                RestAPIService.showErrorDialog(error);
                            });
                    }
                    $scope.previous = function(){
                        $scope.pageNumber = $scope.pageNumber - 1; 
                        RestAPIService.getCostCenterData(search,$scope.pageNumber, $scope.size).then(
                            function(success) {
                                $scope.searchResult = success.data;                                                  
                            },
                            function(error) {
                                RestAPIService.showErrorDialog(error);
                            });

                    }
            }
        } 
        $scope.searchGLAccount =function(ev,index){
            // eaCtrl.selectedIndex = index;
             eaCtrl.selectedIndex =index;
             $mdDialog.show({
                 controllerAs: 'searchGLAccountDialogCtrl',
                 controller: searchGLAccountDialogCtrl,
                 preserveScope: true,
                 autoWrap: true,
                 templateUrl: 'app/main/Requests/glAccountdialog.html'
             });
         }
         function searchGLAccountDialogCtrl($scope, RestAPIService, $mdDialog) {
             $scope.searchGlAccount ={};
             $scope.pageNumber = 0;
             $scope.page =100;
             $scope.size=100;
             $scope.cancel = function() {
                 $mdDialog.cancel();
             }; 
             $scope.searchGLValues =function(search){
               RestAPIService.getGLDataBySearch(search,$scope.pageNumber, $scope.size).then(
                     function(success) {
                         $scope.searchResult = success.data;
                         $scope.totalRecords = success.headers('x-total-count');
                         $scope.pages = $scope.totalRecords/$scope.size;                           
                         var index= $scope.pages.toString().indexOf('.');
                             var x= $scope.pages.toString().substring(0,index);
                             $scope.totalPages = parseInt(x)+1;            
                     },
                     function(error) {
                         RestAPIService.showErrorDialog(error);
                     });
 
                     $scope.next = function(){               	
                         $scope.pageNumber = $scope.pageNumber + 1; 
                         RestAPIService.getGLDataBySearch(search,$scope.pageNumber, $scope.size).then(
                             function(success) {
                                 $scope.searchResult = success.data;                                                  
                             },
                             function(error) {
                                 RestAPIService.showErrorDialog(error);
                             });
                     }
                     $scope.previous = function(){
                         $scope.pageNumber = $scope.pageNumber - 1; 
                         RestAPIService.getGLDataBySearch(search,$scope.pageNumber, $scope.size).then(
                             function(success) {
                                 $scope.searchResult = success.data;                                                  
                             },
                             function(error) {
                                 RestAPIService.showErrorDialog(error);
                             });
 
                     }
                     $scope.searchResultRowClick = function(order) {
                         eaCtrl.searchData =order;
                        eaCtrl.setGLAccount(order);
                         
                         $mdDialog.cancel();
                     }; 
                 }
         }



        $scope.searchPurchaseOrder = function(ev, index) {       
            eaCtrl.selectedIndex = index;
                $mdDialog.show({
                    controllerAs: 'searchPurchaseOrderDialogCtrl',
                    controller: SearchPurchaseOrderController,
                    preserveScope: true,
                    autoWrap: true,
                    templateUrl: 'app/main/mycontent/inbox/searchDataDialog.html'
                });
            };
            function SearchPurchaseOrderController($scope, RestAPIService, $mdDialog) {
                $scope.SearchObject ={};
                $scope.pageNumber = 0;
                $scope.page =100;
                $scope.size=100;
                $scope.cancel = function() {
                    $mdDialog.cancel();
                };   
                $scope.materialTypes =MaterialTypes.data;
               // $scope.plants =Plants.data;            
                $scope.searchValues = function(search) {                 
                    $scope.pageNumber = 0;
                    if(search == null || search ==undefined){
                        var search ={};
                        search['_id']='';
                    }           
                  $scope.SearchObject =search;
                    RestAPIService.getLisBySearch(search,$scope.pageNumber, $scope.size).then(
                        function(success) {
                            $scope.searchResult = success.data;
                            $scope.totalRecords = success.headers('x-total-count');
                            $scope.pages = $scope.totalRecords/$scope.size;                           
                            var index= $scope.pages.toString().indexOf('.');
                                var x= $scope.pages.toString().substring(0,index);
                                $scope.totalPages = parseInt(x)+1;            
                        },
                        function(error) {
                            RestAPIService.showErrorDialog(error);
                        });
    
                        $scope.next = function(){               	
                            $scope.pageNumber = $scope.pageNumber + 1; 
                            RestAPIService.getLisBySearch($scope.SearchObject,$scope.pageNumber, $scope.size).then(
                                function(success) {
                                    $scope.searchResult = success.data;                                                  
                                },
                                function(error) {
                                    RestAPIService.showErrorDialog(error);
                                });
                        }
                        $scope.previous = function(){
                            $scope.pageNumber = $scope.pageNumber - 1; 
                            RestAPIService.getLisBySearch($scope.SearchObject,$scope.pageNumber, $scope.size).then(
                                function(success) {
                                    $scope.searchResult = success.data;                                                  
                                },
                                function(error) {
                                    RestAPIService.showErrorDialog(error);
                                });
                        }
                        $scope.searchResultRowClick = function(order) {
                            eaCtrl.searchData =order;
                           eaCtrl.setLineItemFields(order);
                            
                            $mdDialog.cancel();
                        };   
                };
            }


        $scope.searchList =function(ev,index,material){  
            eaCtrl  .type =material;
            if(material == 'glAccount'){
                eaCtrl.url ="gl_account",
           eaCtrl.searchtypes =[{"name":"GL Account","value":"SAKNR"},{"name":"Description","value":"TXT20"}]
          }
          if(material == 'Asset'){
           eaCtrl.url ="asset_code",
           eaCtrl.searchtypes =[{"name":"AssetCode","value":"ANLN1"},{"name":"Description","value":"TXT50"}]   
          }
          if(material == 'MaterialGroupDesc'){
            eaCtrl.url ="material_group",
            eaCtrl.searchtypes =[{"name":"MaterialGroup","value":"MATKL"},{"name":"Description","value":"WGBEZ "}]
          }
           $mdDialog.show({
               controllerAs: 'searchTestDialogCtrl',
               controller: searchTestDialogCtrl,
               preserveScope: true,
               autoWrap: true,
               templateUrl: 'app/main/mycontent/inbox/Inbox_PR_Edit.html'
           });
       }
     
     

       function searchTestDialogCtrl($scope,$mdDialog,RestAPIService){
           $scope.Type =eaCtrl  .type;
           $scope.searchMaterial =eaCtrl.searchtypes;
           $scope.url =eaCtrl.url;
           $scope.pageNumber = 0;
           $scope.page =100;
           $scope.size=100;
           $scope.searchList =function(search){
               RestAPIService.getAllList(search,$scope.url,$scope.pageNumber, $scope.size).then(
                   function(success) {
                       $scope.searchResult = success.data;
                       $scope.totalRecords = success.headers('x-total-count');
                       $scope.pages = $scope.totalRecords/$scope.size;                           
                       var index= $scope.pages.toString().indexOf('.');
                           var x= $scope.pages.toString().substring(0,index);
                           $scope.totalPages = parseInt(x)+1;            
                   },
                   function(error) {
                       RestAPIService.showErrorDialog(error);
                   });                                
           }
         
         
           $scope.cancel = function() {
           $mdDialog.cancel();
          
         
       }; 
       }
        
        $scope.events = [ {
            badgeClass : 'info',
            badgeIconClass : 'glyphicon-check',
            title : 'First heading',
            content : 'Some awesome content.'
        }, {
            badgeClass : 'warning',
            badgeIconClass : 'glyphicon-credit-card',
            title : 'Second heading',
            content : 'More awesome content.'
        } ];
        $scope.openInWindow=function(fileData){
            window.open(fileData);
            return false;

        }
       

        // $scope.goToWorkitems = function(requestType, displayName) {           
        //     $state.go('app.mycontent_inbox.details', {
        //         'requestType' : requestType,
        //         'displayName' : displayName
        //     });
          

        // }
        resetRequest();
        function resetRequest() {
            $scope.header = {};
            $scope.lineItems = [ ];
            $scope.formHeader = false;
            $scope.formLineitem = false;
            eaCtrl.inboxComment = {};
            $scope.isReadOnlyHeaderCurrency = false;
            $scope.workitemInfo = {};
            $scope.attachmentfiles = [];
        }

        $scope.selectWorkitem = function(workitem) {
            // console.log(workitem);
            $scope.selectedWorkitem = workitem.docId;
            $scope.selectWorkitemDescription =workitem.description;            
            $scope.value =50;
            $scope.value2=80;
            RestAPIService.getInboxWorkitemInfo($stateParams.requestType,workitem.docId).then(
                            function(responce) {                                
                                resetRequest();
                                viewForm(responce.data);
                                $scope.value =100;
                                $scope.value2=100;
                                $scope.disabled =true
                                // $scope.displayName = $stateParams.displayName;
                                $scope.displayName = workitem.description;
                                $scope.workitemInfo = responce.data;  
                                $scope.workitemInfo.logs.forEach(function(h) {
                                            if (h.activityText == "Initiated") {
                                                h['icon'] = "icon-star-outline";
                                            }else if (h.activityText == "Confirm") {
                                                h['icon'] = "icon-check";
                                            }else if (h.activityText == "Approve") {
                                                h['icon'] = "icon-check";
                                            }else if (h.activityText == "Reject") {
                                                h['icon'] = "icon-cancel";
                                            }else if (h.activityText != "Initiated" && h.activityText != "Confirm" && h.activityText != "Approve" && h.activityText != "Reject") {
                                                h['icon'] = "icon-content-save";
                                            }
                                        })                              
                                $scope.header = responce.data.header;                               
                                if($scope.header.BLDAT!=undefined || $scope.header.BLDAT!= null || $scope.header.BUDAT!=undefined || $scope.header.BUDAT!=null){
                                    if($scope.header.BLDAT){                                    
                                    eaCtrl.InvoiceDate = $scope.header.BLDAT;                  
                                    $scope.header.BLDAT = eaCtrl.InvoiceDate.substring(0,4)+'-'+eaCtrl.InvoiceDate.substring(4,6)+'-'+eaCtrl.InvoiceDate.substring(6,8);
                                    $scope.header.BLDAT =  new Date($scope.header.BLDAT);
                                    }
                                    if($scope.header.BUDAT){                                        
                                    eaCtrl.PostingDate = $scope.header.BUDAT;
                                    $scope.header.BUDAT = eaCtrl.PostingDate.substring(0,4)+'-'+eaCtrl.PostingDate.substring(4,6)+'-'+eaCtrl.PostingDate.substring(6,8);
                                   $scope.header.BUDAT =  new Date($scope.header.BUDAT);
                                    }
                                    if($scope.header.RECEIPT_DATE){
                                        eaCtrl.ReceiptDate = $scope.header.RECEIPT_DATE;
                                        $scope.header.RECEIPT_DATE = eaCtrl.ReceiptDate.substring(0,4)+'-'+eaCtrl.ReceiptDate.substring(4,6)+'-'+eaCtrl.ReceiptDate.substring(6,8);
                                        $scope.header.BUDAT =  new Date($scope.header.BUDAT);
                                    }
                                    if($scope.header.WRBTR){
                                        eaCtrl.Amount =$scope.header.WRBTR;
                                        $scope.header.WRBTR = parseInt(eaCtrl.Amount);
                                    }
                                }  
                                
                                eaCtrl.lineItems = responce.data.lineItems;
                                angular.forEach(eaCtrl.lineItems,function(key,value){
                                    $scope.lineItems.push(key.lineItems);
                                    eaCtrl.InsideLineItems =$scope.lineItems;
                                })
                                angular.forEach($scope.lineItems,function(key,value){
                                   if(key.WRBTR !=undefined || key.WRBTR !=null){
                                    eaCtrl.LineItemAmount =key.WRBTR;
                                       key.WRBTR= parseInt(key.WRBTR);
                                   }
                                   if(key.WERKS){
                                       var plant ={}
                                       plant.listname ="plant_unit",
                                       plant.listvar ="WERKS",
                                       plant.value =key.WERKS;
                                    RestAPIService.getItemDetails(plant).then(
                                        function(success){
                                            $scope.plantDescription =success.data;
                                        },
                                        function(error){
                                        });                                       
                                   }
                                   if(key.WBS_ELEMENT){
                                    var plant ={}
                                    plant.listname ="wbs_element",
                                    plant.listvar ="PSPNR",
                                    plant.value =key.WBS_ELEMENT;
                                 RestAPIService.getItemDetails(plant).then(
                                     function(success){
                                         $scope.WBS_Description =success.data;
                                     },
                                     function(error){
                                     });                                       
                                }
                                   if(key.KOSTL){
                                    var plant ={}
                                    plant.listname ="cost_center",
                                    plant.listvar ="KOSTL",
                                    plant.value =key.KOSTL;
                                 RestAPIService.getItemDetails(plant).then(
                                     function(success){
                                         $scope.CostDescription =success.data;
                                         },
                                     function(error){
                                     });    

                                   }
                                   if(key.EKGRP){
                                    var plant ={}
                                    plant.listname ="purchasegroup",
                                    plant.listvar ="EKGRP",
                                    plant.value =key.EKGRP;
                                 RestAPIService.getItemDetails(plant).then(
                                     function(success){
                                         $scope.purchaseDescription =success.data;
                                         },
                                     function(error){
                                     });    

                                   }
                                   if(key.SAKNR){
                                    var plant ={}
                                    plant.listname ="gl_account",
                                    plant.listvar ="SAKNR",
                                    plant.value =key.SAKNR;
                                 RestAPIService.getItemDetails(plant).then(
                                     function(success){
                                         $scope.glAccountDescription =success.data;
                                         },
                                     function(error){
                                     });
                                 }
                                 if(key.ANLN1){
                                    var plant ={}
                                    plant.listname ="asset_code",
                                    plant.listvar ="ANLN1",
                                    plant.value =key.ANLN1;
                                 RestAPIService.getItemDetails(plant).then(
                                     function(success){
                                         $scope.AssetDescription =success.data;
                                         },
                                     function(error){
                                     });
                                 }
                                 if(key.KNTTP){
                                    var plant ={}
                                    plant.listname ="account_assigning",
                                    plant.listvar ="KNTTP",
                                    plant.value =key.KNTTP;
                                 RestAPIService.getItemDetails(plant).then(
                                     function(success){
                                         $scope.AccountDescription =success.data;
                                         },
                                     function(error){
                                     });
                                 }
                                 if(key.EPSTP){
                                    var plant ={}
                                    plant.listname ="item_category",
                                    plant.listvar ="PSTYP",
                                    plant.value =key.EPSTP;
                                 RestAPIService.getItemDetails(plant).then(
                                     function(success){
                                         $scope.ItemDescription =success.data;
                                         },
                                     function(error){
                                     });
                                 }
                                 if(key.ORDER_NO){
                                    var plant ={}
                                    plant.listname ="order_number",
                                    plant.listvar ="AUFNR",
                                    plant.value =key.ORDER_NO;
                                 RestAPIService.getItemDetails(plant).then(
                                     function(success){
                                         $scope.OrderDescription =success.data;
                                         },
                                     function(error){
                                     });
                                 }
                                })
                                $scope.addLineItem = function() {
                                    $scope.lineItems.push({});
                                }
                                $scope.removeLineItem = function(index) {
                                    $scope.lineItems.splice(index, 1);
                                }
                               $scope.formHeader = true;
                                $scope.formLineitem = true;
                                if (responce.data.dataChange == 'D') {
                                    $scope.isUpdatable = true;
                                    $scope.isReadOnlyHeaderCurrency = true;
                                }

                            }, function(error) {
                                RestAPIService.showErrorDialog(error);
                            })
        };

        $scope.updateHeader = function() {
            // console.log("Update Header call ---",$scope.header)
        }

        $scope.updateLineItems = function() {
            // console.log("Update Line Items call ---",$scope.lineItems)
        }
        $scope.selectedTab = 0;
        $scope.changeTab = function() {
            if ($scope.selectedTab > 0) {
                $scope.selectedTab = 0;
            } else {
                $scope.selectedTab--;
            }
        }
//      Display Primary Document.
        $scope.displayPrimaryDocument = function(){
            $scope.workitemInfo.attachments.forEach(function(h){
                if(h.primaryDocumnet === 'X'){
                    $scope.mainDocument = h;
                    return false;
                }               
            })
//          Call the preview function iff document exists.
            if($scope.mainDocument != undefined || $scope.mainDocument != null ){
                $scope.openInWindow($scope.mainDocument.url);
                }
            else
                $mdDialog.show($mdDialog
                        .alert().parent(angular.element(document.querySelector('#popupContainer')))
                        .clickOutsideToClose(true)
                        .title('Not Found.')
                        .htmlContent("No Primary Document for this Workitem.")
                        .ariaLabel('Alert Dialog Demo')
                        .ok('Ok')
                // .targetEvent(ev)
                );
            
        }
        $scope.download = function(file, reqId) {
            archiveId = file.archiveId;
            ReqId = reqId;
            archiveDocId = file.archiveDocId;
            // console.log(file);

            RestAPIService.downloadAttachment(ReqId, archiveId, archiveDocId)
                    .then(function(success) {
                        var headers = success.headers();
                        // alert(JSON.stringify(headers));
                        var data = success.data;
                        // alert(data);
                        // var filename = headers['x-filename'];
                        var filename = file.fileName;
                        var contentType = headers['content-type'];
                        var linkElement = document.createElement('a');
                        try {
                            var blob = new Blob([ data ], {
                                type : contentType
                            });
                            var url = window.URL.createObjectURL(blob);
                            linkElement.setAttribute('href', url);
                            linkElement.setAttribute("download", filename);
                            var clickEvent = new MouseEvent("click", {
                                "view" : window,
                                "bubbles" : true,
                                "cancelable" : false
                            });
                            linkElement.dispatchEvent(clickEvent);
                        } catch (ex) {
                            console.log(ex);
                        }
                    }, function(error) {
                        console.log('ERROR Downloading the file ********');
                        RestAPIService.showErrorDialog(error);
                    });
        }
        $scope.fileIcon = function(fileType) {

            var icon = {};
            if (fileType == "folder") {
                icon = "icon-folder";
            } else if (fileType.indexOf("jpg") != -1) {
                icon = "icon-file-image";
            } else if (fileType.indexOf("jpeg") != -1) {
                icon = "icon-file-image";
            } else if (fileType.indexOf("png") != -1) {
                icon = "icon-file-image";
            } else if (fileType.indexOf("pdf") != -1) {
                icon = "icon-file-pdf-box";
            } else if (fileType.indexOf("txt") != -1) {
                icon = "icon-clipboard-text";
            } else if (fileType.indexOf("html") != -1) {
                icon = "icon-language-html5";
            } else if (fileType.indexOf("xl") != -1) {
                icon = "icon-file-excel";
            } else if (fileType.indexOf("word") != -1) {
                icon = "icon-file-word";
            } else if (fileType.indexOf("xml") != -1) {
                icon = "icon-file-xml";
            } else if (fileType.indexOf("doc") != -1) {
                icon = "icon-file-document";
            } else if (fileType.indexOf("docx") != -1) {
                icon = "icon-file-document";
            } else if (fileType.indexOf("json") != -1) {
                icon = "icon-clipboard-text";
            }

            else {
                icon = "icon-file-document";
            }
            return icon;
            console.log(icon);
        }

        eaCtrl.fileIcon = function(file) {
            return CommonUtil.getIconForFile(file);
        }
        // ReqId = $scope.workitemInfo;
        // console.log(ReqId);
        var jwtToken = $localStorage.currentUser.token.trim();
        $scope.previewFile = function(ev, file, reqId) {
            ReqId = reqId;          
            archiveId = file.archiveId;
            archiveDocId = file.archiveDocId;
            eaCtrl.file = file;
            console.log(ReqId, archiveId, archiveDocId);
            if(file.fileType.toLowerCase() == 'pdf' ){
                window.open(eaCtrl.file.url);
            }
            else{
            $mdDialog.show({
                controller : DialogController,
                templateUrl : 'app/main/mycontent/inbox/previewFiles.html',
                parent : angular.element(document.body),
                targetEvent : ev,
                clickOutsideToClose : true
            });
            }
        }
        function DialogController($scope, $mdDialog, $sce, $sessionStorage) {

            $scope.toggle = [];
            $scope.arrow =[];
    $scope.toggleFilter = function(inx) {
       $scope.arrow[inx]=$scope.arrow[inx] === true ? false :true;
     $scope.toggle[inx] = $scope.toggle[inx] === true ? false : true;
    };
   
            $scope.fileVis = false;
            $scope.imgVis= false;
           
            if(jwtToken != undefined && ReqId != undefined) {
            var encodedURI = encodeURIComponent(baseUrl+'/api/requests/inbox/filedownload?archiveId='+archiveId+'&requestId='+ReqId+'&archiveDocId='+archiveDocId+'&attachment=false&jwtToken='+jwtToken);
                  var encodedURI =eaCtrl.file.url;
                //$scope.fileURL = $sce.trustAsResourceUrl('https://docs.google.com/gview?url='+encodedURI+'&embedded=true');
                if(eaCtrl.file.fileType =="jpg" || eaCtrl.file.fileType =="JPG" || eaCtrl.file.fileType =="jpeg" || eaCtrl.file.fileType =="JPEG" || eaCtrl.file.fileType =="PNG" || eaCtrl.file.fileType =="png"){
                    $scope.imgVis= true;
                    $scope.fileURL =eaCtrl.file.url;
                  }else{
                    $scope.fileVis= true;
                 
                    //$scope.fileURL = $sce.trustAsResourceUrl('https://docs.google.com/gview?url='+encodedURI+'&embedded=true');
                  }
                
            }
//          if(eaCtrl.file.fileType =="jpg" || eaCtrl.file.fileType =="JPG" || eaCtrl.file.fileType =="jpeg" || eaCtrl.file.fileType =="JPEG" || eaCtrl.file.fileType =="PNG" || eaCtrl.file.fileType =="png"){
//                   $scope.imgVis= true;
//                  eaCtrl.fileURL =eaCtrl.file.url;
//               }else{
//                   $scope.fileVis= true;
//                  eaCtrl.fileURL =eaCtrl.file.url;
//               }          
            $scope.cancel = function() {
                $mdDialog.cancel();
            }
        }
        $scope.goToInbox = function() {
            $state.go('app.mycontent_inbox');
        }

        eaCtrl.fileIcon = function(file) {
            return CommonUtil.getIconForFile(file);
        }

        $scope.myView = true;
        $scope.changeView = function() {
            $scope.myView = !$scope.myView;
        };

        $scope.search = function(query) {
            $scope.searchString = query;
        };

        $scope.processActvity = function(actvity, ev) {
            $state.go('app.mycontent_inbox');
            eaCtrl.newAttachments = $scope.attachmentfiles;
            eaCtrl.actvity = actvity;
            eaCtrl.selectedWorkitemInfo = $scope.workitemInfo;
            console.log("hii", eaCtrl.selectedWorkitemInfo);
            $mdDialog.show({
                controller : ProcessController,
                templateUrl : 'app/main/mycontent/inbox/add.comment.html',
                parent : angular.element(document.body),
                targetEvent : ev,
                clickOutsideToClose : true,
                fullscreen : $scope.customFullscreen
            });
        }
        $scope.workitemInfo.attachments = [];
        function ProcessController($scope, $mdDialog) {
            $scope.popupHeading = eaCtrl.actvity.buttonText;
            $scope.process = function(ev, comment) {
                $mdDialog.cancel();
                $rootScope.inboxButtons = true;
                delete eaCtrl.actvity.$$hashKey;
                var json = {
                    activities : []
                };
                json.comment = comment;
                json.activities.push(eaCtrl.actvity);
                json.header = eaCtrl.selectedWorkitemInfo.header;
                if(json.header.BLDAT){
                    json.header.BLDAT =eaCtrl.InvoiceDate;
                }
                if(json.header.BUDAT){
                    json.header.BUDAT =eaCtrl.PostingDate;
                }
                if(json.header.RECEIPT_DATE){               
                    json.header.RECEIPT_DATE=eaCtrl.ReceiptDate;
                }
                if(json.header.WRBTR){
                    json.header.WRBTR =eaCtrl.Amount;
                }
                json.lineItems = eaCtrl.selectedWorkitemInfo.lineItems;
                angular.forEach(json.lineItems,function(key,value){
                    if(key.WRBTR !=undefined || key.WRBTR !=null){
                     key.WRBTR= eaCtrl.LineItemAmount;
                    }
                 })      
                 json.lineItems = eaCtrl.selectedWorkitemInfo.lineItems;
                angular.forEach(json.lineItems,function(key,value){
                    if(key.WRBTR !=undefined || key.WRBTR !=null){
                     key.WRBTR= eaCtrl.LineItemAmount;
                    }
                 })                
                if (eaCtrl.newAttachments.length > 0) {
                    $scope.allAttachments = eaCtrl.selectedWorkitemInfo.attachments
                            .concat(eaCtrl.newAttachments);
                }
                console.log(json);
                RestAPIService.submitRequestResource(
                                eaCtrl.selectedWorkitemInfo.requestId,
                                eaCtrl.selectedWorkitemInfo.requestType,
                                json, $scope.allAttachments)
                        .then(
                                function(success) {
                                    if (success.status == 200) {
                                        resetRequest();
                                        if (eaCtrl.actvity.buttonText == "Approve") {
                                            $mdDialog
                                                    .show($mdDialog
                                                            .alert()
                                                            .parent(
                                                                    angular
                                                                            .element(document
                                                                                    .querySelector('#popupContainer')))
                                                            .clickOutsideToClose(
                                                                    true)
                                                            .title('Success.')
                                                            .htmlContent(
                                                                    "<h4><b>"
                                                                            + eaCtrl.selectedWorkitemInfo.requestId
                                                                            + "</b> was Approved successfully.</h4>")
                                                            .ariaLabel(
                                                                    'Alert Dialog Demo')
                                                            .ok('Ok')
                                                    // .targetEvent(ev)
                                                    );
                                            $state.go('app.mycontent_inbox');
                                        } else {
                                            $mdDialog
                                                    .show($mdDialog
                                                            .alert()
                                                            .parent(
                                                                    angular
                                                                            .element(document
                                                                                    .querySelector('#popupContainer')))
                                                            .clickOutsideToClose(
                                                                    true)
                                                            .title('Success.')
                                                            .htmlContent(
                                                                    "<h4><b>"
                                                                            + eaCtrl.selectedWorkitemInfo.requestId
                                                                            + "</b> was Rejected successfully.</h4>")
                                                            .ariaLabel(
                                                                    'Alert Dialog Demo')
                                                            .ok('Ok')
                                                    // .targetEvent(ev)
                                                    );
                                            $state.go('app.mycontent_inbox');
                                        }
                                    }
                                }, function(error) {
                                    RestAPIService.showErrorDialog(error);
                                });
            }
            $scope.hide = function() {
                $mdDialog.hide();
            };

            $scope.cancel = function() {
                $mdDialog.cancel();
            };

        }
        
        // $scope.itemsVisibility = true;
        // $scope.mobileselectWorkitem = function(workitem) {
        //     $scope.plants=Plants.data;
        //     $scope.prDoctypes =PRDoctypes.data;            
        //     $scope.workitemInfo={};
        //     $scope.itemsVisibility = !$scope.itemsVisibility;            
        //     $scope.selectedWorkitem = workitem.docId;
        //      $anchorScroll();
        //     RestAPIService
        //             .getInboxWorkitemInfo($stateParams.requestType,
        //                     workitem.docId)
        //             .then(
        //                     function(responce) {
        //                         resetRequest();
        //                         viewForm(responce.data);
        //                         $scope.displayName = $stateParams.displayName;
        //                         $scope.workitemInfo = responce.data;
        //                         $scope.workitemInfo.logs
        //                                 .forEach(function(h) {
        //                                     if (h.activityText == "Initiated") {
        //                                         h['icon'] = "icon-star-outline";
        //                                     }else if (h.activityText == "Confirm") {
        //                                         h['icon'] = "icon-check";
        //                                     }
        //                                     else if (h.activityText == "Approve") {
        //                                         h['icon'] = "icon-check";
        //                                     } else if (h.activityText == "Reject") {
        //                                         h['icon'] = "icon-cancel";
        //                                     }
        //                                     else if (h.activityText != "Initiated" && h.activityText != "Confirm" && h.activityText != "Approve" && h.activityText != "Reject") {
        //                                         h['icon'] = "icon-content-save";
        //                                     }

        //                                 })
        //                         // console.log($scope.workitemInfo);
        //                         $scope.header = responce.data.header;
        //                         if($scope.header.BLDAT!=undefined || $scope.header.BLDAT!= null || $scope.header.BUDAT!=undefined || $scope.header.BUDAT!=null){
                                    
        //                             if($scope.header.BLDAT){                                    
        //                                 eaCtrl.InvoiceDate = $scope.header.BLDAT;                  
        //                                 $scope.header.BLDAT = eaCtrl.InvoiceDate.substring(0,4)+'-'+eaCtrl.InvoiceDate.substring(4,6)+'-'+eaCtrl.InvoiceDate.substring(6,8);
        //                                 $scope.header.BLDAT =  new Date($scope.header.BLDAT);
        //                                 }
        //                                 if($scope.header.BUDAT){                                        
        //                                 eaCtrl.PostingDate = $scope.header.BUDAT;
        //                                 $scope.header.BUDAT = eaCtrl.PostingDate.substring(0,4)+'-'+eaCtrl.PostingDate.substring(4,6)+'-'+eaCtrl.PostingDate.substring(6,8);
        //                                $scope.header.BUDAT =  new Date($scope.header.BUDAT);
        //                                 }
        //                                 if($scope.header.RECEIPT_DATE){
        //                                     eaCtrl.ReceiptDate = $scope.header.RECEIPT_DATE;
        //                                     $scope.header.RECEIPT_DATE = eaCtrl.ReceiptDate.substring(0,4)+'-'+eaCtrl.ReceiptDate.substring(4,6)+'-'+eaCtrl.ReceiptDate.substring(6,8);
        //                                     $scope.header.BUDAT =  new Date($scope.header.BUDAT);
        //                                 }                                      
        //                         }
        //                         if($scope.header.TAX_AMOUNT){
        //                             eaCtrl.Amount =$scope.header.TAX_AMOUNT;
        //                             $scope.header.TAX_AMOUNT = parseInt(eaCtrl.Amount);
        //                         }
        //                         if($scope.header.WRBTR){
        //                             eaCtrl.GrossAmount =$scope.header.WRBTR;
        //                             $scope.header.WRBTR = parseInt(eaCtrl.GrossAmount);
        //                         }
        //                         if($scope.header.FRIEGHT_AMT){
        //                             eaCtrl.FrightAmount =$scope.header.FRIEGHT_AMT;
        //                             $scope.header.WRBTR = parseInt(eaCtrl.FrightAmount);
        //                         }
                        



        //                         eaCtrl.lineItems = responce.data.lineItems;
        //                         angular.forEach(eaCtrl.lineItems,function(key,value){
        //                             $scope.lineItems.push(key.lineItems);
        //                         })
        //                         angular.forEach($scope.lineItems,function(key,value){
        //                             if(key.WRBTR !=undefined || key.WRBTR !=null){
        //                              eaCtrl.LineItemAmount =key.WRBTR;
        //                                 key.WRBTR= parseInt(key.WRBTR);
        //                             }
        //                          })
                            
        //                         $scope.formHeader = true;
        //                         $scope.formLineitem = true;
        //                         if (responce.data.dataChange == 'D') {
        //                             $scope.isUpdatable = true;
        //                             $scope.isReadOnlyHeaderCurrency = true;
        //                         }

        //                     }, function(error) {
        //                         RestAPIService.showErrorDialog(error);
        //                     })
        
            
        // }
        // $scope.goBackToItems = function() {
        //     $scope.itemsVisibility = !$scope.itemsVisibility;
        // }
        $scope.getAnotherColor = function(index) {
            $scope.colors = ['blue-bg white-fg','pink-bg white-fg', 'green-bg white-fg'];
            var totalNoOfColors = $scope.colors.length;
            return $scope.colors[index % totalNoOfColors];
        }
        $scope.attachmentfiles = [];
        $scope.setAttachmentFile = function(element) {
            var formData = new FormData();
            $scope.$apply(function() {

                for (var i = 0; i < element.files.length; i++) {
                    formData.append('file', element.files[i]);
                    $scope.attachmentfiles.push(element.files[i]);
                }
            });
        };

      

        
        function viewForm(data) {
            RestAPIService.getFormData(data).then(function(success){
                $scope.formData=success.data;
                $scope.currentFormHeader = $sce.trustAsHtml($scope.formData.content.replace(/&quot;/g, '"'));
                if($scope.formData.lineItemContent){
             $scope.currentFormLineitem = $sce.trustAsHtml($scope.formData.lineItemContent.replace(/&quot;/g, '"'));
                }
             if($scope.formData.inboxHeaderContent){
                $scope.currentFormInboxHeader = $sce.trustAsHtml($scope.formData.inboxHeaderContent.replace(/&quot;/g, '"'));
             }
             if($scope.formData.inboxLineItemContent){
                $scope.currentFormInboxLineitem = $sce.trustAsHtml($scope.formData.inboxLineItemContent.replace(/&quot;/g, '"'));    
             }
            //  $scope.currentFormInboxHeader = $sce.trustAsHtml($scope.formData.inboxHeaderContent.replace(/&quot;/g, '"'));
             //$scope.currentFormInboxLineitem = $sce.trustAsHtml($scope.formData.inboxLineItemContent.replace(/&quot;/g, '"'));
            },function(error){

            })
            // $scope.currentFormHeader = $sce.trustAsHtml(data.mainLayout.replace(/&quot;/g, '"'));
            // $scope.currentFormLineitem = $sce.trustAsHtml(data.detailsLayout.replace(/&quot;/g, '"'));
        }
        $scope.currencies = [ "INR", "USD", "EUR", "PLN" ];
      
        // $scope.getAllWorkitems = function() {
        //     RestAPIService.getAllInboxWorkitems($stateParams.requestType,
        //             $scope.pageNumber, $scope.size).then(function(success) {
        //         $scope.allWorkitems = success.data;
        //     }, function(error) {
        //         RestAPIService.showErrorDialog(error);
        //     });

        // };
//         $scope.pageNumber = 0;
//         $scope.size = 200;
//         $scope.nextInboxItems = function() {            
// //          Preventing the request call for next items when items in present page are zero.
//             if($scope.allWorkitems.length != 0){
//                 $scope.pageNumber = $scope.pageNumber + 1;
//                 $scope.getAllWorkitems();
//             }
//             else{
//                 return;
//             }
//         }
//         $scope.previousInboxItems = function() {
// //          Make the previous items call when the page number is greater than or equal to zero.
//             if ($scope.pageNumber - 1 >= 0) {
//                 $scope.pageNumber = $scope.pageNumber - 1;
//                 $scope.getAllWorkitems();
//             } else {
//                 alert("This is First page.");
//             }
//         }
        function init(){
            // alert("hiiiiii..");
            // RestAPIService.getRequestType($stateParams.requestType).then(function(responce){
            //     eaCtrl.requestTypeData = responce.data;
            // }, function(error){
            //     RestAPIService.showErrorDialog(error);
            // })
            var workitem = {};
            workitem['docId'] = $stateParams.docId;
            workitem['description'] = $stateParams.requestType;
            $scope.selectWorkitem(workitem);

        }
        init();
     
    }   
         
})();
(function ()
{
    'use strict';

    angular
        .module('app.forgot-password',[])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.forgot-password', {
                url    : '/forgot-password',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/forgot-password/forgot-password.html',
                        controller : 'ForgotPasswordController as vm'
                    }
                }
               
            })
          msNavigationServiceProvider.saveItem('fuse.forgot-password', {
            title    : 'ForgotPassword',
            icon     : 'icon-account-key',
            // state    :'app.forgot-password',
            weight   : 2
        });               
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.forgot-password')
        .controller('ForgotPasswordController', ForgotPasswordController);

    /** @ngInject */
    function ForgotPasswordController($scope)
    {
        var vm=this;
        vm.reset=reset;
        function reset(userData){
              console.log(userData);
                
                
                $scope.user = {};            
                vm.forgotPasswordForm.$setPristine();
               vm.forgotPasswordForm.$setUntouched();
          
            }

        

        // Methods

        //////////
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.coromandeloutbox', ['ngSanitize','GlobalModule'] )
        .config(config)
        .run(run);
    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider, $mdThemingProvider)
    {
         $stateProvider
         .state('app.coromandeloutbox', {
            url: '/cmainoutbox',
            params: {
                requestType: null,
                displayName:null
            },
            views: {
                'content@app': {
                    templateUrl: 'app/main/coromandel_outbox/c_outbox/c_outbox.html',
                    controller:  'COutboxController as CoutboxCtrl'
                }}

            })
            .state('app.coromandeloutbox.detail', {
                url      : '/:id',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/coromandel_outbox/c_outbox/c_outboxWorkitem.html',
                        controller : 'COutboxController as CoutboxCtrl'
                    }
                },
                bodyClass: 'e-commerce'
            });
        //      msNavigationServiceProvider.saveItem('cmainoutbox', {
        //     title : 'Outbox',
        //     icon  : 'icon-email',
        //     state : 'app.mycontent_outbox',
        //     weight: 3,
          
        // });



    }
    function run(msNavigationService, $localStorage, $rootScope, $state){
        msNavigationService.saveItem('reports', {
            title : 'Outbox',
            icon  : 'icon-email',
            state : 'app.mycontent_outbox',
            weight: 3,
            hidden:function(){
                if ($localStorage.menubarsetting != undefined) {
                  var show = $localStorage.menubarsetting.COutbox;
                  return !(show);
              }
              }
        });



     }
})();
(function ()
{
    'use strict';

    angular
        .module('app.coromandeloutbox')
        .controller('COutboxController', COutboxController)
      
    /** @ngInject */
    function COutboxController($state, $scope,CommonUtil, RestAPIService, $filter, $mdDialog,$location,$anchorScroll,$sce,$stateParams,$localStorage)
    {
        var CoutboxCtrl = this;
        $scope.workitemInfo = [];      
        CoutboxCtrl.dtOptions = {
       dom       : '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
         pagingType: 'simple',
         lengthMenu: [50, 100,200,300,400,500],
         autoWidth : false,
         responsive: true
        };
       
         $scope.logs= function(){
            $mdDialog.show({
              locals:{logsData: $scope.workitemInfo},
               controller: LogsDialogController,
               templateUrl: 'app/main/coromandel_inbox/c_inbox/c_inboxLogs.html',
               parent: angular.element(document.body),
               clickOutsideToClose: true,
               fullscreen: $scope.customFullscreen
           });
         }
         function LogsDialogController($scope, logsData){
          $scope.showinbox = false;
          $scope.printLogs = function() {
            var innerContents = document.getElementById("printSectionId").innerHTML;
            var popupWinindow = window.open('', '_blank', 'width=600,height=700,scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no');
            popupWinindow.document.open();
            popupWinindow.document.write('<html><head><link rel="stylesheet" type="text/css" href="style.css" /></head><body onload="window.print()">' + innerContents + '</html>');
            popupWinindow.document.close();
            window.close();
        };
    
           $scope.workitemInfo = logsData;
           $scope.log = $scope.workitemInfo.logs;
           $scope.today = new Date();
           $scope.createdDate = new Date($scope.workitemInfo.createdDate);
         $scope.diffDays = Math.round(Math.abs(($scope.today.getTime() - $scope.createdDate.getTime())/(24*3600*1000)));
        //  $scope.downloadFile=function(attachment){
        //   CommonUtil.downloadFile(logsData.requestId,attachment.archiveId,attachment.archiveDocId,attachment)
        //  }
        $scope.downloadFile=function(attachment){
          //  window.open(attachment.url+'.'+attachment.fileType)
         CommonUtil.downloaddirectFile(attachment)
         } 
         $scope.attachmentfiles = [];
         $scope.setAttachmentFile = function(element) {
          var formData = new FormData();
          $scope.$apply(function() {            
              for (var i = 0; i < element.files.length; i++) {
                  formData.append('file', element.files[i]);
                  $scope.attachmentfiles.push(element.files[i]);
              }
          });
        };

        $scope.today = new Date();
        $scope.createdDate = new Date($scope.workitemInfo.createdDate);       
       $scope.diffDays = Math.round(Math.abs(($scope.today.getTime() - $scope.createdDate.getTime())/(24*3600*1000)));
    
         
           $scope.log.forEach(function(h){
              if(h.activityText == "Initiated" || h.activity =='001'){
                h['icon'] = "icon-star-outline";
              }
              else if(h.activity == "101"){
                h['icon'] = "icon-check";
              }
              else if(h.activityText =="Collaborate" ||  h.activity == '110'){
                h['icon'] ="icon-content-save";
              }
              else if(h.activityText =="CollaborateBack" ||  h.activity == '111'){
                h['icon'] ="icon-content-save";
              }
              else if(h.activity =="102"){
                h['icon'] ="icon-close";
              }
              else if(h.activityText =="Cancel"){
                h['icon'] ="icon-plus";
              }
              else if(h.activityText =="Delete"){
                h['icon'] ="icon-delete";
              }
              else if(h.activityText == "Elimination"){
               h['icon'] = "icon-check";
             }
              
            })
          
          
          
          $scope.cancel = function() {
              $mdDialog.cancel();
          };
        
    
         }
        if($stateParams.requestType) $localStorage.requestType =$stateParams.requestType;
        if($stateParams.id) $localStorage.docId =$stateParams.id; $scope.id =$stateParams.id;
        if($localStorage.requestType){
            $scope.vendorform =["DocId","SBU","Location","Department","Category","Cost Center","Subject","Created Date"]
          }
          // $scope.trustSrc = function(src) {
          //   return $sce.trustAsResourceUrl(src);
          // }
          $scope.selectFile = function(fileData){
            if(fileData.fileType.toLowerCase() == 'pdf'){
              window.open(fileData.url);
            }
            else{
              $mdDialog.show(
                $mdDialog.alert()
                .parent(angular.element(document .querySelector('#popupContainer')))
                .clickOutsideToClose(true)
                .title('Warning')
                .htmlContent("<h4><b> Unable To Preview The Document, Please Download. </b></h4>")
                .ariaLabel('Alert Dialog Demo')
                .ok('Ok')
                  );
                $mdDialog.cancel();
            }
         }
          $scope.fileIcon = function(fileType){ 	
    
            
            var icon ={};
              if(fileType == "folder"){
                    icon = "icon-folder";
                }                        
                else if(fileType.indexOf("jpg")!= -1){
                    icon = "icon-file-image";
                }
                else if(fileType.indexOf("jpeg")!= -1){
                    icon = "icon-file-image";
                }
                else if(fileType.indexOf("png")!= -1){
                    icon = "icon-file-image";
                }
                else if(fileType.indexOf("pdf")!= -1){
                    icon = "icon-file-pdf-box";
                }
                else if(fileType.indexOf("txt")!= -1){
                    icon = "icon-clipboard-text";
                }
                else if(fileType.indexOf("html")!= -1){
                    icon = "icon-language-html5";
                }
                else if(fileType.indexOf("xl")!= -1){
                    icon = "icon-file-excel";
                }
                else if(fileType.indexOf("word")!= -1){
                    icon = "icon-file-word";
                }
                else if(fileType.indexOf("xml")!= -1){
                    icon = "icon-file-xml";
                }
                else if(fileType.indexOf("doc")!= -1){
                    icon = "icon-file-document";
                }  
                else if(fileType.indexOf("docx")!= -1){
                    icon = "icon-file-document";
                }
                else if(fileType.indexOf("json")!= -1){
                    icon = "icon-clipboard-text";
                }                      
    
                else{
                    icon = "icon-file-document";
                }
                return icon;
               
      }
      ///priceprocess//

      // $scope.isTabularDetailAvailable = false;
 
      // CoutboxCtrl.tableSample = ['COMPETITOR', 'MONTH', 'DAP (I)', 'DAP (M)', 'DAP (ZN)', '28-28-0', '14-35-14', '10-26-26', '10-26-26(ZN)', '24:24:0:8', '20-20-0-13', '16:20:0:13', '12:32:16', '17:17:17', '15:15:15:09', 'MOP']
      // CoutboxCtrl.tableDetails = [
      //   'Company name',
      //   'Product',
      //   'Month Name',
      //   'MRP (Rs/Mt)',
      //   'MRP (Rs/Bag)',
      //   'Basic Price (Rs/Mt)',
      //   'Basic Price (Rs/Bag)',
      //   'Less : Dealer Margin (Rs./Mt)',
      //   'Less : Adhoc Dealer Margin',
      //   'Less : Product Discount',
      //   'Price Before GST (Rs./Mt)',
      //   'Add: GST (Rs/Mt)',
      //   'Net Invoice Price (Rs/Mt)',
      //   'Net Invoice Price (Rs/Bag)',
      //   'Product Disc (Rs/Mt)',
      //   'Scheme Disc (Rs/Mt)',
      //   'Net Price (Rs/Mt) - FOL - Cr',
      //   'Net Price (Rs/Bag) - FOL - Cr',
      //   'TC (Rs/Mt)',
      //   'Net Price (Rs/Mt) - Ex - Cr',
      //   'Net Price (Rs/Bag) - Ex - Cr',
      //   'Cash Discount (Rs. Per Bag)',
      //   'EPR (Rs Per Bag)',
      //   'Net Price (Rs/Mt) - Ex - Cash',
      //   'Net Price (Rs/Bag) - Ex - Cash',
      //   'Wholesaler to Retailer Price',
      //   'Invoice copy attached']
 
      //   $scope.seeCompleteDetails = function(index){
      //     $scope.isTabularDetailAvailable = true;
      //     $scope.index = index;
      //   }
 
      //   $scope.closeCompleteDetails = function(){
      //     $scope.isTabularDetailAvailable = false;
      //   }
      ///end-price process
      $scope.getAttachmentsLength = function(attachments){
        $scope.attachmentsCount = 0;
        attachments.forEach(function(h){
            if(h.deleteStatus != 'true'){
                $scope.attachmentsCount = $scope.attachmentsCount+1;
            }
        })
        return $scope.attachmentsCount;
      }
          init();

          function init(){
            $scope.downloadFile=function(attachment){
              CommonUtil.downloaddirectFile(attachment)
              // window.open(attachment.url+'.'+attachment.fileType)
              //  CommonUtil.downloadFile($scope.workitemInfo.requestId,attachment.archiveId,attachment.archiveDocId,attachment)
             }
             $scope.attachmentfiles = [];
             $scope.setAttachmentFile = function(element) {
              var formData = new FormData();
              $scope.$apply(function() {            
                  for (var i = 0; i < element.files.length; i++) {
                      formData.append('file', element.files[i]);
                      $scope.attachmentfiles.push(element.files[i]);
                  }
              });
            };
            
            CoutboxCtrl.getAllOutboxWorkitems=function(){
          RestAPIService.getAllOutboxWorkitems($localStorage.requestType,"0","10000",'requestId').then(
            function(success){
              $scope.orders =success.data;
             }, function(error){});   

         }
         CoutboxCtrl.getAllOutboxWorkitems();
                         
            if($localStorage.docId){
              // RestAPIService.getUsers().then(function(success){
              //   CoutboxCtrl .users =success.data;
              //       },function(error){}); 
              RestAPIService.getOutboxWorkitemInfo($localStorage.requestType,$localStorage.docId).then(
                  function(success){
                      $scope.workitemInfo = success.data;
                      $scope.currentFormInboxHeader = $sce.trustAsHtml(success.data.inboxMainLayout.replace(/&quot;/g, '"'));
                      $scope.currentFormInbox = $sce.trustAsHtml(success.data.mainLayout.replace(/&quot;/g,'"'));
                      if( $scope.workitemInfo.requestType == "COR_EXCL_PDR" && success.data.detailsLayout){
                        $scope.currentFormInboxLineitem = $sce.trustAsHtml( success.data.detailsLayout.replace(/&quot;/g, '"'));
                      }
                      if(success.data.detailsLayout){
                        $scope.currentFormInboxLineitem = $sce.trustAsHtml( success.data.detailsLayout.replace(/&quot;/g, '"'));
                      }
                      $scope.workitemInfoLogs = success.data.logs
                      //CoutboxCtrl.url=$scope.workitemInfo.attachments[0].url;
                      var timestamp = $scope.workitemInfo.createdDate
                      var tempdate = timestamp.split("T")[0]
                      $scope.createDate = tempdate.split("-")[2]+"-"+tempdate.split("-")[1]+"-"+tempdate.split("-")[0]
                      $scope.today = new Date();
                      $scope.createdDate = new Date($scope.workitemInfo.createdDate);
                    $scope.diffDays = Math.round(Math.abs(($scope.today.getTime() - $scope.createdDate.getTime())/(24*3600*1000)));
  
                      if($scope.workitemInfo){
                        $scope.header = $scope.workitemInfo.header;
                        $scope.currentstep = parseInt($scope.workitemInfo.currentstep);
                        // $scope.lineItems = $scope.workitemInfo.lineItems;
                        $scope.lineItems=[]
                        CoutboxCtrl.lineItems = $scope.workitemInfo.lineItems;
                        angular.forEach(CoutboxCtrl.lineItems,function(key,value){
                            $scope.lineItems.push(key.lineItems);
                            CoutboxCtrl.InsideLineItems =$scope.lineItems;
                        })
                        if($scope.workitemInfo.flowType == 'SAP'){
                          $scope.workitemInfo.approvalMatrix =[];
                            }
                            $scope.workitemInfo.approvalMatrix.approvers = [];
                              $scope.workitemInfo.approvalMatrix.approverDays = [];
                              $scope.workitemInfo.approvalMatrix.approverDates =[];
                              $scope.workitemInfo.approvalMatrix.selected = [];
                              $scope.workitemInfo.approvalMatrix.checked = [];
                              var logs = $scope.workitemInfo.logs;
                              for (var i = 0; i <$scope.workitemInfo.approvalMatrix.noofApp; i++) {
                                $scope.workitemInfo.approvalMatrix.approvers[i] = $scope.workitemInfo.approvalMatrix["level_" + (i + 1) + "_approvers"];
                                $scope.workitemInfo.approvalMatrix.approverDays[i] =$scope.workitemInfo.approvalMatrix["level_"+(i+1)+"_approversDays"];
                                $scope.workitemInfo.approvalMatrix.approverDates[i] =$scope.workitemInfo.approvalMatrix["level_"+(i+1)+"_approversDate"];
                              for(var j=0;j<=logs.length-1;j++){
                              var log = logs[j];
                              if(log.step == i+1 && log.activity == 101){
                                $scope.workitemInfo.approvalMatrix.approvers[i] = log.actualUser;
                                break;
                              }else if(( i+1 >= $scope.currentstep)){
                                $scope.workitemInfo.approvalMatrix.approvers[i] = $scope.workitemInfo.approvalMatrix["level_" + (i + 1) + "_approvers"];
                                  }
                                 }
                                if (i < ($scope.currentstep)) {
                                    $scope.workitemInfo.approvalMatrix.selected[i] = true;
                                } else {
                                    $scope.workitemInfo.approvalMatrix.selected[i] = false;
                                }
                                if (i < ($scope.currentstep-1)) {
                                    $scope.workitemInfo.approvalMatrix.checked[i] = true;
                                } else {
                                    $scope.workitemInfo.approvalMatrix.checked[i] = false;
                                }
                            }
                      }
                     },function(error){}
              )}
            }
  

          $scope.gotoOrderDetail=function(id){$state.go('app.coromandeloutbox.detail', {id: id});}
          $scope.gotoOrders=function() { $state.go('app.coromandeloutbox'); }
    }
})();







(function ()
{
    'use strict';

    angular
        .module('app.coromandelinbox', ['ngSanitize'] )
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider, $mdThemingProvider)
    {
         $stateProvider
         .state('app.coromandelinbox', {
            url: '/cmaininbox',
            params: {
                requestType: null,
                displayName:null
            },
            views: {
                'content@app': {
                    templateUrl: 'app/main/coromandel_inbox/c_inbox/c_inbox.html',
                    controller:  'CInboxController as CinboxCtrl'
                }}

            })
            .state('app.coromandelinbox.detail', {
                url      : '/:id',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/coromandel_inbox/c_inbox/c_inboxWorkitem.html',
                        controller : 'CInboxController as CinboxCtrl'
                    }
                },
                bodyClass: 'e-commerce'
            });



    }
})();


(function() {
  'use strict';

  angular
      .module('app.coromandelinbox')
      .controller('CInboxController', CInboxController);

  /** @ngInject */
  function CInboxController($state, $scope, CommonUtil, RestAPIService, $filter, $mdDialog, $sce, $stateParams, $localStorage) {
      var CinboxCtrl = this;
      $scope.workitemInfo = []
      $scope.sapTab = false;
      $scope.showLoadingIcon = false;

      CinboxCtrl.dtOptions = {
          dom: '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
          pagingType: 'simple',
          lengthMenu: [50, 100,200,300,400,500],
          autoWidth: false,
          responsive: true
      };

      $scope.toggle = [];
      $scope.arrow = [];
      $scope.toggleFilter = function(inx) {
          $scope.arrow[inx] = $scope.arrow[inx] === true ? false : true;
          $scope.toggle[inx] = $scope.toggle[inx] === true ? false : true;
      };
      $scope.getAttachmentsLength = function(attachments){
        $scope.attachmentsCount = 0;
        if(attachments && attachments.length>0){
            attachments.forEach(function(h){
                if(h.deleteStatus != 'true'){
                    $scope.attachmentsCount = $scope.attachmentsCount+1;
                }
            })
        }
        return $scope.attachmentsCount;
      }
      $scope.logs = function() {
          $mdDialog.show({
              locals: {
                  logsData: $scope.workitemInfo
              },
              controller: LogsDialogController,
              templateUrl: 'app/main/coromandel_inbox/c_inbox/c_inboxLogs.html',
              parent: angular.element(document.body),
              //              targetEvent: ev,
              clickOutsideToClose: true,
              fullscreen: $scope.customFullscreen
          });
      }

      function LogsDialogController($scope, logsData) {
          $scope.showinbox = true
          $scope.printLogs = function(printSectionId) {
              var innerContents = document.getElementById(printSectionId).innerHTML;
              var popupWinindow = window.open('', '_blank', 'width=600,height=700,scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no');
              popupWinindow.document.open();
              popupWinindow.document.write('<html><head><link rel="stylesheet" type="text/css" href="style.css" /></head><body onload="window.print()">' + innerContents + '</html>');
              popupWinindow.document.close();
              window.close();
          };
          $scope.workitemInfo = logsData;
          $scope.log = $scope.workitemInfo.logs;
          $scope.today = new Date();
          $scope.createdDate = new Date($scope.workitemInfo.createdDate);
          $scope.diffDays = Math.round(Math.abs(($scope.today.getTime() - $scope.createdDate.getTime()) / (24 * 3600 * 1000)));
          $scope.log.forEach(function(h) {
              if (h.activityText == "Initiated" || h.activity == '001') {
                  h['icon'] = "icon-star-outline";
              } else if (h.activity == "101") {
                  h['icon'] = "icon-check";
              } else if (h.activityText == "Collaborate" || h.activity == '110') {
                  h['icon'] = "icon-content-save";
              } else if (h.activityText == "CollaborateBack" || h.activity == '111') {
                  h['icon'] = "icon-content-save";
              } else if (h.activity == "102") {
                  h['icon'] = "icon-close";
              } else if (h.activityText == "Cancel") {
                  h['icon'] = "icon-plus";
              } else if (h.activityText == "Delete") {
                  h['icon'] = "icon-delete";
              } else if (h.activityText == "Elimination") {
                  h['icon'] = "icon-check";
              }
          })
          $scope.cancel = function() {
              $mdDialog.cancel();
          };
      }
      $scope.Attachments = function() {
          $mdDialog.show({
              locals: {
                  logsData: $scope.workitemInfo
              },
              controller: LogsDialogController,
              templateUrl: 'app/main/coromandel_inbox/c_inbox/attachments-dialog.html',
              parent: angular.element(document.body),
              //              targetEvent: ev,
              clickOutsideToClose: true,
              fullscreen: $scope.customFullscreen
          });

          function LogsDialogController($scope, logsData) {
              $scope.workitemInfo = logsData;
              $scope.attachmentsData = $scope.workitemInfo.attachments;
              $scope.downloadFile = function(attachment) {
                  // window.open(attachment.url+'.'+attachment.fileType)
                  CommonUtil.downloaddirectFile(attachment)
                  // CommonUtil.downloadFile($scope.workitemInfo.requestId,attachment.archiveId,attachment.archiveDocId,attachment)
              }
              $scope.getAttachmentsLength = function(attachments){
                $scope.attachmentsCount = 0;
                attachments.forEach(function(h){
                    if(h.deleteStatus != 'true'){
                        $scope.attachmentsCount = $scope.attachmentsCount+1;
                    }
                })
                return $scope.attachmentsCount;
              }
              $scope.selectFile = function(fileData) {
                  if (fileData.fileType.toLowerCase() == 'pdf') {
                      window.open(fileData.url);
                  } else {
                      $mdDialog.show(
                          $mdDialog.alert()
                          .parent(angular.element(document.querySelector('#popupContainer')))
                          .clickOutsideToClose(true)
                          .title('Warning')
                          .htmlContent("<h4><b> Unable To Preview The Document, Please Download. </b></h4>")
                          .ariaLabel('Alert Dialog Demo')
                          .ok('Ok')
                      );
                      $mdDialog.cancel();
                  }
              }
              $scope.cancel = function() {
                  $mdDialog.cancel();
              }

          }
      }
      if ($stateParams.requestType) $localStorage.requestType = $stateParams.requestType;
      if ($stateParams.id) $localStorage.docId = $stateParams.id;
      $scope.id = $stateParams.id;
      if ($localStorage.requestType != "COR_ADV" && $localStorage.requestType != 'COR_CDP' && $localStorage.requestType != 'COR_CUT_PO' && $localStorage.requestType != 'COR_FRIEGHT_PO' && $localStorage.requestType != 'COR_GEN_PO' && $localStorage.requestType != 'COR_IMP_PO' && $localStorage.requestType != 'COR_LOAD_PO' && $localStorage.requestType != 'COR_NPO' && $localStorage.requestType != 'COR_STATU_INV' && $localStorage.requestType != 'COR_UNLOAD_PO' && $localStorage.requestType != 'COR_CUT_FREIGHT' && $localStorage.requestType != 'COR_STG_PO') {
          $scope.vendorform = ["DocId", "SBU", "Location", "Department", "Category", "Cost Center", "Subject","Total Amount","Created Date"]

      }
      if ($localStorage.requestType == "COR_ADV" || $localStorage.requestType == "COR_CDP" || $localStorage.requestType == "COR_CUT_PO" || $localStorage.requestType == "COR_FRIEGHT_PO" || $localStorage.requestType == "COR_GEN_PO" || $localStorage.requestType == "COR_IMP_PO" || $localStorage.requestType == "COR_LOAD_PO" || $localStorage.requestType == "COR_NPO" || $localStorage.requestType == "COR_STATU_INV" || $localStorage.requestType == "COR_UNLOAD_PO" || $localStorage.requestType == "COR_CUT_FREIGHT" || $localStorage.requestType == "COR_STG_PO") {
          $scope.sscform = true;
          $scope.vendorform = ["DocId", "SBU", "Department", "Invoice Number", "vendor", "vendor Name", "PO Number", "Invoice Category", "Invoice Amount", "Invoice Date","Total Amount","Created Date"]
      }
      //   if($localStorage.requestType){
      //     $scope.vendorform =["DocId","SBU","Location","Department","Category","Cost Center","Subject"]
      // }
      $scope.selectFile = function(fileData) {
          if (fileData.fileType.toLowerCase() == 'pdf') {
              window.open(fileData.url);
          } else {
              $mdDialog.show(
                  $mdDialog.alert()
                  .parent(angular.element(document.querySelector('#popupContainer')))
                  .clickOutsideToClose(true)
                  .title('Warning')
                  .htmlContent("<h4><b> Unable To Preview The Document, Please Download. </b></h4>")
                  .ariaLabel('Alert Dialog Demo')
                  .ok('Ok')
              );
              $mdDialog.cancel();
          }
      }
      $scope.fileIcon = function(fileType) {
          var icon = {};
          if (fileType == "folder") {
              icon = "icon-folder";
          } else if (fileType.indexOf("jpg") != -1) {
              icon = "icon-file-image";
          } else if (fileType.indexOf("jpeg") != -1) {
              icon = "icon-file-image";
          } else if (fileType.indexOf("png") != -1) {
              icon = "icon-file-image";
          } else if (fileType.indexOf("pdf") != -1) {
              icon = "icon-file-pdf-box";
          } else if (fileType.indexOf("txt") != -1) {
              icon = "icon-clipboard-text";
          } else if (fileType.indexOf("html") != -1) {
              icon = "icon-language-html5";
          } else if (fileType.indexOf("xl") != -1) {
              icon = "icon-file-excel";
          } else if (fileType.indexOf("word") != -1) {
              icon = "icon-file-word";
          } else if (fileType.indexOf("xml") != -1) {
              icon = "icon-file-xml";
          } else if (fileType.indexOf("doc") != -1) {
              icon = "icon-file-document";
          } else if (fileType.indexOf("docx") != -1) {
              icon = "icon-file-document";
          } else if (fileType.indexOf("json") != -1) {
              icon = "icon-clipboard-text";
          } else {
              icon = "icon-file-document";
          }
          return icon;
      }
      init();

      function init() {
          $scope.downloaddirectFile = function(attachment) {
              //  CommonUtil.downloadFile($scope.workitemInfo.requestId,attachment.archiveId,attachment.archiveDocId,attachment)
              // window.open(attachment.url+'.'+attachment.fileType)
              CommonUtil.downloaddirectFile(attachment)
          }
          //   $scope.downloadFile=function(attachment){
          //   CommonUtil.downloadFile($scope.workitemInfo.requestId,attachment.archiveId,attachment.archiveDocId,attachment)
          //  }
          $scope.attachmentfiles = [];
          $scope.setAttachmentFile = function(element) {
              var filetypename = element.files[0].name
              var filetype = filetypename.split(".").pop();
              if (filetype == "msg") {
                  $mdDialog.show(
                      $mdDialog.alert()
                      .parent(angular.element(document.querySelector('#popupContainer')))
                      .clickOutsideToClose(true)
                      .title('')
                      .htmlContent("<h4><b> File type .msg is not permitted to upload. Please contact your administrator.</b></h4>")
                      .ariaLabel('Alert Dialog Demo')
                      .ok('Ok')
                  );
                  $mdDialog.cancel();
                  var fileList = $("#formUploadFile");
                  fileList[0].value = '';
                  return;
              }
              // id.split("_").pop();
              var formData = new FormData();
              $scope.$apply(function() {
                  for (var i = 0; i < element.files.length; i++) {
                      formData.append('file', element.files[i]);
                      $scope.attachmentfiles.push(element.files[i]);
                  }
              });
          };
          $scope.removeAttachment = function(index) {
              var fileList = $("#formUploadFile");
              fileList[0].value = '';
              $scope.attachmentfiles.splice(index, 1);

          }
          $scope.previewFile = function(file) {
              var pdffile_url = URL.createObjectURL(file);
              window.open(pdffile_url, '_blank');
              // $('#viewer').attr('src',pdffile_url);
          }

          if(!$stateParams.id){
            RestAPIService.getAllInboxWorkitems($localStorage.requestType, "0", "1000").then(
              function(success) {
                  $scope.orders = success.data;
                  console.log($scope.orders)


              },
              function(error) {});
          }
          if ($stateParams.id) {
              RestAPIService.getUsers(0, 2000).then(function(success) {
                  CinboxCtrl.users = success.data;
                  $scope.totalRecords = success.headers('x-total-count');
                  if($scope.totalRecords > 2000){
                    RestAPIService.getUsers(1, 2000).then(function(success) {
                        CinboxCtrl.users = CinboxCtrl.users.concat(success.data);
                      },
                       function(error) {});
                  }                  
              },function(error) {});
              
              


              RestAPIService.getInboxWorkitemInfo($localStorage.requestType, $localStorage.docId).then(
                  function(success) {
                      $scope.workitemInfo = success.data;
                      console.log($scope.workitemInfo)
                      $scope.currentFormInboxHeader = $sce.trustAsHtml(success.data.inboxMainLayout.replace(/&quot;/g, '"'));
                      $scope.currentFormInbox = $sce.trustAsHtml(success.data.mainLayout.replace(/&quot;/g, '"'));
                      if ($scope.workitemInfo.requestType == "COR_EXCL_PDR" && success.data.detailsLayout) {
                          $scope.currentFormInboxLineitem = $sce.trustAsHtml(success.data.detailsLayout.replace(/&quot;/g, '"'));
                          // $('tr:has(td:contains("Yes"))').addClass('success');
                      }
                      if (success.data.detailsLayout) {
                          $scope.currentFormInboxLineitem = $sce.trustAsHtml(success.data.detailsLayout.replace(/&quot;/g, '"'));
                      }
                      console.log($scope.currentFormInboxLineitem);

                      $scope.workitemInfoLogs = success.data.logs
                      var timestamp = $scope.workitemInfo.createdDate
                      var tempdate = timestamp.split("T")[0]
                      $scope.createDate = tempdate.split("-")[2] + "-" + tempdate.split("-")[1] + "-" + tempdate.split("-")[0]
                      $scope.today = new Date();
                      $scope.createdDate = new Date($scope.workitemInfo.createdDate);
                      $scope.diffDays = Math.round(Math.abs(($scope.today.getTime() - $scope.createdDate.getTime()) / (24 * 3600 * 1000)));
                      if ($scope.workitemInfo) {
                          $scope.header = $scope.workitemInfo.header;
                          $scope.currentstep = parseInt($scope.workitemInfo.currentstep);
                          // $scope.lineItems = $scope.workitemInfo.lineItems[0];
                          $scope.lineItems = []
                          CinboxCtrl.lineItems = $scope.workitemInfo.lineItems;
                          angular.forEach(CinboxCtrl.lineItems, function(key, value) {
                              $scope.lineItems.push(key.lineItems);
                              CinboxCtrl.InsideLineItems = $scope.lineItems;
                          })


                          if ($scope.workitemInfo.flowType == 'SAP') {
                              $scope.workitemInfo.approvalMatrix = [];
                          }
                          if (!$scope.workitemInfo.approvalMatrix) {
                              $scope.workitemInfo.approvalMatrix = {}
                          }
                          $scope.workitemInfo.approvalMatrix.approvers = [];
                          $scope.workitemInfo.approvalMatrix.approverDays = [];
                          $scope.workitemInfo.approvalMatrix.approverDates = [];
                          $scope.workitemInfo.approvalMatrix.selected = [];
                          $scope.workitemInfo.approvalMatrix.checked = [];
                          var logs = $scope.workitemInfo.logs;
                          for (var i = 0; i < $scope.workitemInfo.approvalMatrix.noofApp; i++) {
                              $scope.workitemInfo.approvalMatrix.approvers[i] = $scope.workitemInfo.approvalMatrix["level_" + (i + 1) + "_approvers"];
                              $scope.workitemInfo.approvalMatrix.approverDays[i] = $scope.workitemInfo.approvalMatrix["level_" + (i + 1) + "_approversDays"];
                              $scope.workitemInfo.approvalMatrix.approverDates[i] = $scope.workitemInfo.approvalMatrix["level_" + (i + 1) + "_approversDate"];
                              for (var j = 0; j <= logs.length - 1; j++) {
                                  var log = logs[j];
                                  if (log.step == i + 1 && log.activity == 101) {
                                      $scope.workitemInfo.approvalMatrix.approvers[i] = log.actualUser;
                                      break;
                                  } else if ((i + 1 >= $scope.currentstep)) {
                                      $scope.workitemInfo.approvalMatrix.approvers[i] = $scope.workitemInfo.approvalMatrix["level_" + (i + 1) + "_approvers"];
                                  }
                              }
                              if (i < ($scope.currentstep)) {
                                  $scope.workitemInfo.approvalMatrix.selected[i] = true;
                              } else {
                                  $scope.workitemInfo.approvalMatrix.selected[i] = false;
                              }
                              if (i < ($scope.currentstep - 1)) {
                                  $scope.workitemInfo.approvalMatrix.checked[i] = true;
                              } else {
                                  $scope.workitemInfo.approvalMatrix.checked[i] = false;
                              }
                          }

                          if ($scope.workitemInfo.attachments.length <= "0" && $scope.workitemInfo.requestType != 'COR_ADV') {
                              $mdDialog.show(
                                  $mdDialog.alert()
                                  .parent(angular.element(document.querySelector('#popupContainer')))
                                  .clickOutsideToClose(true)
                                  .title('')
                                  .htmlContent("<h4><b> Please Contact Admin To get Attachments </b></h4>")
                                  .ariaLabel('Alert Dialog Demo')
                                  .ok('Ok')
                              );
                              $mdDialog.cancel();
                          }
                      }
                  },
                  function(error) {}
              )
          }
      }


      $scope.activityAction = false;
      $scope.processActvity = function(actvity, ev) {
          CinboxCtrl.newAttachments = $scope.attachmentfiles;
          CinboxCtrl.actvity = actvity;
          CinboxCtrl.selectedWorkitemInfo = $scope.workitemInfo;
          console.log(CinboxCtrl.actvity)
          if (CinboxCtrl.actvity.buttonText == "Reject") {
              var confirm = $mdDialog.confirm()
                  .title()
                  .textContent('Do you want to Reject?')
                  // .targetEvent(ev)
                  .ok('Yes')
                  .cancel('NO');
              $mdDialog.show(confirm).then(function() {
                  $mdDialog.show({
                      controller: ProcessController,
                      templateUrl: 'app/main/mycontent/inbox/add.comment.html',
                      parent: angular.element(document.body),
                      targetEvent: ev,
                      clickOutsideToClose: true,
                      fullscreen: $scope.customFullscreen
                  });
              })
          } else {
              $mdDialog.show({
                  controller: ProcessController,
                  templateUrl: 'app/main/mycontent/inbox/add.comment.html',
                  parent: angular.element(document.body),
                  targetEvent: ev,
                  clickOutsideToClose: true,
                  fullscreen: $scope.customFullscreen
              });
          }
      }

      function ProcessController($scope, $mdDialog) {
          $scope.popupHeading = CinboxCtrl.actvity.buttonText;
          $scope.cancel = function() {
              $mdDialog.cancel();
          }
          $scope.count = 1;
          $scope.process = function(ev, comment) {
              delete CinboxCtrl.actvity.$$hashKey;
              var json = {
                  activities: []
              };
              json.comment = comment;
              json.activities.push(CinboxCtrl.actvity);
              json.header = CinboxCtrl.selectedWorkitemInfo.header;
              json.lineItems = CinboxCtrl.selectedWorkitemInfo.lineItems;
              angular.forEach(json.lineItems, function(key, value) {
                  delete key.lineItems.$$hashKey;
              })
              if (CinboxCtrl.newAttachments.length == 0) CinboxCtrl.newAttachments = [];
              $scope.allAttachments = CinboxCtrl.newAttachments;
              if ($scope.count == 1) {
                  $scope.count = $scope.count + 1;
                  RestAPIService.submitRequestResource(CinboxCtrl.selectedWorkitemInfo.requestId, CinboxCtrl.selectedWorkitemInfo.requestType,
                      json, $scope.allAttachments).then(
                      function(success) {
                          if (CinboxCtrl.actvity.buttonText == 'Approve') {
                              CinboxCtrl.actvity.buttonText = 'Approved';
                          } else if (CinboxCtrl.actvity.buttonText == 'Reject') {
                              CinboxCtrl.actvity.buttonText = 'Rejected';
                          }
                          $mdDialog.show(
                              $mdDialog.alert()
                              .parent(angular.element(document.querySelector('#popupContainer')))
                              .clickOutsideToClose(true)
                              .title('Success.')
                              .htmlContent("<h4><b>" + CinboxCtrl.selectedWorkitemInfo.requestId + "</b> has been " + CinboxCtrl.actvity.buttonText + "</h4>")
                              .ariaLabel('Alert Dialog Demo')
                              .ok('Ok')
                          );
                          $mdDialog.cancel();
                          $state.go('app.coromandelinbox');
                      },
                      function(error) {})
              } else {

              }

          }
      }
      // Collaborte call.
      $scope.collaborate = function(ev, activity) {
          CinboxCtrl.selectedWorkitemInfo = $scope.workitemInfo;
          CinboxCtrl.attachmentfiles = $scope.attachmentfiles;
          CinboxCtrl.CollaborateActivity = activity;
          $mdDialog.show({
              controller: CollaborateDialogController,
              controllerAs: 'ctrl',
              templateUrl: 'app/main/coromandel_inbox/c_inbox/c_collaborate.html',
              parent: angular.element(document.body),
              targetEvent: ev,
              clickOutsideToClose: true,
              fullscreen: $scope.customFullscreen
          });
      }

      function CollaborateDialogController($scope, RestAPIService, $mdDialog, $rootScope) {
          $scope.count = 1;
          $scope.users = CinboxCtrl.users;
          $scope.sampleheader = {};
          $scope.cancel = function() {
              $mdDialog.cancel();
          };

          $scope.SAPcollaboration = function() {
              console.log("first")
              $scope.sampleheader = {};
              $scope.sapTab = true;
              $scope.name = CinboxCtrl.selectedWorkitemInfo.createdBy.toLowerCase();




          }

          $scope.generateDataForCollaboration = function() {
              var select = false;
              if ($scope.sampleheader.person) {
                  var user = $scope.sampleheader.person;
                  $scope.users.forEach(function(elm) {
                      if (elm.login === $scope.sampleheader.person) {
                          select = true;
                      }
                  })
              }

              if (!select && !$scope.sapTab) {
                  $scope.errormsg = "Please Select the user from Dropdown"
                  return;
              }


              // Collaborated User is not selected.
              if (!$scope.sampleheader.person) {
                  if ($scope.name) {
                      // This is SAP Collaboration
                      var user = $scope.name;
                      CinboxCtrl.CollaborateActivity.actvity = "550"


                  } else {

                      // This is Collaboration with company user
                      // TODO = Show error message to select collaborated user
                  }

              }

              var workItem = CinboxCtrl.selectedWorkitemInfo;
              var requestId = workItem.requestId;
              var activity = CinboxCtrl.CollaborateActivity;
              delete activity.$$hashKey;
              var json = {
                  activities: []
              };
              json.comment = $scope.comment;
              json.activities.push(activity);
              json.header = workItem.header;
              // json.lineItems = workItem.lineItems;
              var form = new FormData();
              if (!CinboxCtrl.attachmentfiles) CinboxCtrl.attachmentfiles = [];
              $scope.newAttachments = workItem.attachments.concat(CinboxCtrl.attachmentfiles);
              for (var prop in $scope.newAttachments) {
                  form.append('files', $scope.newAttachments[prop]);
              }


              if ($scope.count == 1) {
                  $scope.showLoadingIcon = true;
                  $scope.count = $scope.count + 1;
                  RestAPIService.sendCollaboration(requestId, workItem.requestType, user, json, form).then(
                      function(response) {
                          $scope.showLoadingIcon = false;
                          $mdDialog.show(
                              $mdDialog.alert()
                              .parent(angular.element(document.querySelector('#popupContainer')))
                              .clickOutsideToClose(true)
                              .title('Success.')
                              .htmlContent("<h4>Collaboration sent successful for <b>" + workItem.requestId + "</b>.</h4>")
                              .ariaLabel('Alert Dialog Demo')
                              .ok('Ok'));
                          $state.go('app.coromandelinbox');
                      },
                      function(error) {
                          $scope.showLoadingIcon = false;
                          // RestAPIService.showErrorDialog(error);
                      });
              }

          }
          $scope.collaborateActivity = function(ev, user, comment) {
              // Collaborated User is selected. 
              // TODO = Validate collaborated user is valid
              $scope.comment = comment;
              $scope.generateDataForCollaboration();
            //   if ($scope.sapTab == true) {
            //       //Check whether the user existing in the protal or not by passing createdBy field
            //       RestAPIService.getUservalidation($scope.name).then(
            //           function(success) {
            //               //Means ,user is created in the portal
            //               if (!success.data.login) {
            //                   $mdDialog.show(
            //                       $mdDialog.alert()
            //                       .parent(angular.element(document.querySelector('#popupContainer')))
            //                       .clickOutsideToClose(true)
            //                       .title()
            //                       .htmlContent("<h4>Initiator id doesn’t exist in Portal</h4><h4>Please contact administrator</h4>")
            //                       .ariaLabel('Alert Dialog Demo')
            //                       .ok('Ok'));
            //                   return;
            //               } else {
            //                   $scope.generateDataForCollaboration();
            //               }
            //           })
            //   } else {
            //       $scope.generateDataForCollaboration();
            //   }




          }
      }
      $scope.collaborateBack = function(ev, activity) {
          $scope.showLoadingIcon = false;
          CinboxCtrl.attachmentfiles = $scope.attachmentfiles;
          CinboxCtrl.selectedWorkitemInfo = $scope.workitemInfo;
          CinboxCtrl.collabratebackactivity = activity;
          $mdDialog.show({
              controller: CollaborateBackDialogController,
              templateUrl: 'app/main/mycontent/inbox/collaborateBackDialog.html',
              parent: angular.element(document.body),
              targetEvent: ev,
              clickOutsideToClose: true,
              fullscreen: $scope.customFullscreen
          });
      }

      function CollaborateBackDialogController($scope, $mdDialog, RestAPIService) {
          $scope.cancel = function() {
              $mdDialog.cancel();
          };
          $scope.count = 1;

          $scope.collaborateBackComment = function(ev, comment) {
              var workItem = CinboxCtrl.selectedWorkitemInfo;
              var requestId = workItem.requestId;
              $scope.showLoadingIcon = true;
              var actvity = CinboxCtrl.collabratebackactivity;
              delete actvity.$$hashKey;
              var json = {
                  activities: []
              };
              json.comment = comment;
              json.activities.push(actvity);
              json.header = workItem.header;
              // json.lineItems = workItem.lineItems;
              var form = new FormData();
              if (!CinboxCtrl.attachmentfiles) CinboxCtrl.attachmentfiles = [];
              if (CinboxCtrl.attachmentfiles) {
                  $scope.newAttachments = workItem.attachments.concat(CinboxCtrl.attachmentfiles);
                  for (var prop in $scope.newAttachments) {
                      form.append('files', $scope.newAttachments[prop]);
                  }
              }
              var user = null;
              if ($scope.count == 1) {
                  $scope.count = $scope.count + 1;
                  RestAPIService.sendCollaboration(requestId, workItem.requestType, user, json, form).then(
                      function(response) {
                          $scope.showLoadingIcon = false;
                          $mdDialog.show(
                              $mdDialog.alert()
                              .parent(angular.element(document.querySelector('#popupContainer')))
                              .clickOutsideToClose(true)
                              .title('Success.')
                              .htmlContent("<h4>Collaboration back is successful for <b>" + workItem.requestId + "</b>.</h4>")
                              .ariaLabel('Alert Dialog Demo')
                              .ok('Ok')
                          );
                          $state.go('app.coromandelinbox');
                          $mdDialog.cancel();
                      },
                      function(error) {
                          $scope.showLoadingIcon = false;
                          // RestAPIService.showErrorDialog(error);
                      });
              } else {

              }



          }
      }
      $scope.deleteAttachedFile = function(attachment, requestid) {
          CinboxCtrl.archiveId = attachment.archiveId;
          CinboxCtrl.archiveDocId = attachment.archiveDocId;
          CinboxCtrl.requestId = requestid
          console.log(CinboxCtrl)
          var confirm = $mdDialog.confirm()
              .title('Remove')
              .textContent('The Attachment will be permanently deleted.')
              // .targetEvent(ev)
              .ok('Ok')
              .cancel('Cancel');
          $mdDialog.show(confirm).then(function() {

                  $mdDialog.show({
                      controller: deleteAttachmentsDialogController,
                      templateUrl: 'app/main/coromandel_inbox/c_inbox/deleteAttachments.html',
                      parent: angular.element(document.body),
                      clickOutsideToClose: true,
                      fullscreen: $scope.customFullscreen
                  })

                  function deleteAttachmentsDialogController($scope, $mdDialog, RestAPIService) {
                      $scope.deleteattachment = function(comment) {

                          RestAPIService.deleteFormAttachments(CinboxCtrl.archiveId, CinboxCtrl.requestId, CinboxCtrl.archiveDocId, comment).then(
                              function(response) {
                                  $scope.attachment = response.data
                                  $mdDialog.show(
                                      $mdDialog.alert()
                                      .parent(angular.element(document.querySelector('#popupContainer')))
                                      .clickOutsideToClose(true)
                                      .title('Success.')
                                      .htmlContent("<h4>Deleted Sucessfully</h4>")
                                      .ariaLabel('Alert Dialog Demo')
                                      .ok('Ok')
                                  );
                                  $state.reload();
                                  $mdDialog.cancel();
                              },
                              function(error) {
                                  RestAPIService.showErrorDialog(error);
                              });
                      }
                      $scope.cancel = function() {
                          $mdDialog.cancel();
                      }
                  }

              },

              function() {
                  $mdDialog.cancel();
              });
      }
      $scope.gotoOrderDetail = function(id) {
          $state.go('app.coromandelinbox.detail', {
              id: id
          });




      }
      $scope.gotoOrders = function() {
          $state.go('app.coromandelinbox');
      }




      // select all option
      //  $scope.selected = [];

      //  $scope.checkuncheckWorkitems = function (workitem, list) {
      //    var idx = list.indexOf(workitem);
      //    if (idx > -1) {
      //      list.splice(idx, 1);
      //    }
      //    else {
      //      list.push(workitem);
      //    }
      //    DraftABPCtrl.selectItems = list;
      //  };

      //  $scope.exists = function (workitem, list) {
      //    return list.indexOf(workitem) > -1;
      //  };

      //  $scope.isIndeterminate = function () {
      //    return ($scope.selected.length !== 0 &&
      //      $scope.selected.length !== $scope.ABPDraftData.length);
      //  }


      //  $scope.checkuncheckAllWorkitems = function () {
      //    if ($scope.ABPDraftData == undefined) $scope.ABPDraftData = [];
      //    return $scope.selected.length === $scope.ABPDraftData.length;

      //  };


      //  $scope.selectAll = function () {
      //    if ($scope.selected.length === $scope.ABPDraftData.length) {
      //      $scope.selected = [];
      //      DraftABPCtrl.selectItems = $scope.selected;
      //    } else if ($scope.selected.length === 0 || $scope.selected.length > 0) {
      //      $scope.selected = $scope.ABPDraftData.slice(0);
      //      DraftABPCtrl.selectItems = $scope.selected;
      //    }
      //  }


      // RestAPIService.getAllInboxWorkitems($stateParams.requestType,
      //   $scope.pageNumber, 1000).then(function(success) {
      // $scope.allWorkitems = success.data;
      // console.log( $scope.allWorkitems )
      // }, function(error) {
      // RestAPIService.showErrorDialog(error);
      // });


  }



})();
 (function() {
     'use strict';
     angular
         .module('app.businessadmin')
         .controller('BusinessUserController', BusinessUserController);

     function BusinessUserController($state, $http, $scope, $mdDialog, RestAPIService) {
         var businessUserCtrl = this;
        $scope.orderByField = 'login';
        $scope.reverseSort = false;
        // $scope.usersList = BusinessUsers.data;
        // $scope.count = BusinessUsers.data.length;       
         businessUserCtrl.user = {};       
       businessUserCtrl.dtOptions = {
        		 
    		   dom: '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
	            pagingType: 'simple',
	            autoWidth : false,
	            responsive: true

//                 dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
//                     columnDefs: [
//
//                         { // Target the actions column
//                             targets: 6,
//                             responsivePriority: 1,
//                             filterable: false,
//                             sortable: false
//                         }
//                     ],
//
//                     pagingType: 'simple',
//                     lengthMenu: [10, 20, 30, 50, 100],
//                     pageLength: 20
//                         // scrollY     : 'auto',
//                         //responsive  : true
                 }; 
         businessUserCtrl.goToadmin =function(){
        	 $state.go('app.businessadmin.content');
         }
         businessUserCtrl.getUsers = function() {
             RestAPIService.getUsers().then(
                 function(success) {
                     $scope.usersList = success.data;
                     $scope.count = $scope.usersList.length;
                 },
                 function(error) {
                     RestAPIService.showErrorDialog(error);
                 }
             );
             //return businessUserCtrl.usersList;
         }


         //$scope.allUsers = Users.data; 
         
       /*  businessUserCtrl.pageNumber = 0;
         businessUserCtrl.pageSize = 10;
         businessUserCtrl.next = function() {
        	 businessUserCtrl.pageNumber = businessUserCtrl.pageNumber + 1;
        	getuserdata();
         }
         businessUserCtrl.previous = function() {
        	 businessUserCtrl.pageNumber = businessUserCtrl.pageNumber - 1;
        	 getuserdata();
         }
         $scope.sendPageNumber = function(pageNumber) {
        	 businessUserCtrl.pageNumber = pageNumber;
        	getuserdata();
         }
         
         function getuserdata(){
        	RestAPIService.getUsersbysize(businessUserCtrl.pageNumber,businessUserCtrl.pageSize).then(
        	function(success){
        		$scope.usersList = success.data;
        		businessUserCtrl.numberOfElements = success.headers('x-total-count');
                $scope.noOfPages = businessUserCtrl.numberOfElements / businessUserCtrl.pageSize;
                $scope.pageNumbers = [];
                if ($scope.noOfPages > 0) {
                    for (var i = 0; i < $scope.noOfPages; i++) {
                        $scope.pageNumbers.push(i);
                    }
                }
        	},
        	 function(error) {
                RestAPIService.showErrorDialog(error);
            });
        }*/
         $scope.createUserDialog = function(ev) {
             $mdDialog.show({
                 controller: CreateUserDialogController,
                 templateUrl: 'app/main/business-admin/business-usermanagement/create.businessuser.dialog.html',
                 parent: angular.element(document.body),
                 targetEvent: ev,
                 clickOutsideToClose: true,
                 fullscreen: $scope.customFullscreen
             })
             $scope.cancel = function() {
                 $scope.user = {};
             };
         };


         function CreateUserDialogController($scope, $mdDialog) {
             $scope.status = ["True", "False"];
             $scope.roles = ["ROLE_USER", "ROLE_ADMIN","ROLE_TICKETMANAGER","ROLE_AUDITOR"];
             $scope.user={};
             $scope.user.activated=false;
            // $scope.re = /^[a-z0-9._%+-]+@(yahoo\.com|gmail\.com|msn\.com|hotmail\.com|actiprocess\.com|smartdocsnow\.com|live\.com)/
             $scope.re = /^[a-z]+[a-z0-9._%+-/]+@[a-z]+\.[a-z.]{2,5}$/;
             $scope.hide = function() {
                 $mdDialog.hide();
             };
             $scope.cancel = function() {
                 $mdDialog.cancel();
             };
             $scope.passwordLength = 12;
             $scope.addUpper = true;
             $scope.addNumbers = true;
             $scope.addSymbols = true;

             function getRandomInt(min, max) {
               return Math.floor(Math.random() * (max - min + 1)) + min;
             }

             function shuffleArray(array) {
               for (var i = array.length - 1; i > 0; i--) {
                 var j = Math.floor(Math.random() * (i + 1));
                 var temp = array[i];
                 array[i] = array[j];
                 array[j] = temp;
               }
               return array;
             }
             $scope.createPassword = function() {
               var lowerCharacters = ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z'];
               var upperCharacters = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];
               var numbers = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
               var symbols = ['!', '#', '$', '%', '&', '\'', '(', ')', '*', '+', ',', '-', '.', '/', ':', ';', '<', '=', '>', '?', '@', '[', '\\', ']', '^', '_', '`', '{', '|', '}', '~'];
               var noOfLowerCharacters = 0,
                 noOfUpperCharacters = 0,
                 noOfNumbers = 0,
                 noOfSymbols = 0;
               var noOfneededTypes = $scope.addUpper + $scope.addNumbers + $scope.addSymbols;
               var noOfLowerCharacters = getRandomInt(1, $scope.passwordLength - noOfneededTypes);
               var usedTypeCounter = 1;
               if ($scope.addUpper) {
                 noOfUpperCharacters = getRandomInt(1, $scope.passwordLength - noOfneededTypes + usedTypeCounter - noOfLowerCharacters);
                 usedTypeCounter++;
               }
               if ($scope.addNumbers) {
                 noOfNumbers = getRandomInt(1, $scope.passwordLength - noOfneededTypes + usedTypeCounter - noOfLowerCharacters - noOfUpperCharacters);
                 usedTypeCounter++;
               }
               if ($scope.addSymbols) {
                 noOfSymbols = $scope.passwordLength - noOfLowerCharacters - noOfUpperCharacters - noOfNumbers;
               }
               var passwordArray = [];
               for (var i = 0; i < noOfLowerCharacters; i++) {
                 passwordArray.push(lowerCharacters[getRandomInt(1, lowerCharacters.length - 1)]);
               }
               for (var i = 0; i < noOfUpperCharacters; i++) {
                 passwordArray.push(upperCharacters[getRandomInt(1, upperCharacters.length - 1)]);
               }
               for (var i = 0; i < noOfNumbers; i++) {
                 passwordArray.push(numbers[getRandomInt(1, numbers.length - 1)]);
               }
               for (var i = 0; i < noOfSymbols; i++) {
                 passwordArray.push(symbols[getRandomInt(1, symbols.length - 1)]);
               }
               passwordArray = shuffleArray(passwordArray);
               return passwordArray.join("");
             };
             $scope.password=$scope.createPassword();
             $scope.mypassword = "";
             $scope.showPassword = function(){
               $scope.mypassword = $scope.password;  
             };
             
         
             
          // Set the default value of inputType
             $scope.inputType = 'password';
             
             // Hide & show password function
             $scope.hideShowPassword = function(){
               if ($scope.inputType == 'password')
                 $scope.inputType = 'text';
               else
                 $scope.inputType = 'password';
             };
             
             $scope.save = function(user) {            	 	
            	 RestAPIService.createUser(user).then(
                     function(success) {
                    	// RestAPIService.successTostDialog(success.headers('X-smartportalApp-alert'));
                    	 RestAPIService.successTostDialog("User Created Successfully");
                         $state.reload();
                     },
                     function(error) {
                    	 //alert(error.headers('X-smartportalApp-defaultMessage'));
                        RestAPIService.showErrorDialog(error);
                     }
                 );
                 $mdDialog.hide(user);
             };

         }
         businessUserCtrl.resetPassword = function(email) {
       	     // $scope.mailId=email;
        	// alert(email);
             RestAPIService.resetPassword(email).then(
                 function(success) {
                	 //RestAPIService.successTostDialog("Reset link sent to emailId successfully");
                	 alert("Reset link sent to emailId successfully");
                     $state.reload();
                    
                 },
                 function(error) {
                     RestAPIService.showErrorDialog(error);
                 }
             );
             $mdDialog.hide();
        
     }
         businessUserCtrl.currentUser = {};
         $scope.updateUserDialog = function(ev, user) {
             businessUserCtrl.currentUser = angular.copy(user);
             $mdDialog.show({
                 controller: UpdateUserDialogController,
                 templateUrl: 'app/main/business-admin/business-usermanagement/update.businessuser.dialog.html',
                 parent: angular.element(document.body),
                 targetEvent: ev,
                 clickOutsideToClose: true,
                 fullscreen: $scope.customFullscreen
             })
         };

         function UpdateUserDialogController($scope, $mdDialog) {
             $scope.status = ["true", "false"];
             $scope.roles = ["ROLE_USER", "ROLE_ADMIN","ROLE_TICKETMANAGER","ROLE_AUDITOR"];
             $scope.currentUser = businessUserCtrl.currentUser;

             $scope.hide = function() {
                 $mdDialog.hide();
             };
             $scope.cancel = function() {
                 $mdDialog.cancel();
             };
             $scope.update = function(user) {
                 RestAPIService.updateUser(user).then(
                     function(success) {
                    	 RestAPIService.successTostDialog("User Details Updated Successfully");
                    	// RestAPIService.successTostDialog(success.headers('X-smartportalApp-alert'));
                         $state.reload();
                     },
                     function(error) {
                         RestAPIService.showErrorDialog(error);
                     }
                 );
                 $mdDialog.hide(user);
             };
         }

         businessUserCtrl.deleteUser = function(ev, user) {
             var confirm = $mdDialog.confirm()
                 .title('Remove')
                 .textContent('User ' + user.firstName + ' ' + user.lastName + ' will be permanently deleted. Continue ?')
                 .targetEvent(ev)
                 .ok('Ok')
                 .cancel('Cancel');
             $mdDialog.show(confirm).then(function() {

                 RestAPIService.deleteUser(user.login).then(
                     function(success) {
                    	// RestAPIService.successTostDialog(success.headers('X-smartportalApp-alert'));
                    	 RestAPIService.successTostDialog("User Deleted Successfully");
                         $state.reload();
                     },
                     function(error) {
                         RestAPIService.showErrorDialog(error);
                     }
                 );
             }, function() {
                 $mdDialog.cancel();
             });
         }
        function init(){
        	// getuserdata();
        	 businessUserCtrl.getUsers();
         }
         init();

     }
 })();
(function() {
    'use strict';

    angular
        .module('app.businessadmin')
        .controller('BusinessTemplateController', BusinessTemplateController);

    /** @ngInject */
    function BusinessTemplateController($state, $scope, $mdDialog, RestAPIService,DocumentTypes,Templates) {
        var businessTemplateCtrl = this;
       $scope.templates =Templates.data;       
     
        businessTemplateCtrl.dtOptions = { 
       		 dom       : '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
	            pagingType: 'simple',
	            autoWidth : false,
	            responsive: true
        };
       
       /* $scope.getTemplates = function() {
            RestAPIService.getTemplates().then(
                function(success) { 
                	console.log(success.data);
                     },
                function(error) {
                    RestAPIService.showErrorDialog(error);
                });
        };*/
        
        businessTemplateCtrl.goToadmin =function (){
        	 $state.go('app.businessadmin');
        }
        $scope.templateDelete = function(template){
        	 var confirm = $mdDialog.confirm()
             .title('Remove')
             .textContent('DocumentType Template ' + template.name + ' ' + ' will be permanently deleted. Continue ?')
             .ok('Ok')
             .cancel('Cancel');
         $mdDialog.show(confirm).then(function() {
        	RestAPIService.DeleteTemplate(template.id).then(
                    function(success) {
                       RestAPIService.successTostDialog("Template Deleted successfully ");
                      $state.reload();
                    },
                    function(error) {
                        RestAPIService.showErrorDialog(error);
                    }
                );
                $mdDialog.hide();
        	
         });
        
    }
        $scope.createTemplateDialog = function(ev) {
            $mdDialog.show({
                controller: createTemplateDialogController,
                templateUrl: 'app/main/business-admin/business-templates/create.businesstemplate.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: $scope.customFullscreen
            })
            $scope.cancel = function() {

            };
        };
        function createTemplateDialogController($scope, $mdDialog, RestAPIService,$state) {
        	$scope.Documents =DocumentTypes.data;
           /* console.log($scope.Documents);*/
        	
        	  var formData = new FormData();
        	 $scope.setFile = function(element) {
                 $scope.$apply(function() {
                     $scope.files = [];
                     for (var i = 0; i < element.files.length; i++) {
                         formData.append('file', element.files[i]);
                         $scope.files.push(element.files[i]);
                         //console.log($scope.files);
                     }
                 });
             };
            $scope.hide = function() {
                $mdDialog.hide();
            };
           
            $scope.cancel = function() {
                $mdDialog.cancel();
            };
            $scope.save = function(ev,template) {            	
            	RestAPIService.CreateTemplate(template, $scope.files[0]).then(
                        function(success) {
                           RestAPIService.successTostDialog("Template uploaded successfully ");
                          $state.reload();
                        },
                        function(error) {
                            RestAPIService.showErrorDialog(error);
                        }
                    );
                    $mdDialog.hide(ev);
            	    
            };
        }
        
         businessTemplateCtrl.currentTemplate = {};
        $scope.updateTemplateDialog = function(ev,template) {
        
             businessTemplateCtrl.currentTemplate = angular.copy(template);
            $mdDialog.show({
                controller: updateTemplateDialogController,
                templateUrl: 'app/main/business-admin/business-templates/update.businesstemplate.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: $scope.customFullscreen
            })
        };
        function updateTemplateDialogController($scope, $mdDialog) {
        	$scope.Documents =DocumentTypes.data;
        	  var formData = new FormData();
         	 $scope.setFile = function(element) {
                  $scope.$apply(function() {
                      $scope.files = [];
                      for (var i = 0; i < element.files.length; i++) {
                          formData.append('file', element.files[i]);
                          $scope.files.push(element.files[i]);
                          //console.log($scope.files);
                      }
                  });
              };
            $scope.currentTemplate =  businessTemplateCtrl.currentTemplate;
            //alert(JSON.stringify( $scope.currentTemplate));

            $scope.hide = function() {
                $mdDialog.hide();
            };
            $scope.cancel = function() {
                $mdDialog.cancel();
            };
            $scope.update = function(ev,template) {
            	//console.log(template);
            	RestAPIService.UpdateTemplate(template, $scope.files[0]).then(
                        function(success) {
                           RestAPIService.successTostDialog("Template updated successfully ");
                          $state.reload();
                        },
                        function(error) {
                            RestAPIService.showErrorDialog(error);
                        }
                    );
                    $mdDialog.hide(ev);
            	
            };
        }
       
        
        $scope.previewFile = function(ev) {
     	   $mdDialog.show({
     	      controller: DialogController,
     	      templateUrl: 'app/main/business-admin/business-templates/businesstemplate.preview.html',
     	      parent: angular.element(document.body),
     	      targetEvent: ev,
     	      clickOutsideToClose:true
     	    });
         }
         
         function DialogController($scope, $mdDialog, $sce) {
         	
         }
       
     
       
    }
})();
(function() {
    'use strict';

    angular
        .module('app.businessadmin')
        .controller('BusinessPurchaseController', BusinessPurchaseController);

    /** @ngInject */
    function BusinessPurchaseController($state, $scope, $mdDialog, RestAPIService) {
        var PurchaseCtrl = this;       
       
        PurchaseCtrl.dtOptions = {
                dom: '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
                pagingType: 'simple',
                autoWidth: false,
                responsive: true
        };
        $scope.goToPreviousState = function(){
        	$state.go('app.businessadmin');
        }
        
        var list = "PurchaseOrg";
        $scope.inputfield = new Array();
        $scope.List =function(){
        	RestAPIService.getdetaildata(list).then(
    				function(success){     				
    					$scope.EmployeesList =success.data;
    				 	angular.forEach($scope.EmployeesList, function(value, key) {
    				 		 $scope.employeelist = value;
    				 		angular.forEach( $scope.employeelist, function(value, key) {
    				 			if ($.inArray((key), $scope.inputfield) === -1){
    	                   			 if(key!=null && key !=undefined)
    	                   			 $scope.inputfield.push(key);
    	                   		 }
    				 		});
                  		});
    				},function(error){
    					RestAPIService.showErrorDialog(error);
    				});
        
        }
        
            $scope.createEmployee = function(ev) {
            	PurchaseCtrl.employeeinputdata = $scope.inputfield;
            	PurchaseCtrl.listname = list;
                $mdDialog.show({
                    controller: EmployeeMaincontroller,
                    templateUrl: 'app/main/business-admin/business-purchaseorg/create.purchaseorg.dialog.html', 
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    fullscreen: $scope.customFullscreen
                })
            };
            
            $scope.updateEmployee = function(ev, detaildata) {
            	PurchaseCtrl.updatedata = detaildata;
            	PurchaseCtrl.listname = list;
                  $mdDialog.show({
                      controller: UpdateEmployeecontroller,
                      templateUrl: 'app/main/business-admin/business-purchaseorg/update.purchaseorg.dialog.html',
                      parent: angular.element(document.body),
                      targetEvent: ev,
                      fullscreen: $scope.customFullscreen
                  })
              };
              
              
              $scope.deletedata = function(ev, data){
                  var confirm = $mdDialog.confirm()
                      .title('Remove')
                      .textContent('PurchaseOrg will be permanently deleted. Continue ?')
                      .targetEvent(ev)
                      .ok('Ok')
                      .cancel('Cancel');
                  $mdDialog.show(confirm).then(function() {

                	  RestAPIService.deletedata(data._id,list).then(
                              function(success) {
                                  RestAPIService.successTostDialog("Deleted successfully");
                                  $state.reload();
                              },
                              function(error) {
                                  RestAPIService.showErrorDialog(error);
                              }
                          );
                  }, function() {
                      $mdDialog.cancel();
                  });
              }
              function UpdateEmployeecontroller($scope, $mdDialog){
            	  $scope.currentdata = PurchaseCtrl.updatedata;
            	  $scope.updateddata = [];
           	   var udata =[];
           	   var pmap = {};
                  $scope.hide = function() {
                      $mdDialog.hide();
                  };
                  $scope.cancel = function() {
                      $mdDialog.cancel();
                  };

            	   var valarr = [];
                  $scope.updatedata = function() {
                   angular.forEach($scope.currentdata, function(value, key){
          	      valarr.push(key);
          	      });
         		  for(var i=0; i<$scope.updateddata.length; i++){
          			  if(valarr[i] !="_id"){
          				pmap[valarr[i]] = $scope.updateddata[i];
          			  }
            		} 
                   udata.push({"productMap":pmap});
                   $scope.arrsend = udata[0];
                   $scope.arrsend.id = $scope.updateddata[0];
                   $scope.arrsend.name = PurchaseCtrl.listname;
                      RestAPIService.updatedyData($scope.arrsend).then(
                          function(success) {
                              RestAPIService.successTostDialog("Updated successfully");
                              $state.reload();
                          },
                          function(error) {
                              RestAPIService.showErrorDialog(error);
                          }
                      );
                      $mdDialog.hide(udata);
                  };
                  
              }
              
            function EmployeeMaincontroller($scope, $mdDialog){
            	$scope.attrdata = PurchaseCtrl.employeeinputdata;
            	$scope.listname = PurchaseCtrl.listname;
            	$scope.crlist=[];
            	   $scope.cancel = function() {
                       $mdDialog.cancel();
                   };
                   
                   
                   
                   $scope.save =function(){
                 	  var t = $scope.attrdata;
                 	  var uniqueNames=[];
                 	  var uniqueNames1 = [];
                 	  var obj ={};
                 	  var ary=[];
                 	  for(var i=1; i<t.length; i++){
                 		  obj[t[i]] = $scope.crlist[i].list;
                 		}
                       
                 	  ary.push({"productMap":obj});
                 	  ary.name = $scope.attrdata.name;
                        $scope.arr1 = ary[0];
                        $scope.arr1.name = $scope.listname;
                       RestAPIService.createdetail($scope.arr1).then(
                               function(success) {
                            	   RestAPIService.successTostDialog("Created successfully");
                                   $state.reload();
                               },
                               function(error) {
                                   RestAPIService.showErrorDialog(error);
                               }
                           );
                           $mdDialog.hide();
                          
                   }
            }
            
        $scope.init = function(){
        	$scope.List();
        }
       
       
      $scope.init();
        
       
         
       
     
       
    }
})();
(function() {
    'use strict';

    angular
        .module('app.businessadmin')
        .controller('BusinessPortletController', BusinessPortletController);

    /** @ngInject */
    function BusinessPortletController($state, $scope, $mdDialog, RestAPIService, AllPortlets) {
        var portletCtrl = this;       
        $scope.allPortlets = AllPortlets.data;
        portletCtrl.dtOptions = {
                dom: '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
                pagingType: 'simple',
                autoWidth: false,
                responsive: true
        };
        $scope.goToPreviousState = function(){
        	$state.go('app.businessadmin');
        }
        $scope.createPortletDialog = function(ev){
        	$mdDialog.show({
                controller: createPortletDialogController,
                templateUrl: 'app/main/business-admin/business-portlets/create.portlet.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: $scope.customFullscreen
            })
        }
        function createPortletDialogController($scope, $mdDialog){
        	$scope.cancel = function(){
        		$mdDialog.cancel();
        	}
        	$scope.save = function(portletObj){
        		RestAPIService.savePortlet(portletObj).then(
        				function(responce){
        					RestAPIService.successTostDialog("Portlet was successfully created.");
        					$state.reload();
        					$mdDialog.cancel();
        				},function(error){
        					RestAPIService.showErrorDialog(error);
        				})
        	}        	
        }
        $scope.deletePortlet = function(ev, portletObj){
        	 var confirm = $mdDialog.confirm()
             .title('Remove')
             .textContent( portletObj.name + ' ' + ' will be permanently deleted. Continue ?')
             .targetEvent(ev)
             .ok('Ok')
             .cancel('Cancel');
        	 $mdDialog.show(confirm).then(function() {
        		 RestAPIService.deletePortlet(portletObj).then(
        			function(responce){
        				RestAPIService.successTostDialog("Portlet was successfully removed.");
        				$state.reload();        		
        			},function(error){
        					RestAPIService.showErrorDialog(error);
        			});
        	 },
        	 function() {
                 $mdDialog.cancel();
             });
        }
        $scope.updatePortletDialog = function(ev, portletObj){
        	portletCtrl.portlet= angular.copy(portletObj);
            $mdDialog.show({
                controller: updatePortletDialogController,
                templateUrl: 'app/main/business-admin/business-portlets/update.portlet.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: $scope.customFullscreen
            })
        }
        function updatePortletDialogController($scope, $mdDialog){
        	$scope.portlet = portletCtrl.portlet;
        	$scope.cancel = function(){
        		$mdDialog.cancel();
        	}
        	$scope.save = function(portletObj){
        		RestAPIService.updatePortlet(portletObj).then(
        				function(responce){
        					RestAPIService.successTostDialog("Portlet was successfully updated.");
        					$state.reload();
        					$mdDialog.cancel();
        				},function(error){
        					RestAPIService.showErrorDialog(error);
        				})
        	}
        }
        
       
         
       
     
       
    }
})();
(function() {
    'use strict';

    angular
        .module('app.businessadmin')
        .controller('BusinessPlantController', BusinessPlantController);

    /** @ngInject */
    function BusinessPlantController($state, $scope, $mdDialog, RestAPIService) {
        var plantCtrl = this;       
       
        plantCtrl.dtOptions = {
                dom: '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
                pagingType: 'simple',
                autoWidth: false,
                responsive: true
        };
        $scope.goToPreviousState = function(){
        	$state.go('app.businessadmin');
        }
        
        var list = "Plants";
       
        $scope.inputfield = new Array();
        $scope.List =function(){
        	RestAPIService.getdetaildata(list).then(
    				function(success){     				
    					$scope.CustomersList =success.data;
    				 	angular.forEach($scope.CustomersList, function(value, key) {
    				 		 $scope.customerlist = value;
    				 		angular.forEach( $scope.customerlist, function(value, key) {
    				 			if ($.inArray((key), $scope.inputfield) === -1){
    	                   			 if(key!=null && key !=undefined)
    	                   			 $scope.inputfield.push(key);
    	                   		 }
    				 		});
                  		});
    				},function(error){
    					RestAPIService.showErrorDialog(error);
    				});
        
        }
        
            $scope.createCustomer = function(ev) {
            	plantCtrl.customerinputdata = $scope.inputfield;
            	plantCtrl.listname = list;
                $mdDialog.show({
                    controller: CustomerMaincontroller,
                    templateUrl: 'app/main/business-admin/business-plants/create.plant.dialog.html', 
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    fullscreen: $scope.customFullscreen
                })
            };
            
            $scope.updateCustomer = function(ev, detaildata) {
            	plantCtrl.updatedata = detaildata;
            	plantCtrl.listname = list;
                  $mdDialog.show({
                      controller: UpdateCustomerscontroller,
                      templateUrl: 'app/main/business-admin/business-plants/update.plant.dialog.html',
                      parent: angular.element(document.body),
                      targetEvent: ev,
                      fullscreen: $scope.customFullscreen
                  })
              };
              
              
              $scope.deletedata = function(ev, data){
                  var confirm = $mdDialog.confirm()
                      .title('Remove')
                      .textContent('Plant will be permanently deleted. Continue ?')
                      .targetEvent(ev)
                      .ok('Ok')
                      .cancel('Cancel');
                  $mdDialog.show(confirm).then(function() {

                	  RestAPIService.deletedata(data._id,list).then(
                              function(success) {
                                  RestAPIService.successTostDialog("Deleted successfully");
                                  $state.reload();
                              },
                              function(error) {
                                  RestAPIService.showErrorDialog(error);
                              }
                          );
                  }, function() {
                      $mdDialog.cancel();
                  });
              }
              function UpdateCustomerscontroller($scope, $mdDialog){
            	  $scope.currentdata = plantCtrl.updatedata;
            	  $scope.updateddata = [];
           	   var udata =[];
           	   var pmap = {};
                  $scope.hide = function() {
                      $mdDialog.hide();
                  };
                  $scope.cancel = function() {
                      $mdDialog.cancel();
                  };

            	   var valarr = [];
                  $scope.updatedata = function() {
                   angular.forEach($scope.currentdata, function(value, key){
          	      valarr.push(key);
          	      });
         		  for(var i=0; i<$scope.updateddata.length; i++){
          			  if(valarr[i] !="_id"){
          				pmap[valarr[i]] = $scope.updateddata[i];
          			  }
            		} 
                   udata.push({"productMap":pmap});
                   $scope.arrsend = udata[0];
                   $scope.arrsend.id = $scope.updateddata[0];
                   $scope.arrsend.name = plantCtrl.listname;
                      RestAPIService.updatedyData($scope.arrsend).then(
                          function(success) {
                              RestAPIService.successTostDialog("Updated successfully");
                              $state.reload();
                          },
                          function(error) {
                              RestAPIService.showErrorDialog(error);
                          }
                      );
                      $mdDialog.hide(udata);
                  };
                  
              }
              
            function CustomerMaincontroller($scope, $mdDialog){
            	$scope.attrdata = plantCtrl.customerinputdata;
            	$scope.listname = plantCtrl.listname;
            	$scope.crlist=[];
            	   $scope.cancel = function() {
                       $mdDialog.cancel();
                   };
                   
                   
                   
                   $scope.save =function(){
                 	  var t = $scope.attrdata;
                 	  var uniqueNames=[];
                 	  var uniqueNames1 = [];
                 	  var obj ={};
                 	  var ary=[];
                 	  for(var i=1; i<t.length; i++){
                 		  obj[t[i]] = $scope.crlist[i].list;
                 		}
                       
                 	  ary.push({"productMap":obj});
                 	  ary.name = $scope.attrdata.name;
                        $scope.arr1 = ary[0];
                        $scope.arr1.name = $scope.listname;
                       RestAPIService.createdetail($scope.arr1).then(
                               function(success) {
                            	   RestAPIService.successTostDialog("Created successfully");
                                   $state.reload();
                               },
                               function(error) {
                                   RestAPIService.showErrorDialog(error);
                               }
                           );
                           $mdDialog.hide();
                          
                   }
            }
            
        $scope.init = function(){
        	$scope.List();
        }
       
       
      $scope.init();
        
       
         
       
     
       
    }
})();
(function() {
    'use strict';

    angular
        .module('app.businessadmin')
        .controller('BusinessEmployeeController', BusinessEmployeeController);

    /** @ngInject */
    function BusinessEmployeeController($state, $scope, $mdDialog, RestAPIService) {
        var employeeCtrl = this;       
       
        employeeCtrl.dtOptions = {
                dom: '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
                pagingType: 'simple',
                autoWidth: false,
                responsive: true
        };
        $scope.goToPreviousState = function(){
        	$state.go('app.businessadmin');
        }
        
        var list = "InvoiceTypes";
        $scope.inputfield = new Array();
        $scope.List =function(){
        	RestAPIService.getdetaildata(list).then(
    				function(success){     				
    					$scope.EmployeesList =success.data;
    				 	angular.forEach($scope.EmployeesList, function(value, key) {
    				 		 $scope.employeelist = value;
    				 		angular.forEach( $scope.employeelist, function(value, key) {
    				 			if ($.inArray((key), $scope.inputfield) === -1){
    	                   			 if(key!=null && key !=undefined)
    	                   			 $scope.inputfield.push(key);
    	                   		 }
    				 		});
                  		});
    				},function(error){
    					RestAPIService.showErrorDialog(error);
    				});
        
        }
        
            $scope.createEmployee = function(ev) {
            	employeeCtrl.employeeinputdata = $scope.inputfield;
            	employeeCtrl.listname = list;
                $mdDialog.show({
                    controller: EmployeeMaincontroller,
                    templateUrl: 'app/main/business-admin/business-invoicetypes/create.invoicetype.dialog.html', 
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    fullscreen: $scope.customFullscreen
                })
            };
            
            $scope.updateEmployee = function(ev, detaildata) {
            	employeeCtrl.updatedata = detaildata;
            	employeeCtrl.listname = list;
                  $mdDialog.show({
                      controller: UpdateEmployeecontroller,
                      templateUrl: 'app/main/business-admin/business-invoicetypes/update.invoicetype.dialog.html',
                      parent: angular.element(document.body),
                      targetEvent: ev,
                      fullscreen: $scope.customFullscreen
                  })
              };
              
              
              $scope.deletedata = function(ev, data){
                  var confirm = $mdDialog.confirm()
                      .title('Remove')
                      .textContent('InvoiceType will be permanently deleted. Continue ?')
                      .targetEvent(ev)
                      .ok('Ok')
                      .cancel('Cancel');
                  $mdDialog.show(confirm).then(function() {

                	  RestAPIService.deletedata(data._id,list).then(
                              function(success) {
                                  RestAPIService.successTostDialog("Deleted successfully");
                                  $state.reload();
                              },
                              function(error) {
                                  RestAPIService.showErrorDialog(error);
                              }
                          );
                  }, function() {
                      $mdDialog.cancel();
                  });
              }
              function UpdateEmployeecontroller($scope, $mdDialog){
            	  $scope.currentdata = employeeCtrl.updatedata;
            	  $scope.updateddata = [];
           	   var udata =[];
           	   var pmap = {};
                  $scope.hide = function() {
                      $mdDialog.hide();
                  };
                  $scope.cancel = function() {
                      $mdDialog.cancel();
                  };

            	   var valarr = [];
                  $scope.updatedata = function() {
                   angular.forEach($scope.currentdata, function(value, key){
          	      valarr.push(key);
          	      });
         		  for(var i=0; i<$scope.updateddata.length; i++){
          			  if(valarr[i] !="_id"){
          				pmap[valarr[i]] = $scope.updateddata[i];
          			  }
            		} 
                   udata.push({"productMap":pmap});
                   $scope.arrsend = udata[0];
                   $scope.arrsend.id = $scope.updateddata[0];
                   $scope.arrsend.name = employeeCtrl.listname;
                      RestAPIService.updatedyData($scope.arrsend).then(
                          function(success) {
                              RestAPIService.successTostDialog("Updated successfully");
                              $state.reload();
                          },
                          function(error) {
                              RestAPIService.showErrorDialog(error);
                          }
                      );
                      $mdDialog.hide(udata);
                  };
                  
              }
              
            function EmployeeMaincontroller($scope, $mdDialog){
            	$scope.attrdata = employeeCtrl.employeeinputdata;
            	$scope.listname = employeeCtrl.listname;
            	$scope.crlist=[];
            	   $scope.cancel = function() {
                       $mdDialog.cancel();
                   };
                   
                   
                   
                   $scope.save =function(){
                 	  var t = $scope.attrdata;
                 	  var uniqueNames=[];
                 	  var uniqueNames1 = [];
                 	  var obj ={};
                 	  var ary=[];
                 	  for(var i=1; i<t.length; i++){
                 		  obj[t[i]] = $scope.crlist[i].list;
                 		}
                       
                 	  ary.push({"productMap":obj});
                 	  ary.name = $scope.attrdata.name;
                        $scope.arr1 = ary[0];
                        $scope.arr1.name = $scope.listname;
                       RestAPIService.createdetail($scope.arr1).then(
                               function(success) {
                            	   RestAPIService.successTostDialog("Created successfully");
                                   $state.reload();
                               },
                               function(error) {
                                   RestAPIService.showErrorDialog(error);
                               }
                           );
                           $mdDialog.hide();
                          
                   }
            }
            
        $scope.init = function(){
        	$scope.List();
        }
       
       
      $scope.init();
        
       
         
       
       
     
       
    }
})();
(function() {
    'use strict';

    angular
        .module('app.businessadmin')
        .controller('BusinessCostcenterController', BusinessCostcenterController);

    /** @ngInject */
    function BusinessCostcenterController($state, $scope, $mdDialog, RestAPIService) {
        var costcenterCtrl = this;       
       
        costcenterCtrl.dtOptions = {
                dom: '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
                pagingType: 'simple',
                autoWidth: false,
                responsive: true
        };
        $scope.goToPreviousState = function(){
        	$state.go('app.businessadmin');
        }
        
        var list = "CostCenters";
       
        $scope.inputfield = new Array();
        $scope.List =function(){
        	RestAPIService.getdetaildata(list).then(
    				function(success){     				
    					$scope.CustomersList =success.data;
    				 	angular.forEach($scope.CustomersList, function(value, key) {
    				 		 $scope.customerlist = value;
    				 		angular.forEach( $scope.customerlist, function(value, key) {
    				 			if ($.inArray((key), $scope.inputfield) === -1){
    	                   			 if(key!=null && key !=undefined)
    	                   			 $scope.inputfield.push(key);
    	                   		 }
    				 		});
                  		});
    				},function(error){
    					RestAPIService.showErrorDialog(error);
    				});
        
        }
        
            $scope.createCustomer = function(ev) {
            	costcenterCtrl.customerinputdata = $scope.inputfield;
            	costcenterCtrl.listname = list;
                $mdDialog.show({
                    controller: CustomerMaincontroller,
                    templateUrl: 'app/main/business-admin/business-costcenters/create.costcenter.dialog.html', 
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    fullscreen: $scope.customFullscreen
                })
            };
            
            $scope.updateCustomer = function(ev, detaildata) {
            	costcenterCtrl.updatedata = detaildata;
            	costcenterCtrl.listname = list;
                  $mdDialog.show({
                      controller: UpdateCustomerscontroller,
                      templateUrl: 'app/main/business-admin/business-costcenters/update.costcenter.dialog.html',
                      parent: angular.element(document.body),
                      targetEvent: ev,
                      fullscreen: $scope.customFullscreen
                  })
              };
              
              
              $scope.deletedata = function(ev, data){
                  var confirm = $mdDialog.confirm()
                      .title('Remove')
                      .textContent('Costcenter will be permanently deleted. Continue ?')
                      .targetEvent(ev)
                      .ok('Ok')
                      .cancel('Cancel');
                  $mdDialog.show(confirm).then(function() {

                	  RestAPIService.deletedata(data._id,list).then(
                              function(success) {
                                  RestAPIService.successTostDialog("Deleted successfully");
                                  $state.reload();
                              },
                              function(error) {
                                  RestAPIService.showErrorDialog(error);
                              }
                          );
                  }, function() {
                      $mdDialog.cancel();
                  });
              }
              function UpdateCustomerscontroller($scope, $mdDialog){
            	  $scope.currentdata = costcenterCtrl.updatedata;
            	  $scope.updateddata = [];
           	   var udata =[];
           	   var pmap = {};
                  $scope.hide = function() {
                      $mdDialog.hide();
                  };
                  $scope.cancel = function() {
                      $mdDialog.cancel();
                  };

            	   var valarr = [];
                  $scope.updatedata = function() {
                   angular.forEach($scope.currentdata, function(value, key){
          	      valarr.push(key);
          	      });
         		  for(var i=0; i<$scope.updateddata.length; i++){
          			  if(valarr[i] !="_id"){
          				pmap[valarr[i]] = $scope.updateddata[i];
          			  }
            		} 
                   udata.push({"productMap":pmap});
                   $scope.arrsend = udata[0];
                   $scope.arrsend.id = $scope.updateddata[0];
                   $scope.arrsend.name = costcenterCtrl.listname;
                      RestAPIService.updatedyData($scope.arrsend).then(
                          function(success) {
                              RestAPIService.successTostDialog("Updated successfully");
                              $state.reload();
                          },
                          function(error) {
                              RestAPIService.showErrorDialog(error);
                          }
                      );
                      $mdDialog.hide(udata);
                  };
                  
              }
              
            function CustomerMaincontroller($scope, $mdDialog){
            	$scope.attrdata = costcenterCtrl.customerinputdata;
            	$scope.listname = costcenterCtrl.listname;
            	$scope.crlist=[];
            	   $scope.cancel = function() {
                       $mdDialog.cancel();
                   };
                   
                   
                   
                   $scope.save =function(){
                 	  var t = $scope.attrdata;
                 	  var uniqueNames=[];
                 	  var uniqueNames1 = [];
                 	  var obj ={};
                 	  var ary=[];
                 	  for(var i=1; i<t.length; i++){
                 		  obj[t[i]] = $scope.crlist[i].list;
                 		}
                       
                 	  ary.push({"productMap":obj});
                 	  ary.name = $scope.attrdata.name;
                        $scope.arr1 = ary[0];
                        $scope.arr1.name = $scope.listname;
                       RestAPIService.createdetail($scope.arr1).then(
                               function(success) {
                            	   RestAPIService.successTostDialog("Created successfully");
                                   $state.reload();
                               },
                               function(error) {
                                   RestAPIService.showErrorDialog(error);
                               }
                           );
                           $mdDialog.hide();
                          
                   }
            }
            
        $scope.init = function(){
        	$scope.List();
        }
       
       
      $scope.init();
        
       
         
       
     
       
    }
})();
(function() {
    'use strict';

    angular
        .module('app.businessadmin')
        .controller('BusinessContractController', BusinessContractController);

    /** @ngInject */
    function BusinessContractController($state, $scope, $mdDialog, RestAPIService) {
        var contractCtrl = this;       
       
        contractCtrl.dtOptions = {
                dom: '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
                pagingType: 'simple',
                autoWidth: false,
                responsive: true
        };
        $scope.goToPreviousState = function(){
        	$state.go('app.businessadmin');
        } 
        var list = "ContractTypes";
        $scope.inputfield = new Array();
        $scope.List =function(){
        	RestAPIService.getdetaildata(list).then(
    				function(success){     				
    					$scope.ContractTypesList =success.data;
    				 	angular.forEach($scope.ContractTypesList, function(value, key) {
    				 		 $scope.contracttypelist = value;
    				 		angular.forEach( $scope.contracttypelist, function(value, key) {
    				 			if ($.inArray((key), $scope.inputfield) === -1){
    	                   			 if(key!=null && key !=undefined)
    	                   			 $scope.inputfield.push(key);
    	                   		 }
    				 		});
                  		});
    				},function(error){
    					RestAPIService.showErrorDialog(error);
    				});
        
        }
        
            $scope.createContractType = function(ev) {
            	contractCtrl.contracttypeinputdata = $scope.inputfield;
            	contractCtrl.listname = list;
                $mdDialog.show({
                    controller: ContractTypeMaincontroller,
                    templateUrl: 'app/main/business-admin/business-contracttypes/create.contracttype.dialog.html', 
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    fullscreen: $scope.customFullscreen
                })
            };
            
            $scope.updateContractType = function(ev, detaildata) {
            	contractCtrl.updatedata = detaildata;
            	contractCtrl.listname = list;
                  $mdDialog.show({
                      controller: updateContractTypecontroller,
                      templateUrl: 'app/main/business-admin/business-contracttypes/update.contracttype.dialog.html',
                      parent: angular.element(document.body),
                      targetEvent: ev,
                      fullscreen: $scope.customFullscreen
                  })
              };
              
              
              $scope.deletedata = function(ev, data){
                  var confirm = $mdDialog.confirm()
                      .title('Remove')
                      .textContent('ContractType will be permanently deleted. Continue ?')
                      .targetEvent(ev)
                      .ok('Ok')
                      .cancel('Cancel');
                  $mdDialog.show(confirm).then(function() {

                	  RestAPIService.deletedata(data._id,list).then(
                              function(success) {
                                  RestAPIService.successTostDialog("Deleted successfully");
                                  $state.reload();
                              },
                              function(error) {
                                  RestAPIService.showErrorDialog(error);
                              }
                          );
                  }, function() {
                      $mdDialog.cancel();
                  });
              }
              function updateContractTypecontroller($scope, $mdDialog){
            	  $scope.currentdata = contractCtrl.updatedata;
            	  $scope.updateddata = [];
           	   var udata =[];
           	   var pmap = {};
                  $scope.hide = function() {
                      $mdDialog.hide();
                  };
                  $scope.cancel = function() {
                      $mdDialog.cancel();
                  };

            	   var valarr = [];
                  $scope.updatedata = function() {
                   angular.forEach($scope.currentdata, function(value, key){
          	      valarr.push(key);
          	      });
         		  for(var i=0; i<$scope.updateddata.length; i++){
          			  if(valarr[i] !="_id"){
          				pmap[valarr[i]] = $scope.updateddata[i];
          			  }
            		} 
                   udata.push({"productMap":pmap});
                   $scope.arrsend = udata[0];
                   $scope.arrsend.id = $scope.updateddata[0];
                   $scope.arrsend.name = contractCtrl.listname;
                      RestAPIService.updatedyData($scope.arrsend).then(
                          function(success) {
                              RestAPIService.successTostDialog("Updated successfully");
                              $state.reload();
                          },
                          function(error) {
                              RestAPIService.showErrorDialog(error);
                          }
                      );
                      $mdDialog.hide(udata);
                  };
                  
              }
              
            function ContractTypeMaincontroller($scope, $mdDialog){
            	$scope.attrdata = contractCtrl.contracttypeinputdata;
            	$scope.listname = contractCtrl.listname;
            	$scope.crlist=[];
            	   $scope.cancel = function() {
                       $mdDialog.cancel();
                   };
                   
                   
                   
                   $scope.save =function(){
                 	  var t = $scope.attrdata;
                 	  var uniqueNames=[];
                 	  var uniqueNames1 = [];
                 	  var obj ={};
                 	  var ary=[];
                 	  for(var i=1; i<t.length; i++){
                 		  obj[t[i]] = $scope.crlist[i].list;
                 		}
                       
                 	  ary.push({"productMap":obj});
                 	  ary.name = $scope.attrdata.name;
                        $scope.arr1 = ary[0];
                        $scope.arr1.name = $scope.listname;
                       RestAPIService.createdetail($scope.arr1).then(
                               function(success) {
                            	   RestAPIService.successTostDialog("Created successfully");
                                   $state.reload();
                               },
                               function(error) {
                                   RestAPIService.showErrorDialog(error);
                               }
                           );
                           $mdDialog.hide();
                          
                   }
            }
            
        $scope.init = function(){
        	$scope.List();
        }
       
       
      $scope.init();
        
       
         
       
    }
})();
(function() {
    'use strict';

    angular
        .module('app.businessadmin')
        .controller('BusinessCompanyController', BusinessCompanyController);

    /** @ngInject */
    function BusinessCompanyController($state, $scope, $mdDialog, RestAPIService) {
        var companyCtrl = this;       
       
        companyCtrl.dtOptions = {
                dom: '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
                pagingType: 'simple',
                autoWidth: false,
                responsive: true
        };
        $scope.goToPreviousState = function(){
        	$state.go('app.businessadmin');
        }
        
        var list = "Company";
        $scope.inputfield = new Array();
        $scope.List =function(){
        	RestAPIService.getdetaildata(list).then(
    				function(success){     				
    					$scope.EmployeesList =success.data;
    				 	angular.forEach($scope.EmployeesList, function(value, key) {
    				 		 $scope.employeelist = value;
    				 		angular.forEach( $scope.employeelist, function(value, key) {
    				 			if ($.inArray((key), $scope.inputfield) === -1){
    	                   			 if(key!=null && key !=undefined)
    	                   			 $scope.inputfield.push(key);
    	                   		 }
    				 		});
                  		});
    				},function(error){
    					RestAPIService.showErrorDialog(error);
    				});
        
        }
        
            $scope.createEmployee = function(ev) {
            	companyCtrl.employeeinputdata = $scope.inputfield;
            	companyCtrl.listname = list;
                $mdDialog.show({
                    controller: EmployeeMaincontroller,
                    templateUrl: 'app/main/business-admin/business-invoicetypes/create.invoicetype.dialog.html', 
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    fullscreen: $scope.customFullscreen
                })
            };
            
            $scope.updateEmployee = function(ev, detaildata) {
            	companyCtrl.updatedata = detaildata;
            	companyCtrl.listname = list;
                  $mdDialog.show({
                      controller: UpdateEmployeecontroller,
                      templateUrl: 'app/main/business-admin/business-invoicetypes/update.invoicetype.dialog.html',
                      parent: angular.element(document.body),
                      targetEvent: ev,
                      fullscreen: $scope.customFullscreen
                  })
              };
              
              
              $scope.deletedata = function(ev, data){
                  var confirm = $mdDialog.confirm()
                      .title('Remove')
                      .textContent('InvoiceType will be permanently deleted. Continue ?')
                      .targetEvent(ev)
                      .ok('Ok')
                      .cancel('Cancel');
                  $mdDialog.show(confirm).then(function() {

                	  RestAPIService.deletedata(data._id,list).then(
                              function(success) {
                                  RestAPIService.successTostDialog("Deleted successfully");
                                  $state.reload();
                              },
                              function(error) {
                                  RestAPIService.showErrorDialog(error);
                              }
                          );
                  }, function() {
                      $mdDialog.cancel();
                  });
              }
              function UpdateEmployeecontroller($scope, $mdDialog){
            	  $scope.currentdata = companyCtrl.updatedata;
            	  $scope.updateddata = [];
           	   var udata =[];
           	   var pmap = {};
                  $scope.hide = function() {
                      $mdDialog.hide();
                  };
                  $scope.cancel = function() {
                      $mdDialog.cancel();
                  };

            	   var valarr = [];
                  $scope.updatedata = function() {
                   angular.forEach($scope.currentdata, function(value, key){
          	      valarr.push(key);
          	      });
         		  for(var i=0; i<$scope.updateddata.length; i++){
          			  if(valarr[i] !="_id"){
          				pmap[valarr[i]] = $scope.updateddata[i];
          			  }
            		} 
                   udata.push({"productMap":pmap});
                   $scope.arrsend = udata[0];
                   $scope.arrsend.id = $scope.updateddata[0];
                   $scope.arrsend.name = companyCtrl.listname;
                      RestAPIService.updatedyData($scope.arrsend).then(
                          function(success) {
                              RestAPIService.successTostDialog("Updated successfully");
                              $state.reload();
                          },
                          function(error) {
                              RestAPIService.showErrorDialog(error);
                          }
                      );
                      $mdDialog.hide(udata);
                  };
                  
              }
              
            function EmployeeMaincontroller($scope, $mdDialog){
            	$scope.attrdata = companyCtrl.employeeinputdata;
            	$scope.listname = companyCtrl.listname;
            	$scope.crlist=[];
            	   $scope.cancel = function() {
                       $mdDialog.cancel();
                   };
                   
                   
                   
                   $scope.save =function(){
                 	  var t = $scope.attrdata;
                 	  var uniqueNames=[];
                 	  var uniqueNames1 = [];
                 	  var obj ={};
                 	  var ary=[];
                 	  for(var i=1; i<t.length; i++){
                 		  obj[t[i]] = $scope.crlist[i].list;
                 		}
                       
                 	  ary.push({"productMap":obj});
                 	  ary.name = $scope.attrdata.name;
                        $scope.arr1 = ary[0];
                        $scope.arr1.name = $scope.listname;
                       RestAPIService.createdetail($scope.arr1).then(
                               function(success) {
                            	   RestAPIService.successTostDialog("Created successfully");
                                   $state.reload();
                               },
                               function(error) {
                                   RestAPIService.showErrorDialog(error);
                               }
                           );
                           $mdDialog.hide();
                          
                   }
            }
            
        $scope.init = function(){
        	$scope.List();
        }
       
       
      $scope.init();
        
       
         
       
       
     
       
    }
})();
(function() {
    'use strict';

    angular
        .module('app.businessadmin')
        .controller('BusinessCategoryController', BusinessCategoryController);

    /** @ngInject */
    function BusinessCategoryController($state, $scope, $mdDialog, RestAPIService) {
        var CategoryCtrl = this;       
       
        CategoryCtrl.dtOptions = {
                dom: '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
                pagingType: 'simple',
                autoWidth: false,
                responsive: true
        };
        $scope.goToPreviousState = function(){
        	$state.go('app.businessadmin');
        }
        
        var list = "Categories";
        $scope.inputfield = new Array();
        $scope.List =function(){
        	RestAPIService.getdetaildata(list).then(
    				function(success){     				
    					$scope.CategoriesList =success.data;
    				 	angular.forEach($scope.CategoriesList, function(value, key) {
    				 		 $scope.categorylist = value;
    				 		angular.forEach( $scope.categorylist, function(value, key) {
    				 			if ($.inArray((key), $scope.inputfield) === -1){
    	                   			 if(key!=null && key !=undefined)
    	                   			 $scope.inputfield.push(key);
    	                   		 }
    				 		});
                  		});
    				},function(error){
    					RestAPIService.showErrorDialog(error);
    				});
        
        }
        
            $scope.createCategory = function(ev) {
            	CategoryCtrl.categoryinputdata = $scope.inputfield;
            	CategoryCtrl.listname = list;
                $mdDialog.show({
                    controller: CategoryMaincontroller,
                    templateUrl: 'app/main/business-admin/business-employees/create.employee.dialog.html', 
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    fullscreen: $scope.customFullscreen
                })
            };
            
            $scope.updateCategory = function(ev, detaildata) {
            	CategoryCtrl.updatedata = detaildata;
            	CategoryCtrl.listname = list;
                  $mdDialog.show({
                      controller: updateCategorycontroller,
                      templateUrl: 'app/main/business-admin/business-employees/update.employee.dialog.html',
                      parent: angular.element(document.body),
                      targetEvent: ev,
                      fullscreen: $scope.customFullscreen
                  })
              };
              
              
              $scope.deletedata = function(ev, data){
                  var confirm = $mdDialog.confirm()
                      .title('Remove')
                      .textContent('Category will be permanently deleted. Continue ?')
                      .targetEvent(ev)
                      .ok('Ok')
                      .cancel('Cancel');
                  $mdDialog.show(confirm).then(function() {
                	  RestAPIService.deletedata(data._id,list).then(
                              function(success) {
                                  RestAPIService.successTostDialog("Deleted successfully");
                                  $state.reload();
                              },
                              function(error) {
                                  RestAPIService.showErrorDialog(error);
                              }
                          );
                  }, function() {
                      $mdDialog.cancel();
                  });
              }
              function updateCategorycontroller($scope, $mdDialog){
            	  $scope.currentdata = CategoryCtrl.updatedata;
            	  $scope.updateddata = [];
           	   var udata =[];
           	   var pmap = {};
                  $scope.hide = function() {
                      $mdDialog.hide();
                  };
                  $scope.cancel = function() {
                      $mdDialog.cancel();
                  };

            	   var valarr = [];
                  $scope.updatedata = function() {
                   angular.forEach($scope.currentdata, function(value, key){
          	      valarr.push(key);
          	      });
         		  for(var i=0; i<$scope.updateddata.length; i++){
          			  if(valarr[i] !="_id"){
          				pmap[valarr[i]] = $scope.updateddata[i];
          			  }
            		} 
                   udata.push({"productMap":pmap});
                   $scope.arrsend = udata[0];
                   $scope.arrsend.id = $scope.updateddata[0];
                   $scope.arrsend.name = CategoryCtrl.listname;
                      RestAPIService.updatedyData($scope.arrsend).then(
                          function(success) {
                              RestAPIService.successTostDialog("Updated successfully");
                              $state.reload();
                          },
                          function(error) {
                              RestAPIService.showErrorDialog(error);
                          }
                      );
                      $mdDialog.hide(udata);
                  };
                  
              }
              
            function CategoryMaincontroller($scope, $mdDialog){
            	$scope.attrdata = CategoryCtrl.categoryinputdata;
            	$scope.listname = CategoryCtrl.listname;
            	$scope.crlist=[];
            	   $scope.cancel = function() {
                       $mdDialog.cancel();
                   };
                   $scope.save =function(){
                 	  var t = $scope.attrdata;
                 	  var uniqueNames=[];
                 	  var uniqueNames1 = [];
                 	  var obj ={};
                 	  var ary=[];
                 	  for(var i=1; i<t.length; i++){
                 		  obj[t[i]] = $scope.crlist[i].list;
                 		} 
                 	  ary.push({"productMap":obj});
                 	  ary.name = $scope.attrdata.name;
                        $scope.arr1 = ary[0];
                        $scope.arr1.name = $scope.listname;
                       RestAPIService.createdetail($scope.arr1).then(
                               function(success) {
                            	   RestAPIService.successTostDialog("Created successfully");
                                   $state.reload();
                               },
                               function(error) {
                                   RestAPIService.showErrorDialog(error);
                               }
                           );
                           $mdDialog.hide();
                          
                   }
            }
            
        $scope.init = function(){
        	$scope.List();
        }
      $scope.init();  
    }
})();
(function() {
    'use strict';

    angular
        .module('app.businessadmin')
        .controller('BusinessAttributesController', BusinessAttributesController);

    /** @ngInject */
    function BusinessAttributesController($state, $localStorage, $rootScope, $http, $scope, $mdDialog, RestAPIService, Attributes) {
        var CACtrl = this;
        $scope.attributesList = Attributes.data;
        CACtrl.attribute = {};
        CACtrl.dtOptions = {

            dom: '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            pagingType: 'simple',
            autoWidth: false,
            responsive: true

        };

        $scope.getContractAttributes = function() {
            RestAPIService.getContractAttributes().then(
                function(success) {
                    $scope.attributesList = success.data;
                },
                function(error) {
                    RestAPIService.showErrorDialog(error);
                }
            );
        }

        $scope.deleteContractAttribute = function(ev, attribute) {
            var confirm = $mdDialog.confirm()
                .title('Remove')
                .textContent('Attribute ' + attribute.name + ' ' + ' will be permanently deleted. Continue ?')
                .targetEvent(ev)
                .ok('Ok')
                .cancel('Cancel');
            $mdDialog.show(confirm).then(function() {
                    RestAPIService.deleteContractAttribute(attribute.id).then(
                        function(success) {
                            RestAPIService.successTostDialog(success.headers('X-smartportalApp-alert'));

                            $state.reload();
                        },
                        function(error) {
                            RestAPIService.showErrorDialog(error);
                        }
                    );
                },
                function() {
                    $mdDialog.cancel();
                });
        }

        $scope.createAttributeDialog = function(ev) {
            $mdDialog.show({
                controller: createAttributeDialogController,
                templateUrl: 'app/main/business-admin/business-attributes/create.attribute.dialog.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: $scope.customFullscreen
            })
            $scope.cancel = function() {

            };
        };


        function createAttributeDialogController($scope, $mdDialog) {
            $scope.attributeTypes = ["String", "Date", "Number"];
            $scope.attribute = {};
            $scope.attribute.isRequired = false;
            $scope.hide = function() {
                $mdDialog.hide();
            };
            $scope.cancel = function() {
                $mdDialog.cancel();
            };
            $scope.save = function(attribute) {
                RestAPIService.createContractAttribute(attribute).then(
                    function(success) {
                        RestAPIService.successTostDialog(success.headers('X-smartportalApp-alert'));
                        $state.reload();
                    },
                    function(error) {
                        RestAPIService.showErrorDialog(error);
                    }
                );
                $mdDialog.hide(attribute);
            };

        }

        CACtrl.currentAttribute = {};
        $scope.updateAttributeDialog = function(ev, attribute) {
            CACtrl.currentAttribute = angular.copy(attribute);
            $mdDialog.show({
                controller: updateAttributeDialogController,
                templateUrl: 'app/main/business-admin/business-attributes/update.attribute.dialog.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: $scope.customFullscreen
            })
        };

        function updateAttributeDialogController($scope, $mdDialog) {
            $scope.attributeTypes = ["String", "Date", "Number"];
            $scope.currentAttribute = CACtrl.currentAttribute;
            $scope.currentAttribute['type'] = $scope.currentAttribute.type;
            $scope.hide = function() {
                $mdDialog.hide();
            };
            $scope.cancel = function() {
                $mdDialog.cancel();
            };
            $scope.update = function(attribute) {
                RestAPIService.updateContractAttribute(attribute).then(
                    function(success) {
                        RestAPIService.successTostDialog(success.headers('X-smartportalApp-alert'));
                        $state.reload();
                    },
                    function(error) {
                        RestAPIService.showErrorDialog(error);
                    }
                );
                $mdDialog.hide();
            };
        }

    }

})();
(function() {
    'use strict';

    angular
        .module('app.businessadmin')
        .controller('BusinessVendorController', BusinessVendorController);

    /** @ngInject */
    function BusinessVendorController($state, $scope, $mdDialog, RestAPIService) {
        var VendorCtrl = this;       
       
        VendorCtrl.dtOptions = {
                dom: '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
                pagingType: 'simple',
                autoWidth: false,
                responsive: true
        };
        $scope.goToPreviousState = function(){
        	$state.go('app.businessadmin');
        }
        
        var list = "Vendor";
        $scope.inputfield = new Array();
        $scope.List =function(){
        	RestAPIService.getdetaildata(list).then(
    				function(success){     				
    					$scope.VendorsList =success.data;
    				 	angular.forEach($scope.VendorsList, function(value, key) {
    				 		 $scope.vendorlist = value;
    				 		angular.forEach( $scope.vendorlist, function(value, key) {
    				 			if ($.inArray((key), $scope.inputfield) === -1){
    	                   			 if(key!=null && key !=undefined)
    	                   			 $scope.inputfield.push(key);
    	                   		 }
    				 		});
                  		});
    				},function(error){
    					RestAPIService.showErrorDialog(error);
    				});
        
        }
        
            $scope.createVendor = function(ev) {
            	VendorCtrl.vendorinputdata = $scope.inputfield;
            	VendorCtrl.listname = list;
                $mdDialog.show({
                    controller: VendorMaincontroller,
                    templateUrl: 'app/main/business-admin/business-Vendor/create.vendor.dialog.html', 
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    fullscreen: $scope.customFullscreen
                })
            };
            
            $scope.updateVendor = function(ev, detaildata) {
            	VendorCtrl.updatedata = detaildata;
            	VendorCtrl.listname = list;
                  $mdDialog.show({
                      controller: UpdateVendorcontroller,
                      templateUrl: 'app/main/business-admin/business-Vendor/update.vendor.dialog.html',
                      parent: angular.element(document.body),
                      targetEvent: ev,
                      fullscreen: $scope.customFullscreen
                  })
              };
              
              $scope.deletedata = function(ev, data){
                  var confirm = $mdDialog.confirm()
                      .title('Remove')
                      .textContent('Vendor will be permanently deleted. Continue ?')
                      .targetEvent(ev)
                      .ok('Ok')
                      .cancel('Cancel');
                  $mdDialog.show(confirm).then(function() {

                	  RestAPIService.deletedata(data._id,list).then(
                              function(success) {
                                  RestAPIService.successTostDialog("Deleted successfully");
                                  $state.reload();
                              },
                              function(error) {
                                  RestAPIService.showErrorDialog(error);
                              }
                          );
                  }, function() {
                      $mdDialog.cancel();
                  });
              }
              function UpdateVendorcontroller($scope, $mdDialog){
            	  $scope.currentdata = VendorCtrl.updatedata;
            	  $scope.updateddata = [];
           	   var udata =[];
           	   var pmap = {};
                  $scope.hide = function() {
                      $mdDialog.hide();
                  };
                  $scope.cancel = function() {
                      $mdDialog.cancel();
                  };

            	   var valarr = [];
                  $scope.updatedata = function() {
                   angular.forEach($scope.currentdata, function(value, key){
          	      valarr.push(key);
          	      });
         		  for(var i=0; i<$scope.updateddata.length; i++){
          			  if(valarr[i] !="_id"){
          				pmap[valarr[i]] = $scope.updateddata[i];
          			  }
            		} 
                   udata.push({"productMap":pmap});
                   $scope.arrsend = udata[0];
                   $scope.arrsend.id = $scope.updateddata[0];
                   $scope.arrsend.name = VendorCtrl.listname;
                      RestAPIService.updatedyData($scope.arrsend).then(
                          function(success) {
                              RestAPIService.successTostDialog(success.headers('X-smartportalApp-alert'));
                              $state.reload();
                          },
                          function(error) {
                              RestAPIService.showErrorDialog(error);
                          }
                      );
                      $mdDialog.hide(udata);
                  };
                  
              }
              
            function VendorMaincontroller($scope, $mdDialog){
            	$scope.attrdata = VendorCtrl.vendorinputdata;
            	$scope.listname = VendorCtrl.listname;
            	$scope.crlist=[];
            	   $scope.cancel = function() {
                       $mdDialog.cancel();
                   };
                   
                   
                   
                   $scope.save =function(){
                 	  var t = $scope.attrdata;
                 	  var uniqueNames=[];
                 	  var uniqueNames1 = [];
                 	  var obj ={};
                 	  var ary=[];
                 	  for(var i=1; i<t.length; i++){
                 		  obj[t[i]] = $scope.crlist[i].list;
                 		}
                       
                 	  ary.push({"productMap":obj});
                 	  ary.name = $scope.attrdata.name;
                        $scope.arr1 = ary[0];
                        $scope.arr1.name = $scope.listname;
                       RestAPIService.createdetail($scope.arr1).then(
                               function(success) {
                                   $state.reload();
                               },
                               function(error) {
                                   RestAPIService.showErrorDialog(error);
                               }
                           );
                           $mdDialog.hide();
                           $mdDialog.show(
                               $mdDialog.alert()
                               .clickOutsideToClose(true)
                               .title('Success!')
                               .textContent('Data of ' + $scope.arr1.name + ' has been successfully updated')
                               .ok('Ok')
                           );
                           
                   }
            }
            
        $scope.init = function(){
        	$scope.List();
        }
       
       
      $scope.init();
        
       
         
       
     
       
    }
})();
(function() {
    'use strict';

    angular
        .module('app.businessadmin')
        .controller('BusinessCustomerController', BusinessCustomerController);

    /** @ngInject */
    function BusinessCustomerController($state, $scope, $mdDialog, RestAPIService) {
        var customerCtrl = this;       
       
        customerCtrl.dtOptions = {
                dom: '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
                pagingType: 'simple',
                autoWidth: false,
                responsive: true
        };
        $scope.goToPreviousState = function(){
        	$state.go('app.businessadmin');
        }
        
        var list = "PRTypes";
       
        $scope.inputfield = new Array();
        $scope.List =function(){
        	RestAPIService.getdetaildata(list).then(
    				function(success){     				
    					$scope.CustomersList =success.data;
    				 	angular.forEach($scope.CustomersList, function(value, key) {
    				 		 $scope.customerlist = value;
    				 		angular.forEach( $scope.customerlist, function(value, key) {
    				 			if ($.inArray((key), $scope.inputfield) === -1){
    	                   			 if(key!=null && key !=undefined)
    	                   			 $scope.inputfield.push(key);
    	                   		 }
    				 		});
                  		});
    				},function(error){
    					RestAPIService.showErrorDialog(error);
    				});
        
        }
        
            $scope.createCustomer = function(ev) {
            	customerCtrl.customerinputdata = $scope.inputfield;
            	customerCtrl.listname = list;
                $mdDialog.show({
                    controller: CustomerMaincontroller,
                    templateUrl: 'app/main/business-admin/business-PRTypes/create.PRType.dialog.html', 
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    fullscreen: $scope.customFullscreen
                })
            };
            
            $scope.updateCustomer = function(ev, detaildata) {
            	customerCtrl.updatedata = detaildata;
            	customerCtrl.listname = list;
                  $mdDialog.show({
                      controller: UpdateCustomerscontroller,
                      templateUrl: 'app/main/business-admin/business-PRTypes/update.PRType.dialog.html',
                      parent: angular.element(document.body),
                      targetEvent: ev,
                      fullscreen: $scope.customFullscreen
                  })
              };
              
              
              $scope.deletedata = function(ev, data){
                  var confirm = $mdDialog.confirm()
                      .title('Remove')
                      .textContent('PRType will be permanently deleted. Continue ?')
                      .targetEvent(ev)
                      .ok('Ok')
                      .cancel('Cancel');
                  $mdDialog.show(confirm).then(function() {

                	  RestAPIService.deletedata(data._id,list).then(
                              function(success) {
                                  RestAPIService.successTostDialog("Deleted successfully");
                                  $state.reload();
                              },
                              function(error) {
                                  RestAPIService.showErrorDialog(error);
                              }
                          );
                  }, function() {
                      $mdDialog.cancel();
                  });
              }
              function UpdateCustomerscontroller($scope, $mdDialog){
            	  $scope.currentdata = customerCtrl.updatedata;
            	  $scope.updateddata = [];
           	   var udata =[];
           	   var pmap = {};
                  $scope.hide = function() {
                      $mdDialog.hide();
                  };
                  $scope.cancel = function() {
                      $mdDialog.cancel();
                  };

            	   var valarr = [];
                  $scope.updatedata = function() {
                   angular.forEach($scope.currentdata, function(value, key){
          	      valarr.push(key);
          	      });
         		  for(var i=0; i<$scope.updateddata.length; i++){
          			  if(valarr[i] !="_id"){
          				pmap[valarr[i]] = $scope.updateddata[i];
          			  }
            		} 
                   udata.push({"productMap":pmap});
                   $scope.arrsend = udata[0];
                   $scope.arrsend.id = $scope.updateddata[0];
                   $scope.arrsend.name = customerCtrl.listname;
                      RestAPIService.updatedyData($scope.arrsend).then(
                          function(success) {
                              RestAPIService.successTostDialog("Updated successfully");
                              $state.reload();
                          },
                          function(error) {
                              RestAPIService.showErrorDialog(error);
                          }
                      );
                      $mdDialog.hide(udata);
                  };
                  
              }
              
            function CustomerMaincontroller($scope, $mdDialog){
            	$scope.attrdata = customerCtrl.customerinputdata;
            	$scope.listname = customerCtrl.listname;
            	$scope.crlist=[];
            	   $scope.cancel = function() {
                       $mdDialog.cancel();
                   };
                   
                   
                   
                   $scope.save =function(){
                 	  var t = $scope.attrdata;
                 	  var uniqueNames=[];
                 	  var uniqueNames1 = [];
                 	  var obj ={};
                 	  var ary=[];
                 	  for(var i=1; i<t.length; i++){
                 		  obj[t[i]] = $scope.crlist[i].list;
                 		}
                       
                 	  ary.push({"productMap":obj});
                 	  ary.name = $scope.attrdata.name;
                        $scope.arr1 = ary[0];
                        $scope.arr1.name = $scope.listname;
                       RestAPIService.createdetail($scope.arr1).then(
                               function(success) {
                            	   RestAPIService.successTostDialog("Created successfully");
                                   $state.reload();
                               },
                               function(error) {
                                   RestAPIService.showErrorDialog(error);
                               }
                           );
                           $mdDialog.hide();
                          
                   }
            }
            
        $scope.init = function(){
        	$scope.List();
        }
       
       
      $scope.init();
        
       
         
       
     
       
    }
})();
(function() {
    'use strict';

    angular
        .module('app.businessadmin')
        .controller('BusinessPOTypesController', BusinessPOTypesController);

    /** @ngInject */
    function BusinessPOTypesController($state, $scope, $mdDialog, RestAPIService) {
        var POTypeCtrl = this;       
       
        POTypeCtrl.dtOptions = {
                dom: '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
                pagingType: 'simple',
                autoWidth: false,
                responsive: true
        };
        $scope.goToPreviousState = function(){
        	$state.go('app.businessadmin');
        }
        
        var list = "POTypes";
       
        $scope.inputfield = new Array();
        $scope.List =function(){
        	RestAPIService.getdetaildata(list).then(
    				function(success){     				
    					$scope.CustomersList =success.data;
    				 	angular.forEach($scope.CustomersList, function(value, key) {
    				 		 $scope.customerlist = value;
    				 		angular.forEach( $scope.customerlist, function(value, key) {
    				 			if ($.inArray((key), $scope.inputfield) === -1){
    	                   			 if(key!=null && key !=undefined)
    	                   			 $scope.inputfield.push(key);
    	                   		 }
    				 		});
                  		});
    				},function(error){
    					RestAPIService.showErrorDialog(error);
    				});
        
        }
        
            $scope.createCustomer = function(ev) {
            	POTypeCtrl.customerinputdata = $scope.inputfield;
            	POTypeCtrl.listname = list;
                $mdDialog.show({
                    controller: CustomerMaincontroller,
                    templateUrl: 'app/main/business-admin/business-PRTypes/create.PRType.dialog.html', 
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    fullscreen: $scope.customFullscreen
                })
            };
            
            $scope.updateCustomer = function(ev, detaildata) {
            	POTypeCtrl.updatedata = detaildata;
            	POTypeCtrl.listname = list;
                  $mdDialog.show({
                      controller: UpdateCustomerscontroller,
                      templateUrl: 'app/main/business-admin/business-PRTypes/update.PRType.dialog.html',
                      parent: angular.element(document.body),
                      targetEvent: ev,
                      fullscreen: $scope.customFullscreen
                  })
              };
              
              
              $scope.deletedata = function(ev, data){
                  var confirm = $mdDialog.confirm()
                      .title('Remove')
                      .textContent('POType will be permanently deleted. Continue ?')
                      .targetEvent(ev)
                      .ok('Ok')
                      .cancel('Cancel');
                  $mdDialog.show(confirm).then(function() {

                	  RestAPIService.deletedata(data._id,list).then(
                              function(success) {
                                  RestAPIService.successTostDialog("Deleted successfully");
                                  $state.reload();
                              },
                              function(error) {
                                  RestAPIService.showErrorDialog(error);
                              }
                          );
                  }, function() {
                      $mdDialog.cancel();
                  });
              }
              function UpdateCustomerscontroller($scope, $mdDialog){
            	  $scope.currentdata = POTypeCtrl.updatedata;
            	  $scope.updateddata = [];
           	   var udata =[];
           	   var pmap = {};
                  $scope.hide = function() {
                      $mdDialog.hide();
                  };
                  $scope.cancel = function() {
                      $mdDialog.cancel();
                  };

            	   var valarr = [];
                  $scope.updatedata = function() {
                   angular.forEach($scope.currentdata, function(value, key){
          	      valarr.push(key);
          	      });
         		  for(var i=0; i<$scope.updateddata.length; i++){
          			  if(valarr[i] !="_id"){
          				pmap[valarr[i]] = $scope.updateddata[i];
          			  }
            		} 
                   udata.push({"productMap":pmap});
                   $scope.arrsend = udata[0];
                   $scope.arrsend.id = $scope.updateddata[0];
                   $scope.arrsend.name = POTypeCtrl.listname;
                      RestAPIService.updatedyData($scope.arrsend).then(
                          function(success) {
                              RestAPIService.successTostDialog("Updated successfully");
                              $state.reload();
                          },
                          function(error) {
                              RestAPIService.showErrorDialog(error);
                          }
                      );
                      $mdDialog.hide(udata);
                  };
                  
              }
              
            function CustomerMaincontroller($scope, $mdDialog){
            	$scope.attrdata = POTypeCtrl.customerinputdata;
            	$scope.listname = POTypeCtrl.listname;
            	$scope.crlist=[];
            	   $scope.cancel = function() {
                       $mdDialog.cancel();
                   };
                   
                   
                   
                   $scope.save =function(){
                 	  var t = $scope.attrdata;
                 	  var uniqueNames=[];
                 	  var uniqueNames1 = [];
                 	  var obj ={};
                 	  var ary=[];
                 	  for(var i=1; i<t.length; i++){
                 		  obj[t[i]] = $scope.crlist[i].list;
                 		}
                       
                 	  ary.push({"productMap":obj});
                 	  ary.name = $scope.attrdata.name;
                        $scope.arr1 = ary[0];
                        $scope.arr1.name = $scope.listname;
                       RestAPIService.createdetail($scope.arr1).then(
                               function(success) {
                            	   RestAPIService.successTostDialog("Created successfully");
                                   $state.reload();
                               },
                               function(error) {
                                   RestAPIService.showErrorDialog(error);
                               }
                           );
                           $mdDialog.hide();
                          
                   }
            }
            
        $scope.init = function(){
        	$scope.List();
        }
       
       
      $scope.init();
        
       
         
       
     
       
    }
})();
(function() {
    'use strict';

    angular
        .module('app.businessadmin')
        .controller('BusinessGLAccountController', BusinessGLAccountController);

    /** @ngInject */
    function BusinessGLAccountController($state, $scope, $mdDialog, RestAPIService) {
        var GLACtrl = this;       
       
        GLACtrl.dtOptions = {
                dom: '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
                pagingType: 'simple',
                autoWidth: false,
                responsive: true
        };
        $scope.goToPreviousState = function(){
        	$state.go('app.businessadmin');
        }
        
        var list = "GLAccounts";
        $scope.inputfield = new Array();
        $scope.List =function(){
        	RestAPIService.getdetaildata(list).then(
    				function(success){     				
    					$scope.EmployeesList =success.data;
    				 	angular.forEach($scope.EmployeesList, function(value, key) {
    				 		 $scope.employeelist = value;
    				 		angular.forEach( $scope.employeelist, function(value, key) {
    				 			if ($.inArray((key), $scope.inputfield) === -1){
    	                   			 if(key!=null && key !=undefined)
    	                   			 $scope.inputfield.push(key);
    	                   		 }
    				 		});
                  		});
    				},function(error){
    					RestAPIService.showErrorDialog(error);
    				});
        
        }
        
            $scope.createEmployee = function(ev) {
            	GLACtrl.employeeinputdata = $scope.inputfield;
            	GLACtrl.listname = list;
                $mdDialog.show({
                    controller: EmployeeMaincontroller,
                    templateUrl: 'app/main/business-admin/business-GLAccounts/create.GLAccount.dialog.html', 
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    fullscreen: $scope.customFullscreen
                })
            };
            
            $scope.updateEmployee = function(ev, detaildata) {
            	GLACtrl.updatedata = detaildata;
            	GLACtrl.listname = list;
                  $mdDialog.show({
                      controller: UpdateEmployeecontroller,
                      templateUrl: 'app/main/business-admin/business-GLAccounts/update.GLAccount.dialog.html',
                      parent: angular.element(document.body),
                      targetEvent: ev,
                      fullscreen: $scope.customFullscreen
                  })
              };
              
              
              $scope.deletedata = function(ev, data){
                  var confirm = $mdDialog.confirm()
                      .title('Remove')
                      .textContent('GL Account will be permanently deleted. Continue ?')
                      .targetEvent(ev)
                      .ok('Ok')
                      .cancel('Cancel');
                  $mdDialog.show(confirm).then(function() {

                	  RestAPIService.deletedata(data._id,list).then(
                              function(success) {
                                  RestAPIService.successTostDialog("Deleted successfully");
                                  $state.reload();
                              },
                              function(error) {
                                  RestAPIService.showErrorDialog(error);
                              }
                          );
                  }, function() {
                      $mdDialog.cancel();
                  });
              }
              function UpdateEmployeecontroller($scope, $mdDialog){
            	  $scope.currentdata = GLACtrl.updatedata;
            	  $scope.updateddata = [];
           	   var udata =[];
           	   var pmap = {};
                  $scope.hide = function() {
                      $mdDialog.hide();
                  };
                  $scope.cancel = function() {
                      $mdDialog.cancel();
                  };

            	   var valarr = [];
                  $scope.updatedata = function() {
                   angular.forEach($scope.currentdata, function(value, key){
          	      valarr.push(key);
          	      });
         		  for(var i=0; i<$scope.updateddata.length; i++){
          			  if(valarr[i] !="_id"){
          				pmap[valarr[i]] = $scope.updateddata[i];
          			  }
            		} 
                   udata.push({"productMap":pmap});
                   $scope.arrsend = udata[0];
                   $scope.arrsend.id = $scope.updateddata[0];
                   $scope.arrsend.name = GLACtrl.listname;
                      RestAPIService.updatedyData($scope.arrsend).then(
                          function(success) {
                              RestAPIService.successTostDialog("Updated successfully");
                              $state.reload();
                          },
                          function(error) {
                              RestAPIService.showErrorDialog(error);
                          }
                      );
                      $mdDialog.hide(udata);
                  };
                  
              }
              
            function EmployeeMaincontroller($scope, $mdDialog){
            	$scope.attrdata = GLACtrl.employeeinputdata;
            	$scope.listname = GLACtrl.listname;
            	$scope.crlist=[];
            	   $scope.cancel = function() {
                       $mdDialog.cancel();
                   };
                   
                   
                   
                   $scope.save =function(){
                 	  var t = $scope.attrdata;
                 	  var uniqueNames=[];
                 	  var uniqueNames1 = [];
                 	  var obj ={};
                 	  var ary=[];
                 	  for(var i=1; i<t.length; i++){
                 		  obj[t[i]] = $scope.crlist[i].list;
                 		}
                       
                 	  ary.push({"productMap":obj});
                 	  ary.name = $scope.attrdata.name;
                        $scope.arr1 = ary[0];
                        $scope.arr1.name = $scope.listname;
                       RestAPIService.createdetail($scope.arr1).then(
                               function(success) {
                            	   RestAPIService.successTostDialog("Created successfully");
                                   $state.reload();
                               },
                               function(error) {
                                   RestAPIService.showErrorDialog(error);
                               }
                           );
                           $mdDialog.hide();
                          
                   }
            }
            
        $scope.init = function(){
        	$scope.List();
        }
       
       
      $scope.init();
        
       
         
       
       
     
       
    }
})();
(function() {
    'use strict';

    angular
        .module('app.businessadmin')
        .controller('BusinessExpenseTypeController', BusinessExpenseTypeController);

    /** @ngInject */
    function BusinessExpenseTypeController($state, $scope, $mdDialog, RestAPIService) {
        var expenseCtrl = this;       
       
        expenseCtrl.dtOptions = {
                dom: '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
                pagingType: 'simple',
                autoWidth: false,
                responsive: true
        };
        $scope.goToPreviousState = function(){
        	$state.go('app.businessadmin');
        }
        
        var list = "ExpenseTypes";
        $scope.inputfield = new Array();
        $scope.List =function(){
        	RestAPIService.getdetaildata(list).then(
    				function(success){     				
    					$scope.EmployeesList =success.data;
    				 	angular.forEach($scope.EmployeesList, function(value, key) {
    				 		 $scope.employeelist = value;
    				 		angular.forEach( $scope.employeelist, function(value, key) {
    				 			if ($.inArray((key), $scope.inputfield) === -1){
    	                   			 if(key!=null && key !=undefined)
    	                   			 $scope.inputfield.push(key);
    	                   		 }
    				 		});
                  		});
    				},function(error){
    					RestAPIService.showErrorDialog(error);
    				});
        
        }
        
            $scope.createEmployee = function(ev) {
            	expenseCtrl.employeeinputdata = $scope.inputfield;
            	expenseCtrl.listname = list;
                $mdDialog.show({
                    controller: EmployeeMaincontroller,
                    templateUrl: 'app/main/business-admin/business-ExpenseTypes/create.ExpenseType.dialog.html', 
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    fullscreen: $scope.customFullscreen
                })
            };
            
            $scope.updateEmployee = function(ev, detaildata) {
            	expenseCtrl.updatedata = detaildata;
            	expenseCtrl.listname = list;
                  $mdDialog.show({
                      controller: UpdateEmployeecontroller,
                      templateUrl: 'app/main/business-admin/business-ExpenseTypes/update.ExpenseType.dialog.html',
                      parent: angular.element(document.body),
                      targetEvent: ev,
                      fullscreen: $scope.customFullscreen
                  })
              };
              
              
              $scope.deletedata = function(ev, data){
                  var confirm = $mdDialog.confirm()
                      .title('Remove')
                      .textContent('GL Account will be permanently deleted. Continue ?')
                      .targetEvent(ev)
                      .ok('Ok')
                      .cancel('Cancel');
                  $mdDialog.show(confirm).then(function() {

                	  RestAPIService.deletedata(data._id,list).then(
                              function(success) {
                                  RestAPIService.successTostDialog("Deleted successfully");
                                  $state.reload();
                              },
                              function(error) {
                                  RestAPIService.showErrorDialog(error);
                              }
                          );
                  }, function() {
                      $mdDialog.cancel();
                  });
              }
              function UpdateEmployeecontroller($scope, $mdDialog){
            	  $scope.currentdata = expenseCtrl.updatedata;
            	  $scope.updateddata = [];
           	   var udata =[];
           	   var pmap = {};
                  $scope.hide = function() {
                      $mdDialog.hide();
                  };
                  $scope.cancel = function() {
                      $mdDialog.cancel();
                  };

            	   var valarr = [];
                  $scope.updatedata = function() {
                   angular.forEach($scope.currentdata, function(value, key){
          	      valarr.push(key);
          	      });
         		  for(var i=0; i<$scope.updateddata.length; i++){
          			  if(valarr[i] !="_id"){
          				pmap[valarr[i]] = $scope.updateddata[i];
          			  }
            		} 
                   udata.push({"productMap":pmap});
                   $scope.arrsend = udata[0];
                   $scope.arrsend.id = $scope.updateddata[0];
                   $scope.arrsend.name = expenseCtrl.listname;
                      RestAPIService.updatedyData($scope.arrsend).then(
                          function(success) {
                              RestAPIService.successTostDialog("Updated successfully");
                              $state.reload();
                          },
                          function(error) {
                              RestAPIService.showErrorDialog(error);
                          }
                      );
                      $mdDialog.hide(udata);
                  };
                  
              }
              
            function EmployeeMaincontroller($scope, $mdDialog){
            	$scope.attrdata = expenseCtrl.employeeinputdata;
            	$scope.listname = expenseCtrl.listname;
            	$scope.crlist=[];
            	   $scope.cancel = function() {
                       $mdDialog.cancel();
                   };
                   
                   
                   
                   $scope.save =function(){
                 	  var t = $scope.attrdata;
                 	  var uniqueNames=[];
                 	  var uniqueNames1 = [];
                 	  var obj ={};
                 	  var ary=[];
                 	  for(var i=1; i<t.length; i++){
                 		  obj[t[i]] = $scope.crlist[i].list;
                 		}
                       
                 	  ary.push({"productMap":obj});
                 	  ary.name = $scope.attrdata.name;
                        $scope.arr1 = ary[0];
                        $scope.arr1.name = $scope.listname;
                       RestAPIService.createdetail($scope.arr1).then(
                               function(success) {
                            	   RestAPIService.successTostDialog("Created successfully");
                                   $state.reload();
                               },
                               function(error) {
                                   RestAPIService.showErrorDialog(error);
                               }
                           );
                           $mdDialog.hide();
                          
                   }
            }
            
        $scope.init = function(){
        	$scope.List();
        }
       
       
      $scope.init();
        
       
         
       
       
     
       
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.administration')
        .controller('ZohoReportsController', ZohoReportsController);    
    function ZohoReportsController($state,$scope, RestAPIService, $mdDialog, ZohoReports,$localStorage )
    {
    	var zohoCtrl = this;
    	$scope.zohoReports = ZohoReports.data;
//    	$scope.zohoReports = [
//   	      	{
// 	       	 	"name":"Invoice Performance Analysis",
// 	       	 	"url":"https://reports.zoho.com/open-view/1516216000000078045/a277ea467d7b8b548b686a341ab639bc",
// 	       	 	"description":"Used for Invoice Performance Analysis" 	       	 	
// 	       	},
// 	       	{
// 	          	 "name":"Invoice SLA analysis",
// 	          	 "url":"https://reports.zoho.com/open-view/1516216000000073804/8c756b2bb3935cc6801c5cf0a332c872",
// 	          	 "description":"Used for Invoice SLA analysis"
// 	         },
// 	         {
// 	          	 "name":"Invoice Analysis",
// 	          	 "url":"https://reports.zoho.com/open-view/1516216000000078439/03871e3c0345ff9c1898b2205f9a771f",
// 	          	 "description":"Used for Invoice Analysis"
// 	         }
//    	];
 zohoCtrl.dtOptions = {
                 
                 dom       : '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
                pagingType: 'simple',
                autoWidth : false,
                responsive: true
                };

                  if ($localStorage.menubarsetting != undefined) {
                     $scope.showsForms = $localStorage.menubarsetting.formsmanagement;
                      $scope.showWorkflow = $localStorage.menubarsetting.adminWorkflow; 
                     $scope.showrequestManagement = $localStorage.menubarsetting.requestManagement;
                     $scope.showListManagement = $localStorage.menubarsetting.listManagement;
                     $scope.showBusinessObject = $localStorage.menubarsetting.businessObject;
                     $scope.showBinder = $localStorage.menubarsetting.binder;
                     $scope.showTemplates = $localStorage.menubarsetting.templates;
                     $scope.showReports1 = $localStorage.menubarsetting.adminReports;
                  
                    
                     $scope.showSubstitution = $localStorage.menubarsetting.substitution;
                     $scope.showZohoReports = $localStorage.menubarsetting.zohoReports;
                     
                      $scope.showDocumentType  = $localStorage.menubarsetting.documentTypes;  
                       $scope.showReqTypeDetails  = $localStorage.menubarsetting.reqTypeDetails; 
                          $scope.showInvoiceTypes  = $localStorage.menubarsetting.invoiceTypes;      
                     
            }
    	$scope.createZohoReport = function(ev){
    		 $mdDialog.show({
                 controller: CreateZohoRepotrDialogController,
                 templateUrl: 'app/main/administration/zohoReports/create.zohoReports.html',
                 parent: angular.element(document.body),
                 targetEvent: ev,
                 clickOutsideToClose: true,
                 fullscreen: $scope.customFullscreen
             })
    	}
    	function CreateZohoRepotrDialogController($scope, $mdDialog){
    		$scope.save = function(reportData){
    			RestAPIService.createZohoReport(reportData).then(
                        function(success) {
                       	 $mdDialog.hide();
                       	 RestAPIService.successTostDialog('Zoho Report Created Successfully');
                       	 $state.reload();
                        },
                        function(error) {
                        	RestAPIService.showErrorDialog(error);
                        }
                       
                    );
    		}
    		$scope.cancel = function(){
    			$mdDialog.cancel();
    		}
    	}
    	$scope.updateZohoReport = function(ev, reportData){
    		zohoCtrl.zohoReport = reportData;
    		$mdDialog.show({
                controller: updateZohoRepotrDialogController,
                templateUrl: 'app/main/administration/zohoReports/update.zohoReports.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: $scope.customFullscreen
            })
    	}
    	function updateZohoRepotrDialogController($scope, $mdDialog){
    		$scope.object = zohoCtrl.zohoReport;
    		$scope.update= function(reportData){    			
    			RestAPIService.updateZohoReport(reportData).then(
                        function(success) {
                       	 $mdDialog.hide();
                       	 RestAPIService.successTostDialog('Zoho Report updated Successfully');
                       	 $state.reload();
                        },
                        function(error) {
                        	RestAPIService.showErrorDialog(error);
                        }
                       
                );
    		}
    		$scope.cancel = function(){
    			$mdDialog.cancel();
    		}
    	}
    	$scope.deletezohoReport = function(ev, report){
            var confirm = $mdDialog.confirm()
                .title('Remove')
                .textContent('This Report will be permanently deleted. Continue ?')
                .targetEvent(ev)
                .ok('Ok')
                .cancel('Cancel');
            $mdDialog.show(confirm).then(function() {
                RestAPIService.deletezohoReport(report).then(
                    function(success) {
                   	 RestAPIService.successTostDialog('Zoho Report was Deleted Successfully');
                        $state.reload();
                    },
                    function(error) {
                        RestAPIService.showErrorDialog(error);
                    }
                );
            }, function() {
                $mdDialog.cancel();
            });        
    	}
         $("#vertical-navigation").hide();
        $("#content-container").css({ "margin-left": "0px" });
    	$scope.goToPreviousState = function() {
         	$state.go("app.mycontent_inbox");
          	$("#vertical-navigation").show();
          	$("#content-container").css({ "margin-left": "60px" });
         }
    }


         
})();
(function ()
{
    'use strict';

    angular
        .module('app.administration')
        .controller('WMController', WMController);

    /** @ngInject */
    function WMController($state,$scope, $mdDialog, RestAPIService,Actvitys,$filter,$localStorage)
    {
        var workflowCtrl = this;
        $("#vertical-navigation").hide();
        $("#content-container").css({ "margin-left": "0px" });
            $scope.activitys = Actvitys.data;

       $scope.goToPreviousState = function() {
         	$state.go("app.mycontent_inbox");
          	$("#vertical-navigation").show();
          	$("#content-container").css({ "margin-left": "60px" });
         }
         $scope.dtOptions =
        		 {
        	           dom       : '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
        	            pagingType: 'simple',
        	            autoWidth : false,
        	            responsive: true
        	        };

                    if ($localStorage.menubarsetting != undefined) {
                     $scope.showsForms = $localStorage.menubarsetting.formsmanagement;
                      $scope.showWorkflow = $localStorage.menubarsetting.adminWorkflow;
                     $scope.showrequestManagement = $localStorage.menubarsetting.requestManagement;
                     $scope.showListManagement = $localStorage.menubarsetting.listManagement;
                     $scope.showBusinessObject = $localStorage.menubarsetting.businessObject;
                     $scope.showBinder = $localStorage.menubarsetting.binder;
                     $scope.showTemplates = $localStorage.menubarsetting.templates;
                     $scope.showReports1 = $localStorage.menubarsetting.adminReports;


                     $scope.showSubstitution = $localStorage.menubarsetting.substitution;
                     $scope.showZohoReports = $localStorage.menubarsetting.zohoReports;

                      $scope.showDocumentType  = $localStorage.menubarsetting.documentTypes;
                       $scope.showReqTypeDetails  = $localStorage.menubarsetting.reqTypeDetails;
                          $scope.showInvoiceTypes  = $localStorage.menubarsetting.invoiceTypes;

            }

         $scope.createWorkflow  = function(ev) {
             $mdDialog.show({
                 controller: createWorkflowDialogController,
                 templateUrl: 'app/main/administration/workflow-management/create.workflow.dialog.html',
                 parent: angular.element(document.body),
                 targetEvent: ev,
                 clickOutsideToClose: true,
                 fullscreen: $scope.customFullscreen
             })
             $scope.cancel = function() {
                 $scope.user = {};
             };
         };


         function createWorkflowDialogController($scope, $mdDialog) {
        	 $scope.activitytypes = ["Portal", "SAP","Document","Hybrid"];
             $scope.user={};
             $scope.hide = function() {
             $mdDialog.hide();
             };
             $scope.cancel = function() {
                 $mdDialog.cancel();
             };

             $scope.save = function(user) {
            	 RestAPIService.createActivity(user).then(
             function(success) {
                    	 RestAPIService.successTostDialog(success.headers('X-smartportalApp-alert'));
                         //Create successful. Need to refresh
                         $state.reload();
                     },
                     function(error) {
                         RestAPIService.showErrorDialog(error);
                     }
                 );
                 $mdDialog.hide(user);
             };

         }

         workflowCtrl.currentUser = {};
         $scope.updateRequestDialog  = function(ev) {
        	 var datares = $filter('filter')($scope.activitys, {'id': ev.id});
        	 workflowCtrl.currentUser = angular.copy(datares[0]);
             $mdDialog.show({
                 controller: updateRequestDialogController,
                 templateUrl: 'app/main/administration/workflow-management/update.workflow.dialog.html',
                 parent: angular.element(document.body),
                 targetEvent: ev,
                 clickOutsideToClose: true,
                 fullscreen: $scope.customFullscreen
             })
         };

         function updateRequestDialogController($scope, $mdDialog) {
        	  $scope.activitytypes = ["Portal", "SAP","Document","Hybrid"];
             $scope.currentUser = workflowCtrl.currentUser;
             console.log( $scope.currentUser);

             $scope.hide = function() {
                 $mdDialog.hide();
             };
             $scope.cancel = function() {
                 $mdDialog.cancel();
             };
             $scope.update = function(user) {
            	 RestAPIService.updateActivity(user).then(
                     function(success) {
    	 RestAPIService.successTostDialog(success.headers('X-smartportalApp-alert'));
                         $state.reload();
                     },
                     function(error) {
                         RestAPIService.showErrorDialog(error);
                     }
                 );
                 $mdDialog.hide(user);
             };
         }


       $scope.deleteActivity = function(ev) {
        var datares = $filter('filter')($scope.activitys, {'id': ev.id});
                  var confirm = $mdDialog.confirm()
                 .title('Remove')
                 .textContent(' Activity ' +  datares[0].name + ' ' + ' will be permanently deleted. Continue ?')
                 .targetEvent(ev)
                 .ok('Ok')
                 .cancel('Cancel');
             $mdDialog.show(confirm).then(function() {

                 RestAPIService.deleteActivity(ev.id).then(
                     function(success) {
                    	 RestAPIService.successTostDialog(success.headers('X-smartportalApp-alert'));

                         $state.reload();
                     },
                     function(error) {
                         RestAPIService.showErrorDialog(error);
                        }
                      );
                     },
                     function() {
                    $mdDialog.cancel();
                   });
                   }

        }
})();

(function() {
    'use strict';
    angular
        .module('app.administration')
        .controller('SystemController', SystemController);

    function SystemController($state, $http, $scope, $mdDialog, RestAPIService,$localStorage) {
        var systemCtrl = this;     
        $("#vertical-navigation").hide();
        $("#content-container").css({ "margin-left": "0px" });
        //systemCtrl.user = {};
         systemCtrl.dtOptions = {
                dom       : '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
               pagingType: 'simple',
               autoWidth : false,
               responsive: true
              };
        $scope.goToPreviousState = function() {
           $state.go("app.mycontent_inbox");
           $("#vertical-navigation").show();
           $("#content-container").css({ "margin-left": "60px" });
        }
        $scope.logObject={};
        systemCtrl.getallSystemlogs =function(){
            RestAPIService.getSystemlogs( $scope.logObject,$scope.pageNumber,$scope.size).then(
                function(success){
                    $scope.allSystemlogs =success.data.content;
                    $scope.totalRecords =success.data.totalElements;
                    $scope.totalPages =success.data.totalPages;
                    $scope.pageNumbers = [];
                    if ($scope.totalPages  > 0) {
                        for (var i = 0; i < $scope.totalPages; i++) {
                            $scope.pageNumbers.push(i);
                        }
                    } 
                },function(error){

                })
        }
        $scope.pageNumber = 0;
        $scope.size =100;
        $scope.next = function(){	
            $scope.pageNumber = $scope.pageNumber + 1; 
           systemCtrl.getallSystemlogs();    	
          }
          $scope.previous = function(){
              $scope.pageNumber = $scope.pageNumber - 1; 
             systemCtrl.getallSystemlogs();    	
          }  	 
          $scope.sendPageNumber = function(page) {
           $scope.pageNumber = page;
          systemCtrl.getallSystemlogs();
       }
       $scope.sizeselect=function(size){
        $scope.size = size
        systemCtrl.getallSystemlogs();                
    }
       
   

  
 }
})();

/*(function ()
{
    'use strict';

    angular
        .module('app.administration')
        .controller('SettingsController', SettingsController);

    *//** @ngInject *//*
    function SettingsController($state,$scope)
    {
        var settingCtrl = this;
        $scope.Edit = true;
        settingCtrl.editMode =function(){
         $scope.Edit = !$scope.Edit;
         $scope.editButton=true;

        };
        settingCtrl.Save = function(){
        	$state.reload();

        };
        settingCtrl.Cancel = function(){
        	$scope.editButton =false;
        	$scope.Edit = !$scope.Edit;

        };

        $("#vertical-navigation").hide();
        $("#content-container").css({ "margin-left": "0px" });

        $scope.policys =["First character must be a letter, it must contain at least 4 characters and no more than 15 characters and no characters other than letters, numbers and the underscore may be used",
        "Password must be between 4 and 8 digits long and include at least one numeric digit",
        "Password must be at least 4 characters, no more than 8 characters, and must include at least one upper case letter, one lower case letter, and one numeric digit",
        "Matches any string between 4 and 8 characters in length. Limits the length of a string",
        "Requires one lower case letter, one upper case letter, one digit, 6-13 length, and no spaces"]


        $scope.goToPreviousState = function() {
        	$state.go("app.overview");
         	$("#vertical-navigation").show();
         	$("#content-container").css({ "margin-left": "55px" });
         }


        }
})();*/


(function ()
{
    'use strict';

    angular
        .module('app.administration')
        .controller('SettingsController', SettingsController);

    /** @ngInject */
    function SettingsController($state,$scope, $mdDialog, RestAPIService,$rootScope,$localStorage,$location,$window )
    {
        var settingCtrl = this;
        $scope.brandsettingdata ={};
    	$scope.systemDetails = {};

        $scope.selectedModel={
        		title: ""
        };
        $scope.Edit = true;
        settingCtrl.editMode =function(){
         $scope.Edit = !$scope.Edit;
         $scope.editButton=true;

        };
        settingCtrl.Save = function(){
        	$state.reload();

        };
         if ($localStorage.menubarsetting != undefined) {
                     $scope.showsForms = $localStorage.menubarsetting.formsmanagement;
                      $scope.showWorkflow = $localStorage.menubarsetting.adminWorkflow;
                     $scope.showrequestManagement = $localStorage.menubarsetting.requestManagement;
                     $scope.showListManagement = $localStorage.menubarsetting.listManagement;
                     $scope.showBusinessObject = $localStorage.menubarsetting.businessObject;
                     $scope.showBinder = $localStorage.menubarsetting.binder;
                     $scope.showTemplates = $localStorage.menubarsetting.templates;
                     $scope.showReports1 = $localStorage.menubarsetting.adminReports;


                     $scope.showSubstitution = $localStorage.menubarsetting.substitution;
                     $scope.showZohoReports = $localStorage.menubarsetting.zohoReports;

                      $scope.showDocumentType  = $localStorage.menubarsetting.documentTypes;
                        $scope.showReqTypeDetails  = $localStorage.menubarsetting.reqTypeDetails;
                          $scope.showInvoiceTypes  = $localStorage.menubarsetting.invoiceTypes;

            }
        settingCtrl.Cancel = function(){
        	$scope.editButton =false;
        	$scope.Edit = !$scope.Edit;

        };

        $("#vertical-navigation").hide();
        $("#content-container").css({ "margin-left": "0px" });

        $scope.policys =["First character must be a letter, it must contain at least 4 characters and no more than 15 characters and no characters other than letters, numbers and the underscore may be used",
        "Password must be between 4 and 8 digits long and include at least one numeric digit",
        "Password must be at least 4 characters, no more than 8 characters, and must include at least one upper case letter, one lower case letter, and one numeric digit",
        "Matches any string between 4 and 8 characters in length. Limits the length of a string",
        "Requires one lower case letter, one upper case letter, one digit, 6-13 length, and no spaces"]


        $scope.goToPreviousState = function() {
        	$state.go('app.mycontent_inbox');
         	$("#vertical-navigation").show();
         	$("#content-container").css({ "margin-left": "60px" });
         }

        settingCtrl.getSystemDetails = function(){
        var sysId = 9999;
        	RestAPIService.getSystemDetails(sysId).then(
                     function(responce) {

                    		 $scope.systemDetails = responce.data;
                            //alert(JSON.stringify($scope.systemDetails));

                    	 console.log($scope.systemDetails);
                     },
                     function(error) {
                         RestAPIService.showErrorDialog(error);
                     }
                 );

        }
        settingCtrl.savingSmartstoreDetails = function(data){
        	RestAPIService.savingSmartstoreDetails(data).then(function(responce){
        		alert("successfully updated");
        	},function(error){
        		RestAPIService.showErrorDialog(error);
        	})


        }

        settingCtrl.savingSolrDetails = function(data){
        	console.log(data);
        	RestAPIService.savingSolrDetails(data).then(function(responce){
        		alert("successfully updated");
        	},function(error){
        		RestAPIService.showErrorDialog(error);
        	})
        }

        settingCtrl.savesitesetting = function(){
        	RestAPIService.savingSitedata($scope.systemDetails).then(function(responce){
        		if(responce.data.site !=null && responce.data.site !=undefined){
        			delete $localStorage.sitesettingdata;
        			$localStorage.sitesettingdata = responce.data.site;
        		}else{
        			$localStorage.sitesettingdata = null;
        		}
        		if(responce.data.activeMenu !=null && responce.data.activeMenu !=undefined){
        			delete $localStorage.menubarsetting;
        			$localStorage.menubarsetting = responce.data.activeMenu;
        		}else{
        			$localStorage.menubarsetting = null;
        		}
        		alert("successfully updated");
        		$window.location.reload();
        	},function(error){
        		RestAPIService.showErrorDialog(error);
        	})
        }



      $scope.setLogoFile = function(element){
    	 var reader = new FileReader();
    	 reader.readAsDataURL(element.files[0]);
    	   reader.onload = function () {
    	     $('#logo').attr('src', reader.result);
    	     $rootScope.logodata = reader.result;
    	   };
    	   reader.onerror = function (error) {
    	     console.log('Error: ', error);
    	   };
      }

      $scope.setappbackgroundimage = function(element){
      	 var reader = new FileReader();
      	 reader.readAsDataURL(element.files[0]);
      	   reader.onload = function () {
      	     $('#appbackimage').attr('src', reader.result);
      	     $rootScope.appbackdata = reader.result;
      	   };
      	   reader.onerror = function (error) {
      	     console.log('Error: ', error);
      	   };
        }

      $scope.setbackgroundfile = function(element){
     	 var reader = new FileReader();
     	 reader.readAsDataURL(element.files[0]);
     	 var file = element.files[0];

     	 var img = new Image();
     	 img.src = window.URL.createObjectURL( file );
     	 img.onload = function() {
             var width = img.naturalWidth,
                 height = img.naturalHeight;

             window.URL.revokeObjectURL( img.src );

             if( width >= 1920 && height >= 1080 ) {
           	     $('#backimage').attr('src', reader.result);
           	     $rootScope.backdata = reader.result;
             }
             else {
               alert("Image size is too small");
             }
         };

       }
      $scope.setapplogo = function(element){
    	  var reader = new FileReader();
     	 reader.readAsDataURL(element.files[0]);
     	   reader.onload = function () {
     	     $('#applogo').attr('src', reader.result);
     	     $rootScope.applogodata = reader.result;
     	   };
     	   reader.onerror = function (error) {
     	     console.log('Error: ', error);
     	   };
      }


      $scope.saveData = function(event){
    	  	$scope.brandsettingdata = {};
    	  	$scope.brandsettingdata.logo = $rootScope.logodata;
    	  	$scope.brandsettingdata.backgroundimage = $rootScope.backdata;
    	  	$scope.brandsettingdata.backgroundcolor = document.getElementById("mycolor").value;
    	   	RestAPIService.savebrandsetting($scope.brandsettingdata).then(function(responce){
        		alert("successfully updated");
        	},function(error){
        		RestAPIService.showErrorDialog(error);
        	})
      }

      $scope.clear = function () {
    		    $('#backimage').attr('src','');
    		    document.getElementById('backroundimageUpload').value = "";
    		    $rootScope.backdata = "";
    	};

      $scope.updateData = function(event){
       	  if($scope.brandsettingdata == undefined){
    		  $scope.brandsettingdata ={};
    	  }
    	  	if($rootScope.logodata !=null && $rootScope.logodata  != undefined){
    	    	$scope.brandsettingdata.loginlogo = $rootScope.logodata;
     	  	}else{
     	 	if($scope.bdata != undefined){
    	  	$scope.brandsettingdata.loginlogo = $scope.bdata.loginlogo;
     	 	}
    	  	}
    	  	if($rootScope.backdata !=null && $rootScope.backdata  != undefined){

    	  	$scope.brandsettingdata.loginbackgroundimage = $rootScope.backdata;

    	  	}else{
    	  	if($scope.bdata  != undefined){
    	  	$scope.brandsettingdata.loginbackgroundimage = $scope.bdata.loginbackgroundimage;
    	  	}
    	  	}
    	  	if($rootScope.applogodata !=null && $rootScope.applogodata !=undefined){
    	     $scope.brandsettingdata.applogo = $rootScope.applogodata;
    	  	}else{
    	  	if($scope.bdata  != undefined){
    	  	 $scope.brandsettingdata.applogo = $scope.bdata.applogo;
    	  	}
    	  	}
      		if($rootScope.appbackdata !=null && $rootScope.appbackdata != undefined){
       	     $scope.brandsettingdata.appbackroundimage = $rootScope.appbackdata;
       	  	}else{
       	  	if( $scope.bdata != undefined){
       	  	$scope.brandsettingdata.appbackroundimage = $scope.bdata.appbackroundimage;
       	  	}
       	  	}
  	     $scope.brandsettingdata.loginbackgroundcolor = document.getElementById("mycolor").value;
  	     $scope.brandsettingdata.applabel =  $scope.selectedModel.title;
     	RestAPIService.updatebrandsetting($scope.brandsettingdata).then(function(response){
     		delete window.localStorage['branddata'];
     		window.localStorage['branddata'] = angular.toJson(response.data);
          	$state.reload();
             alert("successfully updated");
    	},function(error){
    		RestAPIService.showErrorDialog(error);
    	})
       }

      settingCtrl.brandsettingdata = function(){
          RestAPIService.getbrandsetting().then(
                  function(success) {
                	  if(success.data[0] !=null || success.data!= undefined){
                		  $scope.showbutton = false;
                		  $scope.bdata = success.data[0];
                		  $scope.brandsettingdata = success.data[0];
                		  if(window.localStorage['branddata'] !="null"){
                			  var loginlogodata = JSON.parse(window.localStorage['branddata']).loginlogo;
                    		  var loginbackrounddata =  JSON.parse(window.localStorage['branddata']).loginbackgroundimage;
                    		  var loginbackgroundcolor = JSON.parse(window.localStorage['branddata']).loginbackgroundcolor;
                    		  var applog = JSON.parse(window.localStorage['branddata']).applogo;
                    		  var applabel = JSON.parse(window.localStorage['branddata']).applabel;
                    		  var appbackgoundimage = JSON.parse(window.localStorage['branddata']).appbackroundimage;
                		  }

                	       $('#logo').attr('src', loginlogodata);
                	       $('#backimage').attr('src',loginbackrounddata);
                	       $('#applogo').attr('src', applog);
                	       $('#appbackimage').attr('src', appbackgoundimage);
                	       $scope.selectedModel.title = applabel;
                	       if(document.getElementById("mycolor") != undefined || document.getElementById("mycolor") != null){
                	    	   document.getElementById("mycolor").value = loginbackgroundcolor;
                	       }

                          }else{
                        	  $scope.showbutton = true;
                          }

                	  },     function(error) {
                          RestAPIService.showErrorDialog(error);
                      }

              );
	  }
	  init();

	  function init() {
		RestAPIService.getAllEmailConfig ().then(
			function(success) {
				$scope.emailconfig = success.data;
				
			},
			function(error) {
				RestAPIService.showErrorDialog(error);
			}
		);
	  }
	 
	  $scope.createEmailConfig = function(ev) {
		$mdDialog.show({
			controller: CreateEmailDialogController,
			templateUrl: 'app/main/administration/settings/emailConfig.dialog.html',
			parent: angular.element(document.body),
			targetEvent: ev,
			clickOutsideToClose: true,
			fullscreen: $scope.customFullscreen
		})
		$scope.cancel = function() {
			$mdDialog.cancel();
		};
		
	};


	function CreateEmailDialogController($scope, $mdDialog) {

		$scope.save = function(email) {
			RestAPIService.createEmailConfig(email).then(
				function(success) {
					$mdDialog.hide();
               RestAPIService.successTostDialog('email Configuration Created Successfully');
				},
				function(error) {
					RestAPIService.showErrorDialog(error);
				}

			);
	};
	$scope.cancel = function() {
		$mdDialog.cancel();
	};
	}
	$scope.emailUpdate ={}
	settingCtrl.updateemailDialog = function(ev, email) {
		settingCtrl.emailUpdate = angular.copy(email);
		$mdDialog.show({
			controller: UpdateemailDialogController,
			templateUrl: 'app/main/administration/settings/emailUpdateConfig.dialog.html',
			parent: angular.element(document.body),
			targetEvent: ev,
			clickOutsideToClose: true,
			fullscreen: $scope.customFullscreen
		})
	};
	function UpdateemailDialogController($scope, $mdDialog) {
		$scope.emailUpdate = settingCtrl.emailUpdate;
		$scope.hide = function() {
			$mdDialog.hide();
		};
		$scope.cancel = function() {
			$mdDialog.cancel();
		};
		$scope.updatesave = function(email) {
			RestAPIService.updateEmailConfig(email).then(
				function(success) {
					RestAPIService.successTostDialog('email Configuration  Updated Successfully');
					$state.reload();
				},
				function(error) {
					RestAPIService.showErrorDialog(error);
				}
			);
			$mdDialog.hide(email);
		};
	}
	$scope.deleteemailConfig = function(ev, object) {
		var confirm = $mdDialog.confirm()
			.title('Remove')
			.textContent('It will be permanently deleted. Continue ?')
			.targetEvent(ev)
			.ok('Ok')
			.cancel('Cancel');
		$mdDialog.show(confirm).then(function() {
				RestAPIService.deleteEmailConfig(object.id).then(
					function(success) {
						RestAPIService.successTostDialog(success.headers('X-smartportalApp-alert'));
						$state.reload();
					},
					function(error) {
						RestAPIService.showErrorDialog(error);
					}
				);
			},
			function() {
				$mdDialog.cancel();
			});
	}


        }
})();

(function ()
{
    'use strict';

    angular
        .module('app.administration')
        .controller('requestTypeDetailsController', requestTypeDetailsController);    
    function requestTypeDetailsController($state,$scope,$localStorage, RestAPIService, $mdDialog,RequestsData,RequestTypeDetails )
    {
    	var reqTypeCtrl = this;
    	$scope.RequestTypes = RequestTypeDetails.data;

 if ($localStorage.menubarsetting != undefined) {
                     $scope.showsForms = $localStorage.menubarsetting.formsmanagement;
                      $scope.showWorkflow = $localStorage.menubarsetting.adminWorkflow; 
                     $scope.showrequestManagement = $localStorage.menubarsetting.requestManagement;
                     $scope.showListManagement = $localStorage.menubarsetting.listManagement;
                     $scope.showBusinessObject = $localStorage.menubarsetting.businessObject;
                     $scope.showBinder = $localStorage.menubarsetting.binder;
                     $scope.showTemplates = $localStorage.menubarsetting.templates;
                     $scope.showReports1 = $localStorage.menubarsetting.adminReports;
                  
                    
                     $scope.showSubstitution = $localStorage.menubarsetting.substitution;
                     $scope.showZohoReports = $localStorage.menubarsetting.zohoReports;
                     
                      $scope.showDocumentType  = $localStorage.menubarsetting.documentTypes; 
                       $scope.showReqTypeDetails  = $localStorage.menubarsetting.reqTypeDetails; 
                          $scope.showInvoiceTypes  = $localStorage.menubarsetting.invoiceTypes;       
                     
            }

reqTypeCtrl.dtOptions = {
                 
                 dom       : '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
                pagingType: 'simple',
                autoWidth : false,
                responsive: true
                };
    	$scope.createZohoReport = function(ev){
    		 $mdDialog.show({
                 controller: CreateZohoRepotrDialogController,
                 templateUrl: 'app/main/administration/requestTypeDetails/create.requestTypeDeatils.html',
                 parent: angular.element(document.body),
                 targetEvent: ev,
                 clickOutsideToClose: true,
                 fullscreen: $scope.customFullscreen
             })
    	}
    	function CreateZohoRepotrDialogController($scope, $mdDialog){
    		$scope.Documents =RequestsData.data;
    		$scope.save = function(reportData){
    			RestAPIService.createRequestType(reportData).then(
                        function(success) {
                       	 $mdDialog.hide();
                       	 RestAPIService.successTostDialog('RequestType Deatails Created Successfully');
                       	 $state.reload();
                        },
                        function(error) {
                        	RestAPIService.showErrorDialog(error);
                        }
                       
                    );
    		}
    		$scope.cancel = function(){
    			$mdDialog.cancel();
    		}
    	}
    	$scope.updateRequestDetails = function(ev, reportData){
    		reqTypeCtrl.RequestData = reportData;
    		$mdDialog.show({
                controller: updateRequestDetailsDialogController,
                templateUrl: 'app/main/administration/requestTypeDetails/update.requestTypeDeatils.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: $scope.customFullscreen
            })
    	}
    	function updateRequestDetailsDialogController($scope, $mdDialog){
    		$scope.Documents =RequestsData.data;
    		$scope.object = reqTypeCtrl.RequestData;
    		$scope.update= function(reportData){    			
    			RestAPIService.updateRequestDetails(reportData).then(
                        function(success) {
                       	 $mdDialog.hide();
                       	 RestAPIService.successTostDialog('RequestType Deatails updated Successfully');
                       	 $state.reload();
                        },
                        function(error) {
                        	RestAPIService.showErrorDialog(error);
                        }
                       
                );
    		}
    		$scope.cancel = function(){
    			$mdDialog.cancel();
    		}
    	}
    	$scope.deleteRequestDetails = function(ev, report){
            var confirm = $mdDialog.confirm()
                .title('Remove')
                .textContent('RequestType  will be permanently deleted. Continue ?')
                .targetEvent(ev)
                .ok('Ok')
                .cancel('Cancel');
            $mdDialog.show(confirm).then(function() {
                RestAPIService.deleteRequestDetails(report).then(
                    function(success) {
                   	 RestAPIService.successTostDialog('RequestType Deatails was Deleted Successfully');
                        $state.reload();
                    },
                    function(error) {
                        RestAPIService.showErrorDialog(error);
                    }
                );
            }, function() {
                $mdDialog.cancel();
            });        
    	}
         $("#vertical-navigation").hide();
        $("#content-container").css({ "margin-left": "0px" });
    	$scope.goToPreviousState = function() {
         	$state.go("app.mycontent_inbox");
          	$("#vertical-navigation").show();
          	$("#content-container").css({ "margin-left": "60px" });
         }
    }


         
})();
(function() {
    'use strict';

    angular
        .module('app.administration')
        .controller('ReqtypeController', ReqtypeController);

    /** @ngInject */
    function ReqtypeController($scope, $state, $location, $mdDialog, RestAPIService, Requests,Icons,$localStorage) {
        var reqtypeCtrl = this;
        $scope.Requests = Requests.data;
        $("#vertical-navigation").hide();
        $("#content-container").css({ "margin-left": "0px" });
        $scope.dtOptions = {
        		 dom       : '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
 	            pagingType: 'simple',
 	            autoWidth : false,
 	            responsive: true
        };
         if ($localStorage.menubarsetting != undefined) {
                     $scope.showsForms = $localStorage.menubarsetting.formsmanagement;
                      $scope.showWorkflow = $localStorage.menubarsetting.adminWorkflow; 
                     $scope.showrequestManagement = $localStorage.menubarsetting.requestManagement;
                     $scope.showListManagement = $localStorage.menubarsetting.listManagement;
                     $scope.showBusinessObject = $localStorage.menubarsetting.businessObject;
                     $scope.showBinder = $localStorage.menubarsetting.binder;
                     $scope.showTemplates = $localStorage.menubarsetting.templates;
                     $scope.showReports1 = $localStorage.menubarsetting.adminReports;
                  
                    
                     $scope.showSubstitution = $localStorage.menubarsetting.substitution;
                     $scope.showZohoReports = $localStorage.menubarsetting.zohoReports;
                     
                      $scope.showDocumentType  = $localStorage.menubarsetting.documentTypes;   
                       $scope.showReqTypeDetails  = $localStorage.menubarsetting.reqTypeDetails; 
                          $scope.showInvoiceTypes  = $localStorage.menubarsetting.invoiceTypes;     
                     
            }
        
        $scope.goToPreviousState = function() {
        	$state.go("app.mycontent_inbox");
         	$("#vertical-navigation").show();
         	$("#content-container").css({ "margin-left": "60px" });
        }
        $scope.getRequestForms = function() {
            RestAPIService.getRequestForms(0,40).then(
                function(success) {
                	reqtypeCtrl.forms = success.data;
                   // reqtypeCtrl.ids = [];
                  /*  $scope.forms.forEach(function(h) {
                        reqtypeCtrl.ids.push(h.id);
                    });*/


                },
                function(error) {
                    RestAPIService.showErrorDialog(error);
                });
        };

        $scope.createRequestDialog = function(ev) {
            $mdDialog.show({
                controller: createRequestDialogController,
                templateUrl: 'app/main/administration/request-management/create.requestType.dialog.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: $scope.customFullscreen
            })
            $scope.cancel = function() {
                // $scope.user = {};
            };
        };


        function createRequestDialogController($scope, $mdDialog) {
        	
        	
        	$scope.icons = Icons.icons;
        	$scope.openIconList =function(ev){
        		 $mdDialog.show({
                     controller: createRequestDialogController,
                     templateUrl: 'app/main/sites/site/dashboard/site.logo.html',
                     parent: angular.element(document.body),
                     targetEvent: ev,
                     clickOutsideToClose:true,
                     preserveScope: true,
                     autoWrap: true,
                     
                     skipHide: true, // this line does the trick for nested dialogs

                     fullscreen: $scope.customFullscreen // Only for -xs, -sm breakpoints.
                   })
                   .then(function(answer) {
                     $scope.status = 'You said the information was "' + answer + '".';
                   }, function() {
                     $scope.status = 'You cancelled the dialog.';
                   });	
        		
        	
        	}
        	  $scope.noOfIconsForDisplay = 50;
              $scope.iconsPerColumn = 5;

              $scope.range = function(min, max, step){
                step = step || 1;
                var input = [];
                for (var i = min; i <= max; i += step) input.push(i);
                return input;
              };

              $scope.loadMoreIcons = function() {
                  $scope.noOfIconsForDisplay += 10;
                 };
                 $scope.saveLogo = function(siteIcon) {
                	 reqtypeCtrl.Icon  = siteIcon;
                     $mdDialog.hide();
                 }
            $scope.flowtypes = ["Portal", "SAP", "Hybrid"];
            $scope.ids = reqtypeCtrl.ids;
            $scope.forms =reqtypeCtrl.forms;
            $scope.hide = function() {
                $mdDialog.hide();
            };
            $scope.cancel = function() {
                $mdDialog.cancel();
            };

            $scope.save = function(doc) {
            	doc.icon =reqtypeCtrl.Icon;
                RestAPIService.createRequest(doc).then(
                    function(success) {
                    	RestAPIService.successTostDialog(success.headers('X-smartportalApp-alert'));
                        //Create successful. Need to refresh
                        $state.reload();
                    },
                    function(error) {
                        RestAPIService.showErrorDialog(error);
                    }
                );
                $mdDialog.hide(doc);
            };
        }        
        
        $scope.AddattributesDialog = function(ev,req) {
        	reqtypeCtrl.currentRequest =req;
            $mdDialog.show({
                controller: AddattributesDialogController,
                templateUrl: 'app/main/administration/request-management/addattributes.dialog.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: $scope.customFullscreen
            })
         
        };
        function AddattributesDialogController($scope, $mdDialog) { 
        	$scope.CurrentReqData =reqtypeCtrl.currentRequest;
        	delete $scope.CurrentReqData.$$hashKey;
        	$scope.attributes = [];
        	//$scope.CurrentReqData['attributes'] =[];
        	if($scope.CurrentReqData.attributes != null){
        		$scope.attributes =	$scope.CurrentReqData.attributes;
        	
        	}       	
        	 $scope.attributeTypes = ['String', 'Number', 'Date'];
        	 
        	 $scope.addNewAttribute = function() {
                 var newAttribute = {
                     name: '',
                     type: 'String',
                     required: false
                 }                
                 if ($scope.attributes == null) $scope.attributes = [];
                 $scope.attributes.push(newAttribute);
             };
             $scope.removeAttribute = function(index) {
                 $scope.attributes.splice(index, 1);
             };
            $scope.hide = function() {
                $mdDialog.hide();
            };
            $scope.cancel = function() {
                $mdDialog.cancel();
            };
            $scope.save = function() {
            	$scope.attributes.forEach(function (h) {
            	if(h.$$hashKey){
            		delete h.$$hashKey
            	}		    
            		  });            	
            	$scope.CurrentReqData.attributes =$scope.attributes;
                RestAPIService.updateRequest($scope.CurrentReqData).then(
                    function(success) {
                    	RestAPIService.successTostDialog(success.headers('X-smartportalApp-alert'));
                       $state.reload();
                    },
                    function(error) {
                        RestAPIService.showErrorDialog(error);
                    }
                );
                $mdDialog.hide($scope.CurrentReqData);
            };

        }
        
        

        reqtypeCtrl.recivedDoc = {};
        $scope.updateRequestDialog = function(ev, doc) {
            reqtypeCtrl.recivedDoc = angular.copy(doc);
            $mdDialog.show({
                controller: updateRequestDialogController,
                templateUrl: 'app/main/administration/request-management/update.requestType.dialog.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: $scope.customFullscreen
            })
        };

        function updateRequestDialogController($scope, $mdDialog) {
        	$scope.icons = Icons.icons;
        	$scope.openIconList =function(ev){
        		 $mdDialog.show({
                     controller: updateRequestDialogController,
                     templateUrl: 'app/main/sites/site/dashboard/site.logo.html',
                     parent: angular.element(document.body),
                     targetEvent: ev,
                     clickOutsideToClose:true,
                     preserveScope: true,
                     autoWrap: true,
                     
                     skipHide: true, // this line does the trick for nested dialogs

                     fullscreen: $scope.customFullscreen // Only for -xs, -sm breakpoints.
                   })
                   .then(function(answer) {
                     $scope.status = 'You said the information was "' + answer + '".';
                   }, function() {
                     $scope.status = 'You cancelled the dialog.';
                   });	
        		
        	
        	}
        	  $scope.noOfIconsForDisplay = 50;
              $scope.iconsPerColumn = 5;

              $scope.range = function(min, max, step){
                step = step || 1;
                var input = [];
                for (var i = min; i <= max; i += step) input.push(i);
                return input;
              };

              $scope.loadMoreIcons = function() {
                  $scope.noOfIconsForDisplay += 10;
                 };
                 $scope.saveLogo = function(siteIcon) {
                	 reqtypeCtrl.Icon  = siteIcon;
                     $mdDialog.hide();
                 }
                 
            $scope.flowtypes = ["Portal", "SAP", "Hybrid"];
            $scope.formIds = reqtypeCtrl.forms;
            $scope.recivedDoc = reqtypeCtrl.recivedDoc;
            $scope.hide = function() {
                $mdDialog.hide();
            };
            $scope.cancel = function() {
                $mdDialog.cancel();
            };
            $scope.update = function(doc) {
            	doc.icon =reqtypeCtrl.Icon;
                RestAPIService.updateRequest(doc).then(
                    function(success) {
                    	RestAPIService.successTostDialog(success.headers('X-smartportalApp-alert'));
                        $state.reload();
                    },
                    function(error) {
                        RestAPIService.showErrorDialog(error);
                    }
                );
                $mdDialog.hide(doc);
            };
        }

        $scope.deleteDoctype = function(ev, object) {
            var confirm = $mdDialog.confirm()
                .title('Remove')
                .textContent(' Request ' + object.name + ' ' + ' will be permanently deleted. Continue ?')
                .targetEvent(ev)
                .ok('Ok')
                .cancel('Cancel');
            $mdDialog.show(confirm).then(function() {
                    RestAPIService.deleteRequest(object.id).then(
                        function(success) {
                        	RestAPIService.successTostDialog(success.headers('X-smartportalApp-alert'));
                            $state.reload();
                        },
                        function(error) {
                            RestAPIService.showErrorDialog(error);
                        }
                    );
                },
                function() {
                    $mdDialog.cancel();
                });
        }

    }
})();
(function() {
    'use strict';

    angular
        .module('app.administration')
        .controller('Reportscontoller', Reportscontoller);

    /** @ngInject */
    function Reportscontoller($state, $scope, RestAPIService, Icons, $filter, $mdDialog,$localStorage) {
        var repCtrl = this;
        $scope.icons = Icons.icons;
        $scope.reportdata = {};
        $scope.noOfIconsForDisplay = 50;
        $scope.iconsPerColumn = 5;
        $scope.reportInfo = {
            "reportType": "TABULAR",
            "skipSelection": false
        };
        $scope.selectionfields = [];
        $scope.outputfields = [];
        $scope.filterfields = [];
        $scope.selected = [];
        $scope.selectedAttr = [];
        $scope.selectedFilter = [];
        $scope.selectedoutfield = [];
        $scope.attributeObjects = [];
        $scope.finalDocTypeFields = [];
        $scope.finalSelectionFields = [];
        $scope.finalOutData = [];
        $scope.finalFilterData = [];
        $scope.selectedOutFl = [];
        if ($localStorage.menubarsetting != undefined) {
                     $scope.showsForms = $localStorage.menubarsetting.formsmanagement;
                      $scope.showWorkflow = $localStorage.menubarsetting.adminWorkflow; 
                     $scope.showrequestManagement = $localStorage.menubarsetting.requestManagement;
                     $scope.showListManagement = $localStorage.menubarsetting.listManagement;
                     $scope.showBusinessObject = $localStorage.menubarsetting.businessObject;
                     $scope.showBinder = $localStorage.menubarsetting.binder;
                     $scope.showTemplates = $localStorage.menubarsetting.templates;
                     $scope.showReports1 = $localStorage.menubarsetting.adminReports;
                  
                    
                     $scope.showSubstitution = $localStorage.menubarsetting.substitution;
                     $scope.showZohoReports = $localStorage.menubarsetting.zohoReports;
                     
                      $scope.showDocumentType  = $localStorage.menubarsetting.documentTypes;  
                       $scope.showReqTypeDetails  = $localStorage.menubarsetting.reqTypeDetails; 
                          $scope.showInvoiceTypes  = $localStorage.menubarsetting.invoiceTypes;      
                     
            }
        
        
          $("#vertical-navigation").hide();
         $("#content-container").css({ "margin-left": "0px" });
        $scope.selectedFSFields = function(fields) {
        	var cField = JSON.parse(fields);
        	$scope.selectedFSField = angular.copy(cField);
        } 
         
        $scope.setDefaultValue = function(dValue, fsfields) {
        	var fsfield = JSON.parse(fsfields[0]);
        	for (var j in $scope.finalSelectionFields) {
                if ($scope.finalSelectionFields[j].fieldname == fsfield.fieldname) {
                	$scope.finalSelectionFields[j].defaultvalue = dValue;
                }
            }
        }
        $scope.setLabelValue = function(lValue, fsfields) {
        	var fsfield = JSON.parse(fsfields[0]);
        	for (var j in $scope.finalSelectionFields) {
                if ($scope.finalSelectionFields[j].label == fsfield.label) {
                	$scope.finalSelectionFields[j].label = lValue;
                }
            }
        }
       
        $scope.setRequiredFlag = function(rValue, fsfields) {
        	var fsfield = JSON.parse(fsfields[0]);
        	for (var j in $scope.finalSelectionFields) {
                if ($scope.finalSelectionFields[j].requiredflag == fsfield.label) {
                	$scope.finalSelectionFields[j].requiredflag = rValue;
                }
            }
        }
        
        $scope.setPossibleValues = function(pValue, fsfields) {
        	var pValuesArray = pValue.split(',');
        	pValuesArray = pValuesArray.filter(function(e){ return e.replace(/(\r\n|\n|\r)/gm,"")});
        	var fsfield = JSON.parse(fsfields[0]);
        	for (var j in $scope.finalSelectionFields) {
                if ($scope.finalSelectionFields[j].fieldname == fsfield.fieldname) {
                	$scope.finalSelectionFields[j].possibleValues = pValuesArray;
                }
            }
        }
        
        $scope.getReportData = function() {
            RestAPIService.getreportdata().then(function(response) {
                    $scope.allReports = [];
                    $scope.allReports = response.data;
                },
                function(error) {
                    RestAPIService.showErrorDialog(error);
                });
        }

        $scope.goToPreviousState = function() {
            $state.go("app.mycontent_inbox");
            $("#vertical-navigation").show();
            $("#content-container").css({
                "margin-left": "60px"
            });
        }

        $scope.getAnotherColor = function(index) {
            $scope.colors = ['red', 'pink', 'purple', 'deep-purple', 'indigo', 'blue', 'light-blue', 'cyan', 'teal', 'green',
                'light-green', 'lime', 'yellow', 'amber', 'deep-orange', 'brown', 'grey', 'blue-grey'
            ];
            var totalNoOfColors = $scope.colors.length;
            return $scope.colors[index % totalNoOfColors];
        }

        $scope.addColumn = function(sfields) {
            for (var i in sfields) {
                var field = getValues(sfields[i]);
                if ($scope.finalSelectionFields.length == 0) {
                    field.sequence = ($scope.finalSelectionFields.length + 1);
                    $scope.finalSelectionFields.push(field);
                } else {
                    var unique = isUniqueSelection(sfields[i]);
                    if (unique == undefined) {
                        field.sequence = ($scope.finalSelectionFields.length + 1);
                        $scope.finalSelectionFields.push(field);
                    }
                }
            }
        }

        $scope.moveUp = function(fsfields) {
            for (var i in fsfields) {
                var field = JSON.parse(fsfields[i]);
                if ($scope.finalSelectionFields.length > 1) {
                    for (var j in $scope.finalSelectionFields) {
                        if ($scope.finalSelectionFields[j].fieldname == field.fieldname) {
                            swap($scope.finalSelectionFields, j, (j - 1))
                        }
                    }
                }
            }
        }

        $scope.moveDown = function(fsfields) {
            for (var i in fsfields) {
                var field = JSON.parse(fsfields[i]);
                if ($scope.finalSelectionFields.length > 1) {
                    for (var j in $scope.finalSelectionFields) {
                        if ($scope.finalSelectionFields[j].fieldname == field.fieldname) {
                            swap($scope.finalSelectionFields, j, (parseInt(j) + 1))
                            return;
                        }
                    }
                }
            }
        }

        $scope.delColumn = function(fsfields) {
            for (var i in fsfields) {
                for (var j in $scope.finalSelectionFields) {
                    if ($scope.finalSelectionFields[j].fieldname == JSON.parse(fsfields[i]).fieldname) {
                        $scope.finalSelectionFields.splice(j, 1);
                    }
                }
            }
        }

        function getValues(fieldname) {
            for (var i in $scope.selectionfields) {
                if ($scope.selectionfields[i].fieldname == fieldname) {
                    return $scope.selectionfields[i];
                }
            }
        }

        function isUniqueSelection(fieldname) {
            for (var i in $scope.finalSelectionFields) {
                if ($scope.finalSelectionFields[i].fieldname == fieldname) {
                    return false;
                }
            }
        }

        function swap(input, index_A, index_B) {
            if (undefined != input[index_B]) {
                var temp = input[index_A];
                var seq_A = input[index_A].sequence;
                input[index_A] = input[index_B];
                input[index_B] = temp;
                input[index_B].sequence = input[index_A].sequence;
                input[index_A].sequence = seq_A;
            }
        }

        $scope.showIconsList = function(ev) {
            $mdDialog.show({
                controller: ReportlogoDialogController,
                templateUrl: 'app/main/reports/report/report.logo.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                preserveScope: true,
                autoWrap: true,
                skipHide: true, // this line does the trick for nested dialogs
                fullscreen: $scope.customFullscreen // Only for -xs, -sm breakpoints.
            });
        };

        function ReportlogoDialogController($scope, $mdDialog, RestAPIService) {
            $scope.icons = Icons.icons;
            $scope.noOfIconsForDisplay = 50;
            $scope.iconsPerColumn = 5;

            $scope.loadMoreIcons = function() {
                $scope.noOfIconsForDisplay += 10;
            };

            $scope.saveLogo = function(siteIcon) {
                repCtrl.icon = siteIcon;
                $mdDialog.hide();
            };
        }

        $scope.loadMoreIcons = function() {
            $scope.noOfIconsForDisplay += 10;
        };

        $scope.saveLogo = function(siteIcon) {
            $scope.currentreportvalue = siteIcon;
            $mdDialog.hide();
        };

        $scope.cancel = function() {
            $mdDialog.cancel();
        };

        $scope.toggleCheck = function(selectionfield, list, action) {
            if (action == 'DOCTYPEFIELDS') {
                var idx = list.map(function(d) {
                    return d['name'];
                }).indexOf(selectionfield.name)
                if (idx > -1) {
                    list.splice(idx, 1);
                } else {
                    list.push(selectionfield);
                }
                $scope.finalDocTypeFields = list;
            } else {
                var idx = list.map(function(d) {
                    return d['fieldname'];
                }).indexOf(selectionfield.fieldname)
                if (idx > -1) {
                    list.splice(idx, 1);
                } else {
                    list.push(selectionfield);
                }
                if (action == 'OUTPUTFIELDS') {
                    $scope.finalOutData = list;
                } else if (action == 'FILTEREDFIELDS') {
                    $scope.finalFilterData = list;
                }
            }
        };

        $scope.exist = function(selectionfields, list, action) {
            for (var i in list) {
                if (action == 'DOCTYPEFIELDS') {
                    if (list[i].name == selectionfields.name) {
                        return true;
                    }
                } else {
                    if (list[i].fieldname == selectionfields.fieldname) {
                        return true;
                    }
                }
            }
        };

        $scope.getLabelValue = function(list, action) {
            if (action == 'FILTEREDFIELDS') {
                for (var i in $scope.selectedFilter) {
                    if ($scope.selectedFilter[i].fieldname == list.fieldname) {
                        return $scope.selectedFilter[i];
                    }
                }
            } else if (action == 'DOCTYPEFIELDS') {
                for (var i in $scope.selectedAttr) {
                    if ($scope.selectedAttr[i].name == list.name) {
                        return $scope.selectedAttr[i];
                    }
                }
            } else if (action == 'OUTPUTFIELDS') {
                for (var i in $scope.selectedOutFl) {
                    if ($scope.selectedOutFl[i].fieldname == list.fieldname) {
                        return $scope.selectedOutFl[i];
                    }
                }
            }
        }

        $scope.selectedModule = function(reportModule) {
            $scope.reportInfo.reportSpecific = null;
            if (reportModule != null) {
                $scope.getReportTypeFields(reportModule);
            }
        }

        $scope.getReportTypeFields = function(reportModule) {
            RestAPIService.getreporttypefields(reportModule).then(function(response) {
                    var data = [];
                    for (var i = 0; i <= response.data.length - 1; i++) {
                        var str1 = response.data[i].split("@");
                        if (str1[1] != 'object' && str1[0] != '_class') {
                            if (str1[0] == '_id') {
                                data.push({
                                    "fieldname": "id",
                                    "type": str1[1]
                                });
                            } else {
                                data.push({
                                    "fieldname": str1[0],
                                    "type": str1[1]
                                });
                            }
                        }
                    }
                    $scope.selectionfields = angular.copy(data);
                    $scope.outputfields = angular.copy(data);
                    $scope.filterfields = angular.copy(data);
                },
                function(error) {
                    RestAPIService.showErrorDialog(error);
                })
            return $scope.reportInfo.reportSpecific;
        }

        $scope.selectSpecificType = function(reportSpecific) {
            if (reportSpecific.length > 0) {
                for (var i in reportSpecific) {
                    if (reportSpecific[i] == 'docType') {
                        $scope.getDocumentTypes();
                    }
                }
            } else {
                $scope.docTypes = [];
                $scope.attributeObjects = [];
                $scope.finalDocTypeFields = [];
                $scope.reportInfo.docType = null;
            }
        };

        $scope.getDocumentTypes = function() {
            RestAPIService.getDocumentTypes().then(function(response) {
                    $scope.docTypes = [];
                    $scope.docTypes = response.data;
                },
                function(error) {
                    RestAPIService.showErrorDialog(error);
                });
        }

        $scope.selectDocType = function(docType) {
            if (docType != null) {
                RestAPIService.getDocumentTypeAttributes(docType).then(function(responce) {
                        $scope.attributeObjects = [];
                        $scope.attributeObjects = responce.data.attributes;
                        if (responce.data.attributes == null) {
                            alert("No Attributes for selected DocumentType");
                        }
                    },
                    function(error) {
                        RestAPIService.showErrorDialog(error);
                    });
            }
        };

        $scope.submitReport = function(action) {
            if (!$scope.reportInfo.skipSelection) {
                for (var i in $scope.finalSelectionFields) {
                    if ($scope.finalSelectionFields[i].label == undefined) {
                        $scope.finalSelectionFields[i].label = $scope.finalSelectionFields[i].fieldname;
                    }
                    if ($scope.finalSelectionFields[i].requiredflag == undefined) {
                        $scope.finalSelectionFields[i].requiredflag = $scope.finalSelectionFields[i].requiredflag;
                    }
                }
                $scope.reportInfo.selectionfield = $scope.finalSelectionFields;
            }
            for (var i in $scope.finalOutData) {
                if ($scope.finalOutData[i].label == undefined) {
                    $scope.finalOutData[i].label = $scope.finalOutData[i].fieldname;
                }
            }
            for (var i in $scope.finalFilterData) {
                if ($scope.finalFilterData[i].label == undefined) {
                    $scope.finalFilterData[i].label = $scope.finalFilterData[i].fieldname;
                }
            }
            for (var i in $scope.finalDocTypeFields) {
                delete $scope.finalDocTypeFields[i].$$hashKey;
                if ($scope.finalDocTypeFields[i].label == undefined) {
                    $scope.finalDocTypeFields[i].label = $scope.finalDocTypeFields[i].name;
                }
            }

            $scope.reportInfo.doctypefield = $scope.finalDocTypeFields;
            $scope.reportInfo.outputfield = $scope.finalOutData;
            $scope.reportInfo.filterfield = $scope.finalFilterData;
            $scope.reportInfo.icon = repCtrl.icon;
            console.log("$scope.reportInfo : ", $scope.reportInfo)
         

            if (action == 'SAVE') {
                RestAPIService.savereportdata($scope.reportInfo).then(function(success) {
                        RestAPIService.successTostDialog(success.headers('X-smartportalApp-alert'));
                        $state.reload();
                    },
                    function(error) {
                        RestAPIService.showErrorDialog(error);
                    });
            } else if (action == 'UPDATE') {
                RestAPIService.updateReportData($scope.reportInfo).then(function(success) {
                        RestAPIService.successTostDialog(success.headers('X-smartportalApp-alert'));
                        $state.reload();
                    },
                    function(error) {
                        RestAPIService.showErrorDialog(error);
                    });
            }
        }

        $scope.deleteReport = function(reportname, reportid) {
            $scope.reportid = reportid;
            var confirm = $mdDialog.confirm()
                .title('Remove')
                .textContent(reportname + ' will be removed from Report' + ' , continue ?')
                .ok('Ok')
                .cancel('Cancel');
            $mdDialog.show(confirm).then(function(reportname, reportid) {
                RestAPIService.deletereport($scope.reportid).then(
                    function(responce) {
                        RestAPIService.successTostDialog('Report Deleted Successfully');
                        $state.reload();
                    },
                    function(error) {
                        RestAPIService.showErrorDialog(error);
                    }
                );
            }, function() {});
        }

        $scope.goToUpdateReport = function(report) {
            $scope.reportView = 1;
            $scope.getDocumentTypes();
            $scope.finalOutData = [];
            $scope.reportInfo = angular.copy(report);
            if (undefined != $scope.reportInfo.reportModule) {
                $scope.getReportTypeFields($scope.reportInfo.reportModule);
            }
            if (undefined != $scope.reportInfo.docType) {
                $scope.selectDocType($scope.reportInfo.docType);
            }
            $scope.finalSelectionFields = $scope.reportInfo.selectionfield;
            $scope.selectedAttr = $scope.reportInfo.doctypefield;
            $scope.selectedOutFl = $scope.reportInfo.outputfield;
            $scope.selectedFilter = $scope.reportInfo.filterfield;
            $scope.finalDocTypeFields = $scope.reportInfo.doctypefield;
            $scope.finalOutData = $scope.reportInfo.outputfield;
            $scope.finalFilterData = $scope.reportInfo.filterfield;
        }

        $scope.goBack = function(pageNo) {
            $scope.reportView = pageNo;
        }

        // for maintenance
        if ($state.current.name == "app.administration.reports.maintenance") {
            $scope.reportView = 0;
            $scope.getReportData();
        }

    }


})();
(function ()
{
    'use strict';

    angular
        .module('app.administration')
        .controller('MtrInboxConfgController', MtrInboxConfgController);

    /** @ngInject */
    function MtrInboxConfgController($state, $scope,$stateParams, RestAPIService, $filter, $mdDialog, $sce)
    {
        var MtrInCtrl = this;

        $("#vertical-navigation").hide();
        $("#content-container").css({ "margin-left": "0px" });

        $scope.goToPreviousState = function() {
           $state.go("app.mycontent_inbox");
           $("#vertical-navigation").show();
           $("#content-container").css({ "margin-left": "60px" });
        }

        MtrInCtrl.getInboxConfgData = function() {
            RestAPIService.getInboxConfgData().then(
                function(success) {
                    $scope.usersList = success.data;
                },
                function(error) {
                    RestAPIService.showErrorDialog(error);
                }
            );

        }


        $scope.createUserDialog = function(ev) {
            $mdDialog.show({
                controller: CreateUserDialogController,
                templateUrl: 'app/main/administration/mtrInbox-Confg/mtrcreateDialog.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: $scope.customFullscreen
            })
            $scope.cancel = function() {
                $scope.user = {};
            };
        };
        function CreateUserDialogController($scope, $mdDialog) {

          $scope.getRequests =function(){
            RestAPIService.getRequests().then(function(success){
               $scope.requestTypes =success.data;
            },
            function(error){

            });
        }
            $scope.hide = function() {
                $mdDialog.hide();
            };
            $scope.cancel = function() {
                $mdDialog.cancel();
            };
            $scope.save = function(user) {
                RestAPIService.createInboxConfg(user).then(
                    function(success) {
                        $mdDialog.hide();
                        RestAPIService.successTostDialog('Created Successfully');
                       $state.reload();
                    },
                    function(error) {
                        if(error.status == 400){
                            RestAPIService.successTostDialog(error.headers('X-smartportalApp-defaultMessage'));

                            return false;

                        }
                     }

                );


            };
        }

        MtrInCtrl.currentUser = {};
        $scope.updateUserDialog = function(ev,user) {
            MtrInCtrl.currentUser = angular.copy(user);
             $mdDialog.show({
                controller: UpdateUserDialogController,
                templateUrl: 'app/main/administration/mtrInbox-Confg/mtrUpdateDialog.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: $scope.customFullscreen
            })
            $scope.cancel = function() {
                $scope.user = {};
            };
        };
        function UpdateUserDialogController($scope, $mdDialog) {
            $scope.currentUser = MtrInCtrl.currentUser;
            $scope.hide = function() {
                $mdDialog.hide();
            };
            $scope.cancel = function() {
                $mdDialog.cancel();
            };

            $scope.updatesave = function(user) {
                RestAPIService.updateInboxConfg(user).then(
                    function(success) {
                        RestAPIService.successTostDialog('Updated Successfully');
                        $state.reload();
                    },
                    function(error) {
                        RestAPIService.showErrorDialog(error);
                    }
                );
                $mdDialog.hide(user);
            };
        }

        MtrInCtrl.deleteUser = function(ev, user) {
            var confirm = $mdDialog.confirm()
                .title('Remove')
                .textContent( "will be permanently deleted. Continue" )
                .targetEvent(ev)
                .ok('Ok')
                .cancel('Cancel');
            $mdDialog.show(confirm).then(function() {

                RestAPIService.deleteInboxConfg(user.id).then(
                    function(success) {
                        RestAPIService.successTostDialog('User Deleted Successfully');
                        $state.reload();
                    },
                    function(error) {
                        RestAPIService.showErrorDialog(error);
                    }
                );
            }, function() {
                $mdDialog.cancel();
            });
        }
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.administration')
        .controller('LMController', LMController);

    /** @ngInject */
    function LMController($state, $scope,$mdDialog,RestAPIService,$filter,$localStorage)
    {
        var listCtrl = this;
        $scope.onselect = true;
        
        $("#vertical-navigation").hide();
        $("#content-container").css({ "margin-left": "0px" });

        $scope.goToPreviousState = function() {
        	$state.go("app.mycontent_inbox");
         	$("#vertical-navigation").show();
         	$("#content-container").css({ "margin-left": "60px" });
         }
           if ($localStorage.menubarsetting != undefined) {
                     $scope.showsForms = $localStorage.menubarsetting.formsmanagement;
                      $scope.showWorkflow = $localStorage.menubarsetting.adminWorkflow; 
                     $scope.showrequestManagement = $localStorage.menubarsetting.requestManagement;
                     $scope.showListManagement = $localStorage.menubarsetting.listManagement;
                     $scope.showBusinessObject = $localStorage.menubarsetting.businessObject;
                     $scope.showBinder = $localStorage.menubarsetting.binder;
                     $scope.showTemplates = $localStorage.menubarsetting.templates;
                     $scope.showReports1 = $localStorage.menubarsetting.adminReports;
                  
                    
                     $scope.showSubstitution = $localStorage.menubarsetting.substitution;
                     $scope.showZohoReports = $localStorage.menubarsetting.zohoReports;
                     
                      $scope.showDocumentType  = $localStorage.menubarsetting.documentTypes; 
                       $scope.showReqTypeDetails  = $localStorage.menubarsetting.reqTypeDetails; 
                          $scope.showInvoiceTypes  = $localStorage.menubarsetting.invoiceTypes;       
                     
            }
        
        
        listCtrl.dtOptions = {
                dom: '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
                pagingType: 'simple',
                autoWidth: false,
                responsive: true,
            };
        
            RestAPIService.getlistdata().then(
                function(success) {
                    $scope.listdata = success.data;

                },
                function(error) {
                    RestAPIService.showErrorDialog(error);
                }
            );

        
        $scope.createListDialog = function(ev) {
            $mdDialog.show({
                controller: createListDialogController,
                templateUrl: 'app/main/administration/list-management/createlist-dialog.html',  
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: $scope.customFullscreen
            })
            $scope.cancel = function() {

            };
        }
        
        $scope.onTabSelected = function(data){
        	console.log("onTabSelected...........")
        } 
        
        function createListDialogController($scope, $mdDialog, RestAPIService)
        {
            $scope.list = {};
            $scope.hide = function() {
                $mdDialog.hide();
            };

            $scope.cancel = function() {
                $mdDialog.cancel();
            };
            $scope.save = function(list) {
                RestAPIService.createList(list).then(
                    function(success) {
                        RestAPIService.successTostDialog(success.headers('X-smartportalApp-alert'));
                        //alert(success.headers('X-smartportalApp-alert'));
                        $state.reload();
                    },
                    function(error) {
                        alert(error.headers('X-smartportalApp-defaultMessage'));
                        RestAPIService.showErrorDialog(error);
                    }
                );
                $mdDialog.hide(list);
            };
        }
        
        
        $scope.updatelistDialog = function(ev) {
        	 var datares = $filter('filter')($scope.listdata, {'id': ev.id});
        	listCtrl.currentList = angular.copy(datares[0]);
            $mdDialog.show({
                controller: updateListDialogController,
                templateUrl: 'app/main/administration/list-management/updatelist-dialog.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: $scope.customFullscreen
            })
        };
        
        
        function updateListDialogController($scope, $mdDialog, RestAPIService)
        {
            $scope.currentList = listCtrl.currentList;

            $scope.hide = function() {
                $mdDialog.hide();
            };
            $scope.cancel = function() {
                $mdDialog.cancel();
            };
            $scope.update = function(list) {
            	console.log(list);
                RestAPIService.updateList(list).then(
                    function(success) {
                        RestAPIService.successTostDialog(success.headers('X-smartportalApp-alert'));
                        $state.reload();
                    },
                    function(error) {
                        RestAPIService.showErrorDialog(error);
                    }
                );
                $mdDialog.hide(list);
            };
        }
        
        

        $scope.deletelist = function(ev) {
        	 var datares = $filter('filter')($scope.listdata, {'id': ev.id});
            var confirm = $mdDialog.confirm()
                .title('Remove')
                .textContent('list' + datares[0].name + ' ' + ' will be permanently deleted. Continue ?')
                .targetEvent(ev)
                .ok('Ok')
                .cancel('Cancel');
            $mdDialog.show(confirm).then(function() {

                    RestAPIService.delete(datares[0].id).then(
                        function(success) {
                            RestAPIService.successTostDialog(success.headers('X-smartportalApp-alert'));

                            $state.reload();
                        },
                        function(error) {
                            RestAPIService.showErrorDialog(error);
                        }
                    );
                },
                function() {
                    $mdDialog.cancel();
                });
        }
        
        
        $scope.ListAttributesDialog = function(ev) {
        	 var datares = $filter('filter')($scope.listdata, {'id': ev.id});
        	listCtrl.currentList = datares[0];
            $mdDialog.show({
                controller: ListAttributesDialogController,
                templateUrl: 'app/main/administration/list-management/attributes.list.html', 
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: $scope.customFullscreen
            })
            $scope.cancel = function() {};
        };
        
      
        function ListAttributesDialogController($scope, $mdDialog) {
            $scope.dtOptions1 = {
                    dom: '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
                    paging: false,
                    searching: false,
                    lengthChange: false,
                    autoWidth: false,
                    responsive: false,
                    info: false,
                    columnDefs: [
                    { orderable: false, targets: [0,1,2,3,4,5,6,7] },
                  ]
                };
            
        	$scope.showupdate = true;
            $scope.attributes = listCtrl.currentList.attributes;
            $scope.currentList = listCtrl.currentList;
            $scope.attributeTypes = ['String', 'Number', 'Date'];
            $scope.hide = function() {
                $mdDialog.hide();
            };
            $scope.cancel = function() {
                $mdDialog.cancel();
            };

            $scope.addNewAttribute = function() {
                var newAttribute = {
                    fieldname: '',
                    type: 'String',
                    length:'',
                    label:'',
                    outputfieldflag:false,
                    filterfleldflag: false

                }
                if ($scope.attributes == null) $scope.attributes = [];
                $scope.attributes.push(newAttribute);
            };
            $scope.removeAttribute = function(ev) {
                $scope.attributes.splice(ev.id, 1);
            };
            $scope.save = function() {
            	$scope.currentList.attributes = $scope.attributes;
                RestAPIService.updateList($scope.currentList).then(
                    function(success) {
                        $state.reload();
                    },
                    function(error) {
                        RestAPIService.showErrorDialog(error);
                    }
                );
                $mdDialog.hide();
                $mdDialog.show(
                    $mdDialog.alert()
                    .clickOutsideToClose(true)
                    .title('Success!')
                    .textContent('Attributes of ' + listCtrl.currentList.name + ' has been successfully updated')
                    .ok('Ok')
                );
            };
            
            $scope.setunioutputflag = function(id){
            	console.log("id is............", id);
            	for(var i=0;i<=$scope.attributes.length-1;i++){
            		if($scope.attributes[i].id == id){
            			$scope.attributes[i].outputfieldflag = true;
            		}
            		else{
            			$scope.attributes[i].outputfieldflag = false;
            		}
            	}
            	for(var i=0;i<=$scope.attributes.length-1;i++){
            		if($scope.attributes[i].outputfieldflag == true){
            		  	for(var i=0;i<=$scope.attributes.length-1;i++){
                    		if($scope.attributes[i].descriptionflag == true){
                    			$scope.showupdate = false;
                    		}
                    		}
            		}
            	}
            	
            }
            $scope.setunidescflag = function(id){
               	for(var i=0;i<=$scope.attributes.length-1;i++){
            		if($scope.attributes[i].id == id){  
            			$scope.attributes[i].descriptionflag = true;
            		}
            		else{
            			$scope.attributes[i].descriptionflag = false;
            		}
            	}
            	for(var i=0;i<=$scope.attributes.length-1;i++){
            		if($scope.attributes[i].descriptionflag == true){
            		  	for(var i=0;i<=$scope.attributes.length-1;i++){
                    		if($scope.attributes[i].outputfieldflag == true){
                    			$scope.showupdate = false;
                    		}
                    		}
            		}
            	}
            }     
            function init(){
            	if($scope.attributes !=null || $scope.attributes !=undefined){
                   	for(var i=0;i<=$scope.attributes.length-1;i++){
                		if($scope.attributes[i].descriptionflag == true){
                		  	for(var i=0;i<=$scope.attributes.length-1;i++){
                        		if($scope.attributes[i].outputfieldflag == true){
                        			$scope.showupdate = false;
                        		}
                        		}
                		}
                	}
            	}

            }
            init();

        }
        
        }   
})();
(function () {
	'use strict';
	angular
		.module('app.administration')
		.controller('InvoicetypeListController', InvoicetypeListController);

	function InvoicetypeListController($scope, $mdDialog, $state, RestAPIService,$localStorage) {
        var invoiceCtrl = this;
        

        $("#vertical-navigation").hide();
        $("#content-container").css({ "margin-left": "0px" });

        $scope.goToPreviousState = function() {
           $state.go("app.mycontent_inbox");
           $("#vertical-navigation").show();
           $("#content-container").css({ "margin-left": "60px" });
        }
        $scope.gotoPR_Request =function(){
                $state.go('app.administration.pr_request',{type:'pr_type'})
        }
        invoiceCtrl.goToVendor_Request =function(){
                $state.go('app.administration.vendor_request',{type:'vendor_request'})
        }	
		  if ($localStorage.menubarsetting != undefined) {
                     $scope.showsForms = $localStorage.menubarsetting.formsmanagement;
                      $scope.showWorkflow = $localStorage.menubarsetting.adminWorkflow; 
                     $scope.showrequestManagement = $localStorage.menubarsetting.requestManagement;
                     $scope.showListManagement = $localStorage.menubarsetting.listManagement;
                     $scope.showBusinessObject = $localStorage.menubarsetting.businessObject;
                     $scope.showBinder = $localStorage.menubarsetting.binder;
                     $scope.showTemplates = $localStorage.menubarsetting.templates;
                     $scope.showReports1 = $localStorage.menubarsetting.adminReports;
                  
                    
                     $scope.showSubstitution = $localStorage.menubarsetting.substitution;
                     $scope.showZohoReports = $localStorage.menubarsetting.zohoReports;
                     
                      $scope.showDocumentType  = $localStorage.menubarsetting.documentTypes;   
                       $scope.showReqTypeDetails  = $localStorage.menubarsetting.reqTypeDetails; 
                          $scope.showInvoiceTypes  = $localStorage.menubarsetting.invoiceTypes;     
                     
            }
        
     
	}
})();
(function() {
    'use strict';

    angular
        .module('app.administration')
        .controller('FMController', FMController);

    /** @ngInject */
    function FMController($state, $stateParams,$scope, $mdDialog, RestAPIService, $sce,$localStorage) {
        var requestCtrl = this;
        $scope.priceVars = ["INC", "DEC"];
        $scope.rows = ["1", "2", "3"];
        $scope.customerGroups = ["MISC", "AMREP"];
        $scope.CMCFDidtributionChannels = ["DI-DIRECT", "DM-DEEMED"];
        $scope.paymentTerms = ["PT01 NET DUE AFTER 30 DAYS", "PT02 NET DUE AFTER 45 DAYS"];
        $scope.salesAreas = ["South", "East"];
        $scope.salesOffices = ["KARNATAKA", "DELHI"];
        $scope.taxes = ["CST with C from 2%", "SERVICE TAX APPLICABLE / NOT APPLICABLE"];
        $scope.request = {};
        $("#vertical-navigation").hide();
        $("#content-container").css({ "margin-left": "0px" });
        $scope.lineItems = [{
    		sNo : null,
    		baseUnit : null,
    		current : null,
    		materialCode : null,
    		newPrice : null,
    		oldPrice : null,
    		pricePer : null,
    		priceVar : null,        		
    		validFrom : null,
    		validTo : null
        }];

          if ($localStorage.menubarsetting != undefined) {
                     $scope.showsForms = $localStorage.menubarsetting.formsmanagement;
                      $scope.showWorkflow = $localStorage.menubarsetting.adminWorkflow; 
                     $scope.showrequestManagement = $localStorage.menubarsetting.requestManagement;
                     $scope.showListManagement = $localStorage.menubarsetting.listManagement;
                     $scope.showBusinessObject = $localStorage.menubarsetting.businessObject;
                     $scope.showBinder = $localStorage.menubarsetting.binder;
                     $scope.showTemplates = $localStorage.menubarsetting.templates;
                     $scope.showReports1 = $localStorage.menubarsetting.adminReports;
                  
                    
                     $scope.showSubstitution = $localStorage.menubarsetting.substitution;
                     $scope.showZohoReports = $localStorage.menubarsetting.zohoReports;
                     
                      $scope.showDocumentType  = $localStorage.menubarsetting.documentTypes;   
                       $scope.showReqTypeDetails  = $localStorage.menubarsetting.reqTypeDetails; 
                          $scope.showInvoiceTypes  = $localStorage.menubarsetting.invoiceTypes;     
                     
            }
        
        $scope.addLineItem = function() {
        	$scope.lineItems.push({
        		sNo : null,
        		baseUnit : null,
        		current : null,
        		materialCode : null,
        		newPrice : null,
        		oldPrice : null,
        		pricePer : null,
        		priceVar : null,        		
        		validFrom : null,
        		validTo : null
            });
        }
        $scope.removeLineItem = function(index) {
        	$scope.lineItems.splice(index, 1);
        }
        $scope.goToPreviousState = function() {
        	$state.go("app.mycontent_inbox");
         	$("#vertical-navigation").show();
         	$("#content-container").css({ "margin-left": "60px" });
         }
        $scope.selectForm = function(form) {
            var headerContent = form.content;
            var headerContentWithQuotes = headerContent.replace(/&quot;/g,'"');
            form.content = headerContentWithQuotes;

            var lineitemContent = form.lineItemContent;
            var lineitemContentWithQuotes = lineitemContent.replace(/&quot;/g,'"');
            form.lineItemContent = lineitemContentWithQuotes;

            //alert(lineitemContentWithQuotes);
            $scope.headerForm= {};
            $state.go('app.administration.forms.content',{'requestId': form.id, 'currentForm':form});
        }
      
        $scope.getAnotherColor = function(index) {
            $scope.colors = ['green-bg white-fg', 'orange-bg white-fg', 'pink-bg white-fg', 'blue-grey-bg white-fg', 'back-bg white-fg'];
            var totalNoOfColors = $scope.colors.length;
            return $scope.colors[index % totalNoOfColors];
        }
       
        $scope.getAnotherIcon = function(index) {
            $scope.icons = ['icon-account', 'icon-cash-100', 'icon-account-switch', 'icon-file-document', 'icon-cash-usd', 'icon-chart-bar'];
            var totalNoOfIcons = $scope.icons.length;
            return $scope.icons[index % totalNoOfIcons];
        }
        
        $scope.setAttachmentFile = function(element) {
            var formData = new FormData();
            $scope.$apply(function() {
                $scope.attachmentfiles = [];
                for (var i = 0; i < element.files.length; i++) {
                    formData.append('file', element.files[i]);
                    $scope.attachmentfiles.push(element.files[i]);
                }
            });
        };

        requestCtrl.getRequestForms = function() {
            RestAPIService.getRequestForms(0,100).then(
                function(success) {
                    $scope.forms = success.data;
                },
                function(error) {
                    RestAPIService.showErrorDialog(error);
                });
        };

        $scope.createRequest = function(ev) {
            $mdDialog.show({
                controller: CreateRequestDialogController,
                templateUrl: 'app/main/administration/forms-management/formCreation.html', 
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: $scope.customFullscreen
            })
        };

        function CreateRequestDialogController($scope, $http, RestAPIService, $mdDialog, $state, $window) {
        	
        	 $scope.attributes = [];
        	 $scope.Types =["String","Number","List"]
             $scope.addNewAttribute = function() {
                 var newAttribute = {
                    fieldName: '',
                    label: '',
                    type:'',
                    length:'',
                    requiredField:false,
                    possibleValues:'e.g. A,B,C',
                    barcodeEnabled:false,
                    mobileEnabled:false
                   
                    
                           }                
                 if ($scope.attributes == null) $scope.attributes = [];
                 $scope.attributes.push(newAttribute);
             };
             $scope.removeAttribute = function(index) {
                 $scope.attributes.splice(index, 1);
             };
             
            var formData = new FormData();
            $scope.setHeaderFile = function(element) {
                $scope.$apply(function() {
                    $scope.headerfiles = [];
                    for (var i = 0; i < element.files.length; i++) {
                        formData.append('file', element.files[i]);
                        $scope.headerfiles.push(element.files[i]);
                    }
                });
            };
            $scope.setLineItemFile = function(element) {
                $scope.$apply(function() {
                    $scope.lineitemfiles = [];
                    for (var i = 0; i < element.files.length; i++) {
                        formData.append('file', element.files[i]);
                        $scope.lineitemfiles.push(element.files[i]);
                    }
                });
            };

            $scope.hide = function() {
                $mdDialog.hide();
            };
            $scope.cancel = function() {
                $mdDialog.cancel();
            };
            $scope.uploadRequestForm = function(request) {
            	

            	var json = JSON.stringify( $scope.attributes, function( key, value ) {
            	    if( key === "$$hashKey" ) {
            	        return undefined;
            	    }

            	    return value;
            	});
           RestAPIService.uploadRequestForm($scope.headerfiles[0],$scope.lineitemfiles[0],request.name, request.description,json).then(
                    function(success) {
                        requestCtrl.getRequestForms();
                    },
                    function(error) {
                        RestAPIService.showErrorDialog(error);
                    }
                );
                $mdDialog.cancel();
            }

        }
        $scope.UpdateForm = function(ev,form) {
        	requestCtrl.UpdateForm =angular.copy(form)
            $mdDialog.show({
                controller: UpdateRequestDialogController,
                templateUrl: 'app/main/administration/forms-management/formUpdate.html', 
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: $scope.customFullscreen
            })
        };
        function UpdateRequestDialogController($scope, $http, RestAPIService, $mdDialog, $state, $window) {
        	$scope.Types =["String","Number","List"];
        $scope.CurrentForm = requestCtrl.UpdateForm;       
        $scope.attributes =requestCtrl.UpdateForm.formFieldsHeader;
       
   	    $scope.addNewAttribute = function() {
            var newAttribute = {
               fieldName: '',
               label: '',
               type:'',
               length:'',
               requiredField:false,
               possibleValues:'e.g. A,B,C',
               barcodeEnabled:false,
               mobileEnabled:false
                      }                
            if ($scope.attributes == null) $scope.attributes = [];
            $scope.attributes.push(newAttribute);
        };
        $scope.removeAttribute = function(index) {
            $scope.attributes.splice(index, 1);
        };
        var formData = new FormData();
        $scope.setHeaderFile = function(element) {
            $scope.$apply(function() {
                $scope.headerfiles = [];
                for (var i = 0; i < element.files.length; i++) {
                    formData.append('file', element.files[i]);
                    $scope.headerfiles.push(element.files[i]);
                }
            });
        };
        $scope.setLineItemFile = function(element) {
            $scope.$apply(function() {
                $scope.lineitemfiles = [];
                for (var i = 0; i < element.files.length; i++) {
                    formData.append('file', element.files[i]);
                    $scope.lineitemfiles.push(element.files[i]);
                }
            });
        };       
        
        $scope.updateRequestForm = function(request) {
        	var json = JSON.stringify( $scope.attributes, function( key, value ) {
        	    if( key === "$$hashKey" ) {
        	        return undefined;
        	    }
        	    return value;
        	});
       RestAPIService.updateRequestForm($scope.headerfiles[0],$scope.lineitemfiles[0],request.name,request.id, request.description,json).then(
                function(success) {
                    requestCtrl.getRequestForms();
                },
                function(error) {
                    RestAPIService.showErrorDialog(error);
                }
            );
            $mdDialog.cancel();
        }
        
        $scope.hide = function() {
            $mdDialog.hide();
        };
        $scope.cancel = function() {
            $mdDialog.cancel();
        };
        
        
        
        
        
        
        }
       
        
        
        $scope.sendFormData = function(headerForm, lineitemForm){ 
        	
        	var header = {};
        	var lineItems = {}; 
        	var json = {};
        	header.accountGroup = headerForm.accountGroup;
        	header.channel = headerForm.channel;
        	header.conditionType = headerForm.conditionType;
        	header.customerCode = headerForm.customerCode;
        	header.customerName = headerForm.customerName;
        	header.organisation = headerForm.organisation;
        	header.type = headerForm.type;
        	 	
        	for (var i in $scope.lineItems){
        		lineItems[i] = $scope.lineItems[i];
        	}
        	
        	json.docType = 'PR_PROCESS';
        	json.description = $scope.request.comment;
        	json.header = header;
        	json.lineItems = lineItems;
        	
            RestAPIService.sendFormData(json, $scope.attachmentfiles).then(
                function(success) {
                    console.log("success :: ",success)
                },
                function(error) {
                    RestAPIService.showErrorDialog(error);
            });
            
           
        }
        
        function viewForm(data){
            $scope.currentFormName = data.name;
            $scope.currentFormHeader = $sce.trustAsHtml(data.content.replace(/&quot;/g,'"'));
            $scope.currentFormLineitem = $sce.trustAsHtml(data.lineItemContent.replace(/&quot;/g,'"'));
        }
        
        // Initial load
        init();

        function init(){
            if($stateParams.currentForm == undefined && $stateParams.requestId != undefined){
                RestAPIService.getRequestFormById($stateParams.requestId).then(
                    function(success) {
                        viewForm(success.data);
                    },
                    function(error) {
                        RestAPIService.showErrorDialog(error);
                });
            } else if($stateParams.currentForm){
                 viewForm($stateParams.currentForm);
           }
        }
        $scope.createFormDiv = true;
        var data = [];
//         jQuery(function($) {
//         	$('#previewForm').hide();
//         	$('#submitDiv').hide();
//            	var fbEditor = document.getElementById('build-wrap');
//            	/* var formBuilder = $(fbEditor).formBuilder(); */
//            	var options = {
//            	        dataType: 'json',
//            	        defaultFields: []
//            	      };
//            	  var formBuilder = $(fbEditor).formBuilder(options);
           
//            	  document.getElementById('clear-all-fields').onclick = function() {
//            	    formBuilder.actions.clearFields();
//            	    $('#submitDiv').hide();
//            	  };
//            	document.getElementById('getJSONAndSave').addEventListener('click', function() {           	   
//            	    console.log(formBuilder.actions.getData('json'));
//            	    data = formBuilder.actions.getData('json');
//            	    $('#submitDiv').show();
//            	  });
//         	document.getElementById('preview').addEventListener('click', function() {
//         		 $('.fb-render').formRender({
//         			    dataType: 'json',
//         			    formData: formBuilder.actions.getData('json')
//         			  });        		 
// //        		 formData = formBuilder.actions.getData('json');
//         		 $('#createFormDiv').hide();
//         		 $('#previewForm').show();
//            	    console.log(formBuilder.actions.getData('json'));
//            	  });
//         	document.getElementById('edit').addEventListener('click', function() {
//         		$('#createFormDiv').show();
//        		 	$('#previewForm').hide();
//            	  });
           	
//          /*  	document.getElementById('getXML').addEventListener('click', function() {
//            	    alert(formBuilder.actions.getData('xml'));
//            	});
//            	*/
//            	});
        $scope.submitJsonForm = function(formData){        	        	
        	formData['fields'] = JSON.parse(data);
        	console.log(formData);
        	RestAPIService.createJsonForm(formData).then(
                    function(success) {
                    	console.log(success.data);
                        $state.reload();
                    },
                    function(error) {
                        RestAPIService.showErrorDialog(error);
                    }
                );
        	
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.administration')
        .controller('emailBufferConfigController', emailBufferConfigController);


    function emailBufferConfigController($sce, $state,$scope,$filter,CommonUtil,$rootScope,$localStorage,$window,RestAPIService,$mdDialog,$location,$anchorScroll,$stateParams)
    {
        var emailBufCnfgCtr = this;
        $scope.searchmail=false;
        $("#vertical-navigation").hide();
        $("#content-container").css({ "margin-left": "0px" });

        if ($localStorage.menubarsetting != undefined) {
            $scope.showsForms = $localStorage.menubarsetting.formsmanagement;
            $scope.showrequestManagement = $localStorage.menubarsetting.requestManagement;
            $scope.showListManagement = $localStorage.menubarsetting.listManagement;
            $scope.showBusinessObject = $localStorage.menubarsetting.businessObject;
            $scope.showBinder = $localStorage.menubarsetting.binder;
            $scope.showTemplates = $localStorage.menubarsetting.templates;
            $scope.showReports1 = $localStorage.menubarsetting.adminReports;
            $scope.showsReports2 = $localStorage.menubarsetting.adminReports2;
            $scope.showILM = $localStorage.menubarsetting.ILM;
            $scope.showSystemLandscape = $localStorage.menubarsetting.systemLandscape;
            $scope.showAnnouncements = $localStorage.menubarsetting.announcements;
            $scope.showSubstitution = $localStorage.menubarsetting.substitution;
            $scope.showZohoReports = $localStorage.menubarsetting.zohoReports;
            $scope.showWorkspacetype = $localStorage.menubarsetting.workspaceType;
            $scope.showApprovalMatrix = $localStorage.menubarsetting.approvalMatrix;
            $scope.showEmailTemplates = $localStorage.menubarsetting.emailTemplates;
            $scope.showContractApprovals = $localStorage.menubarsetting.contractApprovals;
             $scope.showWorkflow = $localStorage.menubarsetting.adminWorkflow;
              $scope.showDocumentType  = $localStorage.menubarsetting.documentTypes;

   }

   $scope.goToPreviousState = function() {
    $state.go("app.overview");
     $("#vertical-navigation").show();
     $("#content-container").css({ "margin-left": "60px" });
  }
  $scope.sizeNumbers= [10,20,50,100,500,1000];
  $scope.pageNumber = 0;
  $scope.searchpageNumber=0;
  $scope.size= 100;
  $scope.next = function(){
    $scope.pageNumber = $scope.pageNumber + 1;
    console.log($scope.pageNumber)
    $scope.getEmailBuffers();


  }
  $scope.previous = function(){
       $scope.pageNumber = $scope.pageNumber - 1;
       $scope.getEmailBuffers();
  }
  $scope.sendPageNumber = function(page) {
      $scope.pageNumber = page;
      $scope.getEmailBuffers();
  }
  $scope.sendsizeNumber = function(sizeNumber){
      $scope.size =sizeNumber;
      $scope.pageNumber =0 ;
      $scope.getEmailBuffers();
  }
//   /searchemail
  $scope.searchnext = function(){
    $scope.searchpageNumber = $scope.searchpageNumber + 1;
    RestAPIService.searchAllEmailBuffers(emailBufCnfgCtr.searchData,$scope.searchpageNumber,$scope.size).then(
        function(success) {
           $scope.searchpageNumbers = [];
            $scope.allemailsBuffer= success.data.content;

            if($scope.allemailsBuffer.length>0){
                $scope.searchmail=true;
            }
            $scope.searchtotalRecords = success.data.totalElements;
            console.log($scope.searchtotalRecords)
           $scope.searchtotalPages = success.data.totalPages;
           console.log($scope.searchtotalPages)
          if ($scope.totalPages  > 0) {
           for (var i = 0; i < $scope.searchtotalPages; i++) {
               $scope.searchpageNumbers.push(i);
               }
          }
          console.log($scope.searchpageNumbers)
        },
        function(error) {
            RestAPIService.showErrorDialog(error);
        }
    );


  }
  $scope.searchprevious = function(){
       $scope.searchpageNumber = $scope.searchpageNumber - 1;
       RestAPIService.searchAllEmailBuffers(emailBufCnfgCtr.searchData,$scope.searchpageNumber,$scope.size).then(
        function(success) {
           $scope.searchpageNumbers = [];
            $scope.allemailsBuffer= success.data.content;

            if($scope.allemailsBuffer.length>0){
                $scope.searchmail=true;
            }
            $scope.searchtotalRecords = success.data.totalElements;
            console.log($scope.searchtotalRecords)
           $scope.searchtotalPages = success.data.totalPages;
           console.log($scope.searchtotalPages)
          if ($scope.totalPages  > 0) {
           for (var i = 0; i < $scope.searchtotalPages; i++) {
               $scope.searchpageNumbers.push(i);
               }
          }
          console.log($scope.searchpageNumbers)
        },
        function(error) {
            RestAPIService.showErrorDialog(error);
        }
    );
  }
  $scope.searchsendPageNumber = function(page) {
      $scope.searchpageNumber = page;
      RestAPIService.searchAllEmailBuffers(emailBufCnfgCtr.searchData,$scope.searchpageNumber,$scope.size).then(
        function(success) {
           $scope.searchpageNumbers = [];
            $scope.allemailsBuffer= success.data.content;

            if($scope.allemailsBuffer.length>0){
                $scope.searchmail=true;
            }
            $scope.searchtotalRecords = success.data.totalElements;
            console.log($scope.searchtotalRecords)
           $scope.searchtotalPages = success.data.totalPages;
           console.log($scope.searchtotalPages)
          if ($scope.totalPages  > 0) {
           for (var i = 0; i < $scope.searchtotalPages; i++) {
               $scope.searchpageNumbers.push(i);
               }
          }
          console.log($scope.searchpageNumbers)
        },
        function(error) {
            RestAPIService.showErrorDialog(error);
        }
    );
  }
  $scope.searchsendsizeNumber = function(sizeNumber){
      $scope.size =sizeNumber;
      $scope.searchpageNumber =0 ;
      RestAPIService.searchAllEmailBuffers(emailBufCnfgCtr.searchData,$scope.searchpageNumber,$scope.size).then(
        function(success) {
           $scope.searchpageNumbers = [];
            $scope.allemailsBuffer= success.data.content;

            if($scope.allemailsBuffer.length>0){
                $scope.searchmail=true;
            }
            $scope.searchtotalRecords = success.data.totalElements;
            console.log($scope.searchtotalRecords)
           $scope.searchtotalPages = success.data.totalPages;
           console.log($scope.searchtotalPages)
          if ($scope.totalPages  > 0) {
           for (var i = 0; i < $scope.searchtotalPages; i++) {
               $scope.searchpageNumbers.push(i);
               }
          }
          console.log($scope.searchpageNumbers)
        },
        function(error) {
            RestAPIService.showErrorDialog(error);
        }
    );
  }
  $scope.getEmailBuffers = function() {
    RestAPIService.getAllEmailBuffers($scope.pageNumber,$scope.size).then(
        function(success) {
           $scope.pageNumbers = [];
            $scope.allemailsBuffer = success.data;
            $scope.totalRecords = success.headers('x-total-count');
           $scope.totalPages = Math.ceil($scope.totalRecords/$scope.size);
          if ($scope.totalPages  > 0) {
           for (var i = 0; i < $scope.totalPages; i++) {
               $scope.pageNumbers.push(i);
               }
          }

        },
        function(error) {
            RestAPIService.showErrorDialog(error);
        }
    );

 }
 $scope.viewEmail=function(ev,data){
    emailBufCnfgCtr.emailContent= $sce.trustAsHtml(data);
    $mdDialog.show({
        controller: emailContentDialogController,
        templateUrl: 'app/main/administration/email-buffer/emailBuffer-dialog.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        fullscreen: $scope.customFullscreen
    })
    $scope.cancel = function() {
        $mdDialog.cancel();
    };
    function emailContentDialogController($scope, $mdDialog) {
        $scope.emailContent=emailBufCnfgCtr.emailContent;
        $scope.cancel = function() {
            $mdDialog.cancel();
        };

    }
 }
 $scope.obj = {};
 $scope.searchemail=function(data,date){

    if (date) {
        var startDate = new Date(date.startDate._d);
        startDate.setDate(startDate.getDate() + 1)
        var endDate = new Date(date.endDate._d);
        data.fromDate = startDate.toISOString();
        data.toDate = endDate.toISOString();
      } else {
        if (data) {
          data.fromDate = null;
          data.toDate = null;
        }
      }

   emailBufCnfgCtr.searchData={
    "fromDate": data.fromDate,
    "toDate": data.toDate,
    "subject":data.system
    // "fileName":"SORDashboardReports.csv"

    }
    RestAPIService.searchAllEmailBuffers(emailBufCnfgCtr.searchData,$scope.searchpageNumber,$scope.size).then(
        function(success) {
           $scope.searchpageNumbers = [];
            $scope.allemailsBuffer= success.data.content;
          console.log($scope.allemailsBuffer.length)
            if($scope.allemailsBuffer.length>0){
                $scope.searchmail=true;
            }
            $scope.searchtotalRecords = success.data.totalElements;
            console.log($scope.searchtotalRecords)
           $scope.searchtotalPages = success.data.totalPages;
           console.log($scope.searchtotalPages)
          if ($scope.totalPages  > 0) {
           for (var i = 0; i < $scope.searchtotalPages; i++) {
               $scope.searchpageNumbers.push(i);
               }
          }
          console.log($scope.searchpageNumbers)
        },
        function(error) {
            RestAPIService.showErrorDialog(error);
        }
    );

 }
 $scope.Reset=function(){
     $state.reload();
 }
 $scope.getEmailBuffers();

    }


})();

(function ()
{
    'use strict';

    angular
        .module('app.administration')
        .controller('DocumentTypeController', DocumentTypeController);

    /** @ngInject */
    function DocumentTypeController($state, $scope, $mdDialog, RestAPIService,DocumentTypes, $filter,$stateParams,$cookieStore,$localStorage)
    {
        var doctypeCrtl = this;
        if($stateParams.obj != undefined){
        	if($stateParams.obj.docType != undefined){
        		doctypeCrtl.docType = $stateParams.obj.docType;
        		doctypeCrtl.docTypeName = $stateParams.obj.docTypeName;
        		}
        	
        }
        if(doctypeCrtl.docType !=null){
      	  var json = {
           		 "docType" : $stateParams.obj.docType,
           		"docTypeName": $stateParams.obj.docTypeName
                }
      	  $cookieStore.put('docTypeData', json)
      	
      }
        var json = $cookieStore.get('docTypeData');
        if(doctypeCrtl.docType == undefined){
        	if(json !=undefined){
        		doctypeCrtl.docType = json['docType'];
        		doctypeCrtl.docTypeName = json['docTypeName'];
        		
        	}
        }
        
        
        
        if($localStorage.sitesettingdata !=null && $localStorage.sitesettingdata !=undefined){
         	$scope.sitedisplayname = $localStorage.sitesettingdata.sitedisplayname;
         	doctypeCrtl.sitedisname = $scope.sitedisplayname;
         }else{
         	$scope.sitedisplayname = "site";
         	doctypeCrtl.sitedisname = "site";
         }
         if ($localStorage.menubarsetting != undefined) {
                     $scope.showsForms = $localStorage.menubarsetting.formsmanagement;
                      $scope.showWorkflow = $localStorage.menubarsetting.adminWorkflow; 
                     $scope.showrequestManagement = $localStorage.menubarsetting.requestManagement;
                     $scope.showListManagement = $localStorage.menubarsetting.listManagement;
                     $scope.showBusinessObject = $localStorage.menubarsetting.businessObject;
                     $scope.showBinder = $localStorage.menubarsetting.binder;
                     $scope.showTemplates = $localStorage.menubarsetting.templates;
                     $scope.showReports1 = $localStorage.menubarsetting.adminReports;
                  
                    
                     $scope.showSubstitution = $localStorage.menubarsetting.substitution;
                     $scope.showZohoReports = $localStorage.menubarsetting.zohoReports;
                     
                      $scope.showDocumentType  = $localStorage.menubarsetting.documentTypes; 
                       $scope.showReqTypeDetails  = $localStorage.menubarsetting.reqTypeDetails; 
                          $scope.showInvoiceTypes  = $localStorage.menubarsetting.invoiceTypes;       
                     
            }
       $scope.documentsList = DocumentTypes.data;
        $scope.documentType = {};
        // doctypeCrtl.dtInstance = {};
        $("#vertical-navigation").hide();
        $("#content-container").css({
            "margin-left": "0px"
        });
        doctypeCrtl.dtOptions = {
            dom: '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            pagingType: 'simple',
            autoWidth: false,
            responsive: true
        };
        doctypeCrtl.goTomain = function() {
            $state.go('app.administration.documentType');
        }
        $scope.goTositeConfig = function(ev) {
        	console.log("ev............",ev.id);
        	var datares = $filter('filter')($scope.documentsList, {'id': ev.id});
            $state.go('app.administration.documentType.siteConfig',
            		{
                   	 obj: {
       	                  "docType": datares[0].id,
       	               "docTypeName": datares[0].name
       	               }
                   });
        }
        
        $scope.goToPreviousState = function() {
            $state.go("app.mycontent_inbox");
            $("#vertical-navigation").show();
            $("#content-container").css({
                "margin-left": "60px"
            });
        }
        doctypeCrtl.getDocumentTypes = function() {
            RestAPIService.getDocumentTypes().then(
                function(success) {
                    $scope.documentsList = success.data;

                },
                function(error) {
                    RestAPIService.showErrorDialog(error);
                }
            );

        }
        $scope.getForms = function(){
        	 RestAPIService.getRequestForms().then(
                     function(success) {
                    	 doctypeCrtl.forms = success.data;
                     	//alert(JSON.stringify(doctypeCrtl.forms));
                     },
                     function(error) {
                         RestAPIService.showErrorDialog(error);
                     });
        }
       
        
        function init(){ 
        	$scope.getForms();
        }
        //
        init();
        
        $scope.deleteDocumentType = function(ev) {
        	var datares = $filter('filter')($scope.documentsList, {'id': ev.id});
            var confirm = $mdDialog.confirm()
                .title('Remove')
                .textContent('Document Type ' + datares[0].name + ' ' + ' will be permanently deleted. Continue ?')
                .targetEvent(ev)
                .ok('Ok')
                .cancel('Cancel');
            $mdDialog.show(confirm).then(function() {

                    RestAPIService.deleteDocumentType(datares[0].id).then(
                        function(success) {
                            RestAPIService.successTostDialog('DocumentType Deleted Successfully');

                            $state.reload();
                        },
                        function(error) {
                            RestAPIService.showErrorDialog(error);
                        }
                    );
                },
                function() {
                    $mdDialog.cancel();
                });
        }
       
        
        $scope.createDocumentTypeDialog = function(ev) {
          alert("hiii")
            $mdDialog.show({
                controller: createDocumentTypeDialogController,
                templateUrl: 'app/main/administration/document-type/createdoctype.dialog.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: $scope.customFullscreen
            })
            $scope.cancel = function() {

            };
        };

        function createDocumentTypeDialogController($scope, $mdDialog, RestAPIService) {
                $scope.forms = doctypeCrtl.forms;
        	$scope.attributes = [];
            $scope.documentType = {};
            $scope.attributeTypes = ['String', 'Number', 'Date'];
            $scope.hide = function() {
                $mdDialog.hide();
            };

            $scope.cancel = function() {
                $mdDialog.cancel();
            };
           
            
            $scope.addNewAttribute = function() {
                var newAttribute = {
                    name: '',
                    type: 'String',
                    required: false
                }                
                if ($scope.attributes == null) $scope.attributes = [];
                $scope.attributes.push(newAttribute);
            };
            $scope.removeAttribute = function(index) {
                $scope.attributes.splice(index, 1);
            };
            
            $scope.save = function(document) {
            	$scope.documentType=document;
              alert(JSON.stringify($scope.documentType));
            	$scope.documentType.attributes =$scope.attributes;
             	if( $scope.attributes.length == 0){ 
               		$scope.Error ={message:'Please Enter Atleast One Attribute'};
               	 return false;  
                  }   
              RestAPIService.createDocumentType($scope.documentType).then(            		  
                 function(success) {               
                        RestAPIService.successTostDialog('DocumentType Created Successfully');                       
                        $state.reload();
                    },
                    function(error) {                     
                    	  $mdDialog.show(
                                  $mdDialog.alert()
                                  .clickOutsideToClose(true)
                                  .title('Error')
                                  .textContent(error.headers('X-smartportalApp-defaultMessage'))
                                  .ok('Ok')
                              );                       
                    }
                );
                $mdDialog.hide($scope.documentType);
            };
        }
        doctypeCrtl.currentDocType = {};
        $scope.updateDocumentTypeDialog = function(ev) {
        	 var datares = $filter('filter')($scope.documentsList, {'id': ev.id});
             doctypeCrtl.currentDocType = angular.copy(datares[0]);
            $mdDialog.show({
                controller: updateDocumentTypeDialogController,
                templateUrl: 'app/main/administration/document-type/updatedoctype.dialog.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: $scope.customFullscreen
            })
        };

        function updateDocumentTypeDialogController($scope, $mdDialog) {
        	$scope.forms = doctypeCrtl.forms
            $scope.currentDocType = doctypeCrtl.currentDocType;
            $scope.attributes = doctypeCrtl.currentDocType.attributes;
            $scope.attributeTypes = ['String', 'Number', 'Date'];
            
            $scope.addNewAttribute = function() {
                var newAttribute = {
                    name: '',
                    type: 'String',
                    required: false

                }                
                if ($scope.attributes == null) $scope.attributes = [];
                $scope.attributes.push(newAttribute);
            };
            $scope.removeAttribute = function(index) {
                $scope.attributes.splice(index, 1);
            };

            $scope.hide = function() {
                $mdDialog.hide();
            };
            $scope.cancel = function() {
                $mdDialog.cancel();
            };
            $scope.update = function(documentType) {
                RestAPIService.updateDocumentType(documentType).then(
                    function(success) {
                        RestAPIService.successTostDialog('DocumentType Updated Successfully');
                        $state.reload();
                    },
                    function(error) {
                        RestAPIService.showErrorDialog(error);
                    }
                );
                $mdDialog.hide(documentType);
            };
        }
       
        doctypeCrtl.getDocumentTypeSites = function() {
        	$scope.docTypeId = $stateParams.obj.docType;
            RestAPIService.getDocumentTypeSites($scope.docTypeId).then(
                function(success) {
                    doctypeCrtl.sites = success.data;
                    var numberOfSites = doctypeCrtl.sites.length;
                },
                function(error) {
                    RestAPIService.showErrorDialog(error);
                }
            );

        }
        
        doctypeCrtl.deleteSite = function( ev, site, siteData){   
        	$scope.docTypeId = $stateParams.obj.docType;
            var confirm = $mdDialog.confirm() 
            .title('Remove')               
            .textContent(site.name + ' will be removed for this Doctype, continue ?')            
            .targetEvent(ev)
            .ok('Ok')
            .cancel('Cancel');
            
            $mdDialog.show(confirm).then(function() {
                    RestAPIService.deleteDocumentTypesforSite($scope.docTypeId,site.id).then(
                        function(success){ 
                        	 RestAPIService.successTostDialog("Deleted Successfully");
                        	doctypeCrtl.getDocumentTypeSites($scope.docTypeId); 
                        },
                        function(error){
                           RestAPIService.showErrorDialog(error);
                        }
                    );    
            }, function() {
               //User clicked Cancel. Close the popup
            });
        };

        
        doctypeCrtl.currentDocType = {};
            $scope.addSiteDialog = function(ev,documentType){      
            	 doctypeCrtl.currentDocType = angular.copy(documentType);
                $mdDialog.show({
                    controller: AddSiteDialogController ,
                    templateUrl: 'app/main/administration/document-type/addSiteDialog.html',
                    parent: angular.element(document.body),
                    preserveScope: true,
                    autoWrap: true,
                    skipHide: true, 
                    targetEvent: ev,
                    clickOutsideToClose:true,
                    fullscreen: $scope.customFullscreen // Only for -xs, -sm breakpoints.
                })  
            }  
            function AddSiteDialogController($scope, $mdDialog,$stateParams,$localStorage) {
            	 if($localStorage.sitesettingdata !=null && $localStorage.sitesettingdata !=undefined){
                  	$scope.sitedisplayname = $localStorage.sitesettingdata.sitedisplayname;
                  	doctypeCrtl.sitedisname = $scope.sitedisplayname;
                  }else{
                  	$scope.sitedisplayname = "site";
                  	doctypeCrtl.sitedisname = "site";
                  }
            	 $scope.tableVisibility=false;
            	 $scope.cancel = function() {
                     $mdDialog.cancel();
                 };
                 $scope.ok= function(){
                     $mdDialog.cancel();
                 }
                 $scope.searchSite = function(queryname){
                	 $scope.searchedSites= [];                     
                     RestAPIService.searchSites(queryname).then(
                     function(success){
                         $scope.searchedSites = success.data;
                       //  alert(JSON.stringify($scope.searchedSites));
                         $scope.msgVisibility=false;
                         $scope.tableVisibility=true;
                         $scope.site = {};                        
                     },function(error){
                         RestAPIService.showErrorDialog(error);
                     }
                     );
                	 
                 }
                 $scope.addSite = function(siteData,documentType){
                	 $scope.site = {};  
                	 $scope.docTypeId = $stateParams.obj.docType;
                	 var siteId = siteData.id;
                	 RestAPIService.updateDocumentTypeSites($scope.docTypeId, siteId).then(
                             function(success){
                             	 RestAPIService.successTostDialog("added Successfully");	
                             	//$mdDialog.cancel();
                             	//alert(JSON.stringify(siteId)); 
                                 doctypeCrtl.getDocumentTypeSites($scope.docTypeId); 
                             },
                             function(error){
                                 RestAPIService.showErrorDialog(error);
                             }
                         );    
                	 
                 }
                 
            }
            
        $scope.configureApprovalDialog = function(ev) {
        	var datares = $filter('filter')($scope.documentsList, {'id': ev.id});
            doctypeCrtl.currentDocType = angular.copy(datares[0]);
            $mdDialog.show({
                controller: ConfigureApprovalDialogController,
                templateUrl: 'app/main/administration/document-type/configureapproval.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: $scope.customFullscreen
            })
            $scope.cancel = function() {};
        };

        function ConfigureApprovalDialogController($scope, $mdDialog,$filter) {
            $scope.configureApproval = {};
            $scope.configureApproval['docuemntApprovalConfig'] = {};
            // $scope.configureApproval.docuemntApprovalConfig = doctypeCrtl.currentDocType.docuemntApprovalConfig;
            $scope.attributes = doctypeCrtl.currentDocType.attributes;
            $scope.docId = doctypeCrtl.currentDocType.id;
            $scope.data = {};
            $scope.currentDocType = doctypeCrtl.currentDocType;
            $scope.ApprovalConfig = {};
            $scope.ApprovalConfig['docuemntApprovalConfig'] = {};
            $scope.allApprovers = [];
            $scope.durations = [{
                "days": "7 Days",
                "value": 7
            }, {
                "days": "10 Days",
                "value": 10
            }, {
                "days": "15 Days",
                "value": 15
            }, {
                "days": "30 Days",
                "value": 30
            }];
            $scope.searchElements = {
                type: 'user'
            };


            if (doctypeCrtl.currentDocType.docuemntApprovalConfig != null) {

                $scope.configureApproval = {
                    "id": null,
                    "docuemntApprovalConfig": {
                        "agents": [],
                        "approvalsRequired": [],
                        "approverRespondDuration": 0,
                        "requestApproved_notifyApprover": doctypeCrtl.currentDocType.docuemntApprovalConfig.requestApproved_notifyApprover,
                        "requestApproved_notifyRequester": doctypeCrtl.currentDocType.docuemntApprovalConfig.requestApproved_notifyRequester,
                        "requestDenied_notifyApprover": doctypeCrtl.currentDocType.docuemntApprovalConfig.requestDenied_notifyApprover,
                        "requestDenied_notifyRequester": doctypeCrtl.currentDocType.docuemntApprovalConfig.requestDenied_notifyRequester,
                        "requestExpires__notifyRequester": doctypeCrtl.currentDocType.docuemntApprovalConfig.requestExpires__notifyRequester,
                        "requestExpires_notifyApprover": doctypeCrtl.currentDocType.docuemntApprovalConfig.requestExpires_notifyApprover
                    },
                };
                if (doctypeCrtl.currentDocType.docuemntApprovalConfig.approverRespondDuration != null) {
                    $scope.configureApproval.docuemntApprovalConfig.approverRespondDuration = doctypeCrtl.currentDocType.docuemntApprovalConfig.approverRespondDuration;
                }

                doctypeCrtl.currentDocType.docuemntApprovalConfig.approvalsRequired.forEach(function(h) {
                    if (h == null || h == undefined) {
                        h = "";
                    } else if (h != "") {
                        if (h.indexOf('Upload') == 0) {
                            $scope.configureApproval.docuemntApprovalConfig.approvalsRequired['Upload'] = h;
                        } else if (h.indexOf('Share') == 0) {
                            $scope.configureApproval.docuemntApprovalConfig.approvalsRequired['Share'] = h;
                        } else if (h.indexOf('Delete') == 0) {
                            $scope.configureApproval.docuemntApprovalConfig.approvalsRequired['Delete'] = h;
                        }
                        else if (h.indexOf('Edit') == 0) {
                            $scope.configureApproval.docuemntApprovalConfig.approvalsRequired['Edit'] = h;
                        }
                    }
                });
                $scope.allApprovers = doctypeCrtl.currentDocType.docuemntApprovalConfig.agents;
            } else {

                $scope.configureApproval = {
                    "id": null,
                    "docuemntApprovalConfig": {
                        "agents": [],
                        "approvalsRequired": [],
                        "approverRespondDuration": 0,
                        "requestApproved_notifyApprover": false,
                        "requestApproved_notifyRequester": false,
                        "requestDenied_notifyApprover": false,
                        "requestDenied_notifyRequester": false,
                        "requestExpires__notifyRequester": false,
                        "requestExpires_notifyApprover": false
                    },
                };
            }
            $scope.searchUsers = function(elements) {
                $scope.searchedUsers = {};
                RestAPIService.searchUsers(elements).then(
                    function(response) {
                        if (response.data[0].length > 0) {
                            $scope.searchedUsers.data = response.data[0];
                            $scope.searchedUsers.type = elements.type;
                        }
                    },
                    function(error) {
                        RestAPIService.showErrorDialog(error);
                    });
            }

           $scope.addApprover = function(approverData, type) {
                var json = {};
                if (approverData.id == undefined) {
                    json.objectId = approverData.login;
                    json.type = "user";
                } else {
                    json.objectId = approverData.id;
                    json.type = "group";
                }
                
             var result =    $filter('filter')($scope.configureApproval.docuemntApprovalConfig.agents,{objectId:"adam"}, true)[0];
                if(result==undefined){
                	
                	var term = json.objectId;
                  
                  var index = -1;

             $scope.allApprovers.some(function(obj, i) {
               return obj.objectId === term ? index = i : false;
             });
                  /*$scope.allApprovers.forEach(function(h){
                   index = h.objectId.indexOf(term);

                  });*/

                //	var index = $scope.allApprovers.findIndex(x => x.objectId==term);                	
                	if(index == -1){
                		RestAPIService.successTostDialog("User has been added successfully.");
                		$scope.allApprovers.push(json);
                		
                	}        
                }
                
            }    

            $scope.removeApprover = function(index) {
                $scope.allApprovers.splice(index, 1);
            };
            $scope.hide = function() {
                $mdDialog.hide();
            };
            $scope.cancel = function() {
                $mdDialog.cancel();
            };

            $scope.submitApprovalConfig = function(data, currentDoc) {

                $scope.approval = [];
                if ($scope.configureApproval.docuemntApprovalConfig.approvalsRequired.Delete != "") {
                    $scope.approval.push($scope.configureApproval.docuemntApprovalConfig.approvalsRequired.Delete);
                }
                if ($scope.configureApproval.docuemntApprovalConfig.approvalsRequired.Share != "") {
                    $scope.approval.push($scope.configureApproval.docuemntApprovalConfig.approvalsRequired.Share);
                }
                if ($scope.configureApproval.docuemntApprovalConfig.approvalsRequired.Upload != "") {
                    $scope.approval.push($scope.configureApproval.docuemntApprovalConfig.approvalsRequired.Upload);
                }
                if ($scope.configureApproval.docuemntApprovalConfig.approvalsRequired.Edit != "") {
                    $scope.approval.push($scope.configureApproval.docuemntApprovalConfig.approvalsRequired.Edit);
                }
                $scope.configureApproval.docuemntApprovalConfig.approvalsRequired = $scope.approval;
                $scope.configureApproval.docuemntApprovalConfig.agents =   $scope.allApprovers;

                $scope.configureApproval.id = $scope.docId;
                if($scope.configureApproval.docuemntApprovalConfig.agents.length == 0){
                	alert("Please add approver");
                }
                else{
                // console.log("$scope.configureApproval : ", $scope.configureApproval)
                RestAPIService.updateApprovalConfig($scope.configureApproval).then(
                    function(success) {
                    	//alert(JSON.stringify($scope.configureApproval));
                        RestAPIService.successTostDialog('Approval Configuration Updated Successfully');
                        $state.reload();
                    },
                    function(error) {
                        alert(error.headers('X-smartportalApp-defaultMessage'));
                        RestAPIService.showErrorDialog(error);
                    }
                );
                
                $mdDialog.hide();
                }
            }
        }
    }


         
})();
(function() {
    'use strict';

    angular
        .module('app.administration')
        .controller('DOAController', DOAController);

    function DOAController($state, $scope, $mdDialog, RestAPIService) {
        var doCtrl = this;
        // doCtrl.requestTypes=[];
        $scope.sizeselect=function(size){
            $scope.size = size
            doCtrl.getAllDoaReports($scope.pageNumber,$scope.size);                
        }
        $scope.pageNumber = 0;
        $scope.size =100;

        $scope.next = function(){	
            $scope.pageNumber = $scope.pageNumber + 1; 
            doCtrl.getAllDoaReports($scope.pageNumber,$scope.size);    	
          }
          $scope.previous = function(){
              $scope.pageNumber = $scope.pageNumber - 1; 
              doCtrl.getAllDoaReports($scope.pageNumber,$scope.size);    	
          }  	 
          $scope.sendPageNumber = function(page) {
           $scope.pageNumber = page;
           doCtrl.getAllDoaReports($scope.pageNumber,$scope.size);
       }
       doCtrl.getAllDoaReports=function(){
        RestAPIService.getAllDoaReports($scope.pageNumber,$scope.size).then(
            function(success) {
                $scope.Doareports = success.data;
                console.log($scope.Doareports)
                $scope.pageNumbers = [];
                $scope.totalRecords = success.headers('x-total-count');
               $scope.totalPages = Math.ceil($scope.totalRecords/$scope.size);
              if ($scope.totalPages  > 0) {
               for (var i = 0; i < $scope.totalPages; i++) {
                   $scope.pageNumbers.push(i);
                   }
              } 

            },
            function(error) {
                RestAPIService.showErrorDialog(error);
            });
        }

        // doCtrl.getallrequesttypes=function(){
        //     RestAPIService.getAllhybridRquests().then(
        //         function(success) {
        //             doCtrl.requesttypes = success.data;
                       
        //         },
        //         function(error) {
        //             RestAPIService.showErrorDialog(error);
        //         }
        //     );
        // }
        $scope.createDoaReports = function(ev) {
            $mdDialog.show({
                controller: CreateDoaReportsDialogController,
                templateUrl: 'app/main/administration/doa-reports/doaReports-createDialog.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
            })
        };
      function CreateDoaReportsDialogController($scope, $mdDialog) {
        RestAPIService.getUsers("0","1000").then(
            function(success) {
                $scope.usersList = success.data;                       
            },
            function(error) {
                RestAPIService.showErrorDialog(error);
            }
        );
          $scope.request=[];
          $scope.request=doCtrl.requesttypes;
          $scope.allsbus =  doCtrl.AllSBUS;
          $scope.AllLocations=doCtrl.AllLocations;
          $scope.AllDepts= doCtrl.AlDepts;
           $scope.save = function(doa) {
               if(doa.requestTypes=="All"){
                doa.requestTypes=["GENERAL_FORM","VENDOR_FORM","CEP_FORM","SCEP_FORM","EOR_FORM","RFWD_FORM"] 
               }
               
                RestAPIService.createDoaReports(doa).then(
                    function(success) {
                        $mdDialog.hide();
                        RestAPIService.successTostDialog('Doa Reports Created Successfully');
                        $state.reload();
                    },
                    function(error) {
                        RestAPIService.showErrorDialog(error);
                    });
            };     
            
            $scope.cancel = function() {
                $mdDialog.cancel();
            };
        }
        doCtrl.doaUpdate = {};
        // doCtrl.doaUpdate.requestTypes=[];
        doCtrl.updateDoaDialog = function(ev, doa) {
           // console.log(doa)          
            doCtrl.doaUpdate = angular.copy(doa);
            $mdDialog.show({
                controller: UpdateDoaDialogController,
                templateUrl: 'app/main/administration/doa-reports/doa-reports-updateDialog.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: $scope.customFullscreen
            })
        };
        function UpdateDoaDialogController($scope, $mdDialog){
           // doCtrl.doaUpdate
            $scope.doaUpdate = doCtrl.doaUpdate;
            // $scope.doaUpdate.requestTypes=doCtrl.requestTypes;
            $scope.allsbus =  doCtrl.AllSBUS;
            $scope.AllLocations=doCtrl.AllLocations;
            $scope.AllDepts= doCtrl.AlDepts;
            //$scope.requestType=[];
            console.log(  $scope.doaUpdate.requestTypes);
          //  $scope.requestType=doCtrl.requesttypes;
            RestAPIService.getUsers("0","1000").then(
                function(success) {
                    $scope.usersList = success.data;                       
                },
                function(error) {
                    RestAPIService.showErrorDialog(error);
                }
            );
            $scope.hide = function() {
                $mdDialog.hide();
            };
            $scope.cancel = function() {
                $mdDialog.cancel();
            };
            
            $scope.updatesave = function(updatedata) {
                for(var i=0;i<=updatedata.requestTypes.length;i++){
                    if(updatedata.requestTypes[i]=="All"){
                        updatedata.requestTypes=["GENERAL_FORM","VENDOR_FORM","CEP_FORM","SCEP_FORM","EOR_FORM","RFWD_FORM"] 
                       }
                       else{

                       }
                }
              
                RestAPIService.updateDoaReports(updatedata).then(
                    function(success) {
                        RestAPIService.successTostDialog('Doa Reports Updated Successfully');
                        $state.reload();
                    },
                    function(error) {
                        RestAPIService.showErrorDialog(error);
                    }
                );
                $mdDialog.hide(updatedata);
            };
        }
        $scope.deleteDoaReports = function(ev, object) {
            var confirm = $mdDialog.confirm()
                .title('Remove')
                .textContent('It will be permanently deleted. Continue ?')
                .targetEvent(ev)
                .ok('Ok')
                .cancel('Cancel');
            $mdDialog.show(confirm).then(function() {
                    RestAPIService.deleteDoaReports(object.id).then(
                        function(success) {
                            RestAPIService.successTostDialog(success.headers('X-smartportalApp-alert'));
                            $state.reload();
                        },
                        function(error) {
                            RestAPIService.showErrorDialog(error);
                        });
                },
                function() {
                    $mdDialog.cancel();
                });
        }
        init();

        function init() {
            doCtrl.AlDepts=[];
            // doCtrl.getallrequesttypes();           
                RestAPIService.getlistDataBylistName("SBU").then(
                    function(success){
                        $scope.AllSBU =success.data;
                        doCtrl.AllSBUS =success.data;
                    },function(error){});
                RestAPIService.getlistDataBylistName("LOCATION").then(
                    function(success){
                        $scope.AllLocations =success.data;
                        doCtrl.AllLocations =success.data;
                    },function(error){});
                    RestAPIService.getlistDataBylistName("DEPT").then(
                        function(success){
                            // $scope.AllDepts =success.data;
                             doCtrl.AllDepts =success.data;
                            for(var i=0;i<doCtrl.AllDepts.length;i++){
                                var objdepartment={DEPT:doCtrl.AllDepts[i].DEPT.split(/\s/).join(''),DESCRIPTION:doCtrl.AllDepts[i].DESCRIPTION};
                                doCtrl.AlDepts.push(objdepartment);
                              console.log(objdepartment)
                               
                            }
                        },function(error){});

                     
        }

        $("#vertical-navigation").hide();
        $("#content-container").css({
            "margin-left": "0px"
        });
        $scope.goToPreviousState = function() {
            $state.go("app.mycontent_inbox");
            $("#vertical-navigation").show();
            $("#content-container").css({
                "margin-left": "60px"
            });
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.administration')
        .controller('BussinessController', BussinessController);

    /** @ngInject */
    function BussinessController($state,$scope,$mdDialog,RestAPIService,Objects,$localStorage)
    {
        var bsCtrl = this;
        $("#vertical-navigation").hide();
        $("#content-container").css({ "margin-left": "0px" });
        $scope.getRequestForms = function() {
	       	  RestAPIService.getRequestForms().then(
	           function(success) {
	               $scope.forms = success.data;
	               bsCtrl.ids=[];
	             $scope.forms.forEach(function(h){
	           	bsCtrl.ids.push(h.id);  
	                });
	             },
	           function(error) {
	               RestAPIService.showErrorDialog(error);
	           });
	   };
         if ($localStorage.menubarsetting != undefined) {
                     $scope.showsForms = $localStorage.menubarsetting.formsmanagement;
                      $scope.showWorkflow = $localStorage.menubarsetting.adminWorkflow; 
                     $scope.showrequestManagement = $localStorage.menubarsetting.requestManagement;
                     $scope.showListManagement = $localStorage.menubarsetting.listManagement;
                     $scope.showBusinessObject = $localStorage.menubarsetting.businessObject;
                     $scope.showBinder = $localStorage.menubarsetting.binder;
                     $scope.showTemplates = $localStorage.menubarsetting.templates;
                     $scope.showReports1 = $localStorage.menubarsetting.adminReports;
                  
                    
                     $scope.showSubstitution = $localStorage.menubarsetting.substitution;
                     $scope.showZohoReports = $localStorage.menubarsetting.zohoReports;
                     
                      $scope.showDocumentType  = $localStorage.menubarsetting.documentTypes;    
                       $scope.showReqTypeDetails  = $localStorage.menubarsetting.reqTypeDetails; 
                          $scope.showInvoiceTypes  = $localStorage.menubarsetting.invoiceTypes;    
                     
            }
        
        
	   $scope.goToPreviousState = function() {
       	$state.go("app.mycontent_inbox");
        	$("#vertical-navigation").show();
        	$("#content-container").css({ "margin-left": "60px" });
       }
         $scope.objectfiles=Objects.data;
         $scope.object={};
        
         $scope.dtOptions = {
        		 
        		 dom       : '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
	            pagingType: 'simple',
	            autoWidth : false,
	            responsive: true
	        };           
             
             $scope.deleteObject = function(ev,object) {
        
                  var confirm = $mdDialog.confirm()
                 .title('Remove')
                 .textContent('Object ' + object.name + ' ' + ' will be permanently deleted. Continue ?')
                 .targetEvent(ev)
                 .ok('Ok')
                 .cancel('Cancel');
             $mdDialog.show(confirm).then(function() {

                 RestAPIService.deleteObject(object.id).then(
                     function(success) {
                    	 RestAPIService.successTostDialog(success.headers('X-smartportalApp-alert'));
                       
                         $state.reload();
                     },
                     function(error) {
                         RestAPIService.showErrorDialog(error);
                        }
                      );
                     },      
                     function() {
                    $mdDialog.cancel();
                   });
                   }
        

             $scope.createObjectDialog = function(ev) {
                 $mdDialog.show({
                     controller: createObjectDialogController,
                     templateUrl: 'app/main/administration/business-object/create.object.dialog.html',
                     parent: angular.element(document.body),
                     targetEvent: ev,
                     clickOutsideToClose: true,
                     fullscreen: $scope.customFullscreen
                 })
                 $scope.cancel = function() {
                    
                 };
              };


            function createObjectDialogController($scope, $mdDialog,RestAPIService) {
            	$scope.ids = bsCtrl.ids;
                  $scope.hide = function() {
                     $mdDialog.hide();
                   };
                 $scope.cancel = function() {
                     $mdDialog.cancel();
                     };
                 $scope.save = function(object) {
                RestAPIService.createObject(object).then(
                     function(success) {
                    	 RestAPIService.successTostDialog(success.headers('X-smartportalApp-alert'));
                         $state.reload();
                     },
                     function(error) {
                    	 alert(error.headers('X-smartportalApp-defaultMessage'));
                         //RestAPIService.showErrorDialog(error);
                     }
                    );
                 $mdDialog.hide(object);
                     };
                   }
                 bsCtrl.receivedObject ={};
               $scope.updateObjectDialog = function(ev,object) {
               
                 bsCtrl.receivedObject =  angular.copy(object);
                 $mdDialog.show({
                 controller: updateObjectDialogController,
                 templateUrl: 'app/main/administration/business-object/update.object.dialog.html',
                 parent: angular.element(document.body),
                 targetEvent: ev,
                 clickOutsideToClose: true,
                 fullscreen: $scope.customFullscreen
                })
              };

           function updateObjectDialogController($scope, $mdDialog) {
        	   $scope.formIds = bsCtrl.ids;
             
             $scope.currentObject = bsCtrl.receivedObject;
             console.log($scope.currentObject);

             $scope.hide = function() {
                 $mdDialog.hide();
             };
             $scope.cancel = function() {
                 $mdDialog.cancel();
             };
            $scope.update = function(object) {
                 RestAPIService.updateObject(object).then(
                     function(success) {
                    	 RestAPIService.successTostDialog(success.headers('X-smartportalApp-alert'));
                         $state.reload();
                     },
                     function(error) {
                         RestAPIService.showErrorDialog(error);
                     }
                 );
                 $mdDialog.hide(object);
                };
               }
           $scope.detailsObjectDialog = function(ev, object) {
                 bsCtrl.currentObject = object;
                 $mdDialog.show({
                 controller: detailsObjectDialogController,
                 templateUrl: 'app/main/administration/business-object/details.object.dialog.html',
                 parent: angular.element(document.body),
                 targetEvent: ev,
                 clickOutsideToClose: true,
                 fullscreen: $scope.customFullscreen
             })
             $scope.cancel = function() { 
                
             };
         };
         function detailsObjectDialogController($scope, $mdDialog) {
            $scope.attributes = bsCtrl.currentObject.attributes;
            $scope.currentObject = bsCtrl.currentObject;
            $scope.attributeTypes = ['String','List','Date'];
             $scope.hide = function() {
                 $mdDialog.hide();
             };
             $scope.cancel = function() {
                 $mdDialog.cancel();
             };

            $scope.addNewAttribute = function() {
                var newAttribute = {
                    label:'',
                    type:'String',
                    range:false,
                    listReference:'e.g. A,B,C'
                }
                if($scope.attributes == null)   $scope.attributes =[];
                $scope.attributes.push(newAttribute);
            };

            $scope.save = function() {
                //Getting the updated attributes list
                $scope.currentObject.attributes = $scope.attributes;
                RestAPIService.updateObject($scope.currentObject).then(
                    function(success) {
                        $state.reload();
                    },
                    function(error) {
                        RestAPIService.showErrorDialog(error);
                    }
                );
                $mdDialog.hide();

                $mdDialog.show(
                    $mdDialog.alert()
                    .clickOutsideToClose(true)
                    .title('Success!')
                    .textContent('Attributes of '+$scope.currentObject.name+' has been successfully updated')
                    .ok('Ok')
                );
                
            };

         }
         
         init();
         
         function init() {
        	 $scope.getRequestForms();
         }
   
        }   
})();  
(function() {
    'use strict';

    angular
        .module('app.administration')
        .controller('BinderController', BinderController);

    /** @ngInject */
    function BinderController($state, $scope, $mdDialog, RestAPIService, Binders,$localStorage) {
        var binderCrtl = this;
        $scope.bindersList = Binders.data;
        $scope.binder = {};
        binderCrtl.dtInstance = {};
        $("#vertical-navigation").hide();
        $("#content-container").css({ "margin-left": "0px" });
        $scope.dtOptions = {
//            dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
//            columnDefs: [
//
//                { // Target the actions column
//                    targets: 4,
//                    responsivePriority: 1,
//                    filterable: false,
//                    sortable: false
//                }
//            ],
//            pagingType: 'simple',
//            lengthMenu: [10, 20, 30, 50, 100],
//            pageLength: 20
//            // scrollY     : 'auto',
//            // responsive  : true
        		
        		 
       		 dom       : '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
	            pagingType: 'simple',
	            autoWidth : false,
	            responsive: true
        };
         if ($localStorage.menubarsetting != undefined) {
                     $scope.showsForms = $localStorage.menubarsetting.formsmanagement;
                      $scope.showWorkflow = $localStorage.menubarsetting.adminWorkflow; 
                     $scope.showrequestManagement = $localStorage.menubarsetting.requestManagement;
                     $scope.showListManagement = $localStorage.menubarsetting.listManagement;
                     $scope.showBusinessObject = $localStorage.menubarsetting.businessObject;
                     $scope.showBinder = $localStorage.menubarsetting.binder;
                     $scope.showTemplates = $localStorage.menubarsetting.templates;
                     $scope.showReports1 = $localStorage.menubarsetting.adminReports;
                  
                    
                     $scope.showSubstitution = $localStorage.menubarsetting.substitution;
                     $scope.showZohoReports = $localStorage.menubarsetting.zohoReports;
                     
                      $scope.showDocumentType  = $localStorage.menubarsetting.documentTypes;  
                       $scope.showReqTypeDetails  = $localStorage.menubarsetting.reqTypeDetails; 
                          $scope.showInvoiceTypes  = $localStorage.menubarsetting.invoiceTypes;      
                     
            }
        $scope.goToPreviousState = function() {
        	$state.go("app.mycontent_inbox");
         	$("#vertical-navigation").show();
         	$("#content-container").css({ "margin-left": "60px" });
        }
        binderCrtl.selectBusinessObject = function(businessObject) {
            // Calling Rest API Service to get Attributes of this Business Object
            RestAPIService.findBusinessObjectAttributes(businessObject.id).then(function(responce) {
                    $scope.attributeObjects = responce.data.attributes;
                    // If any Attribute is having listReferrence as COMMA separated values, Split them.
                    if ($scope.attributeObjects != null) {
                        $scope.attributeObjects.forEach(function(attribute) {
                            if (attribute.type == "List") {
                                attribute['listValues'] = attribute.listReference.split(',');
                            }
                        });
                    }
                },
                function(error) {
                    RestAPIService.showErrorDialog(error);
                })
        }

        binderCrtl.getBinders = function() {
            RestAPIService.getBinders().then(
                function(success) {
                    $scope.bindersList = success.data;

                },
                function(error) {
                    RestAPIService.showErrorDialog(error);
                }
            );

        }

        $scope.deleteBinder = function(ev, binder) {
            var confirm = $mdDialog.confirm()
                .title('Remove')
                .textContent('Binder ' + binder.name + ' ' + ' will be permanently deleted. Continue ?')
                .targetEvent(ev)
                .ok('Ok')
                .cancel('Cancel');
            $mdDialog.show(confirm).then(function() {

                    RestAPIService.deleteBinder(binder.id).then(
                        function(success) {
                            RestAPIService.successTostDialog(success.headers('X-smartportalApp-alert'));

                            $state.reload();
                        },
                        function(error) {
                            RestAPIService.showErrorDialog(error);
                        }
                    );
                },
                function() {
                    $mdDialog.cancel();
                });
        }


        $scope.createBinderDialog = function(ev) {
            $mdDialog.show({
                controller: createBinderDialogController,
                templateUrl: 'app/main/administration/binder-management/create.binder.dialog.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: $scope.customFullscreen
            })
            $scope.cancel = function() {

            };
        };


        function createBinderDialogController($scope, $mdDialog, RestAPIService) {
            $scope.hide = function() {
                $mdDialog.hide();
            };
           $scope.getAllBusinessObjects = function() {
                RestAPIService.getAllBusinessObjects().then(
                    function(responce) {
                        
                        $scope.allBusinessObjects = responce.data;

                    },
                    function(error) {
                        RestAPIService.showErrorDialog(error);
                    })
        }
            $scope.cancel = function() {
                $mdDialog.cancel();
            };
            $scope.save = function(binder) {
                console.log(binder);
                RestAPIService.createBinder(binder).then(
                    function(success) {
                    	RestAPIService.successTostDialog(success.headers('X-smartportalApp-alert'));
                    	//alert(success.headers('X-smartportalApp-alert'));
                        $state.reload();
                    },
                    function(error) {
                    	alert(error.headers('X-smartportalApp-defaultMessage'));
                        RestAPIService.showErrorDialog(error);
                    }
                );
                $mdDialog.hide(binder);
            };
        }
        binderCrtl.currentBinder = {};
        $scope.updateBinderDialog = function(ev, binder) {

            binderCrtl.currentBinder = angular.copy(binder);

            $mdDialog.show({
                controller: updateBinderDialogController,
                templateUrl: 'app/main/administration/binder-management/update.binder.dialog.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: $scope.customFullscreen
            })
        };

        function updateBinderDialogController($scope, $mdDialog) {
            $scope.currentBinder = binderCrtl.currentBinder;

            $scope.hide = function() {
                $mdDialog.hide();
            };
            $scope.cancel = function() {
                $mdDialog.cancel();
            };
            $scope.getAllBusinessObjects = function() {
                RestAPIService.getAllBusinessObjects().then(
                    function(responce) {
                        
                        $scope.allBusinessObjects = responce.data;

                    },
                    function(error) {
                        RestAPIService.showErrorDialog(error);
                    })
        }
            $scope.update = function(binder) {
                RestAPIService.updateBinder(binder).then(
                    function(success) {
                        RestAPIService.successTostDialog(success.headers('X-smartportalApp-alert'));
                        $state.reload();
                    },
                    function(error) {
                        RestAPIService.showErrorDialog(error);
                    }
                );
                $mdDialog.hide(binder);
            };
        }
        
        // $scope.binderFoldersDialog = function(ev, binder) {
        //     $mdDialog.show({
        //         controller: binderFoldersDialogController,
        //         templateUrl: 'app/main/administration/binder-management/folders.binder.html',
        //         parent: angular.element(document.body),
        //         targetEvent: ev,
        //         clickOutsideToClose: true,
        //         fullscreen: $scope.customFullscreen
        //     })
        // };

    //     function binderFoldersDialogController($scope, $mdDialog) {

    //         $scope.hide = function() {
    //             $mdDialog.hide();
    //         };
    //         $scope.cancel = function() {
    //             $mdDialog.cancel();
    //         };
    //         $scope.remove = function (scope) {
    //             scope.remove();
    //           };

    //           $scope.toggle = function (scope) {
    //             scope.toggle();
    //           };

    //           $scope.moveLastToTheBeginning = function () {
    //             var a = $scope.data.pop();
    //             $scope.data.splice(0, 0, a);
    //           };
    //           $scope.collapseAll = function () {
    //               $scope.$broadcast('angular-ui-tree:collapse-all');
    //             };

    //             $scope.expandAll = function () {
    //               $scope.$broadcast('angular-ui-tree:expand-all');
    //             };    
    //           $scope.newSubItem = function (scope) {
    //               var nodeData = scope.$modelValue;
    //               nodeData.nodes.push({
    //                 id: nodeData.id * 10 + nodeData.nodes.length,
    //                 title: nodeData.title + '.' + (nodeData.nodes.length + 1),
    //                 nodes: []
    //               });
    //             };
    //           $scope.newItem = function () {
    //             var nodeData = $scope.treelist[$scope.treelist.length - 1];
    //             $scope.treelist.push({
    //               id: $scope.treelist.length + 1,
    //               title: 'node ' + ($scope.treelist.length + 1)
    //             });
    //           };
        
        
    //     $scope.treelist =  [
    //     	  {
    //     		    "id": 1,
    //     		    "title": "folder1",
    //     		    "nodes": []   		    
    //    		  }
    //     		]
    // }
    $scope.createBinderFoldersDialog = function(ev, binderData){
        binderCrtl.binderData = binderData;        
        $mdDialog.show({
                controller: CreateBinderFoldersDialogController,
                templateUrl: 'app/main/administration/binder-management/createBinderFoldersDialog.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: $scope.customFullscreen
            })
    }
    function CreateBinderFoldersDialogController($scope){      
        $scope.binderData = binderCrtl.binderData;
         if($scope.binderData.folders == null){
            $scope.binderData.folders = [];
            $scope.binderData.folders.length = 0;
         } 
        RestAPIService.getDocumentTypes().then(function(success){
            $scope.docTypes = success.data;
            console.log($scope.docTypes);
        },
        function(error){
            RestAPIService.showErrorDialog(error);
        })
        $scope.getAllBusinessObjects = function() {
                RestAPIService.getAllBusinessObjects().then(
                    function(responce) {                        
                        $scope.allBusinessObjects = responce.data;
                    },
                    function(error) {
                        RestAPIService.showErrorDialog(error);
                    })
        }
        $scope.addNewfolderObject = function(){            
           
            $scope.binderData.folders.push({
                "folderName":"",
                "documentTypes":[],
                "seqId":""
            });
        }
        $scope.saveBinderFolders = function(){
            $mdDialog.cancel();            
             RestAPIService.updateBinder($scope.binderData).then(
                    function(success) {
                        RestAPIService.successTostDialog(success.headers('X-smartportalApp-alert'));
                        $state.reload();
                    },
                    function(error) {
                        RestAPIService.showErrorDialog(error);
                    }
                );
            console.log($scope.binderData);
        }
        $scope.cancel = function() {
                $mdDialog.cancel();
        };
         
    }
        $scope.attributesBinderDialog = function(ev, binder) {
            binderCrtl.currentBinder = binder;
            $mdDialog.show({
                controller: attributesBinderDialogController,
                templateUrl: 'app/main/administration/binder-management/attributes.binder.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: $scope.customFullscreen
            })
            $scope.cancel = function() {

            };
        };

        function attributesBinderDialogController($scope, $mdDialog) {
            $scope.attributes = binderCrtl.currentBinder.attributes;
            $scope.currentBinder = binderCrtl.currentBinder;
            $scope.attributeTypes = ['String', 'List', 'Date'];
            $scope.hide = function() {
                $mdDialog.hide();
            };
            $scope.cancel = function() {
                $mdDialog.cancel();
            };

            $scope.addNewAttribute = function() {
                var newAttribute = {
                    label: '',
                    type: 'String',
                    range: false,
                    listReference: 'e.g. A,B,C'
                }
                if ($scope.attributes == null) $scope.attributes = [];
                $scope.attributes.push(newAttribute);
            };
        }


    }
})();
(function() {
    'use strict';

    angular
        .module('app.administration')
        .controller('ApprovelevelController', ApprovelevelController);

    function ApprovelevelController($state, $scope, $mdDialog, RestAPIService,$location, $anchorScroll) {
        var approverCtrl = this;
      

        approverCtrl.dtOptions = {
            dom       : '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
           pagingType: 'simple',
           autoWidth : false,
           responsive: true

          };
          approverCtrl.approver = {};
          approverCtrl.approverDialog = function(ev, approver) {
            approverCtrl.approver  = angular.copy(approver);
          $mdDialog.show({
                controller: approverDialogController,
                templateUrl: 'app/main/administration/approver-Level/approver-dialog.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: $scope.customFullscreen
            })
        };
        function approverDialogController($scope, $mdDialog) {
            $scope.approver = approverCtrl.approver;
           $scope.hide = function() {
                $mdDialog.hide();
            };
            $scope.cancel = function() {
                $mdDialog.cancel();
            };
         
        }
        $scope.pageNumber = 0;
        $scope.size =100;
        $scope.next = function(){	
            $scope.pageNumber = $scope.pageNumber + 1; 
            $scope.getApproverlevel();	     	
          }
          $scope.previous = function(){
              $scope.pageNumber = $scope.pageNumber - 1; 
              $scope.getApproverlevel();     	
          }  	 
          $scope.sendPageNumber = function(page) {
           $scope.pageNumber = page;
           $scope.getApproverlevel();
       }
       $scope.sizeselect=function(size){
        $scope.size = size
        $scope.getApproverlevel();
        
    }
       $scope.getApproverlevel =function(){
        RestAPIService.getAllApproveLevel($scope.pageNumber,$scope.size).then(
            function(success) {
                $scope.pageNumbers = [];
                $scope.approverlevel = success.data;
               console.log($scope.approverlevel)
               $scope.totalRecords = success.headers('x-total-count');
               $scope.totalPages = Math.ceil($scope.totalRecords/$scope.size);
                // $scope.length  = success.data.length ; 
                console.log($scope.totalPages )
                if ($scope.totalPages  > 0) {
                    for (var i = 0; i < $scope.totalPages; i++) {
                        $scope.pageNumbers.push(i);
                    }
                } 
            },
            function(error) {
                RestAPIService.showErrorDialog(error);
            });
       }
        init();
        function init() {
            $scope.getApproverlevel()
        }
        $("#vertical-navigation").hide();
        $("#content-container").css({
            "margin-left": "0px"
        });
        $scope.goToPreviousState = function() {
            $state.go("app.mycontent_inbox");
            $("#vertical-navigation").show();
            $("#content-container").css({
                "margin-left": "60px"
            });
        }
    }
})();
(function() {
    'use strict';
    angular
        .module('app.administration')
        .controller('ApprovematrixController', ApprovematrixController);

    function ApprovematrixController($state, $http, $scope, $compile,$localStorage, $stateParams, $mdDialog, RestAPIService, $filter, DTOptionsBuilder, DTColumnDefBuilder) {
        var approveCtrl = this;
        $scope.selectedmatrixDetails = $stateParams.matrixDetails;
        approveCtrl.finalLevels = [];
        $scope.displayApprovalMatrix = [];
        if ($stateParams.matrixDetails != null || $stateParams.matrixDetails != undefined) {
            $scope.noOflevels = $stateParams.matrixDetails.noOfApprovalLevels;

            for (i = 1; i <= $scope.noOflevels; i++) {

                var currentLevel = 'Level' + i ;
                approveCtrl.finalLevels.push(currentLevel);

            }

        }

         if ($localStorage.menubarsetting != undefined) {
                     $scope.showsForms = $localStorage.menubarsetting.formsmanagement;
                      $scope.showWorkflow = $localStorage.menubarsetting.adminWorkflow; 
                     $scope.showrequestManagement = $localStorage.menubarsetting.requestManagement;
                     $scope.showListManagement = $localStorage.menubarsetting.listManagement;
                     $scope.showBusinessObject = $localStorage.menubarsetting.businessObject;
                     $scope.showBinder = $localStorage.menubarsetting.binder;
                     $scope.showTemplates = $localStorage.menubarsetting.templates;
                     $scope.showReports1 = $localStorage.menubarsetting.adminReports;
                     $scope.showsReports2 = $localStorage.menubarsetting.adminReports2;
                     $scope.showILM = $localStorage.menubarsetting.ILM;
                     $scope.showSystemLandscape = $localStorage.menubarsetting.systemLandscape;
                     $scope.showAnnouncements = $localStorage.menubarsetting.announcements;
                     $scope.showSubstitution = $localStorage.menubarsetting.substitution;
                     $scope.showZohoReports = $localStorage.menubarsetting.zohoReports;
                     $scope.showWorkspacetype = $localStorage.menubarsetting.workspaceType;
                     $scope.showApprovalMatrix = $localStorage.menubarsetting.approvalMatrix;
                     $scope.showEmailTemplates = $localStorage.menubarsetting.emailTemplates;
                     $scope.showContractApprovals = $localStorage.menubarsetting.contractApprovals; 
                      $scope.showDocumentType  = $localStorage.menubarsetting.documentTypes;        
                     
            }


        $scope.getAnotherColor = function(index) {
            $scope.colors = ['red', 'pink', 'purple', 'deep-purple', 'indigo', 'blue', 'light-blue', 'cyan', 'teal', 'green',
                'light-green', 'lime', 'yellow', 'amber', 'deep-orange', 'brown', 'grey', 'blue-grey'
            ];
            var totalNoOfColors = $scope.colors.length;
            return $scope.colors[index % totalNoOfColors];
        }

        $scope.goToPreviousState = function() {
            $state.go("app.mycontent_inbox");
            $("#vertical-navigation").show();
            $("#content-container").css({
                "margin-left": "60px"
            });
        }
        $("#vertical-navigation").hide();
        $("#content-container").css({
            "margin-left": "0px"
        });

        $scope.goBack = function() {
            $state.go('app.administration.approvematrix')

        }

        approveCtrl.dtOptions = {

            dom: '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            pagingType: 'simple',
            autoWidth: false,
            responsive: true
        };

        approveCtrl.getApprovematrix = function() {
            RestAPIService.getAllApprovalmatrix().then(
                function(success) {
                    $scope.approvalsList = success.data;

                    $scope.approvalsList.forEach(function(approvalMatrix) {

                        $scope.displayApprovalMatrix = [];
                        approvalMatrix.approvalLevels.forEach(function(formField) {
                            $scope.displayEachApprovalMatrix = {};
                            formField.fromFieldDetails.forEach(function(field) {

                                if (field.fieldType != "number" && field.fieldType != "Number") {
                                    $scope.displayEachApprovalMatrix[field.fieldName] = field.fieldFromValue;
                                } else {

                                    if (field.fieldToValue != "" && field.fieldToValue != undefined && field.fieldToValue != null) {
                                        var tovalue = "To_" + field.fieldName;
                                        var fromvalue = "From_" + field.fieldName;
                                        $scope.displayEachApprovalMatrix[tovalue] = field.fieldToValue;
                                        $scope.displayEachApprovalMatrix[fromvalue] = field.fieldFromValue;

                                    } else {
                                        var fromvalue = "From_" + field.fieldName;
                                        $scope.displayEachApprovalMatrix[fromvalue] = field.fieldFromValue;

                                    }


                                }
                            })


                            var levelApprovers = Object.keys(formField.approvalLevels);
                            levelApprovers.forEach(function(approver) {
                                $scope.displayEachApprovalMatrix[approver] = formField.approvalLevels[approver];


                            })
                            $scope.displayApprovalMatrix.push($scope.displayEachApprovalMatrix);
                        })




                        approvalMatrix['display'] = $scope.displayApprovalMatrix;
                    })




                },
                function(error) {
                    RestAPIService.showErrorDialog(error);
                }
            );

        }


        $scope.selectApproveMatrix = function(matrix) {
            $state.go('app.administration.approvematrix.createDetails', {
                matrixDetails: matrix
            })
        }


        $scope.addApproveMatrix = function(ev) {
            $mdDialog.show({
                controller: addApproveMatrixDialogController,
                templateUrl: 'app/main/administration/approve-matrix/create.approvematrix.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: $scope.customFullscreen
            })

        };


        function addApproveMatrixDialogController($scope, $mdDialog) {
            $scope.approveObj = {};
            $scope.attributeVals = [];
            $scope.hide = function() {
                $mdDialog.hide();
            };
            $scope.cancel = function() {
                $mdDialog.cancel();
            };
            $scope.workspaceType = "Contract";
            $scope.wsAttributeObjects = [{"fieldName":"ContractValue","type":"Number"}];

            RestAPIService.getRequests().then(
                function(success) {
                    $scope.reqTypes = success.data;

                },
                function(error) {
                    RestAPIService.showErrorDialog(error);
                }
            );

            $scope.selectedReqtype = function(request) {
                //alert(request.formId);
                $scope.reqformId = request.formId;
                RestAPIService.getRequestFormById($scope.reqformId).then(function(responce) {
                        $scope.attributeObjects = responce.data.formFieldsHeader;
                        if (responce.data.formFieldsHeader == null) {
                            $mdDialog.show(
                                $mdDialog.alert()
                                .parent(angular.element(document.querySelector('#popupContainer')))
                                .clickOutsideToClose(true)
                                // .title('Success.')
                                .htmlContent("No Attributes for selected Request Type")
                                .ariaLabel('Alert Dialog Demo')
                                .ok('Ok')
                                //                                        .targetEvent(ev)
                            );
                        }
                    },
                    function(error) {
                        RestAPIService.showErrorDialog(error);
                    })

            }


            $scope.selectedAttribute = function(attribute) {
                //alert(JSON.stringify($scope.dynamicAgentUsers));
                $scope.selectedAttributesList = {};

                $scope.selectedAttributesList = attribute;

                if (attribute.type == "number" || attribute.type == "Number") {
                    $scope.range = true;
                } else {
                    $scope.range = false;
                }


            }

            $scope.addAttributes = function(isRange) {
                var attribute = $scope.selectedAttributesList;
                var attributeFinal = {};
                if (isRange && (attribute.type == "number" || attribute.type == "Number")) {
                    var attributeToValue = {};
                    attributeFinal.fieldName = 'From_' + attribute.fieldName;
                    attributeFinal.value = attribute.fieldName;
                    attributeFinal.data = 'From_' + attribute.fieldName;
                    attributeFinal.fieldType = attribute.type;
                     $scope.attributeVals.push(attributeFinal);

                    attributeToValue.fieldName = 'To_' + attribute.fieldName;
                    attributeToValue.data = 'To_' + attribute.fieldName;
                    attributeToValue.fieldType = attribute.type;
                    attributeToValue.value = attribute.fieldName;

                    $scope.attributeVals.push(attributeToValue);
                } else if(!isRange &&(attribute.type == "number" || attribute.type == "Number")) {
                    var attributeToValue = {};
                    attributeFinal.fieldName = 'From_' + attribute.fieldName;
                    attributeFinal.value = attribute.fieldName;
                    attributeFinal.data = 'From_' + attribute.fieldName;
                    attributeFinal.fieldType = attribute.type;
                     $scope.attributeVals.push(attributeFinal);

                }else {

                    attributeFinal.fieldName = attribute.fieldName;
                    attributeFinal.fieldType = attribute.type;
                    attributeFinal.data = attribute.fieldName;
                     $scope.attributeVals.push(attributeFinal);

                }
               

            }


            $scope.save = function() {
                $scope.approveObj['headerValues'] = $scope.attributeVals;
      if($scope.approveObj.requesttype == undefined){
        $scope.approveObj.requesttype = $scope.workspaceType;

     }
                 //alert(JSON.stringify($scope.approveObj)); 
                if($scope.approveObj.headerValues.length == 0){
                    alert("please add attributes");
                }else{

                     RestAPIService.createApprovalmatrix($scope.approveObj).then(
                    function(success) {
                        $mdDialog.hide();
                        RestAPIService.successTostDialog('Approval matrix Created Successfully');
                        $state.reload();
                    },
                    function(error) {
                        RestAPIService.showErrorDialog(error);
                    }

                );

                }
               
            };

        }

        approveCtrl.currentDataObject = {};

         $scope.deleteApprovalMatrix = function(matrix) {
           var matrixId = matrix.id;
             var confirm = $mdDialog.confirm()
                 .title('Remove')
                 .textContent('Approval matrix '  + ' will be permanently deleted. Continue ?')
                // .targetEvent(ev)
                 .ok('Ok')
                 .cancel('Cancel');
             $mdDialog.show(confirm).then(function() {

                 RestAPIService.deleteApprovalMatrix(matrixId).then(
                     function(success) {
                         RestAPIService.successTostDialog('Approval matrix Deleted Successfully');
                         $state.reload();
                     },
                     function(error) {
                         RestAPIService.showErrorDialog(error);
                     }
                 );
             }, function() {
                 $mdDialog.cancel();
             });
         }


        $scope.addApproveMatrixDetails = function(ev, attriData, level, approvalData) {

            approveCtrl.attributeData = angular.copy(attriData);
            approveCtrl.levelData = angular.copy(level);

            approveCtrl.approvalData = angular.copy(approvalData);

            $mdDialog.show({
                controller: addApproveMatrixDetailsController,
                templateUrl: 'app/main/administration/approve-matrix/create.details.dialog.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: $scope.customFullscreen
            })
        };

        function addApproveMatrixDetailsController($scope, $mdDialog) {
            if(approveCtrl.approvalData !=null && approveCtrl.approvalData !=undefined){
                 $scope.approvalLevelsData = approveCtrl.approvalData;
             }else {
                 $scope.approvalLevelsData = [];
             }
           
            $scope.crlist = [];
            $scope.currentLevels = approveCtrl.levelData;
            console.log($scope.currentLevels);
            RestAPIService.getUsers().then(
                function(success) {
                    $scope.agents = success.data;
                },
                function(error) {
                    RestAPIService.showErrorDialog(error);
                }
            );
            $scope.attributeData = approveCtrl.attributeData;
            $scope.levelData = approveCtrl.levelData;
            $scope.hide = function() {
                $mdDialog.hide();
            };
            $scope.cancel = function() {
                $mdDialog.cancel();
            };

            $scope.searchText = null;
            $scope.selectedAgents = null;
            $scope.approvers = {};
            $scope.agentsSearch = function(query) {
                var results = query ? $scope.agents.filter(createFilterForAgents(query)) : [];
                return results;
            }

            function createFilterForAgents(query) {
                var lowercaseQuery = angular.lowercase(query);
                return function filterFn(text) {
                    return (((text.firstName != undefined) ? ((text.firstName).toLowerCase().indexOf(lowercaseQuery) === 0) : false) || ((text.lastName != undefined) ? ((text.lastName).toLowerCase().indexOf(lowercaseQuery) === 0) : false) || ((text.name != undefined) ? ((text.name).toLowerCase().indexOf(lowercaseQuery) === 0) : false));
                };
            }
            $scope.newAttriData = {};
            $scope.newAttriDataList = [];
            $scope.save = function(enteredData) {
                $scope.dynamicAgentList = [];
                console.log($scope.approvers);
                $scope.newAttriData = enteredData;
                var valuesList = [];
                var keys = Object.keys(enteredData);
                for (var k in keys) {
                    valuesList.push(enteredData[keys[k]]);
                }
                $scope.newAttriData.valueList = valuesList;

                $scope.newAttriDataList.push($scope.newAttriData);
                // alert(JSON.stringify($scope.newAttriDataList));
                $scope.newAttriDataList.forEach(function(header) {
                    $scope.fromFieldDetails = [];


                    for (var i = 0; i <= $scope.attributeData.length - 1; i++) {
                        $scope.fieldObject = {};
                        var dynamicData = $scope.attributeData[i].fieldName;

                        var attributeObj = $scope.attributeData[i];
                        if (attributeObj.fieldType == "number" || attributeObj.fieldType == "Number") {
                            var dynamicData = $scope.attributeData[i].value;
                            var numberList = $scope.attributeData;
                            for (var j = 0; j <= numberList.length - 1; j++) {
                                if (attributeObj.value == $scope.attributeData[j].value ) {
//&& i != j
                                    var tovalue = "To_" + attributeObj.value;
                                    var fromValue = "From_" + attributeObj.value;
                                    $scope.fieldObject['fieldToValue'] = header[tovalue];
                                    $scope.fieldObject['fieldFromValue'] = header[fromValue];
                                    $scope.fieldObject['fieldType'] = $scope.attributeData[i].fieldType;
                                    $scope.fieldObject['fieldName'] = $scope.attributeData[i].value;
                                    $scope.attributeData.splice(j, 1);
                                    numberList.splice(i, 1)
                                }

                            }
                        } else {
                            $scope.fieldObject['fieldFromValue'] = header[attributeObj.fieldName];

                            $scope.fieldObject['fieldType'] = $scope.attributeData[i].fieldType;
                            $scope.fieldObject['fieldName'] = $scope.attributeData[i].fieldName;
                        }

                        $scope.fromFieldDetails.push($scope.fieldObject);



                    }
                    // alert(JSON.stringify($scope.fromFieldDetails));

                });


                $scope.totalTotalOfApprovers = {};

                for (i = 0; i < $scope.currentLevels.length; i++) {
                    $scope.totalTotalOfApprovers[$scope.currentLevels[i]] = $scope.approvers[i + 1];
                }



                $scope.approvalLevels = {};
                $scope.approvalLevels['fromFieldDetails'] = $scope.fromFieldDetails;
                $scope.approvalLevels['approvalLevels'] = $scope.totalTotalOfApprovers;
                $scope.approvalLevelsData.push($scope.approvalLevels);
                $scope.approvalObj = {};
                $scope.approvalObj = $stateParams.matrixDetails;

                $scope.approvalObj['approvalLevels'] = $scope.approvalLevelsData;
                delete $scope.approvalObj["display"];
                RestAPIService.UpdateApprovalmatrix($scope.approvalObj).then(
                    function(success) {
                        RestAPIService.successTostDialog('Approval matrix details Updated Successfully');
                        $state.go('app.administration.approvematrix');
                    },
                    function(error) {
                        RestAPIService.showErrorDialog(error);
                    }
                );
                $mdDialog.hide();




            }

        }

      
         $scope.updateApproveDialog = function(ev, headerData,level, currentValues,index) {
            approveCtrl.index = index;
               approveCtrl.headerData = headerData;
               approveCtrl.currentApprovallevels = level;
               approveCtrl.currentValues = currentValues[index];
            $mdDialog.show({
                controller: updateApproveDialogController,
                templateUrl: 'app/main/administration/approve-matrix/update.approvematrix.dialog.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: $scope.customFullscreen
            })
        }; 

           function updateApproveDialogController($scope, $mdDialog) {
            $scope.noOfLevels = $stateParams.matrixDetails.noOfApprovalLevels;
            $scope.headerData = approveCtrl.headerData;
            $scope.currentApprovallevels = approveCtrl.currentApprovallevels;
            $scope.currentValues = approveCtrl.currentValues;
            
              /* var approvalLevels = [];
              for(var i=1;i<= $scope.noOfLevels;i++){
                   var level = "level"+i+"Approvers";
                     $scope.approver={};
                   $scope.approver[level] = $scope.currentValues[level];
                   approvalLevels.push($scope.approver);
              } 
            $scope.currentApprovallevels["approvers"]= approvalLevels;

*/

            RestAPIService.getUsers().then(
                function(success) {
                    $scope.agents = success.data;
                },
                function(error) {
                    RestAPIService.showErrorDialog(error);
                }
            );

            $scope.hide = function() {
                $mdDialog.hide();
            };
            $scope.cancel = function() {
                $mdDialog.cancel();
            };
              $scope.newAttriData = {};
            $scope.newAttriDataList = [];

            $scope.update = function(updatedVals){
                $scope.updatedVals = updatedVals;
                
                $scope.newAttriData = $scope.updatedVals;

                $scope.newAttriDataList.push($scope.newAttriData);
                // alert(JSON.stringify($scope.newAttriDataList));
                $scope.newAttriDataList.forEach(function(header) {
                    $scope.fromFieldDetails = [];


                    for (var i = 0; i <= $scope.headerData.length - 1; i++) {
                        $scope.fieldObject = {};
                        var dynamicData = $scope.headerData[i].fieldName;

                        var attributeObj = $scope.headerData[i];
                        if (attributeObj.fieldType == "number" || attributeObj.fieldType == "Number") {
                            var dynamicData = $scope.headerData[i].value;
                            var numberList = $scope.headerData;
                            for (var j = 0; j <= numberList.length - 1; j++) {
                                if (attributeObj.value == $scope.headerData[j].value && i != j) {

                                    var tovalue = "To_" + attributeObj.value;
                                    var fromValue = "From_" + attributeObj.value;
                                    $scope.fieldObject['fieldToValue'] = header[tovalue];
                                    $scope.fieldObject['fieldFromValue'] = header[fromValue];
                                    $scope.fieldObject['fieldType'] = $scope.headerData[i].fieldType;
                                    $scope.fieldObject['fieldName'] = $scope.headerData[i].value;
                                    $scope.headerData.splice(j, 1);
                                    numberList.splice(i, 1)
                                }

                            }
                        } else {
                            $scope.fieldObject['fieldFromValue'] = header[attributeObj.fieldName];

                            $scope.fieldObject['fieldType'] = $scope.headerData[i].fieldType;
                            $scope.fieldObject['fieldName'] = $scope.headerData[i].fieldName;
                        }

                        $scope.fromFieldDetails.push($scope.fieldObject);



                    }
                   // alert(JSON.stringify($scope.fromFieldDetails));

                });
                 $scope.totalTotalOfApprovers = {};

                for (i = 0; i < $scope.currentApprovallevels.length; i++) {
                    $scope.totalTotalOfApprovers[$scope.currentApprovallevels[i]] = $scope.newAttriData['Level' + (i+ 1)];
                }

    
         $scope.approvalLevels = {};
                $scope.approvalLevels['fromFieldDetails'] = $scope.fromFieldDetails;
                $scope.approvalLevels['approvalLevels'] = $scope.totalTotalOfApprovers;
                
                 $scope.approvalObj = $stateParams.matrixDetails;    
                $scope.approvalObj.approvalLevels[approveCtrl.index] = $scope.approvalLevels;
             //  alert(JSON.stringify($scope.approvalObj));

                 
                   
               RestAPIService.UpdateApprovalmatrix($scope.approvalObj).then(
                    function(success) {
                        RestAPIService.successTostDialog('Approval matrix details Updated Successfully');
                        $state.go('app.administration.approvematrix');
                    },
                    function(error) {
                        RestAPIService.showErrorDialog(error);
                    }
                );
                $mdDialog.hide();

            }

           }

           $scope.deleteApproveMatrixDetails = function(ev,index,currentRow){
            $scope.approvalObj = $stateParams.matrixDetails;
            $scope.approvalObj.approvalLevels.splice(index,1);
           /* RestAPIService.UpdateApprovalmatrix($scope.approvalObj).then(
                    function(success) {
                        RestAPIService.successTostDialog('Approval matrix details Updated Successfully');
                        $state.go('app.administration.approvematrix');
                    },
                    function(error) {
                        RestAPIService.showErrorDialog(error);
                    }
                );
                $mdDialog.hide();*/
                 var confirm = $mdDialog.confirm()
                 .title('Remove')
                 .textContent('Details  will be permanently deleted. Continue ?')
                 .targetEvent(ev)
                 .ok('Ok')
                 .cancel('Cancel');
             $mdDialog.show(confirm).then(function() {

               RestAPIService.UpdateApprovalmatrix($scope.approvalObj).then(
                    function(success) {
                        RestAPIService.successTostDialog('Approval matrix details Updated Successfully');
                        $state.go('app.administration.approvematrix');
                    },
                    function(error) {
                        RestAPIService.showErrorDialog(error);
                    }
                );
             }, function() {
                 $mdDialog.cancel();
             });
              

           }

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.administration')
        .controller('AdminSubstitutionController', AdminSubstitutionController);
        

    /** @ngInject */
    function AdminSubstitutionController($scope,RestAPIService,$state, $mdDialog, $sessionStorage,$localStorage)
    {
    	 var subCtrl = this;    
        
         $("#vertical-navigation").hide();
         $("#content-container").css({ "margin-left": "0px" });

    	 $scope.goToPreviousState = function() {
            $state.go("app.mycontent_inbox");
            $("#vertical-navigation").show();
            $("#content-container").css({ "margin-left": "60px" });
         }
          if ($localStorage.menubarsetting != undefined) {
                     $scope.showsForms = $localStorage.menubarsetting.formsmanagement;
                      $scope.showWorkflow = $localStorage.menubarsetting.adminWorkflow; 
                     $scope.showrequestManagement = $localStorage.menubarsetting.requestManagement;
                     $scope.showListManagement = $localStorage.menubarsetting.listManagement;
                     $scope.showBusinessObject = $localStorage.menubarsetting.businessObject;
                     $scope.showBinder = $localStorage.menubarsetting.binder;
                     $scope.showTemplates = $localStorage.menubarsetting.templates;
                     $scope.showReports1 = $localStorage.menubarsetting.adminReports;
                  
                    
                     $scope.showSubstitution = $localStorage.menubarsetting.substitution;
                     $scope.showZohoReports = $localStorage.menubarsetting.zohoReports;
                     
                      $scope.showDocumentType  = $localStorage.menubarsetting.documentTypes;
                       $scope.showReqTypeDetails  = $localStorage.menubarsetting.reqTypeDetails; 
                          $scope.showInvoiceTypes  = $localStorage.menubarsetting.invoiceTypes;        
                     
            }
    	 $scope.substitute = [];
    	 subCtrl.getAllSubstitutes = function(){
    		 $scope.substitute = [];
    		 RestAPIService.getAllSubstitutes().then(
                     function(success) {
                         $scope.allSubstitutes = success.data;
                         $scope.allSubstitutes.forEach(function(h) {
                             if(h.eliminationUser == null && h.substituteuser != ""){
                             	$scope.substitute.push(h);
                             }
                              
                          })
                     },
                     function(error) {
                         RestAPIService.showErrorDialog(error);
                     }
                 ); 
    	 }
    	 $scope.createSubstitutor = function(ev){
         	$mdDialog.show({
         		templateUrl: 'app/main/administration/admin-substitution/admin.create.substitution.html',
                 controller: CreateSubstitutorDialogController,                
                 parent: angular.element(document.body),
                 targetEvent: ev,
                 clickOutsideToClose: true,
                 fullscreen: $scope.customFullscreen
             })
         }    	 
         function CreateSubstitutorDialogController($scope, $mdDialog, $sessionStorage){
         	$scope.getAllUsers = function(){
             	RestAPIService.getUsers(0,5000).then(
                         function(success) {
                             $scope.usersList = success.data;                       
                         },
                         function(error) {
                             RestAPIService.showErrorDialog(error);
                         }
                     );
             }
         	$scope.cancel = function() {
                $mdDialog.cancel();
         	};
         	$scope.dateVis = false;
         	$scope.save = function(data){
         		if((data.from_date == undefined || data.from_date =="") || (data.to_date == undefined || data.to_date =="")){
         			$scope.dateVis = true;
         		}else{
         			data['createdBy'] = $sessionStorage.currentUser.username;
             		var d = new Date(data.from_date);
             			data.from_date = d;
             		
             		var e = new Date(data.to_date);
             		e.setHours(e.getHours()+23);
             		data.to_date = e;
             		
             		console.log(data);
             		RestAPIService.createSubstitutor(data).then(
                             function(success) {
//                                 $scope.usersList = success.data;
                            	 $mdDialog.show(
                             		      $mdDialog.alert()
                             		        .parent(angular.element(document.querySelector('#popupContainer')))
                             		        .clickOutsideToClose(true)
                             		        .title('Success.')
                             		        .textContent("Substitution created successfully.")
//                             		        .htmlContent("<h4><b>"+requestId+ "</b> was Rejectd successfully.</h4>")
                             		        .ariaLabel('Alert Dialog Demo')
                             		        .ok('Ok')
//                             		        .targetEvent(ev)
                             		    );
                             	$mdDialog.cancel();
                             	subCtrl.getAllSubstitutes();
                             },
                             function(error) {
                                 RestAPIService.showErrorDialog(error);
                             }
                         );
         			
         		}
         		
         		
         	}
         }
         $scope.update = function(ev, item){
    		 subCtrl.substitutionItem = angular.copy(item);
         	$mdDialog.show({
         		templateUrl: 'app/main/administration/admin-substitution/admin.update.substitution.html',
                 controller: UpdateUserDialogController,                
                 parent: angular.element(document.body),
                 targetEvent: ev,
                 clickOutsideToClose: true,
                 fullscreen: $scope.customFullscreen
             })
    	 }
         function UpdateUserDialogController($mdDialog, $scope, RestAPIService){        	
         	$scope.substitutionItem = subCtrl.substitutionItem;
            $scope.substitutionItem.from_date = new Date($scope.substitutionItem.from_date);
            $scope.substitutionItem.to_date = new Date($scope.substitutionItem.to_date);  		
         	$scope.cancel = function() {
                 $mdDialog.cancel();
          	};
          	$scope.getAllUsers = function(){
             	RestAPIService.getUsers(0,5000).then(
                         function(success) {
                             $scope.usersList = success.data;                       
                         },
                         function(error) {
                             RestAPIService.showErrorDialog(error);
                         }
                     );
             }
          	$scope.update = function(ev, data){
          		var d = new Date(data.fromDate);
         		/*d.setHours(d.getHours()+10);
         		data.fromDate = d;*/
          		//d.setMinutes(59);
         		data.fromDate = d;
         		
         		var e = new Date(data.toDate);
         		/*e.setHours(e.getHours()+10);*/
         		e.setHours(e.getHours()+23);
         		/*d.setMinutes(59);*/
         		data.toDate = e;
           		RestAPIService.updateSubstitutor(data).then(
                         function(success) {
                         	$mdDialog.cancel();
                         	$mdDialog.show(
                        		      $mdDialog.alert()
                        		        .parent(angular.element(document.querySelector('#popupContainer')))
                        		        .clickOutsideToClose(true)
                        		        .title('Success.')
                        		        .textContent("Substitution updated successfully.")
//                        		        .htmlContent("<h4><b>"+requestId+ "</b> was Rejectd successfully.</h4>")
                        		        .ariaLabel('Alert Dialog Demo')
                        		        .ok('Ok')
//                        		        .targetEvent(ev)
                        		    );
                         	subCtrl.getAllSubstitutes();
                         },
                         function(error) {
                             RestAPIService.showErrorDialog(error);
                         });
          	}
         }
         $scope.delete = function(ev, data){
         	var confirm = $mdDialog.confirm()
             .title('Remove')
             .textContent('Substitution will be permanently deleted. Continue ?')
             .targetEvent(ev)
             .ok('Ok')
             .cancel('Cancel');
         $mdDialog.show(confirm).then(function() {
         	RestAPIService.deleteSubstitutor(data).then(
                     function(success) {                   
//                     	RestAPIService.successTostDialog("Successfully Deleted.");
                    	 $mdDialog.show(
                     		      $mdDialog.alert()
                     		        .parent(angular.element(document.querySelector('#popupContainer')))
                     		        .clickOutsideToClose(true)
                     		        .title('Success.')
                     		        .textContent("Substitution deleted successfully.")
//                     		        .htmlContent("<h4><b>"+requestId+ "</b> was Rejectd successfully.</h4>")
                     		        .ariaLabel('Alert Dialog Demo')
                     		        .ok('Ok')
//                     		        .targetEvent(ev)
                     		    );
                     	subCtrl.getAllSubstitutes();
                     },
                     function(error) {
                         RestAPIService.showErrorDialog(error);
                     }
                 );
             
         }, function() {
             $mdDialog.cancel();
         });
         	
         }
        
    }


         
})();
(function ()
{
    'use strict';

    angular
        .module('app.administration')
        .controller('AdminReportsController', AdminReportsController);
        

    /** @ngInject */
    function AdminReportsController($scope,RestAPIService,$state,$localStorage, $mdDialog, $sessionStorage, Users,$location,$anchorScroll)
    {
    	 var reportsCtrl = this;
         $scope.users = Users.data;		
         $("#vertical-navigation").hide();
         $("#content-container").css({ "margin-left": "0px" });
        $scope.goToPreviousState = function() {
            $state.go("app.mycontent_inbox");
            $("#vertical-navigation").show();
            $("#content-container").css({ "margin-left": "60px" });
         }
        //  $('input[name="datefilter"]').on('apply.daterangepicker', function (
        //     ev,
        //     picker
        //   ) {
        //     $scope.obj.fromDate = picker.startDate._d
        //     $scope.obj.toDate = picker.endDate._d
        //   })

         $scope.getRequests =function(){
             RestAPIService.getRequests().then(function(success){
                $scope.requestTypes =success.data;
             },
             function(error){

             });
         }
         $scope.dateRangeOptions = {
            ranges: {
              'Today': [moment(), moment()],
              'Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
              'Last 7 Days': [moment().subtract(6, 'days'), moment()],
              'Last 30 Days': [moment().subtract(29, 'days'), moment()],
              'This Month': [moment().startOf('month'), moment().endOf('month')],
              'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
          },
          eventHandlers : {
              'apply.daterangepicker' : function(picker) {
              $scope.obj.fromDate =picker.model.startDate._d;
              $scope.obj.toDate =picker.model.endDate._d;
              }
            }
          };
          
      
       	 $scope.selectReport = function(report){	 
         	reportsCtrl.report = report;
			 $scope.header = report.header;  			      	
         	$mdDialog.show({
               controller: ReportDialogController,
               templateUrl: 'app/main/administration/admin-reports/reportPreviewDialog.html',
               parent: angular.element(document.body),
//               targetEvent: ev,
               clickOutsideToClose: true,
               fullscreen: $scope.customFullscreen
           });        	
         }
    	 function ReportDialogController($scope, $mdDialog,$sce){
         	$scope.currentstep = reportsCtrl.currentstep;         	
         	$scope.report = reportsCtrl.report;
         	$scope.workitemInfo = $scope.report;
			$scope.header = $scope.report.header;			
			$scope.currentFormHeader = $sce.trustAsHtml($scope.report.mainLayout.replace(/&quot;/g, '"'));
			$scope.projects =reportsCtrl.projects;
         	$scope.log = $scope.report.logs;
         	$scope.daysArray = [];
             $scope.createdDate = new Date($scope.workitemInfo.createdDate);         
         	$scope.log.forEach(function(h){
             	if(h.activityText == "Initiated" || h.activity =='001'){
             		h['icon'] = "icon-star-outline";
             	}
             	else if(h.activityText == "Approve"){
             		h['icon'] = "icon-check";
             	}
             	else if(h.activityText =="Collaborate" ||  h.activity == '110'){
             		h['icon'] ="icon-content-save";
             	}
             	else if(h.activityText =="CollaborateBack" ||  h.activity == '111'){
             		h['icon'] ="icon-content-save";
             	}
             	else if(h.activityText =="Cancel"){
             		h['icon'] ="icon-plus";
             	}
             	else if(h.activityText =="Delete"){
             		h['icon'] ="icon-delete";
             	}
             	else if(h.activityText == "Elimination"){
            		h['icon'] = "icon-check";
            	}
             	
 		        })	
         	
         	$scope.cancel = function() {
               $mdDialog.cancel();
         	};
           $scope.fileIcon = function(fileType){            	
           	var icon ={};
               if(fileType == "folder"){
                     icon = "icon-folder";
                 }                        
                 else if(fileType.indexOf("jpg")!= -1){
                     icon = "icon-file-image";
                 }
                 else if(fileType.indexOf("jpeg")!= -1){
                     icon = "icon-file-image";
                 }
                 else if(fileType.indexOf("png")!= -1){
                     icon = "icon-file-image";
                 }
                 else if(fileType.indexOf("pdf")!= -1){
                     icon = "icon-file-pdf-box";
                 }
                 else if(fileType.indexOf("txt")!= -1){
                     icon = "icon-clipboard-text";
                 }
                 else if(fileType.indexOf("html")!= -1){
                     icon = "icon-language-html5";
                 }
                 else if(fileType.indexOf("xl")!= -1){
                     icon = "icon-file-excel";
                 }
                 else if(fileType.indexOf("word")!= -1){
                     icon = "icon-file-word";
                 }
                 else if(fileType.indexOf("xml")!= -1){
                     icon = "icon-file-xml";
                 }
                 else if(fileType.indexOf("doc")!= -1){
                     icon = "icon-file-document";
                 }  
                 else if(fileType.indexOf("docx")!= -1){
                     icon = "icon-file-document";
                 }
                 else if(fileType.indexOf("json")!= -1){
                     icon = "icon-clipboard-text";
                 }                      

                 else{
                     icon = "icon-file-document";
                 }
                 return icon;
                
		   } 

		   $scope.downloadFile =function(file,reqId){
            var archiveId = file.archiveId;
            var ReqId = reqId;
            var archiveDocId = file.archiveDocId;
       RestAPIService.downloadAttachment(ReqId,archiveId,archiveDocId).then(
                 function(success) { 
                         var headers = success.headers();                        
                         var data = success.data;                         
                         var filename = file.fileName;
                         var contentType = headers['content-type'];
                         var linkElement = document.createElement('a');
                         try {
                             var blob = new Blob([data], { type: contentType });
                             var url = window.URL.createObjectURL(blob);
                             linkElement.setAttribute('href', url);
                             linkElement.setAttribute("download", filename);
                             var clickEvent = new MouseEvent("click", {
                                 "view": window,
                                 "bubbles": true,
                                 "cancelable": false
                             });
                             linkElement.dispatchEvent(clickEvent);
                         } catch (ex) {
                             console.log(ex);
                         }
                 },
                 function(error) {
                     console.log('ERROR Downloading the file ********');
                     RestAPIService.showErrorDialog(error);
                 }
             );
         } 
		   var jwtToken = $localStorage.currentUser.token.trim();
           $scope.preview = function(ev, file, reqId,url) {
        	   reportsCtrl.file = file;
        	   reportsCtrl.ReqId =reqId;
        	   reportsCtrl.ArchiveId =file.archiveId;
        	   reportsCtrl.ArchivedocId =file.archiveDocId;
			   reportsCtrl.url= url;			  
			   reportsCtrl.file.fileType.toLowerCase();
			   if(reportsCtrl.file.fileType == "pdf"){
				window.open(baseUrl+'/api/requests/inbox/filedownload?archiveId='+reportsCtrl.ArchiveId+'&requestId='+reportsCtrl.ReqId+'&archiveDocId='+reportsCtrl.ArchivedocId+'&attachment=false&jwtToken='+jwtToken);
			  // window.open(url);
			   }
			   else{
               $mdDialog.show({
                   controller: DialogController,
                   templateUrl: 'app/main/reports/previewFiles.html',
                   parent: angular.element(document.body),
				   targetEvent: ev,
				   autoWrap: true,
				   skipHide: true, 
                   clickOutsideToClose: true
               });
		   }
		}
           function DialogController($scope, $mdDialog, $sce, $sessionStorage) {
               $scope.fileVis = false;
               $scope.imgVis= false;
               $scope.cancel = function() {
                   $mdDialog.cancel();
               };               
                 if(jwtToken != undefined && reportsCtrl.ReqId != undefined) {
                 	//baseUrl+'/api/requests/inbox/filedownload?archiveId='+contentCtrl.ArchiveId+'&requestId='+contentCtrl.ReqId+'&archiveDocId='+contentCtrl.ArchivedocId+'&attachment=false&jwtToken='+jwtToken
                  var encodedURI = encodeURIComponent(baseUrl+'/api/requests/inbox/filedownload?archiveId='+reportsCtrl.ArchiveId+'&requestId='+reportsCtrl.ReqId+'&archiveDocId='+reportsCtrl.ArchivedocId+'&attachment=false&jwtToken='+jwtToken);
                   if(reportsCtrl.file.fileType =="jpg" || reportsCtrl.file.fileType =="JPG" || reportsCtrl.file.fileType =="jpeg" || reportsCtrl.file.fileType =="JPEG" || reportsCtrl.file.fileType =="PNG" || reportsCtrl.file.fileType =="png"){
                 	 $scope.imgVis= true;
                 	 $scope.fileURL =baseUrl+'/api/requests/inbox/filedownload?archiveId='+reportsCtrl.ArchiveId+'&requestId='+reportsCtrl.ReqId+'&archiveDocId='+reportsCtrl.ArchivedocId+'&attachment=false&jwtToken='+jwtToken;
                  }else{
                 	 $scope.fileVis= true;
                 	 $scope.fileURL = $sce.trustAsResourceUrl('https://docs.google.com/gview?url='+encodedURI+'&embedded=true');
                  }                  
                 }
			 }
			
           
         }    	
    	 $scope.obj ={    			 
    			 "requestType":null,
    			 "creator":null,
    			 "rangeFrom":null,
    			 "rangeTo":null,    			
    			 "fromDate":null,    			
    			 "toDate":null,    		  
    		    "currentUser":null
    			 
    	 }
    	 $scope.Reset =function(){
    		 $scope.obj ={};
    	 }
    	 
    	 $scope.pageNumber = 0;
    	 $scope.size =10;
         $scope.sizeNumbers= [10,20,50,100,539];
         $scope.next = function(){       	
          $scope.data =reportsCtrl.searchData;        	
     	  $scope.pageNumber = $scope.pageNumber + 1; 
     	  $scope.searchforReports($scope.data);	     	
         }
         $scope.previous = function(){
	         $scope.data =reportsCtrl.searchData;
	         $scope.pageNumber = $scope.pageNumber - 1; 
	         $scope.searchforReports($scope.data);         	
         }
         $scope.sendPageNumber = function(page) {
        	 $scope.pageNumber = page;
             $scope.searchforReports(reportsCtrl.searchData);
         }
         $scope.sendsizeNumber = function(sizeNumber){
        	 $scope.size =sizeNumber;
        	 $scope.pageNumber =0 ;
        	 $scope.searchforReports(reportsCtrl.searchData);
         }
    	 
      $scope.searchforReports = function(data){
    		 reportsCtrl.searchData =data;
    		 if(data.fromDate !=undefined || data.fromDate !=undefined){
    		 if(data.fromDate || data.toDate){
    			 if(data.fromDate){
    		 var d = new Date(data.fromDate);
      		d.setHours(d.getHours()+10);
      		data.fromDate = d;
    			 }
    			 if(data.toDate){
    				 var d = new Date(data.toDate);
    		      		d.setHours(d.getHours()+6);
    		      		d.setMinutes(29);
    		      		data.toDate = d; 
    			 }     		
    		 }
    		 } 		
    		 
      		 for(var index in data) {
    		 if(data[index] == "" || data[index] == undefined){
    				 data[index] =null;
    			 }
    			}  		
      		if(data.requestType =="" ||data.requestType ==undefined){
      			 $mdDialog.show(
      				      $mdDialog.alert()
      				        .parent(angular.element(document.querySelector('#popupContainer')))
      				        .clickOutsideToClose(true)
      				        .title('Warning')
      				        .textContent('Request Type is Required')
      				        .ariaLabel('Alert Dialog')
      				        .ok('Got it!')
      				        
      				    );
    			 return;
    		 }    
      		if($scope.size == undefined || $scope.size == null){
      			$scope.size =10;
			  }
			
    	RestAPIService.getAdminReports(data,$scope.pageNumber,$scope.size,$localStorage.FlowType).then(function(responce){
			$scope.pageNumbers = [];
			  $scope.allReports = responce.data;  
				  $location.hash('scrollToDivID');
    	  		  $anchorScroll();
    	  		 $scope.totalRecords = responce.headers('x-total-count');
    	  		 $scope.totalPages = Math.ceil($scope.totalRecords/$scope.size);    	  		 
                 if ($scope.totalPages > 0) {
                     for (var i = 0; i < $scope.totalPages; i++) {
                         $scope.pageNumbers.push(i);
                     }
                 }    	  	
    		$scope.Reset();          		
          	},function(error){
          		RestAPIService.showErrorDialog(error);
          	})
    	 }
    	 $scope.createdDate = function(report) {
    		    var date = new Date(report.createdDate);
    		    return date;
    		};
    		 
    	
         $scope.selectAll = function(){
//        	 alert($scope.obj.selectAll);
        	 if($scope.obj.selectAll != false){
        		 $scope.obj = null;
        	 }
         }
        
    }


         
})();
(function ()
{
    'use strict';

    angular
        .module('app.administration')
        .controller('ReAssignController', ReAssignController);


    /** @ngInject */
    function ReAssignController($scope,RestAPIService,$state, $mdDialog, $sessionStorage,$localStorage)
    {
    	 var reassignCtrl = this;
    	 reassignCtrl.dtOptions = {

        		 dom       : '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
                 //pagingType: 'simple',
                 pagingType: 'simple',
                 lengthMenu: [10, 50, 100,200,300,400,500],
                 pageLength: 20,
 	            autoWidth : false,
                 responsive: true,
                //  lengthMenu: [10, 20, 50, 100]


    	 }
          if ($localStorage.menubarsetting != undefined) {
                     $scope.showsForms = $localStorage.menubarsetting.formsmanagement;
                      $scope.showWorkflow = $localStorage.menubarsetting.adminWorkflow;
                     $scope.showrequestManagement = $localStorage.menubarsetting.requestManagement;
                     $scope.showListManagement = $localStorage.menubarsetting.listManagement;
                     $scope.showBusinessObject = $localStorage.menubarsetting.businessObject;
                     $scope.showBinder = $localStorage.menubarsetting.binder;
                     $scope.showTemplates = $localStorage.menubarsetting.templates;
                     $scope.showReports1 = $localStorage.menubarsetting.adminReports;


                     $scope.showSubstitution = $localStorage.menubarsetting.substitution;
                     $scope.showZohoReports = $localStorage.menubarsetting.zohoReports;

                      $scope.showDocumentType  = $localStorage.menubarsetting.documentTypes;
                       $scope.showReqTypeDetails  = $localStorage.menubarsetting.reqTypeDetails;
                          $scope.showInvoiceTypes  = $localStorage.menubarsetting.invoiceTypes;

            }


//    	 $scope.requestType = null;
    	 $scope.obj={};
//    	 $scope.obj.requestType
    	  $("#vertical-navigation").hide();
         $("#content-container").css({ "margin-left": "0px" });

    	  $scope.goToPreviousState = function() {
            $state.go("app.mycontent_inbox");
            $("#vertical-navigation").show();
            $("#content-container").css({ "margin-left": "60px" });
         }
//    	 $scope.x=[];
    	 reassignCtrl.getAllRequestTypes = function(){
            $scope.allHybridrequests=[]
    		 RestAPIService.getRequests().then(
                     function(success) {
                         $scope.allRequests = success.data;
                         //coromandel code//
                    for(var i=0;i<$scope.allRequests.length;i++){
                        if($scope.allRequests[i].flowType== "Hybrid"){
                            $scope.allHybridrequests.push($scope.allRequests[i])   

                        }
                    }
               //coromandel code//
                         },

                     function(error) {
                         RestAPIService.showErrorDialog(error);
                     }
                 );
    	 }
    	 $scope.searchMember = function(memberdata){

             var q = "";
            if(memberdata == undefined || angular.equals(memberdata, {}) ){
                $scope.msgVisibility=true;
                $scope.tableVisibility=false;
                $scope.member = {};
            }else{
                if((memberdata.name !=""&&memberdata.name !=undefined) && (memberdata.email !="" && memberdata.email !=undefined)){
                  q = memberdata.name;
                }else if((memberdata.name ==""|| memberdata.name==undefined) && (memberdata.email !="" && memberdata.email != undefined)){
                    q = memberdata.email;
                }else if(memberdata.name !="" && (memberdata.email ==""||memberdata.email==undefined)){
                    q = memberdata.name;
                }
                $scope.searchedMembers= [];
                RestAPIService.searchMemberForGroups(q,'user').then(
                function(success){
                    $scope.searchedMembers = success.data;
                    console.log($scope.searchedMembers);
                    $scope.msgVisibility=false;
                    $scope.tableVisibility=true;
                    $scope.member = {};
                },function(error){
                    RestAPIService.showErrorDialog(error);
                }
                );
            }
        }

    	 $scope.getRequestIds = function(login){
    		 reassignCtrl.member = login;
    		 reassignCtrl.requestType = $scope.obj.requestType.toUpperCase();
    		 RestAPIService.getRequestIds($scope.obj.requestType.toUpperCase(), login).then(
    	                function(success){
    	                    $scope.allRequestTypes = success.data;
    	                    console.log($scope.allRequestTypes);
    	                },function(error){
    	                    RestAPIService.showErrorDialog(error);
    	                });
    	 }
    	 reassignCtrl.finalRequestsArray=[];
    	 $scope.selectNumber = function(value,obj){
    		 if(value == true){
    			 reassignCtrl.finalRequestsArray.push(obj);
    		 }else if(value == false){
    			 reassignCtrl.finalRequestsArray.splice(obj, 1);
    		 }
    		 console.log(reassignCtrl.finalRequestsArray);
    	 }

    	 $scope.searchforReassignUser = function(){
    		 $mdDialog.show({
           		templateUrl: 'app/main/administration/admin-reAssign/reAssignmentDialog.html',
                   controller: ReAssignmentDialogController,
                   parent: angular.element(document.body),
//                   targetEvent: ev,
                   clickOutsideToClose: true,
                   fullscreen: $scope.customFullscreen
               })
    	 }
    	 function ReAssignmentDialogController($scope, $mdDialog, RestAPIService){
    		 $scope.searchMember = function(memberdata){
                 var q = "";
                if(memberdata == undefined || angular.equals(memberdata, {}) ){
                    $scope.msgVisibility=true;
                    $scope.tableVisibility=false;
                    $scope.member = {};
                }else{
                    if((memberdata.name !=""&&memberdata.name !=undefined) && (memberdata.email !="" && memberdata.email !=undefined)){
                      q = memberdata.name;
                    }else if((memberdata.name ==""|| memberdata.name==undefined) && (memberdata.email !="" && memberdata.email != undefined)){
                        q = memberdata.email;
                    }else if(memberdata.name !="" && (memberdata.email ==""||memberdata.email==undefined)){
                        q = memberdata.name;
                    }
                    $scope.searchedMembers= [];
                    RestAPIService.searchMemberForGroups(q,'user').then(
                    function(success){
                        $scope.searchedMembers = success.data;
                        console.log($scope.searchedMembers);
                        $scope.msgVisibility=false;
                        $scope.tableVisibility=true;
                        $scope.member = {};
                    },function(error){
                        RestAPIService.showErrorDialog(error);
                    }
                    );
                }
            }
    		 $scope.cancel = function() {
               $mdDialog.cancel();
        	};
    		 $scope.submit = function(login){
                 $scope.encodedArrayFormat ="";
                 $scope.activity ="350"
    			 reassignCtrl.finalRequestsArray.forEach(function(h) {
    				 if(reassignCtrl.finalRequestsArray.indexOf(h) == 0){
    					 $scope.encodedArrayFormat=h;
    				 }else{
    					 $scope.encodedArrayFormat = $scope.encodedArrayFormat+'%2C'+h;
    				 }
//
    		        })
//    		        var json={};
//    			 json['requestData']=$scope.encodedArrayFormat;
        		 RestAPIService.submitReAssignment(reassignCtrl.requestType, login,$scope.activity, $scope.encodedArrayFormat).then(
     	                function(success){

                         RestAPIService.successTostDialog("Re-Assign is done successfully.")
                         $state.reload()
     	                	$mdDialog.cancel();
     	                },function(error){
     	                    RestAPIService.showErrorDialog(error);
     	                });
        	 }


          }
//    	 $scope.update = function(ev, item){
//    		 elmCtrl.Item = angular.copy(item);
//         	$mdDialog.show({
//         		templateUrl: 'app/main/administration/admin-elimination/update.elimination.html',
//                 controller: UpdateDialogController,
//                 parent: angular.element(document.body),
//                 targetEvent: ev,
//                 clickOutsideToClose: true,
//                 fullscreen: $scope.customFullscreen
//             })
//    	 }
//    	 function UpdateDialogController($mdDialog, $scope, RestAPIService){
//          	$scope.substitutionItem = elmCtrl.Item;
//          	$scope.cancel = function() {
//                  $mdDialog.cancel();
//           	};
//           	$scope.getAllUsers = function(){
//              	RestAPIService.getUsers().then(
//                          function(success) {
//                              $scope.usersList = success.data;
//                          },
//                          function(error) {
//                              RestAPIService.showErrorDialog(error);
//                          }
//                      );
//              }
//           	$scope.save = function(ev, data){
//           		var d = new Date(data.fromDate);
//         		d.setHours(d.getHours()+10);
//         		data.fromDate = d;
//
//         		var e = new Date(data.toDate);
//         		e.setHours(e.getHours()+10);
//         		data.toDate = e;
//            		RestAPIService.updateSubstitutor(data).then(
//                          function(success) {
//                          	$mdDialog.cancel();
//                          	$mdDialog.show(
//                         		      $mdDialog.alert()
//                         		        .parent(angular.element(document.querySelector('#popupContainer')))
//                         		        .clickOutsideToClose(true)
//                         		        .title('Success.')
//                         		        .textContent("Elimination updated successfully.")
////                         		        .htmlContent("<h4><b>"+requestId+ "</b> was Rejectd successfully.</h4>")
//                         		        .ariaLabel('Alert Dialog Demo')
//                         		        .ok('Ok')
////                         		        .targetEvent(ev)
//                         		    );
//                          	elmCtrl.getAllEliminations();
//                          },
//                          function(error) {
//                              RestAPIService.showErrorDialog(error);
//                          });
//           	}
//          }
//    	 $scope.delete = function(ev, data){
//          	var confirm = $mdDialog.confirm()
//              .title('Remove')
//              .textContent('Elimination will be permanently deleted. Continue ?')
//              .targetEvent(ev)
//              .ok('Ok')
//              .cancel('Cancel');
//          $mdDialog.show(confirm).then(function() {
//          	RestAPIService.deleteSubstitutor(data).then(
//                      function(success) {
////                      	RestAPIService.successTostDialog("Successfully Deleted.");
//                     	 $mdDialog.show(
//                      		      $mdDialog.alert()
//                      		        .parent(angular.element(document.querySelector('#popupContainer')))
//                      		        .clickOutsideToClose(true)
//                      		        .title('Success.')
//                      		        .textContent("Elimination deleted successfully.")
////                      		        .htmlContent("<h4><b>"+requestId+ "</b> was Rejectd successfully.</h4>")
//                      		        .ariaLabel('Alert Dialog Demo')
//                      		        .ok('Ok')
////                      		        .targetEvent(ev)
//                      		    );
//                     	elmCtrl.getAllEliminations();
//                      },
//                      function(error) {
//                          RestAPIService.showErrorDialog(error);
//                      }
//                  );
//
//          }, function() {
//              $mdDialog.cancel();
//          });
//
//          }



    }



})();

(function() {
    'use strict';

    angular
        .module('app.administration')
        .controller('TemplateController', TemplateController);

    /** @ngInject */
    function TemplateController($state, $scope, $mdDialog, RestAPIService,DocumentTypes,Templates,$filter,$localStorage) {
        var templateCtrl = this;
       $scope.templates =Templates.data;       
        $("#vertical-navigation").hide();
        $("#content-container").css({ "margin-left": "0px" });
        templateCtrl.dtOptions = { 
       		 dom       : '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
	            pagingType: 'simple',
	            autoWidth : false,
	            responsive: true
        };
        $scope.goToPreviousState = function() {
        	$state.go("app.mycontent_inbox");
         	$("#vertical-navigation").show();
         	$("#content-container").css({ "margin-left": "60px" });
        }
       /* $scope.getTemplates = function() {
            RestAPIService.getTemplates().then(
                function(success) { 
                	console.log(success.data);
                     },
                function(error) {
                    RestAPIService.showErrorDialog(error);
                });
        };*/
        if ($localStorage.menubarsetting != undefined) {
                     $scope.showsForms = $localStorage.menubarsetting.formsmanagement;
                      $scope.showWorkflow = $localStorage.menubarsetting.adminWorkflow; 
                     $scope.showrequestManagement = $localStorage.menubarsetting.requestManagement;
                     $scope.showListManagement = $localStorage.menubarsetting.listManagement;
                     $scope.showBusinessObject = $localStorage.menubarsetting.businessObject;
                     $scope.showBinder = $localStorage.menubarsetting.binder;
                     $scope.showTemplates = $localStorage.menubarsetting.templates;
                     $scope.showReports1 = $localStorage.menubarsetting.adminReports;
                  
                    
                     $scope.showSubstitution = $localStorage.menubarsetting.substitution;
                     $scope.showZohoReports = $localStorage.menubarsetting.zohoReports;
                     
                      $scope.showDocumentType  = $localStorage.menubarsetting.documentTypes; 
                       $scope.showReqTypeDetails  = $localStorage.menubarsetting.reqTypeDetails; 
                          $scope.showInvoiceTypes  = $localStorage.menubarsetting.invoiceTypes;       
                     
            }
        $scope.templateDelete = function(ev){
        	 var datares = $filter('filter')($scope.templates, {'id': ev.id});
        	 var confirm = $mdDialog.confirm()
             .title('Remove')
             .textContent('DocumentType Template ' + datares[0].name + ' ' + ' will be permanently deleted. Continue ?')
             .ok('Ok')
             .cancel('Cancel');
         $mdDialog.show(confirm).then(function() {
        	RestAPIService.DeleteTemplate(datares[0].id).then(
                    function(success) {
                       RestAPIService.successTostDialog("Template Deleted successfully ");
                      $state.reload();
                    },
                    function(error) {
                        RestAPIService.showErrorDialog(error);
                    }
                );
                $mdDialog.hide();
        	
         });
        
    }
        $scope.createTemplateDialog = function(ev) {
            $mdDialog.show({
                controller: createTemplateDialogController,
                templateUrl: 'app/main/administration/Template/create.template.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: $scope.customFullscreen
            })
            $scope.cancel = function() {

            };
        };
        function createTemplateDialogController($scope, $mdDialog, RestAPIService,$state) {
        	$scope.Documents =DocumentTypes.data;
           /* console.log($scope.Documents);*/
        	
        	  var formData = new FormData();
        	 $scope.setFile = function(element) {
                 $scope.$apply(function() {
                     $scope.files = [];
                     for (var i = 0; i < element.files.length; i++) {
                         formData.append('file', element.files[i]);
                         $scope.files.push(element.files[i]);
                         //console.log($scope.files);
                     }
                 });
             };
            $scope.hide = function() {
                $mdDialog.hide();
            };
           
            $scope.cancel = function() {
                $mdDialog.cancel();
            };
            $scope.save = function(ev,template) {            	
            	RestAPIService.CreateTemplate(template, $scope.files[0]).then(
                        function(success) {
                           RestAPIService.successTostDialog("Template uploaded successfully ");
                          $state.reload();
                        },
                        function(error) {
                            RestAPIService.showErrorDialog(error);
                        }
                    );
                    $mdDialog.hide(ev);
            	    
            };
        }
        
         templateCtrl.currentTemplate = {};
        $scope.updateTemplateDialog = function(ev) {
        	 var datares = $filter('filter')($scope.templates, {'id': ev.id});
             templateCtrl.currentTemplate = angular.copy(datares[0]);
            $mdDialog.show({
                controller: updateTemplateDialogController,
                templateUrl: 'app/main/administration/Template/update.template.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: $scope.customFullscreen
            })
        };
        function updateTemplateDialogController($scope, $mdDialog) {
        	$scope.Documents =DocumentTypes.data;
        	  var formData = new FormData();
         	 $scope.setFile = function(element) {
                  $scope.$apply(function() {
                      $scope.files = [];
                      for (var i = 0; i < element.files.length; i++) {
                          formData.append('file', element.files[i]);
                          $scope.files.push(element.files[i]);
                          //console.log($scope.files);
                      }
                  });
              };
            $scope.currentTemplate =  templateCtrl.currentTemplate;
            //alert(JSON.stringify( $scope.currentTemplate));

            $scope.hide = function() {
                $mdDialog.hide();
            };
            $scope.cancel = function() {
                $mdDialog.cancel();
            };
            $scope.update = function(ev,template) {
            	//console.log(template);
            	RestAPIService.UpdateTemplate(template, $scope.files[0]).then(
                        function(success) {
                           RestAPIService.successTostDialog("Template updated successfully ");
                          $state.reload();
                        },
                        function(error) {
                            RestAPIService.showErrorDialog(error);
                        }
                    );
                    $mdDialog.hide(ev);
            	
            };
        }
       
        
        $scope.previewFile = function(ev) {
     	   $mdDialog.show({
     	      controller: DialogController,
     	      templateUrl: 'app/main/administration/Template/template.preview.html',
     	      parent: angular.element(document.body),
     	      targetEvent: ev,
     	      clickOutsideToClose:true
     	    });
         }
         
         function DialogController($scope, $mdDialog, $sce) {
         	
         }
       
     
       
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.Adminsubstitution', [] )
        .run(run)
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider, $mdThemingProvider)
    {
    	 $stateProvider
            
            .state('app.Adminsubstitution', {
                url: '/substitution',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/adminSubstitution/adminSubstitution.html',
                        controller:  'AdminSubstitution as subCtrl'
                    }
                }
            })
            .state('app.Adminsubstitution.reAssign', {
                url: '/reassign',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/adminSubstitution/admin-reAssign/preview.reAssign.html',
                        controller: 'AdminReAssignController as reassignCtrl'
                    }
                }
            });
            // msNavigationServiceProvider.saveItem('Substitution', {
            //     title : 'Substitution',
            //     icon  : 'icon-file-document',
            //     state : 'app.Adminsubstitution',
            //     weight: 8
            // });
    
    }
    function run(msNavigationService, $localStorage, $rootScope, $state) {
        
        $rootScope.$state = $state;
       msNavigationService.saveItem('Substitution', {
           title: 'Substitute',
           icon: 'icon-file-document',
           state: 'app.Adminsubstitution',
           weight: 8,
           hidden: function() {                 
                   if ($rootScope.currentLogedInUser != undefined) {
                       var roles = $rootScope.currentLogedInUser.authorities;
                       return !(roles.indexOf("ROLE_BUSINESS_ADMIN") > -1);
                   }
                  }
       });
      
   }
})();


(function ()
{
    'use strict';

    angular
        .module('app.Adminsubstitution')
        .controller('AdminReAssignController', AdminReAssignController);
        

    /** @ngInject */
    function AdminReAssignController($scope,RestAPIService,$state, $mdDialog, $sessionStorage,$localStorage)
    {
    	 var reassignCtrl = this;
    	 reassignCtrl.dtOptions = {
        		 
        		 dom       : '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
                 //pagingType: 'simple',
                 pagingType: 'simple',
                 lengthMenu: [10, 50, 100,200,300,400,500],
                 pageLength: 20,
 	            autoWidth : false,
                 responsive: true,
                //  lengthMenu: [10, 20, 50, 100]

               
    	 }
          if ($localStorage.menubarsetting != undefined) {
                     $scope.showsForms = $localStorage.menubarsetting.formsmanagement;
                      $scope.showWorkflow = $localStorage.menubarsetting.adminWorkflow; 
                     $scope.showrequestManagement = $localStorage.menubarsetting.requestManagement;
                     $scope.showListManagement = $localStorage.menubarsetting.listManagement;
                     $scope.showBusinessObject = $localStorage.menubarsetting.businessObject;
                     $scope.showBinder = $localStorage.menubarsetting.binder;
                     $scope.showTemplates = $localStorage.menubarsetting.templates;
                     $scope.showReports1 = $localStorage.menubarsetting.adminReports;
                  
                    
                     $scope.showSubstitution = $localStorage.menubarsetting.substitution;
                     $scope.showZohoReports = $localStorage.menubarsetting.zohoReports;
                     
                      $scope.showDocumentType  = $localStorage.menubarsetting.documentTypes; 
                       $scope.showReqTypeDetails  = $localStorage.menubarsetting.reqTypeDetails; 
                          $scope.showInvoiceTypes  = $localStorage.menubarsetting.invoiceTypes;       
                     
            }
    	
    	 

    	 $scope.obj={};
//    

    	 reassignCtrl.getAllRequestTypes = function(){
    		 $scope.allHybridrequests=[];
    		 RestAPIService.getRequests().then(
                     function(success) {
                         $scope.allRequests = success.data;  
                        
                         },                         
                   
                     function(error) {
                         RestAPIService.showErrorDialog(error);
                     }
                 );
    	 }
    	 $scope.searchMember = function(memberdata){ 
      		
             var q = "";
            if(memberdata == undefined || angular.equals(memberdata, {}) ){
                $scope.msgVisibility=true;
                $scope.tableVisibility=false;
                $scope.member = {}; 
            }else{ 
                if((memberdata.name !=""&&memberdata.name !=undefined) && (memberdata.email !="" && memberdata.email !=undefined)){
                  q = memberdata.name;
                }else if((memberdata.name ==""|| memberdata.name==undefined) && (memberdata.email !="" && memberdata.email != undefined)){
                    q = memberdata.email;
                }else if(memberdata.name !="" && (memberdata.email ==""||memberdata.email==undefined)){
                    q = memberdata.name;
                }
                $scope.searchedMembers= [];                     
                RestAPIService.searchMemberForGroups(q,'user').then(
                function(success){
                    $scope.searchedMembers = success.data;
                    console.log($scope.searchedMembers);
                    $scope.msgVisibility=false;
                    $scope.tableVisibility=true;
                    $scope.member = {};                        
                },function(error){
                    RestAPIService.showErrorDialog(error);
                }
                );
            }                       
        }
    	 
    	 $scope.getRequestIds = function(login){
    		 reassignCtrl.member = login;
    		 reassignCtrl.requestType = $scope.obj.requestType.toUpperCase();
    		 RestAPIService.getRequestIds($scope.obj.requestType.toUpperCase(), login).then(
    	                function(success){
    	                    $scope.allRequestTypes = success.data;
    	                    console.log($scope.allRequestTypes);   	                                        
    	                },function(error){
    	                    RestAPIService.showErrorDialog(error);
    	                });
    	 }
    	 reassignCtrl.finalRequestsArray=[];
    	 $scope.selectNumber = function(value,obj){
    		 if(value == true){
    			 reassignCtrl.finalRequestsArray.push(obj);
    		 }else if(value == false){
    			 reassignCtrl.finalRequestsArray.splice(obj, 1);
    		 }
    		 console.log(reassignCtrl.finalRequestsArray);
    	 }
    	 
    	 $scope.searchforReassignUser = function(){
    		 $mdDialog.show({
           		templateUrl: 'app/main/administration/admin-reAssign/reAssignmentDialog.html',
                   controller: ReAssignmentDialogController,                
                   parent: angular.element(document.body),
//                   targetEvent: ev,
                   clickOutsideToClose: true,
                   fullscreen: $scope.customFullscreen
               })
    	 }
    	 function ReAssignmentDialogController($scope, $mdDialog, RestAPIService){
    		 $scope.searchMember = function(memberdata){     	      		
                 var q = "";
                if(memberdata == undefined || angular.equals(memberdata, {}) ){
                    $scope.msgVisibility=true;
                    $scope.tableVisibility=false;
                    $scope.member = {}; 
                }else{ 
                    if((memberdata.name !=""&&memberdata.name !=undefined) && (memberdata.email !="" && memberdata.email !=undefined)){
                      q = memberdata.name;
                    }else if((memberdata.name ==""|| memberdata.name==undefined) && (memberdata.email !="" && memberdata.email != undefined)){
                        q = memberdata.email;
                    }else if(memberdata.name !="" && (memberdata.email ==""||memberdata.email==undefined)){
                        q = memberdata.name;
                    }
                    $scope.searchedMembers= [];                     
                    RestAPIService.searchMemberForGroups(q,'user').then(
                    function(success){
                        $scope.searchedMembers = success.data;
                        console.log($scope.searchedMembers);
                        $scope.msgVisibility=false;
                        $scope.tableVisibility=true;
                        $scope.member = {};                        
                    },function(error){
                        RestAPIService.showErrorDialog(error);
                    }
                    );
                }                       
            }
    		 $scope.cancel = function() {
               $mdDialog.cancel();
        	};
    		 $scope.submit = function(login){
                 $scope.encodedArrayFormat =""; 
                 $scope.activity ="350"
    			 reassignCtrl.finalRequestsArray.forEach(function(h) {
    				 if(reassignCtrl.finalRequestsArray.indexOf(h) == 0){
    					 $scope.encodedArrayFormat=h;
    				 }else{
    					 $scope.encodedArrayFormat = $scope.encodedArrayFormat+'%2C'+h;
    				 }
//    				 
    		        })
//    		        var json={};
//    			 json['requestData']=$scope.encodedArrayFormat;
        		 RestAPIService.submitReAssignment(reassignCtrl.requestType, login,$scope.activity, $scope.encodedArrayFormat).then(
     	                function(success){

     	                	RestAPIService.successTostDialog("Re-Assign is done successfully.")
     	                	$mdDialog.cancel();
     	                },function(error){
     	                    RestAPIService.showErrorDialog(error);
     	                });
        	 }
    	 
         	
          }

    	
         
        
    }


         
})();
(function ()
{
    'use strict';

    angular
        .module('app.maininbox', ['ui.select', 'ngSanitize'] )
        .config(config)
        .run(run);
    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider, $mdThemingProvider)
    {
    	 $stateProvider
            
            .state('app.maininbox', {
                url: '/maininbox',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/Main_Inbox/main_inbox.html',
                        controller:  'MainInboxController as vm'
                    }
                },
                resolve: {
                    RestAPIService: 'RestAPIService',
                    Vendors: function(RestAPIService) {
                        return RestAPIService.getListsByname("Vendor");
                    },
                    Companies: function(RestAPIService) {
                        return RestAPIService.getListsByname("Company");
                    },
                    InvoiceTypes: function(RestAPIService) {
                        return RestAPIService.getListsByname("Invoice Category");
                    },
                    Requestors: function(RestAPIService) {
                        return RestAPIService.getListsByname("requestor");
                    }
                    // InvoiceWorkItems:function(RestAPIService) {
                    //     return RestAPIService.getAllInboxWorkitems("PAYABLES_NPO_V1");
                    // }


                }
            })
            .state('app.maininbox.detail', {
                url      : '/:id',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/Main_Inbox/inbox_details/inbox_details.html',
                        controller : 'DetailsController as DetailsCtrl'
                    }
                },              
                bodyClass: 'e-commerce'
            });

    //   msNavigationServiceProvider.saveItem('Inbox', {
    //         title : 'Inbox',
    //         icon  : 'icon-file-document',
    //         state : 'app.maininbox',
    //         weight: 8
    //     });

    }
    function run(msNavigationService, $localStorage, $rootScope, $state) {
        msNavigationService.saveItem('Inbox', {
            title : 'Inbox',
            icon  : 'icon-file-document',
            state : 'app.maininbox',
           weight: 8,
        hidden:function(){
            if ($localStorage.menubarsetting != undefined) {
              var show = $localStorage.menubarsetting.mainInbox;
              return !(show);
                 }
            }
        });
    }
})();


(function ()
{
    'use strict';

    angular
        .module('app.maininbox')
        .filter('propsFilter', function() {
            return function(items, props) {
              var out = [];
          
              if (angular.isArray(items)) {
                var keys = Object.keys(props);
          
                items.forEach(function(item) {
                  var itemMatches = false;
          
                  for (var i = 0; i < keys.length; i++) {
                    var prop = keys[i];
                    var text = props[prop].toLowerCase();
                    if (item[prop].toString().toLowerCase().indexOf(text) !== -1) {
                      itemMatches = true;
                      break;
                    }
                  }
          
                  if (itemMatches) {
                    out.push(item);
                  }
                });
              } else {
                // Let the output be the input untouched
                out = items;
              }
          
              return out;
            };
          })
        .controller('DetailsController', DetailsController);

    /** @ngInject */
    function DetailsController($state, $scope, RestAPIService,InvoiceTypes,Requestors, $filter,Vendors,Companies, $mdDialog, $sce)
    {
        var DetailsCtrl = this;
        DetailsCtrl.dtInstance = {};
        DetailsCtrl.dtOptions = {
            dom         : 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            pagingType  : 'simple',
            lengthMenu  : [10, 20, 30, 50, 100],
            pageLength  : 20,
            scrollY     : 'auto',
            responsive  : true
        
        }
        $scope.header={};
        $scope.lineItems = [ ];       


        $scope.requestType ="PAYABLES_NPO_V1" ;
        $scope.trustSrc = function(src) {
            return $sce.trustAsResourceUrl(src);
          }  
          //DetailsCtrl.url="https://smartportal-smartstore-r5.appspot.com/actiprocess/smartdocs?get&pVersion=0046&contRep=R5&docId=DAFOUTIDBVN3NN4CRCPN2DZFPTCLIWZA&compId=data&docProt=rud&accessMode=c&authId=CN=AA7&expiration=20170330082306&sp=true&secKey=MIH4BgkqhkiG9w0BBwKggeowgecCAQExCzAJBgUrDgMCGgUAMAsGCSqGSIb3DQEHATGBxzCBxAIBATAZMA4xDDAKBgNVBAMTA0lEMwIHIBUBGAlAEDAJBgUrDgMCGgUAoF0wGAYJKoZIhvcNAQkDMQsGCSqGSIb3DQEHATAcBgkqhkiG9w0BCQUxDxcNMTcwMzMwMDYyMzA2WjAjBgkqhkiG9w0BCQQxFgQUXp+j6yi3h79tsnyLrse1bGrSyYAwCQYHKoZIzjgEAwQvMC0CFQDXXQ741+hxLNhT1biNGa/EJpTXfwIUBHkVs7AvjG75b+PSdsoR9KedVo4=&sp=true"

        init();
        function init()
        {
            $scope.id = $state.params.id;
            RestAPIService.getInboxWorkitemInfo($scope.requestType,$scope.id).then(
                function(success){                   
                    $scope.workitemInfo = success.data;
                    DetailsCtrl.workitemInfo=success.data;
                    DetailsCtrl.url=$scope.workitemInfo.attachments[0].url;
                    $scope.header = success.data.header;
                    if($scope.header.BLDAT){
                        $scope.header.BLDAT =$scope.header.BLDAT.substring(6,7)
                    }
                    angular.forEach($scope.Allvenodrs,function(key,value){

                        if(key.vendorCode ==$scope.header.LIFNR){
                            $scope.sampleheader.vendor =key;                            
                        }            
                    })
                    angular.forEach($scope.Allcompanies,function(key,value){

                        if(key.companyCode ==$scope.header.BUKRS){
                            $scope.sampleheader.company =key;                            
                        }            
                    })

                    DetailsCtrl.header =success.data.header;
                    DetailsCtrl.lineItems = success.data.lineItems;
                    angular.forEach(DetailsCtrl.lineItems,function(key,value){
                        $scope.lineItems.push(key.lineItems);
                    })},
                function(error){
                }
            )
            RestAPIService.getUsers().then(
                function(success){
                    DetailsCtrl.users =success.data; 
                },
                function(error){

                }); 
        }
        $scope.logs = function(actvity, ev) {        
            DetailsCtrl.selectedWorkitemInfo = $scope.workitemInfo;            
            $mdDialog.show({
                controller : LogsController,
                templateUrl : 'app/main/Main_Inbox/inbox_details/logs.html',
                parent : angular.element(document.body),
                targetEvent : ev,
                clickOutsideToClose : true,
                fullscreen : $scope.customFullscreen
            });
        }
        function LogsController($scope, $mdDialog) {
            $scope.report =DetailsCtrl.selectedWorkitemInfo;
            $scope.log = $scope.report.logs;

            $scope.log.forEach(function(h){
            	if(h.activity == "001"){
            		h['icon'] = "icon-star-outline";
            	}
            	else if(h.activityText == "Approve"){
            		h['icon'] = "icon-check";
            	}
            	else if(h.activityText =="Collaborate"){
            		h['icon'] ="icon-content-save";
            	}
            	else if(h.activityText =="CollaborateBack"){
            		h['icon'] ="icon-content-save";
            	}
            	else if(h.activityText =="Cancel"){
            		h['icon'] ="icon-plus";
            	}
            	else if(h.activityText =="Delete"){
             		h['icon'] ="icon-delete";
             	}
            	else if(h.activityText == "Elimination"){
            		h['icon'] = "icon-check";
            	}
            	
		        })
        	
        	$scope.cancel = function() {
              $mdDialog.cancel();
        	};        	
        	
          $scope.fileIcon = function(fileType){          	
          	var icon ={};
              if(fileType == "folder"){
                    icon = "icon-folder";
                }                        
                else if(fileType.indexOf("jpg")!= -1){
                    icon = "icon-file-image";
                }
                else if(fileType.indexOf("jpeg")!= -1){
                    icon = "icon-file-image";
                }
                else if(fileType.indexOf("png")!= -1){
                    icon = "icon-file-image";
                }
                else if(fileType.indexOf("pdf")!= -1){
                    icon = "icon-file-pdf-box";
                }
                else if(fileType.indexOf("txt")!= -1){
                    icon = "icon-clipboard-text";
                }
                else if(fileType.indexOf("html")!= -1){
                    icon = "icon-language-html5";
                }
                else if(fileType.indexOf("xl")!= -1){
                    icon = "icon-file-excel";
                }
                else if(fileType.indexOf("word")!= -1){
                    icon = "icon-file-word";
                }
                else if(fileType.indexOf("xml")!= -1){
                    icon = "icon-file-xml";
                }
                else if(fileType.indexOf("doc")!= -1){
                    icon = "icon-file-document";
                }  
                else if(fileType.indexOf("docx")!= -1){
                    icon = "icon-file-document";
                }
                else if(fileType.indexOf("json")!= -1){
                    icon = "icon-clipboard-text";
                }                      

                else{
                    icon = "icon-file-document";
                }
                return icon;
            
          }        
            $scope.cancel =function(){
                $mdDialog.cancel();
            }


        }

        $scope.processActvity = function(actvity, ev) {
            DetailsCtrl.newAttachments = $scope.attachmentfiles;
            DetailsCtrl.actvity = actvity;
            DetailsCtrl.selectedWorkitemInfo = $scope.workitemInfo;            
            $mdDialog.show({
                controller : ProcessController,
                templateUrl : 'app/main/mycontent/inbox/add.comment.html',
                parent : angular.element(document.body),
                targetEvent : ev,
                clickOutsideToClose : true,
                fullscreen : $scope.customFullscreen
            });
        }
        function ProcessController($scope, $mdDialog) {
            $scope.popupHeading=DetailsCtrl.actvity.buttonText;
            $scope.cancel =function(){
                $mdDialog.cancel();
            }
            $scope.process = function(ev, comment) {
                delete DetailsCtrl.actvity.$$hashKey;
                var json = {
                    activities : []
                };
                json.comment = comment;
                json.activities.push(DetailsCtrl.actvity);
                json.header = DetailsCtrl.selectedWorkitemInfo.header;
                json.lineItems = DetailsCtrl.selectedWorkitemInfo.lineItems;
                angular.forEach(json.lineItems,function(key,value){
                    delete key.lineItems.$$hashKey;
                })
              
                $scope.allAttachments=DetailsCtrl.selectedWorkitemInfo.attachments;
                RestAPIService.submitRequestResource(DetailsCtrl.selectedWorkitemInfo.requestId, DetailsCtrl.selectedWorkitemInfo.requestType,
                    json, $scope.allAttachments).then(
                        function(success){
                            $mdDialog.show(
                            $mdDialog.alert()
                            .parent(angular.element(document .querySelector('#popupContainer')))
                            .clickOutsideToClose(true)
                            .title('Success.')
                            .htmlContent("<h4><b>" + DetailsCtrl.selectedWorkitemInfo.requestId
                                                                            + "</b> was "+DetailsCtrl.actvity.buttonText +"ed  successfully.</h4>")
                                                            .ariaLabel(
                                                                    'Alert Dialog Demo')
                                                            .ok('Ok')
                                                    // .targetEvent(ev)
                                                    );
                            $mdDialog.cancel();
                            $state.go('app.maininbox');
                        },
                        function(error){

                        }

            )
            
            }
        
        
        }

        $scope.Allvenodrs = Vendors.data;
        $scope.Allcompanies=Companies.data;
        $scope.invoiceTypes =InvoiceTypes.data;
        $scope.AllRequestors=Requestors.data;
        $scope.sampleheader ={};     
        $scope.addLineItem = function() {
            $scope.lineItems.push({});
        }
        $scope.deleteworkItem=function(index){
            $scope.lineItems.splice(index,1)

        }
        $scope.recommended =function(){
            angular.forEach(DetailsCtrl.workitemInfo.rLineItems,function(key,value){
                $scope.lineItems.push(key.lineItems);
            })
            //$scope.lineItems =DetailsCtrl.workitemInfo.rLineItems;
        }
         $scope.gotoOrders=function() {
            $state.go('app.maininbox');
        }
        $scope.ReturnToSupplier =function(){
            $mdDialog.show({
                controllerAs: 'ReturnToSupplierCtrl',
                controller: ReturnToSupplierCtrl,
                preserveScope: true,
                autoWrap: true,
                templateUrl: 'app/main/Main_Inbox/inbox_details/returnComments.html'
            });
            function ReturnToSupplierCtrl($scope, RestAPIService, $mdDialog) {
                $scope.cancel=function(){
                    $mdDialog.cancel();
                }
            }
        }
        $scope.Collaborate =function(){
            $mdDialog.show({
                controllerAs: 'CollaborateCtrl',
                controller: CollaborateCtrl,
                preserveScope: true,
                autoWrap: true,
                templateUrl: 'app/main/Main_Inbox/inbox_details/collaborateUser.html'
            });

            function CollaborateCtrl($scope, RestAPIService, $mdDialog) {
                $scope.users =DetailsCtrl.users;
                $scope.collaborate ={}

                $scope.cancel=function(){
                    $mdDialog.cancel();
                }


            }

        }
       
       


         
    }


         
})();
(function ()
{
    'use strict';

    angular
        .module('app.docbuffer', ['angular-timeline','ui.bootstrap'])
        .config(config);

    /** @ngInject */
    function config($stateProvider,msNavigationServiceProvider)
    {    
        $stateProvider.state('app.docbufferlist', {
            url: '/docbufferlist',
            views: {
                'content@app': {
                    templateUrl: 'app/main/DocBuffer/list/list.html',
                    controller:  'DocBufferListController as DblistCtrl'
                }
               
            }, resolve: {
                DocBufferLists: function(RestAPIService){
                    return RestAPIService.getDocbufferList("-1");
            }
        }
           
        }),
        $stateProvider.state('app.docbuffer', {
            url: '/docbuffer',
            params:{
             DocBufferWorkItem:null
            },
            views: {
                'content@app': {
                    templateUrl: 'app/main/DocBuffer/docbuffer/docbuffer.html',
                    controller:  'DocBufferController as DbCtrl'
                }
            }
        });
        
    //    msNavigationServiceProvider.saveItem('DocBuffer', {
    //         title : 'DocBuffer  ',
    //         icon  : 'icon-email',
    //         state : 'app.docbufferlist',
    //         weight: 12
    //     });

       
       
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.docbuffer')
        .controller('DocBufferController', DocBufferController);

    /** @ngInject */
    function DocBufferController($state, $scope,$stateParams,$localStorage,RestAPIService, $filter, $mdDialog, $sce)
    {
        var DbCtrl =this;
        
          $scope.WorkItem=$stateParams.DocBufferWorkItem;
          var jwtToken = $localStorage.currentUser.token.trim();

        //   $scope.preview=function(){
        //       var Document= $scope.WorkItem.attachments[0];
        //     $scope.encodedURI = baseUrl+'/api/requests/inbox/filedownload?archiveId='+Document.archiveId+'&requestId='+$scope.WorkItem.requestId+'&archiveDocId='+Document.archiveDocId+'&attachment=false&jwtToken='+jwtToken;
        //   }
          $scope.trustSrc = function(src) {
            return $sce.trustAsResourceUrl(src);
          }
       
        $scope.goToPreviousState =function(){
            $state.go('app.docbufferlist')
        }
        $scope.lineItems =[{}];
        $scope.addLineItem = function() {
            $scope.lineItems.push({
                 
            });
        } 
        $scope.deleteLineItem =function(index){
            $scope.lineItems.splice(index, 1);
        }
        $scope.selectrow =function(row){
            $scope.hide="true";
            $scope.url ="http://smartportal-smartstore-r5.appspot.com/actiprocess/smartdocs?get&pVersion=0046&contRep=R5&docId=8GGXBRO9L9NAYJDIEVBEC3RS5OLUNSAT&compId=data&docProt=rud&accessMode=c&authId=CN=AA7&expiration=20170330082306&sp=true&secKey=MIH4BgkqhkiG9w0BBwKggeowgecCAQExCzAJBgUrDgMCGgUAMAsGCSqGSIb3DQEHATGBxzCBxAIBATAZMA4xDDAKBgNVBAMTA0lEMwIHIBUBGAlAEDAJBgUrDgMCGgUAoF0wGAYJKoZIhvcNAQkDMQsGCSqGSIb3DQEHATAcBgkqhkiG9w0BCQUxDxcNMTcwMzMwMDYyMzA2WjAjBgkqhkiG9w0BCQQxFgQUXp+j6yi3h79tsnyLrse1bGrSyYAwCQYHKoZIzjgEAwQvMC0CFQDXXQ741+hxLNhT1biNGa/EJpTXfwIUBHkVs7AvjG75b+PSdsoR9KedVo4=&sp=true";
        }
        $scope.searchVendor =function(){
            alert("Search");
        }

        $scope.lineItems =[

            {
                "name":"Test-1",
                "Date":"21-06-18",
                "Type":"Test",
                "Id":"123",
                "Agent":"Bjones"
            },
            {
                "name":"Test-1",
                "Date":"21-06-18",
                "Type":"Test",
                "Id":"123",
                "Agent":"Bjones"
            },
            {
                "name":"Test-1",
                "Date":"21-06-18",
                "Type":"Test",
                "Id":"123",
                "Agent":"Bjones"
            }
        ]

    }


         
})();
(function ()
{
    'use strict';

    angular
        .module('app.docbuffer')
        .controller('DocBufferListController', DocBufferListController);

    /** @ngInject */
    function DocBufferListController($state, $scope,DocBufferLists, RestAPIService, $filter, $mdDialog, $sce)
    {
        var DblistCtrl =this;

        $scope.DocbufferItems =DocBufferLists.data;
        $scope.selectWorkItem =function(item){
            $state.go('app.docbuffer',{'DocBufferWorkItem':item });
        }


    }


         
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .service('fuseTheming', fuseThemingService);

    /** @ngInject */
    function fuseThemingService($cookies, $log, $mdTheming)
    {
        var service = {
            getRegisteredPalettes: getRegisteredPalettes,
            getRegisteredThemes  : getRegisteredThemes,
            setActiveTheme       : setActiveTheme,
            setThemesList        : setThemesList,
            themes               : {
                list  : {},
                active: {
                    'name' : '',
                    'theme': {}
                }
            }
        };

        return service;

        //////////

        /**
         * Get registered palettes
         *
         * @returns {*}
         */
        function getRegisteredPalettes()
        {
            return $mdTheming.PALETTES;
        }

        /**
         * Get registered themes
         *
         * @returns {*}
         */
        function getRegisteredThemes()
        {
            return $mdTheming.THEMES;
        }

        /**
         * Set active theme
         *
         * @param themeName
         */
        function setActiveTheme(themeName)
        {
            // If theme does not exist, fallback to the default theme
            if ( angular.isUndefined(service.themes.list[themeName]) )
            {
                // If there is no theme called "default"...
                if ( angular.isUndefined(service.themes.list.default) )
                {
                    $log.error('You must have at least one theme named "default"');
                    return;
                }

                $log.warn('The theme "' + themeName + '" does not exist! Falling back to the "default" theme.');

                // Otherwise set theme to default theme
                service.themes.active.name = 'default';
                service.themes.active.theme = service.themes.list.default;
                $cookies.put('selectedTheme', service.themes.active.name);

                return;
            }

            service.themes.active.name = themeName;
            service.themes.active.theme = service.themes.list[themeName];
            $cookies.put('selectedTheme', themeName);
        }

        /**
         * Set available themes list
         *
         * @param themeList
         */
        function setThemesList(themeList)
        {
            service.themes.list = themeList;
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .config(config);

    /** @ngInject */
    function config($mdThemingProvider, fusePalettes, fuseThemes)
    {
        // Inject Cookies Service
        var $cookies;
        angular.injector(['ngCookies']).invoke([
            '$cookies', function (_$cookies)
            {
                $cookies = _$cookies;
            }
        ]);

        // Check if custom theme exist in cookies
        var customTheme = $cookies.getObject('customTheme');
        if ( customTheme )
        {
            fuseThemes['custom'] = customTheme;
        }

        $mdThemingProvider.alwaysWatchTheme(true);

        // Define custom palettes
        angular.forEach(fusePalettes, function (palette)
        {
            $mdThemingProvider.definePalette(palette.name, palette.options);
        });

        // Register custom themes
        angular.forEach(fuseThemes, function (theme, themeName)
        {
            $mdThemingProvider.theme(themeName)
                .primaryPalette(theme.primary.name, theme.primary.hues)
                .accentPalette(theme.accent.name, theme.accent.hues)
                .warnPalette(theme.warn.name, theme.warn.hues)
                .backgroundPalette(theme.background.name, theme.background.hues);
        });
    }

})();
(function ()
{
    'use strict';

    var fuseThemes = {
        default  : {
            primary   : {
                name: 'fuse-paleblue',
                hues: {
                    'default': '700',
                    'hue-1'  : '500',
                    'hue-2'  : '600',
                    'hue-3'  : '400'
                }
            },
            accent    : {
                name: 'light-blue',
                hues: {
                    'default': '600',
                    'hue-1'  : '400',
                    'hue-2'  : '700',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {
                name: 'red'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : 'A100',
                    'hue-2'  : '100',
                    'hue-3'  : '300'
                }
            }
        },
        'pinkTheme': {
            primary   : {
                name: 'blue-grey',
                hues: {
                    'default': '800',
                    'hue-1'  : '600',
                    'hue-2'  : '400',
                    'hue-3'  : 'A100'
                }
            },
            accent    : {
                name: 'pink',
                hues: {
                    'default': '400',
                    'hue-1'  : '300',
                    'hue-2'  : '600',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {
                name: 'blue'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : 'A100',
                    'hue-2'  : '100',
                    'hue-3'  : '300'
                }
            }
        },
        'tealTheme': {
            primary   : {
                name: 'fuse-blue',
                hues: {
                    'default': '900',
                    'hue-1'  : '600',
                    'hue-2'  : '500',
                    'hue-3'  : 'A100'
                }
            },
            accent    : {
                name: 'teal',
                hues: {
                    'default': '500',
                    'hue-1'  : '400',
                    'hue-2'  : '600',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {
                name: 'deep-orange'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : 'A100',
                    'hue-2'  : '100',
                    'hue-3'  : '300'
                }
            }
        }
    };

    angular
        .module('app.core')
        .constant('fuseThemes', fuseThemes);
})();
(function () {
    'use strict';

    var fusePalettes = [
        {
            name: 'fuse-blue',
            options: {
                '50': '#ebf1fa',
                '100': '#c2d4ef',
                '200': '#9ab8e5',
                '300': '#78a0dc',
                '400': '#5688d3',
                '500': '#3470ca',
                '600': '#2e62b1',
                '700': '#275498',
                '800': '#21467e',
                '900': '#1a3865',
                'A100': '#c2d4ef',
                'A200': '#9ab8e5',
                'A400': '#5688d3',
                'A700': '#275498',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        },
        {
            name: 'fuse-paleblue',
            options: {
                '50': '#ececee',
                '100': '#c5c6cb',
                '200': '#9ea1a9',
                '300': '#7d818c',
                '400': '#5c616f',
                '500': '#3c4252',
                '600': '#353a48',
                '700': '#2d323e',
                '800': '#262933',
                '900': '#1e2129',
                'A100': '#c5c6cb',
                'A200': '#9ea1a9',
                'A400': '#5c616f',
                'A700': '#2d323e',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        }
    ];

    angular
        .module('app.core')
        .constant('fusePalettes', fusePalettes);
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('fuseGenerator', fuseGeneratorService);

    /** @ngInject */
    function fuseGeneratorService($cookies, $log, fuseTheming)
    {
        // Storage for simplified themes object
        var themes = {};

        var service = {
            generate: generate,
            rgba    : rgba
        };

        return service;

        //////////

        /**
         * Generate less variables for each theme from theme's
         * palette by using material color naming conventions
         */
        function generate()
        {
            // Get registered themes and palettes and copy
            // them so we don't modify the original objects
            var registeredThemes = angular.copy(fuseTheming.getRegisteredThemes());
            var registeredPalettes = angular.copy(fuseTheming.getRegisteredPalettes());

            // First, create a simplified object that stores
            // all registered themes and their colors

            // Iterate through registered themes
            angular.forEach(registeredThemes, function (registeredTheme)
            {
                themes[registeredTheme.name] = {};

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(registeredTheme.colors, function (colorType, colorTypeName)
                {
                    themes[registeredTheme.name][colorTypeName] = {
                        'name'  : colorType.name,
                        'levels': {
                            'default': {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues.default].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 4)
                            },
                            'hue1'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 4)
                            },
                            'hue2'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 4)
                            },
                            'hue3'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 4)
                            }
                        }
                    };
                });
            });

            // Process themes one more time and then store them in the service for external use
            processAndStoreThemes(themes);

            // Iterate through simplified themes
            // object and create style variables
            var styleVars = {};

            // Iterate through registered themes
            angular.forEach(themes, function (theme, themeName)
            {
                styleVars = {};
                styleVars['@themeName'] = themeName;

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorTypes, colorTypeName)
                {
                    // Iterate through color levels (default, hue1, hue2 & hue3)
                    angular.forEach(colorTypes.levels, function (colors, colorLevelName)
                    {
                        // Iterate through color name (color, contrast1, contrast2, contrast3 & contrast4)
                        angular.forEach(colors, function (color, colorName)
                        {
                            styleVars['@' + colorTypeName + ucfirst(colorLevelName) + ucfirst(colorName)] = color;
                        });
                    });
                });

                // Render styles
                render(styleVars);
            });
        }

        // ---------------------------
        //  INTERNAL HELPER FUNCTIONS
        // ---------------------------

        /**
         * Process and store themes for global use
         *
         * @param _themes
         */
        function processAndStoreThemes(_themes)
        {
            // Here we will go through every registered theme one more time
            // and try to simplify their objects as much as possible for
            // easier access to their properties.
            var themes = angular.copy(_themes);

            // Iterate through themes
            angular.forEach(themes, function (theme)
            {
                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorType, colorTypeName)
                {
                    theme[colorTypeName] = colorType.levels;
                    theme[colorTypeName].color = colorType.levels.default.color;
                    theme[colorTypeName].contrast1 = colorType.levels.default.contrast1;
                    theme[colorTypeName].contrast2 = colorType.levels.default.contrast2;
                    theme[colorTypeName].contrast3 = colorType.levels.default.contrast3;
                    theme[colorTypeName].contrast4 = colorType.levels.default.contrast4;
                    delete theme[colorTypeName].default;
                });
            });

            // Store themes and set selected theme for the first time
            fuseTheming.setThemesList(themes);

            // Remember selected theme.
            var selectedTheme = $cookies.get('selectedTheme');

            if ( selectedTheme )
            {
                fuseTheming.setActiveTheme(selectedTheme);
            }
            else
            {
                fuseTheming.setActiveTheme('default');
            }
        }


        /**
         * Render css files
         *
         * @param styleVars
         */
        function render(styleVars)
        {
            var cssTemplate = '/* Content hack because they wont fix */\n/* https://github.com/angular/material/pull/8067 */\n[md-theme="@themeName"] md-content.md-hue-1,\nmd-content.md-@themeName-theme.md-hue-1 {\n    color: @backgroundHue1Contrast1;\n    background-color: @backgroundHue1Color;\n}\n\n[md-theme="@themeName"] md-content.md-hue-2,\nmd-content.md-@themeName-theme.md-hue-2 {\n    color: @backgroundHue2Contrast1;\n    background-color: @backgroundHue2Color;\n}\n\n[md-theme="@themeName"] md-content.md-hue-3,\n md-content.md-@themeName-theme.md-hue-3 {\n    color: @backgroundHue3Contrast1;\n    background-color: @backgroundHue3Color;\n}\n\n/* Text Colors */\n[md-theme="@themeName"] a {\n    color: @accentDefaultColor;\n}\n\n[md-theme="@themeName"] .secondary-text,\n[md-theme="@themeName"] .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .hint-text,\n[md-theme="@themeName"] .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .fade-text,\n[md-theme="@themeName"] .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Primary */\n[md-theme="@themeName"] .md-primary-bg {\n    background-color: @primaryDefaultColor;\n    color: @primaryDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg .secondary-text,\n[md-theme="@themeName"] .md-primary-bg .icon {\n    color: @primaryDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg .hint-text,\n[md-theme="@themeName"] .md-primary-bg .disabled-text {\n    color: @primaryDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg .fade-text,\n[md-theme="@themeName"] .md-primary-bg .divider {\n    color: @primaryDefaultContrast4;\n}\n\n/* Primary, Hue-1 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 {\n    background-color: @primaryHue1Color;\n    color: @primaryHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .icon {\n    color: @primaryHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .disabled-text {\n    color: @primaryHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .divider {\n    color: @primaryHue1Contrast4;\n}\n\n/* Primary, Hue-2 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 {\n    background-color: @primaryHue2Color;\n    color: @primaryHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .icon {\n    color: @primaryHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .disabled-text {\n    color: @primaryHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .divider {\n    color: @primaryHue2Contrast4;\n}\n\n/* Primary, Hue-3 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 {\n    background-color: @primaryHue3Color;\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .icon {\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .disabled-text {\n    color: @primaryHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .divider {\n    color: @primaryHue3Contrast4;\n}\n\n/* Primary foreground */\n[md-theme="@themeName"] .md-primary-fg {\n    color: @primaryDefaultColor !important;\n}\n\n/* Primary foreground, Hue-1 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-1 {\n    color: @primaryHue1Color !important;\n}\n\n/* Primary foreground, Hue-2 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-2 {\n    color: @primaryHue2Color !important;\n}\n\n/* Primary foreground, Hue-3 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-3 {\n    color: @primaryHue3Color !important;\n}\n\n/* Accent */\n[md-theme="@themeName"] .md-accent-bg {\n    background-color: @accentDefaultColor;\n    color: @accentDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg .secondary-text,\n[md-theme="@themeName"] .md-accent-bg .icon {\n    color: @accentDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg .hint-text,\n[md-theme="@themeName"] .md-accent-bg .disabled-text {\n    color: @accentDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg .fade-text,\n[md-theme="@themeName"] .md-accent-bg .divider {\n    color: @accentDefaultContrast4;\n}\n\n/* Accent, Hue-1 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 {\n    background-color: @accentHue1Color;\n    color: @accentHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .icon {\n    color: @accentHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .disabled-text {\n    color: @accentHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .divider {\n    color: @accentHue1Contrast4;\n}\n\n/* Accent, Hue-2 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 {\n    background-color: @accentHue2Color;\n    color: @accentHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .icon {\n    color: @accentHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .disabled-text {\n    color: @accentHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .divider {\n    color: @accentHue2Contrast4;\n}\n\n/* Accent, Hue-3 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 {\n    background-color: @accentHue3Color;\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .icon {\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .disabled-text {\n    color: @accentHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .divider {\n    color: @accentHue3Contrast4;\n}\n\n/* Accent foreground */\n[md-theme="@themeName"] .md-accent-fg {\n    color: @accentDefaultColor !important;\n}\n\n/* Accent foreground, Hue-1 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-1 {\n    color: @accentHue1Color !important;\n}\n\n/* Accent foreground, Hue-2 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-2 {\n    color: @accentHue2Color !important;\n}\n\n/* Accent foreground, Hue-3 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-3 {\n    color: @accentHue3Color !important;\n}\n\n/* Warn */\n[md-theme="@themeName"] .md-warn-bg {\n    background-color: @warnDefaultColor;\n    color: @warnDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg .secondary-text,\n[md-theme="@themeName"] .md-warn-bg .icon {\n    color: @warnDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg .hint-text,\n[md-theme="@themeName"] .md-warn-bg .disabled-text {\n    color: @warnDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg .fade-text,\n[md-theme="@themeName"] .md-warn-bg .divider {\n    color: @warnDefaultContrast4;\n}\n\n/* Warn, Hue-1 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 {\n    background-color: @warnHue1Color;\n    color: @warnHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .icon {\n    color: @warnHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .disabled-text {\n    color: @warnHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .divider {\n    color: @warnHue1Contrast4;\n}\n\n/* Warn, Hue-2 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 {\n    background-color: @warnHue2Color;\n    color: @warnHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .icon {\n    color: @warnHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .disabled-text {\n    color: @warnHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .divider {\n    color: @warnHue2Contrast4;\n}\n\n/* Warn, Hue-3 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 {\n    background-color: @warnHue3Color;\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .icon {\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .disabled-text {\n    color: @warnHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .divider {\n    color: @warnHue3Contrast4;\n}\n\n/* Warn foreground */\n[md-theme="@themeName"] .md-warn-fg {\n    color: @warnDefaultColor !important;\n}\n\n/* Warn foreground, Hue-1 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-1 {\n    color: @warnHue1Color !important;\n}\n\n/* Warn foreground, Hue-2 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-2 {\n    color: @warnHue2Color !important;\n}\n\n/* Warn foreground, Hue-3 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-3 {\n    color: @warnHue3Color !important;\n}\n\n/* Background */\n[md-theme="@themeName"] .md-background-bg {\n    background-color: @backgroundDefaultColor;\n    color: @backgroundDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg .secondary-text,\n[md-theme="@themeName"] .md-background-bg .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg .hint-text,\n[md-theme="@themeName"] .md-background-bg .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg .fade-text,\n[md-theme="@themeName"] .md-background-bg .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Background, Hue-1 */\n[md-theme="@themeName"] .md-background-bg.md-hue-1 {\n    background-color: @backgroundHue1Color;\n    color: @backgroundHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .icon {\n    color: @backgroundHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .disabled-text {\n    color: @backgroundHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .divider {\n    color: @backgroundHue1Contrast4;\n}\n\n/* Background, Hue-2 */\n[md-theme="@themeName"] .md-background-bg.md-hue-2 {\n    background-color: @backgroundHue2Color;\n    color: @backgroundHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .icon {\n    color: @backgroundHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .disabled-text {\n    color: @backgroundHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .divider {\n    color: @backgroundHue2Contrast4;\n}\n\n/* Background, Hue-3 */\n[md-theme="@themeName"] .md-background-bg.md-hue-3 {\n    background-color: @backgroundHue3Color;\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .icon {\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .disabled-text {\n    color: @backgroundHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .divider {\n    color: @backgroundHue3Contrast4;\n}\n\n/* Background foreground */\n[md-theme="@themeName"] .md-background-fg {\n    color: @backgroundDefaultColor !important;\n}\n\n/* Background foreground, Hue-1 */\n[md-theme="@themeName"] .md-background-fg.md-hue-1 {\n    color: @backgroundHue1Color !important;\n}\n\n/* Background foreground, Hue-2 */\n[md-theme="@themeName"] .md-background-fg.md-hue-2 {\n    color: @backgroundHue2Color !important;\n}\n\n/* Background foreground, Hue-3 */\n[md-theme="@themeName"] .md-background-fg.md-hue-3 {\n    color: @backgroundHue3Color !important;\n}';

            var regex = new RegExp(Object.keys(styleVars).join('|'), 'gi');
            var css = cssTemplate.replace(regex, function (matched)
            {
                return styleVars[matched];
            });

            var headEl = angular.element('head');
            var styleEl = angular.element('<style type="text/css"></style>');
            styleEl.html(css);
            headEl.append(styleEl);
        }

        /**
         * Convert color array to rgb/rgba
         * Also apply contrasts if needed
         *
         * @param color
         * @param _contrastLevel
         * @returns {string}
         */
        function rgba(color, _contrastLevel)
        {
            var contrastLevel = _contrastLevel || false;

            // Convert 255,255,255,0.XX to 255,255,255
            // According to Google's Material design specs, white primary
            // text must have opacity of 1 and we will fix that here
            // because Angular Material doesn't care about that spec
            if ( color.length === 4 && color[0] === 255 && color[1] === 255 && color[2] === 255 )
            {
                color.splice(3, 4);
            }

            // If contrast level provided, apply it to the current color
            if ( contrastLevel )
            {
                color = applyContrast(color, contrastLevel);
            }

            // Convert color array to color string (rgb/rgba)
            if ( color.length === 3 )
            {
                return 'rgb(' + color.join(',') + ')';
            }
            else if ( color.length === 4 )
            {
                return 'rgba(' + color.join(',') + ')';
            }
            else
            {
                $log.error('Invalid number of arguments supplied in the color array: ' + color.length + '\n' + 'The array must have 3 or 4 colors.');
            }
        }

        /**
         * Apply given contrast level to the given color
         *
         * @param color
         * @param contrastLevel
         */
        function applyContrast(color, contrastLevel)
        {
            var contrastLevels = {
                'white': {
                    '1': '1',
                    '2': '0.7',
                    '3': '0.3',
                    '4': '0.12'
                },
                'black': {
                    '1': '0.87',
                    '2': '0.54',
                    '3': '0.26',
                    '4': '0.12'
                }
            };

            // If white
            if ( color[0] === 255 && color[1] === 255 && color[2] === 255 )
            {
                color[3] = contrastLevels.white[contrastLevel];
            }
            // If black
            else if ( color[0] === 0 && color[1] === 0 && color[2] === 0 )
            {
                color[3] = contrastLevels.black[contrastLevel];
            }

            return color;
        }

        /**
         * Uppercase first
         */
        function ucfirst(string)
        {
            return string.charAt(0).toUpperCase() + string.slice(1);
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsThemeOptionsController', MsThemeOptionsController)
        .directive('msThemeOptions', msThemeOptions);

    /** @ngInject */
    function MsThemeOptionsController($cookies, fuseTheming)
    {
        var vm = this;

        // Data
        vm.themes = fuseTheming.themes;

        vm.layoutModes = [
            {
                label: 'Boxed',
                value: 'boxed'
            },
            {
                label: 'Wide',
                value: 'wide'
            }
        ];
        vm.layoutStyles = [
            {
                label : 'Vertical Navigation',
                value : 'verticalNavigation',
                figure: 'assets/images/theme-options/vertical-nav.jpg'
            },
            {
                label : 'Vertical Navigation with Fullwidth Toolbar',
                value : 'verticalNavigationFullwidthToolbar',
                figure: 'assets/images/theme-options/vertical-nav-with-full-toolbar.jpg'
            },
            {
                label : 'Vertical Navigation with Fullwidth Toolbar 2',
                value : 'verticalNavigationFullwidthToolbar2',
                figure: 'assets/images/theme-options/vertical-nav-with-full-toolbar-2.jpg'
            },
            {
                label : 'Horizontal Navigation',
                value : 'horizontalNavigation',
                figure: 'assets/images/theme-options/horizontal-nav.jpg'
            },
            {
                label : 'Content with Toolbar',
                value : 'contentWithToolbar',
                figure: 'assets/images/theme-options/content-with-toolbar.jpg'
            },
            {
                label : 'Content Only',
                value : 'contentOnly',
                figure: 'assets/images/theme-options/content-only.jpg'
            },
        ];

        vm.layoutMode = 'wide';
        vm.layoutStyle = $cookies.get('layoutStyle') || 'verticalNavigation';

        // Methods
        vm.setActiveTheme = setActiveTheme;
        vm.getActiveTheme = getActiveTheme;
        vm.updateLayoutMode = updateLayoutMode;
        vm.updateLayoutStyle = updateLayoutStyle;

        //////////

        /**
         * Set active theme
         *
         * @param themeName
         */
        function setActiveTheme(themeName)
        {
            fuseTheming.setActiveTheme(themeName);
        }

        /**
         * Get active theme
         *
         * @returns {service.themes.active|{name, theme}}
         */
        function getActiveTheme()
        {
            return fuseTheming.themes.active;
        }

        /**
         * Update layout mode
         */
        function updateLayoutMode()
        {
            var bodyEl = angular.element('body');

            // Update class on body element
            bodyEl.toggleClass('boxed', (vm.layoutMode === 'boxed'));
        }

        /**
         * Update layout style
         */
        function updateLayoutStyle()
        {
            // Update the cookie
            $cookies.put('layoutStyle', vm.layoutStyle);

            // Reload the page to apply the changes
            location.reload();
        }
    }

    /** @ngInject */
    function msThemeOptions($mdSidenav)
    {
        return {
            restrict   : 'E',
            scope      : {},
            controller : 'MsThemeOptionsController as vm',
            templateUrl: 'app/core/theme-options/theme-options.html',
            compile    : function (tElement)
            {
                tElement.addClass('ms-theme-options');

                return function postLink(scope)
                {
                    /**
                     * Toggle options sidenav
                     */
                    function toggleOptionsSidenav()
                    {
                        // Toggle the fuse theme options panel
                        $mdSidenav('fuse-theme-options').toggle();
                    }

                    // Expose the toggle function
                    scope.toggleOptionsSidenav = toggleOptionsSidenav;
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('msUtils', msUtils);

    /** @ngInject */
    function msUtils($window)
    {
        // Private variables
        var mobileDetect = new MobileDetect($window.navigator.userAgent),
            browserInfo = null;

        var service = {
            exists       : exists,
            detectBrowser: detectBrowser,
            guidGenerator: guidGenerator,
            isMobile     : isMobile,
            toggleInArray: toggleInArray
        };

        return service;

        //////////

        /**
         * Check if item exists in a list
         *
         * @param item
         * @param list
         * @returns {boolean}
         */
        function exists(item, list)
        {
            return list.indexOf(item) > -1;
        }

        /**
         * Returns browser information
         * from user agent data
         *
         * Found at http://www.quirksmode.org/js/detect.html
         * but modified and updated to fit for our needs
         */
        function detectBrowser()
        {
            // If we already tested, do not test again
            if ( browserInfo )
            {
                return browserInfo;
            }

            var browserData = [
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Edge',
                    versionSearch: 'Edge',
                    identity     : 'Edge'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Chrome',
                    identity : 'Chrome'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'OmniWeb',
                    versionSearch: 'OmniWeb/',
                    identity     : 'OmniWeb'
                },
                {
                    string       : $window.navigator.vendor,
                    subString    : 'Apple',
                    versionSearch: 'Version',
                    identity     : 'Safari'
                },
                {
                    prop    : $window.opera,
                    identity: 'Opera'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'iCab',
                    identity : 'iCab'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'KDE',
                    identity : 'Konqueror'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Firefox',
                    identity : 'Firefox'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'Camino',
                    identity : 'Camino'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Netscape',
                    identity : 'Netscape'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'MSIE',
                    identity     : 'Explorer',
                    versionSearch: 'MSIE'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Trident/7',
                    identity     : 'Explorer',
                    versionSearch: 'rv'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Gecko',
                    identity     : 'Mozilla',
                    versionSearch: 'rv'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Mozilla',
                    identity     : 'Netscape',
                    versionSearch: 'Mozilla'
                }
            ];

            var osData = [
                {
                    string   : $window.navigator.platform,
                    subString: 'Win',
                    identity : 'Windows'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Mac',
                    identity : 'Mac'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Linux',
                    identity : 'Linux'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPhone',
                    identity : 'iPhone'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPod',
                    identity : 'iPod'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPad',
                    identity : 'iPad'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Android',
                    identity : 'Android'
                }
            ];

            var versionSearchString = '';

            function searchString(data)
            {
                for ( var i = 0; i < data.length; i++ )
                {
                    var dataString = data[i].string;
                    var dataProp = data[i].prop;

                    versionSearchString = data[i].versionSearch || data[i].identity;

                    if ( dataString )
                    {
                        if ( dataString.indexOf(data[i].subString) !== -1 )
                        {
                            return data[i].identity;

                        }
                    }
                    else if ( dataProp )
                    {
                        return data[i].identity;
                    }
                }
            }

            function searchVersion(dataString)
            {
                var index = dataString.indexOf(versionSearchString);

                if ( index === -1 )
                {
                    return;
                }

                return parseInt(dataString.substring(index + versionSearchString.length + 1));
            }

            var browser = searchString(browserData) || 'unknown-browser';
            var version = searchVersion($window.navigator.userAgent) || searchVersion($window.navigator.appVersion) || 'unknown-version';
            var os = searchString(osData) || 'unknown-os';

            // Prepare and store the object
            browser = browser.toLowerCase();
            version = browser + '-' + version;
            os = os.toLowerCase();

            browserInfo = {
                browser: browser,
                version: version,
                os     : os
            };

            return browserInfo;
        }

        /**
         * Generates a globally unique id
         *
         * @returns {*}
         */
        function guidGenerator()
        {
            var S4 = function ()
            {
                return (((1 + Math.random()) * 0x10000) || 0).toString(16).substring(1);
            };
            return (S4() + S4() + S4() + S4() + S4() + S4());
        }

        /**
         * Return if current device is a
         * mobile device or not
         */
        function isMobile()
        {
            return mobileDetect.mobile();
        }

        /**
         * Toggle in array (push or splice)
         *
         * @param item
         * @param array
         */
        function toggleInArray(item, array)
        {
            if ( array.indexOf(item) === -1 )
            {
                array.push(item);
            }
            else
            {
                array.splice(array.indexOf(item), 1);
            }
        }
    }
}());
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msApi', msApiProvider);

    /** @ngInject **/
    function msApiProvider()
    {
        /* ----------------- */
        /* Provider          */
        /* ----------------- */
        var provider = this;

        // Inject the $log service
        var $log = angular.injector(['ng']).get('$log');

        // Data
        var baseUrl = '';
        var api = [];

        // Methods
        provider.setBaseUrl = setBaseUrl;
        provider.getBaseUrl = getBaseUrl;
        provider.getApiObject = getApiObject;
        provider.register = register;

        //////////

        /**
         * Set base url for API endpoints
         *
         * @param url {string}
         */
        function setBaseUrl(url)
        {
            baseUrl = url;
        }

        /**
         * Return the base url
         *
         * @returns {string}
         */
        function getBaseUrl()
        {
            return baseUrl;
        }

        /**
         * Return the api object
         *
         * @returns {object}
         */
        function getApiObject()
        {
            return api;
        }

        /**
         * Register API endpoint
         *
         * @param key
         * @param resource
         */
        function register(key, resource)
        {
            if ( !angular.isString(key) )
            {
                $log.error('"path" must be a string (eg. `dashboard.project`)');
                return;
            }

            if ( !angular.isArray(resource) )
            {
                $log.error('"resource" must be an array and it must follow $resource definition');
                return;
            }

            // Store the API object
            api[key] = {
                url          : baseUrl + (resource[0] || ''),
                paramDefaults: resource[1] || [],
                actions      : resource[2] || [],
                options      : resource[3] || {}
            };
        }

        /* ----------------- */
        /* Service           */
        /* ----------------- */
        this.$get = function ($log, $q, $resource, $rootScope)
        {
            // Data

            // Methods
            var service = {
                setBaseUrl: setBaseUrl,
                getBaseUrl: getBaseUrl,
                register  : register,
                resolve   : resolve,
                request   : request
            };

            return service;

            //////////

            /**
             * Resolve an API endpoint
             *
             * @param action {string}
             * @param parameters {object}
             * @returns {promise|boolean}
             */
            function resolve(action, parameters)
            {
                // Emit an event
                $rootScope.$broadcast('msApi::resolveStart');
                
                var actionParts = action.split('@'),
                    resource = actionParts[0],
                    method = actionParts[1],
                    params = parameters || {};

                if ( !resource || !method )
                {
                    $log.error('msApi.resolve requires correct action parameter (resourceName@methodName)');
                    return false;
                }

                // Create a new deferred object
                var deferred = $q.defer();

                // Get the correct resource definition from api object
                var apiObject = api[resource];

                if ( !apiObject )
                {
                    $log.error('Resource "' + resource + '" is not defined in the api service!');
                    deferred.reject('Resource "' + resource + '" is not defined in the api service!');
                }
                else
                {
                    // Generate the $resource object based on the stored API object
                    var resourceObject = $resource(apiObject.url, apiObject.paramDefaults, apiObject.actions, apiObject.options);

                    // Make the call...
                    resourceObject[method](params,

                        // Success
                        function (response)
                        {
                            deferred.resolve(response);

                            // Emit an event
                            $rootScope.$broadcast('msApi::resolveSuccess');
                        },

                        // Error
                        function (response)
                        {
                            deferred.reject(response);

                            // Emit an event
                            $rootScope.$broadcast('msApi::resolveError');
                        }
                    );
                }

                // Return the promise
                return deferred.promise;
            }

            /**
             * Make a request to an API endpoint
             *
             * @param action {string}
             * @param [parameters] {object}
             * @param [success] {function}
             * @param [error] {function}
             *
             * @returns {promise|boolean}
             */
            function request(action, parameters, success, error)
            {
                // Emit an event
                $rootScope.$broadcast('msApi::requestStart');
                
                var actionParts = action.split('@'),
                    resource = actionParts[0],
                    method = actionParts[1],
                    params = parameters || {};

                if ( !resource || !method )
                {
                    $log.error('msApi.resolve requires correct action parameter (resourceName@methodName)');
                    return false;
                }

                // Create a new deferred object
                var deferred = $q.defer();

                // Get the correct resource definition from api object
                var apiObject = api[resource];

                if ( !apiObject )
                {
                    $log.error('Resource "' + resource + '" is not defined in the api service!');
                    deferred.reject('Resource "' + resource + '" is not defined in the api service!');
                }
                else
                {
                    // Generate the $resource object based on the stored API object
                    var resourceObject = $resource(apiObject.url, apiObject.paramDefaults, apiObject.actions, apiObject.options);

                    // Make the call...
                    resourceObject[method](params,

                        // SUCCESS
                        function (response)
                        {
                            // Emit an event
                            $rootScope.$broadcast('msApi::requestSuccess');
                            
                            // Resolve the promise
                            deferred.resolve(response);

                            // Call the success function if there is one
                            if ( angular.isDefined(success) && angular.isFunction(success) )
                            {
                                success(response);
                            }
                        },

                        // ERROR
                        function (response)
                        {
                            // Emit an event
                            $rootScope.$broadcast('msApi::requestError');
                            
                            // Reject the promise
                            deferred.reject(response);

                            // Call the error function if there is one
                            if ( angular.isDefined(error) && angular.isFunction(error) )
                            {
                                error(response);
                            }
                        }
                    );
                }

                // Return the promise
                return deferred.promise;
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('apiResolver', apiResolverService);

    /** @ngInject */
    function apiResolverService($q, $log, api)
    {
        var service = {
            resolve: resolve
        };

        return service;

        //////////
        /**
         * Resolve api
         * @param action
         * @param parameters
         */
        function resolve(action, parameters)
        {
            var actionParts = action.split('@'),
                resource = actionParts[0],
                method = actionParts[1],
                params = parameters || {};

            if ( !resource || !method )
            {
                $log.error('apiResolver.resolve requires correct action parameter (ResourceName@methodName)');
                return false;
            }

            // Create a new deferred object
            var deferred = $q.defer();

            // Get the correct api object from api service
            var apiObject = getApiObject(resource);

            if ( !apiObject )
            {
                $log.error('Resource "' + resource + '" is not defined in the api service!');
                deferred.reject('Resource "' + resource + '" is not defined in the api service!');
            }
            else
            {
                apiObject[method](params,

                    // Success
                    function (response)
                    {
                        deferred.resolve(response);
                    },

                    // Error
                    function (response)
                    {
                        deferred.reject(response);
                    }
                );
            }

            // Return the promise
            return deferred.promise;
        }

        /**
         * Get correct api object
         *
         * @param resource
         * @returns {*}
         */
        function getApiObject(resource)
        {
            // Split the resource in case if we have a dot notated object
            var resourceParts = resource.split('.'),
                apiObject = api;

            // Loop through the resource parts and go all the way through
            // the api object and return the correct one
            for ( var l = 0; l < resourceParts.length; l++ )
            {
                if ( angular.isUndefined(apiObject[resourceParts[l]]) )
                {
                    $log.error('Resource part "' + resourceParts[l] + '" is not defined!');
                    apiObject = false;
                    break;
                }

                apiObject = apiObject[resourceParts[l]];
            }

            if ( !apiObject )
            {
                return false;
            }

            return apiObject;
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByTags', filterByTags)
        .filter('filterSingleByTags', filterSingleByTags);

    /** @ngInject */
    function filterByTags()
    {
        return function (items, tags)
        {
            if ( items.length === 0 || tags.length === 0 )
            {
                return items;
            }

            var filtered = [];

            items.forEach(function (item)
            {
                var match = tags.every(function (tag)
                {
                    var tagExists = false;

                    item.tags.forEach(function (itemTag)
                    {
                        if ( itemTag.name === tag.name )
                        {
                            tagExists = true;
                            return;
                        }
                    });

                    return tagExists;
                });

                if ( match )
                {
                    filtered.push(item);
                }
            });

            return filtered;
        };
    }

    /** @ngInject */
    function filterSingleByTags()
    {
        return function (itemTags, tags)
        {
            if ( itemTags.length === 0 || tags.length === 0 )
            {
                return;
            }

            if ( itemTags.length < tags.length )
            {
                return [];
            }

            var filtered = [];

            var match = tags.every(function (tag)
            {
                var tagExists = false;

                itemTags.forEach(function (itemTag)
                {
                    if ( itemTag.name === tag.name )
                    {
                        tagExists = true;
                        return;
                    }
                });

                return tagExists;
            });

            if ( match )
            {
                filtered.push(itemTags);
            }

            return filtered;
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByPropIds', filterByPropIds);

    /** @ngInject */
    function filterByPropIds()
    {
        return function (items, parameter, ids)
        {
            if ( items.length === 0 || !ids || ids.length === 0 )
            {
                return items;
            }

            var filtered = [];

            for ( var i = 0; i < items.length; i++ )
            {
                var item = items[i];
                var match = false;

                for ( var j = 0; j < ids.length; j++ )
                {
                    var id = ids[j];
                    if ( item[parameter].indexOf(id) > -1 )
                    {
                        match = true;
                        break;
                    }
                }

                if ( match )
                {
                    filtered.push(item);
                }

            }

            return filtered;

        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByIds', filterByIds);

    /** @ngInject */
    function filterByIds()
    {
        return function (items, ids)
        {

            if ( items.length === 0 || !ids )
            {
                return items;
            }

            if ( ids.length === 0 )
            {
                return [];
            }

            var filtered = [];

            for ( var i = 0; i < items.length; i++ )
            {
                var item = items[i];
                var match = false;

                for ( var j = 0; j < ids.length; j++ )
                {
                    var id = ids[j];
                    if ( item.id === id )
                    {
                        match = true;
                        break;
                    }
                }

                if ( match )
                {
                    filtered.push(item);
                }

            }

            return filtered;

        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('toTrusted', toTrustedFilter)
        .filter('htmlToPlaintext', htmlToPlainTextFilter)
        .filter('nospace', nospaceFilter)
        .filter('humanizeDoc', humanizeDocFilter);

    /** @ngInject */
    function toTrustedFilter($sce)
    {
        return function (value)
        {
            return $sce.trustAsHtml(value);
        };
    }

    /** @ngInject */
    function htmlToPlainTextFilter()
    {
        return function (text)
        {
            return String(text).replace(/<[^>]+>/gm, '');
        };
    }

    /** @ngInject */
    function nospaceFilter()
    {
        return function (value)
        {
            return (!value) ? '' : value.replace(/ /g, '');
        };
    }

    /** @ngInject */
    function humanizeDocFilter()
    {
        return function (doc)
        {
            if ( !doc )
            {
                return;
            }
            if ( doc.type === 'directive' )
            {
                return doc.name.replace(/([A-Z])/g, function ($1)
                {
                    return '-' + $1.toLowerCase();
                });
            }
            return doc.label || doc.name;
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('altDate', altDate);

    /** @ngInject */
    function altDate()
    {
        return function (value)
        {
            var diff = Date.now() - new Date(value);

            /**
             * If in a hour
             * e.g. "2 minutes ago"
             */
            if ( diff < (60 * 60 * 1000) )
            {
                return moment(value).fromNow();
            }
            /*
             * If in the day
             * e.g. "11:23"
             */
            else if ( diff < (60 * 60 * 24 * 1000) )
            {
                return moment(value).format('HH:mm');
            }
            /*
             * If in week
             * e.g "Tuesday"
             */
            else if ( diff < (60 * 60 * 24 * 7 * 1000) )
            {
                return moment(value).format('dddd');
            }
            /*
             * If more than a week
             * e.g. 03/29/2016
             */
            else
            {
                return moment(value).calendar();
            }

        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('hljs', hljsDirective);

    /** @ngInject */
    function hljsDirective($timeout, $q, $interpolate)
    {
        return {
            restrict: 'E',
            compile : function (element, attr)
            {
                var code;
                //No attribute? code is the content
                if ( !attr.code )
                {
                    code = element.html();
                    element.empty();
                }

                return function (scope, element, attr)
                {

                    if ( attr.code )
                    {
                        // Attribute? code is the evaluation
                        code = scope.$eval(attr.code);
                    }
                    var shouldInterpolate = scope.$eval(attr.shouldInterpolate);

                    $q.when(code).then(function (code)
                    {
                        if ( code )
                        {
                            if ( shouldInterpolate )
                            {
                                code = $interpolate(code)(scope);
                            }
                            var contentParent = angular.element(
                                '<pre><code class="highlight" ng-non-bindable></code></pre>'
                            );
                            element.append(contentParent);
                            // Defer highlighting 1-frame to prevent GA interference...
                            $timeout(function ()
                            {
                                render(code, contentParent);
                            }, 34, false);
                        }
                    });

                    function render(contents, parent)
                    {

                        var codeElement = parent.find('code');
                        var lines = contents.split('\n');

                        // Remove empty lines
                        lines = lines.filter(function (line)
                        {
                            return line.trim().length;
                        });

                        // Make it so each line starts at 0 whitespace
                        var firstLineWhitespace = lines[0].match(/^\s*/)[0];
                        var startingWhitespaceRegex = new RegExp('^' + firstLineWhitespace);
                        lines = lines.map(function (line)
                        {
                            return line
                                .replace(startingWhitespaceRegex, '')
                                .replace(/\s+$/, '');
                        });

                        var highlightedCode = hljs.highlight(attr.language || attr.lang, lines.join('\n'), true);
                        highlightedCode.value = highlightedCode.value
                            .replace(/=<span class="hljs-value">""<\/span>/gi, '')
                            .replace('<head>', '')
                            .replace('<head/>', '');
                        codeElement.append(highlightedCode.value).addClass('highlight');
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('fuseConfig', fuseConfigProvider);

    /** @ngInject */
    function fuseConfigProvider()
    {
        // Default configuration
        var fuseConfiguration = {
            'disableCustomScrollbars'        : false,
            'disableMdInkRippleOnMobile'     : true,
            'disableCustomScrollbarsOnMobile': true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            fuseConfiguration = angular.extend({}, fuseConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig,
                setConfig: setConfig
            };

            return service;

            //////////

            /**
             * Returns a config value
             */
            function getConfig(configName)
            {
                if ( angular.isUndefined(fuseConfiguration[configName]) )
                {
                    return false;
                }

                return fuseConfiguration[configName];
            }

            /**
             * Creates or updates config object
             *
             * @param configName
             * @param configValue
             */
            function setConfig(configName, configValue)
            {
                fuseConfiguration[configName] = configValue;
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.toolbarsearch', [] )
        .config(config)
        .directive('toolbarSearchBar', ToolbarSearchBarDirective);
;

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider, $mdThemingProvider)
    {
    	 $stateProvider
            
            .state('app.toolbarsearch', {
                url: '/toolbarsearch',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/toolbarsearch/toolbarsearch.html',
                        controller: 'ToolbarsearchController as toolbarSearchCtrl'
                    }
                }
            })
           .state('app.resultFiles', {
                url: '/smartportal/search',
                params: {
                    param1: null,
                     obj: null,
                     fileCount:null,
                     FileData:null
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/main/toolbarsearch/toolbarSearchResultNew.html',
                        controller: 'ToolbarsearchController as toolbarSearchCtrl'
                    }
                },
                resolve: {
                    fileResults: ['$stateParams', function($stateParams) {
                        return $stateParams.param1;
                    }]
                }
            });
    }

    /** @ngInject */
    function ToolbarSearchBarDirective($document)
    {
        return {
            restrict        : 'E',
            scope           : {},
            require         : 'toolbarSearchBar',
            controller      : 'ToolbarsearchController as toolbarSearchCtrl',
            bindToController: {
                debounce     : '=?',
                onSearch     : '@',
                onResultClick: '&?',
                onExpand     : '&?',
                onCollapse   : '&?'
            },
            templateUrl     : 'app/main/toolbarsearch/toolbarsearch.html',
            compile         : function (tElement)
            {
                // Add class
                tElement.addClass('toolbar-search-bar');

                return function postLink(scope, iElement)
                {
                    // Data
                    var inputEl,
                        bodyEl = $document.find('body');

                    // Methods
                    scope.collapse = collapse;
                    scope.expand = expand;

                    //////////

                    // Initialize
                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Grab the input element
                        inputEl = iElement.find('#ms-search-bar-input');
                    }

                    /**
                     * Expand action
                     */
                    function expand()
                    {
                        // Add expanded class
                        iElement.addClass('expanded');

                        // Add helper class to the body
                        bodyEl.addClass('ms-search-bar-expanded');

                        // Focus on the input
                        inputEl.focus();
                    }

                    /**
                     * Collapse action
                     */
                    function collapse()
                    {
                        // Remove expanded class
                        iElement.removeClass('expanded');

                        // Remove helper class from the body
                        bodyEl.removeClass('ms-search-bar-expanded');
                    }

                };
            }
        };
    }
})();


(function ()
{
    'use strict';

    angular
        .module('app.toolbarsearch')
        .controller('ToolbarsearchController', ToolbarsearcController)
        .value("AdvanceSearchObject", {value: ""})
        .value("SearchTerm", {value: ""})
        .value("SearchType", {value: ""})
        .value("FileIdForLegacyForm", {value: ""});
        

    /** @ngInject */
    function ToolbarsearcController($state,$stateParams,$scope, $element, $timeout, $mdDialog,RestAPIService, AdvanceSearchObject,SearchTerm,SearchType, FileIdForLegacyForm,CurrentSiteId, CommonUtil)
    {
        var toolbarSearchCtrl = this;
        toolbarSearchCtrl.resultFiles = $stateParams.obj;
        AdvanceSearchObject.value =$stateParams.FileData; 
        toolbarSearchCtrl.numberOfElements = $stateParams.fileCount;
        toolbarSearchCtrl.pageNumber = 0;
        toolbarSearchCtrl.pageSize = 20;
        toolbarSearchCtrl.next = function(){
            toolbarSearchCtrl.pageNumber = toolbarSearchCtrl.pageNumber + 1;            
            $scope.getSearchResult();            
        }
        toolbarSearchCtrl.previous = function(){
            toolbarSearchCtrl.pageNumber = toolbarSearchCtrl.pageNumber - 1;           
            $scope.getSearchResult();
        }
        $scope.sendPageNumber = function(pageNumber){
            toolbarSearchCtrl.pageNumber = pageNumber;
            $scope.getSearchResult();
        }
        $scope.noOfPages =toolbarSearchCtrl.numberOfElements/toolbarSearchCtrl.pageSize;
        $scope.pageNumbers = [];
        if($scope.noOfPages > 0){
          for(var i=0; i<$scope.noOfPages; i++){
              $scope.pageNumbers.push(i);
          }                       
        } 
        toolbarSearchCtrl.collapsed = true;
        toolbarSearchCtrl.query = '';
        toolbarSearchCtrl.queryOptions = {
        debounce: toolbarSearchCtrl.debounce || 0
        };
        toolbarSearchCtrl.resultsLoading = false;
        toolbarSearchCtrl.results = null;
        toolbarSearchCtrl.selectedResultIndex = 0;
        toolbarSearchCtrl.ignoreMouseEvents = false;
       
         $scope.fileResults = {};
         



        // Methods
        toolbarSearchCtrl.populateResults = populateResults;

        toolbarSearchCtrl.expand = expand;
        toolbarSearchCtrl.collapse = collapse;

        toolbarSearchCtrl.absorbEvent = absorbEvent;
        toolbarSearchCtrl.handleKeydown = handleKeydown;
        toolbarSearchCtrl.handleMouseenter = handleMouseenter;
        toolbarSearchCtrl.temporarilyIgnoreMouseEvents = temporarilyIgnoreMouseEvents;
        toolbarSearchCtrl.handleResultClick = handleResultClick;
        toolbarSearchCtrl.ensureSelectedResultIsVisible = ensureSelectedResultIsVisible;
        toolbarSearchCtrl.advancedSearchPopup = advancedSearchPopup;
        $scope.dtOptions={
             dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
             columnDefs: [

                 { // Target the actions column
                     targets: 0,
                     responsivePriority: 1,
                     filterable: false,
                     sortable: false
                 }
             ],
             pagingType: 'simple',
             lengthMenu: [10, 20, 30, 50, 100],
             pageLength: 20
                 // scrollY     : 'auto',
                 //responsive  : true
         };  

         $scope.detailsVisibility = false;   
          
        //////////     

        init();

        function init()
        {
            // Watch the model changes to trigger the search
            $scope.$watch('toolbarSearchCtrl.query', function (current, old)
            {
                if ( angular.isUndefined(current) )
                {
                    return;
                }

                if ( angular.equals(current, old) )
                {
                    return;
                }

                if ( toolbarSearchCtrl.collapsed )
                {
                    return;
                }

                // Evaluate the onSearch function to access the
                // function itself
                var onSearchEvaluated = $scope.$parent.$eval(toolbarSearchCtrl.onSearch, {query: current}),
                    isArray = angular.isArray(onSearchEvaluated),
                    isPromise = (onSearchEvaluated && !!onSearchEvaluated.then);

                if ( isArray )
                {
                    // Populate the results
                    toolbarSearchCtrl.populateResults(onSearchEvaluated);
                }

                if ( isPromise )
                {
                    // Show the loader
                    toolbarSearchCtrl.resultsLoading = true;

                    onSearchEvaluated.then(
                        // Success
                        function (response)
                        {
                            // Populate the results
                            toolbarSearchCtrl.populateResults(response);
                        },
                        // Error
                        function ()
                        {
                            // Assign an empty array to show
                            // the no-results screen
                            toolbarSearchCtrl.populateResults([]);
                        }
                    ).finally(function ()
                        {
                            // Hide the loader
                            toolbarSearchCtrl.resultsLoading = false;
                        }
                    );
                }
            });
        }

        

        toolbarSearchCtrl.VersionFile = {};
        $scope.VersionFileDialog = function(ev, file) {
            toolbarSearchCtrl.VersionFile = angular.copy(file);
            $mdDialog.show({
                controller: VersionFileDialogController,
                templateUrl: 'app/main/toolbarsearch/versionFile.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: $scope.customFullscreen,

            })

        };
        function VersionFileDialogController($scope, $mdDialog) {           
            $scope.VersionFile = toolbarSearchCtrl.VersionFile;
            $scope.selectedFileName = toolbarSearchCtrl.selectedFileName;
            var formData = new FormData();
            $scope.setFile = function(element) {
                $scope.$apply(function() {
                    $scope.files = [];
                    for (var i = 0; i < element.files.length; i++) {
                        formData.append('file', element.files[i]);
                        $scope.files.push(element.files[i]);
                    }
                });
            };
            $scope.hide = function() {
                $mdDialog.hide();
            };
            $scope.cancel = function() {
                $mdDialog.cancel();
            };
            $scope.NewVersionFile = function() {

                //alert(JSON.stringify(checkInfile));
                RestAPIService.NewVersionFile($scope.files[0], toolbarSearchCtrl.VersionFile).then(
                    function(success) {
                       toolbarSearchCtrl.getFileAttributeDetails(toolbarSearchCtrl.selectedFile.id,CurrentSiteId.value);
                    },
                    function(error) {
                        //  RestAPIService.showErrorDialog(error);
                         $mdDialog.show(
                            $mdDialog.alert()
                            .clickOutsideToClose(true)
                            .title('Error')
                            .textContent(error.data.description)
                            .ok('Ok')
                        );
                    }
                );
                $mdDialog.hide();
            };
        }
         toolbarSearchCtrl.checkInFile = {};
        $scope.checkInFileDialog = function(ev) {
            toolbarSearchCtrl.checkInFile = angular.copy(toolbarSearchCtrl.receivedFile);
            $mdDialog.show({
                controller: CheckInFileDialogController,
                templateUrl: 'app/main/toolbarsearch/checkInFile.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: $scope.customFullscreen,
            })
        };
        function CheckInFileDialogController($scope, $mdDialog) {           
            $scope.checkInFile = toolbarSearchCtrl.checkInFile;
            var formData = new FormData();
            $scope.setFile = function(element) {
                $scope.$apply(function() {
                    $scope.files = [];
                    for (var i = 0; i < element.files.length; i++) {
                        formData.append('file', element.files[i]);
                        $scope.files.push(element.files[i]);
                    }
                });
            };
            $scope.hide = function() {
                $mdDialog.hide();
            };
            $scope.cancel = function() {
                $mdDialog.cancel();
            };
            $scope.checkIn = function() {
                //alert(JSON.stringify(checkInfile));
                RestAPIService.checkIn($scope.files[0], toolbarSearchCtrl.checkInFile).then(
                    function(success) {
                        //alert("checkIn Success")
                        //$state.reload();
                        $mdDialog.show(
                                $mdDialog.alert()
                                .clickOutsideToClose(true)
                                .title('Success!')
                                .textContent('File checked in successfully')
                                .ok('Ok')
                            );
                    },
                    function(error) {
                        $mdDialog.show(
                            $mdDialog.alert()
                            .clickOutsideToClose(true)
                            .title('Error')
                            .textContent(error.data.description)
                            .ok('Ok')
                        );
                   }
                );
                $mdDialog.hide();
            };
        }
         $scope.buildForm = function(fileId) {
           
            /*RestAPIService.buildForm(fileId).then(
                function(success){
                    $scope.FormsData =success.data;
                    alert(JSON.stringify($scope.FormsData));
                },
                 function(error){
                        RestAPIService.showErrorDialog(error);
                    }
                );   */  
            FileIdForLegacyForm.value=fileId;

             $state.go('app.doclibraryForm');


        };
    
        $scope.fileCheckout = function(){
            var fileId = toolbarSearchCtrl.receivedFile.id;
            RestAPIService.fileCheckout(fileId).then(
                function(success) { 
                        var headers = success.headers();
                        var data = success.data;
                        var filename = toolbarSearchCtrl.selectedFileName;
                        var contentType = headers['content-type'];
                        var linkElement = document.createElement('a');
                        try {
                            var blob = new Blob([data], { type: contentType });
                            var url = window.URL.createObjectURL(blob);
                            linkElement.setAttribute('href', url);
                            linkElement.setAttribute("download", filename);
                            var clickEvent = new MouseEvent("click", {
                                "view": window,
                                "bubbles": true,
                                "cancelable": false
                            });
                            linkElement.dispatchEvent(clickEvent);
                        } catch (ex) {
                            console.log(ex);
                        }
                },
                function(error) {
                    console.log('ERROR Downloading the file ********');
                    //RestAPIService.showErrorDialog(error);  
                           $mdDialog.show(
                            $mdDialog.alert()
                            .clickOutsideToClose(true)
                            .title('Error')
                            .textContent(error.data.description)
                            .ok('Ok')
                        );
                
                }
            );
        }

            toolbarSearchCtrl.searchresultsDownload = function(file){
            //    alert(file.fileExtension);
            if(file.fileType == 'json' || file.fileType == 'JSON'){
                 FileIdForLegacyForm.value =file.id;
                 CurrentSiteId.value = file.siteId;
                  $state.go('app.doclibraryForm');
                }
                else{
                    RestAPIService.searchresultsDownload(file.id,file.siteId).then(
                        function(success) { 
                            var headers = success.headers();
                            //alert(JSON.stringify(headers));
                            var data = success.data;
                            //alert(data);
                            //var filename = headers['x-filename'];
                            var filename = toolbarSearchCtrl.selectedFileName;
                            var contentType = headers['content-type'];
                            var linkElement = document.createElement('a');
                            try {
                                var blob = new Blob([data], { type: contentType });
                                var url = window.URL.createObjectURL(blob);
                                linkElement.setAttribute('href', url);
                                linkElement.setAttribute("download", filename);
                                var clickEvent = new MouseEvent("click", {
                                    "view": window,
                                    "bubbles": true,
                                    "cancelable": false
                                });
                                linkElement.dispatchEvent(clickEvent);
                            } catch (ex) {
                                console.log(ex);
                            }
                            },
                        function(error) {
                            console.log('ERROR Downloading the file ********');
                            RestAPIService.showErrorDialog(error);
                        }
                            );
                                }
                                    }
        
        

        /**
         * Populate the results
         *
         * @param results
         */
        function populateResults(results)
        {
            // Before doing anything,
            // make sure the search bar is expanded
            if ( toolbarSearchCtrl.collapsed )
            {
                return;
            }

            var isArray = angular.isArray(results),
                isNull = results === null;

            // Only accept arrays and null values
            if ( !isArray && !isNull )
            {
                return;
            }

            // Reset the selected result
            toolbarSearchCtrl.selectedResultIndex = 0;

            // Populate the results
            toolbarSearchCtrl.results = results;
        }

        /**
         * Expand
         */
        function expand()
        {
            // Set collapsed status
            toolbarSearchCtrl.collapsed = false;

            // Call expand on scope
            $scope.expand();

            // Callback
            if ( toolbarSearchCtrl.onExpand && angular.isFunction(toolbarSearchCtrl.onExpand) )
            {
                toolbarSearchCtrl.onExpand();
            }
        }

        /**
         * Collapse
         */
        function collapse()
        {
            // Empty the query
            toolbarSearchCtrl.query = '';

            // Empty results to hide the results view
            toolbarSearchCtrl.populateResults(null);

            // Set collapsed status
            toolbarSearchCtrl.collapsed = true;

            // Call collapse on scope
            $scope.collapse();

            // Callback
            if ( toolbarSearchCtrl.onCollapse && angular.isFunction(toolbarSearchCtrl.onCollapse) )
            {
                toolbarSearchCtrl.onCollapse();
            }
        }

        /**
         * Absorb the given event
         *
         * @param event
         */
        function absorbEvent(event)
        {
            event.preventDefault();
        }

        /**
         * Handle keydown
         *
         * @param event
         */
        function handleKeydown(event)
        {
            var keyCode = event.keyCode,
                keys = [27, 38, 40];

            // Prevent the default action if
            // one of the keys are pressed that
            // we are listening
            if ( keys.indexOf(keyCode) > -1 )
            {
                event.preventDefault();
            }

            switch ( keyCode )
            {
                // Enter
                case 13:               
                    //User pressed Enter                    
                    SearchTerm.value = toolbarSearchCtrl.query;                          
                    SearchType.value = 'basic';  
                     getSearchResult();
                    //$state.go('app.resultFiles');
                    // Send to the result files state.
                    // if(SearchTerm.value != ""){
                    //     $state.go('app.resultFiles');
                    // }else{                        
                    //     $mdDialog.show(
                    //       $mdDialog.alert()
                    //         .parent(angular.element(document.querySelector('#popupContainer')))
                    //         .clickOutsideToClose(true)                           
                    //         .textContent('Please specify the Search Term')                           
                    //         .ok('OK')                           
                    //     );
                    // }
                    //$mdDialog.cancel();
                    //toolbarSearchCtrl.advancedSearchPopup();
                    // Trigger result click
                    //toolbarSearchCtrl.handleResultClick(toolbarSearchCtrl.results[toolbarSearchCtrl.selectedResultIndex]);

                    break;

                // Escape
                case 27:
                    //User pressed Escape
                    // Collapse the search bar
                    toolbarSearchCtrl.collapse();

                    break;

                // Up Arrow
                case 38:

                    // Decrease the selected result index
                    if ( toolbarSearchCtrl.selectedResultIndex - 1 >= 0 )
                    {
                        // Decrease the selected index
                        toolbarSearchCtrl.selectedResultIndex--;

                        // Make sure the selected result is in the view
                        toolbarSearchCtrl.ensureSelectedResultIsVisible();
                    }

                    break;

                // Down Arrow
                case 40:

                    if ( !toolbarSearchCtrl.results )
                    {
                        return;
                    }

                    // Increase the selected result index
                    if ( toolbarSearchCtrl.selectedResultIndex + 1 < toolbarSearchCtrl.results.length )
                    {
                        // Increase the selected index
                        toolbarSearchCtrl.selectedResultIndex++;

                        // Make sure the selected result is in the view
                        toolbarSearchCtrl.ensureSelectedResultIsVisible();
                    }

                    break;

                default:
                    break;
            }
        }

        /**
         * Handle mouseenter
         *
         * @param index
         */
        function handleMouseenter(index)
        {
            if ( toolbarSearchCtrl.ignoreMouseEvents )
            {
                return;
            }

            // Update the selected result index
            // with the given index
            toolbarSearchCtrl.selectedResultIndex = index;
        }

        /**
         * Set a variable for a limited time
         * to make other functions to ignore
         * the mouse events
         */
        function temporarilyIgnoreMouseEvents()
        {
            // Set the variable
            toolbarSearchCtrl.ignoreMouseEvents = true;

            // Cancel the previous timeout
            $timeout.cancel(toolbarSearchCtrl.mouseEventIgnoreTimeout);

            // Set the timeout
            toolbarSearchCtrl.mouseEventIgnoreTimeout = $timeout(function ()
            {
                toolbarSearchCtrl.ignoreMouseEvents = false;
            }, 250);
        }

        /**
         * Handle the result click
         *
         * @param item
         */
        function handleResultClick(item)
        {
            if ( toolbarSearchCtrl.onResultClick )
            {
                toolbarSearchCtrl.onResultClick({item: item});
            }

            // Collapse the search bar
            toolbarSearchCtrl.collapse();
        }

        /**
         * Ensure the selected result will
         * always be visible on the results
         * area
         */
        function ensureSelectedResultIsVisible()
        {
            var resultsEl = $element.find('.ms-search-bar-results'),
                selectedItemEl = angular.element(resultsEl.find('.result')[toolbarSearchCtrl.selectedResultIndex]);

            if ( resultsEl && selectedItemEl )
            {
                var top = selectedItemEl.position().top - 8,
                    bottom = selectedItemEl.position().top + selectedItemEl.outerHeight() + 8;

                // Start ignoring mouse events
                toolbarSearchCtrl.temporarilyIgnoreMouseEvents();

                if ( resultsEl.scrollTop() > top )
                {
                    resultsEl.scrollTop(top);
                }

                if ( bottom > (resultsEl.height() + resultsEl.scrollTop()) )
                {
                    resultsEl.scrollTop(bottom - resultsEl.height());
                }
            }
        }
        $scope.myView = "ListView";
        $scope.grid =false;
        $scope.changeView = function() {
            $scope.grid =!$scope.grid;
            $scope.myView = "GridView";
            if($scope.grid == false){
                $scope.myView ="ListView"
            }
        };

        $scope.selectFile = function(fileItem, i, event) { 
            //alert(JSON.stringify(fileItem));            
            $scope.selectedRow = i; 
            toolbarSearchCtrl.receivedFile = fileItem;
            $scope.filebuttonVisibility = false;
            $scope.iconsVisibility = i;
            $scope.detailsVisibility = true;

            if (fileItem.type === "folder") {
                $scope.versionsVisibility = false;
            }
            else{
                $scope.versionsVisibility = true;
            }

            if (fileItem.fileExtension === "pdf" || fileItem.fileExtension === "txt" || fileItem.fileExtension === "PDF" || fileItem.fileExtension === "docx" || fileItem.fileExtension === "ppt" || fileItem.fileExtension === "xls") {
                $scope.filebuttonVisibility = true;
            }
            
            $scope.fileName = fileItem.name;
            $scope.selectedFileIcon = CommonUtil.getIconForFile(fileItem);
            // Call API service to get attributes, versions and activities of this file.
            
            var fileId = fileItem.id;
            toolbarSearchCtrl.selectedFileName = fileItem.name;
            var siteId = fileItem.siteId;
            CurrentSiteId.value = siteId;
            toolbarSearchCtrl.getFileAttributeDetails(fileId, siteId);
             // toolbarSearchCtrl.getAttributes(fileId);
            toolbarSearchCtrl.edit =false;
            toolbarSearchCtrl.viewFile =false;
            RestAPIService.getMyFilePermissions(siteId,fileId).then(
                    function(response){
                     $scope.myPermissions = response.data;
                    toolbarSearchCtrl.filePermissions = $scope.myPermissions;
                   //alert(JSON.stringify($scope.myPermissions.permissions));
                                     
                    if($scope.myPermissions.permissions != undefined) {
                    var responseEdit = $scope.myPermissions.permissions.indexOf("Edit");
                    var responseView = $scope.myPermissions.permissions.indexOf("View");
                    
                        if(responseEdit >= 0) {
                            toolbarSearchCtrl.edit = true;
                        }
                    if(responseView >=0){
                        toolbarSearchCtrl.viewFile = true;
                        }
                        
                    }
                                    },
                    function(error){
                        RestAPIService.showErrorDialog(error);
                    }
                );  
        }

        toolbarSearchCtrl.getFileAttributeDetails = function(fileId, siteId) {
            RestAPIService.getFileAttributeDetails(fileId, siteId).then(
                function(response) {
                    $scope.file = response.data;
                    toolbarSearchCtrl.selectedFile = response.data;
                    $scope.allSharedUsers = response.data.users;
                    $scope.versions = response.data.versions;
                    $scope.activities = response.data.activities;                    
                    $scope.fileAttributes = [];
                    for(var attributeName in response.data.attributes){
                        var attribute = {
                            name: attributeName,
                            value: response.data.attributes[attributeName]
                        }
                        $scope.fileAttributes.push(attribute);
                    }                    
                },
                function(error) {
                    RestAPIService.showErrorDialog(error);
                }
            );
        };

        function advancedSearchPopup(){
            $mdDialog.show({
                controller: advancedSearchPopupController,
                templateUrl: 'app/main/toolbarsearch/toolbarSearchPopup.html',
                parent: angular.element(document.body),
                // targetEvent: ev,
                clickOutsideToClose:true,
                fullscreen: $scope.customFullscreen 
            })
        }
        toolbarSearchCtrl.resultFiles = {};
        function advancedSearchPopupController($scope, RestAPIService,SearchType, CommonUtil, CurrentSiteId){
            $scope.fileExtensions= ["json","pdf","docx","xl","txt","jpeg","folder","jpg","png","html","xml","doc"];
            $scope.file={                
                "fileExtension":null,
                "creator":null,                                
                "fileName":null,
                "fromDate":null,
                "toDate":null,
                // "businessObject":"",
                "fullTextSearch":null                
            }
            SearchTerm.value = toolbarSearchCtrl.query; 
            $scope.hasTheWords=SearchTerm.value;
            SearchType.value =  'advance';
            $scope.noOfAttributesToDisplay = 5;

            $scope.locations = ["allSites","currentSite"];
            $scope.dateModifiedTypes = ["Any Time", "Today","Yesterday","Last 7 days","Last 30 days","last 90 days"];
            $scope.reset = function(fileData){
                $scope.file = {};
                $scope.attributeObjects = {};
            }
            $scope.cancel = function(){
                $mdDialog.cancel();
            }
            
            $scope.getAllBusinessObjects=function(){            
                RestAPIService.getAllBusinessObjects().then(
                    function(responce){
                        $scope.allBusinessObjects = responce.data;                    
                    },
                    function(error){
                        RestAPIService.showErrorDialog(error);
                    })
            }
            $scope.selectBusinessObject = function(businessObject){                                               
                // Calling Rest API Service to get Attributes of this Business Object
                RestAPIService.findBusinessObjectAttributes(businessObject.id).then(function(responce){                   
                    $scope.attributeObjects = responce.data.attributes;                    
                    // If any Attribute is having listReferrence as COMMA separated values, Split them.
                    if($scope.attributeObjects != null){
                            $scope.attributeObjects.forEach(function(attribute){                   
                            if(attribute.type == "List"){
                                attribute['listValues'] = attribute.listReference.split(',');                  
                            }
                        });  
                    }                    
                },
                function(error){
                    RestAPIService.showErrorDialog(error);
                })                                                       
            }            
            $scope.moreObjects = function(){
                // Increase +5 objects using limitTo filter.
                $scope.noOfAttributesToDisplay += 5;
            }
            $scope.searchFiles = function(hasTheWords, fileData,attributeObjects, siteLocation){
                // alert(JSON.stringify(fileData));                
                if(siteLocation == "currentSite"){
                    fileData.siteId = CurrentSiteId.value;
                }
                 // Build the Attribute Objects array & Append to fileData.So that we can send whole object to API.
                fileData.attributes=[]; 
                if(attributeObjects != undefined){
                    attributeObjects.forEach(function(h){
                        if(h.range == true){
                            if((h.fromValue != undefined && h.fromValue != "") && (h.toValue != undefined && h.toValue != "")){
                                fileData.attributes.push({'name': h.label, 'fromValue': h.fromValue, 'toValue':h.toValue});
                            }
                            else if((h.fromValue != undefined && h.fromValue != "") &&(h.toValue == undefined || h.toValue == "")){
                                fileData.attributes.push({'name': h.label, 'fromValue': h.fromValue, 'toValue':""});
                            }
                            else if((h.fromValue == undefined || h.fromValue == "") && (h.toValue != undefined || h.toValue != "")){
                                fileData.attributes.push({'name': h.label, 'fromValue': "", 'toValue':h.toValue});
                            }
                        }
                        else if(h.range == false){
                            if(h.fromValue != undefined  && h.fromValue != ""){
                               fileData.attributes.push({'name': h.label, 'fromValue': h.fromValue}); 
                            }
                        }
                    });
                }
                AdvanceSearchObject.value = fileData;
                // Override the value of "SearchTerm.value" with the "hasTheWords" for validation.
                SearchTerm.value = hasTheWords;
                // alert(JSON.stringify(AdvanceSearchObject.value));

                if((fileData.fileName != null && fileData.fileName!= undefined) || (fileData.fromDate!= null && fileData.fromDate!= undefined) || (fileData.toDate!= null && fileData.toDate!= undefined) || (fileData.businessObject!= null && fileData.businessObject!= undefined) || (fileData.fileExtension!= null && fileData.fileExtension!= undefined) ){
                    getSearchResult();
                    $mdDialog.cancel();
                }
                else if(SearchTerm.value != "" && SearchTerm.value != undefined){
                    
                        getSearchResult();
                        $mdDialog.cancel();
                    }
                else {
             RestAPIService.successTostDialog("Please specify the Search term."); 
                }       
            }             
        }

       function getSearchResult(){        
            if(SearchType.value=='advance'){                    
                // alert(JSON.stringify(AdvanceSearchObject.value));
                RestAPIService.advancedSearch(AdvanceSearchObject.value,toolbarSearchCtrl.pageNumber, toolbarSearchCtrl.pageSize, toolbarSearchCtrl.dateRange  ).then(function(responce){                           
                    toolbarSearchCtrl.resultFiles =responce.data;
                     $scope.fileResults = toolbarSearchCtrl.resultFiles;
                     console.log($scope.fileResults);
                     $state.go('app.resultFiles', {param1: $scope.fileResults})
                },
                function(error){
                    RestAPIService.showErrorDialog(error);
                })            
            }
            else{            
                RestAPIService.basicSearch(SearchTerm.value ).then(function(responce){
                    toolbarSearchCtrl.resultFiles =responce.data;   
                  //  alert(JSON.stringify(responce.data));
                    $scope.fileResults = toolbarSearchCtrl.resultFiles;
                     console.log($scope.fileResults);
                     $state.go('app.resultFiles', {param1: $scope.fileResults})                   
                },
                function(error){
                    RestAPIService.showErrorDialog(error);
                })                   
            }                
        }

        $scope.getSearchResult = function(){        
            if(SearchType.value=='advance'){                    
                // alert(JSON.stringify(AdvanceSearchObject.value));
                RestAPIService.advancedSearch(AdvanceSearchObject.value,toolbarSearchCtrl.pageNumber, toolbarSearchCtrl.pageSize, toolbarSearchCtrl.dateRange  ).then(function(responce){                           
                    toolbarSearchCtrl.resultFiles =responce.data;
                     $scope.fileResults = toolbarSearchCtrl.resultFiles;
                      toolbarSearchCtrl.numberOfElements = responce.headers('x-total-count');
                   // Make page numbers to be populated in dropdown, to select page numbers directly.
                     $scope.noOfPages =toolbarSearchCtrl.numberOfElements/toolbarSearchCtrl.pageSize;
                                 
                      $scope.pageNumbers = [];
                      if($scope.noOfPages > 0){
                        for(var i=0; i<$scope.noOfPages; i++){
                            $scope.pageNumbers.push(i);
                        }                        
                      } 
                     $state.go('app.resultFiles');
                },
                function(error){
                    RestAPIService.showErrorDialog(error);
                })            
            }
            else{            
                RestAPIService.basicSearch(SearchTerm.value ).then(function(responce){
                    toolbarSearchCtrl.resultFiles =responce.data;   
                      $scope.fileResults = toolbarSearchCtrl.resultFiles;
                       toolbarSearchCtrl.numberOfElements = responce.headers('x-total-count');
                     // Make page numbers to be populated in dropdown, to select page numbers directly.
                      $scope.noOfPages =toolbarSearchCtrl.numberOfElements/toolbarSearchCtrl.pageSize;
                      $scope.pageNumbers = [];
                      if($scope.noOfPages > 0){
                        for(var i=0; i<$scope.noOfPages; i++){
                            $scope.pageNumbers.push(i);
                        }                       
                      } 
                     $state.go('app.resultFiles');                
                },
                function(error){
                    RestAPIService.showErrorDialog(error);
                })                   
            }                
        }
        toolbarSearchCtrl.pageNumber = 0;
        toolbarSearchCtrl.pageSize = 20;
        toolbarSearchCtrl.next = function(){
            toolbarSearchCtrl.pageNumber = toolbarSearchCtrl.pageNumber + 1;            
            $scope.getSearchResult();            
        }
        toolbarSearchCtrl.previous = function(){
            toolbarSearchCtrl.pageNumber = toolbarSearchCtrl.pageNumber - 1;           
            $scope.getSearchResult();
        }
        $scope.sendPageNumber = function(pageNumber){
            toolbarSearchCtrl.pageNumber = pageNumber;
            $scope.getSearchResult();
        }

    }   
})();
(function() {
    'use strict';

    var app = angular
        .module('app.social_login', [])
        .config(config)
        .run(run);
    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider, $controllerProvider, $compileProvider, $filterProvider, $provide) {
        app.controller = $controllerProvider.register;
        app.directive = $compileProvider.directive;
        app.filter = $filterProvider.register;
        app.factory = $provide.factory;
        app.service = $provide.service;

        $stateProvider
            .state('app.social_login', {
                url: '/smartportal/social_login',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/social_login/social_login.html',
                        controller: 'SocialLoginController as SocialCtrl'
                    }
                },
                resolve: {
                    deps: ['$ocLazyLoad', function($ocLazyLoad) {
                        return $ocLazyLoad.load(['app/main/social_login/social_login.controller.js']);
                    }]
                }
            })
        //  msNavigationServiceProvider.saveItem('Social', {
        //         title: 'Social',
        //         icon: 'icon-file-document-box',
        //         state: 'app.social_login',
        //         weight: 15
        //     });

      
    }

    function run(msNavigationService, $localStorage, $rootScope, $state) {
        msNavigationService.saveItem('Social', {
            title: 'Social',
            icon: 'icon-file-document-box',
            state: 'app.social_login',
            weight: 15,
        hidden:function(){
            if ($localStorage.menubarsetting != undefined) {
              var show = $localStorage.menubarsetting.social;
              return !(show);
                 }
            }
        });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.social_login')
        .controller('SocialLoginController', SocialLoginController);

    
    function SocialLoginController($state,$scope,$cookies,$filter,AuthenticationService,$location)
    {
        var SocialCtrl = this;
      
       /* AuthenticationService.loginwithToken(token){
        	alert("Alert From Social Controller");
        }*/
        var token = $cookies.get('social-authentication');    
      
        	
        AuthenticationService.loginwithToken(token, function (result) {
        	 if (result.success === true) {
                 $location.path('/smartportal/overview');
             } else {
               alert("Error");
             }
        });
        
   
    }


         
})();
(function ()
{
    'use strict';

    angular
        .module('app.sites')
        .controller('SitesController', SitesController);
       
    /** @ngInject */
    
    function SitesController($state, $scope, $location, $mdDialog,$document, CurrentSiteName, CurrentSiteId,CurrentSitePage, CurrentSiteUrl, RestAPIService, Icons, Sites,textAngularManager, $stateParams,$localStorage)
    {
        var siteCtrl = this;  
        
        siteCtrl.sites = Sites.data;    
        //console.log(siteCtrl.sites);
        $scope.settingsVisibility =$stateParams.showsettings;
        siteCtrl.totalSites = Sites.data.length;
        if($stateParams.hideLibrary !=undefined && $stateParams.hideLibrary != null  ){
        	  siteCtrl.hideLibrary = $stateParams.hideLibrary;
        }else{
        	siteCtrl.hideLibrary=false;
        }
      
        $scope.siteId = $stateParams.siteId;
        //List of sites              
        siteCtrl.getSites = function() {  
            RestAPIService.getSites().then(
                function(success){
                  siteCtrl.sites = success.data;
                  
                  siteCtrl.totalSites = success.data.length;
                },
                function(error){
                   RestAPIService.showErrorDialog(error);
                }
            );
        }
        
        if($localStorage.sitesettingdata !=null && $localStorage.sitesettingdata !=undefined){
        	$scope.sitedisplayname = $localStorage.sitesettingdata.sitedisplayname;
        	siteCtrl.sitedisname = $scope.sitedisplayname;
        }else{
        	$scope.sitedisplayname = "site";
        	siteCtrl.sitedisname = "site";
        }
        
        siteCtrl.goToSites = function(siteUrl){
            $state.go("app.sites");
        }
        siteCtrl.openSite = function(siteUrl){
            $state.go("app.sites.site");
        }
        $scope.notesData = [];
        if($scope.siteId != undefined) {
            RestAPIService.getToDoList($scope.siteId).then(
              function(success){
                  $scope.notesData = success.data;                
             },
             function(error){
                 RestAPIService.showErrorDialog(error);
             });
        }
        
        $scope.loadPage = CurrentSitePage.value;
        $scope.loadHome =function(){
        	$scope.notes = [];
        	 CurrentSitePage.value = 'Home';
        	 $scope.loadPage = 'Home';         	
        }
       /* $scope.loadDashboard = function(){
        	$scope.notes = [];
            CurrentSitePage.value = 'home';
            $scope.loadPage = 'home';
        }*/
        $scope.loadDoclibrary = function(){
        	$scope.notes = [];
            CurrentSitePage.value = 'Library';
            if(!siteCtrl.hideLibrary){
            	$scope.loadPage = 'Library';
            }else{
            	alert("You have no Permission to View Library");
            }
            
            
        }
        $scope.loadMembers = function(){
        	$scope.notes = [];
            CurrentSitePage.value = 'members';
            $scope.loadPage = 'members';
        }
        $scope.loadTodoList = function(){
        	$scope.notes = [];
            CurrentSitePage.value = 'notes';
            $scope.loadPage = 'notes';
            $scope.notes = $scope.notesData;            
        }
        $scope.loadDiscussionForum = function(){
        	$scope.notes = [];
            CurrentSitePage.value = 'discussionforum';
            $scope.loadPage = 'discussionforum';
        }
        $scope.loadSiteSettings = function(){
        	$scope.notes = [];
            CurrentSitePage.value = 'Site Settings';
            $scope.loadPage = 'sitesettings';
        }

        siteCtrl.getAnotherColor =  function(index){
            siteCtrl.colors = ['red','pink','purple','deep-purple','indigo','blue', 'light-blue','cyan', 'teal','green',
                        'light-green','lime','yellow','amber','deep-orange','brown','grey','blue-grey'];
            var totalNoOfColors = siteCtrl.colors.length;                        
            return siteCtrl.colors[index%totalNoOfColors];
        }

        siteCtrl.showConfirm = function(ev){
            $mdDialog.show({
                template           : '<md-dialog ms-scroll><ms-note-form note-type="\'new\' "></ms-note-form></md-dialog>',
                parent             : $document.find('#notes'),
                targetEvent        : ev,
                clickOutsideToClose: true,
                escapeToClose      : true
            
            });
        }  
        siteCtrl.escKeyEvent = function escKeyEvent(e)
        {
            if ( e.keyCode === 27 )
            {
                showConfirm();
            }
        }
      // console.log(showsettings);
       //console.log(siteId);
        siteCtrl.enterSite =  function(site){ 
        	site.id = "site-2";
        	siteCtrl.siteLibraryId ="1000002";
        	
        	siteCtrl.siteLibraryId = site.documentLibrary;
        	 RestAPIService.getMyFilePermissions(site.id,siteCtrl.siteLibraryId).then(
                     function(success){
                       siteCtrl.siteSettingsPermissions = success.data;
                       if(siteCtrl.siteSettingsPermissions.permissions.length ===0){
                    	   siteCtrl.hideLibrary = true;
                    	  
                       }else{
                    	   siteCtrl.hideLibrary = false; 
                    	  
                       }
                       siteCtrl.showsettings =true;
                   	if(site.createdBy === $localStorage.currentUser.username ){
                   		siteCtrl.showsettings =false;        		
                   	}
                       CurrentSiteName.value = site.name;
                       CurrentSiteId.value = site.id;
                       CurrentSiteUrl.value = site.url;
                       CurrentSitePage.value = 'Home';
                       $state.go('app.sites.site', {siteId: site.id ,hideLibrary:siteCtrl.hideLibrary,showsettings:siteCtrl.showsettings});
                     },
                     function(error){
                        RestAPIService.showErrorDialog(error);
                     }
                 );
        }
       

        siteCtrl.getCurrentSiteName =  function(){
            return CurrentSiteName.value;
        }
        siteCtrl.getCurrentSiteId =  function(){
            return CurrentSiteId.value;
        }
        siteCtrl.getCurrentSitePage =  function(){
            if(CurrentSitePage.value == 'Home'){
            	$scope.loadHome();
            }
            return CurrentSitePage.value;
        }

       
        siteCtrl.deleteSite = function(ev) {
          // Appending dialog to document.body to cover sidenav in docs app
          var confirm = $mdDialog.confirm()
                .title('Remove')
                .textContent('All members, documents and site related data will be permanently deleted. Continue ?')
                .ariaLabel('Delete Site')
                .targetEvent(ev)
                .ok('Ok')
                .cancel('Cancel');

                $mdDialog.show(confirm).then(function() {
                  //Deleting the site
                  RestAPIService.deleteSite(siteCtrl.getCurrentSiteId()).then(
                        function(success){
                          //Go back to sites page                          
                          //Delete site successful.Need to do GET again to refresh.
                          //$state.go('app.sites', null, { reload: true });
                          RestAPIService.successTostDialog("Site deleted successfully ");
                          siteCtrl.getSites();
                          $location.url('/sites');
                          
                        },
                        function(error){
                           RestAPIService.showErrorDialog(error);
                        }
                  );    
                  
                }, function() {
                  //User clicked Cancel. Close the popup.
                });
        };



        $scope.createSite = function(ev) {
             $mdDialog.show({
                  controller: CreateSiteDialogController,
                  templateUrl: 'app/main/sites/site/create.site.dialog.html',
                  parent: angular.element(document.body),
                  targetEvent: ev,
                  clickOutsideToClose:true,
                  fullscreen: $scope.customFullscreen // Only for -xs, -sm breakpoints.
                })
                .then(function(answer) {
                  //$scope.status = 'You said the information was "' + answer + '".';
                }, function() {
                  //$scope.status = 'You cancelled the dialog.';
                });
          };
        

        function CreateSiteDialogController($scope, $mdDialog, RestAPIService, CurrentSiteLogo) {
        	$scope.sitedisplayname = siteCtrl.sitedisname;
           $scope.taToolbar = [
            ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'p', 'pre', 'quote', 'bold', 'italics', 'underline', 'strikeThrough', 'ul', 'ol', 'redo', 'undo', 'clear'],
            ['justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull', 'indent', 'outdent', 'html', 'insertImage', 'insertLink', 'insertVideo', 'wordcount', 'charcount']
        ];



   $scope.ngFlowOptions = {
            // You can configure the ngFlow from here
            /*target                   : 'api/media/image',
             chunkSize                : 15 * 1024 * 1024,
             maxChunkRetries          : 1,
             simultaneousUploads      : 1,
             testChunks               : false,
             progressCallbacksInterval: 1000*/
        };
        $scope.ngFlow = {
            // ng-flow will be injected into here through its directive
            flow: {}
        };
        $scope.dropping = false;
        $scope.upload = upload;



        function upload()
        {
            // Set headers
            $scope.ngFlow.flow.opts.headers = {
                'X-Requested-With': 'XMLHttpRequest',
                //'X-XSRF-TOKEN'    : $cookies.get('XSRF-TOKEN')
            };

            $scope.ngFlow.flow.upload();
        }
            $scope.hide = function() {

              $mdDialog.hide();
            };

            $scope.cancel = function() {
                $scope.user = {};     
                $mdDialog.cancel();
            };

            $scope.save = function(userData) {
                  //Site Icon come from global variable
                   userData.icon = CurrentSiteLogo.value;
                   if(userData.visibility == null || userData.visibility == undefined ){
                	 $scope.Msg ={msg:"Please Select one of these options"}
                	 return;
                   }
                   RestAPIService.createSite(userData).then(
                        function(success){
                         RestAPIService.successTostDialog("Site successfully created");
                         $mdDialog.hide(userData);
                           siteCtrl.getSites();
                        },
                        function(error){
                        if(error.status == 400){
                        	 RestAPIService.successTostDialog(error.data.description);
                        	 return;
                        };
                        }
                    );                                 
                    //$mdDialog.hide(userData);
            };

            //Setting icons in the dialog scope
            $scope.icons = Icons.icons;

            $scope.openIconList = function(ev) {
              $mdDialog.show({
                  controller: CreateSiteDialogController,
                  templateUrl: 'app/main/sites/site/dashboard/site.logo.html',
                  parent: angular.element(document.body),
                  targetEvent: ev,
                  clickOutsideToClose:true,
                  preserveScope: true,
                  autoWrap: true,
                  
                  skipHide: true, // this line does the trick for nested dialogs

                  fullscreen: $scope.customFullscreen // Only for -xs, -sm breakpoints.
                })
                .then(function(answer) {
                  $scope.status = 'You said the information was "' + answer + '".';
                }, function() {
                  $scope.status = 'You cancelled the dialog.';
                });
            };
        
            $scope.noOfIconsForDisplay = 50;
            $scope.iconsPerColumn = 5;

            $scope.range = function(min, max, step){
              step = step || 1;
              var input = [];
              for (var i = min; i <= max; i += step) input.push(i);
              return input;
            };

            $scope.loadMoreIcons = function() {
                $scope.noOfIconsForDisplay += 10;
                // if($scope.noOfIconsForDisplay >= 60)      $scope.iconsPerColumn=10;
                // if($scope.noOfIconsForDisplay >= 140)      $scope.iconsPerColumn=20;
                // if($scope.noOfIconsForDisplay >= 200)      $scope.iconsPerColumn=30;
                // if($scope.noOfIconsForDisplay >= 250)      $scope.iconsPerColumn=40;
                // if($scope.noOfIconsForDisplay >= 300)      $scope.iconsPerColumn=50;
                // if($scope.noOfIconsForDisplay >= 350)      $scope.iconsPerColumn=100;
            };

             $scope.saveLogo = function(siteIcon) {
                //alert(siteIcon);
               
               //Set the name of the selected site
                CurrentSiteLogo.value = siteIcon;
                $mdDialog.hide();
            };
          }
          
    }
})();
(function() {
    'use strict';

    var app = angular
        .module('app.sharedwithme', [])
       // .run(run)
        .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider, $controllerProvider, $compileProvider, $filterProvider, $provide) {
        app.controller = $controllerProvider.register;
        app.directive = $compileProvider.directive;
        app.filter = $filterProvider.register;
        app.factory = $provide.factory;
        app.service = $provide.service;

        $stateProvider
            .state('app.sharedwithme', {
                url: '/sharedwithme',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/sharedwithme/sharedwithme.html',
                        controller: 'SharedwithmeController as sharedCtrl'
                    }
                },
               /* resolve: {
                    deps: ['$ocLazyLoad', function($ocLazyLoad) {
                        return $ocLazyLoad.load(['app/main/sharedwithme/sharedwithme.controller.js']);
                    }]
                }*/
            });

       /* msNavigationServiceProvider.saveItem('sharedwithme', {
              title : 'Shared With Me',
              icon  : 'icon-account-plus',
              state : 'app.sharedwithme',
              weight: 5
          });*/

    }
    
   /* function run(msNavigationService, $localStorage, $rootScope, $state) {
      
    	 $rootScope.$state = $state;
    	 if($localStorage.menubarsetting !=undefined && $localStorage.menubarsetting !=null){
				var showsharedicon = $localStorage.menubarsetting.shared;
			}
         msNavigationService.saveItem('sharedwithme', {
             title: 'Shared',
             icon: 'icon-account-plus',
             state: 'app.sharedwithme',
             weight: 5,
             hidden: function() {                 
            	 if ($localStorage.menubarsetting != undefined) {
                     var show = $localStorage.menubarsetting.shared;
                     return !(show);
                 }
                }
         });
    }*/
})();
(function() {
    'use strict';

    angular
        .module('app.sharedwithme')
        .controller('SharedwithmeController', SharedwithmeController);

    /** @ngInject */
    function SharedwithmeController($state, $scope, $http, RestAPIService, CommonUtil, $stateParams, $mdDialog) {
        var sharedCtrl = this;
      //  $scope.sharedfiles = Sharedfiles.data;
        $scope.orderByField = 'name';
        $scope.reverseSort = false;
        $scope.detailsVisibility = false;
        $scope.buttonVisibility = false;
        $scope.filebuttonVisibility = false;
        sharedCtrl.pageNumber = 0;
        sharedCtrl.pageSize = 10;
        sharedCtrl.next = function(){
            sharedCtrl.pageNumber = sharedCtrl.pageNumber + 1;            
            sharedCtrl.getSharedfiles();            
        }
        sharedCtrl.previous = function(){
            sharedCtrl.pageNumber = sharedCtrl.pageNumber - 1;           
            sharedCtrl.getSharedfiles();
        }
        $scope.sendPageNumber = function(pageNumber){
            sharedCtrl.pageNumber = pageNumber;
            sharedCtrl.getSharedfiles();
        }
        
        sharedCtrl.getSharedfiles = function() {
            RestAPIService.getMySharedfiles(sharedCtrl.pageNumber,sharedCtrl.pageSize).then(
                function(success) {
                    $scope.sharedfiles = success.data;
                sharedCtrl.numberOfElements = success.headers('x-total-count');
                  $scope.noOfPages = sharedCtrl.numberOfElements/sharedCtrl.pageSize ;
                    $scope.pageNumbers = [];
                    if($scope.noOfPages > 0){
                      for(var i=0; i<$scope.noOfPages; i++){
                          $scope.pageNumbers.push(i);
                       }                        
                    } 
                },
                function(error) {
                    RestAPIService.showErrorDialog(error);
                }
            );
        }
        sharedCtrl.selectFile = function(fileItem, i) {
            $scope.selectedRow = i;
            sharedCtrl.receivedFile = fileItem;
            sharedCtrl.permissions = fileItem.permissions;

            $scope.detailsVisibility = true;
            if (fileItem.mimeType == "") {
                $scope.buttonVisibility = false;
                $scope.filebuttonVisibility = false;
            } else if (fileItem.mimeType === "application/pdf" || fileItem.mimeType === "text/plain" || fileItem.mimeType === "multipart/form-data" || fileItem.mimeType === "application/octet-stream") {
                $scope.buttonVisibility = false;
                $scope.filebuttonVisibility = true;
            } else {
                $scope.buttonVisibility = true;
                $scope.filebuttonVisibility = false;
            }
            sharedCtrl.selectedFileName = fileItem.name;
            $scope.selectedFileIcon = CommonUtil.getIconForFile(fileItem);
            $scope.businessObjectName = fileItem.businessObjectName;
            var fileId = fileItem.id;
            sharedCtrl.fileattributes = fileItem.attributes;
            $scope.fileattributes = [];
            var keyset = Object.keys(sharedCtrl.fileattributes);
            keyset.forEach(function(key) {
                $scope.fileattributes.push({
                    name: key,
                    value: sharedCtrl.fileattributes[key]
                });
            });
            //alert(JSON.stringify(sharedCtrl.fileattributes));
            // alert(JSON.stringify(sharedCtrl.permissions));
        }
        $scope.previewFileDialog = function(ev) {
            $mdDialog.show({
                controller: DialogController,
                templateUrl: 'app/main/sharedwithme/previewFiles.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: $scope.customFullscreen
            });
        }

        function DialogController($scope, $mdDialog, $sce, $sessionStorage) {
            var selectedFile = sharedCtrl.receivedFile;
            var siteId = sharedCtrl.receivedFile.siteId;
            var jwtToken = $sessionStorage.currentUser.token.trim();
            if (jwtToken != undefined && selectedFile != undefined) {
                var encodedURI = encodeURIComponent(baseUrl+'/api/sites/' + siteId + '/files/file?fileId=' + selectedFile.id + '&checkingOut=false&attachment=false&jwtToken=' + jwtToken);
                if (selectedFile.mimeType === "application/octet-stream") {
                    $scope.fileURL = $sce.trustAsResourceUrl('https://view.officeapps.live.com/op/view.aspx?src=' + encodedURI + '&embedded=true');
                } else {
                    $scope.fileURL = $sce.trustAsResourceUrl('https://docs.google.com/gview?url=' + encodedURI + '&embedded=true');
                }
            }
        }
        sharedCtrl.fileIcon = function(file) {
            return CommonUtil.getIconForFile(file);
        }
        $scope.buildForm = function(fileId) {

            console.log("$scope.businessObjectName : ", $scope.businessObjectName)

            $state.go('app.doclibraryForm', {
                'siteId': siteId,
                'fileId': fileId,
                'businessObject': $scope.businessObjectName
            });
        };
        
        $scope.isViewBtn = function(permissions, type) {
        	if(undefined != permissions) {
            	var response = permissions.indexOf(type);
            	if(response >= 0) {
            		return true;
            	}
        	}
        }        
        
        $scope.downloadFile = function() {
            var fileId = sharedCtrl.receivedFile.id;
            var siteId = sharedCtrl.receivedFile.siteId;
            RestAPIService.downloadFile(siteId, fileId).then(
                function(success) {
                    var headers = success.headers();
                    var data = success.data;
                    var filename = sharedCtrl.selectedFileName;
                    var contentType = headers['content-type'];
                    var linkElement = document.createElement('a');
                    try {
                        var blob = new Blob([data], {
                            type: contentType
                        });
                        var url = window.URL.createObjectURL(blob);
                        linkElement.setAttribute('href', url);
                        linkElement.setAttribute("download", filename);
                        var clickEvent = new MouseEvent("click", {
                            "view": window,
                            "bubbles": true,
                            "cancelable": false
                        });
                        linkElement.dispatchEvent(clickEvent);
                    } catch (ex) {
                        console.log(ex);
                    }
                },
                function(error) {
                    console.log('ERROR Downloading the file ********');
                    RestAPIService.showErrorDialog(error);
                }
            );
        }
        sharedCtrl.allSharedUsers = [];

        sharedCtrl.sharedUsersDialog = function(ev) {
            $mdDialog.show({
                controller: sharedUsersDialogController,
                templateUrl: 'app/main/sharedwithme/sharedUsersDialog.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: $scope.customFullscreen
            })
        }

        function sharedUsersDialogController($scope) {
            $scope.allSharedUsers = sharedCtrl.allSharedUsers;
            $scope.selectedFileName = sharedCtrl.selectedFileName;
            var siteId = sharedCtrl.receivedFile.siteId;
            $scope.tableVisibility = false;
            $scope.Options = ["Display", "Edit", "Share", "Delete", "Download"];
            $scope.searchUsers = function(searchKeyword) {
                RestAPIService.searchUsers(searchKeyword).then(
                    function(response) {
                        $scope.searchedUsers = response.data;
                        $scope.tableVisibility = true;
                    },
                    function(error) {
                        RestAPIService.showErrorDialog(error);
                    });
            }

            $scope.shareFile = function(memberData, status) {
                memberData.status = status;
                $scope.allSharedUsers.push(memberData);
            }

            $scope.removeSharing = function(userData, i) {
                $scope.allSharedUsers.splice(i, 1);
            }
            $scope.cancel = function() {
                $mdDialog.cancel();
            }
            $scope.fileattributes = sharedCtrl.fileattributes;
            $scope.selectedFileName = sharedCtrl.selectedFileName;
            $scope.updateFileSharing = function() {
                $scope.fileSharingObject = {};
                $scope.fileSharingObjectId = sharedCtrl.selectedFile.id;
                $scope.fileSharingObject.attributes = $scope.fileattributes;
                $scope.fileSharingObject.users = $scope.allSharedUsers;
                RestAPIService.updateFileAttrAndSharing(siteId, $scope.fileSharingObjectId).then(
                    function(response) {
                        RestAPIService.successTostDialog("Fie shared successfully ");
                        sharedCtrl.getAttributes(sharedCtrl.receivedFile.id);
                        $mdDialog.hide();
                    },
                    function(error) {
                        RestAPIService.showErrorDialog(error);
                    });
            }
        }
        sharedCtrl.currentFile = {};
        $scope.UpdateFile = function(ev) {
            sharedCtrl.currentFile = angular.copy(sharedCtrl.receivedFile);
            sharedCtrl.name = sharedCtrl.currentFile.name;
            sharedCtrl.id = sharedCtrl.currentFile.id;
            $mdDialog.show({
                controller: UpdateFileDialogController,
                templateUrl: 'app/main/sharedwithme/editFiledialog.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: $scope.customFullscreen,

            })


        };

        function UpdateFileDialogController($scope, $mdDialog) {
            var siteId = sharedCtrl.receivedFile.siteId;
            $scope.currentFile = sharedCtrl.currentFile;
            $scope.hide = function() {
                $mdDialog.hide();
            };
            $scope.cancel = function() {
                $mdDialog.cancel();
            };
            $scope.updateFile = function(file) {
                RestAPIService.updateFile(siteId, file).then(
                    function(success) {
                        RestAPIService.successTostDialog("File renamed successfully ");
                        sharedCtrl.getSharedfiles();
                    },
                    function(error) {
                        RestAPIService.showErrorDialog(error);
                    }
                );
                $mdDialog.hide(file);
            };
        }

        sharedCtrl.deleteFile = function(ev, file) {
            var fileId = sharedCtrl.receivedFile.id;
            var siteId = sharedCtrl.receivedFile.siteId;
            var confirm = $mdDialog.confirm()
                .title('Remove')
                .textContent('File ' + sharedCtrl.receivedFile.name + ' will be permanently deleted. Continue ?')
                .targetEvent(ev)
                .ok('Ok')
                .cancel('Cancel');
            $mdDialog.show(confirm).then(function() {
                RestAPIService.deleteFile(siteId, fileId).then(
                    function(success) {
                        RestAPIService.successTostDialog("File deleted successfully");
                        $scope.file = {};
                        sharedCtrl.fileAttributes = {};
                        $scope.detailsVisibility = false;
                        sharedCtrl.getSharedfiles();
                    },
                    function(error) {
                        RestAPIService.showErrorDialog(error);
                    }
                );
            }, function() {
                $mdDialog.cancel();
            });
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.settings', [] )
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider, $mdThemingProvider)
    {
    	 $stateProvider
            
            .state('app.settings', {
                url: '/settings',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/settings/settings.html',
                        controller: 'SettingsController as setCtrl'
                    }
                }
            });
           /* .state('app.lists', {
                url: '/settings',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/pages/errors/404/error-404.html',
                        controller: 'Error404Controller as cf'
                    }
                }
            })
            .state('app.workflow', {
                url: '/settings',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/pages/errors/404/error-404.html',
                        controller: 'Error404Controller as cf'
                    }
                }
            });*/

       /* msNavigationServiceProvider.saveItem('admin.settings', {
            title : 'Settings',
            icon  : 'icon-cog',
            state : 'app.settings',
            weight:5
        });*/

 
              }
})();


(function ()
{
    'use strict';

    angular
        .module('app.settings')
        .controller('SettingsController', SettingsController);

    /** @ngInject */
    function SettingsController($state)
    {
        var settingCtrl = this;
        
        }   
})();
(function ()
{
    'use strict';

    angular
        .module('app.reports', [] )
        .config(config)
        .run(run);
    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider, $mdThemingProvider)
    {
    	 $stateProvider
            
            .state('app.reports', {
                url: '/reports',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/reports/reports.html',
                        controller:  'ReportsController as reportCtrl'
                    }
                }
            });

    //  msNavigationServiceProvider.saveItem('reports', {
    //         title : 'Reports',
    //         icon  : 'icon-file-document',
    //         state : 'app.reports',
    //         weight: 5,
    //         hidden: function() {             
    //             if ($rootScope.currentLogedInUser != undefined) {
    //                 var roles = $rootScope.currentLogedInUser.authorities;
    //                 return !(roles.indexOf("ROLE_ADMIN") > -1);
    //             }
    //             }
    //     });

    }
    function run(msNavigationService, $localStorage, $rootScope, $state) {
        msNavigationService.saveItem('reports', {
            title : 'Reports',
            icon  : 'icon-file-document',
            state : 'app.reports',
            weight: 5,
        hidden:function(){
            if ($localStorage.menubarsetting != undefined) {
              var show = $localStorage.menubarsetting.reports;
              return !(show);
                 }
            }
        });
    }
})();


(function ()
{
    'use strict';

    angular
        .module('app.reports')
        .controller('ReportsController', ReportsController);

    /** @ngInject */
    function ReportsController($state, $scope, RestAPIService, $filter, $mdDialog, $sce)
    {
        var reprtCtrl = this;
        $scope.viewPage = 0;
        $scope.doctypefields = [];
        $scope.filterarr = {};
        $scope.filterout = [];
        $scope.filterdlength = 0;
        $scope.currentReport = {};
        $scope.allDocuments = [];
        reprtCtrl.currentDocument = {};

        $scope.getAnotherColor = function(index) {
            $scope.colors = ['red', 'pink', 'purple', 'deep-purple', 'indigo', 'blue', 'light-blue', 'cyan', 'teal', 'green',
                'light-green', 'lime', 'yellow', 'amber', 'deep-orange', 'brown', 'grey', 'blue-grey'
            ];
            var totalNoOfColors = $scope.colors.length;
            return $scope.colors[index % totalNoOfColors];
        }

        $scope.dtOptions = {
            dom: '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            pagingType: 'simple',
            autoWidth: false,
            responsive: true,
        }

        function resetFields() {
            $scope.querylogic = {};
            $scope.outerquery = {};
            $scope.innerquery = {};
            $scope.compdate = [];
            $scope.datearr = {};
            $scope.innerdate = {};
            $scope.datearr1 = {};
            $scope.innerdate1 = {};
            $scope.todate = [];
            $scope.fromdate = [];
        }

        $scope.getValues = function(data, output) {
            var result = null;
            angular.forEach(data, function(value, key) {
                if (output == key) {
                    result = value;
                }
            });
            return result;
        }
 
        $scope.UpdateMode = function(selecteditem, filterval) {
            $scope.comfilterdata = [];
            $scope.filterarr[selecteditem] = filterval;
            $scope.comfilterdata.push($scope.filterarr);
            $scope.filterdlength = Object.keys($scope.filterarr).length;
        }
        
        
        $scope.applyfilter = function() {
        	var tempData = angular.copy($scope.tempData);
            $scope.allDocuments = [];
            angular.forEach($scope.filterarr, function(value, key) {
                var filterExpression = {};
                filterExpression[key] = value;
                $scope.result = $filter('filter')(tempData, filterExpression);
            });
            $scope.allDocuments = $scope.result;
        }

        $scope.goBack = function(pageNo) {
            resetFields();
            $scope.viewPage = pageNo;
        }

        $scope.goToPreviousState = function() {
            $state.go("app.overview");
            $("#vertical-navigation").show();
            $("#content-container").css({
                "margin-left": "0px"
            });
        }

        $scope.viewSelection = function(type, data) {
            reprtCtrl.currentDocument = data;
            if (type == 'requestId') {
                $scope.viewPage = 4;
                RestAPIService.getInboxWorkitemInfo(reprtCtrl.currentDocument.requestType, reprtCtrl.currentDocument.requestId).then(function(responce) {
                    viewForm(responce.data);
                    $scope.requestDetails = responce.data;
                    console.log("responce : ", responce)

                }, function(error) {
                    RestAPIService.showErrorDialog(error);
                });


            } else if (type == 'id') {
                $scope.viewPage = 3;
                RestAPIService.getFileById(data.siteId, data.id).then(
                    function(success) {
                        $scope.fileDetails = success.data;
                        console.log("$scope.fileDetails : ", $scope.fileDetails)
                    },
                    function(error) {});

            }
        }

        function viewForm(data) {
            $scope.currentFormHeader = $sce.trustAsHtml(data.mainLayout.replace(/&quot;/g, '"'));
            $scope.currentFormLineitem = $sce.trustAsHtml(data.detailsLayout.replace(/&quot;/g, '"'));
        }

        $scope.getDummyFileIcon = function(index) {
            reprtCtrl.icons = ['icon-file-pdf-box'];
            var totalNoOfIcons = reprtCtrl.icons.length;
            return reprtCtrl.icons[index % totalNoOfIcons];
        }

        $scope.setAttachmentFile = function(element) {
            var formData = new FormData();
            $scope.$apply(function() {
                for (var i = 0; i < element.files.length; i++) {
                    formData.append('file', element.files[i]);
                    $scope.attachmentfiles.push(element.files[i]);
                }
            });
        };

        $scope.preview = function(ev, file, reqId) {
            reprtCtrl.file = file;
            reprtCtrl.reqId = reqId;
            $mdDialog.show({
                controller: PDialogController,
                templateUrl: 'app/main/mycontent/inbox/previewFiles.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true
            });
        }

        function PDialogController($scope, $mdDialog, $sce, $sessionStorage) {
            $scope.fileVis = false;
            $scope.imgVis = false;
            $scope.cancel = function() {
                $mdDialog.cancel();
            };
            var jwtToken = $sessionStorage.currentUser.token.trim();
            if (jwtToken != undefined && reprtCtrl.reqId != undefined) {
                var encodedURI = encodeURIComponent(reprtCtrl.file.url);
                if (reprtCtrl.file.fileType == "jpg" || reprtCtrl.file.fileType == "JPG" || reprtCtrl.file.fileType == "jpeg" || reprtCtrl.file.fileType == "JPEG" || reprtCtrl.file.fileType == "PNG" || reprtCtrl.file.fileType == "png") {
                    $scope.imgVis = true;
                    $scope.fileURL = reprtCtrl.file.url;
                } else {
                    $scope.fileVis = true;
                    $scope.fileURL = $sce.trustAsResourceUrl('https://docs.google.com/gview?url=' + encodedURI + '&embedded=true');
                }
            }
        }

        $scope.previewFile = function(ev) {
            $mdDialog.show({
                controller: DialogController,
                templateUrl: 'app/main/sites/site/doclibrary/previewFiles.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true
            });
        }

        function DialogController($scope, $mdDialog, $sce, $sessionStorage) {
            var jwtToken = $sessionStorage.currentUser.token.trim();
            if (jwtToken != undefined && reprtCtrl.currentDocument != undefined) {
                var encodedURI = encodeURIComponent(baseUrl + '/api/sites/' + reprtCtrl.currentDocument.siteId + '/files/file?fileId=' + reprtCtrl.currentDocument.id + '&attachment=false&jwtToken=' + jwtToken);
                $scope.fileURL = $sce.trustAsResourceUrl('https://docs.google.com/gview?url=' + encodedURI + '&embedded=true');
            }
        }

        $scope.executecriteria = function(doctypedata, collectionname) {
            $scope.viewPage = 2;
            for (var i = 0; i <= $scope.currentReport.doctypefield.length - 1; i++) {
                if ($scope.currentReport.doctypefield[i].type == "String") {
                    if ($scope.currentReport.doctypefield[i].data != null && $scope.currentReport.doctypefield[i].data != undefined) {
                        var keydata = $scope.currentReport.doctypefield[i].fieldname;
                        var value = $scope.currentReport.doctypefield[i].data.value;
                        $scope.innerquery[keydata] = value;
                    }
                }
                if ($scope.currentReport.doctypefield[i].type == "Date") {
                    if ($scope.currentReport.doctypefield[i].data != null && $scope.currentReport.doctypefield[i].data != undefined) {
                        var keydata = $scope.currentReport.doctypefield[i].fieldname;
                        if ($scope.currentReport.doctypefield[i].data.fromdate != null) {
                            var d = new Date($scope.currentReport.doctypefield[i].data.fromdate);
                            var n = $filter('date')(new Date($scope.currentReport.doctypefield[i].data.fromdate), 'yyyy-MM-ddTHH:mm:ss');

                            $scope.innerdate = {
                                "$date": n + "Z"
                            };
                            $scope.datearr = {
                                "$gt": $scope.innerdate
                            }
                            // $scope.fromdate = {
                            //     [keydata]: $scope.datearr
                            // };
                        }
                        if ($scope.currentReport.doctypefield[i].data.todate != null) {
                            var d = new Date($scope.currentReport.doctypefield[i].data.todate);
                            var n = $filter('date')(new Date($scope.currentReport.doctypefield[i].data.todate), 'yyyy-MM-ddTHH:mm:ss');
                            $scope.innerdate1 = {
                                "$date": n + "Z"
                            }
                            $scope.datearr1 = {
                                "$lt": $scope.innerdate1
                            }
                            // $scope.todate = {
                            //     [keydata]: $scope.datearr1
                            // };
                        }
                        $scope.compdate.push($scope.fromdate);
                        $scope.compdate.push($scope.todate);
                        if ($scope.innerquery.length > 0) {
                            $scope.innerquery["$and"] = $scope.compdate;
                        } else {
                            $scope.innerquery = $scope.compdate;
                        }

                    }
                }
            }

            if (undefined != $scope.currentReport.selectionfield) {
                for (var i = 0; i <= $scope.currentReport.selectionfield.length - 1; i++) {
                    if ($scope.currentReport.selectionfield[i].type == "string") {
                        if ($scope.currentReport.selectionfield[i].data != null && $scope.currentReport.selectionfield[i].data != undefined) {
                            var keydata = $scope.currentReport.selectionfield[i].fieldname;
                            var value = $scope.currentReport.selectionfield[i].data.value;
                            $scope.querylogic[keydata] = value;
                        }
                    }
                    if ($scope.currentReport.selectionfield[i].type == "Date") {
                        if ($scope.currentReport.selectionfield[i].data != null && $scope.currentReport.selectionfield[i].data != undefined) {
                            var keydata = $scope.currentReport.selectionfield[i].fieldname;
                            if ($scope.currentReport.selectionfield[i].data.fromdate != null) {
                                var d = new Date($scope.currentReport.selectionfield[i].data.fromdate);
                                var n = $filter('date')(new Date($scope.currentReport.selectionfield[i].data.fromdate), 'yyyy-MM-ddTHH:mm:ss');

                                $scope.innerdate = {
                                    "$date": n + "Z"
                                };
                                $scope.datearr = {
                                    "$gt": $scope.innerdate
                                }
                                // $scope.fromdate = {
                                //     [keydata]: $scope.datearr
                                // };
                            }
                            if ($scope.currentReport.selectionfield[i].data.todate != null) {
                                var d = new Date($scope.currentReport.selectionfield[i].data.todate);
                                var n = $filter('date')(new Date($scope.currentReport.selectionfield[i].data.todate), 'yyyy-MM-ddTHH:mm:ss');
                                $scope.innerdate1 = {
                                    "$date": n + "Z"
                                }
                                $scope.datearr1 = {
                                    "$lt": $scope.innerdate1
                                }
                                // $scope.todate = {
                                //     [keydata]: $scope.datearr1
                                // };
                            }
                            $scope.compdate.push(fromdate);
                            $scope.compdate.push(todate);
                            $scope.querylogic["$and"] = compdate;
                        }
                    }
                }
            }
            if (Object.keys($scope.innerquery).length > 0 && $scope.innerquery != null && $scope.innerquery != undefined) {
                $scope.querylogic["attributes"] = $scope.innerquery;
            }
            resetFields();
            $scope.allDocuments = [];
            var myJSON = JSON.stringify($scope.querylogic);
            if (collectionname == 'documents') {
                RestAPIService.getdocumentbyquery(myJSON).then(function(response) {
                    $scope.allDocuments = response.data;
                    $scope.tempData = response.data;
                    $scope.allFilteredData = {};
                    angular.forEach($scope.currentReport.filterfield, function(value, key) {
                        var datafilter = [];
                        var j = 0;
                        for (var i = 0; i <= $scope.allDocuments.length - 1; i++) {
                            if ($.inArray(($scope.allDocuments[i][value.fieldname]), datafilter) === -1) {
                                if ($scope.allDocuments[i][value.fieldname] != null && $scope.allDocuments[i][value.fieldname] != undefined) {
                                    datafilter[j] = $scope.allDocuments[i][value.fieldname];
                                    j = j + 1;
                                    $scope.allFilteredData[value.fieldname] = datafilter;
                                }
                            }
                        }
                        $scope.allFilteredDataLength = Object.keys($scope.allFilteredData).length;
                    });
                }, function(error) {
                    RestAPIService.showErrorDialog(error);
                });
            } else if (collectionname == 'request') {
                RestAPIService.getrequestbyquery(myJSON).then(function(response) {
                    $scope.allDocuments = response.data;
                }, function(error) {
                    RestAPIService.showErrorDialog(error);
                });
            }
        }

        $scope.goToReport = function(report) {
            $scope.viewPage = 1;
            $scope.currentReport = report;
        }

        $scope.getReportData = function() {
            RestAPIService.getreportdata().then(function(response) {
                    $scope.allReports = [];
                    $scope.allReports = response.data;
                },
                function(error) {
                    RestAPIService.showErrorDialog(error);
                });
        }

        // 
        init();

        function init() {
            resetFields();
            $scope.getReportData();
        }


    
    }


         
})();
(function ()
{
    'use strict';

    angular
        .module('app.profile')
        .controller('ProfileController', ProfileController);
        

    /** @ngInject */
    function ProfileController($scope,$state, $location,$rootScope,$localStorage,RestAPIService,$mdDialog)
    {
        var profileCtrl = this;
        var json = $localStorage.logedInuserdetail;
        
        $scope.currentLogedInUser = json['currentLogedInUser'];
        $scope.loggedInUserName = json['loggedInUserName'];
        var LoggedInUserName = $scope.loggedInUserName;
        
       /* $scope.UserDetails = function() {
            RestAPIService.UserDetails($localStorage.currentUser.username).then(
                function(success) {
                    $rootScope.currentLogedInUser = success.data;
                    $rootScope.loggedInUserName = success.data.firstName + ' ' + success.data.lastName;
                    LoggedInUserName = $scope.loggedInUserName;
                    console.log($rootScope.currentLogedInUser);
                },
                function(error) {
                    RestAPIService.showErrorDialog(error);
                });
        }*/
//        $scope.editprofile =function(ev,user){
//        	profileCtrl.currentUser = angular.copy(user);
//            $mdDialog.show({
//                controller: UpdateUserDialogController,
//                templateUrl: 'app/main/profile/edit.profile.dialog.html',
//                parent: angular.element(document.body),
//                targetEvent: ev,
//                clickOutsideToClose: true,
//                fullscreen: $scope.customFullscreen
//            })
//        }

//        function UpdateUserDialogController($scope, $mdDialog) {
//        	 $scope.currentUser = profileCtrl.currentUser;
//        	 $scope.roles = ["ROLE_USER", "ROLE_ADMIN"];
//        	 $scope.status = ["true", "false"];
//        	 $scope.currencyFormats = ["Dot(.)" , "Comma(,)"];
//             $scope.dateFormats = ["YYYY-MM-DD", "DD.MM.YYYY", "YYYYMMDD", "DD-MM-YYYY", "MM-DD-YYYY", "MM/DD/YYYY"];
//             $scope.currency= ["INR", "USD", "GBP", "EUR"];
//             $scope.languages= ["English", "German", "French", "Spanish", "Hindi"];
//             $scope.timeZones= ["BRT(Brasilia Time)", "CST(China Standard Time)", "ART(Argentina Time)", "BTT(Bhutan Time)", "CT(China Time)","IST(Indian Standard Time)"];
//        	 
//        	 $scope.updateUserProfile = function(user) {
//               RestAPIService.updateUserProfile(user).then(
//                   function(success) {
//                   	RestAPIService.successTostDialog("Profile updated successfully");
//                   
//                       $mdDialog.hide(user);
//                       $state.reload();
//                   },
//                   function(error) {
//                       RestAPIService.showErrorDialog(error);
//                   });
//           }
//          
//            $scope.hide = function() {
//                $mdDialog.hide();
//            };
//            $scope.cancel = function() {
//                $mdDialog.cancel();
//            };
//           
//        }
        
    	
        $scope.loadPage = "about";
        $scope.loadAbout = function() {        	
            $scope.loadPage = 'about';
        }
        $scope.loadSubstitution = function() {
            $scope.loadPage = 'substitution';

        }
       
        
    }


         
})();
(function ()
{
    'use strict';

    angular
        .module('app.mtrInbox', [] )
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider, $mdThemingProvider)
    {
    	 $stateProvider

            .state('app.mtrInbox', {
                url: '/CustomInbox',
                params: {
                    requestType: null,
                    displayName:null
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/main/mtr_Inbox/mtrInbox.html',
                        controller:  'MtrInboxController as MtrCtrl'
                    }
                }
            });


    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.mtrInbox')
        .controller('MtrInboxController', MtrInboxController);

    /** @ngInject */
    function MtrInboxController($state, $scope,$stateParams,$localStorage, RestAPIService, $filter, $mdDialog,$window, $sce)
    {
        var MtrCtrl = this;
        $scope.workitem={};
        MtrCtrl.selectItems=[];
        MtrCtrl.dtOptions = {
          dom       : '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
         pagingType: 'simple',
         autoWidth : false,
        order:[1,"desc"],
         responsive: true
        };
        //checkbox//
     //   $scope.allWorkitems = [1,2,3,4,5];
     MtrCtrl.getAllListData=function(){
      RestAPIService.getmtrlistitems($localStorage.requestType,$scope.pageNumber, $scope.size).then(
        function(success) {
          $scope.allWorkitems = success.data;
          $scope.items =success.data;
         console.log($scope.allWorkitems)
         }, function(error) {
          RestAPIService.showErrorDialog(error);
      });
      RestAPIService.getInboxConfgData().then(
          function(success) {
              $scope.usersList = success.data;
             },
          function(error) {
              RestAPIService.showErrorDialog(error);
          }
      );
  }
 
  RestAPIService.getUsers(0,500).then(
    function(success){
      MtrCtrl.users =success.data; 
    },
    function(error){

    }); 
  $scope.selected = [];
  $scope.toggle = function (workitem, list) {
    var idx = list.indexOf(workitem);
    if (idx > -1) {
      list.splice(idx, 1);
    }
    else {
      list.push(workitem);
    }
    MtrCtrl.selectItems =  list;
  };

  $scope.exists = function (workitem, list) {
    return list.indexOf(workitem) > -1;
  };

  $scope.isIndeterminate = function() {
    return ($scope.selected.length !== 0 &&
        $scope.selected.length !== $scope.allWorkitems.length);
  };


  $scope.isChecked = function() {
    if($scope.allWorkitems ==undefined) $scope.allWorkitems = [];
    return $scope.selected.length === $scope.allWorkitems.length;

  };


  $scope.toggleAll = function() {
    if ($scope.selected.length === $scope.allWorkitems.length) {
      $scope.selected = [];
    } else if ($scope.selected.length === 0 || $scope.selected.length > 0) {
      $scope.selected = $scope.allWorkitems.slice(0);
      MtrCtrl.selectItems =  $scope.selected;
    }
  }
  
  if($stateParams.requestType) $localStorage.requestType =$stateParams.requestType;     
      $scope.trustSrc = function(src) {
        $scope.previewUrl = $sce.trustAsResourceUrl(src);
      }
      $scope.globalworkitems= [ {
        "id" : "5b0c3e117b5ed000f839a966",
        "actvity" : "510",
        "description" : "Approve",
        "buttonText" : "Approve",
        "url" : "/sap",
        "type" : "SAP",
        "commentsRequired" : true
      }, {
        "id" : "5b0c3e6b7b5ed000f839a967",
        "actvity" : "511",
        "description" : "Reject",
        "buttonText" : "Reject",
        "url" : "/sap",
        "type" : "SAP",
        "commentsRequired" : true
      }]
       $scope.previewFile =function(ev,workItem){
        var datares = $filter('filter')( $scope.allWorkitems, {
          'requestId': ev.id
        });
        workItem =datares[0];
          MtrCtrl.allAttachments =workItem.attachments;
          $mdDialog.show({
            controller : DialogController,
            templateUrl : 'app/main/mtr_Inbox/previewFiles.html',
            parent : angular.element(document.body),
           targetEvent : ev,
            clickOutsideToClose : true
        });

      }
      function DialogController($scope, $mdDialog, $sce, $sessionStorage) {
          $scope.allAttachments =MtrCtrl.allAttachments;
          $scope.previewUrl=  $sce.trustAsResourceUrl($scope.allAttachments[0].url)
          $scope.trustSrc = function(src) {
            $scope.previewUrl = $sce.trustAsResourceUrl(src);
          }
          $scope.selectFile = function(fileData){
               $scope.trustSrc(fileData.url);
            }
            $scope.cancel = function() {
              $mdDialog.cancel();
          };

        }
        $scope.viewlogs =function(ev,currentWorkItem){
          var datares = $filter('filter')( $scope.allWorkitems, {
            'requestId': ev.id
          });
          currentWorkItem =datares[0];
          MtrCtrl.workItem =currentWorkItem;
          $mdDialog.show({
            controllerAs: 'logsDialogCtrl',
            controller: logsDialogCtrl,
            preserveScope: true,
            autoWrap: true,
            templateUrl: 'app/main/mtr_Inbox/logs.html'
        });
        }
        function logsDialogCtrl($scope, RestAPIService, $mdDialog) {
          $scope.CurrentWorkItem = MtrCtrl.workItem;
          $scope.CurrentWorkItem.logs.forEach(function(h) {
            if (h.activityText == "Initiated" || h.actvity == '001') {
                h['icon'] = "icon-star-outline";
            }else if (h.activityText == "Confirm") {
                h['icon'] = "icon-check";
            }else if (h.activityText == "Approve") {
                h['icon'] = "icon-check";

            }
            else if(h.activityText =="Collaborate" ||  h.activity == '110'){
              h['icon'] ="icon-content-save";
            }
            else if(h.activityText =="CollaborateBack" ||  h.activity == '111'){
              h['icon'] ="icon-content-save";
            }else if (h.activityText == "Reject") {
                h['icon'] = "icon-cancel";
            }else if (h.activityText != "Initiated" && h.activityText != "Confirm" && h.activityText != "Approve" && h.activityText != "Reject") {
                h['icon'] = "icon-content-save";
            }
        })

          $scope.cancel = function() {
            $mdDialog.cancel();
        };
        }      
        $scope.gotomtrDetail=function(workitem){
          $scope.workitem=workitem;
          if(workitem.attachments.length == 0){
             return;
          }
          $scope.primaryAttachmentsData=[]
           for(var i=0;i<workitem.attachments.length;i++){
     if(workitem.attachments[i].primaryDocumnet=="X"){
       $scope.primaryAttachmentsData.push(workitem.attachments[i])
     }
   }
         //  $scope.attachment =workitem.attachments[0]
          $scope.trustSrc($scope.primaryAttachmentsData[0].url);
      }
          
           resetRequest();
           function resetRequest() {
               $scope.header = {};
               $scope.lineItems = [ ];
               $scope.formHeader = false;
               $scope.formLineitem = false;
               MtrCtrl.inboxComment = {};
               $scope.isReadOnlyHeaderCurrency = false;
               $scope.workitemInfo = {};
               $scope.attachmentfiles = [];
           }

           $scope.processActvity = function(ev,actvity,workitem ) {
             if(workitem !='bulk'){
            var datares = $filter('filter')( $scope.allWorkitems, {
              'requestId': ev.id
            });
            actvity = JSON.parse(ev.name);
           workitem =datares[0];
          }
            MtrCtrl.newAttachments = $scope.attachmentfiles;
            MtrCtrl.actvity = actvity;
            if(workitem != "bulk"){
              MtrCtrl.requestType= workitem.requestType;
              MtrCtrl.requestId =workitem.requestId;
              MtrCtrl.selectItems =[];
              MtrCtrl.selectItems.push(workitem);
             }
             else {
              MtrCtrl.requestType=  MtrCtrl.selectItems[0].requestType;
              MtrCtrl.requestId ="Bulk WorkItems";
             }
            $mdDialog.show({
                controller : ProcessController,
                templateUrl : 'app/main/mycontent/inbox/add.comment.html',
                parent : angular.element(document.body),
                targetEvent : ev,
                clickOutsideToClose : true,
                fullscreen : $scope.customFullscreen
            });
        }

        function ProcessController($scope, $mdDialog,$rootScope ) {
            $scope.popupHeading = MtrCtrl.actvity.buttonText;
            $scope.count = 1;
            $scope.process = function(ev, comment) {
                $mdDialog.cancel();
                $rootScope.inboxButtons = true;
                MtrCtrl.finalArray=[];
                delete MtrCtrl.actvity.$$hashKey;
                

                angular.forEach(MtrCtrl.selectItems,function(workItem){
                  var json={
                    activities:[]
                  }                
                    json.comment =comment;
                    json.activities.push(MtrCtrl.actvity);
                    json.requestId =workItem.requestId;
                    json.header =workItem.header;
                    json.lineItems =workItem.lineItems;
                    MtrCtrl.finalArray.push(json)
                   })               
                   if($scope.count == 1){
                    $scope.count = $scope.count+1;
                    RestAPIService.submitBulkRequestResource({'requestDetailsList':MtrCtrl.finalArray},MtrCtrl.requestType, $scope.allAttachments).then(
                      function(success) {
                          if (success.status == 200) {
                            resetRequest();
                            MtrCtrl.selectItems=[];
                            MtrCtrl.finalArray=[];
                              if (MtrCtrl.actvity.buttonText == "Approve") {
                                  $mdDialog.show($mdDialog
                                           .alert()
                                           .parent(angular.element(document.querySelector('#popupContainer')))
                                           .clickOutsideToClose(true)
                                           .title('Success.')
                                           .htmlContent("<h4><b>"+ MtrCtrl.requestId+ "</b> was Approved successfully.</h4>")
                                           .ariaLabel('Alert Dialog Demo')
                                           .ok('Ok'));
                                  $state.reload();
                              } else {
                                  $mdDialog.show($mdDialog
                                           .alert()
                                           .parent(angular.element(document.querySelector('#popupContainer')))
                                           .clickOutsideToClose(true)
                                           .title('Success.')
                                           .htmlContent("<h4><b>"+ MtrCtrl.requestId+ "</b> was Rejected successfully.</h4>")
                                          .ariaLabel('Alert Dialog Demo')
                                          .ok('Ok'));
                                  $state.reload();
                              }
                          }
                      }, function(error) {
                          RestAPIService.showErrorDialog(error);
                          MtrCtrl.finalArray=[];
                          MtrCtrl.selectItems=[];
                      });
                  
                  
                  }
               
            }
            $scope.hide = function() {
                $mdDialog.hide();

            };

            $scope.cancel = function() {
                $mdDialog.cancel();

            };

        }
        $scope.Collaborate =function(ev,activity){
          //  var datares = $filter('filter')( $scope.allWorkitems, {
          //     'requestId': ev.id
          //   });
          MtrCtrl.selectedWorkitemInfo= JSON.parse(ev.value);
              MtrCtrl.attachmentfiles = $scope.attachmentfiles;
             MtrCtrl.CollaborateActivity = JSON.parse(ev.name);
          $mdDialog.show({
              controllerAs: 'CollaborateCtrl',
              controller: CollaborateCtrl,
              preserveScope: true,
              autoWrap: true,
              templateUrl: 'app/main/mtr_Inbox/mtrCollaborate.html',
              parent: angular.element(document.body),
             targetEvent: ev,
           clickOutsideToClose: true,
      fullscreen: $scope.customFullscreen
          });

          function CollaborateCtrl($scope, RestAPIService, $mdDialog) {
              $scope.users =MtrCtrl.users;
              $scope.sampleheader ={};  
              $scope.count = 1;    
              $scope.collaborateActivity =function(ev,user, comment){
                var select = false;
                if($scope.sampleheader.person) {
                  var user =$scope.sampleheader.person;
                  $scope.users.forEach(function(elm) {
                    if(elm.login === $scope.sampleheader.person) {
                      select = true;
                    }
                  })
                }
                if(!select ){
                  $scope.errormsg="Please Select the user from Dropdown"
                  return;
                }
                // if($scope.sampleheader.person) var user =$scope.sampleheader.person;   
                  var workItem = MtrCtrl.selectedWorkitemInfo;
                var requestId = workItem.requestId;
                if(!$scope.sampleheader.person){
                    var user =$scope.name;
                    MtrCtrl.CollaborateActivity.actvity ="550"
                }
                  var activity = MtrCtrl.CollaborateActivity;
                // delete activity.$$hashKey;
                var json = {
                            activities: []
                          };
                        json.comment = comment;
                        json.activities.push(activity);
                        json.header = workItem.header;
                        json.lineItems = workItem.lineItems;
                        var form = new FormData();
                       $scope.newAttachments =  workItem.attachments;
                       if($scope.count == 1){
                      $scope.count = $scope.count+1;
                      RestAPIService.sendCollaboration(requestId,workItem.requestType,user,json,form).then(
                        function(response){
                              $mdDialog.show(
                                  $mdDialog.alert()
                                    .parent(angular.element(document.querySelector('#popupContainer')))
                                    .clickOutsideToClose(true)
                                    .title('Success.')
                                    .htmlContent("<h4>Collaboration sent successfully for <b>"+workItem.requestId+"</b>.</h4>")
                                    .ariaLabel('Alert Dialog Demo')
                                    .ok('Ok'));
                                  
                                    $state.reload();
                        },function(error){
                            RestAPIService.showErrorDialog(error);
                        });
                      }
                      }

              $scope.cancel=function(){
                  $mdDialog.cancel();
              }


          }
        }

        $scope.collaborateBack= function(ev,activity){
          
          MtrCtrl.selectedWorkitemInfo= JSON.parse(ev.value);
          MtrCtrl.attachmentfiles = $scope.attachmentfiles;
         MtrCtrl.CollaborateActivity = JSON.parse(ev.name);
          $mdDialog.show({
              controller: CollaborateBackDialogController,
              templateUrl: 'app/main/mycontent/inbox/collaborateBackDialog.html',
              parent: angular.element(document.body),
              targetEvent: ev,
              clickOutsideToClose: true,
              fullscreen: $scope.customFullscreen
          });
          }
          function CollaborateBackDialogController($scope, $mdDialog, RestAPIService){
          $scope.cancel = function() {
              $mdDialog.cancel();
          };
          $scope.count = 1;  
          $scope.collaborateBackComment = function(ev, comment){
              var workItem = MtrCtrl.selectedWorkitemInfo;
              var requestId = workItem.requestId;     
              var actvity =  MtrCtrl.CollaborateActivity;
              delete actvity.$$hashKey;
                var json = {
                      activities: []
                  };
              json.comment = comment;
              json.activities.push(actvity);
              json.header = workItem.header;
              json.lineItems = workItem.lineItems;
              var form = new FormData();
              if(!MtrCtrl .attachmentfiles) MtrCtrl.attachmentfiles =[];
              $scope.newAttachments =  workItem.attachments;
                var user = null;
                if($scope.count == 1){
                  $scope.count = $scope.count+1;
                  RestAPIService.sendCollaboration(requestId,workItem.requestType,user,json,form).then(
                    function(response){

                        $mdDialog.show(
                                  $mdDialog.alert()
                                    .parent(angular.element(document.querySelector('#popupContainer')))
                                    .clickOutsideToClose(true)
                                    .title('Success.')
                                    .htmlContent("<h4>Collaboration back is successfull for <b>"+workItem.requestId+"</b>.</h4>")
                                    .ariaLabel('Alert Dialog Demo')
                                    .ok('Ok'));
                                   
                                    $state.reload();
                       
                    },function(error){
                        RestAPIService.showErrorDialog(error);
                    });
                }
             
                  $mdDialog.cancel();

          }}

    }





})();

(function ()
{
    'use strict';

    angular
        .module('login',[])
        .config(config);

    /** @ngInject */
    function config(){}
    
})();
(function() {
    'use strict';


    angular
        .module('login')
        .controller('LoginController', LoginController);
        function LoginController($scope, $rootScope,$http,$localStorage,  $mdDialog,Idle, $location,$timeout,$cookies,$cookieStore,$sessionStorage, $state, AuthenticationService,RestAPIService) {
            var vm = this;
            vm.login=login;
            $scope.visibility = true;
           
            $scope.forgotPasswordPage = false;
            if($localStorage.menubarsetting){
              if($localStorage.menubarsetting.googleLogin) $scope.googleLogin=true;
             }
            // else  $scope.loginId="text";
            $scope.forgotPassword = function(){
               $scope.forgotPasswordPage = !$scope.forgotPasswordPage;
            }
            $scope.goToLoginPage = function(){
                $scope.forgotPasswordPage = !$scope.forgotPasswordPage;
            }
            $scope.loginwithgoogle =function(){
              var token = $cookies.get('social-authentication');
              $cookies.remove('social-authentication');
              delete $sessionStorage.currentUser;
                delete $localStorage.currentUser;
                delete  $localStorage.logedInuserdetail;
               if(token !=undefined || token !=null){
                 AuthenticationService.loginwithToken(token, function (result) {
                       if (result.success === true) {
                         RestAPIService.UserDetails().then(
                                       function(success) {
                                          var json = {
                                                 "currentLogedInUser" : success.data,
                                                 "loggedInUserName" : success.data.firstName + ' ' + success.data.lastName
                                                 }
                                          $localStorage.logedInuserdetail =json;
                                       },
                                       function(error) {
                                           RestAPIService.showErrorDialog(error);
                                       });
                             $location.path('/inbox');
                         } else {
                           alert("Error");
                         }
                    });
                 }
             }
             var Base64={_keyStr:"ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",encode:function(e){var t="";var n,r,i,s,o,u,a;var f=0;e=Base64._utf8_encode(e);while(f<e.length){n=e.charCodeAt(f++);r=e.charCodeAt(f++);i=e.charCodeAt(f++);s=n>>2;o=(n&3)<<4|r>>4;u=(r&15)<<2|i>>6;a=i&63;if(isNaN(r)){u=a=64}else if(isNaN(i)){a=64}t=t+this._keyStr.charAt(s)+this._keyStr.charAt(o)+this._keyStr.charAt(u)+this._keyStr.charAt(a)}return t},decode:function(e){var t="";var n,r,i;var s,o,u,a;var f=0;e=e.replace(/[^A-Za-z0-9\+\/\=]/g,"");while(f<e.length){s=this._keyStr.indexOf(e.charAt(f++));o=this._keyStr.indexOf(e.charAt(f++));u=this._keyStr.indexOf(e.charAt(f++));a=this._keyStr.indexOf(e.charAt(f++));n=s<<2|o>>4;r=(o&15)<<4|u>>2;i=(u&3)<<6|a;t=t+String.fromCharCode(n);if(u!=64){t=t+String.fromCharCode(r)}if(a!=64){t=t+String.fromCharCode(i)}}t=Base64._utf8_decode(t);return t},_utf8_encode:function(e){e=e.replace(/\r\n/g,"\n");var t="";for(var n=0;n<e.length;n++){var r=e.charCodeAt(n);if(r<128){t+=String.fromCharCode(r)}else if(r>127&&r<2048){t+=String.fromCharCode(r>>6|192);t+=String.fromCharCode(r&63|128)}else{t+=String.fromCharCode(r>>12|224);t+=String.fromCharCode(r>>6&63|128);t+=String.fromCharCode(r&63|128)}}return t},_utf8_decode:function(e){var t="";var n=0;var r=c1=c2=0;while(n<e.length){r=e.charCodeAt(n);if(r<128){t+=String.fromCharCode(r);n++}else if(r>191&&r<224){c2=e.charCodeAt(n+1);t+=String.fromCharCode((r&31)<<6|c2&63);n+=2}else{c2=e.charCodeAt(n+1);c3=e.charCodeAt(n+2);t+=String.fromCharCode((r&15)<<12|(c2&63)<<6|c3&63);n+=3}}return t}}
            function login(userData){
               if(navigator.onLine == false){
                $mdDialog.show(
                  $mdDialog.alert()
                  .parent(angular.element(document .querySelector('#popupContainer')))
                  .clickOutsideToClose(true)
                  .title('Warning')
                  .htmlContent("<h4><b> Login is failed due to weak/No Internet connection.</b></h4>")
                  .ariaLabel('Alert Dialog Demo')
                  .ok('Ok')
                    );
                  $mdDialog.cancel();
              
                return;
              }
              var key='symentric@123$';
                var id=userData.userid;
                var pwd=CryptoJS.AES.encrypt(userData.password,key).toString();
                vm.loginForm.$setPristine();
                vm.loginForm.$setUntouched();
                AuthenticationService.Login(id, pwd, function (result) {
                    if (result.success === true) {
                      RestAPIService.getSystemsettings().then(
                        function (success){
                           $scope.SystemSettingsData =success.data;
                           delete $localStorage.menubarsetting;
                            $localStorage.menubarsetting =success.data[0].activeMenu;
                            $localStorage.viewer =success.data[0].viewer;
                        },
                        function(error){ })
                       RestAPIService.UserDetails().then(
                          function(success) {
                            if(success.data.loginCounter == "1"){
                              var confirm = $mdDialog.confirm()
                              .title('')
                              .textContent("Please Change the default password")
                              .ok('Ok')
                             
                          $mdDialog.show(confirm).then(function() {
                            $mdDialog.show({
                                 controller: ChangePasswordController,
                                 templateUrl: 'app/main/finishReset/finishReset.html',
                                 parent: angular.element(document.body),
                                 clickOutsideToClose: false,
                                 fullscreen: $scope.customFullscreen
                             })
                         function ChangePasswordController($scope) {
                             $scope.cancel = function() {
                                 $mdDialog.cancel();
                             }
                             $scope.save = function(password) {
                              $scope.loginusername= $localStorage.logedInuserdetail.currentLogedInUser.login;
                              RestAPIService.ResetPassword($scope.loginusername,password).then(
                                           function(success){
                                                   RestAPIService.successTostDialog("Password Changed successfully ");
                                               $mdDialog.hide(password);
                                           },
                                            function(error) {
                                         RestAPIService.showErrorDialog(error);
                                         });
                  
                  
                             }
                         } 

                              },
                              function() {
                                  $mdDialog.cancel();
                              });
                            }

                            var json = {
                                    "currentLogedInUser" : success.data,
                                    "loggedInUserName" : success.data.firstName + ' ' + success.data.lastName
                                    }
                            $localStorage.logedInuserdetail =json;
                            console.log(json,"test")
                              // Once the user logs in successfully, bring the idle concept into picture.
                              Idle.watch();
//                                    Sometimes charts data is not getting displayed. So, if the logged in user is admin,  call that fun here only and store the values in global var's before we pass the state to homepage.
                            if(success.data.authorities.indexOf("ROLE_ADMIN")){
                              // $scope.getPayablesDashboard();
                              var json = $localStorage.logedInuserdetail;
                            }
                                if(json !=null || json !=undefined ){
                                  if(success.data.authorities.indexOf("ROLE_AUDITOR")>-1){
                                    $location.path('/auditorsTool');
                                  }
                            if($rootScope.postLoginRoute){
                                    $location.url($rootScope.postLoginRoute);
                                  }
                                  else{$location.path('/inbox');}
                                }else{$location.path('/login'); }
                                 },
                                 function(error) {
                                     RestAPIService.showErrorDialog(error);
                                 });

                    } else {
                        $scope.ErrorMsg = "Failed to signIn! Please check your credentials and try again.";
                    }
                });
            }



            $scope.resetPassword = function(email) {
              RestAPIService.resetPassword(email).then(
                  function(success) {
                     alert("Reset link sent to emailId successfully");
                  },
                  function(error) {
                    $scope.ErrorMsg =error.data;
                  }
              );


      }
//             $scope.getPayablesDashboard = function(){
//               RestAPIService.getPayablesDashboard('site-2').then(
//                         function(success){
//                          $scope.payablesDashboard = success.data;
// //                         Processing data for Process time Analysis.
//                          ptaDataMonths = success.data.ptaVM.ptaMonths;
//                          ptaDataInvoicesProcessd = success.data.ptaVM.ptaProcessedInvoices;
//                          ptaDataAverageProcessingTimes = success.data.ptaVM.ptaAverageProcessingTimes;
// //                         Processing data for Channel analysis.
//                          $scope.channelAnalysisNoOfItemsProcessed = success.data.caVM.noOfItemsProcessed[0];
//                          $scope.caKeys =  Object.keys($scope.channelAnalysisNoOfItemsProcessed);
//                      $scope.cavalues = Object.values($scope.channelAnalysisNoOfItemsProcessed);
//                      $scope.caMainArray = [];
//                      for(var i=0; i<$scope.caKeys.length; i++){
//                        $scope.singleArray = [];
//                        $scope.singleArray.push($scope.caKeys[i]);
//                        $scope.singleArray.push($scope.cavalues[i]);
//                        $scope.caMainArray.push($scope.singleArray);
//                      }
//                      caNoOfItemsProcessed = $scope.caMainArray;
// //                     Processing data for Status Analysis.
//                      $scope.statusAnalysisNoOfItemsProcessed = success.data.statusVM.noOfItemsProcessed[0];
//                      $scope.saKeys =  Object.keys($scope.statusAnalysisNoOfItemsProcessed);
//                      $scope.savalues = Object.values($scope.statusAnalysisNoOfItemsProcessed);
//                      $scope.saMainArray = [];
//                      $scope.saMainArray[0] = ['ocr',$scope.statusAnalysisNoOfItemsProcessed.ocr];
//                          $scope.saMainArray[1] = ['revised',$scope.statusAnalysisNoOfItemsProcessed.revised];
//                          $scope.saMainArray[2] = ['posted',$scope.statusAnalysisNoOfItemsProcessed.posted];
//                          $scope.saMainArray[3] = ['paid',$scope.statusAnalysisNoOfItemsProcessed.paid];
//                      saNoOfItemsProcessed = $scope.saMainArray;
// //                     Processing data for key pint indexes.
//                      $scope.keyPointIndexes = success.data.kpiVM.keyPointIndexs;
// //                     Processing data for Invoice Volume Analysis.
//                      $scope.IVAMonthsData= success.data.invoiceVm.months;
// //                     Making month number (01) as Strings (Jan) to display in chart.
//                      for(var i=0; i<$scope.IVAMonthsData.length; i++){
//                        var monthNumber = $scope.IVAMonthsData[i].substring(4,6);
// //                       Call a function which converts Month number to String.
//                        var month = $scope.setMonth(monthNumber);
//                        $scope.IVAMonthsData[i] = $scope.IVAMonthsData[i].substring(6,8)+'-'+month+'-'+$scope.IVAMonthsData[i].substring(0,4);
//                      }
//                      IVAMonths = $scope.IVAMonthsData;
//                      $scope.IVAItemsData = success.data.invoiceVm.data;
//                      $scope.IVAItemsFinalArray = [];
//                      for(var i=0; i<$scope.IVAItemsData.length; i++){
//                        $scope.IVATempAObj = {};
//                        var keys = Object.keys($scope.IVAItemsData[i]);
//                        var values = Object.values($scope.IVAItemsData[i]);
//                        $scope.IVATempAObj['name'] =  keys[0];
//                        $scope.IVATempAObj['data'] =  values[0];
//                        $scope.IVAItemsFinalArray.push($scope.IVATempAObj);
//                      }
//                      IVAItemsFinalArray = $scope.IVAItemsFinalArray;
//                      console.log(IVAItemsFinalArray);
//                      console.log(IVAMonths);
//                         },
//                         function(error){
//                            RestAPIService.showErrorDialog(error);
//                         }
//                     );
//             }
            $scope.brandSettingsPresence = false;
            init();
            function init(){
            RestAPIService.getbrandsetting().then(
                      function(success) {
                        if(success.data.length>0){
                          $scope.brandSettingsPresence = true;
                          window.localStorage['branddata'] = angular.toJson(success.data[0]);
                                if((success.data[0].loginbackgroundcolor || success.data[0].loginlogo) !=null){
                                  if(success.data[0].loginbackgroundimage !=null && success.data[0].loginbackgroundimage !=""){
                                    /*$('#login').css('background-image', 'url(assets/images/backgrounds/november.jpg)');*/
                                    $("#login").css('background-image', 'url('+success.data[0].loginbackgroundimage+')');
                                  }else{
                                    $("#login").css('background-color',success.data[0].loginbackgroundcolor);
                                  }
                                  $('#logoimage').attr('src', success.data[0].loginlogo);
                                }else{
                                  $("#login").css('background-color',"#62a8e0");
                                  $('#logoimage').attr('src', "../assets/images/logos/Logo2.jpg");
                                }
                        }else{
                          window.localStorage['branddata'] = null;
                            $("#login").css('background-color',"#62a8e0");
                            $('#logoimage').attr('src', "../assets/images/logos/Logo2.jpg");
                        }
                        $scope.loginButton =true;
                      },
                      function(error) {
                          RestAPIService.showErrorDialog(error);
                      }
                  );
            }
            $scope.setMonth = function(month){
            if(month == '01'){
              return 'Jan';
            }
            else if(month == '02'){
              return 'Feb';
            }
            else if(month == '03'){
              return 'Mar';
            }
            else if(month == '04'){
              return 'Apr';
            }
            else if(month == '05'){
              return 'May';
            }
            else if(month == '06'){
              return 'Jun';
            }
            else if(month == '07'){
              return 'Jul';
            }
            else if(month == '08'){
              return 'Aug';
            }
            else if(month == '09'){
              return 'Sep';
            }
            else if(month == '10'){
              return 'Oct';
            }
            else if(month == '11'){
              return 'Nov';
            }
            else if(month == '12'){
              return 'Dec';
            }

          }
        }
})();

(function() {
    'use strict';

    var app = angular
        .module('app.initiateReports', [])
        .config(config)
        .run(run);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider, $controllerProvider, $compileProvider, $filterProvider, $provide) {
        app.controller = $controllerProvider.register;
        app.directive = $compileProvider.directive;
        app.filter = $filterProvider.register;
        app.factory = $provide.factory;
        app.service = $provide.service;

        $stateProvider
            .state('app.initiateReports', {
                url: '/ireports',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/initiateReports/initiateReports.html',
                        controller: 'InitiateReportsController as ireprtCtrl'
                    }
                }
            })       
         }

         function run(msNavigationService, $localStorage, $rootScope, $state){
            msNavigationService.saveItem('report', {
                title: 'Reports',
                icon: 'icon-file-document',
                state: 'app.initiateReports',
                weight:4,
                hidden:function(){
                    if ($localStorage.menubarsetting != undefined) {
                      var show = $localStorage.menubarsetting.userReports;
                      return !(show);
                  }
                  }
            });



         }
})();

(function ()
{
    'use strict';

    angular
        .module('app.initiateReports')
        .controller('InitiateReportsController', InitiateReportsController);


    function InitiateReportsController($state,$scope,$filter, $localStorage,$window,RestAPIService,$mdDialog,$location,$anchorScroll,$stateParams)
    {
        var ireprtCtrl = this;
        $scope.sizeNumbers= [10,20,50,100];
        $scope.pageNumber = 0;
        $scope.size= 10;
        $scope.inbox =true;
        $scope.goToPreviousState = function(){
          $state.go('app.initiateReports')
        }
        ireprtCtrl.dtOptions = {
            dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            columnDefs: [
                { // Target the actions column
                    targets: 6,
                    responsivePriority: 1,
                    filterable: false,
                    sortable: false
                }
            ],

            pagingType: 'simple',
            lengthMenu: [10, 20, 30, 50, 100],
            pageLength: 20
                // scrollY     : 'auto',
                //responsive  : true
        };
        ireprtCtrl.goToReports =function(){
                RestAPIService.getReports("SAP",$scope.pageNumber,$scope.size).then(function(responce){
                    $scope.pageNumbers =[];
                    $scope.allReports = responce.data;
                    $location.hash('scrollToDivID');
                        $anchorScroll();
                     $scope.totalRecords = responce.headers('x-total-count');
                       $scope.totalPages = Math.ceil($scope.totalRecords/$scope.size);
                        if ($scope.totalPages > 0) {
                          for (var i = 0; i < $scope.totalPages; i++) {
                              $scope.pageNumbers.push(i);
                          }
                      }
                    var i=1;
                    $scope.allReports.forEach(function(h){
                        h['sno'] =i;
                        i++;
                    })


                },function(error){
                    RestAPIService.showErrorDialog(error);
                })

        }



        $scope.next = function(){
          $scope.pageNumber = $scope.pageNumber + 1;
          ireprtCtrl.goToReports ('SAP');

        }
        $scope.previous = function(){
	         $scope.pageNumber = $scope.pageNumber - 1;
	         ireprtCtrl.goToReports ('SAP');
        }
        $scope.sendPageNumber = function(page) {
       	 $scope.pageNumber = page;
       	 ireprtCtrl.goToReports ('SAP');
        }
        $scope.sendsizeNumber = function(sizeNumber){
       	 $scope.size =sizeNumber;
       	 $scope.pageNumber =0 ;
       	 ireprtCtrl.goToReports ('SAP');
        }
        $scope.selectReport = function(report){
           	ireprtCtrl.report = report;
        	$scope.header = report.header;
        	$mdDialog.show({
              controller: ReportDialogController,
              templateUrl: 'app/main/initiateReports/reportPreviewDialog.html',
              parent: angular.element(document.body),
//              targetEvent: ev,
              clickOutsideToClose: true,
              fullscreen: $scope.customFullscreen
          });
        }
        function ReportDialogController($scope, $mdDialog,$sce){
            $scope.inbox=true;
        	$scope.currentstep = ireprtCtrl.currentstep;
        	$scope.report = ireprtCtrl.report;
        	$scope.workitemInfo = $scope.report;
            $scope.header = $scope.report.header;
             if($scope.header.BLDAT!=undefined || $scope.header.BLDAT!= null || $scope.header.BUDAT!=undefined || $scope.header.BUDAT!=null){
             if( $scope.header.BLDAT && typeof $scope.header.BLDAT != 'object'){
                ireprtCtrl.InvoiceDate = $scope.header.BLDAT;
                $scope.header.BLDAT = ireprtCtrl.InvoiceDate.substring(0,4)+'-'+ireprtCtrl.InvoiceDate.substring(4,6)+'-'+ireprtCtrl.InvoiceDate.substring(6,8);
                $scope.header.BLDAT =  new Date($scope.header.BLDAT);
                }
                if($scope.header.BUDAT && typeof $scope.header.BUDAT != 'object'){
                ireprtCtrl.PostingDate = $scope.header.BUDAT;
                $scope.header.BUDAT = ireprtCtrl.PostingDate.substring(0,4)+'-'+ireprtCtrl.PostingDate.substring(4,6)+'-'+ireprtCtrl.PostingDate.substring(6,8);
                $scope.header.BUDAT =  new Date($scope.header.BUDAT);
                }
                if($scope.header.RECEIPT_DATE){
                    ireprtCtrl.ReceiptDate = $scope.header.RECEIPT_DATE;
                    $scope.header.RECEIPT_DATE = ireprtCtrl.ReceiptDate.substring(0,4)+'-'+ireprtCtrl.ReceiptDate.substring(4,6)+'-'+ireprtCtrl.ReceiptDate.substring(6,8);
                    $scope.header.BUDAT =  new Date($scope.header.BUDAT);
                }
        }
        if($scope.header.TAX_AMOUNT){
            ireprtCtrl.Amount =$scope.header.TAX_AMOUNT;
            $scope.header.TAX_AMOUNT = parseInt(ireprtCtrl.Amount);
        }
        if($scope.header.WRBTR){
            ireprtCtrl.GrossAmount =$scope.header.WRBTR;
            $scope.header.WRBTR = parseInt(ireprtCtrl.GrossAmount);
        }
        if($scope.header.FRIEGHT_AMT){
            ireprtCtrl.FrightAmount =$scope.header.FRIEGHT_AMT;
            $scope.header.WRBTR = parseInt(ireprtCtrl.FrightAmount);
        }

        $scope.lineItems=[];
        ireprtCtrl.lineItems = $scope.report.lineItems;
        angular.forEach(ireprtCtrl.lineItems,function(key,value){
            $scope.lineItems.push(key.lineItems);
        })
        angular.forEach($scope.lineItems,function(key,value){
           if(key.WRBTR !=undefined || key.WRBTR !=null){
            ireprtCtrl.LineItemAmount =key.WRBTR;
               key.WRBTR= parseInt(key.WRBTR);
           }
            if(key.WERKS){
                var plant ={}
                plant.listname ="plant_unit",
                plant.listvar ="WERKS",
                plant.value =key.WERKS;
             RestAPIService.getItemDetails(plant).then(
                 function(success){
                     $scope.plantDescription =success.data;
                 },
                 function(error){
                 });
            }
            if(key.WBS_ELEMENT){
             var plant ={}
             plant.listname ="wbs_element",
             plant.listvar ="PSPNR",
             plant.value =key.WBS_ELEMENT;
          RestAPIService.getItemDetails(plant).then(
              function(success){
                  $scope.WBS_Description =success.data;
              },
              function(error){
              });
         }
            if(key.KOSTL){
             var plant ={}
             plant.listname ="cost_center",
             plant.listvar ="KOSTL",
             plant.value =key.KOSTL;
          RestAPIService.getItemDetails(plant).then(
              function(success){
                  $scope.CostDescription =success.data;
                  },
              function(error){
              });

            }
            if(key.EKGRP){
             var plant ={}
             plant.listname ="purchasegroup",
             plant.listvar ="EKGRP",
             plant.value =key.EKGRP;
          RestAPIService.getItemDetails(plant).then(
              function(success){
                  $scope.purchaseDescription =success.data;
                  },
              function(error){
              });

            }
            if(key.SAKNR){
             var plant ={}
             plant.listname ="gl_account",
             plant.listvar ="SAKNR",
             plant.value =key.SAKNR;
          RestAPIService.getItemDetails(plant).then(
              function(success){
                  $scope.glAccountDescription =success.data;
                  },
              function(error){
              });
          }
          if(key.ANLN1){
             var plant ={}
             plant.listname ="asset_code",
             plant.listvar ="ANLN1",
             plant.value =key.ANLN1;
          RestAPIService.getItemDetails(plant).then(
              function(success){
                  $scope.AssetDescription =success.data;
                  },
              function(error){
              });
          }
          if(key.KNTTP){
             var plant ={}
             plant.listname ="account_assigning",
             plant.listvar ="KNTTP",
             plant.value =key.KNTTP;
          RestAPIService.getItemDetails(plant).then(
              function(success){
                  $scope.AccountDescription =success.data;
                  },
              function(error){
              });
          }
          if(key.EPSTP){
             var plant ={}
             plant.listname ="item_category",
             plant.listvar ="PSTYP",
             plant.value =key.EPSTP;
          RestAPIService.getItemDetails(plant).then(
              function(success){
                  $scope.ItemDescription =success.data;
                  },
              function(error){
              });
          }
          if(key.ORDER_NO){
             var plant ={}
             plant.listname ="order_number",
             plant.listvar ="AUFNR",
             plant.value =key.ORDER_NO;
          RestAPIService.getItemDetails(plant).then(
              function(success){
                  $scope.OrderDescription =success.data;
                  },
              function(error){
              });
          }

        })

            $scope.log = $scope.report.logs;
            $scope.currentFormHeader = $sce.trustAsHtml($scope.report.mainLayout.replace(/&quot;/g, '"'));
            if($scope.report.detailsLayout){
                $scope.currentFormLineitem =$sce.trustAsHtml($scope.report.detailsLayout.replace(/&quot;/g, '"'));
            }
            if($scope.report.inboxMainLayout){
                $scope.currentFormInboxHeader = $sce.trustAsHtml($scope.report.inboxMainLayout.replace(/&quot;/g, '"'));
             }
             if($scope.report.inboxLineItemLayout){
                $scope.currentFormInboxLineitem = $sce.trustAsHtml($scope.report.inboxLineItemLayout.replace(/&quot;/g, '"'));
             }

        	$scope.daysArray = [];

        	$scope.log.forEach(function(h){
            	if(h.activityText == "Initiated"){
            		h['icon'] = "icon-star-outline";
            	}
            	else if(h.activityText == "Approve"){
            		h['icon'] = "icon-check";
            	}
            	else if(h.activityText =="Collaborate"){
            		h['icon'] ="icon-content-save";
            	}
            	else if(h.activityText =="CollaborateBack"){
            		h['icon'] ="icon-content-save";
            	}
            	else if(h.activityText =="Cancel"){
            		h['icon'] ="icon-plus";
            	}
            	else if(h.activityText =="Delete"){
             		h['icon'] ="icon-delete";
             	}
            	else if(h.activityText == "Elimination"){
            		h['icon'] = "icon-check";
            	}

		        })

        	$scope.cancel = function() {
              $mdDialog.cancel();
        	};

          $scope.fileIcon = function(fileType){
          	var icon ={};
              if(fileType == "folder"){
                    icon = "icon-folder";
                }
                else if(fileType.indexOf("jpg")!= -1){
                    icon = "icon-file-image";
                }
                else if(fileType.indexOf("jpeg")!= -1){
                    icon = "icon-file-image";
                }
                else if(fileType.indexOf("png")!= -1){
                    icon = "icon-file-image";
                }
                else if(fileType.indexOf("pdf")!= -1){
                    icon = "icon-file-pdf-box";
                }
                else if(fileType.indexOf("txt")!= -1){
                    icon = "icon-clipboard-text";
                }
                else if(fileType.indexOf("html")!= -1){
                    icon = "icon-language-html5";
                }
                else if(fileType.indexOf("xl")!= -1){
                    icon = "icon-file-excel";
                }
                else if(fileType.indexOf("word")!= -1){
                    icon = "icon-file-word";
                }
                else if(fileType.indexOf("xml")!= -1){
                    icon = "icon-file-xml";
                }
                else if(fileType.indexOf("doc")!= -1){
                    icon = "icon-file-document";
                }
                else if(fileType.indexOf("docx")!= -1){
                    icon = "icon-file-document";
                }
                else if(fileType.indexOf("json")!= -1){
                    icon = "icon-clipboard-text";
                }

                else{
                    icon = "icon-file-document";
                }
                return icon;

          }

          $scope.downloadFile =function(file,reqId){
            var archiveId = file.archiveId;
            var ReqId = reqId;
            var archiveDocId = file.archiveDocId;
       RestAPIService.downloadAttachment(ReqId,archiveId,archiveDocId).then(
                 function(success) {
                         var headers = success.headers();
                         //alert(JSON.stringify(headers));
                         var data = success.data;
                         //alert(data);
                         //var filename = headers['x-filename'];
                         var filename = file.fileName;
                         var contentType = headers['content-type'];
                         var linkElement = document.createElement('a');
                         try {
                             var blob = new Blob([data], { type: contentType });
                             var url = window.URL.createObjectURL(blob);
                             linkElement.setAttribute('href', url);
                             linkElement.setAttribute("download", filename);
                             var clickEvent = new MouseEvent("click", {
                                 "view": window,
                                 "bubbles": true,
                                 "cancelable": false
                             });
                             linkElement.dispatchEvent(clickEvent);
                         } catch (ex) {
                             console.log(ex);
                         }
                 },
                 function(error) {
                     //console.log('ERROR Downloading the file ********');
                     RestAPIService.showErrorDialog(error);
                 }
             );
         }

         $scope.preview = function(ev,file,reqId){
            ireprtCtrl.file = file;
            ireprtCtrl.ReqId =reqId;
            ireprtCtrl.ArchiveId =file.archiveId;
            ireprtCtrl.ArchivedocId =file.archiveDocId;
            var jwtToken = $localStorage.currentUser.token.trim();
          if(jwtToken != undefined && ireprtCtrl.ReqId != undefined) {
              var encodedURI =file.url;
           // var encodedURI = baseUrl+'/api/requests/inbox/filedownload?archiveId='+ireprtCtrl.ArchiveId+'&requestId='+ireprtCtrl.ReqId+'&archiveDocId='+ireprtCtrl.ArchivedocId+'&attachment=false&jwtToken='+jwtToken;
            $window.open(encodedURI);
          }

         }

        //   $scope.preview = function(ev, file, reqId,url) {
        // 	  ireprtCtrl.file = file;
        // 	 ireprtCtrl.ReqId =reqId;
        // 	 ireprtCtrl.ArchiveId =file.archiveId;
        // 	 ireprtCtrl.ArchivedocId =file.archiveDocId;
        // 	 ireprtCtrl.url= url;
        //       $mdDialog.show({
        //           controller: DialogController,
        //           templateUrl: 'app/main/initiateReports/previewFiles.html',
        //           parent: angular.element(document.body),
        //           targetEvent: ev,
        //           autoWrap: true,
		// 		  skipHide: true,
        //           clickOutsideToClose: true
        //       });
        //   }
        //   function DialogController($scope, $mdDialog, $sce, $sessionStorage,$localStorage) {
        // 	  $scope.fileVis = false;
        //       $scope.imgVis= false;
        //       $scope.cancel = function() {
        //           $mdDialog.cancel();
        //       };
        //         var jwtToken = $localStorage.currentUser.token.trim();
        //         if(jwtToken != undefined && ireprtCtrl.ReqId != undefined) {
        //         	//baseUrl+'/api/requests/inbox/filedownload?archiveId='+ireprtCtrl.ArchiveId+'&requestId='+ireprtCtrl.ReqId+'&archiveDocId='+ireprtCtrl.ArchivedocId+'&attachment=false&jwtToken='+jwtToken
        //          var encodedURI = baseUrl+'/api/requests/inbox/filedownload?archiveId='+ireprtCtrl.ArchiveId+'&requestId='+ireprtCtrl.ReqId+'&archiveDocId='+ireprtCtrl.ArchivedocId+'&attachment=false&jwtToken='+jwtToken;

        //          if(ireprtCtrl.file.fileType =="jpg" || ireprtCtrl.file.fileType =="JPG" || ireprtCtrl.file.fileType =="jpeg" || ireprtCtrl.file.fileType =="JPEG" || ireprtCtrl.file.fileType =="PNG" || ireprtCtrl.file.fileType =="png"){
        //         	 $scope.imgVis= true;
        //         	 $scope.fileURL =ireprtCtrl.file.url;
        //          }else{
        //              $scope.fileVis= true;
        //              //+'&embedded=true'
        //         	 $scope.fileURL = $sce.trustAsResourceUrl('https://docs.google.com/gview?url='+encodedURI+'&embedded=true');
        //          }

        //         }
        //     }


        }

    }



})();

(function ()
{
    'use strict';

    angular
        .module('finishReset',[])
        .config(config);

    /** @ngInject */
    function config(){}
    
})();
(function() {
    'use strict';


    angular
        .module('finishReset')
        .controller('FinishResetController', FinishResetController);
        function FinishResetController($scope) {
            var rp = this;
           
            rp.resetPasswordfinish = function(key,password) {
                RestAPIService.resetPasswordfinish(key,password).then(
                    function(success) {
                      $state.reload();
                    },
                    function(error) {
                        RestAPIService.showErrorDialog(error);
                    }
                );
                $mdDialog.hide(user);
           
        }
           

        }


})();
(function() {
    'use strict';

    var app = angular
        .module('app.doaReports', [])
        .config(config)
        .run(run);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider, $controllerProvider, $compileProvider, $filterProvider, $provide) {
        app.controller = $controllerProvider.register;
        app.directive = $compileProvider.directive;
        app.filter = $filterProvider.register;
        app.factory = $provide.factory;
        app.service = $provide.service;

        $stateProvider
            .state('app.doaReports', {
                url: '/Doareports',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/doaReports/doaReprts.html',
                        controller: 'DoaReportsController as doareprtCtrl'
                        }
                   },
                   resolve: {
                    RestAPIService: 'RestAPIService',
                    ReqTypes: function(RestAPIService) {
                        return RestAPIService.getRequests();
                    }
                }
              })
          
             }
             function run(msNavigationService, $localStorage, $rootScope, $state) {
                msNavigationService.saveItem('doareports', {
                title: 'Reports',
                icon: 'icon-file-document',
                state: 'app.doaReports',
                weight:9,
                hidden:function(){
                    if ($localStorage.menubarsetting != undefined) {
                      var show = $localStorage.menubarsetting.doaReports;
                      return !(show);
                         }
                    }
                });
            }
})();
(function ()
{
    'use strict';

    angular
        .module('app.doaReports')
        .controller('DoaReportsController', DoaReportsController);


    function DoaReportsController($state,$scope,CommonUtil,$filter,$sessionStorage,ReqTypes,$sce, $localStorage,$window,RestAPIService,$mdDialog,$location,$anchorScroll,$stateParams)
    {
        var doareprtCtrl = this;
        $scope.requestTypes =ReqTypes.data;
        $scope.obj={}
        $scope.showTable = true;
        $scope.AllSBU=[];
        $scope.createdByUsers=[];
     
    //    $scope.isSelected==true
        $scope.getvalueoflist=function(data)
    {
       
        for(var i=0;i< $scope.createdByUsers.length;i++){
            if($scope.createdByUsers[i] === data){
                $scope.isSelected=true;
                return;
            }
            else{
                $scope.isSelected=false;
            }

        }
        console.log("dropdownchnged",data  );
    }
        // $scope.onInput=function() {
        //     var val = document.getElementById("input").value;
        //     var opts = document.getElementById('dlist').childNodes;
        //     for (var i = 0; i < opts.length; i++) {
        //       if (opts[i].value === val) {
               
        //         alert(opts[i].value);
        //         break;
        //       }
        //     }
        //   }
        
        
        var jwtToken = $localStorage.currentUser.token.trim(); 
        doareprtCtrl.Download=function(obj){
            if(obj.headerFields.DEPT =="" && obj.headerFields.LOCATION =="" && obj.headerFields.SBU =="" || obj.fromDate==""||obj.fromDate==null||obj.fromDate==undefined||obj.toDate==""||obj.toDate==null||obj.toDate==undefined){
                if(obj.fromDate==""||obj.fromDate==null||obj.fromDate==undefined||obj.toDate==""||obj.toDate==null||obj.toDate==undefined){
                    $mdDialog.show(
                        $mdDialog
                        .alert()
                        .parent(angular.element(document.querySelector("#popupContainer")))
                        .clickOutsideToClose(true)
                        .title("")
                        //+engCAPCtrl.selectedWorkitemInfo.requestId +"</b> was "
                        .htmlContent("<h4>Please Select From Date and To Date</h4>")
                        .ariaLabel("Alert Dialog Demo")
                        .ok("Ok")           
                        );
                      $mdDialog.cancel();
                      return;
                }
  
            }
            $scope.name=obj.requestType; 
            $scope.filename="Reports";
            console.log(doareprtCtrl.searchdataDate)
            var status =obj.sendToSAP   
            if($scope.obj.sendToSAP === undefined){
                status="";
                // $mdDialog.show(
                //     $mdDialog
                //     .alert()
                //     .parent(angular.element(document.querySelector("#popupContainer")))
                //     .clickOutsideToClose(true)
                //     .title("")
                //     //+engCAPCtrl.selectedWorkitemInfo.requestId +"</b> was "
                //     .htmlContent("<h4>please select status and search to download</h4>")
                //     .ariaLabel("Alert Dialog Demo")
                //     .ok("Ok")           
                //     );
                //   $mdDialog.cancel();
            }  
    //   console.log(obj.fromDate._d)
            // else{
                if(obj.creator==undefined || obj.creator== null){
                    obj.creator="";
                }
                if(obj.currentUser == undefined || obj.currentUser == null){
                    obj.currentUser = "";
                }
                var fromDate=moment.utc(obj.fromDate).format("YYYY-MM-DDTHH:mm:ss")+".228Z";                
                var toDate=moment(obj.toDate).format("YYYY-MM-DDTHH:mm:ss")+".228Z";
                // var fromDate = new Date(FromDate);
                // var toDate = new Date(toDate);
                // // fromDate modifications.
                // var fromDateMonth = parseInt(fromDate.getMonth()+1);
                // if(fromDateMonth < 10){
                //     var fromDateMonth = '0'+fromDateMonth;
                // }
                // var fromdateDate = fromDate.getDate();
                // if(fromdateDate < 10){
                //    var fromdateDate = '0'+fromdateDate;
                // }
                // // toDate modifications.
                // var toDateMonth = parseInt(toDate.getMonth()+1);
                // if(toDateMonth < 10){
                //     var toDateMonth = '0'+toDateMonth;
                // }
                // var toDateDate = toDate.getDate();
                // if(toDateDate < 10){
                //     var toDateDate = '0'+toDateDate;
                // }   
                // // var requestDataObj = angular.copy(requestData);
                // fromDate = fromDate.getFullYear()+'-'+ fromDateMonth+'-'+fromdateDate+'T00:00:00.000Z'; 
                // fromDate = new Date(fromDate);
                // toDate = toDate.getFullYear()+'-'+ toDateMonth+'-'+toDateDate+'T00:00:00.000Z';
                // toDate = new Date(toDate);
                var fDate = fromDate.substring(0,10);
                fDate = fDate+'T00:00:00.511Z';
                var tDate = toDate.substring(0,10);
                tDate = tDate+'T00:00:00.511Z';
                
              
                // window.open(baseUrl +'/api/exceldownload/'+name+'/'+test+'?jwtToken='+jwtToken)
                window.open(baseUrl +'/api/csv/'+$scope.filename+'/reqtype/'+encodeURIComponent(obj.requestType)+'?sbu='+encodeURIComponent(obj.headerFields.SBU)+'&location='+encodeURIComponent(obj.headerFields.LOCATION)+'&dept='+encodeURIComponent(obj.headerFields.DEPT)+'&status='+status+'&startDate='+fDate+'&endDate='+tDate+'&creator='+obj.creator+'&currentuser='+obj.currentUser+'&jwtToken='+jwtToken);
               
                // window.open(baseUrl +'/api/csv/'+status+'/reqtype/'+encodeURIComponent(obj.requestType)+'/status/'+status+'/pagen/'+$scope.pageNumber+'/pagesize/'+$scope.size+'?jwtToken='+jwtToken);
            // }    
             
  } 
  
  $scope.getAttachmentsLength = function(attachments){
    $scope.attachmentsCount = 0;
    attachments.forEach(function(h){
        if(h.deleteStatus != 'true'){
            $scope.attachmentsCount = $scope.attachmentsCount+1;
        }
    })
    return $scope.attachmentsCount;
  }
  doareprtCtrl.getDOAReports=function(searchdata){
        console.log(searchdata)
        doareprtCtrl.searchdataDate=searchdata
        $scope.sbuobj ={};
        var sbu="";
        var loc="";
        var dept="";

        if(searchdata != "" && searchdata != null && searchdata != undefined ){
            if(searchdata.creator != "" && searchdata.creator != null && searchdata.creator != undefined && $scope.isSelected==true){

            }
            else if(searchdata.creator != "" && searchdata.creator != null && searchdata.creator != undefined && $scope.isSelected==false){
                $mdDialog.show(
                    $mdDialog.alert()
                    .parent(angular.element(document .querySelector('#popupContainer')))
                    .clickOutsideToClose(true)
                    .title('Warning')
                    .htmlContent("<h4><b> Please Select Valid Creator Id</b></h4>")
                    .ariaLabel('Alert Dialog Demo')
                    .ok('Ok')
                      );
                    $mdDialog.cancel();
               
                return;
            }
    
        if(searchdata.headerFields != undefined && (searchdata.headerFields.LOCATION != "" &&searchdata.headerFields.LOCATION != null && searchdata.headerFields.LOCATION != undefined)){
            loc=searchdata.headerFields.LOCATION.toString();
          }
          if(searchdata.headerFields != undefined && (searchdata.headerFields.DEPT != "" && searchdata.headerFields.DEPT != null && searchdata.headerFields.DEPT != undefined)){
           var testdept = searchdata.headerFields.DEPT.toString()
            dept=testdept.split(/\s/).join('');
           console.log(testdept)
           console.log(dept)
          }
          if(searchdata.headerFields != undefined && (searchdata.headerFields.SBU != "" &&searchdata.headerFields.SBU != null && searchdata.headerFields.SBU != undefined)){
            sbu=searchdata.headerFields.SBU.toString();
          }
           $scope.sbuobj={SBU:sbu,LOCATION:loc,DEPT:dept};
            $scope.obj.headerFields=  $scope.sbuobj;
          
            
        }
        else{
            $scope.obj={};
            $scope.obj.headerFields={};
        }
      
        $scope.sbuobj={SBU:sbu,LOCATION:loc,DEPT:dept};
        $scope.obj.headerFields=  $scope.sbuobj;
    // $scope.obj['requestType'] = ["CEP_FORM","VENDOR_FORM","EOR_FORM","SCEP_FORM","GENERAL_FORM","RFWD_FORM","COR_EXCL_PDR"];
    // $scope.obj['requestType'] = $scope.permittedRequestTypes;
    $scope.obj['requestType'] = searchdata.requestType; 
    // $scope.obj['fromDate'] = "";
    // $scope.obj['toDate'] = "";
    var requestData =$scope.obj;
    console.log(requestData);
    // fromDate modifications.
    if(requestData.fromDate){
        var fromDateMonth = parseInt(requestData.fromDate._d.getMonth()+1);
        if(fromDateMonth < 10){
            var fromDateMonth = '0'+fromDateMonth;
        }
        var fromdateDate = requestData.fromDate._d.getDate();
        if(fromdateDate < 10){
           var fromdateDate = '0'+fromdateDate;
        }
    }
    
    // toDate modifications.
    if(requestData.toDate){
        var toDateMonth = parseInt(requestData.toDate._d.getMonth()+1);
        if(toDateMonth < 10){
            var toDateMonth = '0'+toDateMonth;
        }
        var toDateDate = requestData.toDate._d.getDate();
        if(toDateDate < 10){
            var toDateDate = '0'+toDateDate;
        }
    }
       
    var requestDataObj = angular.copy(requestData);
    if(requestData.fromDate){        
        requestDataObj.fromDate = requestDataObj.fromDate._d.getFullYear()+'-'+ fromDateMonth+'-'+fromdateDate+'T00:00:00.000Z'; 
        requestDataObj.fromDate = new Date(requestDataObj.fromDate);
    }
    if(requestData.toDate){
        requestDataObj.toDate = requestDataObj.toDate._d.getFullYear()+'-'+ toDateMonth+'-'+toDateDate+'T00:00:00.000Z';
        requestDataObj.toDate = new Date(requestDataObj.toDate);
    }
    RestAPIService.getDOAReports(requestDataObj,$scope.pageNumber,$scope.size).then(function(responce){
       
        $scope.pageNumbers =[];
        $scope.allReports = responce.data;
       
      $location.hash('scrollToDivID');
            $anchorScroll();
         $scope.totalRecords = responce.headers('x-total-count');
           $scope.totalPages = Math.ceil($scope.totalRecords/$scope.size);
            if ($scope.totalPages > 0) {
              for (var i = 0; i < $scope.totalPages; i++) {
                  $scope.pageNumbers.push(i);
              }
          }          

    },function(error){
        $mdDialog.show(
            $mdDialog.alert()
            .clickOutsideToClose(true)
            .title('Error occurred while processing')
            .htmlContent('<hr><br><strong>' + error.data.description + ' </strong>' )
            .ariaLabel('Alert Dialog Demo')
            .ok('Ok')
        );
    })}
             init();
        $scope.selectFile = function(fileData){
            if(fileData.fileType.toLowerCase() == 'pdf'){
                window.open(fileData.url);
            }
            else{
                $mdDialog.show(
                  $mdDialog.alert()
                  .parent(angular.element(document .querySelector('#popupContainer')))
                  .clickOutsideToClose(true)
                  .title('Warning')
                  .htmlContent("<h4><b> Unable To Preview The Document, Please Download. </b></h4>")
                  .ariaLabel('Alert Dialog Demo')
                  .ok('Ok')
                    );
                  $mdDialog.cancel();
              }
         }
         $scope.printLogs = function(printSectionId) {
            
            var innerContents = document.getElementById(printSectionId).innerHTML;
            console.log(innerContents)
            var popupWinindow = window.open('', '_blank', 'width=600,height=700,scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no');
            popupWinindow.document.open();
            popupWinindow.document.write('<html><head><link rel="stylesheet" type="text/css" href="style.css" /></head><body onload="window.print()">' + innerContents + '</html>');
            popupWinindow.document.close();
            window.close();
        };
        
        doareprtCtrl.cancelReport = function(allReports){
            doareprtCtrl.allReports=allReports
            $mdDialog.show({
                   controller: ReportDialogController,
                   templateUrl: 'app/main/doaReports/doaRportsComment.html',
                   parent: angular.element(document.body),
                //  targetEvent: ev,
                   clickOutsideToClose:true,
                   fullscreen: $scope.customFullscreen
               });   
               
               function ReportDialogController($scope,$mdDialog,$sce){
               
                $scope.allReports= doareprtCtrl.allReports
               
              var login =""
              var requestType = $scope.allReports.requestType 
             var requestId = $scope.allReports.requestId 
                $scope.activity ="103"
                console.log($scope.allReports)
                   $scope.reportCancel = function($event, reportsComment){
                    RestAPIService.cancelDoaReports(requestType,reportsComment,$scope.activity,requestId).then(
                        function(success) {
                            RestAPIService.successTostDialog("Cancel  is done successfully.")
                         $state.reload()
     	                	$mdDialog.cancel();  
                                           
                        },
                        function(error) {
                            RestAPIService.showErrorDialog(error);
                        }
                    );
                   }
                   $scope.cancel=function(){
                    $mdDialog.cancel();
                   } 
        
             }
            
             }



        function init() {
          $scope.currentUserobj = $localStorage.logedInuserdetail.currentLogedInUser;
          console.log("name",$scope.currentUserobj)

         
            RestAPIService.getDoaReportsfield($scope.currentUserobj.login).then(
                function(success) {
                    $scope.Doareports = success.data;
                    console.log($scope.Doareports)
                     var sbu=$scope.Doareports.sbu;
                         var location=$scope.Doareports.location;
                         var department=$scope.Doareports.department;
                         $scope.permittedRequestTypes = success.data.requestTypes
                            if(sbu== "*"){
                                RestAPIService.getlistDataBylistName("SBU").then(
                                    function(success){
                                        $scope.AllSBU =success.data;
                                        doareprtCtrl.AllSBUS =success.data;
                                    },function(error){});
                               
                            }else{
                                for(var i=0;i<$scope.Doareports.sbu.length;i++){
                                    var obj={SBU:$scope.Doareports.sbu[i],DESCRIPTION:$scope.Doareports.sbu[i]};
                                    $scope.AllSBU.push(obj);
                                }
                              
                                console.log($scope.AllSBU);
                            }
                            $scope.AllLocations=[];
                            if(location == "*"){
                            RestAPIService.getlistDataBylistName("LOCATION").then(
                                    function(success){
                                        $scope.AllLocations =success.data;
                                        doareprtCtrl.AllLocations =success.data;
                                    },function(error){});
                                 
                            }else{
                                for(var i=0;i<$scope.Doareports.location.length;i++){
                                    var objlocation={LOCATION:$scope.Doareports.location[i],DESCRIPTION:$scope.Doareports.location[i]};
                                    $scope.AllLocations.push(objlocation);
                                  
                                }
                                console.log($scope.AllLocations);
                            }
                            $scope.AllDepts=[];
                            if(department == "*"){
                                 RestAPIService.getlistDataBylistName("DEPT").then(
                                            function(success){
                                                // $scope.AllDepts =success.data;
                                                doareprtCtrl.AllDepts =success.data;
                                                for(var i=0;i<doareprtCtrl.AllDepts.length;i++){
                                                    var objdepartment={DEPT:doareprtCtrl.AllDepts[i].DEPT.split(/\s/).join(''),DESCRIPTION:doareprtCtrl.AllDepts[i].DESCRIPTION};
                                                   $scope.AllDepts.push(objdepartment);
                                                  
                                                   
                                                }
                                            },function(error){});
                                }else{
                                    for(var i=0;i<$scope.Doareports.department.length;i++){
                                        var objdepartment={DEPT:$scope.Doareports.department[i].split(/\s/).join(''),DESCRIPTION:$scope.Doareports.department[i]};
                                       $scope.AllDepts.push(objdepartment);
                                    //    console.log(objdepartment)
                                       
                                    }
                                    console.log( $scope.AllDepts);
                                }
                                
                           
                        
                        
                    
                 
                
                },
                function(error) {
                    RestAPIService.showErrorDialog(error);
                });
                

            RestAPIService.getUsers("0","2000").then(
                function(success) {
                    $scope.usersList = success.data;                       
                },
                function(error) {
                    RestAPIService.showErrorDialog(error);
                }
            );

   

            
        }
      

           
        $scope.Reset =function(){
            $state.reload();
            $scope.obj ={};
            $scope.sbuobj={SBU:"",LOCATION:"",DEPT:""};
            $scope.obj.headerFields=  $scope.sbuobj;
        $scope.obj['requestType'] = ["CEP_FORM","VENDOR_FORM","EOR_FORM","SCEP_FORM","GENERAL_FORM","RFWD_FORM","COR_EXCL_PDR"];  
        }        
        $scope.pageNumber = 0;
        $scope.size =100;
        $scope.sizeNumbers= [100,200,300,400,500,1000,1200];
        $scope.next = function(){       	
         $scope.data =doareprtCtrl.searchData;        	
          $scope.pageNumber = $scope.pageNumber + 1; 
          doareprtCtrl.getDOAReports($scope.obj);	     	
        }
        $scope.previous = function(){
            $scope.data =doareprtCtrl.searchData;
            $scope.pageNumber = $scope.pageNumber - 1; 
            doareprtCtrl.getDOAReports($scope.obj);	         	
        }
        $scope.sendPageNumber = function(page) {
            $scope.pageNumber = page;
            doareprtCtrl.getDOAReports($scope.obj);	
        }
        $scope.sendsizeNumber = function(sizeNumber){
            $scope.size =sizeNumber;
            $scope.pageNumber =0 ;
            doareprtCtrl.getDOAReports($scope.obj);	
        }
       
        
        $scope.gotopreview = function(report){
            $scope.showTable = false;
            $scope.currentFormInbox = $sce.trustAsHtml(report.mainLayout.replace(/&quot;/g,'"'));
            // $scope.currentFormInboxHeader = $sce.trustAsHtml(report.inboxMainLayout.replace(/&quot;/g, '"'));
            $scope.header =report.header
           $scope.logs=report.logs;
          //console.log(report.approvalMatrix)
         //  doareprtCtrl.url=report.attachments[0].url;
           $scope.attachments =report.attachments;

           if(report){
            $scope.header = report.header;
            $scope.currentstep = parseInt(report.currentstep);
            $scope.lineItems = report.lineItems;
            if(report.flowType == 'SAP'){
              report.approvalMatrix =[];
                }
                if(!report.approvalMatrix){
                    report.approvalMatrix ={}
                }
               report.approvalMatrix.approvers = [];
                 report.approvalMatrix.approverDays = [];
                 report.approvalMatrix.approverDates =[];
                 report.approvalMatrix.selected = [];
                 report.approvalMatrix.checked = [];
                  var logs = report.logs;
                  for (var i = 0; i <report.approvalMatrix.noofApp; i++) {
                   report.approvalMatrix.approvers[i] = report.approvalMatrix["level_" + (i + 1) + "_approvers"];
                    report.approvalMatrix.approverDays[i] =report.approvalMatrix["level_"+(i+1)+"_approversDays"];
                    report.approvalMatrix.approverDates[i] =report.approvalMatrix["level_"+(i+1)+"_approversDate"];
                  for(var j=0;j<=logs.length-1;j++){
                  var log = logs[j];
                  if(log.step == i+1 && log.activity == 101){
                   report.approvalMatrix.approvers[i] = log.actualUser;
                    break;
                  }else if(( i+1 >= $scope.currentstep)){
                    report.approvalMatrix.approvers[i] = report.approvalMatrix["level_" + (i + 1) + "_approvers"];
                      }
                     }
                    if (i < ($scope.currentstep)) {
                        report.approvalMatrix.selected[i] = true;
                    } else {
                       report.approvalMatrix.selected[i] = false;
                    }
                    if (i < ($scope.currentstep-1)) {
                        report.approvalMatrix.checked[i] = true;
                    } else {
                        report.approvalMatrix.checked[i] = false;
                    }
                }
                $scope.report =report;
          }
        
        //   $scope.downloadFile=function(attachment){
        //    CommonUtil.downloadFile(report.requestId,attachment.archiveId,attachment.archiveDocId,attachment)
        //   }

        $scope.downloadFile=function(attachment){
            // var data=CommonUtil.downloaddirectFile(attachment)

            // window.open(downloadurl+attachment.archiveId+'&docId='+attachment.archiveDocId+"&compId="+encodeURIComponent(attachment.fileName)+jwtToken)
            //  window.open(attachment.url+'.'+attachment.fileType);
           CommonUtil.downloaddirectFile(attachment)
           } 
        
      
           $scope.logs.forEach(function(h){
            if(h.activityText == "Initiated" || h.activity =='001'){
              h['icon'] = "icon-star-outline";
            }
            else if(h.activityText == "Approve"){
              h['icon'] = "icon-check";
            }
            else if(h.activityText =="Collaborate" ||  h.activity == '110'){
              h['icon'] ="icon-content-save";
            }
            else if(h.activityText =="CollaborateBack" ||  h.activity == '111'){
              h['icon'] ="icon-content-save";
            }
            else if(h.activityText =="Reject"){
              h['icon'] ="icon-close";
            }
            else if(h.activityText =="Cancel"){
              h['icon'] ="icon-plus";
            }
            else if(h.activityText =="Delete"){
              h['icon'] ="icon-delete";
            }
            else if(h.activityText == "Elimination"){
             h['icon'] = "icon-check";
           }
            
          })
          
        }
       $scope.gotoback = function(){
        $scope.showTable = true;

        $scope.report="";
        doareprtCtrl.getDOAReports($scope.obj);
       }
      
      
      
 $scope.fileIcon = function(fileType){ 	
 var icon ={};
          if(fileType == "folder"){
                icon = "icon-folder";
            }                        
            else if(fileType.indexOf("jpg")!= -1){
                icon = "icon-file-image";
            }
            else if(fileType.indexOf("jpeg")!= -1){
                icon = "icon-file-image";
            }
            else if(fileType.indexOf("png")!= -1){
                icon = "icon-file-image";
            }
            else if(fileType.indexOf("pdf")!= -1){
                icon = "icon-file-pdf-box";
            }
            else if(fileType.indexOf("txt")!= -1){
                icon = "icon-clipboard-text";
            }
            else if(fileType.indexOf("html")!= -1){
                icon = "icon-language-html5";
            }
            else if(fileType.indexOf("xl")!= -1){
                icon = "icon-file-excel";
            }
            else if(fileType.indexOf("word")!= -1){
                icon = "icon-file-word";
            }
            else if(fileType.indexOf("xml")!= -1){
                icon = "icon-file-xml";
            }
            else if(fileType.indexOf("doc")!= -1){
                icon = "icon-file-document";
            }  
            else if(fileType.indexOf("docx")!= -1){
                icon = "icon-file-document";
            }
            else if(fileType.indexOf("json")!= -1){
                icon = "icon-clipboard-text";
            }                      

            else{
                icon = "icon-file-document";
            }
            return icon;
           
  }
  $scope.analyticreports="false"

  $scope.showanalyticReport=function(){
    $scope.analyticreports="true"
  }

  $scope.doaReports = function(){
      $scope.showTable=true;
      $scope.analyticreports="false"
  }
  $scope.ResetanalyticReport=function(){
      $state.reload();
    //   $scope.analyticreports='true';
// $scope.object.SBU="";
// $scope.object.DEPT="";
// $scope.object.currentUser="";

  }
$scope.selectDate=function(data){
    $scope.maxDate=moment(data.fromDate).add(6, 'months').format('DD-MM-YYYY')
    console.log($scope.maxDate)
}
  doareprtCtrl.getAnalyticDOAReports=function(data){
   RestAPIService.getanalyticReports(data,"AnalyticReports").then(
        function(success) {
            var headers = success.headers();                       
            var data = success.data;                        
            var filename = "TATReports"+".csv";
            var contentType = headers['content-type'];
            var linkElement = document.createElement('a');
            try {
                var blob = new Blob([data], { type: contentType });
                var url = window.URL.createObjectURL(blob);
                linkElement.setAttribute('href', url);
                linkElement.setAttribute("download", filename);
                var clickEvent = new MouseEvent("click", {
                    "view": window,
                    "bubbles": true,
                    "cancelable": false
                });
                linkElement.dispatchEvent(clickEvent);
            } catch (ex) {
                console.log(ex);
            }                    
        },
        function(error) {
            RestAPIService.showErrorDialog(error);
        }
    );
    // window.open(baseUrl +'/api/requestslogsearch/'+encodeURIComponent(data.SBU)+'?login='+encodeURIComponent(data.currentUser)+'&jwtToken='+jwtToken);

  }
//   $scope.data.fromDate=new.moment()
// $scope.object.fromDate=new Date($scope.object.fromDate)

//    $scope.maxDate=moment($scope.object.fromDate).add(6, 'months').format('DD-MM-YYYY')
//     console.log($scope.maxDate)


   
RestAPIService.getDOAReports($scope.obj,0,100).then(function(responce){
//     $scope.allReportscreatedData = responce.data;
//  // angular.forEach($scope.allReports.createdBy, function(item){
//     for(var i=0 ;i<$scope.allReportscreatedData.length;i++){
//         // console.log($scope.allReportscreatedData[i].createdBy)
//         if ( $scope.createdByUsers.indexOf($scope.allReportscreatedData[i].createdBy) === -1 )
//         {
//             $scope.createdByUsers.push($scope.allReportscreatedData[i].createdBy);
//         }
//         // else
//         // {
//         //     $scope.createdByUsers.splice($scope.createdByUsers.indexOf($scope.allReports[i].createdBy), 1);
//         // }
//     }
//    console.log($scope.createdByUsers)
// //   })
$scope.pageNumbers =[];
        $scope.allReports = responce.data;
       
      $location.hash('scrollToDivID');
            $anchorScroll();
         $scope.totalRecords = responce.headers('x-total-count');
           $scope.totalPages = Math.ceil($scope.totalRecords/$scope.size);
            if ($scope.totalPages > 0) {
              for (var i = 0; i < $scope.totalPages; i++) {
                  $scope.pageNumbers.push(i);
              }
          } 
})














    }
    
 
       



})();
(function ()
{
    'use strict';

    angular
        .module('app.overview')
        .controller('OverviewController', OverviewController)
        .value("CurrentSiteName", {value: ""})
        .value("CurrentSiteLogo", {value: ""})
        .value("CurrentSiteId", {value: ""})
        .value("CurrentSiteUrl", {value: ""})
        .value("CurrentSitePage", {value: "dashboard"});

    /** @ngInject */
    function OverviewController($state,$scope,$location, $mdDialog,$document,CurrentSiteName,CommonUtil, CurrentSiteId, CurrentSiteUrl, CurrentSitePage, RestAPIService, Icons,LoggedInUserName,LoggedInUserId,Homepage,$localStorage)
    {
        var overCtrl = this;
        
        if($localStorage.sitesettingdata !=null && $localStorage.sitesettingdata !=undefined){
        	$scope.sitedisplayname = $localStorage.sitesettingdata.sitedisplayname;
        }
        
        overCtrl.goToSites = function(){
            $state.go('app.sites');
        }
         
        overCtrl.goToCreateform = function(){
            $state.go('app.createform.custom');
        }
        $scope.getDummyFileIcon =  function(index){
            overCtrl.icons = ['icon-file-pdf-box','icon-file-word','icon-file-image','icon-clipboard-text','icon-file-image'];
            var totalNoOfIcons = overCtrl.icons.length;                        
            return overCtrl.icons[index%totalNoOfIcons];
        }
         $scope.getSiteIcon =  function(index){
            overCtrl.icons = ['icon-format-italic','icon-bank','icon-cog','icon-people','icon-account'];
            var totalNoOfIcons = overCtrl.icons.length;                        
            return overCtrl.icons[index%totalNoOfIcons];
        }
         overCtrl.fileIcon = function(file){
             return CommonUtil.getIconForFile(file);
         }
         $scope.homepageList = Homepage.data;
         overCtrl.getHomePage = function() {
             RestAPIService.getHomePage().then(
                 function(success) {                     
                     $scope.homepageList = success.data;
                    
                 },
                 function(error) {
                     RestAPIService.showErrorDialog(error);
                 }
             );
             
         }
}
})();
(function ()
{
    'use strict';

    angular
        .module('app.bussiness', ['datatables', 'ngResource'])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider, $mdThemingProvider)
    {
         $stateProvider
            
            .state('app.bussinessobject', {
                url: '/bussinessobject',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/bussinessobject/bussiness.html',
                        controller:  'BussinessController as bsCrtl'
                    }
                },
              resolve : {
                    RestAPIService: 'RestAPIService',
                    Objects:  function(RestAPIService){
                        return RestAPIService.getObjects();
                    }
                }
                
            });

       /* msNavigationServiceProvider.saveItem('bussinessobject', {
            title : 'Bussiness Object',
            icon  : 'icon-format-object-tight',
            state : 'app.bussinessobject',
            weight: 7
        });*/

    }
})();


(function ()
{
    'use strict';

    angular
        .module('app.bussiness')
        .controller('BussinessController', BussinessController);

    /** @ngInject */
    function BussinessController($state,$scope,$mdDialog,RestAPIService,Objects)
    {
        var bsCtrl = this;
         $scope.objectfiles=Objects.data;
         console.log(Objects.data);
         $scope.object={};
        
         //bsCtrl.dtInstance = {};
         bsCtrl.dtOptions = {

         dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
             columnDefs: [

                 { // Target the actions column
                     targets: 6,
                     responsivePriority: 1,
                     filterable: false,
                     sortable: false
                 }
             ],

             pagingType: 'simple',
             lengthMenu: [10, 20, 30, 50, 100],
             pageLength: 20
                 // scrollY     : 'auto',
                 //responsive  : true
         };

             $scope.goToAdmin = function(){
            $state.go('app.admin');
        }
             $scope.deleteObject = function(ev,object) {
        
                  var confirm = $mdDialog.confirm()
                 .title('Remove')
                 .textContent('Object ' + object.name + ' ' + ' will be permanently deleted. Continue ?')
                 .targetEvent(ev)
                 .ok('Ok')
                 .cancel('Cancel');
             $mdDialog.show(confirm).then(function() {

                 RestAPIService.deleteObject(object.id).then(
                     function(success) {
                       
                         $state.reload();
                     },
                     function(error) {
                         RestAPIService.showErrorDialog(error);
                        }
                      );
                     },      
                     function() {
                    $mdDialog.cancel();
                   });
                   }
        

             $scope.createObjectDialog = function(ev) {
                 $mdDialog.show({
                     controller: createObjectDialogController,
                     templateUrl: 'app/main/bussinessobject/create.object.dialog.html',
                     parent: angular.element(document.body),
                     targetEvent: ev,
                     clickOutsideToClose: true,
                     fullscreen: $scope.customFullscreen
                 })
                 $scope.cancel = function() {
                    
                 };
              };


            function createObjectDialogController($scope, $mdDialog,RestAPIService) {

                  $scope.hide = function() {
                     $mdDialog.hide();
                   };
                 $scope.cancel = function() {
                     $mdDialog.cancel();
                     };
                 $scope.save = function(object) {

                 RestAPIService.createObject(object).then(
                     function(success) {
                         $state.reload();
                     },
                     function(error) {
                         RestAPIService.showErrorDialog(error);
                     }
                    );
                 $mdDialog.hide(object);
                     };
                   }
                 bsCtrl.receivedObject ={};
               $scope.updateObjectDialog = function(ev,object) {
               
                 bsCtrl.receivedObject = object;
                 $mdDialog.show({
                 controller: updateObjectDialogController,
                 templateUrl: 'app/main/bussinessobject/update.object.dialog.html',
                 parent: angular.element(document.body),
                 targetEvent: ev,
                 clickOutsideToClose: true,
                 fullscreen: $scope.customFullscreen
                })
              };

           function updateObjectDialogController($scope, $mdDialog) {
             
             $scope.receivedObject = bsCtrl.receivedObject;

             $scope.hide = function() {
                 $mdDialog.hide();
             };
             $scope.cancel = function() {
                 $mdDialog.cancel();
             };
            $scope.update = function(object) {
                 RestAPIService.updateObject(object).then(
                     function(success) {
                         $state.reload();
                     },
                     function(error) {
                         RestAPIService.showErrorDialog(error);
                     }
                 );
                 $mdDialog.hide(object);
                };
               }
           $scope.detailsObjectDialog = function(ev, object) {
                 bsCtrl.currentObject = object;
                 $mdDialog.show({
                 controller: detailsObjectDialogController,
                 templateUrl: 'app/main/bussinessobject/details.object.dialog.html',
                 parent: angular.element(document.body),
                 targetEvent: ev,
                 clickOutsideToClose: true,
                 fullscreen: $scope.customFullscreen
             })
             $scope.cancel = function() { 
                
             };
         };
         function detailsObjectDialogController($scope, $mdDialog) {
            $scope.attributes = bsCtrl.currentObject.attributes;
            $scope.currentObject = bsCtrl.currentObject;
            $scope.attributeTypes = ['String','List','Date'];
             $scope.hide = function() {
                 $mdDialog.hide();
             };
             $scope.cancel = function() {
                 $mdDialog.cancel();
             };

            $scope.addNewAttribute = function() {
                var newAttribute = {
                    label:'',
                    type:'String',
                    range:false,
                    listReference:'e.g. A,B,C'
                }
                if($scope.attributes == null)   $scope.attributes =[];
                $scope.attributes.push(newAttribute);
            };

            $scope.save = function() {
                //Getting the updated attributes list
                $scope.currentObject.attributes = $scope.attributes;
                RestAPIService.updateObject($scope.currentObject).then(
                    function(success) {
                        $state.reload();
                    },
                    function(error) {
                        RestAPIService.showErrorDialog(error);
                    }
                );
                $mdDialog.hide();

                $mdDialog.show(
                    $mdDialog.alert()
                    .clickOutsideToClose(true)
                    .title('Success!')
                    .textContent('Attributes of '+$scope.currentObject.name+' has been successfully updated')
                    .ok('Ok')
                );
                
            };

         }
   
        }   
})();  
(function ()
{
    'use strict';

    angular
        .module('app.businessadmin')
        .controller('AdminController', AdminController);

    /** @ngInject */
    function AdminController($state)
    {
        var adminCtrl = this;      
        adminCtrl.goToAdminuser = function(){
         $state.go('app.businessadmin.content');
        }
        adminCtrl.gotoApprovalMatrix = function(){
             $state.go('app.administration.approvematrix');
        }
        
        adminCtrl.goToUsers =function(){
        	$state.go('app.businessadmin.users');
        }
        adminCtrl.goToGroups =function(){
        	$state.go('app.businessadmin.groups');
        }

        adminCtrl.goToTemplates =function(){
        $state.go('app.businessadmin.template');
        }
        adminCtrl.goToadmin =function()
        {
        	$state.go('app.businessadmin');
        }
        adminCtrl.goToApprove =function(){
           	$state.go('app.businessadmin.approve');
        }
        adminCtrl.goToPermissions =function(){
        	$state.go('app.businessadmin.permissions');
        	
        }
        adminCtrl.goToAttributes =function(){
        	$state.go('app.businessadmin.attributes');
        	
        }
        adminCtrl.goToPortlets = function(){        	
        	$state.go('app.businessadmin.portlets');
        }
        adminCtrl.gotoVendorList =function(){
        	$state.go('app.businessadmin.Vendor');
        }
        adminCtrl.gotoPOTypes =function(){
        	$state.go('app.businessadmin.POTypes');
        }
        adminCtrl.gotoExpenseTypes =function(){
        	$state.go('app.businessadmin.ExpenseType');
        }
        adminCtrl.gotoCompanies =function(){
        	$state.go('app.businessadmin.Company');
        }
        adminCtrl.gotoGLAccounts =function(){
        	$state.go('app.businessadmin.GLAccount');
        }
        adminCtrl.gotoCustomerList =function(){
        	$state.go('app.businessadmin.PRTypes');
        }
        adminCtrl.gotoPlants =function(){
        	$state.go('app.businessadmin.Plants');
        }
        adminCtrl.gotoCostcenters =function(){
        	$state.go('app.businessadmin.Costcenter');
        }
        adminCtrl.gotoEmployeeList =function(){
        	$state.go('app.businessadmin.InvoiceType');
        }
        adminCtrl.gotoPurchaseOrg =function(){
        	$state.go('app.businessadmin.PurchaseOrg');	
        }
        adminCtrl.goToCategoryList =function(){
        	$state.go('app.businessadmin.CategoryList');	
        }
        adminCtrl.goToContractTypes =function(){
        	$state.go('app.businessadmin.contractTypes');	
        }
        }   
})();
(function ()
{
    'use strict';

    angular
        .module('app.binder', [] )
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider, $mdThemingProvider)
    {
         $stateProvider
            
            .state('app.binder', {
                url: '/binder',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/binder/binder.html',
                        controller:  'BinderController as binderCrtl'
                    }
                }
            });

      /*  msNavigationServiceProvider.saveItem('binder', {
            title : 'Binder',
            icon  : 'icon-book',
            state : 'app.binder',
            weight: 5
        });*/

    }
})();


(function() {
    'use strict';

    angular
        .module('app.binder')
        .controller('BinderController', BinderController);

    /** @ngInject */
    function BinderController($scope, $mdDialog, $state, RestAPIService,CommonUtil,CurrentBinderId) {
        var binderCrtl = this;
        var binderId = CurrentBinderId.value;
        if(!binderId)   binderId=1000133;
        binderCrtl.currentFolderId = '';
        $scope.detailsVisibility = false;
        $scope.versionsVisibility = false;

        $scope.filePath = [];
          binderCrtl.getbinderFiles = function() {
            RestAPIService.getbinderFiles(binderCrtl.currentFolderId,binderId).then(
                function(success) {
                    binderCrtl.files = success.data;
                },
                function(error) {
                    RestAPIService.showErrorDialog(error);
                });
        };
         RestAPIService.attributesThroughBinderId(binderId).then(
            function(response){
                $scope.binderObject = response.data;
            },
            function(error){
                RestAPIService.showErrorDialog(error);
            });

        binderCrtl.getbinderAttributes = function(fileId,binderId) {
            RestAPIService.getbinderAttributes(fileId).then(
                function(response) {
                    $scope.file = response.data;                    
                    binderCrtl.selectedFile = response.data;
                    binderCrtl.fileAttributes = response.data.attributes;
                    binderCrtl.allSharedUsers = response.data.users;
                },
                function(error) {
                    RestAPIService.showErrorDialog(error);
                }
            );
        };
         $scope.editorEnabled = false;
        $scope.enableEditor = function() {
            $scope.editorEnabled = true;
        };
        $scope.disableEditor = function() {
            $scope.editorEnabled = false;
        };
        $scope.saveAllAttributes = function() {
            $scope.disableEditor();
            //building the PUT object manually,i.e.JSON structure
            //because only share and attributes are editable 
            $scope.fileAttributesObject = {};
            $scope.fileAttributesObject.id = binderCrtl.selectedFile.id;
            
            //Appending dynamic file attributes
            $scope.fileAttributesObject.attributes = binderCrtl.fileAttributes; 
            //Appending the versions and activities AS IT IS-without any change
            $scope.fileAttributesObject.versions = binderCrtl.selectedFile.versions;
            $scope.fileAttributesObject.activities = binderCrtl.selectedFile.activities;
            $scope.fileAttributesObject.users = binderCrtl.selectedFile.users;

            //alert(JSON.stringify($scope.fileAttributesObject));
            RestAPIService.updatebinderFileAttrAndSharing($scope.fileAttributesObject).then(
                function(response){
                   //$state.reload();
                   //reloading is a bad UI experience.Hence calling GET again
                   binderCrtl.getbinderAttributes(binderCrtl.selectedFile.id);
                   $mdDialog.hide();
                },
                function(error){
                    RestAPIService.showErrorDialog(error);
                }
            );
        };
        binderCrtl.fileIcon = function(file){
            return CommonUtil.getIconForFile(file);
        }


        binderCrtl.selectFile = function(fileItem, i) {
            // $scope.fileType = fileItem.type;

            // binderCrtl.files.forEach(function(h) {
            //     if (h.iconsVisibility)  h.iconsVisibility = false;
            // });
            // binderCrtl.files[i]['iconsVisibility'] = true;
            $scope.iconsVisibility = i;
            $scope.detailsVisibility = true;

            if (fileItem.type === "folder") {
                $scope.versionsVisibility = false;
            } else {
                $scope.versionsVisibility = true;
            }

            binderCrtl.selectedFileName = fileItem.name;
            $scope.selectedFileIcon = CommonUtil.getIconForFile(fileItem);
            // Call API service to get attributes, versions and activities of this file.
            var fileId = fileItem.id;
            binderCrtl.getbinderAttributes(fileId);
        }
         $scope.addNewAttribute = function() {
            var newAttribute = {
                name: '',
                type:'String',
                label:'Enter name...',
                value:'Enter value...'
            }
            //Replacing all spaces with underscore in "label" and use it as "name"
            newAttribute.name = newAttribute.label.replace(/ /g,"_");
            binderCrtl.fileAttributes.push(newAttribute);
        
        };

        binderCrtl.allSharedUsers = [];

        binderCrtl.sharedUsersDialog = function(ev) {
            $mdDialog.show({
                controller: sharedUsersDialogController,
                templateUrl: 'app/main/binder/sharedUsersDialog.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: $scope.customFullscreen
            })

        }

        function sharedUsersDialogController($scope) {
            $scope.allSharedUsers = binderCrtl.allSharedUsers;
            $scope.selectedFileName = binderCrtl.selectedFileName;
            $scope.tableVisibility = false;


            $scope.searchUsers = function(searchKeyword) {
                RestAPIService.searchUsers(searchKeyword).then(
                    function(response) {
                        $scope.searchedUsers = response.data;
                        $scope.tableVisibility = true;
                    },
                    function(error) {
                        RestAPIService.showErrorDialog(error);
                    });
            }

            $scope.shareFile = function(memberData) {
                $scope.allSharedUsers.push(memberData);
            }

            $scope.removeSharing = function(userData, i) {
                $scope.allSharedUsers.splice(i, 1);
            }

            $scope.cancel = function() {
                $mdDialog.cancel();
            }

            $scope.fileAttributes = binderCrtl.fileAttributes;
            $scope.selectedFileName = binderCrtl.selectedFileName;
            $scope.updateFileSharing = function() {
                //building the PUT object manually,i.e.JSON structure
                //because only share and attributes are editable 
                $scope.fileSharingObject = {};
                $scope.fileSharingObject.id = binderCrtl.selectedFile.id;
                //Appending dynamic file attributes
                $scope.fileSharingObject.attributes = $scope.fileAttributes;
                //Appending the versions and activities AS IT IS-without any change
                $scope.fileSharingObject.versions = binderCrtl.selectedFile.versions;
                $scope.fileSharingObject.activities = binderCrtl.selectedFile.activities;
                //Updating the shared user object
                $scope.fileSharingObject.users = $scope.allSharedUsers;

                //alert(JSON.stringify($scope.fileAttributesObject));
                RestAPIService.updatebinderFileAttrAndSharing($scope.fileSharingObject,binderId).then(
                    function(response) {
                        //$state.reload();
                        //reloading is a bad UI experience.Hence calling GET again
                        binderCrtl.getbinderAttributes(binderCrtl.selectedFile.id);
                        $mdDialog.hide();
                    },
                    function(error) {
                        RestAPIService.showErrorDialog(error);
                        //alert(JSON.stringify(error));
                    });
                $mdDialog.hide();
            }
        }

        binderCrtl.doubleClick = function(file) {
            if (file.type == 'file') return;
            binderCrtl.currentFolderId = file.id;
            $scope.filePath.push(file);
            binderCrtl.getbinderFiles();

        };
        binderCrtl.gotoFolder = function(folder) {
            //Get the content of that specific folder
            binderCrtl.doubleClick(folder);

            //Delete the intermediate folder links that come after selected folder
            var currentPath = $scope.filePath;
            var i;
            for (i = 0; i < currentPath.length; i++) {
                if (currentPath[i].id == folder.id) {
                    $scope.filePath.splice(i + 1, (currentPath.length - i + 1));
                    break;
                }
            }
        }

        binderCrtl.currentFile = {};
        $scope.UpdatebinderFile = function(ev, file) {
            binderCrtl.currentFile = angular.copy(file);
            $mdDialog.show({
                controller: UpdateFileDialogController,
                templateUrl: 'app/main/binder/editbinderFiledialog.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: $scope.customFullscreen,
            })
            binderCrtl.name = file.name;
            binderCrtl.id = file.id;

        };

        function UpdateFileDialogController($scope, $mdDialog) {
            $scope.currentFile = binderCrtl.currentFile;

            $scope.hide = function() {
                $mdDialog.hide();
            };
            $scope.cancel = function() {
                $mdDialog.cancel();
            };
            $scope.updatebinderFile = function(file) {
                RestAPIService.updatebinderFile(file,binderId).then(
                    function(success) {
                        //Update successful. Need to refresh
                        //$state.reload();
                        //Reload is bad UI experience, hence executing GET again
                        binderCrtl.getbinderFiles();
                    },
                    function(error) {
                        RestAPIService.showErrorDialog(error);
                    }
                );
                $mdDialog.hide(file);
            };
        }


        binderCrtl.VersionFile = {};
        $scope.VersionFileDialog = function(ev, file) {
            binderCrtl.VersionFile = angular.copy(file);
            $mdDialog.show({
                controller: VersionFileDialogController,
                templateUrl: 'app/main/binder/VersionbinderFiledialog.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: $scope.customFullscreen,
            })
        };

        function VersionFileDialogController($scope, $mdDialog) {
            $scope.VersionFile = binderCrtl.VersionFile;
            $scope.selectedFileName = binderCrtl.selectedFileName;
            var formData = new FormData();
            $scope.setFile = function(element) {
                $scope.$apply(function() {
                    $scope.files = [];
                    for (var i = 0; i < element.files.length; i++) {
                        formData.append('file', element.files[i]);
                        $scope.files.push(element.files[i]);
                    }
                });
            };
            $scope.hide = function() {
                $mdDialog.hide();
            };
            $scope.cancel = function() {
                $mdDialog.cancel();
            };
            $scope.NewVersionbinderFile = function() {
                //alert(JSON.stringify(checkInfile));
                RestAPIService.NewVersionbinderFile($scope.files[0], binderCrtl.VersionFile,binderId).then(
                    function(success) {
                        //        //Update successful. Need to refresh
                        //$state.reload();
                        //Update the file attribute section. Calling get again
                        //reloading is a bad UI experience.Hence calling GET again
                        binderCrtl.getbinderAttributes(binderCrtl.selectedFile.id);
                        
                    },
                    function(error) {
                        // RestAPIService.showErrorDialog(error);
                        $mdDialog.show(
                            $mdDialog.alert()
                            .clickOutsideToClose(true)
                            .title('Error')
                            .textContent(error.data.description)
                            .ok('Ok')
                        );
                    }
                );
                $mdDialog.hide();
            };
        }
        binderCrtl.checkInFile = {};
        $scope.checkInFileDialog = function(ev, file) {
            binderCrtl.checkInFile = angular.copy(file);
            $mdDialog.show({
                controller: CheckInFileDialogController,
                templateUrl: 'app/main/binder/bindercheckInFiledialog.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: $scope.customFullscreen,
            })
        };

        function CheckInFileDialogController($scope, $mdDialog) {
            $scope.checkInFile = binderCrtl.checkInFile;
            var formData = new FormData();
            $scope.setFile = function(element) {
                $scope.$apply(function() {
                    $scope.files = [];
                    for (var i = 0; i < element.files.length; i++) {
                        formData.append('file', element.files[i]);
                        $scope.files.push(element.files[i]);
                    }
                });
            };
            $scope.hide = function() {
                $mdDialog.hide();
            };
            $scope.cancel = function() {
                $mdDialog.cancel();
            };
            $scope.binerfilecheckIn = function() {
                //alert(JSON.stringify(checkInfile));
                RestAPIService.binerfilecheckIn($scope.files[0], binderCrtl.checkInFile, binderCrtl.currentFolderId,binderId).then(
                    function(success) {
                        //alert("checkIn Success")
                        //$state.reload();
                        $mdDialog.show(
                            $mdDialog.alert()
                            .clickOutsideToClose(true)
                            .title('Success!')
                            .textContent('File checked in successfully')
                            .ok('Ok')
                        );
                    },
                    function(error) {
                            $mdDialog.show(
                            $mdDialog.alert()
                            .clickOutsideToClose(true)
                            .title('Error')
                            .textContent(error.data.description)
                            .ok('Ok')
                        );
                    }
                );
                $mdDialog.hide();
            };
        }
        binderCrtl.deleteFile = function(ev, file) {
            var confirm = $mdDialog.confirm()
                .title('Remove')
                .textContent('File ' + file.name + ' will be permanently deleted. Continue ?')
                .targetEvent(ev)
                .ok('Ok')
                .cancel('Cancel');
            $mdDialog.show(confirm).then(function() {
                RestAPIService.deletebinderFile(file.id,binderId).then(
                    function(success) {
                        //delete successful. Need to refresh                        
                        // Making the Attributes, versions, activities and shared users as  empty when a file was deleted.                        
                        $scope.file = {};
                        binderCrtl.fileAttributes = {};
                        binderCrtl.allSharedUsers = {};
                        // Show the <div> consisting of " Select a file or folder to view its details."
                        $scope.detailsVisibility = false;
                        //$state.reload();
                        //Reload is bad UI experience, hence executing GET again
                        binderCrtl.getbinderFiles();
                    },
                    function(error) {
                        RestAPIService.showErrorDialog(error);
                    }
                );
            }, function() {
                $mdDialog.cancel();
            });
        }

        $scope.downloadbinderFile = function(fileId) {
            RestAPIService.downloadbinderFile(fileId,binderId).then(
                function(success) {
                   // alert(JSON.stringify(success));
                    var headers = success.headers();
                    //alert(JSON.stringify(headers));
                    var data = success.data;
                    //alert(data);
                    //var filename = headers['x-filename'];
                    var filename = binderCrtl.selectedFileName;
                    var contentType = headers['content-type'];
                    var linkElement = document.createElement('a');
                    try {
                        var blob = new Blob([data], {
                            type: contentType
                        });
                        var url = window.URL.createObjectURL(blob);
                        linkElement.setAttribute('href', url);
                        linkElement.setAttribute("download", filename);
                        var clickEvent = new MouseEvent("click", {
                            "view": window,
                            "bubbles": true,
                            "cancelable": false
                        });
                        linkElement.dispatchEvent(clickEvent);
                    } catch (ex) {
                        alert(JSON.stringify(ex));
                        console.log(ex);
                    }
                },
                function(error) {
                    console.log('ERROR Downloading the file ********');
                    RestAPIService.showErrorDialog(error);
                }
            );
        }
        $scope.downloadVersionedbinderFile = function(fileId, versionNo,binderId) {
            RestAPIService.downloadVersionedbinderFile(fileId, versionNo).then(
                function(success) {
                    var headers = success.headers();
                    var data = success.data;
                    var filename = binderCrtl.selectedFileName;
                    var contentType = headers['content-type'];
                    var linkElement = document.createElement('a');
                    try {
                        var blob = new Blob([data], {
                            type: contentType
                        });
                        var url = window.URL.createObjectURL(blob);
                        linkElement.setAttribute('href', url);
                        linkElement.setAttribute("download", filename);
                        var clickEvent = new MouseEvent("click", {
                            "view": window,
                            "bubbles": true,
                            "cancelable": false
                        });
                        linkElement.dispatchEvent(clickEvent);
                    } catch (ex) {
                        console.log(ex);
                    }
                },
                function(error) {
                    console.log('ERROR Downloading the file ********');
                    RestAPIService.showErrorDialog(error);
                }
            );
        }
        $scope.binderfileCheckout = function(fileId) {
            RestAPIService.binderfileCheckout(fileId,binderId).then(
                function(success) {
                    var headers = success.headers();
                    var data = success.data;
                    var filename = binderCrtl.selectedFileName;
                    var contentType = headers['content-type'];
                    var linkElement = document.createElement('a');
                    try {
                        var blob = new Blob([data], {
                            type: contentType
                        });
                        var url = window.URL.createObjectURL(blob);
                        linkElement.setAttribute('href', url);
                        linkElement.setAttribute("download", filename);
                        var clickEvent = new MouseEvent("click", {
                            "view": window,
                            "bubbles": true,
                            "cancelable": false
                        });
                        linkElement.dispatchEvent(clickEvent);
                    } catch (ex) {
                        console.log(ex);
                    }
                },
                function(error) {
                    console.log('ERROR Downloading the file ********');
                    //RestAPIService.showErrorDialog(error);  
                    $mdDialog.show(
                        $mdDialog.alert()
                        .clickOutsideToClose(true)
                        .title('Error')
                        .textContent()
                        .ok('Ok')
                    );

                }
            );
        }
        $scope.createFile = function(ev) {
            $mdDialog.show({
                controller: CreateFileDialogController,
                templateUrl: 'app/main/binder/upload.binderdialog.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: $scope.customFullscreen
            })
        };

        function CreateFileDialogController($scope, $http, RestAPIService, $mdDialog, $state, $window) {
            var formData = new FormData();
            $scope.setFile = function(element) {
                $scope.$apply(function() {
                    $scope.files = [];
                    for (var i = 0; i < element.files.length; i++) {
                        formData.append('file', element.files[i]);
                        $scope.files.push(element.files[i]);
                    }
                });
            };
            $scope.hide = function() {
                $mdDialog.hide();
            };
            $scope.cancel = function() {
                $mdDialog.cancel();
            };
            $scope.uploadbinderFile = function(ev, name) {
                var folderName = name;
                var files = $scope.files;
                if (files == undefined && folderName == undefined) {
                    $scope.ErrorMsg = "Please upload a file or create new folder"
                } else if (files != undefined || folderName == undefined) {
                    // alert("File Uploaded Successfully");
                    RestAPIService.uploadbinderFile($scope.files[0], binderCrtl.currentFolderId,binderId).then(
                        function(success) {
                            $mdDialog.show(
                                $mdDialog.alert()
                                .clickOutsideToClose(true)
                                .title('Success!')
                                .textContent('File uploaded successfully')
                                .ok('Ok')
                            );

                            //$state.reload();
                            //Reload is bad UI experience, hence executing GET again
                            binderCrtl.getbinderFiles();
                        },
                        function(error) {
                            RestAPIService.showErrorDialog(error);
                        }
                    );
                    $mdDialog.hide(ev);

                } else if (files == undefined || folderName != undefined) {

                    //alert("folder Created Successfully");
                    RestAPIService.createbinderFolder(name, binderCrtl.currentFolderId,binderId).then(
                        function(success) {
                            $mdDialog.show(
                                $mdDialog.alert()
                                .clickOutsideToClose(true)
                                .title('Success!')
                                .textContent('Folder created successfully')
                                .ok('Ok')
                            );
                            //$state.reload();
                            //Reload is bad UI experience, hence executing GET again
                            binderCrtl.getbinderFiles();
                        },
                        function(error) {
                            RestAPIService.showErrorDialog(error);
                        }
                    );
                    $mdDialog.hide(ev);
                };
            };
        }

        

    }
})();
 
(function() {
    'use strict';
    angular.module('app.administration') .service('FormService', function($http, $q,$localStorage) {
    	return {
            fields:[
    			 
                {
                	name : 'date',
                	value : 'Date'
                },
                {
                    name : 'textfield',
                    value : 'Input'
                },
                {
                    name : 'textarea',
                    value : 'Input Area'
                },
                {
                    name : 'dropdown',
                    value : 'Dropdown'
                },
                {
                	name : 'checkboxMultiselect',
                    value : 'Checkboxes'
                },
                {
                    name : 'radio',
                    value : 'Radio Button'
                } 
            ] 
              
            
        }
         
        });
})();

(function ()
{
    'use strict';

    angular
        .module('app.Adminsubstitution')
        .controller('AdminSubstitution', AdminSubstitution);
        

    /** @ngInject */
    function AdminSubstitution($scope,RestAPIService,$state, $mdDialog, $sessionStorage,$localStorage)
    {
    	 var subCtrl = this;    
      	 $scope.substitute = [];
    	 subCtrl.getAllSubstitutes = function(){
    		 $scope.substitute = [];
    		 RestAPIService.getAllSubstitutes().then(
                     function(success) {
                         $scope.allSubstitutes = success.data;
                         $scope.allSubstitutes.forEach(function(h) {
                             if(h.eliminationUser == null && h.substituteuser != ""){
                             	$scope.substitute.push(h);
                             }
                              
                          })
                     },
                     function(error) {
                         RestAPIService.showErrorDialog(error);
                     }
                 ); 
    	 }
    	 $scope.createSubstitutor = function(ev){
         	$mdDialog.show({
         		templateUrl: 'app/main/administration/admin-substitution/admin.create.substitution.html',
                 controller: CreateSubstitutorDialogController,                
                 parent: angular.element(document.body),
                 targetEvent: ev,
                 clickOutsideToClose: true,
                 fullscreen: $scope.customFullscreen
             })
         }    	 
         function CreateSubstitutorDialogController($scope, $mdDialog, $sessionStorage){
         	$scope.getAllUsers = function(){
             	RestAPIService.getUsers().then(
                         function(success) {
                             $scope.usersList = success.data;                       
                         },
                         function(error) {
                             RestAPIService.showErrorDialog(error);
                         }
                     );
             }
         	$scope.cancel = function() {
                $mdDialog.cancel();
         	};
         	$scope.dateVis = false;
         	$scope.save = function(data){
         		if((data.from_date == undefined || data.from_date =="") || (data.to_date == undefined || data.to_date =="")){
         			$scope.dateVis = true;
         		}else{
         			data['createdBy'] = $sessionStorage.currentUser.username;
             		var d = new Date(data.from_date);
             			data.from_date = d;
             		
             		var e = new Date(data.to_date);
             		e.setHours(e.getHours()+23);
             		data.to_date = e;
             		
             		console.log(data);
             		RestAPIService.createSubstitutor(data).then(
                             function(success) {
//                                 $scope.usersList = success.data;
                            	 $mdDialog.show(
                             		      $mdDialog.alert()
                             		        .parent(angular.element(document.querySelector('#popupContainer')))
                             		        .clickOutsideToClose(true)
                             		        .title('Success.')
                             		        .textContent("Substitution created successfully.")
//                             		        .htmlContent("<h4><b>"+requestId+ "</b> was Rejectd successfully.</h4>")
                             		        .ariaLabel('Alert Dialog Demo')
                             		        .ok('Ok')
//                             		        .targetEvent(ev)
                             		    );
                             	$mdDialog.cancel();
                             	subCtrl.getAllSubstitutes();
                             },
                             function(error) {
                                 RestAPIService.showErrorDialog(error);
                             }
                         );
         			
         		}
         		
         		
         	}
         }
         $scope.update = function(ev, item){
    		 subCtrl.substitutionItem = angular.copy(item);
         	$mdDialog.show({
         		templateUrl: 'app/main/administration/admin-substitution/admin.update.substitution.html',
                 controller: UpdateUserDialogController,                
                 parent: angular.element(document.body),
                 targetEvent: ev,
                 clickOutsideToClose: true,
                 fullscreen: $scope.customFullscreen
             })
    	 }
         function UpdateUserDialogController($mdDialog, $scope, RestAPIService){        	
         	$scope.substitutionItem = subCtrl.substitutionItem;        		
         	$scope.cancel = function() {
                 $mdDialog.cancel();
          	};
          	$scope.getAllUsers = function(){
             	RestAPIService.getUsers().then(
                         function(success) {
                             $scope.usersList = success.data;                       
                         },
                         function(error) {
                             RestAPIService.showErrorDialog(error);
                         }
                     );
             }
          	$scope.update = function(ev, data){
          		var d = new Date(data.fromDate);
         		/*d.setHours(d.getHours()+10);
         		data.fromDate = d;*/
          		//d.setMinutes(59);
         		data.fromDate = d;
         		
         		var e = new Date(data.toDate);
         		/*e.setHours(e.getHours()+10);*/
         		e.setHours(e.getHours()+23);
         		/*d.setMinutes(59);*/
         		data.toDate = e;
           		RestAPIService.updateSubstitutor(data).then(
                         function(success) {
                         	$mdDialog.cancel();
                         	$mdDialog.show(
                        		      $mdDialog.alert()
                        		        .parent(angular.element(document.querySelector('#popupContainer')))
                        		        .clickOutsideToClose(true)
                        		        .title('Success.')
                        		        .textContent("Substitution updated successfully.")
//                        		        .htmlContent("<h4><b>"+requestId+ "</b> was Rejectd successfully.</h4>")
                        		        .ariaLabel('Alert Dialog Demo')
                        		        .ok('Ok')
//                        		        .targetEvent(ev)
                        		    );
                         	subCtrl.getAllSubstitutes();
                         },
                         function(error) {
                             RestAPIService.showErrorDialog(error);
                         });
          	}
         }
         $scope.delete = function(ev, data){
         	var confirm = $mdDialog.confirm()
             .title('Remove')
             .textContent('Substitution will be permanently deleted. Continue ?')
             .targetEvent(ev)
             .ok('Ok')
             .cancel('Cancel');
         $mdDialog.show(confirm).then(function() {
         	RestAPIService.deleteSubstitutor(data).then(
                     function(success) {                   
//                     	RestAPIService.successTostDialog("Successfully Deleted.");
                    	 $mdDialog.show(
                     		      $mdDialog.alert()
                     		        .parent(angular.element(document.querySelector('#popupContainer')))
                     		        .clickOutsideToClose(true)
                     		        .title('Success.')
                     		        .textContent("Substitution deleted successfully.")
//                     		        .htmlContent("<h4><b>"+requestId+ "</b> was Rejectd successfully.</h4>")
                     		        .ariaLabel('Alert Dialog Demo')
                     		        .ok('Ok')
//                     		        .targetEvent(ev)
                     		    );
                     	subCtrl.getAllSubstitutes();
                     },
                     function(error) {
                         RestAPIService.showErrorDialog(error);
                     }
                 );
             
         }, function() {
             $mdDialog.cancel();
         });
         	
         }
        
    }


         
})();
(function() {
    'use strict';

    var app = angular
        .module('app.verification', [])
        //.run(run)
        .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider, $controllerProvider, $compileProvider, $filterProvider, $provide) {
        app.controller = $controllerProvider.register;
        app.directive = $compileProvider.directive;
        app.filter = $filterProvider.register;
        app.factory = $provide.factory;
        app.service = $provide.service;

        $stateProvider
            .state('app.verification', {
                url: '/smartportal/verification',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/Verify/verification.html',
                        controller: 'Verificationcontoller as verifyCtrl'
                    }
                }
                
            })
        //  msNavigationServiceProvider.saveItem('Verification', {
        //      title: 'Verify',
        //      icon: 'icon-verified',
        //      state: 'app.verification',
        //      weight: 24           
             
        //  });
        }
    
})();
(function() {
    'use strict';

    angular
        .module('app.verification')
        .controller('Verificationcontoller', Verificationcontoller);

    /** @ngInject */
    function Verificationcontoller($state, $scope, RestAPIService, $filter, $mdDialog) {
    	var verifyCtrl = this;
    
    	
    
    	 
    	
    }


})();
(function() {
    'use strict';

    angular
        .module('app.ticketManagement', [])
        .config(config)
        .run(run);
    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
        $stateProvider
            .state('app.addTicket', {
                url: '/smartportal/addTicket',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/TicketManagement/addTicket.html',
                        controller: 'AddTicketController as tktCtrl'
                    }
                }
                ,
                resolve: {                
                	RestAPIService: 'RestAPIService',
                    Tickets: function(RestAPIService) {
                        return RestAPIService.getAllTickets();
                    }
                }
            })
            .state('app.ticketsList', {
                url: '/smartportal/tickets',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/TicketManagement/tickets.html',
                        controller: 'AddTicketController as tktCtrl'
                    }
                },
                resolve: {
                	RestAPIService: 'RestAPIService',
                    Tickets: function(RestAPIService) {
                        return RestAPIService.getAllTickets();
                    }
                }
            })
            .state('app.ticketDetails', {
                url: '/smartportal/ticketDetails',
                params: {
                    param1: null
                   },
                views: {
                    'content@app': {
                        templateUrl: 'app/main/TicketManagement/ticketDetails.html',
                        controller: 'AddTicketController as tktCtrl'
                    }
                },
                resolve: {
                	RestAPIService: 'RestAPIService',
                    Tickets: function(RestAPIService) {
                        return RestAPIService.getAllTickets();
                    }
                }
            });

    //    msNavigationServiceProvider.saveItem('ticket', {
    //        title: 'Add Ticket',
    //        icon: 'icon-read',
    //        state: 'app.addTicket',
    //        translate: 'Add Ticket',
    //        weight: 16,
        
    //    });
    }
    function run(msNavigationService, $localStorage, $rootScope, $state) {
        msNavigationService.saveItem('ticket', {
            title: 'Add Ticket',
            icon: 'icon-read',
            state: 'app.addTicket',
            translate: 'Add Ticket',
            weight: 16,
            hidden:function(){
              if ($localStorage.menubarsetting != undefined) {
                var show = $localStorage.menubarsetting.addTicket;
                return !(show);
            }
            }
        });
    }

})();
 (function() {
     'use strict';
     angular
         .module('app.ticketManagement')
         .controller('AddTicketController', AddTicketController);

     function AddTicketController($state, $http, $scope, $mdDialog, RestAPIService, Tickets, $stateParams,$rootScope) {    	 
         var tktCtrl = this;         
         $scope.allTickets = Tickets.data;         
         $scope.buttonDis = false;
         $scope.requestTypes=["Issue","Question","Task","Incident","Other"];
         $scope.Priorities=["Low","Normal","High","Urgent"];
         $scope.products=["SmartPortal","Icontracts","SmartFlow","SmartPayables","SmartKey"];
         $scope.status=["Open","Pending","Solved"];
         $scope.ticketData = $stateParams.param1;
         tktCtrl.dtOptions = {

                 dom: '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
                 pagingType: 'simple',
                 autoWidth: false,
                 responsive: true,
             }
        $scope.attachmentfiles = [];
         $scope.setAttachmentFile = function(element) {
             var formData = new FormData();
             $scope.$apply(function() {
                 // $scope.attachmentfiles = [];
                 for (var i = 0; i < element.files.length; i++) {
                     formData.append('file', element.files[i]);
                     $scope.attachmentfiles.push(element.files[i]);
                 }
             });
         };

         $scope.buttonDis = false;
         $scope.addTicket = function(ticketData, description){
        	 $scope.buttonDis = true;
        	 $scope.ticketData= ticketData;        	 
        	 var json = {};
        	 json.docType = "TICKET";
         	json.description = description;
         	json.header = ticketData;
            json.header['firstName'] = $rootScope.currentLogedInUser.firstName;
            json.header['lastName'] = $rootScope.currentLogedInUser.lastName;
         	json.lineItems = {};
         	console.log(json);
         	RestAPIService.sendFormData(json, $scope.attachmentfiles).then(
                    function(success) {
                    	
                    	$mdDialog.show(
                     		      $mdDialog.alert()
                     		        .parent(angular.element(document.querySelector('#popupContainer')))
                     		        .clickOutsideToClose(true)
                     		        .title('Success.')
//                     		        .textContent("Collaboration sent successfully.")
                     		        .htmlContent("Ticket is created successfully")
                     		        .ariaLabel('Alert Dialog Demo')
                     		        .ok('Ok')
//                     		        .targetEvent(ev)
                     		    );
                    	
                      $state.go('app.mycontent_inbox');
                    },
                    function(error) {
                        RestAPIService.showErrorDialog(error);
                        alert("not success");
                });
         }
         $scope.selectTicket = function(ticketData){
         	$scope.data= ticketData;         	
         	$state.go('app.ticketDetails',
         			{'param1': $scope.data}         	
         	);
         	tktCtrl.requestId = $scope.data.requestId;
         }
         $scope.ticket = {};
         $scope.sendReply = function(ticketdata){
         	
         	RestAPIService.sendReply(ticketdata.description,$scope.ticketData.requestId).then(function(responce){
         		$scope.ticketData = responce.data;
         		$scope.ticket.description = "";
         	},
         	function(error){
         		RestAPIService.showErrorDialog(error);
         	})
         	
         }
         $scope.goBack = function(){
        	 $state.go('app.ticketsList');
         }
     }
 })();
(function ()
{
    'use strict';

    angular
        .module('app.requests', ['material.components.expansionPanels','moment-picker'] )
        .config(config)
       .run(run)
        .directive('compileTemplate', function($compile, $parse) {
            return {
                link: function(scope, element, attr) {
                    var parsed = $parse(attr.ngBindHtml);
                    function getStringValue() {
                        return (parsed(scope) || '').toString();
                    }
                    scope.$watch(getStringValue, function() {
                        $compile(element, null, -9999)(scope);
                    });
                }
            }
        });

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider, $mdThemingProvider)
    {
    	 $stateProvider

            .state('app.requests', {
                url: '/smartportal/requests',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/Requests/requestsOverviewPage.html',
                        controller:  'RequestsController as requestCtrl'
                    }
                },
                resolve: {
                    RestAPIService: 'RestAPIService',
                    ReqTypes: function(RestAPIService) {
                        return RestAPIService.getRequests();
                    },
                    MaterialTypes: function(RestAPIService) {
                        return RestAPIService.GetMaterialTypes();
                    },
                    Plants: function(RestAPIService) {
                        return RestAPIService.GetPlants();
                    },
                    PRDoctypes: function(RestAPIService){
                        return RestAPIService.getDocTypes("pr_doctype");
                    },
                    PurchaseGroups:function(RestAPIService){
                        return RestAPIService.getDocTypes("purchasegroup");

                    },
                    BlockList:function(RestAPIService){
                        return RestAPIService.getBlockList("block_text");
                    }
                }
            })
            .state('app.requests.content', {
                url: '/content/:reqId',
                params: {
                    'reqId': null,
                    'docType':null,
                    'name' :null
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/main/Requests/requests.content.html',
                        controller: 'RequestsController as requestCtrl'
                        // controller: 'Alkem_RequestsController as requestCtrl'
                    }
                }
            })

    //   msNavigationServiceProvider.saveItem('Request', {
    //         title : 'Request',
    //         icon  : 'icon-read',
    //         state : 'app.requests',
    //         weight: 3
    //     });

    }


    function run(msNavigationService, $localStorage, $rootScope, $state) {
      msNavigationService.saveItem('Request', {
        title : 'Request',
        icon  : 'icon-read',
        state : 'app.requests',
        weight: 3,
          hidden:function(){
            if ($localStorage.menubarsetting != undefined) {
              var show = $localStorage.menubarsetting.request;
              return !(show);
          }
          }
      });
  }
})();


(function ()
{
    'use strict';

    angular
        .module('app.requests')
        .controller('RequestsController', RequestsController);
       
    /** @ngInject */
    
    function RequestsController($state,$filter, $stateParams,$scope, $mdDialog,$localStorage, RestAPIService, $sce, ReqTypes,$rootScope)
    {   var requestCtrl =this;
        $scope.reqTypes = ReqTypes.data;
        $scope.request = {};
        $scope.header = {};
        $scope.currencies = ["INR","USD","EUR","PLN"];
        $scope.docTypes = ["EX-1","Ex-2","Ex-3"];
        $scope.invoiceTypes = ["NPO"];
        $scope.lineItems=[{}];       
        var name =$rootScope.currentLogedInUser;
        requestCtrl.currentUserobj = $localStorage.logedInuserdetail.currentLogedInUser.login;
        console.log(requestCtrl.currentUserobj)
        $scope.isUpdatable = true;
        $scope.toggle = [];
        $scope.arrow =[]; 
       
       
        $scope.changeInvoiceOption=function(){
            if( $scope.header.INVOICE_CAT == "EMP_ADV_T"){
                $scope.header.XBLNR ="Travel Advance";
                $scope.header.ZUMSK ="V";
            }
            if( $scope.header.INVOICE_CAT == "EMP_ADV_V"){
                $scope.header.XBLNR ="Other Advance";
                $scope.header.ZUMSK ="T";

            }

        }
    //     var now = moment();
    //  requestCtrl.format = 'DD/MM/YYYY'; 
    //  requestCtrl.maxDate = now.format(requestCtrl.format);
    //     console.log( requestCtrl.maxDate)
        $scope.toggleFilter = function(inx) {
            $scope.arrow[inx]=$scope.arrow[inx] === true ? false :true;
        $scope.toggle[inx] = $scope.toggle[inx] === true ? false : true;
        };
        $scope.addLineItem = function() {
            $scope.lineItems.push({ });
        }       
        $scope.goToRequests = function(){
            $state.go('app.requests');
        }
        $scope.name = $stateParams.name;

        if($scope.name == null || $scope.name == undefined){
            $state.go('app.requests');
        }
        $scope.removeLineItem = function(index) {
            $scope.lineItems.splice(index, 1);
        }
        $scope.deleteworkItem= function(index) {
            $scope.lineItems.splice(index, 1);
        }
        
        requestCtrl.goToRequests = function() {
            $state.go('app.requests');
        }
        $scope.selectDoctype = function(doc) {
            $state.go('app.requests.content',{'docType':doc.id,'reqId': doc.formId,'name':doc.name});
        }
        $scope.selectmanualDoctype = function(doc) {
            $state.go('app.requests.content',{'docType':'COR_ADV','reqId':'coromandeladvancepayment18may','name':doc.name});
        }
        $scope.getAnotherIcon = function(index) {
            $scope.icons = ['icon-account', 'icon-cash-100', 'icon-account-switch', 'icon-file-document', 'icon-cash-usd', 'icon-chart-bar'];
            var totalNoOfIcons = $scope.icons.length;
            return $scope.icons[index % totalNoOfIcons];
        }
        $scope.getAnotherColor = function(index) {
            $scope.colors = ['blue-grey-bg white-fg','blue-bg white-fg','green-bg white-fg',  'orange-bg white-fg','red-bg white-fg'];
           var totalNoOfColors = $scope.colors.length;
           return $scope.colors[index % totalNoOfColors];
       }
       $scope.attachmentfiles = [];
       $scope.setAttachmentFile = function(element) {
        var formData = new FormData();
        $scope.$apply(function() {            
            for (var i = 0; i < element.files.length; i++) {
                formData.append('file', element.files[i]);
                $scope.attachmentfiles.push(element.files[i]);
            }
        });
      };


      // MTR search helps
     $scope.openMTRSearchHelp = function(tabName, listName, lineitemIndex){
        requestCtrl.mtrTabName = tabName;
        requestCtrl.mtrListName = listName;
        requestCtrl.lineitemIndex = lineitemIndex;
        $mdDialog.show({
              controller: MTRSearchHelpDialogCtrl,
              preserveScope: true,
              autoWrap: true,
              templateUrl: 'app/main/Requests/mtr-search-help.html',
              clickOutsideToClose:false
          });
     }
     function MTRSearchHelpDialogCtrl($scope, $mdDialog){
        $scope.mtrListName = requestCtrl.mtrListName;
        $scope.pageNumber = 0;
        $scope.pageSize = 500;
        $scope.dynamicdata1 = [];
        $scope.searchObj = {};
        $scope.getListData = function () {
        RestAPIService.getDynamicList(requestCtrl.mtrListName, $scope.pageNumber, $scope.pageSize).then(function (responce) {
          $scope.listData = responce.data;
          $scope.keys = Object.keys(responce.data[1]);
          $scope.numberOfElements = responce.headers('x-total-count');
          $scope.resultsLength = responce.data.length;
          if(responce.data.length > 0){
            for(var prop in responce.data[0]){
                if(responce.data[0].hasOwnProperty(prop)){
                    if ($.inArray(prop, $scope.dynamicdata1) === -1) {
                        $scope.dynamicdata1.push(prop);
                    }
                } 
            }
          }           
        });
      };
      $scope.mtrSearchHelpSearch = function(searchObj){
        // Make the page number to 0
        $scope.pageNumber = 0;
        RestAPIService.getDynamicInstanceDataByMultipleValues($scope.mtrListName,[searchObj.key], [searchObj.value]).then(function(responce){
            $scope.listData = responce.data;
            // $scope.keys = Object.keys(responce.data[1]);
            $scope.numberOfElements = responce.headers('x-total-count');
            $scope.resultsLength = responce.data.length;
            if(responce.data.length > 0){
            for(var prop in responce.data[0]){
                if(responce.data[0].hasOwnProperty(prop)){
                    if ($.inArray(prop, $scope.dynamicdata1) === -1) {
                        $scope.dynamicdata1.push(prop);
                    }
                } 
            }
            } 
        })
     }
     $scope.reserMTRSearch = function(){
         $scope.searchObj= {};
         $scope.mtrSearchHelpSearch($scope.searchObj);
     }
      $scope.getListData();
      $scope.selectRow = function(data){
        requestCtrl.setMTRData(data);
        $scope.cancel();
      }
      $scope.cancel = function () {
        $mdDialog.cancel();
      }
      $scope.next = function () {
        $scope.pageNumber = $scope.pageNumber + 1;
        $scope.getListData();
      }
      $scope.previous = function () {
        $scope.pageNumber = $scope.pageNumber - 1;
        $scope.getListData();
      }      
     }
     requestCtrl.setMTRData = function(data){
        if(requestCtrl.mtrTabName == 'header'){
            if(requestCtrl.mtrListName == 'Invoicecat'){
                $scope.header.INVOICE_CAT = data.INV_CAT;
                $scope.header.INVOICE_CAT_TEXT = data.TEXT;
            }else if(requestCtrl.mtrListName == 'Companycode'){
                $scope.header.BUKRS = data.BUKRS;
            }else if(requestCtrl.mtrListName == 'Vendors'){
                $scope.header.LIFNR = data.LIFNR;
                $scope.header.NAME1 = data.VENDOR_NAME;
            }else if(requestCtrl.mtrListName == 'Currency'){
                $scope.header.WAERS = data.WAERS;
            }else if(requestCtrl.mtrListName == 'Department'){
                $scope.header.DEPT = data.DEPT;
            }else if(requestCtrl.mtrListName == 'MTRGST'){
                $scope.header.MTR_GST = data.MTR_GST;
            }
        }else if(requestCtrl.mtrTabName == 'line-item'){
            if(requestCtrl.mtrListName == 'Companycode'){
                $scope.lineItems[requestCtrl.lineitemIndex].BUKRS  = data.BUKRS;
            }else if(requestCtrl.mtrListName == 'Plant'){
                $scope.lineItems[requestCtrl.lineitemIndex].WERKS  = data.WERKS_D;
            }else if(requestCtrl.mtrListName == 'GLaccount'){
                $scope.lineItems[requestCtrl.lineitemIndex].HKONT  = data.SAKNR;
            }else if(requestCtrl.mtrListName == 'CostCenter'){
                $scope.lineItems[requestCtrl.lineitemIndex].KOSTL  = data.KOSTL;
            }else if(requestCtrl.mtrListName == 'Taxcode'){
                $scope.lineItems[requestCtrl.lineitemIndex].MWSKZ  = data.MWSKZ;
            }else if(requestCtrl.mtrListName == 'Order'){
                $scope.lineItems[requestCtrl.lineitemIndex].AUFNR  = data.AUFNR;
            }else if(requestCtrl.mtrListName == 'HsnCode'){
                $scope.lineItems[requestCtrl.lineitemIndex].HSN_SAC  = data.STEUC;
            }
        }
     }

      $scope.sendFormData = function(){   
        if($stateParams.name=="COR_ADV"){
            if($scope.header.SBU == undefined || $scope.header.SBU == null || $scope.header.SBU == "" || $scope.header.LOCATION == undefined || $scope.header.LOCATION == null || $scope.header.LOCATION == "" ){
                $mdDialog.show(
                    $mdDialog.alert()
                      .parent(angular.element(document.querySelector('#popupContainer')))
                      .clickOutsideToClose(true)
                      .title()
                      .htmlContent("<h4>Please contact administrator</h4>")
                      .ariaLabel('Alert Dialog Demo')
                      .ok('Ok'));
                      return;

            }
        }
      if($scope.header.POSTING_DATE != undefined && $scope.header.POSTING_DATE != null){
            var d = $scope.header.POSTING_DATE;
            $scope.month = parseInt(d.getMonth()+1);
            $scope.date =parseInt(d.getDate());
            $scope.month = $scope.month < 10 ? ("00" + $scope.month).slice(-2) : $scope.month;
            $scope.date = $scope.date < 10 ? ("00" + $scope.date).slice(-2) : $scope.date;
            $scope.header.POSTING_DATE = ((d.getFullYear().toString()).concat(($scope.month).toString())).concat(($scope.date).toString());
        }
        if($scope.header.BLDAT != undefined && $scope.header.BLDAT != null){
            var d = $scope.header.BLDAT._d;
            $scope.month = parseInt(d.getMonth()+1);
            $scope.date =parseInt(d.getDate());
            $scope.month = $scope.month < 10 ? ("00" + $scope.month).slice(-2) : $scope.month;
            $scope.date = $scope.date < 10 ? ("00" + $scope.date).slice(-2) : $scope.date;
            $scope.header.BLDAT = ((d.getFullYear().toString()).concat(($scope.month).toString())).concat(($scope.date).toString());
        }
        if($scope.header.BUDAT != undefined && $scope.header.BUDAT != null){
            var d =  $scope.header.BUDAT._d;
            $scope.month = parseInt(d.getMonth()+1);
            $scope.date =parseInt(d.getDate());
            $scope.month = $scope.month < 10 ? ("00" + $scope.month).slice(-2) : $scope.month;
            $scope.date = $scope.date < 10 ? ("00" + $scope.date).slice(-2) : $scope.date;
            $scope.header.BUDAT = ((d.getFullYear().toString()).concat(($scope.month).toString())).concat(($scope.date).toString());
        }
        if($scope.header.RECEIPT_DATE != undefined && $scope.header.RECEIPT_DATE != null){
            var d =  $scope.header.RECEIPT_DATE._d;
            $scope.month = parseInt(d.getMonth()+1);
            $scope.date =parseInt(d.getDate());
            $scope.month = $scope.month < 10 ? ("00" + $scope.month).slice(-2) : $scope.month;
            $scope.date = $scope.date < 10 ? ("00" + $scope.date).slice(-2) : $scope.date;
            $scope.header.RECEIPT_DATE = ((d.getFullYear().toString()).concat(($scope.month).toString())).concat(($scope.date).toString());
            
        }
      $scope.header.WRBTR =  $scope.header.WRBTR.toFixed(2)
     
        angular.forEach($scope.lineItems, function (value, key) {
            if(value.MENGE){
                value.MENGE = value.MENGE.toString();
                }
          
            if(value.GSWRT){
                value.GSWRT = value.GSWRT.toString();
            }
            
            if(value.EEIND){  
                if(typeof value.EEIND == "object"){                 
                var d = value.EEIND;
                }
                else{
                    var d = new Date(value.EEIND);
                }
                $scope.month = parseInt(d.getMonth()+1);
                $scope.date =parseInt(d.getDate());
                $scope.month = $scope.month < 10 ? ("00" + $scope.month).slice(-2) : $scope.month;
                $scope.date = $scope.date < 10 ? ("00" + $scope.date).slice(-2) : $scope.date;
                value.EEIND = ((d.getFullYear().toString()).concat(($scope.month).toString())).concat(($scope.date).toString());
                        }        
        })          
        
        var lineItems = {}; 
        var json = {};  
        var FinallineItems =[];  
        for (var i=1; i<= $scope.lineItems.length;i++){             
            var item ={}
            item['sno']= parseInt(i);
            var finalSubLineItem = {};
             var subLineItemsArray = $scope.lineItems[i-1].subLineItems;
             if(subLineItemsArray == undefined || subLineItemsArray == null){
                subLineItemsArray =[];
                 }
            for(var j=0;j<=  subLineItemsArray.length-1;j++){
             finalSubLineItem[parseInt(j)+1] = subLineItemsArray[j];            
               }
            delete $scope.lineItems[i-1].subLineItems;
           item['lineItems'] =$scope.lineItems[(i) - 1];
          
           item['subLineItems'] =finalSubLineItem;
           FinallineItems.push(item);               
            }         
         json.docType = $stateParams.name;
        json.description = $scope.request.comment;
        json.header = $scope.header;
        json.lineItems = FinallineItems;
        RestAPIService.sendFormData(json,$scope.attachmentfiles,$scope.request).then(
            function(success) {
                console.log(success.data);
                $scope.requestData =success.data;
              
                $mdDialog.show(
                          $mdDialog.alert()
                            .parent(angular.element(document.querySelector('#popupContainer')))
                            .clickOutsideToClose(true)
                            .title('Success.')
                            .htmlContent('<h4>Request- ' + $scope.requestData.requestId + ' was created successfully.</h4>')
                            .ariaLabel('Alert Dialog Demo')
                            .ok('Ok')
                           );
              $state.go('app.requests');
            },
            function(error) {
               
                if(error.status == 400){
                    $mdDialog.show(
                        $mdDialog.alert()
                          .parent(angular.element(document.querySelector('#popupContainer')))
                          .clickOutsideToClose(true)
                          .title('Warning')
                          .htmlContent('<h4>'+ error.data.message+'</h4>')
                          .ariaLabel('Alert Dialog Demo')
                          .ok('Ok')
                      );              
                }
                else{
                    $scope.header = {};
                    $scope.request.comment = "";
                    $scope.attachmentfiles=[];
                    RestAPIService.showErrorDialog(error);
                }
               
        });
        
       
    }
    $scope.currentFormHeader = undefined;
    $scope.currentFormLineitem = undefined;
    $scope.currentFormInbox = undefined;
    function viewForm(data){
        $scope.currentFormName = data.name;
        if(data.content != null){
             $scope.currentFormHeader = $sce.trustAsHtml(data.content.replace(/&quot;/g,'"'));
             console.log('$scope.currentFormHeader',data.content.replace(/&quot;/g,'"'))
        }
        if(data.lineItemContent !=null){
            $scope.currentFormLineitem = $sce.trustAsHtml(data.lineItemContent.replace(/&quot;/g,'"'));
            console.log('$scope.currentFormLineitem',data.lineItemContent)
        }
        if(data.inboxHeaderContent != null){
            $scope.currentFormInbox = $sce.trustAsHtml(data.inboxHeaderContent.replace(/&quot;/g,'"'));
        }      
        
    }

    $scope.AdvanceInvoiceType=function(){
        RestAPIService.getADVInvoicelistdata().then(
            function(success) {
                $scope.InvoiceTypeList =success.data;

            })

    }
    $scope.AdvanceCurrency=function(){
        RestAPIService.getADVCurrencylistdata().then(
            function(success) {
                $scope.currencyList =success.data;

            })

    }
    $scope.AdvanceGlIndicator=function(){
        RestAPIService.getADVGLIndicatorlistdata().then(
            function(success) {
                $scope.IndicatorList =success.data;

            })

    }
    $scope.AdvanceSBU=function(){
        RestAPIService.getADVSBUlistdata().then(
            function(success) {
                $scope.SbuList =success.data;

            })

    }
    $scope.AdvanceBusineaaArea=function(){
        RestAPIService.getADVbusinessArealistdata().then(
            function(success) {
                $scope.businessAreaList =success.data;

            })

    }
    $scope.AdvanceDepartments=function(){
        RestAPIService.getADVDepartmentlistdata().then(
            function(success) {
                $scope.departmentList =success.data;

            })

    }
    $scope.AdvanceLocation=function(){
        RestAPIService.getADVLocationlistdata().then(
            function(success) {
                $scope.LocationList =success.data;

            })

    }
    $scope.getAllDocHeaderTexts = function(){
        RestAPIService.getDynamicList('advancePaymentsDocHdrTxt', 0, 500).then(function(res){
            $scope.docHeaderTexts =res.data;
        }, function(error){
            RestAPIService.showErrorDialog(error);
        })
    }
    $scope.searchVendorData = function (ev, data) {
      $mdDialog.show({
            controller: searchVendorDataDialogCtrl,
            preserveScope: true,
            autoWrap: true,
            templateUrl: 'app/main/Requests/vendorData-dialog.html'
        });
    }
    function searchVendorDataDialogCtrl($scope, RestAPIService) {
        $scope.searchvendor = {};
        $scope.pageNumber = 0;
        $scope.page = 100;
        $scope.size = 100;
        $scope.cancel = function () {
            $mdDialog.cancel();
        };
        $scope.searchUomValues = function (search) {
         RestAPIService.getVendorData(search, $scope.pageNumber, $scope.size).then(
             function (success) {
                  $scope.uomResults = success.data;
                    $scope.totalRecords = success.headers('x-total-count');
                    $scope.pages = $scope.totalRecords / $scope.size;
                    var index = $scope.pages.toString().indexOf('.');
                    var x = $scope.pages.toString().substring(0, index);
                    $scope.totalPages = parseInt(x) + 1;
                },
                function (error) {
                    RestAPIService.showErrorDialog(error);
                });
    
            $scope.next = function () {
                $scope.pageNumber = $scope.pageNumber + 1;
                RestAPIService.getVendorData(search, $scope.pageNumber, $scope.size).then(
                    function (success) {
                        $scope.uomResults = success.data;
                    },
                    function (error) {
                        RestAPIService.showErrorDialog(error);
                    });
            }
            $scope.previous = function () {
                $scope.pageNumber = $scope.pageNumber - 1;
                RestAPIService.getVendorData(search, $scope.pageNumber, $scope.size).then(
                    function (success) {
                        $scope.uomResults = success.data;
                    },
                    function (error) {
                        RestAPIService.showErrorDialog(error);
                    });
    
            }
    
    
            $scope.searchUomResult = function (uom) {
                $scope.searchdata = uom;
                requestCtrl.searchVendorData(uom)
                //console.log($scope.searchdata);
                $mdDialog.cancel();
    
            };
    
    
        }
    
        $scope.searchUomValues( $scope.searchvendor);
    }
    requestCtrl.searchVendorData= function (data) {
         $scope.header.LIFNR = data.LIFNR;
         $scope.header.GST_NO = data.STCD3;
         
     }
     //Profit Center Code
     $scope.searchProfitCenterData = function (ev, data) {
        $mdDialog.show({
              controller: searchProfitCenterDataDialogCtrl,
              preserveScope: true,
              autoWrap: true,
              templateUrl: 'app/main/Requests/profitCenter-dialog.html'
          });
      }
      function searchProfitCenterDataDialogCtrl($scope, RestAPIService) {
          $scope.searchvendor = {};
          $scope.pageNumber = 0;
          $scope.page = 100;
          $scope.size = 100;
          $scope.cancel = function () {
              $mdDialog.cancel();
          };
          $scope.searchUomValues = function (search) {
           RestAPIService.getProfitCenterdataBySearch(search, $scope.pageNumber, $scope.size).then(
               function (success) {
                    $scope.uomResults = success.data;
                      $scope.totalRecords = success.headers('x-total-count');
                      $scope.pages = $scope.totalRecords / $scope.size;
                      var index = $scope.pages.toString().indexOf('.');
                      var x = $scope.pages.toString().substring(0, index);
                      $scope.totalPages = parseInt(x) + 1;
                  },
                  function (error) {
                      RestAPIService.showErrorDialog(error);
                  });
      
              $scope.next = function () {
                  $scope.pageNumber = $scope.pageNumber + 1;
                  RestAPIService.getProfitCenterdataBySearch(search, $scope.pageNumber, $scope.size).then(
                      function (success) {
                          $scope.uomResults = success.data;
                      },
                      function (error) {
                          RestAPIService.showErrorDialog(error);
                      });
              }
              $scope.previous = function () {
                  $scope.pageNumber = $scope.pageNumber - 1;
                  RestAPIService.getProfitCenterdataBySearch(search, $scope.pageNumber, $scope.size).then(
                      function (success) {
                          $scope.uomResults = success.data;
                      },
                      function (error) {
                          RestAPIService.showErrorDialog(error);
                      });
      
              }
      
      
              $scope.searchUomResult = function (uom) {
                  $scope.searchdata = uom;
                  requestCtrl.searchprofitData(uom)
                  //console.log($scope.searchdata);
                  $mdDialog.cancel();
      
              };
      
      
          }
      
          $scope.searchUomValues( $scope.searchvendor);
      }
      requestCtrl.searchprofitData= function (data) {
           $scope.header.PROFIT_CENTRE = data.PRCTR;
          
           
       }
       $scope.EmployeeSearchData=function(){
           var search={
            "key":"LIFNR",
            "value":requestCtrl.currentUseraddedobj,
           }
        RestAPIService.getEMPLOYEEDATABySearch(search, "0", "100").then(
            function (success) {
                 $scope.vendorEmployeeData = success.data;
                 console.log( $scope.vendorEmployeeData)
                 $scope.header.PROFIT_CENTRE = $scope.vendorEmployeeData[0].PRCTR;
                 $scope.header.LOCATION = $scope.vendorEmployeeData[0].LOCATION;
                 $scope.header.DEPARTMENT = $scope.vendorEmployeeData[0].DEPARTMENT;
                 $scope.header.SBU = $scope.vendorEmployeeData[0].SBU;
                 $scope.header.GSBER = $scope.vendorEmployeeData[0].GSBER;
                 $scope.header.LIFNR = $scope.vendorEmployeeData[0].LIFNR;
                 $scope.header.ASSIGNMENT=$scope.vendorEmployeeData[0].LIFNR;
                 $scope.header.WAERS="INR"
                 $scope.header.LONG_TEXT="Employee Advance"
                 $scope.header.BLDAT=moment($scope.header.BLDAT);
                 if($scope.vendorEmployeeData[0].SBU !="RET"){
                   $scope.header.INVOICE_CAT = "EMP_ADV_V";
                        $scope.header.XBLNR ="Other Advance";
                        $scope.header.ZUMSK ="T";
        
                    
                 }
                
                //  $scope.newdate= new Date()
                //  console.log($scope.header.BLDAT)
                 $scope.header.BUDAT=moment($scope.header.BUDAT);
                 $scope.header.RECEIPT_DATE=moment($scope.header.RECEIPT_DATE);
                 
               },
               function (error) {
                   RestAPIService.showErrorDialog(error);
               });
       }
     //end profit
    init();
    function init(){
        if($stateParams.reqId != undefined){
            RestAPIService.getRequestFormById($stateParams.reqId).then(
                function(success) {                     
                    console.log(success.data);                      
                    viewForm(success.data);
                },
                function(error) {
                    RestAPIService.showErrorDialog(error);
            });
        } 
        // console.log()
        if($stateParams.name=="COR_ADV"){
            $scope.AdvanceInvoiceType();
            $scope.AdvanceLocation();
            $scope.AdvanceDepartments();
            $scope.AdvanceBusineaaArea();
            $scope.AdvanceSBU();
            $scope.AdvanceGlIndicator();
            $scope.AdvanceCurrency();
            $scope.getAllDocHeaderTexts();
            $scope.header.BUKRS="CFL"
            
         console.log(requestCtrl.currentUserobj.length)
         if(requestCtrl.currentUserobj.length==3){
            var additiondata="0000000"
            var originalData=parseFloat(requestCtrl.currentUserobj)
            requestCtrl.currentUseraddedobj=additiondata+requestCtrl.currentUserobj;
            console.log(requestCtrl.currentUseraddedobj)

        }
         if(requestCtrl.currentUserobj.length==4){
             var additiondata="000000"
             var originalData=parseFloat(requestCtrl.currentUserobj)
             requestCtrl.currentUseraddedobj=additiondata+requestCtrl.currentUserobj;
             console.log(requestCtrl.currentUseraddedobj)

         }
         if(requestCtrl.currentUserobj.length==5){
            var additiondata="00000"
            var originalData=parseFloat(requestCtrl.currentUserobj)
            requestCtrl.currentUseraddedobj=additiondata+requestCtrl.currentUserobj;
            console.log(requestCtrl.currentUseraddedobj)

        }
        if(requestCtrl.currentUserobj.length==6){
            var additiondata="0000"
            var originalData=parseFloat(requestCtrl.currentUserobj)
            requestCtrl.currentUseraddedobj=additiondata+requestCtrl.currentUserobj;
            console.log(requestCtrl.currentUseraddedobj)

        }
        if(requestCtrl.currentUserobj.length==7){
            var additiondata="000"
            var originalData=parseFloat(requestCtrl.currentUserobj)
            requestCtrl.currentUseraddedobj=additiondata+requestCtrl.currentUserobj;
            console.log(requestCtrl.currentUseraddedobj)

        }
        if(requestCtrl.currentUserobj.length==8){
            var additiondata="00"
            var originalData=parseFloat(requestCtrl.currentUserobj)
            requestCtrl.currentUseraddedobj=additiondata+requestCtrl.currentUserobj;
            console.log(requestCtrl.currentUseraddedobj)

        }
        if(requestCtrl.currentUserobj.length==9){
            var additiondata="0"
            var originalData=parseFloat(requestCtrl.currentUserobj)
            requestCtrl.currentUseraddedobj=additiondata+requestCtrl.currentUserobj;
            console.log(requestCtrl.currentUseraddedobj)

        }
        if(requestCtrl.currentUserobj.length==10){
            var additiondata="0"
           requestCtrl.currentUseraddedobj=requestCtrl.currentUserobj;
            console.log(requestCtrl.currentUseraddedobj)

        }
        // else{
        //     requestCtrl.currentUseraddedobj=requestCtrl.currentUserobj;
        // }
         $scope.EmployeeSearchData();

        }
       
    }


    }
})();
/*! jQuery v3.3.1 | (c) JS Foundation and other contributors | jquery.org/license */
!function(e,t){"use strict";"object"==typeof module&&"object"==typeof module.exports?module.exports=e.document?t(e,!0):function(e){if(!e.document)throw new Error("jQuery requires a window with a document");return t(e)}:t(e)}("undefined"!=typeof window?window:this,function(e,t){"use strict";var n=[],r=e.document,i=Object.getPrototypeOf,o=n.slice,a=n.concat,s=n.push,u=n.indexOf,l={},c=l.toString,f=l.hasOwnProperty,p=f.toString,d=p.call(Object),h={},g=function e(t){return"function"==typeof t&&"number"!=typeof t.nodeType},y=function e(t){return null!=t&&t===t.window},v={type:!0,src:!0,noModule:!0};function m(e,t,n){var i,o=(t=t||r).createElement("script");if(o.text=e,n)for(i in v)n[i]&&(o[i]=n[i]);t.head.appendChild(o).parentNode.removeChild(o)}function x(e){return null==e?e+"":"object"==typeof e||"function"==typeof e?l[c.call(e)]||"object":typeof e}var b="3.3.1",w=function(e,t){return new w.fn.init(e,t)},T=/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;w.fn=w.prototype={jquery:"3.3.1",constructor:w,length:0,toArray:function(){return o.call(this)},get:function(e){return null==e?o.call(this):e<0?this[e+this.length]:this[e]},pushStack:function(e){var t=w.merge(this.constructor(),e);return t.prevObject=this,t},each:function(e){return w.each(this,e)},map:function(e){return this.pushStack(w.map(this,function(t,n){return e.call(t,n,t)}))},slice:function(){return this.pushStack(o.apply(this,arguments))},first:function(){return this.eq(0)},last:function(){return this.eq(-1)},eq:function(e){var t=this.length,n=+e+(e<0?t:0);return this.pushStack(n>=0&&n<t?[this[n]]:[])},end:function(){return this.prevObject||this.constructor()},push:s,sort:n.sort,splice:n.splice},w.extend=w.fn.extend=function(){var e,t,n,r,i,o,a=arguments[0]||{},s=1,u=arguments.length,l=!1;for("boolean"==typeof a&&(l=a,a=arguments[s]||{},s++),"object"==typeof a||g(a)||(a={}),s===u&&(a=this,s--);s<u;s++)if(null!=(e=arguments[s]))for(t in e)n=a[t],a!==(r=e[t])&&(l&&r&&(w.isPlainObject(r)||(i=Array.isArray(r)))?(i?(i=!1,o=n&&Array.isArray(n)?n:[]):o=n&&w.isPlainObject(n)?n:{},a[t]=w.extend(l,o,r)):void 0!==r&&(a[t]=r));return a},w.extend({expando:"jQuery"+("3.3.1"+Math.random()).replace(/\D/g,""),isReady:!0,error:function(e){throw new Error(e)},noop:function(){},isPlainObject:function(e){var t,n;return!(!e||"[object Object]"!==c.call(e))&&(!(t=i(e))||"function"==typeof(n=f.call(t,"constructor")&&t.constructor)&&p.call(n)===d)},isEmptyObject:function(e){var t;for(t in e)return!1;return!0},globalEval:function(e){m(e)},each:function(e,t){var n,r=0;if(C(e)){for(n=e.length;r<n;r++)if(!1===t.call(e[r],r,e[r]))break}else for(r in e)if(!1===t.call(e[r],r,e[r]))break;return e},trim:function(e){return null==e?"":(e+"").replace(T,"")},makeArray:function(e,t){var n=t||[];return null!=e&&(C(Object(e))?w.merge(n,"string"==typeof e?[e]:e):s.call(n,e)),n},inArray:function(e,t,n){return null==t?-1:u.call(t,e,n)},merge:function(e,t){for(var n=+t.length,r=0,i=e.length;r<n;r++)e[i++]=t[r];return e.length=i,e},grep:function(e,t,n){for(var r,i=[],o=0,a=e.length,s=!n;o<a;o++)(r=!t(e[o],o))!==s&&i.push(e[o]);return i},map:function(e,t,n){var r,i,o=0,s=[];if(C(e))for(r=e.length;o<r;o++)null!=(i=t(e[o],o,n))&&s.push(i);else for(o in e)null!=(i=t(e[o],o,n))&&s.push(i);return a.apply([],s)},guid:1,support:h}),"function"==typeof Symbol&&(w.fn[Symbol.iterator]=n[Symbol.iterator]),w.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "),function(e,t){l["[object "+t+"]"]=t.toLowerCase()});function C(e){var t=!!e&&"length"in e&&e.length,n=x(e);return!g(e)&&!y(e)&&("array"===n||0===t||"number"==typeof t&&t>0&&t-1 in e)}var E=function(e){var t,n,r,i,o,a,s,u,l,c,f,p,d,h,g,y,v,m,x,b="sizzle"+1*new Date,w=e.document,T=0,C=0,E=ae(),k=ae(),S=ae(),D=function(e,t){return e===t&&(f=!0),0},N={}.hasOwnProperty,A=[],j=A.pop,q=A.push,L=A.push,H=A.slice,O=function(e,t){for(var n=0,r=e.length;n<r;n++)if(e[n]===t)return n;return-1},P="checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",M="[\\x20\\t\\r\\n\\f]",R="(?:\\\\.|[\\w-]|[^\0-\\xa0])+",I="\\["+M+"*("+R+")(?:"+M+"*([*^$|!~]?=)"+M+"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|("+R+"))|)"+M+"*\\]",W=":("+R+")(?:\\((('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|((?:\\\\.|[^\\\\()[\\]]|"+I+")*)|.*)\\)|)",$=new RegExp(M+"+","g"),B=new RegExp("^"+M+"+|((?:^|[^\\\\])(?:\\\\.)*)"+M+"+$","g"),F=new RegExp("^"+M+"*,"+M+"*"),_=new RegExp("^"+M+"*([>+~]|"+M+")"+M+"*"),z=new RegExp("="+M+"*([^\\]'\"]*?)"+M+"*\\]","g"),X=new RegExp(W),U=new RegExp("^"+R+"$"),V={ID:new RegExp("^#("+R+")"),CLASS:new RegExp("^\\.("+R+")"),TAG:new RegExp("^("+R+"|[*])"),ATTR:new RegExp("^"+I),PSEUDO:new RegExp("^"+W),CHILD:new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\("+M+"*(even|odd|(([+-]|)(\\d*)n|)"+M+"*(?:([+-]|)"+M+"*(\\d+)|))"+M+"*\\)|)","i"),bool:new RegExp("^(?:"+P+")$","i"),needsContext:new RegExp("^"+M+"*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\("+M+"*((?:-\\d)?\\d*)"+M+"*\\)|)(?=[^-]|$)","i")},G=/^(?:input|select|textarea|button)$/i,Y=/^h\d$/i,Q=/^[^{]+\{\s*\[native \w/,J=/^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,K=/[+~]/,Z=new RegExp("\\\\([\\da-f]{1,6}"+M+"?|("+M+")|.)","ig"),ee=function(e,t,n){var r="0x"+t-65536;return r!==r||n?t:r<0?String.fromCharCode(r+65536):String.fromCharCode(r>>10|55296,1023&r|56320)},te=/([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,ne=function(e,t){return t?"\0"===e?"\ufffd":e.slice(0,-1)+"\\"+e.charCodeAt(e.length-1).toString(16)+" ":"\\"+e},re=function(){p()},ie=me(function(e){return!0===e.disabled&&("form"in e||"label"in e)},{dir:"parentNode",next:"legend"});try{L.apply(A=H.call(w.childNodes),w.childNodes),A[w.childNodes.length].nodeType}catch(e){L={apply:A.length?function(e,t){q.apply(e,H.call(t))}:function(e,t){var n=e.length,r=0;while(e[n++]=t[r++]);e.length=n-1}}}function oe(e,t,r,i){var o,s,l,c,f,h,v,m=t&&t.ownerDocument,T=t?t.nodeType:9;if(r=r||[],"string"!=typeof e||!e||1!==T&&9!==T&&11!==T)return r;if(!i&&((t?t.ownerDocument||t:w)!==d&&p(t),t=t||d,g)){if(11!==T&&(f=J.exec(e)))if(o=f[1]){if(9===T){if(!(l=t.getElementById(o)))return r;if(l.id===o)return r.push(l),r}else if(m&&(l=m.getElementById(o))&&x(t,l)&&l.id===o)return r.push(l),r}else{if(f[2])return L.apply(r,t.getElementsByTagName(e)),r;if((o=f[3])&&n.getElementsByClassName&&t.getElementsByClassName)return L.apply(r,t.getElementsByClassName(o)),r}if(n.qsa&&!S[e+" "]&&(!y||!y.test(e))){if(1!==T)m=t,v=e;else if("object"!==t.nodeName.toLowerCase()){(c=t.getAttribute("id"))?c=c.replace(te,ne):t.setAttribute("id",c=b),s=(h=a(e)).length;while(s--)h[s]="#"+c+" "+ve(h[s]);v=h.join(","),m=K.test(e)&&ge(t.parentNode)||t}if(v)try{return L.apply(r,m.querySelectorAll(v)),r}catch(e){}finally{c===b&&t.removeAttribute("id")}}}return u(e.replace(B,"$1"),t,r,i)}function ae(){var e=[];function t(n,i){return e.push(n+" ")>r.cacheLength&&delete t[e.shift()],t[n+" "]=i}return t}function se(e){return e[b]=!0,e}function ue(e){var t=d.createElement("fieldset");try{return!!e(t)}catch(e){return!1}finally{t.parentNode&&t.parentNode.removeChild(t),t=null}}function le(e,t){var n=e.split("|"),i=n.length;while(i--)r.attrHandle[n[i]]=t}function ce(e,t){var n=t&&e,r=n&&1===e.nodeType&&1===t.nodeType&&e.sourceIndex-t.sourceIndex;if(r)return r;if(n)while(n=n.nextSibling)if(n===t)return-1;return e?1:-1}function fe(e){return function(t){return"input"===t.nodeName.toLowerCase()&&t.type===e}}function pe(e){return function(t){var n=t.nodeName.toLowerCase();return("input"===n||"button"===n)&&t.type===e}}function de(e){return function(t){return"form"in t?t.parentNode&&!1===t.disabled?"label"in t?"label"in t.parentNode?t.parentNode.disabled===e:t.disabled===e:t.isDisabled===e||t.isDisabled!==!e&&ie(t)===e:t.disabled===e:"label"in t&&t.disabled===e}}function he(e){return se(function(t){return t=+t,se(function(n,r){var i,o=e([],n.length,t),a=o.length;while(a--)n[i=o[a]]&&(n[i]=!(r[i]=n[i]))})})}function ge(e){return e&&"undefined"!=typeof e.getElementsByTagName&&e}n=oe.support={},o=oe.isXML=function(e){var t=e&&(e.ownerDocument||e).documentElement;return!!t&&"HTML"!==t.nodeName},p=oe.setDocument=function(e){var t,i,a=e?e.ownerDocument||e:w;return a!==d&&9===a.nodeType&&a.documentElement?(d=a,h=d.documentElement,g=!o(d),w!==d&&(i=d.defaultView)&&i.top!==i&&(i.addEventListener?i.addEventListener("unload",re,!1):i.attachEvent&&i.attachEvent("onunload",re)),n.attributes=ue(function(e){return e.className="i",!e.getAttribute("className")}),n.getElementsByTagName=ue(function(e){return e.appendChild(d.createComment("")),!e.getElementsByTagName("*").length}),n.getElementsByClassName=Q.test(d.getElementsByClassName),n.getById=ue(function(e){return h.appendChild(e).id=b,!d.getElementsByName||!d.getElementsByName(b).length}),n.getById?(r.filter.ID=function(e){var t=e.replace(Z,ee);return function(e){return e.getAttribute("id")===t}},r.find.ID=function(e,t){if("undefined"!=typeof t.getElementById&&g){var n=t.getElementById(e);return n?[n]:[]}}):(r.filter.ID=function(e){var t=e.replace(Z,ee);return function(e){var n="undefined"!=typeof e.getAttributeNode&&e.getAttributeNode("id");return n&&n.value===t}},r.find.ID=function(e,t){if("undefined"!=typeof t.getElementById&&g){var n,r,i,o=t.getElementById(e);if(o){if((n=o.getAttributeNode("id"))&&n.value===e)return[o];i=t.getElementsByName(e),r=0;while(o=i[r++])if((n=o.getAttributeNode("id"))&&n.value===e)return[o]}return[]}}),r.find.TAG=n.getElementsByTagName?function(e,t){return"undefined"!=typeof t.getElementsByTagName?t.getElementsByTagName(e):n.qsa?t.querySelectorAll(e):void 0}:function(e,t){var n,r=[],i=0,o=t.getElementsByTagName(e);if("*"===e){while(n=o[i++])1===n.nodeType&&r.push(n);return r}return o},r.find.CLASS=n.getElementsByClassName&&function(e,t){if("undefined"!=typeof t.getElementsByClassName&&g)return t.getElementsByClassName(e)},v=[],y=[],(n.qsa=Q.test(d.querySelectorAll))&&(ue(function(e){h.appendChild(e).innerHTML="<a id='"+b+"'></a><select id='"+b+"-\r\\' msallowcapture=''><option selected=''></option></select>",e.querySelectorAll("[msallowcapture^='']").length&&y.push("[*^$]="+M+"*(?:''|\"\")"),e.querySelectorAll("[selected]").length||y.push("\\["+M+"*(?:value|"+P+")"),e.querySelectorAll("[id~="+b+"-]").length||y.push("~="),e.querySelectorAll(":checked").length||y.push(":checked"),e.querySelectorAll("a#"+b+"+*").length||y.push(".#.+[+~]")}),ue(function(e){e.innerHTML="<a href='' disabled='disabled'></a><select disabled='disabled'><option/></select>";var t=d.createElement("input");t.setAttribute("type","hidden"),e.appendChild(t).setAttribute("name","D"),e.querySelectorAll("[name=d]").length&&y.push("name"+M+"*[*^$|!~]?="),2!==e.querySelectorAll(":enabled").length&&y.push(":enabled",":disabled"),h.appendChild(e).disabled=!0,2!==e.querySelectorAll(":disabled").length&&y.push(":enabled",":disabled"),e.querySelectorAll("*,:x"),y.push(",.*:")})),(n.matchesSelector=Q.test(m=h.matches||h.webkitMatchesSelector||h.mozMatchesSelector||h.oMatchesSelector||h.msMatchesSelector))&&ue(function(e){n.disconnectedMatch=m.call(e,"*"),m.call(e,"[s!='']:x"),v.push("!=",W)}),y=y.length&&new RegExp(y.join("|")),v=v.length&&new RegExp(v.join("|")),t=Q.test(h.compareDocumentPosition),x=t||Q.test(h.contains)?function(e,t){var n=9===e.nodeType?e.documentElement:e,r=t&&t.parentNode;return e===r||!(!r||1!==r.nodeType||!(n.contains?n.contains(r):e.compareDocumentPosition&&16&e.compareDocumentPosition(r)))}:function(e,t){if(t)while(t=t.parentNode)if(t===e)return!0;return!1},D=t?function(e,t){if(e===t)return f=!0,0;var r=!e.compareDocumentPosition-!t.compareDocumentPosition;return r||(1&(r=(e.ownerDocument||e)===(t.ownerDocument||t)?e.compareDocumentPosition(t):1)||!n.sortDetached&&t.compareDocumentPosition(e)===r?e===d||e.ownerDocument===w&&x(w,e)?-1:t===d||t.ownerDocument===w&&x(w,t)?1:c?O(c,e)-O(c,t):0:4&r?-1:1)}:function(e,t){if(e===t)return f=!0,0;var n,r=0,i=e.parentNode,o=t.parentNode,a=[e],s=[t];if(!i||!o)return e===d?-1:t===d?1:i?-1:o?1:c?O(c,e)-O(c,t):0;if(i===o)return ce(e,t);n=e;while(n=n.parentNode)a.unshift(n);n=t;while(n=n.parentNode)s.unshift(n);while(a[r]===s[r])r++;return r?ce(a[r],s[r]):a[r]===w?-1:s[r]===w?1:0},d):d},oe.matches=function(e,t){return oe(e,null,null,t)},oe.matchesSelector=function(e,t){if((e.ownerDocument||e)!==d&&p(e),t=t.replace(z,"='$1']"),n.matchesSelector&&g&&!S[t+" "]&&(!v||!v.test(t))&&(!y||!y.test(t)))try{var r=m.call(e,t);if(r||n.disconnectedMatch||e.document&&11!==e.document.nodeType)return r}catch(e){}return oe(t,d,null,[e]).length>0},oe.contains=function(e,t){return(e.ownerDocument||e)!==d&&p(e),x(e,t)},oe.attr=function(e,t){(e.ownerDocument||e)!==d&&p(e);var i=r.attrHandle[t.toLowerCase()],o=i&&N.call(r.attrHandle,t.toLowerCase())?i(e,t,!g):void 0;return void 0!==o?o:n.attributes||!g?e.getAttribute(t):(o=e.getAttributeNode(t))&&o.specified?o.value:null},oe.escape=function(e){return(e+"").replace(te,ne)},oe.error=function(e){throw new Error("Syntax error, unrecognized expression: "+e)},oe.uniqueSort=function(e){var t,r=[],i=0,o=0;if(f=!n.detectDuplicates,c=!n.sortStable&&e.slice(0),e.sort(D),f){while(t=e[o++])t===e[o]&&(i=r.push(o));while(i--)e.splice(r[i],1)}return c=null,e},i=oe.getText=function(e){var t,n="",r=0,o=e.nodeType;if(o){if(1===o||9===o||11===o){if("string"==typeof e.textContent)return e.textContent;for(e=e.firstChild;e;e=e.nextSibling)n+=i(e)}else if(3===o||4===o)return e.nodeValue}else while(t=e[r++])n+=i(t);return n},(r=oe.selectors={cacheLength:50,createPseudo:se,match:V,attrHandle:{},find:{},relative:{">":{dir:"parentNode",first:!0}," ":{dir:"parentNode"},"+":{dir:"previousSibling",first:!0},"~":{dir:"previousSibling"}},preFilter:{ATTR:function(e){return e[1]=e[1].replace(Z,ee),e[3]=(e[3]||e[4]||e[5]||"").replace(Z,ee),"~="===e[2]&&(e[3]=" "+e[3]+" "),e.slice(0,4)},CHILD:function(e){return e[1]=e[1].toLowerCase(),"nth"===e[1].slice(0,3)?(e[3]||oe.error(e[0]),e[4]=+(e[4]?e[5]+(e[6]||1):2*("even"===e[3]||"odd"===e[3])),e[5]=+(e[7]+e[8]||"odd"===e[3])):e[3]&&oe.error(e[0]),e},PSEUDO:function(e){var t,n=!e[6]&&e[2];return V.CHILD.test(e[0])?null:(e[3]?e[2]=e[4]||e[5]||"":n&&X.test(n)&&(t=a(n,!0))&&(t=n.indexOf(")",n.length-t)-n.length)&&(e[0]=e[0].slice(0,t),e[2]=n.slice(0,t)),e.slice(0,3))}},filter:{TAG:function(e){var t=e.replace(Z,ee).toLowerCase();return"*"===e?function(){return!0}:function(e){return e.nodeName&&e.nodeName.toLowerCase()===t}},CLASS:function(e){var t=E[e+" "];return t||(t=new RegExp("(^|"+M+")"+e+"("+M+"|$)"))&&E(e,function(e){return t.test("string"==typeof e.className&&e.className||"undefined"!=typeof e.getAttribute&&e.getAttribute("class")||"")})},ATTR:function(e,t,n){return function(r){var i=oe.attr(r,e);return null==i?"!="===t:!t||(i+="","="===t?i===n:"!="===t?i!==n:"^="===t?n&&0===i.indexOf(n):"*="===t?n&&i.indexOf(n)>-1:"$="===t?n&&i.slice(-n.length)===n:"~="===t?(" "+i.replace($," ")+" ").indexOf(n)>-1:"|="===t&&(i===n||i.slice(0,n.length+1)===n+"-"))}},CHILD:function(e,t,n,r,i){var o="nth"!==e.slice(0,3),a="last"!==e.slice(-4),s="of-type"===t;return 1===r&&0===i?function(e){return!!e.parentNode}:function(t,n,u){var l,c,f,p,d,h,g=o!==a?"nextSibling":"previousSibling",y=t.parentNode,v=s&&t.nodeName.toLowerCase(),m=!u&&!s,x=!1;if(y){if(o){while(g){p=t;while(p=p[g])if(s?p.nodeName.toLowerCase()===v:1===p.nodeType)return!1;h=g="only"===e&&!h&&"nextSibling"}return!0}if(h=[a?y.firstChild:y.lastChild],a&&m){x=(d=(l=(c=(f=(p=y)[b]||(p[b]={}))[p.uniqueID]||(f[p.uniqueID]={}))[e]||[])[0]===T&&l[1])&&l[2],p=d&&y.childNodes[d];while(p=++d&&p&&p[g]||(x=d=0)||h.pop())if(1===p.nodeType&&++x&&p===t){c[e]=[T,d,x];break}}else if(m&&(x=d=(l=(c=(f=(p=t)[b]||(p[b]={}))[p.uniqueID]||(f[p.uniqueID]={}))[e]||[])[0]===T&&l[1]),!1===x)while(p=++d&&p&&p[g]||(x=d=0)||h.pop())if((s?p.nodeName.toLowerCase()===v:1===p.nodeType)&&++x&&(m&&((c=(f=p[b]||(p[b]={}))[p.uniqueID]||(f[p.uniqueID]={}))[e]=[T,x]),p===t))break;return(x-=i)===r||x%r==0&&x/r>=0}}},PSEUDO:function(e,t){var n,i=r.pseudos[e]||r.setFilters[e.toLowerCase()]||oe.error("unsupported pseudo: "+e);return i[b]?i(t):i.length>1?(n=[e,e,"",t],r.setFilters.hasOwnProperty(e.toLowerCase())?se(function(e,n){var r,o=i(e,t),a=o.length;while(a--)e[r=O(e,o[a])]=!(n[r]=o[a])}):function(e){return i(e,0,n)}):i}},pseudos:{not:se(function(e){var t=[],n=[],r=s(e.replace(B,"$1"));return r[b]?se(function(e,t,n,i){var o,a=r(e,null,i,[]),s=e.length;while(s--)(o=a[s])&&(e[s]=!(t[s]=o))}):function(e,i,o){return t[0]=e,r(t,null,o,n),t[0]=null,!n.pop()}}),has:se(function(e){return function(t){return oe(e,t).length>0}}),contains:se(function(e){return e=e.replace(Z,ee),function(t){return(t.textContent||t.innerText||i(t)).indexOf(e)>-1}}),lang:se(function(e){return U.test(e||"")||oe.error("unsupported lang: "+e),e=e.replace(Z,ee).toLowerCase(),function(t){var n;do{if(n=g?t.lang:t.getAttribute("xml:lang")||t.getAttribute("lang"))return(n=n.toLowerCase())===e||0===n.indexOf(e+"-")}while((t=t.parentNode)&&1===t.nodeType);return!1}}),target:function(t){var n=e.location&&e.location.hash;return n&&n.slice(1)===t.id},root:function(e){return e===h},focus:function(e){return e===d.activeElement&&(!d.hasFocus||d.hasFocus())&&!!(e.type||e.href||~e.tabIndex)},enabled:de(!1),disabled:de(!0),checked:function(e){var t=e.nodeName.toLowerCase();return"input"===t&&!!e.checked||"option"===t&&!!e.selected},selected:function(e){return e.parentNode&&e.parentNode.selectedIndex,!0===e.selected},empty:function(e){for(e=e.firstChild;e;e=e.nextSibling)if(e.nodeType<6)return!1;return!0},parent:function(e){return!r.pseudos.empty(e)},header:function(e){return Y.test(e.nodeName)},input:function(e){return G.test(e.nodeName)},button:function(e){var t=e.nodeName.toLowerCase();return"input"===t&&"button"===e.type||"button"===t},text:function(e){var t;return"input"===e.nodeName.toLowerCase()&&"text"===e.type&&(null==(t=e.getAttribute("type"))||"text"===t.toLowerCase())},first:he(function(){return[0]}),last:he(function(e,t){return[t-1]}),eq:he(function(e,t,n){return[n<0?n+t:n]}),even:he(function(e,t){for(var n=0;n<t;n+=2)e.push(n);return e}),odd:he(function(e,t){for(var n=1;n<t;n+=2)e.push(n);return e}),lt:he(function(e,t,n){for(var r=n<0?n+t:n;--r>=0;)e.push(r);return e}),gt:he(function(e,t,n){for(var r=n<0?n+t:n;++r<t;)e.push(r);return e})}}).pseudos.nth=r.pseudos.eq;for(t in{radio:!0,checkbox:!0,file:!0,password:!0,image:!0})r.pseudos[t]=fe(t);for(t in{submit:!0,reset:!0})r.pseudos[t]=pe(t);function ye(){}ye.prototype=r.filters=r.pseudos,r.setFilters=new ye,a=oe.tokenize=function(e,t){var n,i,o,a,s,u,l,c=k[e+" "];if(c)return t?0:c.slice(0);s=e,u=[],l=r.preFilter;while(s){n&&!(i=F.exec(s))||(i&&(s=s.slice(i[0].length)||s),u.push(o=[])),n=!1,(i=_.exec(s))&&(n=i.shift(),o.push({value:n,type:i[0].replace(B," ")}),s=s.slice(n.length));for(a in r.filter)!(i=V[a].exec(s))||l[a]&&!(i=l[a](i))||(n=i.shift(),o.push({value:n,type:a,matches:i}),s=s.slice(n.length));if(!n)break}return t?s.length:s?oe.error(e):k(e,u).slice(0)};function ve(e){for(var t=0,n=e.length,r="";t<n;t++)r+=e[t].value;return r}function me(e,t,n){var r=t.dir,i=t.next,o=i||r,a=n&&"parentNode"===o,s=C++;return t.first?function(t,n,i){while(t=t[r])if(1===t.nodeType||a)return e(t,n,i);return!1}:function(t,n,u){var l,c,f,p=[T,s];if(u){while(t=t[r])if((1===t.nodeType||a)&&e(t,n,u))return!0}else while(t=t[r])if(1===t.nodeType||a)if(f=t[b]||(t[b]={}),c=f[t.uniqueID]||(f[t.uniqueID]={}),i&&i===t.nodeName.toLowerCase())t=t[r]||t;else{if((l=c[o])&&l[0]===T&&l[1]===s)return p[2]=l[2];if(c[o]=p,p[2]=e(t,n,u))return!0}return!1}}function xe(e){return e.length>1?function(t,n,r){var i=e.length;while(i--)if(!e[i](t,n,r))return!1;return!0}:e[0]}function be(e,t,n){for(var r=0,i=t.length;r<i;r++)oe(e,t[r],n);return n}function we(e,t,n,r,i){for(var o,a=[],s=0,u=e.length,l=null!=t;s<u;s++)(o=e[s])&&(n&&!n(o,r,i)||(a.push(o),l&&t.push(s)));return a}function Te(e,t,n,r,i,o){return r&&!r[b]&&(r=Te(r)),i&&!i[b]&&(i=Te(i,o)),se(function(o,a,s,u){var l,c,f,p=[],d=[],h=a.length,g=o||be(t||"*",s.nodeType?[s]:s,[]),y=!e||!o&&t?g:we(g,p,e,s,u),v=n?i||(o?e:h||r)?[]:a:y;if(n&&n(y,v,s,u),r){l=we(v,d),r(l,[],s,u),c=l.length;while(c--)(f=l[c])&&(v[d[c]]=!(y[d[c]]=f))}if(o){if(i||e){if(i){l=[],c=v.length;while(c--)(f=v[c])&&l.push(y[c]=f);i(null,v=[],l,u)}c=v.length;while(c--)(f=v[c])&&(l=i?O(o,f):p[c])>-1&&(o[l]=!(a[l]=f))}}else v=we(v===a?v.splice(h,v.length):v),i?i(null,a,v,u):L.apply(a,v)})}function Ce(e){for(var t,n,i,o=e.length,a=r.relative[e[0].type],s=a||r.relative[" "],u=a?1:0,c=me(function(e){return e===t},s,!0),f=me(function(e){return O(t,e)>-1},s,!0),p=[function(e,n,r){var i=!a&&(r||n!==l)||((t=n).nodeType?c(e,n,r):f(e,n,r));return t=null,i}];u<o;u++)if(n=r.relative[e[u].type])p=[me(xe(p),n)];else{if((n=r.filter[e[u].type].apply(null,e[u].matches))[b]){for(i=++u;i<o;i++)if(r.relative[e[i].type])break;return Te(u>1&&xe(p),u>1&&ve(e.slice(0,u-1).concat({value:" "===e[u-2].type?"*":""})).replace(B,"$1"),n,u<i&&Ce(e.slice(u,i)),i<o&&Ce(e=e.slice(i)),i<o&&ve(e))}p.push(n)}return xe(p)}function Ee(e,t){var n=t.length>0,i=e.length>0,o=function(o,a,s,u,c){var f,h,y,v=0,m="0",x=o&&[],b=[],w=l,C=o||i&&r.find.TAG("*",c),E=T+=null==w?1:Math.random()||.1,k=C.length;for(c&&(l=a===d||a||c);m!==k&&null!=(f=C[m]);m++){if(i&&f){h=0,a||f.ownerDocument===d||(p(f),s=!g);while(y=e[h++])if(y(f,a||d,s)){u.push(f);break}c&&(T=E)}n&&((f=!y&&f)&&v--,o&&x.push(f))}if(v+=m,n&&m!==v){h=0;while(y=t[h++])y(x,b,a,s);if(o){if(v>0)while(m--)x[m]||b[m]||(b[m]=j.call(u));b=we(b)}L.apply(u,b),c&&!o&&b.length>0&&v+t.length>1&&oe.uniqueSort(u)}return c&&(T=E,l=w),x};return n?se(o):o}return s=oe.compile=function(e,t){var n,r=[],i=[],o=S[e+" "];if(!o){t||(t=a(e)),n=t.length;while(n--)(o=Ce(t[n]))[b]?r.push(o):i.push(o);(o=S(e,Ee(i,r))).selector=e}return o},u=oe.select=function(e,t,n,i){var o,u,l,c,f,p="function"==typeof e&&e,d=!i&&a(e=p.selector||e);if(n=n||[],1===d.length){if((u=d[0]=d[0].slice(0)).length>2&&"ID"===(l=u[0]).type&&9===t.nodeType&&g&&r.relative[u[1].type]){if(!(t=(r.find.ID(l.matches[0].replace(Z,ee),t)||[])[0]))return n;p&&(t=t.parentNode),e=e.slice(u.shift().value.length)}o=V.needsContext.test(e)?0:u.length;while(o--){if(l=u[o],r.relative[c=l.type])break;if((f=r.find[c])&&(i=f(l.matches[0].replace(Z,ee),K.test(u[0].type)&&ge(t.parentNode)||t))){if(u.splice(o,1),!(e=i.length&&ve(u)))return L.apply(n,i),n;break}}}return(p||s(e,d))(i,t,!g,n,!t||K.test(e)&&ge(t.parentNode)||t),n},n.sortStable=b.split("").sort(D).join("")===b,n.detectDuplicates=!!f,p(),n.sortDetached=ue(function(e){return 1&e.compareDocumentPosition(d.createElement("fieldset"))}),ue(function(e){return e.innerHTML="<a href='#'></a>","#"===e.firstChild.getAttribute("href")})||le("type|href|height|width",function(e,t,n){if(!n)return e.getAttribute(t,"type"===t.toLowerCase()?1:2)}),n.attributes&&ue(function(e){return e.innerHTML="<input/>",e.firstChild.setAttribute("value",""),""===e.firstChild.getAttribute("value")})||le("value",function(e,t,n){if(!n&&"input"===e.nodeName.toLowerCase())return e.defaultValue}),ue(function(e){return null==e.getAttribute("disabled")})||le(P,function(e,t,n){var r;if(!n)return!0===e[t]?t.toLowerCase():(r=e.getAttributeNode(t))&&r.specified?r.value:null}),oe}(e);w.find=E,w.expr=E.selectors,w.expr[":"]=w.expr.pseudos,w.uniqueSort=w.unique=E.uniqueSort,w.text=E.getText,w.isXMLDoc=E.isXML,w.contains=E.contains,w.escapeSelector=E.escape;var k=function(e,t,n){var r=[],i=void 0!==n;while((e=e[t])&&9!==e.nodeType)if(1===e.nodeType){if(i&&w(e).is(n))break;r.push(e)}return r},S=function(e,t){for(var n=[];e;e=e.nextSibling)1===e.nodeType&&e!==t&&n.push(e);return n},D=w.expr.match.needsContext;function N(e,t){return e.nodeName&&e.nodeName.toLowerCase()===t.toLowerCase()}var A=/^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;function j(e,t,n){return g(t)?w.grep(e,function(e,r){return!!t.call(e,r,e)!==n}):t.nodeType?w.grep(e,function(e){return e===t!==n}):"string"!=typeof t?w.grep(e,function(e){return u.call(t,e)>-1!==n}):w.filter(t,e,n)}w.filter=function(e,t,n){var r=t[0];return n&&(e=":not("+e+")"),1===t.length&&1===r.nodeType?w.find.matchesSelector(r,e)?[r]:[]:w.find.matches(e,w.grep(t,function(e){return 1===e.nodeType}))},w.fn.extend({find:function(e){var t,n,r=this.length,i=this;if("string"!=typeof e)return this.pushStack(w(e).filter(function(){for(t=0;t<r;t++)if(w.contains(i[t],this))return!0}));for(n=this.pushStack([]),t=0;t<r;t++)w.find(e,i[t],n);return r>1?w.uniqueSort(n):n},filter:function(e){return this.pushStack(j(this,e||[],!1))},not:function(e){return this.pushStack(j(this,e||[],!0))},is:function(e){return!!j(this,"string"==typeof e&&D.test(e)?w(e):e||[],!1).length}});var q,L=/^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/;(w.fn.init=function(e,t,n){var i,o;if(!e)return this;if(n=n||q,"string"==typeof e){if(!(i="<"===e[0]&&">"===e[e.length-1]&&e.length>=3?[null,e,null]:L.exec(e))||!i[1]&&t)return!t||t.jquery?(t||n).find(e):this.constructor(t).find(e);if(i[1]){if(t=t instanceof w?t[0]:t,w.merge(this,w.parseHTML(i[1],t&&t.nodeType?t.ownerDocument||t:r,!0)),A.test(i[1])&&w.isPlainObject(t))for(i in t)g(this[i])?this[i](t[i]):this.attr(i,t[i]);return this}return(o=r.getElementById(i[2]))&&(this[0]=o,this.length=1),this}return e.nodeType?(this[0]=e,this.length=1,this):g(e)?void 0!==n.ready?n.ready(e):e(w):w.makeArray(e,this)}).prototype=w.fn,q=w(r);var H=/^(?:parents|prev(?:Until|All))/,O={children:!0,contents:!0,next:!0,prev:!0};w.fn.extend({has:function(e){var t=w(e,this),n=t.length;return this.filter(function(){for(var e=0;e<n;e++)if(w.contains(this,t[e]))return!0})},closest:function(e,t){var n,r=0,i=this.length,o=[],a="string"!=typeof e&&w(e);if(!D.test(e))for(;r<i;r++)for(n=this[r];n&&n!==t;n=n.parentNode)if(n.nodeType<11&&(a?a.index(n)>-1:1===n.nodeType&&w.find.matchesSelector(n,e))){o.push(n);break}return this.pushStack(o.length>1?w.uniqueSort(o):o)},index:function(e){return e?"string"==typeof e?u.call(w(e),this[0]):u.call(this,e.jquery?e[0]:e):this[0]&&this[0].parentNode?this.first().prevAll().length:-1},add:function(e,t){return this.pushStack(w.uniqueSort(w.merge(this.get(),w(e,t))))},addBack:function(e){return this.add(null==e?this.prevObject:this.prevObject.filter(e))}});function P(e,t){while((e=e[t])&&1!==e.nodeType);return e}w.each({parent:function(e){var t=e.parentNode;return t&&11!==t.nodeType?t:null},parents:function(e){return k(e,"parentNode")},parentsUntil:function(e,t,n){return k(e,"parentNode",n)},next:function(e){return P(e,"nextSibling")},prev:function(e){return P(e,"previousSibling")},nextAll:function(e){return k(e,"nextSibling")},prevAll:function(e){return k(e,"previousSibling")},nextUntil:function(e,t,n){return k(e,"nextSibling",n)},prevUntil:function(e,t,n){return k(e,"previousSibling",n)},siblings:function(e){return S((e.parentNode||{}).firstChild,e)},children:function(e){return S(e.firstChild)},contents:function(e){return N(e,"iframe")?e.contentDocument:(N(e,"template")&&(e=e.content||e),w.merge([],e.childNodes))}},function(e,t){w.fn[e]=function(n,r){var i=w.map(this,t,n);return"Until"!==e.slice(-5)&&(r=n),r&&"string"==typeof r&&(i=w.filter(r,i)),this.length>1&&(O[e]||w.uniqueSort(i),H.test(e)&&i.reverse()),this.pushStack(i)}});var M=/[^\x20\t\r\n\f]+/g;function R(e){var t={};return w.each(e.match(M)||[],function(e,n){t[n]=!0}),t}w.Callbacks=function(e){e="string"==typeof e?R(e):w.extend({},e);var t,n,r,i,o=[],a=[],s=-1,u=function(){for(i=i||e.once,r=t=!0;a.length;s=-1){n=a.shift();while(++s<o.length)!1===o[s].apply(n[0],n[1])&&e.stopOnFalse&&(s=o.length,n=!1)}e.memory||(n=!1),t=!1,i&&(o=n?[]:"")},l={add:function(){return o&&(n&&!t&&(s=o.length-1,a.push(n)),function t(n){w.each(n,function(n,r){g(r)?e.unique&&l.has(r)||o.push(r):r&&r.length&&"string"!==x(r)&&t(r)})}(arguments),n&&!t&&u()),this},remove:function(){return w.each(arguments,function(e,t){var n;while((n=w.inArray(t,o,n))>-1)o.splice(n,1),n<=s&&s--}),this},has:function(e){return e?w.inArray(e,o)>-1:o.length>0},empty:function(){return o&&(o=[]),this},disable:function(){return i=a=[],o=n="",this},disabled:function(){return!o},lock:function(){return i=a=[],n||t||(o=n=""),this},locked:function(){return!!i},fireWith:function(e,n){return i||(n=[e,(n=n||[]).slice?n.slice():n],a.push(n),t||u()),this},fire:function(){return l.fireWith(this,arguments),this},fired:function(){return!!r}};return l};function I(e){return e}function W(e){throw e}function $(e,t,n,r){var i;try{e&&g(i=e.promise)?i.call(e).done(t).fail(n):e&&g(i=e.then)?i.call(e,t,n):t.apply(void 0,[e].slice(r))}catch(e){n.apply(void 0,[e])}}w.extend({Deferred:function(t){var n=[["notify","progress",w.Callbacks("memory"),w.Callbacks("memory"),2],["resolve","done",w.Callbacks("once memory"),w.Callbacks("once memory"),0,"resolved"],["reject","fail",w.Callbacks("once memory"),w.Callbacks("once memory"),1,"rejected"]],r="pending",i={state:function(){return r},always:function(){return o.done(arguments).fail(arguments),this},"catch":function(e){return i.then(null,e)},pipe:function(){var e=arguments;return w.Deferred(function(t){w.each(n,function(n,r){var i=g(e[r[4]])&&e[r[4]];o[r[1]](function(){var e=i&&i.apply(this,arguments);e&&g(e.promise)?e.promise().progress(t.notify).done(t.resolve).fail(t.reject):t[r[0]+"With"](this,i?[e]:arguments)})}),e=null}).promise()},then:function(t,r,i){var o=0;function a(t,n,r,i){return function(){var s=this,u=arguments,l=function(){var e,l;if(!(t<o)){if((e=r.apply(s,u))===n.promise())throw new TypeError("Thenable self-resolution");l=e&&("object"==typeof e||"function"==typeof e)&&e.then,g(l)?i?l.call(e,a(o,n,I,i),a(o,n,W,i)):(o++,l.call(e,a(o,n,I,i),a(o,n,W,i),a(o,n,I,n.notifyWith))):(r!==I&&(s=void 0,u=[e]),(i||n.resolveWith)(s,u))}},c=i?l:function(){try{l()}catch(e){w.Deferred.exceptionHook&&w.Deferred.exceptionHook(e,c.stackTrace),t+1>=o&&(r!==W&&(s=void 0,u=[e]),n.rejectWith(s,u))}};t?c():(w.Deferred.getStackHook&&(c.stackTrace=w.Deferred.getStackHook()),e.setTimeout(c))}}return w.Deferred(function(e){n[0][3].add(a(0,e,g(i)?i:I,e.notifyWith)),n[1][3].add(a(0,e,g(t)?t:I)),n[2][3].add(a(0,e,g(r)?r:W))}).promise()},promise:function(e){return null!=e?w.extend(e,i):i}},o={};return w.each(n,function(e,t){var a=t[2],s=t[5];i[t[1]]=a.add,s&&a.add(function(){r=s},n[3-e][2].disable,n[3-e][3].disable,n[0][2].lock,n[0][3].lock),a.add(t[3].fire),o[t[0]]=function(){return o[t[0]+"With"](this===o?void 0:this,arguments),this},o[t[0]+"With"]=a.fireWith}),i.promise(o),t&&t.call(o,o),o},when:function(e){var t=arguments.length,n=t,r=Array(n),i=o.call(arguments),a=w.Deferred(),s=function(e){return function(n){r[e]=this,i[e]=arguments.length>1?o.call(arguments):n,--t||a.resolveWith(r,i)}};if(t<=1&&($(e,a.done(s(n)).resolve,a.reject,!t),"pending"===a.state()||g(i[n]&&i[n].then)))return a.then();while(n--)$(i[n],s(n),a.reject);return a.promise()}});var B=/^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;w.Deferred.exceptionHook=function(t,n){e.console&&e.console.warn&&t&&B.test(t.name)&&e.console.warn("jQuery.Deferred exception: "+t.message,t.stack,n)},w.readyException=function(t){e.setTimeout(function(){throw t})};var F=w.Deferred();w.fn.ready=function(e){return F.then(e)["catch"](function(e){w.readyException(e)}),this},w.extend({isReady:!1,readyWait:1,ready:function(e){(!0===e?--w.readyWait:w.isReady)||(w.isReady=!0,!0!==e&&--w.readyWait>0||F.resolveWith(r,[w]))}}),w.ready.then=F.then;function _(){r.removeEventListener("DOMContentLoaded",_),e.removeEventListener("load",_),w.ready()}"complete"===r.readyState||"loading"!==r.readyState&&!r.documentElement.doScroll?e.setTimeout(w.ready):(r.addEventListener("DOMContentLoaded",_),e.addEventListener("load",_));var z=function(e,t,n,r,i,o,a){var s=0,u=e.length,l=null==n;if("object"===x(n)){i=!0;for(s in n)z(e,t,s,n[s],!0,o,a)}else if(void 0!==r&&(i=!0,g(r)||(a=!0),l&&(a?(t.call(e,r),t=null):(l=t,t=function(e,t,n){return l.call(w(e),n)})),t))for(;s<u;s++)t(e[s],n,a?r:r.call(e[s],s,t(e[s],n)));return i?e:l?t.call(e):u?t(e[0],n):o},X=/^-ms-/,U=/-([a-z])/g;function V(e,t){return t.toUpperCase()}function G(e){return e.replace(X,"ms-").replace(U,V)}var Y=function(e){return 1===e.nodeType||9===e.nodeType||!+e.nodeType};function Q(){this.expando=w.expando+Q.uid++}Q.uid=1,Q.prototype={cache:function(e){var t=e[this.expando];return t||(t={},Y(e)&&(e.nodeType?e[this.expando]=t:Object.defineProperty(e,this.expando,{value:t,configurable:!0}))),t},set:function(e,t,n){var r,i=this.cache(e);if("string"==typeof t)i[G(t)]=n;else for(r in t)i[G(r)]=t[r];return i},get:function(e,t){return void 0===t?this.cache(e):e[this.expando]&&e[this.expando][G(t)]},access:function(e,t,n){return void 0===t||t&&"string"==typeof t&&void 0===n?this.get(e,t):(this.set(e,t,n),void 0!==n?n:t)},remove:function(e,t){var n,r=e[this.expando];if(void 0!==r){if(void 0!==t){n=(t=Array.isArray(t)?t.map(G):(t=G(t))in r?[t]:t.match(M)||[]).length;while(n--)delete r[t[n]]}(void 0===t||w.isEmptyObject(r))&&(e.nodeType?e[this.expando]=void 0:delete e[this.expando])}},hasData:function(e){var t=e[this.expando];return void 0!==t&&!w.isEmptyObject(t)}};var J=new Q,K=new Q,Z=/^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,ee=/[A-Z]/g;function te(e){return"true"===e||"false"!==e&&("null"===e?null:e===+e+""?+e:Z.test(e)?JSON.parse(e):e)}function ne(e,t,n){var r;if(void 0===n&&1===e.nodeType)if(r="data-"+t.replace(ee,"-$&").toLowerCase(),"string"==typeof(n=e.getAttribute(r))){try{n=te(n)}catch(e){}K.set(e,t,n)}else n=void 0;return n}w.extend({hasData:function(e){return K.hasData(e)||J.hasData(e)},data:function(e,t,n){return K.access(e,t,n)},removeData:function(e,t){K.remove(e,t)},_data:function(e,t,n){return J.access(e,t,n)},_removeData:function(e,t){J.remove(e,t)}}),w.fn.extend({data:function(e,t){var n,r,i,o=this[0],a=o&&o.attributes;if(void 0===e){if(this.length&&(i=K.get(o),1===o.nodeType&&!J.get(o,"hasDataAttrs"))){n=a.length;while(n--)a[n]&&0===(r=a[n].name).indexOf("data-")&&(r=G(r.slice(5)),ne(o,r,i[r]));J.set(o,"hasDataAttrs",!0)}return i}return"object"==typeof e?this.each(function(){K.set(this,e)}):z(this,function(t){var n;if(o&&void 0===t){if(void 0!==(n=K.get(o,e)))return n;if(void 0!==(n=ne(o,e)))return n}else this.each(function(){K.set(this,e,t)})},null,t,arguments.length>1,null,!0)},removeData:function(e){return this.each(function(){K.remove(this,e)})}}),w.extend({queue:function(e,t,n){var r;if(e)return t=(t||"fx")+"queue",r=J.get(e,t),n&&(!r||Array.isArray(n)?r=J.access(e,t,w.makeArray(n)):r.push(n)),r||[]},dequeue:function(e,t){t=t||"fx";var n=w.queue(e,t),r=n.length,i=n.shift(),o=w._queueHooks(e,t),a=function(){w.dequeue(e,t)};"inprogress"===i&&(i=n.shift(),r--),i&&("fx"===t&&n.unshift("inprogress"),delete o.stop,i.call(e,a,o)),!r&&o&&o.empty.fire()},_queueHooks:function(e,t){var n=t+"queueHooks";return J.get(e,n)||J.access(e,n,{empty:w.Callbacks("once memory").add(function(){J.remove(e,[t+"queue",n])})})}}),w.fn.extend({queue:function(e,t){var n=2;return"string"!=typeof e&&(t=e,e="fx",n--),arguments.length<n?w.queue(this[0],e):void 0===t?this:this.each(function(){var n=w.queue(this,e,t);w._queueHooks(this,e),"fx"===e&&"inprogress"!==n[0]&&w.dequeue(this,e)})},dequeue:function(e){return this.each(function(){w.dequeue(this,e)})},clearQueue:function(e){return this.queue(e||"fx",[])},promise:function(e,t){var n,r=1,i=w.Deferred(),o=this,a=this.length,s=function(){--r||i.resolveWith(o,[o])};"string"!=typeof e&&(t=e,e=void 0),e=e||"fx";while(a--)(n=J.get(o[a],e+"queueHooks"))&&n.empty&&(r++,n.empty.add(s));return s(),i.promise(t)}});var re=/[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,ie=new RegExp("^(?:([+-])=|)("+re+")([a-z%]*)$","i"),oe=["Top","Right","Bottom","Left"],ae=function(e,t){return"none"===(e=t||e).style.display||""===e.style.display&&w.contains(e.ownerDocument,e)&&"none"===w.css(e,"display")},se=function(e,t,n,r){var i,o,a={};for(o in t)a[o]=e.style[o],e.style[o]=t[o];i=n.apply(e,r||[]);for(o in t)e.style[o]=a[o];return i};function ue(e,t,n,r){var i,o,a=20,s=r?function(){return r.cur()}:function(){return w.css(e,t,"")},u=s(),l=n&&n[3]||(w.cssNumber[t]?"":"px"),c=(w.cssNumber[t]||"px"!==l&&+u)&&ie.exec(w.css(e,t));if(c&&c[3]!==l){u/=2,l=l||c[3],c=+u||1;while(a--)w.style(e,t,c+l),(1-o)*(1-(o=s()/u||.5))<=0&&(a=0),c/=o;c*=2,w.style(e,t,c+l),n=n||[]}return n&&(c=+c||+u||0,i=n[1]?c+(n[1]+1)*n[2]:+n[2],r&&(r.unit=l,r.start=c,r.end=i)),i}var le={};function ce(e){var t,n=e.ownerDocument,r=e.nodeName,i=le[r];return i||(t=n.body.appendChild(n.createElement(r)),i=w.css(t,"display"),t.parentNode.removeChild(t),"none"===i&&(i="block"),le[r]=i,i)}function fe(e,t){for(var n,r,i=[],o=0,a=e.length;o<a;o++)(r=e[o]).style&&(n=r.style.display,t?("none"===n&&(i[o]=J.get(r,"display")||null,i[o]||(r.style.display="")),""===r.style.display&&ae(r)&&(i[o]=ce(r))):"none"!==n&&(i[o]="none",J.set(r,"display",n)));for(o=0;o<a;o++)null!=i[o]&&(e[o].style.display=i[o]);return e}w.fn.extend({show:function(){return fe(this,!0)},hide:function(){return fe(this)},toggle:function(e){return"boolean"==typeof e?e?this.show():this.hide():this.each(function(){ae(this)?w(this).show():w(this).hide()})}});var pe=/^(?:checkbox|radio)$/i,de=/<([a-z][^\/\0>\x20\t\r\n\f]+)/i,he=/^$|^module$|\/(?:java|ecma)script/i,ge={option:[1,"<select multiple='multiple'>","</select>"],thead:[1,"<table>","</table>"],col:[2,"<table><colgroup>","</colgroup></table>"],tr:[2,"<table><tbody>","</tbody></table>"],td:[3,"<table><tbody><tr>","</tr></tbody></table>"],_default:[0,"",""]};ge.optgroup=ge.option,ge.tbody=ge.tfoot=ge.colgroup=ge.caption=ge.thead,ge.th=ge.td;function ye(e,t){var n;return n="undefined"!=typeof e.getElementsByTagName?e.getElementsByTagName(t||"*"):"undefined"!=typeof e.querySelectorAll?e.querySelectorAll(t||"*"):[],void 0===t||t&&N(e,t)?w.merge([e],n):n}function ve(e,t){for(var n=0,r=e.length;n<r;n++)J.set(e[n],"globalEval",!t||J.get(t[n],"globalEval"))}var me=/<|&#?\w+;/;function xe(e,t,n,r,i){for(var o,a,s,u,l,c,f=t.createDocumentFragment(),p=[],d=0,h=e.length;d<h;d++)if((o=e[d])||0===o)if("object"===x(o))w.merge(p,o.nodeType?[o]:o);else if(me.test(o)){a=a||f.appendChild(t.createElement("div")),s=(de.exec(o)||["",""])[1].toLowerCase(),u=ge[s]||ge._default,a.innerHTML=u[1]+w.htmlPrefilter(o)+u[2],c=u[0];while(c--)a=a.lastChild;w.merge(p,a.childNodes),(a=f.firstChild).textContent=""}else p.push(t.createTextNode(o));f.textContent="",d=0;while(o=p[d++])if(r&&w.inArray(o,r)>-1)i&&i.push(o);else if(l=w.contains(o.ownerDocument,o),a=ye(f.appendChild(o),"script"),l&&ve(a),n){c=0;while(o=a[c++])he.test(o.type||"")&&n.push(o)}return f}!function(){var e=r.createDocumentFragment().appendChild(r.createElement("div")),t=r.createElement("input");t.setAttribute("type","radio"),t.setAttribute("checked","checked"),t.setAttribute("name","t"),e.appendChild(t),h.checkClone=e.cloneNode(!0).cloneNode(!0).lastChild.checked,e.innerHTML="<textarea>x</textarea>",h.noCloneChecked=!!e.cloneNode(!0).lastChild.defaultValue}();var be=r.documentElement,we=/^key/,Te=/^(?:mouse|pointer|contextmenu|drag|drop)|click/,Ce=/^([^.]*)(?:\.(.+)|)/;function Ee(){return!0}function ke(){return!1}function Se(){try{return r.activeElement}catch(e){}}function De(e,t,n,r,i,o){var a,s;if("object"==typeof t){"string"!=typeof n&&(r=r||n,n=void 0);for(s in t)De(e,s,n,r,t[s],o);return e}if(null==r&&null==i?(i=n,r=n=void 0):null==i&&("string"==typeof n?(i=r,r=void 0):(i=r,r=n,n=void 0)),!1===i)i=ke;else if(!i)return e;return 1===o&&(a=i,(i=function(e){return w().off(e),a.apply(this,arguments)}).guid=a.guid||(a.guid=w.guid++)),e.each(function(){w.event.add(this,t,i,r,n)})}w.event={global:{},add:function(e,t,n,r,i){var o,a,s,u,l,c,f,p,d,h,g,y=J.get(e);if(y){n.handler&&(n=(o=n).handler,i=o.selector),i&&w.find.matchesSelector(be,i),n.guid||(n.guid=w.guid++),(u=y.events)||(u=y.events={}),(a=y.handle)||(a=y.handle=function(t){return"undefined"!=typeof w&&w.event.triggered!==t.type?w.event.dispatch.apply(e,arguments):void 0}),l=(t=(t||"").match(M)||[""]).length;while(l--)d=g=(s=Ce.exec(t[l])||[])[1],h=(s[2]||"").split(".").sort(),d&&(f=w.event.special[d]||{},d=(i?f.delegateType:f.bindType)||d,f=w.event.special[d]||{},c=w.extend({type:d,origType:g,data:r,handler:n,guid:n.guid,selector:i,needsContext:i&&w.expr.match.needsContext.test(i),namespace:h.join(".")},o),(p=u[d])||((p=u[d]=[]).delegateCount=0,f.setup&&!1!==f.setup.call(e,r,h,a)||e.addEventListener&&e.addEventListener(d,a)),f.add&&(f.add.call(e,c),c.handler.guid||(c.handler.guid=n.guid)),i?p.splice(p.delegateCount++,0,c):p.push(c),w.event.global[d]=!0)}},remove:function(e,t,n,r,i){var o,a,s,u,l,c,f,p,d,h,g,y=J.hasData(e)&&J.get(e);if(y&&(u=y.events)){l=(t=(t||"").match(M)||[""]).length;while(l--)if(s=Ce.exec(t[l])||[],d=g=s[1],h=(s[2]||"").split(".").sort(),d){f=w.event.special[d]||{},p=u[d=(r?f.delegateType:f.bindType)||d]||[],s=s[2]&&new RegExp("(^|\\.)"+h.join("\\.(?:.*\\.|)")+"(\\.|$)"),a=o=p.length;while(o--)c=p[o],!i&&g!==c.origType||n&&n.guid!==c.guid||s&&!s.test(c.namespace)||r&&r!==c.selector&&("**"!==r||!c.selector)||(p.splice(o,1),c.selector&&p.delegateCount--,f.remove&&f.remove.call(e,c));a&&!p.length&&(f.teardown&&!1!==f.teardown.call(e,h,y.handle)||w.removeEvent(e,d,y.handle),delete u[d])}else for(d in u)w.event.remove(e,d+t[l],n,r,!0);w.isEmptyObject(u)&&J.remove(e,"handle events")}},dispatch:function(e){var t=w.event.fix(e),n,r,i,o,a,s,u=new Array(arguments.length),l=(J.get(this,"events")||{})[t.type]||[],c=w.event.special[t.type]||{};for(u[0]=t,n=1;n<arguments.length;n++)u[n]=arguments[n];if(t.delegateTarget=this,!c.preDispatch||!1!==c.preDispatch.call(this,t)){s=w.event.handlers.call(this,t,l),n=0;while((o=s[n++])&&!t.isPropagationStopped()){t.currentTarget=o.elem,r=0;while((a=o.handlers[r++])&&!t.isImmediatePropagationStopped())t.rnamespace&&!t.rnamespace.test(a.namespace)||(t.handleObj=a,t.data=a.data,void 0!==(i=((w.event.special[a.origType]||{}).handle||a.handler).apply(o.elem,u))&&!1===(t.result=i)&&(t.preventDefault(),t.stopPropagation()))}return c.postDispatch&&c.postDispatch.call(this,t),t.result}},handlers:function(e,t){var n,r,i,o,a,s=[],u=t.delegateCount,l=e.target;if(u&&l.nodeType&&!("click"===e.type&&e.button>=1))for(;l!==this;l=l.parentNode||this)if(1===l.nodeType&&("click"!==e.type||!0!==l.disabled)){for(o=[],a={},n=0;n<u;n++)void 0===a[i=(r=t[n]).selector+" "]&&(a[i]=r.needsContext?w(i,this).index(l)>-1:w.find(i,this,null,[l]).length),a[i]&&o.push(r);o.length&&s.push({elem:l,handlers:o})}return l=this,u<t.length&&s.push({elem:l,handlers:t.slice(u)}),s},addProp:function(e,t){Object.defineProperty(w.Event.prototype,e,{enumerable:!0,configurable:!0,get:g(t)?function(){if(this.originalEvent)return t(this.originalEvent)}:function(){if(this.originalEvent)return this.originalEvent[e]},set:function(t){Object.defineProperty(this,e,{enumerable:!0,configurable:!0,writable:!0,value:t})}})},fix:function(e){return e[w.expando]?e:new w.Event(e)},special:{load:{noBubble:!0},focus:{trigger:function(){if(this!==Se()&&this.focus)return this.focus(),!1},delegateType:"focusin"},blur:{trigger:function(){if(this===Se()&&this.blur)return this.blur(),!1},delegateType:"focusout"},click:{trigger:function(){if("checkbox"===this.type&&this.click&&N(this,"input"))return this.click(),!1},_default:function(e){return N(e.target,"a")}},beforeunload:{postDispatch:function(e){void 0!==e.result&&e.originalEvent&&(e.originalEvent.returnValue=e.result)}}}},w.removeEvent=function(e,t,n){e.removeEventListener&&e.removeEventListener(t,n)},w.Event=function(e,t){if(!(this instanceof w.Event))return new w.Event(e,t);e&&e.type?(this.originalEvent=e,this.type=e.type,this.isDefaultPrevented=e.defaultPrevented||void 0===e.defaultPrevented&&!1===e.returnValue?Ee:ke,this.target=e.target&&3===e.target.nodeType?e.target.parentNode:e.target,this.currentTarget=e.currentTarget,this.relatedTarget=e.relatedTarget):this.type=e,t&&w.extend(this,t),this.timeStamp=e&&e.timeStamp||Date.now(),this[w.expando]=!0},w.Event.prototype={constructor:w.Event,isDefaultPrevented:ke,isPropagationStopped:ke,isImmediatePropagationStopped:ke,isSimulated:!1,preventDefault:function(){var e=this.originalEvent;this.isDefaultPrevented=Ee,e&&!this.isSimulated&&e.preventDefault()},stopPropagation:function(){var e=this.originalEvent;this.isPropagationStopped=Ee,e&&!this.isSimulated&&e.stopPropagation()},stopImmediatePropagation:function(){var e=this.originalEvent;this.isImmediatePropagationStopped=Ee,e&&!this.isSimulated&&e.stopImmediatePropagation(),this.stopPropagation()}},w.each({altKey:!0,bubbles:!0,cancelable:!0,changedTouches:!0,ctrlKey:!0,detail:!0,eventPhase:!0,metaKey:!0,pageX:!0,pageY:!0,shiftKey:!0,view:!0,"char":!0,charCode:!0,key:!0,keyCode:!0,button:!0,buttons:!0,clientX:!0,clientY:!0,offsetX:!0,offsetY:!0,pointerId:!0,pointerType:!0,screenX:!0,screenY:!0,targetTouches:!0,toElement:!0,touches:!0,which:function(e){var t=e.button;return null==e.which&&we.test(e.type)?null!=e.charCode?e.charCode:e.keyCode:!e.which&&void 0!==t&&Te.test(e.type)?1&t?1:2&t?3:4&t?2:0:e.which}},w.event.addProp),w.each({mouseenter:"mouseover",mouseleave:"mouseout",pointerenter:"pointerover",pointerleave:"pointerout"},function(e,t){w.event.special[e]={delegateType:t,bindType:t,handle:function(e){var n,r=this,i=e.relatedTarget,o=e.handleObj;return i&&(i===r||w.contains(r,i))||(e.type=o.origType,n=o.handler.apply(this,arguments),e.type=t),n}}}),w.fn.extend({on:function(e,t,n,r){return De(this,e,t,n,r)},one:function(e,t,n,r){return De(this,e,t,n,r,1)},off:function(e,t,n){var r,i;if(e&&e.preventDefault&&e.handleObj)return r=e.handleObj,w(e.delegateTarget).off(r.namespace?r.origType+"."+r.namespace:r.origType,r.selector,r.handler),this;if("object"==typeof e){for(i in e)this.off(i,t,e[i]);return this}return!1!==t&&"function"!=typeof t||(n=t,t=void 0),!1===n&&(n=ke),this.each(function(){w.event.remove(this,e,n,t)})}});var Ne=/<(?!area|br|col|embed|hr|img|input|link|meta|param)(([a-z][^\/\0>\x20\t\r\n\f]*)[^>]*)\/>/gi,Ae=/<script|<style|<link/i,je=/checked\s*(?:[^=]|=\s*.checked.)/i,qe=/^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;function Le(e,t){return N(e,"table")&&N(11!==t.nodeType?t:t.firstChild,"tr")?w(e).children("tbody")[0]||e:e}function He(e){return e.type=(null!==e.getAttribute("type"))+"/"+e.type,e}function Oe(e){return"true/"===(e.type||"").slice(0,5)?e.type=e.type.slice(5):e.removeAttribute("type"),e}function Pe(e,t){var n,r,i,o,a,s,u,l;if(1===t.nodeType){if(J.hasData(e)&&(o=J.access(e),a=J.set(t,o),l=o.events)){delete a.handle,a.events={};for(i in l)for(n=0,r=l[i].length;n<r;n++)w.event.add(t,i,l[i][n])}K.hasData(e)&&(s=K.access(e),u=w.extend({},s),K.set(t,u))}}function Me(e,t){var n=t.nodeName.toLowerCase();"input"===n&&pe.test(e.type)?t.checked=e.checked:"input"!==n&&"textarea"!==n||(t.defaultValue=e.defaultValue)}function Re(e,t,n,r){t=a.apply([],t);var i,o,s,u,l,c,f=0,p=e.length,d=p-1,y=t[0],v=g(y);if(v||p>1&&"string"==typeof y&&!h.checkClone&&je.test(y))return e.each(function(i){var o=e.eq(i);v&&(t[0]=y.call(this,i,o.html())),Re(o,t,n,r)});if(p&&(i=xe(t,e[0].ownerDocument,!1,e,r),o=i.firstChild,1===i.childNodes.length&&(i=o),o||r)){for(u=(s=w.map(ye(i,"script"),He)).length;f<p;f++)l=i,f!==d&&(l=w.clone(l,!0,!0),u&&w.merge(s,ye(l,"script"))),n.call(e[f],l,f);if(u)for(c=s[s.length-1].ownerDocument,w.map(s,Oe),f=0;f<u;f++)l=s[f],he.test(l.type||"")&&!J.access(l,"globalEval")&&w.contains(c,l)&&(l.src&&"module"!==(l.type||"").toLowerCase()?w._evalUrl&&w._evalUrl(l.src):m(l.textContent.replace(qe,""),c,l))}return e}function Ie(e,t,n){for(var r,i=t?w.filter(t,e):e,o=0;null!=(r=i[o]);o++)n||1!==r.nodeType||w.cleanData(ye(r)),r.parentNode&&(n&&w.contains(r.ownerDocument,r)&&ve(ye(r,"script")),r.parentNode.removeChild(r));return e}w.extend({htmlPrefilter:function(e){return e.replace(Ne,"<$1></$2>")},clone:function(e,t,n){var r,i,o,a,s=e.cloneNode(!0),u=w.contains(e.ownerDocument,e);if(!(h.noCloneChecked||1!==e.nodeType&&11!==e.nodeType||w.isXMLDoc(e)))for(a=ye(s),r=0,i=(o=ye(e)).length;r<i;r++)Me(o[r],a[r]);if(t)if(n)for(o=o||ye(e),a=a||ye(s),r=0,i=o.length;r<i;r++)Pe(o[r],a[r]);else Pe(e,s);return(a=ye(s,"script")).length>0&&ve(a,!u&&ye(e,"script")),s},cleanData:function(e){for(var t,n,r,i=w.event.special,o=0;void 0!==(n=e[o]);o++)if(Y(n)){if(t=n[J.expando]){if(t.events)for(r in t.events)i[r]?w.event.remove(n,r):w.removeEvent(n,r,t.handle);n[J.expando]=void 0}n[K.expando]&&(n[K.expando]=void 0)}}}),w.fn.extend({detach:function(e){return Ie(this,e,!0)},remove:function(e){return Ie(this,e)},text:function(e){return z(this,function(e){return void 0===e?w.text(this):this.empty().each(function(){1!==this.nodeType&&11!==this.nodeType&&9!==this.nodeType||(this.textContent=e)})},null,e,arguments.length)},append:function(){return Re(this,arguments,function(e){1!==this.nodeType&&11!==this.nodeType&&9!==this.nodeType||Le(this,e).appendChild(e)})},prepend:function(){return Re(this,arguments,function(e){if(1===this.nodeType||11===this.nodeType||9===this.nodeType){var t=Le(this,e);t.insertBefore(e,t.firstChild)}})},before:function(){return Re(this,arguments,function(e){this.parentNode&&this.parentNode.insertBefore(e,this)})},after:function(){return Re(this,arguments,function(e){this.parentNode&&this.parentNode.insertBefore(e,this.nextSibling)})},empty:function(){for(var e,t=0;null!=(e=this[t]);t++)1===e.nodeType&&(w.cleanData(ye(e,!1)),e.textContent="");return this},clone:function(e,t){return e=null!=e&&e,t=null==t?e:t,this.map(function(){return w.clone(this,e,t)})},html:function(e){return z(this,function(e){var t=this[0]||{},n=0,r=this.length;if(void 0===e&&1===t.nodeType)return t.innerHTML;if("string"==typeof e&&!Ae.test(e)&&!ge[(de.exec(e)||["",""])[1].toLowerCase()]){e=w.htmlPrefilter(e);try{for(;n<r;n++)1===(t=this[n]||{}).nodeType&&(w.cleanData(ye(t,!1)),t.innerHTML=e);t=0}catch(e){}}t&&this.empty().append(e)},null,e,arguments.length)},replaceWith:function(){var e=[];return Re(this,arguments,function(t){var n=this.parentNode;w.inArray(this,e)<0&&(w.cleanData(ye(this)),n&&n.replaceChild(t,this))},e)}}),w.each({appendTo:"append",prependTo:"prepend",insertBefore:"before",insertAfter:"after",replaceAll:"replaceWith"},function(e,t){w.fn[e]=function(e){for(var n,r=[],i=w(e),o=i.length-1,a=0;a<=o;a++)n=a===o?this:this.clone(!0),w(i[a])[t](n),s.apply(r,n.get());return this.pushStack(r)}});var We=new RegExp("^("+re+")(?!px)[a-z%]+$","i"),$e=function(t){var n=t.ownerDocument.defaultView;return n&&n.opener||(n=e),n.getComputedStyle(t)},Be=new RegExp(oe.join("|"),"i");!function(){function t(){if(c){l.style.cssText="position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0",c.style.cssText="position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%",be.appendChild(l).appendChild(c);var t=e.getComputedStyle(c);i="1%"!==t.top,u=12===n(t.marginLeft),c.style.right="60%",s=36===n(t.right),o=36===n(t.width),c.style.position="absolute",a=36===c.offsetWidth||"absolute",be.removeChild(l),c=null}}function n(e){return Math.round(parseFloat(e))}var i,o,a,s,u,l=r.createElement("div"),c=r.createElement("div");c.style&&(c.style.backgroundClip="content-box",c.cloneNode(!0).style.backgroundClip="",h.clearCloneStyle="content-box"===c.style.backgroundClip,w.extend(h,{boxSizingReliable:function(){return t(),o},pixelBoxStyles:function(){return t(),s},pixelPosition:function(){return t(),i},reliableMarginLeft:function(){return t(),u},scrollboxSize:function(){return t(),a}}))}();function Fe(e,t,n){var r,i,o,a,s=e.style;return(n=n||$e(e))&&(""!==(a=n.getPropertyValue(t)||n[t])||w.contains(e.ownerDocument,e)||(a=w.style(e,t)),!h.pixelBoxStyles()&&We.test(a)&&Be.test(t)&&(r=s.width,i=s.minWidth,o=s.maxWidth,s.minWidth=s.maxWidth=s.width=a,a=n.width,s.width=r,s.minWidth=i,s.maxWidth=o)),void 0!==a?a+"":a}function _e(e,t){return{get:function(){if(!e())return(this.get=t).apply(this,arguments);delete this.get}}}var ze=/^(none|table(?!-c[ea]).+)/,Xe=/^--/,Ue={position:"absolute",visibility:"hidden",display:"block"},Ve={letterSpacing:"0",fontWeight:"400"},Ge=["Webkit","Moz","ms"],Ye=r.createElement("div").style;function Qe(e){if(e in Ye)return e;var t=e[0].toUpperCase()+e.slice(1),n=Ge.length;while(n--)if((e=Ge[n]+t)in Ye)return e}function Je(e){var t=w.cssProps[e];return t||(t=w.cssProps[e]=Qe(e)||e),t}function Ke(e,t,n){var r=ie.exec(t);return r?Math.max(0,r[2]-(n||0))+(r[3]||"px"):t}function Ze(e,t,n,r,i,o){var a="width"===t?1:0,s=0,u=0;if(n===(r?"border":"content"))return 0;for(;a<4;a+=2)"margin"===n&&(u+=w.css(e,n+oe[a],!0,i)),r?("content"===n&&(u-=w.css(e,"padding"+oe[a],!0,i)),"margin"!==n&&(u-=w.css(e,"border"+oe[a]+"Width",!0,i))):(u+=w.css(e,"padding"+oe[a],!0,i),"padding"!==n?u+=w.css(e,"border"+oe[a]+"Width",!0,i):s+=w.css(e,"border"+oe[a]+"Width",!0,i));return!r&&o>=0&&(u+=Math.max(0,Math.ceil(e["offset"+t[0].toUpperCase()+t.slice(1)]-o-u-s-.5))),u}function et(e,t,n){var r=$e(e),i=Fe(e,t,r),o="border-box"===w.css(e,"boxSizing",!1,r),a=o;if(We.test(i)){if(!n)return i;i="auto"}return a=a&&(h.boxSizingReliable()||i===e.style[t]),("auto"===i||!parseFloat(i)&&"inline"===w.css(e,"display",!1,r))&&(i=e["offset"+t[0].toUpperCase()+t.slice(1)],a=!0),(i=parseFloat(i)||0)+Ze(e,t,n||(o?"border":"content"),a,r,i)+"px"}w.extend({cssHooks:{opacity:{get:function(e,t){if(t){var n=Fe(e,"opacity");return""===n?"1":n}}}},cssNumber:{animationIterationCount:!0,columnCount:!0,fillOpacity:!0,flexGrow:!0,flexShrink:!0,fontWeight:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,widows:!0,zIndex:!0,zoom:!0},cssProps:{},style:function(e,t,n,r){if(e&&3!==e.nodeType&&8!==e.nodeType&&e.style){var i,o,a,s=G(t),u=Xe.test(t),l=e.style;if(u||(t=Je(s)),a=w.cssHooks[t]||w.cssHooks[s],void 0===n)return a&&"get"in a&&void 0!==(i=a.get(e,!1,r))?i:l[t];"string"==(o=typeof n)&&(i=ie.exec(n))&&i[1]&&(n=ue(e,t,i),o="number"),null!=n&&n===n&&("number"===o&&(n+=i&&i[3]||(w.cssNumber[s]?"":"px")),h.clearCloneStyle||""!==n||0!==t.indexOf("background")||(l[t]="inherit"),a&&"set"in a&&void 0===(n=a.set(e,n,r))||(u?l.setProperty(t,n):l[t]=n))}},css:function(e,t,n,r){var i,o,a,s=G(t);return Xe.test(t)||(t=Je(s)),(a=w.cssHooks[t]||w.cssHooks[s])&&"get"in a&&(i=a.get(e,!0,n)),void 0===i&&(i=Fe(e,t,r)),"normal"===i&&t in Ve&&(i=Ve[t]),""===n||n?(o=parseFloat(i),!0===n||isFinite(o)?o||0:i):i}}),w.each(["height","width"],function(e,t){w.cssHooks[t]={get:function(e,n,r){if(n)return!ze.test(w.css(e,"display"))||e.getClientRects().length&&e.getBoundingClientRect().width?et(e,t,r):se(e,Ue,function(){return et(e,t,r)})},set:function(e,n,r){var i,o=$e(e),a="border-box"===w.css(e,"boxSizing",!1,o),s=r&&Ze(e,t,r,a,o);return a&&h.scrollboxSize()===o.position&&(s-=Math.ceil(e["offset"+t[0].toUpperCase()+t.slice(1)]-parseFloat(o[t])-Ze(e,t,"border",!1,o)-.5)),s&&(i=ie.exec(n))&&"px"!==(i[3]||"px")&&(e.style[t]=n,n=w.css(e,t)),Ke(e,n,s)}}}),w.cssHooks.marginLeft=_e(h.reliableMarginLeft,function(e,t){if(t)return(parseFloat(Fe(e,"marginLeft"))||e.getBoundingClientRect().left-se(e,{marginLeft:0},function(){return e.getBoundingClientRect().left}))+"px"}),w.each({margin:"",padding:"",border:"Width"},function(e,t){w.cssHooks[e+t]={expand:function(n){for(var r=0,i={},o="string"==typeof n?n.split(" "):[n];r<4;r++)i[e+oe[r]+t]=o[r]||o[r-2]||o[0];return i}},"margin"!==e&&(w.cssHooks[e+t].set=Ke)}),w.fn.extend({css:function(e,t){return z(this,function(e,t,n){var r,i,o={},a=0;if(Array.isArray(t)){for(r=$e(e),i=t.length;a<i;a++)o[t[a]]=w.css(e,t[a],!1,r);return o}return void 0!==n?w.style(e,t,n):w.css(e,t)},e,t,arguments.length>1)}});function tt(e,t,n,r,i){return new tt.prototype.init(e,t,n,r,i)}w.Tween=tt,tt.prototype={constructor:tt,init:function(e,t,n,r,i,o){this.elem=e,this.prop=n,this.easing=i||w.easing._default,this.options=t,this.start=this.now=this.cur(),this.end=r,this.unit=o||(w.cssNumber[n]?"":"px")},cur:function(){var e=tt.propHooks[this.prop];return e&&e.get?e.get(this):tt.propHooks._default.get(this)},run:function(e){var t,n=tt.propHooks[this.prop];return this.options.duration?this.pos=t=w.easing[this.easing](e,this.options.duration*e,0,1,this.options.duration):this.pos=t=e,this.now=(this.end-this.start)*t+this.start,this.options.step&&this.options.step.call(this.elem,this.now,this),n&&n.set?n.set(this):tt.propHooks._default.set(this),this}},tt.prototype.init.prototype=tt.prototype,tt.propHooks={_default:{get:function(e){var t;return 1!==e.elem.nodeType||null!=e.elem[e.prop]&&null==e.elem.style[e.prop]?e.elem[e.prop]:(t=w.css(e.elem,e.prop,""))&&"auto"!==t?t:0},set:function(e){w.fx.step[e.prop]?w.fx.step[e.prop](e):1!==e.elem.nodeType||null==e.elem.style[w.cssProps[e.prop]]&&!w.cssHooks[e.prop]?e.elem[e.prop]=e.now:w.style(e.elem,e.prop,e.now+e.unit)}}},tt.propHooks.scrollTop=tt.propHooks.scrollLeft={set:function(e){e.elem.nodeType&&e.elem.parentNode&&(e.elem[e.prop]=e.now)}},w.easing={linear:function(e){return e},swing:function(e){return.5-Math.cos(e*Math.PI)/2},_default:"swing"},w.fx=tt.prototype.init,w.fx.step={};var nt,rt,it=/^(?:toggle|show|hide)$/,ot=/queueHooks$/;function at(){rt&&(!1===r.hidden&&e.requestAnimationFrame?e.requestAnimationFrame(at):e.setTimeout(at,w.fx.interval),w.fx.tick())}function st(){return e.setTimeout(function(){nt=void 0}),nt=Date.now()}function ut(e,t){var n,r=0,i={height:e};for(t=t?1:0;r<4;r+=2-t)i["margin"+(n=oe[r])]=i["padding"+n]=e;return t&&(i.opacity=i.width=e),i}function lt(e,t,n){for(var r,i=(pt.tweeners[t]||[]).concat(pt.tweeners["*"]),o=0,a=i.length;o<a;o++)if(r=i[o].call(n,t,e))return r}function ct(e,t,n){var r,i,o,a,s,u,l,c,f="width"in t||"height"in t,p=this,d={},h=e.style,g=e.nodeType&&ae(e),y=J.get(e,"fxshow");n.queue||(null==(a=w._queueHooks(e,"fx")).unqueued&&(a.unqueued=0,s=a.empty.fire,a.empty.fire=function(){a.unqueued||s()}),a.unqueued++,p.always(function(){p.always(function(){a.unqueued--,w.queue(e,"fx").length||a.empty.fire()})}));for(r in t)if(i=t[r],it.test(i)){if(delete t[r],o=o||"toggle"===i,i===(g?"hide":"show")){if("show"!==i||!y||void 0===y[r])continue;g=!0}d[r]=y&&y[r]||w.style(e,r)}if((u=!w.isEmptyObject(t))||!w.isEmptyObject(d)){f&&1===e.nodeType&&(n.overflow=[h.overflow,h.overflowX,h.overflowY],null==(l=y&&y.display)&&(l=J.get(e,"display")),"none"===(c=w.css(e,"display"))&&(l?c=l:(fe([e],!0),l=e.style.display||l,c=w.css(e,"display"),fe([e]))),("inline"===c||"inline-block"===c&&null!=l)&&"none"===w.css(e,"float")&&(u||(p.done(function(){h.display=l}),null==l&&(c=h.display,l="none"===c?"":c)),h.display="inline-block")),n.overflow&&(h.overflow="hidden",p.always(function(){h.overflow=n.overflow[0],h.overflowX=n.overflow[1],h.overflowY=n.overflow[2]})),u=!1;for(r in d)u||(y?"hidden"in y&&(g=y.hidden):y=J.access(e,"fxshow",{display:l}),o&&(y.hidden=!g),g&&fe([e],!0),p.done(function(){g||fe([e]),J.remove(e,"fxshow");for(r in d)w.style(e,r,d[r])})),u=lt(g?y[r]:0,r,p),r in y||(y[r]=u.start,g&&(u.end=u.start,u.start=0))}}function ft(e,t){var n,r,i,o,a;for(n in e)if(r=G(n),i=t[r],o=e[n],Array.isArray(o)&&(i=o[1],o=e[n]=o[0]),n!==r&&(e[r]=o,delete e[n]),(a=w.cssHooks[r])&&"expand"in a){o=a.expand(o),delete e[r];for(n in o)n in e||(e[n]=o[n],t[n]=i)}else t[r]=i}function pt(e,t,n){var r,i,o=0,a=pt.prefilters.length,s=w.Deferred().always(function(){delete u.elem}),u=function(){if(i)return!1;for(var t=nt||st(),n=Math.max(0,l.startTime+l.duration-t),r=1-(n/l.duration||0),o=0,a=l.tweens.length;o<a;o++)l.tweens[o].run(r);return s.notifyWith(e,[l,r,n]),r<1&&a?n:(a||s.notifyWith(e,[l,1,0]),s.resolveWith(e,[l]),!1)},l=s.promise({elem:e,props:w.extend({},t),opts:w.extend(!0,{specialEasing:{},easing:w.easing._default},n),originalProperties:t,originalOptions:n,startTime:nt||st(),duration:n.duration,tweens:[],createTween:function(t,n){var r=w.Tween(e,l.opts,t,n,l.opts.specialEasing[t]||l.opts.easing);return l.tweens.push(r),r},stop:function(t){var n=0,r=t?l.tweens.length:0;if(i)return this;for(i=!0;n<r;n++)l.tweens[n].run(1);return t?(s.notifyWith(e,[l,1,0]),s.resolveWith(e,[l,t])):s.rejectWith(e,[l,t]),this}}),c=l.props;for(ft(c,l.opts.specialEasing);o<a;o++)if(r=pt.prefilters[o].call(l,e,c,l.opts))return g(r.stop)&&(w._queueHooks(l.elem,l.opts.queue).stop=r.stop.bind(r)),r;return w.map(c,lt,l),g(l.opts.start)&&l.opts.start.call(e,l),l.progress(l.opts.progress).done(l.opts.done,l.opts.complete).fail(l.opts.fail).always(l.opts.always),w.fx.timer(w.extend(u,{elem:e,anim:l,queue:l.opts.queue})),l}w.Animation=w.extend(pt,{tweeners:{"*":[function(e,t){var n=this.createTween(e,t);return ue(n.elem,e,ie.exec(t),n),n}]},tweener:function(e,t){g(e)?(t=e,e=["*"]):e=e.match(M);for(var n,r=0,i=e.length;r<i;r++)n=e[r],pt.tweeners[n]=pt.tweeners[n]||[],pt.tweeners[n].unshift(t)},prefilters:[ct],prefilter:function(e,t){t?pt.prefilters.unshift(e):pt.prefilters.push(e)}}),w.speed=function(e,t,n){var r=e&&"object"==typeof e?w.extend({},e):{complete:n||!n&&t||g(e)&&e,duration:e,easing:n&&t||t&&!g(t)&&t};return w.fx.off?r.duration=0:"number"!=typeof r.duration&&(r.duration in w.fx.speeds?r.duration=w.fx.speeds[r.duration]:r.duration=w.fx.speeds._default),null!=r.queue&&!0!==r.queue||(r.queue="fx"),r.old=r.complete,r.complete=function(){g(r.old)&&r.old.call(this),r.queue&&w.dequeue(this,r.queue)},r},w.fn.extend({fadeTo:function(e,t,n,r){return this.filter(ae).css("opacity",0).show().end().animate({opacity:t},e,n,r)},animate:function(e,t,n,r){var i=w.isEmptyObject(e),o=w.speed(t,n,r),a=function(){var t=pt(this,w.extend({},e),o);(i||J.get(this,"finish"))&&t.stop(!0)};return a.finish=a,i||!1===o.queue?this.each(a):this.queue(o.queue,a)},stop:function(e,t,n){var r=function(e){var t=e.stop;delete e.stop,t(n)};return"string"!=typeof e&&(n=t,t=e,e=void 0),t&&!1!==e&&this.queue(e||"fx",[]),this.each(function(){var t=!0,i=null!=e&&e+"queueHooks",o=w.timers,a=J.get(this);if(i)a[i]&&a[i].stop&&r(a[i]);else for(i in a)a[i]&&a[i].stop&&ot.test(i)&&r(a[i]);for(i=o.length;i--;)o[i].elem!==this||null!=e&&o[i].queue!==e||(o[i].anim.stop(n),t=!1,o.splice(i,1));!t&&n||w.dequeue(this,e)})},finish:function(e){return!1!==e&&(e=e||"fx"),this.each(function(){var t,n=J.get(this),r=n[e+"queue"],i=n[e+"queueHooks"],o=w.timers,a=r?r.length:0;for(n.finish=!0,w.queue(this,e,[]),i&&i.stop&&i.stop.call(this,!0),t=o.length;t--;)o[t].elem===this&&o[t].queue===e&&(o[t].anim.stop(!0),o.splice(t,1));for(t=0;t<a;t++)r[t]&&r[t].finish&&r[t].finish.call(this);delete n.finish})}}),w.each(["toggle","show","hide"],function(e,t){var n=w.fn[t];w.fn[t]=function(e,r,i){return null==e||"boolean"==typeof e?n.apply(this,arguments):this.animate(ut(t,!0),e,r,i)}}),w.each({slideDown:ut("show"),slideUp:ut("hide"),slideToggle:ut("toggle"),fadeIn:{opacity:"show"},fadeOut:{opacity:"hide"},fadeToggle:{opacity:"toggle"}},function(e,t){w.fn[e]=function(e,n,r){return this.animate(t,e,n,r)}}),w.timers=[],w.fx.tick=function(){var e,t=0,n=w.timers;for(nt=Date.now();t<n.length;t++)(e=n[t])()||n[t]!==e||n.splice(t--,1);n.length||w.fx.stop(),nt=void 0},w.fx.timer=function(e){w.timers.push(e),w.fx.start()},w.fx.interval=13,w.fx.start=function(){rt||(rt=!0,at())},w.fx.stop=function(){rt=null},w.fx.speeds={slow:600,fast:200,_default:400},w.fn.delay=function(t,n){return t=w.fx?w.fx.speeds[t]||t:t,n=n||"fx",this.queue(n,function(n,r){var i=e.setTimeout(n,t);r.stop=function(){e.clearTimeout(i)}})},function(){var e=r.createElement("input"),t=r.createElement("select").appendChild(r.createElement("option"));e.type="checkbox",h.checkOn=""!==e.value,h.optSelected=t.selected,(e=r.createElement("input")).value="t",e.type="radio",h.radioValue="t"===e.value}();var dt,ht=w.expr.attrHandle;w.fn.extend({attr:function(e,t){return z(this,w.attr,e,t,arguments.length>1)},removeAttr:function(e){return this.each(function(){w.removeAttr(this,e)})}}),w.extend({attr:function(e,t,n){var r,i,o=e.nodeType;if(3!==o&&8!==o&&2!==o)return"undefined"==typeof e.getAttribute?w.prop(e,t,n):(1===o&&w.isXMLDoc(e)||(i=w.attrHooks[t.toLowerCase()]||(w.expr.match.bool.test(t)?dt:void 0)),void 0!==n?null===n?void w.removeAttr(e,t):i&&"set"in i&&void 0!==(r=i.set(e,n,t))?r:(e.setAttribute(t,n+""),n):i&&"get"in i&&null!==(r=i.get(e,t))?r:null==(r=w.find.attr(e,t))?void 0:r)},attrHooks:{type:{set:function(e,t){if(!h.radioValue&&"radio"===t&&N(e,"input")){var n=e.value;return e.setAttribute("type",t),n&&(e.value=n),t}}}},removeAttr:function(e,t){var n,r=0,i=t&&t.match(M);if(i&&1===e.nodeType)while(n=i[r++])e.removeAttribute(n)}}),dt={set:function(e,t,n){return!1===t?w.removeAttr(e,n):e.setAttribute(n,n),n}},w.each(w.expr.match.bool.source.match(/\w+/g),function(e,t){var n=ht[t]||w.find.attr;ht[t]=function(e,t,r){var i,o,a=t.toLowerCase();return r||(o=ht[a],ht[a]=i,i=null!=n(e,t,r)?a:null,ht[a]=o),i}});var gt=/^(?:input|select|textarea|button)$/i,yt=/^(?:a|area)$/i;w.fn.extend({prop:function(e,t){return z(this,w.prop,e,t,arguments.length>1)},removeProp:function(e){return this.each(function(){delete this[w.propFix[e]||e]})}}),w.extend({prop:function(e,t,n){var r,i,o=e.nodeType;if(3!==o&&8!==o&&2!==o)return 1===o&&w.isXMLDoc(e)||(t=w.propFix[t]||t,i=w.propHooks[t]),void 0!==n?i&&"set"in i&&void 0!==(r=i.set(e,n,t))?r:e[t]=n:i&&"get"in i&&null!==(r=i.get(e,t))?r:e[t]},propHooks:{tabIndex:{get:function(e){var t=w.find.attr(e,"tabindex");return t?parseInt(t,10):gt.test(e.nodeName)||yt.test(e.nodeName)&&e.href?0:-1}}},propFix:{"for":"htmlFor","class":"className"}}),h.optSelected||(w.propHooks.selected={get:function(e){var t=e.parentNode;return t&&t.parentNode&&t.parentNode.selectedIndex,null},set:function(e){var t=e.parentNode;t&&(t.selectedIndex,t.parentNode&&t.parentNode.selectedIndex)}}),w.each(["tabIndex","readOnly","maxLength","cellSpacing","cellPadding","rowSpan","colSpan","useMap","frameBorder","contentEditable"],function(){w.propFix[this.toLowerCase()]=this});function vt(e){return(e.match(M)||[]).join(" ")}function mt(e){return e.getAttribute&&e.getAttribute("class")||""}function xt(e){return Array.isArray(e)?e:"string"==typeof e?e.match(M)||[]:[]}w.fn.extend({addClass:function(e){var t,n,r,i,o,a,s,u=0;if(g(e))return this.each(function(t){w(this).addClass(e.call(this,t,mt(this)))});if((t=xt(e)).length)while(n=this[u++])if(i=mt(n),r=1===n.nodeType&&" "+vt(i)+" "){a=0;while(o=t[a++])r.indexOf(" "+o+" ")<0&&(r+=o+" ");i!==(s=vt(r))&&n.setAttribute("class",s)}return this},removeClass:function(e){var t,n,r,i,o,a,s,u=0;if(g(e))return this.each(function(t){w(this).removeClass(e.call(this,t,mt(this)))});if(!arguments.length)return this.attr("class","");if((t=xt(e)).length)while(n=this[u++])if(i=mt(n),r=1===n.nodeType&&" "+vt(i)+" "){a=0;while(o=t[a++])while(r.indexOf(" "+o+" ")>-1)r=r.replace(" "+o+" "," ");i!==(s=vt(r))&&n.setAttribute("class",s)}return this},toggleClass:function(e,t){var n=typeof e,r="string"===n||Array.isArray(e);return"boolean"==typeof t&&r?t?this.addClass(e):this.removeClass(e):g(e)?this.each(function(n){w(this).toggleClass(e.call(this,n,mt(this),t),t)}):this.each(function(){var t,i,o,a;if(r){i=0,o=w(this),a=xt(e);while(t=a[i++])o.hasClass(t)?o.removeClass(t):o.addClass(t)}else void 0!==e&&"boolean"!==n||((t=mt(this))&&J.set(this,"__className__",t),this.setAttribute&&this.setAttribute("class",t||!1===e?"":J.get(this,"__className__")||""))})},hasClass:function(e){var t,n,r=0;t=" "+e+" ";while(n=this[r++])if(1===n.nodeType&&(" "+vt(mt(n))+" ").indexOf(t)>-1)return!0;return!1}});var bt=/\r/g;w.fn.extend({val:function(e){var t,n,r,i=this[0];{if(arguments.length)return r=g(e),this.each(function(n){var i;1===this.nodeType&&(null==(i=r?e.call(this,n,w(this).val()):e)?i="":"number"==typeof i?i+="":Array.isArray(i)&&(i=w.map(i,function(e){return null==e?"":e+""})),(t=w.valHooks[this.type]||w.valHooks[this.nodeName.toLowerCase()])&&"set"in t&&void 0!==t.set(this,i,"value")||(this.value=i))});if(i)return(t=w.valHooks[i.type]||w.valHooks[i.nodeName.toLowerCase()])&&"get"in t&&void 0!==(n=t.get(i,"value"))?n:"string"==typeof(n=i.value)?n.replace(bt,""):null==n?"":n}}}),w.extend({valHooks:{option:{get:function(e){var t=w.find.attr(e,"value");return null!=t?t:vt(w.text(e))}},select:{get:function(e){var t,n,r,i=e.options,o=e.selectedIndex,a="select-one"===e.type,s=a?null:[],u=a?o+1:i.length;for(r=o<0?u:a?o:0;r<u;r++)if(((n=i[r]).selected||r===o)&&!n.disabled&&(!n.parentNode.disabled||!N(n.parentNode,"optgroup"))){if(t=w(n).val(),a)return t;s.push(t)}return s},set:function(e,t){var n,r,i=e.options,o=w.makeArray(t),a=i.length;while(a--)((r=i[a]).selected=w.inArray(w.valHooks.option.get(r),o)>-1)&&(n=!0);return n||(e.selectedIndex=-1),o}}}}),w.each(["radio","checkbox"],function(){w.valHooks[this]={set:function(e,t){if(Array.isArray(t))return e.checked=w.inArray(w(e).val(),t)>-1}},h.checkOn||(w.valHooks[this].get=function(e){return null===e.getAttribute("value")?"on":e.value})}),h.focusin="onfocusin"in e;var wt=/^(?:focusinfocus|focusoutblur)$/,Tt=function(e){e.stopPropagation()};w.extend(w.event,{trigger:function(t,n,i,o){var a,s,u,l,c,p,d,h,v=[i||r],m=f.call(t,"type")?t.type:t,x=f.call(t,"namespace")?t.namespace.split("."):[];if(s=h=u=i=i||r,3!==i.nodeType&&8!==i.nodeType&&!wt.test(m+w.event.triggered)&&(m.indexOf(".")>-1&&(m=(x=m.split(".")).shift(),x.sort()),c=m.indexOf(":")<0&&"on"+m,t=t[w.expando]?t:new w.Event(m,"object"==typeof t&&t),t.isTrigger=o?2:3,t.namespace=x.join("."),t.rnamespace=t.namespace?new RegExp("(^|\\.)"+x.join("\\.(?:.*\\.|)")+"(\\.|$)"):null,t.result=void 0,t.target||(t.target=i),n=null==n?[t]:w.makeArray(n,[t]),d=w.event.special[m]||{},o||!d.trigger||!1!==d.trigger.apply(i,n))){if(!o&&!d.noBubble&&!y(i)){for(l=d.delegateType||m,wt.test(l+m)||(s=s.parentNode);s;s=s.parentNode)v.push(s),u=s;u===(i.ownerDocument||r)&&v.push(u.defaultView||u.parentWindow||e)}a=0;while((s=v[a++])&&!t.isPropagationStopped())h=s,t.type=a>1?l:d.bindType||m,(p=(J.get(s,"events")||{})[t.type]&&J.get(s,"handle"))&&p.apply(s,n),(p=c&&s[c])&&p.apply&&Y(s)&&(t.result=p.apply(s,n),!1===t.result&&t.preventDefault());return t.type=m,o||t.isDefaultPrevented()||d._default&&!1!==d._default.apply(v.pop(),n)||!Y(i)||c&&g(i[m])&&!y(i)&&((u=i[c])&&(i[c]=null),w.event.triggered=m,t.isPropagationStopped()&&h.addEventListener(m,Tt),i[m](),t.isPropagationStopped()&&h.removeEventListener(m,Tt),w.event.triggered=void 0,u&&(i[c]=u)),t.result}},simulate:function(e,t,n){var r=w.extend(new w.Event,n,{type:e,isSimulated:!0});w.event.trigger(r,null,t)}}),w.fn.extend({trigger:function(e,t){return this.each(function(){w.event.trigger(e,t,this)})},triggerHandler:function(e,t){var n=this[0];if(n)return w.event.trigger(e,t,n,!0)}}),h.focusin||w.each({focus:"focusin",blur:"focusout"},function(e,t){var n=function(e){w.event.simulate(t,e.target,w.event.fix(e))};w.event.special[t]={setup:function(){var r=this.ownerDocument||this,i=J.access(r,t);i||r.addEventListener(e,n,!0),J.access(r,t,(i||0)+1)},teardown:function(){var r=this.ownerDocument||this,i=J.access(r,t)-1;i?J.access(r,t,i):(r.removeEventListener(e,n,!0),J.remove(r,t))}}});var Ct=e.location,Et=Date.now(),kt=/\?/;w.parseXML=function(t){var n;if(!t||"string"!=typeof t)return null;try{n=(new e.DOMParser).parseFromString(t,"text/xml")}catch(e){n=void 0}return n&&!n.getElementsByTagName("parsererror").length||w.error("Invalid XML: "+t),n};var St=/\[\]$/,Dt=/\r?\n/g,Nt=/^(?:submit|button|image|reset|file)$/i,At=/^(?:input|select|textarea|keygen)/i;function jt(e,t,n,r){var i;if(Array.isArray(t))w.each(t,function(t,i){n||St.test(e)?r(e,i):jt(e+"["+("object"==typeof i&&null!=i?t:"")+"]",i,n,r)});else if(n||"object"!==x(t))r(e,t);else for(i in t)jt(e+"["+i+"]",t[i],n,r)}w.param=function(e,t){var n,r=[],i=function(e,t){var n=g(t)?t():t;r[r.length]=encodeURIComponent(e)+"="+encodeURIComponent(null==n?"":n)};if(Array.isArray(e)||e.jquery&&!w.isPlainObject(e))w.each(e,function(){i(this.name,this.value)});else for(n in e)jt(n,e[n],t,i);return r.join("&")},w.fn.extend({serialize:function(){return w.param(this.serializeArray())},serializeArray:function(){return this.map(function(){var e=w.prop(this,"elements");return e?w.makeArray(e):this}).filter(function(){var e=this.type;return this.name&&!w(this).is(":disabled")&&At.test(this.nodeName)&&!Nt.test(e)&&(this.checked||!pe.test(e))}).map(function(e,t){var n=w(this).val();return null==n?null:Array.isArray(n)?w.map(n,function(e){return{name:t.name,value:e.replace(Dt,"\r\n")}}):{name:t.name,value:n.replace(Dt,"\r\n")}}).get()}});var qt=/%20/g,Lt=/#.*$/,Ht=/([?&])_=[^&]*/,Ot=/^(.*?):[ \t]*([^\r\n]*)$/gm,Pt=/^(?:about|app|app-storage|.+-extension|file|res|widget):$/,Mt=/^(?:GET|HEAD)$/,Rt=/^\/\//,It={},Wt={},$t="*/".concat("*"),Bt=r.createElement("a");Bt.href=Ct.href;function Ft(e){return function(t,n){"string"!=typeof t&&(n=t,t="*");var r,i=0,o=t.toLowerCase().match(M)||[];if(g(n))while(r=o[i++])"+"===r[0]?(r=r.slice(1)||"*",(e[r]=e[r]||[]).unshift(n)):(e[r]=e[r]||[]).push(n)}}function _t(e,t,n,r){var i={},o=e===Wt;function a(s){var u;return i[s]=!0,w.each(e[s]||[],function(e,s){var l=s(t,n,r);return"string"!=typeof l||o||i[l]?o?!(u=l):void 0:(t.dataTypes.unshift(l),a(l),!1)}),u}return a(t.dataTypes[0])||!i["*"]&&a("*")}function zt(e,t){var n,r,i=w.ajaxSettings.flatOptions||{};for(n in t)void 0!==t[n]&&((i[n]?e:r||(r={}))[n]=t[n]);return r&&w.extend(!0,e,r),e}function Xt(e,t,n){var r,i,o,a,s=e.contents,u=e.dataTypes;while("*"===u[0])u.shift(),void 0===r&&(r=e.mimeType||t.getResponseHeader("Content-Type"));if(r)for(i in s)if(s[i]&&s[i].test(r)){u.unshift(i);break}if(u[0]in n)o=u[0];else{for(i in n){if(!u[0]||e.converters[i+" "+u[0]]){o=i;break}a||(a=i)}o=o||a}if(o)return o!==u[0]&&u.unshift(o),n[o]}function Ut(e,t,n,r){var i,o,a,s,u,l={},c=e.dataTypes.slice();if(c[1])for(a in e.converters)l[a.toLowerCase()]=e.converters[a];o=c.shift();while(o)if(e.responseFields[o]&&(n[e.responseFields[o]]=t),!u&&r&&e.dataFilter&&(t=e.dataFilter(t,e.dataType)),u=o,o=c.shift())if("*"===o)o=u;else if("*"!==u&&u!==o){if(!(a=l[u+" "+o]||l["* "+o]))for(i in l)if((s=i.split(" "))[1]===o&&(a=l[u+" "+s[0]]||l["* "+s[0]])){!0===a?a=l[i]:!0!==l[i]&&(o=s[0],c.unshift(s[1]));break}if(!0!==a)if(a&&e["throws"])t=a(t);else try{t=a(t)}catch(e){return{state:"parsererror",error:a?e:"No conversion from "+u+" to "+o}}}return{state:"success",data:t}}w.extend({active:0,lastModified:{},etag:{},ajaxSettings:{url:Ct.href,type:"GET",isLocal:Pt.test(Ct.protocol),global:!0,processData:!0,async:!0,contentType:"application/x-www-form-urlencoded; charset=UTF-8",accepts:{"*":$t,text:"text/plain",html:"text/html",xml:"application/xml, text/xml",json:"application/json, text/javascript"},contents:{xml:/\bxml\b/,html:/\bhtml/,json:/\bjson\b/},responseFields:{xml:"responseXML",text:"responseText",json:"responseJSON"},converters:{"* text":String,"text html":!0,"text json":JSON.parse,"text xml":w.parseXML},flatOptions:{url:!0,context:!0}},ajaxSetup:function(e,t){return t?zt(zt(e,w.ajaxSettings),t):zt(w.ajaxSettings,e)},ajaxPrefilter:Ft(It),ajaxTransport:Ft(Wt),ajax:function(t,n){"object"==typeof t&&(n=t,t=void 0),n=n||{};var i,o,a,s,u,l,c,f,p,d,h=w.ajaxSetup({},n),g=h.context||h,y=h.context&&(g.nodeType||g.jquery)?w(g):w.event,v=w.Deferred(),m=w.Callbacks("once memory"),x=h.statusCode||{},b={},T={},C="canceled",E={readyState:0,getResponseHeader:function(e){var t;if(c){if(!s){s={};while(t=Ot.exec(a))s[t[1].toLowerCase()]=t[2]}t=s[e.toLowerCase()]}return null==t?null:t},getAllResponseHeaders:function(){return c?a:null},setRequestHeader:function(e,t){return null==c&&(e=T[e.toLowerCase()]=T[e.toLowerCase()]||e,b[e]=t),this},overrideMimeType:function(e){return null==c&&(h.mimeType=e),this},statusCode:function(e){var t;if(e)if(c)E.always(e[E.status]);else for(t in e)x[t]=[x[t],e[t]];return this},abort:function(e){var t=e||C;return i&&i.abort(t),k(0,t),this}};if(v.promise(E),h.url=((t||h.url||Ct.href)+"").replace(Rt,Ct.protocol+"//"),h.type=n.method||n.type||h.method||h.type,h.dataTypes=(h.dataType||"*").toLowerCase().match(M)||[""],null==h.crossDomain){l=r.createElement("a");try{l.href=h.url,l.href=l.href,h.crossDomain=Bt.protocol+"//"+Bt.host!=l.protocol+"//"+l.host}catch(e){h.crossDomain=!0}}if(h.data&&h.processData&&"string"!=typeof h.data&&(h.data=w.param(h.data,h.traditional)),_t(It,h,n,E),c)return E;(f=w.event&&h.global)&&0==w.active++&&w.event.trigger("ajaxStart"),h.type=h.type.toUpperCase(),h.hasContent=!Mt.test(h.type),o=h.url.replace(Lt,""),h.hasContent?h.data&&h.processData&&0===(h.contentType||"").indexOf("application/x-www-form-urlencoded")&&(h.data=h.data.replace(qt,"+")):(d=h.url.slice(o.length),h.data&&(h.processData||"string"==typeof h.data)&&(o+=(kt.test(o)?"&":"?")+h.data,delete h.data),!1===h.cache&&(o=o.replace(Ht,"$1"),d=(kt.test(o)?"&":"?")+"_="+Et+++d),h.url=o+d),h.ifModified&&(w.lastModified[o]&&E.setRequestHeader("If-Modified-Since",w.lastModified[o]),w.etag[o]&&E.setRequestHeader("If-None-Match",w.etag[o])),(h.data&&h.hasContent&&!1!==h.contentType||n.contentType)&&E.setRequestHeader("Content-Type",h.contentType),E.setRequestHeader("Accept",h.dataTypes[0]&&h.accepts[h.dataTypes[0]]?h.accepts[h.dataTypes[0]]+("*"!==h.dataTypes[0]?", "+$t+"; q=0.01":""):h.accepts["*"]);for(p in h.headers)E.setRequestHeader(p,h.headers[p]);if(h.beforeSend&&(!1===h.beforeSend.call(g,E,h)||c))return E.abort();if(C="abort",m.add(h.complete),E.done(h.success),E.fail(h.error),i=_t(Wt,h,n,E)){if(E.readyState=1,f&&y.trigger("ajaxSend",[E,h]),c)return E;h.async&&h.timeout>0&&(u=e.setTimeout(function(){E.abort("timeout")},h.timeout));try{c=!1,i.send(b,k)}catch(e){if(c)throw e;k(-1,e)}}else k(-1,"No Transport");function k(t,n,r,s){var l,p,d,b,T,C=n;c||(c=!0,u&&e.clearTimeout(u),i=void 0,a=s||"",E.readyState=t>0?4:0,l=t>=200&&t<300||304===t,r&&(b=Xt(h,E,r)),b=Ut(h,b,E,l),l?(h.ifModified&&((T=E.getResponseHeader("Last-Modified"))&&(w.lastModified[o]=T),(T=E.getResponseHeader("etag"))&&(w.etag[o]=T)),204===t||"HEAD"===h.type?C="nocontent":304===t?C="notmodified":(C=b.state,p=b.data,l=!(d=b.error))):(d=C,!t&&C||(C="error",t<0&&(t=0))),E.status=t,E.statusText=(n||C)+"",l?v.resolveWith(g,[p,C,E]):v.rejectWith(g,[E,C,d]),E.statusCode(x),x=void 0,f&&y.trigger(l?"ajaxSuccess":"ajaxError",[E,h,l?p:d]),m.fireWith(g,[E,C]),f&&(y.trigger("ajaxComplete",[E,h]),--w.active||w.event.trigger("ajaxStop")))}return E},getJSON:function(e,t,n){return w.get(e,t,n,"json")},getScript:function(e,t){return w.get(e,void 0,t,"script")}}),w.each(["get","post"],function(e,t){w[t]=function(e,n,r,i){return g(n)&&(i=i||r,r=n,n=void 0),w.ajax(w.extend({url:e,type:t,dataType:i,data:n,success:r},w.isPlainObject(e)&&e))}}),w._evalUrl=function(e){return w.ajax({url:e,type:"GET",dataType:"script",cache:!0,async:!1,global:!1,"throws":!0})},w.fn.extend({wrapAll:function(e){var t;return this[0]&&(g(e)&&(e=e.call(this[0])),t=w(e,this[0].ownerDocument).eq(0).clone(!0),this[0].parentNode&&t.insertBefore(this[0]),t.map(function(){var e=this;while(e.firstElementChild)e=e.firstElementChild;return e}).append(this)),this},wrapInner:function(e){return g(e)?this.each(function(t){w(this).wrapInner(e.call(this,t))}):this.each(function(){var t=w(this),n=t.contents();n.length?n.wrapAll(e):t.append(e)})},wrap:function(e){var t=g(e);return this.each(function(n){w(this).wrapAll(t?e.call(this,n):e)})},unwrap:function(e){return this.parent(e).not("body").each(function(){w(this).replaceWith(this.childNodes)}),this}}),w.expr.pseudos.hidden=function(e){return!w.expr.pseudos.visible(e)},w.expr.pseudos.visible=function(e){return!!(e.offsetWidth||e.offsetHeight||e.getClientRects().length)},w.ajaxSettings.xhr=function(){try{return new e.XMLHttpRequest}catch(e){}};var Vt={0:200,1223:204},Gt=w.ajaxSettings.xhr();h.cors=!!Gt&&"withCredentials"in Gt,h.ajax=Gt=!!Gt,w.ajaxTransport(function(t){var n,r;if(h.cors||Gt&&!t.crossDomain)return{send:function(i,o){var a,s=t.xhr();if(s.open(t.type,t.url,t.async,t.username,t.password),t.xhrFields)for(a in t.xhrFields)s[a]=t.xhrFields[a];t.mimeType&&s.overrideMimeType&&s.overrideMimeType(t.mimeType),t.crossDomain||i["X-Requested-With"]||(i["X-Requested-With"]="XMLHttpRequest");for(a in i)s.setRequestHeader(a,i[a]);n=function(e){return function(){n&&(n=r=s.onload=s.onerror=s.onabort=s.ontimeout=s.onreadystatechange=null,"abort"===e?s.abort():"error"===e?"number"!=typeof s.status?o(0,"error"):o(s.status,s.statusText):o(Vt[s.status]||s.status,s.statusText,"text"!==(s.responseType||"text")||"string"!=typeof s.responseText?{binary:s.response}:{text:s.responseText},s.getAllResponseHeaders()))}},s.onload=n(),r=s.onerror=s.ontimeout=n("error"),void 0!==s.onabort?s.onabort=r:s.onreadystatechange=function(){4===s.readyState&&e.setTimeout(function(){n&&r()})},n=n("abort");try{s.send(t.hasContent&&t.data||null)}catch(e){if(n)throw e}},abort:function(){n&&n()}}}),w.ajaxPrefilter(function(e){e.crossDomain&&(e.contents.script=!1)}),w.ajaxSetup({accepts:{script:"text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"},contents:{script:/\b(?:java|ecma)script\b/},converters:{"text script":function(e){return w.globalEval(e),e}}}),w.ajaxPrefilter("script",function(e){void 0===e.cache&&(e.cache=!1),e.crossDomain&&(e.type="GET")}),w.ajaxTransport("script",function(e){if(e.crossDomain){var t,n;return{send:function(i,o){t=w("<script>").prop({charset:e.scriptCharset,src:e.url}).on("load error",n=function(e){t.remove(),n=null,e&&o("error"===e.type?404:200,e.type)}),r.head.appendChild(t[0])},abort:function(){n&&n()}}}});var Yt=[],Qt=/(=)\?(?=&|$)|\?\?/;w.ajaxSetup({jsonp:"callback",jsonpCallback:function(){var e=Yt.pop()||w.expando+"_"+Et++;return this[e]=!0,e}}),w.ajaxPrefilter("json jsonp",function(t,n,r){var i,o,a,s=!1!==t.jsonp&&(Qt.test(t.url)?"url":"string"==typeof t.data&&0===(t.contentType||"").indexOf("application/x-www-form-urlencoded")&&Qt.test(t.data)&&"data");if(s||"jsonp"===t.dataTypes[0])return i=t.jsonpCallback=g(t.jsonpCallback)?t.jsonpCallback():t.jsonpCallback,s?t[s]=t[s].replace(Qt,"$1"+i):!1!==t.jsonp&&(t.url+=(kt.test(t.url)?"&":"?")+t.jsonp+"="+i),t.converters["script json"]=function(){return a||w.error(i+" was not called"),a[0]},t.dataTypes[0]="json",o=e[i],e[i]=function(){a=arguments},r.always(function(){void 0===o?w(e).removeProp(i):e[i]=o,t[i]&&(t.jsonpCallback=n.jsonpCallback,Yt.push(i)),a&&g(o)&&o(a[0]),a=o=void 0}),"script"}),h.createHTMLDocument=function(){var e=r.implementation.createHTMLDocument("").body;return e.innerHTML="<form></form><form></form>",2===e.childNodes.length}(),w.parseHTML=function(e,t,n){if("string"!=typeof e)return[];"boolean"==typeof t&&(n=t,t=!1);var i,o,a;return t||(h.createHTMLDocument?((i=(t=r.implementation.createHTMLDocument("")).createElement("base")).href=r.location.href,t.head.appendChild(i)):t=r),o=A.exec(e),a=!n&&[],o?[t.createElement(o[1])]:(o=xe([e],t,a),a&&a.length&&w(a).remove(),w.merge([],o.childNodes))},w.fn.load=function(e,t,n){var r,i,o,a=this,s=e.indexOf(" ");return s>-1&&(r=vt(e.slice(s)),e=e.slice(0,s)),g(t)?(n=t,t=void 0):t&&"object"==typeof t&&(i="POST"),a.length>0&&w.ajax({url:e,type:i||"GET",dataType:"html",data:t}).done(function(e){o=arguments,a.html(r?w("<div>").append(w.parseHTML(e)).find(r):e)}).always(n&&function(e,t){a.each(function(){n.apply(this,o||[e.responseText,t,e])})}),this},w.each(["ajaxStart","ajaxStop","ajaxComplete","ajaxError","ajaxSuccess","ajaxSend"],function(e,t){w.fn[t]=function(e){return this.on(t,e)}}),w.expr.pseudos.animated=function(e){return w.grep(w.timers,function(t){return e===t.elem}).length},w.offset={setOffset:function(e,t,n){var r,i,o,a,s,u,l,c=w.css(e,"position"),f=w(e),p={};"static"===c&&(e.style.position="relative"),s=f.offset(),o=w.css(e,"top"),u=w.css(e,"left"),(l=("absolute"===c||"fixed"===c)&&(o+u).indexOf("auto")>-1)?(a=(r=f.position()).top,i=r.left):(a=parseFloat(o)||0,i=parseFloat(u)||0),g(t)&&(t=t.call(e,n,w.extend({},s))),null!=t.top&&(p.top=t.top-s.top+a),null!=t.left&&(p.left=t.left-s.left+i),"using"in t?t.using.call(e,p):f.css(p)}},w.fn.extend({offset:function(e){if(arguments.length)return void 0===e?this:this.each(function(t){w.offset.setOffset(this,e,t)});var t,n,r=this[0];if(r)return r.getClientRects().length?(t=r.getBoundingClientRect(),n=r.ownerDocument.defaultView,{top:t.top+n.pageYOffset,left:t.left+n.pageXOffset}):{top:0,left:0}},position:function(){if(this[0]){var e,t,n,r=this[0],i={top:0,left:0};if("fixed"===w.css(r,"position"))t=r.getBoundingClientRect();else{t=this.offset(),n=r.ownerDocument,e=r.offsetParent||n.documentElement;while(e&&(e===n.body||e===n.documentElement)&&"static"===w.css(e,"position"))e=e.parentNode;e&&e!==r&&1===e.nodeType&&((i=w(e).offset()).top+=w.css(e,"borderTopWidth",!0),i.left+=w.css(e,"borderLeftWidth",!0))}return{top:t.top-i.top-w.css(r,"marginTop",!0),left:t.left-i.left-w.css(r,"marginLeft",!0)}}},offsetParent:function(){return this.map(function(){var e=this.offsetParent;while(e&&"static"===w.css(e,"position"))e=e.offsetParent;return e||be})}}),w.each({scrollLeft:"pageXOffset",scrollTop:"pageYOffset"},function(e,t){var n="pageYOffset"===t;w.fn[e]=function(r){return z(this,function(e,r,i){var o;if(y(e)?o=e:9===e.nodeType&&(o=e.defaultView),void 0===i)return o?o[t]:e[r];o?o.scrollTo(n?o.pageXOffset:i,n?i:o.pageYOffset):e[r]=i},e,r,arguments.length)}}),w.each(["top","left"],function(e,t){w.cssHooks[t]=_e(h.pixelPosition,function(e,n){if(n)return n=Fe(e,t),We.test(n)?w(e).position()[t]+"px":n})}),w.each({Height:"height",Width:"width"},function(e,t){w.each({padding:"inner"+e,content:t,"":"outer"+e},function(n,r){w.fn[r]=function(i,o){var a=arguments.length&&(n||"boolean"!=typeof i),s=n||(!0===i||!0===o?"margin":"border");return z(this,function(t,n,i){var o;return y(t)?0===r.indexOf("outer")?t["inner"+e]:t.document.documentElement["client"+e]:9===t.nodeType?(o=t.documentElement,Math.max(t.body["scroll"+e],o["scroll"+e],t.body["offset"+e],o["offset"+e],o["client"+e])):void 0===i?w.css(t,n,s):w.style(t,n,i,s)},t,a?i:void 0,a)}})}),w.each("blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(" "),function(e,t){w.fn[t]=function(e,n){return arguments.length>0?this.on(t,null,e,n):this.trigger(t)}}),w.fn.extend({hover:function(e,t){return this.mouseenter(e).mouseleave(t||e)}}),w.fn.extend({bind:function(e,t,n){return this.on(e,null,t,n)},unbind:function(e,t){return this.off(e,null,t)},delegate:function(e,t,n,r){return this.on(t,e,n,r)},undelegate:function(e,t,n){return 1===arguments.length?this.off(e,"**"):this.off(t,e||"**",n)}}),w.proxy=function(e,t){var n,r,i;if("string"==typeof t&&(n=e[t],t=e,e=n),g(e))return r=o.call(arguments,2),i=function(){return e.apply(t||this,r.concat(o.call(arguments)))},i.guid=e.guid=e.guid||w.guid++,i},w.holdReady=function(e){e?w.readyWait++:w.ready(!0)},w.isArray=Array.isArray,w.parseJSON=JSON.parse,w.nodeName=N,w.isFunction=g,w.isWindow=y,w.camelCase=G,w.type=x,w.now=Date.now,w.isNumeric=function(e){var t=w.type(e);return("number"===t||"string"===t)&&!isNaN(e-parseFloat(e))},"function"==typeof define&&define.amd&&define("jquery",[],function(){return w});var Jt=e.jQuery,Kt=e.$;return w.noConflict=function(t){return e.$===w&&(e.$=Kt),t&&e.jQuery===w&&(e.jQuery=Jt),w},t||(e.jQuery=e.$=w),w});
/*!
 * Bootstrap v3.3.7 (http://getbootstrap.com)
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under the MIT license
 */
if("undefined"==typeof jQuery)throw new Error("Bootstrap's JavaScript requires jQuery");+function(a){"use strict";var b=a.fn.jquery.split(" ")[0].split(".");if(b[0]<2&&b[1]<9||1==b[0]&&9==b[1]&&b[2]<1||b[0]>3)throw new Error("Bootstrap's JavaScript requires jQuery version 1.9.1 or higher, but lower than version 4")}(jQuery),+function(a){"use strict";function b(){var a=document.createElement("bootstrap"),b={WebkitTransition:"webkitTransitionEnd",MozTransition:"transitionend",OTransition:"oTransitionEnd otransitionend",transition:"transitionend"};for(var c in b)if(void 0!==a.style[c])return{end:b[c]};return!1}a.fn.emulateTransitionEnd=function(b){var c=!1,d=this;a(this).one("bsTransitionEnd",function(){c=!0});var e=function(){c||a(d).trigger(a.support.transition.end)};return setTimeout(e,b),this},a(function(){a.support.transition=b(),a.support.transition&&(a.event.special.bsTransitionEnd={bindType:a.support.transition.end,delegateType:a.support.transition.end,handle:function(b){if(a(b.target).is(this))return b.handleObj.handler.apply(this,arguments)}})})}(jQuery),+function(a){"use strict";function b(b){return this.each(function(){var c=a(this),e=c.data("bs.alert");e||c.data("bs.alert",e=new d(this)),"string"==typeof b&&e[b].call(c)})}var c='[data-dismiss="alert"]',d=function(b){a(b).on("click",c,this.close)};d.VERSION="3.3.7",d.TRANSITION_DURATION=150,d.prototype.close=function(b){function c(){g.detach().trigger("closed.bs.alert").remove()}var e=a(this),f=e.attr("data-target");f||(f=e.attr("href"),f=f&&f.replace(/.*(?=#[^\s]*$)/,""));var g=a("#"===f?[]:f);b&&b.preventDefault(),g.length||(g=e.closest(".alert")),g.trigger(b=a.Event("close.bs.alert")),b.isDefaultPrevented()||(g.removeClass("in"),a.support.transition&&g.hasClass("fade")?g.one("bsTransitionEnd",c).emulateTransitionEnd(d.TRANSITION_DURATION):c())};var e=a.fn.alert;a.fn.alert=b,a.fn.alert.Constructor=d,a.fn.alert.noConflict=function(){return a.fn.alert=e,this},a(document).on("click.bs.alert.data-api",c,d.prototype.close)}(jQuery),+function(a){"use strict";function b(b){return this.each(function(){var d=a(this),e=d.data("bs.button"),f="object"==typeof b&&b;e||d.data("bs.button",e=new c(this,f)),"toggle"==b?e.toggle():b&&e.setState(b)})}var c=function(b,d){this.$element=a(b),this.options=a.extend({},c.DEFAULTS,d),this.isLoading=!1};c.VERSION="3.3.7",c.DEFAULTS={loadingText:"loading..."},c.prototype.setState=function(b){var c="disabled",d=this.$element,e=d.is("input")?"val":"html",f=d.data();b+="Text",null==f.resetText&&d.data("resetText",d[e]()),setTimeout(a.proxy(function(){d[e](null==f[b]?this.options[b]:f[b]),"loadingText"==b?(this.isLoading=!0,d.addClass(c).attr(c,c).prop(c,!0)):this.isLoading&&(this.isLoading=!1,d.removeClass(c).removeAttr(c).prop(c,!1))},this),0)},c.prototype.toggle=function(){var a=!0,b=this.$element.closest('[data-toggle="buttons"]');if(b.length){var c=this.$element.find("input");"radio"==c.prop("type")?(c.prop("checked")&&(a=!1),b.find(".active").removeClass("active"),this.$element.addClass("active")):"checkbox"==c.prop("type")&&(c.prop("checked")!==this.$element.hasClass("active")&&(a=!1),this.$element.toggleClass("active")),c.prop("checked",this.$element.hasClass("active")),a&&c.trigger("change")}else this.$element.attr("aria-pressed",!this.$element.hasClass("active")),this.$element.toggleClass("active")};var d=a.fn.button;a.fn.button=b,a.fn.button.Constructor=c,a.fn.button.noConflict=function(){return a.fn.button=d,this},a(document).on("click.bs.button.data-api",'[data-toggle^="button"]',function(c){var d=a(c.target).closest(".btn");b.call(d,"toggle"),a(c.target).is('input[type="radio"], input[type="checkbox"]')||(c.preventDefault(),d.is("input,button")?d.trigger("focus"):d.find("input:visible,button:visible").first().trigger("focus"))}).on("focus.bs.button.data-api blur.bs.button.data-api",'[data-toggle^="button"]',function(b){a(b.target).closest(".btn").toggleClass("focus",/^focus(in)?$/.test(b.type))})}(jQuery),+function(a){"use strict";function b(b){return this.each(function(){var d=a(this),e=d.data("bs.carousel"),f=a.extend({},c.DEFAULTS,d.data(),"object"==typeof b&&b),g="string"==typeof b?b:f.slide;e||d.data("bs.carousel",e=new c(this,f)),"number"==typeof b?e.to(b):g?e[g]():f.interval&&e.pause().cycle()})}var c=function(b,c){this.$element=a(b),this.$indicators=this.$element.find(".carousel-indicators"),this.options=c,this.paused=null,this.sliding=null,this.interval=null,this.$active=null,this.$items=null,this.options.keyboard&&this.$element.on("keydown.bs.carousel",a.proxy(this.keydown,this)),"hover"==this.options.pause&&!("ontouchstart"in document.documentElement)&&this.$element.on("mouseenter.bs.carousel",a.proxy(this.pause,this)).on("mouseleave.bs.carousel",a.proxy(this.cycle,this))};c.VERSION="3.3.7",c.TRANSITION_DURATION=600,c.DEFAULTS={interval:5e3,pause:"hover",wrap:!0,keyboard:!0},c.prototype.keydown=function(a){if(!/input|textarea/i.test(a.target.tagName)){switch(a.which){case 37:this.prev();break;case 39:this.next();break;default:return}a.preventDefault()}},c.prototype.cycle=function(b){return b||(this.paused=!1),this.interval&&clearInterval(this.interval),this.options.interval&&!this.paused&&(this.interval=setInterval(a.proxy(this.next,this),this.options.interval)),this},c.prototype.getItemIndex=function(a){return this.$items=a.parent().children(".item"),this.$items.index(a||this.$active)},c.prototype.getItemForDirection=function(a,b){var c=this.getItemIndex(b),d="prev"==a&&0===c||"next"==a&&c==this.$items.length-1;if(d&&!this.options.wrap)return b;var e="prev"==a?-1:1,f=(c+e)%this.$items.length;return this.$items.eq(f)},c.prototype.to=function(a){var b=this,c=this.getItemIndex(this.$active=this.$element.find(".item.active"));if(!(a>this.$items.length-1||a<0))return this.sliding?this.$element.one("slid.bs.carousel",function(){b.to(a)}):c==a?this.pause().cycle():this.slide(a>c?"next":"prev",this.$items.eq(a))},c.prototype.pause=function(b){return b||(this.paused=!0),this.$element.find(".next, .prev").length&&a.support.transition&&(this.$element.trigger(a.support.transition.end),this.cycle(!0)),this.interval=clearInterval(this.interval),this},c.prototype.next=function(){if(!this.sliding)return this.slide("next")},c.prototype.prev=function(){if(!this.sliding)return this.slide("prev")},c.prototype.slide=function(b,d){var e=this.$element.find(".item.active"),f=d||this.getItemForDirection(b,e),g=this.interval,h="next"==b?"left":"right",i=this;if(f.hasClass("active"))return this.sliding=!1;var j=f[0],k=a.Event("slide.bs.carousel",{relatedTarget:j,direction:h});if(this.$element.trigger(k),!k.isDefaultPrevented()){if(this.sliding=!0,g&&this.pause(),this.$indicators.length){this.$indicators.find(".active").removeClass("active");var l=a(this.$indicators.children()[this.getItemIndex(f)]);l&&l.addClass("active")}var m=a.Event("slid.bs.carousel",{relatedTarget:j,direction:h});return a.support.transition&&this.$element.hasClass("slide")?(f.addClass(b),f[0].offsetWidth,e.addClass(h),f.addClass(h),e.one("bsTransitionEnd",function(){f.removeClass([b,h].join(" ")).addClass("active"),e.removeClass(["active",h].join(" ")),i.sliding=!1,setTimeout(function(){i.$element.trigger(m)},0)}).emulateTransitionEnd(c.TRANSITION_DURATION)):(e.removeClass("active"),f.addClass("active"),this.sliding=!1,this.$element.trigger(m)),g&&this.cycle(),this}};var d=a.fn.carousel;a.fn.carousel=b,a.fn.carousel.Constructor=c,a.fn.carousel.noConflict=function(){return a.fn.carousel=d,this};var e=function(c){var d,e=a(this),f=a(e.attr("data-target")||(d=e.attr("href"))&&d.replace(/.*(?=#[^\s]+$)/,""));if(f.hasClass("carousel")){var g=a.extend({},f.data(),e.data()),h=e.attr("data-slide-to");h&&(g.interval=!1),b.call(f,g),h&&f.data("bs.carousel").to(h),c.preventDefault()}};a(document).on("click.bs.carousel.data-api","[data-slide]",e).on("click.bs.carousel.data-api","[data-slide-to]",e),a(window).on("load",function(){a('[data-ride="carousel"]').each(function(){var c=a(this);b.call(c,c.data())})})}(jQuery),+function(a){"use strict";function b(b){var c,d=b.attr("data-target")||(c=b.attr("href"))&&c.replace(/.*(?=#[^\s]+$)/,"");return a(d)}function c(b){return this.each(function(){var c=a(this),e=c.data("bs.collapse"),f=a.extend({},d.DEFAULTS,c.data(),"object"==typeof b&&b);!e&&f.toggle&&/show|hide/.test(b)&&(f.toggle=!1),e||c.data("bs.collapse",e=new d(this,f)),"string"==typeof b&&e[b]()})}var d=function(b,c){this.$element=a(b),this.options=a.extend({},d.DEFAULTS,c),this.$trigger=a('[data-toggle="collapse"][href="#'+b.id+'"],[data-toggle="collapse"][data-target="#'+b.id+'"]'),this.transitioning=null,this.options.parent?this.$parent=this.getParent():this.addAriaAndCollapsedClass(this.$element,this.$trigger),this.options.toggle&&this.toggle()};d.VERSION="3.3.7",d.TRANSITION_DURATION=350,d.DEFAULTS={toggle:!0},d.prototype.dimension=function(){var a=this.$element.hasClass("width");return a?"width":"height"},d.prototype.show=function(){if(!this.transitioning&&!this.$element.hasClass("in")){var b,e=this.$parent&&this.$parent.children(".panel").children(".in, .collapsing");if(!(e&&e.length&&(b=e.data("bs.collapse"),b&&b.transitioning))){var f=a.Event("show.bs.collapse");if(this.$element.trigger(f),!f.isDefaultPrevented()){e&&e.length&&(c.call(e,"hide"),b||e.data("bs.collapse",null));var g=this.dimension();this.$element.removeClass("collapse").addClass("collapsing")[g](0).attr("aria-expanded",!0),this.$trigger.removeClass("collapsed").attr("aria-expanded",!0),this.transitioning=1;var h=function(){this.$element.removeClass("collapsing").addClass("collapse in")[g](""),this.transitioning=0,this.$element.trigger("shown.bs.collapse")};if(!a.support.transition)return h.call(this);var i=a.camelCase(["scroll",g].join("-"));this.$element.one("bsTransitionEnd",a.proxy(h,this)).emulateTransitionEnd(d.TRANSITION_DURATION)[g](this.$element[0][i])}}}},d.prototype.hide=function(){if(!this.transitioning&&this.$element.hasClass("in")){var b=a.Event("hide.bs.collapse");if(this.$element.trigger(b),!b.isDefaultPrevented()){var c=this.dimension();this.$element[c](this.$element[c]())[0].offsetHeight,this.$element.addClass("collapsing").removeClass("collapse in").attr("aria-expanded",!1),this.$trigger.addClass("collapsed").attr("aria-expanded",!1),this.transitioning=1;var e=function(){this.transitioning=0,this.$element.removeClass("collapsing").addClass("collapse").trigger("hidden.bs.collapse")};return a.support.transition?void this.$element[c](0).one("bsTransitionEnd",a.proxy(e,this)).emulateTransitionEnd(d.TRANSITION_DURATION):e.call(this)}}},d.prototype.toggle=function(){this[this.$element.hasClass("in")?"hide":"show"]()},d.prototype.getParent=function(){return a(this.options.parent).find('[data-toggle="collapse"][data-parent="'+this.options.parent+'"]').each(a.proxy(function(c,d){var e=a(d);this.addAriaAndCollapsedClass(b(e),e)},this)).end()},d.prototype.addAriaAndCollapsedClass=function(a,b){var c=a.hasClass("in");a.attr("aria-expanded",c),b.toggleClass("collapsed",!c).attr("aria-expanded",c)};var e=a.fn.collapse;a.fn.collapse=c,a.fn.collapse.Constructor=d,a.fn.collapse.noConflict=function(){return a.fn.collapse=e,this},a(document).on("click.bs.collapse.data-api",'[data-toggle="collapse"]',function(d){var e=a(this);e.attr("data-target")||d.preventDefault();var f=b(e),g=f.data("bs.collapse"),h=g?"toggle":e.data();c.call(f,h)})}(jQuery),+function(a){"use strict";function b(b){var c=b.attr("data-target");c||(c=b.attr("href"),c=c&&/#[A-Za-z]/.test(c)&&c.replace(/.*(?=#[^\s]*$)/,""));var d=c&&a(c);return d&&d.length?d:b.parent()}function c(c){c&&3===c.which||(a(e).remove(),a(f).each(function(){var d=a(this),e=b(d),f={relatedTarget:this};e.hasClass("open")&&(c&&"click"==c.type&&/input|textarea/i.test(c.target.tagName)&&a.contains(e[0],c.target)||(e.trigger(c=a.Event("hide.bs.dropdown",f)),c.isDefaultPrevented()||(d.attr("aria-expanded","false"),e.removeClass("open").trigger(a.Event("hidden.bs.dropdown",f)))))}))}function d(b){return this.each(function(){var c=a(this),d=c.data("bs.dropdown");d||c.data("bs.dropdown",d=new g(this)),"string"==typeof b&&d[b].call(c)})}var e=".dropdown-backdrop",f='[data-toggle="dropdown"]',g=function(b){a(b).on("click.bs.dropdown",this.toggle)};g.VERSION="3.3.7",g.prototype.toggle=function(d){var e=a(this);if(!e.is(".disabled, :disabled")){var f=b(e),g=f.hasClass("open");if(c(),!g){"ontouchstart"in document.documentElement&&!f.closest(".navbar-nav").length&&a(document.createElement("div")).addClass("dropdown-backdrop").insertAfter(a(this)).on("click",c);var h={relatedTarget:this};if(f.trigger(d=a.Event("show.bs.dropdown",h)),d.isDefaultPrevented())return;e.trigger("focus").attr("aria-expanded","true"),f.toggleClass("open").trigger(a.Event("shown.bs.dropdown",h))}return!1}},g.prototype.keydown=function(c){if(/(38|40|27|32)/.test(c.which)&&!/input|textarea/i.test(c.target.tagName)){var d=a(this);if(c.preventDefault(),c.stopPropagation(),!d.is(".disabled, :disabled")){var e=b(d),g=e.hasClass("open");if(!g&&27!=c.which||g&&27==c.which)return 27==c.which&&e.find(f).trigger("focus"),d.trigger("click");var h=" li:not(.disabled):visible a",i=e.find(".dropdown-menu"+h);if(i.length){var j=i.index(c.target);38==c.which&&j>0&&j--,40==c.which&&j<i.length-1&&j++,~j||(j=0),i.eq(j).trigger("focus")}}}};var h=a.fn.dropdown;a.fn.dropdown=d,a.fn.dropdown.Constructor=g,a.fn.dropdown.noConflict=function(){return a.fn.dropdown=h,this},a(document).on("click.bs.dropdown.data-api",c).on("click.bs.dropdown.data-api",".dropdown form",function(a){a.stopPropagation()}).on("click.bs.dropdown.data-api",f,g.prototype.toggle).on("keydown.bs.dropdown.data-api",f,g.prototype.keydown).on("keydown.bs.dropdown.data-api",".dropdown-menu",g.prototype.keydown)}(jQuery),+function(a){"use strict";function b(b,d){return this.each(function(){var e=a(this),f=e.data("bs.modal"),g=a.extend({},c.DEFAULTS,e.data(),"object"==typeof b&&b);f||e.data("bs.modal",f=new c(this,g)),"string"==typeof b?f[b](d):g.show&&f.show(d)})}var c=function(b,c){this.options=c,this.$body=a(document.body),this.$element=a(b),this.$dialog=this.$element.find(".modal-dialog"),this.$backdrop=null,this.isShown=null,this.originalBodyPad=null,this.scrollbarWidth=0,this.ignoreBackdropClick=!1,this.options.remote&&this.$element.find(".modal-content").load(this.options.remote,a.proxy(function(){this.$element.trigger("loaded.bs.modal")},this))};c.VERSION="3.3.7",c.TRANSITION_DURATION=300,c.BACKDROP_TRANSITION_DURATION=150,c.DEFAULTS={backdrop:!0,keyboard:!0,show:!0},c.prototype.toggle=function(a){return this.isShown?this.hide():this.show(a)},c.prototype.show=function(b){var d=this,e=a.Event("show.bs.modal",{relatedTarget:b});this.$element.trigger(e),this.isShown||e.isDefaultPrevented()||(this.isShown=!0,this.checkScrollbar(),this.setScrollbar(),this.$body.addClass("modal-open"),this.escape(),this.resize(),this.$element.on("click.dismiss.bs.modal",'[data-dismiss="modal"]',a.proxy(this.hide,this)),this.$dialog.on("mousedown.dismiss.bs.modal",function(){d.$element.one("mouseup.dismiss.bs.modal",function(b){a(b.target).is(d.$element)&&(d.ignoreBackdropClick=!0)})}),this.backdrop(function(){var e=a.support.transition&&d.$element.hasClass("fade");d.$element.parent().length||d.$element.appendTo(d.$body),d.$element.show().scrollTop(0),d.adjustDialog(),e&&d.$element[0].offsetWidth,d.$element.addClass("in"),d.enforceFocus();var f=a.Event("shown.bs.modal",{relatedTarget:b});e?d.$dialog.one("bsTransitionEnd",function(){d.$element.trigger("focus").trigger(f)}).emulateTransitionEnd(c.TRANSITION_DURATION):d.$element.trigger("focus").trigger(f)}))},c.prototype.hide=function(b){b&&b.preventDefault(),b=a.Event("hide.bs.modal"),this.$element.trigger(b),this.isShown&&!b.isDefaultPrevented()&&(this.isShown=!1,this.escape(),this.resize(),a(document).off("focusin.bs.modal"),this.$element.removeClass("in").off("click.dismiss.bs.modal").off("mouseup.dismiss.bs.modal"),this.$dialog.off("mousedown.dismiss.bs.modal"),a.support.transition&&this.$element.hasClass("fade")?this.$element.one("bsTransitionEnd",a.proxy(this.hideModal,this)).emulateTransitionEnd(c.TRANSITION_DURATION):this.hideModal())},c.prototype.enforceFocus=function(){a(document).off("focusin.bs.modal").on("focusin.bs.modal",a.proxy(function(a){document===a.target||this.$element[0]===a.target||this.$element.has(a.target).length||this.$element.trigger("focus")},this))},c.prototype.escape=function(){this.isShown&&this.options.keyboard?this.$element.on("keydown.dismiss.bs.modal",a.proxy(function(a){27==a.which&&this.hide()},this)):this.isShown||this.$element.off("keydown.dismiss.bs.modal")},c.prototype.resize=function(){this.isShown?a(window).on("resize.bs.modal",a.proxy(this.handleUpdate,this)):a(window).off("resize.bs.modal")},c.prototype.hideModal=function(){var a=this;this.$element.hide(),this.backdrop(function(){a.$body.removeClass("modal-open"),a.resetAdjustments(),a.resetScrollbar(),a.$element.trigger("hidden.bs.modal")})},c.prototype.removeBackdrop=function(){this.$backdrop&&this.$backdrop.remove(),this.$backdrop=null},c.prototype.backdrop=function(b){var d=this,e=this.$element.hasClass("fade")?"fade":"";if(this.isShown&&this.options.backdrop){var f=a.support.transition&&e;if(this.$backdrop=a(document.createElement("div")).addClass("modal-backdrop "+e).appendTo(this.$body),this.$element.on("click.dismiss.bs.modal",a.proxy(function(a){return this.ignoreBackdropClick?void(this.ignoreBackdropClick=!1):void(a.target===a.currentTarget&&("static"==this.options.backdrop?this.$element[0].focus():this.hide()))},this)),f&&this.$backdrop[0].offsetWidth,this.$backdrop.addClass("in"),!b)return;f?this.$backdrop.one("bsTransitionEnd",b).emulateTransitionEnd(c.BACKDROP_TRANSITION_DURATION):b()}else if(!this.isShown&&this.$backdrop){this.$backdrop.removeClass("in");var g=function(){d.removeBackdrop(),b&&b()};a.support.transition&&this.$element.hasClass("fade")?this.$backdrop.one("bsTransitionEnd",g).emulateTransitionEnd(c.BACKDROP_TRANSITION_DURATION):g()}else b&&b()},c.prototype.handleUpdate=function(){this.adjustDialog()},c.prototype.adjustDialog=function(){var a=this.$element[0].scrollHeight>document.documentElement.clientHeight;this.$element.css({paddingLeft:!this.bodyIsOverflowing&&a?this.scrollbarWidth:"",paddingRight:this.bodyIsOverflowing&&!a?this.scrollbarWidth:""})},c.prototype.resetAdjustments=function(){this.$element.css({paddingLeft:"",paddingRight:""})},c.prototype.checkScrollbar=function(){var a=window.innerWidth;if(!a){var b=document.documentElement.getBoundingClientRect();a=b.right-Math.abs(b.left)}this.bodyIsOverflowing=document.body.clientWidth<a,this.scrollbarWidth=this.measureScrollbar()},c.prototype.setScrollbar=function(){var a=parseInt(this.$body.css("padding-right")||0,10);this.originalBodyPad=document.body.style.paddingRight||"",this.bodyIsOverflowing&&this.$body.css("padding-right",a+this.scrollbarWidth)},c.prototype.resetScrollbar=function(){this.$body.css("padding-right",this.originalBodyPad)},c.prototype.measureScrollbar=function(){var a=document.createElement("div");a.className="modal-scrollbar-measure",this.$body.append(a);var b=a.offsetWidth-a.clientWidth;return this.$body[0].removeChild(a),b};var d=a.fn.modal;a.fn.modal=b,a.fn.modal.Constructor=c,a.fn.modal.noConflict=function(){return a.fn.modal=d,this},a(document).on("click.bs.modal.data-api",'[data-toggle="modal"]',function(c){var d=a(this),e=d.attr("href"),f=a(d.attr("data-target")||e&&e.replace(/.*(?=#[^\s]+$)/,"")),g=f.data("bs.modal")?"toggle":a.extend({remote:!/#/.test(e)&&e},f.data(),d.data());d.is("a")&&c.preventDefault(),f.one("show.bs.modal",function(a){a.isDefaultPrevented()||f.one("hidden.bs.modal",function(){d.is(":visible")&&d.trigger("focus")})}),b.call(f,g,this)})}(jQuery),+function(a){"use strict";function b(b){return this.each(function(){var d=a(this),e=d.data("bs.tooltip"),f="object"==typeof b&&b;!e&&/destroy|hide/.test(b)||(e||d.data("bs.tooltip",e=new c(this,f)),"string"==typeof b&&e[b]())})}var c=function(a,b){this.type=null,this.options=null,this.enabled=null,this.timeout=null,this.hoverState=null,this.$element=null,this.inState=null,this.init("tooltip",a,b)};c.VERSION="3.3.7",c.TRANSITION_DURATION=150,c.DEFAULTS={animation:!0,placement:"top",selector:!1,template:'<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',trigger:"hover focus",title:"",delay:0,html:!1,container:!1,viewport:{selector:"body",padding:0}},c.prototype.init=function(b,c,d){if(this.enabled=!0,this.type=b,this.$element=a(c),this.options=this.getOptions(d),this.$viewport=this.options.viewport&&a(a.isFunction(this.options.viewport)?this.options.viewport.call(this,this.$element):this.options.viewport.selector||this.options.viewport),this.inState={click:!1,hover:!1,focus:!1},this.$element[0]instanceof document.constructor&&!this.options.selector)throw new Error("`selector` option must be specified when initializing "+this.type+" on the window.document object!");for(var e=this.options.trigger.split(" "),f=e.length;f--;){var g=e[f];if("click"==g)this.$element.on("click."+this.type,this.options.selector,a.proxy(this.toggle,this));else if("manual"!=g){var h="hover"==g?"mouseenter":"focusin",i="hover"==g?"mouseleave":"focusout";this.$element.on(h+"."+this.type,this.options.selector,a.proxy(this.enter,this)),this.$element.on(i+"."+this.type,this.options.selector,a.proxy(this.leave,this))}}this.options.selector?this._options=a.extend({},this.options,{trigger:"manual",selector:""}):this.fixTitle()},c.prototype.getDefaults=function(){return c.DEFAULTS},c.prototype.getOptions=function(b){return b=a.extend({},this.getDefaults(),this.$element.data(),b),b.delay&&"number"==typeof b.delay&&(b.delay={show:b.delay,hide:b.delay}),b},c.prototype.getDelegateOptions=function(){var b={},c=this.getDefaults();return this._options&&a.each(this._options,function(a,d){c[a]!=d&&(b[a]=d)}),b},c.prototype.enter=function(b){var c=b instanceof this.constructor?b:a(b.currentTarget).data("bs."+this.type);return c||(c=new this.constructor(b.currentTarget,this.getDelegateOptions()),a(b.currentTarget).data("bs."+this.type,c)),b instanceof a.Event&&(c.inState["focusin"==b.type?"focus":"hover"]=!0),c.tip().hasClass("in")||"in"==c.hoverState?void(c.hoverState="in"):(clearTimeout(c.timeout),c.hoverState="in",c.options.delay&&c.options.delay.show?void(c.timeout=setTimeout(function(){"in"==c.hoverState&&c.show()},c.options.delay.show)):c.show())},c.prototype.isInStateTrue=function(){for(var a in this.inState)if(this.inState[a])return!0;return!1},c.prototype.leave=function(b){var c=b instanceof this.constructor?b:a(b.currentTarget).data("bs."+this.type);if(c||(c=new this.constructor(b.currentTarget,this.getDelegateOptions()),a(b.currentTarget).data("bs."+this.type,c)),b instanceof a.Event&&(c.inState["focusout"==b.type?"focus":"hover"]=!1),!c.isInStateTrue())return clearTimeout(c.timeout),c.hoverState="out",c.options.delay&&c.options.delay.hide?void(c.timeout=setTimeout(function(){"out"==c.hoverState&&c.hide()},c.options.delay.hide)):c.hide()},c.prototype.show=function(){var b=a.Event("show.bs."+this.type);if(this.hasContent()&&this.enabled){this.$element.trigger(b);var d=a.contains(this.$element[0].ownerDocument.documentElement,this.$element[0]);if(b.isDefaultPrevented()||!d)return;var e=this,f=this.tip(),g=this.getUID(this.type);this.setContent(),f.attr("id",g),this.$element.attr("aria-describedby",g),this.options.animation&&f.addClass("fade");var h="function"==typeof this.options.placement?this.options.placement.call(this,f[0],this.$element[0]):this.options.placement,i=/\s?auto?\s?/i,j=i.test(h);j&&(h=h.replace(i,"")||"top"),f.detach().css({top:0,left:0,display:"block"}).addClass(h).data("bs."+this.type,this),this.options.container?f.appendTo(this.options.container):f.insertAfter(this.$element),this.$element.trigger("inserted.bs."+this.type);var k=this.getPosition(),l=f[0].offsetWidth,m=f[0].offsetHeight;if(j){var n=h,o=this.getPosition(this.$viewport);h="bottom"==h&&k.bottom+m>o.bottom?"top":"top"==h&&k.top-m<o.top?"bottom":"right"==h&&k.right+l>o.width?"left":"left"==h&&k.left-l<o.left?"right":h,f.removeClass(n).addClass(h)}var p=this.getCalculatedOffset(h,k,l,m);this.applyPlacement(p,h);var q=function(){var a=e.hoverState;e.$element.trigger("shown.bs."+e.type),e.hoverState=null,"out"==a&&e.leave(e)};a.support.transition&&this.$tip.hasClass("fade")?f.one("bsTransitionEnd",q).emulateTransitionEnd(c.TRANSITION_DURATION):q()}},c.prototype.applyPlacement=function(b,c){var d=this.tip(),e=d[0].offsetWidth,f=d[0].offsetHeight,g=parseInt(d.css("margin-top"),10),h=parseInt(d.css("margin-left"),10);isNaN(g)&&(g=0),isNaN(h)&&(h=0),b.top+=g,b.left+=h,a.offset.setOffset(d[0],a.extend({using:function(a){d.css({top:Math.round(a.top),left:Math.round(a.left)})}},b),0),d.addClass("in");var i=d[0].offsetWidth,j=d[0].offsetHeight;"top"==c&&j!=f&&(b.top=b.top+f-j);var k=this.getViewportAdjustedDelta(c,b,i,j);k.left?b.left+=k.left:b.top+=k.top;var l=/top|bottom/.test(c),m=l?2*k.left-e+i:2*k.top-f+j,n=l?"offsetWidth":"offsetHeight";d.offset(b),this.replaceArrow(m,d[0][n],l)},c.prototype.replaceArrow=function(a,b,c){this.arrow().css(c?"left":"top",50*(1-a/b)+"%").css(c?"top":"left","")},c.prototype.setContent=function(){var a=this.tip(),b=this.getTitle();a.find(".tooltip-inner")[this.options.html?"html":"text"](b),a.removeClass("fade in top bottom left right")},c.prototype.hide=function(b){function d(){"in"!=e.hoverState&&f.detach(),e.$element&&e.$element.removeAttr("aria-describedby").trigger("hidden.bs."+e.type),b&&b()}var e=this,f=a(this.$tip),g=a.Event("hide.bs."+this.type);if(this.$element.trigger(g),!g.isDefaultPrevented())return f.removeClass("in"),a.support.transition&&f.hasClass("fade")?f.one("bsTransitionEnd",d).emulateTransitionEnd(c.TRANSITION_DURATION):d(),this.hoverState=null,this},c.prototype.fixTitle=function(){var a=this.$element;(a.attr("title")||"string"!=typeof a.attr("data-original-title"))&&a.attr("data-original-title",a.attr("title")||"").attr("title","")},c.prototype.hasContent=function(){return this.getTitle()},c.prototype.getPosition=function(b){b=b||this.$element;var c=b[0],d="BODY"==c.tagName,e=c.getBoundingClientRect();null==e.width&&(e=a.extend({},e,{width:e.right-e.left,height:e.bottom-e.top}));var f=window.SVGElement&&c instanceof window.SVGElement,g=d?{top:0,left:0}:f?null:b.offset(),h={scroll:d?document.documentElement.scrollTop||document.body.scrollTop:b.scrollTop()},i=d?{width:a(window).width(),height:a(window).height()}:null;return a.extend({},e,h,i,g)},c.prototype.getCalculatedOffset=function(a,b,c,d){return"bottom"==a?{top:b.top+b.height,left:b.left+b.width/2-c/2}:"top"==a?{top:b.top-d,left:b.left+b.width/2-c/2}:"left"==a?{top:b.top+b.height/2-d/2,left:b.left-c}:{top:b.top+b.height/2-d/2,left:b.left+b.width}},c.prototype.getViewportAdjustedDelta=function(a,b,c,d){var e={top:0,left:0};if(!this.$viewport)return e;var f=this.options.viewport&&this.options.viewport.padding||0,g=this.getPosition(this.$viewport);if(/right|left/.test(a)){var h=b.top-f-g.scroll,i=b.top+f-g.scroll+d;h<g.top?e.top=g.top-h:i>g.top+g.height&&(e.top=g.top+g.height-i)}else{var j=b.left-f,k=b.left+f+c;j<g.left?e.left=g.left-j:k>g.right&&(e.left=g.left+g.width-k)}return e},c.prototype.getTitle=function(){var a,b=this.$element,c=this.options;return a=b.attr("data-original-title")||("function"==typeof c.title?c.title.call(b[0]):c.title)},c.prototype.getUID=function(a){do a+=~~(1e6*Math.random());while(document.getElementById(a));return a},c.prototype.tip=function(){if(!this.$tip&&(this.$tip=a(this.options.template),1!=this.$tip.length))throw new Error(this.type+" `template` option must consist of exactly 1 top-level element!");return this.$tip},c.prototype.arrow=function(){return this.$arrow=this.$arrow||this.tip().find(".tooltip-arrow")},c.prototype.enable=function(){this.enabled=!0},c.prototype.disable=function(){this.enabled=!1},c.prototype.toggleEnabled=function(){this.enabled=!this.enabled},c.prototype.toggle=function(b){var c=this;b&&(c=a(b.currentTarget).data("bs."+this.type),c||(c=new this.constructor(b.currentTarget,this.getDelegateOptions()),a(b.currentTarget).data("bs."+this.type,c))),b?(c.inState.click=!c.inState.click,c.isInStateTrue()?c.enter(c):c.leave(c)):c.tip().hasClass("in")?c.leave(c):c.enter(c)},c.prototype.destroy=function(){var a=this;clearTimeout(this.timeout),this.hide(function(){a.$element.off("."+a.type).removeData("bs."+a.type),a.$tip&&a.$tip.detach(),a.$tip=null,a.$arrow=null,a.$viewport=null,a.$element=null})};var d=a.fn.tooltip;a.fn.tooltip=b,a.fn.tooltip.Constructor=c,a.fn.tooltip.noConflict=function(){return a.fn.tooltip=d,this}}(jQuery),+function(a){"use strict";function b(b){return this.each(function(){var d=a(this),e=d.data("bs.popover"),f="object"==typeof b&&b;!e&&/destroy|hide/.test(b)||(e||d.data("bs.popover",e=new c(this,f)),"string"==typeof b&&e[b]())})}var c=function(a,b){this.init("popover",a,b)};if(!a.fn.tooltip)throw new Error("Popover requires tooltip.js");c.VERSION="3.3.7",c.DEFAULTS=a.extend({},a.fn.tooltip.Constructor.DEFAULTS,{placement:"right",trigger:"click",content:"",template:'<div class="popover" role="tooltip"><div class="arrow"></div><h3 class="popover-title"></h3><div class="popover-content"></div></div>'}),c.prototype=a.extend({},a.fn.tooltip.Constructor.prototype),c.prototype.constructor=c,c.prototype.getDefaults=function(){return c.DEFAULTS},c.prototype.setContent=function(){var a=this.tip(),b=this.getTitle(),c=this.getContent();a.find(".popover-title")[this.options.html?"html":"text"](b),a.find(".popover-content").children().detach().end()[this.options.html?"string"==typeof c?"html":"append":"text"](c),a.removeClass("fade top bottom left right in"),a.find(".popover-title").html()||a.find(".popover-title").hide()},c.prototype.hasContent=function(){return this.getTitle()||this.getContent()},c.prototype.getContent=function(){var a=this.$element,b=this.options;return a.attr("data-content")||("function"==typeof b.content?b.content.call(a[0]):b.content)},c.prototype.arrow=function(){return this.$arrow=this.$arrow||this.tip().find(".arrow")};var d=a.fn.popover;a.fn.popover=b,a.fn.popover.Constructor=c,a.fn.popover.noConflict=function(){return a.fn.popover=d,this}}(jQuery),+function(a){"use strict";function b(c,d){this.$body=a(document.body),this.$scrollElement=a(a(c).is(document.body)?window:c),this.options=a.extend({},b.DEFAULTS,d),this.selector=(this.options.target||"")+" .nav li > a",this.offsets=[],this.targets=[],this.activeTarget=null,this.scrollHeight=0,this.$scrollElement.on("scroll.bs.scrollspy",a.proxy(this.process,this)),this.refresh(),this.process()}function c(c){return this.each(function(){var d=a(this),e=d.data("bs.scrollspy"),f="object"==typeof c&&c;e||d.data("bs.scrollspy",e=new b(this,f)),"string"==typeof c&&e[c]()})}b.VERSION="3.3.7",b.DEFAULTS={offset:10},b.prototype.getScrollHeight=function(){return this.$scrollElement[0].scrollHeight||Math.max(this.$body[0].scrollHeight,document.documentElement.scrollHeight)},b.prototype.refresh=function(){var b=this,c="offset",d=0;this.offsets=[],this.targets=[],this.scrollHeight=this.getScrollHeight(),a.isWindow(this.$scrollElement[0])||(c="position",d=this.$scrollElement.scrollTop()),this.$body.find(this.selector).map(function(){var b=a(this),e=b.data("target")||b.attr("href"),f=/^#./.test(e)&&a(e);return f&&f.length&&f.is(":visible")&&[[f[c]().top+d,e]]||null}).sort(function(a,b){return a[0]-b[0]}).each(function(){b.offsets.push(this[0]),b.targets.push(this[1])})},b.prototype.process=function(){var a,b=this.$scrollElement.scrollTop()+this.options.offset,c=this.getScrollHeight(),d=this.options.offset+c-this.$scrollElement.height(),e=this.offsets,f=this.targets,g=this.activeTarget;if(this.scrollHeight!=c&&this.refresh(),b>=d)return g!=(a=f[f.length-1])&&this.activate(a);if(g&&b<e[0])return this.activeTarget=null,this.clear();for(a=e.length;a--;)g!=f[a]&&b>=e[a]&&(void 0===e[a+1]||b<e[a+1])&&this.activate(f[a])},b.prototype.activate=function(b){
    this.activeTarget=b,this.clear();var c=this.selector+'[data-target="'+b+'"],'+this.selector+'[href="'+b+'"]',d=a(c).parents("li").addClass("active");d.parent(".dropdown-menu").length&&(d=d.closest("li.dropdown").addClass("active")),d.trigger("activate.bs.scrollspy")},b.prototype.clear=function(){a(this.selector).parentsUntil(this.options.target,".active").removeClass("active")};var d=a.fn.scrollspy;a.fn.scrollspy=c,a.fn.scrollspy.Constructor=b,a.fn.scrollspy.noConflict=function(){return a.fn.scrollspy=d,this},a(window).on("load.bs.scrollspy.data-api",function(){a('[data-spy="scroll"]').each(function(){var b=a(this);c.call(b,b.data())})})}(jQuery),+function(a){"use strict";function b(b){return this.each(function(){var d=a(this),e=d.data("bs.tab");e||d.data("bs.tab",e=new c(this)),"string"==typeof b&&e[b]()})}var c=function(b){this.element=a(b)};c.VERSION="3.3.7",c.TRANSITION_DURATION=150,c.prototype.show=function(){var b=this.element,c=b.closest("ul:not(.dropdown-menu)"),d=b.data("target");if(d||(d=b.attr("href"),d=d&&d.replace(/.*(?=#[^\s]*$)/,"")),!b.parent("li").hasClass("active")){var e=c.find(".active:last a"),f=a.Event("hide.bs.tab",{relatedTarget:b[0]}),g=a.Event("show.bs.tab",{relatedTarget:e[0]});if(e.trigger(f),b.trigger(g),!g.isDefaultPrevented()&&!f.isDefaultPrevented()){var h=a(d);this.activate(b.closest("li"),c),this.activate(h,h.parent(),function(){e.trigger({type:"hidden.bs.tab",relatedTarget:b[0]}),b.trigger({type:"shown.bs.tab",relatedTarget:e[0]})})}}},c.prototype.activate=function(b,d,e){function f(){g.removeClass("active").find("> .dropdown-menu > .active").removeClass("active").end().find('[data-toggle="tab"]').attr("aria-expanded",!1),b.addClass("active").find('[data-toggle="tab"]').attr("aria-expanded",!0),h?(b[0].offsetWidth,b.addClass("in")):b.removeClass("fade"),b.parent(".dropdown-menu").length&&b.closest("li.dropdown").addClass("active").end().find('[data-toggle="tab"]').attr("aria-expanded",!0),e&&e()}var g=d.find("> .active"),h=e&&a.support.transition&&(g.length&&g.hasClass("fade")||!!d.find("> .fade").length);g.length&&h?g.one("bsTransitionEnd",f).emulateTransitionEnd(c.TRANSITION_DURATION):f(),g.removeClass("in")};var d=a.fn.tab;a.fn.tab=b,a.fn.tab.Constructor=c,a.fn.tab.noConflict=function(){return a.fn.tab=d,this};var e=function(c){c.preventDefault(),b.call(a(this),"show")};a(document).on("click.bs.tab.data-api",'[data-toggle="tab"]',e).on("click.bs.tab.data-api",'[data-toggle="pill"]',e)}(jQuery),+function(a){"use strict";function b(b){return this.each(function(){var d=a(this),e=d.data("bs.affix"),f="object"==typeof b&&b;e||d.data("bs.affix",e=new c(this,f)),"string"==typeof b&&e[b]()})}var c=function(b,d){this.options=a.extend({},c.DEFAULTS,d),this.$target=a(this.options.target).on("scroll.bs.affix.data-api",a.proxy(this.checkPosition,this)).on("click.bs.affix.data-api",a.proxy(this.checkPositionWithEventLoop,this)),this.$element=a(b),this.affixed=null,this.unpin=null,this.pinnedOffset=null,this.checkPosition()};c.VERSION="3.3.7",c.RESET="affix affix-top affix-bottom",c.DEFAULTS={offset:0,target:window},c.prototype.getState=function(a,b,c,d){var e=this.$target.scrollTop(),f=this.$element.offset(),g=this.$target.height();if(null!=c&&"top"==this.affixed)return e<c&&"top";if("bottom"==this.affixed)return null!=c?!(e+this.unpin<=f.top)&&"bottom":!(e+g<=a-d)&&"bottom";var h=null==this.affixed,i=h?e:f.top,j=h?g:b;return null!=c&&e<=c?"top":null!=d&&i+j>=a-d&&"bottom"},c.prototype.getPinnedOffset=function(){if(this.pinnedOffset)return this.pinnedOffset;this.$element.removeClass(c.RESET).addClass("affix");var a=this.$target.scrollTop(),b=this.$element.offset();return this.pinnedOffset=b.top-a},c.prototype.checkPositionWithEventLoop=function(){setTimeout(a.proxy(this.checkPosition,this),1)},c.prototype.checkPosition=function(){if(this.$element.is(":visible")){var b=this.$element.height(),d=this.options.offset,e=d.top,f=d.bottom,g=Math.max(a(document).height(),a(document.body).height());"object"!=typeof d&&(f=e=d),"function"==typeof e&&(e=d.top(this.$element)),"function"==typeof f&&(f=d.bottom(this.$element));var h=this.getState(g,b,e,f);if(this.affixed!=h){null!=this.unpin&&this.$element.css("top","");var i="affix"+(h?"-"+h:""),j=a.Event(i+".bs.affix");if(this.$element.trigger(j),j.isDefaultPrevented())return;this.affixed=h,this.unpin="bottom"==h?this.getPinnedOffset():null,this.$element.removeClass(c.RESET).addClass(i).trigger(i.replace("affix","affixed")+".bs.affix")}"bottom"==h&&this.$element.offset({top:g-b-f})}};var d=a.fn.affix;a.fn.affix=b,a.fn.affix.Constructor=c,a.fn.affix.noConflict=function(){return a.fn.affix=d,this},a(window).on("load",function(){a('[data-spy="affix"]').each(function(){var c=a(this),d=c.data();d.offset=d.offset||{},null!=d.offsetBottom&&(d.offset.bottom=d.offsetBottom),null!=d.offsetTop&&(d.offset.top=d.offsetTop),b.call(c,d)})})}(jQuery);
(function() {
    'use strict';
    angular
     .module('app.requests')
    .directive('validNumber', function() {
        return {
          require: '?ngModel',
          link: function(scope, element, attrs, ngModelCtrl) {
            if(!ngModelCtrl) {
              return;
            }
            ngModelCtrl.$parsers.push(function(val) {
              if (angular.isUndefined(val)) {
                  var val = '';
              }
              var clean = val.replace(/[^-0-9\.]/g, '');
              var negativeCheck = clean.split('-');
              var decimalCheck = clean.split('.');
              if(!angular.isUndefined(negativeCheck[1])) {
                  negativeCheck[1] = negativeCheck[1].slice(0, negativeCheck[1].length);
                  clean =negativeCheck[0] + '-' + negativeCheck[1];
                  if(negativeCheck[0].length > 0) {
                      clean =negativeCheck[0];
                  }
              }
              if(!angular.isUndefined(decimalCheck[1])) {
                  decimalCheck[1] = decimalCheck[1].slice(0,2);
                  clean =decimalCheck[0] + '.' + decimalCheck[1];
              }
              if (val !== clean) {
                ngModelCtrl.$setViewValue(clean);
                ngModelCtrl.$render();
              }
              return clean;
            });
            element.bind('keypress', function(event) {
              if(event.keyCode === 32) {
                event.preventDefault();
              }
            });
          }
        };
      })
     .controller('Alkem_RequestsController', Alkem_RequestsController);
    /** @ngInject */
    function Alkem_RequestsController($state, $filter, $localStorage, CommonUtil, $stateParams, $scope, Plants, BlockList, PRDoctypes, MaterialTypes, PurchaseGroups, $mdDialog, RestAPIService, $sce, ReqTypes, $rootScope) {
     var requestCtrl = this;
     $scope.tab = 2;
     $scope.header = {};
     $scope.request = {};
   
     var json = $localStorage.logedInuserdetail;
     $scope.RequestedBy = $scope.loggedInUserName;
     $scope.reqTypes = ReqTypes.data;
     $scope.Allplants = Plants.data;
     $scope.PR_Doctypes = PRDoctypes.data;
     $scope.BlockLists = BlockList.data;
     $scope.Purchasegroups = PurchaseGroups.data;
     $scope.getCategory = getCategory;
     $scope.getAccountAssCategory = getAccountAssCategory;
     $scope.oredrrequired = true;
     $scope.Assetrequired = false;
     $scope.costrequired = true;
     $scope.wbsrequired = false;
     $scope.header.ZUMSK="A";
    $scope.Defaultdata=function(){
       $scope.header.MBRSH ="P";
        $scope.header.GEN_ITEM ="NORM";
        $scope.header.GEWEI ="G";
        $scope.header.TAXKM ="1";
        $scope.header.STGMA ="1";
        $scope.header.MTPOS_MARA ="NORM";
        $scope.header.LADGR ="0001";
        $scope.header.TRAGR ="0001";
        $scope.header.PRCTR ="DUMMY";
        $scope.header.TAXIM1 ="0";
        $scope.header.MAABC ="N";
        $scope.header.DISMM ="PD";
        $scope.header.DISLS ="EX";
        $scope.header.PLIFZ ="0";
        $scope.header.WEBAZ ="0";
        $scope.header.FHORI ="000";
        $scope.header.LGRAD ="0";
        $scope.header.CHCK_GROUP ="YP";
        $scope.header.PERKZ ="M";
        $scope.header.PEINH ="1";
     }
     if (json != undefined) {
      if (json['loggedInUserName'] != undefined && json['currentLogedInUser'] != undefined) {
       $scope.loggedInUserNameDetails = json['currentLogedInUser'];
       $scope.loggedInUserName = $scope.loggedInUserNameDetails.login;
       $rootScope.currentLogedInUser = json['currentLogedInUser'];
      }
     }
     $scope.getAnotherIcon = function(index) {
        $scope.icons = ['icon-account', 'icon-cash-100', 'icon-account-switch', 'icon-file-document', 'icon-cash-usd', 'icon-chart-bar'];
        var totalNoOfIcons = $scope.icons.length;
        return $scope.icons[index % totalNoOfIcons];
    }
    $scope.getAnotherColor = function(index) {
         $scope.colors = ['blue-grey-bg white-fg','blue-bg white-fg','green-bg white-fg',  'orange-bg white-fg','red-bg white-fg'];
        var totalNoOfColors = $scope.colors.length;
        return $scope.colors[index % totalNoOfColors];
    }
     $scope.Mmcsearch = function(ev, gldata, modeldata) {
      requestCtrl.datagl = gldata
      requestCtrl.datamodel = modeldata
      $mdDialog.show({
       controller: searchMMCDialogCtrl,
       templateUrl: 'app/main/Requests/Mmcdialog.html',
       targetEvent: ev,
       clickOutsideToClose: true,
       fullscreen: $scope.customFullscreen,
      })
     }
     function searchMMCDialogCtrl($scope, $mdDialog, RestAPIService) {
      $scope.Mmcsearch = {};
      $scope.pageNumber = 0;
     // $scope.page = 100;
      $scope.size = 100;
      RestAPIService.getAccountInstance(requestCtrl.datagl).then(
       function(response) {
        $scope.groupList = response.data[0];
       },
       function(error) {
        RestAPIService.showErrorDialog(error);
       });
      $scope.cancel = function() {
       $mdDialog.cancel();
      };
      $scope.searchGLValues = function(search) {
       RestAPIService.getDyamicDataBySearch(requestCtrl.datagl, search, $scope.pageNumber, $scope.size).then(
        function(success) {
         $scope.searchResult = success.data;

        // console.log(success.data)
         $scope.totalRecords = success.headers('x-total-count');
         $scope.pages = $scope.totalRecords / $scope.size;
         var index = $scope.pages.toString().indexOf('.');
         var x = $scope.pages.toString().substring(0, index);
         $scope.totalPages = parseInt(x) + 1;
        },
        function(error) {
         RestAPIService.showErrorDialog(error);
        });
       $scope.next = function() {
        $scope.pageNumber = $scope.pageNumber + 1;
        RestAPIService.getDyamicDataBySearch(requestCtrl.datagl, search, $scope.pageNumber, $scope.size).then(
         function(success) {
          $scope.searchResult = success.data;
         },
         function(error) {
          RestAPIService.showErrorDialog(error);
         });
       }
       $scope.previous = function() {
        $scope.pageNumber = $scope.pageNumber - 1;
        RestAPIService.getDyamicDataBySearch(requestCtrl.datagl, search, $scope.pageNumber, $scope.size).then(
         function(success) {
          $scope.searchResult = success.data;
         },
         function(error) {
          RestAPIService.showErrorDialog(error);
         });
       }
       $scope.searchResultRowClick = function(value) {
        requestCtrl.searchData = value;
        requestCtrl.setheaderdata(value[requestCtrl.datamodel]);
        $mdDialog.cancel();
       };
      }
     }
// back revert//

$scope.goToRequests  = function(ev) {
    $mdDialog.show({
     controller: AlkemAlertdialogcontrollerCtrl,
     targetEvent: ev,
     templateUrl: 'app/main/Requests/AlkemAlert.dialog.html'
    });
   }
   function AlkemAlertdialogcontrollerCtrl($scope, $mdDialog) {
    $scope.goToBAckRequests = function(goToBAckRequests){
        $state.go('app.requests');
        $mdDialog.hide(goToBAckRequests);
    }
    $scope.cancel = function() {
     $mdDialog.cancel();
    };
   }

//endcode//
     $scope.header.AFNAM = $scope.RequestedBy;
     $scope.currencies = ["INR", "USD", "EUR", "PLN"];
     $scope.docTypes = ["EX-1", "Ex-2", "Ex-3"];
     $scope.invoiceTypes = ["NPO"];
     requestCtrl.lineItems = [{}];
     var name = $rootScope.currentLogedInUser;
     requestCtrl.setheaderdata = function(value) {
      $scope.header[requestCtrl.datamodel] = value;
      if($scope.header['MTART']=='UNBW'){
        $scope.header['BATCH_MANGMENT']=true;
        $scope.header['XCHPF'] =true;
    }
    if($scope.header['MTART']=='HAWA'||$scope.header['MTART']=='ZSAH'){
        $scope.header['UEETO']='10';
    }
    if($scope.header['MTART']=='ZENV'||$scope.header['MTART']=='ZEPM'){
          $scope.header['BKLAS']='3050';
    }
    if($scope.header['MTART']=='ZERC'){
        $scope.header['BKLAS']='3000';
    }
    if($scope.header['MTART']=='ZECO'||$scope.header['MTART']=='ZEFR'){
    $scope.header['BKLAS']='7920';
    }
    if($scope.header['MTART']=='ZERM'){
        $scope.header['BKLAS']='3000';
    }
    if($scope.header['MTART']=='ZESF'){
        $scope.header['BKLAS']='7900';
    }
    if($scope.header['MTART']=='ZETP'){
        $scope.header['BKLAS']='3100';
    }
     }
     RestAPIService.getAllCodingTemplates($stateParams.name, $scope.pageNumber, $scope.size).then(
      function(success) {
       requestCtrl.AllcodingTemplates = success.data;
       $scope.totalRecords = success.headers('x-total-count');
       $scope.pages = $scope.totalRecords / $scope.size;
       var index = $scope.pages.toString().indexOf('.');
       var x = $scope.pages.toString().substring(0, index);
       $scope.totalPages = parseInt(x) + 1;
      },
      function(error) {
       RestAPIService.showErrorDialog(error);
      });
     if (!FinalLineItems) {
      var FinalLineItems = [];
     }
     if (!UpdatedLinItems) {
      var UpdatedLinItems = [];
     }
     $scope.searchCodingTemplates = function(ev, index) {
      $mdDialog.show({
       controllerAs: 'searchCodingTemplateDialogCtrl',
       controller: searchCodingTemplateDialogCtrl,
       preserveScope: true,
       autoWrap: true,
       templateUrl: 'app/main/Requests/coadingTemplates.html'
      });
     }
     function searchCodingTemplateDialogCtrl($scope, $mdDialog, RestAPIService) {
      $scope.searchResult = requestCtrl.AllcodingTemplates;
      $scope.searchResultRowClick = function(orderData) {
       angular.forEach(orderData.lineItems, function(key, value) {
        if (key.WRBTR) {
         key.WRBTR = parseInt(key.WRBTR);
        }
        UpdatedLinItems.push(key);
       })
       if (UpdatedLinItems.length > 0) {
        var codingtemplates = UpdatedLinItems;
        requestCtrl.setCodingtemplates(codingtemplates);
       } }
      $scope.cancel = function() {
       $mdDialog.cancel();
      };
     }
     requestCtrl.setCodingtemplates = function(FinallineItems) {
      requestCtrl.lineItems = FinallineItems;
      $mdDialog.cancel();
     }
     $scope.SubLineItems = function(index) {
      requestCtrl.sublineItemIndex = index;
      $mdDialog.show({
       controllerAs: 'MoreDetailsDialogCtrl',
       controller: MoreDetailsDialogCtrl,
       preserveScope: true,
       autoWrap: true,
       templateUrl: 'app/main/Requests/MoreDetails.html'
      });
      function MoreDetailsDialogCtrl($scope, RestAPIService, $mdDialog) {
       if (requestCtrl.lineItems[requestCtrl.sublineItemIndex].subLineItems) {
        $scope.SUBLINEITEMS = requestCtrl.lineItems[requestCtrl.sublineItemIndex].subLineItems;
       } else {
        requestCtrl.lineItems[requestCtrl.sublineItemIndex].subLineItems = [{}]
        $scope.SUBLINEITEMS = requestCtrl.lineItems[requestCtrl.sublineItemIndex].subLineItems;
       }
       $scope.SubLineItemTotal = function(price, Quantity, index) {
        if (Quantity == undefined || Quantity == null || price == undefined || price == null) {
         $scope.SUBLINEITEMS[index].NETWR = 0;
         return;
        }
        $scope.SUBLINEITEMS[index].NETWR = parseFloat(Quantity) * parseFloat(price);
        parseFloat($scope.SUBLINEITEMS[index].NETWR.toFixed(2));
        $scope.AllsublineItemsTotal();
       }
       $scope.AllsublineItemsTotal = function() {
        $scope.total = 0;
        for (var i = 0; i < $scope.SUBLINEITEMS.length; i++) {
         $scope.total += Number($scope.SUBLINEITEMS[i].NETWR);
        }
        return $scope.total;
       }
       if ($scope.SUBLINEITEMS) {
        $scope.AllsublineItemsTotal()
       }
       $scope.cancel = function() {
        $mdDialog.cancel();
       };
       $scope.addSubLineItem = function(i) {
        requestCtrl.lineItems[requestCtrl.sublineItemIndex].subLineItems.push({});
       }
       $scope.removeSubLineItem = function(index) {
        requestCtrl.lineItems[requestCtrl.sublineItemIndex].subLineItems.splice(index, 1);
        $scope.AllsublineItemsTotal();

       }
       $scope.saveSubLineItems = function(total) {
        requestCtrl.lineItems[requestCtrl.sublineItemIndex].GSWRT = total;
        $mdDialog.cancel();
        if (total) {
         requestCtrl.lineItems[requestCtrl.sublineItemIndex].MENGE = 1;
         requestCtrl.lineItems[requestCtrl.sublineItemIndex].UNT_PRICE = total;
             }
          }
      }
  }
     $scope.isUpdatable = true;
     $scope.toggle = [];
     $scope.arrow = [];
     $scope.toggleFilter = function(inx) {
        $scope.arrow[inx]=$scope.arrow[inx] === true ? false :true;
    $scope.toggle[inx] = $scope.toggle[inx] === true ? false : true;
    };
     function getCategory() {
      RestAPIService.getCategory().then(
       function(success) {
        $scope.Categories = success.data;
       },
       function(error) {
        RestAPIService.showErrorDialog(error);
       });
     }
     function getAccountAssCategory() {
      RestAPIService.getAccountAssCategory().then(
       function(success) {
        $scope.AccountCategories = success.data;
       },
       function(error) {
        RestAPIService.showErrorDialog(error);
       });
     }
     $scope.AccountAssignCategory = function(number) {
      $scope.oredrrequired = true;
      $scope.Assetrequired = false;
      $scope.costrequired = true;
      $scope.wbsrequired = false;

      if (number == 'A' || number == 'H') {
       $scope.oredrrequired = false;
      }
      if (number == 'A') {
       $scope.Assetrequired = true;
      }
      if (number == 'A' || number == 'I') {
       $scope.costrequired = false;
      }
      if (number == '1') {
       $scope.wbsrequired = true;
      }
     }
     $scope.searchMaterialGroup =function(ev,index){
        requestCtrl.selectedIndex = index;
        $mdDialog.show({
            controllerAs: 'searchMaterialGroupDialogCtrl',
            controller: searchMaterialGroupDialogCtrl,
            preserveScope: true,
            autoWrap: true,
            templateUrl: 'app/main/Requests/Material_groupDialog.html'
        });
    }
    function searchMaterialGroupDialogCtrl($scope, RestAPIService, $mdDialog) {
        $scope.searchAssetCode ={};
        $scope.pageNumber = 0;
        $scope.page =100;
        $scope.size=100;
        $scope.cancel = function() {
            $mdDialog.cancel();
        };
        $scope.searchMaterialGroup =function(search){
            RestAPIService.getMaterialgroupDataBySearch(search,$scope.pageNumber, $scope.size).then(
                function(success) {
                  $scope.searchResult =success.data;
                  $scope.totalRecords = success.headers('x-total-count');
                  $scope.pages = $scope.totalRecords/$scope.size;
                  var index= $scope.pages.toString().indexOf('.');
                      var x= $scope.pages.toString().substring(0,index);
                      $scope.totalPages = parseInt(x)+1;
                },
                function(error) {
                    RestAPIService.showErrorDialog(error);
                });
                $scope.searchResultRowClick = function(orderData) {
                    requestCtrl.searchData =orderData;
                   requestCtrl.setMaterialGroup(orderData);
                    $mdDialog.cancel();
                };
                $scope.next = function(){
                    $scope.pageNumber = $scope.pageNumber + 1;
                    RestAPIService.getMaterialgroupDataBySearch(search,$scope.pageNumber, $scope.size).then(
                        function(success) {
                            $scope.searchResult = success.data;
                        },
                        function(error) {
                            RestAPIService.showErrorDialog(error);
                        });
                }
                $scope.previous = function(){
                    $scope.pageNumber = $scope.pageNumber - 1;
                    RestAPIService.getMaterialgroupDataBySearch(search,$scope.pageNumber, $scope.size).then(
                        function(success) {
                            $scope.searchResult = success.data;
                        },
                        function(error) {
                            RestAPIService.showErrorDialog(error);
                        });
                }
        }
    }

    $scope.searchPurchaseOrder = function(ev, index) {
        requestCtrl.selectedIndex = index;
            $mdDialog.show({
                controllerAs: 'searchPurchaseOrderDialogCtrl',
                controller: SearchPurchaseOrderController,
                preserveScope: true,
                autoWrap: true,
                templateUrl: 'app/main/Requests/searchDataDialog.html'
            });
        };
     function SearchPurchaseOrderController($scope, RestAPIService, $mdDialog) {
            $scope.SearchObject ={};
            $scope.pageNumber = 0;
            $scope.page =100;
            $scope.size=100;
            $scope.cancel = function() {
                $mdDialog.cancel();
            };
            $scope.materialTypes =MaterialTypes.data;
            $scope.searchValues = function(search) {
                $scope.pageNumber = 0;
                if(search == null || search ==undefined){
                    var search ={};
                    search['_id']='';
                }
              $scope.SearchObject =search;
                RestAPIService.getLisBySearch(search,$scope.pageNumber, $scope.size).then(
                    function(success) {
                        $scope.searchResult = success.data;
                        $scope.totalRecords = success.headers('x-total-count');
                        $scope.pages = $scope.totalRecords/$scope.size;
                        var index= $scope.pages.toString().indexOf('.');
                            var x= $scope.pages.toString().substring(0,index);
                            $scope.totalPages = parseInt(x)+1;
                    },
                    function(error) {
                        RestAPIService.showErrorDialog(error);
                    });

                    $scope.next = function(){
                        $scope.pageNumber = $scope.pageNumber + 1;
                        RestAPIService.getLisBySearch($scope.SearchObject,$scope.pageNumber, $scope.size).then(
                            function(success) {
                                $scope.searchResult = success.data;
                            },
                            function(error) {
                                RestAPIService.showErrorDialog(error);
                            });
                    }
                    $scope.previous = function(){
                        $scope.pageNumber = $scope.pageNumber - 1;
                        RestAPIService.getLisBySearch($scope.SearchObject,$scope.pageNumber, $scope.size).then(
                            function(success) {
                                $scope.searchResult = success.data;
                            },
                            function(error) {
                                RestAPIService.showErrorDialog(error);
                            });
                    }
                    $scope.searchResultRowClick = function(orderData) {
                        requestCtrl.searchData =orderData;
                       requestCtrl.setLineItemFields(orderData);
                        $mdDialog.cancel();
                    };
            };
        }
        $scope.searchUOM =function(ev,index){
            requestCtrl.selectedIndex = index;
            $mdDialog.show({
                controllerAs: 'searchUOMDialogCtrl',
                controller: searchUOMDialogCtrl,
                preserveScope: true,
                autoWrap: true,
                templateUrl: 'app/main/Requests/uomdialog.html'
            });
        }
        function searchUOMDialogCtrl($scope, RestAPIService, $mdDialog) {
            $scope.searchAssetCode ={};
            $scope.pageNumber = 0;
            $scope.page =100;
            $scope.size=100;
            $scope.cancel = function() {
                $mdDialog.cancel();
            };
            $scope.searchUOMCode =function(search){
                RestAPIService.getuomDataBySearch(search,$scope.pageNumber, $scope.size).then(
                    function(success) {
                      $scope.searchResult =success.data;
                      $scope.totalRecords = success.headers('x-total-count');
                      $scope.pages = $scope.totalRecords/$scope.size;
                      var index= $scope.pages.toString().indexOf('.');
                          var x= $scope.pages.toString().substring(0,index);
                          $scope.totalPages = parseInt(x)+1;
                    },
                    function(error) {
                        RestAPIService.showErrorDialog(error);
                    });
                    $scope.searchResultRowClick = function(orderData) {
                        requestCtrl.searchData =orderData;
                       requestCtrl.setUMOCode(orderData);

                        $mdDialog.cancel();
                    };
                    $scope.next = function(){
                        $scope.pageNumber = $scope.pageNumber + 1;
                        RestAPIService.getuomDataBySearch(search,$scope.pageNumber, $scope.size).then(
                            function(success) {
                                $scope.searchResult = success.data;
                            },
                            function(error) {
                                RestAPIService.showErrorDialog(error);
                            });
                    }
                    $scope.previous = function(){
                        $scope.pageNumber = $scope.pageNumber - 1;
                        RestAPIService.getuomDataBySearch(search,$scope.pageNumber, $scope.size).then(
                            function(success) {
                                $scope.searchResult = success.data;
                            },
                            function(error) {
                                RestAPIService.showErrorDialog(error);
                            });

                    }
            }
        }
        //companycode
        $scope.CompanyCode =function(ev,index){
            requestCtrl.selectedIndex = index;
            $mdDialog.show({
                controllerAs: 'searchcompanyCodeDialogCtrl',
                controller: searchcompanyCodeDialogCtrl,
                preserveScope: true,
                autoWrap: true,
                templateUrl: 'app/main/Requests/companyCode-dialog.html'
            });
        }
        function searchcompanyCodeDialogCtrl($scope, RestAPIService, $mdDialog) {
            $scope.searchAssetCode ={};
            $scope.pageNumber = 0;
            $scope.page =100;
            $scope.size=100;
            $scope.cancel = function() {
                $mdDialog.cancel();
            };
            $scope.searchcompanyCode =function(search){
                RestAPIService.getCompanyataBySearch(search,$scope.pageNumber, $scope.size).then(
                    function(success) {
                      $scope.searchResult =success.data;
                      $scope.totalRecords = success.headers('x-total-count');
                      $scope.pages = $scope.totalRecords/$scope.size;
                      var index= $scope.pages.toString().indexOf('.');
                          var x= $scope.pages.toString().substring(0,index);
                          $scope.totalPages = parseInt(x)+1;
                    },
                    function(error) {
                        RestAPIService.showErrorDialog(error);
                    });
                    $scope.searchResultRowClick = function(orderData) {
                        requestCtrl.searchData =orderData;
                       requestCtrl.setCompanyCode(orderData);

                        $mdDialog.cancel();
                    };
                    $scope.next = function(){
                        $scope.pageNumber = $scope.pageNumber + 1;
                        RestAPIService.getCompanyataBySearch(search,$scope.pageNumber, $scope.size).then(
                            function(success) {
                                $scope.searchResult = success.data;
                            },
                            function(error) {
                                RestAPIService.showErrorDialog(error);
                            });
                    }
                    $scope.previous = function(){
                        $scope.pageNumber = $scope.pageNumber - 1;
                        RestAPIService.getCompanyataBySearch(search,$scope.pageNumber, $scope.size).then(
                            function(success) {
                                $scope.searchResult = success.data;
                            },
                            function(error) {
                                RestAPIService.showErrorDialog(error);
                            });

                    }
            }
        }
        //endcompanycode
        //vendorcode
        $scope.vendorCode =function(ev,index){
            requestCtrl.selectedIndex = index;
            $mdDialog.show({
                controllerAs: 'searchvendorCodeDialogCtrl',
                controller: searchvendorCodeDialogCtrl,
                preserveScope: true,
                autoWrap: true,
                templateUrl: 'app/main/Requests/vendor-dialog.html'
            });
        }
        function searchvendorCodeDialogCtrl($scope, RestAPIService, $mdDialog) {
            $scope.searchAssetCode ={};
            $scope.pageNumber = 0;
            $scope.page =100;
            $scope.size=100;
            $scope.cancel = function() {
                $mdDialog.cancel();
            };
            $scope.searchcompanyCode =function(search){
                RestAPIService.getvendordataBySearch(search,$scope.pageNumber, $scope.size).then(
                    function(success) {
                      $scope.searchResult =success.data;
                      $scope.totalRecords = success.headers('x-total-count');
                      $scope.pages = $scope.totalRecords/$scope.size;
                      var index= $scope.pages.toString().indexOf('.');
                          var x= $scope.pages.toString().substring(0,index);
                          $scope.totalPages = parseInt(x)+1;
                    },
                    function(error) {
                        RestAPIService.showErrorDialog(error);
                    });
                    $scope.searchResultRowClick = function(orderData) {
                        requestCtrl.searchData =orderData;
                       requestCtrl.setvendorCode(orderData);

                        $mdDialog.cancel();
                    };
                    $scope.next = function(){
                        $scope.pageNumber = $scope.pageNumber + 1;
                        RestAPIService.getvendordataBySearch(search,$scope.pageNumber, $scope.size).then(
                            function(success) {
                                $scope.searchResult = success.data;
                            },
                            function(error) {
                                RestAPIService.showErrorDialog(error);
                            });
                    }
                    $scope.previous = function(){
                        $scope.pageNumber = $scope.pageNumber - 1;
                        RestAPIService.getvendordataBySearch(search,$scope.pageNumber, $scope.size).then(
                            function(success) {
                                $scope.searchResult = success.data;
                            },
                            function(error) {
                                RestAPIService.showErrorDialog(error);
                            });

                    }
            }
        }
        //endvendor
        $scope.searchOrder =function(ev,index){
            requestCtrl.selectedIndex = index;
            $mdDialog.show({
                controllerAs: 'searchOrderDialogCtrl',
                controller: searchOrderDialogCtrl,
                preserveScope: true,
                autoWrap: true,
                templateUrl: 'app/main/Requests/orderdialog.html'
            });
        }
        function searchOrderDialogCtrl($scope, RestAPIService, $mdDialog) {
            $scope.searchAssetCode ={};
            $scope.pageNumber = 0;
            $scope.page =100;
            $scope.size=100;
            $scope.cancel = function() {
                $mdDialog.cancel();
            };
            $scope.searchAssetCode =function(search){
                RestAPIService.getorderDataBySearch(search,$scope.pageNumber, $scope.size).then(
                    function(success) {
                      $scope.searchResult =success.data;
                      $scope.totalRecords = success.headers('x-total-count');
                      $scope.pages = $scope.totalRecords/$scope.size;
                      var index= $scope.pages.toString().indexOf('.');
                          var x= $scope.pages.toString().substring(0,index);
                          $scope.totalPages = parseInt(x)+1;
                    },
                    function(error) {
                        RestAPIService.showErrorDialog(error);
                    });
                    $scope.searchResultRowClick = function(orderData) {
                        requestCtrl.searchData =orderData;
                       requestCtrl.setorderCode(orderData);
                        $mdDialog.cancel();
                    };
                    $scope.next = function(){
                        $scope.pageNumber = $scope.pageNumber + 1;
                        RestAPIService.getorderDataBySearch(search,$scope.pageNumber, $scope.size).then(
                            function(success) {
                                $scope.searchResult = success.data;
                            },
                            function(error) {
                                RestAPIService.showErrorDialog(error);
                            });
                    }
                    $scope.previous = function(){
                        $scope.pageNumber = $scope.pageNumber - 1;
                        RestAPIService.getorderDataBySearch(search,$scope.pageNumber, $scope.size).then(
                            function(success) {
                                $scope.searchResult = success.data;
                            },
                            function(error) {
                                RestAPIService.showErrorDialog(error);
                            });

                    }
            }
        }
        $scope.searchAssetCode =function(ev,index){
            requestCtrl.selectedIndex = index;
            $mdDialog.show({
                controllerAs: 'searchAssetCodeDialogCtrl',
                controller: searchAssetCodeDialogCtrl,
                preserveScope: true,
                autoWrap: true,
                templateUrl: 'app/main/Requests/AssetCodedialog.html'
            });
        }
        function searchAssetCodeDialogCtrl($scope, RestAPIService, $mdDialog) {
            $scope.searchAssetCode ={};
            $scope.pageNumber = 0;
            $scope.page =100;
            $scope.size=100;
            $scope.cancel = function() {
                $mdDialog.cancel();
            };

            $scope.searchAssetCode =function(search){
                RestAPIService.getAssetCodeData(search,$scope.pageNumber, $scope.size).then(
                    function(success) {
                      $scope.searchResult =success.data;
                      $scope.totalRecords = success.headers('x-total-count');
                      $scope.pages = $scope.totalRecords/$scope.size;
                      var index= $scope.pages.toString().indexOf('.');
                          var x= $scope.pages.toString().substring(0,index);
                          $scope.totalPages = parseInt(x)+1;
                    },
                    function(error) {
                        RestAPIService.showErrorDialog(error);
                    });
                    $scope.searchResultRowClick = function(orderData) {
                        requestCtrl.searchData =orderData;
                       requestCtrl.setAssetCode(orderData);

                        $mdDialog.cancel();
                    };
                    $scope.next = function(){
                        $scope.pageNumber = $scope.pageNumber + 1;
                        RestAPIService.getAssetCodeData(search,$scope.pageNumber, $scope.size).then(
                            function(success) {
                                $scope.searchResult = success.data;
                            },
                            function(error) {
                                RestAPIService.showErrorDialog(error);
                            });
                    }
                    $scope.previous = function(){
                        $scope.pageNumber = $scope.pageNumber - 1;
                        RestAPIService.getAssetCodeData(search,$scope.pageNumber, $scope.size).then(
                            function(success) {
                                $scope.searchResult = success.data;
                            },
                            function(error) {
                                RestAPIService.showErrorDialog(error);
                            });

                    }
            }
        }
        $scope.searchFund=function(ev,index){
            requestCtrl.selectedIndex =index;
            $mdDialog.show({
                controllerAs: 'searchFundDialogCtrl',
                controller: searchFundDialogCtrl,
                preserveScope: true,
                autoWrap: true,
                templateUrl: 'app/main/Requests/FundDialog.html'
            });

        }
        function searchFundDialogCtrl($scope, RestAPIService, $mdDialog) {
            $scope.pageNumber = 0;
            $scope.page =100;
            $scope.size=100;
            $scope.cancel = function() {
                $mdDialog.cancel();
            };
            $scope.searchFund =function(search){
              RestAPIService.getFundDataBySearch(search,$scope.pageNumber, $scope.size).then(
                    function(success) {
                        $scope.searchResult = success.data;
                        $scope.totalRecords = success.headers('x-total-count');
                        $scope.pages = $scope.totalRecords/$scope.size;
                        var index= $scope.pages.toString().indexOf('.');
                            var x= $scope.pages.toString().substring(0,index);
                            $scope.totalPages = parseInt(x)+1;
                    },
                    function(error) {
                        RestAPIService.showErrorDialog(error);
                    });

                    $scope.next = function(){
                        $scope.pageNumber = $scope.pageNumber + 1;
                        RestAPIService.getFundDataBySearch(search,$scope.pageNumber, $scope.size).then(
                            function(success) {
                                $scope.searchResult = success.data;
                            },
                            function(error) {
                                RestAPIService.showErrorDialog(error);
                            });
                    }
                    $scope.previous = function(){
                        $scope.pageNumber = $scope.pageNumber - 1;
                        RestAPIService.getFundDataBySearch(search,$scope.pageNumber, $scope.size).then(
                            function(success) {
                                $scope.searchResult = success.data;
                            },
                            function(error) {
                                RestAPIService.showErrorDialog(error);
                            });

                    }
                    $scope.searchResultRowClick = function(order) {
                       // $scope.searchData =order;
                        $scope.header= searchData;
                       requestCtrl.setFund(order);

                        $mdDialog.cancel();
                    };
                }
        }


        $scope.searchGLAccount =function(ev,index){
            // requestCtrl.selectedIndex = index;
             requestCtrl.selectedIndex =index;
             $mdDialog.show({
                 controllerAs: 'searchGLAccountDialogCtrl',
                 controller: searchGLAccountDialogCtrl,
                 preserveScope: true,
                 autoWrap: true,
                 templateUrl: 'app/main/Requests/glAccountdialog.html'
             });
         }
         function searchGLAccountDialogCtrl($scope, RestAPIService, $mdDialog) {
             $scope.searchGlAccount ={};
             $scope.pageNumber = 0;
             $scope.page =100;
             $scope.size=100;
             $scope.cancel = function() {
                 $mdDialog.cancel();
             };
             $scope.searchGLValues =function(search){
               RestAPIService.getGLDataBySearch(search,$scope.pageNumber, $scope.size).then(
                     function(success) {
                         $scope.searchResult = success.data;
                         $scope.totalRecords = success.headers('x-total-count');
                         $scope.pages = $scope.totalRecords/$scope.size;
                         var index= $scope.pages.toString().indexOf('.');
                             var x= $scope.pages.toString().substring(0,index);
                             $scope.totalPages = parseInt(x)+1;
                     },
                     function(error) {
                         RestAPIService.showErrorDialog(error);
                     });

                     $scope.next = function(){
                         $scope.pageNumber = $scope.pageNumber + 1;
                         RestAPIService.getGLDataBySearch(search,$scope.pageNumber, $scope.size).then(
                             function(success) {
                                 $scope.searchResult = success.data;
                             },
                             function(error) {
                                 RestAPIService.showErrorDialog(error);
                             });
                     }
                     $scope.previous = function(){
                         $scope.pageNumber = $scope.pageNumber - 1;
                         RestAPIService.getGLDataBySearch(search,$scope.pageNumber, $scope.size).then(
                             function(success) {
                                 $scope.searchResult = success.data;
                             },
                             function(error) {
                                 RestAPIService.showErrorDialog(error);
                             });

                     }
                     $scope.searchResultRowClick = function(order) {
                         requestCtrl.searchData =order;
                        requestCtrl.setGLAccount(order);

                         $mdDialog.cancel();
                     };
                 }
         }

         $scope.searchpoNumber =function(ev){
         //    requestCtrl.selectedIndex =index;
             $mdDialog.show({
                 controller:searchpoNumberDialogCtrl,
                 preserveScope: true,
                 autoWrap: true,
                 templateUrl: 'app/main/Requests/poNumberdialog.html'
             });
         }
         function searchpoNumberDialogCtrl($scope, RestAPIService) {
             $scope.searchpoNumber ={};
             $scope.pageNumber = 0;
             $scope.size=100;
             $scope.cancel = function() {
                 $mdDialog.cancel();
             };
             $scope.searchPOValues =function(search){
               RestAPIService.getPODataBySearch(search,$scope.pageNumber, $scope.size).then(
                     function(success) {
                         $scope.searchResult = success.data;
                         console.log($scope.searchResult);
                         $scope.totalRecords = success.headers('x-total-count');
                         $scope.pages = $scope.totalRecords/$scope.size;
                             $scope.totalPages = parseInt($scope.pages)+1;
                     },
                     function(error) {
                         RestAPIService.showErrorDialog(error);
                     });

                     $scope.next = function(){
                         $scope.pageNumber = $scope.pageNumber + 1;
                         RestAPIService.getPODataBySearch(search,$scope.pageNumber, $scope.size).then(
                             function(success) {
                                 $scope.searchResult = success.data;
                             },
                             function(error) {
                                 RestAPIService.showErrorDialog(error);
                             });
                     }
                     $scope.previous = function(){
                         $scope.pageNumber = $scope.pageNumber - 1;
                         RestAPIService.getPODataBySearch(search,$scope.pageNumber, $scope.size).then(
                             function(success) {
                                 $scope.searchResult = success.data;
                             },
                             function(error) {
                                 RestAPIService.showErrorDialog(error);
                             });

                     }

                   

                     $scope.searchResultRowClick = function(order) {
                         $scope.searchdata = order;

                         $scope.header = {};
                         var headers={};
                    //     console.log( $scope.searchdata.EBELN);
                    //    // $scope.header.EBELN=$scope.searchdata.EBELN;
                        headers['EBELN']=$scope.searchdata.EBELN;
                        headers['ZUMSK']="A";
                        headers['GROSS_AMT']=$scope.searchdata.GROSS_AMT;
                        headers['NAME1']=$scope.searchdata.NAME1;
                        headers['LIFNR']=$scope.searchdata.LIFNR;
                        headers['NAME1']=$scope.searchdata.NAME1;
                        headers['BUKRS']=$scope.searchdata.BUKRS;
                        headers['INV_CAT_DES']=$scope.searchdata.INV_CAT_DES;
                        headers['INVOICE_CAT']=$scope.searchdata.INVOICE_CAT;
                        headers['BUTXT']=$scope.searchdata.BUTXT;
                        headers['WAERS']=$scope.searchdata.WAERS;
                        headers['WRBTR'] ="";
                        headers['XBLNR'] ="";
                        headers['BKTXT']="";
                        headers['ADV_INV_TYPE']="PO";
                     
                          //   $scope.header.push(headers);

                        // $scope.header =order;
                        //requestCtrl.setGLAccount(order);
                          // $scope.cancel();
                          $scope.header = headers;

                         requestCtrl.poHeaderData(headers);

                          console.log($scope.header);
                          console.log(headers);
                         $mdDialog.cancel();

                     };


                 }
         }

         requestCtrl.poHeaderData=function(headerdata)
         {
                       $scope.header = headerdata;
                         //var headers={};
                        
         }

         $scope.searchFunctionalArea =function(ev,index){
            // requestCtrl.selectedIndex = index;
             requestCtrl.selectedIndex =index;
             $mdDialog.show({
                 controllerAs: 'searchFunctionalAreaDialogCtrl',
                 controller: searchFunctionalAreaDialogCtrl,
                 preserveScope: true,
                 autoWrap: true,
                 templateUrl: 'app/main/Requests/FunctionalAreaDialog.html'
             });
         }
         function searchFunctionalAreaDialogCtrl($scope, RestAPIService, $mdDialog) {
             $scope.searchGlAccount ={};
             $scope.pageNumber = 0;
             $scope.page =100;
             $scope.size=100;
             $scope.cancel = function() {
                 $mdDialog.cancel();
             };
             $scope.searchFuncationlArea =function(search){
               RestAPIService.getFuncationalDataBySearch(search,$scope.pageNumber, $scope.size).then(
                     function(success) {
                         $scope.searchResult = success.data;
                         $scope.totalRecords = success.headers('x-total-count');
                         $scope.pages = $scope.totalRecords/$scope.size;
                         var index= $scope.pages.toString().indexOf('.');
                             var x= $scope.pages.toString().substring(0,index);
                             $scope.totalPages = parseInt(x)+1;
                     },
                     function(error) {
                         RestAPIService.showErrorDialog(error);
                     });

                     $scope.next = function(){
                         $scope.pageNumber = $scope.pageNumber + 1;
                         RestAPIService.getFuncationalDataBySearch(search,$scope.pageNumber, $scope.size).then(
                             function(success) {
                                 $scope.searchResult = success.data;
                             },
                             function(error) {
                                 RestAPIService.showErrorDialog(error);
                             });
                     }
                     $scope.previous = function(){
                         $scope.pageNumber = $scope.pageNumber - 1;
                         RestAPIService.getFuncationalDataBySearch(search,$scope.pageNumber, $scope.size).then(
                             function(success) {
                                 $scope.searchResult = success.data;
                             },
                             function(error) {
                                 RestAPIService.showErrorDialog(error);
                             });

                     }
                     $scope.searchResultRowClick = function(order) {
                         requestCtrl.searchData =order;
                        requestCtrl.setFunctionalArea(order);

                         $mdDialog.cancel();
                     };
                 }
         }

         $scope.searchWBSElement =function(ev,index){
            // requestCtrl.selectedIndex = index;
             requestCtrl.selectedIndex =index;
             $mdDialog.show({
                 controllerAs: 'searchWBSDialogCtrl',
                 controller: searchWBSDialogCtrl,
                 preserveScope: true,
                 autoWrap: true,
                 templateUrl: 'app/main/Requests/WBS_elementdialog.html'
             });
         }
         function searchWBSDialogCtrl($scope, RestAPIService, $mdDialog) {
             $scope.searchGlAccount ={};
             $scope.pageNumber = 0;
             $scope.page =100;
             $scope.size=100;
             $scope.cancel = function() {
                 $mdDialog.cancel();
             };
             $scope.searchWBSelement =function(search){
               RestAPIService.getWBSDataBySearch(search,$scope.pageNumber, $scope.size).then(
                     function(success) {
                         $scope.searchResult = success.data;
                         $scope.totalRecords = success.headers('x-total-count');
                         $scope.pages = $scope.totalRecords/$scope.size;
                         var index= $scope.pages.toString().indexOf('.');
                             var x= $scope.pages.toString().substring(0,index);
                             $scope.totalPages = parseInt(x)+1;
                     },
                     function(error) {
                         RestAPIService.showErrorDialog(error);
                     });

                     $scope.next = function(){
                         $scope.pageNumber = $scope.pageNumber + 1;
                         RestAPIService.getWBSDataBySearch(search,$scope.pageNumber, $scope.size).then(
                             function(success) {
                                 $scope.searchResult = success.data;
                             },
                             function(error) {
                                 RestAPIService.showErrorDialog(error);
                             });
                     }
                     $scope.previous = function(){
                         $scope.pageNumber = $scope.pageNumber - 1;
                         RestAPIService.getWBSDataBySearch(search,$scope.pageNumber, $scope.size).then(
                             function(success) {
                                 $scope.searchResult = success.data;
                             },
                             function(error) {
                                 RestAPIService.showErrorDialog(error);
                             });

                     }
                     $scope.searchResultRowClick = function(order) {
                         requestCtrl.searchData =order;
                        requestCtrl.setWBSelement(order);

                         $mdDialog.cancel();
                     };
                 }
         }
         $scope.searchCostCenter =function(ev,index){
            requestCtrl.selectedIndex = index;
            $mdDialog.show({
                controllerAs: 'searchCostCenterDialogCtrl',
                controller: searchCostCenterDialogCtrl,
                preserveScope: true,
                autoWrap: true,
                templateUrl: 'app/main/Requests/costcenterdialog.html'
            });
        }
        function searchCostCenterDialogCtrl($scope, RestAPIService, $mdDialog) {
            $scope.searchAssetCode ={};
            $scope.pageNumber = 0;
            $scope.page =100;
            $scope.size=100;
            $scope.cancel = function() {
                $mdDialog.cancel();
            };

            $scope.searchCostCenter =function(search){
                RestAPIService.getCostCenterData(search,$scope.pageNumber, $scope.size).then(
                    function(success) {
                      $scope.searchResult =success.data;
                      $scope.totalRecords = success.headers('x-total-count');
                      $scope.pages = $scope.totalRecords/$scope.size;
                      var index= $scope.pages.toString().indexOf('.');
                          var x= $scope.pages.toString().substring(0,index);
                          $scope.totalPages = parseInt(x)+1;
                    },
                    function(error) {
                        RestAPIService.showErrorDialog(error);
                    });
                    $scope.searchResultRowClick = function(orderData) {
                        requestCtrl.searchData =orderData;
                       requestCtrl.setCostCenter(orderData);

                        $mdDialog.cancel();
                    };
                    $scope.next = function(){
                        $scope.pageNumber = $scope.pageNumber + 1;
                        RestAPIService.getCostCenterData(search,$scope.pageNumber, $scope.size).then(
                            function(success) {
                                $scope.searchResult = success.data;
                            },
                            function(error) {
                                RestAPIService.showErrorDialog(error);
                            });
                    }
                    $scope.previous = function(){
                        $scope.pageNumber = $scope.pageNumber - 1;
                        RestAPIService.getCostCenterData(search,$scope.pageNumber, $scope.size).then(
                            function(success) {
                                $scope.searchResult = success.data;
                            },
                            function(error) {
                                RestAPIService.showErrorDialog(error);
                            });

                    }
            }
        }
        $scope.myFunct =function(keyEvent,index,value){
            if (keyEvent.which === 13){
                if(value != null || value !=undefined){
                    var search ={};
                    search['_id']=value;
                }
                requestCtrl.selectedIndex =index;
                RestAPIService.getLisBySearch(search,$scope.pageNumber, $scope.size).then(
                    function(success) {
                        $scope.searchResult = success.data;
                        if($scope.searchResult.length == 1){
                            requestCtrl.setLineItemFields($scope.searchResult[0]);
                            }

                    },
                    function(error) {
                       $scope.errorMsg =true;
                    });
          }
        }

        requestCtrl.PlantDetails =function(plantDetails){
            requestCtrl.setMoveprice(plantDetails);
          }
          requestCtrl.setMoveprice =function(Details){
              angular.forEach($scope.Plantdetails,function(key,value){
                  if(key.plant == Details){
                    requestCtrl.lineItems[requestCtrl.selectedIndex].PREIS = key.movPrice;
                    requestCtrl.lineItems[requestCtrl.selectedIndex].HSN_CODE =key.hsnCode;
                  }
              })
            }
            $scope.Total =function(price,Quantity,index){
                if(Quantity == undefined || Quantity ==null || price == undefined || price == null){
                    requestCtrl.lineItems[index].GSWRT = 0;
                    return;
                }
                requestCtrl.lineItems[index].GSWRT = parseFloat(Quantity) * parseFloat(price);
                parseFloat( requestCtrl.lineItems[index].GSWRT).toFixed(2);
              }
              requestCtrl.setvendorCode=function(data){
                $scope.header.LIFNR =data.LIFNR;
                $scope.header.NAME1 =data.NAME1;
            }
              requestCtrl.setCompanyCode=function(data){
                $scope.header.BUKRS =data.BUKRS;
                $scope.header.BUTXT =data.BUTXT;
            }
              requestCtrl.setGLAccount =function(data){
                requestCtrl.lineItems[requestCtrl.selectedIndex].SAKNR =data.SAKNR;
            }
            requestCtrl.setAssetCode =function(data){
                requestCtrl.lineItems[requestCtrl.selectedIndex].ANLN1 =data.ANLN1;
            }
            requestCtrl.setCostCenter=function(data){
                requestCtrl.lineItems[requestCtrl.selectedIndex].KOSTL =data.KOSTL;
            }
            requestCtrl.setFund =function(data){
                requestCtrl.lineItems[requestCtrl.selectedIndex].GEBER =data.FINCODE;

            }
            requestCtrl.setWBSelement =function(data){
                requestCtrl.lineItems[requestCtrl.selectedIndex].WBS_ELEMENT =data.PSPNR;
            }
            requestCtrl.setFunctionalArea =function(data){
                requestCtrl.lineItems[requestCtrl.selectedIndex].FKBER =data.FKBER;
            }
            requestCtrl.setorderCode =function(data){
                requestCtrl.lineItems[requestCtrl.selectedIndex].ORDER_NO =data.AUFNR;
            }
            requestCtrl.setUMOCode =function(data){
                requestCtrl.lineItems[requestCtrl.selectedIndex].MEINS =data.MSEHI;
            }
          
            requestCtrl.setMaterialGroup =function(data){
                requestCtrl.lineItems[requestCtrl.selectedIndex].MATKL =data.MATKL;
                requestCtrl.lineItems[requestCtrl.selectedIndex].TXZ01 =data.WGBEZ;
            }
            requestCtrl.setLineItemFields = function(data){
                $scope.Plantdetails =data.plantDetails;
                requestCtrl.lineItems[requestCtrl.selectedIndex].MATNR = data.materailCode;
                requestCtrl.lineItems[requestCtrl.selectedIndex].TXZ01=data.materialGroupDescription;
                requestCtrl.lineItems[requestCtrl.selectedIndex].MATKL=data.materailGroup;
                 requestCtrl.lineItems[requestCtrl.selectedIndex].MEINS=data.umo;
                requestCtrl.lineItems[requestCtrl.selectedIndex].BISMT=data.oldMaterailCode;
                requestCtrl.lineItems[requestCtrl.selectedIndex].MAKTX=data.materialDescription;
              }
             $scope.addLineItem = function() {
                requestCtrl.lineItems.push({});
            }
            // $scope.goToRequests = function(){
            //     $state.go('app.requests');
            // }
            $scope.name = $stateParams.name;
            if($scope.name == null || $scope.name == undefined){
                $state.go('app.requests');
            }
            $scope.removeLineItem = function(index) {
                requestCtrl.lineItems.splice(index, 1);
            }

            // requestCtrl.goToRequests = function() {
            //     $state.go('app.requests');
            // }

            $scope.selectDoctype = function(doc) {
                $state.go('app.requests.content',{'docType':doc.id,'reqId': doc.formId,'name':doc.name});
            }
         $scope.attachmentfiles = [];
         $scope.setAttachmentFile = function(element) {
            var formData = new FormData();
            $scope.$apply(function() {
                for (var i = 0; i < element.files.length; i++) {
                    formData.append('file', element.files[i]);
                    $scope.attachmentfiles.push(element.files[i]);
                }
            });
        };
        $scope.doInitiateCall =function(){
            if($scope.header.POSTING_DATE != undefined && $scope.header.POSTING_DATE != null){
                $scope.header.POSTING_DATE =requestCtrl.generateSAPDate($scope.header.POSTING_DATE._d);
            }
            if($scope.header.BLDAT != undefined && $scope.header.BLDAT != null){
                $scope.header.BLDAT = CommonUtil.generateSAPDate($scope.header.BLDAT._d);
            }
            if($scope.header.BUDAT != undefined && $scope.header.BUDAT != null){
                $scope.header.BUDAT = CommonUtil.generateSAPDate($scope.header.BUDAT._d);
             }
             if($scope.header.MSEHL){
              $scope.header.MSEHL =$scope.header.MSEHL.replace(/(\r\n|\n|\r)/gm," ");
             }
             if($scope.header.KURZTEXT){
              $scope.header.KURZTEXT =$scope.header.KURZTEXT.replace(/(\r\n|\n|\r)/gm," ");
             }

             if( $scope.header['BATCH_MANGMENT']){
                $scope.header['BATCH_MANGMENT']='X'
             }
             if( $scope.header['XCHPF']){
                $scope.header['XCHPF'] ='X'
             }
            angular.forEach(requestCtrl.lineItems, function (value, key) {
                if(value.MENGE){
                    value.MENGE = value.MENGE.toString();
                }
                if(value.GSWRT){
                    value.GSWRT = value.GSWRT.toString();
                }
                if(value.EEIND){
                    if(typeof value.EEIND == "object"){
                    var d = value.EEIND._d;
                    if(d == undefined || d == null){
                        d=value.EEIND;
                    }
                 } else{
                        var d = new Date(value.EEIND);
                    }
                    $scope.month = parseInt(d.getMonth()+1);
                    $scope.date =parseInt(d.getDate());
                    $scope.month = $scope.month < 10 ? ("00" + $scope.month).slice(-2) : $scope.month;
                    $scope.date = $scope.date < 10 ? ("00" + $scope.date).slice(-2) : $scope.date;
                    value.EEIND = ((d.getFullYear().toString()).concat(($scope.month).toString())).concat(($scope.date).toString());
                }
            })

            var lineItems = {};
            var json = {};
            var FinallineItems =[];
            for (var i=1; i<= requestCtrl.lineItems.length;i++){
                var item ={}
                item['sno']= parseInt(i);
                var finalSubLineItem = {};
                 var subLineItemsArray = requestCtrl.lineItems[i-1].subLineItems;
                 if(subLineItemsArray == undefined || subLineItemsArray == null){
                    subLineItemsArray =[];
                     }
                for(var j=0;j<=  subLineItemsArray.length-1;j++){
                 finalSubLineItem[parseInt(j)+1] = subLineItemsArray[j];
                   }
                delete requestCtrl.lineItems[i-1].subLineItems;
               item['lineItems'] =requestCtrl.lineItems[(i) - 1];

               item['subLineItems'] =finalSubLineItem;
               FinallineItems.push(item);
                }
            json.docType = $stateParams.name;
            json.description = $scope.request.comment;
            json.header = $scope.header;
            json.lineItems = FinallineItems;
             RestAPIService.sendFormData(json, $scope.attachmentfiles,$scope.request).then(
                function(success) {
                   // console.log(success.data);
                    $scope.requestData =success.data;

                    $mdDialog.show(
                              $mdDialog.alert()
                                .parent(angular.element(document.querySelector('#popupContainer')))
                                .clickOutsideToClose(true)
                                .title('Success.')
                                .htmlContent('<h4>Request- ' + $scope.requestData.requestId + ' was created successfully.</h4>')
                                .ariaLabel('Alert Dialog Demo')
                                .ok('Ok')
                            );
                  $state.go('app.requests');
                },
                function(error) {

                    if(error.status == 400){
                        $mdDialog.show(
                            $mdDialog.alert()
                              .parent(angular.element(document.querySelector('#popupContainer')))
                              .clickOutsideToClose(true)
                              .title('Warning')
                              .htmlContent('<h4>'+ error.data.message+'</h4>')
                              .ariaLabel('Alert Dialog Demo')
                              .ok('Ok')
                          );
                    }
                    else{
                        $scope.header = {};
                        $scope.request.comment = "";
                        $scope.attachmentfiles=[];
                        RestAPIService.showErrorDialog(error);
                    }

            });
        }
        console.log('hi')
        $scope.sendFormData = function(){

            // If the request type is DownPayments, 1st please check whether the vendor is active or blocked.
            if($stateParams.name == 'DOWN_PAYMENTS'){
                RestAPIService.getDynamicInstanceDataByMultipleValues('Vendorcodes',['LIFNR','C_CODE'], [$scope.header.LIFNR, $scope.header.BUKRS]).then(function(res){
                    if(res.data.length > 0){
                        if(res.data[0].hasOwnProperty('BLOCK_IND')){
                           if(res.data[0].BLOCK_IND == 'X'){
                                $mdDialog.show(
                                  $mdDialog.alert()
                                    .parent(angular.element(document.querySelector('#popupContainer')))
                                    .clickOutsideToClose(true)
                                    .title('Error.')
                                    .htmlContent('<h4>Vendor has been blocked with this Company. You cannot initiate the Request.</h4>')
                                    .ariaLabel('Alert Dialog Demo')
                                    .ok('Ok')
                                );
                                return;
                            }else{
                                $scope.doInitiateCall();
                            } 
                        }else{
                            $mdDialog.show(
                                  $mdDialog.alert()
                                    .parent(angular.element(document.querySelector('#popupContainer')))
                                    .clickOutsideToClose(true)
                                    .title('Error.')
                                    .htmlContent('<h4>The data received on the combination of the selected Vendor & Company code is not having the BLOCK_IND value. Please re-dispatch from SAP once again.</h4>')
                                    .ariaLabel('Alert Dialog Demo')
                                    .ok('Ok')
                                );
                            return;
                        }
                        
                    }else{
                        $mdDialog.show(
                              $mdDialog.alert()
                                .parent(angular.element(document.querySelector('#popupContainer')))
                                .clickOutsideToClose(true)
                                .title('Error.')
                                .htmlContent('<h4>No data is received with the combination of the selected Vendor & Company from Vendorcodes list maintenance.</h4>')
                                .ariaLabel('Alert Dialog Demo')
                                .ok('Ok')
                            );
                        return;
                    }
                    
                }, function(error){
                    RestAPIService.showErrorDialog(error);
                })
            }else{
                $scope.doInitiateCall();
            }
        }
        function viewForm(data){
            $scope.currentFormName = data.name;
            if(data.content != null){
                 $scope.currentFormHeader = $sce.trustAsHtml(data.content.replace(/&quot;/g,'"'));
            }
            if(data.lineItemContent !=null){
                $scope.currentFormLineitem = $sce.trustAsHtml(data.lineItemContent.replace(/&quot;/g,'"'));
            }
        }
        function getDepartmentlistdata () {
            RestAPIService.getDepartmentlistdata ().then(
             function(success) {
              $scope.departmentLists = success.data;

              console.log($scope.departmentLists)
             },
             function(error) {
              RestAPIService.showErrorDialog(error);
             });
           }

        init();

        function init(){
            getCategory();
            getDepartmentlistdata ();
            getAccountAssCategory();
           RestAPIService.getAllCodingTemplates();
            if($stateParams.reqId != undefined){
                RestAPIService.getRequestFormById($stateParams.reqId).then(
                    function(success) {
                       // console.log(success.data);
                        viewForm(success.data);
                    },
                    function(error) {
                        RestAPIService.showErrorDialog(error);
                });
            }
        }










    }
   })();

(function() {
    'use strict';

    var app = angular
        .module('app.PARreports', [])
        .config(config)
        .run(run);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider, $controllerProvider, $compileProvider, $filterProvider, $provide) {
        app.controller = $controllerProvider.register;
        app.directive = $compileProvider.directive;
        app.filter = $filterProvider.register;
        app.factory = $provide.factory;
        app.service = $provide.service;

        $stateProvider
            .state('app.PARreports', {
            url: '/PARreports',
            views: {
                'content@app': {
                    templateUrl: 'app/main/PARreport/PARreports.html',
                    controller: 'PARreportsController as parrepoCtrl'
                }
            },
            resolve: {
                RestAPIService: 'RestAPIService',
                   Users: function(RestAPIService) {
                       return RestAPIService.getUsers();
                   },
                   Requests: function(RestAPIService) {
                    return RestAPIService.getRequests();
                }
               }
        });

        //   msNavigationServiceProvider.saveItem('reports', {
        //         title: 'Reports',
        //         icon: 'icon-file-document-box',
        //         state: 'app.reports',
        //         weight: 13
        //     });

      
    }

     function run(msNavigationService, $localStorage, $rootScope, $state) {
        // Navigation
         $rootScope.$state = $state;
         msNavigationService.saveItem('PARreports', {
             title: 'PReports',
             icon: 'icon-file-document-box',
             state: 'app.PARreports',            
             weight: 7,
             hidden: function() {             
                if ($rootScope.currentLogedInUser != undefined) {
                    var roles = $rootScope.currentLogedInUser.authorities;
                    var show = $localStorage.menubarsetting.Parreports;
                    if(!show) return  !(show);                   
                    else return (!(roles.indexOf("ROLE_ADMIN") > -1) );                  
                }
                }
         });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.PARreports')
        .controller('PARreportsController', PARreportsController);
        

    /** @ngInject */
    function PARreportsController($scope,RestAPIService,$state,$sce,Requests, $mdDialog, $sessionStorage, Users,$location,$anchorScroll)
    {
    	 var parrepoCtrl = this;
   
         $scope.users = Users.data;
         $scope.requestTypes=Requests.data;    
         $scope.fileName = "report";      
       parrepoCtrl.dtOptions = {
         dom       : '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
      pagingType: 'simple',
      autoWidth : false,
      responsive: true
         } 
         $scope.pageNumber = 0;
       $scope.size =10;
         $scope.sizeNumbers= [10,20,50,100];     
    //       Call for getting Projects & Depts for search concept.    
    
      

      
         $scope.obj ={           
            "requestType":null,
            "creator":null,
            "rangeFrom":null,
            "rangeTo":null,         
            "fromDate":null,          
            "toDate":null,
           "sendToSAP":null,
           "currentUser":null
            
    }
    $scope.Reset =function(){
        $scope.obj ={};
    }
    $scope.lineItems = [];
         $scope.searchforReports = function(data){
         parrepoCtrl.searchData =data;
         if(data.fromDate !=undefined || data.fromDate !=undefined){
         if(data.fromDate || data.toDate){
           if(data.fromDate){
         var d = new Date(data.fromDate);
          d.setHours(d.getHours()+10);
          data.fromDate = d;
           }
           if(data.toDate){
             var d = new Date(data.toDate);
                  d.setHours(d.getHours()+6);
                  d.setMinutes(29);
                  data.toDate = d; 
           }
          
         }
         }    
         
           for(var index in data) {
         if(data[index] == "" || data[index] == undefined){
             data[index] =null;
           }
          }     
          if(data.requestType =="" ||data.requestType ==undefined){
             $mdDialog.show(
                    $mdDialog.alert()
                      .parent(angular.element(document.querySelector('#popupContainer')))
                      .clickOutsideToClose(true)
                      .title('Warning')
                      .textContent('Request Type is Required')
                      .ariaLabel('Alert Dialog')
                      .ok('Got it!')
                      
                  );
           return;
         }    
          if($scope.size == undefined || $scope.size == null){
            $scope.size =10;
          }

          $scope.flowType = "SAP";
      RestAPIService.getAdminReports(data,$scope.pageNumber,$scope.size,$scope.flowType).then(function(responce){
        $scope.pageNumbers = [];
          $scope.allReports = responce.data;  
          $location.hash('scrollToDivID');
              $anchorScroll();
             $scope.totalRecords = responce.headers('x-total-count');
             $scope.totalPages = Math.ceil($scope.totalRecords/$scope.size);             
                 if ($scope.totalPages > 0) {
                     for (var i = 0; i < $scope.totalPages; i++) {
                         $scope.pageNumbers.push(i);
                     }
                 }
                 $scope.temptabledata =$scope.allReports;
                 $scope.exportData =[];
                 $scope.exportData.push(["REQ ID", "REQ Type", "Created By", "Created Date", "Status", "Current User"]);
                 angular.forEach($scope.temptabledata, function(value, key) {
                     if(value.status == '&END'){
                         value.status ="Completed"
                     }
                     else{
                        value.status ="In-progress"
                     }
                     if(value.createdDate){
                         value.createdDate =value.createdDate.substring(0,10);
                     }
                     $scope.exportData.push([value.requestId, value.requestType, value.createdBy,
                        value.createdDate,value.status,value.currentUser
                    ]);
                 })
                 
        $scope.Reset();             
            },function(error){
              RestAPIService.showErrorDialog(error);
            })
         }
          $scope.getListData = function(){
            RestAPIService.getdetaildata('HarnessTypes').then(
                function(success) {
                    $scope.harnessTypes = success.data;
                },
                function(error) {
                    //RestAPIService.showErrorDialog(error);
                }
            );
        }
        
         $scope.getListTypeData = function(){
            RestAPIService.getdetaildata('Types').then(
                function(success) {
                    $scope.typesList = success.data;
                },
                function(error) {
                    //RestAPIService.showErrorDialog(error);
                }
            );
        }

       
         
        $scope.selectReport = function(report){   
     //   alert(JSON.stringify(report));      
        $scope.details =true;
        $scope.report =report;
        $scope.workitemInfo = $scope.report;
        $scope.currentFormHeader = $sce.trustAsHtml($scope.workitemInfo.mainLayout.replace(/&quot;/g,'"'));
        $scope.currentFormLineitem = $sce.trustAsHtml($scope.workitemInfo.detailsLayout.replace(/&quot;/g,'"'));
        $scope.header = $scope.report.header;
        $scope.log = $scope.report.logs;
           $scope.lineItemsData = []; 
                $scope.lineItemsData = $scope.report.lineItems;
              //  alert(JSON.stringify($scope.lineItemsData))
                /*for(i=0;i<=$scope.lineItemsData.length;i++){
                     $scope.lineItems.push($scope.lineItemsData[i].lineItems);

                }
               */
               $scope.lineItemsData.forEach(function(h){
                             $scope.lineItems.push(h.lineItems)
                        });
              //  alert(JSON.stringify($scope.lineItems))
                $scope.formHeader = true;
                $scope.formLineitem = true;                
                if(responce.data.dataChange == 'D'){
                  $scope.isUpdatable = false;
                  $scope.isReadOnlyHeaderCurrency = true;
                }
                // If form is code snippet one.
                if($scope.workitemInfo.mainLayout){
                    viewForm($scope.workitemInfo);
                        $scope.isUpdatable = false;
                }
                // If form is form builder one. So get the form content by id & modify the fields of JSON array as form builder needs for rendering.
                else if (!$scope.workitemInfo.mainLayout){                    
                    RestAPIService.getRequestFormById($scope.workitemInfo.formId).then(function(responce){
                        $scope.formFields = responce.data.fields;
                        $scope.formFields.forEach(function(h){
                            h.value = $scope.workitemInfo.header[h.name];
                        });
                        $scope.formFields.forEach(function(h){
                            if(h.type == 'number'){                               
                                h.value = parseInt(h.value);
                            }                           
                        });                      
                    });
                }
        $scope.log.forEach(function(h){
            if(h.activityText == "Initiated"){
                h['icon'] = "icon-star-outline";
            }
            else if(h.activityText == "Approve"){
                h['icon'] = "icon-check";
            }
            else if(h.activityText =="Collaborate"){
                h['icon'] ="icon-content-save";
            }
            else if(h.activityText =="CollaborateBack"){
                h['icon'] ="icon-content-save";
            }
            else if(h.activityText =="Cancel"){
                h['icon'] ="icon-plus";
            }
            else if(h.activityText =="Delete"){
                h['icon'] ="icon-delete";
            }
            else if(h.activityText == "Elimination"){
               h['icon'] = "icon-check";
           }
            
            })
            $scope.fileIcon = function(fileType){         
                var icon ={};
                if(fileType == "folder"){
                      icon = "icon-folder";
                  }                        
                  else if(fileType.indexOf("jpg")!= -1){
                      icon = "icon-file-image";
                  }
                  else if(fileType.indexOf("jpeg")!= -1){
                      icon = "icon-file-image";
                  }
                  else if(fileType.indexOf("png")!= -1){
                      icon = "icon-file-image";
                  }
                  else if(fileType.indexOf("pdf")!= -1){
                      icon = "icon-file-pdf-box";
                  }
                  else if(fileType.indexOf("txt")!= -1){
                      icon = "icon-clipboard-text";
                  }
                  else if(fileType.indexOf("html")!= -1){
                      icon = "icon-language-html5";
                  }
                  else if(fileType.indexOf("xl")!= -1){
                      icon = "icon-file-excel";
                  }
                  else if(fileType.indexOf("word")!= -1){
                      icon = "icon-file-word";
                  }
                  else if(fileType.indexOf("xml")!= -1){
                      icon = "icon-file-xml";
                  }
                  else if(fileType.indexOf("doc")!= -1){
                      icon = "icon-file-document";
                  }  
                  else if(fileType.indexOf("docx")!= -1){
                      icon = "icon-file-document";
                  }
                  else if(fileType.indexOf("json")!= -1){
                      icon = "icon-clipboard-text";
                  }                      
 
                  else{
                      icon = "icon-file-document";
                  }
                  return icon;
                 
            }
            
          
            


        }

         var jwtToken = $sessionStorage.currentUser.token.trim();
             $scope.previewFile = function(file, reqId) {
                parrepoCtrl.file = file;
                parrepoCtrl.ReqId =reqId;
                parrepoCtrl.ArchiveId =file.archiveId;
                parrepoCtrl.ArchivedocId =file.archiveDocId;
               // parrepoCtrl.url= url;
                parrepoCtrl.file.fileType.toLowerCase();
                if(parrepoCtrl.file.fileType){
                    window.open(baseUrl+'/api/requests/inbox/filedownload?archiveId='+parrepoCtrl.ArchiveId+'&requestId='+parrepoCtrl.ReqId+'&archiveDocId='+parrepoCtrl.ArchivedocId+'&attachment=false&jwtToken='+jwtToken);
                
                }
            }

              $scope.downloadFile =function(file,reqId){
                var archiveId = file.archiveId;
                var ReqId = reqId;
                var archiveDocId = file.archiveDocId;
             RestAPIService.downloadAttachment(ReqId,archiveId,archiveDocId).then(
                     function(success) { 
                             var headers = success.headers();                       
                             var data = success.data;                        
                             var filename = file.fileName;
                             var contentType = headers['content-type'];
                             var linkElement = document.createElement('a');
                             try {
                                 var blob = new Blob([data], { type: contentType });
                                 var url = window.URL.createObjectURL(blob);
                                 linkElement.setAttribute('href', url);
                                 linkElement.setAttribute("download", filename);
                                 var clickEvent = new MouseEvent("click", {
                                     "view": window,
                                     "bubbles": true,
                                     "cancelable": false
                                 });
                                 linkElement.dispatchEvent(clickEvent);
                             } catch (ex) {
                                 console.log(ex);
                             }
                     },
                     function(error) {
                         console.log('ERROR Downloading the file ********');
                         RestAPIService.showErrorDialog(error);
                     }
                 );
             }
        $scope.goToBack =function(){
         // location.reload();
            $scope.details =false;
        }
 


        }       

         
})();
(function ()
{
    'use strict';

    angular
        .module('app.maininbox')
        .controller('MainInboxController', MainInboxController);

    /** @ngInject */
    function MainInboxController($state, $scope, RestAPIService, $filter, $mdDialog, $sce)
    {
        var vm = this;
        init();
        function init(){
            RestAPIService.getAllInboxWorkitems("PAYABLES_NPO_V1").then(
                function(success){
                    vm.orders =success.data;
                },
                function(error){

                }
            )
        }
        vm.dtInstance = {};
        vm.dtOptions = {
            dom         : 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            pagingType  : 'simple',
            lengthMenu  : [10, 20, 30, 50, 100],
            pageLength  : 20,
            scrollY     : 'auto',
            responsive  : true
        }
        $scope.gotoOrderDetail=function(id)
        {
            $state.go('app.maininbox.detail', {id: id});
        }

    }



})();

(function() {
    'use strict';

    var app = angular
        .module('app.analyticsModule', [])
        //.run(run)
        .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider, $controllerProvider, $compileProvider, $filterProvider, $provide) {
        app.controller = $controllerProvider.register;
        app.directive = $compileProvider.directive;
        app.filter = $filterProvider.register;
        app.factory = $provide.factory;
        app.service = $provide.service;

        $stateProvider
            .state('app.analytics', {
                url: '/smartportal/analytic_reports',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/Analytics/analytics.html',
                        controller: 'Analyticscontoller as anltcs'
                    }
                },
                resolve: {
                	RestAPIService: 'RestAPIService',
                    ZohoReports: function(RestAPIService) {
                        return RestAPIService.getAllZohoReports();
                    }
                }
            })
            .state('app.analytics.preview', {
                url: '/smartportal/analytic_Preview',
                params: {
                	reportUrl:null,
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/main/Analytics/analyticPreview.html',
                        controller: 'AnalyticPreviewController as apCtrl'
                    }
                }
            });  
     
        //  msNavigationServiceProvider.saveItem('analytics', {
        //      title: 'Analytics',
        //      icon: 'icon-chart-line',
        //      state: 'app.analytics',
        //      weight: 4            
             
        //  });
        }
    
})();
(function() {
    'use strict';

    angular
        .module('app.analyticsModule')
        .controller('Analyticscontoller', Analyticscontoller);

    /** @ngInject */
    function Analyticscontoller($state, $scope, RestAPIService, $filter, $mdDialog, ZohoReports) {
    	var anltcs = this;
    	$scope.analytics = ZohoReports.data;
    	
    	$scope.selectAnalytic = function(analytic){
    		$state.go('app.analytics.preview', {reportUrl: analytic.url});
    	}
    	 $scope.getAnotherIcon = function(index) {
             $scope.icons = ['icon-currency-usd','icon-file-document', 'icon-timetable'];
             var totalNoOfIcons = $scope.icons.length;
             return $scope.icons[index % totalNoOfIcons];
         }
    	 $scope.getAnotherColor = function(index) {
        	 $scope.colors = ['red', 'purple', 'deep-purple', 'indigo', 'blue',  
                   'deep-orange'  
            ];
            var totalNoOfColors = $scope.colors.length;
            return $scope.colors[index % totalNoOfColors];
        }
    }


})();
(function() {
    'use strict';

    angular
        .module('app.analyticsModule')
        .controller('AnalyticPreviewController', AnalyticPreviewController);	    

    /** @ngInject */


    function AnalyticPreviewController($state, $scope, $filter,RestAPIService,$stateParams,$sce) {
        var apCtrl = this;
        var data = "Contract";
        var Url =$stateParams.reportUrl;
       // $sce.trustAsHtml(myIframe);
        $scope.fileURL = $sce.trustAsResourceUrl(Url);
    }

    



})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .run(runBlock);

    /** @ngInject */
    function runBlock(msUtils, fuseGenerator, fuseConfig)
    {
        /**
         * Generate extra classes based on registered themes so we
         * can use same colors with non-angular-material elements
         */
        fuseGenerator.generate();

        /**
         * Disable md-ink-ripple effects on mobile
         * if 'disableMdInkRippleOnMobile' config enabled
         */
        if ( fuseConfig.getConfig('disableMdInkRippleOnMobile') && msUtils.isMobile() )
        {
            var bodyEl = angular.element('body');
            bodyEl.attr('md-no-ink', true);
        }

        /**
         * Put isMobile() to the html as a class
         */
        if ( msUtils.isMobile() )
        {
            angular.element('html').addClass('is-mobile');
        }

        /**
         * Put browser information to the html as a class
         */
        var browserInfo = msUtils.detectBrowser();
        if ( browserInfo )
        {
            var htmlClass = browserInfo.browser + ' ' + browserInfo.version + ' ' + browserInfo.os;
            angular.element('html').addClass(htmlClass);
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .config(config);

    /** @ngInject */
    function config($ariaProvider, $logProvider, msScrollConfigProvider, $translateProvider, fuseConfigProvider)
    {
        // Enable debug logging
        $logProvider.debugEnabled(true);
        
        // angular-translate configuration
        $translateProvider.useLoader('$translatePartialLoader', {
            urlTemplate: '{part}/i18n/{lang}.json'
        });
        $translateProvider.preferredLanguage('en');
        $translateProvider.useSanitizeValueStrategy('sanitize');

        /*eslint-disable */

        // ng-aria configuration
        $ariaProvider.config({
            tabindex: false
        });

        // Fuse theme configurations
        fuseConfigProvider.config({
            'disableCustomScrollbars'        : false,
            'disableCustomScrollbarsOnMobile': true,
            'disableMdInkRippleOnMobile'     : true
        });

        // msScroll configuration
        msScrollConfigProvider.config({
            wheelPropagation: true
        });

        /*eslint-enable */
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.toolbar', ['ngMaterial', 'ngMessages','ngIdle','ngSanitize'])
        .config(config);

    /** @ngInject */
    function config($translatePartialLoaderProvider)
    {
        $translatePartialLoaderProvider.addPart('app/toolbar');
    }
})();

(function() {
    'use strict';

    angular
        .module('app.toolbar')
        .controller('ToolbarController', ToolbarController)
        // .config(function(IdleProvider, KeepaliveProvider) {
        //     IdleProvider.idle(5);
		// 	IdleProvider.timeout(5);
		// 	KeepaliveProvider.interval(10);
        // })
        // .run(function(Idle){
        //      Idle.watch();
        // })        
        .value("LoggedInUserName", { value: "" });

    /** @ngInject */
    function ToolbarController($scope, $rootScope, $q, $state, $timeout, $interval, $mdSidenav, 
        $translate, $mdToast, $mdDialog, msNavigationService, AuthenticationService, RestAPIService, 
        LoggedInUserId, LoggedInUserName, $localStorage,$location) {
        var vm = this;
       var interval = null;
        var json = $localStorage.logedInuserdetail;
        if(json !=undefined){
        	   if(json['loggedInUserName'] !=undefined && json['currentLogedInUser'] !=undefined){
              	 $scope.loggedInUserName = json['loggedInUserName'];
                   $rootScope.currentLogedInUser  =json['currentLogedInUser'];
              }
        }else{
        	 var interval = $interval(function() {
        		 	var json = $localStorage.logedInuserdetail;
              	  if(json !=undefined){
                 	   if(json['loggedInUserName'] !=undefined && json['currentLogedInUser'] !=undefined){
                       	 $scope.loggedInUserName = json['loggedInUserName'];
                            $rootScope.currentLogedInUser  =json['currentLogedInUser'];
                       }
                  $interval.cancel(interval);
              }
                }, 3000);
                
                
        }
        // alert('hi')
        // // FInd whether the JWT tocken is alive or not by calling user details API.
        // RestAPIService.UserDetails().then(function(responce){
        //     alert('details received')
        //     $scope.userDetails = responce.data;
        // }, function(error){
        //     alert('details not received')
        //     RestAPIService.showErrorDialog(error);
        // })
        
        // $(function () {
        //     $(window).bind("beforeunload", function () {
        //   //      fnLogOut();
        //   vm.logout();

        //     })
        // });   
       
        // Data
        $rootScope.global = {
            search: ''
        };

        vm.goToFavorites = function() {
            $state.go('app.favorites');
        }
        
        vm.goToShared = function() {
            $state.go('app.shared');
        }
        $scope.createTicket = function(){
            $state.go('app.addTicket');
        }
        vm.bodyEl = angular.element('body');
        vm.userStatusOptions = [{
                'title': 'Online',
                'icon': 'icon-checkbox-marked-circle',
                'color': '#4CAF50'
            },
            {
                'title': 'Away',
                'icon': 'icon-clock',
                'color': '#FFC107'
            },
            {
                'title': 'Do not Disturb',
                'icon': 'icon-minus-circle',
                'color': '#F44336'
            },
            {
                'title': 'Invisible',
                'icon': 'icon-checkbox-blank-circle-outline',
                'color': '#BDBDBD'
            },
            {
                'title': 'Offline',
                'icon': 'icon-checkbox-blank-circle-outline',
                'color': '#616161'
            }
        ];
        vm.languages = {
            en: {
                'title': 'English',
                'translation': 'TOOLBAR.ENGLISH',
                'code': 'en',
                'flag': 'us'
            },
            es: {
                'title': 'Spanish',
                'translation': 'TOOLBAR.SPANISH',
                'code': 'es',
                'flag': 'es'
            },
            tr: {
                'title': 'Turkish',
                'translation': 'TOOLBAR.TURKISH',
                'code': 'tr',
                'flag': 'tr'
            }
        };

        // Methods
        vm.toggleSidenav = toggleSidenav;
        vm.logout = logout;
        vm.changeLanguage = changeLanguage;
        vm.setUserStatus = setUserStatus;
        vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;
        vm.toggleMsNavigationFolded = toggleMsNavigationFolded;
        vm.search = search;
        vm.searchResultClick = searchResultClick;
        vm.advancedSearchPopup = advancedSearchPopup;
        //////////

        init();

        /**
         * Initialize
         */
        function init() {

            // Select the first status as a default
            vm.userStatus = vm.userStatusOptions[0];

            // Get the selected language directly from angular-translate module setting
            vm.selectedLanguage = vm.languages[$translate.preferredLanguage()];
        }


        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId) {
            $mdSidenav(sidenavId).toggle();
        }

        /**
         * Sets User Status
         * @param status
         */
        function setUserStatus(status) {
            vm.userStatus = status;
        }

        /**
         * Logout Function
         */
        function logout() {
            // Do logout here..
            AuthenticationService.Logout();
            $location.path('/login');
        }

        /**
         * Change Language
         */
        function changeLanguage(lang) {
            vm.selectedLanguage = lang;

            /**
             * Show temporary message if user selects a language other than English
             * 
             * angular-translate module will try to load language specific json files
             * as soon as you change the language. And because we don't have them, there
             * will be a lot of errors in the page potentially breaking couple functions
             * of the template.
             *
             * To prevent that from happening, we added a simple "return;" statement at the
             * end of this if block. If you have all the translation files, remove this if
             * block and the translations should work without any problems.
             */
            if (lang.code !== 'en') {
                var message = 'Fuse supports translations through angular-translate module, but currently we do not have any translations other than English language. If you want to help us, send us a message through ThemeForest profile page.';

                $mdToast.show({
                    template: '<md-toast id="language-message" layout="column" layout-align="center start"><div class="md-toast-content">' + message + '</div></md-toast>',
                    hideDelay: 7000,
                    position: 'top right',
                    parent: '#content'
                });

                return;
            }

            // Change the language
            $translate.use(lang.code);
        }

        /**
         * Toggle horizontal mobile menu
         */
        function toggleHorizontalMobileMenu() {
            vm.bodyEl.toggleClass('ms-navigation-horizontal-mobile-menu-active');
        }

        /**
         * Toggle msNavigation folded
         */
        function toggleMsNavigationFolded() {
            msNavigationService.toggleFolded();
        }

        /**
         * Search action
         *
         * @param query
         * @returns {Promise}
         */
        function search(query) {
            var navigation = [],
                flatNavigation = msNavigationService.getFlatNavigation(),
                deferred = $q.defer();

            // Iterate through the navigation array and
            // make sure it doesn't have any groups or
            // none ui-sref items
            for (var x = 0; x < flatNavigation.length; x++) {
                if (flatNavigation[x].uisref) {
                    navigation.push(flatNavigation[x]);
                }
            }

            // If there is a query, filter the navigation;
            // otherwise we will return the entire navigation
            // list. Not exactly a good thing to do but it's
            // for demo purposes.
            if (query) {
                navigation = navigation.filter(function(item) {
                    if (angular.lowercase(item.title).search(angular.lowercase(query)) > -1) {
                        return true;
                    }
                });
            }

            // Fake service delay
            $timeout(function() {
                deferred.resolve(navigation);
            }, 1000);

            return deferred.promise;
        }



        /**
         * Search result click action
         *
         * @param item
         */
        function searchResultClick(item) {
            // If item has a link
            if (item.uisref) {
                // If there are state params,
                // use them...
                if (item.stateParams) {
                    $state.go(item.state, item.stateParams);
                } else {
                    $state.go(item.state);
                }
            }
        }
        function advancedSearchPopup(){
            $mdDialog.show({
                controller: advancedSearchPopupController,
                templateUrl: 'app/main/toolbarsearch/toolbarSearchPopup.html',
                parent: angular.element(document.body),
                // targetEvent: ev,
                clickOutsideToClose:true,
                fullscreen: $scope.customFullscreen 
            })
        }
        vm.resultFiles = {};

        function advancedSearchPopupController($scope, RestAPIService,SearchType, CommonUtil,CurrentSiteId){
            $scope.fileExtensions= ["json","pdf","docx","xl","txt","jpeg","folder","jpg","png","html","xml","doc"];
            $scope.file={                
                "fileExtension":null,
                "creator":null,                                
                "fileName":null,
                "fromDate":null,
                "toDate":null,
                "siteId":null,
               "fullTextSearch":null                
            } 
            $scope.locations = ["allSites","currentSite"];
            $scope.dateModifiedTypes = ["Any Time", "Today","Yesterday","Last 7 days","Last 30 days","last 90 days"];
            $scope.reset = function(fileData){ 
                $scope.file = {                
                        "fileExtension":null,
                        "creator":null,                                
                        "fileName":null,
                        "fromDate":null,
                        "toDate":null,
                        "siteId":null,                      
                        "fullTextSearch":null                
                    };
                $scope.attributeObjects = [];
                $scope.hasTheWords= "";
            }
            $scope.cancel = function(){
                $mdDialog.cancel();
            }
            $scope.getAllBusinessObjects=function(){            
                RestAPIService.getDocumentTypes().then(
                    function(responce){
                        $scope.alldocumentType = responce.data;
                        //console.log($scope.alldocumentType);
                    },
                    function(error){
                        RestAPIService.showErrorDialog(error);
                    })
            }
            $scope.selectBusinessObject = function(businessObject){                           
                RestAPIService.findDoctypeAttributes(businessObject.id).then(function(responce){                   
                    $scope.attributeObjects = responce.data.attributes;                 
                    if($scope.attributeObjects != null){
                            $scope.attributeObjects.forEach(function(attribute){                   
                            if(attribute.type == "List"){
                                attribute['listValues'] = attribute.listReference.split(',');                  
                            }
                        });  
                    }                    
                },
                function(error){
                    RestAPIService.showErrorDialog(error);
                })                                                       
            }
            $scope.searchFiles = function(hasTheWords, fileData,attributeObjects, siteLocation){
               SearchType.value =  'advance';
                vm.dateRange = "";            	
              if(siteLocation == "currentSite"){
                    fileData.siteId = CurrentSiteId.value;
                    if(fileData.siteId == ""){
                        fileData.siteId = null;
                     }
                }             
                fileData['q'] = hasTheWords;             
                fileData.attributes=[];            
                if(attributeObjects != undefined && attributeObjects !=""){
                    attributeObjects.forEach(function(h){
                            if((h.value != undefined && h.value != "") && (h.value != undefined && h.value != "")){
                            fileData.attributes.push({'name': h.name, 'type':h.type, 'value': h.value});
                            }
                    });                    
                } 
                $mdDialog.cancel();
                RestAPIService.advanceSearch(fileData).then(function(responce){                           
                    vm.resultFiles =responce.data
                    // console.log(vm.resultFiles);
                    vm.numberOfElements = responce.headers('x-total-count');
                    $state.go('app.resultFiles', {obj:vm.resultFiles, fileCount:vm.numberOfElements,FileData:fileData});
                }, 
                function(error){
                    RestAPIService.showErrorDialog(error);
                })            
             }

                    
        }
          
        
        vm.editMyProfile =function(){
        	$state.go('app.profile');
        }

        vm.changePassword = changePassword;

        function changePassword(ev) {
            $mdDialog.show({
                controller: ChangePasswordController,
                templateUrl: 'app/main/finishReset/finishReset.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: $scope.customFullscreen
            })
        }

        function ChangePasswordController($scope) {
            $scope.cancel = function() {
                $mdDialog.cancel();
            }
            $scope.save = function(password) {
                $scope.profileUser =""
              	RestAPIService.ResetPassword($scope.profileUser,password).then(
              			function(success){
              			   	 RestAPIService.successTostDialog("Password Changed successfully ");              		
              				$mdDialog.hide(password);
              			},
              			 function(error) {
                        RestAPIService.showErrorDialog(error);
                        });
            	
                
            }
        }

        $scope.toolbarSearchPopup = function(ev) {
            // alert("hii");
            $mdDialog.show({
                controller: PopupController,
                templateUrl: 'app/main/toolbarsearch/toolbarSearchPopup.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: $scope.customFullscreen
            })

        }
        $scope.times = ["Today", "Last Week", "This Month"];
        $scope.doctypes = ["PO", "NPO", "CHQ_REQ"];
        $scope.sites = ["HR", "Finance", "IT"];
        $scope.fileTypes = ["docx", "pdf", "txt"];
        $scope.resultFiles = {};
        $scope.resultFiles = {
            "content": [{
                    "name": "Invoice.pdf",
                    "type": "pdf",
                    "owner": "admin",
                    "size": "55kb",
                    "createdOn": "15 Apr 2010"
                },
                {
                    "name": "Purchase Order.pdf",
                    "type": "pdf",
                    "owner": "admin",
                    "size": "55kb",
                    "createdOn": "15 Apr 2010"
                },
                {
                    "name": "Non Purchase Order.pdf",
                    "type": "pdf",
                    "owner": "admin",
                    "size": "55kb",
                    "createdOn": "15 Apr 2010"
                },
                {
                    "name": "All Doctypes List.pdf",
                    "type": "pdf",
                    "owner": "admin",
                    "size": "55kb",
                    "createdOn": "15 Apr 2010"
                }

            ],
            "facetResultPages": [{
                    "content": [{
                            "valueCount": 1,
                            "value": "site-0",
                            "field": {
                                "name": "site_id"
                            },
                            "key": {
                                "name": "site_id"
                            }
                        },
                        {
                            "valueCount": 1,
                            "value": "site-1",
                            "field": {
                                "name": "site_id"
                            },
                            "key": {
                                "name": "site_id"
                            }
                        }
                    ]
                },
                {
                    "content": [{
                        "valueCount": 101,
                        "value": "pdf",
                        "field": {
                            "name": "fileExtension"
                        },
                        "key": {
                            "name": "fileExtension"
                        }
                    }]
                },
                {
                    "content": [{
                        "valueCount": 101,
                        "value": "LFA1",
                        "field": {
                            "name": "businessObjectName"
                        },
                        "key": {
                            "name": "businessObjectName"
                        }
                    }]
                }
            ],
            "facetFields": [{
                    "name": "site_id"
                },
                {
                    "name": "fileExtension"
                },
                {
                    "name": "businessObjectName"
                }
            ],
            "totalPages": 6,
            "totalElements": 101,
            "size": 20,
            "number": 0,
            "first": true,
            "sort": null,
            "last": false,
            "numberOfElements": 20
        };

        $scope.filesLength = $scope.resultFiles.content.length;


        // This popup is for when you click search icon in toolbar page for files search.
        function PopupController($scope, RestAPIService) {
            $scope.noOfAttributesToDisplay = 5;
            $scope.locations = ["Anywhere", "Current Location", "My Sites"];

            $scope.getAllBusinessObjects = function() {
                RestAPIService.getAllBusinessObjects().then(
                    function(responce) {
                        $scope.allBusinessObjects = responce.data;
                    },
                    function(error) {
                        RestAPIService.showErrorDialog(error);
                    })
            }
            $scope.cancel = function() {
                $mdDialog.cancel();
            }
            $scope.reset = function(fileData) {
                $scope.file = {};
                $scope.attributeObjects = {};
            }
            $scope.selectBusinessObject = function(businessObject) {

                // Calling Rest API Service to get Attributes of this Business Object
                RestAPIService.findBusinessObjectAttributes(businessObject.id).then(function(responce) {
                        $scope.attributeObjects = responce.data.attributes;
                    },
                    function(error) {
                        RestAPIService.showErrorDialog(error);
                    })
                // If any Attribute is having listReferrence as COMMA separated values, Split them.         
                if ($scope.attributeObjects != null && $scope.attributeObjects != undefined) {
                    $scope.attributeObjects.forEach(function(attribute) {
                        if (attribute.listReference != null && attribute.listReference != undefined) {
                            attribute['listValues'] = attribute.listReference.split(',');
                        }
                    });
                }
            }

            $scope.moreObjects = function() {
                $scope.noOfAttributesToDisplay += 5;
            }
            $scope.searchResult = [];

            $scope.searchFiles = function(fileData) {
                alert(JSON.stringify(fileData));
                // Calling Rest API Service to get Result Files
                RestAPIService.searchFiles(fileData).then(function(responce) {
                        $scope.resultFiles = responce.data;
                        alert(JSON.stringify($scope.resultFiles));
                    },
                    function(error) {
                        RestAPIService.showErrorDialog(error);
                    })
                // Send to the result files state.
                $state.go('app.resultFiles');
                $mdDialog.cancel();

            }
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.quick-panel')
        .controller('QuickPanelController', QuickPanelController);

    /** @ngInject */
    function QuickPanelController(msApi)
    {
        var vm = this;

        // Data
        vm.date = new Date();
        vm.settings = {
            notify: true,
            cloud : false,
            retro : true
        };

        msApi.request('quickPanel.activities@get', {},
            // Success
            function (response)
            {
                vm.activities = response.data;
            }
        );

        msApi.request('quickPanel.events@get', {},
            // Success
            function (response)
            {
                vm.events = response.data;
            }
        );

        msApi.request('quickPanel.notes@get', {},
            // Success
            function (response)
            {
                vm.notes = response.data;
            }
        );

        // Methods

        //////////
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.navigation', [])
        .config(config);

    /** @ngInject */
    function config()
    {
        
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.navigation')
        .controller('NavigationController', NavigationController);

    /** @ngInject */
    function NavigationController($scope)
    {
        var vm = this;

        // Data
        vm.bodyEl = angular.element('body');
        vm.folded = true;
        vm.msScrollOptions = {
            suppressScrollX: true
        };

        // Methods
        vm.toggleMsNavigationFolded = toggleMsNavigationFolded;

        //////////

        /**
         * Toggle folded status
         */
        function toggleMsNavigationFolded()
        {
           // vm.folded = !vm.folded;
        }

        // Close the mobile menu on $stateChangeSuccess
        $scope.$on('$stateChangeSuccess', function ()
        {
            vm.bodyEl.removeClass('ms-navigation-horizontal-mobile-menu-active');
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.overview')
        .controller('MainController', MainController);

    /** @ngInject */
    function MainController($scope, $rootScope)
    {
        // Remove the splash screen
        $scope.$on('$viewContentAnimationEnded', function (event)
        {
            if ( event.targetScope.$id === $scope.$id )
            {
                $rootScope.$broadcast('msSplashScreen::remove');
            }
        });
    }
})();
    (function ()
{
    'use strict';

    /**
     * Main module of the Fuse
     */
    angular
        .module('smartportal', [
            // Core
            'app.core',
            // Navigation
            'app.navigation',
            // Toolbar
            'app.toolbar',
            // Quick panel
            'app.quick-panel',
            // Overview
            'app.overview',
            // Create Form
	        //'app.create'
            'app.settings',
            // 'app.requests',
            'app.mycontent',
            'app.reports',
            'app.doaReports',
            'app.bussiness',
            'app.toolbarsearch',
            'app.sharedwithme',
            'app.administration',
            'app.businessadmin',
            'app.coromandeloutbox',
           //  'app.nps',
            'app.profile',
             'app.PARreports',
            'app.ticketManagement',
            'app.reset',
            
            // 'app.reset_token',
            'ngIdle',
            'app.Adminsubstitution',
            'app.social_login'
            

           //'app.analyticsModule'
        ]);
})();

(function() {
    'use strict';

    angular
        .module('smartportal')
        .factory('RestAPIService', RestAPIService);
    function RestAPIService($q, $log, $http, $mdDialog, $mdToast, $sessionStorage, $localStorage, $state) {
        var service = {};
        service.baseUrl = baseUrl+'/api';
        var last = {
            bottom: false,
            top: true,
            left: false,
            right: true
        };
        service.toastPosition = angular.extend({}, last);
        service.getToastPosition = function() {
            service.sanitizePosition();
            return Object.keys(service.toastPosition)
                .filter(function(pos) {
                    return service.toastPosition[pos];
                })
                .join(' ');
        };
        service.sanitizePosition = function() {
            var current = service.toastPosition;
            if (current.bottom && last.top) current.top = false;
            if (current.top && last.bottom) current.bottom = false;
            if (current.right && last.left) current.left = false;
            if (current.left && last.right) current.right = false;
            last = angular.extend({}, current);
        }
        service.successTostDialog = successTostDialog;
        function successTostDialog(msg) {
            var pinTo = service.getToastPosition();
            $mdToast.show(
                $mdToast.simple()
                .textContent(msg)
                .position(pinTo)
                .hideDelay(1000)
            );
        }
        service.showErrorDialog = showErrorDialog;
        function showErrorDialog(error) {
            var errorStatus = error.status;
            var errorStatusText = error.statusText;
            if (errorStatus == -1) {
                errorStatusText = 'The server application is not running';
            }
            if(errorStatus == 401){
              delete $sessionStorage.currentUser;
              delete $localStorage.currentUser;
              delete $localStorage.language;
              $http.defaults.headers.common.Authorization = '';
              delete window.localStorage['branddata'];
              delete window.localStorage['ngStorage-logedInuserdetail'];
              delete window.localStorage['ngStorage-currentUser'];
              $state.go('login');             
            }
            $mdDialog.show(
                $mdDialog.alert()
                .clickOutsideToClose(true)
                .title('Server error occurred while processing')
                .htmlContent('<hr><br><strong>Error code : </strong>' + errorStatus +
                    '<br><strong>Error message : </strong>' + errorStatusText)
                .ariaLabel('Alert Dialog Demo')
                .ok('Ok')
            );
        }
        service.deleteFormAttachments = function(archiveId, requestId, archiveDocId, comment) {
            var appUrl = '/requests/inbox/filedelete?archiveId=' + archiveId + '&requestId=' + requestId + '&archiveDocId=' + archiveDocId+ '&comment=' + comment;
            return call_POST(appUrl,archiveId,requestId,archiveDocId,comment);
        }
        service.createUser = function(user) {
            var appUrl = '/users';
            return call_POST(appUrl, user);
        }
        service.updateUser = function(user) {
            var appUrl = '/users';
            return call_PUT(appUrl, user);
        }
        service.deleteUser = function(login) {
            var appUrl = '/users/' + login;
            return call_DELETE(appUrl);
        }
        service.resetPassword = function(email) {
            var appUrl = '/account/reset_password/init';
            return call_POST(appUrl, email);
        }
        service.resetPasswordfinish = function(newPassword) {
            var appUrl = '/account/reset_password/finish';
            return call_POST(appUrl,newPassword);
        }
        service.getbrandsetting = function(){
            var appUrl = '/getbrandsetting';
            return call_GET(appUrl);
        }
        service.savebrandsetting = function(branddata){
            var appUrl = '/savebrandSetting';
            return call_PUT(appUrl,branddata);
        }
        service.updatebrandsetting = function(branddata){
            var appUrl = '/updatebrandsetting';
            return call_POST(appUrl,branddata);
        }
         service.getlistdata = function(){
            var appUrl = '/list';
             return call_GET(appUrl);
        }
        service.createList = function(list){
            var appUrl = '/createlist';
             return call_POST(appUrl,list);
        }
        service.updateList = function(list){
            var appUrl = '/updatelist';
         return call_PUT(appUrl,list);
        }
        service.delete = function(listid){
            var appUrl = '/list/'+ listid;
         return call_DELETE(appUrl);
        }
        service.getDepartmentlistdata = function(){
            var appUrl = '/getdynamicinstace/Department';
             return call_GET(appUrl);
        }
        service.getreporttypefields = function(data) {
            var appUrl = '/reports/getcollectionfields/' + data;
            return call_GET(appUrl);
        }
        service.getDoaReportsfield = function(data) {
            var appUrl = '/reportConfiguration/' + data+'/getlogin';
            return call_GET(appUrl);
        }
        service.savereportdata = function(data) {
            var appUrl = '/reports/savereportdata';
            return call_PUT(appUrl,data);
        }
        service.updateReportData = function(data) {
            var appUrl = '/reports/updatereportdata';
            return call_POST(appUrl,data);
        }
        service.getreportdata = function() {
            var appUrl = '/reports/getreportdata';
            return call_GET(appUrl);
        }
        service.deletereport = function(id){
            var appUrl = '/reports/'+ id ;
            return call_DELETE(appUrl);
        }
        //advancepayments
        service.getADVInvoicelistdata = function(){
            var appUrl = '/getdynamicinstace/INVOICETYPESVALUES';
             return call_GET(appUrl);
        }
        service.getADVCurrencylistdata = function(){
            var appUrl = '/getdynamicinstace/CURRENCY';
             return call_GET(appUrl);
        }
        service.getADVGLIndicatorlistdata = function(){
            var appUrl = '/getdynamicinstace/GLINDICATOR';
             return call_GET(appUrl);
        }
        service.getADVSBUlistdata = function(){
            var appUrl = '/getdynamicinstace/SBUADVANCE';
             return call_GET(appUrl);
        }
        service.getADVbusinessArealistdata = function(){
            var appUrl = '/getdynamicinstace/businessArea';
             return call_GET(appUrl);
        }
        service.getADVDepartmentlistdata = function(){
            var appUrl = '/getdynamicinstace/Department';
             return call_GET(appUrl);
        }
        service.getADVLocationlistdata = function(){
            var appUrl = '/getdynamicinstace/locationForAdvancePayments';
             return call_GET(appUrl);
        }
        // MTR search helps call 
        service.getDynamicList =function(list, pageNumber, pageSize){
        if(pageNumber){
          var pageNumber = pageNumber;
        }else{
          var pageNumber = 0
        }
        if(pageSize){
          var pageSize = pageSize
        }else{
          pageSize = 2000;
        }
          var appUrl ='/getdynamicinstace/'+list +'?page='+pageNumber+'&size='+pageSize;
          return call_GET(appUrl);

      }
      service.getDynamicInstanceDataByMultipleValues = function(instanceName, listVariables, listValues){
        var url = '';
        if (listValues !== '') {
          url = '/' + instanceName + '/getlistdatabyvalues?listvar=' + listVariables.join('%2C') + '&values=' + listValues.join('%2C')+ '&page=' + 0 + '&size=' + 10000 ;
          // url = '/' + instanceName +'/'+ listVariables.join('%2C')+'/'+listValues.join('%2C')+'/getlistdatabysearch?page=0&size=10';
        } else {
          url = '/getdynamicinstace/' + instanceName + '?page=' + 0 + ' &size=' + 1000;
        }
        return call_GET(url);
      }

        service.getVendorData=function(search,page,size){
            if(search.value ==undefined ||search.value == ""){
                search.value =null;
            }
            var appUrl='/VENDORDATA/'+search.key +'/'+search.value +'/getlistdatabysearch?page='+page+'&size='+size;
            return call_POST(appUrl,search);
          }
        // service.getADVLocationlistdata = function(){
        //     var appUrl = '/getdynamicinstace/locationForAdvancePayments';
        //      return call_GET(appUrl);
        // }
        //end
        service.cancelDoaReports = function(requestType,reportsComment,activity,id){
        
        var appUrl = '/cancel?requestType='+requestType+'&comment='+reportsComment+'&activity='+activity+'&requestData='+id;
            return call_POST(appUrl);
        }
        service.createdetail = function(data){
            var appUrl = '/savedynamiccollection';
         return call_POST(appUrl,data);
        }

        service.getdetaildata = function(name, pageNumber, pageSize){
            var appUrl = '/getdynamicinstace/' + name+'?page='+pageNumber+'&size='+pageSize;
            return call_GET(appUrl);
        }
        // service.getdetaildata = function(name){
        //     var appUrl = '/getdynamicinstace/' + name;
        //     return call_GET(appUrl);
        // }
        service.updatedyData = function(data){
            var appUrl = '/updatedynamiccollection';
            return call_PUT(appUrl,data);
        }
        service.deletedata = function(id,name){
            var appUrl = '/deletedynamicinstace/' + name +'/'+id;
            return call_DELETE(appUrl);
        }

        service.getDocumentTypes = function() {
            var appUrl = '/documentTypes';
            return call_GET(appUrl);
        }
        service.createDocumentType = function(documentType) {
            var appUrl = '/documentTypes';
            return call_POST(appUrl, documentType);
        }
        service.updateDocumentType = function(documentType) {
            var appUrl = '/documentTypes';
            return call_PUT(appUrl, documentType);
        }
        service.deleteDocumentType = function(documentId) {
            var appUrl = '/documentTypes/' + documentId;
            return call_DELETE(appUrl);
        }
        service.getDocumentTypeAttributes = function(id) {
            var appUrl = '/documentTypes/' + id;
            return call_GET(appUrl);
        }
        service.getDocumentTemplate = function() {
            var appUrl = '/documentTemplate';
            return call_GET(appUrl);
        }
        service.updateApprovalConfig = function(documentType) {
            var appUrl = '/documentTypes/updateConfig';
            return call_PUT(appUrl, documentType);
        }
        service.getAllGroups = function() {
            var appUrl = '/groups';
            return call_GET(appUrl);
        }
        service.getGroupMembers = function(groupId) {
            var appUrl = '/groups/' + groupId + '/users';
            return call_GET(appUrl);
        }
        service.createGroup = function(groupData) {
            var appUrl = '/groups';
            return call_POST(appUrl, groupData);
        }
        service.searchMemberForGroups = function(searchKeyword, type) {
            var appUrl = '/users/search?q=' + searchKeyword + '&type=' + type;
            return call_GET(appUrl);
        }
        service.addGroupMember = function(member, groupId) {
            var appUrl = '/groups/' + groupId + '/users';
            return call_POST(appUrl, member)
        }
        service.deleteGroup = function(groupId) {
            var appUrl = '/groups/' + groupId;
            return call_DELETE(appUrl)
        }
        service.deleteGroupMember = function(groupId, login) {
            var appUrl = '/groups/' + groupId + '/users/' + login;
            return call_DELETE(appUrl);
        }
        service.getSites = function() {
            var appUrl = '/mysites';
            return call_GET(appUrl);
        }
        service.createSite = function(site) {
            var appUrl = '/sites';
            return call_POST(appUrl, site);
        }
        service.deleteSite = function(siteId) {
            var appUrl = '/sites/' + siteId;
            return call_DELETE(appUrl);
        }
        service.getSiteDetails = function(siteId) {
            var appUrl = '/sites/' + siteId;
            return call_GET(appUrl);
        }
        service.updateSite = function(site) {
            var appUrl = '/sites';
            return call_PUT(appUrl, site);
        }
        service.getMembers = function(siteId) {
            var appUrl = '/sites/' + siteId + '/members';
            return call_GET(appUrl);
        }
        service.deleteMember = function(siteId, login) {
            var appUrl = '/sites/' + siteId + '/members/' + login;
            return call_DELETE(appUrl);
        }
        service.searchMember = function(siteId, searchKeyword) {
            var appUrl = '/sites/' + siteId + '/users/search?q=' + searchKeyword;
            return call_GET(appUrl);
        }
        service.addMember = function(siteId, member) {
            var appUrl = '/sites/' + siteId + '/members';
            return call_POST(appUrl, member);
        }
        service.getToDoList = function getToDoList(siteId) {
            var appUrl = '/sites/' + "site-2" + '/todolists';
            return call_GET(appUrl);
        }
        service.addToDoList = function addToDoList(note, siteId) {
            var appUrl = '/sites/' + siteId + '/todolists';
            return call_POST(appUrl, note);
        }
        service.deleteTodo = function(noteId) {
            var appUrl = '/sites/todolists/' + noteId;
            return call_DELETE(appUrl);
        }
        service.updateTodo = function(data, siteId) {
            var appUrl = '/sites/' + siteId + '/todolists';
            return call_PUT(appUrl, data);
        }
        service.getSiteHome = function(siteId) {
            var appUrl = '/sites/' + siteId + '/dashbord';
            return call_GET(appUrl);
        }
        service.siteSettings = function(siteId, settings) {
            var appUrl = '/sites/' + siteId + '/settings/createSettings';
            return call_POST(appUrl, settings);
        }
        service.getFilesOnly = function(siteId) {
            var appUrl = '/sites/' + siteId + '/filesonly';
            return call_GET(appUrl);
        }
        service.getFileById = function(siteId,libraryId) {
            var appUrl = '/sites/' + siteId + '/files/'+libraryId;
            return call_GET(appUrl);
        }
        service.uploadFileToUrl = function(file) {
            var uploadUrl = 'http://1-dot-clock-asit.appspot.com/rest/createform/custom/file';
            var fd = new FormData();
            fd.append('file', file);
            return $http.post(uploadUrl, fd, {
                transformRequest: angular.identity,
                headers: {
                    'Content-Type': undefined
                }
            });
        };
        service.uploadFile = function(siteId,description, file, currentFolderId, documentTypeJson) {
            var appUrl;
            if (currentFolderId == '') {
                appUrl = '/sites/' + siteId + '/files/file';
            } else {
                appUrl = '/sites/' + siteId + '/files/file?parentId=' + currentFolderId;
            }
            var form = new FormData();
            form.append('documentTypeJson', JSON.stringify(documentTypeJson));
            form.append('file', file);
            form.append('description',description);
            return $http.post(service.baseUrl + appUrl, form, {
                transformRequest: angular.identity,
                headers: {
                    'Content-Type': undefined
                }
            });
        }
        service.createTemplateFile = function(siteId,currentFolderId,documentTypeJson,templatename,name) {
            var appUrl;
         if (currentFolderId == '') {
             appUrl = '/sites/' + siteId + '/files/createfile?documentTemplate='+templatename+'&name='+name +'&documentTypeJson='+encodeURIComponent(JSON.stringify(documentTypeJson));
         } else {
             appUrl = '/sites/' + siteId + '/files/?documentTemplate='+templatename+'&name='+name +'&documentTypeJson='+encodeURIComponent(JSON.stringify(documentTypeJson))+'&parentId=' + currentFolderId;
         }

         return $http.post(service.baseUrl + appUrl, {
             transformRequest: angular.identity,
             headers: {
                 'Content-Type': undefined
             }
         });


     }
        service.createFolder = function(siteId,description, folderName, currentFolderId) {
            var appUrl;
            if (currentFolderId == '')
                appUrl = '/sites/' + siteId + '/files/folder?name=' + folderName+'&description='+description;
            else
                appUrl = '/sites/' + siteId + '/files/folder?name=' + folderName + '&parentId=' + currentFolderId+'&description='+description;
            return call_POST(appUrl);
        }
        service.getFiles = function(parentId, siteId, pageNumber, pageSize) {
            var appUrl;
            if (parentId != '')
                appUrl = '/sites/' + siteId + '/files?page=' + pageNumber + '&size=' + pageSize + '&parentId=' + parentId;
            else
                appUrl = '/sites/' + siteId + '/files?page=' + pageNumber + '&size=' + pageSize;
            return call_GET(appUrl);
        }
        service.updateFile = function(siteId, file) {
            var appUrl = '/sites/' + siteId + '/files';
            return call_PUT(appUrl, file);
        }
        service.deleteFile = function(siteId, fileId) {
            var appUrl = '/sites/' + siteId + '/files/' + fileId;
            return call_DELETE(appUrl);
        }
        service.downloadFile = function(siteId, fileId) {
            var appUrl = '/sites/' + siteId + '/files/file?fileId=' + fileId;
            return $http.get(service.baseUrl + appUrl, {
                responseType: "blob",
                headers: {
                    'Accept': '*/*'
                }
            });
        }
        service.downloadVersionedFile = function(siteId, fileId, versionNo) {
            var appUrl = '/sites/' + siteId + '/files/file?fileId=' + fileId + '&versionNo=' + versionNo;
            return $http.get(service.baseUrl + appUrl, {
                responseType: "blob",
                headers: {
                    'Accept': '*/*'
                }
            });
        }
        service.fileCheckout = function(siteId, fileId) {
            var appUrl = '/sites/' + siteId + '/files/file?fileId=' + fileId + '&checkingOut=true';
            return $http.get(service.baseUrl + appUrl, {
                responseType: "blob",
                headers: {
                    'Accept': '*/*'
                }
            });
        }
        service.getAttributes = function(siteId, fileId) {
            var appUrl = '/sites/' + siteId + '/files/' + fileId;
            return call_GET(appUrl);
        }
        service.updateFileAttrAndSharing = function(siteId, fileObject) {
            var appUrl = '/sites/' + siteId + '/files/' + fileObject.id;
            return call_PUT(appUrl, fileObject);
        }
        service.searchUsers = function(elements) {
            var appUrl = '/users/search?q=' + elements.text + '&type=' + elements.type;
            return call_GET(appUrl);
        }
        service.NewVersionFile = function(siteId, file, VersionFile) {
            var appUrl = '/sites/' + siteId + '/files/file?' + 'checkingIn=false&addNewVersion=true' + '&fileId=' + VersionFile.id+'&documentTypeJson='+encodeURIComponent('documentTypeJson={}');
            var fd = new FormData();
            fd.append('file', file);
            return $http.post(service.baseUrl + appUrl, fd, {
                transformRequest: angular.identity,
                headers: {
                    'Content-Type': undefined
                }
            });
        }
        service.checkIn = function(siteId, file, checkInFile) {
            var appUrl = '/sites/' + siteId + '/files/file?' + 'checkingIn=true&addNewVersion=false' + '&fileId=' + checkInFile.id+'&documentTypeJson='+encodeURIComponent('documentTypeJson={}');
            var fd = new FormData();
            fd.append('file', file);
            return $http.post(service.baseUrl + appUrl, fd, {
                transformRequest: angular.identity,
                headers: {
                    'Content-Type': undefined
                }
            });
        }
        service.buildForm = function(siteId, fileId) {
            var appUrl = '/sites/' + siteId + '/files/file?fileId=' + fileId + '&checkingOut=false&attachment=false';
            return call_GET(appUrl);
        }
        service.getbinderFiles = function(parentId, binderId) {
            var appUrl;
            if (parentId != '')
                appUrl = '/binder/' + binderId + '/files?parentId=' + parentId;
            else
                appUrl = '/binder/' + binderId + '/files';
            return call_GET(appUrl);
        }
        service.getbinderAttributes = function(fileId, binderId) {
            var appUrl = '/binder/' + binderId + '/files/' + fileId;
            return call_GET(appUrl);
        }
        service.deletebinderFile = function(fileId, binderId) {
            var appUrl = '/binder/' + binderId + '/files/' + fileId;
            return call_DELETE(appUrl);
        }
        service.uploadbinderFile = function(file, currentFolderId, binderId) {
            var appUrl;
            if (currentFolderId == '')
                appUrl = '/binder/' + binderId + '/files/file';
            else
                appUrl = '/binder/' + binderId + '/files/file?parentId=' + currentFolderId;
            var fd = new FormData();
            fd.append('file', file);
            return $http.post(service.baseUrl + appUrl, fd, {
                transformRequest: angular.identity,
                headers: {
                    'Content-Type': undefined
                }
            });
        }
        service.binerfilecheckIn = function(file, checkInFile, checkInFolderid, binderId) {
            var appUrl = '/binder/' + binderId + '/files/file?' + 'checkingIn=true&addNewVersion=false' + '&fileId=' + checkInFile.id;
            var fd = new FormData();
            fd.append('file', file);
            return $http.post(service.baseUrl + appUrl, fd, {
                transformRequest: angular.identity,
                headers: {
                    'Content-Type': undefined
                }
            });
        }
        service.binderfileCheckout = function(fileId, binderId) {
            var appUrl = '/binder/' + binderId + '/files/file?fileId=' + fileId + '&checkingOut=true&attachment=true';
            return $http.get(service.baseUrl + appUrl, {
                responseType: "blob",
                headers: {
                    'Accept': '*/*'
                }
            });
        }
        service.updatebinderFileAttrAndSharing = function(fileObject, binderId) {
            var appUrl = '/binder/' + binderId + '/files/' + fileObject.id;
            return call_PUT(appUrl, fileObject);
        }
        service.NewVersionbinderFile = function(file, VersionFile, binderId) {
            var appUrl = '/binder/' + binderId + '/files/file?' + 'checkingIn=false&addNewVersion=true' + '&fileId=' + VersionFile.id;
            var fd = new FormData();
            fd.append('file', file);
            return $http.post(service.baseUrl + appUrl, fd, {
                transformRequest: angular.identity,
                headers: {
                    'Content-Type': undefined
                }
            });
        }
        service.updatebinderFile = function(file, binderId) {
            var appUrl = '/binder/' + binderId + '/files';
            return call_PUT(appUrl, file);
        }
        service.downloadbinderFile = function(fileId, binderId) {
            var appUrl = '/binder/' + binderId + '/files/file?fileId=' + fileId;
            return $http.get(service.baseUrl + appUrl, {
                responseType: "blob",
                headers: {
                    'Accept': '*/*'
                }
            });
        }
        service.downloadVersionedbinderFile = function(fileId, versionNo, binderId) {
            var appUrl = '/binder/' + binderId + '/files/file?fileId=' + fileId + '&versionNo=' + versionNo;
            return $http.get(service.baseUrl + appUrl, {
                responseType: "blob",
                headers: {
                    'Accept': '*/*'
                }
            });
        }

        service.downloadAttachment = function(ReqId,archiveId,archiveDocId) {
            var appUrl = '/requests/inbox/filedownload?archiveId='+archiveId+'&requestId='+ReqId+'&archiveDocId='+archiveDocId+'&attachment=true';
            return $http.get(service.baseUrl + appUrl, {
                responseType: "blob",
                headers: {
                    'Accept': '*/*'
                }
            });
        }
        service.downloadAttachmentdirectly = function(attachmenturl) {
            var appUrl =attachmenturl;
            return $http.get(appUrl, {
                responseType: "blob",
                headers: {
                    'Accept': '*/*'
                }
            });
        }
        service.createbinderFolder = function(folderName, currentFolderId, binderId) {
            var appUrl;
            if (currentFolderId == '')
                appUrl = '/binder/' + binderId + '/files/folder?name=' + folderName;
            else
                appUrl = '/binder/' + binderId + '/files/folder?name=' + folderName + '&parentId=' + currentFolderId;
            return call_POST(appUrl);
        }
        service.getbinderAttributes = function(fileId, binderId) {
            var appUrl = '/binder/' + binderId + '/files/' + fileId;
            return call_GET(appUrl);
        }
        service.attributesThroughBinderId = function(binderId) {
            var appUrl = "/binder/" + binderId;
            return call_GET(appUrl);
        }
        service.getAllBusinessObjects = function() {
            var appUrl = '/business-objects';
            return call_GET(appUrl);
        }
        service.getBinders = function() {
            var appUrl = '/binders';
            return call_GET(appUrl);
        }
        service.createBinder = function(binder) {
            var appUrl = '/binders';
            return call_POST(appUrl, binder);
        }
        service.updateBinder = function(binder) {
            var appUrl = '/binders';
            return call_PUT(appUrl, binder);
        }
        service.deleteBinder = function(id) {
            var appUrl = '/binders/' + id;
            return call_DELETE(appUrl);
        }
        service.getObjects = function() {
            var appUrl = '/business-objects';
            return call_GET(appUrl);
        }
        service.createObject = function(object) {
            var appUrl = '/business-objects';
            return call_POST(appUrl, object);
        }
        service.updateObject = function(object) {
            var appUrl = '/business-objects';
            return call_PUT(appUrl, object);
        }
        service.deleteObject = function(id) {
            var appUrl = '/business-objects/' + id;
            return call_DELETE(appUrl);
        }
        service.getUser = function(login) {
            var appUrl = '/users/' + login;
            return call_GET(appUrl);
        }
        service.updateUserProfile = function(user) {
            var appUrl = '/users';
            return call_PUT(appUrl, user);
        }
        service.UserDetails = function() {
            var appUrl = '/account';
            return call_GET(appUrl);
        }
        service.findBusinessObjectAttributes = function(id) {
            var appUrl = '/business-objects/' + id;
            return call_GET(appUrl);
        }
        service.findDoctypeAttributes = function(id) {
            var appUrl = '/documentTypes/' + id;
            return call_GET(appUrl);
        }
        service.advanceSearch = function(fileData, pageNumber, pageSize, dateRange) {
            var appUrl = '/advancedSearch?page='+pageNumber+'&size='+pageSize;
            return call_POST(appUrl, fileData);
        }
        service.basicSearch = function(searchObject, pageNumber, pageSize) {
            var appUrl = '/search?page=' + pageNumber + '&size=' + pageSize + '&term=' + searchObject.q;
            return call_GET(appUrl);
        }
        service.basicFacetQueryResult = function(facetQueryObject, pageNumber, pageSize, dateRange) {
            var appUrl = '/search/documents?page=' + pageNumber + '&size=' + pageSize + '&dateRange=' + dateRange;
            return call_POST(appUrl, facetQueryObject);
        }
        service.advanceFacetQueryResult = function(facetQueryObject, pageNumber, pageSize, dateRange) {
            var appUrl = '/advancedSearch/documents?page=' + pageNumber + '&size=' + pageSize + '&dateRange=' + dateRange;
            return call_POST(appUrl, facetQueryObject);
        }
        service.getMySharedfiles = function(pageNumber,pageSize) {
            var appUrl = '/users/preference/mysharedfiles?page=' + pageNumber + '&size=' + pageSize;
            return call_GET(appUrl);
        }
        service.searchresultsDownload = function(fileId, siteId) {
            var appUrl = '/sites/' + siteId + '/files/file?fileId=' + fileId;
            return $http.get(service.baseUrl + appUrl, {
                responseType: "blob",
                headers: {
                    'Accept': '*/*'
                }
            });
        }
        service.getFileAttributeDetails = function(fileId, siteId) {
            var appUrl = '/sites/' + siteId + '/files/' + fileId;
            return call_GET(appUrl);
        }
        service.uploadRequestForm = function(headerfile, name, description) {
            // alert("header");
            var appUrl = '/forms?name=' + name + '&description=' + description;
            var form = new FormData();
            form.append('headerFile', headerfile);
           /* form.append('lineitemfile', lineitemfile);*/
            return $http.post(service.baseUrl + appUrl, form, {
                transformRequest: angular.identity,
                headers: {
                    'Content-Type': undefined
                }
            });
        }
        service.getRequestForms = function() {
            var appUrl = '/forms?page=0&size=1000';
            return call_GET(appUrl);
        }
        service.getRequestFormById = function(id) {
            var appUrl = '/forms/' + id;
            return call_GET(appUrl);
        }
        service.createRequest = function(doc) {
            var appUrl = '/request-types';
            return call_POST(appUrl, doc);
        }
        service.getRequests = function() {
            var appUrl = '/request-types';
            return call_GET(appUrl);
        }
        service.updateRequest = function(doc) {
            var appUrl = '/request-types';
            return call_PUT(appUrl, doc);
        }
        service.deleteRequest = function(id) {
            var appUrl = '/request-types/' + id;
            return call_DELETE(appUrl);
        }
        service.getForms = function() {
            var appUrl = '/forms/?page=0&size=1000';
            return call_GET(appUrl);
        }
        service.uploadForm = function(headerfile, lineitemfile, name, description) {
            var appUrl = '/forms?name=' + name + '&description=' + description;
            var form = new FormData();
            form.append('headerFile', headerfile);
            form.append('lineitemfile', lineitemfile);
            return $http.post(service.baseUrl + appUrl, form, {
                transformRequest: angular.identity,
                headers: {
                    'Content-Type': undefined
                }
            });
        }
        service.getRequestDocuments = function() {
            var appUrl = '/documents-requests/inbox';
            return call_GET(appUrl);
        }
        service.getRequestDocumentsDetails = function(requestId) {
            var appUrl = '/documents-requests/inbox/'+requestId ;
            return call_GET(appUrl);
        }

        service.getRequestGroupDoctypes = function() {
            var appUrl = '/requests/inbox';
            return call_GET(appUrl);
        }
        service.getAllInboxWorkitems = function(requestType, pageNumber, size) {
            var appUrl = '/requests/inbox/requestType/'+requestType+'?page='+pageNumber+'&size='+size;
            return call_GET(appUrl);
        }
        service.getInboxWorkitemInfo = function(requestType, requestId) {
            var appUrl = '/requests/inbox/requestType/'+requestType+'/requests/' + requestId;
            return call_GET(appUrl);
        }
        service.getRequestOutbox = function() {
            var appUrl = '/requests/outbox';
            return call_GET(appUrl);
        }
        service.getAllOutboxWorkitems = function(requestType, pageNumber, size, sortField) {
            if(sortField){
                var appUrl = '/requests/outbox/requestType/' + requestType+'?page='+pageNumber+'&size='+size+'&sortField='+sortField;
            }else{
                var appUrl = '/requests/outbox/requestType/' + requestType+'?page='+pageNumber+'&size='+size;
            }
            
            return call_GET(appUrl);
        }
        service.getOutboxWorkitemInfo = function(requestType, requestId) {
            var appUrl = '/requests/outbox/requestType/' + requestType + '/requests/' + requestId;
            return call_GET(appUrl);
        }
        ///mtr RequstType///
        service.getmtrlistitems = function(requestType) {
            var appUrl = '/requests/inbox/requests/'+requestType +'/list ';
            return call_GET(appUrl);
        }
        //////
        //mtr multiplerequest//
        service.selectMultipleApproval= function(dataApprover) {
            var appUrl = '/multiplerequests';
            return call_POST(appUrl, dataApprover);
        }
//Emailconfig//
service.getAllEmailConfig = function() {
    var appUrl = '/emailconfig';
    return call_GET(appUrl);
}
service.createEmailConfig= function(email) {
    var appUrl = '/emailconfig';
    return call_POST(appUrl, email);
}
service.updateEmailConfig = function(email) {
    var appUrl = '/emailconfig';
    return call_PUT(appUrl, email);
}
service.deleteEmailConfig = function(id) {
    var appUrl = '/emailconfig/' + id;
    return call_DELETE(appUrl);
}
//Do reports//
service.getAllDoaReports= function(pageNumber,pageSize) {
    var appUrl = '/reportConfiguration?page='+pageNumber+'&size='+pageSize;
    return call_GET(appUrl);
}
service.getAllhybridRquests= function() {
    var appUrl = '/request-types/type/Hybrid';
    return call_GET(appUrl);
}
service.createDoaReports= function(doa) {
    var appUrl = '/reportConfiguration';
    return call_POST(appUrl, doa);
}
service.updateDoaReports = function(doa) {
    var appUrl = '/reportConfiguration';
    return call_PUT(appUrl, doa);
}
service.deleteDoaReports = function(id) {
    var appUrl = '/reportConfiguration/' + id;
    return call_DELETE(appUrl);
}


service.getUsers = function(page,size) {
    var appUrl = '/users?page='+page+'&size='+size;
    return call_GET(appUrl);
}
//upload csv
service.getUploadCsv= function(attachmentfiles) {
    var appUrl = '/uploadCsv?collectionName=users';
    var form = new FormData();
    for(var prop in  attachmentfiles){
        form.append('file',attachmentfiles[prop]);
    }
   // return call_POST(appUrl);
   return $http.post(service.baseUrl + appUrl, form, {
    transformRequest: angular.identity,
    headers: {
        'Content-Type': undefined
    }
});
}
//approver level
service.getAllApproveLevel= function(page,size) {
    var appUrl = '/sap-approval-matrices?size='+size+'&page='+page;
    return call_GET(appUrl);
}
        //mtr adminconfg///
        service.getInboxConfgData= function(user) {
            var appUrl = '/requestui-config';
            return call_GET(appUrl);
        }
        service.createInboxConfg= function(user) {
            var appUrl = '/requestui-config';
            return call_POST(appUrl, user);
        }
        service.updateInboxConfg = function(user) {
            var appUrl = '/requestui-config';
            return call_PUT(appUrl, user);
        }
        service.deleteInboxConfg = function(id) {
            var appUrl = '/requestui-config/' + id;
            return call_DELETE(appUrl);
        }
        ///////
        service.sendFormData = function(json, attachmentfiles,primaryDocument) {
            var appUrl = '/requests';
            var form = new FormData();
            form.append('requestData',JSON.stringify(json))

//            attachmentfiles.forEach(function(item){
//               if(item.primaryDocument == 'X'){
//                 form.append('primaryDocument',item);
//               }
//               else{
//                 form.append('files',item);
//               }
//            });

         //   form.append('files',attachmentfiles[0]);
           for(var prop in  attachmentfiles){
              if(attachmentfiles[prop].name == primaryDocument.primary){
                form.append('primaryDocument',attachmentfiles[prop]);
                }
              else{
               form.append('files',attachmentfiles[prop]);
              }


             }
            return $http.post(service.baseUrl + appUrl, form, {
                transformRequest: angular.identity,
                headers: {
                    'Content-Type': undefined
                }
            });
        }

        service.updateRequestForm = function(headerfile,lineitemfile, name,id, description,json) {
            var appUrl = '/forms';
            var form = new FormData();
            form.append('id',id);
            form.append('name',name);
            form.append('description',description);
            form.append('headerFile', headerfile);
            form.append('lineitemfile', lineitemfile);
            form.append('formFieldsHeader',json);
            return $http.put(service.baseUrl + appUrl, form, {
                transformRequest: angular.identity,
                headers: {
                    'Content-Type': undefined
                }
            });

        }
        service.submitRequestResource = function(requestId, requestType, json, attachmentfiles) {
            var appUrl = '/requests/inbox/requestType/' + requestType + '/requests/' + requestId + '/submit';
            var form = new FormData();
            for (var prop in attachmentfiles) {
                form.append('files', attachmentfiles[prop]);
            }
            form.append('requestData', JSON.stringify(json));
            return $http.post(service.baseUrl + appUrl, form, {
                transformRequest: angular.identity,
                headers: {
                    'Content-Type': undefined
                    }
            });
        }
        service.submitBulkRequestResource = function(requestData, requestType, json, attachmentfiles) {
          var appUrl = '/requests/inbox/requestType/' + requestType + '/requests/submit';
          var form = new FormData();
          for (var prop in attachmentfiles) {
              form.append('files', attachmentfiles[prop]);
          }
          form.append('requestData',JSON.stringify(requestData));
          return $http.post(service.baseUrl + appUrl, form, {
              transformRequest: angular.identity,
              headers: {
                  'Content-Type': undefined
                  }
          });
      }
        service.getPermissionInbox = function(pageNumber,pageSize) {
            var appUrl = '/permissions/inbox?page=' + pageNumber + '&size=' +pageSize;
            return call_GET(appUrl);
        }
        service.getPermissionInboxFileDetails = function(permissionId, fileId) {
            var appUrl = '/permissions/inbox/' + permissionId + '/files/' + fileId
            return call_GET(appUrl);
        }
       /* service.approveRequest = function(permissionId) {
            var appUrl = '/permissions/inbox/approve/' + permissionId;
            return call_POST(appUrl);
        }
        service.rejectRequest = function(permissionId) {
            var appUrl = '/permissions/inbox/reject/' + permissionId;
            return call_POST(appUrl);
        }*/

        service.getSystemsettings = function(){
            var appUrl = '/systemSettings';
            return call_GET(appUrl);
        }
        service.getActvitys = function() {
            var appUrl = '/request-activities';
            return call_GET(appUrl);
        }
        service.createActivity = function(doc) {
            var appUrl = '/request-activities';
            return call_POST(appUrl, doc);
        }
        service.updateActivity = function(doc) {
            var appUrl = '/request-activities';
            return call_PUT(appUrl, doc);
        }
        service.deleteActivity = function(id) {
            var appUrl = '/request-activities/' + id;
            return call_DELETE(appUrl);
        }
        service.getHomePage = function() {
            var appUrl = '/users/dashbord';
            return call_GET(appUrl);
        }
        service.Filepermission = function(permission) {
            var appUrl = '/permissions';
            return call_POST(appUrl, permission);
        }
        service.getPermission = function(fileId) {
            var appUrl = '/permissions/' + fileId;
            return call_GET(appUrl);
        }
        // service.getFilePermissions = function(siteId,fileId) {
        //     var appUrl = '/sites/'+siteId+  '/files/'+fileId+'/permissions/';
        //     return call_GET(appUrl);
        // }
        service.getMyFilePermissions = function(siteId,fileId) {
            var appUrl = '/sites/'+siteId+  '/files/'+fileId+'/mypermissions/';
            return call_GET(appUrl);
        }
        service.Removepermission = function(id) {
            var appUrl = '/permissions/' + id;
            return call_DELETE(appUrl);
        }
        service.setInherited = function(siteId,fileId) {
            var appUrl = '/sites/'+ siteId +'/files/' + fileId + '/setInherited/';
            return call_POST(appUrl);
        }

        service.updateFilePermission = function(siteId, fileId, data) {
            var appUrl = '/sites/'+siteId+ '/files/'+fileId+'/permissions/';
            return call_PUT(appUrl, data);
        }

        service.ResetPassword = function(user,password) {
            var appUrl = '/account/change_password?password='+password+'&user='+user;
            return call_POST(appUrl, password);
        }
        service.getTemplates = function() {
            var appUrl = '/documentTemplate';
            return call_GET(appUrl);
        }
        service.CreateTemplate = function(template, file) {
            var appUrl = '/documentTemplate?name=' + template.name + '&description=' + template.description + '&documentType=' + template.documentType;
            var form = new FormData();
            form.append('file', file);
            return $http.post(service.baseUrl + appUrl, form, {
                transformRequest: angular.identity,
                headers: {
                    'Content-Type': undefined
                }
            });
        }
        service.DeleteTemplate = function(id) {
            var appUrl = '/documentTemplate/' + id;
            return call_DELETE(appUrl);
        }
        service.UpdateTemplate = function(template, file) {
            var appUrl = '/documentTemplate?id=' + template.id + '&description=' + template.description + '&documentType=' + template.documentType;
            var form = new FormData();
            form.append('file', file);
            return $http.put(service.baseUrl + appUrl, form, {
                transformRequest: angular.identity,
                headers: {
                    'Content-Type': undefined
                }
            });
        }
       service.sendCollaboration = function(requestId, requestType,user ,json,form) {
            var appUrl = '/collaborate?requestType='+requestType+'&requestID='+requestId+'&userName='+user+'&requestData='+encodeURIComponent(JSON.stringify(json));
                return $http.post(service.baseUrl + appUrl,form, {
                       transformRequest: angular.identity,
                       headers: {
                           'Content-Type': undefined
                       }
                   });
        }
        // user validation for coromandel
        service.getUservalidation = function(creater) {
            var appUrl = '/users/creator/'+creater;
            return call_GET(appUrl,creater);
        }
        service.getContractsAttribute = function(id) {
            var appUrl = '/documentTypesAtrribute/' + id;
            return call_GET(appUrl);
        }
        service.renewalFile =function(siteId,file){
            console.log(siteId,file.id);
        }
        service.getAllWorkflow = function() {
             var appUrl = '/wfb/getAll';
             return call_GET(appUrl);
        }
        service.getWorkflowById = function(id) {
            var appUrl = '/wfb/get/'+id;
            return call_GET(appUrl);
        }
        service.createWorkflow = function(json) {
            var appUrl = '/wfb/create';
            return call_POST(appUrl, json);
        }
        service.getListsByname = function(name) {
            var appUrl = '/getdynamicinstace/' + name;
            return call_GET(appUrl);
        }
        service.getApproveMatrices = function(){
            var appUrl ='/contratcs-approval-matrices';
            return call_GET(appUrl);
        }
        service.CreateApproveMatrice =function(approver){
            var appUrl ='/contratcs-approval-matrices';
            return call_POST(appUrl, approver);
        }
        service.UpdateApproveMatrice =function(ApprovalMatrice){
            var appUrl ='/contratcs-approval-matrices';
            return call_PUT(appUrl, ApprovalMatrice);
        }
        service.DeleteApproveMatice =function(Id){
             var appUrl = '/contratcs-approval-matrices/'+Id;
             return call_DELETE(appUrl);
        }
        service.getOrgUnits = function(){
            var appUrl = '/getinstace/Company';
            return call_GET(appUrl);
                    }
        service.getContractTypes=function(){
            var appUrl ='/getinstace/ContractTypes';
            return call_GET(appUrl);
        }
        service.getPermissionContractTypes=function(){
            var appUrl ='/getinstace/ContractTypes';
            return call_GET(appUrl);
        }
        service.getPermissions=function(){
            var appUrl ='/companypermission';
            return call_GET(appUrl);
        }
        service.CreatePermission = function(permission){
            var appUrl = '/companypermission';
             return call_POST(appUrl, permission);
        }
        service.UpdatePermission = function(permission){
            var appUrl = '/companypermission';
             return call_PUT(appUrl, permission);
        }
        service.Deletepermission =function(Id){
             var appUrl = '/companypermission/'+Id;
             return call_DELETE(appUrl);
        }
        service.getCompanyCodes = function(){
            var appUrl ='/companypermission/getmycompanies';
            return call_GET(appUrl);
        }
        service.getContractTypes = function(orgUnit){
            var appUrl ='/companypermission/getcontractType/' + orgUnit;
            return call_GET(appUrl);
        }


        service.sendToApprover = function(siteId,fileId){
            var appUrl = '/sites/' + siteId + '/sendtoapproval/' + fileId;
             return call_POST(appUrl);
        }
        //        Calls for System settings like smartstore & solr
        service.getSystemDetails = function(sysId){
            var appUrl = '/systemSettings/'+sysId;
            return call_GET(appUrl);
        }
        service.savingSolrDetails = function(data){
            var appUrl = '/systemSettings';
            return call_PUT(appUrl, data);
        }
        service.savingSmartstoreDetails = function(data){
            var appUrl = '/systemSettings';
            return call_PUT(appUrl, data);
        }
        service.savingSitedata = function(data){
            var appUrl = '/systemSettings';
            return call_PUT(appUrl, data);
        }

        // calls for substitution.
        service.getAllSubstitutes = function(){
            var appUrl = '/substitutions';
            return call_GET(appUrl);
        }
        service.createSubstitutor = function(data){
            var appUrl = '/substitutions';
            return call_POST(appUrl, data);
        }
        service.deleteSubstitutor = function(data){
            var appUrl = '/substitutions/'+ data.id;
            return call_DELETE(appUrl);
        }
        service.updateSubstitutor = function(data){
            var appUrl = '/substitutions';
            return call_PUT(appUrl, data);
        }
        service.FoldersOnly =function(id,file){
            var appUrl ='/sites/'+id+'/files/'+file.id+'/isFoldersOnly/?permission='+file.foldersOnly;
            return call_PUT(appUrl, file);
        }
        service.getFoldersOnly =function(siteId,file){
            var appUrl ='/sites/'+siteId+'/files/'+file.id+'/isFoldersOnly/?permission='+ file.foldersOnly;
            return call_GET(appUrl);
        }
        service.submitDocument =function(activity,ReqId){
            var appUrl ='/documents-requests/inbox/'+ReqId+'/activities/'+activity.actvity;
            return call_POST(appUrl, activity);
        }
        //Ticket Managamemnt

        service.getAllTickets = function(){
            var appUrl = '/requests';
            return call_GET(appUrl);
        }
        service.sendReply = function(description, requestId){
            var appUrl = '/requests/'+requestId+'?comment='+description;
            return call_PUT(appUrl);
        }
        service.getPayablesDashboard = function(){
            var appUrl='/payables/dashbord';
            return call_GET(appUrl);
        }
//        Calls for Zoho Reports.
        service.getAllZohoReports = function(){
            var appUrl = '/zohoReport';
            return call_GET(appUrl);
        }
        service.createZohoReport =function(data){
            var appUrl ='/zohoReport';
            return call_POST(appUrl, data);
        }
        service.updateZohoReport = function(data){
            var appUrl = '/zohoReport';
            return call_PUT(appUrl, data);
        }
        service.deletezohoReport  = function(data){
            var appUrl = '/zohoReport/'+data.id;
            return call_DELETE(appUrl);
        }

        //Request Type Details
        service.getAllRequestTypeDetails = function(){
            var appUrl = '/requestTypeDetails';
            return call_GET(appUrl);
        }
        service.createRequestType =function(data){
            var appUrl ='/requestTypeDetails';
            return call_POST(appUrl, data);
        }
        service.updateRequestDetails = function(data){
            var appUrl = '/requestTypeDetails';
            return call_PUT(appUrl, data);
        }
        service.deleteRequestDetails  = function(data){
            var appUrl = '/requestTypeDetails/'+data.id;
            return call_DELETE(appUrl);
        }
        service.getrequestbyquery = function(query){
            var appUrl = '/getrequestbyquery/'+ query ;
               return call_GET(appUrl);
           }
        service.getdocumentbyquery = function(query){
            var appUrl = '/getdocumentbyquery/'+ query ;
               return call_GET(appUrl);
           }

           service.getRequestIds = function(requestType, login){
           var appUrl = '/requests/'+requestType+'/'+login+'?page=0&size=1000';
            return call_GET(appUrl);
        }
        service.submitReAssignment = function(requestType, login,activity, array){
           var appUrl = '/reassign?requestType='+requestType+'&reassignUser='+login+'&activity='+activity+'&requestData='+array;
            return call_POST(appUrl);
        }
        service.getReports = function(flowType,pageNumber,size){
            var appUrl = '/requests/initiatereports?page='+pageNumber+'&size='+size+'&flowType='+flowType;
            return call_GET(appUrl);
          }
          service.getDOAReports = function(requestData,pageNumber,pagesize){
            var appUrl = '/doa/requestSearch?page='+pageNumber+'&size='+pagesize;
            return call_POST(appUrl,requestData);
          }
          service.getDocbufferList =function(status){
            var appUrl ='/requests/status/'+status;
            return call_GET(appUrl);
          }
          //Matrial Data

          service.GetMaterialTypes=function(){
            var appUrl='/material_type/'+null +'/'+null +'/getlistdatabysearch';
            return call_POST(appUrl);
        }
        service.GetPlants=function(){
            var appUrl='/plant_unit/'+null +'/'+null +'/getlistdatabysearch';
            return call_POST(appUrl);
        }
        service.getDocTypes=function(type){
            var appUrl='/'+type+'/'+null +'/'+null +'/getlistdatabysearch';
            return call_POST(appUrl);
        }
        service.getCategory=function(){
            var appUrl='/item_category/'+null +'/'+null +'/getlistdatabysearch';
            return call_POST(appUrl);

        }
        service.getAccountAssCategory=function(){
            var appUrl='/account_assigning/'+null +'/'+null +'/getlistdatabysearch';
            return call_POST(appUrl);

        }
        service.getLisBySearch =function(search,page,size){
            var appUrl ='/materailSearch?page='+page+'&size='+size;
            return call_POST(appUrl,search);

        }
        service.getGLDataBySearch=function(search,page,size){
            if(search.value ==undefined){
                search.value =null;
            }
            var appUrl='/gl_account/'+search.key +'/'+ search.value+'/getlistdatabysearch?page='+page+'&size='+size;
            return call_POST(appUrl,search);

        }
        service.getPODataBySearch=function(search,page,size){
            if(search.value ==undefined){
                search.value =null;
            }
            var appUrl='/PODataDispatch/'+search.key +'/'+ search.value+'/getlistdatabysearch?page='+page+'&size='+size;
            return call_POST(appUrl,search);

        }
        service.getCostCenterData=function(search,page,size){
            if(search.value ==undefined){
                search.value =null;
            }
            var appUrl='/cost_center/'+search.key +'/'+search.value +'/getlistdatabysearch?page='+page+'&size='+size;
            return call_POST(appUrl,search);

        }
        service.getFormData =function(form){
          var appUrl ='/forms/'+form.formId;
            return call_GET(appUrl);
        }
        service.getAssetCodeData=function(search,page,size){
            if(search.value ==undefined ||search.value == ""){
                search.value =null;
            }
            var appUrl='/asset_code/'+search.key +'/'+search.value +'/getlistdatabysearch?page='+page+'&size='+size;
            return call_POST(appUrl,search);

        }
        service.getFundDataBySearch=function(search,page,size){
            if(search.value ==undefined ||search.value == ""){
                search.value =null;
            }
            var appUrl='/fund_master/'+search.key +'/'+search.value +'/getlistdatabysearch?page='+page+'&size='+size;
            return call_POST(appUrl,search);
        }
        service.getWBSDataBySearch=function(search,page,size){
            if(search.value ==undefined ||search.value == ""){
                search.value =null;
            }
            var appUrl='/wbs_element/'+search.key +'/'+search.value +'/getlistdatabysearch?page='+page+'&size='+size;
            return call_POST(appUrl,search);
        }
        service.getFuncationalDataBySearch=function(search,page,size){
            if(search.value ==undefined ||search.value == ""){
                search.value =null;
            }
            var appUrl='/functional_area/'+search.key +'/'+search.value +'/getlistdatabysearch?page='+page+'&size='+size;
            return call_POST(appUrl,search);
        }
        service.getorderDataBySearch=function(search,page,size){
            if(search.value ==undefined ||search.value == ""){
                search.value =null;
            }
            var appUrl='/order_number/'+search.key +'/'+search.value +'/getlistdatabysearch?page='+page+'&size='+size;
            return call_POST(appUrl,search);
        }
        service.getItemDetails =function(search){
            var appUrl ="/"+search.listname+"/"+search.listvar+"/"+search.value+"/getlistdatabysearch";
            return call_POST(appUrl,search)
        }
        service.getuomDataBySearch=function(search,page,size){
            if(search.value ==undefined ||search.value == ""){
                search.value =null;
            }
            var appUrl='/measurement_unit/'+search.key +'/'+search.value +'/getlistdatabysearch?page='+page+'&size='+size;
            return call_POST(appUrl,search);
        }
        service.getCompanyataBySearch=function(search,page,size){
            if(search.value ==undefined ||search.value == ""){
                search.value =null;
            }
            var appUrl='/Companycode/'+search.key +'/'+search.value +'/getlistdatabysearch?page='+page+'&size='+size;
            return call_POST(appUrl,search);
        }
        service.getvendordataBySearch=function(search,page,size){
            if(search.value ==undefined ||search.value == ""){
                search.value =null;
            }
            var appUrl='/Vendorcodes/'+search.key +'/'+search.value +'/getlistdatabysearch?page='+page+'&size='+size;
            return call_POST(appUrl,search);
        }
        service.getProfitCenterdataBySearch=function(search,page,size){
            if(search.value ==undefined ||search.value == ""){
                search.value =null;
            }
            var appUrl='/PROFITCENTERDATA/'+search.key +'/'+search.value +'/getlistdatabysearch?page='+page+'&size='+size;
            return call_POST(appUrl,search);
        }
        /*emailBuffer*/
        service.getAllEmailBuffers = function(pageNumber,size){
            var appUrl = '/emails/'+pageNumber+'/'+size;
            return call_GET(appUrl);
          }
          service.searchAllEmailBuffers = function(data,pageNumber,size){
            var appUrl = '/emails?pageNumber='+pageNumber+'&pageSize='+size;
            return call_POST(appUrl,data);
          }
        //vendoruserData
        service.getEMPLOYEEDATABySearch=function(search,page,size){
            if(search.value ==undefined ||search.value == ""){
                search.value =null;
            }
            var appUrl='/EMPLOYEEDATA/'+search.key +'/'+search.value +'/getlistdatabysearch?page='+page+'&size='+size;
            return call_POST(appUrl,search);
        }
        service.getMaterialgroupDataBySearch=function(search,page,size){
            if(search.value ==undefined ||search.value == ""){
                search.value =null;
            }
            var appUrl='/material_group/'+search.key +'/'+search.value +'/getlistdatabysearch?page='+page+'&size='+size;
            return call_POST(appUrl,search);
        }
        service.getAllList=function(search,url,page,size){
            if(search.value ==undefined ||search.value == ""){
                search.value =null;
            }
            var appUrl='/'+url+'/'+search.key +'/'+search.value +'/getlistdatabysearch?page='+page+'&size='+size;
            return call_POST(appUrl,search);
        }
        service.getAllCodingTemplates =function(doctype,page,size){
          var appUrl ='/coding-templates/reqType/'+doctype;
            return call_GET(appUrl);
        }
        service.getAdminReports = function(data,pageNumber,size,flowType){
            var appUrl = '/requestSearch?page='+pageNumber+'&size='+size+'&flowType='+flowType;
            return call_POST (appUrl, data);
          }
           service.getAdminPARReports = function(data,pageNumber,size){
            var appUrl = '/requestSearch?page='+pageNumber+'&size='+size;
            return call_POST (appUrl, data);
          }
          service.getBlockList =function(data){
              var appUrl ='/getdynamicinstace/'+data;
              return call_GET(appUrl);
          }
          //analyticMatrix
          service.getanalyticReports=function(data,filename){
            var appUrl ='/requestslogsearch/'+filename;
            return call_POST(appUrl, data);
        }

//Aproval matrix
          service.getAllApprovalmatrix = function(){
            var appUrl = '/approval-matrices';
            return call_GET(appUrl);
        }

          service.getAllApprovalmatrixByType = function(type){
            var appUrl = '/approval-matrices/{type}?type='+type;
            return call_GET(appUrl);
        }
          service.createApprovalmatrix =function(data){
            var appUrl ='/approval-matrices';
            return call_POST(appUrl, data);
        }
         service.UpdateApprovalmatrix =function(data){
            var appUrl='/approval-matrices';
            return call_PUT(appUrl,data);

          }
         service.deleteApprovalMatrix  = function(id){
            var appUrl = '/approval-matrices/'+id;
            return call_DELETE(appUrl);
        }

        service.getAccountInstance =function(doctype){
          var appUrl ='/listbyname/'+doctype;
            return call_GET(appUrl);
        }
        service.getDyamicDataBySearch=function(gldata,search,page,size){
            if(search.value ==undefined){
                search.value =null;
            }
            var appUrl='/'+gldata+'/'+search.key +'/'+ search.value+'/getlistdatabysearch?page='+page+'&size='+size;
            return call_POST(appUrl,search);

        }
        service.getlistDataBylistName =function(listName){
                var appUrl ='/getinstace/'+listName
                return call_GET(appUrl);
        }
        service.getSystemlogs=function(logObject,page,size){
            var appUrl='/loggedInRecords?page='+page+'&size='+size
            return call_POST(appUrl, logObject);
        }

        function call_GET(appUrl) {
            return $http.get(service.baseUrl + appUrl);
        }
        function call_POST(appUrl, userData) {
            return $http.post(service.baseUrl + appUrl, userData);
        }
        function call_DELETE(appUrl) {
            return $http.delete(service.baseUrl + appUrl);
        }
        function call_PUT(appUrl, userData) {
            return $http.put(service.baseUrl + appUrl, userData);
        }
        return service;
    }

})();

   // var baseUrl="http://10.101.2.113:8080/payables-server";
  // var baseUrl = "https://dev-spay.smartdocsnow.com/payables-server";
    //  var baseUrl="https://sscportal.coromandel.biz/payables-server";
    //  var baseUrl="http://192.168.2.57/payables-server";
    // var baseUrl="http://192.168.227.6/payables-server"; 
    //  var baseUrl="https://sscportaltest.coromandel.biz/payables-server";
        // var baseUrl="http://192.168.227.6/payables-server";
(function () {
    'use strict';

    angular
        .module('smartportal')
        .factory('AuthenticationService', Service)
        .value("LoggedInUserToken", {value: ""})
        .value("LoggedInUserId", {value: ""});

    function Service($http, $localStorage, $sessionStorage, $rootScope, LoggedInUserId, LoggedInUserToken,$templateCache,$cookies) {
        var service = {};

        
        service.Login = Login;
        service.Logout = Logout;
       // service.GetLoggedInUser = GetLoggedInUser;
      
        return service;

        function Login(username, password, callback) {
            var response;
            //https://peoplecornerbe.smartdocsnow.com/smartportal-server 
            $http.post(baseUrl +'/api/authenticate?encoded=true', { 
                username: username, 
                password: password,
                rememberMe:true
             }).then(
                    function(success){
                        //login successful if there's a token in the response
                        if (success.data.id_token) {

                            LoggedInUserId.value = username;
                            LoggedInUserToken.value = success.data.id_token;
                            
                            // store username and token in local storage to keep user logged in between page refreshes
                            //$localStorage.currentUser = { username: username, token: success.data.id_token };

                           $localStorage.currentUser = { username: username, token: success.data.id_token };
                        $sessionStorage.currentUser = { username: username, token: success.data.id_token };

                            // add jwt token to auth header for all requests made by the $http service
                            $http.defaults.headers.common.Authorization = 'Bearer ' + success.data.id_token;
                        $rootScope.loggedInUser = username;
                            // execute callback with true to indicate successful login
                            response = { success: true, message: 'successful login' };
                            callback(response);
                        }                       
                    }, 
                    function(error){
                        //Unauthorized 401 error
                        response = { success: false, message: 'ERROR : Username or password do not match !' };
                        callback(response);
                    });

               
        }

        
         function Logout() {
            // remove user from local storage and clear http auth header
            delete $sessionStorage.currentUser;
            delete $localStorage.currentUser;
            $http.defaults.headers.common.Authorization = '';
            delete window.localStorage['ngStorage-logedInuserdetail'];
            delete window.localStorage['ngStorage-currentUser'];
          // $templateCache.removeAll();            
            var cookies = $cookies.getAll();
            angular.forEach(cookies, function (v, k) {
                $cookies.remove(k);
            });
        }


    }
})();
(function ()
{
    'use strict';

    angular
        .module('smartportal')
        .run(runBlock)
        .value("CurrentBinderId", {value: ""})
        .config(config);
    /** @ngInject */
    function runBlock($rootScope, $timeout, $state, $localStorage, $sessionStorage, $location,Idle, $http,$mdDialog, LoggedInUserId,AuthenticationService, LoggedInUserToken, CurrentBinderId, RestAPIService)
    {
        // if(navigator.vendor != "Google Inc."){
        //     alert('This Application Supports Only Chrome Browser.');
        //     $rootScope.notChromeBrowser = true;
        // }
        // Activate loading indicator
        var stateChangeStartEvent = $rootScope.$on('$stateChangeStart', function ()
        {
            // $rootScope.loadingProgress = true;
        });

        // De-activate loading indicator
        var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', function ()
        {
            $timeout(function ()
            {
                // $rootScope.loadingProgress = false;
            });
        });

        // Store state in the root scope for easy access
        $rootScope.state = $state;

        // Cleanup
        $rootScope.$on('$destroy', function ()
        {
            stateChangeStartEvent();
            stateChangeSuccessEvent();
        });



        // keep user logged in after page refresh
        if ($localStorage.currentUser) {           
            $http.defaults.headers.common.Authorization = 'Bearer ' + $localStorage.currentUser.token;            
            RestAPIService.UserDetails().then(function(responce){
               
            }, function(error){
                delete $sessionStorage.currentUser;
                delete $localStorage.currentUser;
                delete $localStorage.language;
                $http.defaults.headers.common.Authorization = '';
                delete window.localStorage['branddata'];
                delete window.localStorage['ngStorage-logedInuserdetail'];
                delete window.localStorage['ngStorage-currentUser'];
                $state.go('login');
            })
        }


        $rootScope.$on('$locationChangeStart', function (event, next, current) {

            var publicPages = ['/login','/smartportal/social_login'];

            var userId = $location.search().userId;
            var binderId = $location.search().binderId;
            //Get the login token for userId for binder URLs coming from Success Factor
            if($location.path().indexOf('binder') != -1 && userId){

                $http.get(baseUrl +"/api/signin?userId="+userId).then(
                    function(success) {
                        if (success.data.id_token) {
                            LoggedInUserId.value = userId;
                            LoggedInUserToken.value = success.data.id_token;
                            CurrentBinderId.value = binderId;
                            //alert(CurrentBinderId.value);
                            // store username and token in local storage to keep user logged in between page refreshes
                            $sessionStorage.currentUser = { username: userId, token: success.data.id_token };
                             $localStorage.currentUser = { username: userId, token: success.data.id_token };


                            // add jwt token to auth header for all requests made by the $http service
                            $http.defaults.headers.common.Authorization = 'Bearer ' + success.data.id_token;

                            $rootScope.loggedInUser = userId;

                            // Redirect to binder page after successful login
                            $location.path('/binder');
                        }
                    },
                    function(error) {
                        //alert(error.status);
                        $location.path('/login');
                    }
                );

            }

            // redirect to login page if not logged in and trying to access a restricted page
           var restrictedPage = publicPages.indexOf($location.path()) === -1;
             if (restrictedPage && !$localStorage.currentUser) {
                $rootScope.postLoginRoute = $location.path();
                if($location.path().indexOf("/smartportal/reset/finish/") > -1){
                    $location.path();
                } else {
                     $location.path('/login');
                }
            }
            // if($localStorage.currentUser != undefined && $localStorage.currentUser.token != undefined){
            //     if($location.path().indexOf("/login") > -1){
            //         $location.path('/overview');
            //     }
            // }



        });

        $rootScope.$on('IdleStart', function() {
            // the user appears to have gone idle
            // console.log('idlestart start');
        });

        $rootScope.$on('IdleWarn', function(e, countdown) {
            // follows after the IdleStart event, but includes a countdown until the user is considered timed out
            // the countdown arg is the number of seconds remaining until then.
            // you can change the title or display a warning dialog from here.
            // you can let them resume their session by calling Idle.watch()
            // console.log('idlewarn start');
        });

        $rootScope.$on('IdleTimeout', function() {
            // the user has timed out (meaning idleDuration + timeout has passed without any activity)
            // this is where you'd log them out

            // Do logout here..
            $localStorage.loginWithSmartDocs='';                
            AuthenticationService.Logout();
            $state.go('login');
            
            $mdDialog.show(
              $mdDialog.alert()
                .parent(angular.element(document.querySelector('#popupContainer')))
                .clickOutsideToClose(true)
                .title('Alert')
                .textContent('Your session has expired. Please log in again.')
                .ariaLabel('Alert Dialog Demo')
                .ok('Ok')
                // .targetEvent(ev)
            );            
        });

        $rootScope.$on('IdleEnd', function() {
            // the user has come back from AFK and is doing stuff. if you are warning them, you can use this to hide the dialog
            console.log('idleend. Means, the user came back.');
        });

        $rootScope.$on('Keepalive', function() {
            // do something to keep the user's session alive
        }); 

    }
    function config($mdDateLocaleProvider, IdleProvider, KeepaliveProvider) {       
        // configure Idle settings
        IdleProvider.idle(1); // in seconds
        IdleProvider.timeout(900); // in seconds
        KeepaliveProvider.interval(2); // in seconds      
        
    }
})();

(function ()
{
    'use strict';

    angular
        .module('smartportal')
        .config(routeConfig)
       // .run(run);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider, $locationProvider)
    {
        $locationProvider.html5Mode(false);

        $urlRouterProvider.otherwise('/inbox');

        /**
         * Layout Style Switcher
         *
         * This code is here for demonstration purposes.
         * If you don't need to switch between the layout
         * styles like in the demo, you can set one manually by
         * typing the template urls into the `State definitions`
         * area and remove this code
         */
        // Inject $cookies
        var $cookies;

        angular.injector(['ngCookies']).invoke([
            '$cookies', function (_$cookies)
            {
                $cookies = _$cookies;
            }
        ]);

        // Get active layout
        var layoutStyle = $cookies.get('layoutStyle') || 'verticalNavigation';

        var layouts = {
            verticalNavigation  : {
                main      : 'app/core/layouts/vertical-navigation.html',
                toolbar   : 'app/toolbar/layouts/vertical-navigation/toolbar.html',
                navigation: 'app/navigation/layouts/vertical-navigation/navigation.html'
            },
            // verticalNavigationFullwidthToolbar  : {
            //     main      : 'app/core/layouts/vertical-navigation-fullwidth-toolbar.html',
            //     toolbar   : 'app/toolbar/layouts/vertical-navigation-fullwidth-toolbar/toolbar.html',
            //     navigation: 'app/navigation/layouts/vertical-navigation/navigation.html'
            // },
            // verticalNavigationFullwidthToolbar2  : {
            //     main      : 'app/core/layouts/vertical-navigation-fullwidth-toolbar-2.html',
            //     toolbar   : 'app/toolbar/layouts/vertical-navigation-fullwidth-toolbar-2/toolbar.html',
            //     navigation: 'app/navigation/layouts/vertical-navigation-fullwidth-toolbar-2/navigation.html'
            // },
            // horizontalNavigation: {
            //     main      : 'app/core/layouts/horizontal-navigation.html',
            //     toolbar   : 'app/toolbar/layouts/horizontal-navigation/toolbar.html',
            //     navigation: 'app/navigation/layouts/horizontal-navigation/navigation.html'
            // },
            contentOnly         : {
                main      : 'app/core/layouts/content-only.html',
                toolbar   : '',
                navigation: ''
            },
            contentWithToolbar  : {
                main      : 'app/core/layouts/content-with-toolbar.html',
                toolbar   : 'app/toolbar/layouts/content-with-toolbar/toolbar.html',
                navigation: ''
            }
        };
        // END - Layout Style Switcher

        // State definitions
        $stateProvider
            .state('app', {
                abstract: true,
                views   : {
                    'main@'         : {
                        templateUrl: layouts[layoutStyle].main,
                        controller : 'MainController as vm'
                    },
                    'toolbar@app'   : {
                        templateUrl: layouts[layoutStyle].toolbar,
                        controller : 'ToolbarController as vm'
                    },
                    'navigation@app': {
                        templateUrl: layouts[layoutStyle].navigation,
                        controller : 'NavigationController as vm'
                    },
                    'quickPanel@app': {
                        templateUrl: 'app/quick-panel/quick-panel.html',
                        controller : 'QuickPanelController as vm'
                    }
                }
            })
             .state('login', {
                url: '/login',
                views   : {
                    'main@' : {
                        templateUrl: 'app/core/layouts/content-only.html',
                        controller : 'MainController as vm'
                    },
                    'content@login': {
                        templateUrl: 'app/main/login/login.html',
                        controller : 'LoginController'
                    }
                },
                bodyClass: 'login'
            });
    }


   
})();

(function ()
{
    'use strict';

    angular
        .module('smartportal')
        .controller('IndexController', IndexController);

    /** @ngInject */
    function IndexController(fuseTheming)
    {
        var vm = this;

        // Data
        vm.themes = fuseTheming.themes;

        //////////
    }
})();
(function ()
{
    'use strict';

    angular
        .module('smartportal');
})();

(function ()
{
    'use strict';

    angular
        .module('smartportal')
        .config(config);

    /** @ngInject */
    function config($mdThemingProvider)
    {
        // Put your custom configurations here
        $mdThemingProvider.theme('red').backgroundPalette('red');
        $mdThemingProvider.theme('pink').backgroundPalette('pink');
        $mdThemingProvider.theme('purple').backgroundPalette('purple');
        $mdThemingProvider.theme('deep-purple').backgroundPalette('deep-purple');
        $mdThemingProvider.theme('indigo').backgroundPalette('indigo');
        $mdThemingProvider.theme('blue').backgroundPalette('blue');
        $mdThemingProvider.theme('light-blue').backgroundPalette('light-blue');
        $mdThemingProvider.theme('cyan').backgroundPalette('cyan');
        $mdThemingProvider.theme('teal').backgroundPalette('teal');
        $mdThemingProvider.theme('green').backgroundPalette('green');
        $mdThemingProvider.theme('light-green').backgroundPalette('light-green');
        $mdThemingProvider.theme('lime').backgroundPalette('lime');
        $mdThemingProvider.theme('yellow').backgroundPalette('yellow');
        $mdThemingProvider.theme('amber').backgroundPalette('amber');
        $mdThemingProvider.theme('orange').backgroundPalette('orange');
        $mdThemingProvider.theme('deep-orange').backgroundPalette('deep-orange');
        $mdThemingProvider.theme('brown').backgroundPalette('brown');
        $mdThemingProvider.theme('grey').backgroundPalette('grey');
        $mdThemingProvider.theme('blue-grey').backgroundPalette('blue-grey');

    }

})();
(function ()
{
    'use strict';

    angular
        .module('smartportal')
        .factory('api', apiService);

    /** @ngInject */
    function apiService($resource)
    {
        /**
         * You can use this service to define your API urls. The "api" service
         * is designed to work in parallel with "apiResolver" service which you can
         * find in the "app/core/services/api-resolver.service.js" file.
         *
         * You can structure your API urls whatever the way you want to structure them.
         * You can either use very simple definitions, or you can use multi-dimensional
         * objects.
         *
         * Here's a very simple API url definition example:
         *
         *      api.getBlogList = $resource('http://api.example.com/getBlogList');
         *
         * While this is a perfectly valid $resource definition, most of the time you will
         * find yourself in a more complex situation where you want url parameters:
         *
         *      api.getBlogById = $resource('http://api.example.com/blog/:id', {id: '@id'});
         *
         * You can also define your custom methods. Custom method definitions allow you to
         * add hardcoded parameters to your API calls that you want to sent every time you
         * make that API call:
         *
         *      api.getBlogById = $resource('http://api.example.com/blog/:id', {id: '@id'}, {
         *         'getFromHomeCategory' : {method: 'GET', params: {blogCategory: 'home'}}
         *      });
         *
         * In addition to these definitions, you can also create multi-dimensional objects.
         * They are nothing to do with the $resource object, it's just a more convenient
         * way that we have created for you to packing your related API urls together:
         *
         *      api.blog = {
         *                   list     : $resource('http://api.example.com/blog'),
         *                   getById  : $resource('http://api.example.com/blog/:id', {id: '@id'}),
         *                   getByDate: $resource('http://api.example.com/blog/:date', {id: '@date'}, {
         *                       get: {
         *                            method: 'GET',
         *                            params: {
         *                                getByDate: true
         *                            }
         *                       }
         *                   })
         *       }
         *
         * If you look at the last example from above, we overrode the 'get' method to put a
         * hardcoded parameter. Now every time we make the "getByDate" call, the {getByDate: true}
         * object will also be sent along with whatever data we are sending.
         *
         * All the above methods are using standard $resource service. You can learn more about
         * it at: https://docs.angularjs.org/api/ngResource/service/$resource
         *
         * -----
         *
         * After you defined your API urls, you can use them in Controllers, Services and even
         * in the UIRouter state definitions.
         *
         * If we use the last example from above, you can do an API call in your Controllers and
         * Services like this:
         *
         *      function MyController (api)
         *      {
         *          // Get the blog list
         *          api.blog.list.get({},
         *
         *              // Success
         *              function (response)
         *              {
         *                  console.log(response);
         *              },
         *
         *              // Error
         *              function (response)
         *              {
         *                  console.error(response);
         *              }
         *          );
         *
         *          // Get the blog with the id of 3
         *          var id = 3;
         *          api.blog.getById.get({'id': id},
         *
         *              // Success
         *              function (response)
         *              {
         *                  console.log(response);
         *              },
         *
         *              // Error
         *              function (response)
         *              {
         *                  console.error(response);
         *              }
         *          );
         *
         *          // Get the blog with the date by using custom defined method
         *          var date = 112314232132;
         *          api.blog.getByDate.get({'date': date},
         *
         *              // Success
         *              function (response)
         *              {
         *                  console.log(response);
         *              },
         *
         *              // Error
         *              function (response)
         *              {
         *                  console.error(response);
         *              }
         *          );
         *      }
         *
         * Because we are directly using $resource service, all your API calls will return a
         * $promise object.
         *
         * --
         *
         * If you want to do the same calls in your UI Router state definitions, you need to use
         * "apiResolver" service we have prepared for you:
         *
         *      $stateProvider.state('app.blog', {
         *          url      : '/blog',
         *          views    : {
         *               'content@app': {
         *                   templateUrl: 'app/main/apps/blog/blog.html',
         *                   controller : 'BlogController as vm'
         *               }
         *          },
         *          resolve  : {
         *              Blog: function (apiResolver)
         *              {
         *                  return apiResolver.resolve('blog.list@get');
         *              }
         *          }
         *      });
         *
         *  You can even use parameters with apiResolver service:
         *
         *      $stateProvider.state('app.blog.show', {
         *          url      : '/blog/:id',
         *          views    : {
         *               'content@app': {
         *                   templateUrl: 'app/main/apps/blog/blog.html',
         *                   controller : 'BlogController as vm'
         *               }
         *          },
         *          resolve  : {
         *              Blog: function (apiResolver, $stateParams)
         *              {
         *                  return apiResolver.resolve('blog.getById@get', {'id': $stateParams.id);
         *              }
         *          }
         *      });
         *
         *  And the "Blog" object will be available in your BlogController:
         *
         *      function BlogController(Blog)
         *      {
         *          var vm = this;
         *
         *          // Data
         *          vm.blog = Blog;
         *
         *          ...
         *      }
         */

        var api = {};

        // Base Url
        api.baseUrl = 'app/data/';

        // api.sample = $resource(api.baseUrl + 'sample/sample.json');

        return api;
    }

})();
(function ()
{
    'use strict';

    angular
        .module('smartportal')
        .factory('CommonUtil', CommonUtil);

    /** @ngInject */
    function CommonUtil(RestAPIService)
    {
        var service = {};

        service.getIconForFile = function(file){
          var icon ={};
          if(file.type == "folder"){
                icon = "icon-folder";
            }                        
            else if(file.name.indexOf("jpg")!= -1){
                icon = "icon-file-image";
            }
            else if(file.name.indexOf("jpeg")!= -1){
                icon = "icon-file-image";
            }
            else if(file.name.indexOf("png")!= -1){
                icon = "icon-file-image";
            }
            else if(file.name.indexOf("pdf")!= -1){
                icon = "icon-file-pdf-box";
            }
            else if(file.name.indexOf("txt")!= -1){
                icon = "icon-clipboard-text";
            }
            else if(file.name.indexOf("html")!= -1){
                icon = "icon-language-html5";
            }
            else if(file.name.indexOf("xl")!= -1){
                icon = "icon-file-excel";
            }
            else if(file.name.indexOf("word")!= -1){
                icon = "icon-file-word";
            }
            else if(file.name.indexOf("xml")!= -1){
                icon = "icon-file-xml";
            }
            else if(file.name.indexOf("doc")!= -1){
                icon = "icon-file-document";
            }  
            else if(file.name.indexOf("docx")!= -1){
                icon = "icon-file-document";
            }
            else if(file.name.indexOf("json")!= -1){
                icon = "icon-clipboard-text";
            }                      

            else{
                icon = "icon-file-document";
            }
            return icon;
        }
        service.generateSAPDate =function(date){
            var selectedDate = date;
            var month  = selectedDate.getMonth();
            if(month == 9){
              month=month+1;
            }
            if(month<9){
              month = month+1;
              month = "0"+(month.toString());
            }
            var newDate = selectedDate.getDate();
            if(newDate<=9){
                newDate = "0"+(newDate.toString());
            }
            return selectedDate = selectedDate.getFullYear().toString()+month+newDate;
        }

        service.generatePortalDate =function(date){
            var SelectedDate =date.substring(4,6)+'-'+date.substring(6,8)+'-'+date.substring(0,4);
            SelectedDate =moment(SelectedDate);
            return SelectedDate;
        }
      
         service.downloadFile=function(ReqId,archiveId,archiveDocId,attachment){     
            if(attachment.fileType) var fileName =attachment.fileName+ '.'+attachment.fileType;   
            else var fileName =attachment.fileName;   
          RestAPIService.downloadAttachment(ReqId,archiveId,archiveDocId).then(
           function(success) { 
                   var headers = success.headers();                       
                   var data = success.data;                        
                   var filename = fileName;
                   var contentType = headers['content-type'];
                   var linkElement = document.createElement('a');
                   try {
                       var blob = new Blob([data], { type: contentType });
                       var url = window.URL.createObjectURL(blob);
                       linkElement.setAttribute('href', url);
                       linkElement.setAttribute("download", filename);
                       var clickEvent = new MouseEvent("click", {
                           "view": window,
                           "bubbles": true,
                           "cancelable": false
                       });
                       linkElement.dispatchEvent(clickEvent);
                   } catch (ex) {
                       console.log(ex);
                   }
           },
           function(error) {
               console.log('ERROR Downloading the file ********');
               RestAPIService.showErrorDialog(error);
           }
       );
        }
        service.downloaddirectFile=function(attachment){     
            if(attachment.fileType) var fileName =attachment.fileName+ '.'+attachment.fileType;   
            else var fileName =attachment.fileName;   
          RestAPIService.downloadAttachmentdirectly(attachment.url).then(
           function(success) { 
                   var headers = success.headers();                       
                   var data = success.data;                        
                   var filename = fileName;
                   var contentType = headers['content-type'];
                   var linkElement = document.createElement('a');
                   try {
                       var blob = new Blob([data], { type: contentType });
                       var url = window.URL.createObjectURL(blob);
                       linkElement.setAttribute('href', url);
                       linkElement.setAttribute("download", filename);
                       var clickEvent = new MouseEvent("click", {
                           "view": window,
                           "bubbles": true,
                           "cancelable": false
                       });
                       linkElement.dispatchEvent(clickEvent);
                   } catch (ex) {
                       console.log(ex);
                   }
           },
           function(error) {
               console.log('ERROR Downloading the file ********');
               RestAPIService.showErrorDialog(error);
           }
       );
        }
        return service;
    }

})();
angular
    .module("GlobalModule", [])
    .filter("unique", function() { 
        // we will return a function which will take in a collection
        // and a keyname
        return function(collection, keyname) {
          // we define our output and keys array;
          var output = [],
            keys = [];      
          // we utilize angular's foreach function
          // this takes in our original collection and an iterator function
          angular.forEach(collection, function(item) {
            // we check to see whether our object exists
            var key = item[keyname];
            // if it's not already part of our keys array
            if (keys.indexOf(key) === -1) {
              // add it to our keys array
              keys.push(key);
              // push this item to our final output array
              output.push(item);
            }
          });
          // return our array which should be devoid of
          // any duplicates
          return output;
        };
    })
    .filter('capitalize', function() {
      return function(input) {
        return (angular.isString(input) && input.length > 0) ? input.charAt(0).toUpperCase() + input.substr(1).toLowerCase() : input;
      }
  });;
(function() {
    'use strict';

	angular.module('app.reset', [ 'app.reset.password' ]).config(config);

	function config() {
	}
})();
(function ()
{
    'use strict';

    angular
        .module('app.mycontent', [
            'app.mycontent.inbox',
            'app.mycontent.outbox',
            'app.mycontent.emailApprovals',
            'angular-timeline',
            'app.coromandelinbox',
            'material.components.expansionPanels'
        ])
        .config(config)
        .run(run);


    /** @ngInject */
    function config(msNavigationServiceProvider,$translatePartialLoaderProvider)
    {
         $translatePartialLoaderProvider.addPart('app/main/mycontent');
      /* msNavigationServiceProvider.saveItem('mycontent', {
            title : 'Inbox  ',
            icon  : 'icon-email',
            state : 'app.mycontent_inbox',
            weight: 2,
             hidden: function() {
                 if ($localStorage.menubarsetting != undefined) {
                     var show = $localStorage.menubarsetting.inbox;
                     return !(show);
                 }
                }
        });*/



    }
function run(msNavigationService, $localStorage, $rootScope, $state) {
        // Navigation
         $rootScope.$state = $state;
         msNavigationService.saveItem('mycontent', {
             title: 'Inbox',
             icon: 'icon-email',
             state: 'app.mycontent_inbox',
             translate:'NAV.INBOX',
             weight: 2,
             /*
             hidden: function() {
                 if ($localStorage.menubarsetting != undefined) {
                     var show = $localStorage.menubarsetting.inbox;
                     return !(show);
                 }
                }*/
         });
    }
    // function run(msNavigationService, $localStorage, $rootScope, $state) {
    //   $rootScope.$state = $state;
    //      msNavigationService.saveItem('mycontent', {
    //          title: 'outbox',
    //          icon: 'icon-email',
    //          state: 'app.mycontent_outbox',
    //          translate:'NAV.OutBOX',
    //          weight: 10
          
    //      });
    // }
})();

(function ()
{
    'use strict';

    angular
        .module('app.createform', []).config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.createform', {
               // abstract: true,
                url     : '/createform',
                 views    : {
                    'content@app': {
                        templateUrl: 'app/main/pages/errors/404/error-404.html',
                        controller : 'Error404Controller as cf'
                    }
                }
            })
            .state('app.createform.custom', {
                url      : '/custom',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/createform/views/custom/custom.html',
                        controller : 'CustomCreateformController as cf'
                    }
                }
            });
            /* .state('app.createform.standard', {
                url      : '/standard',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/pages/errors/404/error-404.html',
                        controller : 'Error404Controller as cf'
                    }
                }
            });*/
            /*.state('app.createform.new', {
                url      : '/new',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/pages/errors/404/error-404.html',
                        controller : 'Error404Controller as cf'
                    }
                }
            });*/
            
        // Translation
        //$translatePartialLoaderProvider.addPart('app/main/apps/e-commerce');

      
        // Navigation
       /* msNavigationServiceProvider.saveItem('admin', {
            title : 'ADMIN',
            group : true,
            weight: 4
        });*/

      /*  msNavigationServiceProvider.saveItem('admin.createform', {
            title : 'Requests Management',
            icon  : 'icon-script',
            state:'app.createform.custom',
            weight: 2
        });
*/
        // msNavigationServiceProvider.saveItem('admin.custom', {
        //     title: 'Lists Management',
        //     icon:'icon-view-list'
        //     state: 'app.createform.custom',
        //     weight: 3
        // });
        
        // msNavigationServiceProvider.saveItem('admin.standard', {
        //     title: 'Workflow Management',
        //     icon:'icon-worker',
        //     state: 'app.createform.standard',
        //      weight: 4
        // });

       /*    msNavigationServiceProvider.saveItem('admin.new', {
            title: 'Workflow-management',
            icon:'icon-worker'
            state: 'app.createform.new',
             weight: 4
        });*/
    }
})();

angular.module("smartportal").run(["$templateCache", function($templateCache) {$templateCache.put("app/quick-panel/quick-panel.html","<md-content><md-tabs md-no-pagination md-swipe-content md-stretch-tabs=\"always\"><md-tab><md-tab-label><span \ntranslate=\"QUICKPANEL.TODAY\">TODAY</span></md-tab-label><md-tab-body><md-content class=\"today-tab scrollable\" \nms-scroll ng-include=\"\'app/quick-panel/tabs/today/today-tab.html\'\"></md-content></md-tab-body></md-tab><md-tab>\n<md-tab-label><span translate=\"QUICKPANEL.CHAT\">CHAT</span></md-tab-label><md-tab-body><md-content \nclass=\"chat-tab scrollable\" ms-scroll ng-include=\"\'app/quick-panel/tabs/chat/chat-tab.html\'\" \nng-controller=\"ChatTabController as vm\"></md-content></md-tab-body></md-tab><md-tab><md-tab-label><span \ntranslate=\"QUICKPANEL.ACTIVITY\">ACTIVITY</span></md-tab-label><md-tab-body><md-content class=\"activity-tab scrollable\" \nms-scroll ng-include=\"\'app/quick-panel/tabs/activity/activity-tab.html\'\"></md-content></md-tab-body></md-tab></md-tabs>\n</md-content>");
$templateCache.put("app/main/details.announcement.dialog.html","<md-dialog aria-label=\"Add a new user\" flex=\"50\"><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2 \nclass=\"white-fg\">{{currentAnc.title}}</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\">\n<md-icon md-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><div layout=\"column\"><div class=\"md-title md-padding\">\n{{currentAnc.description}}</div><div class=\"md-padding md-subhead\">\nThis will start on {{currentAnc.durationFrom.slice(0,10)}} and end on {{currentAnc.durationTo.slice(0,10)}}</div></div>\n</md-dialog-content></md-dialog>");
$templateCache.put("app/core/layouts/content-only.html","<div id=\"layout-content-only\" class=\"template-layout\" layout=\"column\" flex><md-content id=\"content\" \nclass=\"animate-slide-up md-hue-2\" ui-view=\"content\" flex></md-content></div>");
$templateCache.put("app/core/layouts/content-with-toolbar.html","<div id=\"layout-content-with-toolbar\" class=\"template-layout\" layout=\"column\" flex><md-toolbar id=\"toolbar\" \nclass=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><md-content id=\"content\" \nclass=\"animate-slide-up md-hue-2\" ui-view=\"content\" flex></md-content></div>");
$templateCache.put("app/core/layouts/footer.html","<span class=\"pos-abs\" style=\"left: 40%\">Version 3.0.2 <span>&#9400; 2017 SmartDocs Inc. Powered by SmartDocs.</span>\n</span>");
$templateCache.put("app/core/layouts/vertical-navigation.html","<style>\n.footer-div {\n    bottom: -4px;\n    background: #313940;\n    height: 40px;\n    width: 100%;\n    position: initial;\n    text-align: center;\n    padding-top: 9px;\n    font-size:14px;\n}\n.pos-abs {\n    position: absolute !important;\n}\n</style><div id=\"layout-vertical-navigation\" class=\"template-layout\" layout=\"row\" flex><md-sidenav \nid=\"vertical-navigation\" class=\"md-primary-bg\" md-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" \nms-scroll ui-view=\"navigation\"></md-sidenav><div id=\"content-container\" flex layout=\"column\"><md-toolbar id=\"toolbar\" \nclass=\"md-menu-toolbar\" ui-view=\"toolbar\"></md-toolbar><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" \nms-scroll ui-view=\"content\" flex></md-content></div></div><script>\nif(window.localStorage[\'branddata\']!=\"null\"){\n	var backrounddata = JSON.parse(window.localStorage[\'branddata\']).appbackroundimage;\n	if(backrounddata !=null && backrounddata != \'undefined\'){\n		$(\"#toolbar\").css(\'background-image\', \'url(\'+backrounddata+\')\');\n	}else{\n		$(\"#toolbar\").css(\'background-image\', \'url(\'+\"assets/images/2.jpg\"+\')\');\n	}\n}else{\n	$(\"#toolbar\").css(\'background-image\', \'url(\'+\"assets/images/2.jpg\"+\')\');\n}\n</script><fuse-footer class=\"below md-fuse-dark-800-bg\" flex layout=\"column\"><md-toolbar role=\"toolbar\"><div \nclass=\"mat-toolbar-layout pb-35\"><md-toolbar-row class=\"mat-toolbar-row\"><span class=\"footer-div pos-abs\">4.1.78<span>\n&#9400; 2020 SmartDocs Inc. Powered by SmartDocs.</span></span></md-toolbar-row></div></md-toolbar></fuse-footer>");
$templateCache.put("app/core/theme-options/theme-options.html","<md-sidenav md-component-id=\"fuse-theme-options\" class=\"md-sidenav-right\"><div class=\"ms-theme-options-list\" \nlayout=\"column\"><div class=\"theme-option layout-options\"><div class=\"option-title\">Layout Style:</div><md-radio-group \nlayout=\"row\" layout-align=\"start start\" layout-wrap ng-model=\"vm.layoutStyle\" ng-change=\"vm.updateLayoutStyle()\">\n<md-radio-button ng-repeat=\"layoutStyle in vm.layoutStyles\" ng-value=\"layoutStyle.value\"><div layout=\"column\" \nlayout-align=\"center center\"><img ng-src=\"{{layoutStyle.figure}}\"> <span class=\"text-center font-size-12 mt-8\">\n{{layoutStyle.label}}</span></div></md-radio-button></md-radio-group></div><md-divider></md-divider><div \nclass=\"theme-option\"><div class=\"option-title\">Layout Mode:</div><md-radio-group layout=\"row\" \nlayout-align=\"start center\" ng-model=\"vm.layoutMode\" ng-change=\"vm.updateLayoutMode()\"><md-radio-button \nng-repeat=\"layoutMode in vm.layoutModes\" ng-value=\"layoutMode.value\">{{layoutMode.label}}</md-radio-button>\n</md-radio-group></div><md-divider></md-divider><div class=\"theme-option color-palettes\"><div class=\"option-title\">\nColor Palette:</div><div layout=\"row\" layout-align=\"start start\" layout-wrap><md-button \nng-repeat=\"(themeName, theme) in vm.themes.list\" class=\"md-raised theme-button\" layout=\"row\" \nlayout-align=\"center center\" aria-label=\"{{themeName}}\" ng-click=\"vm.setActiveTheme(themeName)\" \nng-style=\"{\'background-color\': theme.primary.color,\'border-color\': theme.accent.color,\'color\': theme.primary.contrast1}\" \nng-class=\"{active: vm.getActiveTheme().name === themeName}\"><md-icon ng-style=\"{\'color\': theme.primary.contrast1}\" \nmd-font-icon=\"icon-palette\" class=\"icon s32\"></md-icon></md-button></div></div></div></md-sidenav>");
$templateCache.put("app/main/Analytics/analyticPreview.html","<div><iframe id=\"iframe\" src=\"{{fileURL}}\" name=\"contentframe\" frameborder=\"0\" \nstyle=\"width: 100%; height: 100%; position: absolute; z-index: 999\"></iframe></div>");
$templateCache.put("app/main/Analytics/analytics.html","<div class=\"page-layout simple tabbed mh-0\" layout=\"column\"><div class=\"content parent-tabs\"><md-tabs class=\"mh-0\">\n<md-tab label=\"Analytics\" md-active=\"true\"></md-tab></md-tabs></div></div><div class=\"widget-group\" flex=\"100\" \nlayout=\"column\" layout-wrap><ms-widget><ms-widget-front class=\"white-bg md-padding\"><div layout=\"row\"><div flex=\"100\" \nflex-gt-xs=\"33\" flex-gt-sm=\"25\" ng-repeat=\"analytic in analytics\"><md-card md-theme=\"{{getAnotherColor($index)}}\" \nmd-theme-watch class=\"c-p\" ng-click=\"selectAnalytic(analytic)\"><div class=\"info\" layout=\"column\" \nlayout-align=\"space-between\" flex><div class=\"white-bg md-padding\" layout=\"row\" layout-align=\"center center\" \nng-style=\"{\'height\':\'150px\'}\"><md-icon md-font-icon=\"{{getAnotherIcon($index)}}\" class=\"s64\" style=\"color: #389cec\">\n</md-icon></div><div><md-divider></md-divider><div class=\"p-8 white-bg\" layout=\"column\" layout-align=\"center center\">\n<h3>{{analytic.name}}</h3></div></div></div></md-card></div></div></ms-widget-front></ms-widget></div>");
$templateCache.put("app/main/Main_Inbox/main_inbox.html","<style>\n.table-header{\n    background-color:white !important;\n}\n.page-layout .top-bg {\n    height: 100px;\n    background-image: none;\n    background-color: whitesmoke\n}\n#e-commerce-orders .center .header {\n    min-height: 80px !important;\n    max-height: 80px !important;\n}\n.table-header{\n        text-transform: none;\n\n    }\ntable.dataTable tbody td {\n    padding: 6px 8px !important;\n    }\n</style><div id=\"e-commerce-orders\" class=\"page-layout carded fullwidth\" layout=\"row\"><div class=\"top-bg md-accent-bg\">\n</div><div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\">\n<div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h3\" layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-cart-outline\" style=\"color: #2196F3 !important\"></md-icon><span\n style=\"color: #2196F3 !important\">Invoices:{{vm.orders.length}}</span></div></div></div><div class=\"content-card\" \nlayout=\"column\" flex><div class=\"content fullpage-datatable\" layout=\"column\" flex><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-instance=\"vm.dtInstance\" dt-options=\"vm.dtOptions\"><thead><tr><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Vendor</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Vendor Invoice No</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Invoice Type</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Amount</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Currency</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Actions</span></div></th></tr></thead>\n<tbody><tr ng-repeat=\"order in ::vm.orders\"><td>{{order.headerValues.Field2}}</td><td>{{order.headerValues.Field3}}\n</td><td>{{order.headerValues.Field4}}</td><td>{{order.headerValues.Field5 | number:0}}</td><td>\n{{order.headerValues.Field6}}</td><td><md-button class=\"edit-button md-icon-button\" \nng-click=\"gotoOrderDetail(order.docId)\" onclick=\"angular.element(this).scope().gotoOrderDetail(this.order)\" \naria-label=\"Order details\"><md-icon md-font-icon=\"icon-eye\" class=\"s16\"></md-icon></md-button></td></tr></tbody>\n</table></div></div></div></div>");
$templateCache.put("app/main/PARreport/PARreportPreviewDialog.html","<style>\n.selectedApprovalMatrixrow {\n        font-size: 18px;\n        font-weight: bold;\n        color: black;\n        \n    }\n    .selectedApprovalMatrixrowBackground{\n    	background-color: #7ae2d8;\n    }\n    .disabled {\n  pointer-events: none;\n \n}\nmd-tabs-canvas{\n    background-color: white;\n    }\n</style><md-dialog flex=\"90\" flex-gt-sm=\"75\" flex-md=\"75\" flex-gt-md=\"75\" style=\"height:85% !important\" \nng-init=\"loadApprovalMatrix()\"><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2>Report Details</h2><span\n flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content class=\"scrollable\" ms-scroll><md-content><div \nstyle=\"background:#dcecf0\" class=\"md-padding\"><div layout=\"row\"><div><span class=\"h3\" style=\"font-family: verdana\">\n{{report.requestId.substr(0,3) | uppercase}} No </span><span class=\"h3\" \nstyle=\"font-family: verdana;color: rgb(38, 161, 242)\">\n{{report.requestId.substr(4,report.requestId.length-2) | uppercase}}</span></div></div><div layout=\"row\" \nlayout-align=\"space-between center\"><div ng-if=\"report.requestType == \'TRN_PROCESS\' \"><span class=\"h4\" \nstyle=\"font-family: verdana\">PR No </span><span class=\"h4\" style=\"font-family: verdana;color: rgb(38, 161, 242)\">\n{{header.PURCHASE_REQ_NO}}</span></div><div ng-if=\"report.requestType == \'CAR_PROCESS\' \"><span class=\"h4\" \nstyle=\"font-family: verdana\">PO No </span><span class=\"h4\" style=\"font-family: verdana;color: rgb(38, 161, 242)\">\n{{header.PURCHASE_ORDER}}</span></div><span class=\"h4\" style=\"font-family: verdana;color: rgb(38, 161, 242)\">\n{{header.VALUE | currency:\"\"}} {{header.CURRENCY}}</span></div><div layout=\"row\" layout-align=\"space-between center\">\n<div><span class=\"h4\" style=\"font-family: verdana\">Vendor </span><span class=\"h4\" \nstyle=\"font-family: verdana;color: rgb(38, 161, 242)\">{{header.VENDOR}}</span></div><div><span class=\"h4\" \nstyle=\"font-family: verdana\">Created By </span><span class=\"h4\" style=\"font-family: verdana; color: rgb(38, 161, 242)\">\n{{report.createdBy}}</span></div></div></div><div><md-tabs md-dynamic-height><md-tab><md-tab-label \nstyle=\"padding-bottom:50px !important\">COMMENTS</md-tab-label><md-tab-body class=\"md-padding scrollable\" ms-scroll><div\n class=\"md-padding\"><timeline><timeline-event ng-repeat=\"log in log track by log.seqId\" side=\"\"><timeline-badge \nstyle=\"background-color: rgb(3,155,229)\"><md-icon md-font-icon=\"{{log.icon}}\" class=\"s25 icon white-fg\" \nstyle=\"color:white !important\"></md-icon></timeline-badge><timeline-panel class=\"{{\'info\'}}\" \nstyle=\"background-color: #f1eded\"><timeline-heading><div layout=\"row\" layout-align=\"end end\"><p><b>\nDate : {{log.endDate.substr(6,2)}}-{{log.endDate.substr(4,2)}}-{{log.endDate.substr(0,4)}}</b></p></div><div \nlayout=\"row\" layout-align=\"start center\" style=\"color:black\"><img ng-src=\"assets\\images\\avatars/Nora.jpg\" \nclass=\"md-avatar\" style=\"border-radius:50% !important;width:13%; height:auto\"><div class=\"h2\" \nng-if=\"log.activityText == \'Initiated\' \">{{log.actualUser}} Initiated</div><div class=\"h2\" \nng-if=\"log.activityText == \'Approve\' \">{{log.actualUser}} Recommended</div><div class=\"h2\" \nng-if=\"log.activityText == \'Cancel\' \">{{log.actualUser}} Rejected</div><div class=\"h2\" \nng-if=\"log.activityText == \'Collaborate\' \">{{log.actualUser}} Collaborated with {{log.currAgent}}</div><div class=\"h2\" \nng-if=\"log.activityText == \'CollaborateBack\' \">{{log.actualUser}} Collaborated back with {{log.currAgent}}</div><div \nclass=\"h2\" ng-if=\"log.activityText == \'Delete\' \">{{report.requestId}} has been deleted by {{log.actualUser}}</div><div \nclass=\"h2\" ng-if=\"log.activityText == \'Elimination\' \">{{log.actualUser}} eliminated</div></div></timeline-heading><div \nlayout=\"row\" layout-align=\"start start\" style=\"padding-left: 2%\"><div class=\"text pt-16\">{{log.comments}}</div></div>\n</timeline-panel></timeline-event></timeline></div></md-tab-body></md-tab><md-tab><md-tab-label \ndata-ng-click=\"loadApprovalMatrix()\">INFO</md-tab-label><md-tab-body class=\"md-padding scrollable\" ms-scroll \nflex=\"100\"><div layout=\"row\" flex=\"100\" class=\"md-padding\"><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" \nstyle=\"border:1px solid #cccccc\" class=\"md-padding\"><form name=\"basicForm\" class=\"md-inline-form\" novalidate \ndata-ng-class=\"{ \'disabled\': true }\"><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex-gt-sm=\"50\"><input\n ng-model=\"header.PROJECTDESC\" type=\"text\" placeholder=\"Project\"></md-input-container></div><div layout=\"column\" \nlayout-gt-sm=\"row\"><md-input-container flex-gt-sm=\"50\"><input ng-model=\"header.DEPARTMENT\" type=\"text\" \nplaceholder=\"Department\"></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container \nflex-gt-sm=\"50\"><input ng-model=\"header.TEXT\" type=\"text\" placeholder=\"Text\"></md-input-container></div><div \nlayout=\"column\" layout-gt-sm=\"row\"><md-input-container flex-gt-sm=\"50\"><input ng-model=\"header.VALUE\" type=\"text\" \nplaceholder=\"Value\" ng-if=\"report.requestType==\'TRN_PROCESS\'\"> <input ng-model=\"header.VALUE\" type=\"text\" \nplaceholder=\"Percentage change in Value\" ng-if=\"report.requestType==\'CAR_PROCESS\'\"></md-input-container></div><div \nlayout=\"column\" layout-gt-sm=\"row\" ng-if=\"report.requestType==\'CAR_PROCESS\'\"><md-input-container flex-gt-sm=\"50\"><input\n ng-model=\"header.VAL\" type=\"text\" placeholder=\"Value\"></md-input-container></div><div layout=\"column\" \nlayout-gt-sm=\"row\"><md-input-container flex-gt-sm=\"50\"><input ng-model=\"header.VENDOR\" type=\"text\" \nplaceholder=\"Recommended Vendor\"></md-input-container></div></form></div><div layout=\"column\" flex=\"100\" \nflex-gt-sm=\"50\"><div ng-if=\"report.approvalMatrix\" style=\"border: 2px solid #efefef;padding: 15px\"><div \nlayout=\"column\" layout-gt-sm=\"row\" layout-align=\"center center\" style=\"background-color: whitesmoke !important\"><h2><b>\nApproval Matrix</b></h2></div><div style=\"height:10px;width: 100%\"></div><div style=\"height:10px;width: 100%\"></div>\n<div data-ng-repeat=\"approver in report.approvalMatrix.approvers track by $index\"><div layout=\"row\" layout-gt-sm=\"row\" \nstyle=\"height:60px;  text-align: center;   border: 2px #50afe1 solid;padding: 10px;border-radius:15px;font-family: verdana\" \nng-class=\"{\'selectedApprovalMatrixrowBackground\':report.approvalMatrix.selected[$index]}\"><div \nstyle=\"height:50px;width: 80%\" ng-class=\"{\'selectedApprovalMatrixrow\':report.approvalMatrix.selected[$index]}\">\n{{approver}}</div><span ng-if=\"report.approvalMatrix.checked[$index] == true\" \nstyle=\"content: \\2713; color:#ff003b;font-size:42px;line-height:22px\">&#10003;</span><div \nng-if=\"report.approvalMatrix.checked[$index] == true\" layout=\"column\" style=\"width:10%\"><b>\n{{workitemInfo.approvalMatrix.approverDays[$index]}}</b> Days</div></div><div ng-hide=\"$last\" layout=\"column\" \nlayout-gt-sm=\"row\" style=\"height:40px;    text-align: center; padding: 5px\"><div style=\"height:10px;width: 100%\"><i \nclass=\"icon icon-arrow-down-bold s30\" style=\"color: cornflowerblue\"></i></div></div></div></div></div></div><div \nlayout=\"row\" layout-align=\"center center\" class=\"md-padding\"><md-button class=\"md-accent md-raised pull-right\" \nng-if=\"workitemInfo.dataChange == \'M\'\" ng-click=\"updateHeader();\">Update</md-button></div></md-tab-body></md-tab>\n<md-tab><md-tab-label>ATTACHMENTS</md-tab-label><md-tab-body class=\"md-padding scrollable\" ms-scroll \nng-style=\"{\'border\': \'1px solid #cccccc\'}\"><div class=\"md-padding\" layout=\"row\" layout-align=\"space-between center\">\n<span class=\"h2\">Attachments</span> <span class=\"h3\">{{report.attachments.length}}</span></div><div><md-list>\n<md-list-item class=\"md-3-line\" ng-repeat=\"attachment in report.attachments\"><div layout=\"row\" flex=\"100\" \nng-click=\"preview($event,attachment,report.requestId,attachment.url)\"><div flex=\"5\" layout=\"row\" \nlayout-align=\"center center\"><md-icon md-font-icon=\"{{fileIcon(attachment.fileType)}}\" class=\"s42 icon md-accent\">\n</md-icon></div><div flex=\"60\"><div class=\"md-list-item-text\"><h3><b>{{attachment.fileName}}</b></h3><h3>\nCreated By : {{attachment.creator}}</h3></div></div><div flex=\"30\"><h3>Created On : {{attachment.createDate }}</h3>\n</div><md-divider ng-if=\"!$last\"></md-divider></div><div><md-icon md-font-icon=\"icon-download\" \nclass=\"s32 c-p icon md-accent\" ng-click=\"downloadFile(attachment,workitemInfo.requestId )\"></md-icon></div>\n</md-list-item></md-list></div></md-tab-body></md-tab></md-tabs></div></md-content></md-dialog-content>\n<md-dialog-actions><md-button ng-click=\"cancel()\">Ok</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/PARreport/PARreports.html","<style>\n#spinner{\nposition:fixed;\ntop:50%;\nleft:50%;\n}\n\n.c-p {\n    cursor: pointer;\n}\n.selected {\n    background-color: rgb(232, 233, 237) !important;\n}\n.md-button.md-fab{\n    width: 40px;\n    height: 40px;\n    margin-top: -14% !important;\n}\n /* md-tabs-canvas{\nbackground-color:rgb(232, 233, 237);\n\n}  */\n\n.tab{\nbackground:#dcecf0;\n}\n.disabled {\n  pointer-events: none;\n \n}\nlabel{\n   font-size:20px}\n</style><div class=\"page-layout simple right-sidenav\" layout=\"row\"><div \nclass=\"page-layout carded fullwidth md-padding scrollable\" layout=\"column\" flex ms-scroll><div class=\"widget-group\" \nflex=\"100\" ng-hide=\"details\"><ms-widget flippable=\"true\" layout=\"column\" flex md-dynamic-height><ms-widget-front \nclass=\"white-bg\"><div layout=\"row\" layout-align=\"center center\" class=\"md-padding\"><div flex=\"100\" \nstyle=\"border:2px solid #cccccc; border-radius:5px;margin-bottom:3%\" flex-gt-xs><div layout=\"column\" \nlayout-gt-sm=\"row\"><md-input-container md-no-float flex-gt-sm=\"10\"><label>Request Type</label><md-select \nng-model=\"obj.requestType\" multiple=\"multiple\"><md-option ng-value=\"requestType.docType\" \nng-repeat=\"requestType in requestTypes\" ng-selected=\"$first\">{{requestType.id}}</md-option></md-select>\n</md-input-container><md-input-container md-no-float flex-gt-sm=\"10\"><label>Initiator</label><md-select \nng-model=\"obj.creator\"><md-option ng-value=\"user.login\" ng-repeat=\"user in users | orderBy:\'firstName\'\">\n{{user.firstName}} {{user.lastName}}</md-option></md-select></md-input-container><md-input-container md-no-float \nflex-gt-sm=\"10\"><label>CurrentUser</label><md-select ng-model=\"obj.currentUser\"><md-option ng-value=\"user.login\" \nng-repeat=\"user in users | orderBy:\'firstName\'\">{{user.firstName}} {{user.lastName}}</md-option></md-select>\n</md-input-container><div flex-gt-sm style=\"margin-top: 1.5% !important\"><md-datepicker md-no-float \nclass=\"md-block datepicker-inline\" ng-model=\"obj.fromDate\" md-placeholder=\"From Date\"></md-datepicker></div><div \nflex-gt-sm style=\"margin-top: 1.5% !important\"><md-datepicker md-no-float class=\"md-block datepicker-inline\" \nng-disabled=\"obj.fromDate == null\" md-min-date=\"obj.fromDate\" ng-model=\"obj.toDate\" md-placeholder=\"To Date\">\n</md-datepicker></div></div><div flex-gt-sm layout=\"row\" layout-align=\"end end\" class=\"md-padding\"><md-button \nclass=\"md-raised md-accent\" ng-click=\"searchforReports(obj)\" \nng-disabled=\"(obj.selectAll == null && obj.selectAll== false && obj.requestType ==null && obj.creator==null && obj.project ==null && obj.department ==null)\">\nSearch</md-button><md-button class=\"md-raised md-warn\" ng-click=\"Reset()\">Reset</md-button><div excel-export \nexport-data=\"exportData\" file-name=\"{{fileName}}\"></div></div></div></div><div layout=\"row\" flex=\"60\" \nlayout-align=\"center center\" ng-if=\"allReports.length == 0\" \nstyle=\"border:2px solid #cccccc; border-radius:5px; height:50px;margin-left:20%\"><b>No Records were found</b></div><div\n layout=\"row\" class=\"md-padding\" layout-align=\"start start\" style=\"margin-bottom:-4% !important\"><span>Size</span>\n<md-input-container class=\"md-block md-padding\" style=\"margin-top: -3%\"><md-select ng-model=\"sizeNumber\"><md-option \nng-repeat=\"size in sizeNumbers\" ng-value=\"size\" ng-click=\"sendsizeNumber(size)\" value=\"sizeNumber\" \nng-selected=\"$first\">{{size}}</md-option></md-select></md-input-container></div><table id=\"scrollToDivID\" \nclass=\"dataTable row-border hover tableHighllete md-padding\" ng-if=\"allReports.length != 0\" class=\"scrollable\" \nms-scroll><thead><tr class=\"table-header\"><th>REQ ID</th><th>REQ Type</th><th>Created By</th><th>Created Date</th><th>\nStatus</th></tr></thead><tbody><tr ng-repeat=\"report in allReports  | filter : searchReport\" \nng-click=\"selectReport(report)\" class=\"c-p\"><td>{{report.requestId | uppercase}}</td><td>{{report.requestType}}</td>\n<td>{{report.createdBy}}</td><td>{{report.createdDate.substr(0,10)}}</td><td><div ng-if=\"report.currentstep == \'&END\'\">\nCompleted</div><div ng-if=\"report.currentstep != \'&END\'\">InProcess</div></td></tr></tbody></table><div layout=\"row\" \nlayout-align=\"space-between center\" flex=\"100\"><div class=\"md-padding\"><h5><b>\nShowing {{(isNaN(pageNumber*size))+1}} - {{(pageNumber + 1)*size}} of {{totalRecords}} Results</b></h5></div><div \nlayout=\"row\" layout-align=\"center center\">Page No<md-input-container class=\"md-block md-padding\" style=\"margin: 0px\">\n<md-select ng-model=\"pageNumber\"><md-option ng-repeat=\"pageNumber in pageNumbers\" ng-value=\"pageNumber\" \nng-click=\"sendPageNumber(pageNumber)\" value=\"pageNumber\" ng-selected=\"$first\">{{pageNumber+1}}</md-option></md-select>\n</md-input-container></div><div layout=\"row\" layout-align=\"center center\"><div><md-button type=\"button\" \nng-click=\"previous()\" ng-disabled=\"pageNumber <= 0\">Prev</md-button></div><p class=\"md-padding\"><b>\n{{pageNumber+1}}/{{totalPages}} &nbsp;PAGES</b></p><div class=\"md-padding\"><md-button type=\"button\" \nng-click=\"next(obj)\" ng-disabled=\"pageNumber == totalPages-1\">Next</md-button></div></div></div></ms-widget-front>\n</ms-widget></div><div ng-show=\"details\"><ms-widget flippable=\"true\" layout=\"column\" flex md-dynamic-height>\n<ms-widget-front class=\"white-bg\"><span class=\"previous-state c-p\" data-ng-click=\"goToBack()\"><span><span \nclass=\"icon-arrow-left-bold-circle-outline\"></span> Back</span></span><md-tabs md-dynamic-height class=\"x\"><md-tab>\n<md-tab-label><md-button class=\"md-fab md-accent\" aria-label=\"Android\" md-tooltip=\"Main\"><md-icon \nmd-svg-src=\"assets/icons/fonts/001-info.svg\"></md-icon><md-tooltip md-direction=\"top\">Information</md-tooltip>\n</md-button></md-tab-label><md-tab-body ng-show=\"formHeader\" flex=\"100\"><div class=\"md-padding scrollable\" ms-scroll>\n<div layout=\"row\" layout-align=\"center center\"><div flex=\"100\" style=\"color:black\"><form name=\"headerForm\" \nng-if=\"workitemInfo.mainLayout\"><div><div class=\"md-padding\" data-ng-class=\"{\'disabled\':true}\" \nng-bind-html=\"currentFormHeader\" compile-template class=\"scrollable\" ms-scroll \nstyle=\"border:2px solid #cccccc; border-radius:0px\"></div></div><div>&nbsp;</div><div \nng-if=\" (workitemInfo.lineItems | json) != \'{}\'\"><div class=\"md-padding\" ng-bind-html=\"currentFormLineitem\" \ncompile-template class=\"scrollable\" ms-scroll style=\"border:2px solid #cccccc; border-radius:0px\"></div></div></form>\n<div class=\"md-padding\" ng-if=\"!workitemInfo.mainLayout\" ng-include=\"\'app/main/form-builder/form-render.html\'\"></div>\n</div></div></div></md-tab-body></md-tab><md-tab><md-tab-label><md-button class=\"md-fab md-accent\" \naria-label=\"Use Android\"><md-icon md-svg-src=\"assets/icons/fonts/004-comment-white-oval-bubble.svg\"></md-icon>\n<md-tooltip md-direction=\"top\">Comments</md-tooltip></md-button></md-tab-label><md-tab-body><div \nclass=\"md-padding scrollable\" ms-scroll><timeline><timeline-event \nng-repeat=\"log in workitemInfo.logs | orderBy : \'-step\'\" side=\"\"><timeline-badge \nstyle=\"background-color: rgb(3,155,229)\"><md-icon md-font-icon=\"{{log.icon}}\" class=\"s25 icon white-fg\" \nstyle=\"color:white !important\"></md-icon></timeline-badge><timeline-panel class=\"{{\'info\'}}\" \nstyle=\"background-color: #f1eded;    border-radius: 10px\"><timeline-heading><div layout=\"row\" \nlayout-align=\"space-between center\"><div ng-if=\"log.currAgent\">{{log.currAgent}}</div><div ng-if=\"!log.currAgent\">\n</div><p><b>Date : {{log.endDate.substr(6,2)}}-{{log.endDate.substr(4,2)}}-{{log.endDate.substr(0,4)}}</b></p></div>\n<div layout=\"row\" layout-align=\"start center\" style=\"color:black\"><img ng-src=\"assets\\images\\avatars/Nora.jpg\" \nclass=\"md-avatar\" style=\"border-radius:50% !important;width:13%; height:auto\"><div class=\"h2\" \nng-if=\"log.activityText == \'Initiated\' \">{{log.actualUser}} initiated</div><div class=\"h2\" \nng-if=\"log.activityText == \'Approve\' \">{{log.actualUser}} &nbsp Approved</div><div class=\"h2\" \nng-if=\"log.activityText == \'Reject\' \">{{log.actualUser}} &nbsp Rejected</div><div class=\"h2\" \nng-if=\"log.activityText == \'Confirm\' \">{{log.actualUser}} &nbsp Confirmed</div><div class=\"h2\" \nng-if=\"log.activityText != \'Initiated\' && log.activityText != \'Approve\' && log.activityText != \'Reject\' && log.activityText != \'Confirm\'  \">\n{{log.actualUser}} &nbsp {{log.activityText}}</div></div></timeline-heading><div layout=\"row\" \nlayout-align=\"start start\" style=\"padding-left: 2%\"><p style=\"color:black\">{{log.comments}}</p></div></timeline-panel>\n</timeline-event></timeline></div></md-tab-body></md-tab><md-tab><md-tab-label><md-button class=\"md-fab md-accent\" \naria-label=\"Use Android\"><md-icon md-svg-src=\"assets/icons/fonts/005-clip.svg\"></md-icon><md-tooltip \nmd-direction=\"top\">Attachments</md-tooltip></md-button></md-tab-label><md-tab-body \nng-style=\"{\'border\': \'1px solid #cccccc\'}\"><div class=\"md-padding scrollable\" ms-scroll><div class=\"md-padding\" \nlayout=\"row\" layout-align=\"space-between center\"><span class=\"h2\">Attachments</span> <span class=\"h3\">\n{{workitemInfo.attachments.length}}</span></div><div><md-list><md-list-item class=\"md-3-line\" \nng-repeat=\"attachment in workitemInfo.attachments\"><div layout=\"row\" flex=\"100\"><div flex=\"5\" layout=\"row\" \nlayout-align=\"center center\"><md-icon md-font-icon=\"{{fileIcon(attachment.fileType)}}\" class=\"s42 icon md-accent\">\n</md-icon></div><div flex=\"60\" class=\"c-p\" ng-click=\"previewFile(attachment,workitemInfo.requestId)\"><div \nclass=\"md-list-item-text\"><h3><b>{{attachment.fileName}}</b></h3><h3>Created By : {{attachment.creator}}</h3></div>\n</div><div flex=\"30\"><h3>Date : {{attachment.createDate }}</h3></div><md-button class=\"md-icon-button md-accent\" \nng-click=\"downloadFile(attachment,workitemInfo.requestId)\"><md-icon md-font-icon=\"icon-download\" class=\"s32 md-accent\">\n</md-icon></md-button><md-divider ng-if=\"!$last\"></md-divider></div></md-list-item></md-list></div></div></md-tab-body>\n<div layout=\"row\" layout-align=\"center center\" flex=\"100\" class=\"md-padding\"><div><div><input class=\"ng-hide\" \nid=\"attachmentUpload\" name=\"attachmentUpload\" type=\"file\" \nonchange=\"angular.element(this).scope().setAttachmentFile(this)\"><label for=\"attachmentUpload\" \nclass=\"md-button md-raised\">Upload files</label></div></div><div flex=\"10\"></div><div \nng-repeat=\"file in attachmentfiles.slice(0)\" layout=\"row\" layout-align=\"center center\"><span class=\"md-warn\">\n{{file.webkitRelativePath || file.name}}</span> ( <span ng-switch=\"file.size > 1024*1024\"><span ng-switch-when=\"true\">\n{{file.size / 1024 / 1024 | number:2}} MB</span> <span ng-switch-default>{{file.size / 1024 | number:2}} kB</span> \n</span>)</div>{{activities}}</div></md-tab></md-tabs></ms-widget-front></ms-widget></div></div></div>");
$templateCache.put("app/main/Requests/AlkemAlert.dialog.html","<md-dialog><form ng-cloak><md-toolbar class=\"md-hue-2\" style=\"background-color: rgb(44, 119, 158);height: 41px\"><div \nclass=\"md-toolbar-tools\"><span flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div class=\"md-dialog-content\">\n<h2>If you go back Data is deleted</h2></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex></span>\n<md-button style=\"background-color: #4974f9\" ng-click=\"goToBAckRequests()\">Confirm</md-button><md-button \nclass=\"md-raised md-warn\" ng-click=\"cancel()\" class=\"md-primary\">Cancel</md-button></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/Requests/AssetCodedialog.html","<md-dialog ng-cloak flex=\"60\"><md-toolbar layout=\"row\" class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2>\nSearch AssetCode</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content layout=\"column\" \nlayout-align=\"center center\" class=\"p-0\"><div layout=\"row\" style=\"position: inherit !important\"><md-select \nstyle=\"margin-top: 14px;margin-bottom: 44px\" ng-model=\"search.key\"><md-option value=\"ANLN1\" selected=\"selected\">\nAssetCode</md-option><md-option value=\"TXT50\">Description</md-option></md-select><span flex=\"10\"></span>\n<md-input-container class=\"md-block\" flex=\"40\"><input ng-model=\"search.value\" placeholder=\"Search here\">\n</md-input-container><md-button class=\"md-raised\" ng-click=\"searchAssetCode(search)\" style=\"height: 35px;top: 5px\">\nSearch</md-button></div><div style=\"width:100%;     margin-top: 5% !important\" class=\"md-padding scrollable\" ms-scroll \nng-if=\"searchResult\"><div layout=\"row\" flex=\"60\" layout-align=\"center center\" ng-if=\"searchResult.length == 0\" \nstyle=\"border:2px solid #cccccc; border-radius:5px; height:50px;margin-left:20%\"><b>No Records were found</b></div>\n<table class=\"dataTable row-border hover tableHighllete\" ng-if=\"searchResult.length != 0\"><thead><tr \nclass=\"table-header\"><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">AssetCode</span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">AssetCodeLineItem</span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">AsstCodeDescription</span>\n</div></th></tr></thead><tbody><tr ng-repeat=\"order in searchResult\" ng-click=\"searchResultRowClick(order)\" \nclass=\"c-p\"><td>{{order.ANLN1}}</td><td>{{order.ANLN2}}</td><td>{{order.TXT50}}</td></tr></tbody></table></div>\n</md-dialog-content><md-dialog-actions ng-if=\"searchResult\"><div layout=\"row\" layout-align=\"space-between center\" \nflex=\"100\"><div class=\"md-padding\"><h5><b>\nShowing {{(pageNumber*size)+1}} - {{(pageNumber + 1)*size}} of {{totalRecords}} Results</b></h5></div><div \nlayout=\"row\" layout-align=\"center center\"><div><md-button type=\"button\" ng-click=\"previous()\" \nng-disabled=\"pageNumber <= 0\">Prev</md-button></div><p class=\"md-padding\"><b>\n{{pageNumber+1}} / {{totalPages}} &nbsp;PAGES</b></p><div class=\"md-padding\"><md-button type=\"button\" \nng-click=\"next()\" ng-disabled=\"pageNumber == totalPages-1\">Next</md-button></div></div></div></md-dialog-actions>\n</md-dialog>");
$templateCache.put("app/main/Requests/FunctionalAreaDialog.html","<md-dialog ng-cloak flex=\"60\"><md-toolbar layout=\"row\" class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2>\nSearch FunctionalArea</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content layout=\"column\" \nlayout-align=\"center center\" class=\"p-0\"><div layout=\"row\" style=\"position: inherit !important\"><md-select \nstyle=\"margin-top: 14px;margin-bottom: 44px\" ng-model=\"search.key\"><md-option value=\"FKBER\" selected=\"selected\">\nFunctionalArea</md-option><md-option value=\"FKBTX\">Description</md-option></md-select><span flex=\"10\"></span>\n<md-input-container class=\"md-block\" flex=\"40\"><input ng-model=\"search.value\" placeholder=\"Search here\">\n</md-input-container><md-button class=\"md-raised\" ng-click=\"searchFuncationlArea(search)\" \nstyle=\"height: 35px;top: 5px\">Search</md-button></div><div style=\"width:100%;     margin-top: 5% !important\" \nclass=\"md-padding scrollable\" ms-scroll ng-if=\"searchResult\"><div layout=\"row\" flex=\"60\" layout-align=\"center center\" \nng-if=\"searchResult.length == 0\" style=\"border:2px solid #cccccc; border-radius:5px; height:50px;margin-left:20%\"><b>\nNo Records were found</b></div><table class=\"dataTable row-border hover tableHighllete\" \nng-if=\"searchResult.length != 0\"><thead><tr class=\"table-header\"><th class=\"secondary-text\"><div class=\"table-header\">\n<span class=\"column-title\">FunctionalArea</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Description</span></div></th></tr></thead><tbody><tr ng-repeat=\"order in searchResult\" \nng-click=\"searchResultRowClick(order)\" class=\"c-p\"><td>{{order.FKBER}}</td><td>{{order.FKBTX}}</td></tr></tbody>\n</table></div></md-dialog-content><md-dialog-actions ng-if=\"searchResult\"><div layout=\"row\" \nlayout-align=\"space-between center\" flex=\"100\"><div class=\"md-padding\"><h5><b>\nShowing {{(pageNumber*size)+1}} - {{(pageNumber + 1)*size}} of {{totalRecords}} Results</b></h5></div><div \nlayout=\"row\" layout-align=\"center center\"><div><md-button type=\"button\" ng-click=\"previous()\" \nng-disabled=\"pageNumber <= 0\">Prev</md-button></div><p class=\"md-padding\"><b>\n{{pageNumber+1}} / {{totalPages}} &nbsp;PAGES</b></p><div class=\"md-padding\"><md-button type=\"button\" \nng-click=\"next()\" ng-disabled=\"pageNumber == totalPages-1\">Next</md-button></div></div></div></md-dialog-actions>\n</md-dialog>");
$templateCache.put("app/main/Requests/FundDialog.html","<md-dialog ng-cloak flex=\"60\"><md-toolbar layout=\"row\" class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2>Search Fund\n</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon md-font-icon=\"icon-close\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content layout=\"column\" layout-align=\"center center\" class=\"p-0\">\n<div layout=\"row\" style=\"position: inherit !important\"><md-select style=\"margin-top: 14px;margin-bottom: 44px\" \nng-model=\"search.key\"><md-option value=\"FINCODE\" selected=\"selected\">Fund</md-option><md-option value=\"BESCHR\">\nDescription</md-option></md-select><span flex=\"10\"></span><md-input-container class=\"md-block\" flex=\"40\"><input \nng-model=\"search.value\" placeholder=\"Search here\"></md-input-container><md-button class=\"md-raised\" \nng-click=\"searchFund(search)\" style=\"height: 35px;top: 5px\">Search</md-button></div><div \nstyle=\"width:100%;     margin-top: 5% !important\" class=\"md-padding scrollable\" ms-scroll ng-if=\"searchResult\"><div \nlayout=\"row\" flex=\"60\" layout-align=\"center center\" ng-if=\"searchResult.length == 0\" \nstyle=\"border:2px solid #cccccc; border-radius:5px; height:50px;margin-left:20%\"><b>No Records were found</b></div>\n<table class=\"dataTable row-border hover tableHighllete\" ng-if=\"searchResult.length != 0\"><thead><tr \nclass=\"table-header\"><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">FundCode</span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">FundCodeDescription</span>\n</div></th></tr></thead><tbody><tr ng-repeat=\"order in searchResult\" ng-click=\"searchResultRowClick(order)\" \nclass=\"c-p\"><td>{{order.FINCODE}}</td><td>{{order.BESCHR}}</td></tr></tbody></table></div></md-dialog-content>\n<md-dialog-actions ng-if=\"searchResult\"><div layout=\"row\" layout-align=\"space-between center\" flex=\"100\"><div \nclass=\"md-padding\"><h5><b>Showing {{(pageNumber*size)+1}} - {{(pageNumber + 1)*size}} of {{totalRecords}} Results</b>\n</h5></div><div layout=\"row\" layout-align=\"center center\"><div><md-button type=\"button\" ng-click=\"previous()\" \nng-disabled=\"pageNumber <= 0\">Prev</md-button></div><p class=\"md-padding\"><b>\n{{pageNumber+1}} / {{totalPages}} &nbsp;PAGES</b></p><div class=\"md-padding\"><md-button type=\"button\" \nng-click=\"next()\" ng-disabled=\"pageNumber == totalPages-1\">Next</md-button></div></div></div></md-dialog-actions>\n</md-dialog>");
$templateCache.put("app/main/Requests/Material_groupDialog.html","<md-dialog ng-cloak flex=\"60\"><md-toolbar layout=\"row\" class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2>\nSearch MaterialGroup</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content layout=\"column\" \nlayout-align=\"center center\" class=\"p-0\"><div layout=\"row\" style=\"position: inherit !important\"><md-select \nstyle=\"margin-top: 14px;margin-bottom: 44px\" ng-model=\"search.key\"><md-option value=\"MATKL\" selected=\"selected\">\nMaterialGroup</md-option><md-option value=\"WGBEZ\">Description</md-option></md-select><span flex=\"10\"></span>\n<md-input-container class=\"md-block\" flex=\"40\"><input ng-model=\"search.value\" placeholder=\"Search here\">\n</md-input-container><md-button class=\"md-raised\" ng-click=\"searchMaterialGroup(search)\" style=\"height: 35px;top: 5px\">\nSearch</md-button></div><div style=\"width:100%;     margin-top: 5% !important\" class=\"md-padding scrollable\" ms-scroll \nng-if=\"searchResult\"><div layout=\"row\" flex=\"60\" layout-align=\"center center\" ng-if=\"searchResult.length == 0\" \nstyle=\"border:2px solid #cccccc; border-radius:5px; height:50px;margin-left:20%\"><b>No Records were found</b></div>\n<table class=\"dataTable row-border hover tableHighllete\" ng-if=\"searchResult.length != 0\"><thead><tr \nclass=\"table-header\"><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">MaterialGroup\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Description</span>\n</div></th></tr></thead><tbody><tr ng-repeat=\"order in searchResult\" ng-click=\"searchResultRowClick(order)\" \nclass=\"c-p\"><td>{{order.MATKL}}</td><td>{{order.WGBEZ}}</td></tr></tbody></table></div></md-dialog-content>\n<md-dialog-actions ng-if=\"searchResult\"><div layout=\"row\" layout-align=\"space-between center\" flex=\"100\"><div \nclass=\"md-padding\"><h5><b>Showing {{(pageNumber*size)+1}} - {{(pageNumber + 1)*size}} of {{totalRecords}} Results</b>\n</h5></div><div layout=\"row\" layout-align=\"center center\"><div><md-button type=\"button\" ng-click=\"previous()\" \nng-disabled=\"pageNumber <= 0\">Prev</md-button></div><p class=\"md-padding\"><b>\n{{pageNumber+1}} / {{totalPages}} &nbsp;PAGES</b></p><div class=\"md-padding\"><md-button type=\"button\" \nng-click=\"next()\" ng-disabled=\"pageNumber == totalPages-1\">Next</md-button></div></div></div></md-dialog-actions>\n</md-dialog>");
$templateCache.put("app/main/Requests/Mmcdialog.html","<md-dialog ng-cloak flex=\"60\"><md-toolbar layout=\"row\" class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2>\nPossible Entries:{{groupList.attributes[0].label}}</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"cancel()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nlayout=\"column\" layout-align=\"center center\" class=\"p-0\"><div layout=\"row\" style=\"position: inherit !important\">\n<md-select style=\"margin-top: 14px;margin-bottom: 44px\" ng-model=\"search.key\"><md-option \nng-repeat=\"listName in groupList.attributes\" ng-selected=\"$first\" value=\"{{listName.fieldname}}\">{{listName.label}}\n</md-option></md-select><span flex=\"10\"></span><md-input-container class=\"md-block\" flex=\"40\"><input \nng-model=\"search.value\" placeholder=\"Search here\"></md-input-container><md-button class=\"md-raised\" \nng-click=\"searchGLValues(search)\" style=\"height: 35px;top: 5px\">Search</md-button></div><div \nstyle=\"width:100%;     margin-top: 5% !important\" class=\"md-padding scrollable\" ms-scroll ng-if=\"searchResult\"><div \nlayout=\"row\" flex=\"60\" layout-align=\"center center\" ng-if=\"searchResult.length == 0\" \nstyle=\"border:2px solid #cccccc; border-radius:5px; height:50px;margin-left:20%\"><b>No Records were found</b></div>\n<table class=\"dataTable row-border hover tableHighllete\" ng-if=\"searchResult.length != 0\"><thead><tr \nclass=\"table-header\"><th class=\"secondary-text\" ng-repeat=\"listName in groupList.attributes\"><div class=\"table-header\">\n<span class=\"column-title\">{{listName.label}}</span></div></th></tr></thead><tbody><tr \nng-repeat=\"(key, value) in searchResult \" ng-click=\"searchResultRowClick(value)\" class=\"c-p\"><td ng-hide=\"k == \'_id\'\" \nng-repeat=\"(k, v) in searchResult[$index] \">{{v}}</td></tr></tbody></table></div></md-dialog-content><md-dialog-actions\n ng-if=\"searchResult\"><div layout=\"row\" layout-align=\"space-between center\" flex=\"100\"><div class=\"md-padding\"><h5><b>\nShowing {{(pageNumber*size)+1}} - {{(pageNumber + 1)*size}} of {{totalRecords}} Results</b></h5></div><div \nlayout=\"row\" layout-align=\"center center\"><div><md-button type=\"button\" ng-click=\"previous()\" \nng-disabled=\"pageNumber <= 0\">Prev</md-button></div><p class=\"md-padding\" style=\"margin-left: auto\"><b>\n{{pageNumber+1}} / {{totalPages}} &nbsp;PAGES</b></p><div class=\"md-padding\"><md-button type=\"button\" \nng-click=\"next()\" ng-disabled=\"pageNumber == totalPages-1\">Next</md-button></div></div></div></md-dialog-actions>\n</md-dialog>");
$templateCache.put("app/main/Requests/MoreDetails.html","<style>\n.no-margin-bottom {\n               margin-bottom: -20% !important\n           }\n     .total{\n       width: 13% !important;\n       background-color: #efe6e6;\n       font-size: 17px;\n       padding: 16px !important;\n       font-weight: 900;\n     }\n</style><md-dialog flex=\"80\"><form ng-cloak><md-toolbar layout=\"row\" class=\"md-accent\"><div class=\"md-toolbar-tools\">\n<h2>Add Sub-Line items</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"row\" \nlayout-align=\"end end\"><button type=\"button\" class=\"btn btn-info\" ng-click=\"addSubLineItem($index)\" \nstyle=\"border-radius: 6px\">Add Sub-Line Item</button></div><table class=\"dataTable row-border table table-bordered\">\n<thead><tr><th></th><th style=\"text-align: center !important\">Service No</th><th style=\"text-align: center !important\">\nShortText</th><th style=\"text-align: center !important\">Quantity</th><th style=\"text-align: center !important\">UOM</th>\n<th style=\"text-align: center !important\">Gross Price</th><th style=\"text-align: center !important\">Net Value</th></tr>\n</thead><tbody ng-repeat=\"subLineitem in SUBLINEITEMS track by $index\"><tr><td><span style=\"color:red\" \nng-show=\"$index != 0\" class=\"glyphicon glyphicon-remove\" ng-click=\"removeSubLineItem($index)\"></span></td><td>\n<md-input-container class=\"md-block no-margin-bottom\"><input type=\"text\" name=\"ServiceNo\" \nng-model=\"subLineitem.SRVPOS\"></md-input-container></td><td><md-input-container class=\"md-block no-margin-bottom\">\n<input type=\"text\" name=\"ShortText\" ng-model=\"subLineitem.MAKTX\"></md-input-container></td><td><md-input-container \nclass=\"md-block no-margin-bottom\"><input type=\"number\" name=\"Quantity\" ng-model=\"subLineitem.MENGE\" \nng-change=\"SubLineItemTotal(subLineitem.TBTWR,subLineitem.MENGE,$index)\" \nng-keypress=\"SubLineItemTotal(subLineitem.TBTWR,subLineitem.MENGE,$index)\"></md-input-container></td><td>\n<md-input-container class=\"md-block no-margin-bottom\"><input type=\"text\" name=\"UOM\" ng-model=\"subLineitem.MEINS\">\n</md-input-container></td><td><md-input-container class=\"md-block no-margin-bottom\"><input type=\"number\" \nname=\"GrossPrice\" ng-model=\"subLineitem.TBTWR\" \nng-change=\"SubLineItemTotal(subLineitem.TBTWR,subLineitem.MENGE,$index)\" \nng-keypress=\"SubLineItemTotal(subLineitem.TBTWR,subLineitem.MENGE,$index)\"></md-input-container></td><td>\n<md-input-container class=\"md-block no-margin-bottom\"><input type=\"number\" name=\"NetValue\" \nng-model=\"subLineitem.NETWR\" ng-disabled=\"true\"></md-input-container></td></tr></tbody></table><div>&nbsp;</div><div \nclass=\"form-group\" layout=\"row\" layout-align=\"end end\"><label for=\"usr\">Total:</label><input type=\"text\" \nclass=\"form-control total\" ng-model=\"total\"></div></md-dialog-content><md-dialog-actions layout=\"row\"><button \ntype=\"button\" class=\"btn btn-danger\" ng-click=\"cancel()\">Cancel</button><div>&nbsp;</div><button type=\"button\" \nclass=\"btn btn-success\" ng-click=\"saveSubLineItems(total)\">Save</button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/Requests/WBS_elementdialog.html","<md-dialog ng-cloak flex=\"60\"><md-toolbar layout=\"row\" class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2>\nSearch WBS Element</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content layout=\"column\" \nlayout-align=\"center center\" class=\"p-0\"><div layout=\"row\" style=\"position: inherit !important\"><md-select \nstyle=\"margin-top: 14px;margin-bottom: 44px\" ng-model=\"search.key\"><md-option value=\"PSPNR\" selected=\"selected\">\nWBS Element</md-option><md-option value=\"POST1\">WBS Description</md-option></md-select><span flex=\"10\"></span>\n<md-input-container class=\"md-block\" flex=\"40\"><input ng-model=\"search.value\" placeholder=\"Search here\">\n</md-input-container><md-button class=\"md-raised\" ng-click=\"searchWBSelement(search)\" style=\"height: 35px;top: 5px\">\nSearch</md-button></div><div style=\"width:100%;     margin-top: 5% !important\" class=\"md-padding scrollable\" ms-scroll \nng-if=\"searchResult\"><div layout=\"row\" flex=\"60\" layout-align=\"center center\" ng-if=\"searchResult.length == 0\" \nstyle=\"border:2px solid #cccccc; border-radius:5px; height:50px;margin-left:20%\"><b>No Records were found</b></div>\n<table class=\"dataTable row-border hover tableHighllete\" ng-if=\"searchResult.length != 0\"><thead><tr \nclass=\"table-header\"><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">WBS Element</span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">WBS Description</span></div>\n</th></tr></thead><tbody><tr ng-repeat=\"order in searchResult\" ng-click=\"searchResultRowClick(order)\" class=\"c-p\"><td>\n{{order.PSPNR}}</td><td>{{order.POST1}}</td></tr></tbody></table></div></md-dialog-content><md-dialog-actions \nng-if=\"searchResult\"><div layout=\"row\" layout-align=\"space-between center\" flex=\"100\"><div class=\"md-padding\"><h5><b>\nShowing {{(pageNumber*size)+1}} - {{(pageNumber + 1)*size}} of {{totalRecords}} Results</b></h5></div><div \nlayout=\"row\" layout-align=\"center center\"><div><md-button type=\"button\" ng-click=\"previous()\" \nng-disabled=\"pageNumber <= 0\">Prev</md-button></div><p class=\"md-padding\"><b>\n{{pageNumber+1}} / {{totalPages}} &nbsp;PAGES</b></p><div class=\"md-padding\"><md-button type=\"button\" \nng-click=\"next()\" ng-disabled=\"pageNumber == totalPages-1\">Next</md-button></div></div></div></md-dialog-actions>\n</md-dialog>");
$templateCache.put("app/main/Requests/coadingTemplates.html","<md-dialog ng-cloak flex=\"60\"><md-toolbar layout=\"row\" class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2>\nSearch CodingTemplates</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content layout=\"column\" \nlayout-align=\"center center\" class=\"p-0\"><div style=\"width:100%;     margin-top: 5% !important\" \nclass=\"md-padding scrollable\" ms-scroll ng-if=\"searchResult\"><div layout=\"row\" flex=\"60\" layout-align=\"center center\" \nng-if=\"searchResult.length == 0\" style=\"border:2px solid #cccccc; border-radius:5px; height:50px;margin-left:20%\"><b>\nNo Records were found</b></div><table class=\"dataTable row-border hover tableHighllete\" \nng-if=\"searchResult.length != 0\"><thead><tr class=\"table-header\"><th class=\"secondary-text\"><div class=\"table-header\">\n<span class=\"column-title\">TemplateId</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Template description</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Invoice category</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">RequestType</span></div></th></tr></thead><tbody><tr ng-repeat=\"order in searchResult\" \nng-click=\"searchResultRowClick(order)\" class=\"c-p\"><td>{{order.templateId}}</td><td>{{order.templateDescription}}</td>\n<td>{{order.invoiceCategory}}</td><td>{{order.requestType}}</td></tr></tbody></table></div></md-dialog-content>\n<md-dialog-actions ng-if=\"searchResult\"><div layout=\"row\" layout-align=\"space-between center\" flex=\"100\"><div \nclass=\"md-padding\"><h5><b>Showing {{1}} - {{searchResult.length}} of {{totalRecords}} Results</b></h5></div><div \nlayout=\"row\" layout-align=\"center center\"><div><md-button type=\"button\" ng-click=\"previous()\" \nng-disabled=\"pageNumber <= 0\">Prev</md-button></div><p class=\"md-padding\"><b>\n{{pageNumber+1}} / {{totalPages}} &nbsp;PAGES</b></p><div class=\"md-padding\"><md-button type=\"button\" \nng-click=\"next()\" ng-disabled=\"pageNumber == totalPages-1\">Next</md-button></div></div></div></md-dialog-actions>\n</md-dialog>");
$templateCache.put("app/main/Requests/companyCode-dialog.html","<md-dialog ng-cloak flex=\"60\"><md-toolbar layout=\"row\" class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2>\nSearch Company Code</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content layout=\"column\" \nlayout-align=\"center center\" class=\"p-0\"><div layout=\"row\" style=\"position: inherit !important\"><md-select \nstyle=\"margin-top: 14px;margin-bottom: 44px\" ng-model=\"search.key\"><md-option value=\"BUKRS\" selected=\"selected\">\nCompany Code</md-option><md-option value=\"BUTXT\">Company Name</md-option></md-select><span flex=\"10\"></span>\n<md-input-container class=\"md-block\" flex=\"40\"><input ng-model=\"search.value\" placeholder=\"Search here\">\n</md-input-container><md-button class=\"md-raised\" ng-click=\"searchcompanyCode(search)\" style=\"height: 35px;top: 5px\">\nSearch</md-button></div><div style=\"width:100%;     margin-top: 5% !important\" class=\"md-padding scrollable\" ms-scroll \nng-if=\"searchResult\"><div layout=\"row\" flex=\"60\" layout-align=\"center center\" ng-if=\"searchResult.length == 0\" \nstyle=\"border:2px solid #cccccc; border-radius:5px; height:50px;margin-left:20%\"><b>No Records were found</b></div>\n<table class=\"dataTable row-border hover tableHighllete\" ng-if=\"searchResult.length != 0\"><thead><tr \nclass=\"table-header\"><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Company Code\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Company Name</span>\n</div></th></tr></thead><tbody><tr ng-repeat=\"order in searchResult\" ng-click=\"searchResultRowClick(order)\" \nclass=\"c-p\"><td>{{order.BUKRS}}</td><td>{{order.BUTXT}}</td></tr></tbody></table></div></md-dialog-content>\n<md-dialog-actions ng-if=\"searchResult\"><div layout=\"row\" layout-align=\"space-between center\" flex=\"100\"><div \nclass=\"md-padding\"><h5><b>Showing {{(pageNumber*size)+1}} - {{(pageNumber + 1)*size}} of {{totalRecords}} Results</b>\n</h5></div><div layout=\"row\" layout-align=\"center center\"><div><md-button type=\"button\" ng-click=\"previous()\" \nng-disabled=\"pageNumber <= 0\">Prev</md-button></div><p class=\"md-padding\"><b>\n{{pageNumber+1}} / {{totalPages}} &nbsp;PAGES</b></p><div class=\"md-padding\"><md-button type=\"button\" \nng-click=\"next()\" ng-disabled=\"pageNumber == totalPages-1\">Next</md-button></div></div></div></md-dialog-actions>\n</md-dialog>");
$templateCache.put("app/main/Requests/costcenterdialog.html","<md-dialog ng-cloak flex=\"60\"><md-toolbar layout=\"row\" class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2>\nSearch CostCenter</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content layout=\"column\" \nlayout-align=\"center center\" class=\"p-0\"><div layout=\"row\" style=\"position: inherit !important\"><md-select \nstyle=\"margin-top: 14px;margin-bottom: 44px\" ng-model=\"search.key\"><md-option value=\"KOSTL\" selected=\"selected\">\nCostCenter</md-option><md-option value=\"LTEXT\">Description</md-option></md-select><span flex=\"10\"></span>\n<md-input-container class=\"md-block\" flex=\"40\"><input ng-model=\"search.value\" placeholder=\"Search here\">\n</md-input-container><md-button class=\"md-raised\" ng-click=\"searchCostCenter(search)\" style=\"height: 35px;top: 5px\">\nSearch</md-button></div><div style=\"width:100%;     margin-top: 5% !important\" class=\"md-padding scrollable\" ms-scroll \nng-if=\"searchResult\"><div layout=\"row\" flex=\"60\" layout-align=\"center center\" ng-if=\"searchResult.length == 0\" \nstyle=\"border:2px solid #cccccc; border-radius:5px; height:50px;margin-left:20%\"><b>No Records were found</b></div>\n<table class=\"dataTable row-border hover tableHighllete\" ng-if=\"searchResult.length != 0\"><thead><tr \nclass=\"table-header\"><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">CostCenter Code\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">\nCostCenter Description</span></div></th></tr></thead><tbody><tr ng-repeat=\"order in searchResult\" \nng-click=\"searchResultRowClick(order)\" class=\"c-p\"><td>{{order.KOSTL}}</td><td>{{order.LTEXT}}</td></tr></tbody>\n</table></div></md-dialog-content><md-dialog-actions ng-if=\"searchResult\"><div layout=\"row\" \nlayout-align=\"space-between center\" flex=\"100\"><div class=\"md-padding\"><h5><b>\nShowing {{(pageNumber*size)+1}} - {{(pageNumber + 1)*size}} of {{totalRecords}} Results</b></h5></div><div \nlayout=\"row\" layout-align=\"center center\"><div><md-button type=\"button\" ng-click=\"previous()\" \nng-disabled=\"pageNumber <= 0\">Prev</md-button></div><p class=\"md-padding\"><b>\n{{pageNumber+1}} / {{totalPages}} &nbsp;PAGES</b></p><div class=\"md-padding\"><md-button type=\"button\" \nng-click=\"next()\" ng-disabled=\"pageNumber == totalPages-1\">Next</md-button></div></div></div></md-dialog-actions>\n</md-dialog>");
$templateCache.put("app/main/Requests/customerMasterCreationForm.html","<div class=\"page-layout carded fullwidth scrollable\" layout=\"column\" flex ms-scroll><div class=\"widget-group\" \nflex=\"100\" layout=\"column\" layout-wrap><ms-widget flippable=\"true\" layout=\"column\"><ms-widget-front class=\"white-bg\">\n<div flex=\"35\" class=\"md-padding\"><ul class=\"breadcrumb\"><li ng-click=\"requestCtrl.goToRequests()\">Requests</li><li>\nCustomerMasterCreationForm</li></ul></div><div layout=\"row\"><div ng-cloak flex=\"100\" class=\"scrollable\" ms-scroll>\n<md-content><md-tabs md-dynamic-height md-border-bottom><md-tab label=\"Header\"><md-content \nclass=\"md-padding scrollable\" ms-scroll><div layout=\"row\" layout-align=\"center center\"><div flex=\"70\" \nstyle=\"border: 1px solid #cccccc\"><form name=\"customerForm\" novalidate><md-toolbar class=\"orange-bg white-fg\"><div \nclass=\"md-toolbar-tools\"><h2>CUSTOMER - MASTER CREATION FORM</h2></div></md-toolbar><div layout=\"row\"><div flex=\"20\" \nlayout=\"row\" layout-align=\"end center\"><h3>Customer Code</h3></div><span flex=\"5\"></span><md-input-container \nclass=\"md-block\" flex=\"20\"><input type=\"text\" name=\"owner\" ng-model=\"form.customerCode\"></md-input-container><span \nflex=\"5\"></span><div flex=\"20\" layout=\"row\" layout-align=\"end center\"><h3>Account Group</h3></div><span flex=\"5\">\n</span><md-input-container class=\"md-block\" flex=\"20\"><md-select ng-model=\"form.accountGroup\"><md-option \nng-repeat=\"AccountGroup in AccountGroups\" ng-value=\"AccountGroup\">{{AccountGroup}}</md-option></md-select>\n</md-input-container></div><div layout=\"row\"><div flex=\"20\" layout=\"row\" layout-align=\"end center\"><h3>\nReconciliation Account</h3></div><span flex=\"5\"></span><md-input-container class=\"md-block\" flex=\"20\"><md-select \nng-model=\"form.organisation\"><md-option ng-repeat=\"salesOrganisation in salesOrganisations\" \nng-value=\"salesOrganisation\">{{salesOrganisation}}</md-option></md-select></md-input-container><span flex=\"5\"></span>\n<div flex=\"20\" layout=\"row\" layout-align=\"end center\"><h3>Type</h3></div><span flex=\"5\"></span><md-input-container \nclass=\"md-block\" flex=\"20\"><md-select ng-model=\"form.type\"><md-option ng-repeat=\"type in types\" ng-value=\"type\">\n{{type}}</md-option></md-select></md-input-container></div><div layout=\"row\"><div flex=\"20\" layout=\"row\" \nlayout-align=\"end center\"><h3>Industry Sector</h3></div><span flex=\"5\"></span><md-input-container class=\"md-block\" \nflex=\"20\"><md-select ng-model=\"form.channel\"><md-option ng-repeat=\"distributionChannel in distributionChannels\" \nng-value=\"distributionChannel\">{{distributionChannel}}</md-option></md-select></md-input-container><span flex=\"5\">\n</span><div flex=\"20\" layout=\"row\" layout-align=\"end center\"><h3>Customer Group</h3></div><span flex=\"5\"></span>\n<md-input-container class=\"md-block\" flex=\"20\"><md-select ng-model=\"form.conditionType\"><md-option \nng-repeat=\"customerGroup in customerGroups\" ng-value=\"customerGroup\">{{customerGroup}}</md-option></md-select>\n</md-input-container></div><div layout=\"row\"><div flex=\"20\" layout=\"row\" layout-align=\"end center\"></div><span \nflex=\"5\"></span><md-input-container class=\"md-block\" flex=\"20\"><input type=\"text\" name=\"owner\" \nplaceholder=\"Name of the Firm\" ng-model=\"form.customerCo\"></md-input-container><span flex=\"5\"></span><div flex=\"20\" \nlayout=\"row\" layout-align=\"end center\"></div><span flex=\"5\"></span><md-input-container class=\"md-block\" flex=\"20\">\n<input type=\"text\" name=\"owner\" placeholder=\"Address of the Firm\" ng-model=\"form.customerCo\"></md-input-container>\n</div><div layout=\"row\"><div flex=\"20\" layout=\"row\" layout-align=\"end center\"><h3>Billing Address</h3></div><span \nflex=\"5\"></span><md-input-container class=\"md-block\" flex=\"20\"><input type=\"text\" name=\"owner\" \nng-model=\"form.customerCo\"></md-input-container><span flex=\"5\"></span><div flex=\"20\" layout=\"row\" \nlayout-align=\"end center\"><h3>Delivery Address</h3></div><span flex=\"5\"></span><md-input-container class=\"md-block\" \nflex=\"20\"><input type=\"text\" name=\"owner\" ng-model=\"form.customerCo\"></md-input-container></div><div layout=\"row\"><div \nflex=\"20\" layout=\"row\" layout-align=\"end center\"><h3>Post Code</h3></div><span flex=\"5\"></span><md-input-container \nclass=\"md-block\" flex=\"20\"><input type=\"text\" name=\"owner\" ng-model=\"form.customerCo\"></md-input-container><span \nflex=\"5\"></span><div flex=\"20\" layout=\"row\" layout-align=\"end center\"><h3>Post Code</h3></div><span flex=\"5\"></span>\n<md-input-container class=\"md-block\" flex=\"20\"><input type=\"text\" name=\"owner\" ng-model=\"form.customerCo\">\n</md-input-container></div><div layout=\"row\"><span flex=\"50\"></span><div flex=\"20\" layout=\"row\" \nlayout-align=\"end center\"><h3>Distribution Channel</h3></div><span flex=\"5\"></span><md-input-container \nclass=\"md-block\" flex=\"20\"><md-select ng-model=\"form.distributionChannel\"><md-option \nng-repeat=\"CMCFDidtributionChannel in CMCFDidtributionChannels\" ng-value=\"CMCFDidtributionChannel\">\n{{CMCFDidtributionChannel}}</md-option></md-select></md-input-container></div><div layout=\"row\"><div flex=\"20\" \nlayout=\"row\" layout-align=\"end center\"><h3>Payment Terms</h3></div><span flex=\"5\"></span><md-input-container \nclass=\"md-block\" flex=\"70\"><md-select ng-model=\"form.paymentTerm\"><md-option ng-repeat=\"paymentTerm in paymentTerms\" \nng-value=\"paymentTerm\">{{paymentTerm}}</md-option></md-select></md-input-container></div><div layout=\"row\"><div \nflex=\"20\" layout=\"row\" layout-align=\"end center\"><h3>Sales Area</h3></div><span flex=\"5\"></span><md-input-container \nclass=\"md-block\" flex=\"20\"><md-select ng-model=\"form.salesArea\"><md-option ng-repeat=\"salesArea in salesAreas\" \nng-value=\"salesArea\">{{salesArea}}</md-option></md-select></md-input-container><span flex=\"5\"></span><div flex=\"20\" \nlayout=\"row\" layout-align=\"end center\"><h3>Sales Office</h3></div><span flex=\"5\"></span><md-input-container \nclass=\"md-block\" flex=\"20\"><md-select ng-model=\"form.salesOffice\"><md-option ng-repeat=\"salesOffice in salesOffices\" \nng-value=\"salesOffice\">{{salesOffice}}</md-option></md-select></md-input-container></div><div layout=\"row\"><div \nflex=\"20\" layout=\"row\" layout-align=\"end center\"><h3>Customer Status Group</h3></div><span flex=\"5\"></span>\n<md-input-container class=\"md-block\" flex=\"20\"><md-select ng-model=\"form.customerStatusGroup\"><md-option \nng-repeat=\"salesArea in salesAreas\" ng-value=\"salesArea\">{{salesArea}}</md-option></md-select></md-input-container>\n<span flex=\"5\"></span><div flex=\"20\" layout=\"row\" layout-align=\"end center\"><h3>Order Currency</h3></div><span \nflex=\"5\"></span><md-input-container class=\"md-block\" flex=\"20\"><input type=\"text\" name=\"owner\" \nng-model=\"form.orderCurrency\"></md-input-container></div><div layout=\"row\"><div flex=\"20\" layout=\"row\" \nlayout-align=\"end center\"><h3>Taxes</h3></div><span flex=\"5\"></span><md-input-container class=\"md-block\" flex=\"70\">\n<md-select ng-model=\"form.tax\"><md-option ng-repeat=\"tax in taxes\" ng-value=\"tax\">{{tax}}</md-option></md-select>\n</md-input-container></div><div layout=\"row\" layout-align=\"center center\"><h4>\nNOTE: PLEASE ATTACH COPY OF TAX EXPEMTION / CONCESSION ISSUED BY THE RELEVANT DEPARTMENT</h4></div><div layout=\"row\">\n<div flex=\"20\" layout=\"row\" layout-align=\"end center\"><h3>Excise Registration No</h3></div><span flex=\"5\"></span>\n<md-input-container class=\"md-block\" flex=\"70\"><input type=\"text\" name=\"owner\" ng-model=\"form.exsiseRegistrationNo\">\n</md-input-container></div><div layout=\"row\"><div flex=\"20\" layout=\"row\" layout-align=\"end center\"><h3>\nExcise Range and DIvision</h3></div><span flex=\"5\"></span><md-input-container class=\"md-block\" flex=\"70\"><input \ntype=\"text\" name=\"owner\" ng-model=\"form.exciseRangeandDivision\"></md-input-container></div><div layout=\"row\"><div \nflex=\"20\" layout=\"row\" layout-align=\"end center\"><h3>VAT / TIN</h3></div><span flex=\"5\"></span><md-input-container \nclass=\"md-block\" flex=\"70\"><input type=\"text\" name=\"owner\" ng-model=\"form.vatOrTin\"></md-input-container></div><div \nlayout=\"row\"><div flex=\"20\" layout=\"row\" layout-align=\"end center\"><h3>Service Tax</h3></div><span flex=\"5\"></span>\n<md-input-container class=\"md-block\" flex=\"70\"><input type=\"text\" name=\"owner\" ng-model=\"form.serviceTax\">\n</md-input-container></div><div layout=\"row\"><div flex=\"20\" layout=\"row\" layout-align=\"end center\"><h3>PAN No</h3>\n</div><span flex=\"5\"></span><md-input-container class=\"md-block\" flex=\"70\"><input type=\"text\" name=\"owner\" \nng-model=\"form.panNo\"></md-input-container></div><div layout=\"row\"><div flex=\"20\" layout=\"row\" \nlayout-align=\"end center\"><h3>SSI Registration No</h3></div><span flex=\"5\"></span><md-input-container class=\"md-block\" \nflex=\"70\"><input type=\"text\" name=\"owner\" ng-model=\"form.ssiRegistrationNo\"></md-input-container></div><div \nlayout=\"row\"><div flex=\"20\" layout=\"row\" layout-align=\"end center\"><h3>Year of Establishment</h3></div><span flex=\"5\">\n</span><md-input-container class=\"md-block\" flex=\"20\"><input type=\"text\" name=\"owner\" \nng-model=\"form.establishmentYear\"></md-input-container><span flex=\"5\"></span><div flex=\"20\" layout=\"row\" \nlayout-align=\"end center\"><h3>Trade License No</h3></div><span flex=\"5\"></span><md-input-container class=\"md-block\" \nflex=\"20\"><input type=\"text\" name=\"owner\" ng-model=\"form.tradeLicenseNo\"></md-input-container></div><md-toolbar \nclass=\"md-primary\"><div class=\"md-toolbar-tools\"><div layout=\"row\" layout-align=\"end center\" flex><div \nclass=\"md-padding\"><md-button type=\"submit\" class=\"md-warn md-raised\" ng-click=\"submitForm(form)\">Submit</md-button>\n<md-button type=\"button\" class=\"green-bg md-raised\" ng-click=\"\">Cancel</md-button></div></div></div></md-toolbar>\n</form></div></div></md-content></md-tab><md-tab label=\"Line Items\"><md-content class=\"md-padding\"><div layout=\"row\" \nlayout-align=\"center center\"><h2>Line Items data</h2></div></md-content></md-tab><md-tab label=\"Comments\"><md-content \nclass=\"md-padding\"><h1 class=\"md-display-2\">Comments Tab</h1><p>\nInteger turpis erat, porttitor vitae mi faucibus, laoreet interdum tellus. Curabitur posuere molestie dictum. Morbi eget congue risus, quis rhoncus quam. Suspendisse vitae hendrerit erat, at posuere mi. Cras eu fermentum nunc. Sed id ante eu orci commodo volutpat non ac est. Praesent ligula diam, congue eu enim scelerisque, finibus commodo lectus.\n</p></md-content></md-tab><md-tab label=\"Attachments\"><md-content class=\"md-padding\"><h1 class=\"md-display-2\">\nAttachments Tab</h1><p>\nInteger turpis erat, porttitor vitae mi faucibus, laoreet interdum tellus. Curabitur posuere molestie dictum. Morbi eget congue risus, quis rhoncus quam. Suspendisse vitae hendrerit erat, at posuere mi. Cras eu fermentum nunc. Sed id ante eu orci commodo volutpat non ac est. Praesent ligula diam, congue eu enim scelerisque, finibus commodo lectus.\n</p></md-content></md-tab></md-tabs></md-content></div></div></ms-widget-front></ms-widget></div></div>");
$templateCache.put("app/main/Requests/customerPriceMasterForm.html","<div class=\"page-layout carded fullwidth scrollable\" layout=\"column\" flex ms-scroll md-dynamic-height><div \nclass=\"widget-group\" flex=\"100\" layout=\"column\" layout-wrap><ms-widget flippable=\"true\" layout=\"column\">\n<ms-widget-front class=\"white-bg\"><div flex=\"30\" class=\"md-padding\"><ul class=\"breadcrumb\"><li \nng-click=\"requestCtrl.goToRequests()\">Requests</li><li>CustomerPriceMasterForm</li></ul></div><div layout=\"row\"><div \nng-cloak flex=\"100\" class=\"scrollable\" ms-scroll><md-content><md-tabs md-dynamic-height md-border-bottom><md-tab \nlabel=\"Header\"><md-content class=\"md-padding scrollable\" ms-scroll><div layout=\"row\" layout-align=\"center center\"><div \nflex=\"70\" style=\"border: 1px solid #cccccc\"><form name=\"customerForm\" novalidate><div layout=\"row\"><div flex=\"20\" \nlayout=\"row\" layout-align=\"end center\"><h3>Customer Code</h3></div><span flex=\"5\"></span><md-input-container \nclass=\"md-block\" flex=\"20\"><input type=\"text\" name=\"owner\" ng-model=\"form.customerCode\"></md-input-container><span \nflex=\"5\"></span><div flex=\"20\" layout=\"row\" layout-align=\"end center\"><h3>Account Group</h3></div><span flex=\"5\">\n</span><md-input-container class=\"md-block\" flex=\"20\"><md-select ng-model=\"form.accountGroup\"><md-option \nng-repeat=\"AccountGroup in AccountGroups\" ng-value=\"AccountGroup\">{{AccountGroup}}</md-option></md-select>\n</md-input-container></div><div layout=\"row\"><div flex=\"20\" layout=\"row\" layout-align=\"end center\"><h3>Customer Name:\n</h3></div><span flex=\"5\"></span><md-input-container class=\"md-block\" flex=\"70\"><input type=\"text\" name=\"owner\" \nng-model=\"form.customerName\"></md-input-container></div><div layout=\"row\"><div flex=\"20\" layout=\"row\" \nlayout-align=\"end center\"><h3>Sales Organisation:</h3></div><span flex=\"5\"></span><md-input-container class=\"md-block\" \nflex=\"20\"><md-select ng-model=\"form.organisation\"><md-option ng-repeat=\"salesOrganisation in salesOrganisations\" \nng-value=\"salesOrganisation\">{{salesOrganisation}}</md-option></md-select></md-input-container><span flex=\"5\"></span>\n<div flex=\"20\" layout=\"row\" layout-align=\"end center\"><h3>Type</h3></div><span flex=\"5\"></span><md-input-container \nclass=\"md-block\" flex=\"20\"><md-select ng-model=\"form.type\"><md-option ng-repeat=\"type in types\" ng-value=\"type\">\n{{type}}</md-option></md-select></md-input-container></div><div layout=\"row\"><div flex=\"20\" layout=\"row\" \nlayout-align=\"end center\"><h3>Distribution Channel:</h3></div><span flex=\"5\"></span><md-input-container \nclass=\"md-block\" flex=\"20\"><md-select ng-model=\"form.channel\"><md-option \nng-repeat=\"distributionChannel in distributionChannels\" ng-value=\"distributionChannel\">{{distributionChannel}}\n</md-option></md-select></md-input-container><span flex=\"5\"></span><div flex=\"20\" layout=\"row\" \nlayout-align=\"end center\"><h3>Conditions Type:</h3></div><span flex=\"5\"></span><md-input-container class=\"md-block\" \nflex=\"20\"><md-select ng-model=\"form.conditionType\"><md-option ng-repeat=\"conditionType in conditionTypes\" \nng-value=\"conditionType\">{{conditionType}}</md-option></md-select></md-input-container></div><md-toolbar \nclass=\"md-primary\"><div class=\"md-toolbar-tools\"><div layout=\"row\" layout-align=\"end center\" flex><div \nclass=\"md-padding\"><md-button type=\"submit\" class=\"md-warn md-raised\" ng-click=\"submitForm(form)\">Submit</md-button>\n<md-button type=\"button\" class=\"green-bg md-raised\" ng-click=\"\">Cancel</md-button></div></div></div></md-toolbar>\n</form></div></div></md-content></md-tab><md-tab label=\"Line Items\"><md-content class=\"md-padding\"><div layout=\"row\" \nlayout-align=\"center center\"><div flex=\"90\" style=\"border: 1px solid #cccccc\"><md-toolbar \nstyle=\"background-color:rgb(41, 66, 112)\" class=\"white-fg\"><div class=\"md-toolbar-tools\"><div layout=\"row\" flex=\"100\" \nlayout-align=\"center center\"><div flex=\"5\"><p>S.No</p></div><div flex=\"10\"><p>Material Code</p></div><div flex=\"10\"><p>\nNew Price</p></div><div flex=\"10\"><p>Old Price</p></div><div flex=\"10\"><p>Price Var.</p></div><div flex=\"10\"><p>Current\n</p></div><div flex=\"10\"><p>Price per 1000 or EA</p></div><span flex=\"5\"></span><div flex=\"10\"><p>Base Unit of Measure\n</p></div><div flex=\"10\"><p>Valid From</p></div><div flex=\"10\"><p>Valid To</p></div></div></div></md-toolbar><form \nname=\"lineItemsForm\" novalidate><div layout=\"row\" layout-align=\"center center\" ng-repeat=\"row in rows\"><div flex=\"5\">\n<h3 class=\"md-padding\">{{row}}</h3></div><div flex=\"10\" class=\"md-block md-padding\"><md-input-container \nclass=\"md-block\"><input type=\"text\" name=\"owner\" ng-model=\"form.materialCode\"></md-input-container></div><div \nflex=\"10\"><md-input-container class=\"md-block md-padding\"><input type=\"text\" name=\"owner\" ng-model=\"form.newPrice\">\n</md-input-container></div><div flex=\"10\"><md-input-container class=\"md-block md-padding\"><input type=\"text\" \nname=\"owner\" ng-model=\"form.oldPrice\"></md-input-container></div><div flex=\"10\"><md-input-container class=\"md-block\">\n<md-select ng-model=\"form.priceVar\"><md-option ng-repeat=\"priceVar in priceVars\" ng-value=\"priceVar\">{{priceVar}}\n</md-option></md-select></md-input-container></div><div flex=\"10\"><md-input-container class=\"md-block md-padding\">\n<input type=\"text\" name=\"owner\" ng-model=\"form.current\"></md-input-container></div><div flex=\"15\"><md-input-container \nclass=\"md-block md-padding\"><input type=\"text\" name=\"owner\" ng-model=\"form.pricePer\"></md-input-container></div><div \nflex=\"10\"><md-input-container class=\"md-block md-padding\"><input type=\"text\" name=\"owner\" ng-model=\"form.baseUnit\">\n</md-input-container></div><div flex=\"10\"><md-input-container class=\"md-block md-padding\"><input type=\"text\" \nname=\"owner\" ng-model=\"form.validFrom\"></md-input-container></div><div flex=\"10\"><md-input-container \nclass=\"md-block md-padding\"><input type=\"text\" name=\"owner\" ng-model=\"form.validTo\"></md-input-container></div></div>\n<md-toolbar class=\"md-primary\"><div class=\"md-toolbar-tools\"><div layout=\"row\" layout-align=\"end center\" flex><div \nclass=\"md-padding\"><md-button type=\"submit\" class=\"md-warn md-raised\" ng-click=\"submitForm(form)\">Submit</md-button>\n<md-button type=\"button\" class=\"green-bg md-raised\" ng-click=\"\">Cancel</md-button></div></div></div></md-toolbar>\n</form></div></div></md-content></md-tab><md-tab label=\"Comments\"><md-content class=\"md-padding\"><h1 \nclass=\"md-display-2\">Comments Tab</h1><p>\nInteger turpis erat, porttitor vitae mi faucibus, laoreet interdum tellus. Curabitur posuere molestie dictum. Morbi eget congue risus, quis rhoncus quam. Suspendisse vitae hendrerit erat, at posuere mi. Cras eu fermentum nunc. Sed id ante eu orci commodo volutpat non ac est. Praesent ligula diam, congue eu enim scelerisque, finibus commodo lectus.\n</p></md-content></md-tab><md-tab label=\"Attachments\"><md-content class=\"md-padding\"><h1 class=\"md-display-2\">\nAttachments Tab</h1><p>\nInteger turpis erat, porttitor vitae mi faucibus, laoreet interdum tellus. Curabitur posuere molestie dictum. Morbi eget congue risus, quis rhoncus quam. Suspendisse vitae hendrerit erat, at posuere mi. Cras eu fermentum nunc. Sed id ante eu orci commodo volutpat non ac est. Praesent ligula diam, congue eu enim scelerisque, finibus commodo lectus.\n</p></md-content></md-tab></md-tabs></md-content></div></div></ms-widget-front></ms-widget></div></div>");
$templateCache.put("app/main/Requests/glAccountdialog.html","<md-dialog ng-cloak flex=\"60\"><md-toolbar layout=\"row\" class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2>\nSearch G/L Account</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content layout=\"column\" \nlayout-align=\"center center\" class=\"p-0\"><div layout=\"row\" style=\"position: inherit !important\"><md-select \nstyle=\"margin-top: 14px;margin-bottom: 44px\" ng-model=\"search.key\"><md-option value=\"SAKNR\" selected=\"selected\">\nG/L Account</md-option><md-option value=\"TXT20\">Description</md-option></md-select><span flex=\"10\"></span>\n<md-input-container class=\"md-block\" flex=\"40\"><input ng-model=\"search.value\" placeholder=\"Search here\">\n</md-input-container><md-button class=\"md-raised\" ng-click=\"searchGLValues(search)\" style=\"height: 35px;top: 5px\">\nSearch</md-button></div><div style=\"width:100%;     margin-top: 5% !important\" class=\"md-padding scrollable\" ms-scroll \nng-if=\"searchResult\"><div layout=\"row\" flex=\"60\" layout-align=\"center center\" ng-if=\"searchResult.length == 0\" \nstyle=\"border:2px solid #cccccc; border-radius:5px; height:50px;margin-left:20%\"><b>No Records were found</b></div>\n<table class=\"dataTable row-border hover tableHighllete\" ng-if=\"searchResult.length != 0\"><thead><tr \nclass=\"table-header\"><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">G/L AccountCode\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">\nG/L AccountDescription</span></div></th></tr></thead><tbody><tr ng-repeat=\"order in searchResult\" \nng-click=\"searchResultRowClick(order)\" class=\"c-p\"><td>{{order.SAKNR}}</td><td>{{order.TXT20}}</td></tr></tbody>\n</table></div></md-dialog-content><md-dialog-actions ng-if=\"searchResult\"><div layout=\"row\" \nlayout-align=\"space-between center\" flex=\"100\"><div class=\"md-padding\"><h5><b>\nShowing {{(pageNumber*size)+1}} - {{(pageNumber + 1)*size}} of {{totalRecords}} Results</b></h5></div><div \nlayout=\"row\" layout-align=\"center center\"><div><md-button type=\"button\" ng-click=\"previous()\" \nng-disabled=\"pageNumber <= 0\">Prev</md-button></div><p class=\"md-padding\"><b>\n{{pageNumber+1}} / {{totalPages}} &nbsp;PAGES</b></p><div class=\"md-padding\"><md-button type=\"button\" \nng-click=\"next()\" ng-disabled=\"pageNumber == totalPages-1\">Next</md-button></div></div></div></md-dialog-actions>\n</md-dialog>");
$templateCache.put("app/main/Requests/mtr-search-help.html","<md-dialog flex=\"90\" flex-gt-sm=\"40\"><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><h2>Search {{mtrListName}}</h2><md-button class=\"md-icon-button\" \nng-click=\"cancel()\"><md-icon md-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"row\" \nlayout-align=\"end center\"><md-input-container><label>Selet Field</label><md-select ng-model=\"searchObj.key\"><md-option \nng-repeat=\"key in keys\" ng-value=\"key\">{{key}}</md-option></md-select></md-input-container><mat-input-container \nclass=\"md-block\" style=\"border: 1px solid #cccccc;\n                border-radius: 3px;\n                padding: 5px\">\n<input type=\"text\" ng-model=\"searchObj.value\" placeholder=\"Search\"></mat-input-container><md-button \nclass=\"md-raised md-accent\" ng-click=\"mtrSearchHelpSearch(searchObj)\">Search</md-button><md-button \nclass=\"md-raised md-accent\" ng-click=\"reserMTRSearch()\">Reset</md-button></div><table \nclass=\"dataTable row-border hover table-border ng-cloak\" dt-options=\"SORClaimCtrl.dtOptions\"><thead><tr \nclass=\"table-header\"><th class=\"secondary-text\" ng-hide=\"value == \'_id\'\" ng-repeat=\"(key, value) in dynamicdata1\"><div \nclass=\"table-header\"><span class=\"column-title\">{{value}}</span></div></th></tr></thead><tbody><tr \nng-repeat=\"(key, value) in listData track by $index\" ng-click=\"selectRow(value)\" class=\"c-p\"><td ng-hide=\"k == \'_id\'\" \nng-repeat=\"(k, v) in listData[$index] track by $index\">{{v}}</td></tr></tbody></table></md-dialog-content>\n<md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"center center\"><div><md-button type=\"button\" \nng-click=\"previous()\" ng-disabled=\"(pageNumber*pageSize)+1 <= 1\">Prev</md-button></div><h5>\n{{(pageNumber*pageSize)+1}} - {{(pageNumber*pageSize)+resultsLength }} of {{numberOfElements}} Results</h5><div \nclass=\"md-padding\"><md-button type=\"button\" ng-click=\"next()\" \nng-disabled=\"(pageNumber*pageSize)+resultsLength >= numberOfElements\">Next</md-button></div></div></div><md-button \nng-click=\"cancel()\">Cancel</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/Requests/orderdialog.html","<md-dialog ng-cloak flex=\"60\"><md-toolbar layout=\"row\" class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2>\nSearch Order No</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content layout=\"column\" \nlayout-align=\"center center\" class=\"p-0\"><div layout=\"row\" style=\"position: inherit !important\"><md-select \nstyle=\"margin-top: 14px;margin-bottom: 44px\" ng-model=\"search.key\"><md-option value=\"AUFNR\" selected=\"selected\">\nOrder Number</md-option><md-option value=\"KTEXT\">Description</md-option></md-select><span flex=\"10\"></span>\n<md-input-container class=\"md-block\" flex=\"40\"><input ng-model=\"search.value\" placeholder=\"Search here\">\n</md-input-container><md-button class=\"md-raised\" ng-click=\"searchAssetCode(search)\" style=\"height: 35px;top: 5px\">\nSearch</md-button></div><div style=\"width:100%;     margin-top: 5% !important\" class=\"md-padding scrollable\" ms-scroll \nng-if=\"searchResult\"><div layout=\"row\" flex=\"60\" layout-align=\"center center\" ng-if=\"searchResult.length == 0\" \nstyle=\"border:2px solid #cccccc; border-radius:5px; height:50px;margin-left:20%\"><b>No Records were found</b></div>\n<table class=\"dataTable row-border hover tableHighllete\" ng-if=\"searchResult.length != 0\"><thead><tr \nclass=\"table-header\"><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Oredr Number\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Order Description\n</span></div></th></tr></thead><tbody><tr ng-repeat=\"order in searchResult\" ng-click=\"searchResultRowClick(order)\" \nclass=\"c-p\"><td>{{order.AUFNR}}</td><td>{{order.KTEXT}}</td></tr></tbody></table></div></md-dialog-content>\n<md-dialog-actions ng-if=\"searchResult\"><div layout=\"row\" layout-align=\"space-between center\" flex=\"100\"><div \nclass=\"md-padding\"><h5><b>Showing {{(pageNumber*size)+1}} - {{(pageNumber + 1)*size}} of {{totalRecords}} Results</b>\n</h5></div><div layout=\"row\" layout-align=\"center center\"><div><md-button type=\"button\" ng-click=\"previous()\" \nng-disabled=\"pageNumber <= 0\">Prev</md-button></div><p class=\"md-padding\"><b>\n{{pageNumber+1}} / {{totalPages}} &nbsp;PAGES</b></p><div class=\"md-padding\"><md-button type=\"button\" \nng-click=\"next()\" ng-disabled=\"pageNumber == totalPages-1\">Next</md-button></div></div></div></md-dialog-actions>\n</md-dialog>");
$templateCache.put("app/main/Requests/poNumberdialog.html","<md-dialog ng-cloak flex=\"60\"><md-toolbar layout=\"row\" class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2>\nSearch PO Number</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content layout=\"column\" \nlayout-align=\"center center\" class=\"p-0\"><div layout=\"row\" style=\"position: inherit !important\"><md-select \nstyle=\"margin-top: 14px;margin-bottom: 44px\" ng-model=\"search.key\"><md-option value=\"EBELN\" selected=\"selected\">\nPO Number</md-option><md-option value=\"LIFNR\">Vendor Code</md-option></md-select><span flex=\"10\"></span>\n<md-input-container class=\"md-block\" flex=\"40\"><input ng-model=\"search.value\" placeholder=\"Search here\">\n</md-input-container><md-button class=\"md-raised\" ng-click=\"searchPOValues(search)\" style=\"height: 35px;top: 5px\">\nSearch</md-button></div><div style=\"width:100%;     margin-top: 5% !important\" class=\"md-padding scrollable\" ms-scroll \nng-if=\"searchResult\"><div layout=\"row\" flex=\"60\" layout-align=\"center center\" ng-if=\"searchResult.length == 0\" \nstyle=\"border:2px solid #cccccc; border-radius:5px; height:50px;margin-left:20%\"><b>No Records were found</b></div>\n<table class=\"dataTable row-border hover tableHighllete\" ng-if=\"searchResult.length != 0\"><thead><tr \nclass=\"table-header\"><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">PO Number</span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Vendor Code</span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Vendor Name</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Company Code</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Company Name</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Invoice Category</span></div></th></tr>\n</thead><tbody><tr ng-repeat=\"order in searchResult\" ng-click=\"searchResultRowClick(order)\"><td>{{order.EBELN}}</td>\n<td>{{order.LIFNR}}</td><td>{{order.NAME1}}</td><td>{{order.BUKRS}}</td><td>{{order.BUTXT}}</td><td>\n{{order.INVOICE_CAT}}</td></tr></tbody></table></div></md-dialog-content><md-dialog-actions ng-if=\"searchResult\"><div \nlayout=\"row\" layout-align=\"space-between center\" flex=\"100\"><div class=\"md-padding\"><h5><b>\nShowing {{(pageNumber*size)+1}} - {{(pageNumber + 1)*size}} of {{totalRecords}} Results</b></h5></div><div \nlayout=\"row\" layout-align=\"center center\"><div><md-button type=\"button\" ng-click=\"previous()\" \nng-disabled=\"pageNumber <= 0\">Prev</md-button></div><p class=\"md-padding\"><b>\n{{pageNumber+1}} / {{totalPages}} &nbsp;PAGES</b></p><div class=\"md-padding\"><md-button type=\"button\" \nng-click=\"next()\" ng-disabled=\"pageNumber == totalPages-1\">Next</md-button></div></div></div></md-dialog-actions>\n</md-dialog>");
$templateCache.put("app/main/Requests/profitCenter-dialog.html","<style>\n.ps-container > .ps-scrollbar-y-rail > .ps-scrollbar-y {\n        width: 4px;\n        padding: 5px;\n        height: 80px;\n        margin: 0px;\n        height: 36px !important;\n    }\n    thead th {\n         position: sticky; \n         top: 0;\n         background: #dee7f4 !important;\n    }\n    table.dataTable tbody td {\n    padding: 9px 8px;\n    vertical-align: middle;\n}\n</style><md-dialog ng-cloak flex=\"40\"><md-toolbar layout=\"row\" class=\"md-accent\"><div class=\"md-toolbar-tools\" \nlayout=\"row\" layout-align=\"space-between\n        center\"><h2>Search ProfitCenter</h2><md-button class=\"md-icon-button\" \nng-click=\"cancel()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nlayout=\"column\" layout-align=\"center center\" class=\"p-0\"><div layout=\"row\" \nstyle=\"position: inherit !important; padding-bottom: 2%\"><md-select style=\"margin-top: 14px;margin-bottom: 44px\" \nng-model=\"search.key\"><md-option value=\"PRCTR \" selected=\"selected\">Profit Center</md-option></md-select><span \nflex=\"10\"></span><md-input-container class=\"md-block\" flex=\"40\"><input ng-model=\"search.value\" \nplaceholder=\"Search here\"></md-input-container><md-button class=\"md-raised\" ng-click=\"searchUomValues(search)\" \nstyle=\"height: 35px;top: 5px\">Search</md-button></div><div \nstyle=\"width:100%;margin-top: -5% !important;padding-top: 0%\" class=\"md-padding scrollable\" ms-scroll \nng-if=\"uomResults\"><div layout=\"row\" flex=\"60\" layout-align=\"center center\" ng-if=\"uomResults.length == 0\" \nstyle=\"border:2px solid #cccccc; border-radius:5px; height:50px;margin-left:20%\"><b>No Records were found</b></div>\n<table class=\"dataTable row-border hover tableHighllete\" ng-if=\"uomResults.length != 0\"><thead><tr \nclass=\"table-header\"><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Profit Center\n</span></div></th></tr></thead><tbody><tr ng-repeat=\"uom in uomResults | filter: searchedItem\" \nng-click=\"searchUomResult(uom)\"><td>{{uom.PRCTR}}</td></tr></tbody></table></div></md-dialog-content><md-dialog-actions\n ng-if=\"uomResults\"><div layout=\"row\" layout-align=\"space-between center\" flex=\"100\"><div class=\"md-padding\"><h5><b>\nShowing {{(pageNumber*size)+1}} - {{(pageNumber + 1)*size}} of {{totalRecords}} Results</b></h5></div><div \nlayout=\"row\" layout-align=\"center center\"><div><md-button type=\"button\" ng-click=\"previous()\" \nng-disabled=\"pageNumber <= 0\">Prev</md-button></div><p class=\"md-padding\"><b>\n{{pageNumber+1}} / {{totalPages}} &nbsp;PAGES</b></p><div class=\"md-padding\"><md-button type=\"button\" \nng-click=\"next()\" ng-disabled=\"pageNumber == totalPages-1\">Next</md-button></div></div></div></md-dialog-actions>\n</md-dialog>");
$templateCache.put("app/main/Requests/requestUploadForm.html","<md-dialog flex=\"40\"><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2>Create Form</h2><span flex></span>\n<md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><form name=\"requestform\" novalidate layout=\"column\"><div \nlayout=\"row\"><div flex=\"30\" layout=\"column\" layout-align=\"center end\"><span class=\"h3\"><b>Name</b></span></div><span \nflex=\"10\"></span><md-input-container flex=\"45\" class=\"md-block\" layout=\"column\" layout-align=\"space-around start\" \nstyle=\"padding-bottom: 0px !important; padding-top: 0px !important\"><input type=\"text\" name=\"name\" \nng-model=\"request.name\" placeholder=\"Name\" required></md-input-container></div><div layout=\"row\"><div flex=\"30\" \nlayout=\"column\" layout-align=\"center end\"><span class=\"h3\"><b>Description</b></span></div><span flex=\"10\"></span>\n<md-input-container flex=\"45\" class=\"md-block\" layout=\"column\" layout-align=\"space-around start\" \nstyle=\"padding-bottom: 0px !important; padding-top: 0px !important\"><input type=\"text\" name=\"description\" \nng-model=\"request.description\" placeholder=\"Description\" required></md-input-container></div><div layout=\"row\"><div \nflex=\"30\" layout=\"column\" layout-align=\"center end\"><span class=\"h3\"><b>Header File</b></span></div><span flex=\"10\">\n</span><div flex=\"45\" layout=\"column\" layout-align=\"center start\"><input class=\"ng-hide\" id=\"headerFileUpload\" \nname=\"headerFileUpload\" type=\"file\" onchange=\"angular.element(this).scope().setHeaderFile(this)\"><label \nfor=\"headerFileUpload\" class=\"md-button md-raised md-accent\">Upload</label></div></div><div \nng-repeat=\"file in headerfiles.slice(0)\" layout=\"row\" layout-align=\"center center\"><span class=\"md-warn\">\n{{file.webkitRelativePath || file.name}}</span> (<span ng-switch=\"file.size > 1024*1024\"> <span ng-switch-when=\"true\">\n{{file.size / 1024 / 1024 | number:2}} MB</span> <span ng-switch-default>{{file.size / 1024 | number:2}} kB</span> \n</span>)</div><div layout=\"row\"><div flex=\"30\" layout=\"column\" layout-align=\"center end\"><span class=\"h3\"><b>\nLineitem File</b></span></div><span flex=\"10\"></span><div flex=\"45\" layout=\"column\" layout-align=\"center start\"><input \nclass=\"ng-hide\" id=\"LineItemFileUpload\" name=\"LineItemFileUpload\" type=\"file\" \nonchange=\"angular.element(this).scope().setLineItemFile(this)\"><label for=\"LineItemFileUpload\" \nclass=\"md-button md-raised md-accent\">Upload</label></div></div><div><div ng-repeat=\"file in lineitemfiles.slice(0)\" \nlayout=\"row\" layout-align=\"center center\"><span class=\"md-warn\">{{file.webkitRelativePath || file.name}}</span> (<span \nng-switch=\"file.size > 1024*1024\"> <span ng-switch-when=\"true\">{{file.size / 1024 / 1024 | number:2}} MB</span> <span \nng-switch-default>{{file.size / 1024 | number:2}} kB</span> </span>)</div></div></form></md-dialog-content>\n<md-dialog-actions layout=\"row\"><span flex></span><md-button ng-click=\"cancel()\">Cancel</md-button><md-button \nng-click=\"uploadRequestForm(request)\">Save</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/Requests/requests.content.html","<style>\n.req {\n    position: absolute;\n    top: -14px;\n    left: 124px;\n  }\n\n  .lh {\n    color: black !important;\n  }\n\n  .input {\n    color: blue !important;\n  }\n\n  .smallCell {\n    width: 200px;\n    white-space: nowrap;\n  }\n\n  .total {\n    font-size: 15px;\n    font-weight: 700;\n  }\n\n  .no-margin-bottom {\n    margin-bottom: -24% !important;\n  }\n  .label {\n    font-family: roboto;\n  }\n  p {\n    margin-left: 15%;\n    padding: 5px;\n    font-size: 14px;\n  }\n  .tabactive:active {\n    background-color: #4974f9 !important;\n    color: white;\n  }\n</style><div class=\"page-layout simple tabbed mh-0\" layout=\"column\"><div class=\"content parent-tabs\"><md-tabs \nclass=\"mh-0\"><md-tab label=\"Request Initiation\" md-active=\"true\"></md-tab></md-tabs></div></div><div \nclass=\"page-layout carded fullwidth scrollable\" layout=\"column\" flex ms-scroll md-dynamic-height ng-init=\"init()\"><div \nclass=\"widget-group\" flex=\"100\" layout=\"column\" layout-wrap><ms-widget flippable=\"true\" layout=\"row\" flex=\"50\">\n<ms-form-wizard flex><span ng-click=\"goToRequests()\" style=\"color:#5394e7\" class=\"c-p\"><span \nclass=\"icon-arrow-left-bold-circle-outline\"></span> Back</span><md-tabs md-dynamic-height \nmd-selected=\"msWizard.selectedIndex\" md-center-tabs=\"true\"><md-tab><md-tab-label><span \nclass=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"headerForm.$invalid\">1\n</span> <span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"headerForm.$valid\"><i class=\"icon-check s16\"></i> \n</span><span class=\"ms-form-wizard-step-text\">Header</span></span></md-tab-label><md-tab-body><md-content \nclass=\"md-padding scrollable\" ms-scroll><div layout=\"row\" layout-align=\"center center\"><div flex \nstyle=\"border:5px solid #cccccc;  border-radius:10px;margin-top:2%\"><form name=\"headerForm\" class=\"md-inline-form\" \nms-form-wizard-form novalidate><div ng-bind-html=\"currentFormHeader\" compile-template></div></form></div></div>\n</md-content></md-tab-body></md-tab><md-tab ng-if=\"currentFormLineitem != undefined\"><md-tab-label><span \nclass=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"lineitemForm.$invalid\">2\n</span> <span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"lineitemForm.$valid\"><i class=\"icon-check s16\">\n</i> </span><span class=\"ms-form-wizard-step-text\">Details</span></span></md-tab-label><md-tab-body><md-content \nclass=\"md-padding scrollable\" ms-scroll ng-hide=\"name == \'PR_PROCESS\'\"><div flex=\"100\"><form name=\"lineitemForm\" \nms-form-wizard-form novalidate><div ng-bind-html=\"currentFormLineitem\" compile-template></div></form></div>\n</md-content></md-tab-body></md-tab><md-tab><md-tab-label><span class=\"ms-form-wizard-step-label\"><span \nclass=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep3.$invalid\">3</span> <span \nclass=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep3.$valid\"><i class=\"icon-check s16\"></i> </span><span \nclass=\"ms-form-wizard-step-text\">Attachments</span></span></md-tab-label><md-tab-body><form name=\"wizardStep3\" \nms-form-wizard-form novalidate><div layout=\"row\" layout-align=\"center center\" flex=\"100\"><div><div><input \nclass=\"ng-hide\" id=\"attachmentUpload\" name=\"attachmentUpload\" type=\"file\" \nonchange=\"angular.element(this).scope().setAttachmentFile(this)\"><label for=\"attachmentUpload\" \nclass=\"md-button md-raised\">Upload files</label></div></div><div flex=\"10\"></div><table style=\"width:50%\"><tr><th>\nFileName</th><th>Size</th><th>PrimaryDocument</th></tr><tr ng-repeat=\"file in attachmentfiles.slice(0)\"><td>\n{{ file.webkitRelativePath || file.name }}</td><td><span ng-if=\"file.size > 1024*1024\">\n{{ file.size / 1024 / 1024 | number: 2 }}MB</span> <span ng-if=\"file.size < 1024*1024\">\n{{ file.size / 1024 | number: 2 }} kB</span></td><td><input type=\"radio\" ng-model=\"request.primary\" \nng-init=\"$index==0?(request.primary=file.name):\'\'\" name=\"name\" value=\"{{ file.name }}\"></td></tr></table></div></form>\n</md-tab-body></md-tab><md-tab ng-disabled=\"lineitemForm.$invalid || wizardStep3.$invalid\"><md-tab-label><span \nclass=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep4.$invalid\"><i\n class=\"icon-check s16\"></i></span> <span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep4.$valid\"><i\n class=\"icon-check s16\"></i> </span><span class=\"ms-form-wizard-step-text\">Submit</span></span></md-tab-label>\n<md-tab-body><form name=\"wizardStep4\" ms-form-wizard-form novalidate><md-input-container class=\"md-block\"><label>\nAdd comment</label><textarea ng-model=\"request.comment\" columns=\"1\" md-maxlength=\"150\" rows=\"5\" required></textarea>\n<div ng-messages=\"wizardStep4.address.$error\" ng-show=\"wizardStep4.address.$touched\" role=\"alert\" multiple=\"multiple\">\n<div ng-message=\"required\"><span>Comment field is required.</span></div><div ng-message=\"md-maxlength\"><span>\nComment can\'t be longer than 150 characters.</span></div></div></md-input-container></form></md-tab-body></md-tab>\n</md-tabs><div class=\"navigation\" flex layout=\"row\" layout-align=\"center center\" style=\"margin-bottom: 5% !important\">\n<md-button class=\"md-raised md-accent\" ng-click=\"msWizard.previousStep()\" ng-disabled=\"msWizard.isFirstStep()\">Previous\n</md-button><div class=\"steps\"><span ng-repeat=\"form in msWizard.forms\" \nng-class=\"{\'selected md-accent-bg\':msWizard.selectedIndex === $index}\"></span></div><md-button \nclass=\"md-raised md-accent\" ng-click=\"msWizard.nextStep()\" ng-hide=\"msWizard.isLastStep()\" \nng-disabled=\"msWizard.currentStepInvalid()\">Next</md-button><md-button class=\"md-raised md-warn\" \nng-click=\"sendFormData(); msWizard.resetForm();\" ng-show=\"msWizard.isLastStep()\" \nng-disabled=\"msWizard.formsIncomplete()\">Submit</md-button></div></ms-form-wizard></ms-widget></div></div>");
$templateCache.put("app/main/Requests/requestsOverviewPage.html","<style>md-input-container{\n    margin-top: 0px;\n    }</style><div class=\"page-layout simple tabbed mh-0\" \nlayout=\"column\"><div class=\"content parent-tabs\"><md-tabs class=\"mh-0\"><md-tab label=\"Requests\" ui-sref=\"app.requests\" \nmd-active=\"true\"></md-tab></md-tabs></div></div><div class=\"widget-group\" flex=\"100\" layout=\"column\" layout-wrap>\n<ms-widget><ms-widget-front class=\"white-bg md-padding\"><div layout=\"row\" layout-wrap><div ng-repeat=\"doc in reqTypes\" \nflex=\"100\" flex-gt-xs=\"25\" flex-gt-md=\"25\" layout=\"column\"><a ng-click=\"selectDoctype(doc)\"><md-card \nng-if=\"doc.name !=\'COR_ADV\'\" md-theme=\"{{getAnotherColor($index)}}\" md-theme-watch class=\"c-p\"><div class=\"info\" \nlayout=\"column\" layout-align=\"space-between\" flex><div class=\"white-fg md-padding\" layout=\"row\" \nlayout-align=\"center center\" ng-style=\"{\'height\':\'150px\'}\"><md-icon md-font-icon=\"icon-account\" class=\"s64\"></md-icon>\n</div><div><md-divider></md-divider><div class=\"h4 p-8 white-bg black-fg\" layout=\"column\" layout-align=\"center center\">\n{{doc.docType}}</div></div></div></md-card></a></div></div></ms-widget-front></ms-widget></div>");
$templateCache.put("app/main/Requests/searchDataDialog.html","<md-dialog ng-cloak flex=\"60\"><md-toolbar layout=\"row\" class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2>\nSearch Material Code</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content layout=\"column\" \nlayout-align=\"center center\" class=\"p-0\"><div layout=\"row\" layout-align=\"start start\" flex><div layout=\"column\" \nstyle=\"position: inherit !important\"><div layout=\"row\"><md-input-container class=\"md-block\" flex-gt-sm><input \nng-model=\"search._id\" placeholder=\"Material\"></md-input-container><span flex=\"5\"></span><md-input-container \nclass=\"md-block\" flex-gt-sm><label>Material Type</label><md-select ng-model=\"search.materailType\"><md-option \nng-repeat=\"material in materialTypes\" value=\"{{material.MTART}}\">{{material.MTBEZ}}</md-option></md-select>\n</md-input-container></div><div layout=\"row\" style=\"margin-top:-5% !important\"><md-input-container class=\"md-block\" \nflex-gt-sm><label for=\"MaterialGroup\">MaterialGroup</label><input ng-model=\"search.materailGroup\"></md-input-container>\n<span flex=\"5\"></span><md-input-container class=\"md-block\" flex-gt-sm><input ng-model=\"search.materialDescription\" \nplaceholder=\"MaterialDescription\"></md-input-container><span flex=\"5\"></span><md-input-container class=\"md-block\" \nflex-gt-sm><input ng-model=\"search.oldMaterailCode\" placeholder=\"Old MaterialNumber\"></md-input-container></div></div>\n<md-button class=\"md-raised\" ng-click=\"searchValues(search)\" style=\"height: 35px;margin-top:11% !important\">Search\n</md-button></div><div style=\"width:100%;     margin-top: 10% !important\" class=\"md-padding scrollable\" ms-scroll \nng-if=\"searchResult\"><div layout=\"row\" flex=\"60\" layout-align=\"center center\" ng-if=\"searchResult.length == 0\" \nstyle=\"border:2px solid #cccccc; border-radius:5px; height:50px;margin-left:20%\"><b>No Records were found</b></div>\n<table class=\"dataTable row-border hover tableHighllete\" ng-if=\"searchResult.length != 0\"><thead><tr \nclass=\"table-header\"><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">MaterailCode\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">MaterialDescription\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">MaterailType</span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">UOM</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">OldMaterialCode</span></div></th></tr>\n</thead><tbody><tr ng-repeat=\"order in searchResult\" ng-click=\"searchResultRowClick(order)\" class=\"c-p\"><td>\n{{order.materailCode}}</td><td>{{order.materialDescription}}</td><td>{{order.materailType}}</td><td>{{order.umo}}</td>\n<td>{{order.oldMaterailCode}}</td></tr></tbody></table></div></md-dialog-content><md-dialog-actions \nng-if=\"searchResult\"><div layout=\"row\" layout-align=\"space-between center\" flex=\"100\"><div class=\"md-padding\"><h5><b>\nShowing {{(pageNumber*size)+1}} - {{(pageNumber + 1)*size}} of {{totalRecords}} Results</b></h5></div><div \nlayout=\"row\" layout-align=\"center center\"><div><md-button type=\"button\" ng-click=\"previous()\" \nng-disabled=\"pageNumber <= 0\">Prev</md-button></div><p class=\"md-padding\"><b>\n{{pageNumber+1}} / {{totalPages}} &nbsp;PAGES</b></p><div class=\"md-padding\"><md-button type=\"button\" \nng-click=\"next()\" ng-disabled=\"pageNumber == totalPages-1\">Next</md-button></div></div></div></md-dialog-actions>\n</md-dialog>");
$templateCache.put("app/main/Requests/searchTest.html","<md-dialog ng-cloak flex=\"60\"><md-toolbar layout=\"row\" class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2>\nSearch {{Type}}</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content layout=\"column\" \nlayout-align=\"center center\" class=\"p-0\"><div layout=\"row\" style=\"position: inherit !important\"><md-select \nstyle=\"margin-top: 14px;margin-bottom: 44px\" ng-model=\"search.key\"><md-option ng-repeat=\"search in searchMaterial\" \nvalue=\"{{search.value}}\">{{search.name}}</md-option></md-select><span flex=\"10\"></span><md-input-container \nclass=\"md-block\" flex=\"40\"><input ng-model=\"search.value\" placeholder=\"Search here\"></md-input-container><md-button \nclass=\"md-raised\" ng-click=\"searchGLValues(search)\" style=\"height: 35px;top: 5px\">Search</md-button></div><div \nstyle=\"width:100%;     margin-top: 5% !important\" class=\"md-padding scrollable\" ms-scroll ng-if=\"searchResult\"><div \nlayout=\"row\" flex=\"60\" layout-align=\"center center\" ng-if=\"searchResult.length == 0\" \nstyle=\"border:2px solid #cccccc; border-radius:5px; height:50px;margin-left:20%\"><b>No Records were found</b></div>\n<table class=\"dataTable row-border hover tableHighllete\" ng-if=\"searchResult.length != 0\"><thead><tr \nclass=\"table-header\"><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">G/L AccountCode\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">\nG/L AccountDescription</span></div></th></tr></thead><tbody><tr ng-repeat=\"order in searchResult\" \nng-click=\"searchResultRowClick(order)\" class=\"c-p\"><td>{{order.SAKNR}}</td><td>{{order.TXT20}}</td></tr></tbody>\n</table></div></md-dialog-content><md-dialog-actions ng-if=\"searchResult\"><div layout=\"row\" \nlayout-align=\"space-between center\" flex=\"100\"><div class=\"md-padding\"><h5><b>\nShowing {{(pageNumber*size)+1}} - {{(pageNumber + 1)*size}} of {{totalRecords}} Results</b></h5></div><div \nlayout=\"row\" layout-align=\"center center\"><div><md-button type=\"button\" ng-click=\"previous()\" \nng-disabled=\"pageNumber <= 0\">Prev</md-button></div><p class=\"md-padding\"><b>\n{{pageNumber+1}} / {{totalPages}} &nbsp;PAGES</b></p><div class=\"md-padding\"><md-button type=\"button\" \nng-click=\"next()\" ng-disabled=\"pageNumber == totalPages-1\">Next</md-button></div></div></div></md-dialog-actions>\n</md-dialog>");
$templateCache.put("app/main/Requests/uomdialog.html","<md-dialog ng-cloak flex=\"60\"><md-toolbar layout=\"row\" class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2>\nSearch FunctionalArea</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content layout=\"column\" \nlayout-align=\"center center\" class=\"p-0\"><div layout=\"row\" style=\"position: inherit !important\"><md-select \nstyle=\"margin-top: 14px;margin-bottom: 44px\" ng-model=\"search.key\"><md-option value=\"MSEHI\" selected=\"selected\">UOM\n</md-option><md-option value=\"MSEHL\">Description</md-option></md-select><span flex=\"10\"></span><md-input-container \nclass=\"md-block\" flex=\"40\"><input ng-model=\"search.value\" placeholder=\"Search here\"></md-input-container><md-button \nclass=\"md-raised\" ng-click=\"searchUOMCode(search)\" style=\"height: 35px;top: 5px\">Search</md-button></div><div \nstyle=\"width:100%;     margin-top: 5% !important\" class=\"md-padding scrollable\" ms-scroll ng-if=\"searchResult\"><div \nlayout=\"row\" flex=\"60\" layout-align=\"center center\" ng-if=\"searchResult.length == 0\" \nstyle=\"border:2px solid #cccccc; border-radius:5px; height:50px;margin-left:20%\"><b>No Records were found</b></div>\n<table class=\"dataTable row-border hover tableHighllete\" ng-if=\"searchResult.length != 0\"><thead><tr \nclass=\"table-header\"><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">UOM</span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Description</span></div></th></tr>\n</thead><tbody><tr ng-repeat=\"order in searchResult\" ng-click=\"searchResultRowClick(order)\" class=\"c-p\"><td>\n{{order.MSEHI}}</td><td>{{order.MSEHL}}</td></tr></tbody></table></div></md-dialog-content><md-dialog-actions \nng-if=\"searchResult\"><div layout=\"row\" layout-align=\"space-between center\" flex=\"100\"><div class=\"md-padding\"><h5><b>\nShowing {{(pageNumber*size)+1}} - {{(pageNumber + 1)*size}} of {{totalRecords}} Results</b></h5></div><div \nlayout=\"row\" layout-align=\"center center\"><div><md-button type=\"button\" ng-click=\"previous()\" \nng-disabled=\"pageNumber <= 0\">Prev</md-button></div><p class=\"md-padding\"><b>\n{{pageNumber+1}} / {{totalPages}} &nbsp;PAGES</b></p><div class=\"md-padding\"><md-button type=\"button\" \nng-click=\"next()\" ng-disabled=\"pageNumber == totalPages-1\">Next</md-button></div></div></div></md-dialog-actions>\n</md-dialog>");
$templateCache.put("app/main/Requests/vendor-dialog.html","<md-dialog ng-cloak flex=\"60\"><md-toolbar layout=\"row\" class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2>\nSearch Vendor</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content layout=\"column\" \nlayout-align=\"center center\" class=\"p-0\"><div layout=\"row\" style=\"position: inherit !important\"><md-select \nstyle=\"margin-top: 14px;margin-bottom: 44px\" ng-model=\"search.key\"><md-option value=\"LIFNR\" selected=\"selected\">Vendor\n</md-option><md-option value=\"NAME1\">Vendor Description</md-option></md-select><span flex=\"10\"></span>\n<md-input-container class=\"md-block\" flex=\"40\"><input ng-model=\"search.value\" placeholder=\"Search here\">\n</md-input-container><md-button class=\"md-raised\" ng-click=\"searchcompanyCode(search)\" style=\"height: 35px;top: 5px\">\nSearch</md-button></div><div style=\"width:100%;     margin-top: 5% !important\" class=\"md-padding scrollable\" ms-scroll \nng-if=\"searchResult\"><div layout=\"row\" flex=\"60\" layout-align=\"center center\" ng-if=\"searchResult.length == 0\" \nstyle=\"border:2px solid #cccccc; border-radius:5px; height:50px;margin-left:20%\"><b>No Records were found</b></div>\n<table class=\"dataTable row-border hover tableHighllete\" ng-if=\"searchResult.length != 0\"><thead><tr \nclass=\"table-header\"><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Vendor</span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Vendor Description</span>\n</div></th></tr></thead><tbody><tr ng-repeat=\"order in searchResult\" ng-click=\"searchResultRowClick(order)\" \nclass=\"c-p\"><td>{{order.LIFNR}}</td><td>{{order.NAME1}}</td></tr></tbody></table></div></md-dialog-content>\n<md-dialog-actions ng-if=\"searchResult\"><div layout=\"row\" layout-align=\"space-between center\" flex=\"100\"><div \nclass=\"md-padding\"><h5><b>Showing {{(pageNumber*size)+1}} - {{(pageNumber + 1)*size}} of {{totalRecords}} Results</b>\n</h5></div><div layout=\"row\" layout-align=\"center center\"><div><md-button type=\"button\" ng-click=\"previous()\" \nng-disabled=\"pageNumber <= 0\">Prev</md-button></div><p class=\"md-padding\"><b>\n{{pageNumber+1}} / {{totalPages}} &nbsp;PAGES</b></p><div class=\"md-padding\"><md-button type=\"button\" \nng-click=\"next()\" ng-disabled=\"pageNumber == totalPages-1\">Next</md-button></div></div></div></md-dialog-actions>\n</md-dialog>");
$templateCache.put("app/main/Requests/vendorData-dialog.html","<style>\n.ps-container > .ps-scrollbar-y-rail > .ps-scrollbar-y {\n        width: 4px;\n        padding: 5px;\n        height: 80px;\n        margin: 0px;\n        height: 36px !important;\n    }\n    thead th {\n         position: sticky; \n         top: 0;\n         background: #dee7f4 !important;\n    }\n    table.dataTable tbody td {\n    padding: 9px 8px;\n    vertical-align: middle;\n}\n</style><md-dialog ng-cloak flex=\"50\"><md-toolbar layout=\"row\" class=\"md-accent\"><div class=\"md-toolbar-tools\" \nlayout=\"row\" layout-align=\"space-between\n        center\"><h2>Search Vendor</h2><md-button class=\"md-icon-button\" \nng-click=\"cancel()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nlayout=\"column\" layout-align=\"center center\" class=\"p-0\"><div layout=\"row\" \nstyle=\"position: inherit !important; padding-bottom: 2%\"><md-select style=\"margin-top: 14px;margin-bottom: 44px\" \nng-model=\"search.key\"><md-option value=\"LIFNR \" selected=\"selected\">Vendor</md-option></md-select><span flex=\"10\">\n</span><md-input-container class=\"md-block\" flex=\"40\"><input ng-model=\"search.value\" placeholder=\"Search here\">\n</md-input-container><md-button class=\"md-raised\" ng-click=\"searchUomValues(search)\" style=\"height: 35px;top: 5px\">\nSearch</md-button></div><div style=\"width:100%;margin-top: -5% !important;padding-top: 0%\" \nclass=\"md-padding scrollable\" ms-scroll ng-if=\"uomResults\"><div layout=\"row\" flex=\"60\" layout-align=\"center center\" \nng-if=\"uomResults.length == 0\" style=\"border:2px solid #cccccc; border-radius:5px; height:50px;margin-left:20%\"><b>\nNo Records were found</b></div><table class=\"dataTable row-border hover tableHighllete\" ng-if=\"uomResults.length != 0\">\n<thead><tr class=\"table-header\"><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Vendor\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">GST Number</span>\n</div></th></tr></thead><tbody><tr ng-repeat=\"uom in uomResults | filter: searchedItem\" \nng-click=\"searchUomResult(uom)\"><td>{{uom.LIFNR}}</td><td>{{uom.STCD3}}</td></tr></tbody></table></div>\n</md-dialog-content><md-dialog-actions ng-if=\"uomResults\"><div layout=\"row\" layout-align=\"space-between center\" \nflex=\"100\"><div class=\"md-padding\"><h5><b>\nShowing {{(pageNumber*size)+1}} - {{(pageNumber + 1)*size}} of {{totalRecords}} Results</b></h5></div><div \nlayout=\"row\" layout-align=\"center center\"><div><md-button type=\"button\" ng-click=\"previous()\" \nng-disabled=\"pageNumber <= 0\">Prev</md-button></div><p class=\"md-padding\"><b>\n{{pageNumber+1}} / {{totalPages}} &nbsp;PAGES</b></p><div class=\"md-padding\"><md-button type=\"button\" \nng-click=\"next()\" ng-disabled=\"pageNumber == totalPages-1\">Next</md-button></div></div></div></md-dialog-actions>\n</md-dialog>");
$templateCache.put("app/main/Requests/vendorMasterCreationForm.html","<div class=\"page-layout carded fullwidth scrollable\" layout=\"column\" flex ms-scroll md-dynamic-height><div \nclass=\"widget-group\" flex=\"100\" layout=\"column\" layout-wrap><ms-widget flippable=\"true\" layout=\"column\">\n<ms-widget-front class=\"white-bg\"><div flex=\"30\" class=\"md-padding\"><ul class=\"breadcrumb\"><li \nng-click=\"requestCtrl.goToRequests()\">Requests</li><li>VendorMasterCreationForm</li></ul></div><div layout=\"row\"><div \nng-cloak flex=\"100\" class=\"scrollable\" ms-scroll><md-content><md-tabs md-dynamic-height md-border-bottom><md-tab \nlabel=\"Header\"><md-content class=\"md-padding scrollable\" ms-scroll><div layout=\"row\" layout-align=\"center center\"><div \nflex=\"70\" style=\"border: 1px solid #cccccc\"><form name=\"customerForm\" novalidate><md-toolbar \nclass=\"orange-bg white-fg\"><div class=\"md-toolbar-tools\"><h2>VENDOR - MASTER CREATION FORM</h2></div></md-toolbar><div \nlayout=\"row\"><div flex=\"20\" layout=\"row\" layout-align=\"end center\"><h3>Vendor Code</h3></div><span flex=\"5\"></span>\n<md-input-container class=\"md-block\" flex=\"20\"><input type=\"text\" name=\"owner\" ng-model=\"form.customerCode\">\n</md-input-container><span flex=\"5\"></span><div flex=\"20\" layout=\"row\" layout-align=\"end center\"><h3>Account Group</h3>\n</div><span flex=\"5\"></span><md-input-container class=\"md-block\" flex=\"20\"><md-select ng-model=\"form.accountGroup\">\n<md-option ng-repeat=\"AccountGroup in AccountGroups\" ng-value=\"AccountGroup\">{{AccountGroup}}</md-option></md-select>\n</md-input-container></div><div layout=\"row\"><div flex=\"20\" layout=\"row\" layout-align=\"end center\"><h3>\nReconciliation Account</h3></div><span flex=\"5\"></span><md-input-container class=\"md-block\" flex=\"20\"><md-select \nng-model=\"form.organisation\"><md-option ng-repeat=\"salesOrganisation in salesOrganisations\" \nng-value=\"salesOrganisation\">{{salesOrganisation}}</md-option></md-select></md-input-container><span flex=\"5\"></span>\n<div flex=\"20\" layout=\"row\" layout-align=\"end center\"><h3>Type</h3></div><span flex=\"5\"></span><md-input-container \nclass=\"md-block\" flex=\"20\"><md-select ng-model=\"form.type\"><md-option ng-repeat=\"type in types\" ng-value=\"type\">\n{{type}}</md-option></md-select></md-input-container></div><div layout=\"row\"><div flex=\"20\" layout=\"row\" \nlayout-align=\"end center\"><h3>Industry Sector</h3></div><span flex=\"5\"></span><md-input-container class=\"md-block\" \nflex=\"20\"><md-select ng-model=\"form.channel\"><md-option ng-repeat=\"distributionChannel in distributionChannels\" \nng-value=\"distributionChannel\">{{distributionChannel}}</md-option></md-select></md-input-container><span flex=\"5\">\n</span><div flex=\"20\" layout=\"row\" layout-align=\"end center\"><h3>Customer Group</h3></div><span flex=\"5\"></span>\n<md-input-container class=\"md-block\" flex=\"20\"><md-select ng-model=\"form.conditionType\"><md-option \nng-repeat=\"customerGroup in customerGroups\" ng-value=\"customerGroup\">{{customerGroup}}</md-option></md-select>\n</md-input-container></div><div layout=\"row\"><div flex=\"20\" layout=\"row\" layout-align=\"end center\"></div><span \nflex=\"5\"></span><md-input-container class=\"md-block\" flex=\"20\"><input type=\"text\" name=\"owner\" \nplaceholder=\"Name of the Firm\" ng-model=\"form.customerCo\"></md-input-container><span flex=\"5\"></span><div flex=\"20\" \nlayout=\"row\" layout-align=\"end center\"></div><span flex=\"5\"></span><md-input-container class=\"md-block\" flex=\"20\">\n<input type=\"text\" name=\"owner\" placeholder=\"Address of the Firm\" ng-model=\"form.customerCo\"></md-input-container>\n</div><div layout=\"row\"><div flex=\"20\" layout=\"row\" layout-align=\"end center\"><h3>Billing Address</h3></div><span \nflex=\"5\"></span><md-input-container class=\"md-block\" flex=\"20\"><input type=\"text\" name=\"owner\" \nng-model=\"form.customerCo\"></md-input-container><span flex=\"5\"></span><div flex=\"20\" layout=\"row\" \nlayout-align=\"end center\"><h3>Delivery Address</h3></div><span flex=\"5\"></span><md-input-container class=\"md-block\" \nflex=\"20\"><input type=\"text\" name=\"owner\" ng-model=\"form.customerCo\"></md-input-container></div><div layout=\"row\"><div \nflex=\"20\" layout=\"row\" layout-align=\"end center\"><h3>If ISO Certified</h3></div><span flex=\"5\"></span>\n<md-input-container class=\"md-block\" flex=\"70\"><input type=\"text\" name=\"owner\" ng-model=\"form.ISOCertified\">\n</md-input-container></div><div layout=\"row\"><div flex=\"20\" layout=\"row\" layout-align=\"end center\"><h3>Payment Terms\n</h3></div><span flex=\"5\"></span><md-input-container class=\"md-block\" flex=\"70\"><md-select ng-model=\"form.paymentTerm\">\n<md-option ng-repeat=\"paymentTerm in paymentTerms\" ng-value=\"paymentTerm\">{{paymentTerm}}</md-option></md-select>\n</md-input-container></div><div layout=\"row\"><div flex=\"20\" layout=\"row\" layout-align=\"end center\"><h3>\nName & Address of Branch</h3></div><span flex=\"5\"></span><md-input-container class=\"md-block\" flex=\"70\"><input \ntype=\"text\" name=\"owner\" ng-model=\"form.branchAddress\"></md-input-container></div><div layout=\"row\"><div flex=\"20\" \nlayout=\"row\" layout-align=\"end center\"><h3>RTGS Code</h3></div><span flex=\"5\"></span><md-input-container \nclass=\"md-block\" flex=\"20\"><input type=\"text\" name=\"owner\" ng-model=\"form.RTGSCode\"></md-input-container><span \nflex=\"5\"></span><div flex=\"20\" layout=\"row\" layout-align=\"end center\"><h3>IFSC Code</h3></div><span flex=\"5\"></span>\n<md-input-container class=\"md-block\" flex=\"20\"><input type=\"text\" name=\"owner\" ng-model=\"form.IFSCCode\">\n</md-input-container></div><div layout=\"row\"><div flex=\"20\" layout=\"row\" layout-align=\"end center\"><h3>MICR No</h3>\n</div><span flex=\"5\"></span><md-input-container class=\"md-block\" flex=\"20\"><input type=\"text\" name=\"owner\" \nng-model=\"form.MICRNo\"></md-input-container><span flex=\"5\"></span><div flex=\"20\" layout=\"row\" \nlayout-align=\"end center\"><h3>Order Currency</h3></div><span flex=\"5\"></span><md-input-container class=\"md-block\" \nflex=\"20\"><input type=\"text\" name=\"owner\" ng-model=\"form.orderCrrency\"></md-input-container></div><div layout=\"row\">\n<div flex=\"20\" layout=\"row\" layout-align=\"end center\"><h3>Taxes</h3></div><span flex=\"5\"></span><md-input-container \nclass=\"md-block\" flex=\"70\"><md-select ng-model=\"form.tax\"><md-option ng-repeat=\"tax in taxes\" ng-value=\"tax\">{{tax}}\n</md-option></md-select></md-input-container></div><div layout=\"row\" layout-align=\"center center\"><h4>\nNOTE: PLEASE ATTACH COPY OF TAX EXPEMTION / CONCESSION ISSUED BY THE RELEVANT DEPARTMENT</h4></div><div layout=\"row\">\n<div flex=\"20\" layout=\"row\" layout-align=\"end center\"><h3>Excise Registration No</h3></div><span flex=\"5\"></span>\n<md-input-container class=\"md-block\" flex=\"70\"><input type=\"text\" name=\"owner\" ng-model=\"form.exsiseRegistrationNo\">\n</md-input-container></div><div layout=\"row\"><div flex=\"20\" layout=\"row\" layout-align=\"end center\"><h3>\nExcise Range and DIvision</h3></div><span flex=\"5\"></span><md-input-container class=\"md-block\" flex=\"70\"><input \ntype=\"text\" name=\"owner\" ng-model=\"form.exciseRangeandDivision\"></md-input-container></div><div layout=\"row\"><div \nflex=\"20\" layout=\"row\" layout-align=\"end center\"><h3>VAT / TIN</h3></div><span flex=\"5\"></span><md-input-container \nclass=\"md-block\" flex=\"70\"><input type=\"text\" name=\"owner\" ng-model=\"form.vatOrTin\"></md-input-container></div><div \nlayout=\"row\"><div flex=\"20\" layout=\"row\" layout-align=\"end center\"><h3>Service Tax</h3></div><span flex=\"5\"></span>\n<md-input-container class=\"md-block\" flex=\"70\"><input type=\"text\" name=\"owner\" ng-model=\"form.serviceTax\">\n</md-input-container></div><div layout=\"row\"><div flex=\"20\" layout=\"row\" layout-align=\"end center\"><h3>PAN No</h3>\n</div><span flex=\"5\"></span><md-input-container class=\"md-block\" flex=\"70\"><input type=\"text\" name=\"owner\" \nng-model=\"form.panNo\"></md-input-container></div><div layout=\"row\"><div flex=\"20\" layout=\"row\" \nlayout-align=\"end center\"><h3>SSI Registration No</h3></div><span flex=\"5\"></span><md-input-container class=\"md-block\" \nflex=\"70\"><input type=\"text\" name=\"owner\" ng-model=\"form.ssiRegistrationNo\"></md-input-container></div><div \nlayout=\"row\"><div flex=\"20\" layout=\"row\" layout-align=\"end center\"><h3>Year of Establishment</h3></div><span flex=\"5\">\n</span><md-input-container class=\"md-block\" flex=\"20\"><input type=\"text\" name=\"owner\" \nng-model=\"form.establishmentYear\"></md-input-container><span flex=\"5\"></span><div flex=\"20\" layout=\"row\" \nlayout-align=\"end center\"><h3>Trade License No</h3></div><span flex=\"5\"></span><md-input-container class=\"md-block\" \nflex=\"20\"><input type=\"text\" name=\"owner\" ng-model=\"form.tradeLicenseNo\"></md-input-container></div><md-toolbar \nclass=\"md-primary\"><div class=\"md-toolbar-tools\"><div layout=\"row\" layout-align=\"end center\" flex><div \nclass=\"md-padding\"><md-button class=\"md-warn md-raised\" ng-click=\"\">Submit</md-button><md-button \nclass=\"green-bg md-raised\" ng-click=\"\">Cancel</md-button></div></div></div></md-toolbar></form></div></div>\n</md-content></md-tab><md-tab label=\"Line Items\"><md-content class=\"md-padding\"><div layout=\"row\" \nlayout-align=\"center center\"></div></md-content></md-tab><md-tab label=\"Comments\"><md-content class=\"md-padding\"><h1 \nclass=\"md-display-2\">Comments Tab</h1><p>\nInteger turpis erat, porttitor vitae mi faucibus, laoreet interdum tellus. Curabitur posuere molestie dictum. Morbi eget congue risus, quis rhoncus quam. Suspendisse vitae hendrerit erat, at posuere mi. Cras eu fermentum nunc. Sed id ante eu orci commodo volutpat non ac est. Praesent ligula diam, congue eu enim scelerisque, finibus commodo lectus.\n</p></md-content></md-tab><md-tab label=\"Attachments\"><md-content class=\"md-padding\"><h1 class=\"md-display-2\">\nAttachments Tab</h1><p>\nInteger turpis erat, porttitor vitae mi faucibus, laoreet interdum tellus. Curabitur posuere molestie dictum. Morbi eget congue risus, quis rhoncus quam. Suspendisse vitae hendrerit erat, at posuere mi. Cras eu fermentum nunc. Sed id ante eu orci commodo volutpat non ac est. Praesent ligula diam, congue eu enim scelerisque, finibus commodo lectus.\n</p></md-content></md-tab></md-tabs></md-content></div></div></ms-widget-front></ms-widget></div></div>");
$templateCache.put("app/main/Requests/vendorPriceMasterForm.html","<div class=\"page-layout carded fullwidth scrollable\" layout=\"column\" flex ms-scroll md-dynamic-height><div \nclass=\"widget-group\" flex=\"100\" layout=\"column\" layout-wrap><ms-widget flippable=\"true\" layout=\"column\">\n<ms-widget-front class=\"white-bg\"><div flex=\"30\" class=\"md-padding\"><ul class=\"breadcrumb\"><li \nng-click=\"requestCtrl.goToRequests()\">Requests</li><li>VendoPriceMasterForm</li></ul></div><div layout=\"row\"><div \nng-cloak flex=\"100\" class=\"scrollable\" ms-scroll><md-content><md-tabs md-dynamic-height md-border-bottom><md-tab \nlabel=\"Header\"><md-content class=\"md-padding scrollable\" ms-scroll><div layout=\"row\" layout-align=\"center center\"><div \nflex=\"70\" style=\"border: 1px solid #cccccc\"><md-toolbar class=\"orange-bg white-fg\"><div class=\"md-toolbar-tools\"><h2>\nVENDOR - PRICE MASTER FORM (Info Record)</h2></div></md-toolbar><div layout=\"row\"><div flex=\"20\" layout=\"row\" \nlayout-align=\"end center\"><h3>Vendor Code</h3></div><span flex=\"5\"></span><md-input-container class=\"md-block\" \nflex=\"20\"><input type=\"text\" name=\"owner\" ng-model=\"file.creat\"></md-input-container><span flex=\"5\"></span><div \nflex=\"20\" layout=\"row\" layout-align=\"end center\"><h3>Account Group</h3></div><span flex=\"5\"></span><md-input-container \nclass=\"md-block\" flex=\"20\"><md-select ng-model=\"abc\"><md-option ng-repeat=\"AccountGroup in AccountGroups\" \nng-value=\"AccountGroup\">{{AccountGroup}}</md-option></md-select></md-input-container></div><div layout=\"row\"><div \nflex=\"20\" layout=\"row\" layout-align=\"end center\"><h3>Vendor Name:</h3></div><span flex=\"5\"></span><md-input-container \nclass=\"md-block\" flex=\"70\"><input type=\"text\" name=\"owner\" ng-model=\"file.creator\"></md-input-container></div><div \nlayout=\"row\"><div flex=\"20\" layout=\"row\" layout-align=\"end center\"><h3>Purchase Org:</h3></div><span flex=\"5\"></span>\n<md-input-container class=\"md-block\" flex=\"20\"><md-select ng-model=\"ab\"><md-option \nng-repeat=\"salesOrganisation in salesOrganisations\" ng-value=\"salesOrganisation\">{{salesOrganisation}}</md-option>\n</md-select></md-input-container><span flex=\"5\"></span><div flex=\"20\" layout=\"row\" layout-align=\"end center\"><h3>Type\n</h3></div><span flex=\"5\"></span><md-input-container class=\"md-block\" flex=\"20\"><md-select ng-model=\"abf\"><md-option \nng-repeat=\"type in types\" ng-value=\"type\">{{type}}</md-option></md-select></md-input-container></div><div layout=\"row\">\n<div flex=\"20\" layout=\"row\" layout-align=\"end center\"><h3>Plant:</h3></div><span flex=\"5\"></span><md-input-container \nclass=\"md-block\" flex=\"20\"><md-select ng-model=\"abcd\"><md-option \nng-repeat=\"distributionChannel in distributionChannels\" ng-value=\"distributionChannel\">{{distributionChannel}}\n</md-option></md-select></md-input-container><span flex=\"5\"></span><div flex=\"20\" layout=\"row\" \nlayout-align=\"end center\"><h3>Info Category:</h3></div><span flex=\"5\"></span><md-input-container class=\"md-block\" \nflex=\"20\"><md-select ng-model=\"abcd\"><md-option ng-repeat=\"conditionType in conditionTypes\" ng-value=\"conditionType\">\n{{conditionType}}</md-option></md-select></md-input-container></div><md-toolbar class=\"md-primary\"><div \nclass=\"md-toolbar-tools\"><div layout=\"row\" layout-align=\"end center\" flex><div class=\"md-padding\"><md-button \nclass=\"md-warn md-raised\" ng-click=\"\">Submit</md-button><md-button class=\"green-bg md-raised\" ng-click=\"\">Cancel\n</md-button></div></div></div></md-toolbar></div></div></md-content></md-tab><md-tab label=\"Line Items\"><md-content \nclass=\"md-padding\"><div layout=\"row\" layout-align=\"center center\"><div flex=\"90\" style=\"border: 1px solid #cccccc\">\n<md-toolbar style=\"background-color:rgb(41, 66, 112)\" class=\"white-fg\"><div class=\"md-toolbar-tools\"><div layout=\"row\" \nflex=\"100\" layout-align=\"center center\"><div flex=\"5\" class=\"md-padding\"><p>S.No</p></div><div flex=\"10\" \nclass=\"md-padding\"><p>Material Code</p></div><div flex=\"10\" class=\"md-padding\"><p>New Price</p></div><div flex=\"10\" \nclass=\"md-padding\"><p>Old Price</p></div><div flex=\"10\" class=\"md-padding\"><p>Price Var.</p></div><div flex=\"10\" \nclass=\"md-padding\"><p>Current</p></div><div flex=\"10\"><p>Price per 1000 or EA</p></div><span flex=\"5\"></span><div \nflex=\"10\"><p>Base Unit of Measure</p></div><div flex=\"10\"><p>Valid From</p></div><div flex=\"10\" class=\"md-padding\"><p>\nValid To</p></div></div></div></md-toolbar><form name=\"lineItemsForm\" novalidate><div layout=\"row\" \nlayout-align=\"center center\" ng-repeat=\"row in rows\"><div flex=\"5\"><h3 class=\"md-padding\">{{row}}</h3></div><div \nflex=\"10\" class=\"md-block md-padding\"><md-input-container class=\"md-block\" style=\"margin: 0px\"><input type=\"text\" \nname=\"owner\" ng-model=\"form.materialCode\"></md-input-container></div><div flex=\"10\"><md-input-container \nclass=\"md-block md-padding\" style=\"margin: 0px\"><input type=\"text\" name=\"owner\" ng-model=\"form.newPrice\">\n</md-input-container></div><div flex=\"10\"><md-input-container class=\"md-block md-padding\" style=\"margin: 0px\"><input \ntype=\"text\" name=\"owner\" ng-model=\"form.oldPrice\"></md-input-container></div><div flex=\"10\"><md-input-container \nclass=\"md-block\" style=\"margin: 0px\"><md-select ng-model=\"form.priceVar\"><md-option ng-repeat=\"priceVar in priceVars\" \nng-value=\"priceVar\">{{priceVar}}</md-option></md-select></md-input-container></div><div flex=\"10\"><md-input-container \nclass=\"md-block md-padding\" style=\"margin: 0px\"><input type=\"text\" name=\"owner\" ng-model=\"form.current\">\n</md-input-container></div><div flex=\"15\"><md-input-container class=\"md-block md-padding\" style=\"margin: 0px\"><input \ntype=\"text\" name=\"owner\" ng-model=\"form.pricePer\"></md-input-container></div><div flex=\"10\"><md-input-container \nclass=\"md-block md-padding\" style=\"margin: 0px\"><input type=\"text\" name=\"owner\" ng-model=\"form.baseUnit\">\n</md-input-container></div><div flex=\"10\"><md-input-container class=\"md-block md-padding\" style=\"margin: 0px\"><input \ntype=\"text\" name=\"owner\" ng-model=\"form.validFrom\"></md-input-container></div><div flex=\"10\"><md-input-container \nclass=\"md-block md-padding\" style=\"margin: 0px\"><input type=\"text\" name=\"owner\" ng-model=\"form.validTo\">\n</md-input-container></div></div><md-toolbar class=\"md-primary\"><div class=\"md-toolbar-tools\"><div layout=\"row\" \nlayout-align=\"end center\" flex><div class=\"md-padding\"><md-button type=\"submit\" class=\"md-warn md-raised\" \nng-click=\"submitForm(form)\">Submit</md-button><md-button type=\"button\" class=\"green-bg md-raised\" ng-click=\"\">Cancel\n</md-button></div></div></div></md-toolbar></form></div></div></md-content></md-tab><md-tab label=\"Comments\">\n<md-content class=\"md-padding\"><h1 class=\"md-display-2\">Comments Tab</h1><p>\nInteger turpis erat, porttitor vitae mi faucibus, laoreet interdum tellus. Curabitur posuere molestie dictum. Morbi eget congue risus, quis rhoncus quam. Suspendisse vitae hendrerit erat, at posuere mi. Cras eu fermentum nunc. Sed id ante eu orci commodo volutpat non ac est. Praesent ligula diam, congue eu enim scelerisque, finibus commodo lectus.\n</p></md-content></md-tab><md-tab label=\"Attachments\"><md-content class=\"md-padding\"><h1 class=\"md-display-2\">\nAttachments Tab</h1><p>\nInteger turpis erat, porttitor vitae mi faucibus, laoreet interdum tellus. Curabitur posuere molestie dictum. Morbi eget congue risus, quis rhoncus quam. Suspendisse vitae hendrerit erat, at posuere mi. Cras eu fermentum nunc. Sed id ante eu orci commodo volutpat non ac est. Praesent ligula diam, congue eu enim scelerisque, finibus commodo lectus.\n</p></md-content></md-tab></md-tabs></md-content></div></div></ms-widget-front></ms-widget></div></div>");
$templateCache.put("app/main/Verify/verification.html","<div><iframe id=\"iframe\" \nsrc=\"https://ocr.smartdocsnow.com/FlexiCapture12/VerificationNew/QueueList?projectId=3&roleId=39\" name=\"contentframe\" \nframeborder=\"0\" style=\"width: 100%; height: 100%; position: absolute; z-index: 999\"></iframe></div>");
$templateCache.put("app/main/adminSubstitution/adminSubstitution.html","<div class=\"page-layout simple right-sidenav\" layout=\"row\" ng-init=\"subCtrl.getAllSubstitutes()\"><div \nclass=\"page-layout carded fullwidth md-padding scrollable\" layout=\"column\" flex ms-scroll><md-button flow-btn \nclass=\"md-fab grey-700-bg md-mini md-fab-bottom-right add_btn\" ng-click=\"createSubstitutor($event)\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon><md-tooltip md-direction=\"top\">Create substitution</md-tooltip></md-button><div \nclass=\"parent-tabs white-bg mb-15\"><md-tabs class=\"mh-0\"><md-tab label=\"Substitution\" ui-sref=\"app.Adminsubstitution\" \nmd-active=\"true\"></md-tab><md-tab label=\"Re-Assign\" ui-sref=\"app.Adminsubstitution.reAssign\"></md-tab></md-tabs></div>\n<div class=\"widget-group\" flex=\"100\" layout=\"column\" layout-wrap><ms-widget flippable=\"true\" layout=\"column\" \nflex=\"100\" md-dynamic-height><ms-widget-front class=\"white-bg\"><div class=\"h3 md-padding\">Manage Substitution</div><div\n layout=\"row\" layout-align=\"center center\"><div flex=\"100\" class=\"md-padding scrollable\" ms-scroll><table \nclass=\"dataTable row-border hover table-border\" datatable=\"ng\" dt-options=\"userCtrl.dtOptions\"><thead><tr \nclass=\"table-header\"><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Substitution-From\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Substitution-To\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">From Date</span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">To Date</span></div></th><th\n class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Status</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\" layout=\"row\" layout-align=\"center center\"><span class=\"column-title\">\nActions</span></div></th></tr></thead><tbody><tr ng-repeat=\"substitute in substitute\" \nng-if=\"substitute.substitution_user != null && substitute.eliminationUser ==null\"><td>{{substitute.user_id}}</td><td>\n{{substitute.substitution_user}}</td><td>{{substitute.from_date.substr(0,10)}}</td><td>\n{{substitute.to_date.substr(0,10)}}</td><td><i class=\"icon-checkbox-marked-circle green-500-fg\" \nng-show=\"{{substitute.status}}\"></i> <i class=\"icon-cancel red-500-fg\" ng-show=\"{{! substitute.status}}\"></i></td><td \nlayout=\"row\" layout-align=\"center center\" style=\"padding-top:0px !important;padding-bottom:0px !important\"><md-button \nclass=\"md-icon-button test-tooltip\" aria-label=\"Update\" ng-click=\"update($event,substitute)\"><md-tooltip \nmd-direction=\"top\">Update</md-tooltip><md-icon><i layout=\"row\" layout-align=\"center center\" \nclass=\"icon icon-pencil s18\"></i></md-icon></md-button><md-button class=\"md-icon-button test-tooltip\" \naria-label=\"Delete\" ng-click=\"delete($event, substitute) \"><md-tooltip md-direction=\"top\">Delete</md-tooltip><md-icon>\n<i layout=\"row\" layout-align=\"center center\" class=\"icon icon-delete s18\"></i></md-icon></md-button></td></tr></tbody>\n</table></div></div></ms-widget-front></ms-widget></div></div></div>");
$templateCache.put("app/main/binder/VersionbinderFiledialog.html","<md-dialog><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2>Add new version : {{selectedFileName}}</h2>\n<span flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><form name=\"doclibrary\" novalidate layout=\"column\"><div layout=\"row\">\n<div flex=\"45\" layout=\"column\" layout-align=\"center end\"><span class=\"h3\"><b>Upload File</b></span></div><span \nflex=\"10\"></span><div flex=\"45\" layout=\"column\" layout-align=\"center start\"><input class=\"ng-hide\" id=\"formUploadFile\" \nname=\"formUploadFile\" type=\"file\" onchange=\"angular.element(this).scope().setFile(this)\"><label for=\"formUploadFile\" \nclass=\"md-button md-raised md-accent\">Upload</label></div></div><div><div ng-repeat=\"file in files.slice(0)\" \nlayout=\"row\" layout-align=\"center center\"><span class=\"md-warn\">{{file.webkitRelativePath || file.name}}</span> (<span \nng-switch=\"file.size > 1024*1024\"> <span ng-switch-when=\"true\">{{file.size / 1024 / 1024 | number:2}} MB</span> <span \nng-switch-default>{{file.size / 1024 | number:2}} kB</span> </span>)</div></div></form></md-dialog-content>\n<md-dialog-actions layout=\"row\"><span flex></span><md-button ng-click=\"cancel()\">Cancel</md-button><md-button \nng-click=\"NewVersionbinderFile()\">Save</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/binder/binder.html","<div id=\"binder\" class=\"page-layout simple right-sidenav\" layout=\"row\"><div class=\"widget-group\" layout=\"column\" \nflex=\"20\" layout-wrap><ms-widget flippable=\"true\" layout=\"column\"><ms-widget-front class=\"white-bg\"><md-toolbar \nlayout=\"row\" class=\"md-accent\"><div class=\"md-toolbar-tools\"><span>\n{{binderObject.objectType}} - #{{binderObject.objectId}}</span></div></md-toolbar><md-divider></md-divider><div \nclass=\"scrollable\" ms-scroll><div ng-repeat=\"attribute in binderObject.attributes\"><div class=\"md-padding\"><div \nclass=\"h4\"><b>{{attribute.label}}</b></div><span>{{attribute.value}}</span></div><md-divider></md-divider></div></div>\n</ms-widget-front></ms-widget></div><div class=\"widget-group\" layout=\"column\" flex=\"80\" layout-wrap><ms-widget \nflippable=\"true\" layout=\"column\"><ms-widget-front class=\"white-bg\"><div id=\"docLibrary\" \nclass=\"page-layout simple right-sidenav\" layout=\"row\"><md-button flow-btn class=\"md-fab md-accent md-fab-bottom-right\" \naria-label=\"Add Note\" ng-click=\"createFile($event)\" ng-init=\"binderCrtl.getbinderFiles()\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon><md-tooltip md-direction=\"top\">Upload File</md-tooltip></md-button><div flex=\"65\" \nclass=\"scrollable md-padding\" ms-scroll><div layout=\"row\" class=\"md-padding\"><span \nng-repeat=\"folder in filePath track by $index\" class=\"md-subhead\"><a ng-click=\"binderCrtl.gotoFolder(folder)\" \nstyle=\"border: 1px solid blue;color: blue !important;padding:3px\">{{folder.name}}</a><md-icon \nmd-font-icon=\"icon-chevron-right\"></md-icon></span></div><table class=\"simple list-view\"><thead><tr><th></th><th>Name\n</th><th hide-xs>Owner</th><th hide-xs>Size</th><th hide show-gt-md>Last Modified</th></tr></thead><tbody><tr \nng-repeat=\"file in binderCrtl.files | filter:global.search | orderBy: \'-type\'\" \nng-click=\"binderCrtl.selectFile(file, $index)\" ng-dblclick=\"binderCrtl.doubleClick(file)\"><td class=\"file-icon\">\n<md-icon md-font-icon=\"{{binderCrtl.fileIcon(file)}}\" class=\"icon md-accent\"></md-icon></td><td class=\"name\">\n{{file.name}}</td><td class=\"owner\" hide-xs>{{file.createdBy}}</td><td class=\"size\" hide-xs><div \nng-hide=\"iconsVisibility==$index\"><span ng-switch=\"file.size > 1024*1024\"><span ng-switch-when=\"true\">\n{{file.size / 1024 / 1024 | number:2}} MB</span> <span ng-switch-default>{{file.size / 1024 | number:2}} kB</span>\n</span></div><span ng-show=\"iconsVisibility==$index\" layout=\"row\" layout-align=\"end center\" \nclass=\"animate-slide-right\"><md-button class=\"md-icon-button md-fab md-mini md-accent md-hue-3\" \nng-click=\"UpdatebinderFile($event,file)\"><md-tooltip md-direction=\"top\">Edit</md-tooltip><md-icon \nmd-font-icon=\"icon-pencil\"></md-icon></md-button><md-button class=\"md-icon-button md-fab md-mini yellow-bg\" \nng-hide=\"file.type==\'folder\'\" ng-click=\"checkInFileDialog($event,file)\"><md-tooltip md-direction=\"top\">Check in\n</md-tooltip><md-icon md-font-icon=\"icon-upload\"></md-icon></md-button><md-button \nclass=\"md-icon-button md-fab md-mini orange-bg\" ng-hide=\"file.type==\'folder\'\" ng-click=\"binderfileCheckout(file.id)\">\n<md-tooltip md-direction=\"top\">Check out</md-tooltip><md-icon md-font-icon=\"icon-download\"></md-icon></md-button>\n</span></td><td><span ng-hide=\"iconsVisibility==$index\">{{file.lastModifiedDate.substr(0,10)}}</span> <span \nng-show=\"iconsVisibility==$index\"><md-button class=\"md-warn md-raised\" ng-click=\"binderCrtl.deleteFile(ev,file)\">\n<md-tooltip md-direction=\"top\">Delete</md-tooltip>Delete</md-button></span></td></tr></tbody></table></div><md-divider>\n</md-divider><div flex=\"35\" ng-hide=\"detailsVisibility\" layout=\"column\"><md-tabs md-dynamic-height md-center-tabs \nmd-border-bottom><md-tab label=\"Details\"><md-content class=\"md-padding\"><div layout=\"column\" \nlayout-align=\"center center\"><md-icon md-font-icon=\"icon-message-alert\" class=\"s128 md-hue-3\"></md-icon><p \nclass=\"md-primary md-hue-3\">Select a file or folder to view its details.</p></div></md-content></md-tab><md-tab \nlabel=\"Activity\"><md-content class=\"md-padding\"><div layout=\"column\" layout-align=\"center center\"><md-icon \nmd-font-icon=\"icon-message-alert\" class=\"s128 md-hue-3\"></md-icon><p class=\"md-primary md-hue-3\">\nSelect a file or folder to view its details.</p></div></md-content></md-tab></md-tabs></div><div flex=\"35\" \nlayout=\"column\" ng-show=\"detailsVisibility\" class=\"scrollable\" ms-scroll><div layout=\"row\" \nlayout-align=\"center center\"><h1>{{binderCrtl.selectedFileName}}</h1></div><div><md-content ng-cloak><md-tabs \nmd-dynamic-height md-center-tabs md-border-bottom><md-tab label=\"Details\"><div class=\"auto-height scrollable\" \nms-scroll><md-content class=\"md-padding\"><table class=\"md-padding detailsTable\"><tr \nng-repeat=\"fileAttribute in binderCrtl.fileAttributes\" ng-hide=\"editorEnabled\" ng-click=\"enableEditor()\"><th>\n{{fileAttribute.label}}</th><td>{{fileAttribute.type}}</td><th>{{fileAttribute.value}}</th></tr><tr \nng-repeat=\"fileAttribute in binderCrtl.fileAttributes\" ng-show=\"editorEnabled\"><th><input \nng-model=\"fileAttribute.label\"></th><td><input ng-model=\"fileAttribute.type\" disabled=\"disabled\"></td><th><input \nng-model=\"fileAttribute.value\"></th></tr></table><div align=\"right\"><md-button flow-btn class=\"md-fab md-mini md-warn\" \nng-click=\" addNewAttribute() \"><md-icon md-font-icon=\"icon-plus\"></md-icon><md-tooltip md-direction=\"top\">\nAdd New Attribute</md-tooltip></md-button><md-button flow-btn class=\"md-fab md-mini md-accent md-hue-3\" \nng-click=\"enableEditor()\" ng-hide=\"editorEnabled\"><md-icon md-font-icon=\"icon-pencil\"></md-icon><md-tooltip \nmd-direction=\"top\">Edit Attributes</md-tooltip></md-button><md-button flow-btn \nclass=\"md-fab md-mini md-accent md-hue-3\" ng-click=\"saveAllAttributes()\" ng-show=\"editorEnabled\"><md-icon \nmd-font-icon=\"icon-content-save\"></md-icon><md-tooltip md-direction=\"top\">Save Attributes</md-tooltip></md-button>\n<md-button flow-btn class=\"md-fab md-mini teal-bg\" ng-click=\"binderCrtl.sharedUsersDialog($event)\"><md-icon \nmd-font-icon=\"icon-account-plus\"></md-icon><md-tooltip md-direction=\"top\">Share {{binderCrtl.selectedFileName}}\n</md-tooltip></md-button></div><div layout=\"row\" layout-align=\"center center\"><div \nng-repeat=\"user in binderCrtl.allSharedUsers\" style=\"padding-left: 2%\"><md-button flow-btn \nclass=\"md-fab md-mini light-green-bg\" ng-click=\"\">{{user.firstName.slice(0,1).toUpperCase()}}<md-tooltip \nmd-direction=\"top\">{{user.firstName +\" \"+ user.lastName}}</md-tooltip></md-button></div></div></md-content></div>\n<md-divider ng-show=\"versionsVisibility\"></md-divider><div layout=\"row\" layout-align=\"center center\" \nclass=\"md-padding\" ng-show=\"versionsVisibility\"><span class=\"md-body-2\">VERSIONS</span></div><md-divider \nng-show=\"versionsVisibility\"></md-divider><div class=\"auto-height scrollable\" ms-scroll><md-content><md-list>\n<md-list-item class=\"md-2-line\" ng-repeat=\"version in file.versions\" ng-click=\"null\"><md-button flow-btn \nclass=\"md-fab md-mini grey-bg\"><md-icon md-font-icon=\"{{selectedFileIcon}}\" class=\"icon\"></md-icon></md-button><span \nflex=\"5\"></span><div class=\"md-list-item-text\" layout=\"column\"><h3><strong>Version {{version.versionNo}} </strong>\ncreated by <strong>{{version.createdBy}}</strong></h3><p>Date : {{version.createdDate.substr(0,10)}}</p><md-button \nclass=\"md-secondary md-icon-button\" ng-click=\"downloadVersionedbinderFile(file.id,version.versionNo)\"><md-tooltip \nmd-direction=\"top\">Download</md-tooltip><md-icon><i class=\"icon icon-download\"></i></md-icon></md-button></div>\n<md-divider ng-if=\"!$last\"></md-divider></md-list-item></md-list><div layout=\"row\" layout-align=\"center center\" \nng-show=\"versionsVisibility\" class=\"md-padding\"><md-button class=\"md-raised\" ng-click=\"VersionFileDialog($event,file)\">\nAdd new version</md-button><span flex=\"5\"></span><md-button class=\"md-raised\" ng-click=\"downloadbinderFile(file.id)\">\nDownload</md-button></div></md-content></div></md-tab><md-tab label=\"ACTIVITY\"><div \nclass=\"auto-height-activity scrollable\" ms-scroll><md-content class=\"md-padding\"><md-list><md-list-item \nclass=\"md-2-line\" ng-repeat=\"activity in file.activities\" ng-click=\"null\"><img ng-src=\"assets\\images\\avatars/Nora.jpg\" \nclass=\"md-avatar\"><div class=\"md-list-item-text\" layout=\"column\"><h3><strong>{{activity.description}}</strong> by \n<strong>{{activity.userId}}</strong></h3><p>Date :{{activity.postedAt.substr(0,10)}}</p></div><md-divider \nng-if=\"!$last\"></md-divider></md-list-item></md-list></md-content></div></md-tab></md-tabs></md-content></div></div>\n</div></ms-widget-front></ms-widget></div></div>");
$templateCache.put("app/main/binder/bindercheckInFiledialog.html","<md-dialog><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2>\nCheckIn {{checkInFile.type}} : {{checkInFile.name}}</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"cancel()\"><md-icon md-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><form name=\"doclibrary\" \nnovalidate layout=\"column\"><div layout=\"row\"><div flex=\"45\" layout=\"column\" layout-align=\"center end\"><span class=\"h3\">\n<b>Upload File</b></span></div><span flex=\"10\"></span><div flex=\"45\" layout=\"column\" layout-align=\"center start\"><input\n class=\"ng-hide\" id=\"formUploadFile\" name=\"formUploadFile\" type=\"file\" \nonchange=\"angular.element(this).scope().setFile(this)\"><label for=\"formUploadFile\" \nclass=\"md-button md-raised md-accent\">Upload</label></div></div><div><div ng-repeat=\"file in files.slice(0)\" \nlayout=\"row\" layout-align=\"center center\"><span class=\"md-warn\">{{file.webkitRelativePath || file.name}}</span> (<span \nng-switch=\"file.size > 1024*1024\"> <span ng-switch-when=\"true\">{{file.size / 1024 / 1024 | number:2}} MB</span> <span \nng-switch-default>{{file.size / 1024 | number:2}} kB</span> </span>)</div></div></form></md-dialog-content>\n<md-dialog-actions layout=\"row\"><span flex></span><md-button ng-click=\"cancel()\">Cancel</md-button><md-button \nng-click=\"binerfilecheckIn()\">Save</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/binder/binderfileDetailsDialog.html","<md-dialog><form name=\"fileDetailsForm\" novalidate ng-submit=\"fileDetailsForm.$valid && update(selectedFile)\" \nlayout=\"column\" flex=\"66\"><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2>\nDetails : {{selectedFileName}}</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-button flow-btn class=\"md-fab md-mini md-warn md-fab-top-right add-button-modal\" \naria-label=\"Add Name\" ng-click=\"showPrompt($event)\"><md-icon md-font-icon=\"icon-plus\"></md-icon><md-tooltip \nmd-direction=\"top\">Add New Attribute</md-tooltip></md-button><md-dialog-content layout=\"column\" class=\"scrollable\" \nms-scroll><div layout=\"column\" flex=\"45\"><md-input-container class=\"md-block\" \nng-repeat=\"fileAttribute in fileAttributes\"><input type=\"text\" name=\"fileName\" ng-model=\"fileAttribute.attributeValue\" \nplaceholder=\"{{fileAttribute.attributeName}}\" required></md-input-container><span flex=\"10\"></span></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"center center\"><md-button ng-click=\"cancel()\">Cancel\n</md-button><md-button type=\"submit\" ng-click=\"updatebinderFileAttributes()\">Update</md-button></md-dialog-actions>\n</form></md-dialog>");
$templateCache.put("app/main/binder/editbinderFiledialog.html","<md-dialog><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2>\nEdit {{currentFile.type}} : {{currentFile.name}}</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"cancel()\"><md-icon md-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><form name=\"doclibrary\" \nnovalidate layout=\"column\"><div layout=\"row\"><div flex=\"45\" layout=\"column\" layout-align=\"center end\"><span class=\"h3\">\n<b>Rename</b></span></div><span flex=\"10\"></span><div flex=\"45\" layout=\"column\" layout-align=\"center start\">\n<md-input-container flex=\"45\" class=\"md-block\" layout=\"column\" layout-align=\"space-around start\"><input type=\"text\" \nname=\"editname\" ng-model=\"currentFile.name\"></md-input-container></div></div><div layout=\"row\"><div flex=\"45\" \nlayout=\"column\" layout-align=\"center end\"><span class=\"h3\"><b>Move to folder</b></span></div><span flex=\"10\"></span>\n<md-input-container flex=\"45\" class=\"md-block\" layout=\"column\" layout-align=\"space-around start\"><input type=\"text\" \nname=\"name\" ng-model=\"currentFile.id\"></md-input-container></div></form></md-dialog-content><md-dialog-actions \nlayout=\"row\"><span flex></span><md-button ng-click=\"cancel()\">Cancel</md-button><md-button \nng-click=\"updatebinderFile(currentFile)\">Save</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/binder/sharedUsersDialog.html","<md-dialog ng-cloak flex=\"40\"><md-toolbar layout=\"row\" class=\"md-accent\"><div class=\"md-toolbar-tools\"><span>\nSharing : {{selectedFileName}}</span> <span flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content layout=\"column\" layout-align=\"center center\"><div flex=\"55\" \nclass=\"md-padding\"><md-content flex ng-style=\"{\'border\': \'1px solid #cccccc\'}\" class=\"scrollable\" ms-scroll \nlayout=\"row\" layout-wrap><div ng-switch=\"(allSharedUsers).length\"><div ng-switch-when=\"0\" layout=\"row\" \nlayout-align=\"center center\"><p class=\"md-padding md-subhead md-primary-fg\">{{\'Not shared yet...\' | uppercase}}</p>\n</div><div ng-switch-default ng-style=\"{\'height\':\'190px\'}\"><md-list><md-list-item class=\"md-2-line\" \nng-repeat=\"user in allSharedUsers \" ng-click=\"null\"><img ng-src=\"assets\\images\\avatars/Nora.jpg\" class=\"md-avatar\"><div\n class=\"md-list-item-text\" layout=\"column\"><h3>{{ user.firstName }} {{ user.lastName }}</h3><p>{{user.email}}</p>\n<md-button class=\"md-secondary md-icon-button\" ng-click=\"removeSharing(user, $index)\"><md-tooltip md-direction=\"top\">\nDelete</md-tooltip><md-icon><i class=\"icon icon-delete s30\"></i></md-icon></md-button></div><md-divider ng-if=\"!$last\">\n</md-divider></md-list-item></md-list></div></div></md-content></div><div class=\"scrollable md-padding\" ms-scroll><div \nlayout=\"row\" class=\"md-padding\"><md-input-container class=\"md-block\" flex=\"70\"><input type=\"text\" name=\"name\" \nng-model=\"searchKeyword\" placeholder=\"Search User\" required></md-input-container><div layout=\"column\" \nlayout-align=\"center center\"><md-button flow-btn class=\"md-accent md-raised\" ng-click=\" searchUsers(searchKeyword)\">\nSearch</md-button></div></div><div ng-show=\"tableVisibility\"><table><thead><tr><th class=\"secondary-text md-padding\">\n<div class=\"table-header\"><span class=\"column-title\">NAME</span></div></th><th class=\"secondary-text md-padding\"><div \nclass=\"table-header\"><span class=\"column-title\">EMAIL</span></div></th></tr></thead><tbody><tr \nng-repeat=\"member in searchedUsers\"><td class=\"md-padding\">{{member.firstName}} {{member.lastName}}</td><td \nclass=\"md-padding\">{{member.email}}</td><td layout=\"row\" layout-align=\"center center\"><md-button \nclass=\"md-accent md-raised\" ng-click=\"shareFile(member) \">ADD</md-button></td></tr></tbody></table></div></div>\n</md-dialog-content><md-dialog-actions layout=\"row\"><span flex></span><md-button ng-click=\"cancel(member)\">Cancel\n</md-button><md-button ng-click=\"updateFileSharing()\" md-autofocus>Ok</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/binder/upload.binderdialog.html","<md-dialog><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2>Create File</h2><span flex></span><md-button\n class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><form name=\"doclibrary\" novalidate layout=\"column\"><span \nclass=\"md-body-2\" ng-style=\"{color:\'red\'}\" ng-hide=\"files.length\">{{ErrorMsg}}</span><div layout=\"row\" \nng-hide=\"folderName\"><div flex=\"45\" layout=\"column\" layout-align=\"center end\"><span class=\"h3\"><b>Upload File</b>\n</span></div><span flex=\"10\"></span><div flex=\"45\" layout=\"column\" layout-align=\"center start\"><input class=\"ng-hide\" \nid=\"formUploadFile\" name=\"formUploadFile\" type=\"file\" onchange=\"angular.element(this).scope().setFile(this)\"><label \nfor=\"formUploadFile\" class=\"md-button md-raised md-accent\">Upload</label></div></div><div><div \nng-repeat=\"file in files.slice(0)\" layout=\"row\" layout-align=\"center center\"><span class=\"md-warn\">\n{{file.webkitRelativePath || file.name}}</span> (<span ng-switch=\"file.size > 1024*1024\"> <span ng-switch-when=\"true\">\n{{file.size / 1024 / 1024 | number:2}} MB</span> <span ng-switch-default>{{file.size / 1024 | number:2}} kB</span> \n</span>)</div></div><div layout=\"row\" ng-hide=\"files.length\"><div flex=\"45\" layout=\"column\" layout-align=\"center end\">\n<span class=\"h3\"><b>Create Folder </b></span></div><span flex=\"10\"></span><md-input-container flex=\"45\" \nclass=\"md-block\" layout=\"column\" layout-align=\"space-around start\"><input type=\"text\" name=\"name\" \nng-model=\"folderName\" placeholder=\"Folder name\" required></md-input-container></div></form></md-dialog-content>\n<md-dialog-actions layout=\"row\"><span flex></span><md-button ng-click=\"cancel()\">Cancel</md-button><md-button \nng-click=\"uploadbinderFile($event,folderName)\">Save</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/bussinessobject/bussiness.html","<div class=\"page-layout carded fullwidth scrollable\" layout=\"column\" flex ms-scroll><div class=\"widget-group\" \nflex=\"100\" layout=\"column\" layout-wrap><ms-widget flippable=\"true\"><ms-widget-front class=\"white-bg md-padding\"><div \nclass=\"md-padding\" flex=\"30\"><ul class=\"breadcrumb\"><li ng-click=\"goToAdmin()\">Administration</li><li>Business Object\n</li></ul></div><table class=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"bsCtrl.dtOptions\"><thead><tr><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Id</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Name</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Description</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\" layout=\"row\" layout-align=\"center center\"><span class=\"column-title\">\nActions</span></div></th></tr></thead><tbody><tr ng-repeat=\"object in objectfiles\"><td>{{object.id}}</td><td>\n{{object.name}}</td><td>{{object.description}}</td><td layout=\"row\" layout-align=\"center center\"><md-button \nclass=\"md-icon-button test-tooltip\" aria-label=\"Update\" ng-click=\"detailsObjectDialog($event,object)\"><md-tooltip \nmd-direction=\"top\">Details</md-tooltip><md-icon><i layout=\"row\" layout-align=\"center center\" \nclass=\"icon icon-dots-vertical s20\"></i></md-icon></md-button><md-button class=\"md-icon-button test-tooltip\" \naria-label=\"Update\" ng-click=\"updateObjectDialog($event,object)\"><md-tooltip md-direction=\"top\">Update</md-tooltip>\n<md-icon><i layout=\"row\" layout-align=\"center center\" class=\"icon icon-pencil s20\"></i></md-icon></md-button><md-button\n class=\"md-icon-button test-tooltip\" aria-label=\"Delete\" ng-click=\"deleteObject($event,object)\"><md-tooltip \nmd-direction=\"top\">Delete</md-tooltip><md-icon><i layout=\"row\" layout-align=\"center center\" \nclass=\"icon icon-delete s20\"></i></md-icon></md-button></td></tr></tbody></table></ms-widget-front></ms-widget></div>\n<md-button flow-btn class=\"md-fab grey-700-bg md-mini md-fab-bottom-right\" ng-click=\"createObjectDialog($event)\">\n<md-icon md-font-icon=\"icon-plus\"></md-icon><md-tooltip md-direction=\"top\">Create Business Object</md-tooltip>\n</md-button></div>");
$templateCache.put("app/main/bussinessobject/create.object.dialog.html","<md-dialog aria-label=\"Add a new object\" flex=\"30\"><form name=\"objectCreateForm\" novalidate \nng-submit=\"objectCreateForm.$valid && bsCtrl.createObject(object)\" layout=\"column\" flex=\"66\"><md-toolbar \nclass=\"md-accent\"><div class=\"md-toolbar-tools\"><h2>Create Business Object</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><md-input-container class=\"md-block\"><input type=\"text\" name=\"name\" \nng-model=\"object.name\" placeholder=\"Name\" required><div ng-messages=\"objectCreateForm.name.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Name is required</span></div></div></md-input-container><md-input-container \nclass=\"md-block\"><input type=\"text\" name=\"description\" ng-model=\"object.description\" placeholder=\"Description\" \nrequired><div ng-messages=\"objectCreateForm.description.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nDescription is required</span></div></div></md-input-container></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"center center\"><md-button type=\"button\" ng-click=\"cancel()\">Cancel</md-button><md-button type=\"submit\" \nng-click=\"objectCreateForm.$valid && save(object) \">Save</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/bussinessobject/details.object.dialog.html","<md-dialog aria-label=\"Add a new user\" flex=\"75\"><form name=\"objectForm\" novalidate \nng-submit=\"objectForm.$valid && bsCtrl.detailsObject(object)\" layout=\"column\" flex=\"66\"><md-toolbar class=\"md-accent\">\n<div class=\"md-toolbar-tools\"><h2>Attributes of Business Object : {{currentObject.name}}</h2><span flex></span>\n<md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content class=\"scrollable\" ms-scroll><div><div layout=\"row\" \nlayout-align=\"space-around center\"><div class=\"table-header\"><span class=\"column-title\">NAME</span></div><div \nclass=\"table-header\"><span class=\"column-title\">TYPE</span></div><div class=\"table-header\"><span class=\"column-title\">\nRANGE</span></div><div class=\"table-header\"><span class=\"column-title\"></span></div></div><md-content><div \nng-repeat=\"element in attributes\" layout=\"row\" layout-align=\"center center\"><md-input-container class=\"md-block\" \nflex=\"20\"><input type=\"text\" name=\"type\" ng-model=\"element.label\"></md-input-container><span flex=\"5\"></span>\n<md-input-container class=\"md-block\" flex=\"20\"><md-select ng-model=\"element.type\"><md-option \nng-repeat=\"type in attributeTypes\" value=\"{{type}}\">{{type}}</md-option></md-select></md-input-container><span \nflex=\"15\"></span><md-input-container class=\"md-block\" flex=\"10\"><md-switch ng-model=\"element.range\" \naria-label=\"Switch\"></md-switch></md-input-container><md-input-container class=\"md-block\" flex=\"20\"><input type=\"text\" \nname=\"list\" ng-model=\"element.listReference\" ng-show=\"element.type == \'List\'\"></md-input-container><span flex=\"5\">\n</span></div></md-content></div></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"center center\">\n<md-button ng-click=\"cancel()\">Cancel</md-button><md-button type=\"submit\" ng-click=\"save()\">Update</md-button>\n</md-dialog-actions><md-button flow-btn class=\"md-fab md-accent md-fab-bottom-right\" aria-label=\"Create User\" \nng-click=\"addNewAttribute()\"><md-icon md-font-icon=\"icon-plus\"></md-icon><md-tooltip md-direction=\"top\">New Attribute\n</md-tooltip></md-button></form></md-dialog>");
$templateCache.put("app/main/bussinessobject/update.object.dialog.html","<md-dialog aria-label=\"Add a new user\" flex=\"30\"><form name=\"objectUpdateForm\" novalidate \nng-submit=\"userForm.$valid && userCtrl.createUser(user)\" layout=\"column\" flex=\"66\"><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools\"><h2>Edit Business Object : {{receivedObject.name}}</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><md-input-container class=\"md-block\"><input type=\"text\" \ndisabled=\"true\" name=\"id\" ng-model=\"receivedObject.id\" required></md-input-container><md-input-container \nclass=\"md-block\"><input type=\"text\" name=\"name\" ng-model=\"receivedObject.name\" placeholder=\"Name\" required>\n</md-input-container><md-input-container class=\"md-block\"><input type=\"text\" name=\"description\" \nng-model=\"receivedObject.description\" placeholder=\"Description\" required></md-input-container></md-dialog-content>\n<md-dialog-actions layout=\"row\" layout-align=\"center center\"><md-button type=\"button\" ng-click=\"cancel()\">Cancel\n</md-button><md-button type=\"submit\" ng-click=\"objectUpdateForm.$valid && update(receivedObject)\">Update</md-button>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/business-admin/busines.admin.content.html","<div class=\"widget-group\" flex=\"100\" layout=\"column\" layout-wrap><ms-widget><ms-widget-front class=\"white-bg\"><div \nclass=\"previous-state c-p\" data-ng-click=\"adminCtrl.goToadmin()\"><span><span \nclass=\"icon-arrow-left-bold-circle-outline\"></span> Back </span></div><div class=\"widget-group\" layout=\"row\" \nflex=\"100\" layout-wrap><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"20\" \nng-click=\"adminCtrl.goToUsers()\"><ms-widget-front class=\"h-170 p-16 orange-bg white-fg c-p\"><div class=\"white-fg\" \nlayout=\"column\" layout-align=\"end start\" flex><div class=\"h1 pb-16\">Users</div></div><div \nclass=\"background-image-center\"><md-icon md-font-icon=\"icon-account-multiple\" class=\"s128 faint-text\"></md-icon></div>\n</ms-widget-front></ms-widget><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"20\" \nng-click=\"adminCtrl.goToGroups()\"><ms-widget-front class=\"h-170 p-16 light-green-bg white-fg c-p\"><div \nclass=\"white-fg\" layout=\"column\" layout-align=\"end start\" flex><div class=\"h1 pb-16\">Groups</div></div><div \nclass=\"background-image-center\"><md-icon md-font-icon=\"icon-account-multiple\" class=\"s128 faint-text\"></md-icon></div>\n</ms-widget-front></ms-widget></div></ms-widget-front></ms-widget></div>");
$templateCache.put("app/main/business-admin/business.admin.html","<div class=\"widget-group\" flex=\"100\" layout=\"column\" layout-wrap><ms-widget><ms-widget-front class=\"white-bg\"><div \nclass=\"widget-group c-p\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" \nflex-gt-xs=\"33\" flex-gt-md=\"20\" ng-click=\"adminCtrl.goToAdminuser()\"><ms-widget-front \nclass=\"h-170 p-16 orange-bg white-fg\"><div class=\"white-fg\" layout=\"column\" layout-align=\"end start\" flex><div \nclass=\"md-title pb-16\">User Management</div><span class=\"h4\">Users and Groups</span></div><div \nclass=\"background-image-center\"><md-icon md-font-icon=\"icon-account-multiple\" class=\"s128 faint-text\"></md-icon></div>\n</ms-widget-front></ms-widget><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"33\" flex-gt-md=\"20\" \nng-click=\"adminCtrl.gotoVendorList()\"><ms-widget-front class=\"h-170 p-16 md-teal-300-bg white-fg\"><div \nclass=\"white-fg\" layout=\"column\" layout-align=\"end start\" flex><div class=\"md-title pb-16\">Vendor List</div><span \nclass=\"h4\"></span></div><div class=\"background-image-center\"><md-icon md-font-icon=\"icon-view-list\" \nclass=\"s128 faint-text\"></md-icon></div></ms-widget-front></ms-widget><ms-widget flippable=\"true\" layout=\"column\" \nflex=\"100\" flex-gt-xs=\"33\" flex-gt-md=\"20\" ng-click=\"adminCtrl.gotoApprovalMatrix()\"><ms-widget-front \nclass=\"h-170 p-16 md-pink-300-bg white-fg\"><div class=\"white-fg\" layout=\"column\" layout-align=\"end start\" flex><div \nclass=\"md-title pb-16\">Approval Matrix</div><span class=\"h4\"></span></div><div class=\"background-image-center\"><md-icon\n md-font-icon=\"icon-view-list\" class=\"s128 faint-text\"></md-icon></div></ms-widget-front></ms-widget></div>\n</ms-widget-front></ms-widget></div>");
$templateCache.put("app/main/dashboard/overview.html","<div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" \nflex-gt-md=\"30\"><ms-widget-front class=\"white-bg h-430\"><md-toolbar layout=\"row\" \nclass=\"white-bg md-primary-fg border-bottom\"><div class=\"md-toolbar-tools\"><span class=\"h3\">{{sitedisplayname}}</span>\n</div></md-toolbar><div class=\"scrollable\" ms-scroll><table class=\"simple list-view\"><tbody><tr \nng-repeat=\"site in homepageList.mySites\"><td class=\"file-icon\"><md-icon md-font-icon=\"{{site.icon}}\" class=\"icon\">\n</md-icon></td><td>{{site.name}}</td><td>{{site.description}}</td></tr></tbody></table></div></ms-widget-front>\n</ms-widget><ms-widget layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"30\"><ms-widget-front \nclass=\"white-bg h-430\"><md-toolbar layout=\"row\" class=\"white-bg md-primary-fg border-bottom\"><div \nclass=\"md-toolbar-tools\"><span class=\"h3\">Latest Activities</span></div></md-toolbar><md-content flex><md-list>\n<md-list-item ng-repeat=\"activity in homepageList.latestActivities\"><p ng-bind-html=\"activity.description\"></p>\n</md-list-item></md-list></md-content></ms-widget-front></ms-widget><ms-widget layout=\"column\" flex=\"100\" \nflex-gt-xs=\"50\" flex-gt-md=\"30\"><ms-widget-front class=\"white-bg h-430\"><md-toolbar layout=\"row\" \nclass=\"white-bg md-primary-fg border-bottom\"><div class=\"md-toolbar-tools\"><span class=\"h3\">Latest Documents</span>\n</div></md-toolbar><md-content flex><table class=\"simple list-view\"><thead><tr><th></th><th>Name</th><th>Owner</th>\n</tr></thead><tbody><tr ng-repeat=\"document in homepageList.latestDocuments\"><td class=\"file-icon\"><md-icon \nmd-font-icon=\"{{overCtrl.fileIcon(document)}}\" class=\"icon\"></md-icon></td><td>{{document.name}}</td><td>\n{{document.createdBy}}</td></tr></tbody></table></md-content></ms-widget-front></ms-widget></div>");
$templateCache.put("app/main/doaReports/doaReprts.html","<style>md-tabs-wrapper {\n		background-color: #24a9dc !important;\n	}</style><div><div ng-if=\"showTable==true \" \nclass=\"page-layout simple tabbed mh-0 md-padding\" layout=\"column\" id=\"scrollToDivID\"><div class=\"content parent-tabs\">\n<md-tabs><md-tab md-active=\"true\" ng-click=\"doaReports()\"><md-tab-label><b style=\"font-family: verdana !important\" \nclass=\"white-fg\" ng-click=\"doaReports()\">User Reports</b></md-tab-label></md-tab><md-tab \nng-click=\"showanalyticReport()\"><md-tab-label><b style=\"font-family: verdana !important\" class=\"white-fg\" \nng-click=\"showanalyticReport()\">TAT Reports</b></md-tab-label></md-tab></md-tabs></div></div><div \nclass=\"page-layout carded fullwidth md-padding scrollable\" layout=\"column\" flex ms-scroll style=\"margin-top: -20px\">\n<div ng-if=\"showTable==true && analyticreports==\'false\'\" class=\"row\" style=\"background-color: white\"><div id=\"report\" \nstyle=\"padding: 20px\" class=\"scrollable\" ms-scroll><div layout=\"row\" layout-align=\"space-between center\" flex=\"100\">\n<div flex=\"15\" style=\"margin-top: 1%\"><md-input-container class=\"md-block margin\" \nstyle=\"border: 1px solid rgb(169, 161, 161);margin-top: 0%;border-radius: 5px;height: 35px;margin-right: 1%\"><input \nng-model=\"obj.sapDocId\" type=\"text\" placeholder=\"RequestId Search\" \nng-keyup=\"$event.keyCode == 13 ? doareprtCtrl.getDOAReports(obj) : \'\' \"><md-icon md-font-icon=\"icon-magnify\"></md-icon>\n</md-input-container></div><div flex=\"15\" style=\"margin-top: 1.5%\"><md-input-container class=\"md-block margin\">\n<md-select ng-model=\"obj.headerFields.SBU\" ng-required=\"true\" placeholder=\"SBU\" \nstyle=\"border: 1px solid rgb(169, 161, 161);border-radius: 3px;margin-bottom: -10%;height: 35px; margin-top: -16%\">\n<md-option ng-value=\"sbu.SBU\" ng-repeat=\"sbu in AllSBU | orderBy:\'SBU\'\">{{sbu.SBU}}-({{sbu.DESCRIPTION}})</md-option>\n</md-select></md-input-container></div><div flex=\"15\" style=\"margin-top: 1.5%\"><md-input-container \nclass=\"md-block margin\"><md-select ng-model=\"obj.headerFields.DEPT\" ng-required=\"true\" placeholder=\"Department\" \nstyle=\"border: 1px solid rgb(169, 161, 161);border-radius: 3px;margin-bottom: -10%;height: 35px; margin-top: -16%\">\n<md-option ng-value=\"dept.DEPT\" ng-repeat=\"dept in AllDepts | orderBy:\'DEPT\'\">{{dept.DEPT}}-({{dept.DESCRIPTION}})\n</md-option></md-select></md-input-container></div><div flex=\"15\" style=\"margin-top: 1.5%\"><md-input-container \nclass=\"md-block margin\"><md-select ng-model=\"obj.headerFields.LOCATION\" ng-required=\"true\" placeholder=\"Location\" \nstyle=\"border: 1px solid hsl(0, 4%, 65%);border-radius: 3px;margin-bottom: -10%;height: 35px; margin-top: -16%\">\n<md-option ng-value=\"location.LOCATION\" ng-repeat=\"location in AllLocations | orderBy:\'LOCATION\'\">\n{{location.LOCATION}}-({{location.DESCRIPTION}})</md-option></md-select></md-input-container></div><div flex=\"15\">\n<label class=\"child-label\" for=\"existing-phases\"></label><input type=\"text\" placeholder=\"current User\" \nng-model=\"obj.currentUser\" list=\"names\" \nstyle=\"border: 1px solid rgb(169, 161, 161);margin-top: 4px;border-radius: 3px;margin-bottom: 9%;height: 35px;margin-right: 1%;border-radius: 3px;width: 100%\">\n<datalist id=\"names\" class=\"form-control\" ng-model=\"obj.currentUser\"><option value=\"\">-- select an option --</option>\n<option ng-repeat=\"person in usersList | filter:search \" ng-value=\"person.login\">\n{{person.firstName}}-{{person.lastName}}</option></datalist></div></div><div layout=\"row\" \nlayout-align=\"space-between center\"><div flex=\"15\"><md-select ng-model=\"obj.sendToSAP\" placeholder=\"status\" \nstyle=\"margin-left:5%;border: 1px solid rgb(169, 161, 161);margin-bottom: 1%;margin-top: -5%;border-radius: 3px;height: 35px;margin-right: 0%\" \nclass=\"md-no-underline\"><md-optgroup><md-option value=\"1\">In-Progress</md-option><md-option value=\"2\">Completed\n</md-option><md-option value=\"8\">Rejected</md-option><md-option value=\"5\">Collaborated</md-option></md-optgroup>\n</md-select></div><div flex=\"15\"><input type=\"text\" placeholder=\"CreatedBy\" ng-model=\"obj.creator\" \nng-change=\"getvalueoflist(obj.creator)\" list=\"creator\" \nstyle=\"border: 1px solid rgb(169, 161, 161);margin-top: 4px;border-radius: 3px;margin-bottom: 9%;height: 35px;margin-right: 1%;border-radius: 3px;width: 99%\">\n<datalist id=\"creator\" class=\"form-control\" ng-model=\"obj.creator\"><option value=\"\">-- select an option --</option>\n<option ng-repeat=\"person in createdByUsers | filter:search \" ng-value=\"person\">{{person}}</option></datalist></div>\n<div flex=\"15\" style=\"margin-top: 0.5%\"><md-input-container class=\"md-block\" \nstyle=\"border: 1px solid rgb(169, 161, 161);margin-top: 0%;margin-right: 1%;border-radius: 5px;height: 35px\"><label>\nFrom Date</label><input moment-picker=\"obj.fromDate\" ng-model=\"obj.fromDate\" autocomplete=\"off\" format=\"DD/MM/YYYY\">\n</md-input-container></div><div flex=\"15\" style=\"margin-top: 0.5%\"><md-input-container class=\"md-block\" \nstyle=\"border: 1px solid rgb(169, 161, 161);margin-top: 0%;margin-right: 1%;border-radius: 5px;height: 35px\"><label>\nTo Date</label><input moment-picker=\"obj.toDate\" ng-model=\"obj.toDate\" autocomplete=\"off\" ng-click=\"selectDate(obj)\" \nformat=\"DD/MM/YYYY\" ng-disabled=\"obj.fromDate == null\" min-date=\"obj.fromDate\" max-date=\"maxDate\"></md-input-container>\n</div><md-input-container flex=\"15\" class=\"md-block\" \nstyle=\"border: 1px solid rgb(169, 161, 161);margin-top: 0.5%;border-radius: 3px;height: 35px;margin-right: 1%\"><input \nng-model=\"report\" type=\"text\" placeholder=\"Filter Table Data\"></md-input-container></div><div layout=\"row\"><div \nflex=\"15\" style=\"margin-top: 20px\"><md-input-container class=\"md-block margin\"><md-select ng-model=\"obj.requestType\" \nmultiple=\"multiple\" placeholder=\"Request Type\" \nstyle=\"border: 1px solid hsl(0, 4%, 65%);border-radius: 3px;margin-bottom: -10%;height: 35px; margin-top: -16%\">\n<md-option ng-value=\"req\" ng-repeat=\"req in permittedRequestTypes\">{{req}}</md-option></md-select></md-input-container>\n</div><div flex-gt-sm=\"15\" layout=\"row\" style=\"margin-top: 5px\"><div><md-button class=\"md-raised md-accent\" \nng-click=\"doareprtCtrl.getDOAReports(obj)\" style=\"margin-top:-1% !important\">Search</md-button></div><div><md-button \nclass=\"md-raised md-warn\" ng-click=\"Reset()\" style=\"margin-top:-1% !important\">Reset</md-button></div></div><div \nflex=\"15\" layout=\"row\" layout-align=\"end end\"><div style=\"margin-bottom:13%\"><md-icon md-font-icon=\"icon-download\" \nclass=\"s32 c-p\" ng-click=\"doareprtCtrl.Download(obj)\" style=\"color: #13e513\"></md-icon></div><div><md-input-container \nclass=\"md-block md-padding\" style=\"margin-top:-11%;margin-left: 2%;margin-right: -2%\"><md-select ng-model=\"sizeNumber\">\n<md-option ng-repeat=\"size in sizeNumbers\" ng-value=\"size\" ng-click=\"sendsizeNumber(size)\" value=\"sizeNumber\" \nng-selected=\"$first\">{{size}}</md-option></md-select></md-input-container></div></div></div></div><div layout=\"row\" \nflex=\"60\" layout-align=\"center center\" ng-if=\"allReports.length == 0\" \nstyle=\"border:2px solid #cccccc; border-radius:5px; height:50px;margin-left:20%\"><b>No Records were found</b></div>\n<table id=\"scrollToDivID\" class=\"dataTable row-border hover tableHighllete\" ng-if=\"allReports.length != 0\" \nclass=\"scrollable\" ms-scroll style=\"border: 1px solid #ccc\"><thead><tr style=\"background-color: #dee7f4 !important\">\n<th>REQ ID</th><th>Request Type</th><th>Subject</th><th>Created By</th><th>Created Date</th><th>SBU</th><th>Department\n</th><th>Location</th><th>Total Amount</th><th>Io Number</th><th>Status</th><th>CurrentUser</th><th>Completed Date</th>\n</tr></thead><tbody><tr ng-repeat=\"report in allReports | filter :report\" ng-click=\"selectReport(report)\" class=\"c-p\">\n<td><span ng-click=\"gotopreview(report)\" \nstyle=\"text-align: start;text-decoration: underline;color: blue;cursor: pointer\">{{report.requestId}}</span></td><td>\n{{report.requestType}}</td><td>{{report.header.JS_SHORTTEXT}}</td><td>{{report.createdBy}}</td><td>\n{{report.createdDate.substring(0,10)}}</td><td>{{report.header.SBU_DES }}</td><td>{{report.header.DEPT_DES}}</td><td>\n{{report.header.LOCATION_DES}}</td><td><span>{{report.header.FARM_TOTAL}}</span></td><td style=\"word-break: break-all\">\n<span>{{report.header.MULTI_IO}}</span></td><td>{{report.workFlowStatus}}</td><td><span \nng-if=\"report.workFlowStatus == \'Completed\'\">- </span><span ng-if=\"report.workFlowStatus != \'Completed\'\">\n{{report.header.CurrentUser | capitalize}}</span></td><td><span ng-if=\"report.workFlowStatus != \'Completed\'\">- </span>\n<span ng-if=\"report.workFlowStatus == \'Completed\'\">{{report.lastModifiedDate.substring(0,10)}}</span></td></tr></tbody>\n</table><div layout=\"row\" layout-align=\"space-between center\" flex=\"100\"><div class=\"md-padding\"><h5><b>\nShowing {{(pageNumber*size)+1}} - {{(pageNumber + 1)*size}} of {{totalRecords}} Results</b></h5></div><div \nlayout=\"row\" layout-align=\"center center\">Page No<md-input-container class=\"md-block md-padding\" style=\"margin: 0px\">\n<md-select ng-model=\"pageNumber\"><md-option ng-repeat=\"pageNumber in pageNumbers\" ng-value=\"pageNumber\" \nng-click=\"sendPageNumber(pageNumber)\" value=\"pageNumber\" ng-selected=\"$first\">{{pageNumber+1}}</md-option></md-select>\n</md-input-container></div><div layout=\"row\" layout-align=\"center center\"><div><md-button type=\"button\" \nng-click=\"previous()\" ng-disabled=\"pageNumber <= 0\">Prev</md-button></div><p class=\"md-padding\"><b>\n{{pageNumber+1}}/{{totalPages}} &nbsp;PAGES</b></p><div class=\"md-padding\"><md-button type=\"button\" \nng-click=\"next(obj)\" ng-disabled=\"pageNumber == totalPages-1\">Next</md-button></div></div></div></div></div><div \nng-if=\"showTable==false && analyticreports==\'false\'\"><div layout=\"row\" layout-align=\"space-between center\" \nclass=\"p-9 c-p\" style=\"padding: 3px\"><div><span><md-icon ng-click=\"gotoback()\" md-font-icon=\"icon-arrow-left\" \nstyle=\"color: black\"></md-icon></span><span class=\"h3\">Back</span></div><div class=\"h4\">{{report.requestId}}</div><div \nclass=\"h4\" style=\"text-align:center\"></div><div layout-align=\"end end\" \nng-if=\"report.workFlowStatus !=\'Rejected\' && report.workFlowStatus !=\'Completed\'\"><md-button class=\"md-raised md-warn\" \nng-click=\"doareprtCtrl.cancelReport(report)\">Cancel</md-button></div></div><div ng-cloak><md-content><md-tabs \nmd-dynamic-height md-border-bottom><md-tab label=\"Info\"><md-content class=\"md-padding\"><div \nclass=\"md-stepper-horizontal orange\" ms-scroll><div class=\"md-step active done\" \nng-repeat=\"approver in report.approvalMatrix.approvers  track by $index\"><div style=\"margin-left: 50%\"><md-icon \nclass=\"icon s20 green-fg\" ng-if=\"report.approvalMatrix.checked[$index]\" md-font-icon=\"icon-checkbox-marked-circle \">\n</md-icon><md-icon class=\"icon s20 blue-500-fg\" \nng-if=\"(!report.approvalMatrix.checked[$index] && report.status != \'8\') ||  (!report.approvalMatrix.checked[$index]&& report.approvalMatrix.approverDates[$index])\" \nmd-font-icon=\"	icon-google-circles-invite\"></md-icon><md-icon class=\"icon s25 red-fg\" \nng-if=\"report.approvalMatrix.checked[$index] == false && report.status == \'8\' && !report.approvalMatrix.approverDates[$index]\" \nmd-font-icon=\"icon-close-circle-outline\"></md-icon></div><div class=\"md-step-title\" \nng-class=\"{\'selectedApprovalMatrixrow\':report.approvalMatrix.selected[$index]}\"><h5 \nng-class=\"{\'activateadUser\': $index+1 == report.currentstep}\"><b>{{approver}}</b> <span class=\"icon s25 red-fg\" \nng-if=\"report.approvalMatrix.checked[$index] == false && report.status == \'8\' && !report.approvalMatrix.approverDates[$index]\">\n(Rejected)</span></h5></div><div class=\"md-step-bar-left\"><div hide-xs show-gt-md \nng-if=\"report.approvalMatrix.approverDates[$index]\" style=\"font-size:12px\" layout=\"column\"><span \nng-if=\"report.approvalMatrix.approvers.length <\'6\'\">\nDate: {{report.approvalMatrix.approverDates[$index].substring(6,8)}}-{{report.approvalMatrix.approverDates[$index].substring(4,6)}}-{{report.approvalMatrix.approverDates[$index].substring(0,4)}}\n</span> <span ng-if=\"report.approvalMatrix.approvers.length >=\'6\'\">\nD: {{report.approvalMatrix.approverDates[$index].substring(6,8)}}/{{report.approvalMatrix.approverDates[$index].substring(4,6)}}-{{report.approvalMatrix.approverDates[$index].substring(0,4)}}\n</span> <span>\nTime: {{report.approvalMatrix.approverDates[$index].substring(9,11)}}:{{report.approvalMatrix.approverDates[$index].substring(11,13)}}\n</span></div></div><div class=\"md-step-bar-right\"></div></div></div><div layout=\"row\"><div flex=\"50\"><ms-widget \nlayout=\"column\"><ms-widget-front class=\"white-bg\" style=\"border-radius: 6px\"><md-content><div class=\"h3 p-8\">Header\n</div><div class=\"md-stepper-horizontal orange\" ms-scroll></div><md-divider></md-divider><div class=\"md-padding\"><div \nng-bind-html=\"currentFormInbox\" compile-template></div></div></md-content></ms-widget-front></ms-widget></div><div \nflex=\"50\"><ms-widget layout=\"column\" flex-xs=\"100\"><ms-widget-front class=\"white-bg\" style=\"border-radius: 6px\">\n<md-content><div class=\"md-padding\"><div layout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">Logs</div>\n<div><md-button style=\"line-height: 29px !important\" ng-click=\"printLogs(\'printSectionId\')\" \nclass=\"md-raised md-accent\">Print</md-button></div></div><md-divider></md-divider><div flex-gt-sm><div \nid=\"printSectionId\"><style>\n.md-active {\n																	color: #f0f2f3 !important;\n																}\n\n																.back {\n																	background-image: url(\"data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iNiIgaGVpZ2h0PSI2Ij4KPHJlY3Qgd2lkdGg9IjYiIGhlaWdodD0iNiIgZmlsbD0iI2VlZWVlZSI+PC9yZWN0Pgo8ZyBpZD0iYyI+CjxyZWN0IHdpZHRoPSIzIiBoZWlnaHQ9IjMiIGZpbGw9IiNlNmU2ZTYiPjwvcmVjdD4KPHJlY3QgeT0iMSIgd2lkdGg9IjMiIGhlaWdodD0iMiIgZmlsbD0iI2Q4ZDhkOCI+PC9yZWN0Pgo8L2c+Cjx1c2UgeGxpbms6aHJlZj0iI2MiIHg9IjMiIHk9IjMiPjwvdXNlPgo8L3N2Zz4=\");\n																}\n\n																.md-stepper-horizontal {\n																	display: table;\n																	width: 98%;\n																	margin-top: 1% !important;\n																	border-radius: 6px;\n																	margin: 0 auto;\n																	background-color: #FFFFFF;\n																	box-shadow: 0 3px 8px -6px rgba(0, 0, 0, .50);\n																}\n\n																.md-stepper-horizontal .md-step {\n																	display: table-cell;\n																	position: relative;\n																	padding: 20px;\n																}\n\n																.md-stepper-horizontal .md-step .md-step-circle {\n																	width: 30px;\n																	height: 30px;\n																	margin: 0 auto;\n																	background-color: #999999;\n																	border-radius: 50%;\n																	text-align: center;\n																	line-height: 30px;\n																	font-size: 16px;\n																	font-weight: 600;\n																	color: #FFFFFF;\n																}\n\n																.md-stepper-horizontal.orange .md-step.active .md-step-circle {\n																	background-color: #F96302;\n																}\n\n																.md-stepper-horizontal .md-step.active .md-step-circle {\n																	background-color: rgb(33, 150, 243);\n																}\n\n																.md-stepper-horizontal .md-step.done .md-step-circle:before {\n																	font-family: \'FontAwesome\';\n																	font-weight: 100;\n																	content: \"\\f00c\";\n																}\n\n																.md-stepper-horizontal .md-step.done .md-step-circle *,\n																.md-stepper-horizontal .md-step.editable .md-step-circle * {\n																	display: none;\n																}\n\n																.md-stepper-horizontal .md-step.editable .md-step-circle {\n																	-moz-transform: scaleX(-1);\n																	-o-transform: scaleX(-1);\n																	-webkit-transform: scaleX(-1);\n																	transform: scaleX(-1);\n																}\n\n																.md-stepper-horizontal .md-step.editable .md-step-circle:before {\n																	font-family: \'FontAwesome\';\n																	font-weight: 100;\n																	content: \"\\f040\";\n																}\n\n																.md-stepper-horizontal .md-step .md-step-title {\n																	margin-top: 16px;\n																	font-size: 16px;\n																	font-weight: 600;\n																}\n\n																.md-stepper-horizontal .md-step .md-step-title,\n																.md-stepper-horizontal .md-step .md-step-optional {\n																	text-align: center;\n																	color: rgba(0, 0, 0, .26);\n																}\n\n																.md-stepper-horizontal .md-step.active .md-step-title {\n																	font-weight: 600;\n																	color: rgba(0, 0, 0, .87);\n																}\n\n																.md-stepper-horizontal .md-step.active.done .md-step-title,\n																.md-stepper-horizontal .md-step.active.editable .md-step-title {\n																	font-weight: 600;\n																}\n\n																.md-stepper-horizontal .md-step .md-step-optional {\n																	font-size: 12px;\n																}\n\n																.md-stepper-horizontal .md-step.active .md-step-optional {\n																	color: rgba(0, 0, 0, .54);\n																}\n\n																.md-stepper-horizontal .md-step .md-step-bar-left,\n																.md-stepper-horizontal .md-step .md-step-bar-right {\n																	position: absolute;\n																	top: 36px;\n																	height: 5px;\n																	border-top: 1px solid #DDDDDD;\n																}\n\n																.md-stepper-horizontal .md-step .md-step-bar-right {\n																	right: 0;\n																	left: 50%;\n																	margin-left: 20px;\n																}\n\n																.md-stepper-horizontal .md-step .md-step-bar-left {\n																	left: 0;\n																	right: 50%;\n																}\n\n																.activateadUser {\n																	color: green\n																}\n\n																#customers {\n																	font-family: \"Trebuchet MS\", Arial, Helvetica, sans-serif;\n																	border-collapse: collapse;\n																	width: 100%;\n																}\n\n																#customers td,\n																#customers th {\n																	border: 1px solid #ddd;\n																	padding: 8px;\n																}\n\n																#customers tr:nth-child(even) {\n																	background-color: #f2f2f2;\n																}\n\n																#customers tr:hover {\n																	background-color: #ddd;\n																}\n\n																#customers th {\n																	padding-top: 12px;\n																	padding-bottom: 12px;\n																	text-align: left;\n																	background-color: #4CAF50;\n																	color: white;\n																}\n</style><table id=\"customers\" ng-hide=\"true\"><tr><th>SNo</th><th>Request Id</th><th>User Name</th><th>Activity</th><th>\nComment</th><th>Date</th><th>Time</th></tr><tr ng-repeat=\"log in  logs | orderBy:\'id\':true \"><td>{{$index+1}}</td><td>\n{{report.requestId}}</td><td>{{log.actualUser.charAt(0).toUpperCase() + log.actualUser.substr(1).toLowerCase()}}</td>\n<td><span ng-if=\"log.activity == \'001\'\">Initiated</span> <span ng-if=\"log.activity == \'\'\">\nInitior Comments For CollaborateBack</span> <span ng-if=\"log.activity == \'101\'\">Approved</span> <span \nng-if=\"log.activity == \'102\'\">Rejected</span> <span ng-if=\"log.activity == \'110\'\">Collaborate	With User</span> <span \nng-if=\"log.activity == \'111\'\">CollaborateBack</span> <span ng-if=\"log.activity == \'550\'\">Collaborate	With Initiator\n</span> <span ng-if=\"log.activity == \'551\'\">CollaborateBack	From Initiator</span></td><td>{{log.comments}}</td><td>\n{{log.endDate.substring(6,8)}} - {{log.endDate.substring(4,6)}} -{{log.endDate.substring(0,4)}}</td><td>\n{{log.endTime.substring(0,2)}}:{{log.endTime.substring(2,4)}}</td></tr></table></div><timeline class=\"md-padding\">\n<timeline-event ng-repeat=\"log in logs | orderBy:\'id\':true \"><timeline-badge style=\"background-color: rgb(3,155,229)\">\n<md-icon md-font-icon=\"{{log.icon}}\" class=\"s25 icon white-fg\" style=\"color:white !important\"></md-icon>\n</timeline-badge><timeline-panel class=\"{{\'info\'}}\" style=\"background-color: #f1eded\"><timeline-heading><div \nlayout=\"row\" layout-align=\"end end\"><p><b>\nDate :{{log.endDate.substr(6,2)}}-{{log.endDate.substr(4,2)}}-{{log.endDate.substr(0,4)}}</b></p></div><div \nlayout=\"row\" layout-align=\"start center\" style=\"color:black\"><img ng-src=\"assets\\images\\avatars/Nora.jpg\" \nclass=\"md-avatar\" style=\"border-radius:50% !important;width:13%; height:auto\"><div class=\"h3\" \nng-if=\"log.activity == \'001\' \">{{log.actualUser}} Initiated</div><div class=\"h3\" \nng-if=\"log.activity == \'101\'|| log.activity == \'510\' \">{{log.actualUser}} Approved</div><div class=\"h3\" \nng-if=\"log.activity == \'103\' \">{{log.actualUser}} Rejected</div><div class=\"h3\" \nng-if=\"log.activity == \'515\' || log.activity == \'516\' || log.activity == \'502\' \">\n{{log.actualUser}} {{log.activityText}}</div><div class=\"h3\" \nng-if=\"log.activity == \'110\' || log.activity == \'111\' || log.activity == \'550\' ||  log.activity == \'551\'\">\n{{log.actualUser}} {{log.activityText}} With {{log.currAgent}}</div><div class=\"h3\" ng-if=\"!log.activity\">\n{{log.actualUser}}</div></div></timeline-heading><div layout=\"row\" layout-align=\"start start\" style=\"padding-left: 2%\">\n<div class=\"text pt-16\">{{log.comments}}</div></div></timeline-panel></timeline-event></timeline></div></div>\n</md-content></ms-widget-front></ms-widget></div></div></md-content></md-tab><md-tab label=\"Attachments\"><md-content \nclass=\"md-padding\"><div class=\"md-padding\" layout=\"row\" layout-align=\"space-between center\"><span class=\"h2\">\nAttachments : {{getAttachmentsLength(attachments)}}</span></div><div><md-list><md-list-item class=\"md-3-line\" \nng-repeat=\"attachment in attachments | orderBy : \'folderName\'\" ng-if=\"attachment.deleteStatus != \'true\'\"><div \nlayout=\"column\" flex=\"60\" ng-click=\"preview($event,attachment,report.requestId,attachment.url)\"><div class=\"h3\" \nstyle=\"color: #4fbfe9\">{{attachment.folderName}}</div><div layout=\"row\" layout-align=\"start start\"><span><md-icon \nmd-font-icon=\"{{fileIcon(attachment.fileType)}}\" class=\"s42 icon md-accent\"></md-icon></span><div layout=\"column\" \nflex=\"50\"><span class=\"h4\" ng-click=\"selectFile(attachment)\">{{attachment.fileName}}</span> <span class=\"h6\" \nstyle=\"color:black\">Created By : {{attachment.creator}}</span></div><span flex=\"20\" style=\"margin-top: -1%\"><md-button \nclass=\"md-icon-button md-accent\" ng-click=\"downloadFile(attachment)\"><md-icon md-font-icon=\"icon-download\" \nclass=\"s20 green-fg\"></md-icon></md-button></span><div hide-sm><h3 style=\"color: #030303;margin-top: -2%\">\nCreated On :{{attachment.createDate.substr(6,2)}}-{{attachment.createDate.substr(4,2)}}-{{attachment.createDate.substr(0,4)}}\n</h3></div></div></div></md-list-item></md-list></div></md-content></md-tab></md-tabs></md-content></div></div><div \nng-if=\"analyticreports==\'true\'\"><div layout=\"row\" layout-align=\"space-between center\" \nstyle=\"background: white;padding: 10px\"><div flex=\"15\" style=\"margin-top: 3%\"><md-input-container \nclass=\"md-block margin\"><md-select ng-model=\"object.sbu\" ng-required=\"true\" placeholder=\"SBU\" \nstyle=\"border: 1px solid rgb(169, 161, 161);border-radius: 3px;margin-bottom: -10%;height: 35px; margin-top: -16%\">\n<md-option ng-value=\"sbu.SBU\" ng-repeat=\"sbu in AllSBU | orderBy:\'SBU\'\">{{sbu.SBU}}-({{sbu.DESCRIPTION}})</md-option>\n</md-select></md-input-container></div><div flex=\"15\" style=\"margin-top: 3%\"><md-input-container \nclass=\"md-block margin\"><md-select ng-model=\"object.department\" ng-required=\"true\" placeholder=\"Department\" \nstyle=\"border: 1px solid rgb(169, 161, 161);border-radius: 3px;margin-bottom: -10%;height: 35px; margin-top: -16%\">\n<md-option ng-value=\"dept.DEPT\" ng-repeat=\"dept in AllDepts | orderBy:\'DEPT\'\">{{dept.DEPT}}-({{dept.DESCRIPTION}})\n</md-option></md-select></md-input-container></div><div flex=\"15\" style=\"margin-top: 3%\"><md-input-container \nclass=\"md-block margin\"><md-select ng-model=\"object.LOCATION\" ng-required=\"true\" placeholder=\"Location\" \nstyle=\"border: 1px solid hsl(0, 4%, 65%);border-radius: 3px;margin-bottom: -10%;height: 35px; margin-top: -16%\">\n<md-option ng-value=\"location.LOCATION\" ng-repeat=\"location in AllLocations | orderBy:\'LOCATION\'\">\n{{location.LOCATION}}-({{location.DESCRIPTION}})</md-option></md-select></md-input-container></div><div flex=\"15\" \nstyle=\"margin-top: 3%\"><md-input-container class=\"md-block margin\"><md-select ng-model=\"object.users\" \nng-required=\"true\" placeholder=\"Approver Name\" multiple=\"multiple\" \nstyle=\"border: 1px solid rgb(169, 161, 161);border-radius: 3px;margin-bottom: -10%;height: 35px; margin-top: -16%\">\n<md-option ng-value=\"person.login\" ng-repeat=\"person in usersList | filter:search \">\n{{person.firstName}}-{{person.lastName}}</md-option></md-select></md-input-container></div><div flex=\"10\" \nstyle=\"margin-top: 2%\"><md-input-container class=\"md-block\" \nstyle=\"border: 1px solid rgb(169, 161, 161);margin-top: 0%;margin-right: 1%;border-radius: 5px;height: 35px\"><label>\nFrom Date</label><input moment-picker=\"object.fromDate\" ng-model=\"object.fromDate\" autocomplete=\"off\" \nformat=\"DD/MM/YYYY\"></md-input-container></div><div flex=\"10\" style=\"margin-top: 2%\"><md-input-container \nclass=\"md-block\" \nstyle=\"border: 1px solid rgb(169, 161, 161);margin-top: 0%;margin-right: 1%;border-radius: 5px;height: 35px\"><label>\nTo Date</label><input moment-picker=\"object.toDate\" ng-model=\"object.toDate\" autocomplete=\"off\" \nng-click=\"selectDate(object)\" format=\"DD/MM/YYYY\" ng-disabled=\"object.fromDate == null\" min-date=\"object.fromDate\" \nmax-date=\"maxDate\"></md-input-container></div><div flex=\"15\" style=\"margin-top: 1%\"><md-button \nclass=\"md-raised md-accent\" ng-click=\"doareprtCtrl.getAnalyticDOAReports(object)\" style=\"margin-top:-1% !important\">\nSearch</md-button><md-button class=\"md-raised md-warn\" ng-click=\"ResetanalyticReport()\" \nstyle=\"margin-top:-1% !important\">Reset</md-button></div></div></div></div>");
$templateCache.put("app/main/doaReports/doaRportsComment.html","<md-dialog flex=\"40\"><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2>{{popupHeading}}</h2><span flex>\n</span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><form name=\"commentForm\" novalidate layout=\"column\"><div \nlayout=\"row\"><md-input-container class=\"md-block no-margin\" flex=\"100\"><label>Add comment</label><textarea \nng-model=\"reportsComment\" columns=\"1\" md-maxlength=\"150\" rows=\"3\" required></textarea></md-input-container></div>\n</form></md-dialog-content><md-dialog-actions layout=\"row\"><span flex></span><md-button ng-click=\"cancel()\">Cancel\n</md-button><md-button ng-click=\"reportCancel($event, reportsComment)\" ng-disabled=\"!reportsComment\">Ok</md-button>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/finishReset/finishReset.html","<md-dialog flex=\"35\"><form name=\"passwordForm\" novalidate layout=\"column\"><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools\"><h2>Change Password</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"cancel()\"><md-icon md-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"column\" \nlayout-align=\"center center\"><md-input-container class=\"md-block\"><md-icon md-font-icon=\"icon-key-variant\" \nstyle=\"color: rgb(5, 167, 253) !important\"></md-icon><input type=\"password\" name=\"password\" ng-model=\"user.password\" \nplaceholder=\"Enter Password*\" minlength=\"4\" required><div ng-messages=\"passwordForm.password.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Password field is required</span></div><div ng-message=\"minlength\"><span>\nPassword must contain at least 4 letters</span></div></div></md-input-container><md-input-container class=\"md-block\">\n<md-icon md-font-icon=\"icon-key-variant\" style=\"color: rgb(5, 167, 253) !important\"></md-icon><input type=\"password\" \nname=\"passwordConfirm\" ng-model=\"user.passwordConfirm\" placeholder=\"Re-enter Password*\" required><div \nng-messages=\"passwordForm.passwordConfirm.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nRe-enter Password field is required</span></div></div></md-input-container><span \nstyle=\"color: red;font-family: \'Roboto\';font-size: 12px; margin-top: -4% !important\" \nng-show=\"user.password !== user.passwordConfirm\">Passwords do not match</span></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" layout-align=\"center center\"><md-button type=\"button\" ng-click=\"cancel()\">Cancel\n</md-button><md-button type=\"submit\" ng-disabled=\"user.password !== user.passwordConfirm\" \nng-click=\" passwordForm.$valid && save(user.password)\">Save</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/TicketManagement/addTicket.html","<style>\nmd-tabs-wrapper{\n   background-color:#24a9dc !important;;\n   }\n   input,md-select{\n   font-family:verdana !important\n   }\n</style><div class=\"page-layout simple tabbed mh-0 md-padding\" layout=\"column\"><div class=\"content parent-tabs\">\n<md-tabs><md-tab md-active=\"true\"><md-tab-label><b style=\"font-family: verdana !important\" class=\"white-fg\">Add Ticket\n</b></md-tab-label></md-tab></md-tabs></div></div><div id=\"sites\" class=\"page-layout carded fullwidth scrollable\" \nlayout=\"column\" flex ms-scroll style=\"margin-top: -20px\"><div class=\"widget-group\" flex=\"100\" layout=\"column\" \nlayout-wrap><ms-widget flippable=\"true\"><ms-widget-front class=\"white-bg md-padding\"><div layout=\"row\" \nlayout-align=\"center center\"><div flex=\"70\" class=\"scrollable\" ms-scroll style=\"padding-top:30px\"><div \nstyle=\"border:2px solid #cccccc; border-radius:5px\" class=\"md-padding\"><div layout=\"column\" layout-gt-sm=\"row\"><div \nflex=\"100\" layout=\"row\"><h3 flex=\"20\">Requestor</h3><md-input-container flex-gt-sm=\"20\" md-no-float \nstyle=\"margin: 0px 0px 0px 30px\"><input name=\"firstName\" ng-model=\"currentLogedInUser.firstName\" type=\"text\" \nplaceholder=\"First Name\" ng-disabled=\"true\"></md-input-container><span flex=\"5\"></span><md-input-container \nflex-gt-sm=\"20\" md-no-float style=\"margin: 0px\"><input ng-model=\"currentLogedInUser.lastName\" type=\"text\" \nplaceholder=\"Last Name\" ng-disabled=\"true\"></md-input-container><span flex=\"10\"></span><md-input-container \nflex-gt-sm=\"20\" md-no-float style=\"margin: 0px\"><md-select ng-model=\"ticket.status\" placeholder=\"Status\"><md-option \nng-value=\"state\" ng-repeat=\"state in status\">{{state}}</md-option></md-select></md-input-container></div></div><div \nlayout=\"column\" layout-gt-sm=\"row\"><div flex=\"45\" layout=\"row\"><h3 flex=\"45\">Request Type</h3><span flex=\"5\"></span>\n<md-input-container class=\"md-block\" flex=\"50\" style=\"margin: 0px\"><md-select ng-model=\"ticket.requestType\"><md-option \nng-value=\"requestType\" ng-repeat=\"requestType in requestTypes\">{{requestType}}</md-option></md-select>\n</md-input-container></div><span flex=\"10\"></span><div flex=\"45\" layout=\"row\"><h3 flex=\"45\">Priority</h3><span \nflex=\"5\"></span><md-input-container class=\"md-block\" flex=\"50\" style=\"margin: 0px\"><md-select \nng-model=\"ticket.priority\"><md-option ng-value=\"Priority\" ng-repeat=\"Priority in Priorities\">{{Priority}}</md-option>\n</md-select></md-input-container></div></div><div layout=\"column\" layout-gt-sm=\"row\"><div flex=\"100\" layout=\"row\"><h3 \nflex=\"15\">Subject</h3><span flex=\"5\"></span><md-input-container flex-gt-sm=\"80\" md-no-float \nstyle=\"margin: 0px 0px 0px 30px\"><input ng-model=\"ticket.subject\" type=\"text\" placeholder=\"Subject\" \nstyle=\"border: 1px solid rgb(204, 204, 204);border-radius:5px\"></md-input-container></div></div><div layout=\"column\" \nlayout-gt-sm=\"row\"><div flex=\"100\" layout=\"row\"><h3 flex=\"15\">Description</h3><span flex=\"10\"></span>\n<md-input-container flex-gt-sm=\"80\" md-no-float style=\"border:1px solid #cccccc; border-radius:5px\"><textarea \nng-model=\"description\" placeholder=\"Description\" rows=\"6\" required></textarea></md-input-container></div></div><div \nlayout=\"row\" layout-align=\"start center\" flex=\"100\"><div><div><input class=\"ng-hide\" id=\"attachmentUpload\" \nname=\"attachmentUpload\" type=\"file\" multiple=\"multiple\" \nonchange=\"angular.element(this).scope().setAttachmentFile(this)\"><label for=\"attachmentUpload\" \nclass=\"md-button md-raised\">Upload files</label></div></div><div flex=\"10\"></div><div layout=\"column\"><div \nng-repeat=\"file in attachmentfiles.slice(0)\"><div layout=\"row\"><span class=\"md-warn\">\n{{file.webkitRelativePath || file.name}}</span> ( <span ng-switch=\"file.size > 1024*1024\"><span ng-switch-when=\"true\">\n{{file.size / 1024 / 1024 | number:2}} MB</span> <span ng-switch-default>{{file.size / 1024 | number:2}} kB</span> \n</span>)</div></div></div></div><div layout=\"row\" layout-align=\"end center\"><md-button class=\"md-accent md-raised\" \nng-click=\"addTicket(ticket, description)\" ng-disabled=\"buttonDis\">Submit</md-button></div></div></div></div>\n</ms-widget-front></ms-widget></div></div>");
$templateCache.put("app/main/TicketManagement/ticketDetails.html","<style>\nspan{\n	font-family:verdana !important;\n	}\n	.disabled {\n  pointer-events: none;\n  }\n  input{\n  font-family:verdana !important;\n  }\n</style><div id=\"sites\" class=\"page-layout carded fullwidth scrollable\" layout=\"column\" flex ms-scroll><div \nclass=\"widget-group\" flex=\"100\" layout=\"column\" layout-wrap><ms-widget flippable=\"true\"><ms-widget-front \nclass=\"white-bg md-padding\"><div><md-button ng-click=\"goBack()\"><md-icon md-font-icon=\"icon-arrow-left\" \nclass=\"md-accent\"></md-icon><span style=\"color:#298cb2\">Back</span></md-button></div><div layout=\"row\" flex=\"100\"><div \nflex=\"25\"><div layout=\"row\" layout-align=\"start center\" flex=\"95\" \nstyle=\"border-radius: 10px; background-color: #ece7e7\"><div layout=\"column\" class=\"md-padding\"><span class=\"h3\">\nCreated By : {{ticketData.createdBy}}</span> <span class=\"h3\">Last replied by : {{ticketData.lastModifiedBy}}</span>\n</div></div><form name=\"basicForm\" class=\"md-inline-form\" novalidate data-ng-class=\"{ \'disabled\': true }\"><div \nlayout=\"row\" style=\"height:20px !important\"></div><div layout=\"row\"><md-input-container flex=\"95\"><input \nng-model=\"ticketData.requestId\" type=\"text\" placeholder=\"Ticket Number\"></md-input-container></div><div layout=\"row\">\n<md-input-container flex=\"45\"><input ng-model=\"ticketData.header.firstName\" type=\"text\" \nplaceholder=\"Requester First Name\"></md-input-container><span flex=\"10\"></span><md-input-container flex=\"45\"><input \nng-model=\"ticketData.header.lastName\" type=\"text\" placeholder=\"Last Name\"></md-input-container></div><div layout=\"row\">\n<md-input-container flex=\"95\"><input ng-model=\"ticketData.header.customer\" type=\"text\" placeholder=\"Customer From\">\n</md-input-container></div><div layout=\"row\"><md-input-container flex=\"95\"><input ng-model=\"ticketData.header.product\" \ntype=\"text\" placeholder=\"Product\"></md-input-container></div><div layout=\"row\"><md-input-container flex=\"45\"><input \nng-model=\"ticketData.header.priority\" type=\"text\" placeholder=\"Priority\"></md-input-container><span flex=\"10\"></span>\n<md-input-container flex=\"45\"><input ng-model=\"ticketData.header.status\" type=\"text\" placeholder=\"Status\">\n</md-input-container></div><div layout=\"row\"><md-input-container flex=\"95\"><input \nng-model=\"ticketData.header.requestType\" type=\"text\" placeholder=\"Request Type\"></md-input-container></div></form>\n</div><md-divider></md-divider><div flex=\"75\"><div layout=\"row\" flex=\"100\" class=\"md-padding\"><div flex=\"10\" \nlayout=\"column\" layout-align=\"center center\"><md-icon md-font-icon=\"icon-email\" class=\"s-128\"></md-icon></div><div \nflex=\"90\" layout=\"column\"><span class=\"h1\">{{ticketData.header.subject}}</span><div layout=\"row\"><span class=\"h3\">\n{{ticketData.header.firstName}} {{ticketData.header.lastName}} </span><span flex=\"5\"></span><div layout=\"column\" \nlayout-align=\"center center\">{{ticketData.createdDate.substr(0,10)}}</div></div></div></div><md-divider></md-divider>\n<div layout=\"row\" flex=\"100\" class=\"md-padding\"><div flex=\"10\" layout=\"column\" layout-align=\"start start\"><img \nng-src=\"assets\\images\\avatars/Nora.jpg\" class=\"md-avatar\" \nstyle=\"border-radius:50% !important; width: 50%;; height:auto\"></div><div flex=\"90\" layout=\"column\"><md-content>\n<md-tabs md-dynamic-height md-border-bottom><md-tab label=\"Reply\"><md-content class=\"md-padding\" flex=\"100\">\n<md-input-container md-no-float style=\"border:1px solid #cccccc; border-radius:5px;width: 100% !important\"><textarea \nng-model=\"ticket.description\" placeholder=\"Description\" rows=\"6\"></textarea></md-input-container></md-content></md-tab>\n</md-tabs><div layout=\"row\" layout-align=\"end center\"><md-button class=\"md-icon-button\" ng-click=\"sendReply(ticket)\">\n<md-tooltip md-direction=\"top\">Send</md-tooltip><md-icon md-font-icon=\"icon-send\"></md-icon></md-button></div>\n</md-content></div></div><md-divider></md-divider><div ng-repeat=\"log in ticketData.logs | orderBy:\'+\':true\" \nclass=\"md-padding\"><div layout=\"row\"><div flex=\"10\" layout=\"column\" layout-align=\"start start\"><img \nng-src=\"assets\\images\\avatars/Nora.jpg\" class=\"md-avatar\" \nstyle=\"border-radius:50% !important; width: 50%;; height:auto\"></div><div flex=\"90\"><div layout=\"row\"><span class=\"h3\">\n<b>{{log.actualUser}}</b></span> <span flex=\"5\"></span> <span>\n{{log.endDate.substr(6,2)}}-{{log.endDate.substr(4,2)}}-{{log.endDate.substr(0,4)}}</span></div><div layout=\"row\" \nclass=\"md-padding\"><p style=\"font-family:verdana !important\">{{log.comments}}</p></div></div></div><md-divider>\n</md-divider></div></div></div></ms-widget-front></ms-widget></div></div>");
$templateCache.put("app/main/TicketManagement/tickets.html","<div class=\"page-layout simple tabbed mh-0\" layout=\"column\"><div class=\"content parent-tabs\"><md-tabs class=\"mh-0\">\n<md-tab label=\"Inbox\" ui-sref=\"app.mycontent_inbox\"></md-tab><md-tab label=\"Outbox\" ui-sref=\"app.mycontent_outbox\">\n</md-tab><md-tab label=\"Tickets\" ui-sref=\"app.ticketsList\" md-active=\"true\"></md-tab></md-tabs></div></div><div \nid=\"sites\" class=\"page-layout carded fullwidth scrollable\" layout=\"column\" flex ms-scroll md-dynamic-height><div \nclass=\"widget-group\" flex=\"100\" layout=\"column\" layout-wrap><ms-widget flippable=\"true\"><ms-widget-front \nclass=\"white-bg md-padding\"><table class=\"dataTable row-border hover table-border\" datatable=\"ng\" \ndt-options=\"tktCtrl.dtOptions\"><thead><tr><th style=\"font-family:verdana\">Ticket No</th><th \nstyle=\"font-family:verdana\">Requester</th><th style=\"font-family:verdana\">Customer</th><th style=\"font-family:verdana\">\nProduct</th><th style=\"font-family:verdana\">Subject</th><th style=\"font-family:verdana\">Request Type</th><th \nstyle=\"font-family:verdana\">Priority</th><th style=\"font-family:verdana\">Status</th><th style=\"font-family:verdana\">\nRequested On</th></tr></thead><tbody><tr ng-repeat=\"ticket in allTickets | filter:{requestType:\'TICKET\'}\" class=\"c-p\" \nng-click=\"selectTicket(ticket)\"><td style=\"font-family:verdana;color:#0d88c3\">{{ticket.requestId | uppercase}}</td><td \nstyle=\"font-family:verdana\">{{ticket.header.firstName}} {{ticket.header.lastName}}</td><td style=\"color: green\">\n{{ticket.header.customer | uppercase}}</td><td style=\"font-family:verdana\">{{ticket.header.product}}</td><td \nstyle=\"font-family:verdana\"><b>{{ticket.header.subject}}</b></td><td style=\"font-family:verdana\">\n{{ticket.header.requestType}}</td><td style=\"font-family:verdana\"><div \nng-if=\"ticket.Priority === \'Urgent\' || ticket.Priority === \'High\'\" style=\"color:red\"><b>{{ticket.header.priority}}</b>\n</div><div ng-if=\"ticket.Priority != \'Urgent\' && ticket.Priority != \'High\'\">{{ticket.header.priority}}</div></td><td \nstyle=\"font-family:verdana\">{{ticket.header.status}}</td><td>{{ticket.createdDate.substr(0,10)}}</td></tr></tbody>\n</table></ms-widget-front></ms-widget></div></div>");
$templateCache.put("app/main/coromandel_inbox/c_priceprocess.html","");
$templateCache.put("app/main/login/login.html","<script src=\"https://cdnjs.cloudflare.com/ajax/libs/crypto-js/4.1.1/crypto-js.min.js\"></script><div id=\"login\" \nclass=\"bg no-padding scrollable\" ng-controller=\"LoginController as vm\" layout=\"column\" ms-scroll \nstyle=\"height:100% !important\"><div id=\"login-form-wrapper\" layout=\"column\" layout-align=\"end end\" class=\"no-padding\" \nng-if=\"!forgotPasswordPage\"><div id=\"login-form\" class=\"md-whiteframe-8dp\" style=\"margin-right:2%; margin-top:3%\"><div \nlayout=\"row\" layout-align=\"center center\"><span><img id=\"logoimage\"></span></div><div class=\"title\">\nLog in to your account</div><form name=\"vm.loginForm\" novalidate ng-submit=\"vm.loginForm.$valid && vm.login(login)\">\n<span class=\"md-body-2\" ng-style=\"{color:\'red\'}\" layout=\"row\" layout-align=\"center center\">{{ErrorMsg}}</span>\n<md-input-container class=\"md-block\"><input type=\"{{loginId}}\" name=\"userId\" ng-model=\"login.userid\" \nplaceholder=\"User Id\" required autocomplete=\"off\" ng-pattern=\"/^[a-zA-Z0-9 ._@]*$/\"><div \nng-messages=\"vm.loginForm.userId.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>\nUserId field is required</span></div><div ng-message=\"pattern\"><span>User Id has invalid characters</span></div></div>\n</md-input-container><md-input-container class=\"md-block\"><input type=\"password\" name=\"password\" \nng-model=\"login.password\" placeholder=\"Password\" autocomplete=\"new-password\" required><div \nng-messages=\"vm.loginForm.password.$error\" role=\"alert\"><div ng-message=\"required\"><span>Password field is required\n</span></div></div></md-input-container><div class=\"remember-forgot-password\" layout=\"row\" layout-sm=\"column\" \nlayout-align=\"space-between center\"><md-checkbox class=\"remember-me\" ng-model=\"login.remember\" \naria-label=\"Remember Me\"><span>Remember Me</span></md-checkbox><a class=\"forgot-password md-accent-color c-p\" \nng-click=\"forgotPassword()\" style=\"color:rgb(0, 102, 255) !important\">Forgot Password?</a></div><md-button \ntype=\"submit\" ng-if=\"loginButton\" role=\"loginForm\" class=\"md-raised md-accent submit-button\" aria-label=\"LOG IN\" \nng-disabled=\"notChromeBrowser || !vm.loginForm.$valid\">LOG IN</md-button></form><form name=\"loginwithgoogle\" \naction=\"https://dev-spay.smartdocsnow.com/payables-server/signin/google\" method=\"POST\" class=\"ng-pristine ng-valid\" \nstyle=\"text-align: center\" ng-if=\"googleLogin\"><md-button class=\"md-raised google\" type=\"submit\" ng-if=\"loginButton\">\n<div layout=\"row\" layout-align=\"center center\"><span><md-icon md-font-icon=\"icon-google-plus\" class=\"s16\"></md-icon>\n<span>Log in with Google</span></span></div></md-button><input name=\"scope\" type=\"hidden\" \nvalue=\"https://www.googleapis.com/auth/userinfo.profile https://www.googleapis.com/auth/userinfo.email\"> <input \nname=\"_csrf\" type=\"hidden\" value=\"\"></form></div></div><div id=\"forgotpassword\" class=\"flex-scrollable\" \nlayout=\"column\" ms-scroll style=\"background:none\" ng-if=\"forgotPasswordPage\"><div id=\"forgot-password-form-wrapper\" \nlayout=\"column\" layout-align=\"center center\"><div id=\"forgot-password-form\" class=\"md-whiteframe-8dp\"><div \nclass=\"title\">Recover your password</div><span class=\"md-body-2\" ng-if=\"ErrorMsg\" ng-style=\"{color:\'red\'}\" \nlayout=\"row\" layout-align=\"center center\">{{ErrorMsg}}</span><form name=\"vm.forgotPasswordForm\" novalidate \nng-submit=\"\"><md-input-container class=\"md-block\"><input type=\"email\" name=\"email\" ng-model=\"user.email\" \nplaceholder=\"Email\" required><div ng-messages=\"vm.forgotPasswordForm.email.$error\" role=\"alert\" multiple=\"multiple\">\n<div ng-message=\"required\"><span>Email field is required</span></div><div ng-message=\"email\"><span>\nEmail must be a valid e-mail address</span></div></div></md-input-container><md-button \nclass=\"md-raised md-accent submit-button\" type=\"submit\" ng-disabled=\"!user.email\" ng-click=\"resetPassword(user.email)\" \naria-label=\"SEND RESET LINK\">SEND RESET LINK<div class=\"md-ripple-container\"></div></md-button></form><div \nclass=\"login\" layout=\"row\" layout-align=\"center center\"><a ng-click=\"goToLoginPage()\" \nstyle=\"color:rgb(0, 102, 255) !important\" class=\"c-p\">Go back to login</a></div></div></div></div></div>");
$templateCache.put("app/main/profile/edit.profile.dialog.html","<md-dialog aria-label=\"Update user\" flex=\"50\"><style>\n.btn-update{\n     min-width: 120px;\n    background-color: #84bf48;\n    box-shadow: 0 4px 0 #6a9d37;\n    font-size: 12px;\n    margin-right: 10px;\n    padding: 10px 15px 10px 15px;\n    padding:0px;\n    }\n    .btn-cancel{\n        min-width: 120px;\n    background-color: #b9bec6;\n    box-shadow: 0 4px 0 #9da4af;\n    font-size: 12px;\n    padding: 10px 15px 10px 15px;\n    padding:0px;\n    }\n    .dialog-header{\n      \n    padding-bottom: 4px;\n    padding-top: 0px;\n    margin-bottom: 8px;}\n    .divider-width \n    {    \n        width: 107% !important;\n   		 margin-left: -4% !important;\n    }\n</style><form name=\"userUpdateForm\" novalidate layout=\"column\"><md-dialog-content layout=\"column\"><div \nclass=\"dialog-header details\" style=\"margin-top: -20px\">Primary Details</div><md-divider class=\"divider-width\">\n</md-divider><div layout=\"row\"><md-input-container flex=\"40\"><label class=\"subtext\">First Name</label><input \ntype=\"text\" ng-model=\"currentUser.firstName\" required></md-input-container><span flex=\"20\"></span><md-input-container \nflex=\"40\"><label class=\"subtext\">Middle Name</label><input type=\"text\" ng-model=\"user\"></md-input-container></div><div \nlayout=\"row\"><md-input-container flex=\"40\"><label class=\"subtext\">Last Name</label><input type=\"text\" \nng-model=\"currentUser.lastName\" required></md-input-container><span flex=\"20\"></span><md-input-container flex=\"40\">\n<label class=\"subtext\">Authority</label><md-select ng-model=\"currentUser.authorities\" multiple=\"multiple\"><md-option \nng-value=\"authority\" disabled=\"true\" ng-repeat=\"authority in roles\">\n{{authority.replace(\"ROLE_USER\",\"User\").replace(\"ROLE_ADMIN\",\"Admin\")}}</md-option></md-select></md-input-container>\n</div><div layout=\"row\"><md-input-container flex=\"40\"><label class=\"subtext\">TimeZone</label><md-select \nng-model=\"currentUser.timeZone\"><md-option ng-value=\"timeZone\" ng-repeat=\"timeZone in timeZones\">{{timeZone}}\n</md-option></md-select></md-input-container><span flex=\"20\"></span><md-input-container flex=\"40\"><label \nclass=\"subtext\">Activate User</label><md-select ng-model=\"currentUser.activated\"><md-option ng-value=\"activated\" \ndisabled=\"true\" ng-repeat=\"activated in status\">{{activated.replace(\"true\",\"True\").replace(\"false\",\"False\")}}\n</md-option></md-select></md-input-container></div><div layout=\"row\"><md-input-container flex=\"40\"><label \nclass=\"subtext\">Currency</label><md-select ng-model=\"currentUser.currency\"><md-option ng-value=\"eachCurrency\" \nng-repeat=\"eachCurrency in currency\">{{eachCurrency}}</md-option></md-select></md-input-container><span flex=\"20\">\n</span><md-input-container flex=\"40\"><label class=\"subtext\">Decimal Seperator</label><md-select \nng-model=\"currentUser.decimalSeparator\"><md-option ng-value=\"currencyFormat\" \nng-repeat=\"currencyFormat in currencyFormats\">{{currencyFormat}}</md-option></md-select></md-input-container></div><div\n layout=\"row\"><md-input-container flex=\"40\"><label class=\"subtext\">Language</label><md-select \nng-model=\"currentUser.language\"><md-option ng-value=\"language\" ng-repeat=\"language in languages\">{{language}}\n</md-option></md-select></md-input-container><span flex=\"20\"></span><md-input-container flex=\"40\"><label \nclass=\"subtext\">Date Format</label><md-select ng-model=\"currentUser.dateFormat\"><md-option ng-value=\"dateFormat\" \nng-repeat=\"dateFormat in dateFormats\">{{dateFormat}}</md-option></md-select></md-input-container></div>\n</md-dialog-content><md-dialog-actions class=\"md-padding\" layout=\"row\" layout-align=\"end end\"><md-button \nclass=\"button btn-update\" ng-click=\"updateUserProfile(currentUser)\">Update</md-button><md-button \nclass=\"button btn-cancel\" ng-click=\"cancel()\">cancel</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/profile/myprofile.html","<style>.rowheight-job\n{\nmargin-top: -5%;\n}\n.icon{\nline-height: 1.5;\n\n}</style><div class=\"widget-group\" flex \nlayout=\"column\" layout-wrap ng-init=\"UserDetails()\"><ms-widget flippable=\"true\"><ms-widget-front class=\"white-bg\"><div \nlayout=\"row\" flex=\"100\"><div flex=\"15\" style=\"background-color: #6f8ab5\" layout=\"row\" layout-align=\"center center\"><i \nclass=\"icon icon-account s128\"></i></div><div flex=\"85\"><div layout=\"column\"><div style=\"margin-left: 17px\"><h1>\n{{currentLogedInUser.firstName}} {{currentLogedInUser.lastName}}</h1></div><div layout=\"row\" \nlayout-align=\"start start\"><div layout=\"row\" class=\"md-padding\"><md-icon class=\"icon-email icon\"></md-icon><span>\n{{currentLogedInUser.email}}</span></div></div></div><md-divider></md-divider><md-content \nstyle=\"background-color: #dee7f4\"><div layout=\"row\" layout-align=\"start center\"><md-button ng-click=\"loadAbout()\" \nstyle=\"min-width: 20px !important\"><span class=\"md-padding\">About</span></md-button><md-button \nng-click=\"loadSubstitution()\" style=\"min-width: 20px !important\"><span class=\"md-padding\">Substitution</span>\n</md-button></div></md-content></div></div></ms-widget-front></ms-widget><div><div ui-view=\"about\" \nng-show=\"loadPage==\'about\'\"></div><div ui-view=\"substitution\" ng-show=\"loadPage==\'substitution\'\"></div></div></div>");
$templateCache.put("app/main/profile/profile.html","<div class=\"md-padding\" layout-align=\"start start\"><div class=\"heading3\">Presonal Information</div><div layout=\"row\" \nflex><div class=\"md-padding\" flex=\"50\" style=\"margin-top: 0\"><ms-widget flippable=\"true\"><ms-widget-front \nclass=\"white-bg\" flex><div class=\"md-padding\" layout=\"row\" layout-align=\"space-between center\"><span class=\"details\">\nPrimary Details </span><span class=\"edit c-p\" ng-click=\"editprofile($event,currentLogedInUser)\">EDIT</span></div>\n<md-divider></md-divider><div layout=\"row\" layout-align=\"start start\"><div layout=\"column\" class=\"md-padding\"><span \nclass=\"subtext\">First Name</span> <span>{{currentLogedInUser.firstName}}</span></div><span flex=\"25\"></span><div \nlayout=\"column\" class=\"md-padding\"><span class=\"subtext\">Middle Name</span> <span>{{}}</span></div></div><div \nlayout=\"row\" layout-align=\"start start\"><div layout=\"column\" class=\"md-padding\"><span class=\"subtext\">Last Name</span> \n<span>{{currentLogedInUser.lastName}}</span></div><span flex=\"25\"></span><div layout=\"column\" class=\"md-padding\"><span \nclass=\"subtext\">Display Name</span> <span>{{currentLogedInUser.firstName}} {{currentLogedInUser.lastName}}</span></div>\n</div><div layout=\"row\" layout-align=\"start start\"><div layout=\"column\" class=\"md-padding\"><span class=\"subtext\">\nMARITAL STATUS</span> <span>Single</span></div><span flex=\"20\"></span><div layout=\"column\" class=\"md-padding\"><span \nclass=\"subtext\">BLOOD GROUP</span> <span></span></div></div><div layout=\"row\" layout-align=\"start start\"><div \nlayout=\"column\" class=\"md-padding\"><span class=\"subtext\">gender</span> <span>Male</span></div><span flex=\"30\"></span>\n<div layout=\"column\" class=\"md-padding\"><span class=\"subtext\">Dob</span> <span>DD-MM-YYYY</span></div></div>\n</ms-widget-front></ms-widget></div><div class=\"md-padding\" flex=\"50\"><ms-widget flippable=\"true\"><ms-widget-front \nclass=\"white-bg\" flex><div class=\"md-padding\" layout=\"row\" layout-align=\"space-between center\"><span class=\"details\">\nContact Details </span><span class=\"edit c-p\" ng-click=\"\">EDIT</span></div><md-divider></md-divider><div \nclass=\"md-padding\">Hi there!you have not added any Contact Details summary</div></ms-widget-front></ms-widget></div>\n</div><div layout=\"row\" layout-align=\"start start\"><div class=\"md-padding\" flex=\"50\"><ms-widget flippable=\"true\">\n<ms-widget-front class=\"white-bg\" flex><div class=\"md-padding details\">Addresses</div><md-divider></md-divider><div \nclass=\"md-padding\">No data available</div></ms-widget-front></ms-widget></div><div class=\"md-padding\" flex=\"50\">\n<ms-widget flippable=\"true\"><ms-widget-front class=\"white-bg\" flex><div class=\"md-padding details\">Relations</div>\n<md-divider></md-divider><div class=\"md-padding\">No data available.</div></ms-widget-front></ms-widget></div></div>\n</div><div class=\"md-padding heading3\">Professional Information</div><div layout=\"row\" layout-align=\"start start\"><div \nclass=\"md-padding\" flex=\"50\"><ms-widget flippable=\"true\"><ms-widget-front class=\"white-bg\" flex><div \nclass=\"md-padding details\">Addresses</div><md-divider></md-divider><div class=\"md-padding\">No data available</div>\n</ms-widget-front></ms-widget></div><div class=\"md-padding\" flex=\"50\"><ms-widget flippable=\"true\"><ms-widget-front \nclass=\"white-bg\" flex><div class=\"md-padding details\">Relations</div><md-divider></md-divider><div class=\"md-padding\">\nNo data available.</div></ms-widget-front></ms-widget></div></div>");
$templateCache.put("app/main/reports/reports.html","<div class=\"page-layout simple tabbed mh-0\" layout=\"column\"><div class=\"content parent-tabs\"><md-tabs class=\"mh-0\">\n<md-tab label=\"Reports\" md-active=\"true\"></md-tab></md-tabs></div></div><div \nclass=\"page-layout carded fullwidth scrollable\" layout=\"column\" flex ms-scroll md-dynamic-height><div \nclass=\"widget-group\" flex=\"100\" layout=\"column\" layout-wrap><ms-widget flippable=\"true\"><div layout=\"row\" \nclass=\"white-bg md-padding\" layout-wrap ng-show=\"viewPage == 0\"><div \nng-repeat=\"report in allReports  | filter : searchSite\" flex=\"100\" flex-gt-xs=\"25\" flex-gt-md=\"20\"><md-card \nmd-theme=\"{{getAnotherColor($index)}}\" md-theme-watch class=\"c-p\"><md-tooltip md-direction=\"top\">{{report.label}}\n</md-tooltip><div class=\"info\" layout=\"column\" layout-align=\"space-between\" flex><div ng-click=\"goToReport(report);\">\n<div class=\"white-fg md-padding\" layout=\"row\" layout-align=\"center center\" ng-style=\"{\'height\':\'150px\'}\"><md-icon \nmd-font-icon=\"{{report.icon}}\" class=\"s64\"></md-icon></div><div layout=\"row\" layout-align=\"end end\" \nstyle=\"color:white\">{{report.visibility}} &nbsp;&nbsp;</div></div><div><md-divider></md-divider><div \nclass=\"text white-bg p-10\" style=\"text-align: center\"><label>{{report.label}}</label></div></div></div></md-card></div>\n</div><div data-ng-show=\"viewPage == 1\" align=\"center\"><div class=\"white-bg mb-15\" flex=\"55\" \nstyle=\"border:2px solid #cccccc; border-radius:5px\"><div class=\"md-padding layout-row\" layout=\"row\"><span \nclass=\"md-active c-p\" data-ng-click=\"goBack(0)\" style=\"display: inherit;color: #52b8e9\" role=\"button\"><md-icon \nmd-font-icon=\"icon-arrow-left md-active s16\" class=\"md-font icon-arrow-left md-active s16 material-icons\" \naria-hidden=\"true\"></md-icon>Go back </span><span flex=\"25\"></span> <span class=\"md-title\">\nReport : {{currentReport.label}}</span></div><div \nclass=\"ph-16 pv-10 border-bottom layout-align-space-between-center layout-row\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"h3\">DocType Specific Fields</div></div><div \nng-repeat=\"doctype in currentReport.doctypefield track by $index\" class=\"no-padding\" flex=\"70\"><md-input-container \nclass=\"md-block\" ng-if=\"doctype.type==\'String\'\"><label>{{doctype.label}}</label><input type=\"text\" name=\"id\" \nng-model=\"doctype.data.value\"></md-input-container><md-input-container class=\"md-block\" ng-if=\"doctype.type==\'Number\'\">\n<label>{{doctype.label}}</label><input ng-model=\"doctype.data.value\" type=\"number\" step=\"0.01\"></md-input-container>\n<md-input-container class=\"md-block\" ng-if=\"doctype.type==\'boolean\'\"><label>{{doctype.label}}</label><md-select \nng-model=\"doctype[$index].data.value\" placeholder=\"{{doctype.label}}\" md-on-close=\"getSelectedreport()\" \nclass=\"md-no-underline\"><md-optgroup label=\"Select\"><md-option value=\"true\">True</md-option><md-option value=\"false\">\nFalse</md-option></md-optgroup></md-select></md-input-container><div layout=\"row\"><md-datepicker class=\"mr-0\" \nng-if=\"doctype.type==\'Date\'\" ng-model=\"doctype.data.fromdate\" md-placeholder=\"From Date\"></md-datepicker><md-datepicker\n ng-if=\"doctype.type==\'Date\'\" ng-model=\"doctype.data.todate\" md-placeholder=\"To Date\"></md-datepicker></div></div>\n</div><div class=\"white-bg\" flex=\"55\" style=\"border:2px solid #cccccc; border-radius:5px\"><div \nng-if=\"!currentReport.skipSelection\" class=\"ph-16 pv-10 border-bottom layout-align-space-between-center layout-row\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">Selection Fields</div></div><span \nclass=\"padding-bottom-5\"></span><div \nng-repeat=\"report in currentReport.selectionfield | orderBy : \'sequence\' track by $index\" class=\"no-padding\" flex=\"70\">\n<md-input-container class=\"md-block\" ng-if=\"report.type==\'string\' && report.possibleValues == null\" \nclass=\"padding-bottom-0\" style=\"margin: 0\"><label>{{report.label}}</label><input type=\"text\" name=\"id\" \nng-model=\"report.data.value\"></md-input-container><md-input-container class=\"md-block\" \nng-if=\"report.possibleValues != null\" class=\"padding-bottom-0\"><label>{{report.label}}</label><md-select \nng-model=\"report.data.value\" placeholder=\"{{report.fieldname}}\"><md-option value=\"{{pv}}\" \nng-repeat=\"pv in report.possibleValues\" ng-selected=\"pv == report.defaultvalue\">{{pv}}</md-option></md-select>\n</md-input-container><md-datepicker class=\"mr-0 pr-25\" ng-if=\"report.type==\'Date\'\" ng-model=\"report.data.fromdate\" \nmd-placeholder=\"From Date\"></md-datepicker><md-datepicker class=\"pr-25\" ng-if=\"report.type==\'Date\'\" \nng-model=\"report.data.todate\" md-placeholder=\"To Date\"></md-datepicker><md-input-container class=\"md-block\" \nng-if=\"report.type==\'Number\'\" class=\"padding-bottom-0\"><label>{{report.label}}</label><input \nng-model=\"report.data.value\" type=\"number\" step=\"0.01\"></md-input-container><md-input-container class=\"md-block\" \nng-if=\"report.type==\'boolean\'\" class=\"padding-bottom-0\"><label>{{report.label}}</label><md-select \nng-model=\"report.data.value\" placeholder=\"{{report.fieldname}}\" md-on-close=\"getSelectedreport()\" \nclass=\"md-no-underline\"><md-optgroup label=\"Select\"><md-option value=\"true\">True</md-option><md-option value=\"false\">\nFalse</md-option></md-optgroup></md-select></md-input-container></div><section class=\"md-padding\" layout=\"row\" \nlayout-sm=\"column\" layout-align=\"center center\" layout-wrap><md-button class=\"md-raised md-accent\" type=\"submit\" \nng-click=\"executecriteria(doctype,currentReport.reportModule)\">Run Report</md-button></section></div></div><div \nng-show=\"viewPage == 2\" class=\"page-layout fullwidth md-padding scrollable md-padding white-bg\" layout=\"column\" flex \nms-scroll><div class=\"md-padding\" layout-gt-xs=\"row\" layout-gt-md=\"row\" layout-gt-sm=\"row\" \nid=\"panel-body contract-list-body-btns\"><a class=\"c-p\" data-ng-click=\"goBack(1)\" role=\"button\" \nstyle=\"color: #52b8e9 !important; padding: 0; height: 16px\"><span><span class=\"icon-arrow-left-bold-circle-outline\">\n</span> Back</span></a><div flex-gt-xs=\"5\" flex-gt-md=\"5\"></div><md-input-container class=\"no-margin\" \nng-repeat=\"report in currentReport.filterfield track by $index\" style=\"margin-left: 10px !important\"><label>\n{{report.fieldname}}</label><md-select ng-if=\"allFilteredDataLength > 0\" class=\"no-margin\" \nng-change=\"UpdateMode(report.fieldname, selected.selectedfilter)\" ng-model=\"selected.selectedfilter\"><md-option \nng-repeat=\"c_report in allFilteredData[report.fieldname] track by $index\" ng-value=\"c_report\">{{c_report}}</md-option>\n</md-select></md-input-container><div flex-gt-xs=\"5\" flex-gt-md=\"5\"></div><md-button ng-if=\"allFilteredDataLength > 0\" \nclass=\"btn material-btn btn-list\" ng-click=\"applyfilter()\" ng-disabled=\"!filterdlength>0\">Apply</md-button></div><div \nclass=\"page-layout fullwidth md-padding scrollable md-padding white-bg\" flex ms-scroll style=\"max-height: 630px\"><table\n class=\"dataTable row-border hover table-border\"><thead><tr class=\"table-header\"><th class=\"secondary-text\" \nng-repeat=\"outputfield in  currentReport.outputfield | orderBy : \'sequence\' track by $index\"><div class=\"table-header\">\n<span class=\"\">{{outputfield.label}}</span></div></th></tr></thead><tbody><tr \ndata-ng-repeat=\"data in allDocuments track by $index\"><td \ndata-ng-repeat=\"outputfield in currentReport.outputfield | orderBy : \'sequence\' track by $index\"><span \nng-class=\"{ \'active-link c-p\': (outputfield.fieldname == \'requestId\' || outputfield.fieldname == \'id\')}\" \ndata-ng-click=\"viewSelection(outputfield.fieldname, data)\">{{getValues(data, outputfield.fieldname)}}</span></td></tr>\n</tbody></table></div></div><div class=\"content md-padding white-bg\" ng-show=\"viewPage == 3\"><div layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"md-active c-p\" data-ng-click=\"goBack(2);\" \nstyle=\"display: inherit;color: #52b8e9\" role=\"button\"><md-icon md-font-icon=\"icon-arrow-left md-active s16\" \nclass=\"md-font icon-arrow-left md-active s16 material-icons\" aria-hidden=\"true\"></md-icon>Go back</span><div><md-button\n class=\"md-raised\" ng-click=\"previewFile($event)\" style=\"top: -10px\">DISPLAY</md-button></div></div><md-divider>\n</md-divider><md-tabs md-dynamic-height><md-tab label=\"Details\"><table class=\"table md-padding\" flex=\"100\" \nlayout=\"row\"><tr class=\"layout-row\" flex=\"100\" ng-repeat=\"(key, value) in fileDetails.attributes track by $index\"><td \nclass=\"w-100\"><b>{{key}}</b></td><td class=\"w-100\">:</td><td>{{value}}</td></tr></table></md-tab><md-tab \nlabel=\"Activity Feed\"><md-content class=\"md-padding\"><md-list><md-list-item class=\"md-2-line\" \nng-repeat=\"activity in fileDetails.activities |  orderBy:\'$index\':true\"><img ng-src=\"assets\\images\\avatars/Nora.jpg\" \nclass=\"md-avatar\"><div class=\"md-list-item-text\" layout=\"column\"><span><p ng-bind-html=\"activity.description\"></p>\n</span></div><md-divider ng-if=\"!$last\"></md-divider></md-list-item></md-list></md-content></md-tab><md-tab \nlabel=\"Versions\"><md-content class=\"md-padding\"><md-list><md-list-item class=\"md-2-line\" \nng-repeat=\"version in fileDetails.versions | orderBy:\'$index\':true\"><md-button flow-btn class=\"md-icon-button\"><md-icon\n md-font-icon=\"{{selectedFileIcon}}\" class=\"icon\"></md-icon></md-button><span flex=\"5\"></span><div \nclass=\"md-list-item-text\" layout=\"row\" layout-align=\"start start\"><div><h3><strong>Version {{version.versionNo}} \n</strong>created by <strong>{{version.createdBy}}</strong></h3><p>\nDate : {{version.createdDate.substr(0,10)|date : filedateFormat}}</p></div><div></div></div><md-divider ng-if=\"!$last\">\n</md-divider></md-list-item></md-list></md-content></md-tab><md-tab label=\"Logs\"><md-content class=\"md-padding\">\n<timeline><timeline-event ng-repeat=\"log in fileDetails.logs | orderBy:\'$index\':true\"><timeline-badge \nclass=\"{{\'info\'}}\"><i class=\"glyphicon {{\'glyphicon-check\'}}\"></i></timeline-badge><timeline-panel class=\"{{\'info\'}}\">\n<timeline-heading><div layout=\"row\" layout-align=\"end end\"><p><b>Created On</b>:&nbsp;</p><p>{{log.endDate}}</p><p>\n&nbsp;</p><p>{{log.endTime}}</p></div><div layout=\"row\" layout-align=\"start start\" style=\"color:black\"><span><b>Agent\n</b>:&nbsp;</span> <span>{{log.actualUser}}</span></div></timeline-heading><div layout=\"row\" \nlayout-align=\"start start\" style=\"color:black\"><p><b>Activity</b>:&nbsp;</p><p>{{log.activityText}}</p></div><div \nlayout=\"row\" layout-align=\"start start\" style=\"color:black;margin-top: -3% !important\"><p><b>Comment</b>:&nbsp;</p><p \nstyle=\"word-wrap: break-word\">{{log.comments}}</p></div></timeline-panel></timeline-event></timeline></md-content>\n</md-tab><md-tab label=\"Comments\"><md-content class=\"md-padding\"><md-list><md-list-item class=\"md-2-line\" \nng-repeat=\"comment in fileDetails.comments  | orderBy:\'$index\':true\"><div class=\"md-list-item-text\" layout=\"row\" \nlayout-align=\"start start\"><div><ui-sref ng-click=\"showComment($event,comment)\" class=\"underline-on-hover c-p\">\n{{comment.name}}</ui-sref><p>\nCreatedBy: {{comment.createdBy}}, CreatedOn:{{comment.createdDate.substr(0,10)|date : dateFormat}}</p></div></div>\n<md-divider ng-if=\"!$last\"></md-divider></md-list-item></md-list></md-content></md-tab></md-tabs></div><div \nclass=\"content md-padding white-bg\" ng-show=\"viewPage == 4\"><div class=\"md-padding\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"md-active c-p\" data-ng-click=\"goBack(2);\" \nstyle=\"display: inherit;color: #52b8e9\" role=\"button\"><md-icon md-font-icon=\"icon-arrow-left md-active s16\" \nclass=\"md-font icon-arrow-left md-active s16 material-icons\" aria-hidden=\"true\"></md-icon>Go back</span></div>\n<md-divider></md-divider><md-tabs md-dynamic-height><md-tab label=\"Main\"><md-content class=\"md-padding scrollable\" \nms-scroll flex=\"100\"><div layout=\"row\" layout-align=\"center center\" class=\"md-padding\"><div flex=\"100\"><form \nname=\"headerForm\" class=\"md-inline-form\" novalidate><fieldset ng-disabled=\"requestDetails.dataChange == \'D\'\"><div \nng-bind-html=\"currentFormHeader\" compile-template class=\"scrollable\" ms-scroll></div></fieldset></form></div></div>\n</md-content></md-tab><md-tab label=\"Details\"><md-content class=\"md-padding scrollable\" ms-scroll><div layout=\"row\" \nlayout-align=\"center center\"><div flex=\"100\"><form name=\"headerForm\" class=\"md-inline-form\" novalidate><fieldset \nng-disabled=\"requestDetails.dataChange == \'D\'\" style=\"border: 1px solid #cccccc\"><div id=\"inbox-details\" \nng-bind-html=\"currentFormLineitem\" compile-template></div></fieldset></form></div></div></md-content></md-tab><md-tab \nlabel=\"Logs\"><div layout=\"column\" layout-align=\"center center\"><md-content class=\"md-padding\" flex=\"60\"><md-content \nflex ng-style=\"{\'border\': \'1px solid #cccccc\'}\"><table class=\"simple\" ms-responsive-table><thead><tr><th>Activity</th>\n<th>Current Agent</th><th>Actual User</th><th>Activity Text</th><th>Comments</th></tr></thead><tbody><tr \ndata-ng-repeat=\"log in requestDetails.logs track by $index\"><td>{{log.activity}}</td><td>{{log.currAgent}}</td><td>\n{{log.actualUser}}</td><td>{{log.activityText}}</td><td>{{log.comments}}</td></tr></tbody></table></md-content>\n</md-content></div></md-tab><md-tab label=\"Attachments\"><div><md-content class=\"md-padding\" \nng-style=\"{\'border\': \'1px solid #cccccc\'}\"><table class=\"simple list-view\" class=\"md-padding\"><thead><tr><th></th><th>\nName</th><th>Owner</th><th>Size</th><th>Type</th><th>CreateDate</th></tr></thead><tbody><tr \nng-repeat=\"attachment in requestDetails.attachments\"><td class=\"file-icon\"><md-icon \nmd-font-icon=\"{{getDummyFileIcon($index)}}\" class=\"icon c-p\" \nng-click=\"preview($event,attachment,requestDetails.requestId)\"></md-icon></td><td \nng-click=\"download(attachment,requestDetails.requestId)\" class=\"c-p\">{{attachment.fileName}}</td><td>\n{{attachment.creator}}</td><td><span ng-switch=\"file.size > 1024*1024\"><span ng-switch-when=\"true\">\n{{attachment.fileSize / 1024 / 1024 | number:2}} MB</span> <span ng-switch-default>\n{{attachment.fileSize / 1024 | number:2}} kB</span></span></td><td>{{attachment.mimeType}}</td><td>\n{{attachment.createDate}}</td></tr></tbody></table></md-content></div><form novalidate><div layout=\"column\" \nlayout-align=\"center center\" flex=\"100\" class=\"md-padding\"><div><div><input class=\"ng-hide\" id=\"attachmentUpload\" \nname=\"attachmentUpload\" type=\"file\" multiple=\"multiple\" \nonchange=\"angular.element(this).scope().setAttachmentFile(this)\"></div></div><div flex=\"10\"></div><div \nng-repeat=\"file in attachmentfiles.slice(0)\" layout=\"row\" layout-align=\"center center\"><span class=\"md-warn\">\n{{file.webkitRelativePath || file.name}}</span> ( <span ng-switch=\"file.size > 1024*1024\"><span ng-switch-when=\"true\">\n{{file.size / 1024 / 1024 | number:2}} MB</span> <span ng-switch-default>{{file.size / 1024 | number:2}} kB</span> \n</span>)</div></div></form></md-tab></md-tabs></div><ms-widget-front class=\"white-bg h-150\" \ndata-ng-if=\"workflowList.length <= 0\"><div class=\"content-container text-center\"><div \nclass=\"alert alert-info mv-10 mh-10\"><p>No data available</p></div></div></ms-widget-front></ms-widget></div></div>");
$templateCache.put("app/main/settings/settings.html","<div class=\"widget-group\" layout=\"column\" flex=\"100\" layout-wrap><ms-widget flippable=\"true\" layout=\"column\">\n<ms-widget-front class=\"white-bg\"><div ng-cloak><md-content><md-tabs md-dynamic-height md-border-bottom><md-tab \nlabel=\"Account Settings\"><md-content class=\"md-padding\"><h1>Password Policy</h1><md-divider></md-divider><h3>\n<md-radio-group class=\"md-primary\"><md-radio-button value=\"a\">\nFirst character must be a letter, it must contain at least 4 characters and no more than 15 characters and no characters other than letters, numbers and the underscore may be used\n</md-radio-button><md-radio-button value=\"b\">\nPassword must be between 4 and 8 digits long and include at least one numeric digit.</md-radio-button><md-radio-button \nvalue=\"c\">\nPassword must be at least 4 characters, no more than 8 characters, and must include at least one upper case letter, one lower case letter, and one numeric digit.\n</md-radio-button><md-radio-button value=\"d\">\nMatches any string between 4 and 8 characters in length. Limits the length of a string.</md-radio-button>\n<md-radio-button value=\"s\">\nRequires one lower case letter, one upper case letter, one digit, 6-13 length, and no spaces.</md-radio-button>\n</md-radio-group></h3></md-content></md-tab><md-tab label=\"Technical Settings\"><md-content class=\"md-padding\">\n</md-content></md-tab><md-tab label=\"Help Settings\"><md-content class=\"md-padding\"></md-content></md-tab></md-tabs>\n</md-content></div></ms-widget-front></ms-widget></div>");
$templateCache.put("app/main/sharedwithme/editFiledialog.html","<md-dialog><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2>\nEdit {{currentFile.type}} : {{currentFile.name}}</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"cancel()\"><md-icon md-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><form name=\"doclibrary\" \nnovalidate layout=\"column\"><div layout=\"row\" layout-align=\"start center\"><div flex=\"20\" layout=\"column\" \nlayout-align=\"center end\"><span class=\"h3\"><b>Rename</b></span></div><span flex=\"10\"></span><div flex=\"60\" \nlayout=\"column\" layout-align=\"center start\"><md-input-container flex=\"45\" class=\"md-block\" layout=\"column\" \nlayout-align=\"space-around start\"><input type=\"text\" name=\"editname\" ng-model=\"currentFile.name\"></md-input-container>\n</div></div></form></md-dialog-content><md-dialog-actions layout=\"row\"><span flex></span><md-button \nng-click=\"cancel()\">Cancel</md-button><md-button ng-click=\"updateFile(currentFile)\">Save</md-button>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/sharedwithme/previewFiles.html","<md-dialog style=\"height: 100%; width: 100%\"><md-dialog-content class=\"no-padding\"><iframe id=\"iframe\" \nsrc=\"{{fileURL}}\" name=\"contentframe\" frameborder=\"0\" \nstyle=\"width: 100%; height: 100%; position: absolute; z-index: 999\"></iframe></md-dialog-content></md-dialog>");
$templateCache.put("app/main/sharedwithme/sharedUsersDialog.html","<md-dialog ng-cloak flex=\"50\"><md-toolbar layout=\"row\" class=\"md-accent\"><div class=\"md-toolbar-tools\"><span>\nSharing : {{selectedFileName}}</span> <span flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content layout=\"column\" layout-align=\"center center\"><div flex=\"55\" \nclass=\"md-padding\"><md-content flex ng-style=\"{\'border\': \'1px solid #cccccc\'}\" class=\"scrollable\" ms-scroll \nlayout=\"row\" layout-wrap><div ng-switch=\"(allSharedUsers).length\"><div ng-switch-when=\"0\" layout=\"row\" \nlayout-align=\"center center\"><p class=\"md-padding md-subhead md-primary-fg\">{{\'Not shared yet...\' | uppercase}}</p>\n</div><div ng-switch-default ng-style=\"{\'height\':\'190px\'}\"><table class=\"simple list-view\"><thead><tr><th>NAME</th><th>\nEMAIL</th><th>PERMISSION</th><th>ACTION</th></tr></thead><tbody><tr ng-repeat=\"user in allSharedUsers \" \nng-click=\"null\"><td>{{user.firstName}} {{user.lastName}}</td><td>{{user.email}}</td><td><li \nng-repeat=\"st in user.status\">{{st}}</li></td><td><md-button class=\"md-secondary md-icon-button\" \nng-click=\"removeSharing(user, $index)\"><md-tooltip md-direction=\"top\">Delete</md-tooltip><md-icon><i \nclass=\"icon icon-delete s30\"></i></md-icon></md-button></td></tr></tbody></table></div></div></md-content></div><div \nclass=\"scrollable md-padding\" ms-scroll><div layout=\"row\" class=\"md-padding\"><md-input-container class=\"md-block\" \nflex=\"70\"><input type=\"text\" name=\"name\" ng-model=\"searchKeyword\" placeholder=\"Search User\" required>\n</md-input-container><div layout=\"column\" layout-align=\"center center\"><md-button flow-btn class=\"md-accent md-raised\" \nng-click=\" searchUsers(searchKeyword)\">Search</md-button></div></div><div ng-show=\"tableVisibility\"><table><thead><tr>\n<th class=\"secondary-text md-padding\"><div class=\"table-header\"><span class=\"column-title\">NAME</span></div></th><th \nclass=\"secondary-text md-padding\"><div class=\"table-header\"><span class=\"column-title\">EMAIL</span></div></th></tr>\n</thead><tbody><tr ng-repeat=\"member in searchedUsers\"><td class=\"md-padding\">{{member.firstName}} {{member.lastName}}\n</td><td class=\"md-padding\">{{member.email}}</td><td layout=\"row\" layout-align=\"center center\"><md-input-container \nclass=\"md-block\"><md-select ng-model=\"status\" multiple=\"multiple\"><md-option ng-value=\"option\" \nng-repeat=\"option in Options\">{{option}}</md-option></md-select></md-input-container><md-button \nclass=\"md-accent md-raised\" ng-click=\"shareFile(member,status) \">ADD</md-button></td></tr></tbody></table></div></div>\n</md-dialog-content><md-dialog-actions layout=\"row\"><span flex></span><md-button ng-click=\"cancel(member)\">Cancel\n</md-button><md-button ng-click=\"updateFileSharing()\" md-autofocus>Ok</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/sharedwithme/sharedwithme.html","<style>\n.selected {\n        background-color: rgb(232, 233, 237) !important;\n    }\n    \n    .uf {\n        background-color: #fb8c00 !important;\n    }\n</style><div class=\"widget-group\" flex=\"100\" layout=\"column\" layout-wrap data-ng-init=\"sharedCtrl.getSharedfiles();\">\n<ms-widget><ms-widget-front class=\"white-bg\"><div id=\"docLibrary\" class=\"page-layout simple right-sidenav\" \nlayout=\"row\"><div flex=\"80\"><table class=\"simple\"><thead><tr><th><a href=\"#\" \nng-click=\"orderByField=\'name\'; reverseSort = !reverseSort\" style=\"color: #626262 !important\">Name<span \nng-show=\"orderByField == \'name\'\"><span ng-show=\"!reverseSort\"><md-icon md-font-icon=\"icon-keyboard-up\" class=\"icon\">\n</md-icon></span><span ng-show=\"reverseSort\"><md-icon md-font-icon=\"icon-keyboard-down\" class=\"icon\"></md-icon></span>\n</span></a></th><th hide-xs><a href=\"#\" ng-click=\"orderByField=\'createdBy\'; reverseSort = !reverseSort\" \nstyle=\"color: #626262 !important\">Owner<span ng-show=\"orderByField == \'createdBy\'\"><span ng-show=\"!reverseSort\">\n<md-icon md-font-icon=\"icon-keyboard-up\" class=\"icon\"></md-icon></span><span ng-show=\"reverseSort\"><md-icon \nmd-font-icon=\"icon-keyboard-down\" class=\"icon\"></md-icon></span></span></a></th><th hide-xs><a href=\"#\" \nng-click=\"orderByField=\'type\'; reverseSort = !reverseSort\" style=\"color: #626262 !important\">Type<span \nng-show=\"orderByField == \'type\'\"><span ng-show=\"!reverseSort\"><md-icon md-font-icon=\"icon-keyboard-up\" class=\"icon\">\n</md-icon></span><span ng-show=\"reverseSort\"><md-icon md-font-icon=\"icon-keyboard-down\" class=\"icon\"></md-icon></span>\n</span></a></th><th hide-xs><a href=\"#\" ng-click=\"orderByField=\'siteName\'; reverseSort = !reverseSort\" \nstyle=\"color: #626262 !important\">Site<span ng-show=\"orderByField == \'siteName\'\"><span ng-show=\"!reverseSort\"><md-icon \nmd-font-icon=\"icon-keyboard-up\" class=\"icon\"></md-icon></span><span ng-show=\"reverseSort\"><md-icon \nmd-font-icon=\"icon-keyboard-down\" class=\"icon\"></md-icon></span></span></a></th><th hide-xs><a href=\"#\" \nng-click=\"orderByField=\'size\'; reverseSort = !reverseSort\" style=\"color: #626262 !important\">Size<span \nng-show=\"orderByField == \'size\'\"><span ng-show=\"!reverseSort\"><md-icon md-font-icon=\"icon-keyboard-up\" class=\"icon\">\n</md-icon></span><span ng-show=\"reverseSort\"><md-icon md-font-icon=\"icon-keyboard-down\" class=\"icon\"></md-icon></span>\n</span></a></th><th hide show-gt-md><a href=\"#\" ng-click=\"orderByField=\'lastModifiedDate\'; reverseSort = !reverseSort\" \nstyle=\"color: #626262 !important\">Last Modified<span ng-show=\"orderByField == \'lastModifiedDate\'\"><span \nng-show=\"!reverseSort\"><md-icon md-font-icon=\"icon-keyboard-up\" class=\"icon\"></md-icon></span><span \nng-show=\"reverseSort\"><md-icon md-font-icon=\"icon-keyboard-down\" class=\"icon\"></md-icon></span></span></a></th></tr>\n</thead><tbody><tr class=\"c-p\" ng-repeat=\"file in sharedfiles |orderBy:orderByField:reverseSort\" \nng-click=\"sharedCtrl.selectFile(file, $index)\" ng-dblclick=\"sharedCtrl.doubleClick(file)\" \nng-class=\"{\'selected\':$index == selectedRow}\"><td><md-icon md-font-icon=\"{{sharedCtrl.fileIcon(file)}}\" class=\"icon\">\n</md-icon><span>{{file.name}}</span></td><td>{{file.createdBy}}</td><td>{{file.type}}</td><td>{{file.siteName}}</td><td\n hide-xs><span ng-show=\"file.size == \'\'\">-</span> <span ng-switch=\"file.size > 1024*1024\" \nng-hide=\"file.type ==\'folder\'\"><span ng-switch-when=\"true\">{{file.size / 1024 / 1024 | number:2}} MB</span> <span \nng-switch-default>{{file.size / 1024 | number:2}} kB</span></span></td><td>{{file.lastModifiedDate.substr(0,10)}}</td>\n</tr></tbody></table><div ng-show=\"sharedCtrl.numberOfElements == 0\" class=\"md-padding\"><span layout=\"row\" \nlayout-align=\"center center\"><h2>No files</h2></span></div><md-divider></md-divider><div layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"md-padding\"><h5>\nShowing {{(sharedCtrl.pageNumber*sharedCtrl.pageSize)+1}} - {{(sharedCtrl.pageNumber*sharedCtrl.pageSize)+sharedCtrl.pageSize}} of {{sharedCtrl.numberOfElements}} Results\n</h5></div><div layout=\"row\" layout-align=\"center center\">Page No<md-input-container class=\"md-block md-padding\" \nstyle=\"margin: 0px\"><md-select ng-model=\"pageNumber\"><md-option ng-repeat=\"pageNumber in pageNumbers\" \nng-value=\"pageNumber\" ng-click=\"sendPageNumber(pageNumber)\" value=\"sharedCtrl.pageNumber\" ng-selected=\"$first\">\n{{pageNumber+1}}</md-option></md-select></md-input-container></div><div layout=\"row\" layout-align=\"center center\"><div>\n<md-button type=\"button\" ng-click=\"sharedCtrl.previous()\" ng-disabled=\"sharedCtrl.pageNumber <= 0\">Prev</md-button>\n</div><p class=\"md-padding\">{{sharedCtrl.pageNumber+1}}/{{pageNumbers.length}} &nbsp;PAGES</p><div class=\"md-padding\">\n<md-button type=\"button\" ng-click=\"sharedCtrl.next()\" \nng-disabled=\"sharedCtrl.pageNumber == pageNumbers.length-1 || sharedCtrl.numberOfElements == 0\">Next</md-button></div>\n</div></div></div><md-divider></md-divider><div flex=\"20\" ng-hide=\"detailsVisibility\" layout=\"column\"><md-tabs \nmd-dynamic-height md-center-tabs md-border-bottom md-active><md-tab label=\"Details\"><md-content class=\"md-padding\"><div\n layout=\"column\" layout-align=\"center center\"><svg width=\"107px\" height=\"82px\" viewBox=\"0 0 107 82\" focusable=\"false\">\n<path class=\"a-s-fa-Ha-pa drive\" fill=\"#B8B8B8\" \nd=\"M0,4a4,4,0,0,1,4,-4h89a4,4,0,0,1,4,4v18.5l-23.5,40.5h-69.5a4,4,0,0,1,-4,-4ZM74.5,65l23,-39.15l1,0l7,4.1l1,1l-23,39.15ZM74,65.8l9.5,5.5l-9,4ZM97,51v8a4,4,0,0,1,-4,4h-3ZM21,63v19l23,-19Z\">\n</path></svg><p class=\"md-primary md-hue-3\">Select a file to view its details.</p></div></md-content></md-tab>\n</md-tabs></div><div flex=\"20\" layout=\"column\" ng-show=\"detailsVisibility\" class=\"scrollable\" ms-scroll><div \nlayout=\"row\" layout-align=\"center center\"><span class=\"md-title md-padding\">{{sharedCtrl.selectedFileName}}</span>\n</div><div layout=\"row\" layout-align=\"center center\"><md-button class=\"md-icon-button\" ng-click=\"UpdateFile($event)\" \ndata-ng-if=\"isViewBtn(sharedCtrl.receivedFile.permissions, \'edit\')\"><md-tooltip md-direction=\"top\">Edit</md-tooltip>\n<md-icon md-font-icon=\"icon-pencil\" style=\"color:#ffc107 ! important\"></md-icon></md-button><md-button \nclass=\"md-icon-button\" ng-click=\"downloadFile()\" \ndata-ng-if=\"isViewBtn(sharedCtrl.receivedFile.permissions, \'download\')\"><md-tooltip md-direction=\"top\">Download\n</md-tooltip><md-icon md-font-icon=\"icon-download\" style=\"color:#2ecc71 ! important\"></md-icon></md-button></div><div>\n<md-content ng-cloak><md-tabs md-dynamic-height md-center-tabs md-border-bottom><md-tab label=\"Details\"><div \nclass=\"auto-height scrollable\" ms-scroll><md-content class=\"md-padding scrollable\" ms-scroll><table \nclass=\"detailsTable1\"><tr ng-repeat=\"fileattribute in fileattributes\"><th align=\"left\">{{fileattribute.name}}</th><td>\n{{fileattribute.value}}</td></tr></table></md-content></div><div class=\"md-padding\" layout=\"row\" \nlayout-align=\"center center\" data-ng-if=\"isViewBtn(sharedCtrl.receivedFile.permissions, \'view\')\" \ndata-ng-show=\"buttonVisibility\"><md-button class=\"md-raised\" ng-click=\"buildForm(file.id)\">DISPLAY</md-button></div>\n<div class=\"md-padding\" layout=\"row\" layout-align=\"center center\" \ndata-ng-if=\"isViewBtn(sharedCtrl.receivedFile.permissions, \'view\')\" data-ng-show=\"filebuttonVisibility\"><md-button \nclass=\"md-raised\" ng-click=\"previewFileDialog($event)\">DISPLAY</md-button></div></md-tab></md-tabs></md-content></div>\n</div></div></ms-widget-front></ms-widget></div><div ng-include=\"\'/app/core/layouts/footer.html\'\"></div>");
$templateCache.put("app/main/sites/sites.html","<div class=\"page-layout simple tabbed mh-0\" layout=\"column\"><div class=\"content parent-tabs\"><md-tabs class=\"mh-0\">\n<md-tab ui-sref=\"app.sites\" md-active=\"true\">{{sitedisplayname}}</md-tab></md-tabs></div><div class=\"sitesearch\"><div>\n<span flex=\"45\" class=\"h3\"><md-input-container class=\"md-block\"><md-icon md-font-icon=\"icon-magnify\"></md-icon><input \nng-model=\"searchSite\" type=\"text\" placeholder=\"Search\"></md-input-container></span></div></div></div><div id=\"sites\" \nclass=\"page-layout carded fullwidth scrollable\" layout=\"column\" flex ms-scroll md-dynamic-height><md-button flow-btn \nclass=\"md-fab md-mini grey-700-bg md-fab-bottom-right add_btn\" aria-label=\"Create User\" ng-click=\"createSite($event)\">\n<md-icon md-font-icon=\"icon-plus\"></md-icon><md-tooltip md-direction=\"top\">Create {{sitedisplayname}}</md-tooltip>\n</md-button><div class=\"widget-group\" flex=\"100\" layout=\"column\" layout-wrap><ms-widget flippable=\"true\">\n<ms-widget-front class=\"white-bg md-padding\"><div layout=\"row\" layout-wrap><div \nng-repeat=\"site in siteCtrl.sites  | filter : searchSite\" flex=\"100\" flex-gt-xs=\"25\" flex-gt-md=\"20\"><md-card \nmd-theme=\"{{siteCtrl.getAnotherColor($index)}}\" md-theme-watch class=\"c-p\" ng-click=\"siteCtrl.enterSite(site)\">\n<md-tooltip md-direction=\"top\">{{site.title}}</md-tooltip><div class=\"info\" layout=\"column\" \nlayout-align=\"space-between\" flex><div class=\"white-fg md-padding\" layout=\"row\" layout-align=\"center center\" \nng-style=\"{\'height\':\'150px\'}\"><md-icon md-font-icon=\"{{site.icon}}\" class=\"s64\"></md-icon></div><div layout=\"row\" \nlayout-align=\"end end\" style=\"color:white\">{{site.visibility}} &nbsp;&nbsp;</div><div><md-divider></md-divider><div \nclass=\"p-8 white-bg\" layout=\"column\" layout-align=\"center center\">{{site.name}}</div></div></div></md-card></div></div>\n</ms-widget-front></ms-widget></div></div>");
$templateCache.put("app/main/social_login/social_login.html","<div>Error Page</div>");
$templateCache.put("app/main/toolbarsearch/checkInFile.html","<md-dialog><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2>\nCheckIn {{checkInFile.type}} : {{checkInFile.name}}</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"cancel()\"><md-icon md-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><form name=\"doclibrary\" \nnovalidate layout=\"column\"><div layout=\"row\"><div flex=\"45\" layout=\"column\" layout-align=\"center end\"><span class=\"h3\">\n<b>Upload File</b></span></div><span flex=\"10\"></span><div flex=\"45\" layout=\"column\" layout-align=\"center start\"><input\n class=\"ng-hide\" id=\"formUploadFile\" name=\"formUploadFile\" type=\"file\" \nonchange=\"angular.element(this).scope().setFile(this)\"><label for=\"formUploadFile\" \nclass=\"md-button md-raised md-accent\">Upload</label></div></div><div><div ng-repeat=\"file in files.slice(0)\" \nlayout=\"row\" layout-align=\"center center\"><span class=\"md-warn\">{{file.webkitRelativePath || file.name}}</span> (<span \nng-switch=\"file.size > 1024*1024\"> <span ng-switch-when=\"true\">{{file.size / 1024 / 1024 | number:2}} MB</span> <span \nng-switch-default>{{file.size / 1024 | number:2}} kB</span> </span>)</div></div></form></md-dialog-content>\n<md-dialog-actions layout=\"row\"><span flex></span><md-button ng-click=\"cancel()\">Cancel</md-button><md-button \nng-click=\"checkIn()\">Save</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/toolbarsearch/toolbarSearchPopup.html","<md-dialog flex=\"45\" ng-init=\"getAllBusinessObjects()\" style=\"height: 85% !important\"><form name=\"businessObjectForm\" \nnovalidate layout=\"column\"><md-dialog-content class=\"scrollable\" ms-scroll><div layout=\"row\" \nlayout-align=\"space-between center\" style=\"margin-bottom: 5%\"><div></div><div class=\"md-title\" layout=\"row\" \nlayout-align=\"start center\">Search</div><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div><div layout=\"row\"><p flex=\"20\">File Name</p><span flex=\"5\"></span><md-input-container \nclass=\"md-block\" flex=\"20\" style=\"margin: 0px\"><input type=\"text\" name=\"fileName\" ng-model=\"file.fileName\">\n</md-input-container><span flex=\"10\"></span><p flex=\"20\">Creator</p><span flex=\"5\"></span><md-input-container \nclass=\"md-block\" flex=\"20\" style=\"margin: 0px\"><input type=\"text\" name=\"creator\" ng-model=\"file.creator\">\n</md-input-container></div><div layout=\"row\"><p flex=\"20\">File Type</p><span flex=\"5\"></span><md-input-container \nclass=\"md-block\" flex=\"20\" style=\"margin: 0px\"><md-select ng-model=\"file.fileExtension\"><md-option \nng-repeat=\"fileExtension in fileExtensions\" ng-value=\"fileExtension\"><md-icon ng-if=\"fileExtension == \'folder\'\" \nmd-font-icon=\"icon-folder\" class=\"icon s16\"></md-icon><md-icon ng-if=\"fileExtension == \'txt\'\" \nmd-font-icon=\"icon-clipboard-text\" class=\"icon s16\"></md-icon><md-icon ng-if=\"fileExtension == \'doc\'\" \nmd-font-icon=\"icon-file-document\" class=\"icon s16\"></md-icon><md-icon ng-if=\"fileExtension == \'xl\'\" \nmd-font-icon=\"icon-file-excel\" class=\"icon s16\"></md-icon><md-icon ng-if=\"fileExtension == \'jpg\'\" \nmd-font-icon=\"icon-file-image\" class=\"icon s16\"></md-icon><md-icon ng-if=\"fileExtension == \'jpeg\'\" \nmd-font-icon=\"icon-file-image\" class=\"icon s16\"></md-icon><md-icon ng-if=\"fileExtension == \'png\'\" \nmd-font-icon=\"icon-file-image\" class=\"icon s16\"></md-icon><md-icon ng-if=\"fileExtension == \'pdf\'\" \nmd-font-icon=\"icon-file-pdf-box\" class=\"icon s16\"></md-icon><md-icon ng-if=\"fileExtension == \'html\'\" \nmd-font-icon=\"icon-language-html5\" class=\"icon s16\"></md-icon><md-icon ng-if=\"fileExtension == \'xml\'\" \nmd-font-icon=\"icon-file-xml\" class=\"icon s16\"></md-icon><md-icon ng-if=\"fileExtension == \'docx\'\" \nmd-font-icon=\"icon-file-document\" class=\"icon s16\"></md-icon><md-icon ng-if=\"fileExtension == \'json\'\" \nmd-font-icon=\"icon-file-outline\" class=\"icon s16\"></md-icon>\n{{fileExtension.replace(\"folder\",\"Folder\").replace(\"jpg\",\"JPG\").replace(\"jpeg\",\"JPEG\").replace(\"png\",\"PNG Images\").replace(\"pdf\",\"PDF Files\").replace(\"txt\",\"Text Documents\").replace(\"html\",\"HTML Documents\").replace(\"xl\",\"Spreadsheets\").replace(\"xml\",\"XML Documents\").replace(\"docx\",\"Word Documents\").replace(\"json\",\"Data\")}}\n</md-option></md-select></md-input-container></div><div layout=\"row\"><p flex=\"15\">Date</p><md-datepicker \nng-model=\"file.fromDate\" md-placeholder=\"From\"></md-datepicker><span flex=\"5\"></span><md-datepicker \nng-model=\"file.toDate\" md-placeholder=\"To\"></md-datepicker></div><div layout=\"row\"><p flex=\"20\">Date Modified</p><span \nflex=\"5\"></span><md-input-container class=\"md-block\" flex=\"20\" style=\"margin: 0px\"><md-select \nng-model=\"file.dateModified\"><md-option ng-repeat=\"dateModifiedType in dateModifiedTypes\" ng-value=\"dateModifiedType\">\n{{dateModifiedType}}</md-option></md-select></md-input-container></div><div layout=\"row\"><p flex=\"20\">Document Type</p>\n<span flex=\"5\"></span><md-input-container class=\"md-block\" flex=\"20\" style=\"margin: 0px\"><md-select \nng-model=\"file.documentType\"><md-option ng-repeat=\"documentType in alldocumentType\" ng-value=\"documentType.name\" \nng-click=\"selectBusinessObject(documentType)\">{{documentType.name}}</md-option></md-select></md-input-container><span \nflex=\"10\"></span></div><md-divider></md-divider><div ng-show=\"attributeObjects\"><div \nng-repeat=\"attributeObject in attributeObjects\"><div layout=\"row\"><p flex=\"40\">{{attributeObject.name}}</p><span \nflex=\"5\"></span><div layout=\"row\" flex=\"100\"><div ng-if=\"attributeObject.type == \'String\' \" layout=\"row\" flex=\"100\">\n<md-input-container class=\"md-block\" flex=\"40\" style=\"margin: 0px\"><input type=\"text\" name=\"from\" \nng-model=\"attributeObject.value\"></md-input-container></div><div ng-if=\"attributeObject.type == \'Date\' \" layout=\"row\" \nflex=\"100\"><md-datepicker ng-model=\"attributeObject.value\"></md-datepicker></div></div></div></div></div>\n</md-dialog-content><md-dialog-actions layout=\"row\"><md-button md-autofocus class=\"md-accent\" \nng-show=\"$scope.attributeObjects.length >5\" ng-click=\"moreObjects()\">More</md-button><span flex></span><md-button \ntype=\"button\" ng-click=\"reset(file)\">Reset</md-button><md-button type=\"submit\" class=\"md-accent md-raised\" \nng-click=\"searchFiles(hasTheWords, file, attributeObjects, siteLocation)\">Search</md-button></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/toolbarsearch/toolbarSearchResultNew.html","<style>\n.detailsTable{\n              padding: 0 7px;\n              width: 100%;\n              text-align: left;\n              tr {\n                  th, td {\n                  padding: 10px;\n                  }\n              }\n          }\n          .selected{\n            background-color: rgb(232, 233, 237) !important;\n          }\n          .selectedDate{\n            color: rgb(61, 190, 237);\n            font-weight: bold; \n          } \n          .h2{\n          color:darkblue;\n          font-family: times;\n          }\n</style><div class=\"page-layout carded fullwidth\" layout=\"column\" flex class=\"scrollable\" ms-scroll \nng-init=\"getSearchResult();getFilePermissions()\"><div class=\"widget-group\" flex=\"100\" layout=\"column\" layout-wrap>\n<ms-widget flippable=\"true\"><ms-widget-front class=\"white-bg\"><div layout=\"row\" layout-align=\"start start\" \nclass=\"md-padding\"><span flex=\"90\"></span><md-switch ng-model=\"grid\" ng-change=\"changeView()\" aria-label=\"Switch 1\">\n<span class=\"h2\">{{myView}}</span></md-switch></div><div layout=\"row\" class=\"md-padding\" ng-hide=\"grid\"><div flex=\"80\">\n<div ng-show=\" !facetView\"><table class=\"dataTable row-border hover tableHighllete simple list-view\"><thead><tr><th><a \nhref=\"#\" ng-click=\"orderByField=\'name\'; reverseSort = !reverseSort\" style=\"color: #626262 !important\">Name<span \nng-show=\"orderByField == \'name\'\"><span ng-show=\"!reverseSort\"><md-icon md-font-icon=\"icon-keyboard-up\" class=\"icon\">\n</md-icon></span><span ng-show=\"reverseSort\"><md-icon md-font-icon=\"icon-keyboard-down\" class=\"icon\"></md-icon></span>\n</span></a></th><th hide-xs><a href=\"#\" ng-click=\"orderByField=\'createdBy\'; reverseSort = !reverseSort\" \nstyle=\"color: #626262 !important\">Owner<span ng-show=\"orderByField == \'createdBy\'\"><span ng-show=\"!reverseSort\">\n<md-icon md-font-icon=\"icon-keyboard-up\" class=\"icon\"></md-icon></span><span ng-show=\"reverseSort\"><md-icon \nmd-font-icon=\"icon-keyboard-down\" class=\"icon\"></md-icon></span></span></a></th><th hide-xs><a href=\"#\" \nng-click=\"orderByField=\'size\'; reverseSort = !reverseSort\" style=\"color: #626262 !important\">Size<span \nng-show=\"orderByField == \'size\'\"><span ng-show=\"!reverseSort\"><md-icon md-font-icon=\"icon-keyboard-up\" class=\"icon\">\n</md-icon></span><span ng-show=\"reverseSort\"><md-icon md-font-icon=\"icon-keyboard-down\" class=\"icon\"></md-icon></span>\n</span></a></th><th hide show-gt-md><a href=\"#\" ng-click=\"orderByField=\'lastModifiedDate\'; reverseSort = !reverseSort\" \nstyle=\"color: #626262 !important\">Last Modified<span ng-show=\"orderByField == \'lastModifiedDate\'\"><span \nng-show=\"!reverseSort\"><md-icon md-font-icon=\"icon-keyboard-up\" class=\"icon\"></md-icon></span><span \nng-show=\"reverseSort\"><md-icon md-font-icon=\"icon-keyboard-down\" class=\"icon\"></md-icon></span></span></a></th></tr>\n</thead><tbody><tr ng-if=\" toolbarSearchCtrl.numberOfElements == 0\"><td flex=\"100\" class=\"md-padding\"><div \nlayout=\"row\" layout-align=\"center center\"><b>No Results were found.</b></div></td></tr><tr class=\"c-p\" \nng-if=\"fileResults.totalElements != 0\" ng-repeat=\"file in toolbarSearchCtrl.resultFiles\" \nng-click=\"selectFile(file, $index, $event)\" ng-class=\"{\'selected\':$index == selectedRow}\"><td flex=\"100\" \nclass=\"md-padding\">{{file.name}}</td><td><span>{{file.createdBy}}</span></td><td><div><span \nng-switch=\"file.size > 1024*1024\"><span ng-switch-when=\"true\">{{file.size / 1024 / 1024 | number:2}} MB</span> <span \nng-switch-default>{{file.size / 1024 | number:2}} kB</span></span></div></td><td><div><span>\n{{file.lastModifiedDate.substr(0,10)}}</span></div></td></tr></tbody></table><md-divider></md-divider><div \nng-if=\"fileResults.totalElements != 0\" layout=\"row\" layout-align=\"space-between center\"><div class=\"md-padding\"><h5>\nShowing {{(toolbarSearchCtrl.pageNumber*toolbarSearchCtrl.pageSize)+1}} - {{(toolbarSearchCtrl.pageNumber*toolbarSearchCtrl.pageSize)+toolbarSearchCtrl.pageSize}} of {{toolbarSearchCtrl.numberOfElements}} Results\n</h5></div><div layout=\"row\" layout-align=\"center center\">Page No<md-input-container class=\"md-block md-padding\" \nstyle=\"margin: 0px\"><md-select ng-model=\"pageNumber\"><md-option ng-repeat=\"pageNumber in pageNumbers\" \nng-value=\"pageNumber\" ng-click=\"sendPageNumber(pageNumber)\" value=\"toolbarSearchCtrl.pageNumber\">{{pageNumber+1}}\n</md-option></md-select></md-input-container></div><div layout=\"row\" layout-align=\"center center\"><div><md-button \ntype=\"button\" ng-click=\"toolbarSearchCtrl.previous()\" ng-disabled=\"toolbarSearchCtrl.pageNumber <= 0\">Prev</md-button>\n</div><p class=\"md-padding\">{{toolbarSearchCtrl.pageNumber+1}}/{{fileResults.totalPages}} &nbsp;PAGES</p><div \nclass=\"md-padding\"><md-button type=\"button\" ng-click=\"toolbarSearchCtrl.next()\" \nng-disabled=\"toolbarSearchCtrl.pageNumber == pageNumbers.length-1\">Next</md-button></div></div></div><md-divider>\n</md-divider></div><div ng-show=\" facetView\"><table class=\"dataTable row-border hover tableHighllete\"><thead><th \nclass=\"md-padding\">Total Results : {{facetResults.totalElements}}</th></thead><tbody><tr \nng-if=\"facetResults.totalElements == 0\"><td flex=\"100\" class=\"md-padding\"><div layout=\"row\" \nlayout-align=\"center center\"><b>No Results were found.</b></div></td></tr><tr class=\"c-p\" \nng-if=\"facetResults.totalElements != 0\" ng-repeat=\"file in facetResults.content\" \nng-click=\"selectFile(file, $index, $event)\" ng-class=\"{\'selected\':$index == selectedRow}\"><td flex=\"100\" \nclass=\"md-padding\"><div layout=\"column\"><div layout=\"row\" layout-align=\"space-between center\"><span class=\"h4\" \nstyle=\"color: rgb(61, 190, 237)\"><b>Document Name: {{file.name}}</b> </span><span class=\"h4\" class=\"button\" \nstyle=\"color: rgb(61, 190, 237)\" ng-click=\"toolbarSearchCtrl.searchresultsDownload(file)\"><b>Open</b></span></div><div \nlayout=\"row\" layout-align=\"space-between center\"><div><span><b>File Type: </b>{{file.fileType}}</span></div><div><span \nng-switch=\"file.size > 1024*1024\"><span ng-switch-when=\"true\"><span><b>Size: </b></span>\n{{file.size / 1024 / 1024 | number:2}} MB</span> <span ng-switch-default><span><b>Size: </b></span>\n{{file.size / 1024 | number:2}} kB</span></span></div><div><span><b>Owner: </b>{{file.createdBy}}</span></div><div>\n<span><b>Site: </b>{{file.site}}</span></div><div><span><b>Last Modified: </b>{{file.lastModifiedDate.substr(0,10)}}\n</span></div></div></div></td></tr></tbody></table><md-divider></md-divider><div \nng-if=\"facetResults.totalElements != 0\" layout=\"row\" layout-align=\"space-between center\"><div class=\"md-padding\"><h5>\nShowing {{(facetResults.number*facetResults.size)+1}} - {{(facetResults.number*facetResults.size)+facetResults.numberOfElements}} of {{facetResults.totalElements}} Results\n</h5></div><div layout=\"row\" layout-align=\"center center\">Page No<md-input-container class=\"md-block md-padding\" \nstyle=\"margin: 0px\"><md-select ng-model=\"pageNumber\"><md-option ng-repeat=\"facetPageNumber in facetPageNumbers\" \nng-value=\"facetPageNumber\" ng-click=\"facetSendPageNumber(facetPageNumber)\">{{facetPageNumber+1}}</md-option>\n</md-select></md-input-container></div><div layout=\"row\" layout-align=\"center center\"><div><md-button type=\"button\" \nng-click=\"toolbarSearchCtrl.facetPrevious()\" ng-disabled=\"toolbarSearchCtrl.pageNumber <= 0\">Prev</md-button></div><p \nclass=\"md-padding\">{{toolbarSearchCtrl.pageNumber+1}}/{{facetResults.totalPages}} &nbsp;PAGES</p><div \nclass=\"md-padding\"><md-button type=\"button\" ng-click=\"toolbarSearchCtrl.facetNext()\" \nng-disabled=\"toolbarSearchCtrl.pageNumber == facetResults.totalPages-1\">Next</md-button></div></div></div><md-divider>\n</md-divider></div></div><md-divider></md-divider><div flex=\"25\" ng-hide=\"detailsVisibility\" layout=\"column\"><md-tabs \nmd-dynamic-height md-center-tabs md-border-bottom><md-tab label=\"Details\"><md-content class=\"md-padding\"><div \nlayout=\"column\" layout-align=\"center center\"><svg width=\"107px\" height=\"82px\" viewBox=\"0 0 107 82\" focusable=\"false\">\n<path class=\"a-s-fa-Ha-pa drive\" fill=\"#B8B8B8\" \nd=\"M0,4a4,4,0,0,1,4,-4h89a4,4,0,0,1,4,4v18.5l-23.5,40.5h-69.5a4,4,0,0,1,-4,-4ZM74.5,65l23,-39.15l1,0l7,4.1l1,1l-23,39.15ZM74,65.8l9.5,5.5l-9,4ZM97,51v8a4,4,0,0,1,-4,4h-3ZM21,63v19l23,-19Z\">\n</path></svg><p class=\"md-primary md-hue-3\">Select a file or folder to view its details.</p></div></md-content>\n</md-tab><md-tab label=\"Activity\"><md-content class=\"md-padding\"><div layout=\"column\" layout-align=\"center center\"><svg\n width=\"107px\" height=\"82px\" viewBox=\"0 0 107 82\" focusable=\"false\"><path class=\"a-s-fa-Ha-pa drive\" fill=\"#B8B8B8\" \nd=\"M0,4a4,4,0,0,1,4,-4h89a4,4,0,0,1,4,4v18.5l-23.5,40.5h-69.5a4,4,0,0,1,-4,-4ZM74.5,65l23,-39.15l1,0l7,4.1l1,1l-23,39.15ZM74,65.8l9.5,5.5l-9,4ZM97,51v8a4,4,0,0,1,-4,4h-3ZM21,63v19l23,-19Z\">\n</path></svg><p class=\"md-primary md-hue-3\">Select a file or folder to view its details.</p></div></md-content>\n</md-tab></md-tabs></div><div flex=\"25\" layout=\"column\" ng-show=\"detailsVisibility\" class=\"scrollable\" ms-scroll><div \nlayout=\"row\" layout-align=\"center center\"><h1>{{fileName}}</h1></div><div layout=\"row\" layout-align=\"center center\">\n<md-button class=\"md-icon-button\" ng-if=\"toolbarSearchCtrl.receivedFile.fileType != \'json\' \" \nng-click=\"checkInFileDialog($event)\" ng-show=\"toolbarSearchCtrl.edit\"><md-tooltip md-direction=\"top\">Check in\n</md-tooltip><md-icon md-font-icon=\"icon-login\"></md-icon></md-button><md-button class=\"md-icon-button\" \nng-if=\"toolbarSearchCtrl.receivedFile.fileType != \'json\'\" ng-click=\"fileCheckout()\" ng-show=\"toolbarSearchCtrl.edit\">\n<md-tooltip md-direction=\"top\">Check out</md-tooltip><md-icon md-font-icon=\"icon-logout\"></md-icon></md-button></div>\n<div><md-content ng-cloak><md-tabs md-dynamic-height md-center-tabs md-border-bottom><md-tab label=\"Details\"><div \nclass=\"auto-height scrollable\" ms-scroll><md-content class=\"md-padding\"><table class=\"md-padding detailsTable\"><tr \nng-repeat=\"fileAttribute in fileAttributes\"><th>\n{{fileAttribute.name.charAt(0).toUpperCase()+ fileAttribute.name.slice(1)}}</th><td>{{fileAttribute.value}}</td></tr>\n</table><div layout=\"row\" layout-align=\"center center\"><div ng-repeat=\"user in allSharedUsers\" \nstyle=\"padding-left: 2%\"><md-button flow-btn class=\"md-icon-button md-fab md-mini grey-700-bg\" ng-click=\"\">\n{{user.firstName.slice(0,1).toUpperCase()}}<md-tooltip md-direction=\"top\">{{user.firstName +\" \"+ user.lastName}}\n</md-tooltip></md-button></div></div></md-content></div><div class=\"md-padding\" layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-raised\" ng-click=\"buildForm(file.id)\" \nng-if=\"toolbarSearchCtrl.receivedFile.fileType === \'json\'\" ng-show=\"toolbarSearchCtrl.viewFile\">DISPLAY</md-button>\n</div><div class=\"md-padding\" layout=\"row\" layout-align=\"center center\" ng-show=\"filebuttonVisibility\"><md-button \nclass=\"md-raised\" ng-click=\"previewFile($event)\" ng-show=\"toolbarSearchCtrl.viewFile\">Preview</md-button></div>\n<md-divider ng-show=\"versionsVisibility\"></md-divider><div layout=\"row\" layout-align=\"center center\" \nclass=\"md-padding\" ng-show=\"versionsVisibility\"><span class=\"md-body-2\">VERSIONS</span></div><md-divider \nng-show=\"versionsVisibility\"></md-divider><div class=\"auto-height scrollable\" ms-scroll><md-content><md-list>\n<md-list-item class=\"md-2-line\" ng-repeat=\"version in versions\" ng-click=\"null\"><md-button flow-btn \nclass=\"md-icon-button\"><md-icon md-font-icon=\"{{selectedFileIcon}}\" class=\"icon\"></md-icon></md-button><span flex=\"5\">\n</span><div class=\"md-list-item-text\" layout=\"column\"><h3><strong>Version {{version.versionNo}} </strong>created by \n<strong>{{version.createdBy}}</strong></h3><p>Date : {{version.createdDate.substr(0,10)}}</p></div><md-divider \nng-if=\"!$last\"></md-divider></md-list-item></md-list><div layout=\"row\" layout-align=\"start center\" \nng-show=\"versionsVisibility\" class=\"md-padding\"><md-button class=\"md-icon-button\" ng-hide=\"file.type==\'folder\'\" \nng-click=\"VersionFileDialog($event,file)\" ng-show=\"toolbarSearchCtrl.edit\"><md-tooltip md-direction=\"top\">\nAdd new version</md-tooltip><md-icon md-font-icon=\"icon-library-plus\"></md-icon></md-button></div></md-content></div>\n</md-tab><md-tab label=\"ACTIVITY\"><div class=\"auto-height-activity scrollable\" ms-scroll><md-content><md-list>\n<md-list-item class=\"md-2-line\" ng-repeat=\"activity in activities | orderBy:\'-\' \" ng-click=\"null\"><img \nng-src=\"assets\\images\\avatars/Nora.jpg\" class=\"md-avatar\"><div class=\"md-list-item-text\" layout=\"column\"><p \nng-bind-html=\"activity.description\"></p></div><md-divider ng-if=\"!$last\"></md-divider></md-list-item></md-list>\n</md-content></div></md-tab></md-tabs></md-content></div></div></div><div layout=\"column\" class=\"md-padding\" \nlayout-align=\"space-around \" ng-show=\"grid\" style=\"margin-left:5%\"><div \nng-repeat=\"file in toolbarSearchCtrl.resultFiles\" class=\"md-padding\"><span class=\"h2\" ng-click=\"previewFile($event)\">\n{{file.name}}</span><br><span><b>CreatedBy:</b>{{file.createdBy}}, <b>CreatedDate:</b>\n{{file.createdDate.substring(0,10)}}, <b>Size:</b>{{file.size}}, <b>Site:</b>{{file.siteId}}, <b>FileExtension:</b>\n{{file.fileExtension}}</span></div></div></ms-widget-front></ms-widget></div></div>");
$templateCache.put("app/main/toolbarsearch/toolbarsearch.html","<div flex layout=\"row\" layout-align=\"start center\"><label for=\"ms-search-bar-input\"><md-button \nclass=\"ms-search-bar-expander md-icon-button\" aria-label=\"Expand Search Bar\" ng-click=\"toolbarSearchCtrl.expand()\" \nng-if=\"!toolbarSearchCtrl.resultsLoading || toolbarSearchCtrl.collapsed\"><md-icon md-font-icon=\"icon-magnify\" \nclass=\"icon s24\"></md-icon></md-button><div class=\"ms-search-bar-loader\" layout=\"row\" layout-align=\"center center\" \nng-if=\"toolbarSearchCtrl.resultsLoading && !toolbarSearchCtrl.collapsed\"><md-progress-circular class=\"md-accent\" \nmd-diameter=\"32\" md-mode=\"indeterminate\"></md-progress-circular></div></label><input id=\"ms-search-bar-input\" \ntype=\"text\" placeholder=\"Search\" flex ng-model=\"toolbarSearchCtrl.query\" \nng-model-options=\"toolbarSearchCtrl.queryOptions\" ng-keydown=\"toolbarSearchCtrl.handleKeydown($event)\"><md-button \nclass=\"ms-search-bar-collapser md-icon-button\" ng-click=\"toolbarSearchCtrl.advancedSearchPopup()\"><md-icon \nmd-font-icon=\"icon-menu-down\" class=\"icon s48\"></md-icon></md-button><md-button \nclass=\"ms-search-bar-collapser md-icon-button\" ng-click=\"toolbarSearchCtrl.collapse()\" \naria-label=\"Collapse Search Bar\"><md-icon md-font-icon=\"icon-close\" class=\"icon s24\"></md-icon></md-button><div \nclass=\"ms-search-bar-results\" ng-if=\"toolbarSearchCtrl.results\" ms-scroll><div class=\"no-results\" \nng-if=\"toolbarSearchCtrl.results.length === 0\">No Results!</div><div class=\"result\" \nng-repeat=\"result in toolbarSearchCtrl.results\" ng-click=\"toolbarSearchCtrl.handleResultClick(result)\" \nng-mouseenter=\"toolbarSearchCtrl.handleMouseenter($index)\" ng-mousedown=\"toolbarSearchCtrl.absorbEvent($event)\" \nng-class=\"{\'selected\': $index == toolbarSearchCtrl.selectedResultIndex}\" md-ink-ripple><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"icon-container\" layout=\"row\" layout-align=\"center center\"><i \nng-if=\"result.icon\" class=\"icon {{result.icon}}\"></i><div ng-if=\"!result.icon\" class=\"square md-accent-bg\"></div></div>\n<div><div class=\"title\">{{result.title}}</div><div class=\"description\" ng-if=\"result.description\">\n{{result.description}}</div></div></div></div></div></div>");
$templateCache.put("app/main/toolbarsearch/toolbarsearchResult.html","<style>\n.detailsTable{\n                padding: 0 7px;\n                width: 100%;\n                text-align: left;\n                tr {\n                    th, td {\n                    padding: 10px;\n                    }\n                }\n            }\n            .selected{\n              background-color: rgb(232, 233, 237) !important;\n            }\n</style><div class=\"page-layout carded fullwidth\" layout=\"column\" flex class=\"scrollable\" ms-scroll \nng-init=\"getSearchResult()\"><div class=\"widget-group\" flex=\"100\" layout=\"column\" layout-wrap><ms-widget \nflippable=\"true\"><ms-widget-front class=\"white-bg\"><div layout=\"row\"><div flex=\"15\"><div layout=\"column\"><div \nclass=\"md-padding\" style=\"padding-bottom: 0px !important;padding-top: 0px !important\" \nng-repeat=\"facetResultPage in fileResults.facetResultPages\"><div style=\"background-color: rgb(61, 190, 237)\"><p \nclass=\"md-padding white-fg\">\n{{facetResultPage.content[0].key.name.charAt(0).toUpperCase()+ facetResultPage.content[0].key.name.slice(1);}}</p>\n</div><div class=\"md-padding\" style=\"padding-top: 0px !important; padding-bottom: 0px !important\"><div \nng-repeat=\"valueObject in facetResultPage.content\"><p ng-click=\"\">{{valueObject.value}} ({{valueObject.valueCount}} )\n</p></div></div><md-divider></md-divider></div></div></div><md-divider></md-divider><div flex=\"60\"><table \nclass=\"dataTable row-border hover tableHighllete\" datatable=\"ng\" dt-options=\"dtOptions\"><thead><th>\nTotal Results : {{fileResults.content.length}}</th></thead><tbody><tr ng-repeat=\"file in fileResults.content\" \nng-click=\"selectFile(file, $index, $event)\" ng-class=\"{\'selected\':$index == selectedRow}\"><td flex=\"100\"><div \nlayout=\"column\"><div layout=\"row\" layout-align=\"space-between center\"><span class=\"h4\" \nstyle=\"color: rgb(61, 190, 237)\"><b>Document Name: {{file.name}}</b> </span><span class=\"h4\" class=\"button\" \nstyle=\"color: rgb(61, 190, 237)\" ng-click=\"toolbarSearchCtrl.searchresultsDownload(file)\"><b>Open</b></span></div><div \nlayout=\"row\" layout-align=\"space-between center\"><div><span><b>File Type: </b>{{file.fileType}}</span></div><div><span \nng-switch=\"file.size > 1024*1024\"><span ng-switch-when=\"true\"><span><b>Size: </b></span>\n{{file.size / 1024 / 1024 | number:2}} MB</span> <span ng-switch-default><span><b>Size: </b></span>\n{{file.size / 1024 | number:2}} kB</span></span></div><div><span><b>Owner: </b>{{file.createdBy}}</span></div><div>\n<span><b>Site: </b>{{file.site}}</span></div><div><span><b>Last Modified: </b>{{file.lastModifiedDate.substr(0,10)}}\n</span></div></div><div layout=\"row\"></div></div></td></tr></tbody></table></div><md-divider></md-divider><div \nflex=\"25\" ng-hide=\"detailsVisibility\" layout=\"column\"><md-tabs md-dynamic-height md-center-tabs md-border-bottom>\n<md-tab label=\"Details\"><md-content class=\"md-padding\"><div layout=\"column\" layout-align=\"center center\"><svg \nwidth=\"107px\" height=\"82px\" viewBox=\"0 0 107 82\" focusable=\"false\"><path class=\"a-s-fa-Ha-pa drive\" fill=\"#B8B8B8\" \nd=\"M0,4a4,4,0,0,1,4,-4h89a4,4,0,0,1,4,4v18.5l-23.5,40.5h-69.5a4,4,0,0,1,-4,-4ZM74.5,65l23,-39.15l1,0l7,4.1l1,1l-23,39.15ZM74,65.8l9.5,5.5l-9,4ZM97,51v8a4,4,0,0,1,-4,4h-3ZM21,63v19l23,-19Z\">\n</path></svg><p class=\"md-primary md-hue-3\">Select a file or folder to view its details.</p></div></md-content>\n</md-tab><md-tab label=\"Activity\"><md-content class=\"md-padding\"><div layout=\"column\" layout-align=\"center center\"><svg\n width=\"107px\" height=\"82px\" viewBox=\"0 0 107 82\" focusable=\"false\"><path class=\"a-s-fa-Ha-pa drive\" fill=\"#B8B8B8\" \nd=\"M0,4a4,4,0,0,1,4,-4h89a4,4,0,0,1,4,4v18.5l-23.5,40.5h-69.5a4,4,0,0,1,-4,-4ZM74.5,65l23,-39.15l1,0l7,4.1l1,1l-23,39.15ZM74,65.8l9.5,5.5l-9,4ZM97,51v8a4,4,0,0,1,-4,4h-3ZM21,63v19l23,-19Z\">\n</path></svg><p class=\"md-primary md-hue-3\">Select a file or folder to view its details.</p></div></md-content>\n</md-tab></md-tabs></div><div flex=\"25\" layout=\"column\" ng-show=\"detailsVisibility\" class=\"scrollable\" ms-scroll><div \nlayout=\"row\" layout-align=\"center center\"><h1>{{fileName}}</h1></div><div layout=\"row\" layout-align=\"center center\">\n<md-button class=\"md-icon-button\" ng-if=\"toolbarSearchCtrl.receivedFile.fileType != \'json\' \" \nng-click=\"checkInFileDialog($event)\"><md-tooltip md-direction=\"top\">Check in</md-tooltip><md-icon \nmd-font-icon=\"icon-login\"></md-icon></md-button><md-button class=\"md-icon-button\" \nng-if=\"toolbarSearchCtrl.receivedFile.fileType != \'json\'\" ng-click=\"fileCheckout()\"><md-tooltip md-direction=\"top\">\nCheck out</md-tooltip><md-icon md-font-icon=\"icon-logout\"></md-icon></md-button></div><div><md-content ng-cloak>\n<md-tabs md-dynamic-height md-center-tabs md-border-bottom><md-tab label=\"Details\"><div class=\"auto-height scrollable\" \nms-scroll><md-content class=\"md-padding\"><table class=\"md-padding detailsTable\"><tr \nng-repeat=\"fileAttribute in fileAttributes\"><th>\n{{fileAttribute.name.charAt(0).toUpperCase()+ fileAttribute.name.slice(1)}}</th><td>{{fileAttribute.value}}</td></tr>\n</table><div layout=\"row\" layout-align=\"center center\"><div ng-repeat=\"user in allSharedUsers\" \nstyle=\"padding-left: 2%\"><md-button flow-btn class=\"md-icon-button md-fab md-mini grey-700-bg\" ng-click=\"\">\n{{user.firstName.slice(0,1).toUpperCase()}}<md-tooltip md-direction=\"top\">{{user.firstName +\" \"+ user.lastName}}\n</md-tooltip></md-button></div></div></md-content></div><div class=\"md-padding\" layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-raised\" ng-click=\"buildForm(file.id)\" \nng-if=\"toolbarSearchCtrl.receivedFile.fileType === \'json\'\">DISPLAY</md-button></div><md-divider \nng-show=\"versionsVisibility\"></md-divider><div layout=\"row\" layout-align=\"center center\" class=\"md-padding\" \nng-show=\"versionsVisibility\"><span class=\"md-body-2\">VERSIONS</span></div><md-divider ng-show=\"versionsVisibility\">\n</md-divider><div class=\"auto-height scrollable\" ms-scroll><md-content><md-list><md-list-item class=\"md-2-line\" \nng-repeat=\"version in versions\" ng-click=\"null\"><md-button flow-btn class=\"md-icon-button\"><md-icon \nmd-font-icon=\"{{selectedFileIcon}}\" class=\"icon\"></md-icon></md-button><span flex=\"5\"></span><div \nclass=\"md-list-item-text\" layout=\"column\"><h3><strong>Version {{version.versionNo}} </strong>created by <strong>\n{{version.createdBy}}</strong></h3><p>Date : {{version.createdDate.substr(0,10)}}</p></div><md-divider ng-if=\"!$last\">\n</md-divider></md-list-item></md-list></md-content></div></md-tab><md-tab label=\"ACTIVITY\"><div \nclass=\"auto-height-activity scrollable\" ms-scroll><md-content><md-list><md-list-item class=\"md-2-line\" \nng-repeat=\"activity in activities | orderBy:\'-\' \" ng-click=\"null\"><img ng-src=\"assets\\images\\avatars/Nora.jpg\" \nclass=\"md-avatar\"><div class=\"md-list-item-text\" layout=\"column\"><span><b><strong>{{activity.description}}</strong></b>\n by <strong>{{activity.userId}}</strong></span><p>Date :{{activity.postedAt.substr(0,10)}}</p></div><md-divider \nng-if=\"!$last\"></md-divider></md-list-item></md-list></md-content></div></md-tab></md-tabs></md-content></div></div>\n</div></ms-widget-front></ms-widget></div></div>");
$templateCache.put("app/main/toolbarsearch/versionFile.html","<md-dialog><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2>Add new version : {{selectedFileName}}</h2>\n<span flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><form name=\"doclibrary\" novalidate layout=\"column\"><div layout=\"row\">\n<div flex=\"45\" layout=\"column\" layout-align=\"center end\"><span class=\"h3\"><b>Upload File</b></span></div><span \nflex=\"10\"></span><div flex=\"45\" layout=\"column\" layout-align=\"center start\"><input class=\"ng-hide\" id=\"formUploadFile\" \nname=\"formUploadFile\" type=\"file\" onchange=\"angular.element(this).scope().setFile(this)\"><label for=\"formUploadFile\" \nclass=\"md-button md-raised md-accent\">Upload</label></div></div><div><div ng-repeat=\"file in files.slice(0)\" \nlayout=\"row\" layout-align=\"center center\"><span class=\"md-warn\">{{file.webkitRelativePath || file.name}}</span> (<span \nng-switch=\"file.size > 1024*1024\"> <span ng-switch-when=\"true\">{{file.size / 1024 / 1024 | number:2}} MB</span> <span \nng-switch-default>{{file.size / 1024 | number:2}} kB</span> </span>)</div></div></form></md-dialog-content>\n<md-dialog-actions layout=\"row\"><span flex></span><md-button ng-click=\"cancel()\">Cancel</md-button><md-button \nng-click=\"NewVersionFile()\">Save</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/user-management/changePassword.html","<md-dialog aria-label=\"Change Password\" flex=\"20\"><form name=\"passwordForm\" novalidate layout=\"column\"><md-toolbar \nclass=\"md-accent\"><div class=\"md-toolbar-tools\"><h2>Change Password</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><div layout=\"column\" layout-align=\"center center\"><md-input-container\n class=\"md-block\"><md-icon md-font-icon=\"icon-key-variant\" style=\"color: rgb(5, 167, 253) !important\"></md-icon><input \ntype=\"password\" name=\"password\" ng-model=\"user.password\" placeholder=\"Enter Password*\" required><div \nng-messages=\"passwordForm.password.$error\" role=\"alert\"><div ng-message=\"required\"><span>Password field is required\n</span></div></div></md-input-container><md-input-container class=\"md-block\"><md-icon md-font-icon=\"icon-key-variant\" \nstyle=\"color: rgb(5, 167, 253) !important\"></md-icon><input type=\"password\" name=\"passwordConfirm\" \nng-model=\"user.passwordConfirm\" placeholder=\"Re-enter Password*\" required> <span \nstyle=\"color: red;font-family: \'Roboto\';font-size: 12px\" ng-show=\"user.password !== user.passwordConfirm\">\nPasswords do not match</span><div ng-messages=\"passwordForm.passwordConfirm.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Re-enter Password field is required</span></div></div></md-input-container></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"center center\"><md-button type=\"button\" \nng-click=\"cancel()\">Cancel</md-button><md-button type=\"submit\" ng-click=\"passwordForm.$valid && save(user)\">Save\n</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/initiateReports/initiateReports.html","<style>\nmd-tabs-wrapper{\n        background-color:#24a9dc !important;;\n        }\n        /* table {border-collapse:collapse; table-layout:fixed; width:310px;}\n           table td {border:solid 1px #fab; width:500px; word-wrap:break-word;} */\n</style><link rel=\"stylesheet\" href=\"https://maxcdn.bootstrapcdn.com/bootstrap/3.3.7/css/bootstrap.min.css\"><script \nsrc=\"https://maxcdn.bootstrapcdn.com/bootstrap/3.3.7/js/bootstrap.min.js\"></script><div \nclass=\"page-layout simple tabbed mh-0 md-padding\" layout=\"column\" id=\"scrollToDivID\"><div class=\"content parent-tabs\">\n<md-tabs><md-tab md-active=\"true\"><md-tab-label><b style=\"font-family: verdana !important\" class=\"white-fg\">Reports</b>\n</md-tab-label></md-tab></md-tabs></div></div><div class=\"page-layout carded fullwidth md-padding scrollable\" \nlayout=\"column\" flex ms-scroll style=\"margin-top: -20px\" ng-init=\"ireprtCtrl.goToReports()\"><div class=\"row\" \nstyle=\"background-color: white\"><div id=\"report\" style=\"padding: 20px\"><div layout=\"row\" layout-align=\"end center\" \nstyle=\"margin-bottom: -3%\"><md-input-container class=\"md-block\" style=\"margin: 0px\"><md-icon \nmd-font-icon=\"icon-magnify\"></md-icon><input ng-model=\"searchReport\" type=\"text\" placeholder=\"Search\">\n</md-input-container><div layout=\"row\" ng-if=\"allReports.length != 0\"><md-input-container class=\"md-block md-padding\" \nstyle=\"margin-top: -2%\"><md-select ng-model=\"sizeNumber\"><md-option ng-repeat=\"size in sizeNumbers\" ng-value=\"size\" \nng-click=\"sendsizeNumber(size)\" value=\"sizeNumber\" ng-selected=\"$first\">{{size}}</md-option></md-select>\n</md-input-container></div></div><div layout=\"row\" flex=\"60\" layout-align=\"center center\" \nng-if=\"allReports.length == 0\" style=\"border:2px solid #cccccc; border-radius:5px; height:50px;margin-left:20%\"><b>\nNo Records were found</b></div><ms-widget class=\"white-bg\"><table class=\"dataTable row-border hover tableHighllete\" \nng-if=\"allReports.length != 0\" class=\"scrollable\" ms-scroll style=\"border: 1px solid #ccc\"><thead><tr \nstyle=\"background-color: #dee7f4 !important\"><th>REQ ID</th><th>REQ Type</th><th>Created By</th><th>Created Date</th>\n</tr></thead><tbody><tr ng-repeat=\"report in allReports | filter : searchReport\" ng-click=\"selectReport(report)\" \nclass=\"c-p\"><td>{{report.requestId}}</td><td>{{report.requestType}}</td><td>{{report.createdBy}}</td><td>\n{{report.createdDate.substring(0,10)}}</td></tr></tbody></table><div layout=\"row\" layout-align=\"space-between center\" \nflex=\"100\" ng-if=\"allReports.length != 0\"><div class=\"md-padding\"><h5><b>\nShowing {{(pageNumber*size)+1}} - {{(pageNumber + 1)*size}} of {{totalRecords}} Results</b></h5></div><div \nlayout=\"row\" layout-align=\"center center\">Page No<md-input-container class=\"md-block md-padding\" style=\"margin: 0px\">\n<md-select ng-model=\"pageNumber\"><md-option ng-repeat=\"Number in pageNumbers\" ng-value=\"Number\" \nng-click=\"sendPageNumber(Number)\" value=\"Number\" ng-selected=\"$first\">{{Number+1}}</md-option></md-select>\n</md-input-container></div><div layout=\"row\" layout-align=\"center center\"><div><md-button type=\"button\" \nng-click=\"previous()\" ng-disabled=\"pageNumber <= 0\">Prev</md-button></div><p class=\"md-padding\"><b>\n{{pageNumber+1}}/ {{totalPages}} &nbsp;PAGES</b></p><div class=\"md-padding\"><md-button type=\"button\" \nng-click=\"next(obj)\" ng-disabled=\"pageNumber == totalPages -1 || allReports.length == 0\">Next</md-button></div></div>\n</div></ms-widget></div></div></div>");
$templateCache.put("app/main/initiateReports/previewFiles.html","<md-dialog style=\"height: 100%; width: 100%\"><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2>Preview\n</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content class=\"no-padding\" \nstyle=\"-webkit-overflow-scrolling:touch; overflow:auto\"><div ng-if=\"fileVis\"><iframe id=\"iframe\" src=\"{{fileURL}}\" \nname=\"contentframe\" frameborder=\"0\" style=\"width: 100%; height: 1000px\"></iframe></div><div ng-if=\"imgVis\"><img \nng-src=\"{{fileURL}}\" name=\"contentframe\" frameborder=\"0\" \nstyle=\"width: 80%; height: 80%; position: absolute;  z-index: 999\"></div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/initiateReports/reportPreviewDialog.html","<style>\n.selectedApprovalMatrixrow {\n        font-size: 18px;\n        font-weight: bold;\n        color: black;\n        \n    }\n    .selectedApprovalMatrixrowBackground{\n    	background-color: #7ae2d8;\n    }\n    .disabled {\n   pointer-events: none;\n   }\nmd-tabs-canvas{\n    background-color: white;\n    }\n</style><md-dialog flex=\"90\" flex-gt-sm=\"75\" flex-md=\"75\" flex-gt-md=\"75\" style=\"height:85% !important\" \nng-init=\"loadApprovalMatrix()\"><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2>Report Details</h2><span\n flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content class=\"scrollable\" ms-scroll><md-content><div \nstyle=\"background:#dcecf0\" class=\"md-padding\"><div layout=\"row\" layout-align=\"space-between center\"><div><span \nclass=\"h3\" style=\"font-family: verdana\">{{report.requestId.substr(0,3) | uppercase}} No </span><span class=\"h3\" \nstyle=\"font-family: verdana;color: rgb(38, 161, 242)\">\n{{report.requestId.substr(4,report.requestId.length-2) | uppercase}}</span></div><div><span class=\"h4\" \nstyle=\"font-family: verdana\">Created By </span><span class=\"h4\" style=\"font-family: verdana; color: rgb(38, 161, 242)\">\n{{report.createdBy}}</span></div></div></div><div><md-tabs md-dynamic-height><md-tab><md-tab-label \ndata-ng-click=\"loadApprovalMatrix()\">INFO</md-tab-label><md-tab-body class=\"md-padding scrollable\" ms-scroll \nflex=\"100\"><div class=\"md-padding scrollable\" ms-scroll><div layout=\"row\" layout-align=\"center center\"><div flex=\"100\" \nstyle=\"color:black\"><form name=\"headerForm\"><div ng-if=\"report.requestType !=\'PR_PROCESS\'\"><div class=\"md-padding\" \nng-bind-html=\"currentFormHeader\" compile-template class=\"scrollable\" ms-scroll \nstyle=\"border:2px solid #cccccc; border-radius:0px\"></div></div><div ng-if=\"report.requestType == \'PR_PROCESS\'\"><div \nclass=\"md-padding\" ng-bind-html=\"currentFormInboxLineitem\" compile-template class=\"scrollable\" ms-scroll \nstyle=\"border:2px solid #cccccc; border-radius:0px\"></div></div><div>&nbsp;</div><div \nng-if=\" workitemInfo.lineItems.length > 0 \" ng-hide=\"report.requestType == \'PR_PROCESS\' \"><div \nclass=\"md-padding scrollable\" ms-scroll><div ng-bind-html=\"currentFormInboxLineitem\" compile-template disabled=\"true\">\n</div></div></div></form></div></div></div></md-tab-body></md-tab><md-tab><md-tab-label \nstyle=\"padding-bottom:50px !important\">COMMENTS</md-tab-label><md-tab-body class=\"md-padding scrollable\" ms-scroll><div\n class=\"md-padding\"><timeline><timeline-event ng-repeat=\"log in log | orderBy:\'-\'\" side=\"\"><timeline-badge \nstyle=\"background-color: rgb(3,155,229)\"><md-icon md-font-icon=\"{{log.icon}}\" class=\"s25 icon white-fg\" \nstyle=\"color:white !important\"></md-icon></timeline-badge><timeline-panel class=\"{{\'info\'}}\" \nstyle=\"background-color: #f1eded\"><timeline-heading><div layout=\"row\" layout-align=\"end end\"><p><b>\nDate : {{log.endDate.substr(6,2)}}-{{log.endDate.substr(4,2)}}-{{log.endDate.substr(0,4)}}</b></p></div><div \nlayout=\"row\" layout-align=\"start center\" style=\"color:black\"><img ng-src=\"assets\\images\\avatars/Nora.jpg\" \nclass=\"md-avatar\" style=\"border-radius:50% !important;width:13%; height:auto\"><div class=\"h3\">\n{{log.actualUser}} {{log.activityText}}</div></div></timeline-heading><div layout=\"row\" layout-align=\"start start\" \nstyle=\"padding-left: 2%\"><div class=\"text pt-16\">{{log.comments}}</div></div></timeline-panel></timeline-event>\n</timeline></div></md-tab-body></md-tab><md-tab><md-tab-label>ATTACHMENTS</md-tab-label><md-tab-body \nclass=\"md-padding scrollable\" ms-scroll ng-style=\"{\'border\': \'1px solid #cccccc\'}\"><div class=\"md-padding\" \nlayout=\"row\" layout-align=\"space-between center\"><span class=\"h2\">Attachments</span> <span class=\"h3\">\n{{report.attachments.length}}</span></div><div><md-list><md-list-item class=\"md-3-line\" \nng-repeat=\"attachment in report.attachments\"><div layout=\"row\" flex=\"100\" \nng-click=\"preview($event,attachment,report.requestId,attachment.url)\"><div flex=\"5\" layout=\"row\" \nlayout-align=\"center center\"><md-icon md-font-icon=\"{{fileIcon(attachment.fileType)}}\" class=\"s42 icon md-accent\">\n</md-icon></div><div flex=\"60\"><div class=\"md-list-item-text\"><h3><b>{{attachment.fileName}}</b></h3><h3>\nCreated By : {{attachment.creator}}</h3></div></div><div flex=\"30\"><h3>Created On : {{attachment.createDate }}</h3>\n</div><md-divider ng-if=\"!$last\"></md-divider></div><div><md-icon md-font-icon=\"icon-download\" \nclass=\"s32 c-p icon md-accent\" ng-click=\"downloadFile(attachment,workitemInfo.requestId )\"></md-icon></div>\n</md-list-item></md-list></div></md-tab-body></md-tab></md-tabs></div></md-content></md-dialog-content>\n<md-dialog-actions><div layout=\"row\" layout-align=\"center center\"><md-button class=\"md-raised\" ng-click=\"cancel()\">Ok\n</md-button></div></md-dialog-actions></md-dialog>");
$templateCache.put("app/core/directives/ms-info-bar/ms-info-bar.html","<div id=\"ms-info-bar\" layout=\"row\" layout-align=\"start center\" flex><div id=\"ms-info-bar-message\" ng-transclude flex>\n</div><md-button id=\"ms-info-bar-close\" class=\"md-icon-button\" aria-label=\"Close\" ng-click=\"removeInfoBar()\"><md-icon \nmd-font-icon=\"icon-close s24\"></md-icon></md-button></div>");
$templateCache.put("app/core/directives/ms-material-color-picker/ms-material-color-picker.html","<md-menu md-position-mode=\"target-right target\"><div ng-click=\"$mdOpenMenu($event)\"><ms-color-picker-button><md-button \naria-label=\"Row Color\" md-menu-origin ng-click=\"$mdOpenMenu($event)\" ng-class=\"vm.selectedColor.class\"><span \nng-show=\"vm.selectedColor.palette\">{{vm.selectedColor.palette}} {{vm.selectedColor.hue}} </span><span \nng-show=\"!vm.selectedColor.palette\">Select Color</span></md-button></ms-color-picker-button></div><md-menu-content \nclass=\"ms-material-color-picker-menu-content\" layout-column><header \nng-class=\"vm.selectedColor.class || \'md-accent-bg\'\" class=\"md-whiteframe-4dp\" layout=\"row\" \nlayout-align=\"space-between center\"><md-button md-prevent-menu-close ng-click=\"vm.activateHueSelection(false,false)\" \nclass=\"md-icon-button\" ng-class=\"{\'hidden\':!vm.selectedPalette}\" aria-label=\"Palette\"><md-icon \nmd-font-icon=\"icon-arrow-left\" class=\"s20\"></md-icon></md-button><span ng-if=\"vm.selectedColor.palette\">\n{{vm.selectedColor.palette}} {{vm.selectedColor.hue}} </span><span ng-if=\"!vm.selectedColor.palette\">Select Color\n</span><md-button class=\"remove-color-button md-icon-button\" ng-click=\"vm.removeColor()\" aria-label=\"Remove Color\">\n<md-icon md-font-icon=\"icon-delete\" class=\"s20\"></md-icon></md-button></header><div class=\"colors\" ms-scroll><div \nng-show=\"!vm.selectedPalette\" layout=\"row\" layout-wrap><div class=\"color\" ng-class=\"\'md-\'+palette+\'-500-bg\'\" \nng-repeat=\"(palette, hues) in vm.palettes\" ng-click=\"vm.activateHueSelection(palette,hues)\" layout=\"row\" \nlayout-align=\"start end\" md-prevent-menu-close md-ink-ripple><span class=\"label\">{{palette}}</span></div></div><div \nng-show=\"vm.selectedPalette\" layout=\"row\" layout-wrap><div class=\"color\" \nng-class=\"\'md-\'+vm.selectedPalette+\'-\'+hue+\'-bg\'\" ng-repeat=\"(hue, values) in vm.selectedHues\" \nng-click=\"vm.selectColor(vm.selectedPalette,hue)\" layout=\"row\" layout-align=\"start end\" md-ink-ripple><span \nclass=\"label\">{{hue}} </span><i ng-if=\"vm.selectedPalette == vm.selectedColor.palette && hue == vm.selectedColor.hue\" \nclass=\"s16 icon-check\"></i></div></div></div></md-menu-content></md-menu>");
$templateCache.put("app/core/directives/ms-search-bar/ms-search-bar.html","<div flex layout=\"row\" layout-align=\"start center\"><label for=\"ms-search-bar-input\"><md-button \nclass=\"ms-search-bar-expander md-icon-button\" aria-label=\"Expand Search Bar\" ng-click=\"MsSearchBar.expand()\" \nng-if=\"!MsSearchBar.resultsLoading || MsSearchBar.collapsed\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon s24\">\n</md-icon></md-button><div class=\"ms-search-bar-loader\" layout=\"row\" layout-align=\"center center\" \nng-if=\"MsSearchBar.resultsLoading && !MsSearchBar.collapsed\"><md-progress-circular class=\"md-accent\" md-diameter=\"32\" \nmd-mode=\"indeterminate\"></md-progress-circular></div></label><input id=\"ms-search-bar-input\" type=\"text\" \nplaceholder=\"Search\" flex ng-model=\"MsSearchBar.query\" ng-model-options=\"MsSearchBar.queryOptions\" \nng-blur=\"MsSearchBar.collapse()\" ng-keydown=\"MsSearchBar.handleKeydown($event)\"><md-button \nclass=\"ms-search-bar-collapser md-icon-button\" ng-click=\"MsSearchBar.collapse()\" aria-label=\"Collapse Search Bar\">\n<md-icon md-font-icon=\"icon-close\" class=\"icon s24\"></md-icon></md-button><div class=\"ms-search-bar-results\" \nng-if=\"MsSearchBar.results\" ms-scroll><div class=\"no-results\" ng-if=\"MsSearchBar.results.length === 0\">No Results!\n</div><div class=\"result\" ng-repeat=\"result in MsSearchBar.results\" ng-click=\"MsSearchBar.handleResultClick(result)\" \nng-mouseenter=\"MsSearchBar.handleMouseenter($index)\" ng-mousedown=\"MsSearchBar.absorbEvent($event)\" \nng-class=\"{\'selected\': $index == MsSearchBar.selectedResultIndex}\" md-ink-ripple><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"icon-container\" layout=\"row\" layout-align=\"center center\"><i \nng-if=\"result.icon\" class=\"icon {{result.icon}}\"></i><div ng-if=\"!result.icon\" class=\"square md-accent-bg\"></div></div>\n<div><div class=\"title\">{{result.title}}</div><div class=\"description\" ng-if=\"result.description\">\n{{result.description}}</div></div></div></div></div></div>");
$templateCache.put("app/core/directives/ms-shortcuts/ms-shortcuts.html","<div class=\"shortcuts-container\" layout=\"row\" layout-align=\"space-between center\" flex \nng-class=\"{\'mobile-bar-active\': MsShortcuts.mobileBarActive}\"><div layout=\"row\" layout-align=\"start center\" flex><div \nclass=\"shortcuts hide show-gt-xs\" layout=\"row\" layout-align=\"start center\" ms-scroll \nng-if=\"MsShortcuts.shortcuts.length > 0\" ng-sortable=\"MsShortcuts.sortableOptions\"><div \nng-repeat=\"shortcut in MsShortcuts.shortcuts\" layout=\"row\" layout-align=\"center center\"><md-button \nclass=\"md-icon-button shortcut\" aria-label=\"{{shortcut.title}}\" ui-sref=\"{{shortcut.uisref}}\"><md-icon \nng-if=\"shortcut.icon\" md-font-icon=\"{{shortcut.icon}}\" class=\"icon s24\"></md-icon><div ng-if=\"!shortcut.icon\" \nclass=\"first-letter\">{{shortcut.title.charAt(0)}}</div><md-tooltip md-direction=\"bottom\">{{shortcut.title}}\n</md-tooltip></md-button></div></div><md-menu md-offset=\"8 56\" class=\"shortcut-menu hide show-gt-xs\"><md-button \nclass=\"md-icon-button add-shortcut-button\" aria-label=\"Add shortcut\" ng-click=\"$mdOpenMenu($event)\"><md-icon \nmd-menu-origin md-font-icon=\"icon-star\" class=\"icon amber-600-fg s24\"></md-icon><md-tooltip md-direction=\"bottom\">\nClick to add/remove shortcut</md-tooltip></md-button><md-menu-content><div id=\"ms-shortcut-add-menu\"><div \nclass=\"shortcut-search\" layout=\"row\" layout-align=\"start center\"><div class=\"search-icon\" layout=\"row\" \nlayout-align=\"center center\" ng-if=\"!MsShortcuts.resultsLoading\"><md-icon md-menu-align-target \nmd-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon></div><div class=\"shortcut-loader\" layout=\"row\" \nlayout-align=\"center center\" ng-if=\"MsShortcuts.resultsLoading\"><md-progress-circular class=\"md-accent\" \nmd-diameter=\"20\" md-mode=\"indeterminate\"></md-progress-circular></div><input type=\"text\" placeholder=\"Search\" flex \nng-model=\"MsShortcuts.query\" ng-model-options=\"MsShortcuts.queryOptions\" \nng-keydown=\"MsShortcuts.handleKeydown($event)\"></div><div class=\"results\" ng-if=\"MsShortcuts.results\" ms-scroll><div \nclass=\"no-results\" ng-if=\"MsShortcuts.results.length === 0\">No Results!</div><div class=\"result\" \nng-repeat=\"result in MsShortcuts.results\" ng-click=\"MsShortcuts.handleResultClick(result)\" \nng-mouseenter=\"MsShortcuts.handleMouseenter($index)\" ng-mousedown=\"MsShortcuts.absorbEvent($event)\" \nng-class=\"{\'selected\': $index == MsShortcuts.selectedResultIndex}\" md-prevent-menu-close=\"md-prevent-menu-close\" \nmd-ink-ripple><div layout=\"row\" layout-align=\"start space-between\"><div layout=\"row\" layout-align=\"start center\" flex>\n<div class=\"icon icon-container\" layout=\"row\" layout-align=\"center center\"><i ng-if=\"result.icon\" \nclass=\"{{result.icon}}\"></i><div ng-if=\"!result.icon\" class=\"square md-accent-bg\"></div></div><div><div class=\"title\">\n{{result.title}}</div></div></div><md-icon md-font-icon=\"icon-pin\" class=\"icon s18\" \nng-class=\"{\'fade-text\': !result.hasShortcut}\"></md-icon></div></div></div></div></md-menu-content></md-menu></div>\n<md-button class=\"md-icon-button toggle-mobile-menu hide-gt-xs\" aria-label=\"Add shortcut\" \nng-click=\"MsShortcuts.toggleMobileBar()\"><md-icon md-menu-origin md-font-icon=\"icon-star\" \nclass=\"icon amber-600-fg s24\" ng-hide=\"MsShortcuts.mobileBarActive\"></md-icon><md-icon md-menu-origin \nmd-font-icon=\"icon-close\" class=\"icon s24\" ng-hide=\"!MsShortcuts.mobileBarActive\"></md-icon></md-button></div>");
$templateCache.put("app/main/mtr_Inbox/logs.html","<md-dialog flex=\"85\" flex-gt-sm=\"50\"><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2>Activity Log</h2>\n<span flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content class=\"md-padding scrollable\" ms-scroll><div \nclass=\"md-padding scrollable\" ms-scroll><timeline><timeline-event \nng-repeat=\"log in CurrentWorkItem.logs | orderBy:\'id\':true \" side=\"\"><timeline-badge \nstyle=\"background-color: rgb(3,155,229)\"><md-icon md-font-icon=\"{{log.icon}}\" class=\"s25 icon white-fg\" \nstyle=\"color:white !important\"></md-icon></timeline-badge><timeline-panel class=\"{{\'info\'}}\" \nstyle=\"background-color: #f1eded;    border-radius: 10px\"><timeline-heading><div layout=\"row\" \nlayout-align=\"space-between center\"><div ng-if=\"log.currAgent\"></div><div ng-if=\"!log.currAgent\"></div><p><b>\nDate : {{log.endDate.substr(6,2)}}-{{log.endDate.substr(4,2)}}-{{log.endDate.substr(0,4)}}</b><br><b>\nTime : {{log.endTime.substr(0,2)}}:{{log.endTime.substr(2,2)}}:{{log.endTime.substr(4,6)}}</b></p></div><div \nlayout=\"row\" layout-align=\"start center\" style=\"color:black\"><img ng-src=\"assets\\images\\avatars/Nora.jpg\" \nclass=\"md-avatar\" style=\"border-radius:50% !important;width:13%; height:auto\"><div class=\"h4\" \nng-if=\"log.activityText == \'Initiated\'|| log.activity ==\'001\' \">{{log.actualUser}} &nbsp Initiated</div><div \nclass=\"h4\" ng-if=\"log.activity == \'514\' \">{{log.actualUser}} &nbsp Approved</div><div class=\"h4\" \nng-if=\"log.activity == \'515\' \">{{log.actualUser}} &nbsp Rejected</div><div class=\"h4\" \nng-if=\"log.activityText == \'Collaborate\' || log.activity ==\'110\' \">\n{{log.actualUser}} Collaborated with {{log.currAgent}}</div><div class=\"h4\" \nng-if=\"log.activityText == \'CollaborateBack\' || log.activity ==\'111\' \">\n{{log.actualUser}} Collaborated back with {{log.currAgent}}</div></div></timeline-heading><div layout=\"row\" \nlayout-align=\"start start\" style=\"padding-left: 2%\"><p style=\"color:black\">{{log.comments}}</p></div></timeline-panel>\n</timeline-event></timeline></div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/mtr_Inbox/mtrCollaborate.html","<style>.md-button {\n     text-transform: none !important;\n    }</style><md-dialog aria-label=\"comments\" flex=\"40\"><form\n ng-cloak><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2>Collaborate</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><div layout=\"column\" layout-align=\"start center\"><div><div \nlayout=\"column \" layout-align=\"center center \" flex-gt-sm=\"100\"><div class=\"h4 md-padding\"><span>\nSelect the user to Collaborate?</span></div><form><input list=\"names\" name=\"namesr\" ng-model=\"sampleheader.person\">\n<datalist id=\"names\" ng-model=\"sampleheader.person \"><option value=\"\">-- select an option --</option><option \nng-repeat=\"person in users | filter:search \" ng-value=\"person.login\">{{person.firstName}}-{{person.lastName}}</option>\n</datalist><p ng-if=\"!select\" style=\"color: red\">{{errormsg}}</p></form></div><div><md-input-container \nclass=\"md-block\"><label>Comments</label><textarea ng-model=\"comments\" md-maxlength=\"150\" rows=\"5\" md-select-on-focus \nstyle=\"border: 1px solid rgb(169, 161, 161);border-radius: 5px\"></textarea></md-input-container></div></div></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"end end\"><md-button ng-click=\"cancel()\">Cancel\n</md-button><md-button ng-click=\"collaborateActivity($event,user,comments)\" class=\"md-warn\">Collaborate</md-button>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/mtr_Inbox/mtrInbox.html","<div class=\"page-layout simple tabbed mh-0\" layout=\"column\"><div class=\"content parent-tabs\"><md-tabs class=\"mh-0\">\n<md-tab label=\"Request Details\" md-active=\"true\"></md-tab></md-tabs></div></div><div flex=\"100\" layout=\"row\" \nlayout-xs=\"column\" style=\"padding: 15px\" layout-wrap ng-init=\"MtrCtrl.getAllListData()\"><ms-widget layout=\"column\" \nflex-gt-sm=\"60\"><ms-widget-front class=\"white-bg\"><md-content><div class=\"md-padding\"><div layout=\"row\" \nlayout-align=\"space-between center\"><div><div class=\"h4\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-cart-outline\" style=\"color: #2196F3 !important\"></md-icon><span style=\"color: #2196F3 !important\">\nInvoice Registers:{{allWorkitems.length}}</span></div></div><div layout=\"row\"><div style=\"padding: 6px\" \nng-if=\"selected.length  > 1 \" ng-repeat=\"actvity in globalworkitems\"><md-button class=\"md-raised md-padding md-accent\" \nng-class=\"{\'md-accent\': activities.buttonText === \'Approve\'} \" data-ng-if=\"actvity.actvity == \'510\'\" \ndata-ng-click=\"processActvity($event,actvity,\'bulk\');\" style=\"margin-right: 5px\">Approve</md-button><md-button \nclass=\"md-raised md-padding md-warn\" ng-class=\"{\'md-warn\': activities.buttonText === \'Reject\'} \" \ndata-ng-if=\"actvity.actvity == \'511\'\" data-ng-click=\"processActvity($event,actvity,\'bulk\');\" style=\"margin-right: 5px\">\nReject</md-button></div></div></div><md-divider></md-divider><table class=\"dataTable row-border hover table-border\" \ndatatable=\"ng\" dt-options=\"MtrCtrl.dtOptions\"><thead><tr \nstyle=\"background-color: #dee7f4 !important;text-align: center\"><th class=\"secondary-text\"><div class=\"table-header\">\n<md-checkbox aria-label=\"Select All\" ng-checked=\"isChecked()\" md-indeterminate=\"isIndeterminate()\" \nng-click=\"toggleAll()\" style=\"margin-bottom: -2%\"></md-checkbox></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">DocId</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Invoice Category</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Vendor Name</span></div></th><th \nclass=\"secondary-text hidden-sm hidden-md\" hide-sm hide-md hide-xs><div class=\"table-header\"><span \nclass=\"column-title\">Created Date</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Actions</span></div></th></tr></thead><tbody><tr ng-repeat=\"workitem in allWorkitems\"><td><span>\n<md-checkbox ng-checked=\"exists(workitem, selected)\" ng-click=\"toggle(workitem, selected)\"></md-checkbox></span></td>\n<td ng-click=\"gotomtrDetail(workitem)\" class=\"c-p\" style=\"text-decoration: underline;color:blue;text-align:start\">\n{{workitem.sapDocId}}</td><td style=\"text-align: start\"><span ng-if=\"workitem.header.INVOICE_CAT_TEXT\">\n{{workitem.header.INVOICE_CAT_TEXT}}</span> <span ng-if=\"workitem.header.INVOICE_CAT_TEXT == \'\'\">\n{{workitem.header.INVOICE_CAT}}</span></td><td>{{workitem.header.NAME1}}</td><td style=\"text-align: start\" hide-sm \nhide-md hide-xs>{{workitem.createdDate.substring(0,10)}}</td><td layout=\"row\"><md-button class=\"md-icon-button\" \nid=\"{{workitem.requestId}}\" onclick=\"angular.element(this).scope().previewFile(this)\"><md-icon md-font-icon=\"icon-eye\" \nstyle=\"color: blue\"></md-icon><md-tooltip md-direction=\"top\"><span>View Document</span></md-tooltip></md-button><div \nlayout=\"row\" layout-wrap ng-repeat=\"actvity in workitem.activities\"><md-button class=\"md-icon-button\" \nname=\"{{actvity}}\" ng-show=\"workitem.status != \'5\' && workitem.status != \'7\'\" \nng-class=\"{ \'md-accent\':actvity.buttonText === \'Approve\'}\" id=\"{{workitem.requestId}}\" \nonclick=\"angular.element(this).scope().processActvity(this)\" data-ng-if=\"actvity.actvity == \'510\'\"><md-tooltip \nmd-direction=\"top\"><span>{{actvity.buttonText}}</span></md-tooltip><md-icon md-font-icon=\"icon-check\"></md-icon>\n</md-button><md-button class=\"md-icon-button\" ng-show=\"workitem.status != \'5\' && workitem.status != \'7\'\" \nname=\"{{actvity}}\" ng-class=\"{\'md-warn\':actvity.buttonText === \'Reject\'}\" id=\"{{workitem.requestId}}\" \nonclick=\"angular.element(this).scope().processActvity(this)\" data-ng-if=\"actvity.actvity == \'511\'\"><md-tooltip \nmd-direction=\"top\"><span>{{actvity.buttonText}}</span></md-tooltip><md-icon md-font-icon=\"icon-close\"></md-icon>\n</md-button></div><div ng-show=\"workitem.status != \'5\' && workitem.status != \'7\'\"><md-button class=\"md-icon-button\" \nname=\"{{actvity}}\" value=\"{{workitem}}\" onclick=\"angular.element(this).scope().Collaborate(this)\" \nng-repeat=\"actvity in workitem.activities\" data-ng-if=\"actvity.actvity == \'110\'\" style=\"margin-right: 5px\"><md-tooltip \nmd-direction=\"top\"><span>{{actvity.buttonText}}</span></md-tooltip><md-icon md-font-icon=\"icon-twitter-retweet\">\n</md-icon></md-button></div><div ng-show=\"workitem.status == \'7\' || workitem.status == \'5\' \"><md-button \nclass=\"md-icon-button\" name=\"{{actvity}}\" value=\"{{workitem}}\" \nonclick=\"angular.element(this).scope().collaborateBack(this)\" ng-repeat=\"actvity in workitem.activities\" \ndata-ng-if=\"actvity.actvity == \'111\' \" style=\"margin-right: 5px\"><md-tooltip md-direction=\"top\"><span>\n{{actvity.buttonText}}</span></md-tooltip><md-icon md-font-icon=\"icon-replay\"></md-icon></md-button></div><md-button \nclass=\"md-icon-button\" id=\"{{workitem.requestId}}\" onclick=\"angular.element(this).scope().viewlogs(this)\"><md-icon \nmd-font-icon=\"icon-comment-text-outline\" style=\"color: lightgreen\"></md-icon><md-tooltip md-direction=\"top\"><span>\nView Logs</span></md-tooltip></md-button></td></tr></tbody></table></div></md-content></ms-widget-front></ms-widget>\n<ms-widget layout=\"column\" flex=\"40\" hide-xs><ms-widget-front class=\"white-bg\"><md-content><div class=\"md-padding\"><div\n class=\"h4\" style=\"color:#27a4d4\">Preview: {{primaryAttachmentsData[0].fileName}}</div><md-divider></md-divider><iframe\n style=\"width: 100%; height: 1000px;overflow:hidden\" scrolling=\"no\" ng-src=\"{{previewUrl}}\"></iframe></div>\n</md-content></ms-widget-front></ms-widget></div>");
$templateCache.put("app/main/mtr_Inbox/previewFiles.html","<md-dialog flex=\"60\"><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2>Attachments</h2><span flex></span>\n<md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content class=\"no-padding\"><div class=\"widget-group md-padding scrollable\" \nlayout=\"row\" flex=\"100\" layout-wrap ms-scroll><ms-widget flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"33\" \nng-repeat=\"file in allAttachments\" ng-if=\"allAttachments.length\"><ms-widget-front class=\"white-bg c-p\" \nng-click=\"selectFile(file)\"><md-list flex><div layout=\"row\" layout-align=\"space-around center\"><div><md-icon \nng-if=\"file.primaryDocumnet ==\'X\'\" md-font-icon=\"icon-star blue-fg\" class=\"s20\"></md-icon><md-icon \nng-if=\"file.primaryDocumnet ==\'\'\" md-font-icon=\"icon-file-pdf blue-fg\" class=\"s20\"></md-icon></div><div \nstyle=\"color: #039be5\">{{ file.fileName }}</div><div>Owner : {{ file.creator }}</div><div>\nDate:- {{ file.createDate.substring(6,8) }}-{{ file.createDate.substring(4,6)}}-{{ file.createDate.substring(0,4)}}\n</div></div></md-list></ms-widget-front></ms-widget><ms-widget flex=\"100\" ng-if=\"!allAttachments.length\">\n<ms-widget-front class=\"white-bg c-p md-padding\"><div layout=\"row\" layout-align=\"center center\">\nNo Attachments were found.</div></ms-widget-front></ms-widget><ms-widget flex=\"100\"><ms-widget-front \nclass=\"white-bg c-p border\"><iframe id=\"iframe\" src=\"{{previewUrl}}\" name=\"contentframe\" frameborder=\"0\" \nstyle=\"width: 100%; height: 1200px;overflow:hidden\" scrolling=\"no\"></iframe></ms-widget-front></ms-widget></div>\n</md-dialog-content></md-dialog>");
$templateCache.put("app/navigation/layouts/horizontal-navigation/navigation.html","<div layout=\"row\" layout-align=\"start center\"><ms-navigation-horizontal></ms-navigation-horizontal></div>");
$templateCache.put("app/navigation/layouts/vertical-navigation/navigation.html","<md-toolbar class=\"navigation-header\" id=\"navheader\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-image\"><img id=\"log1\"></span></div>\n</md-toolbar><ms-navigation class=\"scrollable\" folded=\"vm.folded\" ms-scroll=\"vm.msScrollOptions\"></ms-navigation>\n<script>\nif(window.localStorage[\'branddata\'] !=\"null\"){\n	var logodata = JSON.parse(window.localStorage[\'branddata\']).applogo; \n	var backrounddata = JSON.parse(window.localStorage[\'branddata\']).appbackroundimage; \n	if((logodata ||backrounddata) !=null && (logodata ||backrounddata) !=\'undefined\'){\n		$(\"#navheader\").css(\'background-image\', \'url(\'+backrounddata+\')\');\n		$(\'#log1\').attr(\'src\', logodata);\n	}else{\n		$(\"#navheader\").css(\'background-image\', \'url(\'+\"assets/images/2.jpg\"+\')\');\n		$(\'#log1\').attr(\'src\', \"../assets/images/logos/logo3.jpg\");\n	}\n}\nelse{\n	$(\"#navheader\").css(\'background-image\', \'url(\'+\"assets/images/2.jpg\"+\')\');\n	$(\'#log1\').attr(\'src\', \"../assets/images/logos/logo3.jpg\");\n}\n</script>");
$templateCache.put("app/navigation/layouts/vertical-navigation-fullwidth-toolbar-2/navigation.html","<ms-navigation class=\"scrollable\" folded=\"vm.folded\" ms-scroll=\"vm.msScrollOptions\"></ms-navigation>");
$templateCache.put("app/toolbar/layouts/vertical-navigation/toolbar.html","<div layout=\"row\" layout-align=\"start center\" ng-init=\"vm.UserDetails()\"><div layout=\"row\" layout-align=\"start center\" \nflex><md-button id=\"navigation-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'navigation\')\" hide-gt-sm \naria-label=\"Toggle navigation\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon \nmd-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><div layout=\"row\" flex=\"50\" layout-align=\"start start\" \nclass=\"md-padding\"><span id=\"mySpan\" class=\"\" style=\"color:white\"></span></div><div layout=\"row\" layout-align=\"center\" \nshow-gt-md hide-xs hide-sm hide-md><span id=\"mySpan\" class=\"f-1\" style=\"color:white\">SmartDocs | SmartPayables</span>\n</div></div><div layout=\"row\" layout-align=\"start center\"><md-progress-circular id=\"toolbar-progress\" \nng-disabled=\"!$root.loadingProgress\" class=\"md-accent\" md-diameter=\"32\"></md-progress-circular><div \nclass=\"toolbar-separator\"></div><md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button \nclass=\"user-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate \ntranslate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"username white-500-fg\" show-gt-sm>{{loggedInUserName }}</span><md-icon \nmd-font-icon=\"icon-chevron-down white-500-fg\" class=\"icon s16\" hide-xs></md-icon><div class=\"avatar-wrapper pl-15\"><img\n md-menu-align-target class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"></div></div></md-button><md-menu-content \nwidth=\"3\"><md-menu-item class=\"md-indent\" ng-click=\"vm.openProfileDialog($event)\"><md-icon md-font-icon=\"icon-account\" \nclass=\"icon toolbar-icon-color\"></md-icon><md-button ng-click=\"vm.editMyProfile()\">My Profile</md-button>\n</md-menu-item><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-account-key\" \nclass=\"icon toolbar-icon-color\"></md-icon><md-button ng-click=\"vm.changePassword($event)\">Change Password</md-button>\n</md-menu-item><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" class=\"icon toolbar-icon-color\">\n</md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item></md-menu-content></md-menu></md-menu-bar>\n</div></div><div layout=\"row\"><md-progress-linear class=\"md-accent\" md-mode=\"indeterminate\" \nng-show=\"$root.loadingProgress\"></md-progress-linear></div><script>\nif(window.localStorage[\'branddata\'] !=\"null\"){\n	var label = JSON.parse(window.localStorage[\'branddata\']).applabel;\n	if(label !=null && label != \'undefined\'){	\n		document.getElementById(\'mySpan\').innerHTML = label;\n	}else{\n		document.getElementById(\'mySpan\').innerHTML  = \"SmartDocs Inc.\";\n	}\n}else{\n	document.getElementById(\'mySpan\').innerHTML  = \"SmartDocs Inc.\";\n}\n</script>");
$templateCache.put("app/main/DocBuffer/List/list.html","<link rel=\"stylesheet\" href=\"https://maxcdn.bootstrapcdn.com/bootstrap/4.1.3/css/bootstrap.min.css\"><script \nsrc=\"https://maxcdn.bootstrapcdn.com/bootstrap/4.1.3/js/bootstrap.min.js\"></script><div class=\"widget-group\" \nflex=\"100\" layout=\"column\" layout-wrap><ms-widget><ms-widget-front class=\"white-bg md-padding\"><span class=\"h2\">\nDocBuffer List</span><div layout=\"column\"><table class=\"table table-striped table-hover\"><thead><tr><th scope=\"col\">\nReq ID</th><th scope=\"col\">Doc Type</th><th scope=\"col\">Created By</th><th scope=\"col\">CreateDate</th></tr></thead>\n<tbody><tr class=\"c-p\" ng-repeat=\"list in DocbufferItems.content\" ng-click=\"selectWorkItem(list);\"><td>\n{{list.requestId}}</td><td>{{list.requestType}}</td><td>{{list.createdBy}}</td><td>{{list.createdDate.substring(0,10)}}\n</td></tr></tbody></table></div></ms-widget-front></ms-widget></div>");
$templateCache.put("app/main/DocBuffer/docbuffer/docbuffer.html","<style>\n.head2 {\n            font-size: 20px;\n            color: #6b6b6b;\n            font-weight: medium;\n        }\n        \n        .form-control {\n            font-size: 1.5rem;\n        }\n</style><div class=\"widget-group\" flex=\"100\" layout=\"column\" layout-wrap><ms-widget><ms-widget-front \nclass=\"white-bg md-padding\"><div class=\"breadcrumb\" layout=\"row\" layout-align=\"space-between center\" \nng-init=\"preview()\"><div><li class=\"previous-state c-p\" data-ng-click=\"goToPreviousState()\"><span><span \nclass=\"icon-arrow-left-bold-circle-outline\"></span> Back</span></li></div><div class=\"h2\">{{WorkItem.requestId}}</div>\n<div><button type=\"button\" class=\"btn btn-success btn-lg\">Submit</button> <button type=\"button\" \nclass=\"btn btn-primary btn-lg\">Cancel</button> <button type=\"button\" class=\"btn btn-danger btn-lg\">Return To supplier\n</button></div></div><div layout=\"row\" layout-xs=\"column\"><div layout=\"column\" flex-gt-sm \nstyle=\"height: 100% !important\"><div layout=\"row\" layout-xs=\"column\"><div flex-gt-sm=\"60\" layout=\"column\" \nstyle=\"border: 2px solid #CCC;width:100%; height: 500px; max-height: 400px; overflow-y: scroll\"><span class=\"head2\" \nstyle=\"background-color: #cccc\">Invoice Details</span><md-divider></md-divider><br><form><div class=\"form-row\"><div \nclass=\"col\"><label>Vendor</label><input type=\"text\" class=\"form-control\" style=\"border: 1px solid #ccc\"></div><md-icon \nstyle=\"margin-bottom:0% !important\" class=\"icon-magnify c-p\" ng-click=\"searchVendor()\"></md-icon><div class=\"col\">\n<label>Company Code</label><input type=\"text\" class=\"form-control\" style=\"border: 1px solid #ccc\"></div></div><br><div \nclass=\"form-row\"><div class=\"col\"><label>Reference</label><input type=\"text\" class=\"form-control\" \nstyle=\"border: 1px solid #ccc\"></div><div class=\"col\"><label>GST No</label><input type=\"text\" class=\"form-control\" \nstyle=\"border: 1px solid #ccc\"></div><div class=\"col\"><label>Gross Amount</label><input type=\"text\" \nclass=\"form-control\" style=\"border: 1px solid #ccc\"></div></div><br><div class=\"form-row\"><div class=\"col\"><label>\nInvoice Date</label><md-datepicker ng-model=\"header.invoiceDate\" md-current-view=\"year\"></md-datepicker></div><div \nclass=\"col\"><label>Posting Date</label><md-datepicker ng-model=\"header.postingDate\" md-current-view=\"year\">\n</md-datepicker></div></div><br><div><md-input-container class=\"md-block\"><label>Comments</label><textarea \nng-model=\"header.comments\" columns=\"1\" style=\"border: 1px solid #ccc\" md-maxlength=\"150\" rows=\"3\"></textarea>\n</md-input-container></div><br></form></div><div flex-gt-sm=\"40\" layout=\"column\" style=\"border: 2px solid #CCC\"><span \nclass=\"head2\" style=\"background-color: #cccc\">Vendor Information</span><md-divider></md-divider><div layout=\"row\"><div \nlayout=\"column\"><input type=\"text\" class=\"form-control\" placeholder=\" Repair-Man Pty Ltd\"> <input type=\"text\" \nclass=\"form-control\" placeholder=\" E12345\"><br><input type=\"text\" class=\"form-control\" placeholder=\"432 Storey Street\">\n <span>Perth,AUSTRALIA</span> <span>6000</span></div></div><md-divider></md-divider><div layout=\"row\" \nng-if=\"attachment\"><div layout=\"column\"><span class=\"head2\" style=\"background-color: #cccc\">Attachments</span><table \nclass=\"table table-bordered\"><thead class=\"thead-light\"><th>File Name</th><th>FileType</th><th>Primary Document</th>\n</thead><tbody><tr ng-repeat=\"attachment in WorkItem.attachments\"><td>{{attachment.fileName.substring(0,8)}}</td><td>\n{{attachment.fileType}}</td><td><i class=\"icon-checkbox-marked-circle green-500-fg\" \nng-show=\"{{attachment.primaryDocumnet == \'X\'}}\"></i> <i class=\"icon-cancel red-500-fg\" \nng-show=\"{{! attachment.primaryDocumnet}}\"></i></td></tr></tbody></table></div></div></div></div><div><table \nclass=\"table table-bordered table-responsive-md table-striped\"><thead class=\"thead-light\"><tr><th><button \ntype=\"button\" class=\"btn btn-primary\" ng-click=\"addLineItem();\">Add</button></th><th>Firstname</th><th>Lastname</th>\n<th>Date</th></tr></thead><tbody><tr ng-repeat=\"x in lineItems\" ng-click=\"selectrow(x)\"><td><i \nclass=\"icon-cancel red-500-fg c-p\" ng-click=\"deleteLineItem($index);\"></i></td><td><input type=\"text\" \nclass=\"form-control\" ng-model=\"x.name\"></td><td><input type=\"text\" class=\"form-control\" ng-model=\"x.Agent\"></td><td>\n<input type=\"text\" class=\"form-control\" ng-model=\"x.Date\"></td></tr></tbody></table></div></div><div flex-gt-sm=\"40\">\n<iframe ng-src=\"\" style=\"width:100%; height:100%\" frameborder=\"0\"></iframe></div></div></ms-widget-front></ms-widget>\n</div>");
$templateCache.put("app/main/adminSubstitution/admin-reAssign/create.reAssign.html","<md-dialog flex=\"40\" ng-init=\"getAllUsers();\"><form name=\"userForm\" novalidate \nng-submit=\"userForm.$valid && userCtrl.createUser(user)\" layout=\"column\"><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools\"><h2>Select User for Re-Assignment</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"cancel()\"><md-icon md-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"row\" flex=\"100\" \nlayout-align=\"space-between center\"><md-input-container class=\"md-block\"><input type=\"text\" name=\"name\" \nng-model=\"member.name\" placeholder=\"Name\"></md-input-container><md-input-container class=\"md-block\"><input type=\"text\" \nname=\"email\" ng-model=\"member.email\" placeholder=\"Email\"></md-input-container><md-button type=\"button\" \nclass=\"md-raised\" ng-click=\"searchMember(member)\" style=\"margin-bottom: 20px\"><md-icon md-font-icon=\"icon-magnify\">\n</md-icon>Search</md-button></div><div layout=\"row\" layout-align=\"center center\" \nng-style=\"{\'color\':\'red\',\'font-family\':\'Verdana\',\'font-size\':\'18px\'}\" ng-show=\"msgVisibility\">\nPlease enter either name or email</div><div class=\"md-padding\"></div><div ng-show=\"tableVisibility\" \nclass=\"md-padding scrollable\" ms-scroll><table class=\"dataTable row-border hover table-border\" datatable=\"ng\" \ndt-options=\"dataCtrl.dtOptions\"><thead><tr class=\"table-header\"><th class=\"secondary-text\"><div class=\"table-header\">\n<span class=\"column-title\">NAME</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">EMAIL</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Select</span></div></th></tr></thead><tbody><tr ng-repeat=\"member in searchedMembers[0]\"><td \nclass=\"md-padding\">{{member.firstName}} {{member.lastName}}</td><td class=\"md-padding\">{{member.email}}</td><td \nlayout=\"row\" layout-align=\"center center\"><md-button class=\"md-icon-button green-bg\" \nng-click=\"collaborateActivity($event,member.login, inboxComment)\"><md-icon class=\"white-fg\" md-font-icon=\"icon-check\">\n</md-icon><md-tooltip md-direction=\"top\">Select</md-tooltip></md-button></td></tr></tbody></table></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"center center\"><md-button type=\"button\" \nng-click=\"cancel()\">Cancel</md-button><md-button type=\"submit\" ng-click=\"userForm.$valid && save(substitute)\">Save\n</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/adminSubstitution/admin-reAssign/preview.reAssign.html","<div class=\"page-layout simple right-sidenav\" layout=\"row\" ng-init=\"reassignCtrl.getAllRequestTypes()\"><div \nclass=\"page-layout carded fullwidth md-padding scrollable\" layout=\"column\" flex ms-scroll ng-cloak><div \nclass=\"parent-tabs white-bg mb-15\"><md-tabs class=\"mh-0\"><md-tab label=\"Substitution\" ui-sref=\"app.Adminsubstitution\">\n</md-tab><md-tab label=\"Re-Assign\" ui-sref=\"app.Adminsubstitution.reAssign\" md-active=\"true\"></md-tab></md-tabs></div>\n<div class=\"widget-group\" flex=\"100\" layout=\"column\" layout-wrap><ms-widget flippable=\"true\" layout=\"column\" \nflex=\"100\" md-dynamic-height><ms-widget-front class=\"white-bg\" class=\"scrollable\" ms-scroll><div layout=\"column\" \nng-cloak style=\"flex:none\"><div layout-gt-sm=\"row\" layout-align=\"start start\" class=\"md-padding\"><md-input-container \nflex-gt-sm=\"20\" md-no-float><label>DOCTYPE</label><md-select ng-model=\"obj.requestType\"><md-option \nng-value=\"request.name\" ng-repeat=\"request in allRequests\">{{request.name}}</md-option></md-select>\n</md-input-container><span flex=\"5\"></span><md-input-container flex-gt-sm=\"20\"><input type=\"text\" name=\"name\" \nng-model=\"member.name\" placeholder=\"Name\"></md-input-container><span flex=\"5\"></span><md-input-container \nflex-gt-sm=\"20\"><input type=\"text\" name=\"email\" ng-model=\"member.email\" placeholder=\"Email\"></md-input-container><span \nflex=\"5\"></span><md-button type=\"button\" class=\"md-raised\" ng-click=\"searchMember(member)\" style=\"margin-top:2%\">\n<md-icon md-font-icon=\"icon-magnify\"></md-icon>Search</md-button></div></div><div layout=\"row\" \nlayout-align=\"center center\" ng-style=\"{\'color\':\'red\',\'font-family\':\'Verdana\',\'font-size\':\'18px\'}\" \nng-show=\"msgVisibility\">Please enter either name or email</div><div layout=\"row\" layout-align=\"start strat\"><div \nng-show=\"tableVisibility\" class=\"md-padding\" flex=\"50\"><table class=\"dataTable row-border hover table-border\" \ndatatable=\"ng\" dt-options=\"dataCtrl.dtOptions\"><thead><tr class=\"table-header\"><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Login</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">NAME</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Select</span></div></th></tr></thead><tbody><tr \nng-repeat=\"member in searchedMembers[0]\"><td class=\"md-padding\">{{member.login}}</td><td class=\"md-padding\">\n{{member.firstName}} {{member.lastName}}</td><td layout=\"row\" layout-align=\"center center\"><md-button \nclass=\"md-icon-button md-mini green-bg\" ng-click=\"getRequestIds(member.login)\"><md-icon class=\"white-fg\" \nmd-font-icon=\"icon-check\"></md-icon><md-tooltip md-direction=\"top\">Select</md-tooltip></md-button></td></tr></tbody>\n</table></div><div ng-if=\"allRequestTypes\" class=\"md-padding scrollable\" ms-scroll flex=\"50\"><table \nclass=\"dataTable row-border hover table-border\" datatable=\"ng\" dt-options=\"reassignCtrl.dtOptions\"><thead><tr \nclass=\"table-header\"><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\"><b>Request Type\n</b></span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\"><b>Agent</b>\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\"><b>Action</b></span>\n</div></th></tr></thead><tbody><tr ng-repeat=\"requestType in allRequestTypes track by $index\"><td class=\"md-padding\">\n{{requestType | uppercase}}</td><td class=\"md-padding\">{{reassignCtrl.member}}</td><td layout=\"row\" \nlayout-align=\"center center\"><md-checkbox ng-model=\"x\" ng-change=\"selectNumber(x,requestType, $index)\" \nstyle=\"margin-bottom: 0px\"></md-checkbox></td></tr></tbody></table></div></div><div layout=\"row\" \nlayout-align=\"end center\" ng-if=\"allRequestTypes\"><md-button type=\"button\" class=\"md-raised\" \nng-click=\"searchforReassignUser()\" style=\"margin-bottom: 20px\">Search User for Re-assign</md-button></div>\n</ms-widget-front></ms-widget></div></div></div>");
$templateCache.put("app/main/adminSubstitution/admin-reAssign/reAssignmentDialog.html","<md-dialog flex=\"40\" ng-init=\"getAllUsers();\"><form name=\"userForm\" novalidate \nng-submit=\"userForm.$valid && userCtrl.createUser(user)\" layout=\"column\"><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools\"><h2>Select User for Re-Assignment</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"cancel()\"><md-icon md-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"row\" flex=\"100\" \nlayout-align=\"space-between center\"><md-input-container class=\"md-block\"><input type=\"text\" name=\"name\" \nng-model=\"member.name\" placeholder=\"Name\"></md-input-container><md-input-container class=\"md-block\"><input type=\"text\" \nname=\"email\" ng-model=\"member.email\" placeholder=\"Email\"></md-input-container><md-button type=\"button\" \nclass=\"md-raised\" ng-click=\"searchMember(member)\" style=\"margin-bottom: 20px\"><md-icon md-font-icon=\"icon-magnify\">\n</md-icon>Search</md-button></div><div layout=\"row\" layout-align=\"center center\" \nng-style=\"{\'color\':\'red\',\'font-family\':\'Verdana\',\'font-size\':\'18px\'}\" ng-show=\"msgVisibility\">\nPlease enter either name or email</div><div class=\"md-padding\"></div><div ng-show=\"tableVisibility\" \nclass=\"md-padding scrollable\" ms-scroll><table class=\"dataTable row-border hover table-border\" datatable=\"ng\" \ndt-options=\"dataCtrl.dtOptions\"><thead><tr class=\"table-header\"><th class=\"secondary-text\"><div class=\"table-header\">\n<span class=\"column-title\">NAME</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">EMAIL</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Select</span></div></th></tr></thead><tbody><tr ng-repeat=\"member in searchedMembers[0]\"><td \nclass=\"md-padding\">{{member.firstName}} {{member.lastName}}</td><td class=\"md-padding\">{{member.email}}</td><td \nlayout=\"row\" layout-align=\"center center\"><md-button class=\"md-icon-button green-bg\" ng-click=\"submit(member.login)\">\n<md-icon class=\"white-fg\" md-font-icon=\"icon-check\"></md-icon><md-tooltip md-direction=\"top\">Select</md-tooltip>\n</md-button></td></tr></tbody></table></div></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"center center\"><md-button type=\"button\" ng-click=\"cancel()\">Cancel</md-button><md-button type=\"submit\" \nng-click=\"userForm.$valid && save(substitute)\">Save</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/quick-panel/tabs/activity/activity-tab.html","<md-list class=\"friends\"><md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.FRIENDS\">Friends</span>\n</md-subheader><md-list-item class=\"friend md-3-line\" ng-repeat=\"friend in vm.activities.friends\"><img \nng-src=\"{{friend.avatar}}\" class=\"md-avatar\" alt=\"{{friend.name}}\"><div class=\"status {{friend.status}}\"></div><div \nng-if=\"contact.unread\" class=\"md-accent-bg unread-message-count\">{{contact.unread}}</div><div \nclass=\"md-list-item-text\"><h3 class=\"message\">{{friend.message}}</h3><p class=\"time\">{{friend.time}}</p></div>\n</md-list-item></md-list><md-divider></md-divider><md-list class=\"servers\"><md-subheader class=\"md-no-sticky\"><span \ntranslate=\"QUICKPANEL.APP_SERVERS\">Application Servers</span></md-subheader><md-list-item class=\"server md-3-line\" \nng-repeat=\"server in vm.activities.servers\"><md-icon md-font-icon=\"icon-checkbox-blank-circle\" class=\"s16 status\" \nng-class=\"server.status\"></md-icon><div class=\"md-list-item-text\"><h3>{{server.location}}</h3><p>{{server.detail}}</p>\n</div></md-list-item></md-list><md-divider></md-divider><md-list class=\"stats\"><md-subheader class=\"md-no-sticky\"><span\n translate=\"QUICKPANEL.USER_STATS\">User Stats</span></md-subheader><md-list-item class=\"stat md-2-line\" \nng-repeat=\"stat in vm.activities.stats\"><div class=\"md-list-item-text\"><span>\n{{stat.title}} ({{stat.current}} / {{stat.total}})</span><md-progress-linear ng-class=\"stat.status\" \nmd-mode=\"determinate\" value=\"{{stat.percent}}\"></md-progress-linear></div></md-list-item></md-list>");
$templateCache.put("app/quick-panel/tabs/chat/chat-tab.html","<div class=\"main animate-slide-left\" ng-hide=\"vm.chatActive\"><md-list class=\"recent\"><md-subheader \nclass=\"md-no-sticky\"><span translate=\"QUICKPANEL.RECENT\">Recent</span></md-subheader><md-list-item \nclass=\"contact md-3-line\" ng-repeat=\"contact in vm.contacts.recent\" ng-click=\"vm.toggleChat(contact)\"><img \nng-src=\"{{contact.avatar}}\" class=\"md-avatar\" alt=\"{{contact.name}}\"><div class=\"status {{contact.status}}\"></div><div \nng-if=\"contact.unread\" class=\"md-accent-bg unread-message-count\">{{contact.unread}}</div><div \nclass=\"md-list-item-text\"><h3>{{contact.name}}</h3><p class=\"last-message\">{{contact.lastMessage}}</p></div>\n</md-list-item></md-list><md-divider></md-divider><md-list class=\"all\"><md-subheader class=\"md-no-sticky\"><span \ntranslate=\"QUICKPANEL.START_NEW_CHAT\">Start New Chat</span></md-subheader><md-list-item class=\"contact\" \nng-repeat=\"contact in vm.contacts.all\" ng-click=\"vm.toggleChat(contact)\"><img ng-src=\"{{contact.avatar}}\" \nclass=\"md-avatar\" alt=\"{{contact.name}}\"><div class=\"status {{contact.status}}\"></div><div class=\"md-list-item-text\">\n<h3>{{contact.name}}</h3></div></md-list-item></md-list><md-divider></md-divider></div><div \nclass=\"chat animate-slide-right\" ng-show=\"vm.chatActive\" layout=\"column\"><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"md-icon-button\" ng-click=\"vm.toggleChat()\" aria-label=\"Back\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.BACK\"><md-icon md-font-icon=\"icon-keyboard-backspace\"></md-icon></md-button><h4>\n<span>{{vm.chat.contact.name}}</span></h4></div><div layout=\"row\" layout-align=\"end center\"><md-button \nclass=\"md-icon-button\" aria-label=\"Call\" translate translate-attr-aria-label=\"QUICKPANEL.CALL\"><md-icon \nmd-font-icon=\"icon-phone\"></md-icon></md-button><md-button class=\"md-icon-button\" aria-label=\"More\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.MORE\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button></div>\n</div></md-toolbar><md-content flex layout-paddings ms-scroll id=\"chat-dialog\"><div layout=\"row\" \nng-repeat=\"dialog in vm.chat.contact.dialog\" class=\"md-padding message-row\" ng-class=\"dialog.who\"><img \nng-if=\"dialog.who ===\'contact\'\" ng-src=\"{{vm.chat.contact.avatar}}\" class=\"avatar\" alt=\"{{vm.chat.contact.name}}\"> <img\n ng-if=\"dialog.who ===\'user\'\" class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><div class=\"bubble\" flex><div \nclass=\"message\">{{dialog.message}}</div><div class=\"time secondary-text\">{{dialog.time}}</div></div></div></md-content>\n<form ng-submit=\"vm.reply()\" layout=\"row\" class=\"reply\" layout-align=\"start center\"><textarea \nng-keyup=\"$event.keyCode == 13 ? vm.reply() : null\" flex ng-model=\"vm.replyMessage\" \nplaceholder=\"Type and hit enter to send message\" translate translate-attr-placeholder=\"QUICKPANEL.REPLY_PLACEHOLDER\">\n</textarea><md-button class=\"md-fab md-mini\" type=\"submit\" aria-label=\"Send message\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.SEND_MESSAGE\"><md-icon md-font-icon=\"icon-send\"></md-icon></md-button></form>\n</div>");
$templateCache.put("app/quick-panel/tabs/today/today-tab.html","<md-list class=\"date\"><md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.TODAY\">Today</span></md-subheader>\n<md-list-item class=\"md-display-1 md-2-line\" layout=\"column\" layout-align=\"start start\"><div class=\"secondary-text\">\n<div>{{vm.date | date:\'EEEE\'}}</div><div layout=\"row\" layout-align=\"start start\"><span>{{vm.date | date:\'d\'}}</span> \n<span class=\"md-subhead\">th</span> <span>{{vm.date | date:\'MMMM\'}}</span></div></div></md-list-item></md-list>\n<md-divider></md-divider><md-list><md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.EVENTS\">Events</span>\n</md-subheader><md-list-item class=\"md-2-line\" ng-repeat=\"event in vm.events\" ng-click=\"dummyFunction()\"><div \nclass=\"md-list-item-text\"><h3>{{event.title}}</h3><p>{{event.detail}}</p></div></md-list-item></md-list><md-divider>\n</md-divider><md-list><md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.NOTES\">Notes</span></md-subheader>\n<md-list-item class=\"md-2-line\" ng-repeat=\"note in vm.notes\" ng-click=\"dummyFunction()\"><div class=\"md-list-item-text\">\n<h3>{{note.title}}</h3><p>{{note.detail}}</p></div></md-list-item></md-list><md-divider></md-divider><md-list>\n<md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.QUICK_SETTINGS\">Quick Settings</span></md-subheader>\n<md-list-item><h3 translate=\"QUICKPANEL.NOTIFICATIONS\">Notifications</h3><md-switch class=\"md-secondary\" \nng-model=\"vm.settings.notify\" aria-label=\"Notifications\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.NOTIFICATIONS\"></md-switch></md-list-item><md-list-item><h3 \ntranslate=\"QUICKPANEL.CLOUD_SYNC\">Cloud Sync</h3><md-switch class=\"md-secondary\" ng-model=\"vm.settings.cloud\" \naria-label=\"Cloud Sync\" translate translate-attr-aria-label=\"QUICKPANEL.CLOUD_SYNC\"></md-switch></md-list-item>\n<md-list-item><h3 translate=\"QUICKPANEL.RETRO_THRUSTERS\">Retro Thrusters</h3><md-switch class=\"md-secondary md-warn\" \nng-model=\"vm.settings.retro\" aria-label=\"Retro Thrusters\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.RETRO_THRUSTERS\"></md-switch></md-list-item></md-list>");
$templateCache.put("app/main/business-admin/business-ExpenseTypes/ExpenseTypes.html","<div class=\"page-layout simple right-sidenav\" layout=\"row\"><div \nclass=\"page-layout carded fullwidth md-padding scrollable\" layout=\"column\" flex ms-scroll><div class=\"widget-group\" \nflex=\"100\" layout=\"column\" layout-wrap><ms-widget flippable=\"true\" class=\"no-padding\"><div \nclass=\"md-padding white-bg scrollable\" ms-scroll><div class=\"md-padding white-bg\" ng-init=\"List()\"><div \nclass=\"previous-state c-p\" data-ng-click=\"goToPreviousState()\"><span><span class=\"icon-arrow-left-bold-circle-outline\">\n</span> Back </span></div><table class=\"dataTable row-border hover table-border\" datatable=\"ng\" \ndt-options=\"expenseCtrl.dtOptions\" layout-wrap ng-if=\"inputfield != \'\'\"><thead><tr class=\"table-header\"><th \nclass=\"secondary-text\" ng-hide=\"value == \'_id\'\" ng-repeat=\"(key, value) in inputfield\"><div class=\"table-header\"><span \nclass=\"column-title\">{{value}}</span></div></th><th class=\"secondary-text\"><div class=\"table-header\" layout=\"row\" \nlayout-align=\"center center\"><span class=\"column-title\">Actions</span></div></th></tr></thead><tbody><tr \nng-repeat=\"(key, value) in EmployeesList track by $index\"><td ng-hide=\"k == \'_id\'\" \nng-repeat=\"(k, v) in EmployeesList[$index] track by $index\">{{v}}</td><td layout=\"row\" layout-align=\"center center\" \nstyle=\"padding-top:0px !important;padding-bottom:0px !important\"><md-button class=\"md-icon-button test-tooltip\" \naria-label=\"Update\" ng-click=\"updateEmployee($event,EmployeesList[$index])\"><md-tooltip md-direction=\"top\">Update\n</md-tooltip><md-icon><i layout=\"row\" layout-align=\"center center\" class=\"icon icon-pencil s18\"></i></md-icon>\n</md-button><md-button class=\"md-icon-button test-tooltip\" aria-label=\"Delete\" \nng-click=\"deletedata($event,EmployeesList[$index]) \"><md-tooltip md-direction=\"top\">Delete</md-tooltip><md-icon><i \nlayout=\"row\" layout-align=\"center center\" class=\"icon icon-delete s18\"></i></md-icon></md-button></td></tr></tbody>\n</table><div ng-if=\"inputfield == undefined\"><h1>No Data Available</h1></div></div></div></ms-widget><md-button \nflow-btn class=\"md-fab grey-700-bg md-mini md-fab-bottom-right\" ng-click=\"createEmployee()\"><md-icon \nmd-font-icon=\"icon-plus\" class=\"white-fg\"></md-icon><md-tooltip md-direction=\"top\">Create Employee</md-tooltip>\n</md-button></div></div></div>");
$templateCache.put("app/main/business-admin/business-ExpenseTypes/create.ExpenseType.dialog.html","<md-dialog aria-label=\"Add List\" flex=\"45\"><form name=\"listForm\" novalidate layout=\"column\"><md-toolbar \nclass=\"md-accent\"><div class=\"md-toolbar-tools\"><h2>Create Detail</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><div layout=\"column\"><md-input-container class=\"md-block\" flex=\"45\" \nng-if=\"list != \'_id\'\" ng-repeat=\"list in attrdata track by $index\"><label>{{list}}</label><input type=\"text\" \nname=\"arrval\" ng-model=\"crlist[$index].list\" required><div ng-messages=\"listForm.list.$error\" role=\"alert\"><div \nng-message=\"required\"><span>{{list}} is required</span></div><div ng-message=\"pattern\"><span>\n{{list}} has invalid characters</span></div></div></md-input-container></div></md-dialog-content><md-dialog-actions \nlayout=\"row\" layout-align=\"center center\"><md-button type=\"button\" ng-click=\"cancel()\">Cancel</md-button><md-button \ntype=\"submit\" ng-click=\"listForm.$valid && save()\">Save</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/business-admin/business-ExpenseTypes/update.ExpenseType.dialog.html","<md-dialog aria-label=\"Add List\" flex=\"45\"><form name=\"listForm\" novalidate \nng-submit=\"listForm.$valid && updatedata()\" layout=\"column\"><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools\"><h2>Update Detail</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\">\n<md-icon md-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><div layout=\"column\"><md-input-container class=\"md-block\" flex=\"45\" \nng-hide=\"key == \'_id\'\" ng-repeat=\"(key, value) in currentdata track by $index\"><label>{{key}}</label><input \ntype=\"text\" name=\"arrval\" ng-init=\"updateddata[$index] = value\" ng-model=\"updateddata[$index]\" required><div \nng-messages=\"listForm.$error\" role=\"alert\"><div ng-message=\"required\"><span>{{key}} is required</span></div><div \nng-message=\"pattern\"><span>{{key}} has invalid characters</span></div></div></md-input-container></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"center center\"><md-button type=\"button\" \nng-click=\"cancel()\">Cancel</md-button><md-button type=\"submit\">update</md-button></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/business-admin/business-POTypes/POTypes.html","<div class=\"page-layout simple right-sidenav\" layout=\"row\"><div \nclass=\"page-layout carded fullwidth md-padding scrollable\" layout=\"column\" flex ms-scroll><div class=\"widget-group\" \nflex=\"100\" layout=\"column\" layout-wrap><ms-widget flippable=\"true\" class=\"no-padding\"><div \nclass=\"md-padding white-bg scrollable\" ms-scroll><div class=\"md-padding white-bg\" ng-init=\"List()\"><div \nclass=\"previous-state c-p\" data-ng-click=\"goToPreviousState()\"><span><span class=\"icon-arrow-left-bold-circle-outline\">\n</span> Back </span></div><table class=\"dataTable row-border hover table-border\" datatable=\"ng\" \ndt-options=\"POTypeCtrl.dtOptions\" layout-wrap ng-if=\"inputfield != \'\'\"><thead><tr class=\"table-header\"><th \nclass=\"secondary-text\" ng-hide=\"value == \'_id\'\" ng-repeat=\"(key, value) in inputfield\"><div class=\"table-header\"><span \nclass=\"column-title\">{{value}}</span></div></th><th class=\"secondary-text\"><div class=\"table-header\" layout=\"row\" \nlayout-align=\"center center\"><span class=\"column-title\">Actions</span></div></th></tr></thead><tbody><tr \nng-repeat=\"(key, value) in CustomersList track by $index\"><td ng-hide=\"k == \'_id\'\" \nng-repeat=\"(k, v) in CustomersList[$index] track by $index\">{{v}}</td><td layout=\"row\" layout-align=\"center center\" \nstyle=\"padding-top:0px !important;padding-bottom:0px !important\"><md-button class=\"md-icon-button test-tooltip\" \naria-label=\"Update\" ng-click=\"updateCustomer($event,CustomersList[$index])\"><md-tooltip md-direction=\"top\">Update\n</md-tooltip><md-icon><i layout=\"row\" layout-align=\"center center\" class=\"icon icon-pencil s18\"></i></md-icon>\n</md-button><md-button class=\"md-icon-button test-tooltip\" aria-label=\"Delete\" \nng-click=\"deletedata($event,CustomersList[$index]) \"><md-tooltip md-direction=\"top\">Delete</md-tooltip><md-icon><i \nlayout=\"row\" layout-align=\"center center\" class=\"icon icon-delete s18\"></i></md-icon></md-button></td></tr></tbody>\n</table><div ng-if=\"inputfield == undefined\"><h1>No Data Available</h1></div></div></div></ms-widget><md-button \nflow-btn class=\"md-fab grey-700-bg md-mini md-fab-bottom-right\" ng-click=\"createCustomer()\"><md-icon \nmd-font-icon=\"icon-plus\" class=\"white-fg\"></md-icon><md-tooltip md-direction=\"top\">Create Customer</md-tooltip>\n</md-button></div></div></div>");
$templateCache.put("app/main/business-admin/business-POTypes/create.POType.dialog.html","<md-dialog aria-label=\"Add List\" flex=\"45\"><form name=\"listForm\" novalidate layout=\"column\"><md-toolbar \nclass=\"md-accent\"><div class=\"md-toolbar-tools\"><h2>Create Detail</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><div layout=\"column\"><md-input-container class=\"md-block\" flex=\"45\" \nng-if=\"list != \'_id\'\" ng-repeat=\"list in attrdata track by $index\"><label>{{list}}</label><input type=\"text\" \nname=\"arrval\" ng-model=\"crlist[$index].list\" required><div ng-messages=\"listForm.list.$error\" role=\"alert\"><div \nng-message=\"required\"><span>{{list}} is required</span></div><div ng-message=\"pattern\"><span>\n{{list}} has invalid characters</span></div></div></md-input-container></div></md-dialog-content><md-dialog-actions \nlayout=\"row\" layout-align=\"center center\"><md-button type=\"button\" ng-click=\"cancel()\">Cancel</md-button><md-button \ntype=\"submit\" ng-click=\"listForm.$valid && save()\">Save</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/business-admin/business-POTypes/update.POType.dialog.html","<md-dialog aria-label=\"Add List\" flex=\"45\"><form name=\"listForm\" novalidate \nng-submit=\"listForm.$valid && updatedata()\" layout=\"column\"><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools\"><h2>Update Detail</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\">\n<md-icon md-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><div layout=\"column\"><md-input-container class=\"md-block\" flex=\"45\" \nng-hide=\"key == \'_id\'\" ng-repeat=\"(key, value) in currentdata track by $index\"><label>{{key}}</label><input \ntype=\"text\" name=\"arrval\" ng-init=\"updateddata[$index] = value\" ng-model=\"updateddata[$index]\" required><div \nng-messages=\"listForm.$error\" role=\"alert\"><div ng-message=\"required\"><span>{{key}} is required</span></div><div \nng-message=\"pattern\"><span>{{key}} has invalid characters</span></div></div></md-input-container></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"center center\"><md-button type=\"button\" \nng-click=\"cancel()\">Cancel</md-button><md-button type=\"submit\" ng-click=\"updatedata()\">update</md-button>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/business-admin/business-PRTypes/PRTypes.html","<div class=\"page-layout simple right-sidenav\" layout=\"row\"><div \nclass=\"page-layout carded fullwidth md-padding scrollable\" layout=\"column\" flex ms-scroll><div class=\"widget-group\" \nflex=\"100\" layout=\"column\" layout-wrap><ms-widget flippable=\"true\" class=\"no-padding\"><div \nclass=\"md-padding white-bg scrollable\" ms-scroll><div class=\"md-padding white-bg\" ng-init=\"List()\"><div \nclass=\"previous-state c-p\" data-ng-click=\"goToPreviousState()\"><span><span class=\"icon-arrow-left-bold-circle-outline\">\n</span> Back </span></div><table class=\"dataTable row-border hover table-border\" datatable=\"ng\" \ndt-options=\"customerCtrl.dtOptions\" layout-wrap ng-if=\"inputfield != \'\'\"><thead><tr class=\"table-header\"><th \nclass=\"secondary-text\" ng-hide=\"value == \'_id\'\" ng-repeat=\"(key, value) in inputfield\"><div class=\"table-header\"><span \nclass=\"column-title\">{{value}}</span></div></th><th class=\"secondary-text\"><div class=\"table-header\" layout=\"row\" \nlayout-align=\"center center\"><span class=\"column-title\">Actions</span></div></th></tr></thead><tbody><tr \nng-repeat=\"(key, value) in CustomersList track by $index\"><td ng-hide=\"k == \'_id\'\" \nng-repeat=\"(k, v) in CustomersList[$index] track by $index\">{{v}}</td><td layout=\"row\" layout-align=\"center center\" \nstyle=\"padding-top:0px !important;padding-bottom:0px !important\"><md-button class=\"md-icon-button test-tooltip\" \naria-label=\"Update\" ng-click=\"updateCustomer($event,CustomersList[$index])\"><md-tooltip md-direction=\"top\">Update\n</md-tooltip><md-icon><i layout=\"row\" layout-align=\"center center\" class=\"icon icon-pencil s18\"></i></md-icon>\n</md-button><md-button class=\"md-icon-button test-tooltip\" aria-label=\"Delete\" \nng-click=\"deletedata($event,CustomersList[$index]) \"><md-tooltip md-direction=\"top\">Delete</md-tooltip><md-icon><i \nlayout=\"row\" layout-align=\"center center\" class=\"icon icon-delete s18\"></i></md-icon></md-button></td></tr></tbody>\n</table><div ng-if=\"inputfield == undefined\"><h1>No Data Available</h1></div></div></div></ms-widget><md-button \nflow-btn class=\"md-fab grey-700-bg md-mini md-fab-bottom-right\" ng-click=\"createCustomer()\"><md-icon \nmd-font-icon=\"icon-plus\" class=\"white-fg\"></md-icon><md-tooltip md-direction=\"top\">Create Customer</md-tooltip>\n</md-button></div></div></div>");
$templateCache.put("app/main/business-admin/business-PRTypes/create.PRType.dialog.html","<md-dialog aria-label=\"Add List\" flex=\"45\"><form name=\"listForm\" novalidate layout=\"column\"><md-toolbar \nclass=\"md-accent\"><div class=\"md-toolbar-tools\"><h2>Create Detail</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><div layout=\"column\"><md-input-container class=\"md-block\" flex=\"45\" \nng-if=\"list != \'_id\'\" ng-repeat=\"list in attrdata track by $index\"><label>{{list}}</label><input type=\"text\" \nname=\"arrval\" ng-model=\"crlist[$index].list\" required><div ng-messages=\"listForm.list.$error\" role=\"alert\"><div \nng-message=\"required\"><span>{{list}} is required</span></div><div ng-message=\"pattern\"><span>\n{{list}} has invalid characters</span></div></div></md-input-container></div></md-dialog-content><md-dialog-actions \nlayout=\"row\" layout-align=\"center center\"><md-button type=\"button\" ng-click=\"cancel()\">Cancel</md-button><md-button \ntype=\"submit\" ng-click=\"listForm.$valid && save()\">Save</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/business-admin/business-PRTypes/update.PRType.dialog.html","<md-dialog aria-label=\"Add List\" flex=\"45\"><form name=\"listForm\" novalidate \nng-submit=\"listForm.$valid && updatedata()\" layout=\"column\"><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools\"><h2>Update Detail</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\">\n<md-icon md-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><div layout=\"column\"><md-input-container class=\"md-block\" flex=\"45\" \nng-hide=\"key == \'_id\'\" ng-repeat=\"(key, value) in currentdata track by $index\"><label>{{key}}</label><input \ntype=\"text\" name=\"arrval\" ng-init=\"updateddata[$index] = value\" ng-model=\"updateddata[$index]\" required><div \nng-messages=\"listForm.$error\" role=\"alert\"><div ng-message=\"required\"><span>{{key}} is required</span></div><div \nng-message=\"pattern\"><span>{{key}} has invalid characters</span></div></div></md-input-container></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"center center\"><md-button type=\"button\" \nng-click=\"cancel()\">Cancel</md-button><md-button type=\"submit\" ng-click=\"updatedata()\">update</md-button>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/Main_Inbox/inbox_details/collaborateUser.html","<style>.md-button {\n         text-transform: none !important;\n        }</style><md-dialog aria-label=\"comments\" \nflex=\"40\"><form ng-cloak><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2>Collaborate</h2><span flex>\n</span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><div layout=\"column\" layout-align=\"start center\"><div class=\"h2\">\n<span>Select the user to Collaborate?</span></div><div><div layout=\"row\" layout-align=\"center center\"><input \ntype=\"text\" ng-model=\"sampleheader.person\" list=\"names\" \nstyle=\"border: 1px solid rgb(169, 161, 161);border-radius: 3px;height: 30px\"><datalist id=\"names\" class=\"form-control\" \nng-model=\"sampleheader.person \"><option value=\"\">-- select an option --</option><option \nng-repeat=\"person in users | filter:search \" ng-value=\"person.login\">{{person.firstName}}-{{person.lastName}}</option>\n</datalist></div><div><md-input-container class=\"md-block\"><label>Comments</label><textarea ng-model=\"comments\" \nmd-maxlength=\"150\" rows=\"5\" md-select-on-focus style=\"border: 1px solid rgb(169, 161, 161);border-radius: 5px\">\n</textarea></md-input-container></div><div class=\"md-padding\" ng-if=\"collaborate.user\"><table \nclass=\"dataTable row-border hover\"><thead><tr><th>Login</th><th>FirstName</th><th>LastName</th><th>Email</th></tr>\n</thead><tbody><tr><td>{{collaborate.user.login}}</td><td>{{collaborate.user.firstName}}</td><td>\n{{collaborate.user.lastName}}</td><td>{{collaborate.user.email}}</td></tr></tbody></table></div></div></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"end end\"><md-button ng-click=\"cancel()\">Cancel\n</md-button><md-button ng-click=\"collaborateActivity($event,user,comments)\" class=\"md-warn\">Collaborate</md-button>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/Main_Inbox/inbox_details/inbox_details.html","<link rel=\"stylesheet\" href=\"https://cdnjs.cloudflare.com/ajax/libs/select2/3.4.5/select2.css\"><link rel=\"stylesheet\" \nhref=\"https://cdnjs.cloudflare.com/ajax/libs/selectize.js/0.8.5/css/selectize.default.css\"><link rel=\"stylesheet\" \nhref=\"https://stackpath.bootstrapcdn.com/bootstrap/4.2.1/css/bootstrap.min.css\"><style>\n.table-header{\n    background-color: #fbfbfc !important;\n    text-transform: none;\n}\n.select2-container .select2-choice > .select2-chosen {\n    color: black;\n    }\n    .dataTables_length{\n        display: none;\n    }\n    .dataTables_filter {\n    display: none;\n    }\n    table.dataTable tbody td {\n    padding: 6px 8px !important;\n    }\n    .md-button {\n    text-transform: none;\n    }\n</style><div class=\"page-layout simple tabbed\" layout=\"column\"><div layout=\"row\" layout-align=\"start center\" \nstyle=\"min-height: 53px\"><div class=\"white-fg\" layout=\"row\" layout-align=\"start center\" flex><md-button \nclass=\"goto-orders-button md-icon-button\" aria-label=\"Go to orders\" ng-click=\"gotoOrders()\"><md-icon \nmd-font-icon=\"icon-arrow-left\" style=\"color: black\"></md-icon></md-button><div layout=\"column\" \nlayout-align=\"start start\"><div class=\"h2\" style=\"color: black\"><span>Invoice Details:</span> <span>{{id}}</span></div>\n<div class=\"subtitle secondary-text\"><span></span></div></div></div></div><md-divider></md-divider><div \nclass=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget layout=\"column\" flex=\"50\" flex-xs=\"100\">\n<ms-widget-front class=\"white-bg\"><md-content><span class=\"h2 md-padding\">Summary</span><md-divider></md-divider><div \nlayout=\"row\" layout-align=\"space-between center\" layout-xs=\"column\"><div class=\"md-padding\"><div layout=\"column\">\n<md-input-container class=\"md-block margin\"><label>Invoice Type</label><md-select ng-model=\"header.INVOICE_CAT\" \nplaceholder=\"Invoice Type\" class=\"md-no-underline\" \nstyle=\"border: 1px solid rgb(169, 161, 161);margin-bottom: -4%;border-radius: 5px;height: 35px\"><md-option \nng-repeat=\"invoiceType in invoiceTypes\" ng-value=\"invoiceType.Value\" ng-click=\"selectGroupCode(invoiceType)\">\n{{invoiceType.Description}}</md-option></md-select></md-input-container><div layout=\"row\" layout-xs=\"column\">\n<md-input-container class=\"md-block margin\" style=\"margin-top: 10px !important\"><input ng-model=\"header.XBLNR\" \ntype=\"text\" placeholder=\"Invoice No\" \nstyle=\"border: 1px solid rgb(169, 161, 161);border-radius: 5px;margin-bottom: -25%;height: 35px\"></md-input-container>\n<md-input-container class=\"md-block margin\" style=\"margin-top: 10px !important\"><div moment-picker=\"header.BLDAT\" \nformat=\"DD-MM-YYYY\" today=\"true\" start-view=\"month\"><input \nstyle=\"border: 1px solid rgb(169, 161, 161);border-radius: 5px;margin-bottom: -25%;height: 35px\" \nng-model=\"header.BLDAT\" placeholder=\"Invoice Date\"></div></md-input-container></div><div layout=\"row\" \nlayout-xs=\"column\"><md-input-container class=\"md-block margin\" style=\"margin-top: 10px !important\"><input \nng-model=\"header.WRBTR\" type=\"text\" placeholder=\"Amount\" \nstyle=\"border: 1px solid rgb(169, 161, 161);border-radius: 5px;margin-bottom: -25%;height: 35px\"></md-input-container>\n<md-input-container class=\"md-block margin\" style=\"margin-top: 10px !important\"><label>Currency</label><md-select \nng-model=\"header.WAERS\" placeholder=\"Currency\" class=\"md-no-underline\" \nstyle=\"border: 1px solid rgb(169, 161, 161);margin-bottom: -4%;border-radius: 5px;height: 35px\"><md-option value=\"INR\">\nINR</md-option><md-option value=\"USD\">USD</md-option></md-select></md-input-container></div><md-input-container \nclass=\"md-block margin\" style=\"margin-top: 7px !important\"><label>Requester</label><md-select \nng-model=\"header.REQUESTOR\" placeholder=\"Requester\" class=\"md-no-underline\" \nstyle=\"border: 1px solid rgb(169, 161, 161);margin-bottom: -4%;border-radius: 5px;height: 35px\"><md-option \nng-repeat=\"requestor in AllRequestors\" ng-value=\"requestor.requeterId\">{{requestor.firstName}}{{requestor.lastName}}\n</md-option></md-select></md-input-container></div></div><div layout=\"column\"><div class=\"md-padding\"><ui-select \nng-model=\"sampleheader.vendor\" theme=\"select2\" style=\"min-width: 250px\" title=\"Choose a taskgroup\" \nappend-to-body=\"true\"><ui-select-match placeholder=\"Select Vendor\">{{$select.selected.vendorName}}</ui-select-match>\n<ui-select-choices \nrepeat=\"person in Allvenodrs | propsFilter: {vendorName: $select.search, vendorCode: $select.search}\"><div \nng-bind-html=\"person.vendorName | highlight: $select.search\"></div><small>Vendor Code: {{person.vendorCode}}</small>\n</ui-select-choices></ui-select><div class=\"issuer md-white-bg\" style=\"border: 1px solid grey;border-radius: 4px\" \nlayout=\"row\" layout-align=\"start center\"><div class=\"info md-padding\"><span><b>Vendor</b></span><div class=\"title\">\n{{sampleheader.vendor.vendorName}}</div><div class=\"address\">{{sampleheader.vendor.address1}}</div><div class=\"phone\">\n{{sampleheader.vendor.address2}}</div><div class=\"website\">{{sampleheader.vendor.zip}}</div></div></div></div><div \nclass=\"md-padding\"><ui-select ng-model=\"sampleheader.company\" theme=\"select2\" style=\"min-width: 250px\" \ntitle=\"Choose a taskgroup\" append-to-body=\"true\"><ui-select-match placeholder=\"Select Company\">\n{{$select.selected.companyName}}</ui-select-match><ui-select-choices \nrepeat=\"person in Allcompanies | propsFilter: {companyName: $select.search, vendorCode: $select.search}\"><div \nng-bind-html=\"person.companyName | highlight: $select.search\"></div><small>Company Code: {{person.companyCode}}</small>\n</ui-select-choices></ui-select><div class=\"issuer md-white-bg white-frame 10dp\" \nstyle=\"border: 1px solid grey;border-radius: 4px\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"info md-padding\"><span><b>Company</b></span><div class=\"title\">{{sampleheader.company.companyName}}</div><div \nclass=\"address\">{{sampleheader.company.address1}}</div><div class=\"phone\">{{sampleheader.company.address2}}</div><div \nclass=\"email\">{{sampleheader.company.email}}</div><div class=\"website\">{{sampleheader.company.zip}}</div></div></div>\n</div></div></div><div><md-divider></md-divider><div layout=\"row\" layout-align=\"space-between center\"><div><span \nclass=\"h2 md-padding\">Lines</span></div><div layout=\"row\"><div style=\"padding: 6px\"><md-button class=\"md-raised\" \nng-click=\"recommended()\">Recommended<md-icon md-font-icon=\"icon-checkbox-multiple-blank-outline\"></md-icon></md-button>\n</div><div style=\"padding: 6px\"><md-button class=\"md-raised\" ng-click=\"addLineItem()\">Add Line<md-icon \nmd-font-icon=\"icon-tooltip-outline-plus\"></md-icon></md-button></div><div style=\"padding: 6px\"><md-button \nclass=\"md-raised\" ng-click=\"logs()\">Logs<md-icon md-font-icon=\"icon-comment-outline\"></md-icon></md-button></div></div>\n</div><md-divider></md-divider><div class=\"content fullpage-datatable\" layout=\"column\" flex><table \nclass=\"dataTable row-border hover\" datatable=\"ng\"><thead><tr><th>G/L Account</th><th>Cost Center</th><th>Amount</th>\n</tr></thead><tbody><tr ng-repeat=\"item in lineItems\" class=\"c-p\"><td><md-input-container class=\"md-block margin\" \nstyle=\"margin-top: 10px !important\"><input ng-model=\"item.HKONT\" type=\"text\" placeholder=\"G/L Account\" \nstyle=\"border: 1px solid rgb(169, 161, 161);border-radius: 5px;margin-bottom: -25%;height: 35px\"></md-input-container>\n</td><td><md-input-container class=\"md-block margin\" style=\"margin-top: 10px !important\"><input ng-model=\"item.KOSTL\" \ntype=\"text\" placeholder=\"Cost Center\" \nstyle=\"border: 1px solid rgb(169, 161, 161);border-radius: 5px;margin-bottom: -25%;height: 35px\"></md-input-container>\n</td><td><div layout=\"row\"><md-input-container class=\"md-block margin\" style=\"margin-top: 10px !important\"><input \nng-model=\"item.WRBTR\" type=\"text\" placeholder=\"Amount\" \nstyle=\"border: 1px solid rgb(169, 161, 161);border-radius: 5px;margin-bottom: -25%;height: 35px\"></md-input-container>\n<md-icon md-font-icon=\"icon-delete\" class=\"md-warn\" ng-click=\"deleteworkItem($index)\"><md-tooltip>Delete</md-tooltip>\n</md-icon></div></td></tr></tbody></table></div><div layout=\"row\" layout-align=\"end end\"><div class=\"md-padding\">\n<md-icon md-font-icon=\"icon-keyboard-return\" class=\"md-warn\" ng-click=\"ReturnToSupplier()\"><md-tooltip>\nReturn To Supplier</md-tooltip></md-icon></div><div class=\"md-padding\"><span \nng-repeat=\"actvity in workitemInfo.activities\" data-ng-click=\"processActvity(actvity, $event);\" class=\"md-padding\">\n<md-tooltip md-direction=\"top\">{{actvity.buttonText}}</md-tooltip><md-icon class=\"icon s-18 green-fg\" \nmd-font-icon=\"icon-check\" ng-if=\"actvity.buttonText==\'Approve\'\"></md-icon><md-icon class=\"icon s-18 red-fg\" \nmd-font-icon=\"icon-close\" ng-if=\"actvity.buttonText==\'Reject\'\"></md-icon></span></div><div class=\"md-padding\"><md-icon \nmd-font-icon=\"icon-twitter-retweet\" class=\"md-accent\" ng-click=\"Collaborate()\"><md-tooltip>Collaborate</md-tooltip>\n</md-icon></div></div></div></md-content></ms-widget-front></ms-widget><ms-widget layout=\"column\" flex=\"50\" hide-xs>\n<ms-widget-front class=\"white-bg\"><md-content><div class=\"md-padding\"><div class=\"h3\">Preview</div><md-divider>\n</md-divider><iframe style=\"width: 100%; height: 1000px\" ng-src=\"{{trustSrc(DetailsCtrl.url)}}\"></iframe></div>\n</md-content></ms-widget-front></ms-widget></div></div>");
$templateCache.put("app/main/Main_Inbox/inbox_details/logs.html","<style>.disabled {\n       pointer-events: none;\n       }\n    md-tabs-canvas{\n        background-color: white;\n        }\n</style><md-dialog flex=\"90\" flex-gt-sm=\"75\" flex-md=\"75\" flex-gt-md=\"75\" style=\"height:85% !important\" \nng-init=\"loadApprovalMatrix()\"><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2>Invoice Logs</h2><span \nflex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content class=\"scrollable\" ms-scroll><md-content><div \nstyle=\"background:#dcecf0\" class=\"md-padding\"><div layout=\"row\" layout-align=\"space-between center\"><div><span \nclass=\"h3\" style=\"font-family: verdana\">Invoice No </span><span class=\"h3\" \nstyle=\"font-family: verdana;color: rgb(38, 161, 242)\">\n{{report.requestId.substr(4,report.requestId.length-2) | uppercase}}</span></div></div></div><div><md-tabs \nmd-dynamic-height><md-tab><md-tab-label style=\"padding-bottom:50px !important\">COMMENTS</md-tab-label><md-tab-body \nclass=\"md-padding scrollable\" ms-scroll><div class=\"md-padding\"><timeline><timeline-event \nng-repeat=\"log in log | orderBy:\'-\'\" side=\"\"><timeline-badge style=\"background-color: rgb(3,155,229)\"><md-icon \nmd-font-icon=\"{{log.icon}}\" class=\"s25 icon white-fg\" style=\"color:white !important\"></md-icon></timeline-badge>\n<timeline-panel class=\"{{\'info\'}}\" style=\"background-color: #f1eded\"><timeline-heading><div layout=\"row\" \nlayout-align=\"end end\"><p><b>Date : {{log.endDate.substr(6,2)}}-{{log.endDate.substr(4,2)}}-{{log.endDate.substr(0,4)}}\n</b></p></div><div layout=\"row\" layout-align=\"start center\" style=\"color:black\"><img \nng-src=\"assets\\images\\avatars/Nora.jpg\" class=\"md-avatar\" style=\"border-radius:50% !important;width:13%; height:auto\">\n<div class=\"h3\">{{log.actualUser}} {{log.activityText}}</div></div></timeline-heading><div layout=\"row\" \nlayout-align=\"start start\" style=\"padding-left: 2%\"><div class=\"text pt-16\">{{log.comments}}</div></div>\n</timeline-panel></timeline-event></timeline></div></md-tab-body></md-tab><md-tab><md-tab-label>ATTACHMENTS\n</md-tab-label><md-tab-body class=\"md-padding scrollable\" ms-scroll ng-style=\"{\'border\': \'1px solid #cccccc\'}\"><div \nclass=\"md-padding\" layout=\"row\" layout-align=\"space-between center\"><span class=\"h2\">Attachments</span> <span \nclass=\"h3\">{{report.attachments.length}}</span></div><div><md-list><md-list-item class=\"md-3-line\" \nng-repeat=\"attachment in report.attachments\"><div layout=\"row\" flex=\"100\" \nng-click=\"preview($event,attachment,report.requestId,attachment.url)\"><div flex=\"5\" layout=\"row\" \nlayout-align=\"center center\"><md-icon md-font-icon=\"{{fileIcon(attachment.fileType)}}\" class=\"s42 icon md-accent\">\n</md-icon></div><div flex=\"60\"><div class=\"md-list-item-text\"><h3><b>{{attachment.fileName}}</b></h3><h3>\nCreated By : {{attachment.creator}}</h3></div></div><div flex=\"30\"><h3>Created On : {{attachment.createDate }}</h3>\n</div><md-divider ng-if=\"!$last\"></md-divider></div></md-list-item></md-list></div></md-tab-body></md-tab></md-tabs>\n</div></md-content></md-dialog-content><md-dialog-actions><div layout=\"row\" layout-align=\"center center\"><md-button \nclass=\"md-raised\" ng-click=\"cancel()\">Ok</md-button></div></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/Main_Inbox/inbox_details/returnComments.html","<style>.md-button {\n text-transform: none !important;\n}</style><md-dialog aria-label=\"comments\" flex=\"40\"><form \nng-cloak><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2>Return To Supplier</h2><span flex></span>\n<md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><div layout=\"column\" layout-align=\"start center\"><div class=\"h2\">\n<span>What is the reason for the Return To Supplier?</span></div><div><md-input-container class=\"md-block margin\" \nstyle=\"width: 414px\"><label>Reason</label><md-select ng-model=\"lineitem.employeeCode\" placeholder=\"Reason\" \nclass=\"md-no-underline\" style=\"border: 1px solid rgb(169, 161, 161);border-radius: 5px;height: 35px\"><md-option>\nDefective Goods</md-option><md-option>Price Mismatch</md-option><md-option>Resubmit with Correct data</md-option>\n<md-option>Others</md-option></md-select></md-input-container><md-input-container class=\"md-block\"><label>Comments\n</label><textarea ng-model=\"user.biography\" md-maxlength=\"150\" rows=\"5\" md-select-on-focus \nstyle=\"border: 1px solid rgb(169, 161, 161);border-radius: 5px\"></textarea></md-input-container></div></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"end end\"><md-button ng-click=\"cancel()\">Cancel\n</md-button><md-button ng-click=\"answer(\'useful\')\" class=\"md-warn\">Send</md-button></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/business-admin/business-attributes/attributes.html","<div class=\"page-layout simple right-sidenav\" layout=\"row\"><div \nclass=\"page-layout carded fullwidth md-padding scrollable\" layout=\"column\" flex ms-scroll><div class=\"widget-group\" \nflex=\"100\" layout=\"column\" layout-wrap><ms-widget flippable=\"true\" class=\"no-padding\"><div class=\"md-padding white-bg\">\n<div class=\"previous-state c-p\" data-ng-click=\"businessUserCtrl.goToadmin()\"><span><span \nclass=\"icon-arrow-left-bold-circle-outline\"></span> Back </span></div><table \nclass=\"dataTable row-border hover table-border\" datatable=\"ng\" dt-options=\"CACtrl.dtOptions\"><thead><tr \nclass=\"table-header\"><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Name</span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Label</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Type</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Length</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Required</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\" layout=\"row\" layout-align=\"center center\"><span class=\"column-title\">\nActions</span></div></th></tr></thead><tbody><tr ng-repeat=\"attribute in attributesList \"><td>{{attribute.name}}</td>\n<td>{{attribute.label}}</td><td>{{attribute.type}}</td><td>{{attribute.length}}</td><td>{{attribute.isRequired}}</td>\n<td layout=\"row\" layout-align=\"center center\" style=\"padding-top:0px !important;padding-bottom:0px !important\">\n<md-button class=\"md-icon-button test-tooltip\" aria-label=\"Update\" ng-click=\"updateAttributeDialog($event,attribute)\">\n<md-tooltip md-direction=\"top\">Update</md-tooltip><md-icon><i layout=\"row\" layout-align=\"center center\" \nclass=\"icon icon-pencil s18\"></i></md-icon></md-button><md-button class=\"md-icon-button test-tooltip\" \naria-label=\"Delete\" ng-click=\"deleteContractAttribute($event, attribute) \"><md-tooltip md-direction=\"top\">Delete\n</md-tooltip><md-icon><i layout=\"row\" layout-align=\"center center\" class=\"icon icon-delete s18\"></i></md-icon>\n</md-button></td></tr></tbody></table></div></ms-widget></div><md-button flow-btn \nclass=\"md-fab grey-700-bg md-mini md-fab-bottom-right add_btn\" aria-label=\"Add Attribute\" \nng-click=\"createAttributeDialog($event)\"><md-icon md-font-icon=\"icon-plus\"></md-icon><md-tooltip md-direction=\"top\">\nAdd Attribute</md-tooltip></md-button></div></div>");
$templateCache.put("app/main/business-admin/business-attributes/create.attribute.dialog.html","<md-dialog aria-label=\"Create Folder\" flex=\"30\"><form name=\"addAttribute\" novalidate \nng-submit=\"addAttribute.$valid && save(attribute)\"><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2>\nAdd Attribute</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><div layout=\"row\"><div flex=\"35\" layout=\"column\" \nlayout-align=\"start center\"><span class=\"h3\"><b>Attribute Name </b></span></div><span flex=\"5\"></span>\n<md-input-container flex=\"45\" class=\"md-block\" style=\"margin: 0px\"><input type=\"text\" ng-model=\"attribute.name\" \nrequired></md-input-container></div><div layout=\"row\"><div flex=\"35\" layout=\"column\" layout-align=\"start center\"><span \nclass=\"h3\"><b>Label </b></span></div><span flex=\"5\"></span><md-input-container flex=\"45\" class=\"md-block\" \nstyle=\"margin: 0px\"><input type=\"text\" name=\"label\" ng-model=\"attribute.label\" required><div \nng-messages=\"addAttribute.label.$error\" role=\"alert\"><div ng-message=\"required\">Label is required</div></div>\n</md-input-container></div><div layout=\"row\"><div flex=\"35\" layout=\"column\" layout-align=\"start center\"><span \nclass=\"h3\"><b>Type </b></span></div><span flex=\"5\"></span><md-input-container class=\"md-block\" flex=\"45\" \nstyle=\"margin:0px\"><md-select name=\"type\" ng-model=\"attribute.type\" ng-required=\"true\"><md-option \nng-repeat=\"attributetype in attributeTypes\" ng-value=\"attributetype\">{{attributetype}}</md-option></md-select><div \nng-messages=\"addAttribute.type.$error\" \nng-show=\"addAttribute.$submitted || addAttribute.type.$touched ||  addAttribute.type.$dirty \"><div \nng-message-exp=\"[\'required\']\" ng-hide=\"addAttribute.type.$valid\"><span translate>Select Attribute Type</span></div>\n</div></md-input-container></div><div layout=\"row\"><div flex=\"35\" layout=\"column\" layout-align=\"start center\"><span \nclass=\"h3\"><b>Length</b></span></div><span flex=\"5\"></span><md-input-container flex=\"45\" class=\"md-block\" \nstyle=\"margin: 0px\"><input type=\"number\" ng-model=\"attribute.length\" required> <span \nng-show=\"addAttribute.$error.number\">Enter Only Numbers</span></md-input-container></div><div layout=\"row\" \nlayout-align=\"center center\"><md-switch ng-model=\"attribute.isRequired\" aria-label=\"Required\">Required</md-switch>\n</div></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"center center\"><md-button type=\"button\" \nng-click=\"cancel()\">Cancel</md-button><md-button type=\"submit\">Save</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/business-admin/business-attributes/update.attribute.dialog.html","<md-dialog aria-label=\"Create Folder\" flex=\"30\"><form name=\"addAttribute\"><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools\"><h2>Update Attribute</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"cancel()\"><md-icon md-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"row\"><div flex=\"35\" \nlayout=\"column\" layout-align=\"start center\"><span class=\"h3\"><b>Attribute Name </b></span></div><span flex=\"5\"></span>\n<md-input-container flex=\"45\" class=\"md-block\" style=\"margin: 0px\"><input type=\"text\" ng-model=\"currentAttribute.name\" \nng-disabled=\"true\"></md-input-container></div><div layout=\"row\"><div flex=\"35\" layout=\"column\" \nlayout-align=\"start center\"><span class=\"h3\"><b>Label </b></span></div><span flex=\"5\"></span><md-input-container \nflex=\"45\" class=\"md-block\" style=\"margin: 0px\"><input type=\"text\" name=\"label\" ng-model=\"currentAttribute.label\" \nrequired ng-disabled=\"true\"><div ng-messages=\"addAttribute.label.$error\" role=\"alert\"><div ng-message=\"required\">\nLabel is required</div></div></md-input-container></div><div layout=\"row\"><div flex=\"35\" layout=\"column\" \nlayout-align=\"start center\"><span class=\"h3\"><b>Type </b></span></div><span flex=\"5\"></span><md-input-container \nclass=\"md-block\" flex=\"45\" style=\"margin:0px\"><md-select ng-model=\"currentAttribute.type\" ng-disabled=\"true\"><md-option\n ng-repeat=\"attributetype in attributeTypes\" ng-value=\"attributetype\">{{attributetype}}</md-option></md-select>\n</md-input-container></div><div layout=\"row\"><div flex=\"35\" layout=\"column\" layout-align=\"start center\"><span \nclass=\"h3\"><b>Length</b></span></div><span flex=\"5\"></span><md-input-container flex=\"45\" class=\"md-block\" \nstyle=\"margin: 0px\"><input type=\"text\" ng-model=\"currentAttribute.length\" ng-disabled=\"true\"></md-input-container>\n</div><div layout=\"row\" layout-align=\"center center\"><md-switch ng-model=\"currentAttribute.isRequired\" \naria-label=\"Required\">Required</md-switch></div></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"center center\"><md-button type=\"button\" ng-click=\"cancel()\">Cancel</md-button><md-button type=\"submit\" \nng-click=\"update(currentAttribute)\">Save</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/toolbar/layouts/content-with-toolbar/toolbar.html","<div layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-image\">F</span> <span class=\"logo-text\">FUSE</span></div>\n<div class=\"toolbar-separator\"></div><ms-shortcuts></ms-shortcuts><div class=\"toolbar-separator\"></div></div><div \nlayout=\"row\" layout-align=\"start center\"><md-progress-circular id=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" \nclass=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"32\"></md-progress-circular><div class=\"toolbar-separator\"></div>\n<md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button class=\"user-button\" \nng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" \nsrc=\"assets/images/avatars/profile.jpg\"><md-icon md-font-icon ng-class=\"vm.userStatus.icon\" \nng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\"></md-icon></div><span class=\"username\" hide-sm>\nJohn Doe</span><md-icon md-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-sm></md-icon></div></md-button>\n<md-menu-content width=\"3\"><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-account\" class=\"icon\"></md-icon>\n<md-button ng-click=\"vm.editMyProfile($event)\">My Profile</md-button></md-menu-item><md-menu-item class=\"md-indent\" \nui-sref=\"app.mail\"><md-icon md-font-icon=\"icon-email\" class=\"icon\"></md-icon><md-button>Inbox</md-button>\n</md-menu-item><md-menu-item class=\"md-indent\"><md-icon md-font-icon ng-class=\"vm.userStatus.icon\" \nng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon\"></md-icon><md-menu id=\"user-status-menu\"><md-button \nng-click=\"$mdOpenMenu()\" class=\"status\" ng-class=\"vm.userStatus.class\">{{vm.userStatus.title}}</md-button>\n<md-menu-content width=\"2\"><md-menu-item class=\"status md-indent\" ng-class=\"{\'selected\': status === vm.userStatus}\" \nng-repeat=\"status in vm.userStatusOptions\"><md-icon md-font-icon=\"{{status.icon}}\" ng-style=\"{\'color\': status.color }\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.setUserStatus(status)\">{{status.title}}</md-button></md-menu-item>\n</md-menu-content></md-menu></md-menu-item><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-key\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.changePassword($event)\">Change Password</md-button></md-menu-item>\n<md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" class=\"icon\">\n</md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item></md-menu-content></md-menu></md-menu-bar>\n<div class=\"toolbar-separator\"></div><ms-search-bar on-search=\"vm.search(query)\" \non-result-click=\"vm.searchResultClick(item)\" debounce=\"300\"></ms-search-bar><div class=\"toolbar-separator\"></div>\n<md-menu id=\"language-menu\" md-offset=\"0 72\" md-position-mode=\"target-right target\"><md-button class=\"language-button\" \nng-click=\"$mdOpenMenu()\" aria-label=\"Language\" md-menu-origin md-menu-align-target><div layout=\"row\" \nlayout-align=\"center center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span \nclass=\"iso\">{{vm.selectedLanguage.code}}</span></div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\">\n<md-menu-item ng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" \naria-label=\"{{lang.title}}\" translate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" \nlayout-align=\"start center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span \ntranslate=\"{{lang.translation}}\">{{lang.title}}</span></span></md-button></md-menu-item></md-menu-content></md-menu>\n<div class=\"toolbar-separator\"></div><md-button id=\"quick-panel-toggle\" class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'quick-panel\')\" aria-label=\"Toggle quick panel\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon md-font-icon=\"icon-format-list-bulleted\" class=\"icon\">\n</md-icon></md-button></div></div>");
$templateCache.put("app/main/business-admin/business-categories/categorylist.html","<div class=\"page-layout simple right-sidenav\" layout=\"row\"><div \nclass=\"page-layout carded fullwidth md-padding scrollable\" layout=\"column\" flex ms-scroll><div class=\"widget-group\" \nflex=\"100\" layout=\"column\" layout-wrap><ms-widget flippable=\"true\" class=\"no-padding\"><div \nclass=\"md-padding white-bg scrollable\" ms-scroll><div class=\"md-padding white-bg\" ng-init=\"List()\"><div \nclass=\"previous-state c-p\" data-ng-click=\"goToPreviousState()\"><span><span class=\"icon-arrow-left-bold-circle-outline\">\n</span> Back </span></div><table class=\"dataTable row-border hover table-border\" datatable=\"ng\" \ndt-options=\"CategoryCtrl.dtOptions\" layout-wrap ng-if=\"inputfield != \'\'\"><thead><tr class=\"table-header\"><th \nclass=\"secondary-text\" ng-hide=\"value == \'_id\'\" ng-repeat=\"(key, value) in inputfield\"><div class=\"table-header\"><span \nclass=\"column-title\">{{value}}</span></div></th><th class=\"secondary-text\"><div class=\"table-header\" layout=\"row\" \nlayout-align=\"center center\"><span class=\"column-title\">Actions</span></div></th></tr></thead><tbody><tr \nng-repeat=\"(key, value) in CategoriesList track by $index\"><td ng-hide=\"k == \'_id\'\" \nng-repeat=\"(k, v) in CategoriesList[$index] track by $index\">{{v}}</td><td layout=\"row\" layout-align=\"center center\" \nstyle=\"padding-top:0px !important;padding-bottom:0px !important\"><md-button class=\"md-icon-button test-tooltip\" \naria-label=\"Update\" ng-click=\"updateCategory($event,CategoriesList[$index])\"><md-tooltip md-direction=\"top\">Update\n</md-tooltip><md-icon><i layout=\"row\" layout-align=\"center center\" class=\"icon icon-pencil s18\"></i></md-icon>\n</md-button><md-button class=\"md-icon-button test-tooltip\" aria-label=\"Delete\" \nng-click=\"deletedata($event,CategoriesList[$index])\"><md-tooltip md-direction=\"top\">Delete</md-tooltip><md-icon><i \nlayout=\"row\" layout-align=\"center center\" class=\"icon icon-delete s18\"></i></md-icon></md-button></td></tr></tbody>\n</table><div ng-if=\"inputfield == undefined\"><h1>No Data Available</h1></div></div></div></ms-widget><md-button \nflow-btn class=\"md-fab grey-700-bg md-mini md-fab-bottom-right\" ng-click=\"createCategory()\"><md-icon \nmd-font-icon=\"icon-plus\" class=\"white-fg\"></md-icon><md-tooltip md-direction=\"top\">Create Category</md-tooltip>\n</md-button></div></div></div>");
$templateCache.put("app/main/business-admin/business-categories/create.category.dialog.html","<md-dialog aria-label=\"Add List\" flex=\"45\"><form name=\"listForm\" novalidate layout=\"column\"><md-toolbar \nclass=\"md-accent\"><div class=\"md-toolbar-tools\"><h2>Create Detail</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><div layout=\"column\"><md-input-container class=\"md-block\" flex=\"45\" \nng-if=\"list != \'_id\'\" ng-repeat=\"list in attrdata track by $index\"><label>{{list}}</label><input type=\"text\" \nname=\"arrval\" ng-model=\"crlist[$index].list\" required><div ng-messages=\"listForm.list.$error\" role=\"alert\"><div \nng-message=\"required\"><span>{{list}} is required</span></div><div ng-message=\"pattern\"><span>\n{{list}} has invalid characters</span></div></div></md-input-container></div></md-dialog-content><md-dialog-actions \nlayout=\"row\" layout-align=\"center center\"><md-button type=\"button\" ng-click=\"cancel()\">Cancel</md-button><md-button \ntype=\"submit\" ng-click=\"listForm.$valid && save()\">Save</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/business-admin/business-categories/update.category.dialog.html","<md-dialog aria-label=\"Add List\" flex=\"45\"><form name=\"listForm\" novalidate \nng-submit=\"listForm.$valid && updatedata()\" layout=\"column\"><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools\"><h2>Update Detail</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\">\n<md-icon md-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><div layout=\"column\"><md-input-container class=\"md-block\" flex=\"45\" \nng-hide=\"key == \'_id\'\" ng-repeat=\"(key, value) in currentdata track by $index\"><label>{{key}}</label><input \ntype=\"text\" name=\"arrval\" ng-init=\"updateddata[$index] = value\" ng-model=\"updateddata[$index]\" required><div \nng-messages=\"listForm.$error\" role=\"alert\"><div ng-message=\"required\"><span>{{key}} is required</span></div><div \nng-message=\"pattern\"><span>{{key}} has invalid characters</span></div></div></md-input-container></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"center center\"><md-button type=\"button\" \nng-click=\"cancel()\">Cancel</md-button><md-button type=\"submit\">update</md-button></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/business-admin/business-contracttypes/contracttypes.html","<div class=\"page-layout simple right-sidenav\" layout=\"row\"><div \nclass=\"page-layout carded fullwidth md-padding scrollable\" layout=\"column\" flex ms-scroll><div class=\"widget-group\" \nflex=\"100\" layout=\"column\" layout-wrap><ms-widget flippable=\"true\" class=\"no-padding\"><div \nclass=\"md-padding white-bg scrollable\" ms-scroll><div class=\"md-padding white-bg\" ng-init=\"List()\"><table \nclass=\"dataTable row-border hover table-border\" datatable=\"ng\" dt-options=\"contractCtrl.dtOptions\" layout-wrap \nng-if=\"inputfield != \'\'\"><thead><tr class=\"table-header\"><th class=\"secondary-text\" ng-hide=\"value == \'_id\'\" \nng-repeat=\"(key, value) in inputfield\"><div class=\"table-header\"><span class=\"column-title\">{{value}}</span></div></th>\n<th class=\"secondary-text\"><div class=\"table-header\" layout=\"row\" layout-align=\"center center\"><span \nclass=\"column-title\">Actions</span></div></th></tr></thead><tbody><tr \nng-repeat=\"(key, value) in ContractTypesList track by $index\"><td ng-hide=\"k == \'_id\'\" \nng-repeat=\"(k, v) in ContractTypesList[$index] track by $index\">{{v}}</td><td layout=\"row\" \nlayout-align=\"center center\" style=\"padding-top:0px !important;padding-bottom:0px !important\"><md-button \nclass=\"md-icon-button test-tooltip\" aria-label=\"Update\" \nng-click=\"updateContractType($event,ContractTypesList[$index])\"><md-tooltip md-direction=\"top\">Update</md-tooltip>\n<md-icon><i layout=\"row\" layout-align=\"center center\" class=\"icon icon-pencil s18\"></i></md-icon></md-button><md-button\n class=\"md-icon-button test-tooltip\" aria-label=\"Delete\" ng-click=\"deletedata($event,ContractTypesList[$index]) \">\n<md-tooltip md-direction=\"top\">Delete</md-tooltip><md-icon><i layout=\"row\" layout-align=\"center center\" \nclass=\"icon icon-delete s18\"></i></md-icon></md-button></td></tr></tbody></table><div ng-if=\"inputfield == undefined\">\n<h1>No Data Available</h1></div></div></div></ms-widget><md-button flow-btn \nclass=\"md-fab grey-700-bg md-mini md-fab-bottom-right\" ng-click=\"createContractType()\"><md-icon \nmd-font-icon=\"icon-plus\" class=\"white-fg\"></md-icon><md-tooltip md-direction=\"top\">Create ContractType</md-tooltip>\n</md-button></div></div></div>");
$templateCache.put("app/main/business-admin/business-contracttypes/create.contracttype.dialog.html","<md-dialog aria-label=\"Add List\" flex=\"45\"><form name=\"listForm\" novalidate layout=\"column\"><md-toolbar \nclass=\"md-accent\"><div class=\"md-toolbar-tools\"><h2>Create Detail</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><div layout=\"column\"><md-input-container class=\"md-block\" flex=\"45\" \nng-if=\"list != \'_id\'\" ng-repeat=\"list in attrdata track by $index\"><label>{{list}}</label><input type=\"text\" \nname=\"arrval\" ng-model=\"crlist[$index].list\" required><div ng-messages=\"listForm.list.$error\" role=\"alert\"><div \nng-message=\"required\"><span>{{list}} is required</span></div><div ng-message=\"pattern\"><span>\n{{list}} has invalid characters</span></div></div></md-input-container></div></md-dialog-content><md-dialog-actions \nlayout=\"row\" layout-align=\"center center\"><md-button type=\"button\" ng-click=\"cancel()\">Cancel</md-button><md-button \ntype=\"submit\" ng-click=\"listForm.$valid && save()\">Save</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/business-admin/business-contracttypes/update.contracttype.dialog.html","<md-dialog aria-label=\"Add List\" flex=\"45\"><form name=\"listForm\" novalidate \nng-submit=\"listForm.$valid && updatedata()\" layout=\"column\"><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools\"><h2>Update Detail</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\">\n<md-icon md-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><div layout=\"column\"><md-input-container class=\"md-block\" flex=\"45\" \nng-hide=\"key == \'_id\'\" ng-repeat=\"(key, value) in currentdata track by $index\"><label>{{key}}</label><input \ntype=\"text\" name=\"arrval\" ng-init=\"updateddata[$index] = value\" ng-model=\"updateddata[$index]\" required><div \nng-messages=\"listForm.$error\" role=\"alert\"><div ng-message=\"required\"><span>{{key}} is required</span></div><div \nng-message=\"pattern\"><span>{{key}} has invalid characters</span></div></div></md-input-container></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"center center\"><md-button type=\"button\" \nng-click=\"cancel()\">Cancel</md-button><md-button type=\"submit\">update</md-button></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/business-admin/business-GLAccounts/GLAccount.html","<div class=\"page-layout simple right-sidenav\" layout=\"row\"><div \nclass=\"page-layout carded fullwidth md-padding scrollable\" layout=\"column\" flex ms-scroll><div class=\"widget-group\" \nflex=\"100\" layout=\"column\" layout-wrap><ms-widget flippable=\"true\" class=\"no-padding\"><div \nclass=\"md-padding white-bg scrollable\" ms-scroll><div class=\"md-padding white-bg\" ng-init=\"List()\"><div \nclass=\"previous-state c-p\" data-ng-click=\"goToPreviousState()\"><span><span class=\"icon-arrow-left-bold-circle-outline\">\n</span> Back </span></div><table class=\"dataTable row-border hover table-border\" datatable=\"ng\" \ndt-options=\"GLACtrl.dtOptions\" layout-wrap ng-if=\"inputfield != \'\'\"><thead><tr class=\"table-header\"><th \nclass=\"secondary-text\" ng-hide=\"value == \'_id\'\" ng-repeat=\"(key, value) in inputfield\"><div class=\"table-header\"><span \nclass=\"column-title\">{{value}}</span></div></th><th class=\"secondary-text\"><div class=\"table-header\" layout=\"row\" \nlayout-align=\"center center\"><span class=\"column-title\">Actions</span></div></th></tr></thead><tbody><tr \nng-repeat=\"(key, value) in EmployeesList track by $index\"><td ng-hide=\"k == \'_id\'\" \nng-repeat=\"(k, v) in EmployeesList[$index] track by $index\">{{v}}</td><td layout=\"row\" layout-align=\"center center\" \nstyle=\"padding-top:0px !important;padding-bottom:0px !important\"><md-button class=\"md-icon-button test-tooltip\" \naria-label=\"Update\" ng-click=\"updateEmployee($event,EmployeesList[$index])\"><md-tooltip md-direction=\"top\">Update\n</md-tooltip><md-icon><i layout=\"row\" layout-align=\"center center\" class=\"icon icon-pencil s18\"></i></md-icon>\n</md-button><md-button class=\"md-icon-button test-tooltip\" aria-label=\"Delete\" \nng-click=\"deletedata($event,EmployeesList[$index]) \"><md-tooltip md-direction=\"top\">Delete</md-tooltip><md-icon><i \nlayout=\"row\" layout-align=\"center center\" class=\"icon icon-delete s18\"></i></md-icon></md-button></td></tr></tbody>\n</table><div ng-if=\"inputfield == undefined\"><h1>No Data Available</h1></div></div></div></ms-widget><md-button \nflow-btn class=\"md-fab grey-700-bg md-mini md-fab-bottom-right\" ng-click=\"createEmployee()\"><md-icon \nmd-font-icon=\"icon-plus\" class=\"white-fg\"></md-icon><md-tooltip md-direction=\"top\">Create Employee</md-tooltip>\n</md-button></div></div></div>");
$templateCache.put("app/main/business-admin/business-GLAccounts/create.GLAccount.dialog.html","<md-dialog aria-label=\"Add List\" flex=\"45\"><form name=\"listForm\" novalidate layout=\"column\"><md-toolbar \nclass=\"md-accent\"><div class=\"md-toolbar-tools\"><h2>Create Detail</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><div layout=\"column\"><md-input-container class=\"md-block\" flex=\"45\" \nng-if=\"list != \'_id\'\" ng-repeat=\"list in attrdata track by $index\"><label>{{list}}</label><input type=\"text\" \nname=\"arrval\" ng-model=\"crlist[$index].list\" required><div ng-messages=\"listForm.list.$error\" role=\"alert\"><div \nng-message=\"required\"><span>{{list}} is required</span></div><div ng-message=\"pattern\"><span>\n{{list}} has invalid characters</span></div></div></md-input-container></div></md-dialog-content><md-dialog-actions \nlayout=\"row\" layout-align=\"center center\"><md-button type=\"button\" ng-click=\"cancel()\">Cancel</md-button><md-button \ntype=\"submit\" ng-click=\"listForm.$valid && save()\">Save</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/business-admin/business-GLAccounts/update.GLAccount.dialog.html","<md-dialog aria-label=\"Add List\" flex=\"45\"><form name=\"listForm\" novalidate \nng-submit=\"listForm.$valid && updatedata()\" layout=\"column\"><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools\"><h2>Update Detail</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\">\n<md-icon md-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><div layout=\"column\"><md-input-container class=\"md-block\" flex=\"45\" \nng-hide=\"key == \'_id\'\" ng-repeat=\"(key, value) in currentdata track by $index\"><label>{{key}}</label><input \ntype=\"text\" name=\"arrval\" ng-init=\"updateddata[$index] = value\" ng-model=\"updateddata[$index]\" required><div \nng-messages=\"listForm.$error\" role=\"alert\"><div ng-message=\"required\"><span>{{key}} is required</span></div><div \nng-message=\"pattern\"><span>{{key}} has invalid characters</span></div></div></md-input-container></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"center center\"><md-button type=\"button\" \nng-click=\"cancel()\">Cancel</md-button><md-button type=\"submit\">update</md-button></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/business-admin/business-costcenters/costcenter.html","<div class=\"page-layout simple right-sidenav\" layout=\"row\"><div \nclass=\"page-layout carded fullwidth md-padding scrollable\" layout=\"column\" flex ms-scroll><div class=\"widget-group\" \nflex=\"100\" layout=\"column\" layout-wrap><ms-widget flippable=\"true\" class=\"no-padding\"><div \nclass=\"md-padding white-bg scrollable\" ms-scroll><div class=\"md-padding white-bg\" ng-init=\"List()\"><div \nclass=\"previous-state c-p\" data-ng-click=\"goToPreviousState()\"><span><span class=\"icon-arrow-left-bold-circle-outline\">\n</span> Back </span></div><table class=\"dataTable row-border hover table-border\" datatable=\"ng\" \ndt-options=\"costcenterCtrl.dtOptions\" layout-wrap ng-if=\"inputfield != \'\'\"><thead><tr class=\"table-header\"><th \nclass=\"secondary-text\" ng-hide=\"value == \'_id\'\" ng-repeat=\"(key, value) in inputfield\"><div class=\"table-header\"><span \nclass=\"column-title\">{{value}}</span></div></th><th class=\"secondary-text\"><div class=\"table-header\" layout=\"row\" \nlayout-align=\"center center\"><span class=\"column-title\">Actions</span></div></th></tr></thead><tbody><tr \nng-repeat=\"(key, value) in CustomersList track by $index\"><td ng-hide=\"k == \'_id\'\" \nng-repeat=\"(k, v) in CustomersList[$index] track by $index\">{{v}}</td><td layout=\"row\" layout-align=\"center center\" \nstyle=\"padding-top:0px !important;padding-bottom:0px !important\"><md-button class=\"md-icon-button test-tooltip\" \naria-label=\"Update\" ng-click=\"updateCustomer($event,CustomersList[$index])\"><md-tooltip md-direction=\"top\">Update\n</md-tooltip><md-icon><i layout=\"row\" layout-align=\"center center\" class=\"icon icon-pencil s18\"></i></md-icon>\n</md-button><md-button class=\"md-icon-button test-tooltip\" aria-label=\"Delete\" \nng-click=\"deletedata($event,CustomersList[$index]) \"><md-tooltip md-direction=\"top\">Delete</md-tooltip><md-icon><i \nlayout=\"row\" layout-align=\"center center\" class=\"icon icon-delete s18\"></i></md-icon></md-button></td></tr></tbody>\n</table><div ng-if=\"inputfield == undefined\"><h1>No Data Available</h1></div></div></div></ms-widget><md-button \nflow-btn class=\"md-fab grey-700-bg md-mini md-fab-bottom-right\" ng-click=\"createCustomer()\"><md-icon \nmd-font-icon=\"icon-plus\" class=\"white-fg\"></md-icon><md-tooltip md-direction=\"top\">Create Customer</md-tooltip>\n</md-button></div></div></div>");
$templateCache.put("app/main/business-admin/business-costcenters/create.costcenter.dialog.html","<md-dialog aria-label=\"Add List\" flex=\"45\"><form name=\"listForm\" novalidate layout=\"column\"><md-toolbar \nclass=\"md-accent\"><div class=\"md-toolbar-tools\"><h2>Create Detail</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><div layout=\"column\"><md-input-container class=\"md-block\" flex=\"45\" \nng-if=\"list != \'_id\'\" ng-repeat=\"list in attrdata track by $index\"><label>{{list}}</label><input type=\"text\" \nname=\"arrval\" ng-model=\"crlist[$index].list\" required><div ng-messages=\"listForm.list.$error\" role=\"alert\"><div \nng-message=\"required\"><span>{{list}} is required</span></div><div ng-message=\"pattern\"><span>\n{{list}} has invalid characters</span></div></div></md-input-container></div></md-dialog-content><md-dialog-actions \nlayout=\"row\" layout-align=\"center center\"><md-button type=\"button\" ng-click=\"cancel()\">Cancel</md-button><md-button \ntype=\"submit\" ng-click=\"listForm.$valid && save()\">Save</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/business-admin/business-costcenters/update.costcenter.dialog.html","<md-dialog aria-label=\"Add List\" flex=\"45\"><form name=\"listForm\" novalidate \nng-submit=\"listForm.$valid && updatedata()\" layout=\"column\"><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools\"><h2>Update Detail</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\">\n<md-icon md-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><div layout=\"column\"><md-input-container class=\"md-block\" flex=\"45\" \nng-hide=\"key == \'_id\'\" ng-repeat=\"(key, value) in currentdata track by $index\"><label>{{key}}</label><input \ntype=\"text\" name=\"arrval\" ng-init=\"updateddata[$index] = value\" ng-model=\"updateddata[$index]\" required><div \nng-messages=\"listForm.$error\" role=\"alert\"><div ng-message=\"required\"><span>{{key}} is required</span></div><div \nng-message=\"pattern\"><span>{{key}} has invalid characters</span></div></div></md-input-container></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"center center\"><md-button type=\"button\" \nng-click=\"cancel()\">Cancel</md-button><md-button type=\"submit\" ng-click=\"updatedata()\">update</md-button>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/business-admin/business-plants/create.plant.dialog.html","<md-dialog aria-label=\"Add List\" flex=\"45\"><form name=\"listForm\" novalidate layout=\"column\"><md-toolbar \nclass=\"md-accent\"><div class=\"md-toolbar-tools\"><h2>Create Detail</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><div layout=\"column\"><md-input-container class=\"md-block\" flex=\"45\" \nng-if=\"list != \'_id\'\" ng-repeat=\"list in attrdata track by $index\"><label>{{list}}</label><input type=\"text\" \nname=\"arrval\" ng-model=\"crlist[$index].list\" required><div ng-messages=\"listForm.list.$error\" role=\"alert\"><div \nng-message=\"required\"><span>{{list}} is required</span></div><div ng-message=\"pattern\"><span>\n{{list}} has invalid characters</span></div></div></md-input-container></div></md-dialog-content><md-dialog-actions \nlayout=\"row\" layout-align=\"center center\"><md-button type=\"button\" ng-click=\"cancel()\">Cancel</md-button><md-button \ntype=\"submit\" ng-click=\"listForm.$valid && save()\">Save</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/business-admin/business-plants/plants.html","<div class=\"page-layout simple right-sidenav\" layout=\"row\"><div \nclass=\"page-layout carded fullwidth md-padding scrollable\" layout=\"column\" flex ms-scroll><div class=\"widget-group\" \nflex=\"100\" layout=\"column\" layout-wrap><ms-widget flippable=\"true\" class=\"no-padding\"><div \nclass=\"md-padding white-bg scrollable\" ms-scroll><div class=\"md-padding white-bg\" ng-init=\"List()\"><div \nclass=\"previous-state c-p\" data-ng-click=\"goToPreviousState()\"><span><span class=\"icon-arrow-left-bold-circle-outline\">\n</span> Back </span></div><table class=\"dataTable row-border hover table-border\" datatable=\"ng\" \ndt-options=\"plantCtrl.dtOptions\" layout-wrap ng-if=\"inputfield != \'\'\"><thead><tr class=\"table-header\"><th \nclass=\"secondary-text\" ng-hide=\"value == \'_id\'\" ng-repeat=\"(key, value) in inputfield\"><div class=\"table-header\"><span \nclass=\"column-title\">{{value}}</span></div></th><th class=\"secondary-text\"><div class=\"table-header\" layout=\"row\" \nlayout-align=\"center center\"><span class=\"column-title\">Actions</span></div></th></tr></thead><tbody><tr \nng-repeat=\"(key, value) in CustomersList track by $index\"><td ng-hide=\"k == \'_id\'\" \nng-repeat=\"(k, v) in CustomersList[$index] track by $index\">{{v}}</td><td layout=\"row\" layout-align=\"center center\" \nstyle=\"padding-top:0px !important;padding-bottom:0px !important\"><md-button class=\"md-icon-button test-tooltip\" \naria-label=\"Update\" ng-click=\"updateCustomer($event,CustomersList[$index])\"><md-tooltip md-direction=\"top\">Update\n</md-tooltip><md-icon><i layout=\"row\" layout-align=\"center center\" class=\"icon icon-pencil s18\"></i></md-icon>\n</md-button><md-button class=\"md-icon-button test-tooltip\" aria-label=\"Delete\" \nng-click=\"deletedata($event,CustomersList[$index]) \"><md-tooltip md-direction=\"top\">Delete</md-tooltip><md-icon><i \nlayout=\"row\" layout-align=\"center center\" class=\"icon icon-delete s18\"></i></md-icon></md-button></td></tr></tbody>\n</table><div ng-if=\"inputfield == undefined\"><h1>No Data Available</h1></div></div></div></ms-widget><md-button \nflow-btn class=\"md-fab grey-700-bg md-mini md-fab-bottom-right\" ng-click=\"createCustomer()\"><md-icon \nmd-font-icon=\"icon-plus\" class=\"white-fg\"></md-icon><md-tooltip md-direction=\"top\">Create Customer</md-tooltip>\n</md-button></div></div></div>");
$templateCache.put("app/main/business-admin/business-plants/update.plant.dialog.html","<md-dialog aria-label=\"Add List\" flex=\"45\"><form name=\"listForm\" novalidate \nng-submit=\"listForm.$valid && updatedata()\" layout=\"column\"><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools\"><h2>Update Detail</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\">\n<md-icon md-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><div layout=\"column\"><md-input-container class=\"md-block\" flex=\"45\" \nng-hide=\"key == \'_id\'\" ng-repeat=\"(key, value) in currentdata track by $index\"><label>{{key}}</label><input \ntype=\"text\" name=\"arrval\" ng-init=\"updateddata[$index] = value\" ng-model=\"updateddata[$index]\" required><div \nng-messages=\"listForm.$error\" role=\"alert\"><div ng-message=\"required\"><span>{{key}} is required</span></div><div \nng-message=\"pattern\"><span>{{key}} has invalid characters</span></div></div></md-input-container></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"center center\"><md-button type=\"button\" \nng-click=\"cancel()\">Cancel</md-button><md-button type=\"submit\" ng-click=\"updatedata()\">update</md-button>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/business-admin/business-Vendor/create.vendor.dialog.html","<md-dialog aria-label=\"Add List\" flex=\"45\"><form name=\"listForm\" novalidate \nng-submit=\"listForm.$valid && doctypeCrtl.createDocumentType()\" layout=\"column\"><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools\"><h2>Create Detail</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\">\n<md-icon md-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><div layout=\"column\"><md-input-container class=\"md-block\" flex=\"45\" \nng-if=\"list != \'_id\'\" ng-repeat=\"list in attrdata track by $index\"><label>{{list}}</label><input type=\"text\" \nname=\"arrval\" ng-model=\"crlist[$index].list\" required><div ng-messages=\"listForm.list.$error\" role=\"alert\"><div \nng-message=\"required\"><span>{{list}} is required</span></div><div ng-message=\"pattern\"><span>\n{{list}} has invalid characters</span></div></div></md-input-container></div></md-dialog-content><md-dialog-actions \nlayout=\"row\" layout-align=\"center center\"><md-button type=\"button\" ng-click=\"cancel()\">Cancel</md-button><md-button \ntype=\"submit\" ng-click=\"listForm.$valid && save()\">Save</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/business-admin/business-Vendor/update.vendor.dialog.html","<md-dialog aria-label=\"Add List\" flex=\"45\"><form name=\"listForm\" novalidate \nng-submit=\"listForm.$valid && updatedata()\" layout=\"column\"><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools\"><h2>Update Detail</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\">\n<md-icon md-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><div layout=\"column\"><md-input-container class=\"md-block\" flex=\"45\" \nng-hide=\"key == \'_id\'\" ng-repeat=\"(key, value) in currentdata track by $index\"><label>{{key}}</label><input \ntype=\"text\" name=\"arrval\" ng-init=\"updateddata[$index] = value\" ng-model=\"updateddata[$index]\" required><div \nng-messages=\"listForm.$error\" role=\"alert\"><div ng-message=\"required\"><span>{{key}} is required</span></div><div \nng-message=\"pattern\"><span>{{key}} has invalid characters</span></div></div></md-input-container></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"center center\"><md-button type=\"button\" \nng-click=\"cancel()\">Cancel</md-button><md-button type=\"submit\" ng-click=\"updatedata()\">update</md-button>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/business-admin/business-Vendor/vendor.list.html","<div class=\"page-layout simple right-sidenav\" layout=\"row\"><div \nclass=\"page-layout carded fullwidth md-padding scrollable\" layout=\"column\" flex ms-scroll><div class=\"widget-group\" \nflex=\"100\" layout=\"column\" layout-wrap><ms-widget flippable=\"true\" class=\"no-padding\"><div \nclass=\"md-padding white-bg scrollable\" ms-scroll><div class=\"md-padding white-bg\" ng-init=\"List()\"><div \nclass=\"previous-state c-p\" data-ng-click=\"goToPreviousState()\"><span><span class=\"icon-arrow-left-bold-circle-outline\">\n</span> Back </span></div><table class=\"dataTable row-border hover table-border\" datatable=\"ng\" \ndt-options=\"VendorCtrl.dtOptions\" layout-wrap ng-if=\"inputfield != \'\'\"><thead><tr class=\"table-header\"><th \nclass=\"secondary-text\" ng-hide=\"value == \'_id\'\" ng-repeat=\"(key, value) in inputfield\"><div class=\"table-header\"><span \nclass=\"column-title\">{{value}}</span></div></th><th class=\"secondary-text\"><div class=\"table-header\" layout=\"row\" \nlayout-align=\"center center\"><span class=\"column-title\">Actions</span></div></th></tr></thead><tbody><tr \nng-repeat=\"(key, value) in VendorsList track by $index\"><td ng-hide=\"k == \'_id\'\" \nng-repeat=\"(k, v) in VendorsList[$index] track by $index\">{{v}}</td><td layout=\"row\" layout-align=\"center center\" \nstyle=\"padding-top:0px !important;padding-bottom:0px !important\"><md-button class=\"md-icon-button test-tooltip\" \naria-label=\"Update\" ng-click=\"updateVendor($event,VendorsList[$index])\"><md-tooltip md-direction=\"top\">Update\n</md-tooltip><md-icon><i layout=\"row\" layout-align=\"center center\" class=\"icon icon-pencil s18\"></i></md-icon>\n</md-button><md-button class=\"md-icon-button test-tooltip\" aria-label=\"Delete\" \nng-click=\"deletedata($event,VendorsList[$index]) \"><md-tooltip md-direction=\"top\">Delete</md-tooltip><md-icon><i \nlayout=\"row\" layout-align=\"center center\" class=\"icon icon-delete s18\"></i></md-icon></md-button></td></tr></tbody>\n</table><div ng-if=\"inputfield == undefined\"><h1>No Data Available</h1></div></div></div></ms-widget><md-button \nflow-btn class=\"md-fab grey-700-bg md-mini md-fab-bottom-right\" ng-click=\"createVendor()\"><md-icon \nmd-font-icon=\"icon-plus\" class=\"white-fg\"></md-icon><md-tooltip md-direction=\"top\">Create Vendor</md-tooltip>\n</md-button></div></div></div>");
$templateCache.put("app/main/business-admin/business-portlets/create.portlet.html","<md-dialog aria-label=\"Create Portlet\" flex=\"65\"><form name=\"portletForm\" novalidate \nng-submit=\"portletForm.$valid && save(portlet)\"><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2>\nCreate Portlet</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content class=\"md-padding scrollable\" ms-scroll><div layout=\"row\" \nlayout-align=\"center center\"><span class=\"h3\" flex=\"35\"><b>Portlet Name </b></span><span flex=\"5\"></span>\n<md-input-container flex=\"45\" class=\"md-block\" style=\"margin: 0px\"><input type=\"text\" ng-model=\"portlet.name\" required>\n<div ng-messages=\"portletForm.name.$error\" role=\"alert\"><div ng-message=\"required\">Name is required</div></div>\n</md-input-container></div><div layout=\"row\" layout-align=\"center center\"><span flex=\"35\" class=\"h3\"><b>Description \n</b></span><span flex=\"5\"></span><md-input-container flex=\"45\" class=\"md-block\" style=\"margin: 0px\"><input type=\"text\" \nname=\"label\" ng-model=\"portlet.description\" required><div ng-messages=\"portletForm.description.$error\" role=\"alert\">\n<div ng-message=\"required\">Description is required</div></div></md-input-container></div><div layout=\"row\" \nlayout-align=\"center center\"><span flex=\"35\" class=\"h3\"><b>Details </b></span><span flex=\"5\"></span> <span flex=\"45\">\n</span></div><div layout=\"row\" layout-align=\"center center\" class=\"md-padding\"><text-angular \nng-model=\"portlet.htmlCodeSnippet\" style=\"width:90%\"></text-angular></div></md-dialog-content><md-dialog-actions \nlayout=\"row\" layout-align=\"center center\"><md-button type=\"button\" ng-click=\"cancel()\">Cancel</md-button><md-button \ntype=\"submit\">Save</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/business-admin/business-portlets/preview.portlets.html","<div class=\"page-layout simple right-sidenav\" layout=\"row\"><div \nclass=\"page-layout carded fullwidth md-padding scrollable\" layout=\"column\" flex ms-scroll><div class=\"widget-group\" \nflex=\"100\" layout=\"column\" layout-wrap><ms-widget flippable=\"true\" class=\"no-padding\"><div \nclass=\"md-padding white-bg scrollable\" ms-scroll><div class=\"previous-state c-p\" flex=\"10\"><span \ndata-ng-click=\"goToPreviousState()\"><span class=\"icon-arrow-left-bold-circle-outline\"></span> Back </span></div><table \nclass=\"dataTable row-border hover table-border\" datatable=\"ng\" dt-options=\"portletCtrl.dtOptions\" layout-wrap><thead>\n<tr class=\"table-header\"><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Name</span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Description</span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header\" layout=\"row\" layout-align=\"center center\"><span \nclass=\"column-title\">Actions</span></div></th></tr></thead><tbody><tr ng-repeat=\"portlet in allPortlets \"><td>\n{{portlet.name}}</td><td>{{portlet.description}}</td><td layout=\"row\" layout-align=\"center center\" \nstyle=\"padding-top:0px !important;padding-bottom:0px !important\"><md-button class=\"md-icon-button test-tooltip\" \naria-label=\"Update\" ng-click=\"updatePortletDialog($event,portlet)\"><md-tooltip md-direction=\"top\">Update</md-tooltip>\n<md-icon><i layout=\"row\" layout-align=\"center center\" class=\"icon icon-pencil s18\"></i></md-icon></md-button><md-button\n class=\"md-icon-button test-tooltip\" aria-label=\"Delete\" ng-click=\"deletePortlet($event, portlet) \"><md-tooltip \nmd-direction=\"top\">Delete</md-tooltip><md-icon><i layout=\"row\" layout-align=\"center center\" \nclass=\"icon icon-delete s18\"></i></md-icon></md-button></td></tr></tbody></table></div></ms-widget></div><md-button \nflow-btn class=\"md-fab grey-700-bg md-mini md-fab-bottom-right\" ng-click=\"createPortletDialog($event)\"><md-icon \nmd-font-icon=\"icon-plus\" class=\"white-fg\"></md-icon><md-tooltip md-direction=\"top\">Create Portlet</md-tooltip>\n</md-button></div></div>");
$templateCache.put("app/main/business-admin/business-portlets/update.portlet.html","<md-dialog aria-label=\"Update Portlet\" flex=\"65\"><form name=\"portletForm\" novalidate \nng-submit=\"portletForm.$valid && save(portlet)\"><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2>\nUpdate Portlet</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content class=\"md-padding scrollable\" ms-scroll><div layout=\"row\" \nlayout-align=\"center center\"><span class=\"h3\" flex=\"35\"><b>Portlet Name </b></span><span flex=\"5\"></span>\n<md-input-container flex=\"45\" class=\"md-block\" style=\"margin: 0px\"><input type=\"text\" ng-model=\"portlet.name\" required>\n<div ng-messages=\"portletForm.name.$error\" role=\"alert\"><div ng-message=\"required\">Name is required</div></div>\n</md-input-container></div><div layout=\"row\" layout-align=\"center center\"><span flex=\"35\" class=\"h3\"><b>Description \n</b></span><span flex=\"5\"></span><md-input-container flex=\"45\" class=\"md-block\" style=\"margin: 0px\"><input type=\"text\" \nname=\"label\" ng-model=\"portlet.description\" required><div ng-messages=\"portletForm.description.$error\" role=\"alert\">\n<div ng-message=\"required\">Description is required</div></div></md-input-container></div><div layout=\"row\" \nlayout-align=\"center center\"><span flex=\"35\" class=\"h3\"><b>Details </b></span><span flex=\"5\"></span> <span flex=\"45\">\n</span></div><div layout=\"row\" layout-align=\"center center\" class=\"md-padding\"><text-angular \nng-model=\"portlet.htmlCodeSnippet\"></text-angular></div></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"center center\"><md-button type=\"button\" ng-click=\"cancel()\">Cancel</md-button><md-button type=\"submit\">\nSave</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/business-admin/business-templates/businesstemplate.content.html","<div class=\"page-layout simple right-sidenav\" layout=\"row\"><div \nclass=\"page-layout carded fullwidth md-padding scrollable\" layout=\"column\" flex ms-scroll><div class=\"widget-group\" \nflex=\"100\" layout=\"column\" layout-wrap><ms-widget flippable=\"true\" class=\"no-padding\"><div class=\"md-padding white-bg\">\n<div class=\"previous-state c-p\" data-ng-click=\"businessTemplateCtrl.goToadmin()\"><span><span \nclass=\"icon-arrow-left-bold-circle-outline\"></span> Back </span></div><table \nclass=\"dataTable row-border hover table-border\" datatable=\"ng\" dt-options=\"businessTemplateCtrl.dtOptions\"><thead><tr \nclass=\"table-header\"><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">TemplateName\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Description</span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">DocumentType</span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header\" layout=\"row\" layout-align=\"center center\"><span \nclass=\"column-title\">File</span></div></th></tr></thead><tbody><tr ng-repeat=\"template in templates\"><td>\n{{template.name}}</td><td>{{template.description}}</td><td>{{template.documentType}}</td><td layout=\"row\" \nlayout-align=\"center center\" style=\"padding-top:0px !important;padding-bottom:0px !important\"><md-button \nclass=\"md-icon-button test-tooltip\" aria-label=\"Update\" ng-click=\"updateTemplateDialog($event,template)\"><md-tooltip \nmd-direction=\"top\">Update</md-tooltip><md-icon><i layout=\"row\" layout-align=\"center center\" \nclass=\"icon icon-pencil s18\"></i></md-icon></md-button><md-button class=\"md-icon-button test-tooltip\" \naria-label=\"Delete\" ng-click=\" templateDelete(template)\"><md-tooltip md-direction=\"top\">Delete</md-tooltip><md-icon><i \nlayout=\"row\" layout-align=\"center center\" class=\"icon icon-delete s18\"></i></md-icon></md-button><md-button \nclass=\"md-icon-button test-tooltip\" aria-label=\"Display\" ng-click=\"previewFile($event) \"><md-tooltip \nmd-direction=\"top\">Display</md-tooltip><md-icon><i layout=\"row\" layout-align=\"center center\" \nclass=\"icon icon-login s18\"></i></md-icon></md-button></td></tr></tbody></table></div></ms-widget></div><md-button \nflow-btn class=\"md-fab grey-700-bg md-mini md-fab-bottom-right add_btn\" ng-click=\"createTemplateDialog(ev)\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon><md-tooltip md-direction=\"top\">Create Template</md-tooltip></md-button></div></div>");
$templateCache.put("app/main/business-admin/business-templates/businesstemplate.preview.html","<md-dialog style=\"height: 100%; width: 100%\"><md-dialog-content class=\"no-padding\"><iframe id=\"iframe\" \nsrc=\"{{fileURL}}\" name=\"contentframe\" frameborder=\"0\" \nstyle=\"width: 100%; height: 100%; position: absolute; z-index: 999\"></iframe></md-dialog-content></md-dialog>");
$templateCache.put("app/main/business-admin/business-templates/create.businesstemplate.html","<md-dialog flex=\"45\"><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2>Create Template</h2><span flex>\n</span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><form name=\"template\" novalidate layout=\"column\"><div layout=\"row\">\n<div flex=\"35\" layout=\"column\" layout-align=\"center end\"><span class=\"h3\"><b>Template Name </b></span></div><span \nflex=\"10\"></span><md-input-container flex=\"45\" class=\"md-block\" layout=\"column\" layout-align=\"space-around start\" \nstyle=\"margin-bottom: -11px\"><input type=\"text\" name=\"name\" ng-model=\"test.name\" placeholder=\"Template name\" required>\n</md-input-container></div><div layout=\"row\"><div flex=\"35\" layout=\"column\" layout-align=\"center end\"><span class=\"h3\">\n<b>Description </b></span></div><span flex=\"10\"></span><md-input-container flex=\"45\" class=\"md-block\" layout=\"column\" \nlayout-align=\"space-around start\" style=\"padding-top: 0px !important;padding-bottom: 0px !important\"><input \ntype=\"text\" name=\"name\" ng-model=\"test.description\" placeholder=\"Description\" required></md-input-container></div><div \nlayout=\"row\"><div flex=\"35\" layout=\"column\" layout-align=\"center end\"><span class=\"h3\"><b>DocumentType </b></span>\n</div><span flex=\"10\"></span><md-select ng-model=\"test.documentType\" placeholder=\"DocumentType\" flex=\"45\" \nstyle=\"margin-top:0px !important\"><md-option ng-value=\"doc.name\" ng-repeat=\"doc in Documents\">{{doc.name}}</md-option>\n</md-select></div><div layout=\"row\"><div flex=\"35\" layout=\"column\" layout-align=\"center end\"><span class=\"h3\"><b>\nTemplate File</b></span></div><span flex=\"10\"></span><div flex=\"45\" layout=\"column\" layout-align=\"center start\"><input \nclass=\"ng-hide\" id=\"formUploadFile\" name=\"formUploadFile\" type=\"file\" \nonchange=\"angular.element(this).scope().setFile(this)\"><label for=\"formUploadFile\" \nclass=\"md-button md-raised md-accent\">Browse</label></div></div><div><div ng-repeat=\"file in files.slice(0)\" \nlayout=\"row\" layout-align=\"center center\"><span class=\"md-warn\">{{file.webkitRelativePath || file.name}}</span> (<span \nng-switch=\"file.size > 1024*1024\"> <span ng-switch-when=\"true\">{{file.size / 1024 / 1024 | number:2}} MB</span> <span \nng-switch-default>{{file.size / 1024 | number:2}} kB</span> </span>)</div></div></form></md-dialog-content>\n<md-dialog-actions layout=\"row\"><span flex></span><md-button ng-click=\"cancel()\">Cancel</md-button><md-button \nng-click=\"save($event,test)\">Save</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/business-admin/business-templates/update.businesstemplate.html","<md-dialog flex=\"45\"><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2>Update Template</h2><span flex>\n</span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><form name=\"template\" novalidate layout=\"column\"><div layout=\"row\">\n<div flex=\"35\" layout=\"column\" layout-align=\"center end\"><span class=\"h3\"><b>Template Name </b></span></div><span \nflex=\"10\"></span><md-input-container flex=\"45\" class=\"md-block\" layout=\"column\" layout-align=\"space-around start\" \nstyle=\"margin-bottom: -11px\"><input type=\"text\" name=\"name\" ng-model=\"currentTemplate.name\" disabled=\"disabled\" \nplaceholder=\"Template name\" required></md-input-container></div><div layout=\"row\"><div flex=\"35\" layout=\"column\" \nlayout-align=\"center end\"><span class=\"h3\"><b>Description </b></span></div><span flex=\"10\"></span><md-input-container \nflex=\"45\" class=\"md-block\" layout=\"column\" layout-align=\"space-around start\" \nstyle=\"padding-top: 0px !important;padding-bottom: 0px !important\"><input type=\"text\" name=\"name\" \nng-model=\"currentTemplate.description\" placeholder=\"Description\" required></md-input-container></div><div layout=\"row\">\n<div flex=\"35\" layout=\"column\" layout-align=\"center end\"><span class=\"h3\"><b>DocumentType </b></span></div><span \nflex=\"10\"></span><md-select ng-model=\"currentTemplate.documentType\" placeholder=\"DocumentType\" flex=\"45\" \nstyle=\"margin-top:0px !important\"><md-option ng-value=\"doc.name\" ng-repeat=\"doc in Documents\">{{doc.name}}</md-option>\n</md-select></div><div layout=\"row\"><div flex=\"35\" layout=\"column\" layout-align=\"center end\"><span class=\"h3\"><b>\nTemplate File</b></span></div><span flex=\"10\"></span><div flex=\"45\" layout=\"column\" layout-align=\"center start\"><input \nclass=\"ng-hide\" id=\"formUploadFile\" name=\"formUploadFile\" type=\"file\" \nonchange=\"angular.element(this).scope().setFile(this)\"><label for=\"formUploadFile\" \nclass=\"md-button md-raised md-accent\">Browse</label></div></div><div><div ng-repeat=\"file in files.slice(0)\" \nlayout=\"row\" layout-align=\"center center\"><span class=\"md-warn\">{{file.webkitRelativePath || file.name}}</span> (<span \nng-switch=\"file.size > 1024*1024\"> <span ng-switch-when=\"true\">{{file.size / 1024 / 1024 | number:2}} MB</span> <span \nng-switch-default>{{file.size / 1024 | number:2}} kB</span> </span>)</div></div></form></md-dialog-content>\n<md-dialog-actions layout=\"row\"><span flex></span><md-button ng-click=\"cancel()\">Cancel</md-button><md-button \nng-click=\"update($event,currentTemplate)\">Update</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/business-admin/business-usermanagement/businessUsers.html","<div class=\"page-layout simple right-sidenav\" layout=\"row\"><div \nclass=\"page-layout carded fullwidth md-padding scrollable\" layout=\"column\" flex ms-scroll><div class=\"widget-group\" \nflex=\"100\" layout=\"column\" layout-wrap><ms-widget flippable=\"true\" class=\"no-padding\"><div class=\"md-padding white-bg\">\n<div layout=\"row\"><div class=\"previous-state c-p\" data-ng-click=\"businessUserCtrl.goToadmin()\"><span><span \nclass=\"icon-arrow-left-bold-circle-outline\"></span> Back </span></div></div><table \nclass=\"dataTable row-border hover table-border\" datatable=\"ng\" dt-options=\"businessUserCtrl.dtOptions\"><thead><tr \nclass=\"table-header\"><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Login</span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">First Name</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Last Name</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Email</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Authorities</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Activated</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\" layout=\"row\" layout-align=\"center center\"><span class=\"column-title\">\nActions</span></div></th></tr></thead><tbody><tr ng-repeat=\"user in usersList | filter : searchUser\"><td>{{user.login}}\n</td><td>{{user.firstName}}</td><td>{{user.lastName}}</td><td>{{user.email}}</td><td><span \nclass=\"text-boxed green-bg white-fg\" ng-show=\"{{user.authorities.indexOf(\'ROLE_USER\') != -1}}\">User</span> <span \nclass=\"text-boxed orange-bg white-fg\" ng-show=\"{{user.authorities.indexOf(\'ROLE_ADMIN\') != -1}}\">Admin</span> <span \nclass=\"text-boxed pink-bg white-fg\" ng-show=\"{{user.authorities.indexOf(\'ROLE_AUDITOR\') != -1}}\">Auditor</span> <span \nclass=\"text-boxed blue-bg white-fg\" ng-show=\"{{user.authorities.indexOf(\'ROLE_TICKETMANAGER\') != -1}}\">Ticket Manager\n</span></td><td style=\"padding-top:0px !important;padding-bottom:0px !important\"><i \nclass=\"icon-checkbox-marked-circle green-500-fg\" ng-show=\"{{user.activated}}\"></i> <i class=\"icon-cancel red-500-fg\" \nng-show=\"{{! user.activated}}\"></i></td><td layout=\"row\" layout-align=\"center center\" \nstyle=\"padding-top:0px !important;padding-bottom:0px !important\"><md-button class=\"md-icon-button test-tooltip\" \naria-label=\"Update\" ng-click=\"updateUserDialog($event,user)\"><md-tooltip md-direction=\"top\">Update</md-tooltip>\n<md-icon><i layout=\"row\" layout-align=\"center center\" class=\"icon icon-pencil s18\"></i></md-icon></md-button><md-button\n class=\"md-icon-button test-tooltip\" aria-label=\"Delete\" ng-click=\"businessUserCtrl.deleteUser($event, user) \">\n<md-tooltip md-direction=\"top\">Delete</md-tooltip><md-icon><i layout=\"row\" layout-align=\"center center\" \nclass=\"icon icon-delete s18\"></i></md-icon></md-button><md-button class=\"md-icon-button test-tooltip\" \naria-label=\"Delete\" ng-click=\"businessUserCtrl.resetPassword(user.email)\"><md-tooltip md-direction=\"top\">Reset Password\n</md-tooltip><md-icon><i layout=\"row\" layout-align=\"center center\" class=\"icon-account-key s20\"></i></md-icon>\n</md-button></td></tr></tbody></table></div></ms-widget></div><md-button flow-btn \nclass=\"md-fab grey-700-bg md-mini md-fab-bottom-right add_btn\" aria-label=\"Create User\" \nng-click=\"createUserDialog($event)\"><md-icon md-font-icon=\"icon-plus\"></md-icon><md-tooltip md-direction=\"top\">\nCreate User</md-tooltip></md-button></div></div>");
$templateCache.put("app/main/business-admin/business-usermanagement/create.businessuser.dialog.html","<md-dialog aria-label=\"Add a new user\"><form name=\"userForm\" novalidate ng-submit=\"userForm.$valid && save(user)\" \nlayout=\"column\" flex=\"66\"><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2>Create User</h2><span flex>\n</span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><md-input-container class=\"md-block\"><label>Login Id</label><input \ntype=\"text\" name=\"login\" ng-model=\"user.login\" required><div ng-messages=\"userForm.login.$error\" role=\"alert\"><div \nng-message=\"required\">User ID is required</div></div></md-input-container><md-input-container class=\"md-block\"><label>\nEmail</label><input type=\"email\" name=\"email\" ng-model=\"user.email\" ng-pattern=\"re\" required><div \nng-messages=\"userForm.email.$error||userForm.email.$error.pattern \" role=\"alert\" multiple=\"multiple\"><div \nng-message=\"required\"><span class=\"error\">Email is required</span></div><div ng-message=\"email\"><span class=\"\">\nEmail must be a valid e-mail address</span></div><div ng-message=\"pattern\"><span class=\"\">Please enter correct domain\n</span></div></div></md-input-container><div layout=\"row\"><md-input-container class=\"md-block\" flex=\"45\"><label>\nFirst Name</label><input type=\"text\" name=\"firstName\" ng-pattern=\"/^[a-zA-Z0-9]*$/\" ng-model=\"user.firstName\" required>\n<div ng-messages=\"userForm.firstName.$error\" role=\"alert\"><div ng-message=\"required\"><span>First Name is required\n</span></div><div ng-message=\"pattern\"><span>First Name has invalid characters</span></div></div></md-input-container>\n<span flex=\"10\"></span><md-input-container class=\"md-block\" flex=\"45\"><label>Last name</label><input type=\"text\" \nautocomplete=\"false\" name=\"userLastName\" ng-pattern=\"/^[a-zA-Z0-9]*$/\" ng-model=\"user.lastName\" required><div \nng-messages=\"userForm.userLastName.$error\" role=\"alert\"><div ng-message=\"required\"><span>Last Name is required</span>\n</div><div ng-message=\"pattern\"><span>Last Name has invalid characters</span></div></div></md-input-container></div>\n<div layout=\"row\" layout-align=\"start center\"><md-input-container class=\"md-block\" flex=\"45\"><label>Password</label>\n<input type=\"{{inputType}}\" autocomplete=\"new-password\" name=\"passwordOne\" ng-model=\"user.password\" required><div \nng-messages=\"userForm.passwordOne.$error\" role=\"alert\"><div ng-message=\"required\">Password is required</div></div>\n</md-input-container><span flex=\"5\"></span><md-checkbox type=\"checkbox\" ng-model=\"mypassword\" \nng-click=\"hideShowPassword()\"><label for=\"checkbox\" ng-if=\"mypassword\">Hide</label><label for=\"checkbox\" \nng-if=\"!mypassword\">Show</label></md-checkbox></div><div layout=\"row\"><md-input-container class=\"md-block\" flex=\"45\">\n<label>Select Authority</label><md-select name=\"Authority\" ng-model=\"user.authorities\" multiple=\"multiple\" required>\n<md-option ng-value=\"authority\" ng-repeat=\"authority in roles\" ng-selected=\"$first\">\n{{ authority.replace(\"ROLE_USER\",\"User\").replace(\"ROLE_ADMIN\",\"Admin\").replace(\"ROLE_TICKETMANAGER\",\"TicketManager\").replace(\"ROLE_AUDITOR\",\"Auditor\") }}\n</md-option></md-select><div ng-messages=\"userForm.Authority.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nAuthority is required</span></div></div></md-input-container><span flex=\"10\"></span><md-switch \nng-model=\"user.activated\" aria-label=\" Activate User\">Activate User</md-switch></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" layout-align=\"center center\"><md-button type=\"button\" ng-click=\"cancel()\">Cancel\n</md-button><md-button type=\"submit\">Save</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/business-admin/business-usermanagement/resetpassword.html","<md-dialog flex=\"35\"><form name=\"passwordForm\" novalidate layout=\"column\"><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools\"><h2>Reset Password</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"cancel()\"><md-icon md-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"column\" \nlayout-align=\"center center\"><md-input-container class=\"md-block\"><md-icon md-font-icon=\"icon-key-variant\" \nstyle=\"color: rgb(5, 167, 253) !important\"></md-icon><input type=\"password\" name=\"password\" ng-model=\"user.password\" \nplaceholder=\"Enter Password*\" required><div ng-messages=\"passwordForm.password.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Password field is required</span></div></div></md-input-container><md-input-container \nclass=\"md-block\"><md-icon md-font-icon=\"icon-key-variant\" style=\"color: rgb(5, 167, 253) !important\"></md-icon><input \ntype=\"password\" name=\"passwordConfirm\" ng-model=\"user.passwordConfirm\" placeholder=\"Re-enter Password*\" required> <span\n style=\"color: red;font-family: \'Roboto\';font-size: 12px\" ng-show=\"user.password !== user.passwordConfirm\">\nPasswords do not match</span><div ng-messages=\"passwordForm.passwordConfirm.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Re-enter Password field is required</span></div></div></md-input-container></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"center center\"><md-button type=\"button\" \nng-click=\"cancel()\">Cancel</md-button><md-button type=\"submit\" \nng-click=\"passwordForm.$valid && resetPasswordfinish(user.password,key)\">Save</md-button></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/business-admin/business-usermanagement/update.businessuser.dialog.html","<md-dialog aria-label=\"Update a user\"><form name=\"userUpdateForm\" novalidate \nng-submit=\"userUpdateForm.$valid && update(currentUser)\" layout=\"column\" flex=\"66\"><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools\"><h2>Update User:{{currentUser.login}}</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"cancel()\"><md-icon md-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content layout=\"column\">\n<md-input-container><input type=\"text\" disabled=\"true\" name=\"login\" ng-model=\"currentUser.login\" \nplaceholder=\"Login Id\" required></md-input-container><md-input-container class=\"md-block\"><input type=\"email\" \ndisabled=\"true\" name=\"email\" ng-model=\"currentUser.email\" placeholder=\"Email\" required></md-input-container><div \nlayout=\"row\"><md-input-container class=\"md-block\" flex=\"45\"><input type=\"text\" name=\"firstName\" \nng-pattern=\"/^[a-zA-Z0-9._- ]*$/\" ng-model=\"currentUser.firstName\" placeholder=\"First name\" required><div \nng-messages=\"userUpdateForm.firstName.$error\" role=\"alert\"><div ng-message=\"required\"><span>First Name is required\n</span></div><div ng-message=\"pattern\"><span>First Name has invalid characters</span></div></div></md-input-container>\n<span flex=\"10\"></span><md-input-container class=\"md-block\" flex=\"45\"><input type=\"text\" name=\"lastName\" \nng-pattern=\"/^[a-zA-Z0-9._- ]*$/\" ng-model=\"currentUser.lastName\" placeholder=\"Last name\"><div \nng-messages=\"userUpdateForm.lastName.$error\" role=\"alert\"><div ng-message=\"pattern\"><span>\nLast Name has invalid characters</span></div></div></md-input-container></div><div layout=\"row\"><md-input-container \nclass=\"md-block\" flex=\"45\"><label>Select Authority</label><md-select name=\"Authority\" \nng-model=\"currentUser.authorities\" multiple=\"multiple\" required><md-option ng-value=\"authority\" \nng-repeat=\"authority in roles\">\n{{authority.replace(\"ROLE_USER\",\"User\").replace(\"ROLE_ADMIN\",\"Admin\").replace(\"ROLE_TICKETMANAGER\",\"TicketManager\").replace(\"ROLE_AUDITOR\",\"Auditor\")}}\n</md-option></md-select><div ng-messages=\"userUpdateForm.Authority.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>Authority is required</span></div></div></md-input-container><span flex=\"10\"></span><md-switch \nng-model=\"currentUser.activated\" aria-label=\" Activate User\">Activate User</md-switch></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" layout-align=\"center center\"><md-button ng-click=\"cancel()\">Cancel</md-button>\n<md-button type=\"submit\">Update</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/business-admin/business-invoicetypes/create.invoicetype.dialog.html","<md-dialog aria-label=\"Add List\" flex=\"45\"><form name=\"listForm\" novalidate layout=\"column\"><md-toolbar \nclass=\"md-accent\"><div class=\"md-toolbar-tools\"><h2>Create Detail</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><div layout=\"column\"><md-input-container class=\"md-block\" flex=\"45\" \nng-if=\"list != \'_id\'\" ng-repeat=\"list in attrdata track by $index\"><label>{{list}}</label><input type=\"text\" \nname=\"arrval\" ng-model=\"crlist[$index].list\" required><div ng-messages=\"listForm.list.$error\" role=\"alert\"><div \nng-message=\"required\"><span>{{list}} is required</span></div><div ng-message=\"pattern\"><span>\n{{list}} has invalid characters</span></div></div></md-input-container></div></md-dialog-content><md-dialog-actions \nlayout=\"row\" layout-align=\"center center\"><md-button type=\"button\" ng-click=\"cancel()\">Cancel</md-button><md-button \ntype=\"submit\" ng-click=\"listForm.$valid && save()\">Save</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/business-admin/business-invoicetypes/invoicetypes.html","<div class=\"page-layout simple right-sidenav\" layout=\"row\"><div \nclass=\"page-layout carded fullwidth md-padding scrollable\" layout=\"column\" flex ms-scroll><div class=\"widget-group\" \nflex=\"100\" layout=\"column\" layout-wrap><ms-widget flippable=\"true\" class=\"no-padding\"><div \nclass=\"md-padding white-bg scrollable\" ms-scroll><div class=\"md-padding white-bg\" ng-init=\"List()\"><div \nclass=\"previous-state c-p\" data-ng-click=\"goToPreviousState()\"><span><span class=\"icon-arrow-left-bold-circle-outline\">\n</span> Back </span></div><table class=\"dataTable row-border hover table-border\" datatable=\"ng\" \ndt-options=\"employeeCtrl.dtOptions\" layout-wrap ng-if=\"inputfield != \'\'\"><thead><tr class=\"table-header\"><th \nclass=\"secondary-text\" ng-hide=\"value == \'_id\'\" ng-repeat=\"(key, value) in inputfield\"><div class=\"table-header\"><span \nclass=\"column-title\">{{value}}</span></div></th><th class=\"secondary-text\"><div class=\"table-header\" layout=\"row\" \nlayout-align=\"center center\"><span class=\"column-title\">Actions</span></div></th></tr></thead><tbody><tr \nng-repeat=\"(key, value) in EmployeesList track by $index\"><td ng-hide=\"k == \'_id\'\" \nng-repeat=\"(k, v) in EmployeesList[$index] track by $index\">{{v}}</td><td layout=\"row\" layout-align=\"center center\" \nstyle=\"padding-top:0px !important;padding-bottom:0px !important\"><md-button class=\"md-icon-button test-tooltip\" \naria-label=\"Update\" ng-click=\"updateEmployee($event,EmployeesList[$index])\"><md-tooltip md-direction=\"top\">Update\n</md-tooltip><md-icon><i layout=\"row\" layout-align=\"center center\" class=\"icon icon-pencil s18\"></i></md-icon>\n</md-button><md-button class=\"md-icon-button test-tooltip\" aria-label=\"Delete\" \nng-click=\"deletedata($event,EmployeesList[$index]) \"><md-tooltip md-direction=\"top\">Delete</md-tooltip><md-icon><i \nlayout=\"row\" layout-align=\"center center\" class=\"icon icon-delete s18\"></i></md-icon></md-button></td></tr></tbody>\n</table><div ng-if=\"inputfield == undefined\"><h1>No Data Available</h1></div></div></div></ms-widget><md-button \nflow-btn class=\"md-fab grey-700-bg md-mini md-fab-bottom-right\" ng-click=\"createEmployee()\"><md-icon \nmd-font-icon=\"icon-plus\" class=\"white-fg\"></md-icon><md-tooltip md-direction=\"top\">Create Employee</md-tooltip>\n</md-button></div></div></div>");
$templateCache.put("app/main/business-admin/business-invoicetypes/update.invoicetype.dialog.html","<md-dialog aria-label=\"Add List\" flex=\"45\"><form name=\"listForm\" novalidate \nng-submit=\"listForm.$valid && updatedata()\" layout=\"column\"><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools\"><h2>Update Detail</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\">\n<md-icon md-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><div layout=\"column\"><md-input-container class=\"md-block\" flex=\"45\" \nng-hide=\"key == \'_id\'\" ng-repeat=\"(key, value) in currentdata track by $index\"><label>{{key}}</label><input \ntype=\"text\" name=\"arrval\" ng-init=\"updateddata[$index] = value\" ng-model=\"updateddata[$index]\" required><div \nng-messages=\"listForm.$error\" role=\"alert\"><div ng-message=\"required\"><span>{{key}} is required</span></div><div \nng-message=\"pattern\"><span>{{key}} has invalid characters</span></div></div></md-input-container></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"center center\"><md-button type=\"button\" \nng-click=\"cancel()\">Cancel</md-button><md-button type=\"submit\">update</md-button></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/business-admin/business-companies/company.html","<div class=\"page-layout simple right-sidenav\" layout=\"row\"><div \nclass=\"page-layout carded fullwidth md-padding scrollable\" layout=\"column\" flex ms-scroll><div class=\"widget-group\" \nflex=\"100\" layout=\"column\" layout-wrap><ms-widget flippable=\"true\" class=\"no-padding\"><div \nclass=\"md-padding white-bg scrollable\" ms-scroll><div class=\"md-padding white-bg\" ng-init=\"List()\"><div \nclass=\"previous-state c-p\" data-ng-click=\"goToPreviousState()\"><span><span class=\"icon-arrow-left-bold-circle-outline\">\n</span> Back </span></div><table class=\"dataTable row-border hover table-border\" datatable=\"ng\" \ndt-options=\"companyCtrl.dtOptions\" layout-wrap ng-if=\"inputfield != \'\'\"><thead><tr class=\"table-header\"><th \nclass=\"secondary-text\" ng-hide=\"value == \'_id\'\" ng-repeat=\"(key, value) in inputfield\"><div class=\"table-header\"><span \nclass=\"column-title\">{{value}}</span></div></th><th class=\"secondary-text\"><div class=\"table-header\" layout=\"row\" \nlayout-align=\"center center\"><span class=\"column-title\">Actions</span></div></th></tr></thead><tbody><tr \nng-repeat=\"(key, value) in EmployeesList track by $index\"><td ng-hide=\"k == \'_id\'\" \nng-repeat=\"(k, v) in EmployeesList[$index] track by $index\">{{v}}</td><td layout=\"row\" layout-align=\"center center\" \nstyle=\"padding-top:0px !important;padding-bottom:0px !important\"><md-button class=\"md-icon-button test-tooltip\" \naria-label=\"Update\" ng-click=\"updateEmployee($event,EmployeesList[$index])\"><md-tooltip md-direction=\"top\">Update\n</md-tooltip><md-icon><i layout=\"row\" layout-align=\"center center\" class=\"icon icon-pencil s18\"></i></md-icon>\n</md-button><md-button class=\"md-icon-button test-tooltip\" aria-label=\"Delete\" \nng-click=\"deletedata($event,EmployeesList[$index]) \"><md-tooltip md-direction=\"top\">Delete</md-tooltip><md-icon><i \nlayout=\"row\" layout-align=\"center center\" class=\"icon icon-delete s18\"></i></md-icon></md-button></td></tr></tbody>\n</table><div ng-if=\"inputfield == undefined\"><h1>No Data Available</h1></div></div></div></ms-widget><md-button \nflow-btn class=\"md-fab grey-700-bg md-mini md-fab-bottom-right\" ng-click=\"createEmployee()\"><md-icon \nmd-font-icon=\"icon-plus\" class=\"white-fg\"></md-icon><md-tooltip md-direction=\"top\">Create Employee</md-tooltip>\n</md-button></div></div></div>");
$templateCache.put("app/main/business-admin/business-companies/create.company.dialog.html","<md-dialog aria-label=\"Add List\" flex=\"45\"><form name=\"listForm\" novalidate layout=\"column\"><md-toolbar \nclass=\"md-accent\"><div class=\"md-toolbar-tools\"><h2>Create Detail</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><div layout=\"column\"><md-input-container class=\"md-block\" flex=\"45\" \nng-if=\"list != \'_id\'\" ng-repeat=\"list in attrdata track by $index\"><label>{{list}}</label><input type=\"text\" \nname=\"arrval\" ng-model=\"crlist[$index].list\" required><div ng-messages=\"listForm.list.$error\" role=\"alert\"><div \nng-message=\"required\"><span>{{list}} is required</span></div><div ng-message=\"pattern\"><span>\n{{list}} has invalid characters</span></div></div></md-input-container></div></md-dialog-content><md-dialog-actions \nlayout=\"row\" layout-align=\"center center\"><md-button type=\"button\" ng-click=\"cancel()\">Cancel</md-button><md-button \ntype=\"submit\" ng-click=\"listForm.$valid && save()\">Save</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/business-admin/business-companies/update.company.dialog.html","<md-dialog aria-label=\"Add List\" flex=\"45\"><form name=\"listForm\" novalidate \nng-submit=\"listForm.$valid && updatedata()\" layout=\"column\"><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools\"><h2>Update Detail</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\">\n<md-icon md-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><div layout=\"column\"><md-input-container class=\"md-block\" flex=\"45\" \nng-hide=\"key == \'_id\'\" ng-repeat=\"(key, value) in currentdata track by $index\"><label>{{key}}</label><input \ntype=\"text\" name=\"arrval\" ng-init=\"updateddata[$index] = value\" ng-model=\"updateddata[$index]\" required><div \nng-messages=\"listForm.$error\" role=\"alert\"><div ng-message=\"required\"><span>{{key}} is required</span></div><div \nng-message=\"pattern\"><span>{{key}} has invalid characters</span></div></div></md-input-container></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"center center\"><md-button type=\"button\" \nng-click=\"cancel()\">Cancel</md-button><md-button type=\"submit\">update</md-button></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/administration/admin-reAssign/create.reAssign.html","<md-dialog flex=\"40\" ng-init=\"getAllUsers();\"><form name=\"userForm\" novalidate \nng-submit=\"userForm.$valid && userCtrl.createUser(user)\" layout=\"column\"><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools\"><h2>Select User for Re-Assignment</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"cancel()\"><md-icon md-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"row\" flex=\"100\" \nlayout-align=\"space-between center\"><md-input-container class=\"md-block\"><input type=\"text\" name=\"name\" \nng-model=\"member.name\" placeholder=\"Name\"></md-input-container><md-input-container class=\"md-block\"><input type=\"text\" \nname=\"email\" ng-model=\"member.email\" placeholder=\"Email\"></md-input-container><md-button type=\"button\" \nclass=\"md-raised\" ng-click=\"searchMember(member)\" style=\"margin-bottom: 20px\"><md-icon md-font-icon=\"icon-magnify\">\n</md-icon>Search</md-button></div><div layout=\"row\" layout-align=\"center center\" \nng-style=\"{\'color\':\'red\',\'font-family\':\'Verdana\',\'font-size\':\'18px\'}\" ng-show=\"msgVisibility\">\nPlease enter either name or email</div><div class=\"md-padding\"></div><div ng-show=\"tableVisibility\" \nclass=\"md-padding scrollable\" ms-scroll><table class=\"dataTable row-border hover table-border\" datatable=\"ng\" \ndt-options=\"dataCtrl.dtOptions\"><thead><tr class=\"table-header\"><th class=\"secondary-text\"><div class=\"table-header\">\n<span class=\"column-title\">NAME</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">EMAIL</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Select</span></div></th></tr></thead><tbody><tr ng-repeat=\"member in searchedMembers[0]\"><td \nclass=\"md-padding\">{{member.firstName}} {{member.lastName}}</td><td class=\"md-padding\">{{member.email}}</td><td \nlayout=\"row\" layout-align=\"center center\"><md-button class=\"md-icon-button green-bg\" \nng-click=\"collaborateActivity($event,member.login, inboxComment)\"><md-icon class=\"white-fg\" md-font-icon=\"icon-check\">\n</md-icon><md-tooltip md-direction=\"top\">Select</md-tooltip></md-button></td></tr></tbody></table></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"center center\"><md-button type=\"button\" \nng-click=\"cancel()\">Cancel</md-button><md-button type=\"submit\" ng-click=\"userForm.$valid && save(substitute)\">Save\n</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/administration/admin-reAssign/preview.reAssign.html","<div class=\"page-layout simple right-sidenav\" layout=\"row\" ng-init=\"reassignCtrl.getAllRequestTypes()\"><div \nlayout=\"column\" layout-wrap><ms-widget flippable=\"true\" layout=\"column\"><div \nng-include=\"\'app/main/administration/common/admin.html\'\"></div></ms-widget></div><div \nclass=\"page-layout carded fullwidth md-padding scrollable\" layout=\"column\" flex ms-scroll ng-cloak><div \nclass=\"parent-tabs white-bg mb-15\"><md-tabs class=\"mh-0\"><md-tab label=\"Substitution\" \nui-sref=\"app.administration.substitution\"></md-tab><md-tab label=\"Re-Assign\" ui-sref=\"app.administration.reAssign\" \nmd-active=\"true\"></md-tab></md-tabs></div><div class=\"widget-group\" flex=\"100\" layout=\"column\" layout-wrap><ms-widget \nflippable=\"true\" layout=\"column\" flex=\"100\" md-dynamic-height><ms-widget-front class=\"white-bg\" class=\"scrollable\" \nms-scroll><div layout=\"column\" ng-cloak style=\"flex:none\"><div layout-gt-sm=\"row\" layout-align=\"start start\" \nclass=\"md-padding\"><md-input-container flex-gt-sm=\"20\" md-no-float><label>DOCTYPE</label><md-select \nng-model=\"obj.requestType\"><md-option ng-value=\"request.name\" ng-repeat=\"request in allRequests\">{{request.name}}\n</md-option></md-select></md-input-container><span flex=\"5\"></span><md-input-container flex-gt-sm=\"20\"><input \ntype=\"text\" name=\"name\" ng-model=\"member.name\" placeholder=\"Name\"></md-input-container><span flex=\"5\"></span>\n<md-input-container flex-gt-sm=\"20\"><input type=\"text\" name=\"email\" ng-model=\"member.email\" placeholder=\"Email\">\n</md-input-container><span flex=\"5\"></span><md-button type=\"button\" class=\"md-raised\" ng-click=\"searchMember(member)\" \nstyle=\"margin-top:2%\"><md-icon md-font-icon=\"icon-magnify\"></md-icon>Search</md-button></div></div><div layout=\"row\" \nlayout-align=\"center center\" ng-style=\"{\'color\':\'red\',\'font-family\':\'Verdana\',\'font-size\':\'18px\'}\" \nng-show=\"msgVisibility\">Please enter either name or email</div><div layout=\"row\" layout-align=\"start strat\"><div \nng-show=\"tableVisibility\" class=\"md-padding\" flex=\"50\"><table class=\"dataTable row-border hover table-border\" \ndatatable=\"ng\" dt-options=\"dataCtrl.dtOptions\"><thead><tr class=\"table-header\"><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Login</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">NAME</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Select</span></div></th></tr></thead><tbody><tr \nng-repeat=\"member in searchedMembers[0]\"><td class=\"md-padding\">{{member.login}}</td><td class=\"md-padding\">\n{{member.firstName}} {{member.lastName}}</td><td layout=\"row\" layout-align=\"center center\"><md-button \nclass=\"md-icon-button md-mini green-bg\" ng-click=\"getRequestIds(member.login)\"><md-icon class=\"white-fg\" \nmd-font-icon=\"icon-check\"></md-icon><md-tooltip md-direction=\"top\">Select</md-tooltip></md-button></td></tr></tbody>\n</table></div><div ng-if=\"allRequestTypes\" class=\"md-padding scrollable\" ms-scroll flex=\"50\"><table \nclass=\"dataTable row-border hover table-border\" datatable=\"ng\" dt-options=\"reassignCtrl.dtOptions\"><thead><tr \nclass=\"table-header\"><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\"><b>Request Type\n</b></span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\"><b>Agent</b>\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\"><b>Action</b></span>\n</div></th></tr></thead><tbody><tr ng-repeat=\"requestType in allRequestTypes track by $index\"><td class=\"md-padding\">\n{{requestType | uppercase}}</td><td class=\"md-padding\">{{reassignCtrl.member}}</td><td layout=\"row\" \nlayout-align=\"center center\"><md-checkbox ng-model=\"x\" ng-change=\"selectNumber(x,requestType, $index)\" \nstyle=\"margin-bottom: 0px\"></md-checkbox></td></tr></tbody></table></div></div><div layout=\"row\" \nlayout-align=\"end end\" ng-if=\"allRequestTypes\"><md-button type=\"button\" class=\"md-raised md-warn\" \nng-click=\"searchforReassignUser()\" style=\"margin-bottom: 20px\">Search User for Re-assign</md-button></div>\n</ms-widget-front></ms-widget></div></div></div>");
$templateCache.put("app/main/administration/admin-reAssign/reAssignmentDialog.html","<md-dialog flex=\"40\" ng-init=\"getAllUsers();\"><form name=\"userForm\" novalidate \nng-submit=\"userForm.$valid && userCtrl.createUser(user)\" layout=\"column\"><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools\"><h2>Select User for Re-Assignment</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"cancel()\"><md-icon md-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"row\" flex=\"100\" \nlayout-align=\"space-between center\"><md-input-container class=\"md-block\"><input type=\"text\" name=\"name\" \nng-model=\"member.name\" placeholder=\"Name\"></md-input-container><md-input-container class=\"md-block\"><input type=\"text\" \nname=\"email\" ng-model=\"member.email\" placeholder=\"Email\"></md-input-container><md-button type=\"button\" \nclass=\"md-raised\" ng-click=\"searchMember(member)\" style=\"margin-bottom: 20px\"><md-icon md-font-icon=\"icon-magnify\">\n</md-icon>Search</md-button></div><div layout=\"row\" layout-align=\"center center\" \nng-style=\"{\'color\':\'red\',\'font-family\':\'Verdana\',\'font-size\':\'18px\'}\" ng-show=\"msgVisibility\">\nPlease enter either name or email</div><div class=\"md-padding\"></div><div ng-show=\"tableVisibility\" \nclass=\"md-padding scrollable\" ms-scroll><table class=\"dataTable row-border hover table-border\" datatable=\"ng\" \ndt-options=\"dataCtrl.dtOptions\"><thead><tr class=\"table-header\"><th class=\"secondary-text\"><div class=\"table-header\">\n<span class=\"column-title\">NAME</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">EMAIL</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Select</span></div></th></tr></thead><tbody><tr ng-repeat=\"member in searchedMembers[0]\"><td \nclass=\"md-padding\">{{member.firstName}} {{member.lastName}}</td><td class=\"md-padding\">{{member.email}}</td><td \nlayout=\"row\" layout-align=\"center center\"><md-button class=\"md-icon-button green-bg\" ng-click=\"submit(member.login)\">\n<md-icon class=\"white-fg\" md-font-icon=\"icon-check\"></md-icon><md-tooltip md-direction=\"top\">Select</md-tooltip>\n</md-button></td></tr></tbody></table></div></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"center center\"><md-button type=\"button\" ng-click=\"cancel()\">Cancel</md-button><md-button type=\"submit\" \nng-click=\"userForm.$valid && save(substitute)\">Save</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/administration/admin-reports/admin-reports.html","<div class=\"page-layout simple right-sidenav\" layout=\"row\"><div \nng-include=\"\'app/main/administration/common/admin.html\'\"></div><div \nclass=\"page-layout carded fullwidth md-padding scrollable\" layout=\"column\" flex ms-scroll ng-init=\"getRequests()\"><div \nclass=\"widget-group\" flex=\"100\"><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" md-dynamic-height>\n<ms-widget-front class=\"white-bg\"><div class=\"row\" style=\"background-color: white\"><div id=\"report\" \nstyle=\"padding: 20px\" class=\"scrollable\" ms-scroll><div layout=\"row\" layout-align=\"space-between center\">\n<md-input-container flex-gt-sm=\"15\" class=\"md-block margin\" \nstyle=\"border: 1px solid rgb(169, 161, 161);margin-top: 0%;border-radius: 5px;height: 35px;margin-right: 1%\"><label>\nRequest Type</label><md-select ng-model=\"obj.requestType\" multiple=\"multiple\"><md-option ng-value=\"requestType.name\" \nng-repeat=\"requestType in requestTypes\" ng-selected=\"$first\">{{requestType.name}}</md-option></md-select>\n</md-input-container><md-input-container flex-gt-sm=\"15\" class=\"md-block\" \nstyle=\"border: 1px solid rgb(169, 161, 161);margin-top: 0%;border-radius: 5px;height: 35px;margin-right: 1%\"><md-icon \nmd-font-icon=\"icon-magnify\"></md-icon><input ng-model=\"obj.sapDocId\" type=\"text\" placeholder=\"Request Id\">\n</md-input-container><md-input-container flex-gt-sm=\"15\" class=\"md-block margin\" \nstyle=\"border: 1px solid rgb(169, 161, 161);margin-top: 0%;border-radius: 5px;height: 35px;margin-right: 1%\"><label>\nInitiator</label><md-select ng-model=\"obj.creator\"><md-option ng-value=\"user.login\" \nng-repeat=\"user in users | orderBy:\'firstName\'\">{{user.firstName}} {{user.lastName}}</md-option></md-select>\n</md-input-container><md-input-container flex-gt-sm=\"15\" class=\"md-block\" \nstyle=\"border: 1px solid rgb(169, 161, 161);margin-top: 0%;margin-right: 1%;border-radius: 5px;height: 35px\"><label>\nFrom Date</label><input moment-picker=\"obj.fromDate\" ng-model=\"obj.fromDate\" autocomplete=\"off\" format=\"DD/MM/YYYY\">\n</md-input-container><md-input-container flex-gt-sm=\"15\" class=\"md-block\" \nstyle=\"border: 1px solid rgb(169, 161, 161);margin-top: 0%;margin-right: 1%;border-radius: 5px;height: 35px\"><label>\nTo Date</label><input moment-picker=\"obj.toDate\" ng-model=\"obj.toDate\" autocomplete=\"off\" format=\"DD/MM/YYYY\" \nng-disabled=\"obj.fromDate == null\" min-date=\"obj.fromDate\"></md-input-container><md-input-container flex-gt-sm=\"15\" \nclass=\"md-block margin\" \nstyle=\"border: 1px solid rgb(169, 161, 161);margin-top: 0%;border-radius: 5px;height: 35px;margin-right: 1%\"><label>\nCurrentUser</label><md-select ng-model=\"obj.currentUser\"><md-option ng-value=\"user.login\" \nng-repeat=\"user in users | orderBy:\'firstName\'\">{{user.firstName}} {{user.lastName}}</md-option></md-select>\n</md-input-container><md-input-container flex-gt-sm=\"15\" class=\"md-block\" \nstyle=\"border: 1px solid rgb(169, 161, 161);margin-top: 0%;border-radius: 5px;height: 35px;margin-right: 1%\"><md-icon \nmd-font-icon=\"icon-magnify\"></md-icon><input ng-model=\"searchReport\" type=\"text\" placeholder=\"Global Filter\">\n</md-input-container><div flex-gt-sm=\"15\" layout=\"row\" style=\"margin-top: -1%\"><md-button class=\"md-raised md-accent\" \nng-click=\"searchforReports(obj)\" \nng-disabled=\"(obj.selectAll == null && obj.selectAll== false && obj.requestType ==null && obj.creator==null && obj.project ==null && obj.department ==null)\" \nstyle=\"margin-top:-1% !important;margin-right: 5%\">Search</md-button><md-button class=\"md-raised md-warn\" \nng-click=\"Reset()\" style=\"margin-top:-1% !important\">Reset</md-button></div><md-input-container \nclass=\"md-block md-padding\" style=\"margin-top: 0%\"><md-select ng-model=\"sizeNumber\"><md-option \nng-repeat=\"size in sizeNumbers\" ng-value=\"size\" ng-click=\"sendsizeNumber(size)\" value=\"sizeNumber\" \nng-selected=\"$first\">{{size}}</md-option></md-select></md-input-container></div></div></div><div><div layout=\"row\" \nflex=\"60\" layout-align=\"center center\" ng-if=\"allReports.length == 0\" \nstyle=\"border:2px solid #cccccc; border-radius:5px; height:50px;margin-left:20%\"><b>No Records were found</b></div>\n<table id=\"scrollToDivID\" class=\"dataTable row-border hover tableHighllete\" ng-if=\"allReports.length != 0\" \nclass=\"scrollable\" ms-scroll style=\"border: 1px solid #ccc\"><thead><tr style=\"background-color: #dee7f4 !important\">\n<th>REQ ID</th><th>REQ Type</th><th>Created By</th><th>Created Date</th><th>LastModified By</th><th>Current User</th>\n</tr></thead><tbody><tr ng-repeat=\"report in allReports | filter : searchReport\" ng-click=\"selectReport(report)\" \nclass=\"c-p\"><td>{{report.requestId}}</td><td>{{report.requestType}}</td><td>{{report.createdBy}}</td><td>\n{{report.createdDate.substring(0,10)}}</td><td>{{report.lastModifiedBy}}</td><td>{{report.header.CurrentUser}}</td>\n</tr></tbody></table><div layout=\"row\" layout-align=\"space-between center\" flex=\"100\"><div class=\"md-padding\"><h5><b>\nShowing {{(pageNumber*size)+1}} - {{(pageNumber + 1)*size}} of {{totalRecords}} Results</b></h5></div><div \nlayout=\"row\" layout-align=\"center center\">Page No<md-input-container class=\"md-block md-padding\" style=\"margin: 0px\">\n<md-select ng-model=\"pageNumber\"><md-option ng-repeat=\"pageNumber in pageNumbers\" ng-value=\"pageNumber\" \nng-click=\"sendPageNumber(pageNumber)\" value=\"pageNumber\" ng-selected=\"$first\">{{pageNumber+1}}</md-option></md-select>\n</md-input-container></div><div layout=\"row\" layout-align=\"center center\"><div><md-button type=\"button\" \nng-click=\"previous()\" ng-disabled=\"pageNumber <= 0\">Prev</md-button></div><p class=\"md-padding\"><b>\n{{pageNumber+1}}/{{totalPages}} &nbsp;PAGES</b></p><div class=\"md-padding\"><md-button type=\"button\" \nng-click=\"next(obj)\" ng-disabled=\"pageNumber == totalPages-1\">Next</md-button></div></div></div></div>\n</ms-widget-front></ms-widget></div></div></div>");
$templateCache.put("app/main/administration/admin-reports/reportPreviewDialog.html","<style>\n.selectedApprovalMatrixrow {\n    font-size: 18px;\n    font-weight: bold;\n    color: black;\n    \n}\n        .selectedApprovalMatrixrowBackground{\n            background-color: #7ae2d8;\n        }\n        .disabled {\n      pointer-events: none;\n     \n    }\n    md-tabs-canvas{\n        background-color: white;\n        }\n</style><md-dialog flex=\"90\" flex-gt-sm=\"75\" flex-md=\"75\" flex-gt-md=\"75\" style=\"height:85% !important\" \nng-init=\"loadApprovalMatrix()\"><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2>Report Details</h2><span\n flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content class=\"scrollable\" ms-scroll><md-content><div \nstyle=\"background:#dcecf0\" class=\"md-padding\" ng-if=\"report.flowType==\'Portal\'\"><div layout=\"row\"><div><span \nclass=\"h3\" style=\"font-family: verdana\">{{report.requestId.substr(0,3) | uppercase}} No </span><span class=\"h3\" \nstyle=\"font-family: verdana;color: rgb(38, 161, 242)\">\n{{report.requestId.substr(4,report.requestId.length-2) | uppercase}}</span></div></div><div layout=\"row\" \nlayout-align=\"space-between center\"><div ng-if=\"report.requestType == \'TRN_PROCESS\' \"><span class=\"h4\" \nstyle=\"font-family: verdana\">PR No </span><span class=\"h4\" style=\"font-family: verdana;color: rgb(38, 161, 242)\">\n{{header.PURCHASE_REQ_NO}}</span></div><div ng-if=\"report.requestType == \'CAR_PROCESS\' \"><span class=\"h4\" \nstyle=\"font-family: verdana\">PO No </span><span class=\"h4\" style=\"font-family: verdana;color: rgb(38, 161, 242)\">\n{{header.PURCHASE_ORDER}}</span></div><span class=\"h4\" style=\"font-family: verdana;color: rgb(38, 161, 242)\">\n{{header.VALUE | currency:\"\"}} {{header.CURRENCY}}</span></div><div layout=\"row\" layout-align=\"space-between center\">\n<div><span class=\"h4\" style=\"font-family: verdana\">Vendor </span><span class=\"h4\" \nstyle=\"font-family: verdana;color: rgb(38, 161, 242)\">{{header.VENDOR}}</span></div><div><span class=\"h4\" \nstyle=\"font-family: verdana\">Created By </span><span class=\"h4\" style=\"font-family: verdana; color: rgb(38, 161, 242)\">\n{{report.createdBy}}</span></div></div></div><div style=\"background:#dcecf0\" class=\"md-padding\" \nng-if=\"report.flowType==\'SAP\'\"><div layout=\"row\"><div><span class=\"h3\" style=\"font-family: verdana\">WorkFlow No </span>\n<span class=\"h3\" style=\"font-family: verdana;color: rgb(38, 161, 242)\">{{report.requestId}}</span></div></div><div \nlayout=\"row\" layout-align=\"space-between center\"><div><span class=\"h3\" style=\"font-family: verdana\">\n{{report.requestType.substr(0,2)}} No </span><span ng-if=\"report.requestType ==\'PR_PROCESS\'\" class=\"h3\" \nstyle=\"font-family: verdana;color: rgb(38, 161, 242)\">{{report.header.FIELD15}}</span> <span \nng-if=\"report.requestType ==\'PO_PROCESS\'\" class=\"h3\" style=\"font-family: verdana;color: rgb(38, 161, 242)\">\n{{report.header.FIELD11}}</span></div><span class=\"h4\" style=\"font-family: verdana;color: rgb(38, 161, 242)\">\n{{report.header.TOTAL_AMOUNT | currency:\"\"}} {{report.header.CURRENCY}}</span></div><div layout=\"row\" \nlayout-align=\"end end\"><div><span class=\"h4\" style=\"font-family: verdana\">Created By </span><span class=\"h4\" \nstyle=\"font-family: verdana; color: rgb(38, 161, 242)\">{{report.header.FIELD62}}</span></div></div></div><div><md-tabs \nmd-dynamic-height><md-tab><md-tab-label style=\"padding-bottom:50px !important\">COMMENTS</md-tab-label><md-tab-body \nclass=\"md-padding scrollable\" ms-scroll><div class=\"md-padding scrollable\" ms-scroll><timeline><timeline-event \nng-repeat=\"log in workitemInfo.logs\" side=\"\"><timeline-badge style=\"background-color: rgb(3,155,229)\"><md-icon \nmd-font-icon=\"{{log.icon}}\" class=\"s25 icon white-fg\" style=\"color:white !important\"></md-icon></timeline-badge>\n<timeline-panel class=\"{{\'info\'}}\" style=\"background-color: #f1eded\"><timeline-heading><div layout=\"row\" \nlayout-align=\"end end\"><p><b>Date : {{log.endDate.substr(6,2)}}-{{log.endDate.substr(4,2)}}-{{log.endDate.substr(0,4)}}\n</b></p></div><div layout=\"row\" layout-align=\"start center\" style=\"color:black\"><img \nng-src=\"assets\\images\\avatars/Nora.jpg\" class=\"md-avatar\" style=\"border-radius:50% !important;width:13%; height:auto\">\n<div class=\"h2\" ng-if=\"log.activity == \'001\' \">{{log.actualUser}} Initiated</div><div class=\"h2\" \nng-if=\"log.activity == \'210\' ||  log.activity == \'200\' || log.activityText ===\'Approve\'\">{{log.actualUser}} Recommended\n</div><div class=\"h2\" ng-if=\"log.activity == \'201\' || log.activity ===\'211\' \">{{log.actualUser}} Rejected</div><div \nclass=\"h2\" ng-if=\"log.activity == \'519\' \">{{log.actualUser}} Resubmit Approvals</div><div class=\"h2\" \nng-if=\"log.activity == \'502\' \">{{log.actualUser}} Comments</div><div class=\"h2\" ng-if=\"log.activity == \'899\'\">\nUser cancelled</div><div class=\"h2\" ng-if=\"log.activity == \'350\' \">{{log.actualUser}} Reassign</div><div class=\"h2\" \nng-if=\"log.activity == \'351\' \">{{log.actualUser}} Substitute</div><div class=\"h2\" \nng-if=\"log.activityText == \'Elimination\' \">{{log.actualUser}} Out of Office</div><div class=\"h2\" \nng-if=\"log.activity == \'110\' \">{{log.actualUser}} Collaborated with {{log.currAgent}}</div><div class=\"h2\" \nng-if=\"log.activity == \'111\' \">{{log.actualUser}} Collaborated back with {{log.currAgent}}</div></div>\n</timeline-heading><div layout=\"row\" layout-align=\"start start\" style=\"padding-left: 2%\"><div class=\"text pt-16\">\n{{log.comments}}</div></div></timeline-panel></timeline-event></timeline></div></md-tab-body></md-tab><md-tab>\n<md-tab-label data-ng-click=\"loadApprovalMatrix()\">INFO</md-tab-label><md-tab-body class=\"md-padding scrollable\" \nms-scroll flex=\"100\"><div layout=\"row\" flex=\"100\" class=\"md-padding\"><div layout=\"column\" flex=\"100\" \nstyle=\"border:1px solid #cccccc\" class=\"md-padding\"><form name=\"basicForm\" class=\"md-inline-form\" novalidate \ndata-ng-class=\"{ \'disabled\': true }\"><div ng-bind-html=\"currentFormHeader\" compile-template class=\"scrollable\" \nms-scroll></div></form></div></div><div layout=\"row\" layout-align=\"center center\" class=\"md-padding\"><md-button \nclass=\"md-accent md-raised pull-right\" ng-if=\"workitemInfo.dataChange == \'M\'\" ng-click=\"updateHeader();\">Update\n</md-button></div></md-tab-body></md-tab><md-tab><md-tab-label>ATTACHMENTS</md-tab-label><md-tab-body \nclass=\"md-padding scrollable\" ms-scroll ng-style=\"{\'border\': \'1px solid #cccccc\'}\"><div class=\"md-padding\" \nlayout=\"row\" layout-align=\"space-between center\"><span class=\"h2\">Attachments</span> <span class=\"h3\">\n{{report.attachments.length}}</span></div><div><md-list><md-list-item class=\"md-3-line\" \nng-repeat=\"attachment in report.attachments\"><div layout=\"row\" flex=\"100\" \nng-click=\"preview($event,attachment,report.requestId,attachment.url)\"><div flex=\"5\" layout=\"row\" \nlayout-align=\"center center\"><md-icon md-font-icon=\"{{fileIcon(attachment.fileType)}}\" class=\"s42 icon md-accent\">\n</md-icon></div><div flex=\"60\"><div class=\"md-list-item-text\"><h3><b>{{attachment.fileName}}</b></h3><h3>\nCreated By : {{attachment.creator}}</h3></div></div><div flex=\"30\"><h3>Created On : {{attachment.createDate }}</h3>\n</div><md-divider ng-if=\"!$last\"></md-divider></div><div><md-icon md-font-icon=\"icon-download\" \nclass=\"s32 c-p icon md-accent\" ng-click=\"downloadFile(attachment,workitemInfo.requestId )\"></md-icon></div>\n</md-list-item></md-list></div></md-tab-body></md-tab></md-tabs></div></md-content></md-dialog-content>\n<md-dialog-actions><md-button ng-click=\"cancel()\">Ok</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/administration/admin-substitution/admin.create.substitution.html","<md-dialog flex=\"40\" ng-init=\"getAllUsers();\"><form name=\"userForm\" novalidate \nng-submit=\"userForm.$valid && userCtrl.createUser(user)\" layout=\"column\"><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools\"><h2>Create Substitution</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"cancel()\"><md-icon md-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"row\" flex=\"100\">\n<md-input-container class=\"md-block\" flex=\"40\"><label>Substitute From</label><md-select ng-model=\"substitute.user_id\" \nng-required=\"required\"><md-option ng-value=\"user.login\" ng-repeat=\" user in usersList | orderBy:\'firstName\'\">\n{{user.firstName}} {{user.lastName}}</md-option></md-select></md-input-container><span flex=\"5\"></span>\n<md-input-container class=\"md-block\" flex=\"40\"><label>Substitute To</label><md-select \nng-model=\"substitute.substitution_user\" ng-required=\"required\"><md-option ng-value=\"user.login\" \nng-repeat=\" user in usersList | orderBy:\'firstName\'\">{{user.firstName}} {{user.lastName}}</md-option></md-select>\n</md-input-container><span flex=\"5\"></span><md-switch ng-model=\"substitute.status\" aria-label=\" Activate User\">Status\n</md-switch></div><div ng-if=\"dateVis\" style=\"color:red\">From & To dates are mandatory.</div><div layout=\"row\" \nflex=\"100\"><md-datepicker ng-model=\"substitute.from_date\" md-placeholder=\"From Date\" \nng-model-options=\"{ timezone: \'utc\' }\"></md-datepicker><span flex=\"25\"></span><md-datepicker \nng-model=\"substitute.to_date\" md-placeholder=\"To Date\" ng-model-options=\"{ timezone: \'utc\' }\"></md-datepicker></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"center center\"><md-button type=\"button\" \nng-click=\"cancel()\">Cancel</md-button><md-button type=\"submit\" ng-click=\"userForm.$valid && save(substitute)\">Save\n</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/administration/admin-substitution/admin.preview.substitution.html","<div class=\"page-layout simple right-sidenav\" layout=\"row\" ng-init=\"subCtrl.getAllSubstitutes()\"><div \nng-include=\"\'app/main/administration/common/admin.html\'\"></div><div \nclass=\"page-layout carded fullwidth md-padding scrollable\" layout=\"column\" flex ms-scroll><md-button flow-btn \nclass=\"md-fab grey-700-bg md-mini md-fab-bottom-right add_btn\" ng-click=\"createSubstitutor($event)\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon><md-tooltip md-direction=\"top\">Create substitution</md-tooltip></md-button><div \nclass=\"parent-tabs white-bg mb-15\"><md-tabs class=\"mh-0\"><md-tab label=\"Substitution\" \nui-sref=\"app.administration.substitution\" md-active=\"true\"></md-tab><md-tab label=\"Re-Assign\" \nui-sref=\"app.administration.reAssign\"></md-tab></md-tabs></div><div class=\"widget-group\" flex=\"100\" layout=\"column\" \nlayout-wrap><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" md-dynamic-height><ms-widget-front class=\"white-bg\">\n<div class=\"h3 md-padding\">Manage Substitution</div><div layout=\"row\" layout-align=\"center center\"><div flex=\"100\" \nclass=\"md-padding scrollable\" ms-scroll><table class=\"dataTable row-border hover table-border\" datatable=\"ng\" \ndt-options=\"userCtrl.dtOptions\"><thead><tr class=\"table-header\"><th class=\"secondary-text\"><div class=\"table-header\">\n<span class=\"column-title\">Substitution-From</span></div></th><th class=\"secondary-text\"><div class=\"table-header\">\n<span class=\"column-title\">Substitution-To</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">From Date</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">To Date</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Status</span></div></th><th class=\"secondary-text\"><div class=\"table-header\" layout=\"row\" \nlayout-align=\"center center\"><span class=\"column-title\">Actions</span></div></th></tr></thead><tbody><tr \nng-repeat=\"substitute in substitute\" ng-if=\"substitute.substitution_user != null && substitute.eliminationUser ==null\">\n<td>{{substitute.user_id}}</td><td>{{substitute.substitution_user}}</td><td>{{substitute.from_date.substr(0,10)}}</td>\n<td>{{substitute.to_date.substr(0,10)}}</td><td><i class=\"icon-checkbox-marked-circle green-500-fg\" \nng-show=\"{{substitute.status}}\"></i> <i class=\"icon-cancel red-500-fg\" ng-show=\"{{! substitute.status}}\"></i></td><td \nlayout=\"row\" layout-align=\"center center\" style=\"padding-top:0px !important;padding-bottom:0px !important\"><md-button \nclass=\"md-icon-button test-tooltip\" aria-label=\"Update\" ng-click=\"update($event,substitute)\"><md-tooltip \nmd-direction=\"top\">Update</md-tooltip><md-icon><i layout=\"row\" layout-align=\"center center\" \nclass=\"icon icon-pencil s18\"></i></md-icon></md-button><md-button class=\"md-icon-button test-tooltip\" \naria-label=\"Delete\" ng-click=\"delete($event, substitute) \"><md-tooltip md-direction=\"top\">Delete</md-tooltip><md-icon>\n<i layout=\"row\" layout-align=\"center center\" class=\"icon icon-delete s18\"></i></md-icon></md-button></td></tr></tbody>\n</table></div></div></ms-widget-front></ms-widget></div></div></div>");
$templateCache.put("app/main/administration/admin-substitution/admin.update.substitution.html","<md-dialog aria-label=\"update\" flex=\"40\" ng-init=\"getAllUsers();\"><form name=\"userForm\" novalidate \nng-submit=\"userForm.$valid && userCtrl.createUser(user)\" layout=\"column\"><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools\"><h2>Update Substitution</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"cancel()\"><md-icon md-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"row\" flex=\"100\">\n<md-input-container class=\"md-block\" flex=\"40\"><label>Substitution From</label><md-select \nng-model=\"substitutionItem.user_id\" ng-required=\"required\"><md-option ng-value=\"user.login\" \nng-repeat=\" user in usersList | orderBy:\'firstName\'\">{{user.firstName}} {{user.lastName}}</md-option></md-select>\n</md-input-container><span flex=\"10\"></span><md-input-container class=\"md-block\" flex=\"40\"><label>Substitution To\n</label><md-select ng-model=\"substitutionItem.substitution_user\" ng-required=\"required\"><md-option \nng-value=\"user.login\" ng-repeat=\" user in usersList | orderBy:\'firstName\'\">{{user.firstName}} {{user.lastName}}\n</md-option></md-select></md-input-container><span flex=\"10\"></span><md-switch ng-model=\"substitutionItem.status\" \naria-label=\" Activate User\">Status</md-switch></div><div layout=\"row\" flex=\"100\"><md-datepicker \nng-model=\"substitutionItem.from_date\" md-placeholder=\"From Date\"></md-datepicker><span flex=\"25\"></span><md-datepicker \nng-model=\"substitutionItem.to_date\" md-placeholder=\"To Date\"></md-datepicker></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" layout-align=\"center center\"><md-button type=\"button\" ng-click=\"cancel()\">Cancel\n</md-button><md-button type=\"submit\" ng-click=\"userForm.$valid && update($event, substitutionItem)\">Save</md-button>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/administration/approve-matrix/approvematrix.details.html","<style>.add_btn\n{\ntop: 75% !important;\nmargin-right:1.3% !important;\n}</style><div \nclass=\"page-layout simple right-sidenav\" layout-gt-xs=\"row\"><div \nng-include=\"\'app/main/administration/common/admin.html\'\"></div><div \nclass=\"page-layout carded fullwidth md-padding scrollable\" layout=\"column\" flex ms-scroll><div class=\"widget-group\" \nflex=\"100\" layout=\"column\" layout-wrap><ms-widget flippable=\"true\" class=\"no-padding\"><div \nclass=\"parent-tabs white-bg mb-15\"><md-tabs class=\"mh-0\"><md-tab label=\"Approval Matrix\" \nui-sref=\"app.administration.approvematrix.createDetails\" md-active=\"true\"></md-tab></md-tabs></div><div \nclass=\"md-padding white-bg\"><div class=\"previous-state c-p\" data-ng-click=\"goBack()\"><span><span \nclass=\"icon-arrow-left-bold-circle-outline\"></span> Back </span></div><table \nclass=\"dataTable row-border hover table-border\" datatable=\"ng\" dt-options=\"approveCtrl.dtOptions\" ms-responsive-table>\n<thead><tr class=\"table-header\"><th class=\"secondary-text\" ng-repeat=\"detail in selectedmatrixDetails.headerValues\">\n<div class=\"table-header\"><span class=\"column-title\">{{detail.fieldName}}</span></div></th><th class=\"secondary-text\" \nng-repeat=\"level in approveCtrl.finalLevels\"><div class=\"table-header\"><span class=\"column-title\">{{level}}</span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Actions</span></div></th>\n</tr></thead><tbody><tr ng-repeat=\"displayLine in selectedmatrixDetails.display\"><td \nng-repeat=\"detail in selectedmatrixDetails.headerValues\">{{ displayLine[detail.data] }}</td><td \nng-repeat=\"level in approveCtrl.finalLevels\"><div ng-repeat=\"user in displayLine[level]\">{{user}}</div></td><td \nlayout=\"row\" layout-align=\"center center\" style=\"padding-top:0px !important;padding-bottom:0px !important\"><md-button \nclass=\"md-icon-button test-tooltip\" aria-label=\"Update\" \nng-click=\"updateApproveDialog($event,selectedmatrixDetails.headerValues,approveCtrl.finalLevels,selectedmatrixDetails.display,$index)\">\n<md-tooltip md-direction=\"top\">Update</md-tooltip><md-icon><i layout=\"row\" layout-align=\"center center\" \nclass=\"icon icon-pencil s18\"></i></md-icon></md-button><md-button class=\"md-icon-button test-tooltip\" \naria-label=\"Delete\" ng-click=\"deleteApproveMatrixDetails($index,selectedmatrixDetails.display)\"><md-tooltip \nmd-direction=\"top\">Delete</md-tooltip><md-icon><i layout=\"row\" layout-align=\"center center\" \nclass=\"icon icon-delete s18\"></i></md-icon></md-button></td></tr></tbody></table></div></ms-widget></div></div></div>\n<md-button flow-btn class=\"md-fab grey-700-bg md-mini md-fab-bottom-right add_btm\" aria-label=\"Create User\" \nng-click=\"addApproveMatrixDetails($event,selectedmatrixDetails.headerValues,approveCtrl.finalLevels,selectedmatrixDetails.approvalLevels)\">\n<md-icon md-font-icon=\"icon-plus\"></md-icon><md-tooltip md-direction=\"top\">Add Details</md-tooltip></md-button>");
$templateCache.put("app/main/administration/approve-matrix/approvematrix.html","<style>.add_btn\n{\ntop: 75% !important;\nmargin-right:1.3% !important;\n}</style><div \nclass=\"page-layout simple right-sidenav\" layout-gt-xs=\"row\"><div \nng-include=\"\'app/main/administration/common/admin.html\'\"></div><div \nclass=\"page-layout carded fullwidth md-padding scrollable\" layout=\"column\" flex ms-scroll \nng-init=\"approveCtrl.getApprovematrix()\"><div class=\"widget-group\" flex=\"100\" layout=\"column\" layout-wrap><ms-widget \nflippable=\"true\" class=\"no-padding\"><div class=\"parent-tabs white-bg mb-15\"><md-tabs class=\"mh-0\"><md-tab \nlabel=\"Approval Matrix\" ui-sref=\"app.administration.approvematrix\" md-active=\"true\"></md-tab></md-tabs></div><div \nclass=\"md-padding white-bg\"><div layout=\"row\" layout-wrap><div ng-repeat=\"list in approvalsList\" flex=\"100\" \nflex-gt-xs=\"25\" flex-gt-md=\"20\" layout=\"column\"><md-card md-theme=\"{{getAnotherColor($index)}}\" md-theme-watch \nclass=\"c-p md-{{getAnotherColor($index)}}-500-bg\"><div class=\"info\" layout=\"column\" layout-align=\"space-between\" flex>\n<div class=\"white-fg md-padding\" layout=\"row\" layout-align=\"center center\" ng-style=\"{\'height\':\'150px\'}\" \nng-click=\"selectApproveMatrix(list)\"><md-icon md-font-icon=\"icon-file-document\" class=\"s64\"></md-icon><md-tooltip \nmd-direction=\"top\">{{list.name}}</md-tooltip></div><div><md-divider></md-divider><div class=\"text white-bg\" \nstyle=\"text-align: center\"><label>{{list.name}}</label><md-button class=\"md-icon-button test-tooltip\" \nng-click=\"deleteApprovalMatrix(list)\"><md-tooltip md-direction=\"top\">Delete</md-tooltip><md-icon><i layout=\"row\" \nlayout-align=\"center center\" class=\"icon icon-delete s20\"></i></md-icon></md-button></div></div></div></md-card></div>\n</div></div></ms-widget></div></div></div><md-button flow-btn \nclass=\"md-fab grey-700-bg md-mini md-fab-bottom-right add_btm\" aria-label=\"Create User\" \nng-click=\"addApproveMatrix($event)\"><md-icon md-font-icon=\"icon-plus\"></md-icon><md-tooltip md-direction=\"top\">Create\n</md-tooltip></md-button>");
$templateCache.put("app/main/administration/approve-matrix/create.approvematrix.html","<md-dialog aria-label=\"Add a new announcement\" flex=\"50\"><form name=\"ancForm\" novalidate \nng-submit=\"ancForm.$valid && save(approveObj)\" layout=\"column\"><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools\"><h2>Create Approvematrix</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"cancel()\"><md-icon md-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><md-input-container \nclass=\"md-block\"><input type=\"text\" name=\"title\" ng-model=\"approveObj.name\" placeholder=\"Name\" required><div \nng-messages=\"ancForm.title.$error\" role=\"alert\"><div ng-message=\"required\">Name is required</div></div>\n</md-input-container><md-input-container class=\"md-block\"><input type=\"text\" name=\"description\" \nng-model=\"approveObj.description\" placeholder=\"Description\" ng-pattern=\"re\" required><div \nng-messages=\"ancForm.title.$error\" role=\"alert\"><div ng-message=\"required\">Description is required</div></div>\n</md-input-container><md-input-container class=\"md-block\"><input type=\"text\" name=\"audience\" \nng-model=\"approveObj.noOfApprovalLevels\" placeholder=\"No.of Levels\" required><div \nng-messages=\"ancForm.audience.$error\" role=\"alert\"><div ng-message=\"required\"><span>Levels field is required</span>\n</div></div></md-input-container><div layout=\"row\" layout-align=\"center center\" class=\"md-padding\"><md-radio-group \nng-model=\"approveObj.type\" layout=\"row\"><md-radio-button value=\"requests\">Requests</md-radio-button><md-radio-button \nvalue=\"workspace\">Workspace</md-radio-button></md-radio-group></div><div ng-if=\"approveObj.type == \'requests\' \">\n<md-input-container class=\"md-block\" flex-gt-sm><label>Request Type</label><md-select \nng-model=\"approveObj.requesttype\" required=\"true\"><md-option ng-repeat=\"req in reqTypes\" value=\"{{req.id}}\" \nng-click=\"selectedReqtype(req)\">{{req.name}}</md-option><div ng-messages=\"commentForm.levelapprovers.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Required</span></div></div></md-select></md-input-container><div \nlayout=\"row\" class=\"md-padding\" ng-if=\"approveObj.requesttype\"><h3 flex=\"20\">Attributes</h3><md-input-container \nclass=\"md-block\" flex=\"30\"><md-select ng-model=\"element.name\"><md-option ng-repeat=\"type in attributeObjects\" \nvalue=\"{{type.fieldName}}\" ng-click=\"selectedAttribute(type)\">{{type.fieldName}}</md-option></md-select>\n</md-input-container><span flex=\"10\"></span><div ng-show=\"range\"><md-switch ng-model=\"rangeval\" aria-label=\"range\">\nRange</md-switch></div><md-button type=\"button\" class=\"md-accent\" ng-click=\"addAttributes(rangeval)\">Add</md-button>\n</div><md-divider></md-divider><div ng-repeat=\"x in attributeVals\" ng-if=\"attributeVals.length !=0\" \nclass=\"padding-left-50 padding-top-10\" layout-align=\"center center\">{{x.fieldName}}</div></div><div \nng-if=\"approveObj.type == \'workspace\'\"><md-input-container class=\"md-block\" flex-gt-sm><label>Workspace Type</label>\n<input type=\"text\" name=\"workspaceType\" ng-model=\"workspaceType\" ng-disabled=\"true\"></md-input-container><div \nlayout=\"row\" class=\"md-padding\" ng-if=\"workspaceType\"><h3 flex=\"20\">Attributes</h3><md-input-container \nclass=\"md-block\" flex=\"30\"><md-select ng-model=\"element.name\"><md-option ng-repeat=\"type in wsAttributeObjects\" \nvalue=\"{{type.fieldName}}\" ng-click=\"selectedAttribute(type)\">{{type.fieldName}}</md-option></md-select>\n</md-input-container><span flex=\"10\"></span><div ng-show=\"range\"><md-switch ng-model=\"rangeval\" \nng-false-value=\"\'false\'\" ng-true-value=\"\'true\'\" aria-label=\"range\">Range</md-switch></div><md-button type=\"button\" \nclass=\"md-accent\" ng-click=\"addAttributes(rangeval)\">Add</md-button></div><md-divider></md-divider><div \nng-repeat=\"x in attributeVals\" ng-if=\"attributeVals.length !=0\" class=\"padding-left-50 padding-top-10\" \nlayout-align=\"center center\">{{x.fieldName}}</div></div></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"center center\"><md-button type=\"button\" ng-click=\"cancel()\">Cancel</md-button><md-button type=\"submit\">\nSave</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/administration/approve-matrix/create.details.dialog.html","<md-dialog flex=\"50\"><form name=\"commentForm\" novalidate layout=\"column\"><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools\"><h2>Add Details</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\">\n<md-icon md-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><div layout=\"column\"><md-input-container class=\"md-block\" flex=\"45\" \nng-repeat=\"list in attributeData\"><label>{{list.fieldName}}</label><input type=\"text\" name=\"arrval\" \nng-model=\"crlist[list.fieldName]\" required><md-checkbox ng-model=\"crlist[list.fieldName]\" ng-true-value=\"\'All\'\" \nflex=\"\" ng-show=\"list.fieldType===\'String\'\" aria-label=\"Checkbox 1\">All</md-checkbox></md-input-container></div><div \nlayout=\"column\" ng-repeat=\"level in  currentLevels\"><div flex=\"35\" layout=\"column\" layout-align=\"center end\"><span \nclass=\"h3\" style=\"margin-bottom: -28px\"><b>{{level}}</b></span></div><span flex=\"10\"></span><md-input-container \nclass=\"md-block\" flex-gt-sm><md-select name=\"levelapprovers\" ng-model=\"approvers[$index+1]\" multiple=\"multiple\" \nng-required=\"true\"><md-option ng-repeat=\"agent in agents\" value=\"{{agent.login}}\">{{agent.login}}</md-option>\n</md-select><div ng-messages=\"commentForm.levelapprovers.$error\" role=\"alert\"><div ng-message=\"required\"><span>Required\n</span></div></div></md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex></span>\n<md-button ng-click=\"cancel()\">Cancel</md-button><md-button type=\"submit\" \nng-click=\"commentForm.$valid && save(crlist)\">Save</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/administration/approve-matrix/update.approvematrix.dialog.html","<md-dialog flex=\"50\"><form name=\"commentForm\" novalidate layout=\"column\"><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools\"><h2>Update Approval Matrix</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"cancel()\"><md-icon md-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"column\">\n<md-input-container class=\"md-block\" flex=\"45\" ng-repeat=\"list in headerData\"><label>{{list.fieldName}}</label><input \ntype=\"text\" name=\"arrval\" ng-model=\"currentValues[list.fieldName]\" required></md-input-container></div><div \nlayout=\"column\" ng-repeat=\"level in  currentApprovallevels\"><div flex=\"35\" layout=\"column\" layout-align=\"center end\">\n<span class=\"h3\" style=\"margin-bottom: -28px\"><b>{{level}}</b></span></div><span flex=\"10\"></span><md-input-container \nclass=\"md-block\" flex-gt-sm><md-select name=\"levelapprovers\" ng-model=\"currentValues[level]\" multiple=\"multiple\" \nng-required=\"true\"><md-option ng-repeat=\"agent in agents\" value=\"{{agent.login}}\">{{agent.login}}</md-option>\n</md-select><div ng-messages=\"commentForm.levelapprovers.$error\" role=\"alert\"><div ng-message=\"required\"><span>Required\n</span></div></div></md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex></span>\n<md-button ng-click=\"cancel()\">Cancel</md-button><md-button type=\"submit\" \nng-click=\"commentForm.$valid && update(currentValues)\">Update</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/administration/approver-Level/approveLevel.html","<style>table.dataTable tbody td {\n  vertical-align: middle;\n     padding: 10px;\n }</style><div \nclass=\"page-layout simple right-sidenav\" layout=\"row\"><div ng-include=\"\'app/main/administration/common/admin.html\'\">\n</div><div class=\"page-layout carded fullwidth md-padding scrollable\" layout=\"column\" flex ms-scroll><div \nclass=\"widget-group\" flex=\"100\" layout=\"column\" layout-wrap><ms-widget flippable=\"true\" class=\"no-padding\"><div \nclass=\"parent-tabs white-bg mb-15\"><md-tabs class=\"mh-0\"><md-tab label=\"Approve Level\" \nui-sref=\"app.administration.approveLevel\" md-active=\"true\"></md-tab></md-tabs></div><div class=\"md-padding white-bg\">\n<div layout=\"row\" flex=\"100\" layout=\"row\" layout-align=\"end end\"><md-input-container flex-gt-sm=\"15\" class=\"md-block\" \nstyle=\"border: 1px solid rgb(169, 161, 161);margin-top: 0%;border-radius: 5px;height: 35px;margin-right: 1%\"><input \nng-model=\"searchUser\" type=\"text\" placeholder=\"Global Filter\"></md-input-container><md-input-container \nclass=\"md-block\" flex-gt-sm=\"5\"><label>Size</label><md-select ng-change=\"sizeselect(size)\" ng-model=\"size\"><md-option \nvalue=\"100\">100</md-option><md-option value=\"200\">200</md-option><md-option value=\"400\">400</md-option><md-option \nvalue=\"500\">500</md-option></md-select></md-input-container></div><table class=\"dataTable row-border hover\"><thead><tr \nstyle=\"background-color: #dee7f4 !important\"><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Request Type</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Sbu</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Location</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Department</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">From Amount</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">To Amount</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">No of Approvers</span></div></th></tr></thead><tbody><tr \nng-repeat=\"approver in approverlevel| filter : searchUser\" ng-click=\"approverCtrl.approverDialog(ev,approver)\" \nclass=\"c-p\"><td style=\"color: blue; text-decoration: underline\">{{approver.reqType}}</td><td>{{approver.sbu}}</td><td>\n{{approver.location}}</td><td>{{approver.department}}</td><td>{{approver.fromAmount | currency : \'\':0}}</td><td>\n{{approver.toAmount | currency : \'\':0}}</td><td>{{approver.noofApp }}</td></tr></tbody></table><div layout=\"row\" \nlayout-align=\"space-between center\" flex=\"100\"><div class=\"md-padding\"><h5><b>\nShowing {{(isNaN(pageNumber*size))+1}} - {{(pageNumber + 1)*size}} of {{totalRecords}}Results</b></h5></div><div \nlayout=\"row\" layout-align=\"center center\">Page No<md-input-container class=\"md-block md-padding\" style=\"margin: 0px\">\n<md-select ng-model=\"pageNumber\"><md-option ng-repeat=\"pageNumber in pageNumbers\" ng-value=\"pageNumber\" \nng-click=\"sendPageNumber(pageNumber)\" value=\"pageNumber\" ng-selected=\"$first\">{{pageNumber+1}}</md-option></md-select>\n</md-input-container></div><div layout=\"row\" layout-align=\"center center\"><div><md-button type=\"button\" \nng-click=\"previous()\" ng-disabled=\"pageNumber <= 0\">Prev</md-button></div><p class=\"md-padding\"><b>\n{{pageNumber+1}}/{{totalPages}} &nbsp;PAGES</b></p><div class=\"md-padding\"><md-button type=\"button\" ng-click=\"next()\" \nng-disabled=\"pageNumber ==totalPages -1\">Next</md-button></div></div></div></div></ms-widget></div></div></div>");
$templateCache.put("app/main/administration/approver-Level/approver-dialog.html","<md-dialog aria-label=\"Add a new user\" flex=\"40\"><form name=\"DoaupdateReport\"><div><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools\"><h2>Level Of Approvers</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"cancel()\"><md-icon md-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div style=\"text-align: center\">\n<span><b>No of approver : </b></span><span style=\"color: red\"><b>{{approver.noofApp}}</b></span></div><div \nlayout=\"column\" flex-gt-sm=\"100\"><div layout=\"row\" layout-align=\"center center\"><div flex-gt-sm=\"20\" layout=\"row\">\nApprover 1</div><div flex-gt-sm=\"35\"><md-input-container class=\"md-block margin\"><input type=\"text\" \nng-model=\"approver.level_1_approvers\" class=\"md-no-underline\" readonly=\"readonly\" \nstyle=\"border: 1px solid rgb(169, 161, 161);border-radius: 3px;margin-bottom: -10%;height: 30px; margin-top: -3%\">\n</md-input-container></div></div><div layout=\"row\" layout-align=\"center center\" style=\"margin-top: -3%\"><div \nflex-gt-sm=\"20\">Approver 2</div><div flex-gt-sm=\"35\"><md-input-container class=\"md-block margin\"><input type=\"text\" \nng-model=\"approver.level_2_approvers\" class=\"md-no-underline\" readonly=\"readonly\" \nstyle=\"border: 1px solid rgb(169, 161, 161);border-radius: 3px;margin-bottom: -10%;height: 30px; margin-top: -3%\">\n</md-input-container></div></div><div layout=\"row\" layout-align=\"center center\" style=\"margin-top: -3%\"><div \nflex-gt-sm=\"20\">Approver 3</div><div flex-gt-sm=\"35\"><md-input-container class=\"md-block margin\"><input type=\"text\" \nng-model=\"approver.level_3_approvers\" class=\"md-no-underline\" readonly=\"readonly\" \nstyle=\"border: 1px solid rgb(169, 161, 161);border-radius: 3px;margin-bottom: -10%;height: 30px; margin-top: -3%\">\n</md-input-container></div></div><div layout=\"row\" layout-align=\"center center\" style=\"margin-top: -3%\"><div \nflex-gt-sm=\"20\">Approver 4</div><div flex-gt-sm=\"35\"><md-input-container class=\"md-block margin\"><input type=\"text\" \nng-model=\"approver.level_4_approvers\" class=\"md-no-underline\" readonly=\"readonly\" \nstyle=\"border: 1px solid rgb(169, 161, 161);border-radius: 3px;margin-bottom: -10%;height: 30px; margin-top: -3%\">\n</md-input-container></div></div><div layout=\"row\" layout-align=\"center center\" style=\"margin-top: -3%\"><div \nflex-gt-sm=\"20\">Approver 5</div><div flex-gt-sm=\"35\"><md-input-container class=\"md-block margin\"><input type=\"text\" \nng-model=\"approver.level_5_approvers\" class=\"md-no-underline\" readonly=\"readonly\" \nstyle=\"border: 1px solid rgb(169, 161, 161);border-radius: 3px;margin-bottom: -10%;height: 30px; margin-top: -3%\">\n</md-input-container></div></div><div layout=\"row\" layout-align=\"center center\" style=\"margin-top: -3%\"><div \nflex-gt-sm=\"20\">Approver 6</div><div flex-gt-sm=\"35\"><md-input-container class=\"md-block margin\"><input type=\"text\" \nng-model=\"approver.level_6_approvers\" class=\"md-no-underline\" readonly=\"readonly\" \nstyle=\"border: 1px solid rgb(169, 161, 161);border-radius: 3px;margin-bottom: -10%;height: 30px; margin-top: -3%\">\n</md-input-container></div></div><div layout=\"row\" layout-align=\"center center\" style=\"margin-top: -3%\"><div \nflex-gt-sm=\"20\">Approver 7</div><div flex-gt-sm=\"35\"><md-input-container class=\"md-block margin\"><input type=\"text\" \nng-model=\"approver.level_7_approvers\" class=\"md-no-underline\" readonly=\"readonly\" \nstyle=\"border: 1px solid rgb(169, 161, 161);border-radius: 3px;margin-bottom: -10%;height: 30px; margin-top: -3%\">\n</md-input-container></div></div><div layout=\"row\" layout-align=\"center center\" style=\"margin-top: -3%\"><div \nflex-gt-sm=\"20\">Approver 8</div><div flex-gt-sm=\"35\"><md-input-container class=\"md-block margin\"><input type=\"text\" \nng-model=\"approver.level_8_approvers\" class=\"md-no-underline\" readonly=\"readonly\" \nstyle=\"border: 1px solid rgb(169, 161, 161);border-radius: 3px;margin-bottom: -10%;height: 30px; margin-top: -3%\">\n</md-input-container></div></div><div layout=\"row\" layout-align=\"center center\" style=\"margin-top: -3%\"><div \nflex-gt-sm=\"20\">Approver 9</div><div flex-gt-sm=\"35\"><md-input-container class=\"md-block margin\"><input type=\"text\" \nng-model=\"approver.level_9_approvers\" class=\"md-no-underline\" readonly=\"readonly\" \nstyle=\"border: 1px solid rgb(169, 161, 161);border-radius: 3px;margin-bottom: -10%;height: 30px; margin-top: -3%\">\n</md-input-container></div></div><div layout=\"row\" layout-align=\"center center\" style=\"margin-top: -3%\"><div \nflex-gt-sm=\"20\">Approver 10</div><div flex-gt-sm=\"35\"><md-input-container class=\"md-block margin\"><input type=\"text\" \nng-model=\"approver.level_10_approvers\" class=\"md-no-underline\" readonly=\"readonly\" \nstyle=\"border: 1px solid rgb(169, 161, 161);border-radius: 3px;margin-bottom: -10%;height: 30px; margin-top: -3%\">\n</md-input-container></div></div></div></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"center center\"></md-dialog-actions></div></form></md-dialog>");
$templateCache.put("app/main/administration/binder-management/attributes.binder.html","<md-dialog aria-label=\"Add a new user\" flex=\"75\"><form name=\"objectForm\" novalidate \nng-submit=\"objectForm.$valid && bsCtrl.detailsObject(object)\" layout=\"column\" flex=\"66\"><md-toolbar class=\"md-accent\">\n<div class=\"md-toolbar-tools\"><h2>Attributes of Binder : {{currentBinder.name}}</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content class=\"scrollable\" ms-scroll><div><div layout=\"row\" \nlayout-align=\"space-around center\"><div class=\"table-header\"><span class=\"column-title\">NAME</span></div><div \nclass=\"table-header\"><span class=\"column-title\">TYPE</span></div><div class=\"table-header\"><span class=\"column-title\">\nRANGE</span></div><div class=\"table-header\"><span class=\"column-title\"></span></div></div><md-content><div \nng-repeat=\"element in attributes\" layout=\"row\" layout-align=\"center center\"><md-input-container class=\"md-block\" \nflex=\"20\"><input type=\"text\" name=\"type\" ng-model=\"element.label\"></md-input-container><span flex=\"5\"></span>\n<md-input-container class=\"md-block\" flex=\"20\"><md-select ng-model=\"element.type\"><md-option \nng-repeat=\"type in attributeTypes\" value=\"{{type}}\">{{type}}</md-option></md-select></md-input-container><span \nflex=\"15\"></span><md-input-container class=\"md-block\" flex=\"10\"><md-switch ng-model=\"element.range\" \naria-label=\"Switch\"></md-switch></md-input-container><md-input-container class=\"md-block\" flex=\"20\"><input type=\"text\" \nname=\"list\" ng-model=\"element.listReference\" ng-show=\"element.type == \'List\'\"></md-input-container><span flex=\"5\">\n</span></div></md-content></div></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"center center\">\n<md-button ng-click=\"cancel()\">Cancel</md-button><md-button type=\"submit\" ng-click=\"save()\">Update</md-button>\n</md-dialog-actions><md-button flow-btn class=\"md-fab md-accent md-fab-bottom-right\" aria-label=\"Create User\" \nng-click=\"addNewAttribute()\"><md-icon md-font-icon=\"icon-plus\"></md-icon><md-tooltip md-direction=\"top\">New Attribute\n</md-tooltip></md-button></form></md-dialog>");
$templateCache.put("app/main/administration/binder-management/binder.html","<div class=\"page-layout simple right-sidenav\" layout-gt-xs=\"row\"><div \nng-include=\"\'app/main/administration/common/admin.html\'\"></div><div \nclass=\"page-layout carded fullwidth md-padding scrollable\" layout=\"column\" flex ms-scroll><div class=\"widget-group\" \nflex=\"100\" layout=\"column\" layout-wrap><ms-widget flippable=\"true\" class=\"no-padding\"><div \nclass=\"parent-tabs white-bg mb-15\"><md-tabs class=\"mh-0\"><md-tab label=\"Binders\" md-active=\"true\"></md-tab></md-tabs>\n</div><div class=\"md-padding white-bg\"><table class=\"dataTable row-border hover table-header\" datatable=\"ng\" \ndt-options=\"dtOptions\"><thead class=\"table-border\"><tr class=\"table-header\"><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Name</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Description</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Site Id</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Business Object</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\" layout=\"row\" layout-align=\"center center\"><span class=\"column-title\">Actions</span></div></th>\n</tr></thead><tbody><tr ng-repeat=\"binder in bindersList | filter : searchUser\"><td>{{binder.name}}</td><td>\n{{binder.description}}</td><td>{{binder.siteId}}</td><td>{{binder.businessObject}}</td><td layout=\"row\" \nlayout-align=\"center center\" style=\"padding-top:0px !important;padding-bottom:0px !important\"><md-button \nclass=\"md-icon-button test-tooltip\" aria-label=\"Update\" ng-click=\"attributesBinderDialog($event,binder)\"><md-tooltip \nmd-direction=\"top\">Attributes</md-tooltip><md-icon><i layout=\"row\" layout-align=\"center center\" \nclass=\"icon icon-dots-vertical s20\"></i></md-icon></md-button><md-button class=\"md-icon-button test-tooltip\" \naria-label=\"Update\" ng-click=\"updateBinderDialog($event,binder)\"><md-tooltip md-direction=\"top\">Update</md-tooltip>\n<md-icon><i layout=\"row\" layout-align=\"center center\" class=\"icon icon-pencil s20\"></i></md-icon></md-button><md-button\n class=\"md-icon-button test-tooltip\" aria-label=\"Delete\" ng-click=\"deleteBinder($event,binder)\"><md-tooltip \nmd-direction=\"top\">Delete</md-tooltip><md-icon><i layout=\"row\" layout-align=\"center center\" \nclass=\"icon icon-delete s20\"></i></md-icon></md-button><md-button class=\"md-icon-button test-tooltip\" \naria-label=\"Folders\" ng-click=\"createBinderFoldersDialog($event,binder)\"><md-tooltip md-direction=\"top\">Create Folders\n</md-tooltip><md-icon><i layout=\"row\" layout-align=\"center center\" class=\"icon icon-folder s20\"></i></md-icon>\n</md-button></td></tr></tbody></table></div></ms-widget></div><md-button flow-btn \nclass=\"md-fab grey-700-bg md-mini md-fab-bottom-right add_btn\" ng-click=\"createBinderDialog($event)\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon><md-tooltip md-direction=\"top\">Create Binder</md-tooltip></md-button></div></div>\n<div ng-include=\"\'/app/core/layouts/footer.html\'\"></div>");
$templateCache.put("app/main/administration/binder-management/create.binder.dialog.html","<md-dialog aria-label=\"Add a new object\" flex=\"30\" ng-init=\"getAllBusinessObjects()\"><form name=\"binderCreateForm\" \nnovalidate ng-submit=\"binderCreateForm.$valid && binderCrtl.createBinder(binder)\" layout=\"column\" flex=\"66\"><md-toolbar\n class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2>Create Binder</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><md-input-container class=\"md-block\"><input type=\"text\" name=\"name\" \nng-model=\"binder.name\" placeholder=\"Name\" required><div ng-messages=\"binderCreateForm.name.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Name is required</span></div></div></md-input-container><md-input-container \nclass=\"md-block\"><input type=\"text\" name=\"description\" ng-model=\"binder.description\" placeholder=\"Description\" \nrequired><div ng-messages=\"binderCreateForm.description.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nDescription is required</span></div></div></md-input-container><md-input-container class=\"md-block\"><input type=\"text\" \nname=\"siteId\" ng-model=\"binder.siteId\" placeholder=\"siteId\" required><div ng-messages=\"binderCreateForm.siteId.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>SiteId is required</span></div></div></md-input-container>\n<md-input-container class=\"md-block\"><label>Business Object</label><md-select ng-model=\"binder.businessObject\">\n<md-option ng-repeat=\"businessObject in allBusinessObjects\" ng-value=\"businessObject.name\" \nng-click=\"binderCrtl.selectBusinessObject(businessObject)\">{{businessObject.name}}</md-option></md-select>\n</md-input-container></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"center center\"><md-button \ntype=\"button\" ng-click=\"cancel()\">Cancel</md-button><md-button type=\"submit\" \nng-click=\"binderCreateForm.$valid && save(binder) \">Save</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/administration/binder-management/createBinderFoldersDialog.html","<style>md-input-container{\n   margin : 0px !important;    \n   }\n   md-select{\n   margin-bottom : 20px !important;\n   }\n</style><md-dialog flex=\"75\"><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2>Create Binder Folders</h2>\n<span flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content><div layout=\"row\" flex=\"100\"><div flex=\"20\" class=\"md-padding\"><div layout=\"row\" \nlayout-align=\"start center\"><h3><b>{{binderData.name}} Directories </b></h3></div><div layout=\"row\" \nlayout-align=\"start center\" ng-repeat=\"folderObject in binderData.folders | orderBy : \'seqId\'\"><md-icon \nmd-font-icon=\"icon-folder\" style=\"margin: 0px;color: #f4840fc2\"></md-icon><span class=\"h4 md-padding\">\n{{folderObject.folderName}}</span></div></div><md-divider></md-divider><div flex=\"80\" class=\"md-padding\"><form \nname=\"binderFoldersCreateForm\" novalidate ng-submit=\"binderFoldersCreateForm.$valid\" layout=\"column\"><div \nlayout=\"column\" flex=\"100\"><div layout=\"row\" layout-align=\"center center\" ng-if=\"binderData.folders.length <= 0\"><div \nflex=\"50\" style=\"background-color: #67dbd9;border-radius: 10px\" layout=\"row\" layout-align=\"center center\"><h3>\nNo Folders Yet.</h3></div></div><div layout=\"row\" layout-align=\"space-between center\" \nng-repeat=\"folderObject in binderData.folders\"><md-input-container class=\"md-block\"><input type=\"text\" \nname=\"folderName\" ng-model=\"folderObject.folderName\" placeholder=\"Folder Name\" required><div \nng-messages=\"binderFoldersCreateForm.folderName.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nFolder Name is required</span></div></div></md-input-container><md-input-container class=\"md-block\"><label>\nSelect Doctypes</label><md-select name=\"doctype\" ng-model=\"folderObject.documentTypes\" multiple=\"multiple\" required>\n<md-option ng-value=\"docType.id\" ng-repeat=\"docType in docTypes\">{{docType.name}}</md-option></md-select>\n</md-input-container><md-input-container class=\"md-block\"><input type=\"text\" name=\"sequence\" \nng-model=\"folderObject.seqId\" placeholder=\"Folder Sequence\" required><div \nng-messages=\"binderFoldersCreateForm.sequence.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nFolder Sequence is required</span></div></div></md-input-container><md-button class=\"md-icon-button test-tooltip\" \naria-label=\"Delete\" ng-click=\"\"><md-tooltip md-direction=\"top\">Delete</md-tooltip><md-icon><i layout=\"row\" \nlayout-align=\"center center\" class=\"icon icon-delete s20\"></i></md-icon></md-button></div></div></form></div></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"center center\"><md-button type=\"button\" \nng-click=\"cancel()\">Cancel</md-button><md-button type=\"submit\" \nng-click=\"binderFoldersCreateForm.$valid && saveBinderFolders() \">Save</md-button></md-dialog-actions><md-button \nflow-btn class=\"md-fab md-mini md-accent md-fab-bottom-right\" aria-label=\"Create User\" ng-click=\"addNewfolderObject()\">\n<md-icon md-font-icon=\"icon-plus\"></md-icon><md-tooltip md-direction=\"top\">Add new Folder</md-tooltip></md-button>\n</md-dialog>");
$templateCache.put("app/main/administration/binder-management/folders.binder.html","<md-dialog aria-label=\"Add a new object\" flex=\"30\"><script type=\"text/ng-template\" id=\"nodes_renderer2.html\">\n<div class=\"tree-node\">\n    <div class=\"tree-node-content\">\n      <a class=\"btn btn-success btn-xs\" data-nodrag ng-click=\"toggle(this)\">\n        <span class=\"icon\" ng-style=\"{\'font-size\': \'25px\'}\" ng-class=\"{\n          \'icon-chevron-right\': collapsed,\n          \'icon-chevron-down\': !collapsed\n          }\">\n        </span>\n        </span>\n      </a>\n      <input type=\"text\" name=\"name\" ng-model=\"node.title\" >\n      <md-button class=\"md-icon-button\" data-nodrag ng-click=\"newSubItem(this)\">\n        <md-icon class=\"icon icon-plus\" ng-style=\"{\'font-size\': \'25px\'}\"></md-icon>\n      </md-button>\n      <md-button class=\"pull-right md-icon-button\" data-nodrag ng-click=\"remove(this)\" >\n        <md-icon md-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" ng-style=\"{\'font-size\': \'25px\'}\" ></md-icon>\n      </md-button>\n    </div>\n  </div>\n  <ol ui-tree-nodes=\"\" ng-model=\"node.nodes\" ng-class=\"{hidden: collapsed}\">\n    <li ng-repeat=\"node in node.nodes\" ui-tree-node ng-include=\"\'nodes_renderer2.html\'\">\n    </li>\n  </ol>\n</script><div ui-tree id=\"tree2-root\" data-clone-enabled=\"true\"><ol ui-tree-nodes=\"\" ng-model=\"treelist\"><li \nng-repeat=\"node in treelist\" ui-tree-node ng-include=\"\'nodes_renderer2.html\'\"></li></ol></div><md-dialog-actions \nlayout=\"row\" layout-align=\"center center\"><md-button type=\"button\" ng-click=\"cancel()\">Cancel</md-button><md-button \ntype=\"submit\" ng-click=\"\">Save</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/administration/binder-management/update.binder.dialog.html","<md-dialog aria-label=\"Add a new user\" flex=\"30\" ng-init=\"getAllBusinessObjects()\"><form name=\"binderUpdateForm\" \nnovalidate ng-submit=\"binderForm.$valid && binderCrtl.updateUser(binder)\" layout=\"column\" flex=\"66\"><md-toolbar \nclass=\"md-accent\"><div class=\"md-toolbar-tools\"><h2>Edit Binder : {{currentBinder.name}}</h2><span flex></span>\n<md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><md-input-container class=\"md-block\"><input type=\"text\" name=\"name\" \nng-model=\"currentBinder.name\" placeholder=\"Name\" required></md-input-container><md-input-container class=\"md-block\">\n<input type=\"text\" name=\"description\" ng-model=\"currentBinder.description\" placeholder=\"Description\" required>\n</md-input-container><md-input-container class=\"md-block\"><input type=\"text\" name=\"siteId\" \nng-model=\"currentBinder.siteId\" placeholder=\"siteId\" required></md-input-container><md-input-container \nclass=\"md-block\"><label>Business Object</label><md-select ng-model=\"currentBinder.businessObject\"><md-option \nng-repeat=\"businessObject in allBusinessObjects\" ng-value=\"businessObject.name\" \nng-click=\"binderCrtl.selectBusinessObject(businessObject)\">{{businessObject.name}}</md-option></md-select>\n</md-input-container></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"center center\"><md-button \ntype=\"button\" ng-click=\"cancel()\">Cancel</md-button><md-button type=\"submit\" \nng-click=\"binderUpdateForm.$valid && update(currentBinder)\">Update</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/administration/business-object/bussiness.html","<div class=\"page-layout simple right-sidenav\" layout-gt-xs=\"row\"><div \nng-include=\"\'app/main/administration/common/admin.html\'\"></div><div \nclass=\"page-layout carded fullwidth md-padding scrollable\" layout=\"column\" flex ms-scroll><div class=\"widget-group\" \nflex=\"100\" layout=\"column\" layout-wrap><ms-widget flippable=\"true\" class=\"no-padding\"><div \nclass=\"parent-tabs white-bg mb-15\"><md-tabs class=\"mh-0\"><md-tab label=\"Bussiness Object\" md-active=\"true\"></md-tab>\n</md-tabs></div><div class=\"md-padding white-bg\"><table class=\"dataTable row-border hover table-border\" datatable=\"ng\" \ndt-options=\"dtOptions\"><thead><tr class=\"table-header\"><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Id</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Name</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Description</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">FormId</span></div></th><th class=\"secondary-text\"><div class=\"table-header\" layout=\"row\" \nlayout-align=\"center center\"><span class=\"column-title\">Actions</span></div></th></tr></thead><tbody><tr \nng-repeat=\"object in objectfiles\"><td>{{object.id}}</td><td>{{object.name}}</td><td>{{object.description}}</td><td>\n{{object.formId}}</td><td layout=\"row\" layout-align=\"center center\" \nstyle=\"padding-top:0px !important;padding-bottom:0px !important\"><md-button class=\"md-icon-button test-tooltip\" \naria-label=\"Update\" ng-click=\"detailsObjectDialog($event,object)\"><md-tooltip md-direction=\"top\">Details</md-tooltip>\n<md-icon><i layout=\"row\" layout-align=\"center center\" class=\"icon icon-dots-vertical s20\"></i></md-icon></md-button>\n<md-button class=\"md-icon-button test-tooltip\" aria-label=\"Update\" ng-click=\"updateObjectDialog($event,object)\">\n<md-tooltip md-direction=\"top\">Update</md-tooltip><md-icon><i layout=\"row\" layout-align=\"center center\" \nclass=\"icon icon-pencil s20\"></i></md-icon></md-button><md-button class=\"md-icon-button test-tooltip\" \naria-label=\"Delete\" ng-click=\"deleteObject($event,object)\"><md-tooltip md-direction=\"top\">Delete</md-tooltip><md-icon>\n<i layout=\"row\" layout-align=\"center center\" class=\"icon icon-delete s20\"></i></md-icon></md-button></td></tr></tbody>\n</table></div></ms-widget></div><md-button flow-btn class=\"md-fab grey-700-bg md-mini md-fab-bottom-right add_btn\" \nng-click=\"createObjectDialog($event)\"><md-icon md-font-icon=\"icon-plus\"></md-icon><md-tooltip md-direction=\"top\">\nCreate Business Object</md-tooltip></md-button></div></div><div ng-include=\"\'/app/core/layouts/footer.html\'\"></div>");
$templateCache.put("app/main/administration/business-object/create.object.dialog.html","<md-dialog aria-label=\"Add a new object\" flex=\"30\"><form name=\"objectCreateForm\" novalidate \nng-submit=\"objectCreateForm.$valid && bsCtrl.createObject(object)\" layout=\"column\" flex=\"66\"><md-toolbar \nclass=\"md-accent\"><div class=\"md-toolbar-tools\"><h2>Create Business Object</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><md-input-container class=\"md-block\"><input type=\"text\" name=\"name\" \nng-model=\"object.name\" placeholder=\"Name\" required><div ng-messages=\"objectCreateForm.name.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Name is required</span></div></div></md-input-container><md-input-container \nclass=\"md-block\"><input type=\"text\" name=\"description\" ng-model=\"object.description\" placeholder=\"Description\" \nrequired><div ng-messages=\"objectCreateForm.description.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nDescription is required</span></div></div></md-input-container><md-input-container class=\"md-block\"><label>Form Id\n</label><md-select ng-model=\"object.formId\"><md-option ng-value=\"formId\" ng-repeat=\"formId in ids\">{{formId}}\n</md-option></md-select></md-input-container></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"center center\"><md-button type=\"button\" ng-click=\"cancel()\">Cancel</md-button><md-button type=\"submit\" \nng-click=\"objectCreateForm.$valid && save(object) \">Save</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/administration/business-object/details.object.dialog.html","<md-dialog aria-label=\"Add a new user\" flex=\"75\"><form name=\"objectForm\" novalidate \nng-submit=\"objectForm.$valid && bsCtrl.detailsObject(object)\" layout=\"column\" flex=\"66\"><md-toolbar class=\"md-accent\">\n<div class=\"md-toolbar-tools\"><h2>Attributes of Business Object : {{currentObject.name}}</h2><span flex></span>\n<md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content class=\"scrollable\" ms-scroll><div><div layout=\"row\" \nlayout-align=\"space-around center\"><div class=\"table-header\"><span class=\"column-title\">NAME</span></div><div \nclass=\"table-header\"><span class=\"column-title\">TYPE</span></div><div class=\"table-header\"><span class=\"column-title\">\nRANGE</span></div><div class=\"table-header\"><span class=\"column-title\"></span></div></div><md-content><div \nng-repeat=\"element in attributes\" layout=\"row\" layout-align=\"center center\"><md-input-container class=\"md-block\" \nflex=\"20\"><input type=\"text\" name=\"type\" ng-model=\"element.label\"></md-input-container><span flex=\"5\"></span>\n<md-input-container class=\"md-block\" flex=\"20\"><md-select ng-model=\"element.type\"><md-option \nng-repeat=\"type in attributeTypes\" value=\"{{type}}\">{{type}}</md-option></md-select></md-input-container><span \nflex=\"15\"></span><md-input-container class=\"md-block\" flex=\"10\"><md-switch ng-model=\"element.range\" \naria-label=\"Switch\"></md-switch></md-input-container><md-input-container class=\"md-block\" flex=\"20\"><input type=\"text\" \nname=\"list\" ng-model=\"element.listReference\" ng-show=\"element.type == \'List\'\"></md-input-container><span flex=\"5\">\n</span></div></md-content></div></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"center center\">\n<md-button ng-click=\"cancel()\">Cancel</md-button><md-button type=\"submit\" ng-click=\"save()\">Update</md-button>\n</md-dialog-actions><md-button flow-btn class=\"md-fab md-accent md-fab-bottom-right\" aria-label=\"Create User\" \nng-click=\"addNewAttribute()\"><md-icon md-font-icon=\"icon-plus\"></md-icon><md-tooltip md-direction=\"top\">New Attribute\n</md-tooltip></md-button></form></md-dialog>");
$templateCache.put("app/main/administration/business-object/update.object.dialog.html","<md-dialog aria-label=\"Add a new user\" flex=\"30\"><form name=\"objectUpdateForm\" layout=\"column\" flex=\"66\"><md-toolbar \nclass=\"md-accent\"><div class=\"md-toolbar-tools\"><h2>Edit Business Object : {{currentObject.actvity}}</h2><span flex>\n</span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><md-input-container class=\"md-block\"><input type=\"text\" \ndisabled=\"true\" name=\"id\" ng-model=\"currentObject.id\" placeholder=\"Id\" required></md-input-container>\n<md-input-container class=\"md-block\"><input type=\"text\" name=\"name\" ng-model=\"currentObject.name\" placeholder=\"Name\" \nrequired></md-input-container><md-input-container class=\"md-block\"><input type=\"text\" name=\"description\" \nng-model=\"currentObject.description\" placeholder=\"Description\" required></md-input-container><md-input-container \nclass=\"md-block\"><label>Form Id</label><md-select ng-model=\"currentObject.formId\"><md-option ng-value=\"formId\" \nng-repeat=\"formId in formIds\">{{formId}}</md-option></md-select></md-input-container></md-dialog-content>\n<md-dialog-actions layout=\"row\" layout-align=\"center center\"><md-button type=\"button\" ng-click=\"cancel()\">Cancel\n</md-button><md-button type=\"button\" ng-click=\"update(currentObject)\">Update</md-button></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/administration/common/admin.html","<style>\n[md-theme=\"default\"] a{\ncolor: black !important;\n}\n\nms-nav ms-nav-item .ms-nav-button.active{\ncolor: rgb(3,155,229) !important;\n}\n.static-side {\n    margin-bottom: 10px;\n    width: 200px;\n    border-radius: 3px;\n    border: 1px solid #d3d3d3;   \n}\n/* .static-side li.active>a {\n    color: #fff !important;\n    background-color: #3697ef;\n} */\n/* .static-side li:hover {\n    color: #fff !important;\n    background-color: #3697ef !important;   \n} */\n.static-side li:hover>a {\n    color: #fff !important;\n    background-color: #3697ef !important;   \n}\n.nav {\n    margin-bottom: 0;\n    padding-left: 0;\n    margin-top: 0;\n    list-style: none;\n}  \n.nav>li>a {\n    color: #515152 !important;\n    font-size: 14px;\n    display: block;\n    padding: 7px 15px;\n} \n.previous-state {\n    color: #52b8e9;\n    font-size: 12px;\n    text-transform: uppercase;\n    font-weight: 500;\n    width: 100%;\n    padding: 7px 15px; \n}\n</style><div class=\"page-layout simple right-sidenav\" hide-xs layout=\"row\"><div layout=\"column\" layout-wrap><ms-widget \nflippable=\"true\" layout=\"column\"><div class=\"static-side white-bg\" layout=\"column\"><ul class=\"nav\"><li \nclass=\"previous-state c-p\" data-ng-click=\"goToPreviousState()\"><span><span class=\"icon-arrow-left-bold-circle-outline\">\n</span> Back</span></li><li \nng-class=\"{active: $state.includes(\'app.administration.users\') || $state.includes(\'app.administration.groups\') || $state.includes(\'app.administration.userupload\')}\">\n<a ui-sref=\"app.administration.users\">User Management <span class=\"icon-chevron-right pull-right\"></span></a></li><li \nng-if=\"showsForms\" \nng-class=\"{active: $state.includes(\'app.administration.forms\') || $state.includes(\'app.administration.createform\')}\"><a\n ui-sref=\"app.administration.forms\">Forms Management <span class=\"icon-chevron-right pull-right\"></span></a></li><li \nng-if=\"showListManagement\" \nng-class=\"{active: $state.includes(\'app.administration.lists\') ||$state.includes(\'app.administration.list-maintenance\')}\">\n<a ui-sref=\"app.administration.lists\">List Management <span class=\"icon-chevron-right pull-right\"></span></a></li><li \nng-class=\"{active: $state.includes(\'app.administration.workflow-management\')}\"><a \nui-sref=\"app.administration.workflow-management\">Workflow Management <span class=\"icon-chevron-right pull-right\">\n</span></a></li><li ng-if=\"showrequestManagement\" \nng-class=\"{active: $state.includes(\'app.administration.requestType\')}\"><a ui-sref=\"app.administration.requestType\">\nRequests Management <span class=\"icon-chevron-right pull-right\"></span></a></li><li \nng-class=\"{active: $state.includes(\'app.administration.settings.technical\') || $state.includes(\'app.administration.settings.help\')|| $state.includes(\'app.administration.settings.emailConfig\') || $state.includes(\'app.administration.settings.brand\') || $state.includes(\'app.administration.settings.site\') || $state.includes(\'app.administration.settings.menubar\')}\">\n<a ui-sref=\"app.administration.settings.brand\">Settings <span class=\"icon-chevron-right pull-right\"></span></a></li><li\n ng-class=\"{active: $state.includes(\'app.administration.parReports\')}\"><a ui-sref=\"app.administration.parReports\">\nReports <span class=\"icon-chevron-right pull-right\"></span></a></li><li ng-if=\"showZohoReports\" \nng-class=\"{active: $state.includes(\'app.administration.zohoReports\')}\"><a ui-sref=\"app.administration.zohoReports\">\nZoho Reports <span class=\"icon-chevron-right pull-right\"></span></a></li><li \nng-class=\"{active: $state.includes(\'app.administration.doaReports\')}\"><a ui-sref=\"app.administration.doaReports\">\nDOA Reports Config <span class=\"icon-chevron-right pull-right\"></span></a></li><li ng-if=\"showReqTypeDetails\" \nng-class=\"{active: $state.includes(\'app.administration.requestTypeDetails\')}\"><a \nui-sref=\"app.administration.requestTypeDetails\">RequestType Deatils <span class=\"icon-chevron-right pull-right\"></span>\n</a></li><li ng-class=\"{active: $state.includes(\'app.administration.emailBuffer\')}\"><a \nui-sref=\"app.administration.emailBuffer\">Email Buffer <span class=\"icon-chevron-right pull-right\"></span></a></li><li \nng-class=\"{active: $state.includes(\'app.administration.substitution\')|| $state.includes(\'app.administration.reAssign\')}\">\n<a ui-sref=\"app.administration.substitution\">Substitution <span class=\"icon-chevron-right pull-right\"></span></a></li>\n<li ng-if=\"showInvoiceTypes\" ng-class=\"{active: $state.includes(\'app.administration.invoiceTypeList\')}\"><a \nui-sref=\"app.administration.invoiceTypeList\">Invoice Type<span class=\"icon-chevron-right pull-right\"></span></a></li>\n<li ng-class=\"{active: $state.includes(\'app.administration.approveLevel\')}\"><a \nui-sref=\"app.administration.approveLevel\">DOA-(Approval Matrix)<span class=\"icon-chevron-right pull-right\"></span></a>\n</li><li ng-class=\"{active: $state.includes(\'app.administration.mtrInboxConfg\')}\"><a \nui-sref=\"app.administration.mtrInboxConfg\">InboxConfg <span class=\"icon-chevron-right pull-right\"></span></a></li><li \nng-class=\"{active: $state.includes(\'app.administration.systemLogs\')}\"><a ui-sref=\"app.administration.systemLogs\">\nSystem Logs <span class=\"icon-chevron-right pull-right\"></span></a></li></ul></div></ms-widget></div></div><ms-nav \nhide-gt-md style=\"margin-top: 10px\"><ms-nav-item ms-nav-toggle collapsed=\"true\"><a style=\"background: #5fa648\" \nms-nav-button md-ink-ripple><i class=\"icon-tile-four s16\"></i> <span style=\"color: black\" class=\"ms-nav-label\" \ntranslate=\"ADMIN.DASHBOARDS\">Dashboards</span> <i style=\"color: black\" class=\"icon-chevron-down s16 arrow\"></i></a>\n<ms-nav-toggle-items><ms-nav-item><a ms-nav-button ui-sref=\"app.administration.users\" ui-sref-active=\"active\" \nmd-ink-ripple><span class=\"ms-nav-label\">User Management</span></a></ms-nav-item><ms-nav-item><a ms-nav-button \nui-sref=\"app.administration.forms\" ui-sref-active=\"active\" md-ink-ripple><span class=\"ms-nav-label\">Forms Management\n</span></a></ms-nav-item><ms-nav-item><a ms-nav-button ui-sref=\"app.administration.lists\" ui-sref-active=\"active\" \nmd-ink-ripple><span class=\"ms-nav-label\">List Management</span></a></ms-nav-item><ms-nav-item><a ms-nav-button \nui-sref=\"app.administration.workflow-management\" ui-sref-active=\"active\" md-ink-ripple><span class=\"ms-nav-label\">\nWorkflow Management</span></a></ms-nav-item><ms-nav-item><a ms-nav-button \nui-sref=\"app.administration.bussiness-object\" ui-sref-active=\"active\" md-ink-ripple><span class=\"ms-nav-label\">\nBussiness Object</span></a></ms-nav-item><ms-nav-item><a ms-nav-button ui-sref=\"app.administration.requestType\" \nui-sref-active=\"active\" md-ink-ripple><span class=\"ms-nav-label\">Requests Management</span></a></ms-nav-item>\n<ms-nav-item><a ms-nav-button ui-sref=\"app.administration.settings\" ui-sref-active=\"active\" md-ink-ripple><span \nclass=\"ms-nav-label\">Settings</span></a></ms-nav-item><ms-nav-item><a ui-sref-active=\"active\" ms-nav-button \nui-sref=\"app.administration.binder\" md-ink-ripple><span class=\"ms-nav-label\">Binder</span></a></ms-nav-item>\n<ms-nav-item><a ui-sref-active=\"active\" ms-nav-button ui-sref=\"app.administration.documentType\" md-ink-ripple><span \nclass=\"ms-nav-label\">Document Types</span></a></ms-nav-item><ms-nav-item><a ui-sref-active=\"active\" ms-nav-button \nui-sref=\"app.administration.template\" md-ink-ripple><span class=\"ms-nav-label\">Templates</span></a></ms-nav-item>\n<ms-nav-item><a ui-sref-active=\"active\" ms-nav-button ui-sref=\"app.administration.reports\" md-ink-ripple><span \nclass=\"ms-nav-label\">Reports</span></a></ms-nav-item><ms-nav-item><a ms-nav-button \nui-sref=\"app.administration.doaReports\" ui-sref-active=\"active\" md-ink-ripple><span class=\"ms-nav-label\">Doa Reports\n</span></a></ms-nav-item></ms-nav-toggle-items></ms-nav-item></ms-nav><script>\nif (screen.width < 600) {\n    $(\"#vertical-navigation\").show();\n}else{\n	$(\"#vertical-navigation\").hide();\n}</script>");
$templateCache.put("app/main/business-admin/business-purchaseorg/create.purchaseorg.dialog.html","<md-dialog aria-label=\"Add List\" flex=\"45\"><form name=\"listForm\" novalidate layout=\"column\"><md-toolbar \nclass=\"md-accent\"><div class=\"md-toolbar-tools\"><h2>Create Detail</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><div layout=\"column\"><md-input-container class=\"md-block\" flex=\"45\" \nng-if=\"list != \'_id\'\" ng-repeat=\"list in attrdata track by $index\"><label>{{list}}</label><input type=\"text\" \nname=\"arrval\" ng-model=\"crlist[$index].list\" required><div ng-messages=\"listForm.list.$error\" role=\"alert\"><div \nng-message=\"required\"><span>{{list}} is required</span></div><div ng-message=\"pattern\"><span>\n{{list}} has invalid characters</span></div></div></md-input-container></div></md-dialog-content><md-dialog-actions \nlayout=\"row\" layout-align=\"center center\"><md-button type=\"button\" ng-click=\"cancel()\">Cancel</md-button><md-button \ntype=\"submit\" ng-click=\"listForm.$valid && save()\">Save</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/business-admin/business-purchaseorg/purchase.html","<div class=\"page-layout simple right-sidenav\" layout=\"row\"><div \nclass=\"page-layout carded fullwidth md-padding scrollable\" layout=\"column\" flex ms-scroll><div class=\"widget-group\" \nflex=\"100\" layout=\"column\" layout-wrap><ms-widget flippable=\"true\" class=\"no-padding\"><div \nclass=\"md-padding white-bg scrollable\" ms-scroll><div class=\"md-padding white-bg\" ng-init=\"List()\"><div \nclass=\"previous-state c-p\" data-ng-click=\"goToPreviousState()\"><span><span class=\"icon-arrow-left-bold-circle-outline\">\n</span> Back </span></div><table class=\"dataTable row-border hover table-border\" datatable=\"ng\" \ndt-options=\"PurchaseCtrl.dtOptions\" layout-wrap ng-if=\"inputfield != \'\'\"><thead><tr class=\"table-header\"><th \nclass=\"secondary-text\" ng-hide=\"value == \'_id\'\" ng-repeat=\"(key, value) in inputfield\"><div class=\"table-header\"><span \nclass=\"column-title\">{{value}}</span></div></th><th class=\"secondary-text\"><div class=\"table-header\" layout=\"row\" \nlayout-align=\"center center\"><span class=\"column-title\">Actions</span></div></th></tr></thead><tbody><tr \nng-repeat=\"(key, value) in EmployeesList track by $index\"><td ng-hide=\"k == \'_id\'\" \nng-repeat=\"(k, v) in EmployeesList[$index] track by $index\">{{v}}</td><td layout=\"row\" layout-align=\"center center\" \nstyle=\"padding-top:0px !important;padding-bottom:0px !important\"><md-button class=\"md-icon-button test-tooltip\" \naria-label=\"Update\" ng-click=\"updateEmployee($event,EmployeesList[$index])\"><md-tooltip md-direction=\"top\">Update\n</md-tooltip><md-icon><i layout=\"row\" layout-align=\"center center\" class=\"icon icon-pencil s18\"></i></md-icon>\n</md-button><md-button class=\"md-icon-button test-tooltip\" aria-label=\"Delete\" \nng-click=\"deletedata($event,EmployeesList[$index]) \"><md-tooltip md-direction=\"top\">Delete</md-tooltip><md-icon><i \nlayout=\"row\" layout-align=\"center center\" class=\"icon icon-delete s18\"></i></md-icon></md-button></td></tr></tbody>\n</table><div ng-if=\"inputfield == undefined\"><h1>No Data Available</h1></div></div></div></ms-widget><md-button \nflow-btn class=\"md-fab grey-700-bg md-mini md-fab-bottom-right\" ng-click=\"createEmployee()\"><md-icon \nmd-font-icon=\"icon-plus\" class=\"white-fg\"></md-icon><md-tooltip md-direction=\"top\">Create Employee</md-tooltip>\n</md-button></div></div></div>");
$templateCache.put("app/main/business-admin/business-purchaseorg/update.purchaseorg.dialog.html","<md-dialog aria-label=\"Add List\" flex=\"45\"><form name=\"listForm\" novalidate \nng-submit=\"listForm.$valid && updatedata()\" layout=\"column\"><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools\"><h2>Update Detail</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\">\n<md-icon md-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><div layout=\"column\"><md-input-container class=\"md-block\" flex=\"45\" \nng-hide=\"key == \'_id\'\" ng-repeat=\"(key, value) in currentdata track by $index\"><label>{{key}}</label><input \ntype=\"text\" name=\"arrval\" ng-init=\"updateddata[$index] = value\" ng-model=\"updateddata[$index]\" required><div \nng-messages=\"listForm.$error\" role=\"alert\"><div ng-message=\"required\"><span>{{key}} is required</span></div><div \nng-message=\"pattern\"><span>{{key}} has invalid characters</span></div></div></md-input-container></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"center center\"><md-button type=\"button\" \nng-click=\"cancel()\">Cancel</md-button><md-button type=\"submit\" ng-click=\"updatedata()\">update</md-button>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/coromandel_outbox/c_outbox/c_outbox.html","<style>\n.table-header{\n    text-transform: none;\n    }\n    .page-layout .top-bg {\n    height: 100px;\n    background-image: none;\n    background-color: whitesmoke\n    }\n    #e-commerce-orders .center .header {\n    min-height: 80px !important;\n    max-height: 80px !important;\n    }\n    .pointer {cursor: pointer;}\n</style><div id=\"e-commerce-orders\" class=\"page-layout carded fullwidth\" layout=\"row\"><div class=\"top-bg md-accent-bg\">\n</div><div class=\"center\" layout=\"column\" flex><div class=\"page-layout carded fullwidth md-padding scrollable\" \nlayout=\"column\" flex ms-scroll flex=\"grow\"><div class=\"widget-group\" layout=\"column\" layout-wrap><ms-widget \nflippable=\"true\" class=\"no-padding\"><div class=\"md-padding white-bg\" hide-xs hide-gt-xs show-md show-gt-md><div><span \nstyle=\"color: #2196F3\"><md-icon md-font-icon=\"icon-cart-outline\" style=\"color: #2196F3 !important\"></md-icon>\nWorkItems : {{orders.length}}</span></div><table class=\"dataTable row-border hover table-border\" datatable=\"ng\" \ndt-options=\" CoutboxCtrl.dtOptions\" data-order=\'[[ 1, \"asc\" ]]\'><thead><tr class=\"table-header\"><th \nclass=\"secondary-text\" ng-repeat=\"header in vendorform\"><div class=\"table-header\"><span class=\"column-title\">{{header}}\n</span></div></th></tr></thead><tbody><tr ng-repeat=\"user in orders | filter : searchUser | unique : \'docId\'\"><td><span\n ng-click=\"gotoOrderDetail(user.docId)\" \nstyle=\"text-align: start;text-decoration: underline;color: blue;cursor: pointer\">{{user.docId}}</span></td><td>\n{{user.headerValues.Field2.value}}</td><td>{{user.headerValues.Field3.value}}</td><td>\n{{user.headerValues.Field4.value}}</td><td>{{user.headerValues.Field5.value}}</td><td>\n{{user.headerValues.Field6.value}}</td><td>{{user.headerValues.Field8.value}}</td><td>{{user.createdDate.substr(0,10)}}\n</td></tr></tbody></table></div><div class=\"md-padding white-bg\" show-xs hide-md hide-gt-md><div \nclass=\"md-list-item-text\" layout=\"column\"><md-expansion-panel md-component-id=\"panelOne\" ng-repeat=\"user in orders\">\n<md-expansion-panel-collapsed><div class=\"md-title\" style=\"color: #039be5\">DocId {{user.docId}}</div>\n<md-expansion-panel-icon></md-expansion-panel-icon><md-icon></md-icon><i class=\"icon-arrow-right blue-fg\" \nstyle=\"margin-top: 4%\" ng-click=\"gotoOrderDetail(user.docId)\"></i></md-expansion-panel-collapsed>\n<md-expansion-panel-expanded><md-expansion-panel-header ng-click=\"$panel.collapse()\"><div class=\"md-title\" \nstyle=\"color: #039be5\">DocId{{user.docId}}</div><div layout=\"row\" layout-align=\"end end\"><md-expansion-panel-icon>\n</md-expansion-panel-icon><i class=\"icon-arrow-right blue-fg\" style=\"margin-top: 4%\" \nng-click=\"gotoOrderDetail(user.docId)\"></i></div></md-expansion-panel-header><md-expansion-panel-content><div \nlayout=\"row\" layout-align=\"start center\"><div flex=\"50\" layout-align=\"start center\"><b>{{vendorform[1]}}</b></div><div \nflex=\"50\" layout-align=\"start center\">{{user.headerValues.Field2.value}}</div></div><div layout=\"row\" \nlayout-align=\"start center\"><div flex=\"50\" layout-align=\"start center\"><b>{{vendorform[2]}}</b></div><div flex=\"50\" \nlayout-align=\"start center\">{{user.headerValues.Field3.value}}</div></div><div layout=\"row\" \nlayout-align=\"start center\"><div flex=\"50\" layout-align=\"start center\"><b>{{vendorform[3]}}</b></div><div flex=\"50\" \nlayout-align=\"start center\">{{user.headerValues.Field4.value}}</div></div><div layout=\"row\" \nlayout-align=\"start center\"><div flex=\"50\" layout-align=\"start center\"><b>{{vendorform[4]}}</b></div><div flex=\"50\" \nlayout-align=\"start center\">{{user.headerValues.Field5.value}}</div></div><div layout=\"row\" \nlayout-align=\"start center\"><div flex=\"50\" layout-align=\"start center\"><b>{{vendorform[5]}}</b></div><div flex=\"50\" \nlayout-align=\"start center\">{{user.headerValues.Field6.value}}</div></div><div layout=\"row\" \nlayout-align=\"start center\"><div flex=\"50\" layout-align=\"start center\"><b>{{vendorform[6]}}</b></div><div flex=\"50\" \nlayout-align=\"start center\">{{user.headerValues.Field8.value}}</div></div><div layout=\"row\" \nlayout-align=\"start center\"><div flex=\"50\" layout-align=\"start center\"><b>{{vendorform[7]}}</b></div><div flex=\"50\" \nlayout-align=\"start center\">{{user.createdDate.substr(0,10)}}</div></div></md-expansion-panel-content>\n</md-expansion-panel-expanded></md-expansion-panel></div></div></ms-widget></div></div></div></div>");
$templateCache.put("app/main/coromandel_outbox/c_outbox/c_outboxWorkitem.html","<style>\n.table-header {\n        background-color: #fbfbfc !important;\n        text-transform: none;\n        }\n        .select2-container .select2-choice>.select2-chosen {\n        color: black;\n        }\n        .dataTables_length {\n        display: none;\n        }\n        .dataTables_filter {\n        display: none;\n        }\n        table.dataTable tbody td {\n        padding: 6px 8px !important;\n        }\n        .md-button {\n        text-transform: none;\n        }\n        .selectedApprovalMatrixrow {\n        font-size: 18px;\n        font-weight: bold;\n        color: black;\n        }\n        .selectedApprovalMatrixrowBackground {\n        background-color: #7ae2d8;\n        }\n        /* //horizonatal */\n        body {\n        font-family: \'Open Sans\', sans-serif;\n        font-size: 16px;\n        color: #555555;\n        height: 10px;\n        }\n        .md-stepper-horizontal {\n		display: table;\n		width: 98%;\n		margin-top: 1% !important;\n		border-radius: 6px;\n		margin: 0 auto;\n		background-color: #FFFFFF;\n		box-shadow: 0 3px 8px -6px rgba(0, 0, 0, .50);\n		}\n		.md-stepper-horizontal .md-step {\n		display: table-cell;\n		position: relative;\n		padding: 20px;\n		}\n		.md-stepper-horizontal .md-step .md-step-circle {\n		width: 30px;\n		height: 30px;\n		margin: 0 auto;\n		background-color: #999999;\n		border-radius: 50%;\n		text-align: center;\n		line-height: 30px;\n		font-size: 16px;\n		font-weight: 600;\n		color: #FFFFFF;\n		}\n		.md-stepper-horizontal.orange .md-step.active .md-step-circle {\n		background-color: #F96302;\n		}\n		.md-stepper-horizontal .md-step.active .md-step-circle {\n		background-color: rgb(33, 150, 243);\n		}\n		.md-stepper-horizontal .md-step.done .md-step-circle:before {\n		font-family: \'FontAwesome\';\n		font-weight: 100;\n		content: \"\\f00c\";\n		}\n		.md-stepper-horizontal .md-step.done .md-step-circle *,\n		.md-stepper-horizontal .md-step.editable .md-step-circle * {\n		display: none;\n		}\n		.md-stepper-horizontal .md-step.editable .md-step-circle {\n		-moz-transform: scaleX(-1);\n		-o-transform: scaleX(-1);\n		-webkit-transform: scaleX(-1);\n		transform: scaleX(-1);\n		}\n		.md-stepper-horizontal .md-step.editable .md-step-circle:before {\n		font-family: \'FontAwesome\';\n		font-weight: 100;\n		content: \"\\f040\";\n		}\n		.md-stepper-horizontal .md-step .md-step-title {\n		margin-top: 16px;\n		font-size: 16px;\n		font-weight: 600;\n		}\n		.md-stepper-horizontal .md-step .md-step-title,\n		.md-stepper-horizontal .md-step .md-step-optional {\n		text-align: center;\n		color: rgba(0, 0, 0, .26);\n		}\n		.md-stepper-horizontal .md-step.active .md-step-title {\n		font-weight: 600;\n		color: rgba(0, 0, 0, .87);\n		}\n		.md-stepper-horizontal .md-step.active.done .md-step-title,\n		.md-stepper-horizontal .md-step.active.editable .md-step-title {\n		font-weight: 600;\n		}\n		.md-stepper-horizontal .md-step .md-step-optional {\n		font-size: 12px;\n		}\n		.md-stepper-horizontal .md-step.active .md-step-optional {\n		color: rgba(0, 0, 0, .54);\n		}\n		.md-stepper-horizontal .md-step .md-step-bar-left,\n		.md-stepper-horizontal .md-step .md-step-bar-right {\n		position: absolute;\n		top: 36px;\n		height: 5px;\n		border-top: 1px solid #DDDDDD;\n		}\n		.md-stepper-horizontal .md-step .md-step-bar-right {\n		position: absolute;\n		right: 0;\n		 left: 50%;\n		margin-left: 20px; \n		}\n		/* .md-step-bar-right {\n			text-align: center;\n			font-weight: bold;\n		} */\n		.md-stepper-horizontal .md-step .md-step-bar-left {\n		left: 0;\n		right: 50%;\n		}\n		.activateadUser {\n		color: green\n		}\n</style><div class=\"page-layout simple tabbed\" layout=\"column\"><div layout=\"row\" layout-align=\"start center\" \nstyle=\"min-height: 53px\"><div class=\"white-fg\" layout=\"row\" layout-align=\"start center\" flex><md-button \nclass=\"goto-orders-button md-icon-button\" aria-label=\"Go to orders\" ng-click=\"gotoOrders()\"><md-icon \nmd-font-icon=\"icon-arrow-left\" style=\"color: black\"></md-icon></md-button><div layout=\"column\" \nlayout-align=\"start start\"><div class=\"h4\" style=\"color: black\"><span>Invoice Details:</span> <span>{{id}}</span></div>\n</div></div></div><md-divider></md-divider><div class=\"md-stepper-horizontal orange\" ms-scroll><div \nclass=\"md-step active done\" ng-repeat=\"approver in workitemInfo.approvalMatrix.approvers track by $index\"><div \nstyle=\"margin-left: 50%\"><md-icon class=\"icon s20 green-fg\" ng-if=\"workitemInfo.approvalMatrix.checked[$index]\" \nmd-font-icon=\"icon-checkbox-marked-circle \"></md-icon><md-icon class=\"icon s20 blue-500-fg\" \nng-if=\"(!workitemInfo.approvalMatrix.checked[$index] && workitemInfo.status != \'8\') ||  (!workitemInfo.approvalMatrix.checked[$index]&& workitemInfo.approvalMatrix.approverDates[$index])\" \nmd-font-icon=\"	icon-google-circles-invite\"></md-icon><md-icon class=\"icon s25 red-fg\" \nng-if=\"workitemInfo.approvalMatrix.checked[$index] == false && workitemInfo.status == \'8\' && !workitemInfo.approvalMatrix.approverDates[$index]\" \nmd-font-icon=\"icon-close-circle-outline\"></md-icon></div><div class=\"md-step-title\" \nng-class=\"{\'selectedApprovalMatrixrow\':workitemInfo.approvalMatrix.selected[$index]}\"><h5 \nng-class=\"{\'activateadUser\': $index+1 == workitemInfo.currentstep}\"><b>{{approver}}</b> <span class=\"icon s25 red-fg\" \nng-if=\"workitemInfo.approvalMatrix.checked[$index] == false && !workitemInfo.approvalMatrix.approverDates[$index] && workitemInfo.status == \'8\'\">\n(Rejected)</span></h5></div><div class=\"md-step-bar-left\"><div hide-xs show-gt-md \nng-if=\"workitemInfo.approvalMatrix.approverDates[$index]\" style=\"font-size:12px\" layout=\"column\"><span \nng-if=\"workitemInfo.approvalMatrix.approvers.length <= 7\">\nDate: {{workitemInfo.approvalMatrix.approverDates[$index].substring(6,8)}}-{{workitemInfo.approvalMatrix.approverDates[$index].substring(4,6)}}-{{workitemInfo.approvalMatrix.approverDates[$index].substring(0,4)}}\n</span> <span ng-if=\"workitemInfo.approvalMatrix.approvers.length <= 7\">\nTime: {{workitemInfo.approvalMatrix.approverDates[$index].substring(9,11)}}:{{workitemInfo.approvalMatrix.approverDates[$index].substring(11,13)}}\n</span> <span ng-if=\"workitemInfo.approvalMatrix.approvers.length > 7\">\nD: {{workitemInfo.approvalMatrix.approverDates[$index].substring(6,8)}}/{{workitemInfo.approvalMatrix.approverDates[$index].substring(4,6)}}\n</span></div></div><div class=\"md-step-bar-right\"></div></div></div><div class=\"widget-group\" \nng-if=\"workitemInfo.requestType !=\'COR_EXCL_PDR\'\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget layout=\"column\" \nflex=\"60\" flex-xs=\"100\"><ms-widget-front class=\"white-bg\" style=\"border-radius: 6px\"><md-content><div layout=\"row\" \nlayout-align=\"space-between center\" class=\"md-padding\"><div class=\"h2\">Header</div><div layout=\"row\"><b \nstyle=\"color:rgb(33,150,243)\">Initiated:{{diffDays}} days ago ({{createDate}})</b></div><div></div></div><md-divider>\n</md-divider><div class=\"md-padding\"><div ng-if=\"workitemInfo.requestType == \'COR_ADV\'\" \nng-bind-html=\"currentFormInboxHeader\" compile-template></div><div ng-if=\"workitemInfo.requestType != \'COR_ADV\'\" \nng-bind-html=\"currentFormInbox\" compile-template></div></div><md-divider></md-divider></md-content></ms-widget-front>\n</ms-widget><ms-widget layout=\"column\" flex=\"40\" flex-xs=\"100\"><ms-widget-front class=\"white-bg\" \nstyle=\"border-radius: 6px\"><md-content style=\"background: #e3e9ed3d;padding:15px\"><div><div layout=\"row\" \nlayout-align=\"space-between center\" style=\"padding: 10px\"><div><span class=\"h3\" style=\"color: #030303\">\nAttachments : {{getAttachmentsLength(workitemInfo.attachments)}}</span></div><div><md-icon ng-click=\"logs()\" \nmd-font-icon=\"icon-comment-text-outline\" style=\"color: #23b8e5\"></md-icon><md-tooltip md-direction=\"top\">Logs\n</md-tooltip></div></div><md-divider></md-divider><ms-widget flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"33\" \nng-repeat=\"attachment in workitemInfo.attachments | orderBy :\'folderName\'\" \nng-if=\"workitemInfo.attachments.length && attachment.deleteStatus != \'true\'\"><ms-widget-front class=\"white-bg c-p\">\n<md-list flex><div layout=\"row\" layout-align=\"start start\" flex-gt-sm><span><md-icon \nmd-font-icon=\"{{fileIcon(attachment.fileType)}}\" class=\"s42 icon md-accent\"></md-icon></span><div layout=\"column\" \nflex-gt-sm=\"35\"><span class=\"h4\" style=\"color: #039be5\">{{attachment.folderName}}</span> <span \nng-click=\"selectFile(attachment)\">{{attachment.fileName}}</span><span class=\"h6\" style=\"color: #030303\">\nCreated By : {{attachment.creator}}</span></div><div flex-gt-sm=\"20\" style=\"margin-top: -1%\"><md-button \nclass=\"md-icon-button md-accent\" ng-click=\"downloadFile(attachment,workitemInfo.requestId)\"><md-icon \nmd-font-icon=\"icon-download\" class=\"s20 green-fg\"></md-icon></md-button></div><div hide=\"\" show-gt-sm=\"\" flex=\"\"><h3 \nstyle=\"color: #030303;margin-top: -2%\">\nCreated On : {{attachment.createDate.substr(6,2)}}-{{attachment.createDate.substr(4,2)}}-{{attachment.createDate.substr(0,4)}}\n</h3></div></div></md-list></ms-widget-front></ms-widget></div></md-content></ms-widget-front></ms-widget></div>\n<ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" ng-if=\"workitemInfo.requestType ==\'COR_EXCL_PDR\'\">\n<ms-widget-front class=\"white-bg\" class=\"scrollable\" ms-scroll><div flex=\"100\" style=\"color:black\" \nstyle=\"overflow-y:scroll !important\"><md-content><div layout-align=\"center center\" style=\"background: #f3f3f39e\">\n<md-tabs md-dynamic-height md-center-tabs style=\"padding: 19px\"><md-tab><md-tab-label>Header</md-tab-label><md-tab-body\n flex=\"100\"><ms-widget flex=\"100\"><ms-widget-front class=\"white-bg c-p\"><div ng-bind-html=\"currentFormInbox\" \ncompile-template></div></ms-widget-front></ms-widget></md-tab-body></md-tab><md-tab><md-tab-label>LineItems\n</md-tab-label><md-tab-body><ms-widget flex=\"100\"><ms-widget-front class=\"white-bg c-p\"><div \nng-bind-html=\"currentFormInboxLineitem\" style=\"color: black\" compile-template></div></ms-widget-front></ms-widget>\n</md-tab-body></md-tab><md-tab><md-tab-label>Attachments</md-tab-label><md-tab-body><div style=\"padding: 10px\"><div \nlayout=\"row\" layout-align=\"space-between center\" style=\"padding: 10px\"><div><span class=\"h3\" style=\"color: #030303\">\nAttachments : {{getAttachmentsLength(workitemInfo.attachments)}}</span></div><div><md-icon ng-click=\"logs()\" \nmd-font-icon=\"icon-comment-text-outline\" style=\"color: #23b8e5\"></md-icon><md-tooltip md-direction=\"top\">Logs\n</md-tooltip></div></div><md-divider></md-divider><ms-widget flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"33\" \nng-repeat=\"attachment in workitemInfo.attachments | orderBy :\'folderName\'\" \nng-if=\"workitemInfo.attachments.length && attachment.deleteStatus != \'true\'\"><ms-widget-front class=\"white-bg c-p\">\n<md-list flex style=\"padding: 13px\"><div class=\"h3\" style=\"color: rgb(3,155,229)\">{{attachment.folderName}}</div><div \nlayout=\"row\" layout-align=\"start start\" flex-gt-sm><span><md-icon md-font-icon=\"{{fileIcon(attachment.fileType)}}\" \nclass=\"s42 icon md-accent\"></md-icon></span><div layout=\"column\" flex-gt-sm=\"35\"><span class=\"h4 c-p\" \nng-click=\"selectFile(attachment)\">{{attachment.fileName}}</span> <span class=\"h6\" style=\"color: #030303\">\nCreated By : {{attachment.creator}}</span></div><div flex-gt-sm=\"20\"><md-button class=\"md-icon-button md-accent\" \nng-click=\"downloadFile(attachment,workitemInfo.requestId)\"><md-icon layout-align=\"end end\" \nmd-font-icon=\"icon-download\" class=\"s20 green-fg\"></md-icon></md-button></div><div hide=\"\" show-gt-sm=\"\" flex=\"\"><h3 \nstyle=\"color: #030303;margin-top: -2%\">\nCreated On : {{attachment.createDate.substr(6,2)}}-{{attachment.createDate.substr(4,2)}}-{{attachment.createDate.substr(0,4)}}\n</h3></div></div></md-list></ms-widget-front></ms-widget><div layout=\"row\" layout-align=\"center center\"><div><input \nclass=\"ng-hide\" id=\"formUploadFile\" name=\"formUploadFile\" type=\"file\" \nonchange=\"angular.element(this).scope().setAttachmentFile(this)\"><label for=\"formUploadFile\" \nclass=\"md-button md-raised md-accent\">Upload Files</label></div></div><div \nng-repeat=\"file in attachmentfiles.slice(0)\" layout-align=\"center center\" style=\"text-align: center\"><div><span \nclass=\"md-warn\">{{file.webkitRelativePath || file.name}}</span> (<span ng-switch=\"file.size > 1024*1024\"> <span \nng-switch-when=\"true\">{{file.size / 1024 / 1024 | number:2}} MB</span> <span ng-switch-default>\n{{file.size / 1024 | number:2}} kB</span> </span>) <span><md-tooltip md-direction=\"top\"><span>Remove Attachment</span>\n</md-tooltip><md-icon class=\"icon\" md-font-icon=\"icon-close-circle-outline\" style=\"color: red\" \nng-click=\"removeAttachment($index)\"></md-icon></span><span><md-tooltip md-direction=\"top\"><span>View Attachment</span>\n</md-tooltip><md-icon md-font-icon=\"icon-eye\" ng-click=\"previewFile(file)\" class=\"s25\"></md-icon></span></div></div>\n</div></md-tab-body></md-tab></md-tabs></div></md-content></div></ms-widget-front></ms-widget></div>");
$templateCache.put("app/main/administration/document-type/addSiteDialog.html","<md-dialog flex=\"50\"><form name=\"siteMembersCtrl.memberForm\" role=\"form\" novalidate ng-submit=\" \"><md-toolbar \nlayout=\"row\" class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2>Add {{sitedisplayname}}</h2><span flex></span>\n<md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content layout=\"column\" layout-align=\"center center\"><div layout=\"row\" class=\"md-padding\">\n<md-input-container class=\"md-block\" flex=\"50\"><input type=\"text\" name=\"name\" ng-model=\"queryname\" placeholder=\"Name\">\n</md-input-container><span flex=\"5\"></span><div class=\"md-padding\"><md-button type=\"button\" class=\"md-raised\" \nng-click=\"searchSite(queryname)\"><md-icon md-font-icon=\"icon-magnify\"></md-icon>Search {{sitedisplayname}}</md-button>\n</div></div><div ng-show=\"tableVisibility\" class=\"md-padding scrollable\" ms-scroll><table><thead><tr><th \nclass=\"secondary-text md-padding\"><div class=\"table-header\"><span class=\"column-title\">{{sitedisplayname}} Name</span>\n</div></th><th class=\"secondary-text md-padding\"><div class=\"table-header\"><span class=\"column-title\">\n{{sitedisplayname}} Id</span></div></th></tr></thead><tbody><tr ng-repeat=\"site in searchedSites\"><td \nclass=\"md-padding\">{{site.name}}</td><td class=\"md-padding\">{{site.id}}</td><td layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-accent md-raised\" ng-click=\"addSite(site,documentType) \">ADD\n</md-button></td></tr></tbody></table></div></md-dialog-content></form><md-dialog-actions layout=\"row\"><span flex>\n</span><md-button ng-click=\"cancel()\">Cancel</md-button><md-button ng-click=\"ok()\" md-autofocus>Ok</md-button>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/administration/document-type/attributes.documenttype.html","<md-dialog aria-label=\"Add new Attributes\" flex=\"75\"><form name=\"DoctypeForm\" novalidate \nng-submit=\"DoctypeForm.$valid && save()\" layout=\"column\" flex=\"66\"><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools\"><h2>Attributes of DocumentType:{{currentDocType.name}}</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content class=\"scrollable\" ms-scroll><div><div layout=\"row\" \nlayout-align=\"space-around center\"><div class=\"table-header\"><span class=\"column-title\">NAME</span></div><div \nclass=\"table-header\"><span class=\"column-title\">TYPE</span></div><div class=\"table-header\"><span class=\"column-title\">\nREQUIRED</span></div><div class=\"table-header\"><span class=\"column-title\"></span></div></div><md-content><div \nng-repeat=\"element in attributes\" layout=\"row\" layout-align=\"center center\"><md-input-container class=\"md-block\" \nflex=\"20\"><input type=\"text\" name=\"name\" ng-model=\"element.name\" ng-required=\"true\"><div \nng-messages=\"DoctypeForm.name.$error\" role=\"alert\"><div ng-message=\"required\">Enter attribute name</div></div>\n</md-input-container><span flex=\"5\"></span><md-input-container class=\"md-block\" flex=\"20\"><md-select \nng-model=\"element.type\"><md-option ng-repeat=\"type in attributeTypes\" value=\"{{type}}\">{{type}}</md-option></md-select>\n</md-input-container><span flex=\"15\"></span><md-input-container class=\"md-block\" flex=\"10\"><md-switch \nng-model=\"element.required\" aria-label=\"Switch\"></md-switch></md-input-container><span flex=\"5\"></span><md-button \nclass=\"md-icon-button md-accent\" ng-click=\"removeAttribute($index)\"><md-tooltip md-direction=\"top\">Delete</md-tooltip>\n<md-icon md-font-icon=\"icon-delete\"></md-icon></md-button></div></md-content></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" layout-align=\"center center\"><md-button ng-click=\"cancel()\">Cancel</md-button>\n<md-button type=\"submit\">Update</md-button></md-dialog-actions><md-button flow-btn \nclass=\"md-fab md-accent md-fab-bottom-right\" aria-label=\"Create User\" ng-click=\"addNewAttribute()\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon><md-tooltip md-direction=\"top\">New Attribute</md-tooltip></md-button></form>\n</md-dialog>");
$templateCache.put("app/main/administration/document-type/configureapproval.html","<md-dialog flex=\"45\"><form name=\"ApprovalForm\" novalidate \nng-submit=\"ApprovalForm.$valid && submitApprovalConfig(configureApproval, currentDocType)\" layout=\"column\"><md-toolbar \nclass=\"md-accent\"><div class=\"md-toolbar-tools\"><h2>Configure Approval</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content class=\"scrollable\" ms-scroll><div layout=\"row\" \nlayout-align=\"start Start\" class=\"md-padding\"><div><span class=\"h3\"><b>Approval Required </b></span></div><span \nflex=\"5\"></span><md-checkbox ng-model=\"configureApproval.docuemntApprovalConfig.approvalsRequired.Upload\" \naria-label=\"Upload\" ng-true-value=\"\'Upload\'\" ng-false-value=\"\'\'\">Upload</md-checkbox><span flex=\"5\"></span><md-checkbox\n ng-model=\"configureApproval.docuemntApprovalConfig.approvalsRequired.Share\" aria-label=\"Share\" \nng-true-value=\"\'Share\'\" ng-false-value=\"\'\'\">Share</md-checkbox><span flex=\"5\"></span><md-checkbox \nng-model=\"configureApproval.docuemntApprovalConfig.approvalsRequired.Delete\" aria-label=\"Delete\" \nng-true-value=\"\'Delete\'\" ng-false-value=\"\'\'\">Delete</md-checkbox><span flex=\"5\"></span><md-checkbox \nng-model=\"configureApproval.docuemntApprovalConfig.approvalsRequired.Edit\" aria-label=\"Edit\" ng-true-value=\"\'Edit\'\" \nng-false-value=\"\'\'\">Edit</md-checkbox></div><md-divider></md-divider><div layout=\"row\" layout-align=\"start Start\" \nclass=\"md-padding\"><div><span class=\"h3\"><b style=\"padding-top:15px !important\">Approvers:</b></span></div><span \nflex=\"5\"></span><div class=\"scrollable md-padding\" ms-scroll><div layout=\"row\" class=\"md-padding pl-0\"><md-radio-group \nng-model=\"searchElements.type\" style=\"display: -webkit-inline-box\"><md-radio-button class=\"pr-15\" value=\"user\" \nng-disabled=\"!configureApproval.docuemntApprovalConfig.approvalsRequired.Upload  && !configureApproval.docuemntApprovalConfig.approvalsRequired.Share && !configureApproval.docuemntApprovalConfig.approvalsRequired.Delete && !configureApproval.docuemntApprovalConfig.approvalsRequired.Edit \">\nUsers</md-radio-button><md-radio-button value=\"group\" \nng-disabled=\"!configureApproval.docuemntApprovalConfig.approvalsRequired.Upload  && !configureApproval.docuemntApprovalConfig.approvalsRequired.Share && !configureApproval.docuemntApprovalConfig.approvalsRequired.Delete && !configureApproval.docuemntApprovalConfig.approvalsRequired.Edit\">\nUsers Group</md-radio-button></md-radio-group></div><div layout=\"row\"><md-input-container class=\"no-padding no-margin\" \nflex=\"45\"><input type=\"text\" name=\"name\" ng-model=\"searchElements.text\" \nng-disabled=\"!configureApproval.docuemntApprovalConfig.approvalsRequired.Upload  && !configureApproval.docuemntApprovalConfig.approvalsRequired.Share && !configureApproval.docuemntApprovalConfig.approvalsRequired.Delete && !configureApproval.docuemntApprovalConfig.approvalsRequired.Edit\" \nplaceholder=\"Search here\" required></md-input-container><md-button class=\"md-raised\" \nng-disabled=\"searchElements.text == undefined\" ng-click=\"searchUsers(searchElements)\" style=\"height: 35px;top: -11px\">\nSearch</md-button></div></div></div><div class=\"scrollable md-padding pt-0\" ms-scroll layout=\"column\" \nlayout-align=\"center center\"><table class=\"simple\" ng-show=\"searchedUsers.data.length > 0\"><thead><tr><th \nclass=\"secondary-text md-padding\"><span class=\"column-title\">NAME</span></th><th class=\"secondary-text md-padding\">\n<span class=\"column-title\">TYPE</span></th></tr></thead><tbody><tr \ndata-ng-repeat=\"(key,value) in searchedUsers.data track by $index\"><td class=\"no-padding\" \ndata-ng-if=\"searchedUsers.type == \'user\'\" style=\"padding-left: 10px !important;padding-right: 10px !important\">\n{{value.firstName}} {{value.lastName}}</td><td class=\"no-padding\" data-ng-if=\"searchedUsers.type == \'user\'\" \nstyle=\"padding-left: 10px !important;padding-right: 10px !important\">{{searchedUsers.type}}</td><td class=\"no-padding\" \ndata-ng-if=\"searchedUsers.type == \'group\'\" style=\"padding-left: 10px !important;padding-right: 10px !important\">\n{{value.name}}</td><td class=\"no-padding\" data-ng-if=\"searchedUsers.type == \'group\'\" \nstyle=\"padding-left: 10px !important;padding-right: 10px !important\">{{searchedUsers.type}}</td><td class=\"no-padding\">\n<md-button class=\"md-accent md-raised md-mini\" ng-click=\"addApprover(value,searchedUsers.type) \">ADD</md-button></td>\n</tr></tbody></table></div><div layout=\"column\"><div flex=\"20\" class=\"md-padding\"><div><md-toolbar><div \nclass=\"md-toolbar-tools\"><span>Approvers</span></div></md-toolbar><md-content flex \nng-style=\"{\'border\': \'1px solid #cccccc\'}\" class=\"scrollable\" ms-scroll><div ng-switch=\"(allApprovers).length\"><div \nng-switch-when=\"0\" layout=\"row\" layout-align=\"center center\"><p class=\"md-padding md-subhead md-primary-fg\">\n{{\'No Approver yet...\' | uppercase}}</p></div><div ng-switch-default ng-style=\"{\'height\':\'190px\'}\"><table \nclass=\"simple list-view\"><tbody><tr ng-repeat=\"approver in allApprovers\"><td data-ng-if=\"approver.type != \'user\'\"><i \nclass=\"fa fa-users\" aria-hidden=\"true\"></i> {{approver.objectId}}</td><td data-ng-if=\"approver.type == \'user\'\"><i \nclass=\"fa fa-user\" aria-hidden=\"true\"></i>{{approver.objectId}}</td><td class=\"no-padding\"><md-button \nclass=\"md-secondary md-icon-button\" ng-click=\"removeApprover(index)\"><md-tooltip md-direction=\"top\">Delete</md-tooltip>\n<md-icon><i class=\"icon icon-delete s30\"></i></md-icon></md-button></td></tr></tbody></table></div></div></md-content>\n</div></div></div><md-divider></md-divider><div layout=\"row\" layout-align=\"start Start\" class=\"md-padding\"><div><span \nclass=\"h3\"><b>If Request Approved </b></span></div><span flex=\"10\"></span><div layout=\"column\"><md-checkbox \nng-model=\"configureApproval.docuemntApprovalConfig.requestApproved_notifyRequester\" \naria-label=\"Send Email to Requesters\">Send Email to Requester</md-checkbox><md-checkbox \nng-model=\"configureApproval.docuemntApprovalConfig.requestApproved_notifyApprover\" aria-label=\"Send Email to Appovers\">\nSend Email to Approver</md-checkbox></div></div><md-divider></md-divider><div layout=\"row\" layout-align=\"start Start\" \nclass=\"md-padding\"><div><span class=\"h3\"><b>If Request is Denied </b></span></div><span flex=\"10\"></span><div \nlayout=\"column\"><md-checkbox ng-model=\"configureApproval.docuemntApprovalConfig.requestDenied_notifyRequester\" \naria-label=\"Send Email to Requesters\">Send Email to Requester</md-checkbox><md-checkbox \nng-model=\"configureApproval.docuemntApprovalConfig.requestDenied_notifyApprover\" aria-label=\"Send Email to Appovers\">\nSend Email to Approver</md-checkbox></div></div><md-divider></md-divider><div layout=\"row\"><div flex=\"35\" \nlayout=\"column\" layout-align=\"center end\"><span class=\"h3\"><b>End In </b></span></div><span flex=\"5\"></span>\n<md-input-container class=\"md-block\" flex=\"25\" layout=\"column\" layout-align=\"space-around start\" \nstyle=\"padding-top: 0px !important;padding-bottom: 0px !important\"><md-select \nng-model=\"configureApproval.docuemntApprovalConfig.approverRespondDuration\"><md-option \nng-repeat=\"duration in durations\" ng-value=\"duration.value\">{{duration.days}}</md-option></md-select>\n</md-input-container></div><div layout=\"row\" layout-align=\"start Start\" class=\"md-padding\"><div><span class=\"h3\"><b>\nIf Request is Expired </b></span></div><span flex=\"10\"></span><div layout=\"column\"><md-checkbox \nng-model=\"configureApproval.docuemntApprovalConfig.requestExpires__notifyRequester\" \naria-label=\"Send Email to Requesters\">Send Email to Requester</md-checkbox><md-checkbox \nng-model=\"configureApproval.docuemntApprovalConfig.requestExpires_notifyApprover\" aria-label=\"Send Email to Appovers\">\nSend Email to Approver</md-checkbox></div></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex></span>\n<md-button ng-click=\"cancel()\">Cancel</md-button><md-button \nng-click=\"submitApprovalConfig(configureApproval, currentDocType)\">Save</md-button></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/administration/document-type/createdoctype.dialog.html","<md-dialog aria-label=\"Add Document Type\" flex=\"60\"><form name=\"documentForm\" novalidate \nng-submit=\"documentForm.$valid && doctypeCrtl.createDocumentType()\" layout=\"column\" flex><md-toolbar class=\"md-accent\">\n<div class=\"md-toolbar-tools\"><h2>Create Document Type</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"cancel()\"><md-icon md-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"row\"><div flex=\"45\">\n<md-input-container class=\"md-block\"><label>Name</label><input type=\"text\" name=\"name\" ng-pattern=\"/^[a-zA-Z ]*$/\" \nng-model=\"documentType.name\" required><div ng-messages=\"documentForm.name.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Name is required</span></div><div ng-message=\"pattern\"><span>Name has invalid characters\n</span></div></div></md-input-container></div><span flex=\"10\"></span><div flex=\"45\"><md-input-container \nclass=\"md-block\"><input type=\"text\" name=\"description\" ng-pattern=\"/^[a-zA-Z ]*$/\" ng-model=\"documentType.description\" \nplaceholder=\"Desription\"><div ng-messages=\"documentForm.description.$error\" role=\"alert\"><div ng-message=\"pattern\">\n<span>Description has invalid characters</span></div></div></md-input-container></div></div><div layout=\"row\" \nlayout-align=\"center center\"><div flex=\"45\"><md-input-container class=\"md-block\"><label>Display Form</label><md-select \nng-model=\"documentType.formId\"><md-option ng-value=\"form.id\" ng-repeat=\"form in forms\">{{form.name}}</md-option>\n</md-select></md-input-container></div><div flex=\"10\"></div><div flex=\"45\">Approval Required:<md-checkbox \nng-model=\"documentType.approvalRequired\" aria-label=\"Checkbox 1\"></md-checkbox></div></div><md-dialog-content \nclass=\"scrollable\" ms-scroll><div class=\"md-body-2\" ng-style=\"{color:\'red\'}\" ng-hide=\"attributes.length != 0\" \nlayout=\"row\" layout-align=\"center center\">{{Error.message}}</div><div style=\"margin-top: -5% !important\"><h2 \nng-hide=\"attributes.length == 0\">Attributes of DocumentType</h2><div layout=\"row\" layout-align=\"space-around center\" \nng-hide=\"attributes.length == 0\"><div class=\"table-header\"><span class=\"column-title\">NAME</span></div><div \nclass=\"table-header\"><span class=\"column-title\">TYPE</span></div><div class=\"table-header\" \nstyle=\"margin-right: -12% !important\"><span class=\"column-title\">REQUIRED</span></div><div class=\"table-header\"><span \nclass=\"column-title\"></span></div></div><md-content class=\"scrollable\" ms-scroll><div \nng-repeat=\"element in attributes\" layout=\"row\" layout-align=\"center center\" style=\"margin-bottom: -5%\">\n<md-input-container class=\"md-block\" flex=\"20\"><input type=\"text\" name=\"name\" ng-model=\"element.name\" required><div \nng-messages=\"documentForm.name.$error\" role=\"alert\"><div ng-message=\"required\">Enter attribute name</div></div>\n</md-input-container><span flex=\"5\"></span><md-input-container class=\"md-block\" flex=\"20\" \nstyle=\"margin-top: -1% !important\"><md-select ng-model=\"element.type\"><md-option ng-repeat=\"type in attributeTypes\" \nvalue=\"{{type}}\">{{type}}</md-option></md-select></md-input-container><span flex=\"15\"></span><md-input-container \nclass=\"md-block\" flex=\"10\"><md-switch ng-model=\"element.required\" aria-label=\"Switch\"></md-switch></md-input-container>\n<span flex=\"5\"></span><md-button class=\"md-icon-button md-accent\" ng-click=\"removeAttribute($index)\"><md-tooltip \nmd-direction=\"top\">Delete</md-tooltip><md-icon md-font-icon=\"icon-delete\"></md-icon></md-button></div></md-content>\n</div><md-button flow-btn class=\"md-fab md-accent md-mini md-fab-bottom-right\" aria-label=\"Create User\" \nng-click=\"addNewAttribute()\"><md-icon md-font-icon=\"icon-plus\"></md-icon><md-tooltip md-direction=\"top\">New Attribute\n</md-tooltip></md-button></md-dialog-content></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"center center\"><md-button type=\"button\" ng-click=\"cancel()\">Cancel</md-button><md-button type=\"submit\" \nng-click=\"documentForm.$valid && save(documentType)\">Save</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/administration/document-type/documenttype.html","<div class=\"page-layout simple right-sidenav\" layout-gt-xs=\"row\"><div \nng-include=\"\'app/main/administration/common/admin.html\'\"></div><div \nclass=\"page-layout carded fullwidth md-padding scrollable\" layout=\"column\" flex ms-scroll><div class=\"widget-group\" \nflex=\"100\" layout=\"column\" layout-wrap><ms-widget flippable=\"true\" class=\"no-padding\"><div \nclass=\"parent-tabs white-bg mb-15\"><md-tabs class=\"mh-0\"><md-tab label=\"Document Type\" md-active=\"true\"></md-tab>\n</md-tabs></div><div class=\"md-padding white-bg\"><table class=\"dataTable row-border hover table-border\" datatable=\"ng\" \ndt-options=\"doctypeCrtl.dtOptions\"><thead><tr class=\"table-header\"><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Name</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Description</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\" layout=\"row\" layout-align=\"center center\"><span class=\"column-title\">Actions</span></div></th><th>\n</th></tr></thead><tbody><tr ng-repeat=\"documentType in documentsList \"><td>{{documentType.name}}</td><td>\n{{documentType.description}}</td><td layout=\"row\" layout-align=\"center center\" \nstyle=\"padding-top:0px !important;padding-bottom:0px !important\"><md-button class=\"md-icon-button test-tooltip\" \nid=\"{{documentType.id}}\" aria-label=\"Update\" onclick=\"angular.element(this).scope().updateDocumentTypeDialog(this)\">\n<md-tooltip md-direction=\"top\">Update</md-tooltip><md-icon><i layout=\"row\" layout-align=\"center center\" \nclass=\"icon icon-pencil s18\"></i></md-icon></md-button><md-button class=\"md-icon-button test-tooltip\" \nid=\"{{documentType.id}}\" aria-label=\"Delete\" onclick=\"angular.element(this).scope().deleteDocumentType(this)\">\n<md-tooltip md-direction=\"top\">Delete</md-tooltip><md-icon><i layout=\"row\" layout-align=\"center center\" \nclass=\"icon icon-delete s18\"></i></md-icon></md-button><md-button class=\"md-icon-button test-tooltip\" \naria-label=\"siteupdate\" id=\"{{documentType.id}}\" onclick=\"angular.element(this).scope().goTositeConfig(this)\">\n<md-tooltip md-direction=\"top\">Site Configuration</md-tooltip><md-icon><i layout=\"row\" layout-align=\"center center\" \nclass=\"icon icon-web s20\"></i></md-icon></md-button><md-button class=\"md-icon-button test-tooltip\" aria-label=\"Update\" \nid=\"{{documentType.id}}\" onclick=\"angular.element(this).scope().configureApprovalDialog(this)\"><md-tooltip \nmd-direction=\"top\">Configure Approval</md-tooltip><md-icon \nng-hide=\"documentType.approvalRequired == true && documentType.docuemntApprovalConfig == null || documentType.docuemntApprovalConfig.agents.length == 0\">\n<i layout=\"row\" layout-align=\"center center\" class=\"icon icon-check-circle s20\" style=\"color:green\"></i></md-icon>\n<md-icon \nng-if=\"documentType.approvalRequired == true && documentType.docuemntApprovalConfig == null || documentType.docuemntApprovalConfig.agents.length == 0  \">\n<i layout=\"row\" layout-align=\"center center\" class=\"icon icon-check-circle s20\" style=\"color:red\"></i></md-icon>\n</md-button></td><td><div \nng-if=\"documentType.docuemntApprovalConfig == null && documentType.approvalRequired == true || documentType.docuemntApprovalConfig.agents.length == 0\" \nstyle=\"color:red\">Please Create Approval Config</div></td></tr></tbody></table></div></ms-widget></div><md-button \nflow-btn class=\"md-fab grey-700-bg md-mini md-fab-bottom-right add_btn\" ng-click=\"createDocumentTypeDialog($event)\">\n<md-icon md-font-icon=\"icon-plus\"></md-icon><md-tooltip md-direction=\"top\">Create DocType</md-tooltip></md-button>\n</div></div>");
$templateCache.put("app/main/administration/document-type/siteConfigureDialog.html","<div class=\"page-layout simple right-sidenav\" layout=\"row\" ng-init=\"doctypeCrtl.getDocumentTypeSites()\"><div \nng-include=\"\'app/main/administration/common/admin.html\'\"></div><div \nclass=\"page-layout carded fullwidth md-padding scrollable\" layout=\"column\" flex ms-scroll><div class=\"widget-group\" \nflex=\"100\" layout=\"column\" layout-wrap><ms-widget flippable=\"true\" class=\"no-padding\"><div class=\"md-padding white-bg\">\n<md-button ng-click=\"doctypeCrtl.goTomain()\"><md-icon md-font-icon=\"icon-keyboard-return\"></md-icon>Back</md-button>\n<md-toolbar layout=\"column\" class=\"md-accent\" flex=\"50\" layout-align=\"center center\"><div class=\"md-toolbar-tools\">\n<span>{{sitedisplayname}}Configuration {{doctypeCrtl.docTypeName}}</span></div><div><md-button flow-btn \nclass=\"md-fab grey-700-bg md-mini md-fab-top-right\" ng-click=\"addSiteDialog($event)\"><md-icon md-font-icon=\"icon-plus\">\n</md-icon><md-tooltip md-direction=\"top\">Add {{sitedisplayname}}</md-tooltip></md-button></div></md-toolbar><md-content\n flex=\"50\" ng-style=\"{\'border\': \'1px solid #cccccc\'}\" class=\"scrollable\" ms-scroll><div \nng-switch=\"doctypeCrtl.sites.length\"><div ng-switch-when=\"0\" layout=\"row\" layout-align=\"center center\"><p \nclass=\"md-padding md-subhead md-primary-fg\">NO {{sitedisplayname | uppercase}} YET</p></div><div ng-switch-default \nng-style=\"{\'height\':\'280px\'}\"><md-list><md-list-item class=\"md-2-line\" ng-repeat=\"site in doctypeCrtl.sites\" \nng-click=\"null\"><div class=\"md-list-item-text\" layout=\"column\"><h3>{{ site.name }}</h3><p>{{ site.description }}</p>\n<md-button class=\"md-secondary md-icon-button\" ng-click=\"doctypeCrtl.deleteSite($event,site)\"><md-tooltip \nmd-direction=\"top\">Delete</md-tooltip><md-icon><i class=\"icon icon-delete s30\"></i></md-icon></md-button></div>\n<md-divider></md-divider></md-list-item></md-list></div></div></md-content></div></ms-widget></div></div></div>");
$templateCache.put("app/main/administration/document-type/updatedoctype.dialog.html","<md-dialog aria-label=\"Update Document Type\" flex=\"60\"><form name=\"documentUpdateForm\" novalidate \nng-submit=\"documentUpdateForm.$valid && update(currentDocType)\" layout=\"column\"><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools\"><h2>Update Document Type</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"cancel()\"><md-icon md-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"row\"><div flex=\"45\">\n<md-input-container class=\"md-block\"><label>Name</label><input type=\"text\" name=\"name\" ng-pattern=\"/^[a-zA-Z ]*$/\" \nng-model=\"currentDocType.name\" required><div ng-messages=\"documentForm.name.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Name is required</span></div><div ng-message=\"pattern\"><span>Name has invalid characters\n</span></div></div></md-input-container></div><span flex=\"10\"></span><div flex=\"45\"><md-input-container \nclass=\"md-block\"><input type=\"text\" name=\"description\" ng-pattern=\"/^[a-zA-Z ]*$/\" \nng-model=\"currentDocType.description\" placeholder=\"Desription\"><div ng-messages=\"documentForm.description.$error\" \nrole=\"alert\"><div ng-message=\"pattern\"><span>Description has invalid characters</span></div></div></md-input-container>\n</div></div><div layout=\"row\" layout-align=\"center center\"><div flex-gt-sm=\"40\">Approval Required:<md-checkbox \nng-model=\"currentDocType.approvalRequired\" aria-label=\"Checkbox 1\"></md-checkbox></div><div flex-gt-sm=\"40\">\n<md-input-container class=\"md-block\"><label>Display Form</label><md-select ng-model=\"currentDocType.formId\"><md-option \nng-value=\"form.id\" ng-repeat=\"form in forms\">{{form.name}}</md-option></md-select></md-input-container></div></div>\n<md-dialog-content class=\"scrollable\" ms-scroll><div><h2>Attributes of DocumentType:{{currentDocType.name}}</h2><table \nclass=\"simple table-border\" ms-responsive-table><thead><tr class=\"table-header\"><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">NAME</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">TYPE</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">REQUIRED</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\" layout=\"row\" layout-align=\"center center\"><span class=\"column-title\">Actions</span></div></th>\n</tr></thead><tbody><tr ng-repeat=\"element in attributes\"><td><md-input-container class=\"md-block\" flex=\"20\"><input \ntype=\"text\" name=\"name\" ng-model=\"element.name\" ng-required=\"true\"><div ng-messages=\"DoctypeForm.name.$error\" \nrole=\"alert\"><div ng-message=\"required\">Enter attribute name</div></div></md-input-container></td><td>\n<md-input-container class=\"md-block\" flex=\"20\" style=\"margin-top: -1% !important\"><md-select ng-model=\"element.type\">\n<md-option ng-repeat=\"type in attributeTypes\" value=\"{{type}}\">{{type}}</md-option></md-select></md-input-container>\n</td><td><md-input-container class=\"md-block\" flex=\"10\"><md-switch ng-model=\"element.required\" aria-label=\"Switch\">\n</md-switch></md-input-container></td><td><md-input-container class=\"md-block\" flex=\"10\"><md-button \nclass=\"md-icon-button md-accent\" ng-click=\"removeAttribute($index)\"><md-tooltip md-direction=\"top\">Delete</md-tooltip>\n<md-icon md-font-icon=\"icon-delete\"></md-icon></md-button></md-input-container></td></tr></tbody></table></div>\n<md-button flow-btn class=\"md-fab md-mini md-accent md-fab-bottom-right\" aria-label=\"Create User\" \nng-click=\"addNewAttribute()\"><md-icon md-font-icon=\"icon-plus\"></md-icon><md-tooltip md-direction=\"top\">New Attribute\n</md-tooltip></md-button></md-dialog-content></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"center center\"><md-button ng-click=\"cancel()\">Cancel</md-button><md-button type=\"submit\">Update\n</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/administration/forms-management/createForm.html","<style>\nbody {\n   padding: 0;\n   margin: 10px 0;\n   background: #f2f2f2 url(\'http://formbuilder.readthedocs.io/en/latest/img/noise.png\');\n   }\n  \n   label{\n		line-height: 5px;\n		font-weight: bold;\n	}\n	input{\n		border-radius: 2px !important;\n		padding: 10px !important;\n	}\n	li span{\n		font-size:14px !important;\n		font-family:Arial !important;\n	}\n</style><div class=\"page-layout simple right-sidenav\" layout-gt-xs=\"row\"><div \nng-include=\"\'app/main/administration/common/admin.html\'\"></div><div class=\"widget-group scrollable\" flex=\"100\" \nlayout=\"column\" layout-wrap ms-scroll><ms-widget><div class=\"parent-tabs white-bg mb-15\"><md-tabs class=\"mh-0\"><md-tab \nlabel=\"Forms\" ui-sref=\"app.administration.forms\"></md-tab><md-tab label=\"Create Forms\" \nui-sref=\"app.administration.createform\" md-active=\"true\"></md-tab></md-tabs></div><div class=\"md-padding\" \nng-show=\"createFormDiv\" id=\"createFormDiv\"><div id=\"build-wrap\"></div><div layout=\"row\" layout-align=\"end center\" \nclass=\"md-padding\"><button id=\"preview\" type=\"button\" \nstyle=\"background-color: #aeb6b3;padding: 0.75%;border-radius: 5px;width: 10%\">Preview</button> <span \nstyle=\"width:15px !important\"></span> <button id=\"getJSONAndSave\" type=\"button\" \nstyle=\"background-color: #aeb6b3;padding: 0.75%;border-radius: 5px;width: 10%\">Save</button> <span \nstyle=\"width:15px !important\"></span> <button id=\"clear-all-fields\" type=\"button\" \nstyle=\"background-color: #ff7e71;padding: 0.75%;border-radius: 5px;width: 10%\">Clear Fields</button></div><div \nclass=\"addFieldWrap\"></div></div><div id=\"previewForm\" class=\"md-padding\"><div layout=\"row\" \nstyle=\"background-color: #e5e5e5\" class=\"md-padding\"><div class=\"fb-render\" style=\"width: 95%;margin-top:1%\"><div \nid=\"fb-template\"></div></div></div><div layout=\"row\" layout-align=\"end center\" class=\"md-padding\"><button id=\"edit\" \ntype=\"button\" style=\"background-color: #aeb6b3;padding: 0.75%;border-radius: 5px;width: 10%\">Back to Edit</button>\n</div></div><div layout=\"row\" layout-align=\"end center\" flex=\"100\" id=\"submitDiv\"><div flex=\"70\" layout=\"row\"><div \nflex=\"25\" layout=\"row\"><h3 flex=\"45\">Name</h3><span flex=\"10\"></span><md-input-container class=\"md-block\" flex=\"45\" \nstyle=\"margin:0px\"><input type=\"text\" name=\"name\" ng-model=\"form.name\" required></md-input-container></div><span \nflex=\"5\"></span><div flex=\"25\" layout=\"row\"><h3 flex=\"45\">Description</h3><span flex=\"10\"></span><md-input-container \nclass=\"md-block\" flex=\"45\" style=\"margin:0px\"><input type=\"text\" name=\"description\" ng-model=\"form.description\" \nrequired></md-input-container></div><span flex=\"5\"></span><div><md-button class=\"md-accent\" \nng-click=\"submitJsonForm(form)\">Submit</md-button></div></div></div></ms-widget></div></div>");
$templateCache.put("app/main/administration/forms-management/form.content.html","<div class=\"page-layout simple right-sidenav\" layout-gt-xs=\"row\">><div \nng-include=\"\'app/main/administration/common/admin.html\'\"></div><div class=\"page-layout carded fullwidth scrollable\" \nlayout=\"column\" flex ms-scroll md-dynamic-height><div class=\"widget-group\" flex=\"100\" layout=\"column\" layout-wrap>\n<ms-widget ng-init=\"isHeaderView = true;\"><div class=\"parent-tabs white-bg mb-15\"><md-tabs class=\"mh-0\"><md-tab \nlabel=\"Forms\" md-active=\"true\"></md-tab></md-tabs></div><div class=\"child-tabs white-bg\"><md-tabs class=\"mh-0\"><md-tab \nlabel=\"Header\" md-active=\"isHeaderView\" md-on-select=\"isHeaderView = true;\"></md-tab><md-tab label=\"Line Items\" \nmd-active=\"!isHeaderView\" md-on-select=\"isHeaderView = false;\"></md-tab></md-tabs></div><md-divider></md-divider><div \nclass=\"white-bg md-padding\" layout=\"row\"><div flex=\"100\"><div class=\"md-padding pt-0 pl-0\" layout=\"row\"><span \nclass=\"md-active c-p\" ui-sref=\"app.administration.forms\" style=\"display: inherit\"><md-icon \nmd-font-icon=\"icon-arrow-left md-active s16\"></md-icon>Go back</span></div><div layout=\"row\" \nlayout-align=\"center center\" data-ng-show=\"isHeaderView\"><div flex=\"50\" style=\"border: 1px solid #cccccc\"><form \nname=\"headerForm\" novalidate><div ng-bind-html=\"currentFormHeader\" compile-template></div></form></div></div><div \nlayout=\"row\" layout-align=\"center center\" data-ng-show=\"!isHeaderView\"><div flex=\"100\"><form name=\"lineitemForm\" \nnovalidate style=\"overflow-y: hidden; overflow-x: scroll\"><fieldset style=\"border: 1px solid #cccccc\"><div \nng-bind-html=\"currentFormLineitem\" compile-template></div></fieldset></form></div></div></div></div></ms-widget></div>\n</div></div>");
$templateCache.put("app/main/administration/forms-management/formCreation.html","<md-dialog flex=\"70\"><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2>Create Form</h2><span flex></span>\n<md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><form name=\"requestform\" novalidate layout=\"column\"><md-dialog-content \nclass=\"scrollable\" ms-scroll><div layout=\"row\" layout-align=\"start start\" class=\"md-padding\"><div flex=\"30\" \nlayout=\"column\" layout-align=\"center end\"><span class=\"h3\"><b>Name</b></span></div><span flex=\"10\"></span>\n<md-input-container flex=\"45\" class=\"md-block\" layout=\"column\" layout-align=\"space-around start\" \nstyle=\"margin-top:-2% !important\"><input type=\"text\" name=\"name\" ng-model=\"request.name\" placeholder=\"Name\" required>\n</md-input-container><div flex=\"30\" layout=\"column\" layout-align=\"center end\"><span class=\"h3\"><b>Description</b>\n</span></div><span flex=\"10\"></span><md-input-container flex=\"45\" class=\"md-block\" layout=\"column\" \nlayout-align=\"space-around start\" style=\"margin-top:-2% !important\"><input type=\"text\" name=\"description\" \nng-model=\"request.description\" placeholder=\"Description\" required></md-input-container></div><div layout=\"row\" \nlayout-align=\"start start\" class=\"md-padding\"><div flex=\"30\" layout=\"column\" layout-align=\"center end\"><span \nclass=\"h3\"><b>Main File</b></span></div><span flex=\"10\"></span><div flex=\"40\" layout=\"column\" \nlayout-align=\"center start\" style=\"margin-top:-2% !important\"><input class=\"ng-hide\" id=\"headerFileUpload\" \nname=\"headerFileUpload\" type=\"file\" onchange=\"angular.element(this).scope().setHeaderFile(this)\"><label \nfor=\"headerFileUpload\" class=\"md-button md-raised md-accent\">Upload</label></div><div \nng-repeat=\"file in headerfiles.slice(0)\" layout=\"row\" layout-align=\"start start\"><span class=\"md-warn\">\n{{file.webkitRelativePath || file.name}}</span> (<span ng-switch=\"file.size > 1024*1024\"> <span ng-switch-when=\"true\">\n{{file.size / 1024 / 1024 | number:2}} MB</span> <span ng-switch-default>{{file.size / 1024 | number:2}} kB</span> \n</span>)</div><div flex=\"30\" layout=\"column\" layout-align=\"center end\"><span class=\"h3\"><b>Details File</b></span>\n</div><span flex=\"10\"></span><div flex=\"40\" layout=\"column\" layout-align=\"center start\" \nstyle=\"margin-top:-2% !important\"><input class=\"ng-hide\" id=\"LineItemFileUpload\" name=\"LineItemFileUpload\" type=\"file\" \nonchange=\"angular.element(this).scope().setLineItemFile(this)\"><label for=\"LineItemFileUpload\" \nclass=\"md-button md-raised md-accent\">Upload</label></div><div><div ng-repeat=\"file in lineitemfiles.slice(0)\" \nlayout=\"row\" layout-align=\"start start\"><span class=\"md-warn\">{{file.webkitRelativePath || file.name}}</span> (<span \nng-switch=\"file.size > 1024*1024\"> <span ng-switch-when=\"true\">{{file.size / 1024 / 1024 | number:2}} MB</span> <span \nng-switch-default>{{file.size / 1024 | number:2}} kB</span> </span>)</div></div></div><md-dialog-content \nclass=\"scrollable\" ms-scroll><div style=\"margin-top: -5% !important\"><h2 ng-hide=\"attributes.length == 0\">\nForm Attributes</h2><div layout=\"row\" layout-align=\"space-around center\" ng-hide=\"attributes.length == 0\"><div \nclass=\"table-header\" style=\"margin-right: 4% !important\"><span class=\"column-title\">FieldName</span></div><div \nclass=\"table-header\" style=\"margin-right: 6% !important\"><span class=\"column-title\">Label</span></div><div \nclass=\"table-header\" style=\"margin-right: 4% !important\"><span class=\"column-title\">Type</span></div><div \nclass=\"table-header\" style=\"margin-right: 4% !important\"><span class=\"column-title\">Length</span></div><div \nclass=\"table-header\" style=\"margin-right: 2% !important\"><span class=\"column-title\">RequiredField</span></div><div \nclass=\"table-header\" style=\"margin-right: 2% !important\"><span class=\"column-title\">BarcodeEnabled</span></div><div \nclass=\"table-header\" style=\"margin-right: 4% !important\"><span class=\"column-title\">MobileEnabled</span></div><div \nclass=\"table-header\"><span class=\"column-title\"></span></div><div class=\"table-header\"><span class=\"column-title\">\n</span></div></div><md-content class=\"scrollable\" ms-scroll><div ng-repeat=\"element in attributes\" layout=\"row\" \nlayout-align=\"space-around center\" style=\"margin-bottom: -3%\"><md-input-container class=\"md-block\" flex=\"20\"><input \ntype=\"text\" name=\"fieldName\" ng-model=\"element.fieldName\" required><div ng-messages=\"requestform.fieldName.$error\" \nrole=\"alert\"><div ng-message=\"required\">FieldName*</div></div></md-input-container><span flex=\"5\"></span>\n<md-input-container class=\"md-block\" flex=\"20\"><input type=\"text\" name=\"label\" ng-model=\"element.label\" required><div \nng-messages=\"requestform.label.$error\" role=\"alert\"><div ng-message=\"required\">Label*</div></div></md-input-container>\n<span flex=\"5\"></span><md-input-container class=\"md-block\" flex=\"20\" style=\"margin-top:0% !important\"><md-select \nng-model=\"element.type\"><md-option ng-value=\"type\" ng-repeat=\"type in Types\">{{ type }}</md-option></md-select><div \nng-messages=\"requestform.type.$error\" role=\"alert\"><div ng-message=\"required\">Type*</div></div></md-input-container>\n<span flex=\"5\"></span><md-input-container class=\"md-block\" flex=\"20\"><input type=\"number\" name=\"length\" \nng-model=\"element.length\" required><div ng-messages=\"requestform.length.$error\" role=\"alert\"><div \nng-message=\"required\">Length*</div></div></md-input-container><span flex=\"10\"></span><md-input-container \nclass=\"md-block\" flex=\"20\"><md-switch ng-model=\"element.requiredField\" aria-label=\"Switch\"></md-switch>\n</md-input-container><span flex=\"5\"></span> <span flex=\"10\"></span><md-input-container class=\"md-block\" flex=\"20\">\n<md-switch ng-model=\"element.barcodeEnabled\" aria-label=\"Switch\"></md-switch></md-input-container><span flex=\"10\">\n</span><md-input-container class=\"md-block\" flex=\"20\"><md-switch ng-model=\"element.mobileEnabled\" aria-label=\"Switch\">\n</md-switch></md-input-container><md-input-container class=\"md-block\" flex=\"20\"><input type=\"text\" \nname=\"possibleValues\" ng-model=\"element.possibleValues\" ng-show=\"element.type == \'List\'\"></md-input-container>\n<md-button class=\"md-icon-button md-accent\" ng-click=\"removeAttribute($index)\"><md-tooltip md-direction=\"top\">Delete\n</md-tooltip><md-icon md-font-icon=\"icon-delete\"></md-icon></md-button></div></md-content></div></md-dialog-content>\n<md-button flow-btn class=\"md-fab md-accent md-mini md-fab-bottom-right\" aria-label=\"Create Form\" \nng-click=\"addNewAttribute()\" style=\"margin-bottom: 5%\"><md-icon md-font-icon=\"icon-plus\"></md-icon><md-tooltip \nmd-direction=\"top\">Form Attributes</md-tooltip></md-button></md-dialog-content></form><md-dialog-actions layout=\"row\">\n<span flex></span><md-button ng-click=\"cancel()\">Cancel</md-button><md-button ng-click=\"uploadRequestForm(request)\">\nSave</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/administration/forms-management/formUpdate.html","<md-dialog flex=\"70\"><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2>Update Form:{{CurrentForm.name}}\n</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><form name=\"requestform\" novalidate layout=\"column\"><md-dialog-content \nclass=\"scrollable\" ms-scroll><div layout=\"row\" layout-align=\"start start\" class=\"md-padding\"><div flex=\"30\" \nlayout=\"column\" layout-align=\"center end\"><span class=\"h3\"><b>Name</b></span></div><span flex=\"10\"></span>\n<md-input-container flex=\"45\" class=\"md-block\" layout=\"column\" layout-align=\"space-around start\" \nstyle=\"margin-top:-2% !important\"><input type=\"text\" name=\"name\" ng-model=\"CurrentForm.name\" placeholder=\"Name\" \nrequired></md-input-container><div flex=\"30\" layout=\"column\" layout-align=\"center end\"><span class=\"h3\"><b>Description\n</b></span></div><span flex=\"10\"></span><md-input-container flex=\"45\" class=\"md-block\" layout=\"column\" \nlayout-align=\"space-around start\" style=\"margin-top:-2% !important\"><input type=\"text\" name=\"description\" \nng-model=\"CurrentForm.description\" placeholder=\"Description\" required></md-input-container></div><div layout=\"row\" \nlayout-align=\"start start\" class=\"md-padding\"><div flex=\"30\" layout=\"column\" layout-align=\"center end\"><span \nclass=\"h3\"><b>Main File</b></span></div><span flex=\"10\"></span><div flex=\"40\" layout=\"column\" \nlayout-align=\"center start\" style=\"margin-top:-2% !important\"><input class=\"ng-hide\" id=\"headerFileUpload\" \nname=\"headerFileUpload\" type=\"file\" onchange=\"angular.element(this).scope().setHeaderFile(this)\"><label \nfor=\"headerFileUpload\" class=\"md-button md-raised md-accent\">Upload</label></div><div \nng-repeat=\"file in headerfiles.slice(0)\" layout=\"row\" layout-align=\"start start\"><span class=\"md-warn\">\n{{file.webkitRelativePath || file.name}}</span> (<span ng-switch=\"file.size > 1024*1024\"> <span ng-switch-when=\"true\">\n{{file.size / 1024 / 1024 | number:2}} MB</span> <span ng-switch-default>{{file.size / 1024 | number:2}} kB</span> \n</span>)</div><div flex=\"30\" layout=\"column\" layout-align=\"center end\"><span class=\"h3\"><b>Details File</b></span>\n</div><span flex=\"10\"></span><div flex=\"40\" layout=\"column\" layout-align=\"center start\" \nstyle=\"margin-top:-2% !important\"><input class=\"ng-hide\" id=\"LineItemFileUpload\" name=\"LineItemFileUpload\" type=\"file\" \nonchange=\"angular.element(this).scope().setLineItemFile(this)\"><label for=\"LineItemFileUpload\" \nclass=\"md-button md-raised md-accent\">Upload</label></div><div><div ng-repeat=\"file in lineitemfiles.slice(0)\" \nlayout=\"row\" layout-align=\"start start\"><span class=\"md-warn\">{{file.webkitRelativePath || file.name}}</span> (<span \nng-switch=\"file.size > 1024*1024\"> <span ng-switch-when=\"true\">{{file.size / 1024 / 1024 | number:2}} MB</span> <span \nng-switch-default>{{file.size / 1024 | number:2}} kB</span> </span>)</div></div></div><md-dialog-content \nclass=\"scrollable\" ms-scroll><div style=\"margin-top: -5% !important\"><h2 ng-hide=\"attributes.length == 0\">\nForm Attributes</h2><div layout=\"row\" layout-align=\"space-around center\" ng-hide=\"attributes.length == 0\"><div \nclass=\"table-header\" style=\"margin-right: 4% !important\"><span class=\"column-title\">FieldName</span></div><div \nclass=\"table-header\" style=\"margin-right: 6% !important\"><span class=\"column-title\">Label</span></div><div \nclass=\"table-header\" style=\"margin-right: 4% !important\"><span class=\"column-title\">Type</span></div><div \nclass=\"table-header\" style=\"margin-right: 4% !important\"><span class=\"column-title\">Length</span></div><div \nclass=\"table-header\" style=\"margin-right: 2% !important\"><span class=\"column-title\">RequiredField</span></div><div \nclass=\"table-header\" style=\"margin-right: 2% !important\"><span class=\"column-title\">BarcodeEnabled</span></div><div \nclass=\"table-header\" style=\"margin-right: 4% !important\"><span class=\"column-title\">MobileEnabled</span></div><div \nclass=\"table-header\"><span class=\"column-title\"></span></div><div class=\"table-header\"><span class=\"column-title\">\n</span></div></div><md-content class=\"scrollable\" ms-scroll><div ng-repeat=\"element in attributes\" layout=\"row\" \nlayout-align=\"space-around center\" style=\"margin-bottom: -3%\"><md-input-container class=\"md-block\" flex=\"20\"><input \ntype=\"text\" name=\"fieldName\" ng-model=\"element.fieldName\" required><div ng-messages=\"requestform.fieldName.$error\" \nrole=\"alert\"><div ng-message=\"required\">FieldName*</div></div></md-input-container><span flex=\"5\"></span>\n<md-input-container class=\"md-block\" flex=\"20\"><input type=\"text\" name=\"label\" ng-model=\"element.label\" required><div \nng-messages=\"requestform.label.$error\" role=\"alert\"><div ng-message=\"required\">Label*</div></div></md-input-container>\n<span flex=\"5\"></span><md-input-container class=\"md-block\" flex=\"20\" style=\"margin-top:0% !important\"><md-select \nng-model=\"element.type\"><md-option ng-value=\"type\" ng-repeat=\"type in Types\">{{ type }}</md-option></md-select><div \nng-messages=\"requestform.type.$error\" role=\"alert\"><div ng-message=\"required\">Type*</div></div></md-input-container>\n<span flex=\"5\"></span><md-input-container class=\"md-block\" flex=\"20\"><input type=\"number\" name=\"length\" \nng-model=\"element.length\" required><div ng-messages=\"requestform.length.$error\" role=\"alert\"><div \nng-message=\"required\">Length*</div></div></md-input-container><span flex=\"10\"></span><md-input-container \nclass=\"md-block\" flex=\"20\"><md-switch ng-model=\"element.requiredField\" aria-label=\"Switch\"></md-switch>\n</md-input-container><span flex=\"5\"></span> <span flex=\"10\"></span><md-input-container class=\"md-block\" flex=\"20\">\n<md-switch ng-model=\"element.barcodeEnabled\" aria-label=\"Switch\"></md-switch></md-input-container><span flex=\"10\">\n</span><md-input-container class=\"md-block\" flex=\"20\"><md-switch ng-model=\"element.mobileEnabled\" aria-label=\"Switch\">\n</md-switch></md-input-container><md-input-container class=\"md-block\" flex=\"20\"><input type=\"text\" \nname=\"possibleValues\" ng-model=\"element.possibleValues\" ng-show=\"element.type == \'List\'\"></md-input-container>\n<md-button class=\"md-icon-button md-accent\" ng-click=\"removeAttribute($index)\"><md-tooltip md-direction=\"top\">Delete\n</md-tooltip><md-icon md-font-icon=\"icon-delete\"></md-icon></md-button></div></md-content></div></md-dialog-content>\n<md-button flow-btn class=\"md-fab md-accent md-mini md-fab-bottom-right\" aria-label=\"Create Form\" \nng-click=\"addNewAttribute()\" style=\"margin-bottom: 5%\"><md-icon md-font-icon=\"icon-plus\"></md-icon><md-tooltip \nmd-direction=\"top\">Form Attributes</md-tooltip></md-button></md-dialog-content></form><md-dialog-actions layout=\"row\">\n<span flex></span><md-button ng-click=\"cancel()\">Cancel</md-button><md-button \nng-click=\"updateRequestForm(CurrentForm)\">Update</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/administration/forms-management/overviewPage.html","<style>\n.fb-render {\n  		margin: auto;\n  		max-width: 1280px\n	}\n	label{\n		line-height: 5px;\n		font-weight: bold;\n	}\n	input{\n		border-radius: 2px !important;\n		padding: 10px !important;\n	}\n</style><div class=\"page-layout simple right-sidenav\" layout-gt-xs=\"row\"><div \nng-include=\"\'app/main/administration/common/admin.html\'\"></div><div class=\"widget-group scrollable\" flex=\"100\" \nlayout=\"column\" layout-wrap ms-scroll ng-init=\"requestCtrl.getRequestForms()\"><md-button flow-btn \nclass=\"md-fab md-mini grey-700-bg md-fab-bottom-right add_btn\" aria-label=\"Create Request\" \nng-click=\"createRequest($event)\"><md-icon md-font-icon=\"icon-plus\"></md-icon><md-tooltip md-direction=\"top\">\nCreate Request</md-tooltip></md-button><ms-widget><div class=\"parent-tabs white-bg mb-15\"><md-tabs class=\"mh-0\"><md-tab\n label=\"Forms\" ui-sref=\"app.administration.forms\" md-active=\"true\"></md-tab></md-tabs></div><div class=\"white-bg\" \nlayout=\"row\" layout-wrap><div ng-repeat=\"form in forms\" flex=\"100\" flex-gt-xs=\"20\" flex-gt-md=\"20\" class=\"md-padding\">\n<a ng-click=\"selectForm(form)\"><ms-widget flex=\"15\"><ms-widget-front class=\"h-170 p-16 c-p\"><div \nclass=\"md-subhead font-weight-500 black-fg\">{{form.name}}</div><div layout=\"column\" layout-align=\"space-between\" flex>\n<div><div class=\"h6 secondary-text\">{{form.description}}</div></div></div><div layout=\"row\" \nlayout-align=\"space-between center\"><div><md-icon md-font-icon=\"icon-file-document\" class=\"s50 icon\"></md-icon></div>\n</div></ms-widget-front></ms-widget></a><div layout=\"row\" layout-align=\"end end\"><md-icon md-font-icon=\"icon-pencil\" \nclass=\"c-p\" ng-click=\"UpdateForm($event,form)\"></md-icon></div></div></div></ms-widget></div></div>");
$templateCache.put("app/main/administration/email-buffer/emailBuffer-dialog.html","<style>\n.ps-container>.ps-scrollbar-y-rail>.ps-scrollbar-y {\n    width: 4px;\n    padding: 5px;\n    height: 80px;\n    margin: 0px;\n    height: 36px !important;\n  }\n\n  thead th {\n    position: sticky;\n    top: 0;\n    background: #dee7f4 !important;\n  }\n\n  table.dataTable tbody td {\n    padding: 9px 8px;\n    vertical-align: middle;\n  }\n</style><md-dialog ng-cloak flex=\"70\"><md-toolbar layout=\"row\" class=\"md-accent\"><div class=\"md-toolbar-tools\" \nlayout=\"row\" layout-align=\"space-between\n        center\"><h2>Email</h2><md-button class=\"md-icon-button\" \nng-click=\"cancel()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nlayout=\"column\" layout-align=\"center center\" class=\"p-0\"><div \nstyle=\"width:100%; margin-top:0% !important;padding-top: 0%;padding: 15px\" class=\"md-padding scrollable\" ms-scroll><div\n ng-bind-html=\"emailContent\" style=\"zoom: 1.3\"></div></div></md-dialog-content><md-dialog-actions ng-if=\"uomResults\">\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/administration/email-buffer/emailBuffer.html","<div class=\"page-layout simple right-sidenav\" layout-gt-xs=\"row\"><div \nng-include=\"\'app/main/administration/common/admin.html\'\"></div><div \nclass=\"page-layout carded fullwidth md-padding scrollable\" layout=\"column\" flex ms-scroll><div class=\"widget-group\" \nflex=\"100\" layout=\"column\" layout-wrap><ms-widget flippable=\"true\" class=\"no-padding\"><div \nclass=\"parent-tabs white-bg mb-15\"><md-tabs class=\"mh-0\"><md-tab label=\"EMAIL BUFFER\" md-active=\"true\"></md-tab>\n</md-tabs></div><div class=\"md-padding white-bg scrollable\"><div layout=\"column\" style=\"background: white\"><div \nlayout=\"row\" layout-align=\"space-between center\"><md-input-container flex-gt-sm=\"15\" class=\"md-block\" \nstyle=\"border: 1px solid rgb(169, 161, 161);margin-top: 0%;border-radius: 5px;height: 33px\"><label>Request ID</label>\n<input ng-model=\"obj.system\" type=\"text\" autocomplete=\"off\"></md-input-container><div flex-gt-sm=\"50\" layout=\"row\" \nstyle=\"margin-top: -1%\"><md-button class=\"md-raised md-accent\" ng-click=\" searchemail(obj,obj.date)\" \nstyle=\"margin-top:-1% !important\">Search</md-button><md-button class=\"md-raised md-warn\" ng-click=\"Reset()\" \nstyle=\"margin-top:-1% !important;margin-left: 4%\">Reset</md-button></div></div><table \nclass=\"dataTable row-border hover table-border\"><thead><tr class=\"table-header\"><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">S.No</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Subject</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Date</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Sent To</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\" layout=\"row\" layout-align=\"center center\"><span class=\"column-title\">Actions</span></div></th>\n</tr></thead><tbody><tr ng-repeat=\"email in allemailsBuffer \"><td>{{$index+1}}</td><td>{{email.subject}}</td><td>\n{{email.dateTime.substring(8,10)}}-{{email.dateTime.substring(5,7)}}-{{email.dateTime.substring(0,4)}}</td><td>\n{{email.to}}</td><td layout=\"row\" layout-align=\"center center\" \nstyle=\"padding-top:10px !important;padding-bottom:0px !important\"><md-button class=\"md-icon-button test-tooltip\" \nng-click=\"viewEmail($event,email.body)\"><md-tooltip md-direction=\"top\">View email</md-tooltip><md-icon><i layout=\"row\" \nlayout-align=\"center center\" class=\"icon icon-eye s18 deleteme\"></i></md-icon></md-button></td></tr></tbody></table>\n<div ng-if=\"searchmail==false\" layout=\"row\" layout-align=\"space-between center\" flex=\"100\" \nng-if=\"allemailsBuffer.length != 0\"><div class=\"md-padding\"><h5><b>\nShowing {{(searchpageNumber*size)+1}} - {{(searchpageNumber + 1)*size}} of {{totalRecords}} Results</b></h5></div><div \nlayout=\"row\" layout-align=\"center center\">Page No<md-input-container class=\"md-block md-padding\" style=\"margin: 0px\">\n<md-select ng-model=\"searchpageNumber\"><md-option ng-repeat=\"Number in pageNumbers\" ng-value=\"Number\" \nng-click=\"sendPageNumber(Number)\" value=\"Number\" ng-selected=\"$first\">{{Number+1}}</md-option></md-select>\n</md-input-container></div><div layout=\"row\" layout-align=\"center center\"><div><md-button type=\"button\" \nng-click=\"previous()\" ng-disabled=\"pageNumber <= 0\">Prev</md-button></div><p class=\"md-padding\"><b>\n{{pageNumber+1}}/ {{totalPages}} &nbsp;PAGES</b></p><div class=\"md-padding\"><md-button type=\"button\" \nng-click=\"next(obj)\" ng-disabled=\"pageNumber == totalPages -1 || allReports.length == 0\">Next</md-button></div></div>\n</div><div ng-if=\"searchmail==true\" layout=\"row\" layout-align=\"space-between center\" flex=\"100\" \nng-if=\"allemailsBuffer.length != 0\"><div class=\"md-padding\"><h5><b>\nShowing {{(searchpageNumber*size)+1}} - {{(searchpageNumber + 1)*size}} of {{searchtotalRecords}} Results</b></h5>\n</div><div layout=\"row\" layout-align=\"center center\">Page No<md-input-container class=\"md-block md-padding\" \nstyle=\"margin: 0px\"><md-select ng-model=\"searchpageNumber\"><md-option ng-repeat=\"Number in searchpageNumbers\" \nng-value=\"Number\" ng-click=\"searchsendPageNumber(Number)\" value=\"Number\" ng-selected=\"$first\">{{Number+1}}</md-option>\n</md-select></md-input-container></div><div layout=\"row\" layout-align=\"center center\"><div><md-button type=\"button\" \nng-click=\"searchprevious()\" ng-disabled=\"searchpageNumber <= 0\">Prev</md-button></div><p class=\"md-padding\"><b>\n{{searchpageNumber+1}}/ {{searchtotalPages}} &nbsp;PAGES</b></p><div class=\"md-padding\"><md-button type=\"button\" \nng-click=\"searchnext(obj)\" ng-disabled=\"searchpageNumber == searchtotalPages -1 || allReports.length == 0\">Next\n</md-button></div></div></div></div></div></ms-widget></div></div></div>");
$templateCache.put("app/main/administration/invoiceTypes/create.invoiceType.html","<style>\n.standardRules-list .rule {\n            background-color: rgba(0, 0, 0, 0.08);\n            border: 1px solid rgba(0, 0, 0, 0.16);\n            padding-left: 16px;\n            margin-top: 8px;\n            border-radius: 2px;\n        }\n        \n        .standardRules-list .rule.Warning,\n        .standardRules-list .rule.WARNING {\n            background-color: rgb(255, 249, 62) !important;\n        }\n        \n        .standardRules-list .rule.Error,\n        .standardRules-list .rule.ERROR {\n            background-color: rgb(213, 0, 0) !important;\n            color: white;\n        }\n        \n        .dynamic-form-field .md-errors-spacer {\n            display: none !important;\n        }\n</style><md-dialog flex=\"60\" ng-init=\"getAllUsers();\"><form name=\"userForm\" novalidate \nng-submit=\"userForm.$valid && userCtrl.createUser(user)\" layout=\"column\"><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools\"><h2>Create InvoiceType</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"cancel()\"><md-icon md-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"column\"><div \nlayout=\"row\"><md-input-container class=\"md-block\" flex-gt-sm=\"50\"><label>Name</label><input type=\"text\" name=\"name\" \nng-model=\"vm.InvoiceType.name\"></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"50\"><label>\nDescription</label><input type=\"text\" name=\"name\" ng-model=\"vm.InvoiceType.name\"></md-input-container></div><div \nstyle=\"margin-top:-3% !important\"><md-input-container class=\"md-block\"><label>Substitute From</label><md-select \nng-model=\"substitute.user_id\" ng-required=\"required\"><md-option ng-value=\"user.login\" \nng-repeat=\" user in usersList | orderBy:\'firstName\'\">{{user.firstName}} {{user.lastName}}</md-option></md-select>\n</md-input-container></div><div class=\"content\" flex><md-tabs md-border-bottom><md-tab label=\"Business Rules\">\n<md-content class=\"md-padding\"><table class=\"table w-100p\" cellspacing=\"0\"><tbody><tr><td><md-input-container \nmd-no-float class=\"no-margin h-30\" style=\"width:100%;margin-top: 12% !important\"><md-select \nng-model=\"vm.standardBusinessRules\" placeholder=\"Business Rule\"><md-option ng-value=\"businessRule\" \nng-repeat=\"businessRule in StandardBusinessRules\">{{businessRule.name}}</md-option></md-select></md-input-container>\n</td><td><md-input-container md-no-float><md-radio-group ng-model=\"vm.standardBusinessRules.type\" layout=\"row\">\n<md-radio-button value=\"ERROR\">Error</md-radio-button><md-radio-button value=\"WARNING\">Warning</md-radio-button>\n</md-radio-group></md-input-container><md-input-container><input type=\"text\" \nstyle=\"border: #a5afab 1px solid;height: 32px; width:400px\" name=\"message\" ng-model=\"vm.standardBusinessRules.message\" \nplaceholder=\"Message\"></md-input-container><a href class=\"btn btn-small\" \nng:click=\"vm.addNewrules(vm.standardBusinessRules)\"><md-icon class=\"def-color\" md-font-icon=\"icon-plus-circle\">\n</md-icon></a></td></tr></tbody></table></md-content></md-tab><md-tab label=\"Form Fields\"><md-content \nclass=\"md-padding\"><div layout=\"column\"><div style=\"width:100%\"><div layout=\"column\" class=\"pt-20 pb-10\"><strong>\nHeader Fields</strong></div><div style=\"width:250px;float:left\" data-ng-repeat=\"item in vm.InvoiceType.headerFields\">\n<md-switch style=\"margin: 4px 0\" ng-model=\"item.isEnabled\" aria-label=\"{{item.fieldTitle}}\">{{item.fieldTitle}}\n</md-switch></div></div><div style=\"width:100%\"><div layout=\"column\" class=\"pt-20 pb-10\"><strong>Line Item Fields\n</strong></div><div style=\"width:250px;float:left\" data-ng-repeat=\"item in vm.InvoiceType.lineFields\"><md-switch \nstyle=\"margin: 4px 0\" ng-model=\"item.isEnabled\" aria-label=\"{{item.fieldTitle}}\">{{item.fieldTitle}}</md-switch></div>\n</div><div style=\"width:100%\"><div layout=\"column\" class=\"pt-20 pb-10\"><strong>Dynamic Header Fields</strong></div><div\n layout=\"column\"><table class=\"table w-100p\" cellspacing=\"0\"><tbody><tr><td><md-input-container md-no-float \nclass=\"no-margin h-30\"><md-input-container md-no-float class=\"no-margin h-30\"><md-select ng-model=\"addField.new\" \nng-model=\"addField.new\"><md-option ng-value=\"type.name\" ng-repeat=\"type in addField.types\">{{type.value}}</md-option>\n</md-select></md-input-container></md-input-container><a href class=\"btn btn-small\" ng:click=\"vm.addDynamicField()\">\n<md-icon class=\"def-color\" md-font-icon=\"icon-plus-circle\"></md-icon></a></td></tr></tbody></table></div><div \nlayout=\"column\"><md-collapsible class=\"md-accordion\"><md-collapsible-item ng-repeat=\"field in form.form_fields\">\n<md-collapsible-header layout=\"row\">{{field.field_title}} ({{field.field_type}}) <span flex=\"\" class=\"ng-scope flex\">\n</span> <span style=\"float: right\">[+]</span></md-collapsible-header><md-collapsible-body><div class=\"accordion-edit\">\n<div layout=\"row\" layout-align=\"end center\"></div><div layout=\"row\" flex><h4 flex=\"10\">Title:</h4><md-input-container \nclass=\"\" flex=\"40\" style=\"margin: 0px\"><input type=\"text\" ng-model=\"field.field_title\" value=\"\"></md-input-container>\n<div flex=\"40\"></div><div flex=\"5\"><md-button class=\"md-icon-button md-warn\" aria-label=\"Delete\" \nng-hide=\'field.field_name == \"barcode\" \' ng-click=\"deleteField(field.field_id)\"><md-icon md-font-icon=\"icon-delete\">\n</md-icon><md-tooltip><span>DELETE</span></md-tooltip></md-button></div></div><div layout=\"row\" flex><div md-no-float \nflex=\"55\" ng-show=\"showAddOptions(field)\"><h4 flex=\"20\">Field Options:</h4><div md-no-float flex=\"80\"><div \nng-repeat=\"option in field.field_options\" flex=\"100\"><div layout=\"row\" flex><div flex=\"50\" class=\"dynamic-form-field\">\n<md-input-container style=\"margin: 0px\"><input type=\"text\" style=\"border: 1px solid #d7dad9; padding: 6px\" \nng-model=\"option.option_title\" value=\"{{option.option_title}}\"></md-input-container></div><div flex=\"50\">\n<md-input-container flex=\"40\" style=\"margin: 0px\" class=\"dynamic-form-field\"><input type=\"text\" \nstyle=\"border: 1px solid #d7dad9; padding: 6px\" ng-model=\"option.option_value\" value=\"{{option.option_value}}\">\n</md-input-container><md-button class=\"md-accent md-raised\" aria-label=\"Add Option\" flex=\"20\" \nng-click=\"deleteOption(field, option)\"><md-icon md-font-icon=\"icon-minus icon-white\"></md-icon></md-button></div></div>\n</div><md-button class=\"md-accent md-raised\" aria-label=\"Add Option\" flex=\"20\" ng-click=\"addOption(field)\">Add Option\n</md-button></div></div><h4 flex=\"10\">Required:</h4><md-input-container md-no-float flex=\"45\"><md-radio-group \nng-model=\"field.field_required\" layout=\"row\"><md-radio-button ng-value=\"true\" class=\"md-primary\" ng-selected>Yes\n</md-radio-button><md-radio-button ng-value=\"false\" class=\"md-primary\">No</md-radio-button></md-radio-group>\n</md-input-container></div></div></md-collapsible-body></md-collapsible-item></md-collapsible></div></div></div>\n</md-content></md-tab></md-tabs></div></div></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"end end\">\n<md-button type=\"button\" ng-click=\"cancel()\">Cancel</md-button><md-button type=\"submit\" \nng-click=\"userForm.$valid && save(substitute)\">Save</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/administration/invoiceTypes/invoiceType.html","<link rel=\"stylesheet\" href=\"https://maxcdn.bootstrapcdn.com/bootstrap/3.3.7/css/bootstrap.min.css\"><script \nsrc=\"https://maxcdn.bootstrapcdn.com/bootstrap/3.3.7/js/bootstrap.min.js\"></script><div \nclass=\"page-layout simple right-sidenav\" layout=\"row\"><div ng-include=\"\'app/main/administration/common/admin.html\'\">\n</div><div class=\"page-layout carded fullwidth md-padding scrollable\" layout=\"column\" flex ms-scroll><div \nclass=\"parent-tabs white-bg mb-15\"><md-tabs class=\"mh-0\"><md-tab label=\"InvoiceTypes\" \nui-sref=\"app.administration.invoiceTypeList\" md-active=\"true\"></md-tab></md-tabs></div><div class=\"widget-group\" \nflex=\"100\" layout=\"column\" layout-wrap><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" md-dynamic-height>\n<ms-widget-front class=\"white-bg\"><div class=\"h3 md-padding\">Manage InvoiceTypes</div><div class=\"widget-group c-p\" \nlayout=\"row\" flex=\"100\" layout-wrap><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"33\" \nflex-gt-md=\"20\" ng-click=\"gotoPR_Request()\"><ms-widget-front class=\"h-150 p-16 blue-bg white-fg\"><div class=\"white-fg\" \nlayout=\"column\" layout-align=\"end start\" flex><div class=\"md-title pb-16\">Purchase Requisition</div></div><div \nclass=\"background-image-center\"><md-icon md-font-icon=\"icon-document\" class=\"s128 faint-text\"></md-icon></div>\n</ms-widget-front></ms-widget><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"33\" flex-gt-md=\"20\" \nng-click=\"invoiceCtrl.goToVendor_Request()\"><ms-widget-front class=\"h-150 p-16 red-bg white-fg\"><div class=\"white-fg\" \nlayout=\"column\" layout-align=\"end start\" flex><div class=\"md-title pb-16\">Vendor CR Req</div></div><div \nclass=\"background-image-center\"><md-icon md-font-icon=\"icon-document\" class=\"s128 faint-text\"></md-icon></div>\n</ms-widget-front></ms-widget><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"33\" flex-gt-md=\"20\" \nng-click=\"adminCtrl.goToAdminuser()\"><ms-widget-front class=\"h-150 p-16 orange-bg white-fg\"><div class=\"white-fg\" \nlayout=\"column\" layout-align=\"end start\" flex><div class=\"md-title pb-16\">InvoiceTypes</div></div><div \nclass=\"background-image-center\"><md-icon md-font-icon=\"icon-document\" class=\"s128 faint-text\"></md-icon></div>\n</ms-widget-front></ms-widget></div></ms-widget-front></ms-widget></div></div></div>");
$templateCache.put("app/main/administration/list-management/attributes.list.html","<md-dialog aria-label=\"Add new Attributes\" flex=\"75\"><form name=\"ListForm\" novalidate \nng-submit=\"ListForm.$valid && save()\" layout=\"column\" flex=\"66\"><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools\"><h2>Attributes of List:{{currentDocType.name}}</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content class=\"scrollable\" ms-scroll><table id=\"attrlisttable\" \nclass=\"dataTable row-border hover table-border\" datatable=\"ng\" dt-options=\"dtOptions1\"><thead><tr class=\"table-header\">\n<th ng-show=\"false\"></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Field NAME\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">TYPE</span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header\" layout=\"row\" layout-align=\"center center\"><span \nclass=\"column-title\">LABEL</span></div></th><th class=\"secondary-text\"><div class=\"table-header\" layout=\"row\" \nlayout-align=\"center center\"><span class=\"column-title\">LENGTH</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\" layout=\"row\" layout-align=\"center center\"><span class=\"column-title\">OUTPUTFIELDFLAG</span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header\" layout=\"row\" layout-align=\"center center\"><span \nclass=\"column-title\">FILTERFIELDFLAG</span></div></th><th class=\"secondary-text\"><div class=\"table-header\" \nlayout=\"row\" layout-align=\"center center\"><span class=\"column-title\">DESCRIPTIONFLAG</span></div></th><th><div \nclass=\"table-header\"><span class=\"column-title\"></span></div></th></tr></thead><tbody><tr \nng-repeat=\"element in attributes track by $index\"><td ng-show=\"false\"><md-input-container class=\"md-block\" flex=\"10\">\n<input type=\"text\" name=\"name\" ng-model=\"element.id\" ng-init=\"element.id = $index\"><div \nng-messages=\"ListForm.name.$error\" role=\"alert\"><div ng-message=\"required\">Enter id name</div></div>\n</md-input-container></td><td><md-input-container class=\"md-block\"><input type=\"text\" name=\"name\" \nng-model=\"element.fieldname\" ng-required=\"true\"><div ng-messages=\"ListForm.name.$error\" role=\"alert\"><div \nng-message=\"required\">Enter attribute name</div></div></md-input-container></td><td><md-input-container \nclass=\"md-block\"><md-select ng-model=\"element.type\"><md-option ng-repeat=\"type in attributeTypes\" value=\"{{type}}\">\n{{type}}</md-option></md-select></md-input-container></td><td><md-input-container class=\"md-block\"><input type=\"text\" \nname=\"label\" ng-model=\"element.label\"><div ng-messages=\"ListForm.label.$error\" role=\"alert\"><div ng-message=\"required\">\nEnter Label</div></div></md-input-container></td><td><md-input-container class=\"md-block\"><input type=\"text\" \nname=\"length\" ng-model=\"element.length\"><div ng-messages=\"ListForm.length.$error\" role=\"alert\"><div \nng-message=\"required\">Enter length</div></div></md-input-container></td><td><md-input-container class=\"md-block\">\n<md-switch ng-model=\"element.outputfieldflag\" aria-label=\"Switch\" ng-change=\"setunioutputflag(element.id)\"></md-switch>\n</md-input-container></td><td><md-input-container class=\"md-block\"><md-switch ng-model=\"element.filterfieldflag\" \naria-label=\"Switch\"></md-switch></md-input-container></td><td><md-input-container class=\"md-block\"><md-switch \nng-model=\"element.descriptionflag\" aria-label=\"Switch\" ng-change=\"setunidescflag(element.id)\"></md-switch>\n</md-input-container></td><td><md-button id=\"{{$index}}\" class=\"md-icon-button md-accent\" \nonclick=\"angular.element(this).scope().removeAttribute(this)\"><md-tooltip md-direction=\"top\">Delete</md-tooltip>\n<md-icon md-font-icon=\"icon-delete\"></md-icon></md-button></td></tr></tbody></table></md-dialog-content>\n<md-dialog-actions layout=\"row\" layout-align=\"center center\"><md-button ng-click=\"cancel()\">Cancel</md-button>\n<md-button type=\"submit\" ng-disabled=\"showupdate\">Update</md-button></md-dialog-actions><md-button flow-btn \nclass=\"md-fab md-accent md-fab-bottom-right\" aria-label=\"Create User\" ng-click=\"addNewAttribute()\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon><md-tooltip md-direction=\"top\">New Attribute</md-tooltip></md-button></form>\n</md-dialog>");
$templateCache.put("app/main/administration/list-management/createlist-dialog.html","<md-dialog aria-label=\"Add List\"><form name=\"listForm\" novalidate \nng-submit=\"listForm.$valid && doctypeCrtl.createDocumentType()\" layout=\"column\" flex=\"66\"><md-toolbar \nclass=\"md-accent\"><div class=\"md-toolbar-tools\"><h2>Create List</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><div layout=\"column\"><md-input-container class=\"md-block\" flex=\"45\">\n<input type=\"text\" name=\"name\" ng-model=\"list.name\" placeholder=\"Name\" required><div \nng-messages=\"listForm.name.$error\" role=\"alert\"><div ng-message=\"required\"><span>Name is required</span></div></div>\n</md-input-container><span flex=\"10\"></span><md-input-container class=\"md-block\" flex=\"45\"><input type=\"text\" \nname=\"description\" ng-model=\"list.description\" placeholder=\"Description\"><div \nng-messages=\"listForm.description.$error\" role=\"alert\"><div ng-message=\"pattern\"><span>\nDescription has invalid characters</span></div></div></md-input-container></div></md-dialog-content><md-dialog-actions \nlayout=\"row\" layout-align=\"center center\"><md-button type=\"button\" ng-click=\"cancel()\">Cancel</md-button><md-button \ntype=\"submit\" ng-click=\"listForm.$valid && save(list)\">Save</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/administration/list-management/listOverview.html","<div class=\"page-layout simple right-sidenav\" layout-gt-xs=\"row\"><div \nng-include=\"\'app/main/administration/common/admin.html\'\"></div><div \nclass=\"page-layout carded fullwidth md-padding scrollable\" layout=\"column\" flex ms-scroll><div class=\"widget-group\" \nflex=\"100\" layout=\"column\" layout-wrap><ms-widget flippable=\"true\" class=\"no-padding\"><div \nclass=\"parent-tabs white-bg mb-15\"><md-tabs class=\"mh-0\"><md-tab label=\"List Definition\" md-active=\"true\"></md-tab>\n<md-tab label=\"List Maintenance\" ui-sref=\"app.administration.list-maintenance\"></md-tab></md-tabs></div><div \nclass=\"md-padding white-bg\"><table id=\"listtable\" class=\"dataTable row-border hover table-border\" datatable=\"ng\" \ndt-options=\"listCtrl.dtOptions \"><thead><tr class=\"table-header\"><th class=\"secondary-text\"><div class=\"table-header\">\n<span class=\"column-title\">Name</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Description</span></div></th><th class=\"secondary-text\"><div class=\"table-header\" layout=\"row\" \nlayout-align=\"center center\"><span class=\"column-title\">Actions</span></div></th></tr></thead><tbody><tr \nng-repeat=\"list in listdata \"><td>{{list.name}}</td><td>{{list.description}}</td><td layout=\"row\" \nlayout-align=\"center center\" style=\"padding-top:0px !important;padding-bottom:0px !important\"><md-button \nid=\"{{list.id}}\" class=\"md-icon-button test-tooltip\" aria-label=\"Delete\" \nonclick=\"angular.element(this).scope().deletelist(this)\"><md-tooltip md-direction=\"top\">Delete</md-tooltip><md-icon><i \nlayout=\"row\" layout-align=\"center center\" class=\"icon icon-delete s18\"></i></md-icon></md-button><md-button \nid=\"{{list.id}}\" class=\"md-icon-button test-tooltip\" aria-label=\"Update\" \nonclick=\"angular.element(this).scope().ListAttributesDialog(this)\"><md-tooltip md-direction=\"top\">Attributes\n</md-tooltip><md-icon><i layout=\"row\" layout-align=\"center center\" class=\"icon icon-dots-vertical s20\"></i></md-icon>\n</md-button></td></tr></tbody></table></div></ms-widget></div><md-button flow-btn \nclass=\"md-fab grey-700-bg md-mini md-fab-bottom-right add_btn\" ng-click=\"createListDialog(ev)\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon><md-tooltip md-direction=\"top\">Create DocType</md-tooltip></md-button></div></div>");
$templateCache.put("app/main/administration/list-management/updatelist-dialog.html","<md-dialog aria-label=\"Update List\" flex=\"45\"><form name=\"ListUpdateForm\" novalidate \nng-submit=\"ListUpdateForm.$valid && update(currentList)\" layout=\"column\"><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools\"><h2>Update List</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\">\n<md-icon md-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content layout=\"column\"><md-input-container class=\"md-block\" flex=\"45\"><input\n type=\"text\" name=\"Name\" ng-model=\"currentList.name\" placeholder=\"name\" required><div \nng-messages=\"ListUpdateForm.name.$error\" role=\"alert\"><div ng-message=\"required\"><span>Name is required</span></div>\n<div ng-message=\"pattern\"><span>Name has invalid characters</span></div></div></md-input-container><span flex=\"10\">\n</span><md-input-container class=\"md-block\" flex=\"45\"><input type=\"text\" name=\"Description\" \nng-model=\"currentList.description\" placeholder=\"description\"><div ng-messages=\"ListUpdateForm.description.$error\" \nrole=\"alert\"><div ng-message=\"pattern\"><span>Description has invalid characters</span></div></div></md-input-container>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"center center\"><md-button ng-click=\"cancel()\">Cancel\n</md-button><md-button type=\"submit\" ng-click=\"listForm.$valid && update(currentList)\">Update</md-button>\n</md-dialog-actions></form></md-dialog>tml>");
$templateCache.put("app/main/administration/mtrInbox-Confg/mtrInbox.html","<div class=\"page-layout simple right-sidenav\" layout-gt-xs=\"row\"><div \nng-include=\"\'app/main/administration/common/admin.html\'\"></div><div class=\"widget-group scrollable\" flex=\"100\" \nlayout=\"column\" layout-wrap ms-scroll ng-init=\" MtrInCtrl.getInboxConfgData()\"><ms-widget><div \nclass=\"parent-tabs white-bg mb-15\"><md-tabs class=\"mh-0\"><md-tab label=\"InboxConfig\" md-active=\"true\" \nui-sref=\"app.administration.mtrInboxConfg\"></md-tab></md-tabs><md-button ng-hide=\"showrowdata\" flow-btn \nclass=\"md-fab grey-700-bg md-mini md-fab-bottom-right add_btn\" ng-click=\"createUserDialog(ev)\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon><md-tooltip md-direction=\"top\">Create Detail</md-tooltip></md-button></div><table \nclass=\"dataTable row-border hover table-border\"><thead><tr class=\"table-header\"><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Request Type</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Screen Type</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Action</span></div></th></tr></thead><tbody><tr \nng-repeat=\"user in usersList\"><td>{{user.requestType}}</td><td>{{user.screenType}}</td><td layout=\"row\" \nstyle=\"padding-top:0px !important;padding-bottom:0px !important\"><md-button class=\"md-icon-button test-tooltip\" \naria-label=\"Update\" ng-click=\"updateUserDialog(ev,user)\"><md-tooltip md-direction=\"top\">Update</md-tooltip><md-icon><i \nlayout=\"row\" layout-align=\"center center\" class=\"icon icon-pencil s18\"></i></md-icon></md-button><md-button \nclass=\"md-icon-button test-tooltip\" aria-label=\"Delete\" ng-click=\" MtrInCtrl.deleteUser($event, user) \"><md-tooltip \nmd-direction=\"top\">Delete</md-tooltip><md-icon><i layout=\"row\" layout-align=\"center center\" \nclass=\"icon icon-delete s18\"></i></md-icon></md-button></td></tr></tbody></table></ms-widget></div></div>");
$templateCache.put("app/main/administration/mtrInbox-Confg/mtrUpdateDialog.html","<md-dialog aria-label=\"Add a new user\" flex=\"40\"><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2>\nUpdate Inbox</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><div layout=\"column\"><md-input-container flex-gt-sm=\"15\" \nclass=\"md-block margin\"><label>Request Type</label><md-select ng-model=\"currentUser.requestType\"><md-option \nng-value=\"requestType.name\" ng-repeat=\"requestType in requestTypes\">{{requestType.name}}</md-option></md-select>\n</md-input-container><span flex=\"10\"></span><md-input-container class=\"md-block\"><label>Screen Type</label><input \ntype=\"text\" name=\"Screen\" ng-model=\"currentUser.screenType\"></md-input-container></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" layout-align=\"center center\"><md-button type=\"button\" ng-click=\"cancel()\">Cancel\n</md-button><md-button type=\"submit\" ng-click=\"updatesave(currentUser)\">Save</md-button></md-dialog-actions>\n</md-dialog>");
$templateCache.put("app/main/administration/mtrInbox-Confg/mtrcreateDialog.html","<md-dialog aria-label=\"Add a new user\" flex=\"40\"><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2>\nCreate Inbox</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content ng-init=\"getRequests()\"><div layout=\"column\"><md-input-container \nflex-gt-sm=\"15\" class=\"md-block margin\"><label>Request Type</label><md-select ng-model=\"user.requestType\"><md-option \nng-value=\"requestType.name\" ng-repeat=\"requestType in requestTypes\" ng-selected=\"$first\">{{requestType.name}}\n</md-option></md-select></md-input-container><span flex=\"10\"></span><md-input-container class=\"md-block\"><label>\nScreen Type</label><md-select ng-model=\"user.screenType\"><md-option value=\"split_screen\">Split Screen</md-option>\n<md-option value=\"normal_screen\">Normal Screen</md-option></md-select></md-input-container></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" layout-align=\"center center\"><md-button type=\"button\" ng-click=\"cancel()\">Cancel\n</md-button><md-button type=\"submit\" ng-click=\"save(user)\">Save</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/administration/reports/mainReport.html","<style>\n.reportImage-1 { \n    background: url(/assets/images/reportsicon.svg) no-repeat;\n    background-position: -1px -8px;\n    height: 103px;\n    width: 187px;\n    position: absolute;\n    top: 30px;\n}\n.reportImage-2 { \n    background: url(/assets/images/reportsicon.svg) no-repeat;\n    background-position: -1px -122px;\n    width: 187px;\n    height: 103px;\n    position: absolute;\n    top: 30px;\n}\n.reportImage-3 { \n    background: url(/assets/images/reportsicon.svg) no-repeat;\n    background-position: -1px -236px;\n    width: 187px;\n    height: 101px;\n    position: absolute;\n    top: 30px;\n}\n</style><div class=\"pb-15\" layout=\"row\" ng-if=\"reportView == 1\"><span class=\"md-active c-p\" data-ng-click=\"goBack(0)\" \nstyle=\"display: inherit;color: #52b8e9\" role=\"button\"><md-icon md-font-icon=\"icon-arrow-left md-active s16\" \nclass=\"md-font icon-arrow-left md-active s16 material-icons\" aria-hidden=\"true\"></md-icon>Go back</span></div><div \nclass=\"content md-padding white-bg mb-15\" flex><div layout=\"row\"><div flex=\"45\"><md-input-container \nclass=\"md-block no-margin\"><input type=\"text\" name=\"id\" ng-model=\"reportInfo.reportid\" placeholder=\"ReportId\" required>\n<div ng-messages=\"reportForm.id.$error\" role=\"alert\"><div ng-message=\"required\">Reportid is required</div></div>\n</md-input-container></div><span flex=\"10\"></span><div flex=\"45\"><md-input-container class=\"md-block no-margin\"><input \ntype=\"text\" name=\"label\" ng-model=\"reportInfo.label\" placeholder=\"Label\"></md-input-container></div></div><div \nlayout=\"row\"><md-input-container flex=\"30\"><label>Select Module</label><md-select name=\"type\" \nng-model=\"reportInfo.reportModule\" md-on-close=\"selectedModule(reportInfo.reportModule)\"><md-option value=\"documents\">\nDocument</md-option><md-option value=\"request\">Request</md-option></md-select></md-input-container><span flex=\"5\">\n</span><md-input-container flex=\"30\"><label>Specific Type</label><md-select \nng-disabled=\"reportInfo.reportModule == null && reportInfo.reportModule == undefined\" \nng-model=\"reportInfo.reportSpecific\" md-on-close=\"selectSpecificType(reportInfo.reportSpecific)\" multiple=\"multiple\">\n<md-option ng-if=\"reportInfo.reportModule == \'documents\'\" value=\"docType\">Doctype specific</md-option><md-option \nng-if=\"reportInfo.reportModule == \'request\'\" value=\"reqType\">Requesttype specific</md-option></md-select>\n</md-input-container><span flex=\"5\"></span><md-input-container flex=\"30\"><label>DocType</label><md-select name=\"type\" \nng-disabled=\"reportInfo.reportSpecific.length == 0\" ng-model=\"reportInfo.docType\" \nmd-on-close=\"selectDocType(reportInfo.docType)\"><md-option ng-repeat=\"doctype in docTypes\" ng-value=\"doctype.id\">\n{{doctype.name}}</md-option></md-select></md-input-container></div><md-divider></md-divider><div layout=\"row\" \nclass=\"pt-15 pb-15\"><div class=\"h-136\" flex=\"100\"><md-radio-group ng-model=\"reportInfo.reportType\" layout=\"row\">\n<md-radio-button value=\"TABULAR\" flex>Tabular Report<br><span class=\"reportImage-1\"></span><br></md-radio-button>\n<md-radio-button value=\"SUMMARY\" flex>Summary Report<br><span class=\"reportImage-2\"></span><br></md-radio-button>\n<md-radio-button value=\"MATRIX\" flex>Matrix Report<br><span class=\"reportImage-3\"></span><br></md-radio-button>\n</md-radio-group></div></div><md-divider></md-divider><div layout=\"row\"><div flex=\"50\" class=\"md-padding\"><md-checkbox \nng-model=\"reportInfo.skipSelection\" aria-label=\"Skip Selection\">Skip Selection</md-checkbox></div><md-divider>\n</md-divider><div flex=\"50\" class=\"md-padding\"><md-button ng-click=\"showIconsList()\" class=\"md-accent md-raised\">\nselect report logo</md-button></div></div></div><div class=\"md-padding white-bg\"><md-tabs md-dynamic-height><md-tab \ndata-ng-if=\"!reportInfo.skipSelection\" label=\"Selection Fields\"><ms-widget layout=\"column\"><ms-widget-front \nclass=\"white-bg mh-420 b-t\"><div class=\"scrollable\" ms-scroll><table border=\"0\" align=\"center\" cellpadding=\"0\" \ncellspacing=\"2\"><tbody><tr><td class=\"f14 color_4 pB10\">Available Columns:</td><td>&nbsp;</td><td \nclass=\"f14 color_4 pB10\">Selected Columns:</td><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td></tr><tr>\n<td><select id=\"availList\" name=\"availList\" multiple=\"\" class=\"select\" ng-model=\"sfields\" \nstyle=\"width:200px;height:300px;max-height:300px;overflow: auto\"><option value=\"{{field.fieldname}}\" \nng-repeat=\"field in selectionfields track by $index\" style=\"padding-left: 5px\">{{ field.fieldname }}</option></select>\n</td><td><table border=\"0\" align=\"center\" cellpadding=\"0\" cellspacing=\"5\"><tbody><tr><td><div align=\"center\"><md-button\n class=\"md-accent md-raised\" type=\"submit\" ng-click=\"addColumn(sfields)\">Add</md-button></div></td></tr></tbody>\n</table></td><td><select id=\"selectedColumns\" name=\"selectedColumns\" multiple=\"\" class=\"select\" ng-model=\"fsfields\" \nng-change=\"selectedFSFields(fsfields)\" style=\"width:200px;height:300px;overflow: auto\"><option value=\"{{field}}\" \nng-repeat=\"field in finalSelectionFields track by $index\" style=\"padding-left: 5px\">{{ field.fieldname }}</option>\n</select></td><td><table border=\"0\" cellspacing=\"0\" cellpadding=\"0\"><tbody><tr><td><md-button \nclass=\"md-icon-button md-accent\" aria-label=\"Favorite\" ng-click=\"moveUp(fsfields)\"><md-icon \nmd-svg-icon=\"assets/angular-material-assets/img/icons/ic_keyboard_arrow_up_black_24px.svg\"></md-icon></md-button></td>\n</tr><tr><td><md-button class=\"md-icon-button md-accent\" aria-label=\"Favorite\" ng-click=\"moveDown(fsfields)\"><md-icon \nmd-svg-icon=\"assets/angular-material-assets/img/icons/ic_keyboard_arrow_down_black_24px.svg\"></md-icon></md-button>\n</td></tr><tr style=\"height:5px\"><td></td></tr><tr><td><md-button class=\"md-icon-button md-warn\" aria-label=\"Favorite\" \nng-click=\"delColumn(fsfields)\"><md-icon md-svg-icon=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\">\n</md-icon></md-button></td></tr></tbody></table></td><td style=\"vertical-align: top\" class=\"layout-row\">\n<md-input-container class=\"md-block no-margin\" ng-if=\"selectedFSField != undefined\"><input type=\"text\" \nname=\"defaultvalue\" ng-model=\"selectedFSField.defaultvalue\" \nng-blur=\"setDefaultValue(selectedFSField.defaultvalue, fsfields);\" placeholder=\"Default Value\"></md-input-container>\n<md-input-container class=\"md-block no-margin\" flex=\"100\" ng-if=\"selectedFSField != undefined\"><input type=\"text\" \nname=\"possibleValues\" ng-model=\"selectedFSField.possibleValues\" \nng-blur=\"setPossibleValues(selectedFSField.possibleValues, fsfields);\" placeholder=\"Possible Values\">\n</md-input-container><md-input-container class=\"md-block no-margin\" flex=\"100\" ng-if=\"selectedFSField != undefined\">\n<input type=\"text\" name=\"label\" ng-model=\"selectedFSField.label\" \nng-blur=\"setLabelValue(selectedFSField.label, fsfields);\" placeholder=\"Label\"></md-input-container><md-input-container \nclass=\"md-block no-margin\" flex=\"100\" ng-if=\"selectedFSField != undefined\"><label>Required</label><md-switch \nng-model=\"selectedFSField.requiredflag\" aria-label=\"required\" \nng-blur=\"setRequiredFlag(selectedFSField.requiredflag, fsfields);\"></md-switch></md-input-container></td></tr></tbody>\n</table></div></ms-widget-front></ms-widget></md-tab><md-tab label=\"DocType Fields\"><ms-widget layout=\"column\">\n<ms-widget-front class=\"white-bg mh-420 b-t\"><div class=\"scrollable\" ms-scroll><table class=\"simple list-view\"><tbody>\n<tr class=\"layout-row\" flex=\"100\" ng-repeat=\"attr in attributeObjects\"><td flex=\"20\">{{ attr.name }}</td><td flex=\"20\">\n{{ attr.type }}</td><td flex=\"30\" class=\"no-padding\"><md-input-container md-no-float class=\"no-padding no-margin\" \nstyle=\"top: 15px; height: 30px; width: 50%\"><input type=\"text\" ng-model=\"getLabelValue(attr, \'DOCTYPEFIELDS\').label\" \nplaceholder=\"Label\" style=\"float:left\"></md-input-container></td><td flex=\"30\" class=\"no-padding\"><md-input-container \nclass=\"no-padding no-margin\"><span dir=\"rtl\" style=\"display: -webkit-box; padding-top: 14px\"><md-checkbox \nng-checked=\"exist(attr, selectedAttr, \'DOCTYPEFIELDS\')\" ng-click=\"toggleCheck(attr, selectedAttr, \'DOCTYPEFIELDS\')\">\n</md-checkbox></span></md-input-container></td></tr></tbody></table></div><div class=\"md-padding white-bg\" \ndata-ng-if=\"attributeObjects.length == 0\"><div class=\"content-container text-center\"><div \nclass=\"alert alert-info mv-10 mh-10\"><p>No data available</p></div></div></div></ms-widget-front></ms-widget></md-tab>\n<md-tab label=\"Output Fields\"><ms-widget layout=\"column\"><ms-widget-front class=\"white-bg mh-420 b-t\"><div \nclass=\"scrollable\" ms-scroll><table class=\"simple list-view\"><tbody><tr class=\"layout-row\" flex=\"100\" \nng-repeat=\"field in outputfields track by $index\"><td flex=\"25\">{{ field.fieldname }}</td><td flex=\"25\" \nclass=\"no-padding\"><md-input-container md-no-float class=\"no-padding no-margin\" \nstyle=\"top: 15px; height: 30px; width: 50%\"><input type=\"text\" ng-model=\"getLabelValue(field, \'OUTPUTFIELDS\').label\" \nplaceholder=\"Label\" style=\"float:left\"></md-input-container></td><td flex=\"25\" class=\"no-padding\"><md-input-container \nmd-no-float class=\"no-padding no-margin\" style=\"top: 15px; height: 30px\"><input type=\"number\" \nng-model=\"getLabelValue(field, \'OUTPUTFIELDS\').sequence\" placeholder=\"Sequence Number\" style=\"float:left\">\n</md-input-container></td><td flex=\"25\" class=\"no-padding\"><md-input-container md-no-float \nclass=\"no-padding no-margin\" style=\"top: 15px; height: 30px\"><input type=\"number\" \nng-model=\"getLabelValue(field, \'OUTPUTFIELDS\').length\" placeholder=\"Length\" style=\"float:left\"></md-input-container>\n</td><td flex=\"25\" class=\"no-padding\"><md-input-container class=\"no-padding no-margin\"><span dir=\"rtl\" \nstyle=\"display: -webkit-box; padding-top: 14px\"><md-checkbox ng-checked=\"exist(field, selectedOutFl, \'OUTPUTFIELDS\')\" \nng-click=\"toggleCheck(field, selectedOutFl, \'OUTPUTFIELDS\')\"></md-checkbox></span></md-input-container></td></tr>\n</tbody></table></div><div class=\"md-padding white-bg\" data-ng-if=\"outputfields.length == 0\"><div \nclass=\"content-container text-center\"><div class=\"alert alert-info mv-10 mh-10\"><p>No data available</p></div></div>\n</div></ms-widget-front></ms-widget></md-tab><md-tab label=\"Filtered Fields\"><ms-widget layout=\"column\">\n<ms-widget-front class=\"white-bg mh-420 b-t\"><div class=\"scrollable\" ms-scroll><table class=\"simple list-view\"><tbody>\n<tr class=\"layout-row\" flex=\"100\" ng-repeat=\"field in filterfields track by $index\"><td flex=\"30\">{{ field.fieldname }}\n</td><td flex=\"30\" class=\"no-padding\"><md-input-container md-no-float class=\"no-padding no-margin\" \nstyle=\"top: 15px; height: 30px; width: 50%\"><input type=\"text\" ng-model=\"getLabelValue(field, \'FILTEREDFIELDS\').label\" \nplaceholder=\"Label\" style=\"float:left\"></md-input-container></td><td flex=\"40\" class=\"no-padding\"><md-input-container \nclass=\"no-padding no-margin\"><span dir=\"rtl\" style=\"display: -webkit-box; padding-top: 14px\"><md-checkbox \nng-checked=\"exist(field, selectedFilter, \'FILTEREDFIELDS\')\" \nng-click=\"toggleCheck(field, selectedFilter, \'FILTEREDFIELDS\')\"></md-checkbox></span></md-input-container></td></tr>\n</tbody></table></div><div class=\"md-padding white-bg\" data-ng-if=\"filterfields.length == 0\"><div \nclass=\"content-container text-center\"><div class=\"alert alert-info mv-10 mh-10\"><p>No data available</p></div></div>\n</div></ms-widget-front></ms-widget></md-tab></md-tabs><section layout=\"row\" layout-sm=\"column\" \nlayout-align=\"center center\" layout-wrap><md-button ng-if=\"reportView != 1\" class=\"md-raised md-primary\" type=\"submit\" \nng-click=\"reportForm.$valid && submitReport(\'SAVE\')\">Save Report</md-button><md-button ng-if=\"reportView == 1\" \nclass=\"md-raised md-primary\" type=\"submit\" ng-click=\"reportForm.$valid && submitReport(\'UPDATE\')\">Update Report\n</md-button></section></div>");
$templateCache.put("app/main/administration/reports/reportDefinition.html","<div id=\"reportform\" class=\"page-layout simple right-sidenav\" layout-gt-xs=\"row\"><div \nng-include=\"\'app/main/administration/common/admin.html\'\"></div><form name=\"reportForm\" novalidate \nng-submit=\"repctrl.createreport(report)\" layout=\"column\" flex=\"100\"><div \nclass=\"page-layout carded fullwidth md-padding scrollable\" layout=\"column\" flex ms-scroll><div class=\"widget-group\" \nflex=\"100\" layout=\"column\" layout-wrap><ms-widget flippable=\"true\" class=\"no-padding\"><div \nclass=\"parent-tabs white-bg mb-15\"><md-tabs class=\"mh-0\"><md-tab label=\"Report Definition\" \nui-sref=\"app.administration.reports\" md-active=\"true\"></md-tab><md-tab label=\"Report Maintenance\" \nui-sref=\"app.administration.reports.maintenance\"></md-tab></md-tabs></div><div \nng-include=\"\'app/main/administration/reports/mainReport.html\'\"></div></ms-widget></div></div></form></div>");
$templateCache.put("app/main/administration/reports/reportMaintenance.html","<div id=\"reportform\" class=\"page-layout simple right-sidenav\" layout-gt-xs=\"row\"><div \nng-include=\"\'app/main/administration/common/admin.html\'\"></div><form name=\"reportForm\" novalidate \nng-submit=\"repctrl.createreport(report)\" layout=\"column\" flex=\"100\"><div \nclass=\"page-layout carded fullwidth md-padding scrollable\" layout=\"column\" flex ms-scroll><div class=\"widget-group\" \nflex=\"100\" layout=\"column\" layout-wrap><ms-widget flippable=\"true\" class=\"no-padding\"><div \nclass=\"parent-tabs white-bg mb-15\"><md-tabs class=\"mh-0\"><md-tab label=\"Report Definition\" \nui-sref=\"app.administration.reports\"></md-tab><md-tab label=\"Report Maintenance\" \nui-sref=\"app.administration.reports.maintenance\" md-active=\"true\"></md-tab></md-tabs></div><div layout=\"row\" \nclass=\"white-bg md-padding\" layout-wrap ng-if=\"reportView == 0\"><div \nng-repeat=\"report in allReports  | filter : searchSite\" flex=\"100\" flex-gt-xs=\"25\" flex-gt-md=\"20\"><md-card \nmd-theme=\"{{getAnotherColor($index)}}\" md-theme-watch class=\"c-p\"><md-tooltip md-direction=\"top\">{{report.label}}\n</md-tooltip><div class=\"info\" layout=\"column\" layout-align=\"space-between\" flex><div><div class=\"white-fg md-padding\" \nlayout=\"row\" layout-align=\"center center\" ng-style=\"{\'height\':\'150px\'}\"><md-icon md-font-icon=\"{{report.icon}}\" \nclass=\"s64\"></md-icon></div><div layout=\"row\" layout-align=\"end end\" style=\"color:white\">\n{{report.visibility}} &nbsp;&nbsp;</div></div><div><md-divider></md-divider><div class=\"text white-bg\" \nstyle=\"text-align: center\"><label>{{report.label}}</label><md-button class=\"md-icon-button test-tooltip\" \nng-click=\"deleteReport(report.label,report.id)\"><md-tooltip md-direction=\"top\">Delete Report</md-tooltip><md-icon><i \nlayout=\"row\" layout-align=\"center center\" class=\"icon icon-delete s20\"></i></md-icon></md-button><md-button \nclass=\"md-icon-button test-tooltip\" aria-label=\"Update\" ng-click=\"goToUpdateReport(report)\"><md-tooltip \nmd-direction=\"top\">Update</md-tooltip><md-icon><i layout=\"row\" layout-align=\"center center\" \nclass=\"icon icon-pencil s18 deleteme\"></i></md-icon></md-button></div></div></div></md-card></div></div><div \nng-if=\"reportView == 1\" ng-include=\"\'app/main/administration/reports/mainReport.html\'\"></div><div \nclass=\"md-padding white-bg\" data-ng-if=\"allReports.length == 0\"><div class=\"content-container text-center\"><div \nclass=\"alert alert-info mv-10 mh-10\"><p>No data available</p></div></div></div></ms-widget></div></div></form></div>");
$templateCache.put("app/main/administration/doa-reports/doa-reports-updateDialog.html","<md-dialog aria-label=\"Add a new user\" flex=\"40\"><form name=\"DoaupdateReport\"><div><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools\"><h2>Update Doa Reports</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"cancel()\"><md-icon md-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"column\" \nflex-gt-sm=\"100\"><div layout=\"row\" layout-align=\"center center\"><div flex-gt-sm=\"35\" layout=\"row\">Request Type</div>\n<div flex-gt-sm=\"35\"><md-input-container class=\"md-block margin\"><md-select ng-model=\"doaUpdate.requestTypes\" \nmultiple=\"multiple\" \nstyle=\"border: 1px solid rgb(169, 161, 161);border-radius: 3px;margin-bottom: -10%;height: 30px; margin-top: -3%\">\n<md-option value=\"All\">All</md-option><md-option value=\"CEP_FORM\">CEP_FORM</md-option><md-option value=\"EOR_FORM\">\nEOR_FORM</md-option><md-option value=\"GENERAL_FORM\">GENERAL_FORM</md-option><md-option value=\"RFWD_FORM\">RFWD_FORM\n</md-option><md-option value=\"SCEP_FORM\">SCEP_FORM</md-option><md-option value=\"VENDOR_FORM\">VENDOR_FORM</md-option>\n<md-option value=\"COR_ADV\">COR_ADV</md-option></md-select></md-input-container></div></div><div layout=\"row\" \nlayout-align=\"center center\"><div flex-gt-sm=\"35\" layout=\"row\">User Id</div><div flex-gt-sm=\"35\"><input type=\"text\" \nplaceholder=\"\" ng-model=\"doaUpdate.user\" list=\"names\" \nstyle=\"border: 1px solid rgb(169, 161, 161);\n                        margin-top: 9px; margin-bottom: 7%; height: 30px; border-radius: 3px;width: 99%\">\n<datalist id=\"names\" class=\"form-control\" ng-model=\"obj.currentUser\"><option value=\"\">-- select an option --</option>\n<option ng-repeat=\"person in usersList | filter:search \" ng-value=\"person.login\">\n{{person.firstName}}-{{person.lastName}}</option></datalist></div></div><div layout=\"row\" layout-align=\"center center\" \nstyle=\"margin-top: -2%\"><div flex-gt-sm=\"35\">SBU</div><div flex-gt-sm=\"35\"><md-input-container class=\"md-block margin\">\n<md-select ng-model=\"doaUpdate.sbu\" multiple=\"multiple\" ng-required=\"true\" \nstyle=\"border: 1px solid rgb(169, 161, 161);border-radius: 3px;margin-bottom: -10%;height: 30px; margin-top: -8%\">\n<md-option value=\"*\">All</md-option><md-option ng-value=\"sbu.SBU\" ng-repeat=\"sbu in allsbus | orderBy:\'SBU\'\">\n{{sbu.SBU}}-({{sbu.DESCRIPTION}})</md-option></md-select></md-input-container></div></div><div layout=\"row\" \nlayout-align=\"center center\" style=\"margin-top: 0%\"><div flex-gt-sm=\"35\">Location</div><div flex-gt-sm=\"35\">\n<md-input-container class=\"md-block margin\"><md-select ng-model=\"doaUpdate.location\" multiple=\"multiple\" \nng-required=\"true\" \nstyle=\"border: 1px solid hsl(0, 4%, 65%);border-radius: 3px;margin-bottom: -10%;height: 30px; margin-top: -8%\">\n<md-option value=\"*\">All</md-option><md-option ng-value=\"location.LOCATION\" \nng-repeat=\"location in AllLocations | orderBy:\'LOCATION\'\">{{location.LOCATION}}-({{location.DESCRIPTION}})</md-option>\n</md-select></md-input-container></div></div><div layout=\"row\" layout-align=\"center center\" style=\"margin-top: 0%\"><div\n flex-gt-sm=\"35\">Department</div><div flex-gt-sm=\"35\"><md-input-container class=\"md-block margin\"><md-select \nng-model=\"doaUpdate.department\" multiple=\"multiple\" ng-required=\"true\" \nstyle=\"border: 1px solid rgb(169, 161, 161);border-radius: 3px;margin-bottom: -10%;height: 30px; margin-top: -8%\">\n<md-option value=\"*\">All</md-option><md-option ng-value=\"dept.DEPT\" ng-repeat=\"dept in AllDepts | orderBy:\'DEPT\'\">\n{{dept.DEPT}}-({{dept.DESCRIPTION}})</md-option></md-select></md-input-container></div></div></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" layout-align=\"center center\"><md-button type=\"button\" ng-click=\"cancel()\">Cancel\n</md-button><md-button type=\"submit\" ng-click=\" DoaupdateReport.$valid && updatesave(doaUpdate)\">Save</md-button>\n</md-dialog-actions></div></form></md-dialog>");
$templateCache.put("app/main/administration/doa-reports/doa-reports.html","<style>table.dataTable tbody td {\n      vertical-align: middle;\n         padding: 0px;\n     }</style><div \nclass=\"page-layout simple right-sidenav\" layout=\"row\"><div ng-include=\"\'app/main/administration/common/admin.html\'\">\n</div><div class=\"page-layout carded fullwidth md-padding scrollable\" layout=\"column\" flex ms-scroll><div \nclass=\"widget-group\" flex=\"100\" layout=\"column\" layout-wrap><ms-widget flippable=\"true\" class=\"no-padding\"><div \nclass=\"parent-tabs white-bg mb-15\"><md-tabs class=\"mh-0\"><md-tab label=\"DOA Reports Configuration\" \nui-sref=\"app.administration.doaReports\" md-active=\"true\"></md-tab></md-tabs></div><div class=\"md-padding white-bg\" \nng-init=\" doCtrl.getAllDoaReports()\"><div layout=\"row\" flex=\"100\" layout=\"row\" layout-align=\"end end\">\n<md-input-container flex-gt-sm=\"15\" class=\"md-block\" \nstyle=\"border: 1px solid rgb(169, 161, 161);margin-top: 0%;border-radius: 5px;height: 35px;margin-right: 1%\"><input \nng-model=\"searchUser\" type=\"text\" placeholder=\"Global Filter\"></md-input-container><md-input-container \nclass=\"md-block\" flex-gt-sm=\"5\"><label>Size</label><md-select ng-change=\"sizeselect(size)\" ng-model=\"size\"><md-option \nvalue=\"100\">100</md-option><md-option value=\"200\">200</md-option><md-option value=\"400\">400</md-option><md-option \nvalue=\"500\">500</md-option></md-select></md-input-container></div><table class=\"dataTable row-border hover\"><thead><tr \nstyle=\"background-color: #dee7f4 !important\"><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Request Type</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">user</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Sbu</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Location</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Department</span></div></th><th class=\"secondary-text\"><div class=\"table-header\" layout=\"row\" \nlayout-align=\"center center\"><span class=\"column-title\">Actions</span></div></th></tr></thead><tbody><tr \nng-repeat=\"doa in Doareports | filter : searchUser\"><td><span ng-repeat=\"reqType in doa.requestTypes\">{{reqType}} <span\n ng-if=\"!$last\">,</span></span></td><td>{{doa.user}}</td><td><span ng-repeat=\"sbu in doa.sbu\">{{sbu}} <span \nng-if=\"!$last\">,</span></span></td><td><span ng-repeat=\"location in doa.location\">{{location}} <span ng-if=\"!$last\">,\n</span></span></td><td><span ng-repeat=\"dept in doa.department\">{{dept}}<span ng-if=\"!$last\">,</span></span></td><td \nlayout=\"row\" layout-align=\"center center\" style=\"padding-top:0px !important;padding-bottom:0px !important\"><md-button \nclass=\"md-icon-button test-tooltip\" aria-label=\"Update\" ng-click=\"doCtrl.updateDoaDialog($event,doa)\"><md-tooltip \nmd-direction=\"top\">Update</md-tooltip><md-icon><i layout=\"row\" layout-align=\"center center\" \nclass=\"icon icon-pencil s20\"></i></md-icon></md-button><md-button class=\"md-icon-button test-tooltip\" \naria-label=\"Delete\" ng-click=\"deleteDoaReports ($event, doa) \"><md-tooltip md-direction=\"top\">Delete</md-tooltip>\n<md-icon><i layout=\"row\" layout-align=\"center center\" class=\"icon icon-delete s20\"></i></md-icon></md-button></td></tr>\n</tbody></table><div layout=\"row\" layout-align=\"space-between center\" flex=\"100\"><div layout=\"row\" \nlayout-align=\"center center\">Page No<md-input-container class=\"md-block md-padding\" style=\"margin: 0px\"><md-select \nng-model=\"pageNumber\"><md-option ng-repeat=\"pageNumber in pageNumbers\" ng-value=\"pageNumber\" \nng-click=\"sendPageNumber(pageNumber)\" value=\"pageNumber\" ng-selected=\"$first\">{{pageNumber+1}}</md-option></md-select>\n</md-input-container></div><div layout=\"row\"><p class=\"md-padding\"><b>{{pageNumber+1}}/{{totalPages}} &nbsp;PAGES</b>\n</p></div><div layout=\"row\" layout-align=\"center center\"><div class=\"md-padding\"><h5><b>\nShowing {{(isNaN(pageNumber*size))+1}} - {{(pageNumber + 1)*size}} of {{totalRecords}} Results</b></h5></div><div>\n<md-button class=\"md-raised md-primary\" type=\"button\" ng-click=\"previous()\" ng-disabled=\"pageNumber <= 0\">Prev\n</md-button></div><div class=\"md-padding\"><md-button class=\"md-raised md-primary\" type=\"button\" ng-click=\"next()\" \nng-disabled=\"pageNumber ==totalPages -1\">Next</md-button></div></div></div></div></ms-widget></div><md-button flow-btn \nclass=\"md-fab grey-700-bg md-mini md-fab-bottom-right\" aria-label=\"Create Email\" ng-click=\"createDoaReports($event)\">\n<md-icon md-font-icon=\"icon-plus\"></md-icon><md-tooltip md-direction=\"top\">Create Doa Reports</md-tooltip></md-button>\n</div></div>");
$templateCache.put("app/main/administration/doa-reports/doaReports-createDialog.html","<md-dialog aria-label=\"Add a new user\" flex=\"40\"><form name=\"DoaReport\"><div><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools\"><h2>Create Reports Config</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"cancel()\"><md-icon md-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"column\" \nflex-gt-sm=\"100\"><div layout=\"row\" layout-align=\"center center\"><div flex-gt-sm=\"35\" layout=\"row\">Request Type</div>\n<div flex-gt-sm=\"35\"><md-input-container class=\"md-block margin\"><md-select ng-model=\"doa.requestTypes\" \nmultiple=\"multiple\" \nstyle=\"border: 1px solid rgb(169, 161, 161);border-radius: 3px;margin-bottom: -10%;height: 30px; margin-top: -3%\">\n<md-option value=\"All\">All</md-option><md-option value=\"CEP_FORM\">CEP_FORM</md-option><md-option value=\"EOR_FORM\">\nEOR_FORM</md-option><md-option value=\"GENERAL_FORM\">GENERAL_FORM</md-option><md-option value=\"RFWD_FORM\">RFWD_FORM\n</md-option><md-option value=\"SCEP_FORM\">SCEP_FORM</md-option><md-option value=\"VENDOR_FORM\">VENDOR_FORM</md-option>\n<md-option value=\"COR_ADV\">COR_ADV</md-option></md-select></md-input-container></div></div><div layout=\"row\" \nlayout-align=\"center center\"><div flex-gt-sm=\"35\" layout=\"row\">User Id</div><div flex-gt-sm=\"35\"><input type=\"text\" \nplaceholder=\"\" ng-model=\"doa.user\" list=\"names\" \nstyle=\"border: 1px solid rgb(169, 161, 161);\n                    margin-top: 9px; margin-bottom: 7%; height: 30px; border-radius: 3px;width: 99%\">\n<datalist id=\"names\" class=\"form-control\" ng-model=\"obj.currentUser\"><option value=\"\">-- select an option --</option>\n<option ng-repeat=\"person in usersList | filter:search \" ng-value=\"person.login\">\n{{person.firstName}}-{{person.lastName}}</option></datalist></div></div><div layout=\"row\" layout-align=\"center center\" \nstyle=\"margin-top: -2%\"><div flex-gt-sm=\"35\">SBU</div><div flex-gt-sm=\"35\"><md-input-container class=\"md-block margin\">\n<md-select ng-model=\"doa.sbu\" multiple=\"multiple\" ng-required=\"true\" \nstyle=\"border: 1px solid rgb(169, 161, 161);border-radius: 3px;margin-bottom: -10%;height: 30px; margin-top: -8%\">\n<md-option value=\"*\">All</md-option><md-option ng-hide=\"doa.sbu == \'*\' \" ng-value=\"sbu.SBU\" \nng-repeat=\"sbu in allsbus | orderBy:\'SBU\'\">{{sbu.SBU}}-({{sbu.DESCRIPTION}})</md-option></md-select>\n</md-input-container></div></div><div layout=\"row\" layout-align=\"center center\" style=\"margin-top: 0%\"><div \nflex-gt-sm=\"35\">Location</div><div flex-gt-sm=\"35\"><md-input-container class=\"md-block margin\"><md-select \nng-model=\"doa.location\" multiple=\"multiple\" ng-required=\"true\" \nstyle=\"border: 1px solid hsl(0, 4%, 65%);border-radius: 3px;margin-bottom: -10%;height: 30px; margin-top: -8%\">\n<md-option value=\"*\">All</md-option><md-option ng-hide=\"doa.location == \'*\' \" ng-value=\"location.LOCATION\" \nng-repeat=\"location in AllLocations | orderBy:\'LOCATION\'\">{{location.LOCATION}}-({{location.DESCRIPTION}})</md-option>\n</md-select></md-input-container></div></div><div layout=\"row\" layout-align=\"center center\" style=\"margin-top: 0%\"><div\n flex-gt-sm=\"35\">Department</div><div flex-gt-sm=\"35\"><md-input-container class=\"md-block margin\"><md-select \nng-model=\"doa.department\" multiple=\"multiple\" ng-required=\"true\" \nstyle=\"border: 1px solid rgb(169, 161, 161);border-radius: 3px;margin-bottom: -10%;height: 30px; margin-top: -8%\">\n<md-option value=\"*\">All</md-option><md-option ng-hide=\"doa.department == \'*\' \" ng-value=\"dept.DEPT\" \nng-repeat=\"dept in AllDepts | orderBy:\'DEPT\'\">{{dept.DEPT}}-({{dept.DESCRIPTION}})</md-option></md-select>\n</md-input-container></div></div></div></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"center center\"><md-button type=\"button\" ng-click=\"cancel()\">Cancel</md-button><md-button type=\"submit\" \nng-click=\"DoaReport.$valid && save(doa)\">Save</md-button></md-dialog-actions></div></form></md-dialog>");
$templateCache.put("app/main/administration/requestTypeDetails/create.requestTypeDeatils.html","<md-dialog aria-label=\"Add a new object\" flex=\"30\"><form name=\"objectCreateForm\" novalidate \nng-submit=\"objectCreateForm.$valid && bsCtrl.createObject(object,field1,field2,field3,field4)\" layout=\"column\" \nflex=\"66\"><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2>Create RequestType</h2><span flex></span>\n<md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content class=\"scrollable\" ms-scroll><md-input-container class=\"md-block\" \nflex-gt-sm><label>Label</label><input type=\"text\" name=\"title\" ng-model=\"object.title\"></md-input-container>\n<md-input-container class=\"md-block\" flex-gt-sm><label>RequestType</label><md-select ng-model=\"object.requestType\">\n<md-option ng-repeat=\"doc in Documents\" ng-value=\"doc.name\">{{doc.name}}</md-option></md-select></md-input-container>\n<div layout=\"row\"><md-input-container class=\"md-block\" flex-gt-sm><label>F1label</label><input type=\"text\" \nname=\"F1label\" ng-model=\"object.field1.label\"></md-input-container><span flex=\"5\"></span><md-input-container \nclass=\"md-block\" flex-gt-sm><label>F1Name</label><input type=\"text\" name=\"F1Name\" ng-model=\"object.field1.name\">\n</md-input-container></div><div layout=\"row\"><md-input-container class=\"md-block\" flex-gt-sm><label>F2label</label>\n<input type=\"text\" name=\"F2label\" ng-model=\"object.field2.label\"></md-input-container><span flex=\"5\"></span>\n<md-input-container class=\"md-block\" flex-gt-sm><label>F2Name</label><input type=\"text\" name=\"F2Name\" \nng-model=\"object.field2.name\"></md-input-container></div><div layout=\"row\"><md-input-container class=\"md-block\" \nflex-gt-sm><label>F3label</label><input type=\"text\" name=\"F3label\" ng-model=\"object.field3.label\"></md-input-container>\n<span flex=\"5\"></span><md-input-container class=\"md-block\" flex-gt-sm><label>F3Name</label><input type=\"text\" \nname=\"F3Name\" ng-model=\"object.field3.name\"></md-input-container></div><div layout=\"row\"><md-input-container \nclass=\"md-block\" flex-gt-sm><label>F4label</label><input type=\"text\" name=\"F4label\" ng-model=\"object.field4.label\">\n</md-input-container><span flex=\"5\"></span><md-input-container class=\"md-block\" flex-gt-sm><label>F4Name</label><input \ntype=\"text\" name=\"F4Name\" ng-model=\"object.field4.name\"></md-input-container></div><div layout=\"row\">\n<md-input-container class=\"md-block\" flex-gt-sm><label>F5label</label><input type=\"text\" name=\"F5label\" \nng-model=\"object.field5.label\"></md-input-container><span flex=\"5\"></span><md-input-container class=\"md-block\" \nflex-gt-sm><label>F5Name</label><input type=\"text\" name=\"F5Name\" ng-model=\"object.field5.name\"></md-input-container>\n</div><div layout=\"row\"><md-input-container class=\"md-block\" flex-gt-sm><label>F6label</label><input type=\"text\" \nname=\"F6label\" ng-model=\"object.field6.label\"></md-input-container><span flex=\"5\"></span><md-input-container \nclass=\"md-block\" flex-gt-sm><label>F6Name</label><input type=\"text\" name=\"F6Name\" ng-model=\"object.field6.name\">\n</md-input-container></div><div layout=\"row\"><md-input-container class=\"md-block\" flex-gt-sm><label>F7label</label>\n<input type=\"text\" name=\"F7label\" ng-model=\"object.field7.label\"></md-input-container><span flex=\"5\"></span>\n<md-input-container class=\"md-block\" flex-gt-sm><label>F7Name</label><input type=\"text\" name=\"F7Name\" \nng-model=\"object.field7.name\"></md-input-container></div><div layout=\"row\"><md-input-container class=\"md-block\" \nflex-gt-sm><label>F8label</label><input type=\"text\" name=\"F7label\" ng-model=\"object.field8.label\"></md-input-container>\n<span flex=\"5\"></span><md-input-container class=\"md-block\" flex-gt-sm><label>F8Name</label><input type=\"text\" \nname=\"F8Name\" ng-model=\"object.field8.name\"></md-input-container></div><div layout=\"row\"><md-input-container \nclass=\"md-block\" flex-gt-sm><label>F9label</label><input type=\"text\" name=\"F7label\" ng-model=\"object.field9.label\">\n</md-input-container><span flex=\"5\"></span><md-input-container class=\"md-block\" flex-gt-sm><label>F9Name</label><input \ntype=\"text\" name=\"F9Name\" ng-model=\"object.field9.name\"></md-input-container></div><div layout=\"row\">\n<md-input-container class=\"md-block\" flex-gt-sm><label>F10label</label><input type=\"text\" name=\"F10label\" \nng-model=\"object.field10.label\"></md-input-container><span flex=\"5\"></span><md-input-container class=\"md-block\" \nflex-gt-sm><label>F10Name</label><input type=\"text\" name=\"F10Name\" ng-model=\"object.field10.name\"></md-input-container>\n</div><div layout=\"row\"><md-input-container class=\"md-block\" flex-gt-sm><label>F11label</label><input type=\"text\" \nname=\"F11label\" ng-model=\"object.field11.label\"></md-input-container><span flex=\"5\"></span><md-input-container \nclass=\"md-block\" flex-gt-sm><label>F11Name</label><input type=\"text\" name=\"F11Name\" ng-model=\"object.field11.name\">\n</md-input-container></div><div layout=\"row\"><md-input-container class=\"md-block\" flex-gt-sm><label>F12label</label>\n<input type=\"text\" name=\"F12label\" ng-model=\"object.field12.label\"></md-input-container><span flex=\"5\"></span>\n<md-input-container class=\"md-block\" flex-gt-sm><label>F12Name</label><input type=\"text\" name=\"F12Name\" \nng-model=\"object.field12.name\"></md-input-container></div><div layout=\"row\"><md-input-container class=\"md-block\" \nflex-gt-sm><label>F13label</label><input type=\"text\" name=\"F13label\" ng-model=\"object.field13.label\">\n</md-input-container><span flex=\"5\"></span><md-input-container class=\"md-block\" flex-gt-sm><label>F13Name</label><input\n type=\"text\" name=\"F13Name\" ng-model=\"object.field13.name\"></md-input-container></div><div layout=\"row\">\n<md-input-container class=\"md-block\" flex-gt-sm><label>F14label</label><input type=\"text\" name=\"F14label\" \nng-model=\"object.field14.label\"></md-input-container><span flex=\"5\"></span><md-input-container class=\"md-block\" \nflex-gt-sm><label>F14Name</label><input type=\"text\" name=\"F14Name\" ng-model=\"object.field14.name\"></md-input-container>\n</div><div layout=\"row\"><md-input-container class=\"md-block\" flex-gt-sm><label>F15label</label><input type=\"text\" \nname=\"F15label\" ng-model=\"object.field15.label\"></md-input-container><span flex=\"5\"></span><md-input-container \nclass=\"md-block\" flex-gt-sm><label>F15Name</label><input type=\"text\" name=\"F15Name\" ng-model=\"object.field15.name\">\n</md-input-container></div><div layout=\"row\"><md-input-container class=\"md-block\" flex-gt-sm><label>F16label</label>\n<input type=\"text\" name=\"F16label\" ng-model=\"object.field16.label\"></md-input-container><span flex=\"5\"></span>\n<md-input-container class=\"md-block\" flex-gt-sm><label>F16Name</label><input type=\"text\" name=\"F16Name\" \nng-model=\"object.field16.name\"></md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"center center\"><md-button type=\"button\" ng-click=\"cancel()\">Cancel</md-button><md-button type=\"submit\" \nng-click=\"objectCreateForm.$valid && save(object) \">Save</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/administration/requestTypeDetails/requestTypeDeatils.html","<div class=\"page-layout simple right-sidenav\" layout=\"row\"><div \nng-include=\"\'app/main/administration/common/admin.html\'\"></div><div \nclass=\"page-layout carded fullwidth md-padding scrollable\" layout=\"column\" flex ms-scroll><div class=\"widget-group\" \nflex=\"100\" layout=\"column\" layout-wrap><ms-widget flippable=\"true\" class=\"no-padding\"><div \nclass=\"parent-tabs white-bg mb-15\"><md-tabs class=\"mh-0\"><md-tab label=\"RequestType Details\" md-active=\"true\"></md-tab>\n</md-tabs></div><div class=\"md-padding white-bg\"><table class=\"dataTable row-border hover table-border\" datatable=\"ng\" \ndt-options=\"reqTypeCtrl.dtOptions\"><thead><tr class=\"table-header\"><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">DocumentType</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Label</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Field1</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Field2</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Field3</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Field4</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Field5</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Field6</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\" layout=\"row\" layout-align=\"center center\"><span class=\"column-title\">Actions</span></div></th>\n</tr></thead><tbody><tr ng-repeat=\"type in RequestTypes\"><td>{{type.requestType}}</td><td>{{type.title}}</td><td>\n{{type.field1.name}}</td><td>{{type.field2.name}}</td><td>{{type.field3.name}}</td><td>{{type.field4.name}}</td><td>\n{{type.field5.name}}</td><td>{{type.field6.name}}</td><td layout=\"row\" layout-align=\"center center\" \nstyle=\"padding-top:0px !important;padding-bottom:0px !important\"><md-button class=\"md-icon-button test-tooltip\" \naria-label=\"Update\" ng-click=\"updateRequestDetails($event,type)\"><md-tooltip md-direction=\"top\">Update</md-tooltip>\n<md-icon><i layout=\"row\" layout-align=\"center center\" class=\"icon icon-pencil s18\"></i></md-icon></md-button><md-button\n class=\"md-icon-button test-tooltip\" aria-label=\"Delete\" ng-click=\"deleteRequestDetails($event, type) \"><md-tooltip \nmd-direction=\"top\">Delete</md-tooltip><md-icon><i layout=\"row\" layout-align=\"center center\" \nclass=\"icon icon-delete s18\"></i></md-icon></md-button></td></tr></tbody></table></div></ms-widget></div><md-button \nflow-btn class=\"md-fab grey-700-bg md-mini md-fab-bottom-right add_btn\" aria-label=\"Create User\" \nng-click=\"createZohoReport($event)\"><md-icon md-font-icon=\"icon-plus\"></md-icon><md-tooltip md-direction=\"top\">\nCreate RequestType</md-tooltip></md-button></div></div>");
$templateCache.put("app/main/administration/requestTypeDetails/update.requestTypeDeatils.html","<md-dialog aria-label=\"Add a new object\" flex=\"30\"><form name=\"objectCreateForm\" novalidate \nng-submit=\"objectCreateForm.$valid && bsCtrl.createObject(object)\" layout=\"column\" flex=\"66\"><md-toolbar \nclass=\"md-accent\"><div class=\"md-toolbar-tools\"><h2>Update Request Deatails</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content class=\"scrollable\" ms-scroll><md-input-container class=\"md-block\" \nflex-gt-sm><label>Label</label><input type=\"text\" name=\"title\" ng-model=\"object.title\"></md-input-container>\n<md-input-container class=\"md-block\" flex-gt-sm><label>RequestType</label><md-select ng-model=\"object.requestType\">\n<md-option ng-repeat=\"doc in Documents\" ng-value=\"doc.name\">{{doc.name}}</md-option></md-select></md-input-container>\n<div layout=\"row\"><md-input-container class=\"md-block\" flex-gt-sm><label>F1label</label><input type=\"text\" \nname=\"F1label\" ng-model=\"object.field1.label\"></md-input-container><span flex=\"5\"></span><md-input-container \nclass=\"md-block\" flex-gt-sm><label>F1Name</label><input type=\"text\" name=\"F1Name\" ng-model=\"object.field1.name\">\n</md-input-container></div><div layout=\"row\"><md-input-container class=\"md-block\" flex-gt-sm><label>F2label</label>\n<input type=\"text\" name=\"F2label\" ng-model=\"object.field2.label\"></md-input-container><span flex=\"5\"></span>\n<md-input-container class=\"md-block\" flex-gt-sm><label>F2Name</label><input type=\"text\" name=\"F2Name\" \nng-model=\"object.field2.name\"></md-input-container></div><div layout=\"row\"><md-input-container class=\"md-block\" \nflex-gt-sm><label>F3label</label><input type=\"text\" name=\"F3label\" ng-model=\"object.field3.label\"></md-input-container>\n<span flex=\"5\"></span><md-input-container class=\"md-block\" flex-gt-sm><label>F3Name</label><input type=\"text\" \nname=\"F3Name\" ng-model=\"object.field3.name\"></md-input-container></div><div layout=\"row\"><md-input-container \nclass=\"md-block\" flex-gt-sm><label>F4label</label><input type=\"text\" name=\"F4label\" ng-model=\"object.field4.label\">\n</md-input-container><span flex=\"5\"></span><md-input-container class=\"md-block\" flex-gt-sm><label>F4Name</label><input \ntype=\"text\" name=\"F4Name\" ng-model=\"object.field4.name\"></md-input-container></div><div layout=\"row\">\n<md-input-container class=\"md-block\" flex-gt-sm><label>F5label</label><input type=\"text\" name=\"F5label\" \nng-model=\"object.field5.label\"></md-input-container><span flex=\"5\"></span><md-input-container class=\"md-block\" \nflex-gt-sm><label>F5Name</label><input type=\"text\" name=\"F5Name\" ng-model=\"object.field5.name\"></md-input-container>\n</div><div layout=\"row\"><md-input-container class=\"md-block\" flex-gt-sm><label>F6label</label><input type=\"text\" \nname=\"F6label\" ng-model=\"object.field6.label\"></md-input-container><span flex=\"5\"></span><md-input-container \nclass=\"md-block\" flex-gt-sm><label>F6Name</label><input type=\"text\" name=\"F6Name\" ng-model=\"object.field6.name\">\n</md-input-container></div><div layout=\"row\"><md-input-container class=\"md-block\" flex-gt-sm><label>F7label</label>\n<input type=\"text\" name=\"F7label\" ng-model=\"object.field7.label\"></md-input-container><span flex=\"5\"></span>\n<md-input-container class=\"md-block\" flex-gt-sm><label>F7Name</label><input type=\"text\" name=\"F7Name\" \nng-model=\"object.field7.name\"></md-input-container></div><div layout=\"row\"><md-input-container class=\"md-block\" \nflex-gt-sm><label>F8label</label><input type=\"text\" name=\"F8label\" ng-model=\"object.field8.label\"></md-input-container>\n<span flex=\"5\"></span><md-input-container class=\"md-block\" flex-gt-sm><label>F8Name</label><input type=\"text\" \nname=\"F8Name\" ng-model=\"object.field8.name\"></md-input-container></div><div layout=\"row\"><md-input-container \nclass=\"md-block\" flex-gt-sm><label>F9label</label><input type=\"text\" name=\"F9label\" ng-model=\"object.field9.label\">\n</md-input-container><span flex=\"5\"></span><md-input-container class=\"md-block\" flex-gt-sm><label>F9Name</label><input \ntype=\"text\" name=\"F9Name\" ng-model=\"object.field9.name\"></md-input-container></div><div layout=\"row\">\n<md-input-container class=\"md-block\" flex-gt-sm><label>F10label</label><input type=\"text\" name=\"F10label\" \nng-model=\"object.field10.label\"></md-input-container><span flex=\"5\"></span><md-input-container class=\"md-block\" \nflex-gt-sm><label>F10Name</label><input type=\"text\" name=\"F10Name\" ng-model=\"object.field10.name\"></md-input-container>\n</div><div layout=\"row\"><md-input-container class=\"md-block\" flex-gt-sm><label>F11label</label><input type=\"text\" \nname=\"F11label\" ng-model=\"object.field11.label\"></md-input-container><span flex=\"5\"></span><md-input-container \nclass=\"md-block\" flex-gt-sm><label>F11Name</label><input type=\"text\" name=\"F11Name\" ng-model=\"object.field11.name\">\n</md-input-container></div><div layout=\"row\"><md-input-container class=\"md-block\" flex-gt-sm><label>F12label</label>\n<input type=\"text\" name=\"F12label\" ng-model=\"object.field12.label\"></md-input-container><span flex=\"5\"></span>\n<md-input-container class=\"md-block\" flex-gt-sm><label>F12Name</label><input type=\"text\" name=\"F12Name\" \nng-model=\"object.field12.name\"></md-input-container></div><div layout=\"row\"><md-input-container class=\"md-block\" \nflex-gt-sm><label>F13label</label><input type=\"text\" name=\"F13label\" ng-model=\"object.field13.label\">\n</md-input-container><span flex=\"5\"></span><md-input-container class=\"md-block\" flex-gt-sm><label>F13Name</label><input\n type=\"text\" name=\"F13Name\" ng-model=\"object.field13.name\"></md-input-container></div><div layout=\"row\">\n<md-input-container class=\"md-block\" flex-gt-sm><label>F14label</label><input type=\"text\" name=\"F14label\" \nng-model=\"object.field14.label\"></md-input-container><span flex=\"5\"></span><md-input-container class=\"md-block\" \nflex-gt-sm><label>F14Name</label><input type=\"text\" name=\"F14Name\" ng-model=\"object.field14.name\"></md-input-container>\n</div><div layout=\"row\"><md-input-container class=\"md-block\" flex-gt-sm><label>F15label</label><input type=\"text\" \nname=\"F15label\" ng-model=\"object.field15.label\"></md-input-container><span flex=\"5\"></span><md-input-container \nclass=\"md-block\" flex-gt-sm><label>F15Name</label><input type=\"text\" name=\"F15Name\" ng-model=\"object.field15.name\">\n</md-input-container></div><div layout=\"row\"><md-input-container class=\"md-block\" flex-gt-sm><label>F16label</label>\n<input type=\"text\" name=\"F16label\" ng-model=\"object.field16.label\"></md-input-container><span flex=\"5\"></span>\n<md-input-container class=\"md-block\" flex-gt-sm><label>F16Name</label><input type=\"text\" name=\"F16Name\" \nng-model=\"object.field16.name\"></md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"center center\"><md-button type=\"button\" ng-click=\"cancel()\">Cancel</md-button><md-button type=\"submit\" \nng-click=\"objectCreateForm.$valid && update(object) \">Save</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/administration/Template/create.template.html","<md-dialog flex=\"45\"><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2>Create Template</h2><span flex>\n</span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><form name=\"template\" novalidate layout=\"column\"><div layout=\"row\">\n<div flex=\"35\" layout=\"column\" layout-align=\"center end\"><span class=\"h3\"><b>Template Name </b></span></div><span \nflex=\"10\"></span><md-input-container flex=\"45\" class=\"md-block\" layout=\"column\" layout-align=\"space-around start\" \nstyle=\"margin-bottom: -11px\"><input type=\"text\" name=\"name\" ng-model=\"test.name\" placeholder=\"Template name\" required>\n</md-input-container></div><div layout=\"row\"><div flex=\"35\" layout=\"column\" layout-align=\"center end\"><span class=\"h3\">\n<b>Description </b></span></div><span flex=\"10\"></span><md-input-container flex=\"45\" class=\"md-block\" layout=\"column\" \nlayout-align=\"space-around start\" style=\"padding-top: 0px !important;padding-bottom: 0px !important\"><input \ntype=\"text\" name=\"name\" ng-model=\"test.description\" placeholder=\"Description\" required></md-input-container></div><div \nlayout=\"row\"><div flex=\"35\" layout=\"column\" layout-align=\"center end\"><span class=\"h3\"><b>DocumentType </b></span>\n</div><span flex=\"10\"></span><md-select ng-model=\"test.documentType\" placeholder=\"DocumentType\" flex=\"45\" \nstyle=\"margin-top:0px !important\"><md-option ng-value=\"doc.name\" ng-repeat=\"doc in Documents\">{{doc.name}}</md-option>\n</md-select></div><div layout=\"row\"><div flex=\"35\" layout=\"column\" layout-align=\"center end\"><span class=\"h3\"><b>\nTemplate File</b></span></div><span flex=\"10\"></span><div flex=\"45\" layout=\"column\" layout-align=\"center start\"><input \nclass=\"ng-hide\" id=\"formUploadFile\" name=\"formUploadFile\" type=\"file\" \nonchange=\"angular.element(this).scope().setFile(this)\"><label for=\"formUploadFile\" \nclass=\"md-button md-raised md-accent\">Browse</label></div></div><div><div ng-repeat=\"file in files.slice(0)\" \nlayout=\"row\" layout-align=\"center center\"><span class=\"md-warn\">{{file.webkitRelativePath || file.name}}</span> (<span \nng-switch=\"file.size > 1024*1024\"> <span ng-switch-when=\"true\">{{file.size / 1024 / 1024 | number:2}} MB</span> <span \nng-switch-default>{{file.size / 1024 | number:2}} kB</span> </span>)</div></div></form></md-dialog-content>\n<md-dialog-actions layout=\"row\"><span flex></span><md-button ng-click=\"cancel()\">Cancel</md-button><md-button \nng-click=\"save($event,test)\">Save</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/administration/Template/template.content.html","<style>\n.mh-0 {\n    min-height: 0px !important;\n}\n.parent-tabs > md-tabs .md-tab.md-active:after{\n    content: \" \";\n    border-left: 7px solid transparent;\n    border-right: 7px solid transparent;\n    border-bottom: 7px solid #efefef;\n    position: absolute;\n    display: block;\n    top: 87%;\n    left: 50%;\n   \n}\n.parent-tabs > md-tabs md-ink-bar {\n    background: none; \n}\n.parent-tabs > md-tabs .md-tab:hover {\n    color: #389cec !important;\n}\n.md-tab {\n  \n  text-transform: none;\n  }\n  .table-border {\n    border: 1px solid #d3d3d3 !important;\n}\n.table-header {\n    background-color: #dee7f4 !important;\n    text-transform: uppercase;\n    font-size: 11px!important;\n}\n</style><div class=\"page-layout simple right-sidenav\" layout-gt-xs=\"row\"><div \nng-include=\"\'app/main/administration/common/admin.html\'\"></div><div \nclass=\"page-layout carded fullwidth md-padding scrollable\" layout=\"column\" flex ms-scroll><div class=\"widget-group\" \nflex=\"100\" layout=\"column\" layout-wrap><ms-widget flippable=\"true\" class=\"no-padding\"><div \nclass=\"parent-tabs white-bg mb-15\"><md-tabs class=\"mh-0\"><md-tab label=\"Templates\" md-active=\"true\"></md-tab></md-tabs>\n</div><div class=\"md-padding white-bg\"><table class=\"dataTable row-border hover table-border\" datatable=\"ng\" \ndt-options=\"templateCtrl.dtOptions\"><thead><tr class=\"table-header\"><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">TemplateName</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Description</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">DocumentType</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\" layout=\"row\" layout-align=\"center center\"><span class=\"column-title\">File</span></div></th></tr>\n</thead><tbody><tr ng-repeat=\"template in templates\"><td>{{template.name}}</td><td>{{template.description}}</td><td>\n{{template.documentType}}</td><td layout=\"row\" layout-align=\"center center\" \nstyle=\"padding-top:0px !important;padding-bottom:0px !important\"><md-button id=\"{{template.id}}\" \nclass=\"md-icon-button test-tooltip\" aria-label=\"Update\" \nonclick=\"angular.element(this).scope().updateTemplateDialog(this)\"><md-tooltip md-direction=\"top\">Update</md-tooltip>\n<md-icon><i layout=\"row\" layout-align=\"center center\" class=\"icon icon-pencil s18\"></i></md-icon></md-button><md-button\n id=\"{{template.id}}\" class=\"md-icon-button test-tooltip\" aria-label=\"Delete\" \nonclick=\"angular.element(this).scope().templateDelete(this)\"><md-tooltip md-direction=\"top\">Delete</md-tooltip>\n<md-icon><i layout=\"row\" layout-align=\"center center\" class=\"icon icon-delete s18\"></i></md-icon></md-button><md-button\n id=\"{{template.id}}\" class=\"md-icon-button test-tooltip\" aria-label=\"Display\" \nonclick=\"angular.element(this).scope().previewFile(this)\"><md-tooltip md-direction=\"top\">Display</md-tooltip><md-icon>\n<i layout=\"row\" layout-align=\"center center\" class=\"icon icon-login s18\"></i></md-icon></md-button></td></tr></tbody>\n</table></div></ms-widget></div><md-button flow-btn class=\"md-fab grey-700-bg md-mini md-fab-bottom-right add_btn\" \nng-click=\"createTemplateDialog(ev)\"><md-icon md-font-icon=\"icon-plus\"></md-icon><md-tooltip md-direction=\"top\">\nCreate Template</md-tooltip></md-button></div></div>");
$templateCache.put("app/main/administration/Template/template.preview.html","<md-dialog style=\"height: 100%; width: 100%\"><md-dialog-content class=\"no-padding\"><iframe id=\"iframe\" \nsrc=\"{{fileURL}}\" name=\"contentframe\" frameborder=\"0\" \nstyle=\"width: 100%; height: 100%; position: absolute; z-index: 999\"></iframe></md-dialog-content></md-dialog>");
$templateCache.put("app/main/administration/Template/update.template.html","<md-dialog flex=\"45\"><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2>Update Template</h2><span flex>\n</span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><form name=\"template\" novalidate layout=\"column\"><div layout=\"row\">\n<div flex=\"35\" layout=\"column\" layout-align=\"center end\"><span class=\"h3\"><b>Template Name </b></span></div><span \nflex=\"10\"></span><md-input-container flex=\"45\" class=\"md-block\" layout=\"column\" layout-align=\"space-around start\" \nstyle=\"margin-bottom: -11px\"><input type=\"text\" name=\"name\" ng-model=\"currentTemplate.name\" disabled=\"disabled\" \nplaceholder=\"Template name\" required></md-input-container></div><div layout=\"row\"><div flex=\"35\" layout=\"column\" \nlayout-align=\"center end\"><span class=\"h3\"><b>Description </b></span></div><span flex=\"10\"></span><md-input-container \nflex=\"45\" class=\"md-block\" layout=\"column\" layout-align=\"space-around start\" \nstyle=\"padding-top: 0px !important;padding-bottom: 0px !important\"><input type=\"text\" name=\"name\" \nng-model=\"currentTemplate.description\" placeholder=\"Description\" required></md-input-container></div><div layout=\"row\">\n<div flex=\"35\" layout=\"column\" layout-align=\"center end\"><span class=\"h3\"><b>DocumentType </b></span></div><span \nflex=\"10\"></span><md-select ng-model=\"currentTemplate.documentType\" placeholder=\"DocumentType\" flex=\"45\" \nstyle=\"margin-top:0px !important\"><md-option ng-value=\"doc.name\" ng-repeat=\"doc in Documents\">{{doc.name}}</md-option>\n</md-select></div><div layout=\"row\"><div flex=\"35\" layout=\"column\" layout-align=\"center end\"><span class=\"h3\"><b>\nTemplate File</b></span></div><span flex=\"10\"></span><div flex=\"45\" layout=\"column\" layout-align=\"center start\"><input \nclass=\"ng-hide\" id=\"formUploadFile\" name=\"formUploadFile\" type=\"file\" \nonchange=\"angular.element(this).scope().setFile(this)\"><label for=\"formUploadFile\" \nclass=\"md-button md-raised md-accent\">Browse</label></div></div><div><div ng-repeat=\"file in files.slice(0)\" \nlayout=\"row\" layout-align=\"center center\"><span class=\"md-warn\">{{file.webkitRelativePath || file.name}}</span> (<span \nng-switch=\"file.size > 1024*1024\"> <span ng-switch-when=\"true\">{{file.size / 1024 / 1024 | number:2}} MB</span> <span \nng-switch-default>{{file.size / 1024 | number:2}} kB</span> </span>)</div></div></form></md-dialog-content>\n<md-dialog-actions layout=\"row\"><span flex></span><md-button ng-click=\"cancel()\">Cancel</md-button><md-button \nng-click=\"update($event,currentTemplate)\">Update</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/administration/system-logs/system_logs.html","<style>\ntable.dataTable tbody td {\n         vertical-align: middle;\n         padding: 10px;\n           }\n           .error{\n              color: red;\n           }\n</style><div class=\"page-layout simple right-sidenav\" layout=\"row\" ng-init=\"systemCtrl.getallSystemlogs()\"><div \nng-include=\"\'app/main/administration/common/admin.html\'\"></div><div \nclass=\"page-layout carded fullwidth md-padding scrollable\" layout=\"column\" flex ms-scroll><div class=\"widget-group\" \nflex=\"100\" layout=\"column\" layout-wrap><ms-widget flippable=\"true\" class=\"no-padding\"><div \nclass=\"parent-tabs white-bg mb-15\"><md-tabs class=\"mh-0\"><md-tab label=\"System Logs\" \nui-sref=\"app.administration.systemLogs\" md-active=\"true\"></md-tab></md-tabs></div><div class=\"md-padding white-bg\"><div\n layout=\"row\" flex=\"100\" layout=\"row\" layout-align=\"end end\"><md-input-container flex-gt-sm=\"15\" class=\"md-block\" \nstyle=\"border: 1px solid rgb(169, 161, 161);margin-top: 0%;border-radius: 5px;height: 35px;margin-right: 1%\"><input \nng-model=\"logObject.user\" type=\"text\" ng-keyup=\"$event.keyCode == 13 ? systemCtrl.getallSystemlogs(logObject) : \'\' \" \nplaceholder=\"Search User\"><md-icon md-font-icon=\"icon-magnify\" class=\"c-p\" \nng-click=\"systemCtrl.getallSystemlogs(logObject)\"></md-icon></md-input-container><md-input-container flex-gt-sm=\"15\" \nclass=\"md-block\" \nstyle=\"border: 1px solid rgb(169, 161, 161);margin-top: 0%;border-radius: 5px;height: 35px;margin-right: 1%\"><input \nng-model=\"searchUser\" type=\"text\" placeholder=\"Filter Table Data\"></md-input-container><md-input-container \nclass=\"md-block\" flex-gt-sm=\"5\"><label>Size</label><md-select ng-change=\"sizeselect(size)\" ng-model=\"size\"><md-option \nvalue=\"100\">100</md-option><md-option value=\"200\">200</md-option><md-option value=\"400\">400</md-option><md-option \nvalue=\"500\">500</md-option></md-select></md-input-container></div><div layout=\"row\" flex=\"60\" \nlayout-align=\"center center\" ng-if=\"allSystemlogs.length == 0\" \nstyle=\"border:2px solid #cccccc; border-radius:5px; height:50px;margin-left:20%\"><b>No Records were found</b></div>\n<table class=\"dataTable row-border hover table-border\" ng-if=\"allSystemlogs.length > 0\"><thead><tr \nclass=\"table-header\"><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Login Id</span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">User Name</span></div></th>\n<th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Ip Address</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Browser Name</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Date</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Login Status</span></div></th></tr></thead>\n<tbody><tr ng-repeat=\"log in allSystemlogs | filter : searchUser\" ng-class=\"{error:log.userName === \'Unknown User\'}\">\n<td>{{log.login}}</td><td>{{log.userName}}</td><td>{{log.remoteIpAddress}}</td><td>{{log.remoteBrowser}}</td><td>\n{{log.auditEventDate | date : \'medium\'}}</td><td style=\"padding-top:0px !important;padding-bottom:0px !important\"><i \nclass=\"icon-check green-500-fg\" ng-if=\"log.auditEventType == \'AUTHENTICATION_SUCCESS\'\"></i> <i \nclass=\"icon-close red-500-fg\" ng-if=\"log.auditEventType == \'AUTHENTICATION_FAILURE\'\"></i> <span \nng-if=\"log.auditEventType == \'AUTHENTICATION_SUCCESS\'\">Authentication Success</span> <span \nng-if=\"log.auditEventType == \'AUTHENTICATION_FAILURE\'\">Authentication Failure</span></td></tr></tbody></table><div \nlayout=\"row\" layout-align=\"space-between center\" flex=\"100\" ng-if=\"allSystemlogs.length > 0\"><div layout=\"row\" \nlayout-align=\"center center\">Page No<md-input-container class=\"md-block md-padding\" \nstyle=\"margin: -10px;margin-top: -17%\"><md-select ng-model=\"pageNumber\"><md-option \nng-repeat=\"pageNumber in pageNumbers\" ng-value=\"pageNumber\" ng-click=\"sendPageNumber(pageNumber)\" value=\"pageNumber\" \nng-selected=\"$first\">{{pageNumber+1}}</md-option></md-select></md-input-container></div><div layout=\"row\"><p \nclass=\"md-padding\"><b>{{pageNumber+1}}/{{totalPages}} &nbsp;PAGES</b></p></div><div layout=\"row\" \nlayout-align=\"center center\"><div class=\"md-padding\"><h5><b>\nShowing {{(isNaN(pageNumber*size))+1}} - {{(pageNumber + 1)*size}} of {{totalRecords}} Results</b></h5></div><div>\n<md-button class=\"md-raised md-primary\" type=\"button\" ng-click=\"previous()\" ng-disabled=\"pageNumber <= 0\">Prev\n</md-button></div><div class=\"md-padding\"><md-button class=\"md-raised md-primary\" type=\"button\" ng-click=\"next()\" \nng-disabled=\"pageNumber ==totalPages -1\">Next</md-button></div></div></div></div></ms-widget></div></div></div>");
$templateCache.put("app/main/administration/workflow-management/create.workflow.dialog.html","<md-dialog aria-label=\"Add a new doctype\" flex=\"35\"><form name=\"docType\" layout=\"column\" flex=\"66\"><md-toolbar \nclass=\"md-accent\"><div class=\"md-toolbar-tools\"><h2>Create Activity</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content class=\"scrollable\" ms-scroll><md-input-container class=\"md-block\">\n<input type=\"text\" name=\"name\" ng-model=\"doc.actvity\" placeholder=\"Actvity\" required><div \nng-messages=\"doctype.name.$error\" role=\"alert\"><div ng-message=\"required\">Actvity is required</div></div>\n</md-input-container><md-input-container class=\"md-block\"><input type=\"description\" name=\"description\" \nng-model=\"doc.description\" placeholder=\"Description\" required><div ng-messages=\"doctype.description.$error\" \nrole=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>Description is required</span></div></div>\n</md-input-container><md-input-container class=\"md-block\"><input type=\"text\" name=\"buttonText\" \nng-model=\"doc.buttonText\" placeholder=\"ButtonText\" required><div ng-messages=\"doctype.prefix.$error\" role=\"alert\" \nmultiple=\"multiple\"><div ng-message=\"required\"><span>ButtonText is required</span></div></div></md-input-container>\n<md-input-container class=\"md-block\"><label>Type</label><md-select ng-model=\"doc.type\"><md-option ng-value=\"type\" \nng-repeat=\"type in activitytypes\">{{type}}</md-option></md-select></md-input-container><md-input-container \nclass=\"md-block\"><input type=\"text\" name=\"url\" ng-model=\"doc.url\" placeholder=\"Url\" required><div \nng-messages=\"doctype.flowId.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>Url is required\n</span></div></div></md-input-container><md-checkbox ng-model=\"doc.commentsRequired\" style=\"margin-bottom: 0px\">\n</md-checkbox><span>Comments Required</span></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"center center\"><md-button type=\"button\" ng-click=\"cancel()\">Cancel</md-button><md-button type=\"button\" \nng-click=\"save(doc)\">Save</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/administration/workflow-management/update.workflow.dialog.html","<md-dialog aria-label=\"Add a new doctype\" flex=\"35\"><form name=\"docType\" layout=\"column\" flex=\"66\"><md-toolbar \nclass=\"md-accent\"><div class=\"md-toolbar-tools\"><h2>Edit Activity:{{currentUser.actvity}}</h2><span flex></span>\n<md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content class=\"scrollable\" ms-scroll><md-input-container class=\"md-block\">\n<input type=\"text\" name=\"name\" ng-model=\"currentUser.actvity\" placeholder=\"Activity\" required><div \nng-messages=\"doctype.name.$error\" role=\"alert\"><div ng-message=\"required\">Name is required</div></div>\n</md-input-container><md-input-container class=\"md-block\"><input type=\"description\" name=\"description\" \nng-model=\"currentUser.description\" placeholder=\"Description\" required><div ng-messages=\"doctype.description.$error\" \nrole=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>Description is required</span></div></div>\n</md-input-container><md-input-container class=\"md-block\"><input type=\"text\" name=\"buttonText\" \nng-model=\"currentUser.buttonText\" placeholder=\"Button Text\" required><div ng-messages=\"doctype.prefix.$error\" \nrole=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>ActivityText is required</span></div></div>\n</md-input-container><md-input-container class=\"md-block\"><label>Type</label><md-select ng-model=\"currentUser.type\">\n<md-option ng-value=\"type\" ng-repeat=\"type in activitytypes\">{{type}}</md-option></md-select></md-input-container>\n<md-input-container class=\"md-block\"><input type=\"text\" name=\"url\" ng-model=\"currentUser.url\" placeholder=\"Url\" \nrequired><div ng-messages=\"doctype.flowId.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>\nUrl is required</span></div></div></md-input-container><md-checkbox ng-model=\"currentUser.commentsRequired\" \nstyle=\"margin-bottom: 0px\"></md-checkbox><span>Comments Required</span></md-dialog-content><md-dialog-actions \nlayout=\"row\" layout-align=\"center center\"><md-button type=\"button\" ng-click=\"cancel()\">Cancel</md-button><md-button \ntype=\"button\" ng-click=\"update(currentUser)\">Save</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/administration/workflow-management/workflow.content.html","<style>\n.mh-0 {\n    min-height: 0px !important;\n}\n.parent-tabs > md-tabs .md-tab.md-active:after{\n    content: \" \";\n    border-left: 7px solid transparent;\n    border-right: 7px solid transparent;\n    border-bottom: 7px solid #efefef;\n    position: absolute;\n    display: block;\n    top: 87%;\n    left: 50%;\n    \n}\n.parent-tabs > md-tabs md-ink-bar {\n    background: none; \n}\n.parent-tabs > md-tabs .md-tab:hover {\n    color: #389cec !important;\n}\n.md-tab {\n  \n  text-transform: none;\n  }\n  .table-border {\n    border: 1px solid #d3d3d3 !important;\n}\n.table-header {\n    background-color: #dee7f4 !important;\n    text-transform: uppercase;\n    font-size: 11px!important;\n}\n</style><div class=\"page-layout simple right-sidenav\" layout-gt-xs=\"row\"><div \nng-include=\"\'app/main/administration/common/admin.html\'\"></div><div \nclass=\"page-layout carded fullwidth md-padding scrollable\" layout=\"column\" flex ms-scroll><div class=\"widget-group\" \nflex=\"100\" layout=\"column\" layout-wrap><ms-widget flippable=\"true\" class=\"no-padding\"><div \nclass=\"parent-tabs white-bg mb-15\"><md-tabs class=\"mh-0\"><md-tab label=\"Activity\" \nui-sref=\"app.administration.workflow-management.content\" md-active=\"true\"></md-tab><md-tab label=\"WorkFlow\" \nui-sref=\"app.administration.workflow-management.defination\"></md-tab></md-tabs></div><div class=\"md-padding white-bg\">\n<table class=\"dataTable row-border hover table-border table-header\" datatable=\"ng\" dt-options=\"dtOptions\" \ndata-ng-if=\"activitys.length > 0\"><thead><tr class=\"table-header\"><th class=\"secondary-text\"><div class=\"table-header\">\n<span class=\"column-title\">Activity</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Description</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">ButtonText</span></div></th><th class=\"secondary-text\"><div class=\"table-header\" layout=\"row\" \nlayout-align=\"center center\"><span class=\"column-title\">Actions</span></div></th></tr></thead><tbody><tr \nng-repeat=\"doc in activitys\"><td>{{doc.actvity}}</td><td>{{doc.description}}</td><td>{{doc.buttonText}}</td><td \nlayout=\"row\" layout-align=\"center center\" style=\"padding-top:0px !important;padding-bottom:0px !important\"><md-button \nid=\"{{doc.id}}\" class=\"md-icon-button test-tooltip\" aria-label=\"Update\" \nonclick=\"angular.element(this).scope().updateRequestDialog(this)\"><md-tooltip md-direction=\"top\">Update</md-tooltip>\n<md-icon><i layout=\"row\" layout-align=\"center center\" class=\"icon icon-pencil s18\"></i></md-icon></md-button><md-button\n id=\"{{doc.id}}\" class=\"md-icon-button test-tooltip\" aria-label=\"Delete\" \nonclick=\"angular.element(this).scope().deleteActivity(this)\"><md-tooltip md-direction=\"top\">Delete</md-tooltip>\n<md-icon><i layout=\"row\" layout-align=\"center center\" class=\"icon icon-delete s18\"></i></md-icon></md-button></td></tr>\n</tbody></table></div><div class=\"md-padding white-bg\" data-ng-if=\"activitys.length == 0\"><div \nclass=\"content-container text-center\"><div class=\"alert alert-info mv-10 mh-10\"><p>No data available</p></div></div>\n</div></ms-widget></div><md-button flow-btn class=\"md-fab md-mini grey-700-bg md-fab-bottom-right add_btn\" \naria-label=\"Create Activity\" ng-click=\"createWorkflow($event)\"><md-icon md-font-icon=\"icon-plus\"></md-icon><md-tooltip \nmd-direction=\"top\">Create Activity</md-tooltip></md-button></div></div>");
$templateCache.put("app/main/administration/workflow-management/workflow.defination.html","<style>\n.mh-0 {\n    min-height: 0px !important;\n}\n.parent-tabs > md-tabs .md-tab.md-active:after{\n    content: \" \";\n    border-left: 7px solid transparent;\n    border-right: 7px solid transparent;\n    border-bottom: 7px solid #efefef;\n    position: absolute;\n    display: block;\n    top: 87%;\n    left: 50%;\n    \n}\n.parent-tabs > md-tabs md-ink-bar {\n    background: none; \n}\n.parent-tabs > md-tabs .md-tab:hover {\n    color: #389cec !important;\n}\n.md-tab {\n  \n  text-transform: none;\n  }\n  .table-border {\n    border: 1px solid #d3d3d3 !important;\n}\n.table-header {\n    background-color: #dee7f4 !important;\n    text-transform: uppercase;\n    font-size: 11px!important;\n}\n</style><div class=\"page-layout simple right-sidenav\" layout-gt-xs=\"row\"><div \nng-include=\"\'app/main/administration/common/admin.html\'\"></div><div \nclass=\"page-layout carded fullwidth md-padding scrollable\" layout=\"column\" flex ms-scroll><div class=\"widget-group\" \nflex=\"100\" layout=\"column\" layout-wrap><ms-widget flippable=\"true\" class=\"no-padding\"><div \nclass=\"parent-tabs white-bg mb-15\"><md-tabs class=\"mh-0\"><md-tab label=\"Activity\" \nui-sref=\"app.administration.workflow-management.content\"></md-tab><md-tab label=\"WorkFlow\" \nui-sref=\"app.administration.workflow-management.defination\" md-active=\"true\"></md-tab></md-tabs></div><div \nclass=\"md-padding white-bg\"><div class=\"content-container text-center\"><div class=\"alert alert-info mv-10 mh-10\"><p>\nNo data available</p></div></div></div></ms-widget></div></div></div><div ng-include=\"\'/app/core/layouts/footer.html\'\">\n</div>");
$templateCache.put("app/main/administration/zohoReports/create.zohoReports.html","<md-dialog aria-label=\"Add a new object\" flex=\"30\"><form name=\"objectCreateForm\" novalidate \nng-submit=\"objectCreateForm.$valid && bsCtrl.createObject(object)\" layout=\"column\" flex=\"66\"><md-toolbar \nclass=\"md-accent\"><div class=\"md-toolbar-tools\"><h2>Create Zoho Report</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><md-input-container class=\"md-block\"><input type=\"text\" name=\"name\" \nng-model=\"object.name\" placeholder=\"Name\" required><div ng-messages=\"objectCreateForm.name.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Name is required</span></div></div></md-input-container><md-input-container \nclass=\"md-block\"><input type=\"text\" name=\"description\" ng-model=\"object.description\" placeholder=\"Description\" \nrequired><div ng-messages=\"objectCreateForm.description.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nDescription is required</span></div></div></md-input-container><md-input-container class=\"md-block\"><input type=\"text\" \nname=\"url\" ng-model=\"object.url\" placeholder=\"URL\" required><div ng-messages=\"objectCreateForm.url.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>URL is required</span></div></div></md-input-container>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"center center\"><md-button type=\"button\" \nng-click=\"cancel()\">Cancel</md-button><md-button type=\"submit\" ng-click=\"objectCreateForm.$valid && save(object) \">Save\n</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/administration/zohoReports/preview.zohoReports.html","<div class=\"page-layout simple right-sidenav\" layout=\"row\"><div \nng-include=\"\'app/main/administration/common/admin.html\'\"></div><div \nclass=\"page-layout carded fullwidth md-padding scrollable\" layout=\"column\" flex ms-scroll><div class=\"widget-group\" \nflex=\"100\" layout=\"column\" layout-wrap><ms-widget flippable=\"true\" class=\"no-padding\"><div \nclass=\"parent-tabs white-bg mb-15\"><md-tabs class=\"mh-0\"><md-tab label=\"Zoho Reports\" md-active=\"true\"></md-tab>\n</md-tabs></div><div class=\"md-padding white-bg\"><table class=\"dataTable row-border hover table-border\" datatable=\"ng\" \ndt-options=\"zohoCtrl.dtOptions\"><thead><tr class=\"table-header\"><th class=\"secondary-text\"><div class=\"table-header\">\n<span class=\"column-title\">Name</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Description</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">URL</span></div></th><th class=\"secondary-text\"><div class=\"table-header\" layout=\"row\" \nlayout-align=\"center center\"><span class=\"column-title\">Actions</span></div></th></tr></thead><tbody><tr \nng-repeat=\"report in zohoReports | filter : searchUser\"><td>{{report.name}}</td><td>{{report.description}}</td><td>\n{{report.url}}</td><td layout=\"row\" layout-align=\"center center\" \nstyle=\"padding-top:0px !important;padding-bottom:0px !important\"><md-button class=\"md-icon-button test-tooltip\" \naria-label=\"Update\" ng-click=\"updateZohoReport($event,report)\"><md-tooltip md-direction=\"top\">Update</md-tooltip>\n<md-icon><i layout=\"row\" layout-align=\"center center\" class=\"icon icon-pencil s18\"></i></md-icon></md-button><md-button\n class=\"md-icon-button test-tooltip\" aria-label=\"Delete\" ng-click=\"deletezohoReport($event, report) \"><md-tooltip \nmd-direction=\"top\">Delete</md-tooltip><md-icon><i layout=\"row\" layout-align=\"center center\" \nclass=\"icon icon-delete s18\"></i></md-icon></md-button></td></tr></tbody></table></div></ms-widget></div><md-button \nflow-btn class=\"md-fab grey-700-bg md-mini md-fab-bottom-right add_btn\" aria-label=\"Create User\" \nng-click=\"createZohoReport($event)\"><md-icon md-font-icon=\"icon-plus\"></md-icon><md-tooltip md-direction=\"top\">\nCreate Zoho Report</md-tooltip></md-button></div></div>");
$templateCache.put("app/main/administration/zohoReports/update.zohoReports.html","<md-dialog aria-label=\"Add a new object\" flex=\"30\"><form name=\"objectCreateForm\" novalidate \nng-submit=\"objectCreateForm.$valid && bsCtrl.createObject(object)\" layout=\"column\" flex=\"66\"><md-toolbar \nclass=\"md-accent\"><div class=\"md-toolbar-tools\"><h2>Update Zoho Report</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><md-input-container class=\"md-block\"><input type=\"text\" name=\"name\" \nng-model=\"object.name\" placeholder=\"Name\" required><div ng-messages=\"objectCreateForm.name.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Name is required</span></div></div></md-input-container><md-input-container \nclass=\"md-block\"><input type=\"text\" name=\"description\" ng-model=\"object.description\" placeholder=\"Description\" \nrequired><div ng-messages=\"objectCreateForm.description.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nDescription is required</span></div></div></md-input-container><md-input-container class=\"md-block\"><input type=\"text\" \nname=\"url\" ng-model=\"object.url\" placeholder=\"URL\" required><div ng-messages=\"objectCreateForm.url.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>URL is required</span></div></div></md-input-container>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"center center\"><md-button type=\"button\" \nng-click=\"cancel()\">Cancel</md-button><md-button type=\"submit\" ng-click=\"objectCreateForm.$valid && update(object) \">\nSave</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/administration/request-management/addattributes.dialog.html","<md-dialog aria-label=\"Add new Attributes\" flex=\"75\"><form name=\"DoctypeForm\" novalidate \nng-submit=\"DoctypeForm.$valid && save(element)\" layout=\"column\" flex=\"66\"><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools\"><h2>Attributes of RequestType:{{CurrentReqData.name}}</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content class=\"scrollable\" ms-scroll><div><div layout=\"row\" \nlayout-align=\"space-around center\"><div class=\"table-header\"><span class=\"column-title\">NAME</span></div><div \nclass=\"table-header\"><span class=\"column-title\">TYPE</span></div><div class=\"table-header\"><span class=\"column-title\">\nREQUIRED</span></div><div class=\"table-header\"><span class=\"column-title\"></span></div></div><md-content><div \nng-repeat=\"element in attributes\" layout=\"row\" layout-align=\"center center\"><md-input-container class=\"md-block\" \nflex=\"20\"><input type=\"text\" name=\"name\" ng-model=\"element.name\" ng-required=\"true\"><div \nng-messages=\"DoctypeForm.name.$error\" role=\"alert\"><div ng-message=\"required\">Enter attribute name</div></div>\n</md-input-container><span flex=\"5\"></span><md-input-container class=\"md-block\" flex=\"20\"><md-select \nng-model=\"element.type\"><md-option ng-repeat=\"type in attributeTypes\" value=\"{{type}}\">{{type}}</md-option></md-select>\n</md-input-container><span flex=\"15\"></span><md-input-container class=\"md-block\" flex=\"10\"><md-switch \nng-model=\"element.required\" aria-label=\"Switch\"></md-switch></md-input-container><span flex=\"5\"></span><md-button \nclass=\"md-icon-button md-accent\" ng-click=\"removeAttribute($index)\"><md-tooltip md-direction=\"top\">Delete</md-tooltip>\n<md-icon md-font-icon=\"icon-delete\"></md-icon></md-button></div></md-content></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" layout-align=\"center center\"><md-button ng-click=\"cancel()\">Cancel</md-button>\n<md-button type=\"submit\">Update</md-button></md-dialog-actions><md-button flow-btn \nclass=\"md-fab md-accent md-fab-bottom-right\" aria-label=\"Create User\" ng-click=\"addNewAttribute()\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon><md-tooltip md-direction=\"top\">New Attribute</md-tooltip></md-button></form>\n</md-dialog>");
$templateCache.put("app/main/administration/request-management/create.requestType.dialog.html","<md-dialog aria-label=\"Add a new doctype\" flex=\"35\"><form name=\"docType\" novalidate \nng-submit=\"doctypeCtrl.createDoctype(doc)\" layout=\"column\" flex=\"66\"><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools\"><h2>Create ReqType</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"cancel()\"><md-icon md-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content class=\"scrollable\" ms-scroll>\n<md-input-container class=\"md-block\"><input type=\"text\" name=\"name\" ng-model=\"doc.name\" placeholder=\"Name\" required>\n<div ng-messages=\"doctype.name.$error\" role=\"alert\"><div ng-message=\"required\">Name is required</div></div>\n</md-input-container><md-input-container class=\"md-block\"><input type=\"text\" name=\"doctype\" ng-model=\"doc.docType\" \nplaceholder=\"DiplayName\" required><div ng-messages=\"doctype.name.$error\" role=\"alert\"><div ng-message=\"required\">\nDisplayName is required</div></div></md-input-container><md-input-container class=\"md-block\"><input type=\"description\" \nname=\"description\" ng-model=\"doc.description\" placeholder=\"Description\" required><div \nng-messages=\"doctype.description.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>\nDescription is required</span></div></div></md-input-container><md-input-container class=\"md-block\"><input \ntype=\"prefix\" name=\"prefix\" ng-model=\"doc.prefix\" placeholder=\"Prefix\" required><div \nng-messages=\"doctype.prefix.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>\nPrefix is required</span></div></div></md-input-container><md-input-container class=\"md-block\"><label>Form Id</label>\n<md-select ng-model=\"doc.formId\"><md-option ng-value=\"form.id\" ng-repeat=\"form in forms\">{{form.name}}</md-option>\n</md-select></md-input-container><md-input-container class=\"md-block\"><input type=\"flowId\" name=\"flowId\" \nng-model=\"doc.flowId\" placeholder=\"Flow Id\" required><div ng-messages=\"doctype.flowId.$error\" role=\"alert\" \nmultiple=\"multiple\"><div ng-message=\"required\"><span>FlowId is required</span></div></div></md-input-container>\n<md-input-container class=\"md-block\"><label>FlowType</label><md-select ng-model=\"doc.flowType\"><md-option \nng-value=\"flowtype\" ng-repeat=\"flowtype in flowtypes\">{{flowtype}}</md-option></md-select></md-input-container><div \nlayout=\"row\" layout-align=\"space-between center\"><md-input-container class=\"md-block\"><input type=\"text\" \nname=\"noRangeFrom\" ng-model=\"doc.noRangeFrom\" placeholder=\"From\"></md-input-container><md-input-container \nclass=\"md-block\"><input type=\"text\" name=\"noRangeTo\" ng-model=\"doc.noRangeTo\" placeholder=\"To\"></md-input-container>\n</div><div layout=\"row\" layout-align=\"space-between center\"><label>Select RequestType Icon</label><md-button \nng-click=\"openIconList()\" class=\"md-accent md-raised\">Icons</md-button></div></md-dialog-content><md-dialog-actions \nlayout=\"row\" layout-align=\"center center\"><md-button type=\"button\" ng-click=\"cancel()\">Cancel</md-button><md-button \ntype=\"submit\" ng-click=\"save(doc)\">Save</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/administration/request-management/createrequestType.html","<div class=\"page-layout simple right-sidenav\" layout=\"row\"><div \nng-include=\"\'app/main/administration/common/admin.html\'\"></div><div \nclass=\"page-layout carded fullwidth md-padding scrollable\" layout=\"column\" flex ms-scroll ng-init=\"getRequestForms()\">\n<div class=\"widget-group\" flex=\"100\" layout=\"column\" layout-wrap><ms-widget flippable=\"true\" class=\"no-padding\"><div \nclass=\"parent-tabs white-bg mb-15\"><md-tabs class=\"mh-0\"><md-tab label=\"Requests\" md-active=\"true\"></md-tab></md-tabs>\n</div><div class=\"md-padding white-bg\"><table class=\"dataTable row-border hover table-border\" datatable=\"ng\" \ndt-options=\"dtOptions\"><thead><tr class=\"table-header\"><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Name</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Description</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">FormId</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">FlowId</span></div></th><th class=\"secondary-text\"><div class=\"table-header\" layout=\"row\" \nlayout-align=\"center center\"><span class=\"column-title\">Actions</span></div></th></tr></thead><tbody><tr \nng-repeat=\"doc in Requests | filter : searchUser\"><td>{{doc.name}}</td><td>{{doc.description}}</td><td>{{doc.formId}}\n</td><td>{{doc.flowId}}</td><td layout=\"row\" layout-align=\"center center\" \nstyle=\"padding-top:0px !important;padding-bottom:0px !important\"><md-button class=\"md-icon-button test-tooltip\" \naria-label=\"Update\" ng-click=\"updateRequestDialog($event,doc)\"><md-tooltip md-direction=\"top\">Update</md-tooltip>\n<md-icon><i layout=\"row\" layout-align=\"center center\" class=\"icon icon-pencil s20\"></i></md-icon></md-button><md-button\n class=\"md-icon-button test-tooltip\" aria-label=\"Delete\" ng-click=\"deleteDoctype($event,doc)\"><md-tooltip \nmd-direction=\"top\">Delete</md-tooltip><md-icon><i layout=\"row\" layout-align=\"center center\" \nclass=\"icon icon-delete s20\"></i></md-icon></md-button><md-button class=\"md-icon-button test-tooltip\" \naria-label=\"Update\" ng-click=\"AddattributesDialog($event,doc)\"><md-tooltip md-direction=\"top\">Attributes</md-tooltip>\n<md-icon><i layout=\"row\" layout-align=\"center center\" class=\"icon-plus-circle s20\"></i></md-icon></md-button></td></tr>\n</tbody></table></div></ms-widget></div><md-button flow-btn \nclass=\"md-fab grey-700-bg md-mini md-fab-bottom-right add_btn\" aria-label=\"Create Form\" \nng-click=\"createRequestDialog($event)()\"><md-icon md-font-icon=\"icon-plus\"></md-icon><md-tooltip md-direction=\"top\">\nCreate DocType</md-tooltip></md-button></div></div>");
$templateCache.put("app/main/administration/request-management/update.requestType.dialog.html","<md-dialog aria-label=\"Add a new doctype\" flex=\"35\"><form name=\"docType\" novalidate layout=\"column\" flex=\"66\">\n<md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2>Edit ReqType:{{recivedDoc.name}}</h2><span flex></span>\n<md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content class=\"scrollable\" ms-scroll><md-input-container class=\"md-block\">\n<input type=\"text\" name=\"name\" ng-model=\"recivedDoc.name\" disabled=\"true\" placeholder=\"Name\" required><div \nng-messages=\"doctype.name.$error\" role=\"alert\"><div ng-message=\"required\">Name is required</div></div>\n</md-input-container><md-input-container class=\"md-block\"><input type=\"text\" name=\"doctype\" \nng-model=\"recivedDoc.docType\" placeholder=\"DiplayName\" required><div ng-messages=\"doctype.name.$error\" role=\"alert\">\n<div ng-message=\"required\">DisplayName is required</div></div></md-input-container><md-input-container \nclass=\"md-block\"><input type=\"description\" name=\"description\" ng-model=\"recivedDoc.description\" \nplaceholder=\"Description\" required><div ng-messages=\"doctype.description.$error\" role=\"alert\" multiple=\"multiple\"><div \nng-message=\"required\"><span>Description is required</span></div></div></md-input-container><md-input-container \nclass=\"md-block\"><input type=\"prefix\" name=\"prefix\" ng-model=\"recivedDoc.prefix\" placeholder=\"Prefix\" required><div \nng-messages=\"doctype.prefix.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>\nPrefix is required</span></div></div></md-input-container><md-input-container class=\"md-block\"><label>Form Id</label>\n<md-select ng-model=\"recivedDoc.formId\"><md-option ng-value=\"formId.id\" ng-repeat=\"formId in formIds\">{{formId.name}}\n</md-option></md-select></md-input-container><md-input-container class=\"md-block\"><input type=\"flowId\" name=\"flowId\" \nng-model=\"recivedDoc.flowId\" placeholder=\"Flow Id\" required><div ng-messages=\"doctype.flowId.$error\" role=\"alert\" \nmultiple=\"multiple\"><div ng-message=\"required\"><span>FlowId is required</span></div></div></md-input-container>\n<md-input-container class=\"md-block\"><label>FlowType</label><md-select ng-model=\"recivedDoc.flowType\"><md-option \nng-value=\"flowtype\" ng-repeat=\"flowtype in flowtypes\">{{flowtype}}</md-option></md-select></md-input-container><div \nlayout=\"row\" layout-align=\"space-between center\"><md-input-container class=\"md-block\"><input type=\"text\" \nname=\"noRangeFrom\" ng-model=\"recivedDoc.noRangeFrom\" disabled=\"true\" placeholder=\"From\"></md-input-container>\n<md-input-container class=\"md-block\"><input type=\"text\" name=\"noRangeTo\" ng-model=\"recivedDoc.noRangeTo\" \ndisabled=\"true\" placeholder=\"To\"></md-input-container></div><div layout=\"row\" layout-align=\"space-between center\">\n<label>Update RequestType Icon</label><md-button ng-click=\"openIconList()\" class=\"md-accent md-raised\" \nng-model=\"recivedDoc.icon\">Icons</md-button></div></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"center center\"><md-button type=\"button\" ng-click=\"cancel()\">Cancel</md-button><md-button type=\"submit\" \nng-click=\"update(recivedDoc)\">Save</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/coromandel_inbox/c_inbox/attachments-dialog.html","<md-dialog flex=\"90\" flex-gt-sm=\"55\" flex-md=\"55\" flex-gt-md=\"55\" style=\"height:85% !important\"><md-toolbar \nclass=\"md-accent\"><div class=\"md-toolbar-tools\"><h2>Attachments</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content class=\"scrollable\" ms-scroll><md-content><div \nclass=\"md-padding scrollable\" ms-scroll><div ng-if=\"attachmentsData.length > 0\" class=\"md-padding\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"h4\">Attachments</span> <span class=\"h4\">\n{{getAttachmentsLength(attachmentsData)}}</span></div><div ng-if=\"!(attachmentsData.length > 0)\" class=\"md-padding\" \nlayout=\"row\" layout-align=\"center center\"><span class=\"h4\">No Attachments uploaded while initiation</span></div><div>\n<md-list><md-list-item class=\"md-3-line\" ng-repeat=\"attachment in attachmentsData\" \nng-if=\"attachment.deleteStatus != \'true\'\"><div layout=\"row\" flex=\"100\"><div flex=\"5\" layout=\"row\" \nlayout-align=\"center center\"><md-icon md-font-icon=\"{{fileIcon(attachment.fileType)}}\" class=\"s42 icon md-accent\">\n</md-icon></div><div flex=\"60\" class=\"c-p\"><div class=\"md-list-item-text\"><h4><b>{{attachment.fileName}}</b></h4><h4>\nUploaded By : {{attachment.creator}}</h4></div></div><div flex=\"30\"><h4>\nUploaded On :{{attachment.createDate.substring(6,8) }}-{{ attachment.createDate.substring(4,6)}}-{{ attachment.createDate.substring(0,4)}}\n</h4></div><md-button class=\"md-icon-button md-accent\" ng-click=\"downloadFile(attachment)\" style=\"padding: 0px\">\n<md-icon md-font-icon=\"icon-download\" class=\"s32 md-accent\"></md-icon></md-button><span><md-button \nclass=\"md-icon-button\" ng-click=\"selectFile(attachment)\"><md-tooltip md-direction=\"top\">View Document</md-tooltip>\n<md-icon class=\"icon s-18 blue-fg\" md-font-icon=\"icon-eye\"></md-icon></md-button></span><md-divider ng-if=\"!$last\">\n</md-divider></div></md-list-item></md-list></div><div ng-if=\"addedAttachments.length > 0\"><md-list><md-list-item \nclass=\"md-3-line\" ng-repeat=\"attachment in addedAttachments\"><div layout=\"row\" flex=\"100\"><div flex=\"60\" class=\"c-p\">\n<div class=\"md-list-item-text\"><h4 ng-click=\"openFile(attachment)\"><b>{{$index + 1}}. {{attachment.name}}</b></h4><h4>\nSize : {{getAttachmentSize(attachment.size)}}</h4></div></div><div flex=\"40\"></div><md-button \nclass=\"md-icon-button md-accent\" ng-click=\"removeAttachment($index)\"><md-icon md-font-icon=\"icon-window-close\" \nclass=\"s32 md-warn\"></md-icon></md-button><md-divider ng-if=\"!$last\"></md-divider></div></md-list-item></md-list></div>\n</div></md-content></md-dialog-content><md-dialog-actions><div layout=\"row\" layout-align=\"center center\"></div>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/coromandel_inbox/c_inbox/c_collaborate.html","<style>md-tabs-canvas{\n        background-color: white;\n        }</style><md-dialog flex=\"45\" flex-gt-sm=\"45\" \nstyle=\"height:85% !important\"><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2>Collaboration</h2><span \nflex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content class=\"scrollable\" ms-scroll><form name=\"collaborateForm\"><div \nflex=\"100\" class=\"scrollable\" ms-scroll><md-content><div><md-tabs md-dynamic-height><md-tab><md-tab-label \nstyle=\"padding-bottom:50px !important\">Collaborate With user</md-tab-label><md-tab-body class=\"md-padding scrollable\" \nms-scroll ng-style=\"{\'border\': \'1px solid #cccccc\'}\"><div layout=\"column \" layout-align=\"center center \" \nflex-gt-sm=\"100\"><div class=\"h4 md-padding\"><span>Select the user to Collaborate?</span></div><label \nclass=\"child-label\" for=\"existing-phases\"></label><input type=\"text\" ng-model=\"sampleheader.person\" list=\"names\" \nstyle=\"border: 1px solid rgb(169, 161, 161);border-radius: 3px;height: 30px\"><datalist id=\"names\" class=\"form-control\" \nng-model=\"sampleheader.person \"><option value=\"\">-- select an option --</option><option \nng-repeat=\"person in users | filter:search \" ng-value=\"person.login\">{{person.firstName}}-{{person.lastName}}</option>\n</datalist><p ng-if=\"!sapTab\" style=\"color: red\">{{errormsg}}</p></div><div layout=\"row\" class=\"md-padding\">\n<md-input-container class=\"md-block no-margin\" flex-gt-sm=\"100\"><label>comments</label><textarea ng-model=\"comments\" \noninput=\"this.value = this.value.replace(/[^a-zA-Z0-9 ,.%]/g, \'\')\" name=\"comments\" columns=\"1\" maxlength=\"500\" \nmd-maxlength=\"500\" ng-required=\"true\" rows=\"5\" autocomplete=\"off\" \nstyle=\"border:1px solid rgb(169, 161, 161);border-radius: 3px\"></textarea><div \nng-messages=\"collaborateForm.comments.$error\" role=\"alert\"><div ng-message=\"required\"><span>Comments is required</span>\n</div></div></md-input-container></div></md-tab-body></md-tab><md-tab ng-click=\"SAPcollaboration();\"><md-tab-label>\nCollaborate With Initiator</md-tab-label><md-tab-body class=\"md-padding scrollable\" ms-scroll \nng-style=\"{\'border\': \'1px solid #cccccc\'}\"><div layout=\"column \" layout-align=\"start center\"><div class=\"md-padding\">\n<div layout=\"row\" layout-align=\"center center\"><md-input-container class=\"md-block margin\" \nstyle=\"margin:1% !important\"><input ng-model=\"name\" class=\"md-no-underline\" disabled=\"disabled\" \nstyle=\"border: 1px solid rgb(169, 161, 161);border-radius: 3px;margin-bottom: -10%;height: 30px; margin-top: -3%\">\n</md-input-container></div></div></div><div layout=\"row\"><md-input-container class=\"md-block no-margin\" flex=\"100\">\n<label>comments</label><textarea ng-model=\"comments\" \noninput=\"this.value = this.value.replace(/[^a-zA-Z0-9 ,.%]/g, \'\')\" columns=\"1\" md-maxlength=\"500\" ng-required=\"true\" \nrows=\"5\" autocomplete=\"off\" style=\"border:1px solid rgb(169, 161, 161);border-radius: 3px\"></textarea>\n</md-input-container></div></md-tab-body></md-tab><md-tab></md-tab></md-tabs></div></md-content></div></form>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"end end\"><md-button ng-click=\"cancel()\">Cancel\n</md-button><md-button ng-click=\" collaborateActivity($event,user, comments)\" class=\"md-warn\">Collaborate</md-button>\n<img src=\"assets/images/loader_blue.gif\" style=\"width: 5rem; max-height: 5rem !important\" ng-if=\"showLoadingIcon\">\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/coromandel_inbox/c_inbox/c_inbox.html","<style>\n.table-header{\n    text-transform: none;\n    }\n    .page-layout .top-bg {\n    height: 100px;\n    background-image: none;\n    background-color: whitesmoke\n    }\n    #e-commerce-orders .center .header {\n    min-height: 80px !important;\n    max-height: 80px !important;\n    }\n    .pointer {cursor: pointer;}\n</style><div id=\"e-commerce-orders\" class=\"page-layout carded fullwidth\" layout=\"row\"><div class=\"top-bg md-accent-bg\">\n</div><div class=\"center\" layout=\"column\" flex><div class=\"page-layout carded fullwidth md-padding scrollable\" \nlayout=\"column\" flex ms-scroll flex=\"grow\"><div class=\"widget-group\" layout=\"column\" layout-wrap><ms-widget \nflippable=\"true\" class=\"no-padding\"><div><span style=\"color: #2196F3\"><md-icon md-font-icon=\"icon-cart-outline\" \nstyle=\"color: #2196F3 !important\"></md-icon>WorkItems : {{orders.length}}</span></div><div class=\"md-padding white-bg\" \nhide-xs hide-gt-xs show-md show-gt-md><table class=\"dataTable row-border hover table-border\" datatable=\"ng\" \ndt-options=\"CinboxCtrl.dtOptions\"><thead><tr class=\"table-header\"><th class=\"secondary-text\" \nng-repeat=\"header in vendorform\"><div class=\"table-header\"><span class=\"column-title\">{{header}}</span></div></th></tr>\n</thead><tbody><tr ng-repeat=\"user in orders | filter : searchUser\"><td><span ng-click=\"gotoOrderDetail(user.docId)\" \nstyle=\"text-align: start;text-decoration: underline;color: blue;cursor: pointer\">{{user.docId}}</span></td><td>\n{{user.headerValues.Field2.value}}</td><td>{{user.headerValues.Field3.value}}</td><td>\n{{user.headerValues.Field4.value}}</td><td>{{user.headerValues.Field5.value}}</td><td>\n{{user.headerValues.Field6.value}}</td><td ng-if=\"sscform == true\">{{user.headerValues.Field7.value}}</td><td>\n{{user.headerValues.Field8.value}}</td><td ng-if=\"sscform == true\">{{user.headerValues.Field9.value}}</td><td>\n{{user.headerValues.Field10.value}}</td><td>{{user.createdDate.substr(0,10)}}</td></tr></tbody></table></div><div \nclass=\"md-padding white-bg\" show-xs hide-md hide-gt-md><div class=\"md-list-item-text\" layout=\"column\">\n<md-expansion-panel md-component-id=\"panelOne\" ng-repeat=\"user in orders\"><md-expansion-panel-collapsed><div \nclass=\"md-title\" style=\"color: #039be5\">DocId {{user.docId}}</div><md-expansion-panel-icon></md-expansion-panel-icon>\n<md-icon></md-icon><i class=\"icon-arrow-right blue-fg\" style=\"margin-top: 4%\" ng-click=\"gotoOrderDetail(user.docId)\">\n</i></md-expansion-panel-collapsed><md-expansion-panel-expanded><md-expansion-panel-header \nng-click=\"$panel.collapse()\"><div class=\"md-title\" style=\"color: #039be5\">DocId{{user.docId}}</div><div layout=\"row\" \nlayout-align=\"end end\"><md-expansion-panel-icon></md-expansion-panel-icon><i class=\"icon-arrow-right blue-fg\" \nstyle=\"margin-top: 4%\" ng-click=\"gotoOrderDetail(user.docId)\"></i></div></md-expansion-panel-header>\n<md-expansion-panel-content><div layout=\"row\" layout-align=\"start center\"><div flex=\"50\" layout-align=\"start center\">\n<b>{{vendorform[1]}}</b></div><div flex=\"50\" layout-align=\"start center\">{{user.headerValues.Field2.value}}</div></div>\n<div layout=\"row\" layout-align=\"start center\"><div flex=\"50\" layout-align=\"start center\"><b>{{vendorform[2]}}</b></div>\n<div flex=\"50\" layout-align=\"start center\">{{user.headerValues.Field3.value}}</div></div><div layout=\"row\" \nlayout-align=\"start center\"><div flex=\"50\" layout-align=\"start center\"><b>{{vendorform[3]}}</b></div><div flex=\"50\" \nlayout-align=\"start center\">{{user.headerValues.Field4.value}}</div></div><div layout=\"row\" \nlayout-align=\"start center\"><div flex=\"50\" layout-align=\"start center\"><b>{{vendorform[4]}}</b></div><div flex=\"50\" \nlayout-align=\"start center\">{{user.headerValues.Field5.value}}</div></div><div layout=\"row\" \nlayout-align=\"start center\"><div flex=\"50\" layout-align=\"start center\"><b>{{vendorform[5]}}</b></div><div flex=\"50\" \nlayout-align=\"start center\">{{user.headerValues.Field6.value}}</div></div><div layout=\"row\" \nlayout-align=\"start center\"><div flex=\"50\" layout-align=\"start center\"><b>{{vendorform[6]}}</b></div><div flex=\"50\" \nlayout-align=\"start center\">{{user.headerValues.Field8.value}}</div></div><div layout=\"row\" \nlayout-align=\"start center\"><div flex=\"50\" layout-align=\"start center\"><b>{{vendorform[7]}}</b></div><div flex=\"50\" \nlayout-align=\"start center\">{{user.headerValues.Field10.value}}</div></div><div layout=\"row\" \nlayout-align=\"start center\"><div flex=\"50\" layout-align=\"start center\"><b>{{vendorform[8]}}</b></div><div flex=\"50\" \nlayout-align=\"start center\">{{user.createdDate.substr(0,10)}}</div></div></md-expansion-panel-content>\n</md-expansion-panel-expanded></md-expansion-panel></div></div></ms-widget></div></div></div></div>");
$templateCache.put("app/main/coromandel_inbox/c_inbox/c_inboxLogs.html","<md-dialog flex=\"90\" flex-gt-sm=\"45\" flex-md=\"50\" flex-gt-md=\"40\" \nstyle=\"height:85% !important; right: 1% !important;position: absolute\" ng-init=\"loadApprovalMatrix()\"><md-toolbar \nclass=\"md-accent\"><div class=\"md-toolbar-tools\"><h2>Log Details</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content class=\"scrollable\" ms-scroll><div flex=\"100\" class=\"scrollable\" \nms-scroll><md-content><div><md-tabs md-dynamic-height><md-tab><md-tab-label style=\"padding-bottom:50px !important\">\nCOMMENTS</md-tab-label><md-tab-body class=\"md-padding scrollable\" ms-scroll><div layout=\"row\" layout-align=\"end end\">\n<md-button ng-click=\"printLogs(\'printSectionId\')\" class=\"md-raised md-accent\">Print</md-button></div><div \nid=\"printSectionId\" ng-hide=\"true\"><style>\nmd-tabs-canvas {\n                              background-color: white;\n                              }\n                              #customers {\n                              font-family: \"Trebuchet MS\", Arial, Helvetica, sans-serif;\n                              border-collapse: collapse;\n                              width: 100%;\n                              }\n                              #customers td, #customers th {\n                              border: 1px solid #ddd;\n                              padding: 8px;\n                              }\n                              #customers tr:nth-child(even){background-color: #f2f2f2;}\n                              #customers tr:hover {background-color: #ddd;}\n                              #customers th {\n                              padding-top: 12px;\n                              padding-bottom: 12px;\n                              text-align: left;\n                              background-color: #4CAF50;\n                              color: white;\n                              }\n</style><table id=\"customers\"><tr><th>SNo</th><th>User Name</th><th>Activity</th><th>Comment</th><th>Date</th><th>Time\n</th></tr><tr ng-repeat=\"log in  workitemInfo.logs | orderBy:\'id\':true \"><td>{{$index+1}}</td><td>\n{{log.actualUser.charAt(0).toUpperCase() + log.actualUser.substr(1).toLowerCase()}}</td><td><span \nng-if=\"log.activity == \'001\'\">Initiated</span> <span ng-if=\"log.activity == \'\'\">Initior Comments For CollaborateBack\n</span> <span ng-if=\"log.activity == \'101\'\">Approved</span> <span ng-if=\"log.activity == \'102\'\">Rejected</span> <span \nng-if=\"log.activity == \'110\'\">Collaborate With User</span> <span ng-if=\"log.activity == \'111\'\">CollaborateBack</span> \n<span ng-if=\"log.activity == \'550\'\">Collaborate With Initiator</span> <span ng-if=\"log.activity == \'551\'\">\nCollaborateBack From Initiator</span></td><td>{{log.comments}}</td><td>\n{{log.endDate.substring(6,8)}} - {{log.endDate.substring(4,6)}} -{{log.endDate.substring(0,4)}}</td><td>\n{{log.endTime.substring(0,2)}}:{{log.endTime.substring(2,4)}}</td></tr></table></div><timeline class=\"md-padding\">\n<timeline-event ng-repeat=\"log in log | orderBy:\'id\':true \"><timeline-badge style=\"background-color: rgb(3,155,229)\">\n<md-icon md-font-icon=\"{{log.icon}}\" class=\"s25 icon white-fg\" style=\"color:white !important\"></md-icon>\n</timeline-badge><timeline-panel class=\"{{\'info\'}}\" style=\"background-color: #f1eded\"><timeline-heading><div \nlayout=\"row\" layout-align=\"end end\"><p><b>\nDate : {{log.endDate.substr(6,2)}}-{{log.endDate.substr(4,2)}}-{{log.endDate.substr(0,4)}}</b></p></div><div \nlayout=\"row\" layout-align=\"start center\" style=\"color:black\"><img ng-src=\"assets\\images\\avatars/Nora.jpg\" \nclass=\"md-avatar\" style=\"border-radius:50% !important;width:13%; height:auto\"><div class=\"h3\" \nng-if=\"log.activity == \'001\' \">{{log.actualUser}}Initiated</div><div class=\"h3\" \nng-if=\"log.activity == \'101\' || log.activity == \'510\'  \">{{log.actualUser}} Approved</div><div class=\"h3\" \nng-if=\"log.activity == \'103\' \">{{log.actualUser}} Rejected</div><div class=\"h3\" \nng-if=\"log.activity == \'515\' || log.activity == \'516\' || log.activity == \'502\' \">\n{{log.actualUser}} {{log.activityText}}</div><div class=\"h3\" \nng-if=\"log.activity == \'110\' || log.activity == \'111\' || log.activity == \'550\' || log.activity == \'551\'\">\n{{log.actualUser}} {{log.activityText}} With {{log.currAgent}}</div><div class=\"h3\" ng-if=\"!log.activity\">\n{{log.actualUser}} Comments</div></div></timeline-heading><div layout=\"row\" layout-align=\"start start\" \nstyle=\"padding-left: 2%\"><div class=\"text pt-16\">{{log.comments}}</div></div></timeline-panel></timeline-event>\n</timeline></md-tab-body></md-tab></md-tabs></div></md-content></div></md-dialog-content><md-dialog-actions \nlayout=\"row\" layout-align=\"end end\"></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/coromandel_inbox/c_inbox/c_inboxWorkitem.html","<style>\n/* table tr td:last-child {\n			background-color:red;\n	} */\n	\n		.table-header {\n			background-color: #fbfbfc !important;\n			text-transform: none;\n		}\n	\n		/* .md-tab.md-active {\n		  cursor: default;\n		  background-color: #2196F3;\n		  color: white !important;\n	   } */\n		.success {\n			background: green;\n		}\n	\n		.select2-container .select2-choice>.select2-chosen {\n			color: black;\n		}\n	\n		.dataTables_length {\n			display: none;\n		}\n	\n		.dataTables_filter {\n			display: none;\n		}\n	\n		table.dataTable tbody td {\n			padding: 6px 8px !important;\n		}\n	\n		.md-button {\n			text-transform: none;\n		}\n	\n		.selectedApprovalMatrixrow {\n			font-size: 18px;\n			font-weight: bold;\n			color: black;\n		}\n	\n		.selectedApprovalMatrixrowBackground {\n			background-color: #7ae2d8;\n		}\n	\n		/* //horizonatal */\n		body {\n			font-family: \'Open Sans\', sans-serif;\n			font-size: 16px;\n			color: #555555;\n			height: 10px;\n		}\n	\n		.md-stepper-horizontal {\n			display: table;\n			width: 98%;\n			margin-top: 1% !important;\n			border-radius: 6px;\n			margin: 0 auto;\n			background-color: #FFFFFF;\n			box-shadow: 0 3px 8px -6px rgba(0, 0, 0, .50);\n		}\n	\n		.md-stepper-horizontal .md-step {\n			display: table-cell;\n			position: relative;\n			padding: 20px;\n		}\n	\n		.md-stepper-horizontal .md-step .md-step-circle {\n			width: 30px;\n			height: 30px;\n			margin: 0 auto;\n			background-color: #999999;\n			border-radius: 50%;\n			text-align: center;\n			line-height: 30px;\n			font-size: 16px;\n			font-weight: 600;\n			color: #FFFFFF;\n		}\n	\n		.md-stepper-horizontal.orange .md-step.active .md-step-circle {\n			background-color: #F96302;\n		}\n	\n		.md-stepper-horizontal .md-step.active .md-step-circle {\n			background-color: rgb(33, 150, 243);\n		}\n	\n		.md-stepper-horizontal .md-step.done .md-step-circle:before {\n			font-family: \'FontAwesome\';\n			font-weight: 100;\n			content: \"\\f00c\";\n		}\n	\n		.md-stepper-horizontal .md-step.done .md-step-circle *,\n		.md-stepper-horizontal .md-step.editable .md-step-circle * {\n			display: none;\n		}\n	\n		.md-stepper-horizontal .md-step.editable .md-step-circle {\n			-moz-transform: scaleX(-1);\n			-o-transform: scaleX(-1);\n			-webkit-transform: scaleX(-1);\n			transform: scaleX(-1);\n		}\n	\n		.md-stepper-horizontal .md-step.editable .md-step-circle:before {\n			font-family: \'FontAwesome\';\n			font-weight: 100;\n			content: \"\\f040\";\n		}\n	\n		.md-stepper-horizontal .md-step .md-step-title {\n			margin-top: 16px;\n			font-size: 16px;\n			font-weight: 600;\n		}\n	\n		.md-stepper-horizontal .md-step .md-step-title,\n		.md-stepper-horizontal .md-step .md-step-optional {\n			text-align: center;\n			color: rgba(0, 0, 0, .26);\n		}\n	\n		.md-stepper-horizontal .md-step.active .md-step-title {\n			font-weight: 600;\n			color: rgba(0, 0, 0, .87);\n		}\n	\n		.md-stepper-horizontal .md-step.active.done .md-step-title,\n		.md-stepper-horizontal .md-step.active.editable .md-step-title {\n			font-weight: 600;\n		}\n	\n		.md-stepper-horizontal .md-step .md-step-optional {\n			font-size: 12px;\n		}\n	\n		.md-stepper-horizontal .md-step.active .md-step-optional {\n			color: rgba(0, 0, 0, .54);\n		}\n	\n		.md-stepper-horizontal .md-step .md-step-bar-left,\n		.md-stepper-horizontal .md-step .md-step-bar-right {\n			position: absolute;\n			top: 36px;\n			height: 5px;\n			border-top: 1px solid #DDDDDD;\n		}\n	\n		.md-stepper-horizontal .md-step .md-step-bar-right {\n			position: absolute;\n			right: 0;\n			left: 50%;\n			margin-left: 20px;\n		}\n	\n		/* .md-step-bar-right {\n				text-align: center;\n				font-weight: bold;\n			} */\n		.md-stepper-horizontal .md-step .md-step-bar-left {\n			left: 0;\n			right: 50%;\n		}\n	\n		.activateadUser {\n			color: green\n		}\n</style><div class=\"page-layout simple tabbed\" layout=\"column\"><div layout=\"row\" layout-align=\"start center\" \nstyle=\"min-height: 53px\"><div class=\"white-fg\" layout=\"row\" layout-align=\"start center\" flex><md-button \nclass=\"goto-orders-button md-icon-button\" aria-label=\"Go to orders\" ng-click=\"gotoOrders()\"><md-icon \nmd-font-icon=\"icon-arrow-left\" style=\"color: black\"></md-icon></md-button><div layout=\"column\" \nlayout-align=\"start start\"><div class=\"h4\" style=\"color: black\"><span>Invoice Details:</span> <span>{{id}}</span></div>\n</div></div></div><md-divider></md-divider><div class=\"md-stepper-horizontal orange\" ms-scroll \nng-if=\"workitemInfo.approvalMatrix !=\'null\'\"><div class=\"md-step active done\" \nng-repeat=\"approver in workitemInfo.approvalMatrix.approvers track by $index\"><div style=\"margin-left: 48%\"><md-icon \nclass=\"icon s20 green-fg\" ng-if=\"workitemInfo.approvalMatrix.checked[$index]\" \nmd-font-icon=\"icon-checkbox-marked-circle \"></md-icon><md-icon class=\"icon s20 blue-500-fg\" \nng-if=\"!workitemInfo.approvalMatrix.checked[$index]\" md-font-icon=\"	icon-google-circles-invite\"></md-icon></div><div \nclass=\"md-step-title\" ng-class=\"{\'selectedApprovalMatrixrow\':workitemInfo.approvalMatrix.selected[$index]}\"><h5 \nng-class=\"{\'activateadUser\': $index+1 == workitemInfo.currentstep}\"><b>{{approver}}</b></h5></div><div \nclass=\"md-step-bar-left\"><div hide-xs show-gt-md ng-if=\"workitemInfo.approvalMatrix.approverDates[$index]\" \nstyle=\"font-size:12px\" layout=\"column\"><span ng-if=\"workitemInfo.approvalMatrix.approvers.length <= 7\">\nDate: {{workitemInfo.approvalMatrix.approverDates[$index].substring(6,8)}}-{{workitemInfo.approvalMatrix.approverDates[$index].substring(4,6)}}-{{workitemInfo.approvalMatrix.approverDates[$index].substring(0,4)}}\n</span> <span ng-if=\"workitemInfo.approvalMatrix.approvers.length <= 7\">\nTime: {{workitemInfo.approvalMatrix.approverDates[$index].substring(9,11)}}:{{workitemInfo.approvalMatrix.approverDates[$index].substring(11,13)}}\n</span> <span ng-if=\"workitemInfo.approvalMatrix.approvers.length >7\">\nD: {{workitemInfo.approvalMatrix.approverDates[$index].substring(6,8)}}/{{workitemInfo.approvalMatrix.approverDates[$index].substring(4,6)}}\n</span></div></div><div class=\"md-step-bar-right\"></div></div></div><div \nng-if=\"(workitemInfo.approvalMatrix == \'null\' || workitemInfo.approvalMatrix.length == 0) && workitemInfo.flowType == \'Hybrid\'\">\n<md-card><h4 style=\"text-align:center;color: red\">DOA configuration not maintained. Please contact Admin</h4></md-card>\n</div><div class=\"widget-group\" layout=\"row\" flex=\"100\" ng-if=\"workitemInfo.requestType !=\'COR_EXCL_PDR\'\" layout-wrap>\n<ms-widget layout=\"column\" flex=\"70\" flex-xs=\"100\"><ms-widget-front class=\"white-bg\" class=\"scrollable\" ms-scroll \nstyle=\"border-radius: 6px\"><md-content><div layout=\"row\" layout-align=\"space-between center\" class=\"md-padding\"><div \nclass=\"h2\">Header</div><div layout=\"row\"><b style=\"color:rgb(33,150,243)\">\nInitiated:{{diffDays}} days ago ({{workitemInfo.createdDate.substring(0,10)}})</b></div><div \nng-show=\"workitemInfo.approvalMatrix.approvers.length == 0 && workitemInfo.flowType == \'Hybrid\' \" style=\"color: red\">\n<b>DOA Not configred.Please contact Admin</b></div><div \nng-show=\"workitemInfo.attachments.length <= 0 && workitemInfo.requestType != \'COR_ADV\'\" style=\"color: red\"><b>\nPlease contact Admin for attachments</b></div><div \nng-hide=\"workitemInfo.approvalMatrix.approvers.length == 0 && workitemInfo.flowType == \'Hybrid\' \" layout=\"row\"><div \nlayout=\"row\" ng-repeat=\"actvity in workitemInfo.activities\"><md-tooltip md-direction=\"top\">{{actvity.buttonText}}\n</md-tooltip><div layout=\"row\"><div layout=\"row\" \nng-hide=\"workitemInfo.approvalMatrix.approvers.length == 0 && workitemInfo.flowType == \'Hybrid\'\"><md-icon \nclass=\"icon s-18 green-fg\" md-font-icon=\"icon-check\" data-ng-click=\"processActvity(actvity, $event);\" \nng-if=\"actvity.buttonText==\'Approve\'\"></md-icon></div><div layout=\"row\" \nng-hide=\"workitemInfo.approvalMatrix.approvers.length == 0 && workitemInfo.flowType == \'Hybrid\'\"><md-icon \nclass=\"icon s-18 red-fg\" md-font-icon=\"icon-close\" data-ng-click=\"processActvity(actvity, $event);\" \nng-if=\"actvity.buttonText==\'Reject\'\"></md-icon></div><div data-ng-click=\"collaborate ($event,actvity)\" \nng-if=\"actvity.buttonText==\'Collaborate\'&& workitemInfo.requestType != \'COR_ADV\' &&  workitemInfo.requestType != \'COR_CDP\' && workitemInfo.requestType != \'COR_CUT_PO\' && workitemInfo.requestType != \'COR_FRIEGHT_PO\' && workitemInfo.requestType != \'COR_GEN_PO\' &&workitemInfo.requestType != \'COR_IMP_PO\' &&workitemInfo.requestType != \'COR_LOAD_PO\' &&workitemInfo.requestType != \'COR_NPO\' && workitemInfo.requestType != \'COR_STATU_INV\' && workitemInfo.requestType != \'COR_UNLOAD_PO\' && workitemInfo.requestType != \'COR_CUT_FREIGHT\' && workitemInfo.requestType != \'COR_STG_PO\' \" \nng-hide=\"workitemInfo.approvalMatrix.approvers.length == 0 && workitemInfo.flowType == \'Hybrid\'\" \nstyle=\"margin-left: 15%;margin-top: 9%\"><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"30\" height=\"16\" \nviewBox=\"0 0 262 261\" fill=\"none\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" \nd=\"M56 0.5C56 0.775 54.875 1 53.5 1C52.125 1 51 1.225 51 1.5C51 1.775 50.325 2 49.5 2C48.675 2 48 2.225 48 2.5C48 2.775 47.55 3 47 3C46.45 3 46 3.225 46 3.5C46 3.775 45.55 4 45 4C44.45 4 \n													44 4.225 44 4.5C44 4.775 43.55 5 43 5C42.45 5 42 5.225 42 5.5C42 5.775 41.6595 6 41.2435 6C40.257 6 \n													31 15.257 31 16.2435C31 16.6595 30.775 17 30.5 17C30.225 17 30 17.4005 30 17.8895C30 18.379 29.55 19.1035 \n													29 19.5C28.45 19.8965 28 20.621 28 21.1105C28 21.5995 27.775 22 27.5 22C27.225 22 27 22.675 27 23.5C27 24.325\n													26.775 25 26.5 25C26.225 25 26 25.675 26 26.5C26 27.325 25.775 28 25.5 28C25.209 28 25 29.653 25 31.9585C25 34.636 24.798 \n													36.011 24.375 36.2085C23.875 36.4415 23.875 36.5585 24.375 36.7915C24.7865 36.984 25 38.264 25 40.5415C25 42.514 25.215 44 25.5\n													 44C25.775 44 26 44.9 26 46C26 47.1 26.225 48 26.5 48C26.775 48 27 48.675 27 49.5C27 50.325 27.225 51 27.5 51C27.775 51 28 51.45 28 52C28 52.55 28.225 53 28.5 53C28.775 53 29 53.4005 29 53.8895C29 54.379 29.45 55.1035 30 55.5C30.55 55.8965 31 56.5715 31 57C31 57.4285 31.45 58.1035 32 58.5C32.55 58.8965 33 59.5245 33 59.896C33 60.8115 31.7495 62 30.7855 62C30.3535 62 30 62.225 30 62.5C30 62.775 29.55 63 29 63C28.45 63 28 63.225 28 63.5C28 63.775 27.5995 64 27.1105 64C26.621 64 25.8965 64.45 25.5 65C25.1035 65.55 24.4285 66 24 66C23.5715 66 22.8965 66.45 22.5 67C22.1035 67.55 21.487 68 21.1305 68C20.3445 68 14 74.2555 14 75.03C14 75.3315 13.1 76.443 12 77.5C10.9 78.557 10 79.727 10 80.1005C10 80.474 9.55 81.1035 9 81.5C8.45 81.8965 8 82.621 8 83.1105C8 83.5995 7.775 84 7.5 84C7.225 84 7 84.45 7 85C7 85.55 6.775 86 6.5 86C6.225 86 6 86.45 6 87C6 87.55 5.775 88 5.5 88C5.225 88 5 88.45 5 89C5 89.55 4.775 90 4.5 90C4.225 90 4 90.675 4 91.5C4 92.325 3.775 93 3.5 93C3.225 93 3 93.45 3 94C3 94.55 2.775 95 2.5 95C2.225 95 2 96.125 2 97.5C2 98.875 1.775 100 1.5 100C1.2145 100 1 101.5 1 103.5C1 105.5 0.7855 107 0.5 107C0.1925 107 0 109.5 0 113.5V120H61H122V111.5C122 106.167 121.813 103 121.5 103C121.225 103 121 102.1 121 101C121 99.9 120.775 99 120.5 99C120.225 99 120 98.1 120 97C120 95.9 119.775 95 119.5 95C119.225 95 119 94.325 119 93.5C119 92.675 118.775 92 118.5 92C118.225 92 118 91.55 118 91C118 90.45 117.775 90 117.5 90C117.225 90 117 89.55 117 89C117 88.45 116.775 88 116.5 88C116.225 88 116 87.55 116 87C116 86.45 115.775 86 115.5 86C115.225 86 115 85.55 115 85C115 84.45 114.775 84 114.5 84C114.225 84 114 83.55 114 83C114 82.45 113.775 82 113.5 82C113.225 82 113 81.6405 113 81.2005C113 80.761 112.325 79.7705 111.5 79C110.675 78.2295 110 77.3485 110 77.0425C110 76.316 101.684 68 100.958 68C100.652 68 99.7705 67.325 99 66.5C98.2295 65.675 97.2885 65 96.91 65C96.531 65 95.8965 64.55 95.5 64C95.1035 63.45 94.379 63 93.8895 63C93.4005 63 93 62.775 93 62.5C93 62.225 92.55 62 92 62C91.45 62 91 61.775 91 61.5C91 61.225 90.55 61 90 61C89.45 61 89 60.775 89 60.5C89 60.225 89.225 60 89.5 60C89.775 60 90 59.5995 90 59.1105C90 58.621 90.45 57.8965 91 57.5C91.55 57.1035 92 56.379 92 55.8895C92 55.4005 92.225 55 92.5 55C92.775 55 93 54.55 93 54C93 53.45 93.225 53 93.5 53C93.775 53 94 52.55 94 52C94 51.45 94.225 51 94.5 51C94.775 51 95 50.55 95 50C95 49.45 95.225 49 95.5 49C95.775 49 96 48.325 96 47.5C96 46.675 96.225 46 96.5 46C96.778 46 97 44.6665 97 43C97 41.3335 97.222 40 97.5 40C97.778 40 98 38.6665 98 37C98 35.3335 97.778 34 97.5 34C97.2145 34 97 32.5 97 30.5C97 28.5 96.7855 27 96.5 27C96.225 27 96 26.325 96 25.5C96 24.675 95.775 24 95.5 24C95.225 24 95 23.3745 95 22.6105C95 21.7945 94.587 20.9235 94 20.5C93.45 20.1035 93 19.379 93 18.8895C93 18.4005 92.775 18 92.5 18C92.225 18 92 17.645 92 17.211C92 16.7765 91.1 15.557 90 14.5C88.9 13.443 88 12.3255 88 12.0165C88 11.282 85.7105 9 84.9735 9C84.6585 9 83.7705 8.325 83 7.5C82.2295 6.675 81.239 6 80.7995 6C80.3595 6 80 5.775 80 5.5C80 5.225 79.55 5 79 5C78.45 5 78 4.775 78 4.5C78 4.225 77.55 4 77 4C76.45 4 76 3.775 76 3.5C76 3.225 75.55 3 75 3C74.45 3 74 2.775 74 2.5C74 2.225 73.325 2 72.5 2C71.675 2 71 1.775 71 1.5C71 1.225 69.875 1 68.5 1C67.125 1 66 0.775 66 0.5C66 0.2 64 0 61 0C58 0 56 0.2 56 0.5ZM66 14.5C66 14.775 66.675 15 67.5 15C68.325 15 69 15.225 69 15.5C69 15.775 69.45 16 70 16C70.55 16 71 16.225 71 16.5C71 16.775 71.45 17 72 17C72.55 17 73 17.225 73 17.5C73 17.775 73.3425 18 73.761 18C74.751 18 80 23.249 80 24.239C80 24.6575 80.225 25 80.5 25C80.775 25 81 25.45 81 26C81 26.55 81.225 27 81.5 27C81.775 27 82 27.45 82 28C82 28.55 82.225 29 82.5 29C82.775 29 83 29.675 83 30.5C83 31.325 83.225 32 83.5 32C83.7965 32 84 33.8335 84 36.5C84 39.1665 83.7965 41 83.5 41C83.225 41 83 41.675 83 42.5C83 43.325 82.775 44 82.5 44C82.225 44 82 44.45 82 45C82 45.55 81.775 46 81.5 46C81.225 46 81 46.45 81 47C81 47.55 80.775 48 80.5 48C80.225 48 80 48.3415 80 48.7595C80 49.748 73.748 56 72.7595 56C72.3415 56 72 56.225 72 56.5C72 56.775 71.55 57 71 57C70.45 57 70 57.225 70 57.5C70 57.775 69.325 58 68.5 58C67.675 58 67 58.225 67 58.5C67 58.803 64.8335 59 61.5 59C58.1665 59 56 58.803 56 58.5C56 58.225 55.325 58 54.5 58C53.675 58 53 57.775 53 57.5C53 57.225 52.55 57 52 57C51.45 57 51 56.775 51 56.5C51 56.225 50.5995 56 50.1105 56C49.621 56 48.8965 55.55 48.5 55C48.1035 54.45 47.481 54 47.117 54C46.2585 54 44 51.7415 44 50.883C44 50.519 43.55 49.8965 43 49.5C42.45 49.1035 42 48.4285 42 48C42 47.5715 41.55 46.8965 41 46.5C40.413 46.0765 40 45.2055 40 44.3895C40 43.6255 39.775 43 39.5 43C39.1925 43 39 40.5 39 36.5C39 32.5 39.1925 30 39.5 30C39.775 30 40 29.3745 40 28.6105C40 27.7945 40.413 26.9235 41 26.5C41.55 26.1035 42 25.4285 42 25C42 24.5715 42.45 23.8965 43 23.5C43.55 23.1035 44 22.481 44 22.117C44 21.2585 46.2585 19 47.117 19C47.481 19 48.1035 18.55 48.5 18C48.8965 17.45 49.621 17 50.1105 17C50.5995 17 51 16.775 51 16.5C51 16.225 51.45 16 52 16C52.55 16 53 15.775 53 15.5C53 15.225 53.9 15 55 15C56.1 15 57 14.775 57 14.5C57 14.2035 58.8335 14 61.5 14C64.1665 14 66 14.2035 66 14.5ZM128.5 41C128.104 41.55 127.379 42 126.889 42C126.333 42 126 42.3745 126 43C126 43.55 125.775 44 125.5 44C125.225 44 125 45.245 125 46.7665C125 49.257 125.173 49.7065 126.734 51.2665C127.687 52.22 128.812 53 129.234 53C129.655 53 130 53.225 130 53.5C130 53.8265 138.667 54 155 54C171.333 54 180 54.1735 180 54.5C180 54.775 180.675 55 181.5 55C182.325 55 183 55.225 183 55.5C183 55.775 183.359 56 183.799 56C184.239 56 185.229 56.675 186 57.5C186.771 58.325 187.659 59 187.974 59C188.815 59 191 61.33 191 62.2275C191 62.6525 191.225 63 191.5 63C191.775 63 192 63.45 192 64C192 64.55 192.225 65 192.5 65C192.775 65 193 65.675 193 66.5C193 67.325 193.225 68 193.5 68C193.824 68 194 74.3335 194 86C194 95.9 193.882 104 193.737 104C193.593 104 190.336 100.85 186.5 97C182.664 93.15 179.182 90 178.763 90C178.343 90 178 89.775 178 89.5C178 89.225 176.755 89 175.233 89C172.743 89 172.293 89.173 170.733 90.7335C169.109 92.3575 169 92.6725 169 95.7335C169 97.578 169.218 99 169.5 99C169.775 99 170 99.3385 170 99.7525C170 100.735 196.265 127 197.247 127C197.661 127 198 127.225 198 127.5C198 127.775 198.45 128 199 128C199.55 128 200 128.225 200 128.5C200 128.775 200.675 129 201.5 129C202.325 129 203 128.775 203 128.5C203 128.225 203.45 128 204 128C204.55 128 205 127.775 205 127.5C205 127.225 205.339 127 205.753 127C206.735 127 233 100.735 233 99.7525C233 99.3385 233.225 99 233.5 99C233.778 99 234 97.6665 234 96C234 94.3335 233.778 93 233.5 93C233.225 93 233 92.6465 233 92.2145C233 91.204 231.796 90 230.785 90C230.353 90 230 89.775 230 89.5C230 89.225 228.758 89 227.239 89H224.478L216.5 97C212.113 101.4 208.405 105 208.261 105C208.117 105 208 96.225 208 85.5C208 72.8335 207.825 66 207.5 66C207.225 66 207 65.325 207 64.5C207 63.675 206.775 63 206.5 63C206.225 63 206 62.325 206 61.5C206 60.675 205.775 60 205.5 60C205.225 60 205 59.55 205 59C205 58.45 204.775 58 204.5 58C204.225 58 204 57.55 204 57C204 56.45 203.775 56 203.5 56C203.225 56 203 55.6595 203 55.2435C203 54.257 193.743 45 192.757 45C192.341 45 192 44.775 192 44.5C192 44.225 191.55 44 191 44C190.45 44 190 43.775 190 43.5C190 43.225 189.55 43 189 43C188.45 43 188 42.775 188 42.5C188 42.225 187.325 42 186.5 42C185.675 42 185 41.775 185 41.5C185 41.225 184.325 41 183.5 41C182.675 41 182 40.775 182 40.5C182 40.173 172.87 40 155.611 40C129.795 40 129.205 40.0215 128.5 41ZM75 70.5C75 70.775 75.675 71 76.5 71C77.325 71 78 71.225 78 71.5C78 71.775 78.675 72 79.5 72C80.325 72 81 72.225 81 72.5C81 72.775 81.45 73 82 73C82.55 73 83 73.225 83 73.5C83 73.775 83.45 74 84 74C84.55 74 85 74.225 85 74.5C85 74.775 85.45 75 86 75C86.55 75 87 75.225 87 75.5C87 75.775 87.4005 76 87.8895 76C88.379 76 89.1035 76.45 89.5 77C89.8965 77.55 90.512 78 90.8675 78C91.711 78 100 86.289 100 87.1325C100 87.488 100.45 88.1035 101 88.5C101.55 88.8965 102 89.621 102 90.1105C102 90.5995 102.225 91 102.5 91C102.775 91 103 91.45 103 92C103 92.55 103.225 93 103.5 93C103.775 93 104 93.45 104 94C104 94.55 104.225 95 104.5 95C104.775 95 105 95.45 105 96C105 96.55 105.225 97 105.5 97C105.775 97 106 97.9 106 99C106 100.1 106.225 101 106.5 101C106.775 101 107 101.9 107 103C107 104.1 107.225 105 107.5 105C107.775 105 108 105.225 108 105.5C108 105.829 92.1665 106 61.5 106H15V104C15 102.9 15.225 102 15.5 102C15.775 102 16 101.1 16 100C16 98.9 16.225 98 16.5 98C16.775 98 17 97.55 17 97C17 96.45 17.225 96 17.5 96C17.775 96 18 95.325 18 94.5C18 93.675 18.225 93 18.5 93C18.775 93 19 92.5995 19 92.1105C19 91.621 19.45 90.8965 20 90.5C20.55 90.1035 21 89.4285 21 89C21 88.5715 21.45 87.8965 22 87.5C22.55 87.1035 23 86.487 23 86.1305C23 85.3385 29.2585 79 30.04 79C30.3475 79 31.2295 78.325 32 77.5C32.7705 76.675 33.761 76 34.2005 76C34.6405 76 35 75.775 35 75.5C35 75.225 35.45 75 36 75C36.55 75 37 74.775 37 74.5C37 74.225 37.45 74 38 74C38.55 74 39 73.775 39 73.5C39 73.225 39.45 73 40 73C40.55 73 41 72.775 41 72.5C41 72.225 41.675 72 42.5 72C43.325 72 44 71.775 44 71.5C44 71.225 44.675 71 45.5 71C46.325 71 47 70.775 47 70.5C47 70.1785 52 70 61 70C70 70 75 70.1785 75 70.5ZM61 132.5C61 132.775 60.4365 133 59.748 133C58.774 133 55.326 136.17 44.248 147.248C36.4115 155.084 30 161.834 30 162.248C30 162.662 29.775 163 29.5 163C29.225 163 29 164.075 29 165.389C29 167.205 29.24 167.952 30 168.5C30.55 168.896 31 169.621 31 170.111C31 170.667 31.3745 171 32 171C32.55 171 33 171.225 33 171.5C33 171.778 34.3335 172 36 172C37.6665 172 39 171.778 39 171.5C39 171.225 39.343 171 39.7625 171C40.182 171 43.664 167.85 47.5 164C51.336 160.15 54.593 157 54.7375 157C54.882 157 55 165.775 55 176.5C55 189.167 55.175 196 55.5 196C55.775 196 56 197.125 56 198.5C56 199.875 56.225 201 56.5 201C56.775 201 57 201.45 57 202C57 202.55 57.225 203 57.5 203C57.775 203 58 203.675 58 204.5C58 205.325 58.225 206 58.5 206C58.775 206 59 206.4 59 206.889C59 207.379 59.45 208.104 60 208.5C60.55 208.896 61 209.512 61 209.867C61 210.777 69.3225 219 70.243 219C70.6595 \n													 219 71 219.225 71 219.5C71 219.775 71.45 220 72 220C72.55 220 73 220.225 73 220.5C73 220.775 73.45 221 74 221C74.55 221 75 221.225 75 221.5C75 221.775 75.675 222 76.5 222C77.325 222 78 222.225 78 222.5C78 222.775 78.675 223 79.5 223C80.325 223 81 223.225 81 223.5C81 223.785 82.5 224 84.5 224C86.5 224 88 224.215 88 224.5C88 224.824 94.1665 225 105.5 225C116.833 225 123 224.824 123 224.5C123 224.225 123.798 224 124.773 224C126.668 224 129 222.219 129 220.772C129 220.347 129.225 220 129.5 220C129.775 220 130 218.875 130 217.5C130 216.125 129.775 215 129.5 215C129.225 215 129 214.647 129 214.215C129 213.204 127.796 212 126.786 212C126.354 212 126 211.775 126 211.5C126 211.175 119 211 106 211C93 211 86 210.825 86 210.5C86 210.225 85.1 210 84 210C82.9 210 82 209.775 82 209.5C82 209.225 81.3745 209 80.6105 209C79.7945 209 78.9235 208.587 78.5 208C78.1035 207.45 77.4855 207 77.1265 207C76.216 207 72 202.694 72 201.763C72 201.344 71.775 201 71.5 201C71.225 201 71 200.55 71 200C71 199.45 70.775 199 70.5 199C70.225 199 70 198.325 70 197.5C70 196.675 69.775 196 69.5 196C69.175 196 69 189 69 176C69 165 69.1175 156 69.261 156C69.405 156 73.1125 159.6 77.5 164L85.4775 172H88.239C89.7575 172 91 171.775 91 171.5C91 171.225 91.3535 171 91.7855 171C92.796 171 94 169.796 94 168.785C94 168.353 94.225 168 94.5 168C94.775 168 95 166.875 95 165.5C95 164.125 94.775 163 94.5 163C94.225 163 94 162.662 94 162.248C94 161.834 87.5885 155.084 79.752 147.248C68.674 136.17 65.226 133 64.252 133C63.5635 133 63 132.775 63 132.5C63 132.225 62.55 132 62 132C61.45 132 61 132.225 61 132.5ZM196 141.5C196 141.775 194.875 142 193.5 142C192.125 142 191 142.225 191 142.5C191 142.775 190.325 143 189.5 143C188.675 143 188 143.225 188 143.5C188 143.775 187.325 144 186.5 144C185.675 144 185 144.225 185 144.5C185 144.775 184.6 145 184.111 145C183.621 145 182.896 145.45 182.5 146C182.104 146.55 181.469 147 181.09 147C180.711 147 179.771 147.675 179 148.5C178.229 149.325 177.346 150 177.036 150C176.253 150 172 154.329 172 155.126C172 155.485 171.55 156.104 171 156.5C170.45 156.896 170 157.621 170 158.111C170 158.6 169.775 159 169.5 159C169.225 159 169 159.45 169 160C169 160.55 168.775 161 168.5 161C168.225 161 168 161.45 168 162C168 162.55 167.775 163 167.5 163C167.225 163 167 163.45 167 164C167 164.55 166.775 165 166.5 165C166.225 165 166 165.675 166 166.5C166 167.325 165.775 168 165.5 168C165.225 168 165 169.125 165 170.5C165 171.875 164.775 173 164.5 173C164.197 173 164 175.167 164 178.5C164 181.833 164.197 184 164.5 184C164.775 184 165 184.9 165 186C165 187.1 165.225 188 165.5 188C165.775 188 166 188.675 166 189.5C166 190.325 166.225 191 166.5 191C166.775 191 167 191.45 167 192C167 192.55 167.225 193 167.5 193C167.775 193 168 193.45 168 194C168 194.55 168.225 195 168.5 195C168.775 195 169 195.4 169 195.889C169 196.379 169.45 197.104 170 197.5C170.55 197.896 171 198.572 171 199C171 199.428 171.45 200.104 172 200.5C172.55 200.896 173 201.396 173 201.611C173 201.825 172.55 202 172 202C171.45 202 171 202.225 171 202.5C171 202.775 170.55 203 170 203C169.45 203 169 203.225 169 203.5C169 203.775 168.55 204 168 204C167.45 204 167 204.225 167 204.5C167 204.775 166.641 205 166.201 205C165.761 205 164.771 205.675 164 206.5C163.229 207.325 162.349 208 162.043 208C161.319 208 151 218.319 151 219.043C151 219.349 150.325 220.229 149.5 221C148.675 221.771 148 222.761 148 223.201C148 223.641 147.775 224 147.5 224C147.225 224 147 224.45 147 225C147 225.55 146.775 226 146.5 226C146.225 226 146 226.45 146 227C146 227.55 145.775 228 145.5 228C145.225 228 145 228.45 145 229C145 229.55 144.775 230 144.5 230C144.225 230 144 230.675 144 231.5C144 232.325 143.775 233 143.5 233C143.225 233 143 233.45 143 234C143 234.55 142.775 235 142.5 235C142.225 235 142 235.9 142 237C142 238.1 141.775 239 141.5 239C141.225 239 141 239.9 141 241C141 242.1 140.775 243 140.5 243C140.185 243 140 246.333 140 252V261H201H262V256.5C262 253.833 261.796 252 261.5 252C261.204 252 261 250.167 261 247.5C261 244.833 260.796 243 260.5 243C260.225 243 260 242.1 260 241C260 239.9 259.775 239 259.5 239C259.225 239 259 238.1 259 237C259 235.9 258.775 235 258.5 235C258.225 235 258 234.325 258 233.5C258 232.675 257.775 232 257.5 232C257.225 232 257 231.55 257 231C257 230.45 256.775 230 256.5 230C256.225 230 256 229.55 256 229C256 228.45 255.775 228 255.5 228C255.225 228 255 227.55 255 227C255 226.45 254.775 226 254.5 226C254.225 226 254 225.55 254 225C254 224.45 253.775 224 253.5 224C253.225 224 253 223.641 253 223.201C253 222.761 252.325 221.771 251.5 221C250.675 220.229 250 219.349 250 219.043C250 218.319 239.681 208 238.957 208C238.651 208 237.771 207.325 237 206.5C236.229 205.675 235.239 205 234.799 205C234.359 205 234 204.775 234 204.5C234 204.225 233.55 204 233 204C232.45 204 232 203.775 232 203.5C232 203.225 231.55 203 231 203C230.45 203 230 202.775 230 202.5C230 202.225 229.55 202 229 202C228.45 202 228 201.775 228 201.5C228 201.225 228.225 201 228.5 201C228.775 201 229 200.641 229 200.201C229 199.761 229.675 198.771 230.5 198C231.325 197.229 232 196.239 232 195.799C232 195.359 232.225 195 232.5 195C232.775 195 233 194.55 233 194C233 193.45 233.225 193 233.5 193C233.775 193 234 192.55 234 192C234 191.45 234.225 191 234.5 191C234.775 191 235 190.325 235 189.5C235 188.675 235.225 188 235.5 188C235.775 188 236 187.1 236 186C236 184.9 236.225 184 236.5 184C236.803 184 237 181.833 237 178.5C237 175.167 236.803 173 236.5 173C236.225 173 236 171.875 236 170.5C236 169.125 235.775 168 235.5 168C235.225 168 235 167.325 235 166.5C235 165.675 234.775 165 234.5 165C234.225 165 234 164.325 234 163.5C234 162.675 233.775 162 233.5 162C233.225 162 233 161.6 233 161.111C233 160.621 232.55 159.896 232 159.5C231.45 159.104 231 158.469 231 158.09C231 157.711 230.325 156.771 229.5 156C228.675 155.229 228 154.345 228 154.036C228 153.252 223.671 149 222.874 149C222.515 149 221.896 148.55 221.5 148C221.104 147.45 220.428 147 220 147C219.572 147 218.896 146.55 218.5 146C218.104 145.45 217.379 145 216.889 145C216.4 145 216 144.775 216 144.5C216 144.225 215.325 144 214.5 144C213.675 144 213 143.775 213 143.5C213 143.225 212.325 143 211.5 143C210.675 143 210 142.775 210 142.5C210 142.225 208.875 142 207.5 142C206.125 142 205 141.775 205 141.5C205 141.204 203.167 141 200.5 141C197.833 141 196 141.204 196 141.5ZM206 155.5C206 155.775 206.675 156 207.5 156C208.325 156 209 156.225 209 156.5C209 156.775 209.45 157 210 157C210.55 157 211 157.225 211 157.5C211 157.775 211.341 158 211.758 158C212.746 158 220 165.254 220 166.242C220 166.659 220.225 167 220.5 167C220.775 167 221 167.675 221 168.5C221 169.325 221.225 170 221.5 170C221.775 170 222 170.675 222 171.5C222 172.325 222.225 173 222.5 173C222.796 173 223 174.833 223 177.5C223 180.167 222.796 182 222.5 182C222.225 182 222 182.9 222 184C222 185.1 221.775 186 221.5 186C221.225 186 221 186.45 221 187C221 187.55 220.775 188 220.5 188C220.225 188 220 188.341 220 188.758C220 189.746 212.746 197 211.758 197C211.341 197 211 197.225 211 197.5C211 197.775 210.55 198 210 198C209.45 198 209 198.225 209 198.5C209 198.775 208.325 199 207.5 199C206.675 199 206 199.225 206 199.5C206 199.803 203.833 200 200.5 200C197.167 200 195 199.803 195 199.5C195 199.225 194.325 199 193.5 199C192.675 199 192 198.775 192 198.5C192 198.225 191.55 198 191 198C190.45 198 190 197.775 190 197.5C190 197.225 189.55 197 189 197C188.45 197 188 196.775 188 196.5C188 196.225 187.655 196 187.233 196C186.297 196 183 192.789 183 191.877C183 191.516 182.55 190.896 182 190.5C181.45 190.104 181 189.379 181 188.889C181 188.4 180.775 188 180.5 188C180.225 188 180 187.55 180 187C180 186.45 179.775 186 179.5 186C179.225 186 179 185.55 179 185C179 184.45 178.775 184 178.5 184C178.194 184 178 181.667 178 178C178 174.333 178.194 172 178.5 172C178.775 172 179 171.325 179 170.5C179 169.675 179.225 169 179.5 169C179.775 169 180 168.55 180 168C180 167.45 180.225 167 180.5 167C180.775 167 181 166.659 181 166.242C181 165.825 182.684 163.8 184.742 161.742C186.8 159.684 188.825 158 189.242 158C189.659 158 190 157.775 190 157.5C190 157.225 190.45 157 191 157C191.55 157 192 156.775 192 156.5C192 156.225 192.675 156 193.5 156C194.325 156 195 155.775 195 155.5C195 155.197 197.167 155 200.5 155C203.833 155 206 155.197 206 155.5ZM213 211.5C213 211.775 213.9 212 215 212C216.1 212 217 212.225 217 212.5C217 212.775 217.675 213 218.5 213C219.325 213 220 213.225 220 213.5C220 213.775 220.675 214 221.5 214C222.325 214 223 214.225 223 214.5C223 214.775 223.45 215 224 215C224.55 215 225 215.225 225 215.5C225 215.775 225.359 216 225.799 216C226.239 216 227.229 216.675 228 217.5C228.771 218.325 229.652 219 229.957 219C230.804 219 240 228.38 240 229.243C240 229.659 240.225 230 240.5 230C240.775 230 241 230.4 241 230.889C241 231.379 241.45 232.104 242 232.5C242.587 232.924 243 233.795 243 234.611C243 235.375 243.225 236 243.5 236C243.775 236 244 236.45 244 237C244 237.55 244.225 238 244.5 238C244.775 238 245 238.675 245 239.5C245 240.325 245.225 241 245.5 241C245.775 241 246 241.9 246 243C246 244.1 246.225 245 246.5 245C246.775 245 247 245.45 247 246C247 246.993 246.667 247 200.5 247H154V245.5C154 244.675 154.225 244 154.5 244C154.775 244 155 243.1 155 242C155 240.9 155.225 240 155.5 240C155.775 240 156 239.325 156 238.5C156 237.675 156.225 237 156.5 237C156.775 237 157 236.55 157 236C157 235.45 157.225 235 157.5 235C157.775 235 158 234.375 158 233.611C158 232.795 158.413 231.924 159 231.5C159.55 231.104 160 230.477 160 230.107C160 229.737 161.125 228.339 162.5 227C163.875 225.661 165 224.315 165 224.009C165 223.28 167.293 221 168.026 221C168.341 221 169.229 220.325 170 219.5C170.771 218.675 171.711 218 172.09 218C172.469 218 173.104 217.55 173.5 217C173.896 216.45 174.621 216 175.111 216C175.6 216 176 215.775 176 215.5C176 215.225 176.45 215 177 215C177.55 215 178 214.775 178 214.5C178 214.225 178.45 214 179 214C179.55 214 180 213.775 180 213.5C180 213.225 180.9 213 182 213C183.1 213 184 212.775 184 212.5C184 212.225 184.9 212 186 212C187.1 212 188 211.775\n													  188 211.5C188 211.18 192.5 211 200.5 211C208.5 211 213 211.18 213 211.5Z\" \nfill=\"blue\"/></svg></div><div \nng-hide=\"workitemInfo.approvalMatrix.approvers.length == 0 && workitemInfo.flowType == \'Hybrid\'\"><md-icon \nclass=\"icon s-18 md-accent\" md-font-icon=\"icon-replay\" ng-if=\"actvity.actvity==\'111\'\" \ndata-ng-click=\"collaborateBack($event,actvity)\"></md-icon></div></div></div></div></div><md-divider></md-divider><div \nclass=\"md-padding\"><div ng-if=\"workitemInfo.requestType != \'COR_ADV\'\" ng-bind-html=\"currentFormInbox\" compile-template>\n</div><div ng-if=\"workitemInfo.requestType == \'COR_ADV\'\" ng-bind-html=\"currentFormInboxHeader\" compile-template></div>\n</div><md-divider></md-divider><div ng-if=\"currentFormInboxLineitem\" ng-bind-html=\"currentFormInboxLineitem\" \ncompile-template></div></md-content></ms-widget-front></ms-widget><ms-widget layout=\"column\" flex=\"30\" flex-xs=\"100\">\n<ms-widget-front class=\"white-bg\" style=\"border-radius: 6px\"><md-content style=\"background: #e3e9ed3d;padding:15px\">\n<div><div layout=\"row\" layout-align=\"space-between center\" style=\"padding: 10px\"><div><span class=\"h3\" \nstyle=\"color: #030303\">Attachments : {{getAttachmentsLength(workitemInfo.attachments)}}</span></div><div><md-icon \nng-click=\"logs()\" md-font-icon=\"icon-comment-text-outline\" style=\"color: #23b8e5\"></md-icon><md-tooltip \nmd-direction=\"top\">Logs</md-tooltip></div></div><md-divider></md-divider><ms-widget flex=\"100\" flex-gt-xs=\"50\" \nflex-gt-md=\"33\" ng-repeat=\"attachment in workitemInfo.attachments | orderBy :\'folderName\'\" \nng-if=\"workitemInfo.attachments.length && attachment.deleteStatus != \'true\'\"><ms-widget-front class=\"white-bg c-p\">\n<md-list flex><div class=\"h3\" style=\"color: rgb(3,155,229)\">{{attachment.folderName}}</div><div layout=\"row\" \nlayout-align=\"start start\" flex-gt-sm><span><md-icon md-font-icon=\"{{fileIcon(attachment.fileType)}}\" \nclass=\"s42 icon md-accent\"></md-icon></span><div layout=\"column\" flex-gt-sm=\"35\"><span class=\"h4 c-p\">\n{{attachment.fileName}}</span> <span class=\"h6\" style=\"color: #030303\">Created By : {{attachment.creator}}</span></div>\n<div flex-gt-sm=\"20\" layout=\"row\" style=\"margin-top: -1%;margin-left: 27%\"><span \nng-if=\"attachment.deleteStatus ==\'true\'\"><h5 style=\"color:red\">Attachment is Deleted</h5></span><span \nng-if=\"attachment.deleteStatus!=\'true\'\"><md-button class=\"md-icon-button\" ng-click=\"selectFile(attachment)\"><md-tooltip\n md-direction=\"top\">View Document</md-tooltip><md-icon class=\"icon s-18 blue-fg\" md-font-icon=\"icon-eye\"></md-icon>\n</md-button></span><span ng-if=\"attachment.deleteStatus!=\'true\'\"><md-button class=\"md-icon-button md-accent\" \nng-click=\"downloaddirectFile(attachment,workitemInfo.requestId)\"><md-tooltip md-direction=\"top\">Download attach\n</md-tooltip><md-icon layout-align=\"end end\" md-font-icon=\"icon-download\" class=\"s20 green-fg\"></md-icon></md-button>\n</span><span \nng-if=\" workitemInfo.requestType != \'COR_ADV\' &&  workitemInfo.requestType != \'COR_CDP\' && workitemInfo.requestType != \'COR_CUT_PO\' && workitemInfo.requestType != \'COR_FRIEGHT_PO\' && workitemInfo.requestType != \'COR_GEN_PO\' &&workitemInfo.requestType != \'COR_IMP_PO\' &&workitemInfo.requestType != \'COR_LOAD_PO\' &&workitemInfo.requestType != \'COR_NPO\' && workitemInfo.requestType != \'COR_STATU_INV\' && workitemInfo.requestType != \'COR_UNLOAD_PO\' && workitemInfo.requestType != \'COR_CUT_FREIGHT\' && workitemInfo.requestType != \'COR_STG_PO\' \">\n<md-tooltip md-direction=\"top\"><span>Delete Attachment</span></md-tooltip><md-button \nng-if=\"attachment.deleteStatus!=\'true\'\" class=\"md-icon-button md-accent\" \nng-click=\"deleteAttachedFile(attachment,workitemInfo.requestId)\"><md-icon layout-align=\"end end\" \nmd-font-icon=\"icon-close-circle-outline\" class=\"s20 red-fg\"></md-icon></md-button></span></div></div></md-list>\n</ms-widget-front></ms-widget><div layout=\"row\" layout-align=\"center center\"><div><input class=\"ng-hide\" \nid=\"formUploadFile\" name=\"formUploadFile\" type=\"file\" onchange=\"angular.element(this).scope().setAttachmentFile(this)\">\n<label for=\"formUploadFile\" class=\"md-button md-raised md-accent\">Upload Files</label></div></div><div \nng-repeat=\"file in attachmentfiles.slice(0)\" layout-align=\"center center\" style=\"text-align: center\"><div><span \nclass=\"md-warn\">{{file.webkitRelativePath || file.name}}</span> (<span ng-switch=\"file.size > 1024*1024\"> <span \nng-switch-when=\"true\">{{file.size / 1024 / 1024 | number:2}} MB</span> <span ng-switch-default>\n{{file.size / 1024 | number:2}} kB</span> </span>) <span><md-tooltip md-direction=\"top\"><span>Remove Attachment</span>\n</md-tooltip><md-icon class=\"icon\" md-font-icon=\"icon-close-circle-outline\" style=\"color: red\" \nng-click=\"removeAttachment($index)\"></md-icon></span><span><md-tooltip md-direction=\"top\"><span>View Attachment</span>\n</md-tooltip><md-icon md-font-icon=\"icon-eye\" ng-click=\"previewFile(file)\" class=\"s25\"></md-icon></span></div></div>\n</div></md-content></ms-widget-front></ms-widget></div><ms-widget><mswidget-front><div flippable=\"true\" \nlayout=\"column\" flex=\"100\" style=\"padding: 15px\" ng-if=\"workitemInfo.requestType ==\'COR_EXCL_PDR\'\"><div \nlayout=\"column\" class=\"white-bg md-card\"><div layout=\"row\" layout-align=\"space-between center\" style=\"padding: 17px\" \nflex=\"100\"><div layout=\"row\" flex=\"60\" ng-bind-html=\"currentFormInbox\" compile-template></div><div layout=\"column\" \nflex=\"40\" style=\"padding: 29px;margin-top: -4%\"><div layout=\"row\" layout-align=\"end end\"><div layout=\"row\" \nng-repeat=\"actvity in workitemInfo.activities\"><md-tooltip md-direction=\"top\">{{actvity.buttonText}}</md-tooltip><div \nlayout=\"row\"><div layout=\"row\"><md-icon class=\"icon s-18 green-fg\" md-font-icon=\"icon-check\" \ndata-ng-click=\"processActvity(actvity, $event);\" ng-if=\"actvity.buttonText==\'Approve\' && workitemInfo.sendToSAP !=\'5\'\">\n</md-icon></div><div layout=\"row\"><md-icon class=\"icon s-18 red-fg\" md-font-icon=\"icon-close\" \ndata-ng-click=\"processActvity(actvity, $event);\" ng-if=\"actvity.buttonText==\'Reject\'&& workitemInfo.sendToSAP !=\'5\'\">\n</md-icon></div><div data-ng-click=\"collaborate ($event,actvity)\" \nng-if=\"actvity.buttonText==\'Collaborate\' && workitemInfo.sendToSAP !=\'5\'\" style=\"margin-left: 15%;margin-top: 9%\"><svg \nxmlns=\"http://www.w3.org/2000/svg\" width=\"30\" height=\"16\" viewBox=\"0 0 262 261\" fill=\"none\"><path fill-rule=\"evenodd\" \nclip-rule=\"evenodd\" \nd=\"M56 0.5C56 0.775 54.875 1 53.5 1C52.125 1 51 1.225 51 1.5C51 1.775 50.325 2 49.5 2C48.675 2 48 2.225 48 2.5C48 2.775 47.55 3 47 3C46.45 3 46 3.225 46 3.5C46 3.775 45.55 4 45 4C44.45 4 \n															 44 4.225 44 4.5C44 4.775 43.55 5 43 5C42.45 5 42 5.225 42 5.5C42 5.775 41.6595 6 41.2435 6C40.257 6 \n															 31 15.257 31 16.2435C31 16.6595 30.775 17 30.5 17C30.225 17 30 17.4005 30 17.8895C30 18.379 29.55 19.1035 \n															 29 19.5C28.45 19.8965 28 20.621 28 21.1105C28 21.5995 27.775 22 27.5 22C27.225 22 27 22.675 27 23.5C27 24.325\n															 26.775 25 26.5 25C26.225 25 26 25.675 26 26.5C26 27.325 25.775 28 25.5 28C25.209 28 25 29.653 25 31.9585C25 34.636 24.798 \n															 36.011 24.375 36.2085C23.875 36.4415 23.875 36.5585 24.375 36.7915C24.7865 36.984 25 38.264 25 40.5415C25 42.514 25.215 44 25.5\n															  44C25.775 44 26 44.9 26 46C26 47.1 26.225 48 26.5 48C26.775 48 27 48.675 27 49.5C27 50.325 27.225 51 27.5 51C27.775 51 28 51.45 28 52C28 52.55 28.225 53 28.5 53C28.775 53 29 53.4005 29 53.8895C29 54.379 29.45 55.1035 30 55.5C30.55 55.8965 31 56.5715 31 57C31 57.4285 31.45 58.1035 32 58.5C32.55 58.8965 33 59.5245 33 59.896C33 60.8115 31.7495 62 30.7855 62C30.3535 62 30 62.225 30 62.5C30 62.775 29.55 63 29 63C28.45 63 28 63.225 28 63.5C28 63.775 27.5995 64 27.1105 64C26.621 64 25.8965 64.45 25.5 65C25.1035 65.55 24.4285 66 24 66C23.5715 66 22.8965 66.45 22.5 67C22.1035 67.55 21.487 68 21.1305 68C20.3445 68 14 74.2555 14 75.03C14 75.3315 13.1 76.443 12 77.5C10.9 78.557 10 79.727 10 80.1005C10 80.474 9.55 81.1035 9 81.5C8.45 81.8965 8 82.621 8 83.1105C8 83.5995 7.775 84 7.5 84C7.225 84 7 84.45 7 85C7 85.55 6.775 86 6.5 86C6.225 86 6 86.45 6 87C6 87.55 5.775 88 5.5 88C5.225 88 5 88.45 5 89C5 89.55 4.775 90 4.5 90C4.225 90 4 90.675 4 91.5C4 92.325 3.775 93 3.5 93C3.225 93 3 93.45 3 94C3 94.55 2.775 95 2.5 95C2.225 95 2 96.125 2 97.5C2 98.875 1.775 100 1.5 100C1.2145 100 1 101.5 1 103.5C1 105.5 0.7855 107 0.5 107C0.1925 107 0 109.5 0 113.5V120H61H122V111.5C122 106.167 121.813 103 121.5 103C121.225 103 121 102.1 121 101C121 99.9 120.775 99 120.5 99C120.225 99 120 98.1 120 97C120 95.9 119.775 95 119.5 95C119.225 95 119 94.325 119 93.5C119 92.675 118.775 92 118.5 92C118.225 92 118 91.55 118 91C118 90.45 117.775 90 117.5 90C117.225 90 117 89.55 117 89C117 88.45 116.775 88 116.5 88C116.225 88 116 87.55 116 87C116 86.45 115.775 86 115.5 86C115.225 86 115 85.55 115 85C115 84.45 114.775 84 114.5 84C114.225 84 114 83.55 114 83C114 82.45 113.775 82 113.5 82C113.225 82 113 81.6405 113 81.2005C113 80.761 112.325 79.7705 111.5 79C110.675 78.2295 110 77.3485 110 77.0425C110 76.316 101.684 68 100.958 68C100.652 68 99.7705 67.325 99 66.5C98.2295 65.675 97.2885 65 96.91 65C96.531 65 95.8965 64.55 95.5 64C95.1035 63.45 94.379 63 93.8895 63C93.4005 63 93 62.775 93 62.5C93 62.225 92.55 62 92 62C91.45 62 91 61.775 91 61.5C91 61.225 90.55 61 90 61C89.45 61 89 60.775 89 60.5C89 60.225 89.225 60 89.5 60C89.775 60 90 59.5995 90 59.1105C90 58.621 90.45 57.8965 91 57.5C91.55 57.1035 92 56.379 92 55.8895C92 55.4005 92.225 55 92.5 55C92.775 55 93 54.55 93 54C93 53.45 93.225 53 93.5 53C93.775 53 94 52.55 94 52C94 51.45 94.225 51 94.5 51C94.775 51 95 50.55 95 50C95 49.45 95.225 49 95.5 49C95.775 49 96 48.325 96 47.5C96 46.675 96.225 46 96.5 46C96.778 46 97 44.6665 97 43C97 41.3335 97.222 40 97.5 40C97.778 40 98 38.6665 98 37C98 35.3335 97.778 34 97.5 34C97.2145 34 97 32.5 97 30.5C97 28.5 96.7855 27 96.5 27C96.225 27 96 26.325 96 25.5C96 24.675 95.775 24 95.5 24C95.225 24 95 23.3745 95 22.6105C95 21.7945 94.587 20.9235 94 20.5C93.45 20.1035 93 19.379 93 18.8895C93 18.4005 92.775 18 92.5 18C92.225 18 92 17.645 92 17.211C92 16.7765 91.1 15.557 90 14.5C88.9 13.443 88 12.3255 88 12.0165C88 11.282 85.7105 9 84.9735 9C84.6585 9 83.7705 8.325 83 7.5C82.2295 6.675 81.239 6 80.7995 6C80.3595 6 80 5.775 80 5.5C80 5.225 79.55 5 79 5C78.45 5 78 4.775 78 4.5C78 4.225 77.55 4 77 4C76.45 4 76 3.775 76 3.5C76 3.225 75.55 3 75 3C74.45 3 74 2.775 74 2.5C74 2.225 73.325 2 72.5 2C71.675 2 71 1.775 71 1.5C71 1.225 69.875 1 68.5 1C67.125 1 66 0.775 66 0.5C66 0.2 64 0 61 0C58 0 56 0.2 56 0.5ZM66 14.5C66 14.775 66.675 15 67.5 15C68.325 15 69 15.225 69 15.5C69 15.775 69.45 16 70 16C70.55 16 71 16.225 71 16.5C71 16.775 71.45 17 72 17C72.55 17 73 17.225 73 17.5C73 17.775 73.3425 18 73.761 18C74.751 18 80 23.249 80 24.239C80 24.6575 80.225 25 80.5 25C80.775 25 81 25.45 81 26C81 26.55 81.225 27 81.5 27C81.775 27 82 27.45 82 28C82 28.55 82.225 29 82.5 29C82.775 29 83 29.675 83 30.5C83 31.325 83.225 32 83.5 32C83.7965 32 84 33.8335 84 36.5C84 39.1665 83.7965 41 83.5 41C83.225 41 83 41.675 83 42.5C83 43.325 82.775 44 82.5 44C82.225 44 82 44.45 82 45C82 45.55 81.775 46 81.5 46C81.225 46 81 46.45 81 47C81 47.55 80.775 48 80.5 48C80.225 48 80 48.3415 80 48.7595C80 49.748 73.748 56 72.7595 56C72.3415 56 72 56.225 72 56.5C72 56.775 71.55 57 71 57C70.45 57 70 57.225 70 57.5C70 57.775 69.325 58 68.5 58C67.675 58 67 58.225 67 58.5C67 58.803 64.8335 59 61.5 59C58.1665 59 56 58.803 56 58.5C56 58.225 55.325 58 54.5 58C53.675 58 53 57.775 53 57.5C53 57.225 52.55 57 52 57C51.45 57 51 56.775 51 56.5C51 56.225 50.5995 56 50.1105 56C49.621 56 48.8965 55.55 48.5 55C48.1035 54.45 47.481 54 47.117 54C46.2585 54 44 51.7415 44 50.883C44 50.519 43.55 49.8965 43 49.5C42.45 49.1035 42 48.4285 42 48C42 47.5715 41.55 46.8965 41 46.5C40.413 46.0765 40 45.2055 40 44.3895C40 43.6255 39.775 43 39.5 43C39.1925 43 39 40.5 39 36.5C39 32.5 39.1925 30 39.5 30C39.775 30 40 29.3745 40 28.6105C40 27.7945 40.413 26.9235 41 26.5C41.55 26.1035 42 25.4285 42 25C42 24.5715 42.45 23.8965 43 23.5C43.55 23.1035 44 22.481 44 22.117C44 21.2585 46.2585 19 47.117 19C47.481 19 48.1035 18.55 48.5 18C48.8965 17.45 49.621 17 50.1105 17C50.5995 17 51 16.775 51 16.5C51 16.225 51.45 16 52 16C52.55 16 53 15.775 53 15.5C53 15.225 53.9 15 55 15C56.1 15 57 14.775 57 14.5C57 14.2035 58.8335 14 61.5 14C64.1665 14 66 14.2035 66 14.5ZM128.5 41C128.104 41.55 127.379 42 126.889 42C126.333 42 126 42.3745 126 43C126 43.55 125.775 44 125.5 44C125.225 44 125 45.245 125 46.7665C125 49.257 125.173 49.7065 126.734 51.2665C127.687 52.22 128.812 53 129.234 53C129.655 53 130 53.225 130 53.5C130 53.8265 138.667 54 155 54C171.333 54 180 54.1735 180 54.5C180 54.775 180.675 55 181.5 55C182.325 55 183 55.225 183 55.5C183 55.775 183.359 56 183.799 56C184.239 56 185.229 56.675 186 57.5C186.771 58.325 187.659 59 187.974 59C188.815 59 191 61.33 191 62.2275C191 62.6525 191.225 63 191.5 63C191.775 63 192 63.45 192 64C192 64.55 192.225 65 192.5 65C192.775 65 193 65.675 193 66.5C193 67.325 193.225 68 193.5 68C193.824 68 194 74.3335 194 86C194 95.9 193.882 104 193.737 104C193.593 104 190.336 100.85 186.5 97C182.664 93.15 179.182 90 178.763 90C178.343 90 178 89.775 178 89.5C178 89.225 176.755 89 175.233 89C172.743 89 172.293 89.173 170.733 90.7335C169.109 92.3575 169 92.6725 169 95.7335C169 97.578 169.218 99 169.5 99C169.775 99 170 99.3385 170 99.7525C170 100.735 196.265 127 197.247 127C197.661 127 198 127.225 198 127.5C198 127.775 198.45 128 199 128C199.55 128 200 128.225 200 128.5C200 128.775 200.675 129 201.5 129C202.325 129 203 128.775 203 128.5C203 128.225 203.45 128 204 128C204.55 128 205 127.775 205 127.5C205 127.225 205.339 127 205.753 127C206.735 127 233 100.735 233 99.7525C233 99.3385 233.225 99 233.5 99C233.778 99 234 97.6665 234 96C234 94.3335 233.778 93 233.5 93C233.225 93 233 92.6465 233 92.2145C233 91.204 231.796 90 230.785 90C230.353 90 230 89.775 230 89.5C230 89.225 228.758 89 227.239 89H224.478L216.5 97C212.113 101.4 208.405 105 208.261 105C208.117 105 208 96.225 208 85.5C208 72.8335 207.825 66 207.5 66C207.225 66 207 65.325 207 64.5C207 63.675 206.775 63 206.5 63C206.225 63 206 62.325 206 61.5C206 60.675 205.775 60 205.5 60C205.225 60 205 59.55 205 59C205 58.45 204.775 58 204.5 58C204.225 58 204 57.55 204 57C204 56.45 203.775 56 203.5 56C203.225 56 203 55.6595 203 55.2435C203 54.257 193.743 45 192.757 45C192.341 45 192 44.775 192 44.5C192 44.225 191.55 44 191 44C190.45 44 190 43.775 190 43.5C190 43.225 189.55 43 189 43C188.45 43 188 42.775 188 42.5C188 42.225 187.325 42 186.5 42C185.675 42 185 41.775 185 41.5C185 41.225 184.325 41 183.5 41C182.675 41 182 40.775 182 40.5C182 40.173 172.87 40 155.611 40C129.795 40 129.205 40.0215 128.5 41ZM75 70.5C75 70.775 75.675 71 76.5 71C77.325 71 78 71.225 78 71.5C78 71.775 78.675 72 79.5 72C80.325 72 81 72.225 81 72.5C81 72.775 81.45 73 82 73C82.55 73 83 73.225 83 73.5C83 73.775 83.45 74 84 74C84.55 74 85 74.225 85 74.5C85 74.775 85.45 75 86 75C86.55 75 87 75.225 87 75.5C87 75.775 87.4005 76 87.8895 76C88.379 76 89.1035 76.45 89.5 77C89.8965 77.55 90.512 78 90.8675 78C91.711 78 100 86.289 100 87.1325C100 87.488 100.45 88.1035 101 88.5C101.55 88.8965 102 89.621 102 90.1105C102 90.5995 102.225 91 102.5 91C102.775 91 103 91.45 103 92C103 92.55 103.225 93 103.5 93C103.775 93 104 93.45 104 94C104 94.55 104.225 95 104.5 95C104.775 95 105 95.45 105 96C105 96.55 105.225 97 105.5 97C105.775 97 106 97.9 106 99C106 100.1 106.225 101 106.5 101C106.775 101 107 101.9 107 103C107 104.1 107.225 105 107.5 105C107.775 105 108 105.225 108 105.5C108 105.829 92.1665 106 61.5 106H15V104C15 102.9 15.225 102 15.5 102C15.775 102 16 101.1 16 100C16 98.9 16.225 98 16.5 98C16.775 98 17 97.55 17 97C17 96.45 17.225 96 17.5 96C17.775 96 18 95.325 18 94.5C18 93.675 18.225 93 18.5 93C18.775 93 19 92.5995 19 92.1105C19 91.621 19.45 90.8965 20 90.5C20.55 90.1035 21 89.4285 21 89C21 88.5715 21.45 87.8965 22 87.5C22.55 87.1035 23 86.487 23 86.1305C23 85.3385 29.2585 79 30.04 79C30.3475 79 31.2295 78.325 32 77.5C32.7705 76.675 33.761 76 34.2005 76C34.6405 76 35 75.775 35 75.5C35 75.225 35.45 75 36 75C36.55 75 37 74.775 37 74.5C37 74.225 37.45 74 38 74C38.55 74 39 73.775 39 73.5C39 73.225 39.45 73 40 73C40.55 73 41 72.775 41 72.5C41 72.225 41.675 72 42.5 72C43.325 72 44 71.775 44 71.5C44 71.225 44.675 71 45.5 71C46.325 71 47 70.775 47 70.5C47 70.1785 52 70 61 70C70 70 75 70.1785 75 70.5ZM61 132.5C61 132.775 60.4365 133 59.748 133C58.774 133 55.326 136.17 44.248 147.248C36.4115 155.084 30 161.834 30 162.248C30 162.662 29.775 163 29.5 163C29.225 163 29 164.075 29 165.389C29 167.205 29.24 167.952 30 168.5C30.55 168.896 31 169.621 31 170.111C31 170.667 31.3745 171 32 171C32.55 171 33 171.225 33 171.5C33 171.778 34.3335 172 36 172C37.6665 172 39 171.778 39 171.5C39 171.225 39.343 171 39.7625 171C40.182 171 43.664 167.85 47.5 164C51.336 160.15 54.593 157 54.7375 157C54.882 157 55 165.775 55 176.5C55 189.167 55.175 196 55.5 196C55.775 196 56 197.125 56 198.5C56 199.875 56.225 201 56.5 201C56.775 201 57 201.45 57 202C57 202.55 57.225 203 57.5 203C57.775 203 58 203.675 58 204.5C58 205.325 58.225 206 58.5 206C58.775 206 59 206.4 59 206.889C59 207.379 59.45 208.104 60 208.5C60.55 208.896 61 209.512 61 209.867C61 210.777 69.3225 219 70.243 219C70.6595 \n															  219 71 219.225 71 219.5C71 219.775 71.45 220 72 220C72.55 220 73 220.225 73 220.5C73 220.775 73.45 221 74 221C74.55 221 75 221.225 75 221.5C75 221.775 75.675 222 76.5 222C77.325 222 78 222.225 78 222.5C78 222.775 78.675 223 79.5 223C80.325 223 81 223.225 81 223.5C81 223.785 82.5 224 84.5 224C86.5 224 88 224.215 88 224.5C88 224.824 94.1665 225 105.5 225C116.833 225 123 224.824 123 224.5C123 224.225 123.798 224 124.773 224C126.668 224 129 222.219 129 220.772C129 220.347 129.225 220 129.5 220C129.775 220 130 218.875 130 217.5C130 216.125 129.775 215 129.5 215C129.225 215 129 214.647 129 214.215C129 213.204 127.796 212 126.786 212C126.354 212 126 211.775 126 211.5C126 211.175 119 211 106 211C93 211 86 210.825 86 210.5C86 210.225 85.1 210 84 210C82.9 210 82 209.775 82 209.5C82 209.225 81.3745 209 80.6105 209C79.7945 209 78.9235 208.587 78.5 208C78.1035 207.45 77.4855 207 77.1265 207C76.216 207 72 202.694 72 201.763C72 201.344 71.775 201 71.5 201C71.225 201 71 200.55 71 200C71 199.45 70.775 199 70.5 199C70.225 199 70 198.325 70 197.5C70 196.675 69.775 196 69.5 196C69.175 196 69 189 69 176C69 165 69.1175 156 69.261 156C69.405 156 73.1125 159.6 77.5 164L85.4775 172H88.239C89.7575 172 91 171.775 91 171.5C91 171.225 91.3535 171 91.7855 171C92.796 171 94 169.796 94 168.785C94 168.353 94.225 168 94.5 168C94.775 168 95 166.875 95 165.5C95 164.125 94.775 163 94.5 163C94.225 163 94 162.662 94 162.248C94 161.834 87.5885 155.084 79.752 147.248C68.674 136.17 65.226 133 64.252 133C63.5635 133 63 132.775 63 132.5C63 132.225 62.55 132 62 132C61.45 132 61 132.225 61 132.5ZM196 141.5C196 141.775 194.875 142 193.5 142C192.125 142 191 142.225 191 142.5C191 142.775 190.325 143 189.5 143C188.675 143 188 143.225 188 143.5C188 143.775 187.325 144 186.5 144C185.675 144 185 144.225 185 144.5C185 144.775 184.6 145 184.111 145C183.621 145 182.896 145.45 182.5 146C182.104 146.55 181.469 147 181.09 147C180.711 147 179.771 147.675 179 148.5C178.229 149.325 177.346 150 177.036 150C176.253 150 172 154.329 172 155.126C172 155.485 171.55 156.104 171 156.5C170.45 156.896 170 157.621 170 158.111C170 158.6 169.775 159 169.5 159C169.225 159 169 159.45 169 160C169 160.55 168.775 161 168.5 161C168.225 161 168 161.45 168 162C168 162.55 167.775 163 167.5 163C167.225 163 167 163.45 167 164C167 164.55 166.775 165 166.5 165C166.225 165 166 165.675 166 166.5C166 167.325 165.775 168 165.5 168C165.225 168 165 169.125 165 170.5C165 171.875 164.775 173 164.5 173C164.197 173 164 175.167 164 178.5C164 181.833 164.197 184 164.5 184C164.775 184 165 184.9 165 186C165 187.1 165.225 188 165.5 188C165.775 188 166 188.675 166 189.5C166 190.325 166.225 191 166.5 191C166.775 191 167 191.45 167 192C167 192.55 167.225 193 167.5 193C167.775 193 168 193.45 168 194C168 194.55 168.225 195 168.5 195C168.775 195 169 195.4 169 195.889C169 196.379 169.45 197.104 170 197.5C170.55 197.896 171 198.572 171 199C171 199.428 171.45 200.104 172 200.5C172.55 200.896 173 201.396 173 201.611C173 201.825 172.55 202 172 202C171.45 202 171 202.225 171 202.5C171 202.775 170.55 203 170 203C169.45 203 169 203.225 169 203.5C169 203.775 168.55 204 168 204C167.45 204 167 204.225 167 204.5C167 204.775 166.641 205 166.201 205C165.761 205 164.771 205.675 164 206.5C163.229 207.325 162.349 208 162.043 208C161.319 208 151 218.319 151 219.043C151 219.349 150.325 220.229 149.5 221C148.675 221.771 148 222.761 148 223.201C148 223.641 147.775 224 147.5 224C147.225 224 147 224.45 147 225C147 225.55 146.775 226 146.5 226C146.225 226 146 226.45 146 227C146 227.55 145.775 228 145.5 228C145.225 228 145 228.45 145 229C145 229.55 144.775 230 144.5 230C144.225 230 144 230.675 144 231.5C144 232.325 143.775 233 143.5 233C143.225 233 143 233.45 143 234C143 234.55 142.775 235 142.5 235C142.225 235 142 235.9 142 237C142 238.1 141.775 239 141.5 239C141.225 239 141 239.9 141 241C141 242.1 140.775 243 140.5 243C140.185 243 140 246.333 140 252V261H201H262V256.5C262 253.833 261.796 252 261.5 252C261.204 252 261 250.167 261 247.5C261 244.833 260.796 243 260.5 243C260.225 243 260 242.1 260 241C260 239.9 259.775 239 259.5 239C259.225 239 259 238.1 259 237C259 235.9 258.775 235 258.5 235C258.225 235 258 234.325 258 233.5C258 232.675 257.775 232 257.5 232C257.225 232 257 231.55 257 231C257 230.45 256.775 230 256.5 230C256.225 230 256 229.55 256 229C256 228.45 255.775 228 255.5 228C255.225 228 255 227.55 255 227C255 226.45 254.775 226 254.5 226C254.225 226 254 225.55 254 225C254 224.45 253.775 224 253.5 224C253.225 224 253 223.641 253 223.201C253 222.761 252.325 221.771 251.5 221C250.675 220.229 250 219.349 250 219.043C250 218.319 239.681 208 238.957 208C238.651 208 237.771 207.325 237 206.5C236.229 205.675 235.239 205 234.799 205C234.359 205 234 204.775 234 204.5C234 204.225 233.55 204 233 204C232.45 204 232 203.775 232 203.5C232 203.225 231.55 203 231 203C230.45 203 230 202.775 230 202.5C230 202.225 229.55 202 229 202C228.45 202 228 201.775 228 201.5C228 201.225 228.225 201 228.5 201C228.775 201 229 200.641 229 200.201C229 199.761 229.675 198.771 230.5 198C231.325 197.229 232 196.239 232 195.799C232 195.359 232.225 195 232.5 195C232.775 195 233 194.55 233 194C233 193.45 233.225 193 233.5 193C233.775 193 234 192.55 234 192C234 191.45 234.225 191 234.5 191C234.775 191 235 190.325 235 189.5C235 188.675 235.225 188 235.5 188C235.775 188 236 187.1 236 186C236 184.9 236.225 184 236.5 184C236.803 184 237 181.833 237 178.5C237 175.167 236.803 173 236.5 173C236.225 173 236 171.875 236 170.5C236 169.125 235.775 168 235.5 168C235.225 168 235 167.325 235 166.5C235 165.675 234.775 165 234.5 165C234.225 165 234 164.325 234 163.5C234 162.675 233.775 162 233.5 162C233.225 162 233 161.6 233 161.111C233 160.621 232.55 159.896 232 159.5C231.45 159.104 231 158.469 231 158.09C231 157.711 230.325 156.771 229.5 156C228.675 155.229 228 154.345 228 154.036C228 153.252 223.671 149 222.874 149C222.515 149 221.896 148.55 221.5 148C221.104 147.45 220.428 147 220 147C219.572 147 218.896 146.55 218.5 146C218.104 145.45 217.379 145 216.889 145C216.4 145 216 144.775 216 144.5C216 144.225 215.325 144 214.5 144C213.675 144 213 143.775 213 143.5C213 143.225 212.325 143 211.5 143C210.675 143 210 142.775 210 142.5C210 142.225 208.875 142 207.5 142C206.125 142 205 141.775 205 141.5C205 141.204 203.167 141 200.5 141C197.833 141 196 141.204 196 141.5ZM206 155.5C206 155.775 206.675 156 207.5 156C208.325 156 209 156.225 209 156.5C209 156.775 209.45 157 210 157C210.55 157 211 157.225 211 157.5C211 157.775 211.341 158 211.758 158C212.746 158 220 165.254 220 166.242C220 166.659 220.225 167 220.5 167C220.775 167 221 167.675 221 168.5C221 169.325 221.225 170 221.5 170C221.775 170 222 170.675 222 171.5C222 172.325 222.225 173 222.5 173C222.796 173 223 174.833 223 177.5C223 180.167 222.796 182 222.5 182C222.225 182 222 182.9 222 184C222 185.1 221.775 186 221.5 186C221.225 186 221 186.45 221 187C221 187.55 220.775 188 220.5 188C220.225 188 220 188.341 220 188.758C220 189.746 212.746 197 211.758 197C211.341 197 211 197.225 211 197.5C211 197.775 210.55 198 210 198C209.45 198 209 198.225 209 198.5C209 198.775 208.325 199 207.5 199C206.675 199 206 199.225 206 199.5C206 199.803 203.833 200 200.5 200C197.167 200 195 199.803 195 199.5C195 199.225 194.325 199 193.5 199C192.675 199 192 198.775 192 198.5C192 198.225 191.55 198 191 198C190.45 198 190 197.775 190 197.5C190 197.225 189.55 197 189 197C188.45 197 188 196.775 188 196.5C188 196.225 187.655 196 187.233 196C186.297 196 183 192.789 183 191.877C183 191.516 182.55 190.896 182 190.5C181.45 190.104 181 189.379 181 188.889C181 188.4 180.775 188 180.5 188C180.225 188 180 187.55 180 187C180 186.45 179.775 186 179.5 186C179.225 186 179 185.55 179 185C179 184.45 178.775 184 178.5 184C178.194 184 178 181.667 178 178C178 174.333 178.194 172 178.5 172C178.775 172 179 171.325 179 170.5C179 169.675 179.225 169 179.5 169C179.775 169 180 168.55 180 168C180 167.45 180.225 167 180.5 167C180.775 167 181 166.659 181 166.242C181 165.825 182.684 163.8 184.742 161.742C186.8 159.684 188.825 158 189.242 158C189.659 158 190 157.775 190 157.5C190 157.225 190.45 157 191 157C191.55 157 192 156.775 192 156.5C192 156.225 192.675 156 193.5 156C194.325 156 195 155.775 195 155.5C195 155.197 197.167 155 200.5 155C203.833 155 206 155.197 206 155.5ZM213 211.5C213 211.775 213.9 212 215 212C216.1 212 217 212.225 217 212.5C217 212.775 217.675 213 218.5 213C219.325 213 220 213.225 220 213.5C220 213.775 220.675 214 221.5 214C222.325 214 223 214.225 223 214.5C223 214.775 223.45 215 224 215C224.55 215 225 215.225 225 215.5C225 215.775 225.359 216 225.799 216C226.239 216 227.229 216.675 228 217.5C228.771 218.325 229.652 219 229.957 219C230.804 219 240 228.38 240 229.243C240 229.659 240.225 230 240.5 230C240.775 230 241 230.4 241 230.889C241 231.379 241.45 232.104 242 232.5C242.587 232.924 243 233.795 243 234.611C243 235.375 243.225 236 243.5 236C243.775 236 244 236.45 244 237C244 237.55 244.225 238 244.5 238C244.775 238 245 238.675 245 239.5C245 240.325 245.225 241 245.5 241C245.775 241 246 241.9 246 243C246 244.1 246.225 245 246.5 245C246.775 245 247 245.45 247 246C247 246.993 246.667 247 200.5 247H154V245.5C154 244.675 154.225 244 154.5 244C154.775 244 155 243.1 155 242C155 240.9 155.225 240 155.5 240C155.775 240 156 239.325 156 238.5C156 237.675 156.225 237 156.5 237C156.775 237 157 236.55 157 236C157 235.45 157.225 235 157.5 235C157.775 235 158 234.375 158 233.611C158 232.795 158.413 231.924 159 231.5C159.55 231.104 160 230.477 160 230.107C160 229.737 161.125 228.339 162.5 227C163.875 225.661 165 224.315 165 224.009C165 223.28 167.293 221 168.026 221C168.341 221 169.229 220.325 170 219.5C170.771 218.675 171.711 218 172.09 218C172.469 218 173.104 217.55 173.5 217C173.896 216.45 174.621 216 175.111 216C175.6 216 176 215.775 176 215.5C176 215.225 176.45 215 177 215C177.55 215 178 214.775 178 214.5C178 214.225 178.45 214 179 214C179.55 214 180 213.775 180 213.5C180 213.225 180.9 213 182 213C183.1 213 184 212.775 184 212.5C184 212.225 184.9 212 186 212C187.1 212 188 211.775\n															   188 211.5C188 211.18 192.5 211 200.5 211C208.5 211 213 211.18 213 211.5Z\" \nfill=\"blue\"/></svg></div><div ng-show=\"workitemInfo.status == \'7\' ||workitemInfo.status == \'5\' \"><md-icon \nclass=\"icon s-18 md-accent\" md-font-icon=\"icon-replay\" ng-if=\"workitemInfo.sendToSAP ==\'5\' && actvity.actvity==\'551\'\" \ndata-ng-click=\"collaborateBack($event,actvity)\"></md-icon></div></div></div></div></div></div><div layout=\"row\" \nlayout-align=\"end end\" style=\"padding:10px\"><div><md-button class=\"md-raised\" ng-click=\"logs()\" \nstyle=\"border: 1px solid #27a4d4;color: #27a4d4;margin-left: -30%\">Logs<md-icon class=\"icon s-18 #27a4d4-fg\" \nmd-font-icon=\"icon-comment-text-outline\" style=\"color: #27a4d4\"></md-icon></md-button></div><div><md-button \nclass=\"md-raised\" ng-click=\"Attachments()\" style=\"border: 1px solid #27a4d4;color: #27a4d4\">Attachments<md-icon \nclass=\"icon s-18 #27a4d4-fg\" md-font-icon=\"icon-comment-text-outline\" style=\"color: #27a4d4\"></md-icon></md-button>\n</div></div></div><div ng-bind-html=\"currentFormInboxLineitem\" style=\"color: black\" compile-template></div></div>\n</mswidget-front></ms-widget></div>");
$templateCache.put("app/main/coromandel_inbox/c_inbox/deleteAttachments.html","<md-dialog flex=\"90\" flex-gt-sm=\"70\" flex-md=\"60\" flex-gt-md=\"45\"><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools\"><h2>Delete Attachments</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"cancel()\"><md-icon md-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><form name=\"commentForm\" \nnovalidate layout=\"column\"><div layout=\"row\"><md-input-container class=\"md-block no-margin\" flex=\"100\"><label>\nAdd comment</label><textarea ng-model=\"comment\" columns=\"1\" maxlength=\"250\" md-maxlength=\"250\" rows=\"3\" required>\n</textarea></md-input-container></div></form></md-dialog-content><md-dialog-actions layout=\"row\"><span flex></span>\n<md-button ng-click=\"cancel()\">Cancel</md-button><md-button ng-click=\"deleteattachment( comment)\" \nng-disabled=\"!comment\">Send</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/login/forgot-password/forgot-password.html","<div id=\"forgotpassword\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"forgot-password-form-wrapper\" \nlayout=\"column\" layout-align=\"center center\"><div id=\"forgot-password-form\" class=\"md-whiteframe-8dp\"><div \nclass=\"logo md-accent-bg\"><span>SP</span></div><div class=\"title\">Recover your password</div><form \nname=\"vm.forgotPasswordForm\" novalidate ng-submit=\"vm.forgotPasswordForm.$valid && vm.reset(user)\"><md-input-container \nclass=\"md-block\"><input type=\"email\" name=\"email\" ng-model=\"user.email\" placeholder=\"Email\" required><div \nng-messages=\"vm.forgotPasswordForm.email.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>\nEmail field is required</span></div><div ng-message=\"email\"><span>Email must be a valid e-mail address</span></div>\n</div></md-input-container><md-button \nclass=\"md-raised md-accent submit-button md-button ng-scope md-default-theme md-ink-ripple\" type=\"submit\" \naria-label=\"SEND RESET LINK\">SEND RESET LINK<div class=\"md-ripple-container\"></div></md-button></form><div \nclass=\"login\" layout=\"row\" layout-align=\"center center\"><a class=\"link\" ui-sref=\"app.sample\">Go back to login</a></div>\n</div></div></div>");
$templateCache.put("app/main/profile/documents/documentUploadDialog.html","<md-dialog flex=\"35\" ng-init=\"getDocumentTypes(); getDocumentTemplate();\"><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools\"><h2>Upload Document</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"cancel()\"><md-icon md-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content class=\"p-0\"><md-tabs \nmd-dynamic-height md-stretch-tabs=\"always\" md-center-tabs><md-tab label=\"Create\"><form name=\"uploadfile\" \nng-submit=\"uploadfile.$valid && uploadFile($event,folderName, description,documentTypeName,documentTypeJson)\">\n<md-content class=\"md-padding scrollable\" ms-scroll><span class=\"md-body-2\" ng-style=\"{color:\'red\'}\" \nng-hide=\"files.length\">{{ErrorMsg}}</span><div layout=\"row\" \nng-hide=\"folderName || foldersOnly || filepermission == true\"><div flex=\"35\" layout=\"column\" \nlayout-align=\"start center\"><span class=\"h3\"><b>Upload File</b></span></div><span flex=\"5\"></span><div flex=\"45\" \nlayout=\"column\" layout-align=\"center start\"><input class=\"ng-hide\" id=\"formUploadFile\" name=\"formUploadFile\" \ntype=\"file\" onchange=\"angular.element(this).scope().setFile(this)\"><label for=\"formUploadFile\" \nclass=\"md-button md-raised md-accent\">Upload</label></div></div><div><div ng-repeat=\"file in files.slice(0)\" \nlayout=\"row\" layout-align=\"center center\"><span class=\"md-warn\">{{file.webkitRelativePath || file.name}}</span> (<span \nng-switch=\"file.size > 1024*1024\"> <span ng-switch-when=\"true\">{{file.size / 1024 / 1024 | number:2}} MB</span> <span \nng-switch-default>{{file.size / 1024 | number:2}} kB</span> </span>)</div></div><div layout=\"row\"><div flex=\"35\" \nlayout=\"column\" layout-align=\"start center\"><span class=\"h3\"><b>Description </b></span></div><span flex=\"5\"></span>\n<md-input-container flex=\"45\" class=\"md-block\" style=\"margin: 0px\"><input type=\"text\" name=\"description\" \nng-model=\"description\"></md-input-container></div><div layout=\"row\" ng-if=\"files.length\"><div flex=\"35\" \nlayout=\"column\" layout-align=\"start center\"><span class=\"h3\"><b>Document Typess </b></span></div><span flex=\"5\"></span>\n<md-input-container class=\"md-block\" flex=\"45\" style=\"margin: 0px\"><md-select name=\"documentTypeName\" \nng-model=\"documentTypeName\" ng-required=\"true\"><md-option ng-repeat=\"documentType in newDocumentType | orderBy:\'name\'\" \nng-value=\"documentType.name\" ng-click=\"selectDocumentType(documentType)\">{{documentType.name}}</md-option></md-select>\n<div ng-messages=\"uploadfile.documentTypeName.$error\" \nng-show=\"uploadfile.$submitted || uploadfile.documentTypeName.$touched ||  uploadfile.documentTypeName.$dirty \"><div \nng-message-exp=\"[\'required\']\" ng-hide=\"uploadfile.documentType.$valid\"><span translate>Please select DocumentType\n</span></div></div></md-input-container></div><span flex=\"5\"></span><md-divider></md-divider><div \nng-show=\"attributeObjects\"><div ng-repeat=\"attributeObject in attributeObjects\"><div layout=\"row\"><p flex=\"50\">\n{{attributeObject.name}}</p><div ng-if=\" attributeObject.required == true \">*</div><p></p><div \nng-if=\" attributeObject.required == true \" layout=\"row\" flex=\"100\"><div ng-if=\"attributeObject.type == \'String\' \" \nlayout=\"row\" flex=\"100\"><md-input-container class=\"md-block\" flex=\"40\" style=\"margin: 0px\"><input type=\"text\" \nname=\"string\" ng-model=\"attributeObject.Value\" required><div ng-messages=\"uploadfile.string.$error\" role=\"alert\"><div \nng-message=\"required\">This field is required</div></div></md-input-container></div><div \nng-if=\" attributeObject.type == \'Number\' \" layout=\"row\" flex=\"100\"><md-input-container class=\"md-block\" flex=\"40\" \nstyle=\"margin: 0px\"><input type=\"number\" name=\"number\" ng-model=\"attributeObject.Value\" required><div \nng-messages=\"uploadfile.number.$error\" role=\"alert\"><div ng-message=\"required\">This field is required</div></div>\n</md-input-container></div><div ng-if=\"attributeObject.type == \'Date\' \" layout=\"row\" flex=\"100\"><md-datepicker \nng-model=\"attributeObject.Value\" required style=\"margin: 0px\"></md-datepicker><div \nng-messages=\"uploadfile.attributeObject.Value.$error\"><div ng-message=\"required\">required</div></div></div></div><div \nng-if=\" attributeObject.required == false \" layout=\"row\" flex=\"100\"><div ng-if=\"attributeObject.type == \'String\' \" \nlayout=\"row\" flex=\"100\"><md-input-container class=\"md-block\" flex=\"40\" style=\"margin: 0px\"><input type=\"text\" \nng-model=\"attributeObject.Value\"></md-input-container></div><div ng-if=\" attributeObject.type == \'Number\' \" \nlayout=\"row\" flex=\"100\"><md-input-container class=\"md-block\" flex=\"40\" style=\"margin: 0px\"><input type=\"number\" \nng-model=\"attributeObject.Value\"></md-input-container></div><div ng-if=\"attributeObject.type == \'Date\' \" layout=\"row\" \nflex=\"100\"><md-datepicker ng-model=\"attributeObject.Value\" style=\"margin: 0px\"></md-datepicker></div></div></div></div>\n</div></md-content><div layout=\"row\"><span flex></span><md-button ng-click=\"cancel()\">Cancel</md-button><md-button \ntype=\"submit\">Save</md-button></div></form></md-tab><form name=\"create\" \nng-submit=\"create.$valid && createTemplateFile($event,create.name,create.description,create.documentType,create.template,createFiledocTypeJson)\">\n<md-content class=\"md-padding scrollable\" ms-scroll><div layout=\"row\"><div flex=\"35\" layout=\"column\" \nlayout-align=\"center center\"><span class=\"h3\"><b>Name </b></span></div><span flex=\"5\"></span><md-input-container \nflex=\"45\" class=\"md-block\" style=\"margin:0px\"><input type=\"text\" name=\"createname\" ng-model=\"create.name\" required>\n</md-input-container></div><div layout=\"row\"><div flex=\"35\" layout=\"column\" layout-align=\"center center\"><span \nclass=\"h3\"><b>Description </b></span></div><span flex=\"5\"></span><md-input-container flex=\"45\" class=\"md-block\" \nstyle=\"margin:0px\"><input type=\"text\" name=\"des\" ng-model=\"create.description\" required></md-input-container></div><div\n layout=\"row\"><div flex=\"35\" layout=\"column\" layout-align=\"center center\"><span class=\"h3\"><b>Template Name</b></span>\n</div><span flex=\"5\"></span><md-input-container class=\"md-block\" flex=\"45\" style=\"margin:0px\"><md-select \nname=\"template\" ng-model=\"create.template\" ng-required=\"true\"><md-option ng-repeat=\"template in templateList\" \nng-value=\"template.name\" ng-click=\"selectDocumentTemplate(template.name)\">{{template.name}}</md-option></md-select><div\n ng-messages=\"create.template.$error\" \nng-show=\"create.$submitted || create.template.$touched ||  create.template.$dirty \"><div ng-message-exp=\"[\'required\']\" \nng-hide=\"create.template.$valid\"><span translate>Please select Template</span></div></div></md-input-container></div>\n<div layout=\"row\"><div flex=\"35\" layout=\"column\" layout-align=\"center center\"><span class=\"h3\"><b>Document Type </b>\n</span></div><span flex=\"5\"></span><md-input-container class=\"md-block\" flex=\"45\" style=\"margin:0px\"><input \ntype=\"text\" disabled=\"true\" ng-model=\"create.documentType \" placeholder=\"{{create.documentType }}\">\n</md-input-container></div><md-divider></md-divider><div ng-show=\"DocTypeattributeObjects\"><div \nng-repeat=\"attributeObject in DocTypeattributeObjects\"><div layout=\"row\"><p flex=\"40\">{{attributeObject.name}}</p><div \nng-if=\" attributeObject.required == true \">*</div><p></p><div ng-if=\" attributeObject.required == true \" layout=\"row\" \nflex=\"100\"><div ng-if=\"attributeObject.type == \'String\' \" layout=\"row\" flex=\"100\"><md-input-container class=\"md-block\" \nflex=\"40\" style=\"margin: 0px\"><input type=\"text\" name=\"string\" ng-model=\"attributeObject.Value\" required><div \nng-messages=\"create.string.$error\" role=\"alert\"><div ng-message=\"required\">This field is required</div></div>\n</md-input-container></div><div ng-if=\" attributeObject.type == \'Number\' \" layout=\"row\" flex=\"100\"><md-input-container \nclass=\"md-block\" flex=\"40\" style=\"margin: 0px\"><input type=\"number\" name=\"number\" ng-model=\"attributeObject.Value\" \nrequired><div ng-messages=\"create.number.$error\" role=\"alert\"><div ng-message=\"required\">This field is required</div>\n</div></md-input-container></div><div ng-if=\"attributeObject.type == \'Date\' \" layout=\"row\" flex=\"100\"><md-datepicker \nng-model=\"attributeObject.Value\" required></md-datepicker><div ng-messages=\"create.attributeObject.Value.$error\" \nrole=\"alert\"><div ng-message=\"required\">required</div></div></div></div><div \nng-if=\" attributeObject.required == false \" layout=\"row\" flex=\"100\"><div ng-if=\"attributeObject.type == \'String\' \" \nlayout=\"row\" flex=\"100\"><md-input-container class=\"md-block\" flex=\"40\" style=\"margin: 0px\"><input type=\"text\" \nng-model=\"attributeObject.Value\"></md-input-container></div><div ng-if=\" attributeObject.type == \'Number\' \" \nlayout=\"row\" flex=\"100\"><md-input-container class=\"md-block\" flex=\"40\" style=\"margin: 0px\"><input type=\"number\" \nng-model=\"attributeObject.Value\"></md-input-container></div><div ng-if=\"attributeObject.type == \'Date\' \" layout=\"row\" \nflex=\"100\"><md-datepicker ng-model=\"attributeObject.Value\"></md-datepicker></div></div></div></div></div></md-content>\n<div layout=\"row\"><span flex></span><md-button ng-click=\"cancel()\">Cancel</md-button><md-button type=\"submit\">Save\n</md-button></div></form></md-tabs></md-dialog-content></md-dialog>");
$templateCache.put("app/main/profile/documents/documents.html","<style type=\"text/css\">\n.selected {\n    background-color: rgb(232, 233, 237) !important;\n    color: #0a9af0;\n    cursor:pointer;\n   }\n   md-input-container{\n      margin: 5px !important;\n   }\n</style><div class=\"page-layout simple right-sidenav\" layout=\"row\" ng-init=\"substitutionCtrl.getAllSubstitutes()\"><div \nflex class=\"scrollable\" ms-scroll><div layout=\"row\" flex=\"100\" layout-wrap><div flex=\"20\"><ms-widget flippable=\"true\" \nmd-dynamic-height><ms-widget-front class=\"white-bg\"><div><div layout=\"row\" layout-align=\"center center\" \nclass=\"border-bottom\"><h3>DOCUMENT FOLDERS</h3></div><div layout=\"row\" layout-align=\"start center\" \nng-repeat=\"folder in binderData.folders\" data-ng-init=\"$first && selectFolder(folder);\" class=\"md-padding\" \ndata-ng-class=\"{\'selected\': selectedFolder.folderName == folder.folderName}\" ng-click=\"selectFolder(folder)\"><md-icon \nmd-font-icon=\"icon-folder\" style=\"margin: 0px;color: #f4840fc2\"></md-icon><span class=\"h4\" style=\"padding-left: 10px\">\n{{folder.folderName}}</span></div></div></ms-widget-front></ms-widget></div><div flex=\"80\" layout=\"column\"><ms-widget \nflippable=\"true\" md-dynamic-height><ms-widget-front class=\"white-bg\" layout=\"column\"><div flex=\"100\" layout=\"row\" \nstyle=\"background-color: #eceeed\"><div flex=\"70\" class=\"md-padding\"><h2>{{selectedFolder.folderName}}</h2><p>\n{{selectedFolder.folderName}} &nbsp is a folder which may be used to verify aspects of a person\'s identity</p></div>\n<div flex=\"30\"><div class=\"md-padding\" layout=\"column\" layout-align=\"center start\" style=\"color:#aaa2a2eb\"><b \nclass=\"h3\"><md-icon md-font-icon=\"icon-lock\"></md-icon>Secured</b> <span class=\"h5 pt-10\">\nInformation submitted here is secure and encrypted. Information here is only viewable to employee and HR Management.\n<br><br>You can\'t edit document details once the document is approved.</span></div></div></div></ms-widget-front>\n</ms-widget><ms-widget flippable=\"true\" md-dynamic-height ng-repeat=\"obj in docTypeAndFormDetailsFinalArray\">\n<ms-widget-front class=\"white-bg\" layout=\"column\"><div flex=\"100\" layout=\"row\"><div flex=\"70\" class=\"md-padding\"><h2>\n{{obj.docTypeDetails.name}}</h2><div ng-bind-html=\"obj.formContent\" compile-template class=\"scrollable\" ms-scroll>\n</div></div><md-divider></md-divider><div flex=\"30\" layout=\"column\" layout-align=\"center center\"><div><md-button \nclass=\"\" ng-click=\"createFile($event)\"><md-icon md-font-icon=\"icon-attachment\"></md-icon>Upload Proof</md-button></div>\n</div></div></ms-widget-front></ms-widget></div></div></div></div>");
$templateCache.put("app/main/profile/substitution/substitution.create.html","<md-dialog flex=\"40\" ng-init=\"getAllUsers();\"><form name=\"userForm\" novalidate \nng-submit=\"userForm.$valid && userCtrl.createUser(user)\" layout=\"column\"><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools\"><h2>Create Substitutor</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"cancel()\"><md-icon md-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"row\" flex=\"100\">\n<md-input-container class=\"md-block\" flex=\"40\"><label>Select Substitutor</label><md-select \nng-model=\"substitute.substitution_user\" placeholder=\"Select Substitutor\" ng-required=\"required\"><md-option \nng-value=\"user.login\" ng-repeat=\" user in usersList \">{{user.login}}</md-option></md-select></md-input-container><span \nflex=\"20\"></span><md-switch ng-model=\"substitute.status\" aria-label=\" Activate User\">Status</md-switch></div><div \nlayout=\"row\" flex=\"100\"><md-datepicker ng-model=\"substitute.from_date\" md-placeholder=\"From Date\"></md-datepicker><span\n flex=\"25\"></span><md-datepicker ng-model=\"substitute.to_date\" md-placeholder=\"To Date\"></md-datepicker></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"center center\"><md-button type=\"button\" \nng-click=\"cancel()\">Cancel</md-button><md-button type=\"submit\" ng-click=\"userForm.$valid && save(substitute)\">Save\n</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/profile/substitution/substitution.html","<div class=\"page-layout simple right-sidenav\" layout=\"row\" ng-init=\"substitutionCtrl.getAllSubstitutes()\"><div flex \nclass=\"scrollable\" ms-scroll><div layout=\"column\"><md-button flow-btn \nclass=\"md-fab grey-700-bg md-mini md-fab-bottom-right add_btn\" ng-click=\"createSubstitutor($event)\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon><md-tooltip md-direction=\"top\">Create substitutor</md-tooltip></md-button><div \nclass=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" \nmd-dynamic-height><ms-widget-front class=\"white-bg\"><div class=\"h3 md-padding\">Manage Substitute Users</div><div \nlayout=\"row\" layout-align=\"center center\"><ms-widget flippable=\"true\" layout=\"column\" flex=\"95\" md-dynamic-height>\n<ms-widget-front class=\"white-bg\"><div flex=\"100\" class=\"md-padding scrollable\" ms-scroll><table \nclass=\"dataTable row-border hover table-border\" datatable=\"ng\" dt-options=\"userCtrl.dtOptions\"><thead><tr \nclass=\"table-header\"><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Substituted-By\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Substituted-To</span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">From Date</span></div></th>\n<th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">To Date</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Status</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\" layout=\"row\" layout-align=\"center center\"><span class=\"column-title\">\nActions</span></div></th></tr></thead><tbody><tr ng-repeat=\"substitute in allSubstitutes\"><td>{{substitute.user_id}}\n</td><td>{{substitute.substitution_user}}</td><td>{{substitute.from_date.substr(0,10)}}</td><td>\n{{substitute.to_date.substr(0,10)}}</td><td><i class=\"icon-checkbox-marked-circle green-500-fg\" \nng-show=\"{{substitute.status}}\"></i> <i class=\"icon-cancel red-500-fg\" ng-show=\"{{! substitute.status}}\"></i></td><td \nlayout=\"row\" layout-align=\"center center\" style=\"padding-top:0px !important;padding-bottom:0px !important\"><md-button \nclass=\"md-icon-button test-tooltip\" aria-label=\"Update\" ng-click=\"update($event,substitute)\"><md-tooltip \nmd-direction=\"top\">Update</md-tooltip><md-icon><i layout=\"row\" layout-align=\"center center\" \nclass=\"icon icon-pencil s18\"></i></md-icon></md-button><md-button class=\"md-icon-button test-tooltip\" \naria-label=\"Delete\" ng-click=\"delete($event, substitute) \"><md-tooltip md-direction=\"top\">Delete</md-tooltip><md-icon>\n<i layout=\"row\" layout-align=\"center center\" class=\"icon icon-delete s18\"></i></md-icon></md-button></td></tr></tbody>\n</table></div></ms-widget-front></ms-widget></div></ms-widget-front></ms-widget></div></div></div></div>");
$templateCache.put("app/main/profile/substitution/substitution.update.html","<md-dialog aria-label=\"update\" flex=\"40\" ng-init=\"getAllUsers();\"><form name=\"userForm\" novalidate \nng-submit=\"userForm.$valid && userCtrl.createUser(user)\" layout=\"column\"><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools\"><h2>Update Substitutor</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"cancel()\"><md-icon md-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"row\" flex=\"100\">\n<md-input-container class=\"md-block\" flex=\"40\"><label>Select Substitutor</label><md-select \nng-model=\"substitutionItem.substitution_user\" placeholder=\"Select Substitutor\" ng-required=\"required\"><md-option \nng-value=\"user.login\" ng-repeat=\" user in usersList \">{{user.login}}</md-option></md-select></md-input-container><span \nflex=\"20\"></span><md-switch ng-model=\"substitutionItem.status\" aria-label=\" Activate User\">Status</md-switch></div><div\n layout=\"row\" flex=\"100\"><md-datepicker ng-model=\"substitutionItem.from_date\" md-placeholder=\"From Date\">\n</md-datepicker><span flex=\"25\"></span><md-datepicker ng-model=\"substitutionItem.to_date\" md-placeholder=\"To Date\">\n</md-datepicker></div></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"center center\"><md-button \ntype=\"button\" ng-click=\"cancel()\">Cancel</md-button><md-button type=\"submit\" \nng-click=\"userForm.$valid && update($event, substitutionItem)\">Save</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/administration/settings/accountSettings.html","<style>\n.mh-0 {\n    min-height: 0px !important;\n}\n.parent-tabs > md-tabs .md-tab.md-active:after{\n    content: \" \";\n    border-left: 7px solid transparent;\n    border-right: 7px solid transparent;\n    border-bottom: 7px solid #efefef;\n    position: absolute;\n    display: block;\n    top: 87%;\n    left: 50%;\n   \n}\n.parent-tabs > md-tabs md-ink-bar {\n    background: none; \n}\n.parent-tabs > md-tabs .md-tab:hover {\n    color: #389cec !important;\n}\n.md-tab {\n  \n  text-transform: none;\n  }\n</style><div class=\"page-layout simple right-sidenav\" layout-gt-xs=\"row\"><div \nng-include=\"\'app/main/administration/common/admin.html\'\"></div><div \nclass=\"page-layout carded fullwidth md-padding scrollable\" layout=\"column\" flex ms-scroll><div class=\"widget-group\" \nflex=\"100\" layout=\"column\" layout-wrap><ms-widget flippable=\"true\" class=\"no-padding\"><div \nclass=\"parent-tabs white-bg mb-15\"><md-tabs class=\"mh-0\"><md-tab label=\"Brand\" \nui-sref=\"app.administration.settings.brand\"></md-tab><md-tab label=\"MenuBar\" \nui-sref=\"app.administration.settings.menubar\"></md-tab><md-tab label=\"Email Configuration\" \nui-sref=\"app.administration.settings.emailConfig\"></md-tab></md-tabs></div><div layout=\"row\" \nclass=\"md-padding white-bg\"><div class=\"md-padding\" layout=\"column\" layout-align=\"center end\"><span class=\"h3\"><b>\nPassword Policy</b></span></div><span flex=\"5\"></span><md-input-container flex class=\"md-block\" layout=\"column\" \nlayout-align=\"space-around start\"><md-select ng-model=\"Policy\"><md-option ng-repeat=\"Policy in policys\">{{Policy}}\n</md-option></md-select></md-input-container></div></ms-widget></div></div></div>");
$templateCache.put("app/main/administration/settings/brandsettings.html","<style>\n.mh-0 {\n    min-height: 0px !important;\n}\n.parent-tabs > md-tabs .md-tab.md-active:after{\n    content: \" \";\n    border-left: 7px solid transparent;\n    border-right: 7px solid transparent;\n    border-bottom: 7px solid #efefef;\n    position: absolute;\n    display: block;\n    top: 87%;\n    left: 50%;\n\n}\n.parent-tabs > md-tabs md-ink-bar {\n    background: none;\n}\n.parent-tabs > md-tabs .md-tab:hover {\n    color: #389cec !important;\n}\n.md-tab {\n\n  text-transform: none;\n  }\n</style><div class=\"page-layout simple right-sidenav\" layout-gt-xs=\"row\"><div \nng-include=\"\'app/main/administration/common/admin.html\'\"></div><div \nclass=\"page-layout carded fullwidth md-padding scrollable\" layout=\"column\" flex ms-scroll><div class=\"widget-group\" \nflex=\"100\" layout=\"column\" layout-wrap ng-init=\"settingCtrl.brandsettingdata()\"><ms-widget flippable=\"true\" \nclass=\"no-padding\"><div class=\"parent-tabs white-bg mb-15\"><md-tabs class=\"mh-0\"><md-tab label=\"Brand\" \nui-sref=\"app.administration.settings.brand\" md-active=\"true\"></md-tab><md-tab label=\"MenuBar\" \nui-sref=\"app.administration.settings.menubar\"></md-tab><md-tab label=\"Email Configuration\" \nui-sref=\"app.administration.settings.emailConfig\"></md-tab></md-tabs></div><md-content class=\"md-padding\"><div \nclass=\"content\" flex><md-tabs md-dynamic-height><md-tab label=\"Login Settings\"><div layout=\"column\" layout-wrap><div \nlayout=\"row\" layout-align=\"start start\" layout-wrap><div flex=\"100\" flex-gt-xs=\"33\"><div \nclass=\"h4 m-16 pb-16 border-bottom\">Login Logo Image</div><div class=\"p-16 pb-32\"><div class=\"pb-8\" id=\"imgid\" \nlayout=\"column\" layout-align=\"space-between start\"><img id=\"logo\"></div><input id=\"logoUpload\" name=\"logoUpload\" \ntype=\"file\" maxsize=\"500\" onchange=\"angular.element(this).scope().setLogoFile(this)\" accept=\"image/*\"></div></div><div \nflex=\"100\" flex-gt-xs=\"33\"><div class=\"h4 m-16 pb-16 border-bottom\">Login Background Image</div><div \nclass=\"p-16 pb-32\"><div class=\"pb-8\" layout=\"column\" layout-align=\"space-between start\"><div class=\"pb-8\" \nlayout=\"column\" layout-align=\"space-between start\"><img class=\"w-150 h-150\" id=\"backimage\" \nng-src=\"{{addOperator.imageUrl}}\"> <input id=\"backroundimageUpload\" name=\"backroundimageUpload\" type=\"file\" \nmaxsize=\"500\" onchange=\"angular.element(this).scope().setbackgroundfile(this)\" accept=\"image/*\"> <button \nng-click=\"clear()\">clear</button></div></div></div></div><div flex=\"100\" flex-gt-xs=\"33\"><div \nclass=\"h4 m-16 pb-16 border-bottom\">Login Background Color</div><div class=\"p-16 pb-32\"><div class=\"pb-8\" \nlayout=\"column\" layout-align=\"space-between center\"><div class=\"w-150 h-180\"><input type=\"color\" id=\"mycolor\" \nng-init=\"color = \'#f05a28\'\"></div></div></div></div></div><div layout=\"row\" class=\"margin-bottom-10\" \nlayout-align=\"center center\"><md-button ng-show=\"showbutton\" class=\"md-accent md-raised\" aria-label=\"compose\" \nng-click=\"saveData($event)\" translate=\"save\">Save</md-button><md-button ng-hide=\"showbutton\" \nclass=\"md-accent md-raised\" aria-label=\"compose\" ng-click=\"updateData($event)\" translate=\"update\">Update</md-button>\n</div></div></md-tab><md-tab label=\"Application Settings\"><div layout=\"column\" layout-wrap><div layout=\"row\" \nlayout-align=\"start center\" layout-wrap><div flex=\"100\" flex-gt-xs=\"33\"><div class=\"h4 m-16 pb-16 border-bottom\">\nLogo Image</div><div class=\"p-16 pb-32\"><div class=\"pb-8\" id=\"imgid\" layout=\"column\" \nlayout-align=\"space-between start\"><img class=\"w-150 h-160\" id=\"applogo\"> <input id=\"logoUpload\" name=\"logoUpload\" \ntype=\"file\" maxsize=\"500\" onchange=\"angular.element(this).scope().setapplogo(this)\" accept=\"image/*\"></div></div></div>\n<div flex=\"100\" flex-gt-xs=\"33\"><div class=\"h4 m-16 pb-16 border-bottom\">Background Image</div><div class=\"p-16 pb-32\">\n<div class=\"pb-8\" layout=\"column\" layout-align=\"space-between start\"><div class=\"pb-8\" layout=\"column\" \nlayout-align=\"space-between start\"><img class=\"w-150 h-150\" id=\"appbackimage\" ng-src=\"{{addOperator.imageUrl}}\"> <input\n id=\"appbackroundimageUpload\" name=\"backroundimageUpload\" type=\"file\" maxsize=\"500\" \nonchange=\"angular.element(this).scope().setappbackgroundimage(this)\" accept=\"image/*\"></div></div></div></div><div \nflex=\"100\" flex-gt-xs=\"33\"><div class=\"h4 m-16 pb-16 border-bottom\">Label</div><div class=\"p-16 pb-32\"><div \nclass=\"pb-8\" layout=\"column\" layout-align=\"space-between center\"><div class=\"w-150 h-180\"><md-input-container><label>\nTitle</label><input ng-model=\"selectedModel.title\"></md-input-container></div></div></div></div></div><div \nlayout=\"row\" class=\"margin-bottom-10\" layout-align=\"center center\"><md-button ng-show=\"showbutton\" \nclass=\"md-accent md-raised\" aria-label=\"compose\" ng-click=\"saveData($event)\" translate=\"save\">Save</md-button>\n<md-button ng-hide=\"showbutton\" class=\"md-accent md-raised\" aria-label=\"compose\" ng-click=\"updateData($event)\" \ntranslate=\"update\">Update</md-button></div></div></md-tab></md-tabs></div></md-content></ms-widget></div></div></div>");
$templateCache.put("app/main/administration/settings/emailConfig.dialog.html","<md-dialog aria-label=\"Add a new user\" flex=\"40\"><form name=\"emailConfiguration\"><div><md-toolbar class=\"md-accent\">\n<div class=\"md-toolbar-tools\"><h2>Create Reports Config</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"cancel()\"><md-icon md-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"column\" \nflex-gt-sm=\"100\"><div layout=\"row\" layout-align=\"center center\"><div flex-gt-sm=\"35\" layout=\"row\">User Id</div><div \nflex-gt-sm=\"35\"><md-input-container class=\"md-block margin\"><input type=\"text\" ng-model=\"email.userId\" \nclass=\"md-no-underline\" ng-required=\"true\" \nstyle=\"border: 1px solid rgb(169, 161, 161);border-radius: 3px;margin-bottom: -10%;height: 30px; margin-top: -3%\">\n</md-input-container></div></div><div layout=\"row\" layout-align=\"center center\" style=\"margin-top: -3%\"><div \nflex-gt-sm=\"35\">Port</div><div flex-gt-sm=\"35\"><md-input-container class=\"md-block margin\"><input type=\"text\" \nng-model=\"email.port\" class=\"md-no-underline\" ng-required=\"true\" \nstyle=\"border: 1px solid rgb(169, 161, 161);border-radius: 3px;margin-bottom: -10%;height: 30px; margin-top: -3%\">\n</md-input-container></div></div><div layout=\"row\" layout-align=\"center center\" style=\"margin-top: -3%\"><div \nflex-gt-sm=\"35\">Host</div><div flex-gt-sm=\"35\"><md-input-container class=\"md-block margin\"><input type=\"text\" \nng-model=\"email.host\" class=\"md-no-underline\" ng-required=\"true\" \nstyle=\"border: 1px solid rgb(169, 161, 161);border-radius: 3px;margin-bottom: -10%;height: 30px; margin-top: -3%\">\n</md-input-container></div></div><div layout=\"row\" layout-align=\"center center\" style=\"margin-top: -3%\"><div \nflex-gt-sm=\"35\">Password</div><div flex-gt-sm=\"35\"><md-input-container class=\"md-block margin\"><input type=\"text\" \nng-model=\"email.password\" class=\"md-no-underline\" ng-required=\"true\" \nstyle=\"border: 1px solid rgb(169, 161, 161);border-radius: 3px;margin-bottom: -10%;height: 30px; margin-top: -3%\">\n</md-input-container></div></div><div layout=\"row\" layout-align=\"center center\" style=\"margin-top: -3%\"><div \nflex-gt-sm=\"35\">SSH</div><div flex-gt-sm=\"35\"><md-switch ng-model=\"email.ssh\" aria-label=\" SSH\"></md-switch></div>\n</div></div></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"center center\"><md-button type=\"button\" \nng-click=\"cancel()\">Cancel</md-button><md-button type=\"submit\" ng-click=\"emailConfiguration.$valid && save(email)\">Save\n</md-button></md-dialog-actions></div></form></md-dialog>");
$templateCache.put("app/main/administration/settings/emailConfiguration.html","<div class=\"page-layout simple right-sidenav\" layout-gt-xs=\"row\"><div \nng-include=\"\'app/main/administration/common/admin.html\'\"></div><div \nclass=\"page-layout carded fullwidth md-padding scrollable\" layout=\"column\" flex ms-scroll><div class=\"widget-group\" \nflex=\"100\" layout=\"column\" layout-wrap><ms-widget flippable=\"true\" class=\"no-padding\"><div \nclass=\"parent-tabs white-bg mb-15\"><md-tabs class=\"mh-0\"><md-tab label=\"Brand\" \nui-sref=\"app.administration.settings.brand\"></md-tab><md-tab label=\"MenuBar\" \nui-sref=\"app.administration.settings.menubar\"></md-tab><md-tab label=\"Email Configuration\" \nui-sref=\"app.administration.settings.emailConfig\" md-active=\"true\"></md-tab></md-tabs></div><md-content \nclass=\"md-padding\"><table class=\"dataTable row-border hover\"><thead><tr style=\"background-color: #dee7f4 !important\">\n<th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">userId</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">port</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">host</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Ssh</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\" layout=\"row\" layout-align=\"center center\"><span class=\"column-title\">\nActions</span></div></th></tr></thead><tbody><tr ng-repeat=\"email in emailconfig\"><td>{{email .userId}}</td><td>\n{{email .port}}</td><td>{{email .host}}</td><td style=\"padding-top:0px !important;padding-bottom:0px !important\"><i \nclass=\"icon-checkbox-marked-circle green-500-fg\" ng-show=\"{{email.ssh}}\"></i> <i class=\"icon-cancel red-500-fg\" \nng-show=\"{{! email.ssh}}\"></i></td><td layout=\"row\" layout-align=\"center center\" \nstyle=\"padding-top:0px !important;padding-bottom:0px !important\"><md-button class=\"md-icon-button test-tooltip\" \naria-label=\"Update\" ng-click=\"settingCtrl.updateemailDialog($event,email)\"><md-tooltip md-direction=\"top\">Update\n</md-tooltip><md-icon><i layout=\"row\" layout-align=\"center center\" class=\"icon icon-pencil s20\"></i></md-icon>\n</md-button><md-button class=\"md-icon-button test-tooltip\" aria-label=\"Delete\" \nng-click=\"deleteemailConfig ($event, email) \"><md-tooltip md-direction=\"top\">Delete</md-tooltip><md-icon><i \nlayout=\"row\" layout-align=\"center center\" class=\"icon icon-delete s20\"></i></md-icon></md-button></td></tr></tbody>\n</table></md-content></ms-widget></div><md-button flow-btn class=\"md-fab grey-700-bg md-mini md-fab-bottom-right\" \naria-label=\"Create Email\" ng-click=\"createEmailConfig($event)\"><md-icon md-font-icon=\"icon-plus\"></md-icon><md-tooltip \nmd-direction=\"top\">Create EmailConfig</md-tooltip></md-button></div></div>");
$templateCache.put("app/main/administration/settings/emailUpdateConfig.dialog.html","<md-dialog aria-label=\"Add a new user\" flex=\"40\"><form name=\"emailConfiguration\"><div><md-toolbar class=\"md-accent\">\n<div class=\"md-toolbar-tools\"><h2>Update Reports Config</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"cancel()\"><md-icon md-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"column\" \nflex-gt-sm=\"100\"><div layout=\"row\" layout-align=\"center center\"><div flex-gt-sm=\"35\" layout=\"row\">User Id</div><div \nflex-gt-sm=\"35\"><md-input-container class=\"md-block margin\"><input type=\"text\" ng-model=\"emailUpdate.userId\" \nclass=\"md-no-underline\" ng-required=\"true\" \nstyle=\"border: 1px solid rgb(169, 161, 161);border-radius: 3px;margin-bottom: -10%;height: 30px; margin-top: -3%\">\n</md-input-container></div></div><div layout=\"row\" layout-align=\"center center\" style=\"margin-top: -3%\"><div \nflex-gt-sm=\"35\">Port</div><div flex-gt-sm=\"35\"><md-input-container class=\"md-block margin\"><input type=\"text\" \nng-model=\"emailUpdate.port\" class=\"md-no-underline\" ng-required=\"true\" \nstyle=\"border: 1px solid rgb(169, 161, 161);border-radius: 3px;margin-bottom: -10%;height: 30px; margin-top: -3%\">\n</md-input-container></div></div><div layout=\"row\" layout-align=\"center center\" style=\"margin-top: -3%\"><div \nflex-gt-sm=\"35\">Host</div><div flex-gt-sm=\"35\"><md-input-container class=\"md-block margin\"><input type=\"text\" \nng-model=\"emailUpdate.host\" class=\"md-no-underline\" ng-required=\"true\" \nstyle=\"border: 1px solid rgb(169, 161, 161);border-radius: 3px;margin-bottom: -10%;height: 30px; margin-top: -3%\">\n</md-input-container></div></div><div layout=\"row\" layout-align=\"center center\" style=\"margin-top: -3%\"><div \nflex-gt-sm=\"35\">Password</div><div flex-gt-sm=\"35\"><md-input-container class=\"md-block margin\"><input type=\"text\" \nng-model=\"emailUpdate.password\" class=\"md-no-underline\" ng-required=\"true\" \nstyle=\"border: 1px solid rgb(169, 161, 161);border-radius: 3px;margin-bottom: -10%;height: 30px; margin-top: -3%\">\n</md-input-container></div></div><div layout=\"row\" layout-align=\"center center\" style=\"margin-top: -3%\"><div \nflex-gt-sm=\"35\">SSH</div><div flex-gt-sm=\"35\"><md-switch ng-model=\"emailUpdate.ssh\" aria-label=\" SSH\"></md-switch>\n</div></div></div></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"center center\"><md-button \ntype=\"button\" ng-click=\"cancel()\">Cancel</md-button><md-button type=\"submit\" \nng-click=\"emailConfiguration.$valid && updatesave(emailUpdate)\">Save</md-button></md-dialog-actions></div></form>\n</md-dialog>");
$templateCache.put("app/main/administration/settings/helpSettings.html","<style>\n.mh-0 {\n    min-height: 0px !important;\n}\n.parent-tabs > md-tabs .md-tab.md-active:after{\n    content: \" \";\n    border-left: 7px solid transparent;\n    border-right: 7px solid transparent;\n    border-bottom: 7px solid #efefef;\n    position: absolute;\n    display: block;\n    top: 87%;\n    left: 50%;\n   \n}\n.parent-tabs > md-tabs md-ink-bar {\n    background: none; \n}\n.parent-tabs > md-tabs .md-tab:hover {\n    color: #389cec !important;\n}\n.md-tab {\n  \n  text-transform: none;\n  }\n</style><div class=\"page-layout simple right-sidenav\" layout-gt-xs=\"row\"><div \nng-include=\"\'app/main/administration/common/admin.html\'\"></div><div \nclass=\"page-layout carded fullwidth md-padding scrollable\" layout=\"column\" flex ms-scroll><div class=\"widget-group\" \nflex=\"100\" layout=\"column\" layout-wrap><ms-widget flippable=\"true\" class=\"no-padding\"><div \nclass=\"parent-tabs white-bg mb-15\"><md-tabs class=\"mh-0\"><md-tab label=\"Brand\" \nui-sref=\"app.administration.settings.brand\"></md-tab><md-tab label=\"Site\" ui-sref=\"app.administration.settings.site\">\n</md-tab><md-tab label=\"MenuBar\" ui-sref=\"app.administration.settings.menubar\"></md-tab><md-tab \nlabel=\"Email Configuration\" ui-sref=\"app.administration.settings.emailConfig\"></md-tab></md-tabs></div><div \nlayout=\"row\" class=\"md-padding white-bg\"><div class=\"md-padding\" layout=\"column\" layout-align=\"center end\"><span \nclass=\"h3\"><b>Help </b></span></div><span flex=\"5\"></span></div></ms-widget></div></div></div>");
$templateCache.put("app/main/administration/settings/menubarSettings.html","<div class=\"page-layout simple right-sidenav\" layout-gt-xs=\"row\"><div \nng-include=\"\'app/main/administration/common/admin.html\'\"></div><div \nclass=\"page-layout carded fullwidth md-padding scrollable\" layout=\"column\" flex ms-scroll><div class=\"widget-group\" \nflex=\"100\" layout=\"column\" layout-wrap ng-init=\"settingCtrl.getSystemDetails()\"><ms-widget flippable=\"true\" \nclass=\"no-padding\"><div class=\"parent-tabs white-bg mb-15\"><md-tabs class=\"mh-0\"><md-tab label=\"Brand\" \nui-sref=\"app.administration.settings.brand\"></md-tab><md-tab label=\"MenuBar\" \nui-sref=\"app.administration.settings.menubar\" md-active=\"true\"></md-tab><md-tab label=\"Email Configuration\" \nui-sref=\"app.administration.settings.emailConfig\"></md-tab></md-tabs></div><md-content class=\"md-padding\"><div \nclass=\"content\" flex><md-tabs md-dynamic-height><md-tab label=\"Menubar Settings\"><div layout=\"row\" layout-wrap><div \nlalyout=\"row\" class=\"md-padding\" flex-gt-sm=\"30\"><div flex-gt-sm=\"50\"><md-checkbox \nng-model=\"systemDetails.activeMenu.request\" aria-label=\"Checkbox 1\">Requests</md-checkbox></div><div flex-gt-sm=\"50\">\n<md-checkbox ng-model=\"systemDetails.activeMenu.formsmanagement\" aria-label=\"Checkbox 2\">Forms Management</md-checkbox>\n</div><div flex-gt-sm=\"50\"><md-checkbox ng-model=\"systemDetails.activeMenu.requestManagement\" aria-label=\"Checkbox 2\">\nRequest Management</md-checkbox></div><div flex-gt-sm=\"50\"><md-checkbox \nng-model=\"systemDetails.activeMenu.listManagement\" aria-label=\"Checkbox 1\">List Management</md-checkbox></div><div \nflex-gt-sm=\"50\"><md-checkbox ng-model=\"systemDetails.activeMenu.substitution\" aria-label=\"Checkbox 2\">Substitution\n</md-checkbox></div><div flex-gt-sm=\"50\"><md-checkbox ng-model=\"systemDetails.activeMenu.reqTypeDetails\" \naria-label=\"Checkbox 2\">RequestType Details</md-checkbox></div><div flex-gt-sm=\"50\"><md-checkbox \nng-model=\"systemDetails.activeMenu.invoiceTypes\" aria-label=\"Checkbox 2\">Invoice types</md-checkbox></div><div \nflex-gt-sm=\"50\"><md-checkbox ng-model=\"systemDetails.activeMenu.googleLogin\" aria-label=\"Checkbox 2\">Google Login\n</md-checkbox></div></div><div lalyout=\"row\" class=\"md-padding\" flex-gt-sm=\"30\"><div flex-gt-sm=\"50\"><md-checkbox \nng-model=\"systemDetails.activeMenu.userReports\" aria-label=\"Checkbox 2\">User Reports(Initiate Reports)</md-checkbox>\n</div><div flex-gt-sm=\"50\"><md-checkbox ng-model=\"systemDetails.activeMenu.doaReports\" aria-label=\"Checkbox 2\">\nDOA Reports</md-checkbox></div><div flex-gt-sm=\"50\"><md-checkbox ng-model=\"systemDetails.activeMenu.mainInbox\" \naria-label=\"Checkbox 2\">Main Inbox</md-checkbox></div><div flex-gt-sm=\"50\"><md-checkbox \nng-model=\"systemDetails.activeMenu.reports\" aria-label=\"Checkbox 2\">Reports</md-checkbox></div><div flex-gt-sm=\"50\">\n<md-checkbox ng-model=\"systemDetails.activeMenu.Parreports\" aria-label=\"Checkbox 2\">Par Reports</md-checkbox></div><div\n flex-gt-sm=\"50\"><md-checkbox ng-model=\"systemDetails.activeMenu.social\" aria-label=\"Checkbox 2\">Social Login\n</md-checkbox></div><div flex-gt-sm=\"50\"><md-checkbox ng-model=\"systemDetails.activeMenu.addTicket\" \naria-label=\"Checkbox 2\">Ticket</md-checkbox></div><div flex-gt-sm=\"50\"><md-checkbox \nng-model=\"systemDetails.activeMenu.COutbox\" aria-label=\"Checkbox 2\">C-Outbox</md-checkbox></div></div></div><div \nlayout=\"row\" class=\"margin-bottom-10\" layout-align=\"center center\"><md-button class=\"md-accent md-raised\" \naria-label=\"compose\" ng-click=\"settingCtrl.savesitesetting()\" translate=\"Save\">save</md-button></div></md-tab>\n</md-tabs></div></md-content></ms-widget></div></div></div>");
$templateCache.put("app/main/administration/settings/siteSettings.html","<style>\n.mh-0 {\n    min-height: 0px !important;\n}\n.parent-tabs > md-tabs .md-tab.md-active:after{\n    content: \" \";\n    border-left: 7px solid transparent;\n    border-right: 7px solid transparent;\n    border-bottom: 7px solid #efefef;\n    position: absolute;\n    display: block;\n    top: 87%;\n    left: 50%;\n   \n}\n.parent-tabs > md-tabs md-ink-bar {\n    background: none; \n}\n.parent-tabs > md-tabs .md-tab:hover {\n    color: #389cec !important;\n}\n.md-tab {\n  \n  text-transform: none;\n  }\n</style><div class=\"page-layout simple right-sidenav\" layout-gt-xs=\"row\"><div \nng-include=\"\'app/main/administration/common/admin.html\'\"></div><div \nclass=\"page-layout carded fullwidth md-padding scrollable\" layout=\"column\" flex ms-scroll><div class=\"widget-group\" \nflex=\"100\" layout=\"column\" layout-wrap ng-init=\"settingCtrl.getSystemDetails()\"><ms-widget flippable=\"true\" \nclass=\"no-padding\"><div class=\"parent-tabs white-bg mb-15\"><md-tabs class=\"mh-0\"><md-tab label=\"Brand\" \nui-sref=\"app.administration.settings.brand\"></md-tab><md-tab label=\"MenuBar\" \nui-sref=\"app.administration.settings.menubar\"></md-tab><md-tab label=\"Email Configuration\" \nui-sref=\"app.administration.settings.emailConfig\"></md-tab></md-tabs></div><md-content class=\"md-padding\"><div \nclass=\"content\" flex><md-tabs md-dynamic-height><md-tab label=\"Site Settings\"><div layout=\"column\" layout-wrap><div \nlayout=\"row\" layout-align=\"start center\" layout-wrap><div flex=\"100\" flex-gt-xs=\"33\"><div \nclass=\"h2 m-16 pb-16 border-bottom\">Site Display Name</div><div class=\"p-16 pb-32\"><div class=\"pb-8\" layout=\"column\" \nlayout-align=\"space-between center\"><div class=\"w-150 h-180\"><md-input-container><label>Site Name</label><input \nng-model=\"systemDetails.site.sitedisplayname\"></md-input-container></div></div></div></div><div flex=\"100\" \nflex-gt-xs=\"33\"><div class=\"h2 m-16 pb-16 border-bottom\">Maximun NO. of Sites</div><div class=\"p-16 pb-32\"><div \nclass=\"pb-8\" layout=\"column\" layout-align=\"space-between center\"><div class=\"w-150 h-180\"><md-input-container><label>\nno. of sites</label><input type=\"number\" ng-model=\"systemDetails.site.maxnosite\"></md-input-container></div></div>\n</div></div><div flex=\"100\" flex-gt-xs=\"33\"><div class=\"h2 m-16 pb-16 border-bottom\">Allow WebDAV</div><div \nclass=\"p-16 pb-32\"><div class=\"pb-8\" layout=\"column\" layout-align=\"space-between center\"><div class=\"w-150 h-180\">\n<md-input-container><md-switch class=\"md-accent\" name=\"special\" ng-model=\"systemDetails.site.isWebDav\"></md-switch>\n</md-input-container></div></div></div></div></div><div layout=\"row\" class=\"margin-bottom-10\" \nlayout-align=\"center center\"><md-button class=\"md-accent md-raised\" aria-label=\"compose\" \nng-click=\"settingCtrl.savesitesetting()\" translate=\"Save\">save</md-button></div></div></md-tab></md-tabs></div>\n</md-content></ms-widget></div></div></div>");
$templateCache.put("app/main/administration/settings/technicalSettings.html","<style>\n.mh-0 {\n    min-height: 0px !important;\n}\n.parent-tabs > md-tabs .md-tab.md-active:after{\n    content: \" \";\n    border-left: 7px solid transparent;\n    border-right: 7px solid transparent;\n    border-bottom: 7px solid #efefef;\n    position: absolute;\n    display: block;\n    top: 87%;\n    left: 50%;\n   \n}\n.parent-tabs > md-tabs md-ink-bar {\n    background: none; \n}\n.parent-tabs > md-tabs .md-tab:hover {\n    color: #389cec !important;\n}\n.md-tab {\n  \n  text-transform: none;\n  }\n</style><div class=\"page-layout simple right-sidenav\" layout-gt-xs=\"row\"><div \nng-include=\"\'app/main/administration/common/admin.html\'\"></div><div \nclass=\"page-layout carded fullwidth md-padding scrollable\" layout=\"column\" flex ms-scroll><div class=\"widget-group\" \nflex=\"100\" layout=\"column\" layout-wrap><ms-widget flippable=\"true\" class=\"no-padding\"><div \nclass=\"parent-tabs white-bg mb-15\"><md-tabs class=\"mh-0\"><md-tab label=\"Brand\" \nui-sref=\"app.administration.settings.brand\"></md-tab><md-tab label=\"Site\" ui-sref=\"app.administration.settings.site\">\n</md-tab><md-tab label=\"MenuBar\" ui-sref=\"app.administration.settings.menubar\"></md-tab><md-tab \nlabel=\"Email Configuration\" ui-sref=\"app.administration.settings.emailConfig\"></md-tab></md-tabs></div><div \nlayout=\"row\" class=\"md-padding white-bg\"><div class=\"md-padding\" layout=\"column\" layout-align=\"center end\"><span \nclass=\"h3\"><b>Technical Settings</b></span></div><span flex=\"5\"></span></div></ms-widget></div></div></div>");
$templateCache.put("app/main/sites/site/create.site.dialog.html","<md-dialog aria-label=\"Add a new site\" flex=\"50\"><form name=\"siteForm\" novalidate \nng-submit=\"siteCtrl.createSite(site)\" layout=\"column\" flex=\"100\"><md-toolbar class=\"md-accent\" style=\"height: 50px\" \nflex=\"80\"><div class=\"md-toolbar-tools\"><h2>Create {{sitedisplayname}}</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content class=\"scrollable\" ms-scroll><div layout=\"row\"><div flex=\"45\">\n<md-input-container class=\"md-block\"><input type=\"text\" name=\"name\" ng-model=\"site.name\" placeholder=\"Site name\" \nrequired><div ng-messages=\"siteForm.name.$error\" role=\"alert\"><div ng-message=\"required\">Site name is required</div>\n</div></md-input-container></div><span flex=\"10\"></span><div flex=\"45\"><md-input-container class=\"md-block\"><input \ntype=\"text\" name=\"url\" ng-model=\"site.url\" placeholder=\"URL\" required><div ng-messages=\"siteForm.url.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Site URL is required</span></div></div></md-input-container></div></div>\n<div layout=\"row\"><div flex=\"45\"><md-input-container class=\"md-block\"><input type=\"text\" name=\"title\" \nng-model=\"site.title\" placeholder=\"SiteTitle\"></md-input-container></div><span flex=\"10\"></span><div flex=\"45\">\n<md-input-container class=\"md-block\"><input type=\"text\" name=\"description\" ng-model=\"site.description\" \nplaceholder=\"Description\"></md-input-container></div></div><div layout=\"row\"><div flex=\"45\"><md-button \nng-click=\"openIconList()\" class=\"md-accent md-raised\">select site logo</md-button></div><md-divider \ndirection=\"vertical\"></md-divider><div flex=\"45\" align=\"center\"><md-icon md-font-icon=\"icon-eye\" \nng-style=\"{color: \'black\', \'font-size\': \'36px\'}\"></md-icon><md-radio-group ng-model=\"site.visibility\" flex=\"\" \nlayout=\"row\" class=\"md-padding\"><md-radio-button value=\"Public\">Public</md-radio-button><md-radio-button \nvalue=\"Private\">Private</md-radio-button></md-radio-group><span style=\"color:red\" ng-hide=\"site.visibility\">{{Msg.msg}}\n</span></div></div></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"center center\"><md-button \nng-click=\"cancel()\">Cancel</md-button><md-button type=\"submit\" ng-click=\"siteForm.$valid && save(site)\">Save\n</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/sites/site/site.html","<style>\n.site{\n    position: absolute;\n    top: -14px;\n    left: 124px;\n    }\n    .buttons{  \n   position: absolute;\n    top: 5px;\n    right: 0px;\n }\n .hideSiteSteeingsIcon{\n display: none;\n }\n \n @media only screen and (max-width: 480px) {\n    .inmobile {\n     margin: 6px -7px;\n    }\n    \n   .page-layout.simple.tabbed > .content > md-tabs > md-tabs-wrapper md-tabs-canvas .md-tab{\n   padding: 13px 0px !important; \n   }\n   \n   ul.breadcrumb {\n    padding: 0px 5px;\n    list-style: none;\n    background-color: #eee;\n    font-size: 10px;\n}\n.site {\n    position: absolute;\n    top: 3px;\n    left: 80px;\n}\n}\n</style><div class=\"page-layout simple tabbed mh-0\" layout=\"column\"><div class=\"content parent-tabs\"><md-tabs \nclass=\"mh-0\"><md-tab class=\"onmob\" md-active=\"true\">Home</md-tab></md-tabs></div><div class=\"buttons\"><md-button \nclass=\"inmobile\" ng-click=\"loadHome()\" style=\"min-width: 20px;border-radius:55px !important\"><md-icon \nmd-font-icon=\"icon-home\" ng-style=\"{\'font-size\': \'20px\'}\" style=\"color: #4cc3d9 !important\"></md-icon></md-button>\n<md-button class=\"inmobile\" ng-click=\"loadDoclibrary()\" style=\"min-width: 20px;border-radius:55px !important\"><md-icon \nmd-font-icon=\"icon-folder\" ng-style=\"{\'font-size\': \'20px\'}\" style=\"color: #4cc3d9 !important\"></md-icon></md-button>\n</div></div><div id=\"sites\" class=\"page-layout carded fullwidth scrollable\" layout=\"column\" flex ms-scroll \nmd-dynamic-height><div class=\"widget-group\" layout=\"column\" flex=\"100\" layout-wrap><ms-widget flippable=\"true\" \nlayout=\"column\"><ms-widget-front class=\"white-bg\"><div layout=\"column\" layout-align=\"start center\" layout-wrap \nclass=\"scrollable\" ms-scroll><div class=\"p-16\" layout=\"column\" flex=\"100\"><div ui-view=\"sitehome\" \nng-show=\"loadPage==\'Home\'\"></div><div ui-view=\"dashboard\" ng-show=\"loadPage==\'home\'\"></div><div ui-view=\"doclibrary\" \nng-show=\"loadPage==\'Library\'\"></div><div ui-view=\"members\" ng-show=\"loadPage==\'members\'\"></div><div \nui-view=\"sitesettings\" ng-show=\"loadPage==\'sitesettings\'\"></div></div></div></ms-widget-front></ms-widget></div>\n<md-button flow-btn class=\"md-fab md-accent md-fab-bottom-right\" aria-label=\"Add Note\" \nng-click=\"siteCtrl.showConfirm($event)\" ng-show=\"loadPage==\'todolist\'\"><md-icon md-font-icon=\"icon-plus\"></md-icon>\n<md-tooltip md-direction=\"top\">Add Note</md-tooltip></md-button></div>");
$templateCache.put("app/main/reset/view/reset.html","<div id=\"login\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"login-form-wrapper\" layout=\"column\" \nlayout-align=\"center center\"><div id=\"login-form\" class=\"md-whiteframe-8dp\"><form name=\"passwordForm\" novalidate \nlayout=\"column\"><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2>Reset Password</h2><span flex></span>\n<md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><div layout=\"column\" layout-align=\"center center\"><md-input-container\n class=\"md-block\"><md-icon md-font-icon=\"icon-key-variant\" style=\"color: rgb(5, 167, 253) !important\"></md-icon><input \ntype=\"password\" name=\"password\" ng-model=\"password\" placeholder=\"Enter Password*\" required><div \nng-messages=\"passwordForm.password.$error\" role=\"alert\"><div ng-message=\"required\"><span>Password field is required\n</span></div></div></md-input-container><md-input-container class=\"md-block\"><md-icon md-font-icon=\"icon-key-variant\" \nstyle=\"color: rgb(5, 167, 253) !important\"></md-icon><input type=\"password\" name=\"passwordConfirm\" \nng-model=\"passwordConfirm\" placeholder=\"Re-enter Password*\" required> <span \nstyle=\"color: red;font-family: \'Roboto\';font-size: 12px\" ng-show=\"password !== passwordConfirm\">Passwords do not match\n</span><div ng-messages=\"passwordForm.passwordConfirm.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nRe-enter Password field is required</span></div></div></md-input-container></div></md-dialog-content><md-dialog-actions\n layout=\"row\" layout-align=\"center center\"><md-button type=\"button\" ng-click=\"cancel()\">Cancel</md-button><md-button \ntype=\"submit\" ng-click=\"passwordForm.$valid && resetPasswordfinish($scope.finishPassword)\">Save</md-button>\n</md-dialog-actions></form></div></div></div>");
$templateCache.put("app/main/user-management/users/create.user.dialog.html","<md-dialog aria-label=\"Add a new user\"><form name=\"userForm\" novalidate \nng-submit=\"userForm.$valid && userCtrl.createUser(user)\" layout=\"column\" flex=\"66\"><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools\"><h2>Create User</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\">\n<md-icon md-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><md-input-container class=\"md-block\"><input type=\"text\" name=\"login\" \nng-model=\"user.login\" placeholder=\"Login Id\" required><div ng-messages=\"userForm.login.$error\" role=\"alert\"><div \nng-message=\"required\">User ID is required</div></div></md-input-container><md-input-container class=\"md-block\"><input \ntype=\"email\" name=\"Email\" ng-model=\"user.email\" placeholder=\"Email\" required><div ng-messages=\"userForm.Email.$error\" \nrole=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>Email is required</span></div><div \nng-message=\"Email\"><span>Email must be a valid e-mail address</span></div></div></md-input-container><div layout=\"row\">\n<md-input-container class=\"md-block\" flex=\"45\"><input type=\"text\" name=\"firstName\" ng-pattern=\"/^[a-zA-Z ]*$/\" \nng-model=\"user.firstName\" placeholder=\"First name\" required><div ng-messages=\"userForm.firstName.$error\" role=\"alert\">\n<div ng-message=\"required\"><span>First Name is required</span></div><div ng-message=\"pattern\"><span>\nFirst Name has invalid characters</span></div></div></md-input-container><span flex=\"10\"></span><md-input-container \nclass=\"md-block\" flex=\"45\"><input type=\"text\" name=\"lastName\" ng-pattern=\"/^[a-zA-Z ]*$/\" ng-model=\"user.lastName\" \nplaceholder=\"Last name\"><div ng-messages=\"userForm.lastName.$error\" role=\"alert\"><div ng-message=\"pattern\"><span>\nLast Name has invalid characters</span></div></div></md-input-container></div><div layout=\"row\"><md-input-container \nclass=\"md-block\" flex=\"45\"><input type=\"password\" name=\"password\" ng-model=\"user.password\" placeholder=\"Password\" \nrequired><div ng-messages=\"userForm.password.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nPassword field is required</span></div></div></md-input-container><span flex=\"10\"></span><md-input-container \nclass=\"md-block\" flex=\"45\"><input type=\"password\" name=\"passwordConfirm\" ng-model=\"user.passwordConfirm\" \nplaceholder=\"Re-enter Password\"> <span style=\"color: red;font-family: \'Roboto\';font-size: 12px\" \nng-show=\"user.password !== user.passwordConfirm\">Passwords do not match</span></md-input-container></div><div \nlayout=\"row\"><md-input-container class=\"md-block\" flex=\"45\"><label>Select Authority</label><md-select \nng-model=\"user.authorities\" multiple=\"multiple\"><md-option ng-value=\"authority\" ng-repeat=\"authority in roles\">\n{{ authority.replace(\"ROLE_USER\",\"User\").replace(\"ROLE_ADMIN\",\"Admin\") }}</md-option></md-select></md-input-container>\n<span flex=\"10\"></span><md-input-container class=\"md-block\" flex=\"45\"><label>Activate User</label><md-select \nng-model=\"user.activated\"><md-option ng-value=\"activate\" ng-repeat=\"activate in status\">{{ activate }}</md-option>\n</md-select></md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"center center\"><md-button type=\"button\" ng-click=\"cancel()\">Cancel</md-button><md-button type=\"submit\" \nng-click=\"userForm.$valid && save(user)\">Save</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/user-management/users/update.user.dialog.html","<md-dialog aria-label=\"Update a user\"><form name=\"userUpdateForm\" novalidate \nng-submit=\"userUpdateForm.$valid && update(currentUser)\" layout=\"column\" flex=\"66\"><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools\"><h2>Update User</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\">\n<md-icon md-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content layout=\"column\"><md-input-container><input type=\"text\" \ndisabled=\"true\" name=\"login\" ng-model=\"currentUser.login\" placeholder=\"Login Id\" required></md-input-container>\n<md-input-container class=\"md-block\"><input type=\"email\" disabled=\"true\" name=\"email\" ng-model=\"currentUser.email\" \nplaceholder=\"Email\" required></md-input-container><div layout=\"row\"><md-input-container class=\"md-block\" flex=\"45\">\n<input type=\"text\" name=\"firstName\" ng-pattern=\"/^[a-zA-Z ]*$/\" ng-model=\"currentUser.firstName\" \nplaceholder=\"First name\" required><div ng-messages=\"userUpdateForm.firstName.$error\" role=\"alert\"><div \nng-message=\"required\"><span>First Name is required</span></div><div ng-message=\"pattern\"><span>\nFirst Name has invalid characters</span></div></div></md-input-container><span flex=\"10\"></span><md-input-container \nclass=\"md-block\" flex=\"45\"><input type=\"text\" name=\"lastName\" ng-pattern=\"/^[a-zA-Z ]*$/\" \nng-model=\"currentUser.lastName\" placeholder=\"Last name\"><div ng-messages=\"userUpdateForm.lastName.$error\" role=\"alert\">\n<div ng-message=\"pattern\"><span>Last Name has invalid characters</span></div></div></md-input-container></div><div \nlayout=\"row\"><md-input-container class=\"md-block\" flex=\"45\"><label>Select Authority</label><md-select \nng-model=\"currentUser.authorities\" multiple=\"multiple\"><md-option ng-value=\"authority\" ng-repeat=\"authority in roles\">\n{{authority.replace(\"ROLE_USER\",\"User\").replace(\"ROLE_ADMIN\",\"Admin\")}}</md-option></md-select></md-input-container>\n<span flex=\"10\"></span><md-input-container class=\"md-block\" flex=\"45\"><label>Activate User</label><md-select \nng-model=\"currentUser.activated\"><md-option ng-value=\"activated\" ng-repeat=\"activated in status\">\n{{activated.replace(\"true\",\"True\").replace(\"false\",\"False\")}}</md-option></md-select></md-input-container></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"center center\"><md-button ng-click=\"cancel()\">Cancel\n</md-button><md-button type=\"submit\" ng-click=\"userUpdateForm.$valid && update(currentUser)\">Update</md-button>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/user-management/users/users.html","<div id=\"user\" class=\"page-layout carded fullwidth md-padding scrollable\" layout=\"column\" flex ms-scroll><div \nclass=\"widget-group\" flex=\"100\" layout=\"column\" layout-wrap><ms-widget flippable=\"true\"><ms-widget-front \nclass=\"white-bg\"><div class=\"md-padding\" flex=\"35\"><ul class=\"breadcrumb\"><li ng-click=\"userCtrl.goToAdmin()\">\nAdministration</li><li ng-click=\"userCtrl.goToAdminuser()\">User Management</li><li>Users</li></ul></div><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"userCtrl.dtOptions\"><thead><tr><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Login</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">First Name</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Last Name</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Email</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Authorities</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Activated</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\" layout=\"row\" layout-align=\"center center\"><span class=\"column-title\">\nActions</span></div></th></tr></thead><tbody><tr ng-repeat=\"user in usersList | filter : searchUser\"><td>{{user.login}}\n</td><td>{{user.firstName}}</td><td>{{user.lastName}}</td><td>{{user.email}}</td><td><span \nclass=\"text-boxed green-bg white-fg\" ng-show=\"{{user.authorities.indexOf(\'ROLE_USER\') != -1}}\">User</span> <span \nclass=\"text-boxed orange-bg white-fg\" ng-show=\"{{user.authorities.indexOf(\'ROLE_ADMIN\') != -1}}\">Admin</span></td><td \nstyle=\"padding-top:0px !important;padding-bottom:0px !important\"><i class=\"icon-checkbox-marked-circle green-500-fg\" \nng-show=\"{{user.activated}}\"></i> <i class=\"icon-cancel red-500-fg\" ng-show=\"{{! user.activated}}\"></i></td><td \nlayout=\"row\" layout-align=\"center center\" style=\"padding-top:0px !important;padding-bottom:0px !important\"><md-button \nclass=\"md-icon-button test-tooltip\" aria-label=\"Update\" ng-click=\"updateUserDialog($event,user)\"><md-tooltip \nmd-direction=\"top\">Update</md-tooltip><md-icon><i layout=\"row\" layout-align=\"center center\" \nclass=\"icon icon-pencil s20\"></i></md-icon></md-button><md-button class=\"md-icon-button test-tooltip\" \naria-label=\"Delete\" ng-click=\"userCtrl.deleteUser($event, user) \"><md-tooltip md-direction=\"top\">Delete</md-tooltip>\n<md-icon><i layout=\"row\" layout-align=\"center center\" class=\"icon icon-delete s20\"></i></md-icon></md-button></td></tr>\n</tbody></table></ms-widget-front></ms-widget></div><md-button flow-btn \nclass=\"md-fab grey-700-bg md-mini md-fab-bottom-right\" aria-label=\"Create User\" ng-click=\"createUserDialog($event)\">\n<md-icon md-font-icon=\"icon-plus\"></md-icon><md-tooltip md-direction=\"top\">Create User</md-tooltip></md-button></div>");
$templateCache.put("app/main/profile/about/about.html","<div class=\"widget-group\" flex layout=\"column\" layout-wrap ng-init=\"UserDetails()\"><ms-widget flippable=\"true\">\n<ms-widget-front class=\"white-bg\"><div class=\"md-padding\" layout-align=\"start start\"><div class=\"h3\">\nPersonal Information</div><div layout=\"row\" flex><div class=\"md-padding\" flex=\"100\" style=\"margin-top: 0\"><ms-widget \nflippable=\"true\"><ms-widget-front class=\"white-bg\" flex><div class=\"md-padding\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"details\">Primary Details </span><span class=\"edit c-p\" \nng-click=\"abtCtrl.editprofile($event,currentLogedInUser)\">EDIT</span></div><md-divider></md-divider><div layout=\"row\" \nlayout-align=\"start start\"><div layout=\"column\" class=\"md-padding\" flex=\"40\"><span class=\"subtext\">First Name</span> \n<span>{{currentLogedInUser.firstName}}</span></div><span flex=\"20\"></span><div layout=\"column\" class=\"md-padding\" \nflex=\"40\"><span class=\"subtext\">Middle Name</span> <span>{{}}</span></div></div><div layout=\"row\" \nlayout-align=\"start start\"><div layout=\"column\" class=\"md-padding\" flex=\"40\"><span class=\"subtext\">Last Name</span> \n<span>{{currentLogedInUser.lastName}}</span></div><span flex=\"20\"></span><div layout=\"column\" class=\"md-padding\" \nflex=\"40\"><span class=\"subtext\">Display Name</span> <span>\n{{currentLogedInUser.firstName}} {{currentLogedInUser.lastName}}</span></div></div><div layout=\"row\" \nlayout-align=\"start start\"><div layout=\"column\" class=\"md-padding\" flex=\"40\"><span class=\"subtext\">Authority</span> \n<span ng-repeat=\"authority in currentLogedInUser.authorities \">\n{{authority.replace(\"ROLE_USER\",\"User\").replace(\"ROLE_ADMIN\",\"Admin\")}}</span></div><span flex=\"20\"></span><div \nlayout=\"column\" class=\"md-padding\" flex=\"40\"><span class=\"subtext\">Activate User</span> <span>\n{{currentLogedInUser.activated}}</span></div></div><div layout=\"row\" layout-align=\"start start\"><div layout=\"column\" \nclass=\"md-padding\" flex=\"40\"><span class=\"subtext\">Currency</span> <span>{{currentLogedInUser.currency}}</span></div>\n<span flex=\"20\"></span><div layout=\"column\" class=\"md-padding\" flex=\"40\"><span class=\"subtext\">Decimal Seperator</span>\n <span>{{currentLogedInUser.decimalSeparator}}</span></div></div><div layout=\"row\" layout-align=\"start start\"><div \nlayout=\"column\" class=\"md-padding\" flex=\"40\"><span class=\"subtext\">Language</span> <span>\n{{currentLogedInUser.language}}</span></div><span flex=\"20\"></span><div layout=\"column\" class=\"md-padding\" flex=\"40\">\n<span class=\"subtext\">Date Format</span> <span>{{currentLogedInUser.dateFormat}}</span></div></div><div layout=\"row\" \nlayout-align=\"start start\"><div layout=\"column\" class=\"md-padding\" flex=\"40\"><span class=\"subtext\">TimeZone</span> \n<span>{{currentLogedInUser.timeZone}}</span></div></div></ms-widget-front></ms-widget></div></div></div>\n</ms-widget-front></ms-widget></div>");
$templateCache.put("app/main/user-management/groups/addGroupMemberDialog.html","<md-dialog ng-cloak><form name=\"groupsCtrl.memberForm\" role=\"form\" novalidate ng-submit=\" \"><md-toolbar layout=\"row\" \nclass=\"md-accent\"><div class=\"md-toolbar-tools\"><h2>Add Member</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"ok()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nlayout=\"column\" layout-align=\"center center\"><div layout=\"row\"><md-input-container class=\"md-block\" flex=\"45\"><input \ntype=\"text\" name=\"name\" ng-model=\"member.name\" placeholder=\"Name\"></md-input-container><span flex=\"10\"></span>\n<md-input-container class=\"md-block\" flex=\"45\"><input type=\"text\" name=\"email\" ng-model=\"member.email\" \nplaceholder=\"Email\"></md-input-container></div><div layout=\"row\" \nng-style=\"{\'color\':\'red\',\'font-family\':\'Roboto\',\'font-size\':\'12px\'}\" ng-show=\"msgVisibility\">\nPlease enter either name or email</div><div><md-button type=\"button\" class=\"md-raised md-padding\" \nng-click=\"searchMember(member)\"><md-icon md-font-icon=\"icon-magnify\"></md-icon>Search user</md-button></div><div \nng-show=\"tableVisibility\" class=\"scrollable md-padding\" ms-scroll><table><thead><tr><th \nclass=\"secondary-text md-padding\"><div class=\"table-header\"><span class=\"column-title\">NAME</span></div></th><th \nclass=\"secondary-text md-padding\"><div class=\"table-header\"><span class=\"column-title\">EMAIL</span></div></th></tr>\n</thead><tbody><tr ng-repeat=\"member in searchedMembers\"><td class=\"md-padding\">\n{{member.firstName}} {{member.lastName}}</td><td class=\"md-padding\">{{member.email}}</td><td layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-accent md-raised\" ng-click=\"addGroupMember(member) \">ADD</md-button>\n</td></tr></tbody></table></div></md-dialog-content></form><md-dialog-actions layout=\"row\"><span flex></span><md-button\n ng-click=\"cancel(member)\">Cancel</md-button><md-button ng-click=\"ok()\" md-autofocus>Ok</md-button></md-dialog-actions>\n</md-dialog>");
$templateCache.put("app/main/user-management/groups/createGroupDialog.html","<md-dialog aria-label=\"Create a new Group\" flex=\"20\"><form name=\"groupForm\" novalidate ng-submit=\"\" layout=\"column\">\n<md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2>Create Group</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"close()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><md-input-container class=\"md-block\"><input type=\"text\" name=\"name\" \nng-model=\"group.name\" placeholder=\"Group name\" required><div ng-messages=\"groupForm.name.$error\" role=\"alert\"><div \nng-message=\"required\">Group name is required</div></div></md-input-container><md-input-container class=\"md-block\">\n<input type=\"text\" name=\"description\" ng-model=\"group.description\" placeholder=\"Description\"></md-input-container>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"center center\"><md-button ng-click=\"cancel()\">Cancel\n</md-button><md-button type=\"submit\" ng-click=\"groupForm.$valid && createGroup(group)\">Save</md-button>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/user-management/groups/groups.html","<div class=\"widget-group\" flex=\"100\" layout=\"column\" layout-wrap><ms-widget flippable=\"true\"><ms-widget-front \nclass=\"white-bg\"><div class=\"md-padding\" flex=\"35\"><ul class=\"breadcrumb\"><li ng-click=\"groupsCtrl.goToAdmin()\">\nAdministration</li><li ng-click=\"groupsCtrl.goToAdminuser()\">User Management</li><li>Groups</li></ul></div><div \nid=\"groups\" class=\"page-layout carded fullwidth md-padding scrollable\" layout=\"column\" flex ms-scroll \nmd-dynamic-height><md-button flow-btn class=\"md-fab grey-700-bg md-mini md-fab-bottom-right\" \nng-click=\"groupsCtrl.createGroupDialog($event)\"><md-icon md-font-icon=\"icon-plus\"></md-icon><md-tooltip \nmd-direction=\"top\">Create Group</md-tooltip></md-button><div class=\"widget-group\" layout=\"column\" flex=\"100\" \nlayout-wrap><ms-widget flippable=\"true\" layout=\"column\"><ms-widget-front class=\"white-bg\"><div \nclass=\"ph-16 pv-8 border-bottom\" layout=\"row\" layout-align=\"space-between center\" layout-wrap><div class=\"pv-8 h3\">\n{{groupsCtrl.groupStatGraphData.title}}</div><div class=\"pv-8\" layout=\"row\" layout-align=\"start center\" \nlayout-align-sm=\"end\" flex-sm=\"100\"><md-button class=\"ph-16\" \nng-repeat=\"(key, range) in groupsCtrl.groupStatGraph.ranges\" ng-click=\"groupsCtrl.groupStatGraph.changeRange(key)\" \nng-disabled=\"groupsCtrl.groupStatGraph.currentRange == key\">{{range}}</md-button></div></div><div layout=\"row\" \nlayout-align=\"start center\" layout-wrap><div class=\"p-16\" layout=\"row\" flex=\"100\"><nvd3 class=\"h-320 remove-x-lines\" \nconfig=\"groupsCtrl.groupStatGraph.mainChart.config\" options=\"groupsCtrl.groupStatGraph.mainChart.options\" \ndata=\"groupsCtrl.groupStatGraph.mainChart.data\"></nvd3></div></div></ms-widget-front></ms-widget></div><div \nclass=\"widget-group\" flex=\"100\" layout=\"column\" layout-wrap><ms-widget flippable=\"true\"><ms-widget-front \nclass=\"white-bg\"><div class=\"search\" layout=\"row\" layout-align=\"center center\"><span flex=\"33\"></span> <span flex=\"33\" \nclass=\"h3\"><md-input-container class=\"md-block\"><md-icon md-font-icon=\"icon-magnify\"></md-icon><input \nng-model=\"searchGroup\" type=\"text\" placeholder=\"Search a group here\"></md-input-container></span><span flex=\"33\">\n</span></div><div layout=\"row\" layout-wrap><div ng-repeat=\"eachGroup in groupsCtrl.allGroups | filter : searchGroup\" \nclass=\"md-padding\" flex=\"25\"><md-toolbar layout=\"row\" class=\"{{groupsCtrl.getAnotherColor($index)}}\"><div \nclass=\"md-toolbar-tools\"><span>{{eachGroup.name}}</span><md-fab-speed-dial ng-hide=\"eachGroup.hidden\" \nmd-direction=\"down\" md-open=\"eachGroup.isOpen\" class=\"md-scale md-fab-top-right\" \nng-class=\"{ \'md-hover-full\': eachGroup.hover }\" ng-mouseenter=\"eachGroup.isOpen=true\" \nng-mouseleave=\"eachGroup.isOpen=false\"><md-fab-trigger><md-button aria-label=\"menu\" class=\"md-fab md-mini grey-700-bg\">\n<md-tooltip md-direction=\"top\" md-visible=\"tooltipVisible\">Menu</md-tooltip><md-icon md-font-icon=\"icon-menu\" \naria-label=\"menu\"></md-icon></md-button></md-fab-trigger><md-fab-actions><md-button class=\"md-fab md-raised md-mini\" \nng-click=\"groupsCtrl.addMemberDialog($event, eachGroup)\"><md-tooltip md-direction=\"right\">Add Group Member</md-tooltip>\n<md-icon md-font-icon=\"icon-plus\"></md-icon></md-button><md-button class=\"md-fab md-raised md-mini\"><md-tooltip \nmd-direction=\"right\">Edit Group</md-tooltip><md-icon md-font-icon=\"icon-pencil\"></md-icon></md-button><md-button \nclass=\"md-fab md-raised md-mini\" ng-click=\"groupsCtrl.deleteGroup(eachGroup)\"><md-tooltip md-direction=\"right\">\nDelete Group</md-tooltip><md-icon md-font-icon=\"icon-delete\"></md-icon></md-button></md-fab-actions>\n</md-fab-speed-dial></div></md-toolbar><md-content flex ng-style=\"{\'border\': \'1px solid #cccccc\'}\" class=\"scrollable\" \nms-scroll layout=\"row\" layout-wrap><div ng-switch=\"(eachGroup.members).length\"><div ng-switch-when=\"0\" layout=\"row\" \nlayout-align=\"center center\"><p class=\"md-padding md-subhead md-primary-fg\">{{\'No member yet...\' | uppercase}}</p>\n</div><div ng-switch-default ng-style=\"{\'height\':\'280px\'}\"><md-list><md-list-item class=\"md-2-line\" \nng-repeat=\"member in eachGroup.members \" ng-click=\"null\"><img ng-src=\"assets\\images\\avatars/Nora.jpg\" \nclass=\"md-avatar\"><div class=\"md-list-item-text\" layout=\"column\"><h3>{{ member.firstName }} {{ member.lastName }}</h3>\n<p>{{ member.email }}</p><md-button class=\"md-secondary md-icon-button\" \nng-click=\"groupsCtrl.deleteGroupMember(eachGroup, $index)\"><md-tooltip md-direction=\"top\">Delete</md-tooltip><md-icon>\n<i class=\"icon icon-delete s30\"></i></md-icon></md-button></div><md-divider></md-divider></md-list-item></md-list>\n</div></div></md-content></div></div></ms-widget-front></ms-widget></div></div></ms-widget-front></ms-widget></div>");
$templateCache.put("app/core/directives/ms-navigation/templates/horizontal.html","<div class=\"navigation-toggle\" hide-gt-sm><md-button class=\"md-icon-button\" ng-click=\"vm.toggleHorizontalMobileMenu()\" \naria-label=\"Toggle Mobile Navigation\"><md-icon md-font-icon=\"icon-menu\"></md-icon></md-button></div><ul \nclass=\"horizontal\"><li ng-repeat=\"node in vm.navigation\" ms-navigation-horizontal-node=\"node\" \nng-class=\"{\'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-horizontal-nested.html\'\"></li></ul><script \ntype=\"text/ng-template\" id=\"navigation-horizontal-nested.html\">\n<div ms-navigation-horizontal-item layout=\"row\" ng-if=\"!vm.isHidden()\">\n\n        <div class=\"ms-navigation-horizontal-button\" ng-if=\"!node.uisref && node.title\"\n             ng-class=\"{\'active md-accent-bg md-accent-fg\': vm.isActive}\">\n            <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\"></i>\n        </div>\n\n        <a class=\"ms-navigation-horizontal-button\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"active md-accent-bg\"\n           ng-class=\"{\'active md-accent-bg md-accent-fg\': vm.isActive}\"\n           ng-if=\"node.uisref && node.title\">\n            <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\"></i>\n        </a>\n\n    </div>\n\n    <ul ng-if=\"vm.hasChildren && !vm.isHidden()\">\n        <li ng-repeat=\"node in node.children\" ms-navigation-horizontal-node=\"node\"\n            ng-class=\"{\'has-children\': vm.hasChildren}\"\n            ng-include=\"\'navigation-horizontal-nested.html\'\"></li>\n    </ul>\n</script>");
$templateCache.put("app/core/directives/ms-navigation/templates/vertical.html","<style>\n.sidebar-list-label {\n   color: #aab2bd;\n    font-size: 12px;\n    line-height: 0px;\n    font-weight: 500;\n    text-align: center;\n}\n</style><ul><li ng-repeat=\"node in vm.navigation\" ms-navigation-node=\"node\" \nng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-nested.html\'\"></li></ul>\n<script type=\"text/ng-template\" id=\"navigation-nested.html\">\n<div ms-navigation-item layout=\"row\" ng-if=\"!vm.isHidden()\">\n\n        <div class=\"ms-navigation-button\" ng-if=\"!node.uisref && node.title\">\n            <i class=\"icon s16 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i>\n        </div>\n         <div layout=\"column\" >\n <a class=\"ms-navigation-button\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"active md-black-bg\" style=\"padding: 15px 15px 10px 10px;\" ng-if=\"node.uisref && node.title\">\n          \n <i class=\"icon s16 {{node.icon}} pl-10\" ng-if=\"node.icon\" ></i> <br>\n          <span class=\"sidebar-list-label\">{{node.title}}</span>   \n</a>\n</div>\n  \n    </div>\n\n    <ul class=\"left-side-menu\" ng-if=\"vm.hasChildren && !vm.isHidden()\">\n        <li ng-repeat=\"node in node.children\" ms-navigation-node=\"node\"\n            ng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\"\n            ng-include=\"\'navigation-nested.html\'\"></li>\n    </ul>\n</script>");
$templateCache.put("app/main/mycontent/emailApprovals/workitemDetails.html","<link rel=\"stylesheet\" href=\"https://maxcdn.bootstrapcdn.com/bootstrap/3.3.7/css/bootstrap.min.css\"><script \nsrc=\"https://maxcdn.bootstrapcdn.com/bootstrap/3.3.7/js/bootstrap.min.js\"></script><style>\n.md-button.md-fab{\n   width: 40px;\n   height: 40px;\n   margin-top: -14% !important;\n   }\n   /* md-tabs-canvas{\n   background-color:rgb(232, 233, 237);\n   }  */\n   .tab{\n   background:#dcecf0;\n   }\n   .disabled {\n   pointer-events: none;\n   }\n   label{\n   font-size:15px}\n   td{\n    padding:6px !important;\n }\n.ms-responsive-table-wrapper{\n  overflow: visible;\n}\nmd-select.md-default-theme[disabled] ._md-select-value, md-select[disabled] ._md-select-value {\n    color: blue !important;\n    }\n\n.lh{\n   color: black !important;\n}\n.input{\n color: blue !important;\n }\n</style><div id=\"documnets\" class=\"page-layout simple right-sidenav\" layout=\"row\" layout-align=\"center center\" show-md \nhide-xs ng-init=\"getAllWorkitems()\" \nstyle=\"height:95% !important;overflow-y:scroll !important; min-height:95% !important\" hide-xs hide-sm hide-md \nshow-gt-md><div class=\"widget-group\" layout=\"column\" flex=\"90\" layout-wrap><ms-widget flippable=\"true\" layout=\"column\" \nflex=\"100\"><ms-widget-front class=\"white-bg\" class=\"scrollable\" ms-scroll><div flex=\"100\" style=\"color:black\" \nstyle=\"overflow-y:scroll !important\"><md-content><div style=\"background:#dcecf0\" class=\"md-padding\"><div layout=\"row\" \nlayout-align=\"center center\" class=\"h4\">{{displayName}} <span flex=\"5\"></span>DocId - {{workitemInfo.requestId}}</div>\n</div><div><md-tabs md-dynamic-height class=\"x\"><md-tab><md-tab-label><md-button class=\"md-fab md-accent\" \naria-label=\"Android\" md-tooltip=\"Main\"><md-icon md-svg-src=\"assets/icons/fonts/001-info.svg\"></md-icon><md-tooltip \nmd-direction=\"top\">Information</md-tooltip></md-button></md-tab-label><md-tab-body ng-show=\"formHeader\" flex=\"100\"><div\n class=\"md-padding scrollable\" ms-scroll><div layout=\"row\" layout-align=\"center center\"><div flex=\"100\" \nstyle=\"color:black\"><form name=\"headerForm\"><div flex class=\"scrollable\" show-gt-xs ms-scroll \nstyle=\"border:2px solid #cccccc; border-radius:0px\"><div flex=\"95\" ng-bind-html=\"currentFormHeader\" compile-template \nng-hide=\"workitemInfo.requestType == \'PR_PROCESS\'\"></div><div ng-bind-html=\"currentFormInboxHeader\" compile-template \nng-show=\"workitemInfo.requestType == \'PR_PROCESS\'\"></div></div><div>&nbsp;</div><div \nng-if=\"workitemInfo.lineItems.length > 0 \" flex><div layout=\"row\" layout-align=\"end end\" \nstyle=\"margin-top:0% !important\" ng-if=\"workitemInfo.requestType == \'PAYABLES_NPO\'\"><button type=\"button\" \nclass=\"btn btn-info\" ng-click=\"searchCodingTemplates($event,$index)\" style=\"border-radius: 6px\">Coding Template\n</button></div><div class=\"md-padding scrollable\" ms-scroll style=\"overflow-x: scroll\" \nng-hide=\"workitemInfo.requestType == \'PR_PROCESS\'\"><div ng-bind-html=\"currentFormInboxLineitem\" compile-template \nng-if=\"currentFormInboxLineitem\"></div><div ng-bind-html=\"currentFormLineitem\" compile-template \nng-if=\"!currentFormInboxLineitem\"></div></div></div></form></div></div></div></md-tab-body></md-tab><md-tab>\n<md-tab-label><md-button class=\"md-fab md-accent\" aria-label=\"Use Android\"><md-icon \nmd-svg-src=\"assets/icons/fonts/004-comment-white-oval-bubble.svg\"></md-icon><md-tooltip md-direction=\"top\">Comments\n</md-tooltip></md-button></md-tab-label><md-tab-body><div class=\"md-padding scrollable\" ms-scroll><timeline>\n<timeline-event ng-repeat=\"log in workitemInfo.logs | orderBy : \'-step\'\" side=\"\"><timeline-badge \nstyle=\"background-color: rgb(3,155,229)\"><md-icon md-font-icon=\"{{log.icon}}\" class=\"s25 icon white-fg\" \nstyle=\"color:white !important\"></md-icon></timeline-badge><timeline-panel class=\"{{\'info\'}}\" \nstyle=\"background-color: #f1eded;    border-radius: 10px\"><timeline-heading><div layout=\"row\" \nlayout-align=\"space-between center\"><div ng-if=\"log.currAgent\">{{log.currAgent}}</div><div ng-if=\"!log.currAgent\">\n</div><p><b>Date : {{log.endDate.substr(6,2)}}-{{log.endDate.substr(4,2)}}-{{log.endDate.substr(0,4)}}</b></p></div>\n<div layout=\"row\" layout-align=\"start center\" style=\"color:black\"><img ng-src=\"assets\\images\\avatars/Nora.jpg\" \nclass=\"md-avatar\" style=\"border-radius:50% !important;width:13%; height:auto\"><div class=\"h4\" \nng-if=\"log.activityText == \'Initiated\' \">{{log.actualUser}} &nbsp initiated</div><div class=\"h4\" \nng-if=\"log.activityText == \'Approve\' \">{{log.actualUser}} &nbsp Approved</div><div class=\"h4\" \nng-if=\"log.activityText == \'Reject\' \">{{log.actualUser}} &nbsp Rejected</div><div class=\"h4\" \nng-if=\"log.activityText == \'Confirm\' \">{{log.actualUser}} &nbsp Confirmed</div><div class=\"h4\" \nng-if=\"log.activityText != \'Initiated\' && log.activityText != \'Approve\' && log.activityText != \'Reject\' && log.activityText != \'Confirm\'  \">\n{{log.actualUser}} &nbsp {{log.activityText}}</div></div></timeline-heading><div layout=\"row\" \nlayout-align=\"start start\" style=\"padding-left: 2%\"><p style=\"color:black\">{{log.comments}}</p></div></timeline-panel>\n</timeline-event></timeline></div></md-tab-body></md-tab><md-tab><md-tab-label><md-button class=\"md-fab md-accent\" \naria-label=\"Use Android\"><md-icon md-svg-src=\"assets/icons/fonts/005-clip.svg\"></md-icon><md-tooltip \nmd-direction=\"top\">Attachments</md-tooltip></md-button></md-tab-label><md-tab-body \nng-style=\"{\'border\': \'1px solid #cccccc\'}\"><div class=\"md-padding scrollable\" ms-scroll><div class=\"md-padding\" \nlayout=\"row\" layout-align=\"space-between center\"><span class=\"h2\">Attachments</span> <span class=\"h3\">\n{{workitemInfo.attachments.length}}</span></div><div><md-list><md-list-item class=\"md-3-line\" \nng-repeat=\"attachment in workitemInfo.attachments\"><div layout=\"row\" flex=\"100\"><div flex=\"5\" layout=\"row\" \nlayout-align=\"center center\"><md-icon md-font-icon=\"{{fileIcon(attachment.fileType)}}\" class=\"s42 icon md-accent\">\n</md-icon></div><div flex=\"60\" class=\"c-p\" ng-click=\"previewFile($event,attachment,workitemInfo.requestId)\"><div \nclass=\"md-list-item-text\"><h3><b>{{attachment.fileName}}</b></h3><h3>Created By : {{attachment.creator}}</h3></div>\n</div><div flex=\"30\"><h3>Date : {{attachment.createDate }}</h3></div><md-button class=\"md-icon-button md-accent\" \nng-click=\"download(attachment,workitemInfo.requestId)\"><md-icon md-font-icon=\"icon-download\" class=\"s32 md-accent\">\n</md-icon></md-button><md-divider ng-if=\"!$last\"></md-divider></div></md-list-item></md-list></div></div><div \nlayout=\"row\" layout-align=\"center center\" flex=\"100\"><div><div><input class=\"ng-hide\" id=\"attachmentUpload\" \nname=\"attachmentUpload\" type=\"file\" onchange=\"angular.element(this).scope().setAttachmentFile(this)\"><label \nfor=\"attachmentUpload\" class=\"md-button md-raised\">Upload files</label></div></div><div flex=\"10\"></div><div \nng-repeat=\"file in attachmentfiles.slice(0)\" layout=\"column\"><div layout=\"row\"><span class=\"md-warn\">\n{{file.webkitRelativePath || file.name}}</span> ( <span ng-switch=\"file.size > 1024*1024\"><span ng-switch-when=\"true\">\n{{file.size / 1024 / 1024 | number:2}} MB</span> <span ng-switch-default>{{file.size / 1024 | number:2}} kB</span> \n</span>)</div><br></div></div></md-tab-body></md-tab></md-tabs></div></md-content></div></ms-widget-front><div \nlayout=\"row\" layout-align=\"end center\" style=\"margin-top: 2%\"><md-button class=\"md-raised\" \nng-click=\"VersionFileDialog($event)\" ng-repeat=\"actvity in workitemInfo.activities\" \nng-if=\"actvity.buttonText === \'Re Submit\'\">New Version</md-button><div class=\"md-padding\"><md-button \nclass=\"md-icon-button md-padding\" ng-click=\"displayPrimaryDocument(workitemInfo.attachments)\" \nstyle=\"padding:0px !important\"><md-tooltip md-direction=\"top\">View Primary Document</md-tooltip><md-icon \nmd-font-icon=\"icon-eye\" class=\"s40 md-accent\"></md-icon></md-button></div><md-button class=\"md-raised md-padding\" \nng-disabled=\"inboxButtons\" \nng-class=\"{\'md-warn\':actvity.buttonText === \'Reject\', \'md-accent\':actvity.buttonText === \'Approve\',\'md-accent\':actvity.buttonText === \'Re Submit\'}\" \nng-repeat=\"actvity in workitemInfo.activities\" data-ng-click=\"processActvity(actvity, $event);\" \nstyle=\"margin-right: 5px\">{{actvity.buttonText}}</md-button><span flex=\"10\"></span></div></ms-widget></div></div><div \nclass=\"page-layout simple right-sidenav\" layout=\"row\" show-xs show-sm show-md hide-gt-md><div class=\"widget-group\" \nlayout=\"row\" flex=\"100\" layout-wrap><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\"><ms-widget-front \nclass=\"white-bg\" class=\"scrollable\" ms-scroll><div flex=\"100\" style=\"overflow-y:scroll !important\"><md-content><div \nstyle=\"background:#dcecf0\" class=\"md-padding\"><div style=\"background:#dcecf0\" class=\"md-padding\"><div layout=\"row\" \nlayout-align=\"center center\" class=\"h2\"><span class=\"h5\">{{workitemInfo.requestType}}</span><span flex=\"5\"></span><span\n class=\"h5\">DocId - {{workitemInfo.requestId}}</span></div></div></div><div><md-tabs md-dynamic-height class=\"x\">\n<md-tab><md-tab-label><md-button class=\"md-fab md-accent\" aria-label=\"Android\" md-tooltip=\"Main\"><md-icon \nmd-svg-src=\"assets/icons/fonts/001-info.svg\"></md-icon><md-tooltip md-direction=\"top\">Information</md-tooltip>\n</md-button></md-tab-label><md-tab-body ng-show=\"formHeader\" flex=\"100\"><div class=\"md-padding scrollable\" ms-scroll>\n<div layout=\"row\" layout-align=\"center center\" class=\"md-padding\"><div flex=\"100\" style=\"color:black\"><form \nname=\"headerForm\"><div flex=\"95\" ng-bind-html=\"currentFormHeader\" compile-template \nng-hide=\"workitemInfo.requestType == \'PR_PROCESS\'\"></div><div ng-bind-html=\"currentFormInboxHeader\" compile-template \nng-show=\"workitemInfo.requestType == \'PR_PROCESS\'\"></div><div>&nbsp;</div><div \nng-if=\" (workitemInfo.lineItems | json) != \'{}\'\"><div class=\"md-padding\" ng-bind-html=\"currentFormLineitem\" \ncompile-template class=\"scrollable\" ms-scroll></div></div></form></div></div></div></md-tab-body></md-tab><md-tab>\n<md-tab-label><md-button class=\"md-fab md-accent\" aria-label=\"Use Android\"><md-icon \nmd-svg-src=\"assets/icons/fonts/004-comment-white-oval-bubble.svg\"></md-icon><md-tooltip md-direction=\"top\">Comments\n</md-tooltip></md-button></md-tab-label><md-tab-body><div class=\"md-padding scrollable\" ms-scroll><timeline>\n<timeline-event ng-repeat=\"log in workitemInfo.logs | orderBy : \'-step\'\" side=\"\"><timeline-badge \nstyle=\"background-color: rgb(3,155,229)\"><md-icon md-font-icon=\"{{log.icon}}\" class=\"s25 icon white-fg\" \nstyle=\"color:white !important\"></md-icon></timeline-badge><timeline-panel class=\"{{\'info\'}}\" \nstyle=\"background-color: #f1eded;    border-radius: 10px\"><timeline-heading><div layout=\"column\" \nlayout-align=\"space-between center\"><div ng-if=\"log.currAgent\">{{log.currAgent}}</div><div ng-if=\"!log.currAgent\">\n</div><p><b>Date : {{log.endDate.substr(6,2)}}-{{log.endDate.substr(4,2)}}-{{log.endDate.substr(0,4)}}</b></p></div>\n<div layout=\"row\" layout-align=\"start center\" style=\"color:black\"><img ng-src=\"assets\\images\\avatars/Nora.jpg\" \nclass=\"md-avatar\" style=\"border-radius:50% !important;width:13%; height:auto\"><div class=\"h6\" \nng-if=\"log.activityText == \'Initiated\' \">{{log.actualUser}} &nbsp initiated</div><div class=\"h6\" \nng-if=\"log.activityText == \'Approve\' \">{{log.actualUser}} &nbsp Approved</div><div class=\"h6\" \nng-if=\"log.activityText == \'Reject\' \">{{log.actualUser}} &nbsp Rejected</div><div class=\"h6\" \nng-if=\"log.activityText == \'Confirm\' \">{{log.actualUser}} &nbsp Confirmed</div><div class=\"h6\" \nng-if=\"log.activityText != \'Initiated\' && log.activityText != \'Approve\' && log.activityText != \'Reject\' && log.activityText != \'Confirm\' \">\n{{log.actualUser}} &nbsp {{log.activityText}}</div></div></timeline-heading><div layout=\"row\" \nlayout-align=\"start start\" style=\"padding-left: 2%\"><p style=\"color:black\">{{log.comments}}</p></div></timeline-panel>\n</timeline-event></timeline></div></md-tab-body></md-tab><md-tab><md-tab-label><md-button class=\"md-fab md-accent\" \naria-label=\"Use Android\"><md-icon md-svg-src=\"assets/icons/fonts/005-clip.svg\"></md-icon><md-tooltip \nmd-direction=\"top\">Attachments</md-tooltip></md-button></md-tab-label><md-tab-body \nng-style=\"{\'border\': \'1px solid #cccccc\'}\"><div class=\"md-padding scrollable\" ms-scroll><div class=\"md-padding\" \nlayout=\"row\" layout-align=\"space-between center\"><span class=\"h2\">Attachments</span> <span class=\"h3\">\n{{workitemInfo.attachments.length}}</span></div><div><md-list><md-list-item class=\"md-3-line scrollable\" \nng-repeat=\"attachment in workitemInfo.attachments\" ms-scroll><div layout=\"row\" flex-gt-xs=\"100\" \nlayout-align=\"space-between center\"><div flex-gt-sm=\"5\" layout=\"row\" layout-align=\"center center\"><md-icon \nmd-font-icon=\"{{fileIcon(attachment.fileType)}}\" class=\"s42 icon md-accent\"></md-icon></div><div flex-gt-sm=\"20\" \nclass=\"c-p\" ng-click=\"openInWindow(attachment.url)\"><div class=\"md-list-item-text\" flex-gt-sm><h3><b>\n{{attachment.fileName}}</b></h3><h3>Created By : {{attachment.creator}}</h3></div></div><div flex-gt-sm=\"20\"><h6>\nDate : {{attachment.createDate }}</h6></div><div flex-gt-sm=\"50\"><md-button class=\"md-icon-button md-accent\" \nng-click=\"download(attachment,workitemInfo.requestId)\"><md-icon md-font-icon=\"icon-download\" class=\"s32 md-accent\">\n</md-icon></md-button></div><md-divider ng-if=\"!$last\"></md-divider></div></md-list-item></md-list></div></div><div \nlayout=\"row\" layout-align=\"center center\" flex=\"100\"><div><div><input class=\"ng-hide\" id=\"attachmentUpload\" \nname=\"attachmentUpload\" type=\"file\" onchange=\"angular.element(this).scope().setAttachmentFile(this)\"><label \nfor=\"attachmentUpload\" class=\"md-button md-raised\">Upload files</label></div></div><div flex=\"10\"></div><div \nng-repeat=\"file in attachmentfiles.slice(0)\" layout=\"column\"><div layout=\"row\"><span class=\"md-warn\">\n{{file.webkitRelativePath || file.name}}</span> ( <span ng-switch=\"file.size > 1024*1024\"><span ng-switch-when=\"true\">\n{{file.size / 1024 / 1024 | number:2}} MB</span> <span ng-switch-default>{{file.size / 1024 | number:2}} kB</span> \n</span>)</div><br></div></div></md-tab-body></md-tab></md-tabs></div></md-content></div></ms-widget-front><div \nlayout=\"row\" layout-align=\"end center\" style=\"margin-bottom: 2%\"><md-button class=\"md-raised\" \nng-click=\"VersionFileDialog($event)\" ng-repeat=\"actvity in workitemInfo.activities\" \nng-if=\"actvity.buttonText === \'Re Submit\'\">New Version</md-button><div class=\"md-padding\"><md-button \nclass=\"md-icon-button md-padding\" ng-click=\"displayPrimaryDocument()\" style=\"padding:0px !important\"><md-tooltip \nmd-direction=\"top\">View Primary Document</md-tooltip><md-icon md-font-icon=\"icon-eye\" class=\"s40 md-accent\"></md-icon>\n</md-button></div><md-button class=\"md-raised md-padding\" \nng-class=\"{\'md-warn\':actvity.buttonText === \'Reject\', \'md-accent\':actvity.buttonText === \'Approve\',\'md-accent\':actvity.buttonText === \'Re Submit\'}\" \nng-repeat=\"actvity in workitemInfo.activities\" data-ng-click=\"processActvity(actvity, $event);\" \nstyle=\"margin-right: 5px\">{{actvity.buttonText}}</md-button><span flex=\"10\"></span></div></ms-widget></div></div>");
$templateCache.put("app/main/mycontent/inbox/Inbox_PR_Edit.html","<md-dialog ng-cloak flex=\"60\"><md-toolbar layout=\"row\" class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2>\nSearch {{Type}}</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content layout=\"column\" \nlayout-align=\"center center\" class=\"p-0\"><div layout=\"row\" style=\"position: inherit !important\"><md-select \nstyle=\"margin-top: 14px;margin-bottom: 44px\" ng-model=\"search.key\"><md-option ng-repeat=\"search in searchMaterial\" \nvalue=\"{{search.value}}\">{{search.name}}</md-option></md-select><span flex=\"10\"></span><md-input-container \nclass=\"md-block\" flex=\"40\"><input ng-model=\"search.value\" placeholder=\"Search here\"></md-input-container><md-button \nclass=\"md-raised\" ng-click=\"searchGLValues(search)\" style=\"height: 35px;top: 5px\">Search</md-button></div><div \nstyle=\"width:100%;  margin-top: 5% !important\" class=\"md-padding scrollable\" ms-scroll ng-if=\"searchResult\"><div \nlayout=\"row\" flex=\"60\" layout-align=\"center center\" ng-if=\"searchResult.length == 0\" \nstyle=\"border:2px solid #cccccc; border-radius:5px; height:50px;margin-left:20%\"><b>No Records were found</b></div>\n<table class=\"dataTable row-border hover tableHighllete\" ng-if=\"searchResult.length != 0\"><thead><tr \nclass=\"table-header\"><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">G/L AccountCode\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">\nG/L AccountDescription</span></div></th></tr></thead><tbody><tr ng-repeat=\"order in searchResult\" \nng-click=\"searchResultRowClick(order)\" class=\"c-p\"><td>{{order.SAKNR}}</td><td>{{order.TXT20}}</td></tr></tbody>\n</table></div></md-dialog-content><md-dialog-actions ng-if=\"searchResult\"><div layout=\"row\" \nlayout-align=\"space-between center\" flex=\"100\"><div class=\"md-padding\"><h5><b>\nShowing {{(pageNumber*size)+1}} - {{(pageNumber + 1)*size}} of {{totalRecords}} Results</b></h5></div><div \nlayout=\"row\" layout-align=\"center center\"><div><md-button type=\"button\" ng-click=\"previous()\" \nng-disabled=\"pageNumber <= 0\">Prev</md-button></div><p class=\"md-padding\"><b>\n{{pageNumber+1}} / {{totalPages}} &nbsp;PAGES</b></p><div class=\"md-padding\"><md-button type=\"button\" \nng-click=\"next()\" ng-disabled=\"pageNumber == totalPages-1\">Next</md-button></div></div></div></md-dialog-actions>\n</md-dialog>");
$templateCache.put("app/main/mycontent/inbox/add.comment.html","<md-dialog flex=\"40\"><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2>{{popupHeading}}</h2><span flex>\n</span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><form name=\"commentForm\" novalidate layout=\"column\"><div \nlayout=\"row\"><md-input-container class=\"md-block no-margin\" flex=\"100\"><label>Add comment</label><textarea \nng-model=\"inboxComment\" oninput=\"this.value = this.value.replace(/[^a-zA-Z0-9 ,.%]/g, \'\')\" columns=\"1\" \nmd-maxlength=\"500\" rows=\"3\" required></textarea></md-input-container></div></form></md-dialog-content>\n<md-dialog-actions layout=\"row\"><span flex></span><md-button ng-click=\"cancel()\">Cancel</md-button><md-button \nng-click=\"process($event, inboxComment)\" ng-disabled=\"!inboxComment\">Ok</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/mycontent/inbox/collaborateBackDialog.html","<md-dialog flex=\"90\" flex-gt-sm=\"70\" flex-md=\"60\" flex-gt-md=\"45\"><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools\"><h2>Collaborate back</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"cancel()\"><md-icon md-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><form name=\"commentForm\" \nnovalidate layout=\"column\"><div layout=\"row\"><md-input-container class=\"md-block no-margin\" flex=\"100\"><label>\nAdd comment</label><textarea ng-model=\"comment\" oninput=\"this.value = this.value.replace(/[^a-zA-Z0-9 ,.%]/g, \'\')\" \ncolumns=\"1\" maxlength=\"500\" md-maxlength=\"500\" rows=\"4\" required></textarea></md-input-container></div></form>\n</md-dialog-content><md-dialog-actions layout=\"row\"><span flex></span><md-button ng-click=\"cancel()\">Cancel</md-button>\n<md-button ng-click=\"collaborateBackComment($event,comment)\" ng-disabled=\"!comment\">Send</md-button><img \nsrc=\"assets/images/loader_blue.gif\" style=\"width: 5rem; max-height: 5rem !important\" ng-if=\"showLoadingIcon\">\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/mycontent/inbox/collaborateDialog.html","<md-dialog flex=\"90\" flex-gt-sm=\"70\" flex-md=\"60\" flex-gt-md=\"45\" ng-cloak style=\"max-height: 85% !important\" \nng-init=\"getAllUsers()\"><form name=\"siteMembersCtrl.memberForm\" role=\"form\" novalidate ng-submit=\" \"><md-toolbar \nlayout=\"row\" class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2>Add Collaborator</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"cancel()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content layout=\"column\" flex=\"100\" class=\"scrollable\" ms-scroll><form name=\"commentForm\" novalidate \nlayout=\"column\"><div layout=\"row\"><md-input-container class=\"md-block no-margin\" flex=\"100\"><label>Add comment</label>\n<textarea ng-model=\"inboxComment\" columns=\"1\" maxlength=\"250\" md-maxlength=\"250\" rows=\"3\" required></textarea>\n</md-input-container></div></form><div layout=\"row\" flex=\"100\" layout-align=\"center center\" ng-if=\"inboxComment\"></div>\n<md-chips flex=\"45\" ng-model=\"searchedMembers\" md-autocomplete-snap=\"\" md-require-match=\"\" ng-if=\"inboxComment\">\n<md-autocomplete md-selected-item=\"selectedAgents\" md-search-text=\"searchText\" \nmd-items=\"agent in agentsSearch(searchText)\" md-item-text=\"item\" placeholder=\"Search Users...\"><span \nng-show=\"agent.login != undefined\" md-highlight-text=\"searchText\">{{agent.firstName}} {{agent.lastName}}</span>\n</md-autocomplete><md-chip-template><span ng-show=\"$chip.login != undefined\"><strong>\n{{$chip.firstName}} {{$chip.lastName}}</strong></span> <span ng-show=\"$chip.id != undefined\"><strong>{{$chip.name}}\n</strong></span></md-chip-template></md-chips><div layout=\"row\" layout-align=\"center center\" \nng-style=\"{\'color\':\'red\',\'font-family\':\'Verdana\',\'font-size\':\'18px\'}\" ng-show=\"msgVisibility\">\nPlease enter either name or email</div><div class=\"md-padding\"></div><div ng-if=\"searchedMembers.length\" \nclass=\"md-padding scrollable\" ms-scroll><table class=\"dataTable row-border hover table-border\" datatable=\"ng\" \ndt-options=\"dataCtrl.dtOptions\"><thead><tr class=\"table-header\"><th class=\"secondary-text\"><div class=\"table-header\">\n<span class=\"column-title\">NAME</span></div></th><th class=\"secondary-text\" hide-xs><div class=\"table-header\"><span \nclass=\"column-title\">EMAIL</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Select</span></div></th></tr></thead><tbody><tr ng-repeat=\"member in searchedMembers\"><td \nclass=\"md-padding\">{{member.firstName}} {{member.lastName}}</td><td class=\"md-padding\" hide-xs>{{member.email}}</td><td\n layout=\"row\" layout-align=\"center center\"><md-button class=\"md-icon-button green-bg\" \nng-click=\"collaborateActivity($event,member, inboxComment)\"><md-icon class=\"white-fg\" md-font-icon=\"icon-check\">\n</md-icon><md-tooltip md-direction=\"top\">Select</md-tooltip></md-button></td></tr></tbody></table></div>\n</md-dialog-content></form><md-dialog-actions layout=\"row\"><span flex></span><md-button ng-click=\"cancel(member)\">\nCancel</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/mycontent/inbox/inbox.html","<div class=\"page-layout simple tabbed mh-0\" layout=\"column\" ng-init=\"getinboxConfig()\"><div \nclass=\"content parent-tabs\"><md-tabs class=\"mh-0\"><md-tab label=\"Inbox\" ui-sref=\"app.mycontent_inbox\" md-active=\"true\">\n</md-tab></md-tabs></div></div><div class=\"widget-group\" flex=\"100\" layout=\"column\" layout-wrap><ms-widget>\n<ms-widget-front class=\"white-bg md-padding\"><div layout=\"row\" layout-wrap><div ng-repeat=\"docType in docTypes\" \nflex=\"100\" flex-gt-xs=\"25\" flex-gt-md=\"25\" layout=\"column\"><a \nng-click=\"goToWorkitems(docType.requestType,docType.displayName)\"><md-card md-theme=\"{{getAnotherColor($index)}}\" \nmd-theme-watch class=\"c-p\"><div class=\"info\" layout=\"column\" layout-align=\"space-between\" flex><div \nclass=\"white-fg md-padding\" ng-style=\"{\'height\':\'150px\'}\"><div class=\"md-subhead font-weight-500\">\n{{docType.requestType}}</div><div layout=\"column\" layout-align=\"space-between\" flex><div><div \nclass=\"h6 secondary-text\">{{docType.displayName}}</div></div></div><div layout=\"row\" \nlayout-align=\"space-between center\"><div><md-icon md-font-icon=\"{{docType.icon}}\" class=\"s50 icon\"></md-icon></div>\n<div><div layout=\"column\" layout-align=\"end end\"><span class=\"md-display-1 secondary-text\">{{docType.total}}</span> \n<span class=\"h5 secondary-text\">Pending items</span></div></div></div></div></div></md-card></a></div></div>\n</ms-widget-front></ms-widget><div ng-if=\"docTypes.length == 0\" layout=\"row\" layout-align=\"center\" \nstyle=\"background-color: #98b2dd !important\"><h3>No Workitems available.</h3></div></div>");
$templateCache.put("app/main/mycontent/inbox/inbox.workitems.html","<link rel=\"stylesheet\" href=\"https://maxcdn.bootstrapcdn.com/bootstrap/3.3.7/css/bootstrap.min.css\"><script \nsrc=\"https://maxcdn.bootstrapcdn.com/bootstrap/3.3.7/js/bootstrap.min.js\"></script><style>\n.md-button.md-fab{\n   width: 40px;\n   height: 40px;\n   margin-top: -14% !important;\n   }\n   /* md-tabs-canvas{\n   background-color:rgb(232, 233, 237);\n   }  */\n   .tab{\n   background:#dcecf0;\n   }\n   .disabled {\n   pointer-events: none;\n   }\n   label{\n   font-size:15px}\n   td{\n    padding:6px !important;\n }\n.ms-responsive-table-wrapper{\n  overflow: visible;\n}\nmd-select.md-default-theme[disabled] ._md-select-value, md-select[disabled] ._md-select-value {\n    color: blue !important;\n    }\n\n.lh{\n   color: black !important;\n}\n.input{\n color: blue !important;\n }\n</style><div id=\"documnets\" class=\"page-layout simple right-sidenav\" layout=\"row\" show-md hide-xs \nng-init=\"getAllWorkitems()\" style=\"height:95% !important;overflow-y:scroll !important; min-height:95% !important\" \nhide-xs hide-sm hide-md show-gt-md><div class=\"widget-group\" layout=\"column\" flex=\"25\" layout-wrap><ms-widget \nflippable=\"true\" layout=\"column\"><ms-widget-front class=\"white-bg\" style=\"height: 600px !important\"><md-toolbar \nlayout=\"row\" class=\"md-accent\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><div>\n<span class=\"icon-keyboard-backspace c-p\" data-ng-click=\"goToInbox();\"><md-tooltip md-direction=\"top\">Back</md-tooltip>\n</span><span class=\"c-p\" data-ng-click=\"previousInboxItems();\"><md-tooltip md-direction=\"top\">Previous 200 Items\n</md-tooltip><md-icon class=\"icon-skip-previous\"></md-icon></span></div><div layout=\"row\"><span class=\"c-p\" \ndata-ng-click=\"nextInboxItems();\" style=\"margin-top: 22%\"><md-tooltip md-direction=\"top\">Next 200 Items</md-tooltip>\n<md-icon class=\"icon-skip-next\"></md-icon></span><md-icon class=\"icon-refresh c-p\" ng-click=\"getAllWorkitems()\" \nstyle=\"margin-right:-5% !important;margin-bottom:22%\"><md-tooltip md-direction=\"top\">Refresh</md-tooltip></md-icon>\n<ms-search-bar on-search=\"search(query)\" debounce=\"300\" \nstyle=\"margin-right:-25px !important;margin-top:3%; color:black\"><md-tooltip md-direction=\"top\">Search</md-tooltip>\n</ms-search-bar></div></div></md-toolbar><md-divider></md-divider><div class=\"scrollable\" ms-scroll \ndata-ng-if=\"allWorkitems.length != 0\"><div class=\"c-p\" \ndata-ng-repeat=\"workitem in allWorkitems | filter:searchString | orderBy:\'-docId\'\" \ndata-ng-click=\"selectWorkitem(workitem);changeTab()\" data-ng-init=\"$first && selectWorkitem(workitem);\" \ndata-ng-class=\"{\'tab\': selectedWorkitem == workitem.docId}\"><div class=\"md-padding\"><div class=\"h5\"><b>\n{{workitem.headerValues.Field1}}</b></div><span><b>DocId - {{workitem.docId}}</b></span><div layout=\"row\" \nlayout-align=\"space-between center \"><span>{{workitem.headerValues.Field2}}</span> <span>\n{{workitem.headerValues.Field3}}</span></div><div layout=\"row\" layout-align=\"space-between center \"><span>\n{{workitem.headerValues.Field4}}</span> <span>{{workitem.headerValues.Field5}}</span></div><div layout=\"row\" \nlayout-align=\"space-between center \"><span>{{workitem.headerValues.Field6}}</span> <span>\n{{workitem.headerValues.Field7}}</span></div></div><md-divider class=\"no-margin\"></md-divider></div></div><div \ndata-ng-if=\"allWorkitems.length == 0\" class=\"md-padding\"><p>No Items were Found.</p></div></ms-widget-front>\n</ms-widget></div><div class=\"widget-group\" layout=\"column\" flex=\"75\" layout-wrap><ms-widget \nstyle=\"margin-right: -24% !important\" data-ng-if=\"allWorkitems.length == 0\"><ms-widget-front class=\"white-bg h-150\">\n<div class=\"content-container text-center\"><div class=\"alert alert-info mv-10 mh-10\"><p>No data available</p></div>\n</div></ms-widget-front></ms-widget><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" \nng-hide=\"allWorkitems.length == 0\"><ms-widget-front class=\"white-bg\" class=\"scrollable\" ms-scroll><div flex=\"100\" \nstyle=\"color:black\" style=\"overflow-y:scroll !important\"><md-content><div style=\"background:#dcecf0\" \nclass=\"md-padding\"><div layout=\"row\" layout-align=\"center center\" class=\"h4\">{{displayName}} <span flex=\"5\"></span>\nDocId - {{workitemInfo.requestId}}</div></div><div><md-tabs md-dynamic-height class=\"x\"><md-tab><md-tab-label>\n<md-button class=\"md-fab md-accent\" aria-label=\"Android\" md-tooltip=\"Main\"><md-icon \nmd-svg-src=\"assets/icons/fonts/001-info.svg\"></md-icon><md-tooltip md-direction=\"top\">Information</md-tooltip>\n</md-button></md-tab-label><md-tab-body ng-show=\"formHeader\" flex=\"100\"><div class=\"md-padding scrollable\" ms-scroll>\n<div layout=\"row\" layout-align=\"center center\"><div flex=\"100\" style=\"color:black\"><form name=\"headerForm\" \ndata-ng-class=\"{\'disabled\':true}\"><div flex class=\"scrollable\" show-gt-xs ms-scroll \nstyle=\"border:2px solid #cccccc; border-radius:0px\"><div flex=\"95\" ng-bind-html=\"currentFormHeader\" compile-template \nng-hide=\"workitemInfo.requestType == \'PR_PROCESS\'\"></div><div ng-bind-html=\"currentFormInboxHeader\" compile-template \nng-show=\"workitemInfo.requestType == \'PR_PROCESS\'\"></div></div><div>&nbsp;</div><div \nng-if=\"workitemInfo.lineItems.length > 0 \" flex><div layout=\"row\" layout-align=\"end end\" \nstyle=\"margin-top:0% !important\" ng-if=\"workitemInfo.requestType == \'PAYABLES_NPO\'\" ng-hide=\"CodingTemplate\"><button \ntype=\"button\" class=\"btn btn-info\" ng-click=\"searchCodingTemplates($event,$index)\" style=\"border-radius: 6px\">\nCoding Template</button></div><div class=\"md-padding scrollable\" ms-scroll style=\"overflow-x: scroll\" \nng-hide=\"workitemInfo.requestType == \'PR_PROCESS\'\"><div ng-bind-html=\"currentFormInboxLineitem\" compile-template \nng-if=\"currentFormInboxLineitem\"></div><div ng-bind-html=\"currentFormLineitem\" compile-template \nng-if=\"!currentFormInboxLineitem\"></div></div></div></form></div></div></div></md-tab-body></md-tab><md-tab>\n<md-tab-label><md-button class=\"md-fab md-accent\" aria-label=\"Use Android\"><md-icon \nmd-svg-src=\"assets/icons/fonts/004-comment-white-oval-bubble.svg\"></md-icon><md-tooltip md-direction=\"top\">Comments\n</md-tooltip></md-button></md-tab-label><md-tab-body><div class=\"md-padding scrollable\" ms-scroll><timeline>\n<timeline-event ng-repeat=\"log in workitemInfo.logs | orderBy:\'$index\'\" side=\"\"><timeline-badge \nstyle=\"background-color: rgb(3,155,229)\"><md-icon md-font-icon=\"{{log.icon}}\" class=\"s25 icon white-fg\" \nstyle=\"color:white !important\"></md-icon></timeline-badge><timeline-panel class=\"{{\'info\'}}\" \nstyle=\"background-color: #f1eded;    border-radius: 10px\"><timeline-heading><div layout=\"row\" \nlayout-align=\"space-between center\"><div ng-if=\"log.currAgent\">{{log.currAgent}}</div><div ng-if=\"!log.currAgent\">\n</div><p><b>Date : {{log.endDate.substr(6,2)}}-{{log.endDate.substr(4,2)}}-{{log.endDate.substr(0,4)}}</b></p></div>\n<div layout=\"row\" layout-align=\"start center\" style=\"color:black\"><img ng-src=\"assets\\images\\avatars/Nora.jpg\" \nclass=\"md-avatar\" style=\"border-radius:50% !important;width:13%; height:auto\"><div class=\"h3\" \nng-if=\"log.activityText == \'Initiated\' \">{{log.actualUser}} &nbsp initiated</div><div class=\"h3\" \nng-if=\"log.activityText == \'Approve\' \">{{log.actualUser}} &nbsp Approved</div><div class=\"h3\" \nng-if=\"log.activityText == \'Reject\' \">{{log.actualUser}} &nbsp Rejected</div><div class=\"h3\" \nng-if=\"log.activityText == \'Confirm\' \">{{log.actualUser}} &nbsp Confirmed</div><div class=\"h3\" \nng-if=\"log.activityText == \'Cancel\' \">{{log.actualUser}} &nbsp Cancelled</div><div class=\"h3\" \nng-if=\"log.activityText == \'Resubmit\' \">{{log.actualUser}} &nbsp Resubmitted</div><div class=\"h3\" \nng-if=\"log.activityText != \'Initiated\' && log.activityText != \'Approve\' && log.activityText != \'Reject\' && log.activityText != \'Confirm\' && log.activityText != \'Cancel\' && log.activityText != \'Resubmit\'  \">\n{{log.actualUser}} &nbsp {{log.activityText}}</div></div></timeline-heading><div layout=\"row\" \nlayout-align=\"start start\" style=\"padding-left: 2%\"><p style=\"color:black\">{{log.comments}}</p></div></timeline-panel>\n</timeline-event></timeline></div></md-tab-body></md-tab><md-tab><md-tab-label><md-button class=\"md-fab md-accent\" \naria-label=\"Use Android\"><md-icon md-svg-src=\"assets/icons/fonts/005-clip.svg\"></md-icon><md-tooltip \nmd-direction=\"top\">Attachments</md-tooltip></md-button></md-tab-label><md-tab-body \nng-style=\"{\'border\': \'1px solid #cccccc\'}\"><div class=\"md-padding scrollable\" ms-scroll><div class=\"md-padding\" \nlayout=\"row\" layout-align=\"space-between center\"><span class=\"h2\">Attachments</span> <span class=\"h3\">\n{{workitemInfo.attachments.length}}</span></div><div><md-list><md-list-item class=\"md-3-line\" \nng-repeat=\"attachment in workitemInfo.attachments\"><div layout=\"row\" flex=\"100\"><div flex=\"5\" layout=\"row\" \nlayout-align=\"center center\"><md-icon md-font-icon=\"{{fileIcon(attachment.fileType)}}\" class=\"s42 icon md-accent\">\n</md-icon></div><div flex=\"60\" class=\"c-p\" ng-click=\"previewFile($event,attachment,workitemInfo.requestId)\"><div \nclass=\"md-list-item-text\"><h3><b>{{attachment.fileName}}</b></h3><h3>Created By : {{attachment.creator}}</h3></div>\n</div><div flex=\"30\"><h3>Date : {{attachment.createDate }}</h3></div><md-button class=\"md-icon-button md-accent\" \nng-click=\"download(attachment,workitemInfo.requestId)\"><md-icon md-font-icon=\"icon-download\" class=\"s32 md-accent\">\n</md-icon></md-button><md-divider ng-if=\"!$last\"></md-divider></div></md-list-item></md-list></div></div><div \nlayout=\"row\" layout-align=\"center center\" flex=\"100\"><div><div><input class=\"ng-hide\" id=\"attachmentUpload\" \nname=\"attachmentUpload\" type=\"file\" onchange=\"angular.element(this).scope().setAttachmentFile(this)\"><label \nfor=\"attachmentUpload\" class=\"md-button md-raised\">Upload files</label></div></div><div flex=\"10\"></div><div \nng-repeat=\"file in attachmentfiles.slice(0)\" layout=\"column\"><div layout=\"row\"><span class=\"md-warn\">\n{{file.webkitRelativePath || file.name}}</span> ( <span ng-switch=\"file.size > 1024*1024\"><span ng-switch-when=\"true\">\n{{file.size / 1024 / 1024 | number:2}} MB</span> <span ng-switch-default>{{file.size / 1024 | number:2}} kB</span> \n</span>)</div><br></div></div></md-tab-body></md-tab></md-tabs></div></md-content></div></ms-widget-front><div \nlayout=\"row\" layout-align=\"end center\" style=\"margin-top: 2%\"><md-button class=\"md-raised\" \nng-click=\"VersionFileDialog($event)\" ng-repeat=\"actvity in workitemInfo.activities\" \nng-if=\"actvity.buttonText === \'Re Submit\'\">New Version</md-button><div class=\"md-padding\"><md-button \nclass=\"md-icon-button md-padding\" ng-click=\"displayPrimaryDocument(workitemInfo.attachments)\" \nstyle=\"padding:0px !important\"><md-tooltip md-direction=\"top\">View Primary Document</md-tooltip><md-icon \nmd-font-icon=\"icon-eye\" class=\"s40 md-accent\"></md-icon></md-button></div><div \nng-show=\"workitemInfo.status != \'5\' && workitemInfo.status != \'7\'\"><md-button class=\"md-raised md-padding\" \nng-disabled=\"inboxButtons\" \nng-class=\"{\'md-warn\':actvity.buttonText === \'Reject\', \'md-accent\':actvity.buttonText === \'Approve\',\'md-accent\':actvity.buttonText === \'Re Submit\'}\" \nng-repeat=\"actvity in workitemInfo.activities\" data-ng-click=\"processActvity(actvity, $event);\" \ndata-ng-if=\"actvity.actvity == \'510\' || actvity.actvity == \'511\' \" style=\"margin-right: 5px\">{{actvity.buttonText}}\n</md-button><md-button class=\"md-raised\" ng-disabled=\"inboxButtons\" data-ng-click=\"collaborate($event,actvity)\" \nng-repeat=\"actvity in workitemInfo.activities\" data-ng-if=\"actvity.actvity == \'110\'\" style=\"margin-right: 5px\">\n{{actvity.buttonText}}</md-button></div><div ng-show=\"workitemInfo.status == \'7\' || workitemInfo.status == \'5\' \">\n<md-button class=\"md-raised md-accent\" ng-disabled=\"inboxButtons\" ng-repeat=\"actvity in workitemInfo.activities\" \ndata-ng-if=\"actvity.actvity == \'111\' \" style=\"margin-right: 5px\" data-ng-click=\"collaborateBack($event, actvity)\">\n{{actvity.buttonText}}</md-button></div><span flex=\"10\"></span></div></ms-widget></div></div><div \nclass=\"page-layout simple right-sidenav\" layout=\"row\" show-xs show-sm show-md hide-gt-md><div class=\"widget-group\" \nlayout=\"row\" flex=\"100\" layout-wrap><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" \nng-hide=\"allWorkitems.length == 0\" ng-show=\"itemsVisibility\"><ms-widget-front class=\"white-bg\"><md-toolbar \nlayout=\"row\" class=\"md-accent\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><div>\n<span class=\"icon-keyboard-backspace c-p\" data-ng-click=\"goToInbox();\"></span> Inbox</div></div></md-toolbar>\n<md-divider></md-divider><md-content><div class=\"c-p\" \ndata-ng-repeat=\"workitem in allWorkitems | filter:searchString | orderBy:\'-docId\'\" \ndata-ng-click=\"mobileselectWorkitem(workitem);changeTab()\" data-ng-init=\"$first && selectWorkitem(workitem);\" \ndata-ng-class=\"{\'tab\': selectedWorkitem == workitem.docId}\"><div class=\"md-padding\"><div class=\"h5\"><b>\n{{workitem.headerValues.Field1}}</b></div><span><b>DocId - {{workitem.docId}}</b></span><div layout=\"row\" \nlayout-align=\"space-between center \"><span>{{workitem.headerValues.Field2}}</span> <span>\n{{workitem.headerValues.Field3}}</span></div><div layout=\"row\" layout-align=\"space-between center \"><span>\n{{workitem.headerValues.Field4}}</span> <span>{{workitem.headerValues.Field5}}</span></div><div layout=\"row\" \nlayout-align=\"space-between center \"><span>{{workitem.headerValues.Field6}}</span> <span>\n{{workitem.headerValues.Field7}}</span></div><md-divider></md-divider></div></div></md-content></ms-widget-front>\n</ms-widget><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" data-ng-if=\"allWorkitems.length == 0\">\n<ms-widget-front class=\"white-bg h-150\"><div class=\"content-container text-center\"><div \nclass=\"alert alert-info mv-10 mh-10\" flex=\"50\"><p>No Pending Documents were found for Approvals.</p></div></div>\n</ms-widget-front></ms-widget><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" ng-hide=\"itemsVisibility\">\n<ms-widget-front class=\"white-bg\" class=\"scrollable\" ms-scroll><div flex=\"100\" style=\"overflow-y:scroll !important\">\n<md-content><div layout=\"row\" layout-align=\"start center\" class=\"md-padding\"><md-button \nclass=\"md-icon-button test-tooltip md-accent\" aria-label=\"Delete\" data-ng-click=\"goBackToItems();\"><md-icon><i \nclass=\"icon-keyboard-backspace s32\"></i></md-icon></md-button></div><div style=\"background:#dcecf0\" class=\"md-padding\">\n<div style=\"background:#dcecf0\" class=\"md-padding\"><div layout=\"row\" layout-align=\"center center\" class=\"h2\"><span \nclass=\"h5\">{{workitemInfo.requestType}}</span><span flex=\"5\"></span><span class=\"h5\">DocId - {{workitemInfo.requestId}}\n</span></div></div></div><div><md-tabs md-dynamic-height class=\"x\"><md-tab><md-tab-label><md-button \nclass=\"md-fab md-accent\" aria-label=\"Android\" md-tooltip=\"Main\"><md-icon md-svg-src=\"assets/icons/fonts/001-info.svg\">\n</md-icon><md-tooltip md-direction=\"top\">Information</md-tooltip></md-button></md-tab-label><md-tab-body \nng-show=\"formHeader\" flex=\"100\"><div class=\"md-padding scrollable\" ms-scroll><div layout=\"row\" \nlayout-align=\"center center\" class=\"md-padding\"><div flex=\"100\" style=\"color:black\"><form name=\"headerForm\"><div \nflex=\"95\" ng-bind-html=\"currentFormHeader\" compile-template ng-hide=\"workitemInfo.requestType == \'PR_PROCESS\'\"></div>\n<div ng-bind-html=\"currentFormInboxHeader\" compile-template ng-show=\"workitemInfo.requestType == \'PR_PROCESS\'\"></div>\n<div>&nbsp;</div><div ng-if=\" (workitemInfo.lineItems | json) != \'{}\'\"><div class=\"md-padding\" \nng-bind-html=\"currentFormLineitem\" compile-template class=\"scrollable\" ms-scroll></div></div></form></div></div></div>\n</md-tab-body></md-tab><md-tab><md-tab-label><md-button class=\"md-fab md-accent\" aria-label=\"Use Android\"><md-icon \nmd-svg-src=\"assets/icons/fonts/004-comment-white-oval-bubble.svg\"></md-icon><md-tooltip md-direction=\"top\">Comments\n</md-tooltip></md-button></md-tab-label><md-tab-body><div class=\"md-padding scrollable\" ms-scroll><timeline>\n<timeline-event ng-repeat=\"log in workitemInfo.logs | orderBy : \'-seqId\'\" side=\"\"><timeline-badge \nstyle=\"background-color: rgb(3,155,229)\"><md-icon md-font-icon=\"{{log.icon}}\" class=\"s25 icon white-fg\" \nstyle=\"color:white !important\"></md-icon></timeline-badge><timeline-panel class=\"{{\'info\'}}\" \nstyle=\"background-color: #f1eded;    border-radius: 10px\"><timeline-heading><div layout=\"column\" \nlayout-align=\"space-between center\"><div ng-if=\"log.currAgent\">{{log.currAgent}}</div><div ng-if=\"!log.currAgent\">\n</div><p><b>Date : {{log.endDate.substr(6,2)}}-{{log.endDate.substr(4,2)}}-{{log.endDate.substr(0,4)}}</b></p></div>\n<div layout=\"row\" layout-align=\"start center\" style=\"color:black\"><img ng-src=\"assets\\images\\avatars/Nora.jpg\" \nclass=\"md-avatar\" style=\"border-radius:50% !important;width:13%; height:auto\"><div class=\"h6\" \nng-if=\"log.activityText == \'Initiated\' \">{{log.actualUser}} &nbsp initiated</div><div class=\"h6\" \nng-if=\"log.activityText == \'Approve\' \">{{log.actualUser}} &nbsp Approved</div><div class=\"h6\" \nng-if=\"log.activityText == \'Reject\' \">{{log.actualUser}} &nbsp Rejected</div><div class=\"h6\" \nng-if=\"log.activityText == \'Confirm\' \">{{log.actualUser}} &nbsp Confirmed</div><div class=\"h6\" \nng-if=\"log.activityText != \'Initiated\' && log.activityText != \'Approve\' && log.activityText != \'Reject\' && log.activityText != \'Confirm\' \">\n{{log.actualUser}} &nbsp {{log.activityText}}</div></div></timeline-heading><div layout=\"row\" \nlayout-align=\"start start\" style=\"padding-left: 2%\"><p style=\"color:black\">{{log.comments}}</p></div></timeline-panel>\n</timeline-event></timeline></div></md-tab-body></md-tab><md-tab><md-tab-label><md-button class=\"md-fab md-accent\" \naria-label=\"Use Android\"><md-icon md-svg-src=\"assets/icons/fonts/005-clip.svg\"></md-icon><md-tooltip \nmd-direction=\"top\">Attachments</md-tooltip></md-button></md-tab-label><md-tab-body \nng-style=\"{\'border\': \'1px solid #cccccc\'}\"><div class=\"md-padding scrollable\" ms-scroll><div class=\"md-padding\" \nlayout=\"row\" layout-align=\"space-between center\"><span class=\"h2\">Attachments</span> <span class=\"h3\">\n{{workitemInfo.attachments.length}}</span></div><div><md-list><md-list-item class=\"md-3-line scrollable\" \nng-repeat=\"attachment in workitemInfo.attachments\" ms-scroll><div layout=\"row\" flex-gt-xs=\"100\" \nlayout-align=\"space-between center\"><div flex-gt-sm=\"5\" layout=\"row\" layout-align=\"center center\"><md-icon \nmd-font-icon=\"{{fileIcon(attachment.fileType)}}\" class=\"s42 icon md-accent\"></md-icon></div><div flex-gt-sm=\"20\" \nclass=\"c-p\" ng-click=\"openInWindow(attachment.url)\"><div class=\"md-list-item-text\" flex-gt-sm><h3><b>\n{{attachment.fileName}}</b></h3><h3>Created By : {{attachment.creator}}</h3></div></div><div flex-gt-sm=\"20\"><h6>\nDate : {{attachment.createDate }}</h6></div><div flex-gt-sm=\"50\"><md-button class=\"md-icon-button md-accent\" \nng-click=\"download(attachment,workitemInfo.requestId)\"><md-icon md-font-icon=\"icon-download\" class=\"s32 md-accent\">\n</md-icon></md-button></div><md-divider ng-if=\"!$last\"></md-divider></div></md-list-item></md-list></div></div><div \nlayout=\"row\" layout-align=\"center center\" flex=\"100\"><div><div><input class=\"ng-hide\" id=\"attachmentUpload\" \nname=\"attachmentUpload\" type=\"file\" onchange=\"angular.element(this).scope().setAttachmentFile(this)\"><label \nfor=\"attachmentUpload\" class=\"md-button md-raised\">Upload files</label></div></div><div flex=\"10\"></div><div \nng-repeat=\"file in attachmentfiles.slice(0)\" layout=\"column\"><div layout=\"row\"><span class=\"md-warn\">\n{{file.webkitRelativePath || file.name}}</span> ( <span ng-switch=\"file.size > 1024*1024\"><span ng-switch-when=\"true\">\n{{file.size / 1024 / 1024 | number:2}} MB</span> <span ng-switch-default>{{file.size / 1024 | number:2}} kB</span> \n</span>)</div><br></div></div></md-tab-body></md-tab></md-tabs></div></md-content></div></ms-widget-front><div \nlayout=\"row\" layout-align=\"end center\" style=\"margin-bottom: 2%\"><md-button class=\"md-raised\" \nng-click=\"VersionFileDialog($event)\" ng-repeat=\"actvity in workitemInfo.activities\" \nng-if=\"actvity.buttonText === \'Re Submit\'\">New Version</md-button><div class=\"md-padding\"><md-button \nclass=\"md-icon-button md-padding\" ng-click=\"displayPrimaryDocument()\" style=\"padding:0px !important\"><md-tooltip \nmd-direction=\"top\">View Primary Document</md-tooltip><md-icon md-font-icon=\"icon-eye\" class=\"s40 md-accent\"></md-icon>\n</md-button></div><md-button class=\"md-raised md-padding\" \nng-class=\"{\'md-warn\':actvity.buttonText === \'Reject\', \'md-accent\':actvity.buttonText === \'Approve\',\'md-accent\':actvity.buttonText === \'Re Submit\'}\" \nng-repeat=\"actvity in workitemInfo.activities\" data-ng-click=\"processActvity(actvity, $event);\" \nstyle=\"margin-right: 5px\">{{actvity.buttonText}}</md-button><span flex=\"10\"></span></div></ms-widget></div></div>");
$templateCache.put("app/main/mycontent/inbox/previewFiles.html","<md-dialog style=\"height: 100%; width: 100%\"><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2>Preview\n</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content class=\"no-padding\" \nstyle=\"-webkit-overflow-scrolling:touch; overflow:auto\"><iframe id=\"iframe\" ng-src=\"{{contentCtrl.fileURL}}\" \nname=\"contentframe\" frameborder=\"0\" style=\"width: 100%; height: 1000px\" ng-if=\"fileVis\"></iframe><img \nng-src=\"{{contentCtrl.fileURL}}\" name=\"contentframe\" frameborder=\"0\" ng-if=\"imgVis\" \nstyle=\"width: 80%; height: 80%; position: absolute;  z-index: 999\"></md-dialog-content></md-dialog>");
$templateCache.put("app/main/mycontent/inbox/searchDataDialog.html","<md-dialog ng-cloak flex=\"60\"><md-toolbar layout=\"row\" class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2>\nSearch Material code</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content layout=\"column\" \nlayout-align=\"center center\" class=\"p-0\"><div layout=\"row\" layout-align=\"start start\" flex><div layout=\"column\" \nstyle=\"position: inherit !important\"><div layout=\"row\"><md-input-container class=\"md-block\" flex-gt-sm><input \nng-model=\"search._id\" placeholder=\"Material\"></md-input-container><span flex=\"5\"></span><md-input-container \nclass=\"md-block\" flex-gt-sm><label>Material Type</label><md-select ng-model=\"search.materailType\"><md-option \nng-repeat=\"material in materialTypes\" value=\"{{material.MTART}}\">{{material.MTBEZ}}</md-option></md-select>\n</md-input-container></div><div layout=\"row\" style=\"margin-top:-3% !important\"><md-input-container class=\"md-block\" \nflex-gt-sm><label for=\"MaterialGroup\">MaterialGroup</label><input ng-model=\"search.materailGroup\"></md-input-container>\n<span flex=\"5\"></span><md-input-container class=\"md-block\" flex-gt-sm><input ng-model=\"search.materialDescription\" \nplaceholder=\"MaterialDescription\"></md-input-container><span flex=\"5\"></span><md-input-container class=\"md-block\" \nflex-gt-sm><input ng-model=\"search.oldMaterailCode\" placeholder=\"Old MaterialNumber\"></md-input-container></div></div>\n<md-button class=\"md-raised\" ng-click=\"searchValues(search)\" style=\"height: 35px;margin-top:11% !important\">Search\n</md-button></div><div style=\"width:100%;     margin-top: 10% !important\" class=\"md-padding scrollable\" ms-scroll \nng-if=\"searchResult\"><div layout=\"row\" flex=\"60\" layout-align=\"center center\" ng-if=\"searchResult.length == 0\" \nstyle=\"border:2px solid #cccccc; border-radius:5px; height:50px;margin-left:20%\"><b>No Records were found</b></div>\n<table class=\"dataTable row-border hover tableHighllete\" ng-if=\"searchResult.length != 0\"><thead><tr \nclass=\"table-header\"><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">MaterailCode\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">MaterialDescription\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">MaterailType</span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">UOM</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">OldMaterialCode</span></div></th></tr>\n</thead><tbody><tr ng-repeat=\"order in searchResult\" ng-click=\"searchResultRowClick(order)\" class=\"c-p\"><td>\n{{order.materailCode}}</td><td>{{order.materialDescription}}</td><td>{{order.materailType}}</td><td>{{order.umo}}</td>\n<td>{{order.oldMaterailCode}}</td></tr></tbody></table></div></md-dialog-content><md-dialog-actions \nng-if=\"searchResult\"><div layout=\"row\" layout-align=\"space-between center\" flex=\"100\"><div class=\"md-padding\"><h5><b>\nShowing {{(pageNumber*size)+1}} - {{(pageNumber + 1)*size}} of {{totalRecords}} Results</b></h5></div><div \nlayout=\"row\" layout-align=\"center center\"><div><md-button type=\"button\" ng-click=\"previous()\" \nng-disabled=\"pageNumber <= 0\">Prev</md-button></div><p class=\"md-padding\"><b>\n{{pageNumber+1}} / {{totalPages}} &nbsp;PAGES</b></p><div class=\"md-padding\"><md-button type=\"button\" \nng-click=\"next()\" ng-disabled=\"pageNumber == totalPages-1\">Next</md-button></div></div></div></md-dialog-actions>\n</md-dialog>");
$templateCache.put("app/main/mycontent/outbox/outbox.html","<div class=\"page-layout simple tabbed mh-0\" layout=\"column\"><div class=\"content parent-tabs\"><md-tabs class=\"mh-0\">\n<md-tab label=\"Outbox\" ui-sref=\"app.mycontent_outbox\" md-active=\"true\"></md-tab></md-tabs></div></div><div \nclass=\"widget-group\" flex=\"100\" layout=\"column\" layout-wrap><ms-widget><ms-widget-front class=\"white-bg\" \ndata-ng-if=\"docTypes.length != 0\"><div layout=\"row\" layout-align=\"start start\" class=\"md-padding\"><span flex=\"90\">\n</span><md-icon md-font-icon=\"icon-view-module\" class=\"s30 faint-text c-p\" ng-click=\"changeView()\"><md-tooltip \nmd-direction=\"down\">Changeview</md-tooltip></md-icon></div><div layout=\"row\" ng-show=\"myView\" layout-wrap><div \nng-repeat=\"docType in docTypes\" flex=\"100\" flex-gt-xs=\"25\" flex-gt-md=\"25\" layout=\"column\"><a \nng-click=\"goToWorkitems(docType.requestType,docType.displayName)\"><md-card md-theme=\"{{getAnotherColor($index)}}\" \nmd-theme-watch class=\"c-p\"><div class=\"info\" layout=\"column\" layout-align=\"space-between\" flex><div \nclass=\"white-fg md-padding\" ng-style=\"{\'height\':\'150px\'}\"><div class=\"md-subhead font-weight-500\">\n{{docType.requestType}}</div><div layout=\"column\" layout-align=\"space-between\" flex><div><div \nclass=\"h6 secondary-text\">{{docType.displayName}}</div></div></div><div layout=\"row\" \nlayout-align=\"space-between center\"><div><md-icon md-font-icon=\"{{docType.icon}}\" class=\"s50 icon\"></md-icon></div>\n<div><div layout=\"column\" layout-align=\"end end\"></div></div></div></div></div></md-card></a></div></div><div \nlayout=\"column\" ng-hide=\"myView\" ng-if=\"docTypes.length != 0\"><ms-widget ng-repeat=\"docType in docTypes\">\n<ms-widget-front class=\"h-60 p-16 c-p\" ng-click=\"goToWorkitems(docType.requestType)\"><div layout=\"row\" \nlayout-align=\"space-between center\"><div><md-icon md-font-icon=\"{{docType.icon}}\" class=\"s50 icon\"></md-icon></div><div\n class=\"h4 font-weight-500\">{{docType.requestType}}</div><div class=\"h6 secondary-text\">{{docType.description}}</div>\n<div layout=\"row\" layout-align=\"space-between center\"><div class=\"h5 secondary-text md-padding\">Pending items</div><div\n class=\"md-display-1 secondary-text\">{{docType.total}}</div></div></div></ms-widget-front></ms-widget></div>\n</ms-widget-front><div ng-if=\"docTypes.length == 0\" layout=\"row\" layout-align=\"center\" \nstyle=\"background-color: #98b2dd !important\"><h3>No Workitems available.</h3></div></ms-widget></div>");
$templateCache.put("app/main/mycontent/outbox/outbox.workitems.html","<link rel=\"stylesheet\" href=\"https://maxcdn.bootstrapcdn.com/bootstrap/3.3.7/css/bootstrap.min.css\"><script \nsrc=\"https://maxcdn.bootstrapcdn.com/bootstrap/3.3.7/js/bootstrap.min.js\"></script><style>\n.md-button.md-fab{\n    width: 40px;\n    height: 40px;\n    margin-top: -14% !important;\n}\n /* md-tabs-canvas{\nbackground-color:rgb(232, 233, 237);\n\n}  */\n\n.tab{\nbackground:#dcecf0;\n}\n.disabled {\n  pointer-events: none;\n \n}\nlabel{\n   font-size:20px}\n</style><div id=\"documnets\" class=\"page-layout simple right-sidenav\" layout=\"row\" show-md hide-xs hide-sm hide-md \nshow-gt-md ng-init=\"getAllWorkitems()\"><div class=\"widget-group\" layout=\"column\" flex=\"25\" layout-wrap><ms-widget \nflippable=\"true\" layout=\"column\"><ms-widget-front class=\"white-bg\"><md-toolbar layout=\"row\" class=\"md-accent\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><div><span \nclass=\"icon-keyboard-backspace c-p\" data-ng-click=\"goToOutbox();\"><md-tooltip md-direction=\"top\">Back</md-tooltip>\n</span><span class=\"c-p\" data-ng-click=\"previousInboxItems();\"><md-tooltip md-direction=\"top\">Previous 200 Items\n</md-tooltip><md-icon class=\"icon-skip-previous\"></md-icon></span></div><div layout=\"row\"><span class=\"c-p\" \ndata-ng-click=\"nextInboxItems();\" style=\"margin: 15px\"><md-tooltip md-direction=\"top\">Next 200 Items</md-tooltip>\n<md-icon class=\"icon-skip-next\"></md-icon></span><md-icon class=\"icon-refresh c-p\" ng-click=\"getAllWorkitems()\" \nstyle=\"margin-right:-10px !important\"><md-tooltip md-direction=\"top\">Refresh</md-tooltip></md-icon><ms-search-bar \non-search=\"search(query)\" debounce=\"300\" style=\"margin-right:-25px !important;color:black\"><md-tooltip \nmd-direction=\"top\">Search</md-tooltip></ms-search-bar></div></div></md-toolbar><md-divider></md-divider><div \nclass=\"scrollable\" ms-scroll data-ng-if=\"allWorkitems.length != 0\"><div class=\"c-p\" \ndata-ng-repeat=\"workitem in allWorkitems | filter:searchString | orderBy:\'-docId\'\" \ndata-ng-click=\"selectWorkitem(workitem);changeTab()\" data-ng-init=\"$first && selectWorkitem(workitem);\" \ndata-ng-class=\"{\'tab\': selectedWorkitem == workitem.docId}\"><div class=\"md-padding\"><div class=\"h5\"><b>\n{{workitem.headerValues.Field1}}</b></div><span><b>DocId - {{workitem.docId}}</b></span><div layout=\"row\" \nlayout-align=\"space-between center \"><span>{{workitem.headerValues.Field2}}</span> <span>\n{{workitem.headerValues.Field3}}</span></div><div layout=\"row\" layout-align=\"space-between center \"><span>\n{{workitem.headerValues.Field4}}</span> <span>{{workitem.headerValues.Field5}}</span></div><div layout=\"row\" \nlayout-align=\"space-between center \"><span>{{workitem.headerValues.Field6}}</span> <span>\n{{workitem.headerValues.Field7}}</span></div></div><md-divider class=\"no-margin\"></md-divider></div></div><div \ndata-ng-if=\"allWorkitems.length == 0\" class=\"md-padding\"><p>No Items were Found.</p></div></ms-widget-front>\n</ms-widget></div><div class=\"widget-group\" layout=\"column\" flex=\"75\" layout-wrap><ms-widget \nstyle=\"margin-right: -24% !important\" data-ng-if=\"allWorkitems.length == 0\"><ms-widget-front class=\"white-bg h-150\">\n<div class=\"content-container text-center\"><div class=\"alert alert-info mv-10 mh-10\"><p>No data available</p></div>\n</div></ms-widget-front></ms-widget><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" \nng-hide=\"allWorkitems.length == 0\"><ms-widget-front class=\"white-bg\" class=\"scrollable\" ms-scroll><div flex=\"100\" \nstyle=\"color:black\"><md-content><div style=\"background:#dcecf0\" class=\"md-padding\"><div layout=\"row\" \nlayout-align=\"center center\" class=\"h4\">{{workitemInfo.requestType}} <span flex=\"5\"></span>\nDocId - {{workitemInfo.requestId}}</div></div><div><md-tabs md-dynamic-height class=\"x\"><md-tab><md-tab-label>\n<md-button class=\"md-fab md-accent\" aria-label=\"Android\" md-tooltip=\"Main\"><md-icon \nmd-svg-src=\"assets/icons/fonts/001-info.svg\"></md-icon><md-tooltip md-direction=\"top\">Information</md-tooltip>\n</md-button></md-tab-label><md-tab-body ng-show=\"formHeader\" flex=\"100\"><div class=\"md-padding scrollable\" ms-scroll>\n<div layout=\"row\" layout-align=\"center center\" class=\"md-padding\"><div flex=\"100\" style=\"color:black\"><form \nname=\"headerForm\" class=\"md-inline-form\"><div><div class=\"md-padding\" show-gt-xs ng-bind-html=\"currentFormHeader\" \ncompile-template class=\"scrollable\" ms-scroll style=\"border:5px solid #cccccc; border-radius:15px\"></div></div><div \nng-if=\" workitemInfo.lineItems.length > 0 \"><div class=\"md-padding\" hide-gt-xs ng-bind-html=\"currentFormLineitem\" \ncompile-template class=\"scrollable\" ms-scroll style=\"pointer-events: none\"></div></div></form></div></div></div>\n</md-tab-body></md-tab><md-tab><md-tab-label><md-button class=\"md-fab md-accent\" aria-label=\"Use Android\"><md-icon \nmd-svg-src=\"assets/icons/fonts/004-comment-white-oval-bubble.svg\"></md-icon><md-tooltip md-direction=\"top\">Comments\n</md-tooltip></md-button></md-tab-label><md-tab-body><div class=\"md-padding scrollable\" ms-scroll><timeline>\n<timeline-event ng-repeat=\"log in workitemInfo.logs | orderBy : \'-step\'\" side=\"\"><timeline-badge \nstyle=\"background-color: rgb(3,155,229)\"><md-icon md-font-icon=\"{{log.icon}}\" class=\"s25 icon white-fg\" \nstyle=\"color:white !important\"></md-icon></timeline-badge><timeline-panel class=\"{{\'info\'}}\" \nstyle=\"background-color: #f1eded;    border-radius: 10px\"><timeline-heading><div layout=\"row\" \nlayout-align=\"space-between center\"><div ng-if=\"log.currAgent\">{{log.currAgent}}</div><div ng-if=\"!log.currAgent\">\n</div><p><b>Date : {{log.endDate.substr(6,2)}}-{{log.endDate.substr(4,2)}}-{{log.endDate.substr(0,4)}}</b></p></div>\n<div layout=\"row\" layout-align=\"start center\" style=\"color:black\"><img ng-src=\"assets\\images\\avatars/Nora.jpg\" \nclass=\"md-avatar\" style=\"border-radius:50% !important;width:13%; height:auto\"><div class=\"h4\" \nng-if=\"log.activityText == \'Initiated\' \">{{log.actualUser}} initiated</div><div class=\"h4\" \nng-if=\"log.activityText == \'Approve\' \">{{log.actualUser}} &nbsp Approved</div><div class=\"h4\" \nng-if=\"log.activityText == \'Reject\' \">{{log.actualUser}} &nbsp Rejected</div><div class=\"h4\" \nng-if=\"log.activityText == \'Confirm\' \">{{log.actualUser}} &nbsp Confirmed</div><div class=\"h4\" \nng-if=\"log.activityText != \'Initiated\' && log.activityText != \'Approve\' && log.activityText != \'Reject\' && log.activityText != \'Confirm\'  \">\n{{log.actualUser}} &nbsp {{log.activityText}}</div></div></timeline-heading><div layout=\"row\" \nlayout-align=\"start start\" style=\"padding-left: 2%\"><p style=\"color:black\">{{log.comments}}</p></div></timeline-panel>\n</timeline-event></timeline></div></md-tab-body></md-tab><md-tab><md-tab-label><md-button class=\"md-fab md-accent\" \naria-label=\"Use Android\"><md-icon md-svg-src=\"assets/icons/fonts/005-clip.svg\"></md-icon><md-tooltip \nmd-direction=\"top\">Attachments</md-tooltip></md-button></md-tab-label><md-tab-body \nng-style=\"{\'border\': \'1px solid #cccccc\'}\"><div class=\"md-padding scrollable\" ms-scroll><div class=\"md-padding\" \nlayout=\"row\" layout-align=\"space-between center\"><span class=\"h2\">Attachments</span> <span class=\"h6\">\n{{workitemInfo.attachments.length}}</span></div><div><md-list><md-list-item class=\"md-3-line\" \nng-repeat=\"attachment in workitemInfo.attachments\"><div layout=\"row\" flex=\"100\"><div flex=\"5\" layout=\"row\" \nlayout-align=\"center center\"><md-icon md-font-icon=\"{{fileIcon(attachment.fileType)}}\" class=\"s42 icon md-accent\">\n</md-icon></div><div flex=\"60\" class=\"c-p\" ng-click=\"previewFile($event,attachment,workitemInfo.requestId)\"><div \nclass=\"md-list-item-text\"><h3><b>{{attachment.fileName}}</b></h3><h3>Created By : {{attachment.creator}}</h3></div>\n</div><div flex=\"30\"><h3>Date : {{attachment.createDate }}</h3></div><md-button class=\"md-icon-button md-accent\" \nng-click=\"download(attachment,workitemInfo.requestId)\"><md-icon md-font-icon=\"icon-download\" class=\"s32 md-accent\">\n</md-icon></md-button><md-divider ng-if=\"!$last\"></md-divider></div></md-list-item></md-list></div></div></md-tab-body>\n</md-tab></md-tabs></div></md-content></div></ms-widget-front></ms-widget></div></div><div \nclass=\"page-layout simple right-sidenav\" layout=\"row\" show-xs show-sm show-md hide-gt-md><div class=\"widget-group\" \nlayout=\"row\" flex=\"100\" layout-wrap><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" \nng-hide=\"allWorkitems.length == 0\" ng-show=\"itemsVisibility\"><ms-widget-front class=\"white-bg\"><md-toolbar \nlayout=\"row\" class=\"md-accent\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><div>\n<span class=\"icon-keyboard-backspace c-p\" data-ng-click=\"goToOutbox();\"></span> Outbox</div></div></md-toolbar>\n<md-divider></md-divider><md-content><div class=\"c-p\" \ndata-ng-repeat=\"workitem in allWorkitems | filter:searchString | orderBy:\'-docId\'\" \ndata-ng-click=\"mobileselectWorkitem(workitem);changeTab()\" data-ng-init=\"$first && selectWorkitem(workitem);\" \ndata-ng-class=\"{\'tab\': selectedWorkitem == workitem.docId}\"><div class=\"md-padding\"><div class=\"h5\"><b>\n{{workitem.headerValues.Field1}}</b></div><span><b>DocId - {{workitem.docId}}</b></span><div layout=\"row\" \nlayout-align=\"space-between center \"><span>{{workitem.headerValues.Field2}}</span> <span>\n{{workitem.headerValues.Field3}}</span></div><div layout=\"row\" layout-align=\"space-between center \"><span>\n{{workitem.headerValues.Field4}}</span> <span>{{workitem.headerValues.Field5}}</span></div><div layout=\"row\" \nlayout-align=\"space-between center \"><span>{{workitem.headerValues.Field6}}</span> <span>\n{{workitem.headerValues.Field7}}</span></div></div><md-divider></md-divider></div></md-content></ms-widget-front>\n</ms-widget><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" data-ng-if=\"allWorkitems.length == 0\">\n<ms-widget-front class=\"white-bg h-150\"><div class=\"content-container text-center\"><div \nclass=\"alert alert-info mv-10 mh-10\" flex=\"50\"><p>No Pending Documents were found for Approvals.</p></div></div>\n</ms-widget-front></ms-widget><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" ng-hide=\"itemsVisibility\">\n<ms-widget-front class=\"white-bg\" class=\"scrollable\" ms-scroll><div flex=\"100\" style=\"overflow-y:scroll !important\">\n<md-content><div layout=\"row\" layout-align=\"start center\" class=\"md-padding\"><md-button \nclass=\"md-icon-button test-tooltip md-accent\" aria-label=\"Delete\" data-ng-click=\"goBackToItems();\"><md-icon><i \nclass=\"icon-keyboard-backspace s32\"></i></md-icon></md-button></div><div style=\"background:#dcecf0\" class=\"md-padding\">\n<div style=\"background:#dcecf0\" class=\"md-padding\"><div layout=\"row\" layout-align=\"center center\" class=\"h2\"><span \nclass=\"h5\">{{workitemInfo.requestType}}</span><span flex=\"5\"></span><span class=\"h5\">DocId - {{workitemInfo.requestId}}\n</span></div></div></div><div><md-tabs md-dynamic-height class=\"x\"><md-tab><md-tab-label><md-button \nclass=\"md-fab md-accent\" aria-label=\"Android\" md-tooltip=\"Main\"><md-icon md-svg-src=\"assets/icons/fonts/001-info.svg\">\n</md-icon><md-tooltip md-direction=\"top\">Information</md-tooltip></md-button></md-tab-label><md-tab-body \nng-show=\"formHeader\" flex=\"100\"><div class=\"md-padding scrollable\" ms-scroll><div layout=\"row\" \nlayout-align=\"center center\" class=\"md-padding\"><div flex=\"100\" style=\"color:black\"><form name=\"headerForm\"><div \nng-hide=\"workitemInfo.requestType ==\'PR_PROCESS\'\"><div ng-bind-html=\"currentFormHeader\" \ndata-ng-class=\"{ \'disabled\': true }\" compile-template class=\"scrollable\" ms-scroll></div></div><div>&nbsp;</div><div \nng-if=\" (workitemInfo.lineItems | json) != \'{}\'\"><div ng-bind-html=\"currentFormLineitem\" compile-template \nstyle=\"pointer-events: none\"></div></div></form></div></div></div></md-tab-body></md-tab><md-tab><md-tab-label>\n<md-button class=\"md-fab md-accent\" aria-label=\"Use Android\"><md-icon \nmd-svg-src=\"assets/icons/fonts/004-comment-white-oval-bubble.svg\"></md-icon><md-tooltip md-direction=\"top\">Comments\n</md-tooltip></md-button></md-tab-label><md-tab-body><div class=\"md-padding scrollable\" ms-scroll><timeline>\n<timeline-event ng-repeat=\"log in workitemInfo.logs | orderBy : \'-step\'\" side=\"\"><timeline-badge \nstyle=\"background-color: rgb(3,155,229)\"><md-icon md-font-icon=\"{{log.icon}}\" class=\"s25 icon white-fg\" \nstyle=\"color:white !important\"></md-icon></timeline-badge><timeline-panel class=\"{{\'info\'}}\" \nstyle=\"background-color: #f1eded;    border-radius: 10px\"><timeline-heading><div layout=\"column\" \nlayout-align=\"space-between center\"><div ng-if=\"log.currAgent\">{{log.currAgent}}</div><div ng-if=\"!log.currAgent\">\n</div><p><b>Date : {{log.endDate.substr(6,2)}}-{{log.endDate.substr(4,2)}}-{{log.endDate.substr(0,4)}}</b></p></div>\n<div layout=\"row\" layout-align=\"start center\" style=\"color:black\"><img ng-src=\"assets\\images\\avatars/Nora.jpg\" \nclass=\"md-avatar\" style=\"border-radius:50% !important;width:13%; height:auto\"><div class=\"h4\" \nng-if=\"log.activityText == \'Initiated\' \">{{log.actualUser}} &nbsp initiated</div><div class=\"h4\" \nng-if=\"log.activityText == \'Approve\' \">{{log.actualUser}} &nbsp Approved</div><div class=\"h4\" \nng-if=\"log.activityText == \'Reject\' \">{{log.actualUser}} &nbsp Rejected</div><div class=\"h4\" \nng-if=\"log.activityText == \'Confirm\' \">{{log.actualUser}} &nbsp Confirmed</div><div class=\"h4\" \nng-if=\"log.activityText != \'Initiated\' && log.activityText != \'Approve\' && log.activityText != \'Reject\' && log.activityText != \'Confirm\'  \">\n{{log.actualUser}} &nbsp {{log.activityText}}</div></div></timeline-heading><div layout=\"row\" \nlayout-align=\"start start\" style=\"padding-left: 2%\"><p style=\"color:black\">{{log.comments}}</p></div></timeline-panel>\n</timeline-event></timeline></div></md-tab-body></md-tab><md-tab><md-tab-label><md-button class=\"md-fab md-accent\" \naria-label=\"Use Android\"><md-icon md-svg-src=\"assets/icons/fonts/005-clip.svg\"></md-icon><md-tooltip \nmd-direction=\"top\">Attachments</md-tooltip></md-button></md-tab-label><md-tab-body \nng-style=\"{\'border\': \'1px solid #cccccc\'}\"><div class=\"md-padding scrollable\" ms-scroll><div class=\"md-padding\" \nlayout=\"row\" layout-align=\"space-between center\"><span class=\"h2\">Attachments</span> <span class=\"h3\">\n{{workitemInfo.attachments.length}}</span></div><div><md-list><md-list-item class=\"md-3-line scrollable\" \nng-repeat=\"attachment in workitemInfo.attachments\" ms-scroll><div layout=\"row\" flex-gt-xs=\"100\" \nlayout-align=\"space-between center\"><div flex-gt-sm=\"5\" layout=\"row\" layout-align=\"center center\"><md-icon \nmd-font-icon=\"{{fileIcon(attachment.fileType)}}\" class=\"s42 icon md-accent\"></md-icon></div><div flex-gt-sm=\"20\" \nclass=\"c-p\" ng-click=\"openInWindow(attachment)\"><div class=\"md-list-item-text\" flex-gt-sm><h3><b>\n{{attachment.fileName}}</b></h3><h3>Created By : {{attachment.creator}}</h3></div></div><div flex-gt-sm=\"20\"><h3>\nDate : {{attachment.createDate }}</h3></div><div flex-gt-sm=\"50\"><md-button class=\"md-icon-button md-accent\" \nng-click=\"download(attachment,workitemInfo.requestId)\"><md-icon md-font-icon=\"icon-download\" class=\"s32 md-accent\">\n</md-icon></md-button></div><md-divider ng-if=\"!$last\"></md-divider></div></md-list-item></md-list></div></div>\n</md-tab-body></md-tab></md-tabs></div></md-content></div></ms-widget-front></ms-widget></div></div>");
$templateCache.put("app/main/mycontent/outbox/previewFiles.html","<md-dialog style=\"height: 100%; width: 100%\"><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2>Preview\n</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content class=\"no-padding\" \nstyle=\"-webkit-overflow-scrolling:touch; overflow:auto\"><iframe id=\"iframe\" src=\"{{fileURL}}\" name=\"contentframe\" \nframeborder=\"0\" style=\"width: 100%; height: 1000px\" ng-if=\"fileVis\"></iframe><img ng-src=\"{{fileURL}}\" \nname=\"contentframe\" frameborder=\"0\" ng-if=\"imgVis\" style=\"width: 80%; height: 80%; position: absolute;  z-index: 999\">\n</md-dialog-content></md-dialog>");
$templateCache.put("app/main/business-admin/business-usermanagement/groups/addbusinessGroupMemberDialog.html","<md-dialog ng-cloak><form name=\"groupsCtrl.memberForm\" role=\"form\" novalidate ng-submit=\" \"><md-toolbar layout=\"row\" \nclass=\"md-accent\"><div class=\"md-toolbar-tools\"><h2>Add Member</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"ok()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nlayout=\"column\" layout-align=\"center center\"><div layout=\"row\"><md-input-container class=\"md-block\" flex=\"45\"><input \ntype=\"text\" name=\"name\" ng-model=\"member.name\" placeholder=\"Name\"></md-input-container><span flex=\"10\"></span>\n<md-input-container class=\"md-block\" flex=\"45\"><input type=\"text\" name=\"email\" ng-model=\"member.email\" \nplaceholder=\"Email\"></md-input-container></div><div layout=\"row\" \nng-style=\"{\'color\':\'red\',\'font-family\':\'Roboto\',\'font-size\':\'12px\'}\" ng-show=\"msgVisibility\">\nPlease enter either name or email</div><div><md-button type=\"button\" class=\"md-raised md-padding\" \nng-click=\"searchMember(member)\"><md-icon md-font-icon=\"icon-magnify\"></md-icon>Search user</md-button></div><div \nng-show=\"tableVisibility\" class=\"scrollable md-padding\" ms-scroll><table><thead><tr><th \nclass=\"secondary-text md-padding\"><div class=\"table-header\"><span class=\"column-title\">NAME</span></div></th><th \nclass=\"secondary-text md-padding\"><div class=\"table-header\"><span class=\"column-title\">EMAIL</span></div></th></tr>\n</thead><tbody ng-repeat=\"member in searchedMembers\"><tr ng-repeat=\"user in member\"><td class=\"md-padding\">\n{{user.firstName}} {{user.lastName}}</td><td class=\"md-padding\">{{user.email}}</td><td layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-accent md-raised\" ng-click=\"addGroupMember(user) \">ADD</md-button>\n</td></tr></tbody></table></div></md-dialog-content></form><md-dialog-actions layout=\"row\"><span flex></span><md-button\n ng-click=\"cancel(member)\">Cancel</md-button><md-button ng-click=\"ok()\" md-autofocus>Ok</md-button></md-dialog-actions>\n</md-dialog>");
$templateCache.put("app/main/business-admin/business-usermanagement/groups/businessgroups.html","<div class=\"page-layout simple right-sidenav\" layout=\"row\"><div \nclass=\"page-layout carded fullwidth md-padding scrollable\" layout=\"column\" flex ms-scroll><div class=\"widget-group\" \nflex=\"100\" layout=\"column\" layout-wrap><ms-widget flippable=\"true\" class=\"no-padding\"><div \nclass=\"page-layout carded fullwidth md-padding scrollable white-bg\" layout=\"column\" flex ms-scroll md-dynamic-height \nng-if=\"!viewGroupMember\"><span class=\"previous-state c-p\" data-ng-click=\"businessgroupsCtrl.goToadmin()\"><span><span \nclass=\"icon-arrow-left-bold-circle-outline\"></span> Back</span></span><div class=\"search\" layout=\"row\" \nlayout-align=\"center center\"><span flex=\"100\"><md-input-container class=\"no-margin pull-right\"><md-icon \nmd-font-icon=\"icon-magnify\"></md-icon><input ng-model=\"searchGroup\" type=\"text\" placeholder=\"Search\">\n</md-input-container></span></div><div layout=\"row\" layout-wrap><div \nng-repeat=\"eachGroup in businessgroupsCtrl.allGroups\" flex=\"15\"><a \nng-click=\"businessgroupsCtrl.selectGroup(eachGroup)\"><md-tooltip md-direction=\"top\">{{eachGroup.description}}\n</md-tooltip><md-card md-theme=\"{{getAnotherColor($index)}}\" class=\"c-p\" md-theme-watch><div class=\"info\" \nlayout=\"column\" layout-align=\"space-between\" flex><div class=\"white-fg md-padding\" layout=\"row\" \nlayout-align=\"center center\" ng-style=\"{\'height\':\'150px\'}\"><md-icon md-font-icon=\"icon-account-multiple\" class=\"s64\">\n</md-icon></div><div><md-divider></md-divider><div class=\"h4 p-8 white-bg black-fg\" layout=\"column\" \nlayout-align=\"center center\">{{eachGroup.name}}</div></div></div></md-card></a><div \nstyle=\"margin-left:5%; margin-top:-26%\"><md-button class=\"md-icon-button test-tooltip\" \nng-click=\"businessgroupsCtrl.editGroup($event,eachGroup)\"><md-tooltip md-direction=\"top\">Edit Group</md-tooltip>\n<md-icon><i layout=\"row\" layout-align=\"center center\" class=\"icon icon-pencil s20\"></i></md-icon></md-button></div><div\n style=\"margin-left:75%; margin-top:-22%\"><md-button class=\"md-icon-button test-tooltip\" \nng-click=\"businessgroupsCtrl.deleteGroup(eachGroup)\"><md-tooltip md-direction=\"top\">Delete Group</md-tooltip><md-icon>\n<i layout=\"row\" layout-align=\"center center\" class=\"icon icon-delete s20\"></i></md-icon></md-button></div></div></div>\n</div><div class=\"page-layout carded fullwidth md-padding scrollable white-bg\" data-ng-if=\"viewGroupMember\"><div \nclass=\"md-padding\" layout=\"row\"><span class=\"md-active c-p\" data-ng-click=\"goBackToGroup();\" style=\"display: inherit\">\n<md-icon md-font-icon=\"icon-arrow-left md-active s16\"></md-icon>Go back</span></div><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"dtOptions\"><thead><tr class=\"table-header\"><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">First Name</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Last Name</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Email</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\" layout=\"row\" layout-align=\"center center\"><span class=\"column-title\">\nActions</span></div></th></tr></thead><tbody><tr ng-repeat=\"eachGroup in groupObj.members | filter : searchUser\"><td>\n{{eachGroup.firstName}}</td><td>{{eachGroup.lastName}}</td><td>{{eachGroup.email}}</td><td layout=\"row\" \nlayout-align=\"center center\" style=\"padding-top:0px !important;padding-bottom:0px !important\"><md-button \nclass=\"md-icon-button test-tooltip\" aria-label=\"Delete\" \nng-click=\"businessgroupsCtrl.deleteGroupMember(groupObj, $index)\"><md-tooltip md-direction=\"top\">Delete</md-tooltip>\n<md-icon><i layout=\"row\" layout-align=\"center center\" class=\"icon icon-delete s18\"></i></md-icon></md-button></td></tr>\n</tbody></table></div></ms-widget></div><md-button flow-btn class=\"md-fab grey-700-bg md-mini md-fab-bottom-right\" \nng-click=\"businessgroupsCtrl.createGroupDialog($event)\" ng-if=\"!viewGroupMember\"><md-icon md-font-icon=\"icon-plus\">\n</md-icon><md-tooltip md-direction=\"top\">Create Group</md-tooltip></md-button><md-button flow-btn \nclass=\"md-fab grey-700-bg md-mini md-fab-bottom-right\" ng-click=\"businessgroupsCtrl.addMemberDialog($event, groupObj)\" \nng-if=\"viewGroupMember\"><md-icon md-font-icon=\"icon-plus\"></md-icon><md-tooltip md-direction=\"top\">Add Group Member\n</md-tooltip></md-button></div></div>");
$templateCache.put("app/main/business-admin/business-usermanagement/groups/createbusinessGroupDialog.html","<md-dialog aria-label=\"Create a new Group\" flex=\"20\"><form name=\"groupForm\" novalidate ng-submit=\"\" layout=\"column\">\n<md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2>Create Group</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"close()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><md-input-container class=\"md-block\"><input type=\"text\" name=\"name\" \nng-model=\"group.name\" placeholder=\"Group name\" required><div ng-messages=\"groupForm.name.$error\" role=\"alert\"><div \nng-message=\"required\">Group name is required</div></div></md-input-container><md-input-container class=\"md-block\">\n<input type=\"text\" name=\"description\" ng-model=\"group.description\" placeholder=\"Description\"></md-input-container>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"center center\"><md-button ng-click=\"cancel()\">Cancel\n</md-button><md-button type=\"submit\" ng-click=\"groupForm.$valid && createGroup(group)\">Save</md-button>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/business-admin/business-usermanagement/groups/editGroupDialog.html","<md-dialog aria-label=\"Create a new Group\" flex=\"20\"><form name=\"groupForm\" novalidate ng-submit=\"\" layout=\"column\">\n<md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2>Edit Group</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"close()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><md-input-container class=\"md-block\"><input type=\"text\" name=\"name\" \nng-model=\"currentGroup.name\" placeholder=\"Group name\" required><div ng-messages=\"groupForm.name.$error\" role=\"alert\">\n<div ng-message=\"required\">Group name is required</div></div></md-input-container><md-input-container class=\"md-block\">\n<input type=\"text\" name=\"description\" ng-model=\"currentGroup.description\" placeholder=\"Description\">\n</md-input-container></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"center center\"><md-button \nng-click=\"cancel()\">Cancel</md-button><md-button type=\"submit\" ng-click=\" EditGroup(currentGroup)\">Save</md-button>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/administration/invoiceTypes/pr_request/pr_request.html","<style>\n.header {\n            height: 50px !important;\n            min-height: 0px !important;\n        }\n        \n        .reqtype {\n            font-size: 22px;\n            margin-top: -1px;\n        }\n</style><div class=\"page-layout simple right-sidenav\" layout=\"row\"><div \nng-include=\"\'app/main/administration/common/admin.html\'\"></div><div \nclass=\"page-layout carded fullwidth md-padding scrollable\" layout=\"column\" flex ms-scroll><div \nclass=\"parent-tabs white-bg mb-15\"><md-tabs class=\"mh-0\"><md-tab label=\"InvoiceTypes\"></md-tab></md-tabs></div><div \nclass=\"widget-group\" flex=\"100\" layout=\"column\" layout-wrap><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" \nmd-dynamic-height><ms-widget-front class=\"white-bg\"><div class=\"header md-accent-bg\" layout=\"row\" \nlayout-align=\"space-between\"><div layout=\"column\" layout-align=\"center center\"><div layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16 c-p\" ng-click=\"gotoPR_Types()\"></md-icon>\n<md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span>Update Purchase Requisition</span>\n</div></div></div><div class=\"content\" layout=\"column\"><div layout=\"row\" class=\"md-padding\"><md-input-container \nclass=\"md-block\" flex-gt-sm=\"40\"><label>Name</label><input type=\"text\" name=\"name\" ng-model=\"vm.InvoiceType.name\">\n</md-input-container><span flex=\"10\"></span><md-input-container class=\"md-block\" flex-gt-sm=\"40\"><label>Description\n</label><input type=\"text\" name=\"name\" ng-model=\"vm.InvoiceType.name\"></md-input-container></div><div layout=\"row\" \nclass=\"md-padding\" layout-align=\"start start\"><span class=\"reqtype\">Req Doctypes:</span> <span flex=\"5\"></span>\n<md-input-container class=\"md-block\" flex-gt-sm=\"30\" style=\"margin-top:0%\"><input type=\"text\" name=\"name\" \nng-model=\"vm.InvoiceType.name\"></md-input-container></div><md-tabs md-dynamic-height md-border-bottom><md-tab \nlabel=\"Business Rules\"><md-content class=\"md-padding\"><h1 class=\"md-display-1\">Business Rules</h1></md-content>\n</md-tab><md-tab label=\"Form Fields For Request\"><md-content class=\"md-padding\"><h1 class=\"reqtype\">Header</h1><div \nlayout=\"row\" class=\"md-padding\"><div layout=\"row\" layout-align=\"start start\" class=\"md-padding\"><md-switch \nclass=\"md-accent\" style=\"margin:5px !important\" aria-label=\"Switch No Ink\" ng-model=\"request.requestedby\">RequestedBy\n</md-switch></div><div layout=\"row\" layout-align=\"start start\" class=\"md-padding\"><md-switch class=\"md-accent\" \nstyle=\"margin:5px !important\" aria-label=\"Switch No Ink\" ng-model=\"request.doctype\">PR Doctype</md-switch></div></div>\n<h1 class=\"reqtype\">LineItems</h1><div layout=\"column\"><div layout=\"row\" class=\"md-padding\"><div layout=\"row\" \nlayout-align=\"start start\"><md-switch class=\"md-accent\" style=\"margin:5px !important\" aria-label=\"Switch No Ink\" \nng-model=\"request.accAssCat\">Acc. Ass.Category</md-switch></div><div layout=\"row\" layout-align=\"start start\"><md-switch\n class=\"md-accent\" style=\"margin:5px !important\" aria-label=\"Switch No Ink\" ng-model=\"request.itemCategory\">\nItem Category</md-switch></div><div layout=\"row\" layout-align=\"start start\"><md-switch class=\"md-accent\" \nstyle=\"margin:5px !important\" aria-label=\"Switch No Ink\" ng-model=\"request.materialCode\">Material Code</md-switch>\n</div><div layout=\"row\" layout-align=\"start start\"><md-switch class=\"md-accent\" style=\"margin:5px !important\" \naria-label=\"Switch No Ink\" ng-model=\"request.shortText\">Short Text</md-switch></div><div layout=\"row\" \nlayout-align=\"start start\"><md-switch class=\"md-accent\" style=\"margin:5px !important\" aria-label=\"Switch No Ink\" \nng-model=\"request.matgroupDesc\">Mat. Grp.Desc</md-switch></div><div layout=\"row\" layout-align=\"start start\"><md-switch \nclass=\"md-accent\" style=\"margin:5px !important\" aria-label=\"Switch No Ink\" ng-model=\"request.plant\">Plant</md-switch>\n</div><div layout=\"row\" layout-align=\"start start\"><md-switch class=\"md-accent\" style=\"margin:5px !important\" \naria-label=\"Switch No Ink\" ng-model=\"request.purchasegroup\">Purchase Group</md-switch></div><div layout=\"row\" \nlayout-align=\"start start\"><md-switch class=\"md-accent\" style=\"margin:5px !important\" aria-label=\"Switch No Ink\" \nng-model=\"request.Quantity\">Quantity</md-switch></div><div layout=\"row\" layout-align=\"start start\"><md-switch \nclass=\"md-accent\" style=\"margin:5px !important\" aria-label=\"Switch No Ink\" ng-model=\"request.uom\">UOM</md-switch></div>\n<div layout=\"row\" layout-align=\"start start\"><md-switch class=\"md-accent\" style=\"margin:5px !important\" \naria-label=\"Switch No Ink\" ng-model=\"pr.valprice\">Valuation Price</md-switch></div><div layout=\"row\" \nlayout-align=\"start start\"><md-switch class=\"md-accent\" style=\"margin:5px !important\" aria-label=\"Switch No Ink\" \nng-model=\"request.total\">Total Amount</md-switch></div></div><div layout=\"row\" class=\"md-padding\"><div layout=\"row\" \nlayout-align=\"start start\"><md-switch class=\"md-accent\" style=\"margin:5px !important\" aria-label=\"Switch No Ink\" \nng-model=\"request.order\">Order No</md-switch></div><div layout=\"row\" layout-align=\"start start\"><md-switch \nclass=\"md-accent\" style=\"margin:5px !important\" aria-label=\"Switch No Ink\" ng-model=\"request.costcenter\">Cost Center\n</md-switch></div><div layout=\"row\" layout-align=\"start start\"><md-switch class=\"md-accent\" \nstyle=\"margin:5px !important\" aria-label=\"Switch No Ink\" ng-model=\"request.glaccount\">G/L Account</md-switch></div><div\n layout=\"row\" layout-align=\"start start\"><md-switch class=\"md-accent\" style=\"margin:5px !important\" \naria-label=\"Switch No Ink\" ng-model=\"request.functionalarea\">Functional Area</md-switch></div><div layout=\"row\" \nlayout-align=\"start start\"><md-switch class=\"md-accent\" style=\"margin:5px !important\" aria-label=\"Switch No Ink\" \nng-model=\"request.fund\">Fund</md-switch></div><div layout=\"row\" layout-align=\"start start\"><md-switch \nclass=\"md-accent\" style=\"margin:5px !important\" aria-label=\"Switch No Ink\" ng-model=\"request.date\">Delivery Date\n</md-switch></div></div></div></md-content></md-tab><md-tab label=\"Form Fields For Inbox\"><md-content \nclass=\"md-padding\"><h1 class=\"reqtype\">Header</h1><div layout=\"row\" class=\"md-padding\"><div layout=\"row\" \nlayout-align=\"start start\" class=\"md-padding\"><md-switch class=\"md-accent\" style=\"margin:5px !important\" \naria-label=\"Switch No Ink\" ng-model=\"inbox.requestedby\">RequestedBy</md-switch></div><div layout=\"row\" \nlayout-align=\"start start\" class=\"md-padding\"><md-switch class=\"md-accent\" style=\"margin:5px !important\" \naria-label=\"Switch No Ink\" ng-model=\"inbox.doctype\">PR Doctype</md-switch></div></div><h1 class=\"reqtype\">LineItems\n</h1><div layout=\"column\"><div layout=\"row\" class=\"md-padding\"><div layout=\"row\" layout-align=\"start start\"><md-switch \nclass=\"md-accent\" style=\"margin:5px !important\" aria-label=\"Switch No Ink\" ng-model=\"inbox.accAssCat\">Acc. Ass.Category\n</md-switch></div><div layout=\"row\" layout-align=\"start start\"><md-switch class=\"md-accent\" \nstyle=\"margin:5px !important\" aria-label=\"Switch No Ink\" ng-model=\"inbox.itemCategory\">Item Category</md-switch></div>\n<div layout=\"row\" layout-align=\"start start\"><md-switch class=\"md-accent\" style=\"margin:5px !important\" \naria-label=\"Switch No Ink\" ng-model=\"inbox.materialCode\">Material Code</md-switch></div><div layout=\"row\" \nlayout-align=\"start start\"><md-switch class=\"md-accent\" style=\"margin:5px !important\" aria-label=\"Switch No Ink\" \nng-model=\"inbox.shortText\">Short Text</md-switch></div><div layout=\"row\" layout-align=\"start start\"><md-switch \nclass=\"md-accent\" style=\"margin:5px !important\" aria-label=\"Switch No Ink\" ng-model=\"inbox.matgroupDesc\">Mat. Grp.Desc\n</md-switch></div><div layout=\"row\" layout-align=\"start start\"><md-switch class=\"md-accent\" \nstyle=\"margin:5px !important\" aria-label=\"Switch No Ink\" ng-model=\"inbox.plant\">Plant</md-switch></div><div \nlayout=\"row\" layout-align=\"start start\"><md-switch class=\"md-accent\" style=\"margin:5px !important\" \naria-label=\"Switch No Ink\" ng-model=\"inbox.purchasegroup\">Purchase Group</md-switch></div><div layout=\"row\" \nlayout-align=\"start start\"><md-switch class=\"md-accent\" style=\"margin:5px !important\" aria-label=\"Switch No Ink\" \nng-model=\"inbox.Quantity\">Quantity</md-switch></div><div layout=\"row\" layout-align=\"start start\"><md-switch \nclass=\"md-accent\" style=\"margin:5px !important\" aria-label=\"Switch No Ink\" ng-model=\"inbox.uom\">UOM</md-switch></div>\n<div layout=\"row\" layout-align=\"start start\"><md-switch class=\"md-accent\" style=\"margin:5px !important\" \naria-label=\"Switch No Ink\" ng-model=\"inbox.valprice\">Valuation Price</md-switch></div><div layout=\"row\" \nlayout-align=\"start start\"><md-switch class=\"md-accent\" style=\"margin:5px !important\" aria-label=\"Switch No Ink\" \nng-model=\"inbox.total\">Total Amount</md-switch></div></div><div layout=\"row\" class=\"md-padding\"><div layout=\"row\" \nlayout-align=\"start start\"><md-switch class=\"md-accent\" style=\"margin:5px !important\" aria-label=\"Switch No Ink\" \nng-model=\"inbox.order\">Order No</md-switch></div><div layout=\"row\" layout-align=\"start start\"><md-switch \nclass=\"md-accent\" style=\"margin:5px !important\" aria-label=\"Switch No Ink\" ng-model=\"inbox.costcenter\">Cost Center\n</md-switch></div><div layout=\"row\" layout-align=\"start start\"><md-switch class=\"md-accent\" \nstyle=\"margin:5px !important\" aria-label=\"Switch No Ink\" ng-model=\"inbox.glaccount\">G/L Account</md-switch></div><div \nlayout=\"row\" layout-align=\"start start\"><md-switch class=\"md-accent\" style=\"margin:5px !important\" \naria-label=\"Switch No Ink\" ng-model=\"inbox.functionalarea\">Functional Area</md-switch></div><div layout=\"row\" \nlayout-align=\"start start\"><md-switch class=\"md-accent\" style=\"margin:5px !important\" aria-label=\"Switch No Ink\" \nng-model=\"inbox.fund\">Fund</md-switch></div><div layout=\"row\" layout-align=\"start start\"><md-switch class=\"md-accent\" \nstyle=\"margin:5px !important\" aria-label=\"Switch No Ink\" ng-model=\"inbox.date\">Delivery Date</md-switch></div></div>\n</div></md-content></md-tab><md-tab label=\"Form Fields For Mobile\"><md-content class=\"md-padding\"><h1 class=\"reqtype\">\nHeader</h1><div layout=\"row\" class=\"md-padding\"><div layout=\"row\" layout-align=\"start start\" class=\"md-padding\">\n<md-switch class=\"md-accent\" style=\"margin:5px !important\" aria-label=\"Switch No Ink\" ng-model=\"mobile.requestedby\">\nRequestedBy</md-switch></div><div layout=\"row\" layout-align=\"start start\" class=\"md-padding\"><md-switch \nclass=\"md-accent\" style=\"margin:5px !important\" aria-label=\"Switch No Ink\" ng-model=\"mobile.doctype\">PR Doctype\n</md-switch></div></div><h1 class=\"reqtype\">LineItems</h1><div layout=\"column\"><div layout=\"row\" class=\"md-padding\">\n<div layout=\"row\" layout-align=\"start start\"><md-switch class=\"md-accent\" style=\"margin:5px !important\" \naria-label=\"Switch No Ink\" ng-model=\"mobile.accAssCat\">Acc. Ass.Category</md-switch></div><div layout=\"row\" \nlayout-align=\"start start\"><md-switch class=\"md-accent\" style=\"margin:5px !important\" aria-label=\"Switch No Ink\" \nng-model=\"mobile.itemCategory\">Item Category</md-switch></div><div layout=\"row\" layout-align=\"start start\"><md-switch \nclass=\"md-accent\" style=\"margin:5px !important\" aria-label=\"Switch No Ink\" ng-model=\"mobile.materialCode\">Material Code\n</md-switch></div><div layout=\"row\" layout-align=\"start start\"><md-switch class=\"md-accent\" \nstyle=\"margin:5px !important\" aria-label=\"Switch No Ink\" ng-model=\"mobile.shortText\">Short Text</md-switch></div><div \nlayout=\"row\" layout-align=\"start start\"><md-switch class=\"md-accent\" style=\"margin:5px !important\" \naria-label=\"Switch No Ink\" ng-model=\"mobile.matgroupDesc\">Mat. Grp.Desc</md-switch></div><div layout=\"row\" \nlayout-align=\"start start\"><md-switch class=\"md-accent\" style=\"margin:5px !important\" aria-label=\"Switch No Ink\" \nng-model=\"mobile.plant\">Plant</md-switch></div><div layout=\"row\" layout-align=\"start start\"><md-switch \nclass=\"md-accent\" style=\"margin:5px !important\" aria-label=\"Switch No Ink\" ng-model=\"mobile.purchasegroup\">\nPurchase Group</md-switch></div><div layout=\"row\" layout-align=\"start start\"><md-switch class=\"md-accent\" \nstyle=\"margin:5px !important\" aria-label=\"Switch No Ink\" ng-model=\"mobile.Quantity\">Quantity</md-switch></div><div \nlayout=\"row\" layout-align=\"start start\"><md-switch class=\"md-accent\" style=\"margin:5px !important\" \naria-label=\"Switch No Ink\" ng-model=\"mobile.uom\">UOM</md-switch></div><div layout=\"row\" layout-align=\"start start\">\n<md-switch class=\"md-accent\" style=\"margin:5px !important\" aria-label=\"Switch No Ink\" ng-model=\"pr.valprice\">\nValuation Price</md-switch></div><div layout=\"row\" layout-align=\"start start\"><md-switch class=\"md-accent\" \nstyle=\"margin:5px !important\" aria-label=\"Switch No Ink\" ng-model=\"mobile.total\">Total Amount</md-switch></div></div>\n<div layout=\"row\" class=\"md-padding\"><div layout=\"row\" layout-align=\"start start\"><md-switch class=\"md-accent\" \nstyle=\"margin:5px !important\" aria-label=\"Switch No Ink\" ng-model=\"mobile.order\">Order No</md-switch></div><div \nlayout=\"row\" layout-align=\"start start\"><md-switch class=\"md-accent\" style=\"margin:5px !important\" \naria-label=\"Switch No Ink\" ng-model=\"mobile.costcenter\">Cost Center</md-switch></div><div layout=\"row\" \nlayout-align=\"start start\"><md-switch class=\"md-accent\" style=\"margin:5px !important\" aria-label=\"Switch No Ink\" \nng-model=\"mobile.glaccount\">G/L Account</md-switch></div><div layout=\"row\" layout-align=\"start start\"><md-switch \nclass=\"md-accent\" style=\"margin:5px !important\" aria-label=\"Switch No Ink\" ng-model=\"mobile.functionalarea\">\nFunctional Area</md-switch></div><div layout=\"row\" layout-align=\"start start\"><md-switch class=\"md-accent\" \nstyle=\"margin:5px !important\" aria-label=\"Switch No Ink\" ng-model=\"mobile.fund\">Fund</md-switch></div><div \nlayout=\"row\" layout-align=\"start start\"><md-switch class=\"md-accent\" style=\"margin:5px !important\" \naria-label=\"Switch No Ink\" ng-model=\"mobile.date\">Delivery Date</md-switch></div></div></div></md-content></md-tab>\n</md-tabs></div></ms-widget-front></ms-widget></div></div></div>");
$templateCache.put("app/main/createform/views/custom/custom.html","<div id=\"createForm\" ng-controller=\"CustomCreateformController as ctrl\" \nclass=\"customForm page-layout carded fullwidth md-padding scrollable\" layout=\"column\" flex ms-scroll md-dynamic-height>\n<div class=\"customCreateForm\"><md-content flex layout-padding><form name=\"customForm\" novalidate><div \nclass=\"textInput\" layout=\"column\" layout-align=\"center center\"><md-input-container class=\"md-block\" style=\"width:50%\">\n<label>Name (required)</label><input name=\"formName\" ng-model=\"ctrl.custom.formName\" required><div \nng-messages=\"customForm.formName.$error\"><div ng-message=\"required\">This is required.</div></div></md-input-container>\n<md-input-container class=\"md-block\" style=\"width:50%\"><label>Description</label><input name=\"formDesc\" \nng-model=\"ctrl.custom.formDesc\"></md-input-container></div><div layout=\"row\" align=\"center\"><div flex=\"50\" \nclass=\"htmlUpload\"><md-icon md-font-icon=\"icon-box-upload\" \nng-style=\"{color: \'green\', \'font-size\':\'48px\', height:\'48px\', \'padding-right\' :\'8%\'}\"></md-icon><h1 \nclass=\"md-display-1\"><span>Upload HTML file</span></h1><div class=\"md-list-item-text\">1. Maximum file upload size is \n<span style=\"color: red\">500kB</span><br>2. The file should have a valid <span style=\"color: red\">&lt;form&gt;</span>\n with multiple input elements, i.e.</div><p class=\"md-caption\">\n&lt;input type=\"text\" name=\"GmailAddress\" style=\"color:blue;text-align:center\"></p><md-subheader class=\"md-warn\" \nng-show=\"files.length\">Uploaded files</md-subheader><div ng-repeat=\"file in files.slice(0)\"><span class=\"md-warn\">\n{{file.webkitRelativePath || file.name}}</span> (<span ng-switch=\"file.size > 1024*1024\"> <span ng-switch-when=\"true\">\n{{file.size / 1024 / 1024 | number:2}} MB</span> <span ng-switch-default>{{file.size / 1024 | number:2}} kB</span> \n</span>)</div><md-card-actions layout=\"row\" layout-align=\"center\"><input class=\"ng-hide\" id=\"formUploadFile\" \nname=\"formUploadFile\" multiple=\"multiple\" type=\"file\" type=\"submit\" \nonchange=\"angular.element(this).scope().setFile(this)\"><label for=\"formUploadFile\" ng-hide=\"files.length\" \nclass=\"md-button md-raised md-accent\">Upload</label><md-button class=\"md-accent md-raised\" type=\"submit\" \nng-disabled=\"!files.length\" ng-click=\"ctrl.uploadFile($event)\">Submit</md-button><md-button \nclass=\"md-accent md-raised\" ng-show=\"files.length\" ng-click=\"reset()\">Reset</md-button></md-card-actions></div>\n<md-divider></md-divider><div flex=\"50\"><md-icon md-font-icon=\"icon-web\" \nng-style=\"{color: \'green\', \'font-size\':\'48px\', height:\'48px\', \'padding-right\' :\'8%\'}\"></md-icon><h1 \nclass=\"md-display-1\"><span>Specify page URL</span></h1><div align=\"left\"><md-input-container class=\"md-block\" \nstyle=\"margin-left: 40px\"><label>Enter the URL here</label><input type=\"url\" name=\"formUrl\" \nng-model=\"ctrl.custom.formUrl\" ng-required=\"!files.length\" http-prefix><div ng-messages=\"customForm.formUrl.$error\">\n<div ng-message=\"required\">Please enter the web address of your preferred form.</div><div ng-message=\"url\">\nPlease enter a valid URL to proceed.</div></div></md-input-container></div><md-card-actions layout=\"row\" \nlayout-align=\"center\"><md-button class=\"md-accent md-raised\" type=\"submit\" ng-disabled=\"files.length\" \nng-click=\"customForm.$valid && ctrl.submitUrl($event)\">Submit</md-button></md-card-actions></div></div></form>\n</md-content></div></div>");
$templateCache.put("app/main/createform/views/custom/preview.html","<md-dialog><form name=\"customEditForm\" novalidate><md-dialog-content><md-tabs md-dynamic-height md-border-bottom \nmd-stretch-tabs=\"always\" md-selected=\"selectedTab\"><md-tab label=\"Basic\"><md-content class=\"md-padding\" \nstyle=\"min-width:800px\"><h1 class=\"md-display-1\">Customize input fields</h1><div layout=\"row\" \nng-repeat=\"eachInput in inputElemAll track by $index\"><md-input-container class=\"md-block\" flex=\"5\"><md-button \nclass=\"md-icon-button md-warn\" aria-label=\"Settings\"><md-icon md-font-icon=\"icon-delete\" ng-click=\"removeElem($index)\" \nng-style=\"{\'font-size\':\'36px\', height:\'36px\', \'padding-right\' :\'8%\'}\"></md-icon></md-button></md-input-container><span \nflex=\"5\"></span><md-input-container class=\"md-block\" flex=\"20\"><label>Field Name</label><input name=\"elemName\" \nng-model=\"eachInput.name\" placeholder=\"{{eachInput.name}}\"> <span \nstyle=\"color: red;font-family: \'Roboto\';font-size: 12px\" ng-show=\"getElemId(eachInput.name) != eachInput.id\">\nThe element already exists. Please choose a different name.</span></md-input-container><span flex=\"5\"></span>\n<md-input-container class=\"md-block\" flex=\"20\"><label>Field Type</label><md-select ng-model=\"eachInput.type\" \nplaceholder=\"{{eachInput.type}}\"><md-option ng-value=\"type\" ng-repeat=\"type in fieldTypes\">{{type}}</md-option>\n</md-select></md-input-container><span flex=\"5\"></span><md-input-container class=\"md-block\" flex=\"20\"><label>CSS Style\n</label><input name=\"elemStyle\" ng-model=\"eachInput.style\" placeholder=\"{{custom.style}}\"></md-input-container><span \nflex=\"5\"></span><md-input-container class=\"md-block\" flex=\"15\"><md-switch ng-model=\"eachInput.required\" \naria-label=\"Switch 1\">Required</md-switch></md-input-container></div><md-button \nclass=\"md-fab md-accent md-icon-button\" id=\"add-contact-button\" ng-click=\"addElem()\" aria-label=\"add contact\" \nstyle=\"position: fixed;bottom: 8px;right: 8px;padding: 0\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button>\n</md-content></md-tab><md-tab label=\"Positioning\" md-on-select=\"setParent()\"><md-content class=\"md-padding\" \nstyle=\"min-width:800px\"><h1 class=\"md-display-1\">Define form structure</h1><div layout=\"row\" \nng-repeat=\"eachInput in inputElemAll\"><md-input-container class=\"md-block\" flex=\"20\"><label>{{eachInput.name}}</label>\n</md-input-container><span flex=\"5\"></span><md-input-container class=\"md-block\" flex=\"25\"><label>Is a child of</label>\n<md-select ng-model=\"eachInput.position.parent\" placeholder=\"{{eachInput.position.parent}}\"><md-option ng-value=\"elem\" \nng-repeat=\"elem in parentAll\">{{elem}}</md-option></md-select><span \nstyle=\"color: red;font-family: \'Roboto\';font-size: 12px\" ng-show=\"checkParent(eachInput)\">{{parentError}}</span>\n</md-input-container><span flex=\"5\"></span><md-input-container class=\"md-block\" flex=\"20\" \nng-show=\"eachInput.position.parent==\' \'\"><label>Row</label><input type=\"number\" step=\"any\" name=\"elemRow\" \nng-model=\"eachInput.position.row\"> <span ng-show=\"isNumeric(eachInput.position.row) && eachInput.position.row < 1\" \nstyle=\"color: red;font-family: \'Roboto\';font-size: 12px\">Rows start from 1</span></md-input-container><span flex=\"5\">\n</span><md-input-container class=\"md-block\" flex=\"20\" ng-show=\"eachInput.position.parent==\' \'\"><label>Column</label>\n<input type=\"number\" step=\"any\" name=\"elemColumn\" ng-model=\"eachInput.position.column\"> <span \nng-show=\"isNumeric(eachInput.position.column) && eachInput.position.column < 1\" \nstyle=\"color: red;font-family: \'Roboto\';font-size: 12px\">Columns start from 1</span></md-input-container></div>\n</md-content></md-tab><md-tab label=\"Preview\" md-on-select=\"preview()\"><md-content class=\"md-padding\"><h1 \nclass=\"md-display-1\">Preview your changes</h1><form name=\"customPreviewForm\" novalidate><div layout=\"row\" \nlayout-align=\"start start\" ng-repeat=\"row in rowColMap\"><div layout=\"column\" layout-align=\"start start\" \nng-repeat=\"column in row\" flex-offset=\"10\"><div ng-if=\"column.position.parent == \' \'\"><div ng-switch=\"column.type\"><div\n ng-switch-when=\"text\"><md-input-container class=\"md-block\"><label>{{dynamicElemLabel(column.name,column.required)}}\n</label><input name=\"{{column.name}}\" ng-model=\"ctrl.custom.dummy\" type=\"text\" ng-required=\"column.required\" \nstyle=\"{{column.style}}\"></md-input-container></div><div ng-switch-when=\"password\"><md-input-container \nclass=\"md-block\"><label>{{dynamicElemLabel(column.name,column.required)}}</label><input name=\"{{column.name}}\" \nng-model=\"ctrl.custom.dummy\" type=\"password\" ng-required=\"column.required\" style=\"{{column.style}}\">\n</md-input-container></div><div ng-switch-when=\"url\"><md-input-container class=\"md-block\"><label>\n{{dynamicElemLabel(column.name,column.required)}}</label><input name=\"{{column.name}}\" ng-model=\"ctrl.custom.dummy\" \ntype=\"url\" ng-required=\"column.required\" style=\"{{column.style}}\"></md-input-container></div><div \nng-switch-when=\"email\"><md-input-container class=\"md-block\"><label>{{dynamicElemLabel(column.name,column.required)}}\n</label><input name=\"{{column.name}}\" ng-model=\"ctrl.custom.dummy\" type=\"email\" ng-required=\"column.required\" \nstyle=\"{{column.style}}\"></md-input-container></div><div ng-switch-when=\"number\"><md-input-container class=\"md-block\">\n<label>{{dynamicElemLabel(column.name,column.required)}}</label><input name=\"{{column.name}}\" \nng-model=\"ctrl.custom.dummy\" type=\"number\" ng-required=\"column.required\" style=\"{{column.style}}\"></md-input-container>\n</div><div ng-switch-when=\"checkbox\"><md-input-container class=\"md-block\"><md-checkbox name=\"tos\" \nng-model=\"ctrl.custom.dummy\" ng-required=\"column.required\">{{dynamicElemLabel(column.name,column.required)}}\n</md-checkbox></md-input-container></div><div ng-switch-when=\"date\"><label>\n{{dynamicElemLabel(column.name,column.required)}}</label><md-datepicker ng-model=\"ctrl.custom.dummy\"></md-datepicker>\n</div><div ng-switch-when=\"range\"><label>{{dynamicElemLabel(column.name,column.required)}}</label><md-slider-container>\n<md-slider flex=\"50\" min=\"0\" max=\"50\" ng-model=\"color.red\" aria-label=\"red\" id=\"red-slider\"></md-slider>\n<md-input-container><input flex type=\"number\" ng-model=\"color.red\" aria-label=\"red\" aria-controls=\"red-slider\">\n</md-input-container></md-slider-container></div><div ng-switch-when=\"radio\"><label>\n{{dynamicElemLabel(column.name,column.required)}}</label><md-radio-group ng-model=\"data.group1\" layout=\"row\">\n<md-radio-button value=\"Apple\">Val 1</md-radio-button><md-radio-button value=\"Banana\">Val 2</md-radio-button>\n<md-radio-button value=\"Mango\">Val 3</md-radio-button></md-radio-group></div></div></div><div layout=\"row\" \nlayout-align=\"start start\" ng-repeat=\"childElem in getChildren(column.name)\" flex-offset=\"25\"><div \nng-switch=\"childElem.type\"><div ng-switch-when=\"text\"><md-input-container class=\"md-block\"><label>\n{{dynamicElemLabel(childElem.name,childElem.required)}}</label><input name=\"{{childElem.name}}\" \nng-model=\"ctrl.custom.dummy\" type=\"text\" ng-required=\"childElem.required\" style=\"{{childElem.style}}\">\n</md-input-container></div><div ng-switch-when=\"password\"><md-input-container class=\"md-block\"><label>\n{{dynamicElemLabel(childElem.name,childElem.required)}}</label><input name=\"{{childElem.name}}\" \nng-model=\"ctrl.custom.dummy\" type=\"password\" ng-required=\"childElem.required\" style=\"{{childElem.style}}\">\n</md-input-container></div><div ng-switch-when=\"url\"><md-input-container class=\"md-block\"><label>\n{{dynamicElemLabel(childElem.name,childElem.required)}}</label><input name=\"{{childElem.name}}\" \nng-model=\"ctrl.custom.dummy\" type=\"url\" ng-required=\"childElem.required\" style=\"{{childElem.style}}\">\n</md-input-container></div><div ng-switch-when=\"email\"><md-input-container class=\"md-block\"><label>\n{{dynamicElemLabel(childElem.name,childElem.required)}}</label><input name=\"{{childElem.name}}\" \nng-model=\"ctrl.custom.dummy\" type=\"email\" ng-required=\"childElem.required\" style=\"{{childElem.style}}\">\n</md-input-container></div><div ng-switch-when=\"number\"><md-input-container class=\"md-block\"><label>\n{{dynamicElemLabel(childElem.name,childElem.required)}}</label><input name=\"{{childElem.name}}\" \nng-model=\"ctrl.custom.dummy\" type=\"number\" ng-required=\"childElem.required\" style=\"{{childElem.style}}\">\n</md-input-container></div><div ng-switch-when=\"checkbox\"><md-input-container class=\"md-block\"><md-checkbox name=\"tos\" \nng-model=\"ctrl.custom.dummy\" ng-required=\"childElem.required\">{{dynamicElemLabel(childElem.name,childElem.required)}}\n</md-checkbox></md-input-container></div><div ng-switch-when=\"date\"><label>\n{{dynamicElemLabel(childElem.name,childElem.required)}}</label><md-datepicker ng-model=\"ctrl.custom.dummy\">\n</md-datepicker></div><div ng-switch-when=\"range\"><label>{{dynamicElemLabel(childElem.name,childElem.required)}}\n</label><md-slider-container><md-slider flex=\"50\" min=\"0\" max=\"50\" ng-model=\"color.red\" aria-label=\"red\" \nid=\"red-slider\"></md-slider><md-input-container><input flex type=\"number\" ng-model=\"color.red\" aria-label=\"red\" \naria-controls=\"red-slider\"></md-input-container></md-slider-container></div><div ng-switch-when=\"radio\"><label>\n{{dynamicElemLabel(childElem.name,childElem.required)}}</label><md-radio-group ng-model=\"data.group1\" layout=\"row\">\n<md-radio-button value=\"Apple\">Val 1</md-radio-button><md-radio-button value=\"Banana\">Val 2</md-radio-button>\n<md-radio-button value=\"Mango\">Val 3</md-radio-button></md-radio-group></div></div></div></div></div></form>\n</md-content></md-tab></md-tabs></md-dialog-content><md-dialog-actions layout=\"row\"><span flex></span><md-button \nng-click=\"hide()\">Cancel</md-button><md-button ng-click=\"answer(\'useful\')\">Save</md-button></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/pages/errors/404/error-404.html","<div id=\"error-404\" layout=\"column\" layout-align=\"center center\"><div class=\"content\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"md-display-3 md-padding\" translate=\"ERROR404.CODE\">coming soon</div><div \nclass=\"message md-padding\" translate=\"ERROR404.MESSAGE\">\nIt’s not quite ready yet, but we are working hard to make it available soon.</div><div \nclass=\"search md-whiteframe-1dp\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-magnify\" \nclass=\"icon s24\"></md-icon><input ng-model=\"vm.search\" type=\"text\" placeholder=\"Search for anything\" translate \ntranslate-attr-placeholder=\"ERROR404.SEARCH\" flex></div><md-button class=\"md-raised md-accent\" ng-click=\"goHome()\">\nGo back to home page</md-button></div></div>");
$templateCache.put("app/main/pages/errors/500/error-500.html","<div id=\"error-500\" layout=\"column\" layout-align=\"center center\"><div class=\"content\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"error-code\" translate=\"ERROR500.CODE\">500</div><div class=\"message\" \ntranslate=\"ERROR500.MESSAGE\">Well, you broke the internet!</div><div class=\"sub-message\" \ntranslate=\"ERROR500.SUBMESSAGE\">Just kidding, looks like we have an internal issue, please try again in couple minutes\n</div><a class=\"report-link md-accent-color\" href=\"/\" translate=\"ERROR500.REPORT\">Report this problem</a></div></div>");
$templateCache.put("app/main/sites/site/dashboard/site.dashboard.html","<div class=\"page-layout carded fullwidth\" layout=\"row\" data-ng-init=\"siteCtrl.getCurrentSitePage()\"><div flex=\"95\" \nclass=\"md-padding\"><md-toolbar layout=\"row\" \nstyle=\"background-color: rgb(193, 201, 199); height: 20px;border-top-right-radius: 8px;border-top-left-radius: 8px\">\n<div class=\"md-toolbar-tools\"><span>{{siteDashCtrl.title}}</span></div></md-toolbar><md-content class=\"md-padding\" \nflex ng-style=\"{\'border\': \'1px solid #cccccc\'}\" class=\"scrollable\" ms-scroll ng-bind-html=\"siteDashCtrl.siteHomeText\">\n</md-content></div></div>");
$templateCache.put("app/main/sites/site/dashboard/site.logo.html","<md-dialog aria-label=\"Add site icon\"><form name=\"siteForm\" novalidate ng-submit=\"siteCtrl.createSite(site)\" flex=\"66\">\n<md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2>Select Site Logo</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content flex=\"66\" layout=\"column\" layout-align=\"center center\">\n<md-input-container class=\"md-block\" flex=\"33\"><label>Search an icon</label><input ng-model=\"searchText\">\n</md-input-container><md-radio-group ng-model=\"site.icon\" layout=\"row\" layout-align=\"center center\" layout-wrap \nflex=\"66\"><div ng-repeat=\"icon in icons | filter:{properties: {name:searchText}} | limitTo:noOfIconsForDisplay \">\n<md-radio-button value=\"icon-{{::icon.properties.name}}\" aria-label=\"icon-{{::icon.properties.name}}\"><i \nclass=\"icon icon-{{::icon.properties.name}} s40\"></i></md-radio-button></div></md-radio-group></md-dialog-content>\n<md-dialog-actions layout-align=\"center center\"><md-button ng-click=\"loadMoreIcons($event)\">Load more icons</md-button>\n<md-button ng-click=\"saveLogo(site.icon)\" class=\"md-accent md-raised\">Save</md-button></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/sites/site/discussionforum/create.thread.html","<div flex=\"30\"><md-dialog aria-label=\"Add a new user\"><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2>\nAdd New Thread</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><md-input-container class=\"md-block\"><h3><label>Enter Threadname\n</label></h3><input class=\"md-title\" type=\"text\" ng-model=\"thread.Threadname\" required></md-input-container>\n<md-input-container class=\"md-block\"><h3><label>Enter Comment</label></h3><textarea rows=\"3\"></textarea>\n</md-input-container></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"center center\"><md-button \ntype=\"button\" ng-click=\"cancel()\">Cancel</md-button><md-button type=\"submit\" ng-click=\"\">Save</md-button>\n</md-dialog-actions></md-dialog></div>");
$templateCache.put("app/main/sites/site/discussionforum/site.forum.html","<div layout=\"row\" flex=\"100\"><div flex=\"75\" layout=\"column\" ng-hide=\"commentsVisibility\"><md-content><md-list>\n<md-list-item class=\"md-3-line\" ng-repeat=\"thread in Threads | filter:searchCategory\"><img \nng-src=\"assets\\images\\avatars/Nora.jpg\" class=\"md-avatar\"><div class=\"md-list-item-text md-padding\" layout=\"column\" \nng-click=\"openthread(thread)\"><span class=\"md-body-2 md-primary-fg\">{{thread.Threadname}}</span><h3 \nclass=\"md-headline\"><span class=\"text-boxed orange-bg white-fg\" flex=\"5\">{{thread.Creator}} </span><span \nclass=\"text-boxed green-bg white-fg\" flex=\"5\">{{thread.Category}}</span></h3><p>Last Comment by {{thread.Creator}}</p>\n</div><span class=\"md-primary-fg md-hue-3 md-secondary md-subhead\"><md-icon md-font-icon=\"icon-comment-text-outline\" \nclass=\"md-accent-fg\" ng-style=\"{\'font-size\': \'32px\'}\"></md-icon><span>&nbsp;</span> {{thread.Comments.length}}\n<md-tooltip md-direction=\"top\">Comments</md-tooltip></span><md-divider md-inset ng-if=\"!$last\"></md-divider>\n</md-list-item></md-list></md-content></div><div flex=\"75\" ng-show=\"commentsVisibility\"><md-content><md-list>\n<md-list-item class=\"md-3-line\" ng-repeat=\" eachComment in selectedThread.Comments\"><img \nng-src=\"assets\\images\\avatars/Nora.jpg\" class=\"md-avatar\"><div class=\"md-list-item-text md-padding\" layout=\"column\">\n<span class=\"md-primary-fg md-body-2\">{{eachComment.Commenter}}</span><p>{{\'Commented On \' + eachComment.Commentedon}}\n</p><br><span>{{eachComment.Comment}}</span></div><md-divider md-inset ng-if=\"!$last\"></md-divider></md-list-item>\n</md-list></md-content><div align=\"center\"><div layout=\"row\" layout-align=\"center center\"><span class=\"md-title\">\nEnter comment </span><span flex=\"5\"></span><md-input-container class=\"md-block\" flex=\"60\"><textarea rows=\"4\" \nng-model=\"userComment\" style=\"border: 1px solid; background-color: honeydew\" md-no-autogrow md-maxlength=\"200\">\n</textarea></md-input-container></div><md-button ng-click=\"null\" class=\"md-accent\">save</md-button><md-button \nng-click=\"commentsVisibility=false\" class=\"md-raised\">Go back</md-button></div></div><md-divider></md-divider><div \nflex=\"25\"><div layout=\"column\" layout-padding><md-input-container><label class=\"h3\">Search discussions here</label>\n<md-icon md-font-icon=\"icon-magnify\" class=\"s32\"></md-icon><input ng-model=\"user.name\" type=\"text\">\n</md-input-container><p class=\"md-headline text-bold border-bottom\">Categories</p><div align=\"center\" \nclass=\"md-border-bottom\" flex=\"10\"><span ng-repeat=\"thread in Threads\"><span \nclass=\"md-title {{siteForumCtrl.getAnotherColor($index)}}-fg md-padding\" ng-click=\"opencategory(thread.Category)\">\n#{{thread.Category}} </span><span>&nbsp;</span></span></div><span class=\"md-title md-primary\" \nng-click=\"opencategory(\'\')\" align=\"center\">#ALL</span></div></div><md-button flow-btn \nclass=\"md-fab md-accent md-fab-bottom-right\" ng-click=\"createThreadDialog($event)\"><md-icon md-font-icon=\"icon-plus\">\n</md-icon><md-tooltip md-direction=\"top\">Add Thread</md-tooltip></md-button></div>");
$templateCache.put("app/main/sites/site/doclibraryForm/doclibraryForm.html","<div class=\"page-layout carded fullwidth scrollable\" layout=\"column\" flex ms-scroll md-dynamic-height><div \nclass=\"widget-group\" flex=\"100\" layout=\"column\" layout-wrap><ms-widget flippable=\"true\" layout=\"row\"><ms-widget-front \nclass=\"white-bg\"><div layout=\"row\"><div ng-cloak flex=\"100\" class=\"scrollable\" ms-scroll><md-content><md-tabs \nmd-dynamic-height md-border-bottom><md-tab label=\"Main\"><md-content class=\"md-padding scrollable\" ms-scroll><div \nlayout=\"row\" layout-align=\"center center\"><div flex=\"70\"><form name=\"headerForm\" class=\"md-inline-form\" novalidate>\n<fieldset ng-disabled=\"true\" style=\"border: 1px solid #cccccc\"><div ng-bind-html=\"currentFormHeader\" compile-template>\n</div></fieldset></form></div></div></md-content></md-tab><md-tab label=\"Details\"><md-content class=\"md-padding\"><div \nlayout=\"row\" layout-align=\"center center\"><div flex=\"100\"><form name=\"lineitemForm\" novalidate><fieldset \nstyle=\"border: 1px solid #cccccc\" ng-disabled=\"true\"><div ng-bind-html=\"currentFormLineitem\" compile-template></div>\n</fieldset><div layout=\"row\" layout-align=\"center center\" class=\"md-padding\"><md-button class=\"md-raised\" \nng-click=\"docLibraryFormCtrl.gotoBack()\">Back</md-button></div></form></div></div></md-content></md-tab></md-tabs>\n</md-content></div></div></ms-widget-front></ms-widget></div></div>");
$templateCache.put("app/main/sites/site/home/site.home.html","<style>\n.card-para {\n        margin: 0 0 10px;\n        padding: 15px !important;\n        font-size: 13px;\n        font-family: \"Helvetica Neue\", Helvetica, Arial, Roboto, sans-serif, sans-serif;\n        line-height: 1.53846154;\n    }\n    \n    .pt-b {\n        border: 1px solid #eeeeee;\n    }\n    \n    .panel-heading {\n        padding: 15px;\n    }\n    \n    .panel-body {\n        padding: 15px;\n    }\n    \n    .panel-controls {\n        float: right;\n    }\n    table.simple-row tbody tr td {\n    padding: 14px 8px;\n    border-bottom: 0px !important;\n   \n    }   \n    .highcharts-legend{\n    display:none;}\n</style><div id=\"documnets\" class=\"page-layout simple right-sidenav\" \nstyle=\"height:90% !important; min-height:90% !important\"><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap \nng-init=\"getSiteDetails()\"><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap \nng-init=\"siteHomeCtrl.getHomePage()\"></div></div><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap>\n<ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"33\"><ms-widget-front \nclass=\"white-bg\"><div layout=\"row\" class=\"md-padding\"><div flex=\"55\"><div layout=\"row\" layout-align=\"start center\"><h4>\n<b style=\"font-size:15px\">Invoices to be Approved</b></h4></div></div><div flex=\"45\"><div layout=\"row\" \nlayout-align=\"end end\"><b style=\"color:rgb(37, 141, 232); font-size: 20px;padding-top:15px\">32</b></div></div></div>\n</ms-widget-front></ms-widget><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"33\">\n<ms-widget-front class=\"white-bg\"><div layout=\"row\" class=\"md-padding\"><div flex=\"55\"><div layout=\"row\" \nlayout-align=\"start center\"><h4><b style=\"font-size:15px\">Total of Invoices</b></h4></div></div><div flex=\"45\"><div \nlayout=\"row\" layout-align=\"end end\"><b style=\"color:rgb(8, 178, 82); font-size: 20px;padding-top:15px\">4,275,150.25 USD\n</b></div></div></div></ms-widget-front></ms-widget><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" \nflex-gt-xs=\"50\" flex-gt-md=\"33\"><ms-widget-front class=\"white-bg\"><div layout=\"row\" class=\"md-padding\" \nstyle=\"margin:-2%\"><div flex=\"45\"><div layout=\"row\" layout-align=\"start center\"><h4><b style=\"font-size:15px\">\nRequested Invoices </b></h4></div></div><div flex=\"55\"><div layout=\"row\" layout-align=\"end end\"><b \nstyle=\"color:rgb(8, 178, 82); font-size: 20px;padding-top:15px\">18</b></div></div></div></ms-widget-front></ms-widget>\n</div><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget layout=\"column\" flex=\"100\" \nflex-gt-xs=\"50\" flex-gt-md=\"33\"><ms-widget-front class=\"white-bg h-430\"><md-toolbar layout=\"row\" \nclass=\"white-bg md-primary-fg border-bottom\"><div class=\"md-toolbar-tools\"><span class=\"h2\" \nstyle=\"color: #0695cd !important\"><md-icon class=\"icon black-fg\" md-font-icon=\"icon-menu\"></md-icon>Latest Documents\n</span></div></md-toolbar><md-content class=\"scrollable\" ms-scroll><table class=\"simple\"><thead><tr><th \nstyle=\"min-width: 10px\"></th><th>Name</th><th>Owner</th></tr></thead><tbody><tr \nng-repeat=\"document in homepageList.latestDocuments\"><td class=\"file-icon\"><md-icon \nmd-font-icon=\"{{overCtrl.fileIcon(document)}}\" class=\"icon md-accent\"></md-icon></td><td style=\"color: #3686eb\" \nclass=\"h4\">{{document.name}}</td><td>{{document.createdBy}}</td></tr></tbody></table></md-content></ms-widget-front>\n</ms-widget><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"33\"><ms-widget-front \nclass=\"white-bg h-430\"><md-toolbar layout=\"row\" class=\"white-bg md-primary-fg border-bottom\"><div \nclass=\"md-toolbar-tools\"><span class=\"h2\" style=\"color: #0695cd !important\"><md-icon class=\"icon black-fg\" \nmd-font-icon=\"icon-menu\"></md-icon>Latest Activities</span></div></md-toolbar><md-content class=\"scrollable\" ms-scroll>\n<md-list><md-list-item ng-repeat=\"activity in homepageList.latestActivities\"><p ng-bind-html=\"activity.description\">\n</p></md-list-item></md-list></md-content></ms-widget-front></ms-widget><ms-widget flippable=\"true\" layout=\"column\" \nflex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"33\"><ms-widget-front class=\"white-bg h-430\"><md-toolbar layout=\"row\" \nclass=\"white-bg md-primary-fg border-bottom\"><div class=\"md-toolbar-tools\"><span class=\"h2\" \nstyle=\"color: #0695cd !important\"><md-icon class=\"icon black-fg\" md-font-icon=\"icon-menu\"></md-icon>Quick Links</span>\n</div></md-toolbar><md-content class=\"scrollable portlets p-10\" ms-scroll><span \nng-if=\"systemDetails.dashboardportlets.quicklinks\" ng-bind-html=\"systemDetails.dashboardportlets.quicklinks\"></span> \n<span ng-if=\"!systemDetails.dashboardportlets.quicklinks\" class=\"h2\" layout=\"column\" layout-align=\"center center\" \nstyle=\"padding-top: 150px !important\">Not yet designed. You can design from Quicklinks Portlet in Admin Settings.\n</span></md-content></ms-widget-front></ms-widget></div></div>");
$templateCache.put("app/main/sites/site/members/site.addMemberDialog.html","<md-dialog ng-cloak><form name=\"siteMembersCtrl.memberForm\" role=\"form\" novalidate ng-submit=\" \"><md-toolbar \nlayout=\"row\" class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2>Add {{memberRole}}</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"close()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content layout=\"column\" layout-align=\"center center\"><div layout=\"row\" class=\"md-padding\">\n<md-input-container class=\"md-block\" flex=\"45\"><input type=\"text\" name=\"name\" ng-model=\"member.name\" \nplaceholder=\"Name\"></md-input-container><span flex=\"10\"></span><md-input-container class=\"md-block\" flex=\"45\"><input \ntype=\"text\" name=\"email\" ng-model=\"member.email\" placeholder=\"Email\"></md-input-container></div><div layout=\"row\" \nng-style=\"{\'color\':\'red\',\'font-family\':\'Roboto\',\'font-size\':\'12px\'}\" ng-show=\"msgVisibility\">\nPlease enter either name or email</div><div class=\"md-padding\"><md-button type=\"button\" class=\"md-raised\" \nng-click=\"searchMember(member)\"><md-icon md-font-icon=\"icon-magnify\"></md-icon>Search user</md-button></div><div \nng-show=\"tableVisibility\" class=\"md-padding scrollable\" ms-scroll><table><thead><tr><th \nclass=\"secondary-text md-padding\"><div class=\"table-header\"><span class=\"column-title\">NAME</span></div></th><th \nclass=\"secondary-text md-padding\"><div class=\"table-header\"><span class=\"column-title\">EMAIL</span></div></th></tr>\n</thead><tbody><tr ng-repeat=\"member in searchedMembers\"><td class=\"md-padding\">\n{{member.firstName}} {{member.lastName}}</td><td class=\"md-padding\">{{member.email}}</td><td layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-accent md-raised\" ng-click=\"addMember(member) \">ADD</md-button></td>\n</tr></tbody></table></div></md-dialog-content></form><md-dialog-actions layout=\"row\"><span flex></span><md-button \nng-click=\"cancel(member)\">Cancel</md-button><md-button ng-click=\"ok()\" md-autofocus>Ok</md-button></md-dialog-actions>\n</md-dialog>");
$templateCache.put("app/main/sites/site/members/site.members.html","<div class=\"page-layout carded fullwidth\" layout=\"row\" flex=\"100\" layout-wrap><div layout=\"column\" flex=\"100\" \nflex-gt-xs=\"50\" flex-gt-md=\"35\" ng-repeat=\"role in roles\" class=\"md-padding\"><md-toolbar layout=\"row\" \nclass=\"md-accent\"><div class=\"md-toolbar-tools\"><span>{{role}}</span></div><div><md-button flow-btn \nclass=\"md-fab grey-700-bg md-mini md-fab-top-right\" ng-click=\"siteMembersCtrl.addMemberDialog($event,role)\" \nng-hide=\"hide\"><md-icon md-font-icon=\"icon-plus\"></md-icon><md-tooltip md-direction=\"top\">Add Member</md-tooltip>\n</md-button></div></md-toolbar><md-content flex ng-style=\"{\'border\': \'1px solid #cccccc\'}\" class=\"scrollable\" \nms-scroll><div ng-switch=\"(siteMembersCtrl.members | filter:{roleId:role}).length\"><div ng-switch-when=\"0\" \nlayout=\"row\" layout-align=\"center center\"><p class=\"md-padding md-subhead md-primary-fg\">\n{{\'No member yet...\' | uppercase}}</p></div><div ng-switch-default ng-style=\"{\'height\':\'280px\'}\" flex=\"100\"><md-list>\n<md-list-item class=\"md-2-line\" ng-repeat=\"eachMember in siteMembersCtrl.members | filter: role\" ng-click=\"null\"><img \nng-src=\"assets\\images\\avatars/Nora.jpg\" class=\"md-avatar\"><div class=\"md-list-item-text\" layout=\"column\"><h3>\n{{ eachMember.firstName }} {{ eachMember.lastName }}</h3><p>{{ eachMember.email }}</p><span flex=\"10\"></span><md-button\n class=\"md-secondary md-icon-button\" ng-click=\"siteMembersCtrl.deleteMember($event, role, eachMember)\" ng-hide=\"hide\">\n<md-tooltip md-direction=\"top\">Delete</md-tooltip><md-icon><i class=\"icon icon-delete s30\"></i></md-icon></md-button>\n</div><md-divider></md-divider></md-list-item></md-list></div></div></md-content></div></div>");
$templateCache.put("app/main/sites/site/sitesettings/site.addDocumentDialog.html","<md-dialog ng-cloak flex=\"35\" ng-init=\"getDocumentTypes()\"><form name=\"siteMembersCtrl.memberForm\" role=\"form\" \nnovalidate><md-toolbar layout=\"row\" class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2>Add Document Type</h2><span \nflex></span><md-button class=\"md-icon-button\" ng-click=\"close()\"><md-icon md-font-icon=\"icon-close\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><div layout=\"row\"><div flex=\"45\" layout=\"row\" \nlayout-align=\"center center\"><span class=\"h3\"><b>Document Type </b></span></div><span flex=\"5\"></span>\n<md-input-container class=\"md-block\" flex=\"35\" style=\"padding-top: 0px !important;padding-bottom: 0px !important\">\n<md-select ng-model=\"documentType\"><md-option ng-repeat=\"documentType in documentsList\" ng-value=\"documentType.name\" \nng-click=\"selectDocumentType(documentType)\">{{documentType.name}}</md-option></md-select></md-input-container></div>\n</md-dialog-content></form><md-dialog-actions layout=\"row\"><span flex></span><md-button ng-click=\"cancel()\">Cancel\n</md-button><md-button ng-click=\"\" md-autofocus>Ok</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/sites/site/sitesettings/sitesettings.html","<div ng-init=\"getSite();\"><md-tabs md-dynamic-height md-border-bottom><md-tab label=\"General Settings\"><md-content \nclass=\"md-padding scrollable\" ms-scroll><div><form name=\"userForm\"><label>Portlet 1</label><text-angular \nng-model=\"home.overview\"></text-angular></form></div><div><form name=\"siteHome\"><label>Portlet 2</label><text-angular \nng-model=\"home.support\"></text-angular></form></div></md-content><md-dialog-actions layout=\"row\"><span flex></span>\n<md-button ng-click=\"clear()\" class=\"md-raised\">Cancel</md-button><md-button ng-click=\"save(\'site-2\',home)\" \nclass=\"md-raised\">Save</md-button></md-dialog-actions></md-tab><md-tab label=\"Manage {{sitedisplayname}}\"><md-content>\n<form name=\"siteSetting\" novalidate><div layout=\"row\"><div flex=\"35\" layout=\"column\" layout-align=\"center end\"><span \nclass=\"h3\"><b>{{sitedisplayname}} Name </b></span></div><span flex=\"10\"></span><md-input-container flex=\"15\" \nclass=\"md-block\" layout=\"column\" layout-align=\"space-around start\"><input type=\"text\" name=\"name\" ng-disabled=\"Edit\" \nng-model=\"site.name\"></md-input-container></div><div layout=\"row\"><div flex=\"35\" layout=\"column\" \nlayout-align=\"center end\"><span class=\"h3\"><b>{{sitedisplayname}} Url</b></span></div><span flex=\"10\"></span>\n<md-input-container flex=\"15\" class=\"md-block\" layout=\"column\" layout-align=\"space-around start\" \nstyle=\"padding-top: 0px !important;padding-bottom: 0px !important\"><input type=\"text\" name=\"name\" ng-disabled=\"Edit\" \nng-model=\"site.url\"></md-input-container></div><div layout=\"row\"><div flex=\"35\" layout=\"column\" \nlayout-align=\"center end\"><span class=\"h3\"><b>{{sitedisplayname}} Description </b></span></div><span flex=\"10\"></span>\n<md-input-container flex=\"15\" class=\"md-block\" layout=\"column\" layout-align=\"space-around start\" \nstyle=\"padding-top: 0px !important;padding-bottom: 0px !important\"><input type=\"text\" name=\"name\" ng-disabled=\"Edit\" \nng-model=\"site.description\"></md-input-container></div><div layout=\"row\"><div flex=\"35\" layout=\"column\" \nlayout-align=\"center end\"><span class=\"h3\"><b>{{sitedisplayname}} Title </b></span></div><span flex=\"10\"></span>\n<md-input-container flex=\"15\" class=\"md-block\" layout=\"column\" layout-align=\"space-around start\" \nstyle=\"padding-top: 0px !important;padding-bottom: 0px !important\"><input type=\"text\" name=\"name\" ng-disabled=\"Edit\" \nng-model=\"site.title\"></md-input-container></div><div layout=\"row\"><div flex=\"35\" layout=\"column\" \nlayout-align=\"center end\"><span class=\"h3\"><b>{{sitedisplayname}} Logo </b></span></div><span flex=\"10\"></span>\n<md-button ng-click=\"openIconList()\" class=\"md-accent md-raised\" ng-disabled=\"Edit\">select {{sitedisplayname}} logo\n</md-button></div><div layout=\"row\"><span flex></span><md-button ng-click=\"sitesettingCtrl.editMode()\" \nng-hide=\"editButton\" class=\"md-accent\">Edit</md-button><md-button ng-click=\"sitesettingCtrl.deleteSite()\" \nng-hide=\"editButton\" class=\"md-warn\">Delete</md-button><md-button ng-click=\"Updatesite(site)\" ng-show=\"editButton\">Save\n</md-button><md-button ng-click=\"sitesettingCtrl.Cancel()\" ng-show=\"editButton\">Cancel</md-button></div></form>\n</md-content></md-tab><md-tab label=\"Manage Permissions\"><md-content class=\"md-padding scrollable\" ms-scroll><div \nflex=\"80\" ng-style=\"{\'border\': \'1px solid #cccccc\'}\" class=\"scrollable\" ms-scroll layout=\"row\" \nlayout-align=\"center center\"><div ng-switch=\"(allUsersForPermission).length\" \nng-style=\"{\'border\': \'1px solid #cccccc\'}\"><div ng-switch-when=\"0\" layout=\"row\" layout-align=\"center center\"><p \nclass=\"md-padding md-subhead md-primary-fg\">{{\'No data yet...\' | uppercase}}</p></div><div ng-switch-default \nng-style=\"{\'height\':\'190px\', \'overflow\': \'auto\'}\"><table class=\"simple list-view\"><thead><tr><th>NAME</th><th>View</th>\n<th>Edit</th><th>Permission</th><th>Delete</th><th>Download</th><th></th></tr></thead><tbody><tr \nng-repeat=\"user in allUsersForPermission\"><td data-ng-if=\"user.type == \'Group\'\"><i class=\"fa fa-users\" \naria-hidden=\"true\"></i> {{user.firstName}}</td><td data-ng-if=\"user.type == \'User\'\"><i class=\"fa fa-user\" \naria-hidden=\"true\"></i> {{user.firstName}} {{user.lastName}}</td><td data-ng-if=\"user.type == \'SiteAdmin\'\"><i \nclass=\"fa fa-user-circle-o\" aria-hidden=\"true\"></i> SiteAdmin</td><td data-ng-if=\"user.type == \'Owner\'\"><i \nclass=\"fa fa-user-circle\" aria-hidden=\"true\"></i> Owner</td><td><i class=\"icon-checkbox-marked-circle green-500-fg\" \nng-show=\"{{user.permissions.indexOf(\'View\')!==-1}}\"></i> <i class=\"icon-cancel red-500-fg\" \nng-show=\"{{ user.permissions.indexOf(\'View\')==-1}}\"></i></td><td><i class=\"icon-checkbox-marked-circle green-500-fg\" \nng-show=\"{{user.permissions.indexOf(\'Edit\')!==-1}}\"></i> <i class=\"icon-cancel red-500-fg\" \nng-show=\"{{ user.permissions.indexOf(\'Edit\')==-1}}\"></i></td><td><i class=\"icon-checkbox-marked-circle green-500-fg\" \nng-show=\"{{user.permissions.indexOf(\'Permission\')!==-1}}\"></i> <i class=\"icon-cancel red-500-fg\" \nng-show=\"{{ user.permissions.indexOf(\'Permission\')==-1}}\"></i></td><td><i \nclass=\"icon-checkbox-marked-circle green-500-fg\" ng-show=\"{{user.permissions.indexOf(\'Delete\')!==-1}}\"></i> <i \nclass=\"icon-cancel red-500-fg\" ng-show=\"{{ user.permissions.indexOf(\'Delete\')==-1}}\"></i></td><td><i \nclass=\"icon-checkbox-marked-circle green-500-fg\" ng-show=\"{{user.permissions.indexOf(\'Download\')!==-1}}\"></i> <i \nclass=\"icon-cancel red-500-fg\" ng-show=\"{{ user.permissions.indexOf(\'Download\')==-1}}\"></i></td><td class=\"no-padding\">\n<md-button data-ng-hide=\"user.type == \'SiteAdmin\' || user.type == \'Owner\'\" class=\"md-secondary md-icon-button\" \nng-click=\"removePermission(user)\"><md-tooltip md-direction=\"top\">Delete</md-tooltip><md-icon><i \nclass=\"icon icon-delete s20\"></i></md-icon></md-button></td></tr></tbody></table></div></div></div><div \nclass=\"scrollable md-padding\" ms-scroll><div layout=\"row\" class=\"md-padding pl-0\"><md-radio-group \nng-model=\"searchElements.type\" style=\"display: -webkit-inline-box\" \nng-change=\"onChangePermissionType(searchElements.type)\"><md-radio-button class=\"pr-15\" value=\"User\">User\n</md-radio-button><md-radio-button class=\"pr-15\" value=\"Group\">Group</md-radio-button><md-radio-button class=\"pr-15\" \nvalue=\"Owner\">Owner</md-radio-button><md-radio-button value=\"SiteAdmin\">SiteAdmin</md-radio-button></md-radio-group>\n</div><div layout=\"row\" data-ng-if=\"searchElements.type ==\'User\' || searchElements.type ==\'Group\'\"><md-input-container \nclass=\"no-padding no-margin\" flex=\"40\"><input type=\"text\" name=\"name\" ng-model=\"searchElements.text\" \nplaceholder=\"Search Here\"></md-input-container><md-button class=\"md-raised\" \nng-disabled=\"searchElements.text == undefined\" ng-click=\"searchUsersForManagePermission(searchElements)\" \nstyle=\"height: 35px;top: -11px\">Search</md-button></div></div><div><table class=\"simple\" \nng-show=\"searchElements.type ==\'Owner\'|| searchElements.type ==\'SiteAdmin\'\"><thead><tr><th \nclass=\"secondary-text md-padding\"><span class=\"column-title\">NAME</span></th><th class=\"secondary-text md-padding\">View\n</th><th class=\"secondary-text md-padding\">Edit</th><th class=\"secondary-text md-padding\">Permission</th><th \nclass=\"secondary-text md-padding\">Delete</th><th class=\"secondary-text md-padding\">Download</th><th></th></tr></thead>\n<tbody><tr><td class=\"no-padding\" data-ng-if=\"searchElements.type ==\'Owner\'\" \nstyle=\"padding-left: 10px !important;padding-right: 10px !important\">Owner</td><td class=\"no-padding\" \ndata-ng-if=\"searchElements.type ==\'SiteAdmin\'\" style=\"padding-left: 10px !important;padding-right: 10px !important\">\nSiteAdmin</td><td class=\"no-padding\" \nstyle=\"padding-left: 10px !important;padding-right: 10px !important;padding-top: 12px !important\"><md-checkbox \nvalue=\"view\" ng-model=\"ownerStatus.View\"></md-checkbox></td><td class=\"no-padding\" \nstyle=\"padding-left: 10px !important;padding-right: 10px !important;padding-top: 12px !important\"><md-checkbox \nvalue=\"edit\" ng-model=\"ownerStatus.Edit\"></md-checkbox></td><td class=\"no-padding\" \nstyle=\"padding-left: 10px !important;padding-right: 10px !important;padding-top: 12px !important\"><md-checkbox \nvalue=\"permission\" ng-model=\"ownerStatus.Permission\"></md-checkbox></td><td class=\"no-padding\" \nstyle=\"padding-left: 10px !important;padding-right: 10px !important;padding-top: 12px !important\"><md-checkbox \nvalue=\"delete\" ng-model=\"ownerStatus.Delete\"></md-checkbox></td><td class=\"no-padding\" \nstyle=\"padding-left: 10px !important;padding-right: 10px !important;padding-top: 12px !important\"><md-checkbox \nvalue=\"download\" ng-model=\"ownerStatus.Download\"></md-checkbox></td><td class=\"no-padding\"><md-button \nclass=\"md-accent md-raised md-mini\" ng-click=\"addUserForManagePermission(null,ownerStatus,searchElements.type)\">ADD\n</md-button></td></tr></tbody></table></div><div class=\"scrollable md-padding pt-0\" ms-scroll \ndata-ng-if=\"searchElements.type ==\'User\' || searchElements.type ==\'Group\'\"><table class=\"simple\" \nng-show=\"searchedUsers.data.length > 0\"><thead><tr><th class=\"secondary-text md-padding\"><span class=\"column-title\">\nNAME</span></th><th class=\"secondary-text md-padding\" data-ng-if=\"searchedUsers.type == \'User\'\"><span \nclass=\"column-title\">EMAIL</span></th><th class=\"secondary-text md-padding\">View</th><th \nclass=\"secondary-text md-padding\">Edit</th><th class=\"secondary-text md-padding\">Permission</th><th \nclass=\"secondary-text md-padding\">Delete</th><th class=\"secondary-text md-padding\">Download</th><th></th></tr></thead>\n<tbody><tr data-ng-repeat=\"(key,value) in searchedUsers.data track by $index\" ng-init=\"status = {}\"><td \nclass=\"no-padding\" data-ng-if=\"searchedUsers.type == \'User\'\" \nstyle=\"padding-left: 10px !important;padding-right: 10px !important\">{{value.firstName}} {{value.lastName}}</td><td \nclass=\"no-padding\" data-ng-if=\"searchedUsers.type == \'User\'\" \nstyle=\"padding-left: 10px !important;padding-right: 10px !important\">{{value.email}}</td><td class=\"no-padding\" \ndata-ng-if=\"searchedUsers.type == \'Group\'\" style=\"padding-left: 10px !important;padding-right: 10px !important\">\n{{value.name}}</td><td class=\"no-padding\" \nstyle=\"padding-left: 10px !important;padding-right: 10px !important;padding-top: 12px !important\"><md-checkbox \nvalue=\"view\" ng-model=\"status.View\"></md-checkbox></td><td class=\"no-padding\" \nstyle=\"padding-left: 10px !important;padding-right: 10px !important;padding-top: 12px !important\"><md-checkbox \nvalue=\"edit\" ng-model=\"status.Edit\"></md-checkbox></td><td class=\"no-padding\" \nstyle=\"padding-left: 10px !important;padding-right: 10px !important;padding-top: 12px !important\"><md-checkbox \nvalue=\"permission\" ng-model=\"status.Permission\"></md-checkbox></td><td class=\"no-padding\" \nstyle=\"padding-left: 10px !important;padding-right: 10px !important;padding-top: 12px !important\"><md-checkbox \nvalue=\"delete\" ng-model=\"status.Delete\"></md-checkbox></td><td class=\"no-padding\" \nstyle=\"padding-left: 10px !important;padding-right: 10px !important;padding-top: 12px !important\"><md-checkbox \nvalue=\"download\" ng-model=\"status.Download\"></md-checkbox></td><td class=\"no-padding\"><md-button \nclass=\"md-accent md-raised md-mini\" ng-click=\"addUserForManagePermission(value, status, searchedUsers.type) \">ADD\n</md-button></td></tr></tbody></table></div><div layout=\"row\"><span flex></span><md-button \nng-click=\"saveUserManagePermission()\" md-autofocus>Save</md-button></div></md-content></md-tab><md-tab \nlabel=\"Folder Settings\"><md-content class=\"md-padding\"><div layout=\"column\" layout-align=\"center center\" \nclass=\"md-pdding\"><md-checkbox ng-model=\"file.foldersOnly\" aria-label=\"folder\">Allow only Folders</md-checkbox>\n<md-button class=\"md-accent md-raised md-mini\" ng-click=\"updateFolderSettings()\">Ok</md-button></div></md-content>\n</md-tab></md-tabs></div>");
$templateCache.put("app/main/sites/site/doclibrary/VersionFiledialog.html","<md-dialog><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2>Add new version : {{selectedFileName}}</h2>\n<span flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><form name=\"doclibrary\" novalidate layout=\"column\"><div layout=\"row\">\n<div flex=\"45\" layout=\"column\" layout-align=\"center end\"><span class=\"h3\"><b>Upload File</b></span></div><span \nflex=\"10\"></span><div flex=\"45\" layout=\"column\" layout-align=\"center start\"><input class=\"ng-hide\" id=\"formUploadFile\" \nname=\"formUploadFile\" type=\"file\" onchange=\"angular.element(this).scope().setFile(this)\"><label for=\"formUploadFile\" \nclass=\"md-button md-raised md-accent\">Upload</label></div></div><div><div ng-repeat=\"file in files.slice(0)\" \nlayout=\"row\" layout-align=\"center center\"><span class=\"md-warn\">{{file.webkitRelativePath || file.name}}</span> (<span \nng-switch=\"file.size > 1024*1024\"> <span ng-switch-when=\"true\">{{file.size / 1024 / 1024 | number:2}} MB</span> <span \nng-switch-default>{{file.size / 1024 | number:2}} kB</span> </span>)</div></div></form></md-dialog-content>\n<md-dialog-actions layout=\"row\"><span flex></span><md-button ng-click=\"cancel()\">Cancel</md-button><md-button \nng-click=\"NewVersionFile()\">Save</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/sites/site/doclibrary/checkInFiledialog.html","<md-dialog><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2>\nCheckIn {{checkInFile.type}} : {{checkInFile.name}}</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"cancel()\"><md-icon md-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><form name=\"doclibrary\" \nnovalidate layout=\"column\"><div layout=\"row\"><div flex=\"45\" layout=\"column\" layout-align=\"center end\"><span class=\"h3\">\n<b>Upload File</b></span></div><span flex=\"10\"></span><div flex=\"45\" layout=\"column\" layout-align=\"center start\"><input\n class=\"ng-hide\" id=\"formUploadFile\" name=\"formUploadFile\" type=\"file\" \nonchange=\"angular.element(this).scope().setFile(this)\"><label for=\"formUploadFile\" \nclass=\"md-button md-raised md-accent\">Upload</label></div></div><div><div ng-repeat=\"file in files.slice(0)\" \nlayout=\"row\" layout-align=\"center center\"><span class=\"md-warn\">{{file.webkitRelativePath || file.name}}</span> (<span \nng-switch=\"file.size > 1024*1024\"> <span ng-switch-when=\"true\">{{file.size / 1024 / 1024 | number:2}} MB</span> <span \nng-switch-default>{{file.size / 1024 | number:2}} kB</span> </span>)</div></div></form></md-dialog-content>\n<md-dialog-actions layout=\"row\"><span flex></span><md-button ng-click=\"cancel()\">Cancel</md-button><md-button \nng-click=\"checkIn()\">Save</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/sites/site/doclibrary/details-sidenav.html","<div flex=\"100\" layout=\"column\" ng-show=\"detailsVisibility\" class=\"scrollable\" ms-scroll><div layout=\"row\" \nlayout-align=\"center center\"><span class=\"md-title md-padding\">{{siteDocLibCtrl.selectedFileName}}</span></div><div \nlayout=\"row\" layout-align=\"center center\"><md-button class=\"md-icon-button\" ng-click=\"UpdateFile($event)\" \nng-disabled=\"checkout\"><md-tooltip md-direction=\"top\">Edit</md-tooltip><md-icon md-font-icon=\"icon-pencil\" \nstyle=\"color:#ffc107 ! important\"></md-icon></md-button><md-button class=\"md-icon-button\" \nng-if=\"siteDocLibCtrl.receivedFile.type != \'folder\'\" ng-click=\"checkInFileDialog($event)\"><md-tooltip \nmd-direction=\"top\">Check in</md-tooltip><md-icon md-font-icon=\"icon-login\" style=\"color:#0e76e2 ! important\"></md-icon>\n</md-button><md-button class=\"md-icon-button\" ng-if=\"siteDocLibCtrl.receivedFile.type != \'folder\'\" \nng-click=\"fileCheckout()\"><md-tooltip md-direction=\"top\">Check out</md-tooltip><md-icon md-font-icon=\"icon-logout\" \nstyle=\"color:#ff8080 ! important\"></md-icon></md-button><md-button class=\"md-icon-button\" \nng-if=\"siteDocLibCtrl.receivedFile.type != \'folder\'\" ng-click=\"downloadFile()\" ng-disabled=\"checkout\"><md-tooltip \nmd-direction=\"top\">Download</md-tooltip><md-icon md-font-icon=\"icon-download\" style=\"color:#2ecc71 ! important\">\n</md-icon></md-button><md-button class=\"md-icon-button\" ng-click=\"siteDocLibCtrl.deleteFile(ev)\" \nng-disabled=\"checkout\"><md-tooltip md-direction=\"top\">Delete</md-tooltip><md-icon md-font-icon=\"icon-delete\" \nstyle=\"color:#ff6656 ! important\"></md-icon></md-button></div><div><md-content ng-cloak><md-tabs md-dynamic-height \nmd-center-tabs md-border-bottom><md-tab label=\"Details\"><div class=\"auto-height scrollable\" ms-scroll><md-content \nclass=\"md-padding scrollable\" ms-scroll><div align=\"right\"><md-button flow-btn class=\"md-icon-button\" \nng-click=\"enableEditor()\" ng-hide=\"editorEnabled\" ng-if=\"siteDocLibCtrl.receivedFile.type != \'folder\'\"><md-icon \nmd-font-icon=\"icon-pencil\" style=\"color:#ffc107! important\"></md-icon><md-tooltip md-direction=\"top\">Edit Attributes\n</md-tooltip></md-button><md-button flow-btn class=\"md-icon-button\" ng-click=\"saveAllAttributes()\" \nng-show=\"editorEnabled\" ng-if=\"siteDocLibCtrl.receivedFile.type != \'folder\'\"><md-icon md-font-icon=\"icon-content-save\" \nstyle=\"color:#FFD700 ! important\"></md-icon><md-tooltip md-direction=\"top\">Save Attributes</md-tooltip></md-button>\n<md-button flow-btn class=\"md-icon-button\" ng-click=\"siteDocLibCtrl.sharedUsersDialog($event)\" \nng-if=\"siteDocLibCtrl.receivedFile.type != \'folder\'\"><md-icon md-font-icon=\"icon-account-plus\" \nstyle=\"color:#7fba00 ! important\"></md-icon><md-tooltip md-direction=\"top\">Share {{siteDocLibCtrl.selectedFileName}}\n</md-tooltip></md-button><md-button flow-btn class=\"md-icon-button\" ng-click=\"\" \nng-if=\"siteDocLibCtrl.receivedFile.type != \'folder\'\"><md-icon md-font-icon=\"icon-star\" \nstyle=\"color:#FFD700 ! important\"></md-icon><md-tooltip md-direction=\"top\">Add To Favorites</md-tooltip></md-button>\n</div><table class=\"detailsTable1\"><tr ng-repeat=\"attribute in siteDocLibCtrl.fileAttributes\" ng-hide=\"editorEnabled\" \nng-click=\"enableEditor()\"><th align=\"left\">{{attribute.name.charAt(0).toUpperCase()+ attribute.name.slice(1)}}</th><td>\n{{attribute.value}}</td></tr><tr ng-repeat=\"attribute in siteDocLibCtrl.fileAttributes\" ng-show=\"editorEnabled\"><td>\n<md-input-container style=\"padding-top: 0px !important; padding-bottom: 0px !important;margin:-18px 0 !important\">\n<input type=\"text\" name=\"name\" ng-model=\"attribute.name\"></md-input-container></td><td><md-input-container \nstyle=\"padding-top: 0px !important; padding-bottom: 0px !important;margin:-18px 0 !important\"><input type=\"text\" \nname=\"name\" ng-model=\"attribute.value\"></md-input-container></td></tr></table><div layout=\"row\" \nlayout-align=\"center center\"><div ng-repeat=\"user in siteDocLibCtrl.allSharedUsers\" style=\"padding-left: 2%\"><md-button\n flow-btn class=\"md-icon-button md-fab md-mini grey-700-bg\" ng-click=\"\">{{user.firstName.slice(0,1).toUpperCase()}}\n<md-tooltip md-direction=\"top\">{{user.firstName +\" \"+ user.lastName}}</md-tooltip></md-button></div></div></md-content>\n</div><div class=\"md-padding\" layout=\"row\" layout-align=\"center center\" ng-show=\"buttonVisibility\"><md-button \nclass=\"md-raised\" ng-click=\"buildForm(file.id)\">DISPLAY</md-button></div><div class=\"md-padding\" layout=\"row\" \nlayout-align=\"center center\" ng-show=\"filebuttonVisibility\"><md-button class=\"md-raised\" \nng-click=\"previewFile($event)\">DISPLAY</md-button></div><md-divider ng-show=\"versionsVisibility\"></md-divider><div \nlayout=\"row\" layout-align=\"center center\" class=\"md-padding\" ng-show=\"versionsVisibility\"><span class=\"md-body-2\">\nVERSIONS</span></div><md-divider ng-show=\"versionsVisibility\"></md-divider><div class=\"auto-height scrollable\" \nms-scroll><md-content><md-list><md-list-item class=\"md-2-line\" ng-repeat=\"version in file.versions\" ng-click=\"null\">\n<div class=\"md-list-item-text\" layout=\"row\" layout-align=\"start start\"><div><h3><strong>Version {{version.versionNo}} \n</strong>created by<br><strong>{{version.createdBy}}</strong></h3><p>Date : {{version.createdDate.substr(0,10)}}</p>\n</div><div><md-button class=\"md-secondary md-icon-button\" ng-click=\"downloadVersionedFile(file.id,version.versionNo)\">\n<md-tooltip md-direction=\"top\">Download</md-tooltip><md-icon><i class=\"icon icon-download\"></i></md-icon></md-button>\n</div></div><md-divider ng-if=\"!$last\"></md-divider></md-list-item></md-list><div layout=\"row\" \nlayout-align=\"start center\" ng-show=\"versionsVisibility\" class=\"md-padding\"><md-button class=\"md-icon-button\" \nng-hide=\"file.type==\'folder\'\" ng-click=\"VersionFileDialog($event,file)\" ng-disabled=\"checkout\"><md-tooltip \nmd-direction=\"top\">Add new version</md-tooltip><md-icon md-font-icon=\"icon-library-plus\"></md-icon></md-button></div>\n</md-content></div></md-tab><md-tab label=\"ACTIVITY\"><div class=\"auto-height-activity scrollable\" ms-scroll>\n<md-content><md-list><md-list-item class=\"md-2-line\" ng-repeat=\"activity in file.activities | orderBy:\'-\' \" \nng-click=\"null\"><img ng-src=\"assets\\images\\avatars/Nora.jpg\" class=\"md-avatar\"><div class=\"md-list-item-text\" \nlayout=\"column\"><span><b><strong>{{activity.description}}</strong></b> by <strong>{{activity.userId}}</strong></span>\n<p>Date :{{activity.postedAt.substr(0,10)}}</p></div><md-divider ng-if=\"!$last\"></md-divider></md-list-item></md-list>\n</md-content></div></md-tab></md-tabs></md-content></div></div>");
$templateCache.put("app/main/sites/site/doclibrary/editFiledialog.html","<md-dialog><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2>\nEdit {{currentFile.type}} : {{currentFile.name}}</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"cancel()\"><md-icon md-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><form name=\"doclibrary\" \nnovalidate layout=\"column\"><div layout=\"row\"><div flex=\"45\" layout=\"column\" layout-align=\"center end\"><span class=\"h3\">\n<b>Rename</b></span></div><span flex=\"10\"></span><div flex=\"45\" layout=\"column\" layout-align=\"center start\">\n<md-input-container flex=\"45\" class=\"md-block\" layout=\"column\" layout-align=\"space-around start\"><input type=\"text\" \nname=\"editname\" ng-model=\"currentFile.name\"></md-input-container></div></div><div layout=\"row\"><div flex=\"45\" \nlayout=\"column\" layout-align=\"center end\"><span class=\"h3\"><b>Move to folder</b></span></div><span flex=\"10\"></span>\n<md-input-container flex=\"45\" class=\"md-block\" layout=\"column\" layout-align=\"space-around start\"><input type=\"text\" \nname=\"name\" ng-model=\"currentFile.id\"></md-input-container></div></form></md-dialog-content><md-dialog-actions \nlayout=\"row\"><span flex></span><md-button ng-click=\"cancel()\">Cancel</md-button><md-button \nng-click=\"updateFile(currentFile)\">Save</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/sites/site/doclibrary/fileDetailsDialog.html","<md-dialog><form name=\"fileDetailsForm\" novalidate ng-submit=\"fileDetailsForm.$valid && update(selectedFile)\" \nlayout=\"column\" flex=\"66\"><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2>\nDetails : {{selectedFileName}}</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content layout=\"column\" class=\"scrollable\" ms-scroll><div layout=\"column\" \nflex=\"45\"><md-input-container class=\"md-block\" ng-repeat=\"fileAttribute in fileAttributes\"><input type=\"text\" \nname=\"fileName\" ng-model=\"fileAttribute.attributeValue\" placeholder=\"{{fileAttribute.attributeName}}\" required>\n</md-input-container><span flex=\"10\"></span></div></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"center center\"><md-button ng-click=\"cancel()\">Cancel</md-button><md-button type=\"submit\" \nng-click=\"updateFileAttributes()\">Update</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/sites/site/doclibrary/folderSettingDialog.html","<md-dialog flex=\"30\"><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2>Folder Settings</h2><span flex>\n</span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><div layout=\"row\" layout-align=\"start center\"><md-checkbox \nng-model=\"folder.foldersOnly\" aria-label=\"folder\">Allow only Folders</md-checkbox></div></md-dialog-content>\n<md-dialog-actions layout=\"row\"><span flex></span><md-button ng-click=\"cancel()\">Cancel</md-button><md-button \nng-click=\"FolderUpdate(folder)\">Ok</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/sites/site/doclibrary/managePermissionsDialog.html","<md-dialog aria-label=\"Add a new doctype\" flex=\"80\" ng-init=\"getPermission()\"><form name=\"docType\" layout=\"column\">\n<md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2>Manage Permissions: {{selectedFileName}}</h2><span \nflex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content class=\"scrollable\" ms-scroll><div ng-switch=\"(allUsers).length\" \nng-style=\"{\'border\': \'1px solid #cccccc\'}\"><div ng-switch-when=\"0\" layout=\"row\" layout-align=\"center center\"><p \nclass=\"md-padding md-subhead md-primary-fg\">{{\'No data yet...\' | uppercase}}</p></div><div ng-switch-default \nng-style=\"{\'height\':\'190px\', \'overflow\': \'auto\'}\"><table class=\"simple list-view\"><thead><tr><th>NAME</th><th>View</th>\n<th>Edit</th><th>Permission</th><th>Delete</th><th>Download</th><th></th></tr></thead><tbody><tr \nng-repeat=\"user in allUsersForPermission\"><td data-ng-if=\"user.type == \'Group\'\"><i class=\"fa fa-users\" \naria-hidden=\"true\"></i> {{user.firstName}}</td><td data-ng-if=\"user.type == \'User\'\"><i class=\"fa fa-user\" \naria-hidden=\"true\"></i> {{user.firstName}} {{user.lastName}}</td><td data-ng-if=\"user.type == \'SiteAdmin\'\"><i \nclass=\"fa fa-user-circle-o\" aria-hidden=\"true\"></i> SiteAdmin</td><td data-ng-if=\"user.type == \'Owner\'\"><i \nclass=\"fa fa-user-circle\" aria-hidden=\"true\"></i> Owner</td><td><i class=\"icon-checkbox-marked-circle green-500-fg\" \nng-show=\"{{user.permissions.indexOf(\'View\')!==-1}}\"></i> <i class=\"icon-cancel red-500-fg\" \nng-show=\"{{ user.permissions.indexOf(\'View\')==-1}}\"></i></td><td><i class=\"icon-checkbox-marked-circle green-500-fg\" \nng-show=\"{{user.permissions.indexOf(\'Edit\')!==-1}}\"></i> <i class=\"icon-cancel red-500-fg\" \nng-show=\"{{ user.permissions.indexOf(\'Edit\')==-1}}\"></i></td><td><i class=\"icon-checkbox-marked-circle green-500-fg\" \nng-show=\"{{user.permissions.indexOf(\'Permission\')!==-1}}\"></i> <i class=\"icon-cancel red-500-fg\" \nng-show=\"{{ user.permissions.indexOf(\'Permission\')==-1}}\"></i></td><td><i \nclass=\"icon-checkbox-marked-circle green-500-fg\" ng-show=\"{{user.permissions.indexOf(\'Delete\')!==-1}}\"></i> <i \nclass=\"icon-cancel red-500-fg\" ng-show=\"{{ user.permissions.indexOf(\'Delete\')==-1}}\"></i></td><td><i \nclass=\"icon-checkbox-marked-circle green-500-fg\" ng-show=\"{{user.permissions.indexOf(\'Download\')!==-1}}\"></i> <i \nclass=\"icon-cancel red-500-fg\" ng-show=\"{{ user.permissions.indexOf(\'Download\')==-1}}\"></i></td><td class=\"no-padding\">\n<md-button data-ng-hide=\"user.type == \'SiteAdmin\' || user.type == \'Owner\'\" class=\"md-secondary md-icon-button\" \nng-click=\"removePermission(user)\"><md-tooltip md-direction=\"top\">Delete</md-tooltip><md-icon><i \nclass=\"icon icon-delete s20\"></i></md-icon></md-button></td></tr></tbody></table></div></div><div layout=\"row\" \nlayout-align=\"start center\" class=\"md-padding\"><md-checkbox ng-model=\"filePermissionType\" aria-label=\"inherit\">\nSet Inherited</md-checkbox></div><div class=\"scrollable\" ms-scroll><div layout=\"row\" class=\"pl-0\"><md-radio-group \nng-model=\"searchElements.type\" style=\"display: -webkit-inline-box\" \nng-change=\"onChangePermissionType(searchElements.type)\" ng-disabled=\"\"><md-radio-button class=\"pr-15\" value=\"User\" \nng-disabled=\"filePermissionType\">User</md-radio-button><md-radio-button class=\"pr-15\" value=\"Group\" \nng-disabled=\"filePermissionType\">Group</md-radio-button><md-radio-button class=\"pr-15\" value=\"Owner\" \nng-disabled=\"filePermissionType\">Owner</md-radio-button><md-radio-button value=\"SiteAdmin\" \nng-disabled=\"filePermissionType\">SiteAdmin</md-radio-button></md-radio-group></div><div layout=\"row\" \ndata-ng-if=\"searchElements.type ==\'User\' || searchElements.type ==\'Group\'\"><md-input-container \nclass=\"no-padding no-margin\" flex=\"40\"><input type=\"text\" name=\"name\" ng-model=\"searchElements.text\" \nplaceholder=\"Search Here\" ng-disabled=\"filePermissionType\"></md-input-container><md-button class=\"md-raised\" \nng-disabled=\"searchElements.text == undefined\" ng-click=\"searchUsersForManagePermission(searchElements)\" \nstyle=\"height: 35px;top: -11px\">Search</md-button></div></div><div><table class=\"simple\" \nng-show=\"searchElements.type ==\'Owner\'|| searchElements.type ==\'SiteAdmin\'\"><thead><tr><th \nclass=\"secondary-text md-padding\"><span class=\"column-title\">NAME</span></th><th class=\"secondary-text md-padding\">View\n</th><th class=\"secondary-text md-padding\">Edit</th><th class=\"secondary-text md-padding\">Permission</th><th \nclass=\"secondary-text md-padding\">Delete</th><th class=\"secondary-text md-padding\">Download</th><th></th></tr></thead>\n<tbody><tr><td class=\"no-padding\" data-ng-if=\"searchElements.type ==\'Owner\'\" \nstyle=\"padding-left: 10px !important;padding-right: 10px !important\">Owner</td><td class=\"no-padding\" \ndata-ng-if=\"searchElements.type ==\'SiteAdmin\'\" style=\"padding-left: 10px !important;padding-right: 10px !important\">\nSiteAdmin</td><td class=\"no-padding\" \nstyle=\"padding-left: 10px !important;padding-right: 10px !important;padding-top: 12px !important\"><md-checkbox \nvalue=\"view\" ng-model=\"ownerStatus.View\"></md-checkbox></td><td class=\"no-padding\" \nstyle=\"padding-left: 10px !important;padding-right: 10px !important;padding-top: 12px !important\"><md-checkbox \nvalue=\"edit\" ng-model=\"ownerStatus.Edit\"></md-checkbox></td><td class=\"no-padding\" \nstyle=\"padding-left: 10px !important;padding-right: 10px !important;padding-top: 12px !important\"><md-checkbox \nvalue=\"permission\" ng-model=\"ownerStatus.Permission\"></md-checkbox></td><td class=\"no-padding\" \nstyle=\"padding-left: 10px !important;padding-right: 10px !important;padding-top: 12px !important\"><md-checkbox \nvalue=\"delete\" ng-model=\"ownerStatus.Delete\"></md-checkbox></td><td class=\"no-padding\" \nstyle=\"padding-left: 10px !important;padding-right: 10px !important;padding-top: 12px !important\"><md-checkbox \nvalue=\"download\" ng-model=\"ownerStatus.Download\"></md-checkbox></td><td class=\"no-padding\"><md-button \nclass=\"md-accent md-raised md-mini\" ng-click=\"addUserForManagePermission(null, ownerStatus, searchElements.type)\">ADD\n</md-button></td></tr></tbody></table></div><div class=\"scrollable md-padding pt-0\" ms-scroll \ndata-ng-if=\"searchElements.type ==\'User\' || searchElements.type ==\'Group\'\"><table class=\"simple\" \nng-show=\"searchedUsers.data.length > 0\"><thead><tr><th class=\"secondary-text md-padding\"><span class=\"column-title\">\nNAME</span></th><th class=\"secondary-text md-padding\" data-ng-if=\"searchedUsers.type == \'User\'\"><span \nclass=\"column-title\">EMAIL</span></th><th class=\"secondary-text md-padding\">View</th><th \nclass=\"secondary-text md-padding\">Edit</th><th class=\"secondary-text md-padding\">Permission</th><th \nclass=\"secondary-text md-padding\">Delete</th><th class=\"secondary-text md-padding\">Download</th><th></th></tr></thead>\n<tbody><tr data-ng-repeat=\"(key,value) in searchedUsers.data track by $index\" ng-init=\"status = {}\"><td \nclass=\"no-padding\" data-ng-if=\"searchedUsers.type == \'User\'\" \nstyle=\"padding-left: 10px !important;padding-right: 10px !important\">{{value.firstName}} {{value.lastName}}</td><td \nclass=\"no-padding\" data-ng-if=\"searchedUsers.type == \'User\'\" \nstyle=\"padding-left: 10px !important;padding-right: 10px !important\">{{value.email}}</td><td class=\"no-padding\" \ndata-ng-if=\"searchedUsers.type == \'Group\'\" style=\"padding-left: 10px !important;padding-right: 10px !important\">\n{{value.name}}</td><td class=\"no-padding\" \nstyle=\"padding-left: 10px !important;padding-right: 10px !important;padding-top: 12px !important\"><md-checkbox \nvalue=\"view\" ng-model=\"status.View\"></md-checkbox></td><td class=\"no-padding\" \nstyle=\"padding-left: 10px !important;padding-right: 10px !important;padding-top: 12px !important\"><md-checkbox \nvalue=\"edit\" ng-model=\"status.Edit\"></md-checkbox></td><td class=\"no-padding\" \nstyle=\"padding-left: 10px !important;padding-right: 10px !important;padding-top: 12px !important\"><md-checkbox \nvalue=\"permission\" ng-model=\"status.Permission\"></md-checkbox></td><td class=\"no-padding\" \nstyle=\"padding-left: 10px !important;padding-right: 10px !important;padding-top: 12px !important\"><md-checkbox \nvalue=\"delete\" ng-model=\"status.Delete\"></md-checkbox></td><td class=\"no-padding\" \nstyle=\"padding-left: 10px !important;padding-right: 10px !important;padding-top: 12px !important\"><md-checkbox \nvalue=\"download\" ng-model=\"status.Download\"></md-checkbox></td><td class=\"no-padding\"><md-button \nclass=\"md-accent md-raised md-mini\" ng-click=\"addUserForManagePermission(value, status, searchedUsers.type) \">ADD\n</md-button></td></tr></tbody></table></div></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"center center\"><md-button type=\"button\" ng-click=\"cancel()\">Cancel</md-button><md-button type=\"button\" \nng-click=\"saveUserManagePermission()\">Save</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/sites/site/doclibrary/previewFiles.html","<md-dialog style=\"height: 100%; width: 100%\"><md-dialog-content class=\"no-padding\"><iframe id=\"iframe\" \nsrc=\"{{fileURL}}\" name=\"contentframe\" frameborder=\"0\" \nstyle=\"width: 100%; height: 100%; position: absolute; z-index: 999\"></iframe></md-dialog-content></md-dialog>");
$templateCache.put("app/main/sites/site/doclibrary/sharedUsersDialog.html","<md-dialog ng-cloak flex=\"80\" ng-init=\"getPermission()\"><md-toolbar layout=\"row\" class=\"md-accent\"><div \nclass=\"md-toolbar-tools\"><span>Sharing : {{selectedFileName}}</span> <span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content layout=\"column\" layout-align=\"center center\"><div fill-width>\n<md-content flex ng-style=\"{\'border\': \'1px solid #cccccc\'}\" class=\"scrollable\" ms-scroll layout=\"row\" layout-wrap><div \nng-switch=\"(allSharedUsers).length\"><div ng-switch-when=\"0\" layout=\"row\" layout-align=\"center center\"><p \nclass=\"md-padding md-subhead md-primary-fg\">{{\'Not shared yet...\' | uppercase}}</p></div><div ng-switch-default \nng-style=\"{\'height\':\'190px\'}\"><table class=\"simple list-view\"><thead><tr><th>NAME</th><th>View</th><th>Edit</th><th>\nDownload</th><th>End Date</th><th></th></tr></thead><tbody><tr ng-repeat=\"user in allSharedUsers\"><td \ndata-ng-if=\"user.groupName != null\"><i class=\"fa fa-users\" aria-hidden=\"true\"></i> {{user.groupName}}</td><td \ndata-ng-if=\"user.groupName == null\"><i class=\"fa fa-user\" aria-hidden=\"true\"></i> {{user.firstName}} {{user.lastName}}\n</td><td><i class=\"icon-checkbox-marked-circle green-500-fg\" ng-show=\"{{user.permissions.indexOf(\'view\')!==-1}}\"></i> \n<i class=\"icon-cancel red-500-fg\" ng-show=\"{{ user.permissions.indexOf(\'view\')==-1}}\"></i></td><td><i \nclass=\"icon-checkbox-marked-circle green-500-fg\" ng-show=\"{{user.permissions.indexOf(\'edit\')!==-1}}\"></i> <i \nclass=\"icon-cancel red-500-fg\" ng-show=\"{{ user.permissions.indexOf(\'edit\')==-1}}\"></i></td><td><i \nclass=\"icon-checkbox-marked-circle green-500-fg\" ng-show=\"{{user.permissions.indexOf(\'download\')!==-1}}\"></i> <i \nclass=\"icon-cancel red-500-fg\" ng-show=\"{{ user.permissions.indexOf(\'download\')==-1}}\"></i></td><td>\n{{user.expirydate.substr(0,10)}}</td><td class=\"no-padding\"><md-button class=\"md-secondary md-icon-button\" \nng-click=\"removeSharing(user.id)\"><md-tooltip md-direction=\"top\">Delete</md-tooltip><md-icon><i \nclass=\"icon icon-delete s20\"></i></md-icon></md-button></td></tr></tbody></table></div></div></md-content><div \nclass=\"scrollable md-padding\" ms-scroll><div layout=\"row\" class=\"md-padding pl-0\"><md-radio-group \nng-model=\"searchElements.type\" style=\"display: -webkit-inline-box\"><md-radio-button class=\"pr-15\" value=\"user\">User\n</md-radio-button><md-radio-button value=\"group\">Group</md-radio-button></md-radio-group></div><div layout=\"row\">\n<md-input-container class=\"no-padding no-margin\" flex=\"40\"><input type=\"text\" name=\"name\" \nng-model=\"searchElements.text\" placeholder=\"Search User\" required></md-input-container><md-button class=\"md-raised\" \nng-disabled=\"searchElements.text == undefined\" ng-click=\"searchUsers(searchElements)\" style=\"height: 35px;top: -11px\">\nSearch</md-button></div></div><div class=\"scrollable md-padding pt-0\" ms-scroll ng-style=\"{\'height\':\'180px\'}\"><table \nclass=\"simple\" ng-show=\"searchedUsers.data.length > 0\"><thead><tr><th class=\"secondary-text md-padding\"><span \nclass=\"column-title\">NAME</span></th><th class=\"secondary-text md-padding\">View</th><th \nclass=\"secondary-text md-padding\">Edit</th><th class=\"secondary-text md-padding\">Download</th><th \nclass=\"secondary-text md-padding\">End Date</th><th></th></tr></thead><tbody><tr \ndata-ng-repeat=\"(key,value) in searchedUsers.data track by $index\"><td class=\"no-padding\" \ndata-ng-if=\"searchedUsers.type == \'user\'\" style=\"padding-left: 10px !important;padding-right: 10px !important\">\n{{value.firstName}} {{value.lastName}}</td><td class=\"no-padding\" data-ng-if=\"searchedUsers.type == \'group\'\" \nstyle=\"padding-left: 10px !important;padding-right: 10px !important\">{{value.name}}</td><td class=\"no-padding\" \nstyle=\"padding-left: 10px !important;padding-right: 10px !important;padding-top: 12px !important\"><md-checkbox \nvalue=\"view\" ng-model=\"status.view\"></md-checkbox></td><td class=\"no-padding\" \nstyle=\"padding-left: 10px !important;padding-right: 10px !important;padding-top: 12px !important\"><md-checkbox \nvalue=\"edit\" ng-model=\"status.edit\"></md-checkbox></td><td class=\"no-padding\" \nstyle=\"padding-left: 10px !important;padding-right: 10px !important;padding-top: 12px !important\"><md-checkbox \nvalue=\"download\" ng-model=\"status.download\"></md-checkbox></td><td class=\"no-padding\" \nstyle=\"padding-left: 10px !important;padding-right: 10px !important\"><md-datepicker ng-model=\"myDate\" \nmd-placeholder=\"Expiry Date\"></md-datepicker></td><td class=\"no-padding\"><md-button \nclass=\"md-accent md-raised md-mini\" ng-click=\"shareFile(value, status, myDate, searchedUsers.type) \">ADD</md-button>\n</td></tr></tbody></table></div></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex></span><md-button \nng-click=\"cancel(member)\">Cancel</md-button><md-button ng-click=\"updateFileSharing()\" md-autofocus>Ok</md-button>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/sites/site/doclibrary/site.doclibrary.html","<style>\n.selected {\n        background-color: rgb(232, 233, 237) !important;\n          \n    }\n    .uf {\n    background-color: #fb8c00 !important;\n    }\n</style><div id=\"docLibrary\" class=\"page-layout simple right-sidenav\" layout=\"row\"><md-button flow-btn \nclass=\"md-fab md-mini grey-700-bg md-fab-bottom-right uf\" aria-label=\"Add Note\" ng-click=\"createFile($event)\" \nng-init=\"siteDocLibCtrl.getFiles();getSite();\"><md-icon md-font-icon=\"icon-plus\"></md-icon><md-tooltip \nmd-direction=\"top\">Upload File</md-tooltip></md-button><div flex=\"100\"><div layout=\"row\" ng-show=\"filePathVisibility\" \nclass=\"c-p\"><span ng-repeat=\"folder in filePath track by $index\" class=\"md-subhead\"><a \nng-click=\"siteDocLibCtrl.gotoFolder(folder)\" style=\"border: none;color: black !important;padding:3px;font-size: 14px\">\n{{folder.name}}</a><md-icon md-font-icon=\"icon-chevron-right\"></md-icon></span></div><table class=\"simple\" \nms-responsive-table><thead><tr><th><a href=\"#\" ng-click=\"orderByField=\'name\'; reverseSort = !reverseSort\" \nstyle=\"color: #626262 !important\">Name<span ng-show=\"orderByField == \'name\'\"><span ng-show=\"!reverseSort\"><md-icon \nmd-font-icon=\"icon-keyboard-up\" class=\"icon\"></md-icon></span><span ng-show=\"reverseSort\"><md-icon \nmd-font-icon=\"icon-keyboard-down\" class=\"icon\"></md-icon></span></span></a></th><th><a href=\"#\" \nng-click=\"orderByField=\'createdBy\'; reverseSort = !reverseSort\" style=\"color: #626262 !important\">Owner<span \nng-show=\"orderByField == \'createdBy\'\"><span ng-show=\"!reverseSort\"><md-icon md-font-icon=\"icon-keyboard-up\" \nclass=\"icon\"></md-icon></span><span ng-show=\"reverseSort\"><md-icon md-font-icon=\"icon-keyboard-down\" class=\"icon\">\n</md-icon></span></span></a></th><th><a href=\"#\" ng-click=\"orderByField=\'size\'; reverseSort = !reverseSort\" \nstyle=\"color: #626262 !important\">Size<span ng-show=\"orderByField == \'size\'\"><span ng-show=\"!reverseSort\"><md-icon \nmd-font-icon=\"icon-keyboard-up\" class=\"icon\"></md-icon></span><span ng-show=\"reverseSort\"><md-icon \nmd-font-icon=\"icon-keyboard-down\" class=\"icon\"></md-icon></span></span></a></th><th><a href=\"#\" \nng-click=\"orderByField=\'status\'; reverseSort = !reverseSort\" style=\"color: #626262 !important\">Status<span \nng-show=\"orderByField == \'status\'\"><span ng-show=\"!reverseSort\"><md-icon md-font-icon=\"icon-keyboard-up\" class=\"icon\">\n</md-icon></span><span ng-show=\"reverseSort\"><md-icon md-font-icon=\"icon-keyboard-down\" class=\"icon\"></md-icon></span>\n</span></a></th><th><a href=\"#\" ng-click=\"orderByField=\'lastModifiedDate\'; reverseSort = !reverseSort\" \nstyle=\"color: #626262 !important\">Last Modified<span ng-show=\"orderByField == \'lastModifiedDate\'\"><span \nng-show=\"!reverseSort\"><md-icon md-font-icon=\"icon-keyboard-up\" class=\"icon\"></md-icon></span><span \nng-show=\"reverseSort\"><md-icon md-font-icon=\"icon-keyboard-down\" class=\"icon\"></md-icon></span></span></a></th></tr>\n</thead><tbody><tr class=\"c-p\" hide-xs \nng-repeat=\"file in siteDocLibCtrl.files | filter:global.search | orderBy:orderByField:reverseSort\" \nng-click=\"siteDocLibCtrl.selectFile(file, $index)\" ng-dblclick=\"siteDocLibCtrl.doubleClick(file)\" \nng-class=\"{\'selected\':$index == selectedRow}\"><td class=\"name\"><md-icon \nmd-font-icon=\"{{siteDocLibCtrl.fileIcon(file)}}\" class=\"icon\"></md-icon><span>{{file.name}}</span></td><td \nclass=\"owner\" hide-xs>{{file.createdBy}}</td><td class=\"size\" hide-xs><span ng-show=\"file.size == \'\'\">-</span><span \nng-switch=\"file.size > 1024*1024\" ng-hide=\"file.type ==\'folder\'\"><span ng-switch-when=\"true\">\n{{file.size / 1024 / 1024 | number:2}} MB</span> <span ng-switch-default>{{file.size / 1024 | number:2}} kB</span>\n</span></td><td class=\"status\" hide-xs>{{file.status}}</td><td><span>{{file.lastModifiedDate.substr(0,10)}}</span></td>\n</tr><tr class=\"c-p\" hide-gt-md \nng-repeat=\"file in siteDocLibCtrl.files | filter:global.search | orderBy:orderByField:reverseSort\" \nng-click=\"siteDocLibCtrl.toggleDetails(file, $index)\" ng-dblclick=\"siteDocLibCtrl.folderClick(file)\" \nng-class=\"{\'selected\':$index == selectedRow}\"><td class=\"file-icon\"><md-icon \nmd-font-icon=\"{{siteDocLibCtrl.fileIcon(file)}}\" class=\"icon\"></md-icon></td><td class=\"name\">{{file.name}}</td><td \nclass=\"owner\" hide-xs>{{file.createdBy}}</td><td class=\"size\" hide-xs><span ng-show=\"file.size == \'\'\">-</span><span \nng-switch=\"file.size > 1024*1024\" ng-hide=\"file.type ==\'folder\'\"><span ng-switch-when=\"true\">\n{{file.size / 1024 / 1024 | number:2}} MB</span> <span ng-switch-default>{{file.size / 1024 | number:2}} kB</span>\n</span></td><td class=\"status\" hide-xs>{{file.status}}</td><td><span>{{file.lastModifiedDate.substr(0,10)}}</span></td>\n</tr></tbody></table><div ng-show=\"siteDocLibCtrl.numberOfElements == 0\" class=\"md-padding\"><span layout=\"row\" \nlayout-align=\"center center\"><h2>No files</h2></span></div><md-divider></md-divider><div layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"md-padding\"><h5>\nShowing {{(siteDocLibCtrl.pageNumber*siteDocLibCtrl.pageSize)+1}} - {{(siteDocLibCtrl.pageNumber*siteDocLibCtrl.pageSize)+siteDocLibCtrl.pageSize}} of {{siteDocLibCtrl.numberOfElements}} Results\n</h5></div><div layout=\"row\" layout-align=\"center center\">Page No<md-input-container class=\"md-block md-padding\" \nstyle=\"margin: 0px\"><md-select ng-model=\"pageNumber\"><md-option ng-repeat=\"pageNumber in pageNumbers\" \nng-value=\"pageNumber\" ng-click=\"sendPageNumber(pageNumber)\" value=\"siteDocLibCtrl.pageNumber\" ng-selected=\"$first\">\n{{pageNumber+1}}</md-option></md-select></md-input-container></div><div layout=\"row\" layout-align=\"center center\"><div>\n<md-button type=\"button\" ng-click=\"siteDocLibCtrl.previous()\" ng-disabled=\"siteDocLibCtrl.pageNumber <= 0 \">Prev\n</md-button></div><p class=\"md-padding\">{{siteDocLibCtrl.pageNumber+1}}/{{fileResults.totalPages}} &nbsp;PAGES</p><div \nclass=\"md-padding\"><md-button type=\"button\" ng-click=\"siteDocLibCtrl.next()\" \nng-disabled=\"siteDocLibCtrl.pageNumber == pageNumbers.length-1 || siteDocLibCtrl.numberOfElements == 0\">Next\n</md-button></div></div></div></div><md-divider></md-divider><div flex=\"20\" ng-hide=\"detailsVisibility\" \nlayout=\"column\"><md-tabs md-dynamic-height md-center-tabs md-border-bottom md-active><md-tab label=\"Details\">\n<md-content class=\"md-padding\"><div layout=\"column\" layout-align=\"center center\"><svg width=\"107px\" height=\"82px\" \nviewBox=\"0 0 107 82\" focusable=\"false\"><path class=\"a-s-fa-Ha-pa drive\" fill=\"#B8B8B8\" \nd=\"M0,4a4,4,0,0,1,4,-4h89a4,4,0,0,1,4,4v18.5l-23.5,40.5h-69.5a4,4,0,0,1,-4,-4ZM74.5,65l23,-39.15l1,0l7,4.1l1,1l-23,39.15ZM74,65.8l9.5,5.5l-9,4ZM97,51v8a4,4,0,0,1,-4,4h-3ZM21,63v19l23,-19Z\">\n</path></svg><p class=\"md-primary md-hue-3\">Select a file or folder to view its details.</p></div></md-content>\n</md-tab><md-tab label=\"Activities\"><md-content class=\"md-padding\"><div layout=\"column\" layout-align=\"center center\">\n<svg width=\"107px\" height=\"82px\" viewBox=\"0 0 107 82\" focusable=\"false\"><path class=\"a-s-fa-Ha-pa drive\" \nfill=\"#B8B8B8\" \nd=\"M0,4a4,4,0,0,1,4,-4h89a4,4,0,0,1,4,4v18.5l-23.5,40.5h-69.5a4,4,0,0,1,-4,-4ZM74.5,65l23,-39.15l1,0l7,4.1l1,1l-23,39.15ZM74,65.8l9.5,5.5l-9,4ZM97,51v8a4,4,0,0,1,-4,4h-3ZM21,63v19l23,-19Z\">\n</path></svg><p class=\"md-primary md-hue-3\">Select a file or folder to view its details.</p></div></md-content>\n</md-tab><md-tab label=\"Versions\"><md-content class=\"md-padding\"><div layout=\"column\" layout-align=\"center center\"><svg\n width=\"107px\" height=\"82px\" viewBox=\"0 0 107 82\" focusable=\"false\"><path class=\"a-s-fa-Ha-pa drive\" fill=\"#B8B8B8\" \nd=\"M0,4a4,4,0,0,1,4,-4h89a4,4,0,0,1,4,4v18.5l-23.5,40.5h-69.5a4,4,0,0,1,-4,-4ZM74.5,65l23,-39.15l1,0l7,4.1l1,1l-23,39.15ZM74,65.8l9.5,5.5l-9,4ZM97,51v8a4,4,0,0,1,-4,4h-3ZM21,63v19l23,-19Z\">\n</path></svg><p class=\"md-primary md-hue-3\">Select a file or folder to view its details.</p></div></md-content>\n</md-tab></md-tabs></div><div flex=\"25\" layout=\"column\" ng-show=\"detailsVisibility\" class=\"scrollable\" ms-scroll><div \nlayout=\"row\" layout-align=\"center center\"><span class=\"md-title md-padding\">{{siteDocLibCtrl.selectedFileName}}</span>\n</div><div layout=\"row\" layout-align=\"center center\"><md-button class=\"md-icon-button\" ng-click=\"UpdateFile($event)\" \nng-disabled=\"checkout\"><md-tooltip md-direction=\"top\">Edit</md-tooltip><md-icon md-font-icon=\"icon-pencil\"></md-icon>\n</md-button><md-button class=\"md-icon-button\" ng-if=\"siteDocLibCtrl.receivedFile.type != \'folder\'\" \nng-click=\"checkInFileDialog($event)\"><md-tooltip md-direction=\"top\">Check in</md-tooltip><md-icon \nmd-font-icon=\"icon-login\"></md-icon></md-button><md-button class=\"md-icon-button\" \nng-if=\"siteDocLibCtrl.receivedFile.type != \'folder\'\" ng-click=\"fileCheckout()\"><md-tooltip md-direction=\"top\">Check out\n</md-tooltip><md-icon md-font-icon=\"icon-logout\"></md-icon></md-button><md-button class=\"md-icon-button\" \nng-if=\"siteDocLibCtrl.receivedFile.type != \'folder\'\" ng-click=\"downloadFile()\" ng-disabled=\"checkout\"><md-tooltip \nmd-direction=\"top\">Download</md-tooltip><md-icon md-font-icon=\"icon-download\"></md-icon></md-button><md-button \nclass=\"md-icon-button\" ng-click=\"siteDocLibCtrl.deleteFile(ev)\" ng-disabled=\"checkout\" ng-disabled=\"checkout\">\n<md-tooltip md-direction=\"top\">Delete</md-tooltip><md-icon md-font-icon=\"icon-delete\"></md-icon></md-button></div><div>\n<md-content ng-cloak><md-tabs md-dynamic-height md-center-tabs md-border-bottom><md-tab label=\"Details\"><div \nclass=\"auto-height scrollable\" ms-scroll><md-content class=\"md-padding scrollable\" ms-scroll><div align=\"right\">\n<md-button flow-btn class=\"md-icon-button\" ng-click=\"enableEditor()\" ng-hide=\"editorEnabled\" \nng-if=\"siteDocLibCtrl.receivedFile.type != \'folder\'\" ng-show=\"siteDocLibCtrl.edit\"><md-icon md-font-icon=\"icon-pencil\">\n</md-icon><md-tooltip md-direction=\"top\">Edit Attributes</md-tooltip></md-button><md-button flow-btn \nclass=\"md-icon-button\" ng-click=\"saveAllAttributes()\" ng-show=\"editorEnabled\" \nng-if=\"siteDocLibCtrl.receivedFile.type != \'folder\'\"><md-icon md-font-icon=\"icon-content-save\"></md-icon><md-tooltip \nmd-direction=\"top\">Save Attributes</md-tooltip></md-button><md-button flow-btn class=\"md-icon-button\" \nng-click=\"siteDocLibCtrl.sharedUsersDialog($event)\" ng-if=\"siteDocLibCtrl.receivedFile.type != \'folder\'\" \nng-show=\"siteDocLibCtrl.permission\"><md-icon md-font-icon=\"icon-account-plus\"></md-icon><md-tooltip md-direction=\"top\">\nShare {{siteDocLibCtrl.selectedFileName}}</md-tooltip></md-button><md-button flow-btn class=\"md-icon-button\" \nng-click=\"siteDocLibCtrl.managePermissionsDialog($event)\" ng-show=\"siteDocLibCtrl.permission\"><md-icon \nmd-font-icon=\"icon-account-key\"></md-icon><md-tooltip md-direction=\"top\">Manage Permissions</md-tooltip></md-button>\n<md-button flow-btn class=\"md-icon-button\" ng-click=\"siteDocLibCtrl.folderSettingDialog($event)\" \nng-if=\"siteDocLibCtrl.receivedFile.type == \'folder\'\" ng-show=\"siteDocLibCtrl.permission\"><md-icon \nmd-font-icon=\"icon-cog\"></md-icon><md-tooltip md-direction=\"top\">Settings</md-tooltip></md-button></div><table \nclass=\"detailsTable1\"><tr ng-repeat=\"attribute in siteDocLibCtrl.fileAttributes\" ng-hide=\"editorEnabled\" \nng-click=\"enableEditor()\"><th align=\"left\">{{attribute.name.charAt(0).toUpperCase()+ attribute.name.slice(1)}}</th><td>\n{{attribute.value}}</td></tr><tr ng-repeat=\"attribute in siteDocLibCtrl.fileAttributes\" ng-show=\"editorEnabled\"><td>\n<md-input-container style=\"padding-top: 0px !important; padding-bottom: 0px !important;margin:-18px 0 !important\">\n<input type=\"text\" name=\"name\" ng-model=\"attribute.name\"></md-input-container></td><td><md-input-container \nstyle=\"padding-top: 0px !important; padding-bottom: 0px !important;margin:-18px 0 !important\"><input type=\"text\" \nname=\"name\" ng-model=\"attribute.value\"></md-input-container></td></tr></table><div layout=\"row\" \nlayout-align=\"center center\"><div ng-repeat=\"user in siteDocLibCtrl.allSharedUsers\" style=\"padding-left: 2%\"><md-button\n flow-btn class=\"md-icon-button md-fab md-mini grey-700-bg\" ng-click=\"\">{{user.firstName.slice(0,1).toUpperCase()}}\n<md-tooltip md-direction=\"top\">{{user.firstName +\" \"+ user.lastName}}</md-tooltip></md-button></div></div></md-content>\n</div><div class=\"md-padding\" layout=\"row\" layout-align=\"center center\" ng-show=\"buttonVisibility\"><md-button \nclass=\"md-raised\" ng-click=\"buildForm(file.id)\" ng-show=\"siteDocLibCtrl.viewFile\">DISPLAY</md-button></div><div \nclass=\"md-padding\" layout=\"row\" layout-align=\"center center\" ng-show=\"filebuttonVisibility\"><md-button \nclass=\"md-raised\" ng-click=\"previewFile($event)\">DISPLAY</md-button></div></md-tab><md-tab label=\"Activities\"><div \nclass=\"auto-height-activity scrollable\" ms-scroll><md-content><md-list><md-list-item class=\"md-2-line\" \nng-repeat=\"activity in file.activities | orderBy:\'-\' \" ng-click=\"null\"><img ng-src=\"assets\\images\\avatars/Nora.jpg\" \nclass=\"md-avatar\"><div class=\"md-list-item-text\" layout=\"column\"><p ng-bind-html=\"activity.description\"></p></div>\n<md-divider ng-if=\"!$last\"></md-divider></md-list-item></md-list></md-content></div></md-tab><md-tab label=\"Versions\">\n<div class=\"auto-height-activity scrollable\" ms-scroll><md-content><md-list><md-list-item class=\"md-2-line\" \nng-repeat=\"version in file.versions\" ng-click=\"null\"><div class=\"md-list-item-text\" layout=\"row\" \nlayout-align=\"start start\"><div><h3><strong>Version {{version.versionNo}} </strong>created by<br><strong>\n{{version.createdBy}}</strong></h3><p>Date : {{version.createdDate.substr(0,10)}}</p></div><div><md-button \nclass=\"md-secondary md-icon-button\" ng-click=\"downloadVersionedFile(file.id,version.versionNo)\"><md-tooltip \nmd-direction=\"top\">Download</md-tooltip><md-icon><i class=\"icon icon-download\"></i></md-icon></md-button></div></div>\n<md-divider ng-if=\"!$last\"></md-divider></md-list-item></md-list><div layout=\"row\" layout-align=\"start center\" \nng-show=\"versionsVisibility\" class=\"md-padding\"><md-button class=\"md-icon-button\" ng-hide=\"file.type==\'folder\'\" \nng-click=\"VersionFileDialog($event,file)\" ng-disabled=\"checkout\"><md-tooltip md-direction=\"top\">Add new version\n</md-tooltip><md-icon md-font-icon=\"icon-library-plus\"></md-icon></md-button></div></md-content></div></md-tab>\n</md-tabs></md-content></div></div><md-sidenav ng-show=\"showsidenav\" hide-gt-md \nclass=\"sidenav details-sidenav md-sidenav-right\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" \nmd-component-id=\"details-sidenav\" ng-include=\"\'app/main/sites/site/doclibrary/details-sidenav.html\'\" ms-scroll \nms-sidenav-helper></md-sidenav></div>");
$templateCache.put("app/main/sites/site/doclibrary/upload.doclibrary.dialog.html","<md-dialog flex=\"35\" ng-init=\"getDocumentTypes(); getDocumentTemplate();$scope.getFileById();\"><md-toolbar \nclass=\"md-accent\"><div class=\"md-toolbar-tools\"><h2>Create File</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content class=\"p-0\"><md-tabs md-dynamic-height md-stretch-tabs=\"always\" \nmd-center-tabs><md-tab label=\"Upload\"><form name=\"uploadfile\" \nng-submit=\"uploadfile.$valid && uploadFile($event,folderName, description,documentTypeName,documentTypeJson)\">\n<md-content class=\"md-padding scrollable\" ms-scroll><span class=\"md-body-2\" ng-style=\"{color:\'red\'}\" \nng-hide=\"files.length\">{{ErrorMsg}}</span><div layout=\"row\" \nng-hide=\"folderName || foldersOnly || filepermission == true\"><div flex=\"35\" layout=\"column\" \nlayout-align=\"start center\"><span class=\"h3\"><b>Upload File</b></span></div><span flex=\"5\"></span><div flex=\"45\" \nlayout=\"column\" layout-align=\"center start\"><input class=\"ng-hide\" id=\"formUploadFile\" name=\"formUploadFile\" \ntype=\"file\" onchange=\"angular.element(this).scope().setFile(this)\"><label for=\"formUploadFile\" \nclass=\"md-button md-raised md-accent\">Upload</label></div></div><div><div ng-repeat=\"file in files.slice(0)\" \nlayout=\"row\" layout-align=\"center center\"><span class=\"md-warn\">{{file.webkitRelativePath || file.name}}</span> (<span \nng-switch=\"file.size > 1024*1024\"> <span ng-switch-when=\"true\">{{file.size / 1024 / 1024 | number:2}} MB</span> <span \nng-switch-default>{{file.size / 1024 | number:2}} kB</span> </span>)</div></div><div layout=\"row\" \nng-hide=\"files.length\" class=\"p-15\"><div flex=\"35\" layout=\"column\" layout-align=\"start center\"><span class=\"h3\"><b>\nCreate Folder </b></span></div><span flex=\"5\"></span><md-input-container flex=\"45\" class=\"md-block\" \nstyle=\"margin: 0px\"><input type=\"text\" ng-model=\"folderName\" placeholder=\"Folder name\"></md-input-container></div><div \nlayout=\"row\"><div flex=\"35\" layout=\"column\" layout-align=\"start center\"><span class=\"h3\"><b>Description </b></span>\n</div><span flex=\"5\"></span><md-input-container flex=\"45\" class=\"md-block\" style=\"margin: 0px\"><input type=\"text\" \nname=\"description\" ng-model=\"description\"></md-input-container></div><div layout=\"row\" ng-if=\"files.length\"><div \nflex=\"35\" layout=\"column\" layout-align=\"start center\"><span class=\"h3\"><b>Document Type </b></span></div><span \nflex=\"5\"></span><md-input-container class=\"md-block\" flex=\"45\" style=\"margin: 0px\"><md-select name=\"documentTypeName\" \nng-model=\"documentTypeName\" ng-required=\"true\"><md-option ng-repeat=\"documentType in newDocumentType\" \nng-value=\"documentType.name\" ng-click=\"selectDocumentType(documentType)\">{{documentType.name}}</md-option></md-select>\n<div ng-messages=\"uploadfile.documentTypeName.$error\" \nng-show=\"uploadfile.$submitted || uploadfile.documentTypeName.$touched ||  uploadfile.documentTypeName.$dirty \"><div \nng-message-exp=\"[\'required\']\" ng-hide=\"uploadfile.documentType.$valid\"><span translate>Please select DocumentType\n</span></div></div></md-input-container></div><span flex=\"5\"></span><md-divider></md-divider><div \nng-show=\"attributeObjects\"><div ng-repeat=\"attributeObject in attributeObjects\"><div layout=\"row\"><p flex=\"50\">\n{{attributeObject.name}}</p><div ng-if=\" attributeObject.required == true \">*</div><p></p><div \nng-if=\" attributeObject.required == true \" layout=\"row\" flex=\"100\"><div ng-if=\"attributeObject.type == \'String\' \" \nlayout=\"row\" flex=\"100\"><md-input-container class=\"md-block\" flex=\"40\" style=\"margin: 0px\"><input type=\"text\" \nname=\"string\" ng-model=\"attributeObject.Value\" required><div ng-messages=\"uploadfile.string.$error\" role=\"alert\"><div \nng-message=\"required\">This field is required</div></div></md-input-container></div><div \nng-if=\" attributeObject.type == \'Number\' \" layout=\"row\" flex=\"100\"><md-input-container class=\"md-block\" flex=\"40\" \nstyle=\"margin: 0px\"><input type=\"number\" name=\"number\" ng-model=\"attributeObject.Value\" required><div \nng-messages=\"uploadfile.number.$error\" role=\"alert\"><div ng-message=\"required\">This field is required</div></div>\n</md-input-container></div><div ng-if=\"attributeObject.type == \'Date\' \" layout=\"row\" flex=\"100\"><md-datepicker \nng-model=\"attributeObject.Value\" required style=\"margin: 0px\"></md-datepicker><div \nng-messages=\"uploadfile.attributeObject.Value.$error\"><div ng-message=\"required\">required</div></div></div></div><div \nng-if=\" attributeObject.required == false \" layout=\"row\" flex=\"100\"><div ng-if=\"attributeObject.type == \'String\' \" \nlayout=\"row\" flex=\"100\"><md-input-container class=\"md-block\" flex=\"40\" style=\"margin: 0px\"><input type=\"text\" \nng-model=\"attributeObject.Value\"></md-input-container></div><div ng-if=\" attributeObject.type == \'Number\' \" \nlayout=\"row\" flex=\"100\"><md-input-container class=\"md-block\" flex=\"40\" style=\"margin: 0px\"><input type=\"number\" \nng-model=\"attributeObject.Value\"></md-input-container></div><div ng-if=\"attributeObject.type == \'Date\' \" layout=\"row\" \nflex=\"100\"><md-datepicker ng-model=\"attributeObject.Value\" style=\"margin: 0px\"></md-datepicker></div></div></div></div>\n</div></md-content><div layout=\"row\"><span flex></span><md-button ng-click=\"cancel()\">Cancel</md-button><md-button \ntype=\"submit\">Save</md-button></div></form></md-tab><md-tab label=\"Create\"><form name=\"create\" \nng-submit=\"create.$valid && createTemplateFile($event,create.name,create.description,create.documentType,create.template,createFiledocTypeJson)\">\n<md-content class=\"md-padding scrollable\" ms-scroll><div layout=\"row\"><div flex=\"35\" layout=\"column\" \nlayout-align=\"center center\"><span class=\"h3\"><b>Name </b></span></div><span flex=\"5\"></span><md-input-container \nflex=\"45\" class=\"md-block\" style=\"margin:0px\"><input type=\"text\" name=\"createname\" ng-model=\"create.name\" required>\n</md-input-container></div><div layout=\"row\"><div flex=\"35\" layout=\"column\" layout-align=\"center center\"><span \nclass=\"h3\"><b>Description </b></span></div><span flex=\"5\"></span><md-input-container flex=\"45\" class=\"md-block\" \nstyle=\"margin:0px\"><input type=\"text\" name=\"des\" ng-model=\"create.description\" required></md-input-container></div><div\n layout=\"row\"><div flex=\"35\" layout=\"column\" layout-align=\"center center\"><span class=\"h3\"><b>Template Name</b></span>\n</div><span flex=\"5\"></span><md-input-container class=\"md-block\" flex=\"45\" style=\"margin:0px\"><md-select \nname=\"template\" ng-model=\"create.template\" ng-required=\"true\"><md-option ng-repeat=\"template in templateList\" \nng-value=\"template.name\" ng-click=\"selectDocumentTemplate(template.name)\">{{template.name}}</md-option></md-select><div\n ng-messages=\"create.template.$error\" \nng-show=\"create.$submitted || create.template.$touched ||  create.template.$dirty \"><div ng-message-exp=\"[\'required\']\" \nng-hide=\"create.template.$valid\"><span translate>Please select Template</span></div></div></md-input-container></div>\n<div layout=\"row\"><div flex=\"35\" layout=\"column\" layout-align=\"center center\"><span class=\"h3\"><b>Document Type </b>\n</span></div><span flex=\"5\"></span><md-input-container class=\"md-block\" flex=\"45\" style=\"margin:0px\"><input \ntype=\"text\" disabled=\"true\" ng-model=\"create.documentType \" placeholder=\"{{create.documentType }}\">\n</md-input-container></div><md-divider></md-divider><div ng-show=\"DocTypeattributeObjects\"><div \nng-repeat=\"attributeObject in DocTypeattributeObjects\"><div layout=\"row\"><p flex=\"40\">{{attributeObject.name}}</p><div \nng-if=\" attributeObject.required == true \">*</div><p></p><div ng-if=\" attributeObject.required == true \" layout=\"row\" \nflex=\"100\"><div ng-if=\"attributeObject.type == \'String\' \" layout=\"row\" flex=\"100\"><md-input-container class=\"md-block\" \nflex=\"40\" style=\"margin: 0px\"><input type=\"text\" name=\"string\" ng-model=\"attributeObject.Value\" required><div \nng-messages=\"create.string.$error\" role=\"alert\"><div ng-message=\"required\">This field is required</div></div>\n</md-input-container></div><div ng-if=\" attributeObject.type == \'Number\' \" layout=\"row\" flex=\"100\"><md-input-container \nclass=\"md-block\" flex=\"40\" style=\"margin: 0px\"><input type=\"number\" name=\"number\" ng-model=\"attributeObject.Value\" \nrequired><div ng-messages=\"create.number.$error\" role=\"alert\"><div ng-message=\"required\">This field is required</div>\n</div></md-input-container></div><div ng-if=\"attributeObject.type == \'Date\' \" layout=\"row\" flex=\"100\"><md-datepicker \nng-model=\"attributeObject.Value\" required></md-datepicker><div ng-messages=\"create.attributeObject.Value.$error\" \nrole=\"alert\"><div ng-message=\"required\">required</div></div></div></div><div \nng-if=\" attributeObject.required == false \" layout=\"row\" flex=\"100\"><div ng-if=\"attributeObject.type == \'String\' \" \nlayout=\"row\" flex=\"100\"><md-input-container class=\"md-block\" flex=\"40\" style=\"margin: 0px\"><input type=\"text\" \nng-model=\"attributeObject.Value\"></md-input-container></div><div ng-if=\" attributeObject.type == \'Number\' \" \nlayout=\"row\" flex=\"100\"><md-input-container class=\"md-block\" flex=\"40\" style=\"margin: 0px\"><input type=\"number\" \nng-model=\"attributeObject.Value\"></md-input-container></div><div ng-if=\"attributeObject.type == \'Date\' \" layout=\"row\" \nflex=\"100\"><md-datepicker ng-model=\"attributeObject.Value\"></md-datepicker></div></div></div></div></div></md-content>\n<div layout=\"row\"><span flex></span><md-button ng-click=\"cancel()\">Cancel</md-button><md-button type=\"submit\">Save\n</md-button></div></form></md-tab></md-tabs></md-dialog-content></md-dialog>");
$templateCache.put("app/main/sites/site/wiki/site.wiki.html","<div><h1 class=\"md-display-2\">Wiki -> Naveena</h1><h1>{{siteWikiCtrl.test}}</h1></div>");
$templateCache.put("app/main/administration/invoiceTypes/vendor_cr_request/vendor_cr.html","<style>\n.header {\n            height: 50px !important;\n            min-height: 0px !important;\n        }\n        \n        .reqtype {\n            font-size: 22px;\n            margin-top: -1px;\n        }\n</style><div class=\"page-layout simple right-sidenav\" layout=\"row\"><div \nng-include=\"\'app/main/administration/common/admin.html\'\"></div><div \nclass=\"page-layout carded fullwidth md-padding scrollable\" layout=\"column\" flex ms-scroll><div \nclass=\"parent-tabs white-bg mb-15\"><md-tabs class=\"mh-0\"><md-tab label=\"InvoiceTypes\"></md-tab></md-tabs></div><div \nclass=\"widget-group\" flex=\"100\" layout=\"column\" layout-wrap><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" \nmd-dynamic-height><ms-widget-front class=\"white-bg\"><div class=\"header md-accent-bg\" layout=\"row\" \nlayout-align=\"space-between\"><div layout=\"column\" layout-align=\"center center\"><div layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16 c-p\" ng-click=\"gotoPR_Types()\"></md-icon>\n<md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span>Update Vendor CR Request</span></div>\n</div></div><div class=\"content\" layout=\"column\"><div layout=\"row\" class=\"md-padding\"><md-input-container \nclass=\"md-block\" flex-gt-sm=\"40\"><label>Name</label><input type=\"text\" name=\"name\" ng-model=\"vm.InvoiceType.name\">\n</md-input-container><span flex=\"10\"></span><md-input-container class=\"md-block\" flex-gt-sm=\"40\"><label>Description\n</label><input type=\"text\" name=\"name\" ng-model=\"vm.InvoiceType.name\"></md-input-container></div><div layout=\"row\" \nclass=\"md-padding\" layout-align=\"start start\"><span class=\"reqtype\">Req Doctypes:</span> <span flex=\"5\"></span>\n<md-input-container class=\"md-block\" flex-gt-sm=\"30\" style=\"margin-top:0%\"><input type=\"text\" name=\"name\" \nng-model=\"vm.InvoiceType.name\"></md-input-container></div><md-tabs md-dynamic-height md-border-bottom><md-tab \nlabel=\"Business Rules\"><md-content class=\"md-padding\"><h1 class=\"md-display-1\">Business Rules</h1></md-content>\n</md-tab><md-tab label=\"Form Fields For Request\"><md-content class=\"md-padding\"><h1 class=\"reqtype\">Header</h1><div \nlayout=\"row\" class=\"md-padding\"><div layout=\"row\" layout-align=\"start start\" class=\"md-padding\"><md-switch \nclass=\"md-accent\" style=\"margin:5px !important\" aria-label=\"Switch No Ink\" ng-model=\"request.requestedby\">RequestedBy\n</md-switch></div><div layout=\"row\" layout-align=\"start start\" class=\"md-padding\"><md-switch class=\"md-accent\" \nstyle=\"margin:5px !important\" aria-label=\"Switch No Ink\" ng-model=\"request.doctype\">PR Doctype</md-switch></div></div>\n<h1 class=\"reqtype\">LineItems</h1><div layout=\"column\"><div layout=\"row\" class=\"md-padding\"><div layout=\"row\" \nlayout-align=\"start start\"><md-switch class=\"md-accent\" style=\"margin:5px !important\" aria-label=\"Switch No Ink\" \nng-model=\"request.accAssCat\">Acc. Ass.Category</md-switch></div><div layout=\"row\" layout-align=\"start start\"><md-switch\n class=\"md-accent\" style=\"margin:5px !important\" aria-label=\"Switch No Ink\" ng-model=\"request.itemCategory\">\nItem Category</md-switch></div><div layout=\"row\" layout-align=\"start start\"><md-switch class=\"md-accent\" \nstyle=\"margin:5px !important\" aria-label=\"Switch No Ink\" ng-model=\"request.materialCode\">Material Code</md-switch>\n</div><div layout=\"row\" layout-align=\"start start\"><md-switch class=\"md-accent\" style=\"margin:5px !important\" \naria-label=\"Switch No Ink\" ng-model=\"request.shortText\">Short Text</md-switch></div><div layout=\"row\" \nlayout-align=\"start start\"><md-switch class=\"md-accent\" style=\"margin:5px !important\" aria-label=\"Switch No Ink\" \nng-model=\"request.matgroupDesc\">Mat. Grp.Desc</md-switch></div><div layout=\"row\" layout-align=\"start start\"><md-switch \nclass=\"md-accent\" style=\"margin:5px !important\" aria-label=\"Switch No Ink\" ng-model=\"request.plant\">Plant</md-switch>\n</div><div layout=\"row\" layout-align=\"start start\"><md-switch class=\"md-accent\" style=\"margin:5px !important\" \naria-label=\"Switch No Ink\" ng-model=\"request.purchasegroup\">Purchase Group</md-switch></div><div layout=\"row\" \nlayout-align=\"start start\"><md-switch class=\"md-accent\" style=\"margin:5px !important\" aria-label=\"Switch No Ink\" \nng-model=\"request.Quantity\">Quantity</md-switch></div><div layout=\"row\" layout-align=\"start start\"><md-switch \nclass=\"md-accent\" style=\"margin:5px !important\" aria-label=\"Switch No Ink\" ng-model=\"request.uom\">UOM</md-switch></div>\n<div layout=\"row\" layout-align=\"start start\"><md-switch class=\"md-accent\" style=\"margin:5px !important\" \naria-label=\"Switch No Ink\" ng-model=\"pr.valprice\">Valuation Price</md-switch></div><div layout=\"row\" \nlayout-align=\"start start\"><md-switch class=\"md-accent\" style=\"margin:5px !important\" aria-label=\"Switch No Ink\" \nng-model=\"request.total\">Total Amount</md-switch></div></div><div layout=\"row\" class=\"md-padding\"><div layout=\"row\" \nlayout-align=\"start start\"><md-switch class=\"md-accent\" style=\"margin:5px !important\" aria-label=\"Switch No Ink\" \nng-model=\"request.order\">Order No</md-switch></div><div layout=\"row\" layout-align=\"start start\"><md-switch \nclass=\"md-accent\" style=\"margin:5px !important\" aria-label=\"Switch No Ink\" ng-model=\"request.costcenter\">Cost Center\n</md-switch></div><div layout=\"row\" layout-align=\"start start\"><md-switch class=\"md-accent\" \nstyle=\"margin:5px !important\" aria-label=\"Switch No Ink\" ng-model=\"request.glaccount\">G/L Account</md-switch></div><div\n layout=\"row\" layout-align=\"start start\"><md-switch class=\"md-accent\" style=\"margin:5px !important\" \naria-label=\"Switch No Ink\" ng-model=\"request.functionalarea\">Functional Area</md-switch></div><div layout=\"row\" \nlayout-align=\"start start\"><md-switch class=\"md-accent\" style=\"margin:5px !important\" aria-label=\"Switch No Ink\" \nng-model=\"request.fund\">Fund</md-switch></div><div layout=\"row\" layout-align=\"start start\"><md-switch \nclass=\"md-accent\" style=\"margin:5px !important\" aria-label=\"Switch No Ink\" ng-model=\"request.date\">Delivery Date\n</md-switch></div></div></div></md-content></md-tab><md-tab label=\"Form Fields For Inbox\"><md-content \nclass=\"md-padding\"><h1 class=\"reqtype\">Header</h1><div layout=\"row\" class=\"md-padding\"><div layout=\"row\" \nlayout-align=\"start start\" class=\"md-padding\"><md-switch class=\"md-accent\" style=\"margin:5px !important\" \naria-label=\"Switch No Ink\" ng-model=\"inbox.requestedby\">RequestedBy</md-switch></div><div layout=\"row\" \nlayout-align=\"start start\" class=\"md-padding\"><md-switch class=\"md-accent\" style=\"margin:5px !important\" \naria-label=\"Switch No Ink\" ng-model=\"inbox.doctype\">PR Doctype</md-switch></div></div><h1 class=\"reqtype\">LineItems\n</h1><div layout=\"column\"><div layout=\"row\" class=\"md-padding\"><div layout=\"row\" layout-align=\"start start\"><md-switch \nclass=\"md-accent\" style=\"margin:5px !important\" aria-label=\"Switch No Ink\" ng-model=\"inbox.accAssCat\">Acc. Ass.Category\n</md-switch></div><div layout=\"row\" layout-align=\"start start\"><md-switch class=\"md-accent\" \nstyle=\"margin:5px !important\" aria-label=\"Switch No Ink\" ng-model=\"inbox.itemCategory\">Item Category</md-switch></div>\n<div layout=\"row\" layout-align=\"start start\"><md-switch class=\"md-accent\" style=\"margin:5px !important\" \naria-label=\"Switch No Ink\" ng-model=\"inbox.materialCode\">Material Code</md-switch></div><div layout=\"row\" \nlayout-align=\"start start\"><md-switch class=\"md-accent\" style=\"margin:5px !important\" aria-label=\"Switch No Ink\" \nng-model=\"inbox.shortText\">Short Text</md-switch></div><div layout=\"row\" layout-align=\"start start\"><md-switch \nclass=\"md-accent\" style=\"margin:5px !important\" aria-label=\"Switch No Ink\" ng-model=\"inbox.matgroupDesc\">Mat. Grp.Desc\n</md-switch></div><div layout=\"row\" layout-align=\"start start\"><md-switch class=\"md-accent\" \nstyle=\"margin:5px !important\" aria-label=\"Switch No Ink\" ng-model=\"inbox.plant\">Plant</md-switch></div><div \nlayout=\"row\" layout-align=\"start start\"><md-switch class=\"md-accent\" style=\"margin:5px !important\" \naria-label=\"Switch No Ink\" ng-model=\"inbox.purchasegroup\">Purchase Group</md-switch></div><div layout=\"row\" \nlayout-align=\"start start\"><md-switch class=\"md-accent\" style=\"margin:5px !important\" aria-label=\"Switch No Ink\" \nng-model=\"inbox.Quantity\">Quantity</md-switch></div><div layout=\"row\" layout-align=\"start start\"><md-switch \nclass=\"md-accent\" style=\"margin:5px !important\" aria-label=\"Switch No Ink\" ng-model=\"inbox.uom\">UOM</md-switch></div>\n<div layout=\"row\" layout-align=\"start start\"><md-switch class=\"md-accent\" style=\"margin:5px !important\" \naria-label=\"Switch No Ink\" ng-model=\"inbox.valprice\">Valuation Price</md-switch></div><div layout=\"row\" \nlayout-align=\"start start\"><md-switch class=\"md-accent\" style=\"margin:5px !important\" aria-label=\"Switch No Ink\" \nng-model=\"inbox.total\">Total Amount</md-switch></div></div><div layout=\"row\" class=\"md-padding\"><div layout=\"row\" \nlayout-align=\"start start\"><md-switch class=\"md-accent\" style=\"margin:5px !important\" aria-label=\"Switch No Ink\" \nng-model=\"inbox.order\">Order No</md-switch></div><div layout=\"row\" layout-align=\"start start\"><md-switch \nclass=\"md-accent\" style=\"margin:5px !important\" aria-label=\"Switch No Ink\" ng-model=\"inbox.costcenter\">Cost Center\n</md-switch></div><div layout=\"row\" layout-align=\"start start\"><md-switch class=\"md-accent\" \nstyle=\"margin:5px !important\" aria-label=\"Switch No Ink\" ng-model=\"inbox.glaccount\">G/L Account</md-switch></div><div \nlayout=\"row\" layout-align=\"start start\"><md-switch class=\"md-accent\" style=\"margin:5px !important\" \naria-label=\"Switch No Ink\" ng-model=\"inbox.functionalarea\">Functional Area</md-switch></div><div layout=\"row\" \nlayout-align=\"start start\"><md-switch class=\"md-accent\" style=\"margin:5px !important\" aria-label=\"Switch No Ink\" \nng-model=\"inbox.fund\">Fund</md-switch></div><div layout=\"row\" layout-align=\"start start\"><md-switch class=\"md-accent\" \nstyle=\"margin:5px !important\" aria-label=\"Switch No Ink\" ng-model=\"inbox.date\">Delivery Date</md-switch></div></div>\n</div></md-content></md-tab><md-tab label=\"Form Fields For Mobile\"><md-content class=\"md-padding\"><h1 class=\"reqtype\">\nHeader</h1><div layout=\"row\" class=\"md-padding\"><div layout=\"row\" layout-align=\"start start\" class=\"md-padding\">\n<md-switch class=\"md-accent\" style=\"margin:5px !important\" aria-label=\"Switch No Ink\" ng-model=\"mobile.requestedby\">\nRequestedBy</md-switch></div><div layout=\"row\" layout-align=\"start start\" class=\"md-padding\"><md-switch \nclass=\"md-accent\" style=\"margin:5px !important\" aria-label=\"Switch No Ink\" ng-model=\"mobile.doctype\">PR Doctype\n</md-switch></div></div><h1 class=\"reqtype\">LineItems</h1><div layout=\"column\"><div layout=\"row\" class=\"md-padding\">\n<div layout=\"row\" layout-align=\"start start\"><md-switch class=\"md-accent\" style=\"margin:5px !important\" \naria-label=\"Switch No Ink\" ng-model=\"mobile.accAssCat\">Acc. Ass.Category</md-switch></div><div layout=\"row\" \nlayout-align=\"start start\"><md-switch class=\"md-accent\" style=\"margin:5px !important\" aria-label=\"Switch No Ink\" \nng-model=\"mobile.itemCategory\">Item Category</md-switch></div><div layout=\"row\" layout-align=\"start start\"><md-switch \nclass=\"md-accent\" style=\"margin:5px !important\" aria-label=\"Switch No Ink\" ng-model=\"mobile.materialCode\">Material Code\n</md-switch></div><div layout=\"row\" layout-align=\"start start\"><md-switch class=\"md-accent\" \nstyle=\"margin:5px !important\" aria-label=\"Switch No Ink\" ng-model=\"mobile.shortText\">Short Text</md-switch></div><div \nlayout=\"row\" layout-align=\"start start\"><md-switch class=\"md-accent\" style=\"margin:5px !important\" \naria-label=\"Switch No Ink\" ng-model=\"mobile.matgroupDesc\">Mat. Grp.Desc</md-switch></div><div layout=\"row\" \nlayout-align=\"start start\"><md-switch class=\"md-accent\" style=\"margin:5px !important\" aria-label=\"Switch No Ink\" \nng-model=\"mobile.plant\">Plant</md-switch></div><div layout=\"row\" layout-align=\"start start\"><md-switch \nclass=\"md-accent\" style=\"margin:5px !important\" aria-label=\"Switch No Ink\" ng-model=\"mobile.purchasegroup\">\nPurchase Group</md-switch></div><div layout=\"row\" layout-align=\"start start\"><md-switch class=\"md-accent\" \nstyle=\"margin:5px !important\" aria-label=\"Switch No Ink\" ng-model=\"mobile.Quantity\">Quantity</md-switch></div><div \nlayout=\"row\" layout-align=\"start start\"><md-switch class=\"md-accent\" style=\"margin:5px !important\" \naria-label=\"Switch No Ink\" ng-model=\"mobile.uom\">UOM</md-switch></div><div layout=\"row\" layout-align=\"start start\">\n<md-switch class=\"md-accent\" style=\"margin:5px !important\" aria-label=\"Switch No Ink\" ng-model=\"pr.valprice\">\nValuation Price</md-switch></div><div layout=\"row\" layout-align=\"start start\"><md-switch class=\"md-accent\" \nstyle=\"margin:5px !important\" aria-label=\"Switch No Ink\" ng-model=\"mobile.total\">Total Amount</md-switch></div></div>\n<div layout=\"row\" class=\"md-padding\"><div layout=\"row\" layout-align=\"start start\"><md-switch class=\"md-accent\" \nstyle=\"margin:5px !important\" aria-label=\"Switch No Ink\" ng-model=\"mobile.order\">Order No</md-switch></div><div \nlayout=\"row\" layout-align=\"start start\"><md-switch class=\"md-accent\" style=\"margin:5px !important\" \naria-label=\"Switch No Ink\" ng-model=\"mobile.costcenter\">Cost Center</md-switch></div><div layout=\"row\" \nlayout-align=\"start start\"><md-switch class=\"md-accent\" style=\"margin:5px !important\" aria-label=\"Switch No Ink\" \nng-model=\"mobile.glaccount\">G/L Account</md-switch></div><div layout=\"row\" layout-align=\"start start\"><md-switch \nclass=\"md-accent\" style=\"margin:5px !important\" aria-label=\"Switch No Ink\" ng-model=\"mobile.functionalarea\">\nFunctional Area</md-switch></div><div layout=\"row\" layout-align=\"start start\"><md-switch class=\"md-accent\" \nstyle=\"margin:5px !important\" aria-label=\"Switch No Ink\" ng-model=\"mobile.fund\">Fund</md-switch></div><div \nlayout=\"row\" layout-align=\"start start\"><md-switch class=\"md-accent\" style=\"margin:5px !important\" \naria-label=\"Switch No Ink\" ng-model=\"mobile.date\">Delivery Date</md-switch></div></div></div></md-content></md-tab>\n</md-tabs></div></ms-widget-front></ms-widget></div></div></div>");
$templateCache.put("app/main/administration/list-management/list-maintenance/createlist-maintenanace-dialog.html","<md-dialog aria-label=\"Add List\"><form name=\"listForm\" novalidate \nng-submit=\"listForm.$valid && doctypeCrtl.createDocumentType()\" layout=\"column\" flex=\"66\"><md-toolbar \nclass=\"md-accent\"><div class=\"md-toolbar-tools\"><h2>Create Detail</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><div layout=\"column\"><md-input-container class=\"md-block\" flex=\"45\" \nng-repeat=\"list in attrdata track by $index\"><label>{{list.fieldname}}</label><input type=\"text\" name=\"arrval\" \nng-model=\"crlist[$index].list\" required><div ng-messages=\"listForm.list.fieldname.$error\" role=\"alert\"><div \nng-message=\"required\"><span>{{list.fieldname}} is required</span></div><div ng-message=\"pattern\"><span>\n{{list.fieldname}} has invalid characters</span></div></div></md-input-container></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" layout-align=\"center center\"><md-button type=\"button\" ng-click=\"cancel()\">Cancel\n</md-button><md-button type=\"submit\" ng-click=\"listForm.$valid && save()\">Save</md-button></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/administration/list-management/list-maintenance/list-maintenance.html","<div class=\"page-layout simple right-sidenav\" layout-gt-xs=\"row\"><div \nng-include=\"\'app/main/administration/common/admin.html\'\"></div><div class=\"widget-group scrollable\" flex=\"100\" \nlayout=\"column\" layout-wrap ms-scroll ng-init=\"requestCtrl.getRequestForms()\"><ms-widget><div \nclass=\"parent-tabs white-bg mb-15\"><md-tabs class=\"mh-0\"><md-tab label=\"List Definition\" \nui-sref=\"app.administration.lists\"></md-tab><md-tab label=\"List Maintenance\" md-active=\"true\" \nui-sref=\"app.administration.list-maintenance\"></md-tab></md-tabs><md-button ng-hide=\"showrowdata\" flow-btn \nclass=\"md-fab grey-700-bg md-mini md-fab-bottom-right add_btn\" ng-click=\"createlistmaintenanace(ev)\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon><md-tooltip md-direction=\"top\">Create Detail</md-tooltip></md-button></div><div \nclass=\"white-bg\" layout=\"row\" ng-show=\"showrowdata\" layout-wrap><div ng-repeat=\"list in listdata\" flex=\"100\" \nflex-gt-xs=\"15\" flex-gt-md=\"15\" class=\"md-padding\"><a ng-click=\"showdetail(list)\"><ms-widget flex=\"15\"><ms-widget-front\n class=\"h-170 p-16 c-p\"><div class=\"md-subhead font-weight-500 black-fg\">{{list.name}}</div><div layout=\"column\" \nlayout-align=\"space-between\" flex><div><div class=\"h6 secondary-text\">{{list.description}}</div></div></div><div \nlayout=\"row\" layout-align=\"space-between center\"><div><md-icon md-font-icon=\"icon-file-document\" class=\"s50 icon\">\n</md-icon></div></div></ms-widget-front></ms-widget></a></div></div><div ng-hide=\"showrowdata\" \nclass=\"md-padding white-bg\"><div layout=\"row\" layout-align=\"space-between center\"><div class=\"previous-state c-p\">\n<md-button ng-click=\"goback()\">Back</md-button></div><div layout=\"row\"><md-input-container><label>Select Attribute\n</label><md-select ng-model=\"searchObj.selectedAttribute\"><md-option ng-repeat=\"attr in dynamicdata1\" ng-value=\"attr\" \nng-disabled=\"attr === \'_id\'\">{{attr}}</md-option></md-select></md-input-container><md-input-container class=\"md-block\">\n<input type=\"text\" name=\"attrValue\" ng-model=\"searchObj.attributeValue\" required></md-input-container><div><md-button \ntype=\"button\" class=\"md-raised md-accent\" ng-click=\"searchListData(searchObj)\">Search</md-button></div></div></div>\n<table class=\"simple table-border\" ng-if=\"dynamicdata1 != undefined\" ms-responsive-table><thead><tr \nclass=\"table-header\"><th class=\"secondary-text\" ng-hide=\"value == \'_id\'\" ng-repeat=\"(key, value) in dynamicdata1\"><div \nclass=\"table-header\"><span class=\"column-title\">{{value}}</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\" layout=\"row\" layout-align=\"center center\"><span class=\"column-title\">Actions</span></div></th>\n</tr></thead><tbody><tr ng-repeat=\"(key, value) in tdata track by $index\"><td ng-hide=\"k == \'_id\'\" \nng-repeat=\"(k, v) in tdata[$index] track by $index\">{{v}}</td><td layout=\"row\" layout-align=\"center center\" \nstyle=\"padding-top:0px !important;padding-bottom:0px !important\"><md-button class=\"md-icon-button test-tooltip\" \naria-label=\"Update\" ng-click=\"updatedataDialog($event,tdata[$index])\"><md-tooltip md-direction=\"top\">Update\n</md-tooltip><md-icon><i layout=\"row\" layout-align=\"center center\" class=\"icon icon-pencil s18\"></i></md-icon>\n</md-button><md-button class=\"md-icon-button test-tooltip\" aria-label=\"Delete\" \nng-click=\"deletedata($event,tdata[$index]) \"><md-tooltip md-direction=\"top\">Delete</md-tooltip><md-icon><i \nlayout=\"row\" layout-align=\"center center\" class=\"icon icon-delete s18\"></i></md-icon></md-button></td></tr></tbody>\n</table><div ng-if=\"dynamicdata1 == undefined\" class=\"md-padding\"><span layout=\"row\" layout-align=\"center center\"><h2>\nNo Data Available</h2></span></div><md-divider></md-divider><div ng-if=\"dynamicdata1 != undefined\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"md-padding\"><h5>\nShowing {{(listmainCtrl.pageNumber*listmainCtrl.pageSize)+1}} - {{(listmainCtrl.pageNumber*listmainCtrl.pageSize)+listmainCtrl.pageSize}} of {{listmainCtrl.numberOfElements}} Results\n</h5></div><div layout=\"row\" layout-align=\"center center\">Page No<md-input-container class=\"md-block md-padding\" \nstyle=\"margin: 0px\"><md-select ng-model=\"pageNumber\"><md-option ng-repeat=\"pageNumber in pageNumbers\" \nng-value=\"pageNumber\" ng-click=\"sendPageNumber(pageNumber)\" value=\"listmainCtrl.pageNumber\">{{pageNumber+1}}\n</md-option></md-select></md-input-container></div><div layout=\"row\" layout-align=\"center center\"><div><md-button \nstyle=\"min-width: 0px; !important;padding:0px\" type=\"button\" ng-click=\"listmainCtrl.previous()\" \nng-disabled=\"listmainCtrl.pageNumber <= 0 \">Prev</md-button></div><p class=\"md-padding\">\n{{listmainCtrl.pageNumber+1}}/{{listmainCtrl.length}} &nbsp;PAGES</p><div class=\"md-padding\"><md-button \nstyle=\"min-width: 0px; !important;padding:0px\" type=\"button\" ng-click=\"listmainCtrl.next()\" \nng-disabled=\"listmainCtrl.pageNumber == pageNumbers.length-1 || listmainCtrl.numberOfElements == 0\">Next</md-button>\n</div></div></div></div></ms-widget></div></div>");
$templateCache.put("app/main/administration/list-management/list-maintenance/updatelistmaintenance-dialog.html","<md-dialog aria-label=\"Add List\"><form name=\"listForm\" novalidate ng-submit=\"listForm.$valid && updatedata()\" \nlayout=\"column\" flex=\"66\"><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2>Update Detail</h2><span flex>\n</span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><div layout=\"column\"><md-input-container class=\"md-block\" flex=\"45\" \nng-hide=\"key == \'_id\'\" ng-repeat=\"(key, value) in currentdata track by $index\"><label>{{key}}</label><input \ntype=\"text\" name=\"arrval\" ng-init=\"updateddata[$index] = value\" ng-model=\"updateddata[$index]\" required><div \nng-messages=\"listForm.$error\" role=\"alert\"><div ng-message=\"required\"><span>{{key}} is required</span></div><div \nng-message=\"pattern\"><span>{{key}} has invalid characters</span></div></div></md-input-container></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"center center\"><md-button type=\"button\" \nng-click=\"cancel()\">Cancel</md-button><md-button type=\"submit\" ng-click=\"updatedata()\">update</md-button>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/sites/site/todolist/site.todolist.html","<div ng-switch=\"notes.length\"><div id=\"notes\" layout=\"column\" ms-scroll flex><div ng-switch-when=\"0\" layout=\"row\" \nlayout-align=\"center center\"><div id=\"error-404\" layout=\"column\" layout-align=\"center center\"><div class=\"content\" \nlayout=\"column\" layout-align=\"center center\"><div class=\"error-code\">&nbsp;</div><div class=\"message\">\nSorry but we couldn’t find any to-do list for the \"{{siteTodoCtrl.value}}\" site.</div><div><md-button \nclass=\"md-raised md-warn\" ng-click=\"siteTodoCtrl.showConfirm()\">Add new to-do</md-button></div></div></div></div>\n<md-content ms-scroll flex><ms-masonry class=\"notes\" options=\'{\"columnCount\":4}\'><ms-masonry-item ng-switch-default \nclass=\"note\" ng-repeat=\"note in notes | orderBy: \'time\':true \" ms-note-item=\"note\" \nng-click=\"siteTodoCtrl.editNote($event, note.todolistId)\"></ms-masonry-item></ms-masonry></md-content></div></div>");
$templateCache.put("app/main/administration/user-management/users/create.user.dialog.html","<md-dialog aria-label=\"Add a new user\"><form name=\"userForm\" novalidate \nng-submit=\"userForm.$valid && userCtrl.createUser(user)\" layout=\"column\" flex=\"66\"><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools\"><h2>Create User</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\">\n<md-icon md-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><div layout=\"row\"><md-input-container class=\"md-block\" flex=\"45\">\n<label>Login Id</label><input type=\"text\" name=\"login\" ng-model=\"user.login\" required autocomplete=\"new-login\"><div \nng-messages=\"userForm.login.$error\" role=\"alert\"><div ng-message=\"required\">User ID is required</div></div>\n</md-input-container><span flex=\"10\"></span><md-input-container class=\"md-block\" flex=\"45\"><label>SAPuser Id</label>\n<input type=\"text\" name=\"sapUser\" ng-model=\"user.sapUserId\"></md-input-container></div><md-input-container \nclass=\"md-block\"><label>Email</label><input type=\"email\" name=\"email\" ng-model=\"user.email\" ng-pattern=\"re\" required>\n<div ng-messages=\"userForm.email.$error||userForm.email.$error.pattern \" role=\"alert\" multiple=\"multiple\"><div \nng-message=\"required\"><span class=\"error\">Email is required</span></div><div ng-message=\"email\"><span class=\"\">\nEmail must be a valid e-mail address</span></div><div ng-message=\"pattern\"><span class=\"\">Please enter correct domain\n</span></div></div></md-input-container><div layout=\"row\"><md-input-container class=\"md-block\" flex=\"45\"><label>\nFirst name</label><input type=\"text\" name=\"firstName\" ng-pattern=\"/^[a-zA-Z ]*$/\" ng-model=\"user.firstName\" required>\n<div ng-messages=\"userForm.firstName.$error\" role=\"alert\"><div ng-message=\"required\"><span>First Name is required\n</span></div><div ng-message=\"pattern\"><span>First Name has invalid characters</span></div></div></md-input-container>\n<span flex=\"10\"></span><md-input-container class=\"md-block\" flex=\"45\"><input type=\"text\" name=\"lastName\" \nng-pattern=\"/^[a-zA-Z ]*$/\" ng-model=\"user.lastName\" placeholder=\"Last name\"><div \nng-messages=\"userForm.lastName.$error\" role=\"alert\"><div ng-message=\"pattern\"><span>Last Name has invalid characters\n</span></div></div></md-input-container></div><div layout=\"row\" layout-align=\"start center\"><md-input-container \nclass=\"md-block\" flex=\"45\"><label>Password</label><input type=\"{{inputType}}\" name=\"password\" ng-model=\"user.password\" \nautocomplete=\"new-password\" required><div ng-messages=\"userForm.password.$error\" role=\"alert\"><div \nng-message=\"required\">Password is required</div></div></md-input-container><span flex=\"5\"></span><md-checkbox \ntype=\"checkbox\" ng-model=\"mypassword\" ng-click=\"hideShowPassword()\"><label for=\"checkbox\" ng-if=\"mypassword\">Hide\n</label><label for=\"checkbox\" ng-if=\"!mypassword\">Show</label></md-checkbox></div><div layout=\"row\"><md-input-container\n flex=\"45\"><label>Select Authority</label><md-select name=\"Authority\" ng-model=\"user.authorities\" multiple=\"multiple\" \nrequired><md-option ng-value=\"authority\" ng-repeat=\"authority in roles\" ng-selected=\"$first\">\n{{ authority.replace(\"ROLE_USER\",\"User\").replace(\"ROLE_ADMIN\",\"Admin\").replace(\"ROLE_TICKETMANAGER\",\"TicketManager\").replace(\"ROLE_AUDITOR\",\"Auditor\").replace(\"ROLE_BUSINESS_ADMIN\",\"BusinessAdmin\") }}\n</md-option></md-select><div ng-messages=\"userForm.Authority.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nAuthority is required</span></div></div></md-input-container><span flex=\"10\"></span><md-switch \nng-model=\"user.activated\" aria-label=\" Activate User\">Activate User</md-switch></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" layout-align=\"center center\"><md-button type=\"button\" ng-click=\"cancel()\">Cancel\n</md-button><md-button type=\"submit\" ng-click=\"userForm.$valid && save(user)\">Save</md-button></md-dialog-actions>\n</form></md-dialog>");
$templateCache.put("app/main/administration/user-management/users/resetpassword.html","<md-dialog flex=\"35\"><form name=\"passwordForm\" novalidate layout=\"column\"><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools\"><h2>Reset Password</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"cancel()\"><md-icon md-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"column\" \nlayout-align=\"center center\"><md-input-container class=\"md-block\"><md-icon md-font-icon=\"icon-key-variant\" \nstyle=\"color: rgb(5, 167, 253) !important\"></md-icon><input type=\"password\" name=\"password\" ng-model=\"user.password\" \nplaceholder=\"Enter Password*\" required><div ng-messages=\"passwordForm.password.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Password field is required</span></div></div></md-input-container><md-input-container \nclass=\"md-block\"><md-icon md-font-icon=\"icon-key-variant\" style=\"color: rgb(5, 167, 253) !important\"></md-icon><input \ntype=\"password\" name=\"passwordConfirm\" ng-model=\"user.passwordConfirm\" placeholder=\"Re-enter Password*\" required> <span\n style=\"color: red;font-family: \'Roboto\';font-size: 12px\" ng-show=\"user.password !== user.passwordConfirm\">\nPasswords do not match</span><div ng-messages=\"passwordForm.passwordConfirm.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Re-enter Password field is required</span></div></div></md-input-container></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"center center\"><md-button type=\"button\" \nng-click=\"cancel()\">Cancel</md-button><md-button type=\"submit\" \nng-click=\"passwordForm.$valid && resetPasswordfinish(user.password,key)\">Save</md-button></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/administration/user-management/users/update.user.dialog.html","<md-dialog aria-label=\"Update a user\"><form name=\"userUpdateForm\" novalidate \nng-submit=\"userUpdateForm.$valid && update(currentUser)\" layout=\"column\" flex=\"66\"><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools\"><h2>Update User:{{currentUser.login}}</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"cancel()\"><md-icon md-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content layout=\"column\"><div \nlayout=\"row\"><md-input-container><input type=\"text\" disabled=\"true\" name=\"login\" ng-model=\"currentUser.login\" \nplaceholder=\"Login Id\" required></md-input-container><md-input-container><input type=\"text\" name=\"sapUser\" \nng-model=\"currentUser.sapUserId\" placeholder=\"SAPuser Id\"></md-input-container></div><md-input-container \nclass=\"md-block\"><input type=\"email\" name=\"email\" ng-model=\"currentUser.email\" placeholder=\"Email\" required>\n</md-input-container><div layout=\"row\"><md-input-container class=\"md-block\" flex=\"45\"><input type=\"text\" \nname=\"firstName\" ng-pattern=\"/^[a-zA-Z ]*$/\" ng-model=\"currentUser.firstName\" placeholder=\"First name\" required><div \nng-messages=\"userUpdateForm.firstName.$error\" role=\"alert\"><div ng-message=\"required\"><span>First Name is required\n</span></div><div ng-message=\"pattern\"><span>First Name has invalid characters</span></div></div></md-input-container>\n<span flex=\"10\"></span><md-input-container class=\"md-block\" flex=\"45\"><input type=\"text\" name=\"lastName\" \nng-pattern=\"/^[a-zA-Z ]*$/\" ng-model=\"currentUser.lastName\" placeholder=\"Last name\"><div \nng-messages=\"userUpdateForm.lastName.$error\" role=\"alert\"><div ng-message=\"pattern\"><span>\nLast Name has invalid characters</span></div></div></md-input-container></div><div layout=\"row\"><md-input-container \nclass=\"md-block\" flex=\"45\"><label>Select Authority</label><md-select name=\"Authority\" \nng-model=\"currentUser.authorities\" multiple=\"multiple\" required><md-option ng-value=\"authority\" \nng-repeat=\"authority in roles\">\n{{authority.replace(\"ROLE_USER\",\"User\").replace(\"ROLE_ADMIN\",\"Admin\").replace(\"ROLE_TICKETMANAGER\",\"TicketManager\").replace(\"ROLE_AUDITOR\",\"Auditor\").replace(\"ROLE_BUSINESS_ADMIN\",\"BusinessAdmin\")}}\n</md-option></md-select><div ng-messages=\"userUpdateForm.Authority.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>Authority is required</span></div></div></md-input-container><span flex=\"10\"></span><md-switch \nng-model=\"currentUser.activated\" aria-label=\" Activate User\">Activate User</md-switch></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" layout-align=\"center center\"><md-button ng-click=\"cancel()\">Cancel</md-button>\n<md-button type=\"submit\" ng-click=\"userUpdateForm.$valid && update(currentUser)\">Update</md-button></md-dialog-actions>\n</form></md-dialog>");
$templateCache.put("app/main/administration/user-management/users/users.html","<style>table.dataTable tbody td {\n vertical-align: middle;\n    padding: 0px;\n}</style><div \nclass=\"page-layout simple right-sidenav\" layout=\"row\"><div ng-include=\"\'app/main/administration/common/admin.html\'\">\n</div><div class=\"page-layout carded fullwidth md-padding scrollable\" layout=\"column\" flex ms-scroll><div \nclass=\"widget-group\" flex=\"100\" layout=\"column\" layout-wrap><ms-widget flippable=\"true\" class=\"no-padding\"><div \nclass=\"parent-tabs white-bg mb-15\"><md-tabs class=\"mh-0\"><md-tab label=\"Users\" ui-sref=\"app.administration.users\" \nmd-active=\"true\"></md-tab><md-tab label=\"Groups\" ui-sref=\"app.administration.groups\"></md-tab><md-tab \nlabel=\"UserUpload\" ui-sref=\"app.administration.userupload\"></md-tab></md-tabs></div><div class=\"md-padding white-bg\">\n<div layout=\"row\" flex=\"100\" layout=\"row\" layout-align=\"end end\"><md-input-container flex-gt-sm=\"15\" class=\"md-block\" \nstyle=\"border: 1px solid rgb(169, 161, 161);margin-top: 0%;border-radius: 5px;height: 35px;margin-right: 1%\"><md-icon \nmd-font-icon=\"icon-magnify\"></md-icon><input ng-model=\"searchUser\" type=\"text\" placeholder=\"Global Filter\">\n</md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"5\"><label>Size</label><md-select \nng-change=\"sizeselect(size)\" ng-model=\"size\"><md-option value=\"100\">100</md-option><md-option value=\"200\">200\n</md-option><md-option value=\"400\">400</md-option><md-option value=\"500\">500</md-option><md-option value=\"600\">600\n</md-option><md-option value=\"700\">700</md-option><md-option value=\"800\">800</md-option><md-option value=\"900\">900\n</md-option><md-option value=\"1000\">1000</md-option><md-option value=\"1200\">1200</md-option></md-select>\n</md-input-container></div><table class=\"dataTable row-border hover table-border\"><thead><tr class=\"table-header\"><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Login</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">First Name</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Last Name</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Email</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Authorities</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Activated</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\" layout=\"row\" layout-align=\"center center\"><span class=\"column-title\">\nActions</span></div></th></tr></thead><tbody><tr ng-repeat=\"user in usersList | filter : searchUser\"><td>{{user.login}}\n</td><td>{{user.firstName}}</td><td>{{user.lastName}}</td><td>{{user.email}}</td><td><span \nclass=\"text-boxed green-bg white-fg\" ng-show=\"{{user.authorities.indexOf(\'ROLE_USER\') != -1}}\">User</span> <span \nclass=\"text-boxed orange-bg white-fg\" ng-show=\"{{user.authorities.indexOf(\'ROLE_ADMIN\') != -1}}\">Admin</span> <span \nclass=\"text-boxed pink-bg white-fg\" ng-show=\"{{user.authorities.indexOf(\'ROLE_AUDITOR\') != -1}}\">Auditor</span> <span \nclass=\"text-boxed blue-bg white-fg\" ng-show=\"{{user.authorities.indexOf(\'ROLE_TICKETMANAGER\') != -1}}\">Ticket Manager\n</span> <span class=\"text-boxed blue-bg white-fg\" ng-show=\"{{user.authorities.indexOf(\'ROLE_BUSINESS_ADMIN\') != -1}}\">\nBusiness Admin</span></td><td style=\"padding-top:0px !important;padding-bottom:0px !important\"><i \nclass=\"icon-checkbox-marked-circle green-500-fg\" ng-show=\"{{user.activated}}\"></i> <i class=\"icon-cancel red-500-fg\" \nng-show=\"{{! user.activated}}\"></i></td><td layout=\"row\" layout-align=\"center center\"><md-button \nclass=\"md-icon-button test-tooltip\" aria-label=\"Update\" ng-click=\"updateUserDialog($event,user)\"><md-tooltip \nmd-direction=\"top\">Update</md-tooltip><md-icon><i layout=\"row\" layout-align=\"center center\" \nclass=\"icon icon-pencil s18\"></i></md-icon></md-button><md-button class=\"md-icon-button test-tooltip\" \naria-label=\"Delete\" ng-click=\"userCtrl.deleteUser($event, user) \"><md-tooltip md-direction=\"top\">Delete</md-tooltip>\n<md-icon><i layout=\"row\" layout-align=\"center center\" class=\"icon icon-delete s18\"></i></md-icon></md-button><md-button\n class=\"md-icon-button test-tooltip\" aria-label=\"Delete\" ng-click=\"userCtrl.resetPassword(user.email)\"><md-tooltip \nmd-direction=\"top\">Reset Password</md-tooltip><md-icon><i layout=\"row\" layout-align=\"center center\" \nclass=\"icon-account-key s20\"></i></md-icon></md-button><md-button class=\"md-icon-button test-tooltip\" \naria-label=\"Delete\" ng-click=\"userCtrl.ChangePassword($event,user.login)\"><md-tooltip md-direction=\"top\">\nChange Password</md-tooltip><md-icon><i layout=\"row\" layout-align=\"center center\" class=\"icon-key-variant s20\"></i>\n</md-icon></md-button></td></tr></tbody></table><div layout=\"row\" layout-align=\"space-between center\" flex=\"100\"><div \nlayout=\"row\" layout-align=\"center center\">Page No<md-input-container class=\"md-block md-padding\" style=\"margin: 0px\">\n<md-select ng-model=\"pageNumber\"><md-option ng-repeat=\"pageNumber in pageNumbers\" ng-value=\"pageNumber\" \nng-click=\"sendPageNumber(pageNumber)\" value=\"pageNumber\" ng-selected=\"$first\">{{pageNumber+1}}</md-option></md-select>\n</md-input-container></div><div layout=\"row\"><p class=\"md-padding\"><b>{{pageNumber+1}}/{{totalPages}} &nbsp;PAGES</b>\n</p></div><div layout=\"row\" layout-align=\"center center\"><div class=\"md-padding\"><h5><b>\nShowing {{(isNaN(pageNumber*size))+1}} - {{(pageNumber + 1)*size}} of {{totalRecords}} Results</b></h5></div><div>\n<md-button class=\"md-raised md-primary\" type=\"button\" ng-click=\"previous()\" ng-disabled=\"pageNumber <= 0\">Prev\n</md-button></div><div class=\"md-padding\"><md-button class=\"md-raised md-primary\" type=\"button\" ng-click=\"next()\" \nng-disabled=\"pageNumber ==totalPages -1\">Next</md-button></div></div></div></div></ms-widget></div><md-button flow-btn \nclass=\"md-fab grey-700-bg md-mini md-fab-bottom-right add_btn\" aria-label=\"Create User\" \nng-click=\"createUserDialog($event)\"><md-icon md-font-icon=\"icon-plus\"></md-icon><md-tooltip md-direction=\"top\">\nCreate User</md-tooltip></md-button></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-10/template-10.html","<div class=\"template-10 p-16\"><div class=\"pb-16\" layout=\"row\" layout-align=\"space-between center\"><div class=\"info\">\n<div class=\"title secondary-text\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle h2\" \nng-if=\"card.subtitle\">{{card.subtitle}}</div></div><div class=\"media ml-16\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div><div \nclass=\"text\">{{card.text}}</div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-2/template-2.html","<div class=\"template-2\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"card.avatar\"><img\n class=\"avatar mr-16\" ng-src=\"{{card.avatar.src}}\" alt=\"{{card.avatar.alt}}\"></div><div class=\"info\"><div \nclass=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div></div></div><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"text p-16\" ng-if=\"card.text\">{{card.text}}\n</div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-3/template-3.html","<div class=\"template-3 p-16 teal-bg white-fg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" \nlayout-align=\"space-between\"><div class=\"info\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}</div><div \nclass=\"subtitle h3 secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div></div><div class=\"cta\"><md-button \nclass=\"m-0\">{{card.cta}}</md-button></div></div><div class=\"media pl-16\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-4/template-4.html","<div class=\"template-4\"><div class=\"info white-fg ph-16 pv-24\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}\n</div><div class=\"text\" ng-if=\"card.text\">{{card.text}}</div></div><div class=\"media\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-5/template-5.html","<div class=\"template-5 p-16\" layout=\"row\" layout-align=\"space-between start\"><div class=\"info\"><div \nclass=\"title secondary-text\" ng-if=\"card.title\">{{card.title}}</div><div class=\"event h2\" ng-if=\"card.event\">\n{{card.event}}</div></div><div class=\"media ml-16\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-6/template-6.html","<div class=\"template-6\"><div class=\"content pv-24 ph-16\"><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div><div class=\"title h2\" ng-if=\"card.title\">{{card.title}}</div><div class=\"text pt-8\" \nng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-7/template-7.html","<div class=\"template-7\" layout=\"row\" layout-align=\"space-between\"><div class=\"info\" layout=\"column\" \nlayout-align=\"space-between\" layout-fill flex><div class=\"p-16\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}\n</div><div class=\"subtitle h4 secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div><div class=\"text h4 pt-8\" \nng-if=\"card.text\">{{card.text}}</div></div><div><md-divider></md-divider><div class=\"p-8\" layout=\"row\"><md-icon \nmd-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\">\n</md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" \nclass=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon></div></div></div><div \nclass=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" \nng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-8/template-8.html","<div class=\"template-8\"><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"content pv-24 ph-16\"><div class=\"title h1\" \nng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}\n</div><div class=\"buttons pt-16\"><md-button class=\"m-0\">{{card.button1}}</md-button><md-button class=\"m-0 md-accent\">\n{{card.button2}}</md-button></div><div class=\"text pt-16\" ng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-9/template-9.html","<div class=\"template-9\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"card.avatar\"><img\n class=\"avatar mr-16\" ng-src=\"{{card.avatar.src}}\" alt=\"{{card.avatar.alt}}\"></div><div class=\"info\"><div \nclass=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div></div></div><div class=\"text ph-16 pb-16\" ng-if=\"card.text\">{{card.text}}</div><div \nclass=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" \nng-show=\"card.media.image\"></div><div class=\"buttons m-8\"><md-button class=\"md-icon-button mr-16\" \naria-label=\"Favorite\"><md-icon md-font-icon=\"icon-heart-outline\" class=\"s24\"></md-icon></md-button><md-button \nclass=\"md-icon-button\" aria-label=\"Share\"><md-icon md-font-icon=\"icon-share\" class=\"s24\"></md-icon></md-button></div>\n</div>");
$templateCache.put("app/core/directives/ms-stepper/templates/horizontal/horizontal.html","<div class=\"ms-stepper-horizontal\"><div class=\"ms-stepper-navigation-wrapper\"><div class=\"ms-stepper-navigation\" \nlayout=\"row\" layout-align=\"center center\"><md-button class=\"ms-stepper-navigation-item\" \nng-class=\"{\'current\': MsStepper.isStepCurrent(step.stepNumber), \'valid\': MsStepper.isStepValid(step.stepNumber), \'disabled\': MsStepper.isStepDisabled(step.stepNumber), \'optional\': MsStepper.isStepOptional(step.stepNumber)}\" \nng-click=\"MsStepper.gotoStep(step.stepNumber)\" ng-disabled=\"MsStepper.isStepDisabled(step.stepNumber)\" \nng-repeat=\"step in MsStepper.steps | filter:MsStepper.filterHiddenStep\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"step md-accent-bg\" layout=\"row\" layout-align=\"center center\"><span \nng-if=\"!MsStepper.isStepValid(step.stepNumber) || MsStepper.isStepOptional(step.stepNumber)\">{{$index + 1}} </span>\n<span ng-if=\"MsStepper.isStepValid(step.stepNumber) && !MsStepper.isStepOptional(step.stepNumber)\"><i \nclass=\"icon icon-check s18\"></i></span></div><div layout=\"column\" layout-align=\"start start\"><div class=\"title\">\n{{step.stepTitle}}</div><div class=\"subtitle\" ng-if=\"MsStepper.isStepOptional(step.stepNumber)\">Optional</div></div>\n</md-button></div></div><div class=\"ms-stepper-steps\" ng-transclude></div><div class=\"ms-stepper-controls\" \nlayout=\"row\" layout-align=\"center center\"><md-button class=\"md-accent md-raised\" ng-disabled=\"MsStepper.isFirstStep()\" \nng-click=\"MsStepper.gotoPreviousStep()\">Back</md-button><div class=\"ms-stepper-dots\"><span \nng-repeat=\"step in MsStepper.steps\" ng-hide=\"MsStepper.isStepHidden(step.stepNumber)\" \nng-class=\"{\'selected md-accent-bg\':MsStepper.currentStepNumber === $index + 1}\"></span></div><md-button \nclass=\"md-accent md-raised\" ng-if=\"!MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isStepValid(MsStepper.currentStepNumber)\" ng-click=\"MsStepper.gotoNextStep()\">Next</md-button>\n<md-button type=\"submit\" class=\"md-accent md-raised\" ng-click=\"MsStepper.resetForm()\" ng-if=\"MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isFormValid()\">Submit</md-button></div></div>");
$templateCache.put("app/core/directives/ms-stepper/templates/vertical/vertical.html","<div class=\"ms-stepper-vertical\"><div class=\"ms-stepper-vertical-line\"></div><div class=\"ms-stepper-steps\" \nng-transclude></div></div>");
$templateCache.put("app/main/administration/user-management/user-upload/userupload.html","<style>\ntable, th , td  {\n  border: 1px solid grey;\n  border-collapse: collapse;\n  padding: 5px;\n  width:50px;\n  height:50px;\n  \n}\ntable tr:nth-child(odd) {\n  background-color: #f1f1f1;\n}\ntable tr:nth-child(even) {\n  background-color: #ffffff;\n}\n\n.mh-0 {\n    min-height: 0px !important;\n}\n.parent-tabs > md-tabs .md-tab.md-active:after{\n    content: \" \";\n    border-left: 7px solid transparent;\n    border-right: 7px solid transparent;\n    border-bottom: 7px solid #efefef;\n    position: absolute;\n    display: block;\n    top: 87%;\n    left: 50%;\n  \n}\n.parent-tabs > md-tabs md-ink-bar {\n    background: none; \n}\n.parent-tabs > md-tabs .md-tab:hover {\n    color: #389cec !important;\n}\n\n.md-tab {\n  \n  text-transform: none;\n  }\n\n#collapse1{\noverflow-y:scroll;\nheight:200px;\n}\n\n\n.md-button {\n  padding: 0 6px 0 6px;\n  margin: 6px 8px 6px 8px;\n  min-width: 88px;\n  border-radius: 3px;\n  font-size: 14px;\n  text-align: center;\n  text-transform: uppercase;\n  text-decoration:none;\n  border: none;\n  outline: none;\n}\n</style><div class=\"page-layout simple right-sidenav\" layout=\"row\"><div \nng-include=\"\'app/main/administration/common/admin.html\'\"></div><div \nclass=\"page-layout carded fullwidth md-padding scrollable\" layout=\"column\" flex ms-scroll><div class=\"widget-group\" \nflex=\"100\" layout=\"column\" layout-wrap><ms-widget flippable=\"true\" class=\"no-padding\"><div \nclass=\"parent-tabs white-bg mb-15\"><md-tabs class=\"mh-0\"><md-tab label=\"Users\" ui-sref=\"app.administration.users\">\n</md-tab><md-tab label=\"Groups\" ui-sref=\"app.administration.groups\"></md-tab><md-tab label=\"UserUpload\" \nui-sref=\"app.administration.userupload\" md-active=\"true\"></md-tab></md-tabs></div><div \nclass=\"page-layout carded fullwidth md-padding scrollable white-bg\" layout=\"column\" flex ms-scroll md-dynamic-height>\n<div layout=\"row\" layout-align=\"end end\"><section layout=\"row\" layout-sm=\"column\" layout-align=\"end end\" layout-wrap>\n<div><input type=\"file\" id=\"fileUpload\" onchange=\"angular.element(this).scope().setAttachmentFile(this)\"></div>\n<md-button ng-click=\"Upload()\">Upload</md-button><md-button class=\"md-warn\" ng-click=\"clear()\">Clear</md-button>\n<md-button class=\"md-accent\" ng-click=\"Save()\" ng-if=\"save\">Save</md-button></section></div><div class=\"scrollable\" \nms-scroll><table><tbody id=\"dvCSV\"></tbody></table></div></div></ms-widget></div></div></div>");
$templateCache.put("app/main/administration/user-management/groups/addGroupMemberDialog.html","<md-dialog ng-cloak flex=\"60\"><form name=\"groupsCtrl.memberForm\" role=\"form\" novalidate ng-submit=\" \"><md-toolbar \nlayout=\"row\" class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2>Add Member</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"ok()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content layout=\"column\" layout-align=\"center center\"><div layout=\"row\" layout-align=\"space-between center\" \nstyle=\"width:100%\"><md-input-container class=\"md-block\"><input type=\"text\" name=\"name\" ng-model=\"member.name\" \nplaceholder=\"Name\"></md-input-container><md-input-container class=\"md-block\"><input type=\"text\" name=\"email\" \nng-model=\"member.email\" placeholder=\"Email\"></md-input-container><md-button type=\"button\" class=\"md-raised\" \nng-click=\"searchMember(member)\" style=\"margin-bottom: 20px\"><md-icon md-font-icon=\"icon-magnify\"></md-icon>Search\n</md-button></div><div layout=\"row\" ng-style=\"{\'color\':\'red\',\'font-family\':\'Roboto\',\'font-size\':\'12px\'}\" \nng-show=\"msgVisibility\">Please enter either name or email</div><div ng-show=\"tableVisibility\" \nclass=\"scrollable md-padding\" ms-scroll><table><thead><tr><th class=\"secondary-text md-padding\"><div \nclass=\"table-header\"><span class=\"column-title\">NAME</span></div></th><th class=\"secondary-text md-padding\"><div \nclass=\"table-header\"><span class=\"column-title\">EMAIL</span></div></th></tr></thead><tbody \nng-repeat=\"member in searchedMembers\"><tr ng-repeat=\"user in member\"><td class=\"md-padding\">\n{{user.firstName}} {{user.lastName}}</td><td class=\"md-padding\">{{user.email}}</td><td layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-accent md-raised\" ng-click=\"addGroupMember(user) \">ADD</md-button>\n</td></tr></tbody></table></div></md-dialog-content></form><md-dialog-actions layout=\"row\"><span flex></span><md-button\n ng-click=\"cancel(member)\">Cancel</md-button><md-button ng-click=\"ok()\" md-autofocus>Ok</md-button></md-dialog-actions>\n</md-dialog>");
$templateCache.put("app/main/administration/user-management/groups/createGroupDialog.html","<md-dialog aria-label=\"Create a new Group\" flex=\"20\"><form name=\"groupForm\" novalidate ng-submit=\"\" layout=\"column\">\n<md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2>Create Group</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"close()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><md-input-container class=\"md-block\"><label>Group name</label><input \ntype=\"text\" name=\"name\" ng-model=\"group.name\" required><div ng-messages=\"groupForm.name.$error\" role=\"alert\"><div \nng-message=\"required\">Group name is required</div></div></md-input-container><md-input-container class=\"md-block\">\n<input type=\"text\" name=\"description\" ng-model=\"group.description\" placeholder=\"Description\"></md-input-container>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"center center\"><md-button ng-click=\"cancel()\">Cancel\n</md-button><md-button type=\"submit\" ng-click=\"groupForm.$valid && createGroup(group)\">Save</md-button>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/administration/user-management/groups/editGroupDialog.html","<md-dialog aria-label=\"Create a new Group\" flex=\"20\"><form name=\"groupForm\" novalidate ng-submit=\"\" layout=\"column\">\n<md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2>Edit Group</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"close()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><md-input-container class=\"md-block\"><input type=\"text\" name=\"name\" \nng-model=\"currentGroup.name\" placeholder=\"Group name\" required><div ng-messages=\"groupForm.name.$error\" role=\"alert\">\n<div ng-message=\"required\">Group name is required</div></div></md-input-container><md-input-container class=\"md-block\">\n<input type=\"text\" name=\"description\" ng-model=\"currentGroup.description\" placeholder=\"Description\">\n</md-input-container></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"center center\"><md-button \nng-click=\"cancel()\">Cancel</md-button><md-button type=\"submit\" ng-click=\" EditGroup(currentGroup)\">Save</md-button>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/administration/user-management/groups/groups.html","<div class=\"page-layout simple right-sidenav\" layout-gt-xs=\"row\"><div \nng-include=\"\'app/main/administration/common/admin.html\'\"></div><div \nclass=\"page-layout carded fullwidth md-padding scrollable\" layout=\"column\" flex ms-scroll><div class=\"widget-group\" \nflex=\"100\" layout=\"column\" layout-wrap><ms-widget flippable=\"true\" class=\"no-padding\"><div \nclass=\"parent-tabs white-bg mb-15\"><md-tabs class=\"mh-0\"><md-tab label=\"Users\" ui-sref=\"app.administration.users\">\n</md-tab><md-tab label=\"Groups\" ui-sref=\"app.administration.groups\" md-active=\"true\"></md-tab><md-tab \nlabel=\"UserUpload\" ui-sref=\"app.administration.userupload\"></md-tab></md-tabs></div><div \nclass=\"page-layout carded fullwidth md-padding scrollable white-bg\" layout=\"column\" flex ms-scroll md-dynamic-height \nng-if=\"!viewGroupMember\"><div class=\"search\" layout=\"row\" layout-align=\"center center\"><span flex=\"100\">\n<md-input-container class=\"no-margin pull-right\"><md-icon md-font-icon=\"icon-magnify\"></md-icon><input \nng-model=\"searchGroup\" type=\"text\" placeholder=\"Search...\"></md-input-container></span></div><div layout=\"row\" \nlayout-wrap><div layout=\"row\" flex=\"100\" layout-align=\"center center\" ng-if=\"totalGroups<1\" \nstyle=\"border:2px solid rgb(97, 149, 232)\"><p><b>No Groups are available.</b></p></div><div \nng-repeat=\"eachGroup in groupsCtrl.allGroups | filter : searchGroup\" flex=\"100\" flex-gt-xs=\"25\" flex-gt-md=\"20\">\n<md-card style=\"height:190px\"><div layout=\"column\" layout-align=\"space-between\" flex class=\"c-p\" \nng-click=\"groupsCtrl.selectGroup(eachGroup)\" md-theme=\"{{getAnotherColor($index)}}\"><md-tooltip md-direction=\"top\">\n{{eachGroup.description}}</md-tooltip><div class=\"white-fg md-padding\" layout=\"row\" layout-align=\"center center\" \nng-style=\"{\'height\':\'150px\'}\" style=\"background-color: {{getAnotherColor($index)}}\"><md-icon \nmd-font-icon=\"icon-account-multiple\" class=\"s64 white-fg\"></md-icon></div></div><div><md-divider></md-divider><div \nclass=\"text\" style=\"text-align: center\"><md-button class=\"md-icon-button test-tooltip\" \nng-click=\"groupsCtrl.editGroup($event,eachGroup)\"><md-tooltip md-direction=\"top\">Edit Group</md-tooltip><md-icon><i \nlayout=\"row\" layout-align=\"center center\" class=\"icon icon-pencil s20\"></i></md-icon></md-button><a class=\"c-p\" \nng-click=\"groupsCtrl.selectGroup(eachGroup)\">{{eachGroup.name}}</a><md-button class=\"md-icon-button test-tooltip\" \nng-click=\"groupsCtrl.deleteGroup(eachGroup)\"><md-tooltip md-direction=\"top\">Delete Group</md-tooltip><md-icon><i \nlayout=\"row\" layout-align=\"center center\" class=\"icon icon-delete s20\"></i></md-icon></md-button></div></div></md-card>\n</div></div></div><div class=\"page-layout carded fullwidth md-padding scrollable white-bg\" \ndata-ng-if=\"viewGroupMember\"><div class=\"md-padding\" layout=\"row\"><span class=\"md-active c-p\" \ndata-ng-click=\"goBackToGroup();\" style=\"display: inherit\"><md-icon md-font-icon=\"icon-arrow-left md-active s16\">\n</md-icon>Go back</span></div><table class=\"dataTable row-border hover table-border\" datatable=\"ng\" \ndt-options=\"dtOptions\"><thead><tr class=\"table-header\"><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">First Name</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Last Name</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Email</span></div></th><th class=\"secondary-text\"><div class=\"table-header\" layout=\"row\" \nlayout-align=\"center center\"><span class=\"column-title\">Actions</span></div></th></tr></thead><tbody><tr \nng-repeat=\"eachGroup in groupObj.members | filter : searchUser\"><td>{{eachGroup.firstName}}</td><td>\n{{eachGroup.lastName}}</td><td>{{eachGroup.email}}</td><td layout=\"row\" layout-align=\"center center\" \nstyle=\"padding-top:0px !important;padding-bottom:0px !important\"><md-button class=\"md-icon-button test-tooltip\" \naria-label=\"Delete\" ng-click=\"groupsCtrl.deleteGroupMember(groupObj, $index)\"><md-tooltip md-direction=\"top\">Delete\n</md-tooltip><md-icon><i layout=\"row\" layout-align=\"center center\" class=\"icon icon-delete s18\"></i></md-icon>\n</md-button></td></tr></tbody></table></div></ms-widget></div><md-button flow-btn \nclass=\"md-fab grey-700-bg md-mini md-fab-bottom-right\" ng-click=\"groupsCtrl.createGroupDialog($event)\" \nng-if=\"!viewGroupMember\"><md-icon md-font-icon=\"icon-plus\"></md-icon><md-tooltip md-direction=\"top\">Create Group\n</md-tooltip></md-button><md-button flow-btn class=\"md-fab grey-700-bg md-mini md-fab-bottom-right add_btn\" \nng-click=\"groupsCtrl.addMemberDialog($event, groupObj)\" ng-if=\"viewGroupMember\"><md-icon md-font-icon=\"icon-plus\">\n</md-icon><md-tooltip md-direction=\"top\">Add Group Member</md-tooltip></md-button></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-1/template-1.html","<div class=\"template-1\"><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"content pv-24 ph-16\"><div class=\"title h1\" \nng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}\n</div><div class=\"text pt-16\" ng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-stepper/templates/vertical/step/vertical-step.html","<md-button class=\"ms-stepper-navigation-item\" \nng-class=\"{\'current\': MsStepper.isStepCurrent(stepInfo.stepNumber), \'valid\': MsStepper.isStepValid(stepInfo.stepNumber), \'disabled\': MsStepper.isStepDisabled(stepInfo.stepNumber), \'optional\': MsStepper.isStepOptional(stepInfo.stepNumber)}\" \nng-click=\"MsStepper.gotoStep(stepInfo.stepNumber)\" ng-disabled=\"MsStepper.isStepDisabled(stepInfo.stepNumber)\" \nng-hide=\"MsStepper.isStepHidden(stepInfo.stepNumber)\" layout=\"row\" layout-align=\"start center\"><div class=\"step\" \nlayout=\"row\" layout-align=\"center center\"><span \nng-if=\"!MsStepper.isStepValid(stepInfo.stepNumber) || MsStepper.isStepOptional(stepInfo.stepNumber)\"><i \nclass=\"icon icon-checkbox-blank-circle-outline s18 md-accent-fg\"></i> </span><span \nng-if=\"MsStepper.isStepValid(stepInfo.stepNumber) && !MsStepper.isStepOptional(stepInfo.stepNumber)\"><i \nclass=\"icon icon-check-circle s18 md-accent-fg\"></i></span></div><div layout=\"column\" layout-align=\"start start\"><div \nclass=\"title\">{{stepInfo.stepTitle}}</div><div class=\"subtitle\" ng-if=\"MsStepper.isStepOptional(stepInfo.stepNumber)\">\nOptional</div></div></md-button><div class=\"ms-stepper-step-content\" ng-transclude></div><div \nclass=\"ms-stepper-controls\" layout=\"row\" layout-align=\"start center\" \nng-show=\"MsStepper.isStepCurrent(stepInfo.stepNumber)\"><md-button class=\"md-accent md-raised\" \nng-disabled=\"MsStepper.isFirstStep()\" ng-click=\"MsStepper.gotoPreviousStep()\">Back</md-button><md-button \nclass=\"md-accent md-raised\" ng-if=\"!MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isStepValid(MsStepper.currentStepNumber)\" ng-click=\"MsStepper.gotoNextStep()\">Next</md-button>\n<md-button type=\"submit\" class=\"md-accent md-raised\" ng-click=\"MsStepper.resetForm()\" ng-if=\"MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isFormValid()\">Submit</md-button></div>");
$templateCache.put("app/main/sites/site/todolist/directives/ms-new-note/ms-new-note.html","<ms-note-form note-type=\"\'new\'\"></ms-note-form>");
$templateCache.put("app/main/sites/site/todolist/directives/ms-note-form/ms-note-form.html","<div><form ng-submit=\"MsNoteForm.submit()\" ng-class=\"MsNoteForm.note.color\"><input type=\"text\" \nclass=\"note-title-input\" placeholder=\"Name\" ng-model=\"MsNoteForm.note.name\" ng-class=\"MsNoteForm.note.color\">\n<md-input-container md-no-float ng-class=\"MsNoteForm.note.color\"><textarea type=\"text\" \nclass=\"note-description-textarea\" placeholder=\"Description\" ng-model=\"MsNoteForm.note.description\">\n      </textarea>\n</md-input-container><md-list class=\"checklist\" ng-if=\"MsNoteForm.note.actions.length > 0\"><md-divider></md-divider>\n<md-list-item ng-repeat=\"item in MsNoteForm.note.actions\"><md-checkbox ng-model=\"item.completed\" \naria-label=\"toggle check\"></md-checkbox><p ng-class=\"{\'text-strike md-secondary-text\':item.completed}\">\n{{item.description}}</p><md-icon ng-click=\"MsNoteForm.deleteCheckItem(item)\" class=\"md-secondary\" \nmd-font-icon=\"icon-close-circle\" aria-label=\"remove\"></md-icon><md-divider></md-divider></md-list-item></md-list><div \nclass=\"checklist-form\" ng-if=\"MsNoteForm.note.actions.length > 0 || MsNoteForm.checkListForm\" layout=\"row\" \nlayout-align=\"space-between end\"><md-input-container class=\"\" md-no-float flex><input id=\"new-checklist-item-input\" \ntype=\"text\" placeholder=\"New Action\" ng-model=\"MsNoteForm.newCheckListItem\" \nng-keydown=\"$event.keyCode === 13 ? + MsNoteForm.addChecklistItem():\'\';\"></md-input-container><md-button \nclass=\"md-icon-button\" ng-click=\"MsNoteForm.addChecklistItem()\" aria-label=\"add\"><md-icon md-font-icon=\"icon-plus\">\n</md-icon></md-button></div><div class=\"footer\" layout-gt-xs=\"row\" layout-align-gt-xs=\"space-between center\" \nlayout=\"column\" layout-align=\"center center\"><div class=\"actions\" layout=\"row\" layout-align=\"center center\" \nlayout-wrap><md-button class=\"md-icon-button\" aria-label=\"checklist\" ng-click=\"MsNoteForm.checklistFormToggle()\">\n<md-icon md-font-icon=\"icon-checkbox-multiple-marked\" class=\"s20\"></md-icon></md-button></div><div layout=\"row\" \nlayout-align=\"end center\"><md-button ng-if=\"MsNoteForm.type ===\'edit\'\" ng-click=\"MsNoteForm.deleteNote()\" \nclass=\"md-icon-button\" aria-label=\"delete note\"><md-icon md-font-icon=\"icon-delete\"></md-icon></md-button><md-button \nng-if=\"MsNoteForm.type ===\'edit\'\" type=\"submit\" ng-disabled=\"MsNoteForm.isNotValid()\">Save</md-button><md-button \nng-if=\"MsNoteForm.type ===\'new\'\" type=\"submit\" ng-enabled=\"MsNoteForm.isNotValid()\">Add</md-button></div></div></form>\n</div>");
$templateCache.put("app/main/sites/site/todolist/directives/ms-note-item/ms-note-item.html","<md-card ng-class=\" siteTodoCtrl.getAnotherColor($index)\"><md-card-content><md-card-title ng-if=\"MsNoteItem.note.name\">\n<md-card-title-text>{{MsNoteItem.note.name}}</md-card-title-text></md-card-title><md-description \nng-if=\"MsNoteItem.note.description\"><span>{{MsNoteItem.note.description}}</span></md-description><div \nng-if=\"MsNoteItem.note.actions.length > 0\" class=\"checklist\"><div class=\"checklist-item\" \nng-repeat=\"checkItem in  MsNoteItem.note.actions\" layout=\"row\" layout-align=\"start center\"><md-checkbox \nng-model=\"checkItem.completed\" ng-click=\"$event.preventDefault();$event.stopPropagation()\" \naria-label=\"{{checkItem.description}}\"></md-checkbox><span class=\"text-truncate\" \nng-class=\"{\'text-strike md-secondary-text\':checkItem.completed}\" flex>{{checkItem.description}}</span></div></div>\n</md-card-content></md-card>");}]);